webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(583);
	
	__webpack_require__(647);
	
	var _i18n = __webpack_require__(227);
	
	var _i18n2 = _interopRequireDefault(_i18n);
	
	var _vueRouter = __webpack_require__(1238);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vueResource = __webpack_require__(315);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _veeValidate = __webpack_require__(258);
	
	var _veeValidate2 = _interopRequireDefault(_veeValidate);
	
	var _vueInfiniteScroll = __webpack_require__(1001);
	
	var _vueInfiniteScroll2 = _interopRequireDefault(_vueInfiniteScroll);
	
	var _vMask = __webpack_require__(998);
	
	var _vMask2 = _interopRequireDefault(_vMask);
	
	var _vAutocomplete = __webpack_require__(997);
	
	var _vAutocomplete2 = _interopRequireDefault(_vAutocomplete);
	
	var _vueVirtualScroller = __webpack_require__(1239);
	
	var _vueVirtualScroller2 = _interopRequireDefault(_vueVirtualScroller);
	
	var _routes = __webpack_require__(236);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _ui = __webpack_require__(602);
	
	var _ui2 = _interopRequireDefault(_ui);
	
	var _global_mixin = __webpack_require__(582);
	
	var _global_mixin2 = _interopRequireDefault(_global_mixin);
	
	var _store = __webpack_require__(228);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_veeValidate.Validator.updateDictionary({
	  'pt-BR': {
	    messages: Locales.error_messages,
	    attributes: Locales.attributes
	  }
	});
	
	Vue.use(_vueResource2.default);
	Vue.use(_vueRouter2.default);
	Vue.use(_veeValidate2.default, { strict: false, delay: 0, locale: 'pt-BR' });
	Vue.use(_vueInfiniteScroll2.default);
	Vue.use(_vMask2.default);
	Vue.use(_vAutocomplete2.default);
	Vue.use(_vueVirtualScroller2.default);
	
	Vue.mixin(_global_mixin2.default);
	
	var router = new _vueRouter2.default({
	  mode: 'history',
	  routes: _routes2.default.routes
	});
	
	router.beforeEach(_routes2.default.guards.email);
	
	new Vue({
	  el: '#app-wrapper',
	  components: {
	    globalLoader: __webpack_require__(183)
	  },
	  i18n: _i18n2.default,
	  store: _store.store,
	  router: router,
	  template: '<div>\n              <global-loader></global-loader>\n              <router-view></router-view>\n            </div>'
	});

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var slice = [].slice;
	
	exports.form = __webpack_require__(232);
	
	exports.filters = __webpack_require__(587);
	
	exports.masks = __webpack_require__(590);
	
	exports.guid = __webpack_require__(233);
	
	exports.contacts = {
	  styles: __webpack_require__(586),
	  list_view_modes: __webpack_require__(584),
	  list_wrapper: __webpack_require__(585)
	};
	
	exports.manual_tasks = {
	  list_wrapper: __webpack_require__(589),
	  list_item_wrapper: __webpack_require__(588)
	};
	
	exports.notifications = {
	  kind_wrapper: __webpack_require__(591)
	};
	
	exports.vue_include = function() {
	  var base, extension, extensions, i, j, len, len1, obj, property, ref, ref1, sub_property, value;
	  obj = arguments[0], extensions = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	  for (i = 0, len = extensions.length; i < len; i++) {
	    extension = extensions[i];
	    ref = ['computed', 'methods'];
	    for (j = 0, len1 = ref.length; j < len1; j++) {
	      property = ref[j];
	      if (obj[property] == null) {
	        obj[property] = {};
	      }
	      ref1 = extension[property];
	      for (sub_property in ref1) {
	        value = ref1[sub_property];
	        if ((base = obj[property])[sub_property] == null) {
	          base[sub_property] = value;
	        }
	      }
	    }
	  }
	  return obj;
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var BaseModel, Guid;
	
	Guid = __webpack_require__(233);
	
	BaseModel = (function() {
	  function BaseModel(attributes) {
	    var association_name, attr_name, attr_options, model_getter, ref, ref1;
	    if (attributes == null) {
	      attributes = this.defaultAttributes();
	    }
	    this.guid = this.id ? this.id : Guid.generateGuid();
	    if (this.constructor.ATTRIBUTES) {
	      ref = this.constructor.ATTRIBUTES;
	      for (attr_name in ref) {
	        attr_options = ref[attr_name];
	        this.setAttribute(attr_name, attributes[attr_name], attr_options);
	      }
	    }
	    this.guid = this.id ? this.id : Guid.generateGuid();
	    if (this.constructor.ASSOCIATIONS) {
	      ref1 = this.constructor.ASSOCIATIONS;
	      for (association_name in ref1) {
	        model_getter = ref1[association_name];
	        this.buildAssociation(association_name, model_getter(), attributes[association_name]);
	      }
	    }
	    if (this.afterInitialize) {
	      this.afterInitialize();
	    }
	  }
	
	  BaseModel.prototype.isPersisted = function() {
	    return !!this.id;
	  };
	
	  BaseModel.prototype.isNew = function() {
	    return !this.isPersisted();
	  };
	
	  BaseModel.prototype.setAttribute = function(name, value, options) {
	    if (options == null) {
	      options = {};
	    }
	    if (value !== void 0) {
	      if (options.type && options.type === Date && value) {
	        return this[name] = moment(value);
	      } else {
	        return this[name] = value;
	      }
	    } else if (options["default"] !== void 0) {
	      return this[name] = options["default"];
	    } else {
	      return this[name] = options.type && (new options.type) || null;
	    }
	  };
	
	  BaseModel.prototype.buildAssociation = function(name, Model, attributes) {
	    var _attributes, i, len, model, results;
	    if (jQuery.isPlainObject(attributes)) {
	      return this[name] = new Model(attributes);
	    } else if (jQuery.isArray(attributes)) {
	      this[name] = [];
	      results = [];
	      for (i = 0, len = attributes.length; i < len; i++) {
	        _attributes = attributes[i];
	        model = new Model(_attributes);
	        results.push(this[name].push(model));
	      }
	      return results;
	    } else {
	      return this[name] = [];
	    }
	  };
	
	  BaseModel.prototype.defaultAttributes = function() {
	    var attribute_name, attributes, i, len, ref;
	    attributes = {};
	    ref = this.constructor.ATTRIBUTES;
	    for (i = 0, len = ref.length; i < len; i++) {
	      attribute_name = ref[i];
	      attributes[attribute_name] = null;
	    }
	    return attributes;
	  };
	
	  BaseModel.prototype.serializableAttributes = function() {
	    var attr_name, i, len, ref, serializable;
	    if (this.constructor.SERIALIZABLE_ATTRIBUTES) {
	      serializable = {};
	      ref = this.constructor.SERIALIZABLE_ATTRIBUTES;
	      for (i = 0, len = ref.length; i < len; i++) {
	        attr_name = ref[i];
	        serializable[attr_name] = this.constructor.ATTRIBUTES[attr_name];
	      }
	      return serializable;
	    }
	    if (this.constructor.ATTRIBUTES) {
	      return this.constructor.ATTRIBUTES;
	    }
	    return [];
	  };
	
	  BaseModel.prototype.serializableAssociations = function() {
	    if (this.constructor.SERIALIZABLE_ASSOCIATIONS) {
	      return this.constructor.SERIALIZABLE_ASSOCIATIONS;
	    }
	    if (this.constructor.ASSOCIATIONS) {
	      return Object.keys(this.constructor.ASSOCIATIONS);
	    }
	    return [];
	  };
	
	  BaseModel.prototype.isMoment = function(obj) {
	    return obj && typeof obj === 'object' && obj.constructor.name === 'Moment';
	  };
	
	  BaseModel.prototype.serialize = function(selected_attributes) {
	    var association_name, attr_name, attr_options, i, instance, j, key, len, len1, ref, ref1, selected_serialized, serialized, serialized_name, value;
	    if (selected_attributes == null) {
	      selected_attributes = false;
	    }
	    serialized = {};
	    ref = this.serializableAttributes();
	    for (attr_name in ref) {
	      attr_options = ref[attr_name];
	      if (this.isMoment(this[attr_name])) {
	        if (this[attr_name].isValid()) {
	          value = this[attr_name].utc().format();
	        } else {
	          value = null;
	        }
	      } else {
	        value = this[attr_name];
	      }
	      serialized[attr_name] = value;
	    }
	    if (!this.isPersisted()) {
	      delete serialized['id'];
	    }
	    ref1 = this.serializableAssociations();
	    for (i = 0, len = ref1.length; i < len; i++) {
	      association_name = ref1[i];
	      if (!this[association_name]) {
	        continue;
	      }
	      serialized_name = association_name + "_attributes";
	      if (this[association_name].serialize) {
	        serialized[serialized_name] = this[association_name].serialize();
	      } else {
	        serialized[serialized_name] = (function() {
	          var j, len1, ref2, results;
	          ref2 = this[association_name];
	          results = [];
	          for (j = 0, len1 = ref2.length; j < len1; j++) {
	            instance = ref2[j];
	            results.push(instance.serialize());
	          }
	          return results;
	        }).call(this);
	      }
	    }
	    if (!selected_attributes) {
	      return serialized;
	    }
	    selected_serialized = {};
	    for (j = 0, len1 = selected_attributes.length; j < len1; j++) {
	      key = selected_attributes[j];
	      selected_serialized[key] = serialized[key];
	    }
	    return selected_serialized;
	  };
	
	  return BaseModel;
	
	})();
	
	module.exports = BaseModel;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var Api, Vue, VueResource,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	Vue = __webpack_require__(18);
	
	VueResource = __webpack_require__(315);
	
	Vue.use(VueResource);
	
	Api = (function(superClass) {
	  extend(Api, superClass);
	
	  function Api(base_url) {
	    if (base_url == null) {
	      base_url = null;
	    }
	    if (base_url) {
	      this.base_url = base_url;
	    } else {
	      this.base_url = ("https://api.reev.co");
	    }
	    Api.__super__.constructor.call(this);
	  }
	
	  Api.prototype.url = function(path) {
	    return "" + this.base_url + path;
	  };
	
	  Api.prototype.get = function(path, params, options) {
	    return this.$http.get(this.url(path), params).then(((function(_this) {
	      return function(response) {
	        if (options.success) {
	          return options.success(response);
	        }
	      };
	    })(this)), ((function(_this) {
	      return function(response) {
	        if (options.failure) {
	          return options.failure(response);
	        }
	      };
	    })(this)));
	  };
	
	  Api.prototype.post = function(path, params, options) {
	    return this.$http.post(this.url(path), params).then(((function(_this) {
	      return function(response) {
	        if (options.success) {
	          return options.success(response);
	        }
	      };
	    })(this)), ((function(_this) {
	      return function(response) {
	        if (options.failure) {
	          return options.failure(response);
	        }
	      };
	    })(this)));
	  };
	
	  Api.prototype.put = function(path, params, options) {
	    return this.$http.put(this.url(path), params).then(((function(_this) {
	      return function(response) {
	        if (options.success) {
	          return options.success(response);
	        }
	      };
	    })(this)), ((function(_this) {
	      return function(response) {
	        if (options.failure) {
	          return options.failure(response);
	        }
	      };
	    })(this)));
	  };
	
	  Api.prototype["delete"] = function(path, params, options) {
	    params['_method'] = 'DELETE';
	    return this.$http["delete"](this.url(path), params).then(((function(_this) {
	      return function(response) {
	        if (options.success) {
	          return options.success(response);
	        }
	      };
	    })(this)), ((function(_this) {
	      return function(response) {
	        if (options.failure) {
	          return options.failure(response);
	        }
	      };
	    })(this)));
	  };
	
	  return Api;
	
	})(Vue);
	
	exports.api = function(base_url) {
	  if (base_url == null) {
	    base_url = null;
	  }
	  return new Api(base_url);
	};


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports) {

	module.exports = {
	  data: function() {
	    return {
	      users_options: [
	        {
	          value: null,
	          text: this.$t('general.feedback.loading')
	        }
	      ]
	    };
	  },
	  methods: {
	    getUsersFromStore: function() {
	      var data;
	      data = {
	        users: this.$store.getters.usersList
	      };
	      return this.loadUsersOptionsSuccess(data);
	    },
	    loadUsersOptionsSuccess: function(data) {
	      var user, users_options;
	      users_options = (function() {
	        var i, len, ref, results;
	        ref = data.users;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          user = ref[i];
	          results.push({
	            value: {
	              user_id_eq: user.id.toString()
	            },
	            text: user.firstAndLastName()
	          });
	        }
	        return results;
	      })();
	      users_options.unshift({
	        value: null,
	        text: this.$t('general.label.user')
	      });
	      this.users_options = users_options;
	      if (this.load_users) {
	        return this.$store.commit('loadUsers', data.users);
	      }
	    },
	    loadUsersOptions: function() {
	      var company_id, ref, roles;
	      roles = [User.ROLES['admin'], User.ROLES['seller'], User.ROLES['sdr'], User.ROLES['manager']];
	      company_id = typeof Session !== "undefined" && Session !== null ? (ref = Session.current_company) != null ? ref.id : void 0 : void 0;
	      return new UsersResource().index(this.loadUsersOptionsSuccess, null, {
	        params: {
	          q: {
	            s: 'name asc',
	            role_in: roles
	          },
	          company_id: company_id
	        }
	      });
	    }
	  },
	  computed: {
	    load_users: function() {
	      return this.$store.getters.usersCount === 0;
	    }
	  },
	  created: function() {
	    if (this.load_users) {
	      return this.loadUsersOptions();
	    } else {
	      return this.getUsersFromStore();
	    }
	  }
	};


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(873)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(324),
	  /* template */
	  __webpack_require__(1192),
	  /* scopeId */
	  "data-v-a1e884d2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(733)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(334),
	  /* template */
	  __webpack_require__(1032),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(750)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(559),
	  /* template */
	  __webpack_require__(1050),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(838)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(391),
	  /* template */
	  __webpack_require__(1148),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(755)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(483),
	  /* template */
	  __webpack_require__(1055),
	  /* scopeId */
	  "data-v-2c726298",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(887)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(372),
	  /* template */
	  __webpack_require__(1212),
	  /* scopeId */
	  "data-v-c60f52a2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(875)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(397),
	  /* template */
	  __webpack_require__(1196),
	  /* scopeId */
	  "data-v-a5324848",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(726)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(514),
	  /* template */
	  __webpack_require__(1022),
	  /* scopeId */
	  "data-v-1633e455",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(853)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(566),
	  /* template */
	  __webpack_require__(1164),
	  /* scopeId */
	  "data-v-7074d966",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKIAAAAiCAMAAADrnPLxAAAAY1BMVEUAAAAH06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx8H06ciHx/6C26sAAAAH3RSTlMAEBAgIDAwQEBQUGBgcHCAgI+Pn5+vr7+/z8/f3+/vdkdMmQAAArZJREFUWMPNmG13syAMhqlaZ9XHaeeUWkv9/79y8lbFBIS2O3vyZTukyHVicpNIjte7l/XFgfyReRLOdjth+9Msq2phZZZFcJUvJ8aObPHlqy12uwfY13ZzPk6m1fNi1LJpa2Ot0Dvgmoace/h/GaDjq0GI90/zARk4jp9GJ8wEY8RQX+ZGbIIYP4wHtNhhKUoxMb6hxH2dG5EU372H6aIxHiDjNVBlc4iSR2jpwwa5wJOulrSLTybKuIPoZ/FFMh63iN32lzxSzCyCVJ/PEanpqxTF64jkcIHZSHWOrU1gbNaYOh/ZkHCKRMKUQC6CEMlJIH4/hah/iG1Q4evUCwfJzvwRDzAZrYi1A7HCEXPkTScTdoAjGz0Rux3EbcINam2E0T/rMvO0Aqo3ikgdiMyBWKqkXEyoaOtPeLwJxH8vIWJlq9cgUAWg3TGUhPfYC7F6AlGK5poIefWH5hp2S1sRbRi2kkiw4iiRX3/tNzvxU4jVGjE1XFG9SF9rij5FZGj/ij4RP0T+cPP6kxiT6dN90rgS6tLoUcpAxFtB/BFBO7ZCxNoIELcOk+2dF93H5AXE0o7I9LvPdT9nlW1HuVz75gjL3B+R5sSGyLoUq+E2ULYtZkVs5+Y/12PBai4Q4ZxXSj0WbOaCpYhDZTsY0Xav4h0Xdp/UYbL9PkS2g7iQIbL9PsTOgUiXcsBNFMkZl+33IdbyEP8NsEOMRBAH8puI9GlEId8VKtv/C6KU7wFrwd+HyNNojOzVQN1ilxuDt8s+zNG1ib0R1ZAqRtdZ/Do1vi4FqwbY2Sf+bmOuLm62J9unnR7HgWgZ9ZNHywMNyreHbF/2vpU4UmuwfhSxfTCB8u0h27cXEKPWikhSao2wGcbzbiHApqcIqaNovn3rxYy7ONHXt7Bq9oFsnnd4DM39hrAhf2Y/OqnjapS450sAAAAASUVORK5CYII="

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(777)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(321),
	  /* template */
	  __webpack_require__(1081),
	  /* scopeId */
	  "data-v-3dbade28",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(762)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(399),
	  /* template */
	  __webpack_require__(1064),
	  /* scopeId */
	  "data-v-2ff3c4f7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(727)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(424),
	  /* template */
	  __webpack_require__(1023),
	  /* scopeId */
	  "data-v-16ffd404",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(749)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(430),
	  /* template */
	  __webpack_require__(1049),
	  /* scopeId */
	  "data-v-26d6dcb6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(468),
	  /* template */
	  __webpack_require__(1029),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(835)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(469),
	  /* template */
	  __webpack_require__(1145),
	  /* scopeId */
	  "data-v-613252aa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(884)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(341),
	  /* template */
	  __webpack_require__(1208),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(824)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(546),
	  /* template */
	  __webpack_require__(1134),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(747)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(580),
	  /* template */
	  __webpack_require__(1047),
	  /* scopeId */
	  "data-v-261ef371",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxMXB4IiB2aWV3Qm94PSIwIDAgMTEgMTEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ3LjEgKDQ1NDIyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5DbG9zZSBpY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkxpZ2HDp8Ojby1maW5hbCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+CiAgICAgICAgPGcgaWQ9IkxpZ2HDp8OjbyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMxMS4wMDAwMDAsIC05MC4wMDAwMDApIiBzdHJva2U9IiNEM0QzRDMiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cC05IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3OC4wMDAwMDAsIDczLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9ImluZm9zLWNvcHktMiI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTQiPgogICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQ2xvc2UtaWNvbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjM0LjAwMDAwMCwgMTguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOC41OTA5MDkwOSwwLjQwOTA5MDkwOSBMMC44MDc0MjM3MTMsOC4xOTI1NzYyOSIgaWQ9IkxpbmUiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LjU5MDkwOTA5LDAuNDA5MDkwOTA5IEwwLjgwNzQyMzcxMyw4LjE5MjU3NjI5IiBpZD0iTGluZS1Db3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0LjUwMDAwMCwgNC41MDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTQuNTAwMDAwLCAtNC41MDAwMDApICI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(380),
	  /* template */
	  __webpack_require__(1115),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(841)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(322),
	  /* template */
	  __webpack_require__(1151),
	  /* scopeId */
	  "data-v-657d908c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(800)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(394),
	  /* template */
	  __webpack_require__(1107),
	  /* scopeId */
	  "data-v-4e052822",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(793)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(410),
	  /* template */
	  __webpack_require__(1099),
	  /* scopeId */
	  "data-v-4ab01e7e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(426),
	  /* template */
	  __webpack_require__(1211),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(878)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(428),
	  /* template */
	  __webpack_require__(1199),
	  /* scopeId */
	  "data-v-ad60b824",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(892)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(434),
	  /* template */
	  __webpack_require__(1216),
	  /* scopeId */
	  "data-v-d367d556",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(744)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(438),
	  /* template */
	  __webpack_require__(1044),
	  /* scopeId */
	  "data-v-22bfcaaa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(785)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(460),
	  /* template */
	  __webpack_require__(1091),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(463),
	  /* template */
	  __webpack_require__(1171),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(788)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(470),
	  /* template */
	  __webpack_require__(1094),
	  /* scopeId */
	  "data-v-475e7b9d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(768)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(476),
	  /* template */
	  __webpack_require__(1070),
	  /* scopeId */
	  "data-v-3442e1e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(847)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(478),
	  /* template */
	  __webpack_require__(1158),
	  /* scopeId */
	  "data-v-683c08bc",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(765)
	__webpack_require__(764)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(479),
	  /* template */
	  __webpack_require__(1066),
	  /* scopeId */
	  "data-v-30b27de6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(896)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(496),
	  /* template */
	  __webpack_require__(1221),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(763)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(499),
	  /* template */
	  __webpack_require__(1065),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(743)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(501),
	  /* template */
	  __webpack_require__(1043),
	  /* scopeId */
	  "data-v-222e4234",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(902)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(336),
	  /* template */
	  __webpack_require__(1227),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(825)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(337),
	  /* template */
	  __webpack_require__(1135),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(859)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(507),
	  /* template */
	  __webpack_require__(1170),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(882)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(515),
	  /* template */
	  __webpack_require__(1206),
	  /* scopeId */
	  "data-v-b929118e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(527),
	  /* template */
	  __webpack_require__(1118),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(729)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(342),
	  /* template */
	  __webpack_require__(1026),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(909)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(553),
	  /* template */
	  __webpack_require__(1237),
	  /* scopeId */
	  "data-v-ff5902f8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(555),
	  /* template */
	  __webpack_require__(1152),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(869)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(558),
	  /* template */
	  __webpack_require__(1184),
	  /* scopeId */
	  "data-v-8bea8dd4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(568),
	  /* template */
	  __webpack_require__(1205),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(771)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(574),
	  /* template */
	  __webpack_require__(1073),
	  /* scopeId */
	  "data-v-36348e7b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(247);
	
	__webpack_require__(234);
	
	module.exports = function(target, options) {
	  return jQuery(target).summernote({
	    lang: 'pt-BR',
	    height: 180,
	    fontSizes: ['8', '9', '10', '11', '12', '13', '14', '16', '18', '24', '36', '48', '72'],
	    fontNames: ['Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Helvetica Neue', 'Impact', 'Lucida Grande', 'Tahoma', 'Times New Roman', 'Montserrat', 'Verdana'],
	    addDefaultFonts: true,
	    toolbar: [['fontname', ['fontname']], ['fontsize', ['fontsize']], ['color', ['color']], ['style', ['bold', 'italic', 'underline', 'strikethrough']], ['para', ['ul', 'ol', 'paragraph']], ['picture', ['picture']], ['link', ['link']]],
	    cleaner: {
	      action: 'paste',
	      notStyle: 'display:none',
	      keepHtml: true,
	      keepClasses: false,
	      badTags: ['style', 'script', 'applet', 'embed', 'noframes', 'noscript', 'html'],
	      badAttributes: ['style', 'start'],
	      limitDisplay: 'both',
	      limitStop: false
	    },
	    callbacks: {
	      onInit: function() {
	        var scroll;
	        jQuery(target).summernote('focus');
	        scroll = !options ? true : options.scroll;
	        if (scroll) {
	          return jQuery('body, html').scrollTop(0);
	        }
	      }
	    }
	  });
	};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(247);
	
	__webpack_require__(234);
	
	module.exports = function(target) {
	  return jQuery(target).summernote({
	    lang: 'pt-BR',
	    height: 180,
	    fontSizes: ['8', '9', '10', '11', '12', '13', '14', '16', '18', '24', '36', '48', '72'],
	    toolbar: [['style', ['bold', 'italic', 'underline', 'strikethrough']], ['para', ['ul', 'ol']], ['picture', ['picture']], ['link', ['link']]],
	    disableResizeEditor: true
	  });
	};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

	module.exports = {
	  error_messages: {
	    after: (function(_this) {
	      return function(field, arg) {
	        var target;
	        target = arg[0];
	        return "O campo " + field + " deve estar depois do campo " + target;
	      };
	    })(this),
	    alpha_dash: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve conter letras, números e traços";
	      };
	    })(this),
	    alpha_num: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve conter somente letras e números";
	      };
	    })(this),
	    alpha_spaces: (function(_this) {
	      return function(field) {
	        return "The " + field + " só pode conter caracteres alfabéticos e espaços";
	      };
	    })(this),
	    alpha: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve conter somente letras";
	      };
	    })(this),
	    before: (function(_this) {
	      return function(field, arg) {
	        var target;
	        target = arg[0];
	        return "O campo " + field + " deve estar antes do campo " + target;
	      };
	    })(this),
	    between: (function(_this) {
	      return function(field, arg) {
	        var max, min;
	        min = arg[0], max = arg[1];
	        return "O campo " + field + " deve estar entre " + min + " e " + max;
	      };
	    })(this),
	    confirmed: (function(_this) {
	      return function(field, arg) {
	        var confirmedField;
	        confirmedField = arg[0];
	        return "O campo " + field + " e " + confirmedField + " devem ser iguais";
	      };
	    })(this),
	    credit_card: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " é inválido";
	      };
	    })(this),
	    date_between: (function(_this) {
	      return function(field, arg) {
	        var max, min;
	        min = arg[0], max = arg[1];
	        return "O campo " + field + " deve estar entre " + min + " e " + max;
	      };
	    })(this),
	    date_format: (function(_this) {
	      return function(field, arg) {
	        var format;
	        format = arg[0];
	        return "O campo " + field + " deve estar no formato " + format;
	      };
	    })(this),
	    decimal: (function(_this) {
	      return function(field, arg) {
	        var decimals, ref;
	        decimals = (arg != null ? arg : ['*'])[0];
	        return "O campo " + field + " deve ser numérico e deve conter " + ((ref = decimals === '*') != null ? ref : {
	          '': decimals
	        }) + " casas decimais";
	      };
	    })(this),
	    digits: (function(_this) {
	      return function(field, arg) {
	        var length;
	        length = arg[0];
	        return "O campo " + field + " deve ser numérico e ter " + length + " dígitos";
	      };
	    })(this),
	    dimensions: (function(_this) {
	      return function(field, arg) {
	        var height, width;
	        width = arg[0], height = arg[1];
	        return "O campo " + field + " deve ter " + width + " pixels de largura por " + height + " pixels de altura";
	      };
	    })(this),
	    email: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve ser um email válido";
	      };
	    })(this),
	    ext: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve ser um arquivo válido";
	      };
	    })(this),
	    image: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve ser uma imagem";
	      };
	    })(this),
	    "in": (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve ter um valor válido";
	      };
	    })(this),
	    ip: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve ser um endereço IP válido";
	      };
	    })(this),
	    max: (function(_this) {
	      return function(field, arg) {
	        var length;
	        length = arg[0];
	        return "O campo " + field + " não deve ter mais que " + length + " caracteres";
	      };
	    })(this),
	    max_value: (function(_this) {
	      return function(field, arg) {
	        var max;
	        max = arg[0];
	        return "O campo " + field + " precisa ser " + max + " ou menor";
	      };
	    })(this),
	    mimes: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve ser um tipo de arquivo válido";
	      };
	    })(this),
	    min: (function(_this) {
	      return function(field, arg) {
	        var length;
	        length = arg[0];
	        return "O campo " + field + " deve conter pelo menos " + length + " caracteres";
	      };
	    })(this),
	    min_value: (function(_this) {
	      return function(field, arg) {
	        var min;
	        min = arg[0];
	        return "O campo " + field + " precisa ser " + min + " ou maior";
	      };
	    })(this),
	    not_in: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve ser um valor válido";
	      };
	    })(this),
	    numeric: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " deve conter apenas números";
	      };
	    })(this),
	    regex: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " possui um formato inválido";
	      };
	    })(this),
	    required: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " é obrigatório";
	      };
	    })(this),
	    size: (function(_this) {
	      return function(field, arg) {
	        var size;
	        size = arg[0];
	        return "O campo " + field + " deve ser menor que " + size + " KB";
	      };
	    })(this),
	    url: (function(_this) {
	      return function(field) {
	        return "O campo " + field + " não é uma URL válida";
	      };
	    })(this)
	  },
	  attributes: {
	    name: "nome",
	    email: "email",
	    password: "senha",
	    password_confirmation: "repetir senha",
	    current_password: "senha atual",
	    reset_password_token: "token",
	    subject: "assunto",
	    body: "conteúdo",
	    template_category_id: "categoria",
	    company_id: "empresa",
	    first_name: "nome",
	    last_name: "sobrenome",
	    business: "empresa",
	    business_name: "nome da empresa",
	    position: "cargo",
	    telephone: "telefone",
	    cellphone: "celular",
	    address: "endereço",
	    domain: "domínio",
	    city: "cidade",
	    state: "estado",
	    country: "país",
	    contact_group: "grupo",
	    role: "função",
	    timezone: "fuso horário",
	    pipedrive_api_key: "API KEY do Pipedrive",
	    nectar_api_key: "API KEY do NectarCRM",
	    'crm_setting.bcc_reply_email': "email de resposta",
	    'crm_setting.bcc_send_email': "email de envio",
	    'webhook_setting.url': "URL",
	    access_key: "chave de acesso",
	    replace_user_id: "usuário",
	    task_service: "tipo de tarefa",
	    due_on_time: "horário",
	    email_domain: "domínio do email",
	    send_at: 'horário da ação',
	    emails_per_day: 'ativação diária',
	    weekdays_to_send: 'dias válidos para envio',
	    delay_before_finishing_contact_amount: 'intervalo para finalizar contato no fluxo',
	    field: 'Nome',
	    webhook_url: 'URL do webhook',
	    url: 'URL',
	    caller_id: 'Numero',
	    meeting_type_id: 'Tipo de Reunião',
	    kind: 'Tipo de propriedade'
	  },
	  voip: {
	    call_status: {
	      idle: 'Ocioso',
	      calling: 'Chamando',
	      connected: 'Em ligação',
	      ended: 'Ligação encerrada',
	      failed: 'Ligação encerrada'
	    },
	    error_messages: {
	      generic: 'Ocorreu um erro com o seu serviço de VoiP. Tente mais tarde ou entre em contato com o suporte',
	      unauthorized_manager: 'Acesso ao VoiP não autorizado. Para mais informações entre em contato com o time de CS do Reev',
	      unauthorized: 'Acesso ao VoiP não autorizado. Para mais informações entre em contato com gerente da conta',
	      web_rtc_support: 'Esse navegador não tem suporte para a realização de chamadas VoiP',
	      authentication: 'Ocorreu um erro de autenticação no serviço de VoiP. Tente mais tarde ou entre em contato com o suporte',
	      mic_permission: 'O microfone está bloqueado para uso do navegador. Habilite para realizar chamadas',
	      ongoing_call: 'Já existe uma chamada em andamento.',
	      failed_status: {
	        'User Denied Media Access': 'Microfone não habilitado',
	        'Canceled': 'Cancelada',
	        'Unavailable': 'Serviço indisponível',
	        'Not Found': 'Número inexistente',
	        'Busy': 'Número ocupado ou inexistente',
	        'Unavailable': 'Não atendida'
	      }
	    }
	  },
	  recipient: {
	    soft_bounce: {
	      generic: function() {
	        return "O servidor de e-mail do contato rejeitou seu e-mail neste momento. O envio foi reagendado para o dia seguinte.";
	      },
	      message_rejected: function(attempts, max_attempts) {
	        return "O servidor de e-mail do contato rejeitou seu e-mail neste momento. O envio foi reagendado para o dia seguinte. " + attempts + "/" + max_attempts + " tentativas";
	      },
	      account_failure: function(attempts, max_attempts) {
	        return "O e-mail não foi enviado pois sua conta não estava sincronizada no momento do envio. O envio do e-mail foi reagendado para o dia seguinte. " + attempts + "/" + max_attempts + " tentativas";
	      },
	      limit_exceeded: function(attempts, max_attempts) {
	        return "O e-mail não foi enviado pois você excedeu o limite de envio para o dia. O envio do e-mail foi reagendado para o dia seguinte. " + attempts + "/" + max_attempts + " tentativas";
	      },
	      service_failure: function(attempts, max_attempts) {
	        return "O e-mail não foi enviado pois ocorreu um problema com o servidor de envio. O envio do e-mail foi reagendado para o dia seguinte. " + attempts + "/" + max_attempts + " tentativas";
	      },
	      unknown: function(attempts, max_attempts) {
	        return "O e-mail não foi enviado pois ocorreu um problema no momento do envio. O envio do e-mail foi reagendado para o dia seguinte. " + attempts + "/" + max_attempts + " tentativas";
	      }
	    }
	  }
	};


/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = {
	  data: function() {
	    return {
	      tag_options: [
	        {
	          value: null,
	          text: 'Carregando...'
	        }
	      ]
	    };
	  },
	  methods: {
	    loadTagsOptions: function() {
	      var company_id, ref;
	      company_id = typeof Session !== "undefined" && Session !== null ? (ref = Session.current_company) != null ? ref.id : void 0 : void 0;
	      return new TagsResource().index(this.loadTagsOptionsSuccess, null, {
	        params: {
	          company_id: company_id
	        }
	      });
	    },
	    getTagsFromStore: function() {
	      var data;
	      data = {
	        tags: this.$store.getters.tagsList
	      };
	      return this.loadTagsOptionsSuccess(data);
	    },
	    loadTagsOptionsSuccess: function(data) {
	      var tag, tag_options;
	      tag_options = (function() {
	        var i, len, ref, results;
	        ref = data.tags;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          tag = ref[i];
	          results.push({
	            value: {
	              contact_tags_tag_id_eq: tag.id.toString()
	            },
	            text: tag.name
	          });
	        }
	        return results;
	      })();
	      tag_options.unshift({
	        value: null,
	        text: 'Tags'
	      });
	      this.tag_options = tag_options;
	      if (this.load_tags && data.tags) {
	        return this.$store.commit('loadTags', data.tags);
	      }
	    }
	  },
	  computed: {
	    load_tags: function() {
	      return this.$store.getters.tagsCount === 0;
	    }
	  },
	  created: function() {
	    if (this.load_tags) {
	      return this.loadTagsOptions();
	    } else {
	      return this.getTagsFromStore();
	    }
	  }
	};


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(893)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(371),
	  /* template */
	  __webpack_require__(1217),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(805)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(373),
	  /* template */
	  __webpack_require__(1113),
	  /* scopeId */
	  "data-v-51b48e34",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(861)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(374),
	  /* template */
	  __webpack_require__(1173),
	  /* scopeId */
	  "data-v-7d9d557a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(865)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(375),
	  /* template */
	  __webpack_require__(1179),
	  /* scopeId */
	  "data-v-80ea2482",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(376),
	  /* template */
	  __webpack_require__(1005),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(378),
	  /* template */
	  __webpack_require__(1183),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(794)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(382),
	  /* template */
	  __webpack_require__(1101),
	  /* scopeId */
	  "data-v-4b1a7404",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(846)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(388),
	  /* template */
	  __webpack_require__(1157),
	  /* scopeId */
	  "data-v-68090c0d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(751)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(389),
	  /* template */
	  __webpack_require__(1051),
	  /* scopeId */
	  "data-v-2905e3a7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(811)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(390),
	  /* template */
	  __webpack_require__(1121),
	  /* scopeId */
	  "data-v-54f4d3f1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(856)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(392),
	  /* template */
	  __webpack_require__(1167),
	  /* scopeId */
	  "data-v-74051c46",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(870)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(393),
	  /* template */
	  __webpack_require__(1189),
	  /* scopeId */
	  "data-v-97f97c06",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(822)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(323),
	  /* template */
	  __webpack_require__(1132),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(756)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(395),
	  /* template */
	  __webpack_require__(1056),
	  /* scopeId */
	  "data-v-2d07467e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(810)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(396),
	  /* template */
	  __webpack_require__(1120),
	  /* scopeId */
	  "data-v-54a3715a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(757)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(398),
	  /* template */
	  __webpack_require__(1057),
	  /* scopeId */
	  "data-v-2d6fb684",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(735)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(400),
	  /* template */
	  __webpack_require__(1034),
	  /* scopeId */
	  "data-v-1c7e702e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(820)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(405),
	  /* template */
	  __webpack_require__(1130),
	  /* scopeId */
	  "data-v-5a452cf1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(877)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(406),
	  /* template */
	  __webpack_require__(1198),
	  /* scopeId */
	  "data-v-aa102902",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(830)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(407),
	  /* template */
	  __webpack_require__(1140),
	  /* scopeId */
	  "data-v-5ed4dd03",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(409),
	  /* template */
	  __webpack_require__(1109),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(803)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(411),
	  /* template */
	  __webpack_require__(1111),
	  /* scopeId */
	  "data-v-50e09d38",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(886)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(412),
	  /* template */
	  __webpack_require__(1210),
	  /* scopeId */
	  "data-v-c16c2e20",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(752)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(414),
	  /* template */
	  __webpack_require__(1052),
	  /* scopeId */
	  "data-v-2a0780b3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(769)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(415),
	  /* template */
	  __webpack_require__(1071),
	  /* scopeId */
	  "data-v-3586e025",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(888)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(416),
	  /* template */
	  __webpack_require__(1213),
	  /* scopeId */
	  "data-v-c9fb9006",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(417),
	  /* template */
	  __webpack_require__(1076),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(898)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(418),
	  /* template */
	  __webpack_require__(1223),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(863)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(419),
	  /* template */
	  __webpack_require__(1175),
	  /* scopeId */
	  "data-v-7ef221b8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(840)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(427),
	  /* template */
	  __webpack_require__(1150),
	  /* scopeId */
	  "data-v-641ab612",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(758)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(432),
	  /* template */
	  __webpack_require__(1058),
	  /* scopeId */
	  "data-v-2d9afb8e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(433),
	  /* template */
	  __webpack_require__(1027),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(436),
	  /* template */
	  __webpack_require__(1087),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(770)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(437),
	  /* template */
	  __webpack_require__(1072),
	  /* scopeId */
	  "data-v-35984320",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(890)
	__webpack_require__(889)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(439),
	  /* template */
	  __webpack_require__(1214),
	  /* scopeId */
	  "data-v-d1054460",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(881)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(440),
	  /* template */
	  __webpack_require__(1203),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(441),
	  /* template */
	  __webpack_require__(1088),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(775)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(442),
	  /* template */
	  __webpack_require__(1079),
	  /* scopeId */
	  "data-v-3b062fc0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(745)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(443),
	  /* template */
	  __webpack_require__(1045),
	  /* scopeId */
	  "data-v-23ddaf27",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(716)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(444),
	  /* template */
	  __webpack_require__(1013),
	  /* scopeId */
	  "data-v-10b07fe2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(908)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(445),
	  /* template */
	  __webpack_require__(1236),
	  /* scopeId */
	  "data-v-fec77e94",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(880)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(446),
	  /* template */
	  __webpack_require__(1201),
	  /* scopeId */
	  "data-v-afb6d766",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(871)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(447),
	  /* template */
	  __webpack_require__(1190),
	  /* scopeId */
	  "data-v-98611c48",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(823)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(448),
	  /* template */
	  __webpack_require__(1133),
	  /* scopeId */
	  "data-v-5b8db912",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(792)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(449),
	  /* template */
	  __webpack_require__(1098),
	  /* scopeId */
	  "data-v-49d50ad8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(450),
	  /* template */
	  __webpack_require__(1235),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(740)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(451),
	  /* template */
	  __webpack_require__(1040),
	  /* scopeId */
	  "data-v-20805a86",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(709)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(452),
	  /* template */
	  __webpack_require__(1002),
	  /* scopeId */
	  "data-v-021591b5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(831)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(453),
	  /* template */
	  __webpack_require__(1141),
	  /* scopeId */
	  "data-v-5edf3f20",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(815)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(454),
	  /* template */
	  __webpack_require__(1125),
	  /* scopeId */
	  "data-v-57208104",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(455),
	  /* template */
	  __webpack_require__(1188),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(456),
	  /* template */
	  __webpack_require__(1060),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(459),
	  /* template */
	  __webpack_require__(1233),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(864)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(325),
	  /* template */
	  __webpack_require__(1176),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(738)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(327),
	  /* template */
	  __webpack_require__(1038),
	  /* scopeId */
	  "data-v-1fd137e8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(862)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(328),
	  /* template */
	  __webpack_require__(1174),
	  /* scopeId */
	  "data-v-7ec3a274",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(773)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(467),
	  /* template */
	  __webpack_require__(1075),
	  /* scopeId */
	  "data-v-39b0505c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(734)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(471),
	  /* template */
	  __webpack_require__(1033),
	  /* scopeId */
	  "data-v-1bf602af",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(711)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(472),
	  /* template */
	  __webpack_require__(1008),
	  /* scopeId */
	  "data-v-0a68a2ac",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(876)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(473),
	  /* template */
	  __webpack_require__(1197),
	  /* scopeId */
	  "data-v-a9b328a4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(710)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(474),
	  /* template */
	  __webpack_require__(1006),
	  /* scopeId */
	  "data-v-07ea2234",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(874)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(475),
	  /* template */
	  __webpack_require__(1195),
	  /* scopeId */
	  "data-v-a51db266",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(797)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(480),
	  /* template */
	  __webpack_require__(1104),
	  /* scopeId */
	  "data-v-4d732263",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(814)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(481),
	  /* template */
	  __webpack_require__(1124),
	  /* scopeId */
	  "data-v-56ed74d3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(787)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(482),
	  /* template */
	  __webpack_require__(1093),
	  /* scopeId */
	  "data-v-46827e1e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(821)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(484),
	  /* template */
	  __webpack_require__(1131),
	  /* scopeId */
	  "data-v-5b1913c6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(812)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(485),
	  /* template */
	  __webpack_require__(1122),
	  /* scopeId */
	  "data-v-5654c91c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(760)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(486),
	  /* template */
	  __webpack_require__(1061),
	  /* scopeId */
	  "data-v-2efe8f75",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(895)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(487),
	  /* template */
	  __webpack_require__(1220),
	  /* scopeId */
	  "data-v-db02f254",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(897)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(488),
	  /* template */
	  __webpack_require__(1222),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(837)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(489),
	  /* template */
	  __webpack_require__(1147),
	  /* scopeId */
	  "data-v-622d2c06",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(742)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(490),
	  /* template */
	  __webpack_require__(1042),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(721)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(330),
	  /* template */
	  __webpack_require__(1018),
	  /* scopeId */
	  "data-v-1490ea69",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(885)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(331),
	  /* template */
	  __webpack_require__(1209),
	  /* scopeId */
	  "data-v-c050ec96",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(879)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(332),
	  /* template */
	  __webpack_require__(1200),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(883)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(495),
	  /* template */
	  __webpack_require__(1207),
	  /* scopeId */
	  "data-v-ba53dfaa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(843)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(497),
	  /* template */
	  __webpack_require__(1154),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(806)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(498),
	  /* template */
	  __webpack_require__(1114),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(722)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(502),
	  /* template */
	  __webpack_require__(1019),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(767)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(333),
	  /* template */
	  __webpack_require__(1069),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(732)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(335),
	  /* template */
	  __webpack_require__(1031),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(832)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(504),
	  /* template */
	  __webpack_require__(1142),
	  /* scopeId */
	  "data-v-5f6b23c1",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(741)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(505),
	  /* template */
	  __webpack_require__(1041),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(850)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(506),
	  /* template */
	  __webpack_require__(1161),
	  /* scopeId */
	  "data-v-6bdf945f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(728)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(509),
	  /* template */
	  __webpack_require__(1025),
	  /* scopeId */
	  "data-v-195cef09",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(766)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(338),
	  /* template */
	  __webpack_require__(1067),
	  /* scopeId */
	  "data-v-31967fb9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(833)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(510),
	  /* template */
	  __webpack_require__(1143),
	  /* scopeId */
	  "data-v-603711e5",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(739)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(339),
	  /* template */
	  __webpack_require__(1039),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(804)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(513),
	  /* template */
	  __webpack_require__(1112),
	  /* scopeId */
	  "data-v-513e4a1a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(809)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(516),
	  /* template */
	  __webpack_require__(1119),
	  /* scopeId */
	  "data-v-547811aa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(836)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(517),
	  /* template */
	  __webpack_require__(1146),
	  /* scopeId */
	  "data-v-619c71de",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(802)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(519),
	  /* template */
	  __webpack_require__(1110),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(520),
	  /* template */
	  __webpack_require__(1062),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(761)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(521),
	  /* template */
	  __webpack_require__(1063),
	  /* scopeId */
	  "data-v-2fb60744",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(816)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(522),
	  /* template */
	  __webpack_require__(1126),
	  /* scopeId */
	  "data-v-57dec966",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(817)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(523),
	  /* template */
	  __webpack_require__(1127),
	  /* scopeId */
	  "data-v-58424cc6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(827)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(340),
	  /* template */
	  __webpack_require__(1138),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(867)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(526),
	  /* template */
	  __webpack_require__(1181),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(528),
	  /* template */
	  __webpack_require__(1024),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(784)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(529),
	  /* template */
	  __webpack_require__(1090),
	  /* scopeId */
	  "data-v-45137450",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(808)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(530),
	  /* template */
	  __webpack_require__(1117),
	  /* scopeId */
	  "data-v-52d11766",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(778)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(532),
	  /* template */
	  __webpack_require__(1082),
	  /* scopeId */
	  "data-v-3ec171cf",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(904)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(533),
	  /* template */
	  __webpack_require__(1229),
	  /* scopeId */
	  "data-v-ec58c906",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(746)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(534),
	  /* template */
	  __webpack_require__(1046),
	  /* scopeId */
	  "data-v-248843d9",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(848)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(535),
	  /* template */
	  __webpack_require__(1159),
	  /* scopeId */
	  "data-v-69f2450e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(852)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(536),
	  /* template */
	  __webpack_require__(1163),
	  /* scopeId */
	  "data-v-6eab0e5f",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(849)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(537),
	  /* template */
	  __webpack_require__(1160),
	  /* scopeId */
	  "data-v-6b163b74",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(905)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(538),
	  /* template */
	  __webpack_require__(1231),
	  /* scopeId */
	  "data-v-edcbe6e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(907)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(539),
	  /* template */
	  __webpack_require__(1234),
	  /* scopeId */
	  "data-v-f77117d8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(712)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(540),
	  /* template */
	  __webpack_require__(1009),
	  /* scopeId */
	  "data-v-0ac3641b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(720)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(541),
	  /* template */
	  __webpack_require__(1017),
	  /* scopeId */
	  "data-v-1487201b",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(759)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(542),
	  /* template */
	  __webpack_require__(1059),
	  /* scopeId */
	  "data-v-2e418d68",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(782)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(543),
	  /* template */
	  __webpack_require__(1086),
	  /* scopeId */
	  "data-v-40accd7e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(748)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(544),
	  /* template */
	  __webpack_require__(1048),
	  /* scopeId */
	  "data-v-264d2b1c",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(845)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(545),
	  /* template */
	  __webpack_require__(1156),
	  /* scopeId */
	  "data-v-6784c81a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(776)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(547),
	  /* template */
	  __webpack_require__(1080),
	  /* scopeId */
	  "data-v-3b5ba5b2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(858)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(343),
	  /* template */
	  __webpack_require__(1169),
	  /* scopeId */
	  "data-v-761a70ae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(737)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(549),
	  /* template */
	  __webpack_require__(1037),
	  /* scopeId */
	  "data-v-1ee94352",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(550),
	  /* template */
	  __webpack_require__(1007),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(818)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(551),
	  /* template */
	  __webpack_require__(1128),
	  /* scopeId */
	  "data-v-5853593d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(717)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(552),
	  /* template */
	  __webpack_require__(1014),
	  /* scopeId */
	  "data-v-138bcc54",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(731)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(556),
	  /* template */
	  __webpack_require__(1030),
	  /* scopeId */
	  "data-v-1aae452a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(730)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(557),
	  /* template */
	  __webpack_require__(1028),
	  /* scopeId */
	  "data-v-1a876d94",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(854)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(561),
	  /* template */
	  __webpack_require__(1165),
	  /* scopeId */
	  "data-v-70d4f7aa",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(839)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(562),
	  /* template */
	  __webpack_require__(1149),
	  /* scopeId */
	  "data-v-630a4894",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(834)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(563),
	  /* template */
	  __webpack_require__(1144),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(565),
	  /* template */
	  __webpack_require__(1202),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(791)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(569),
	  /* template */
	  __webpack_require__(1097),
	  /* scopeId */
	  "data-v-496298e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(724)
	__webpack_require__(723)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(571),
	  /* template */
	  __webpack_require__(1020),
	  /* scopeId */
	  "data-v-156c05b0",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(901)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(572),
	  /* template */
	  __webpack_require__(1226),
	  /* scopeId */
	  "data-v-e1a53bd4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(857)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(573),
	  /* template */
	  __webpack_require__(1168),
	  /* scopeId */
	  "data-v-760c0ee6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(799)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(576),
	  /* template */
	  __webpack_require__(1106),
	  /* scopeId */
	  "data-v-4df379f6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(860)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(579),
	  /* template */
	  __webpack_require__(1172),
	  /* scopeId */
	  "data-v-7c71b25a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(891)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(581),
	  /* template */
	  __webpack_require__(1215),
	  /* scopeId */
	  "data-v-d2462a8a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(18);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueI18n = __webpack_require__(1000);
	
	var _vueI18n2 = _interopRequireDefault(_vueI18n);
	
	var _index = __webpack_require__(346);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _index3 = __webpack_require__(344);
	
	var _index4 = _interopRequireDefault(_index3);
	
	var _index5 = __webpack_require__(345);
	
	var _index6 = _interopRequireDefault(_index5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueI18n2.default);
	
	exports.default = new _vueI18n2.default({
	  locale: 'pt_BR',
	  messages: {
	    pt_BR: _index2.default,
	    en_US: _index4.default,
	    es: _index6.default
	  }
	});

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.store = undefined;
	
	var _vue = __webpack_require__(18);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(316);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _user = __webpack_require__(352);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _tag = __webpack_require__(350);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _template_category = __webpack_require__(351);
	
	var _template_category2 = _interopRequireDefault(_template_category);
	
	var _notification = __webpack_require__(349);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	var _lost_reason = __webpack_require__(347);
	
	var _lost_reason2 = _interopRequireDefault(_lost_reason);
	
	var _meeting_type = __webpack_require__(348);
	
	var _meeting_type2 = _interopRequireDefault(_meeting_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var store = exports.store = new _vuex2.default.Store({
	  modules: {
	    user: _user2.default,
	    tag: _tag2.default,
	    template_category: _template_category2.default,
	    notification: _notification2.default,
	    lost_reason: _lost_reason2.default,
	    meeting_type: _meeting_type2.default
	  }
	});

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	var _typeof2 = __webpack_require__(357);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * jquery-date-range-picker
	 * @version v0.16.0
	 * @link https://github.com/longbill/jquery-date-range-picker
	 * @license MIT
	 */
	!function (e) {
	   true ? !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(92), __webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (e), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : "object" == (typeof exports === "undefined" ? "undefined" : (0, _typeof3.default)(exports)) && "undefined" != typeof module ? module.exports = e(require("jquery"), require("moment")) : e(jQuery, moment);
	}(function (e, t) {
	  "use strict";
	  e.dateRangePickerLanguages = { default: { selected: "Selected:", day: "Day", days: "Days", apply: "Close", "week-1": "mo", "week-2": "tu", "week-3": "we", "week-4": "th", "week-5": "fr", "week-6": "sa", "week-7": "su", "week-number": "W", "month-name": ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"], shortcuts: "Shortcuts", "custom-values": "Custom Values", past: "Past", following: "Following", previous: "Previous", "prev-week": "Week", "prev-month": "Month", "prev-year": "Year", next: "Next", "next-week": "Week", "next-month": "Month", "next-year": "Year", "less-than": "Date range should not be more than %d days", "more-than": "Date range should not be less than %d days", "default-more": "Please select a date range longer than %d days", "default-single": "Please select a date", "default-less": "Please select a date range less than %d days", "default-range": "Please select a date range between %d and %d days", "default-default": "Please select a date range", time: "Time", hour: "Hour", minute: "Minute" }, id: { selected: "Terpilih:", day: "Hari", days: "Hari", apply: "Tutup", "week-1": "sen", "week-2": "sel", "week-3": "rab", "week-4": "kam", "week-5": "jum", "week-6": "sab", "week-7": "min", "week-number": "W", "month-name": ["januari", "februari", "maret", "april", "mei", "juni", "juli", "agustus", "september", "oktober", "november", "desember"], shortcuts: "Pintas", "custom-values": "Nilai yang ditentukan", past: "Yang Lalu", following: "Mengikuti", previous: "Sebelumnya", "prev-week": "Minggu", "prev-month": "Bulan", "prev-year": "Tahun", next: "Selanjutnya", "next-week": "Minggu", "next-month": "Bulan", "next-year": "Tahun", "less-than": "Tanggal harus lebih dari %d hari", "more-than": "Tanggal harus kurang dari %d hari", "default-more": "Jarak tanggal harus lebih lama dari %d hari", "default-single": "Silakan pilih tanggal", "default-less": "Jarak rentang tanggal tidak boleh lebih lama dari %d hari", "default-range": "Rentang tanggal harus antara %d dan %d hari", "default-default": "Silakan pilih rentang tanggal", time: "Waktu", hour: "Jam", minute: "Menit" }, az: { selected: "Seçildi:", day: " gün", days: " gün", apply: "tətbiq", "week-1": "1", "week-2": "2", "week-3": "3", "week-4": "4", "week-5": "5", "week-6": "6", "week-7": "7", "month-name": ["yanvar", "fevral", "mart", "aprel", "may", "iyun", "iyul", "avqust", "sentyabr", "oktyabr", "noyabr", "dekabr"], shortcuts: "Qısayollar", past: "Keçmiş", following: "Növbəti", previous: "&nbsp;&nbsp;&nbsp;", "prev-week": "Öncəki həftə", "prev-month": "Öncəki ay", "prev-year": "Öncəki il", next: "&nbsp;&nbsp;&nbsp;", "next-week": "Növbəti həftə", "next-month": "Növbəti ay", "next-year": "Növbəti il", "less-than": "Tarix aralığı %d gündən çox olmamalıdır", "more-than": "Tarix aralığı %d gündən az olmamalıdır", "default-more": "%d gündən çox bir tarix seçin", "default-single": "Tarix seçin", "default-less": "%d gündən az bir tarix seçin", "default-range": "%d və %d gün aralığında tarixlər seçin", "default-default": "Tarix aralığı seçin" }, bg: { selected: "Избрано:", day: "Ден", days: "Дни", apply: "Затвори", "week-1": "пн", "week-2": "вт", "week-3": "ср", "week-4": "чт", "week-5": "пт", "week-6": "сб", "week-7": "нд", "week-number": "С", "month-name": ["януари", "февруари", "март", "април", "май", "юни", "юли", "август", "септември", "октомври", "ноември", "декември"], shortcuts: "Преки пътища", "custom-values": "Персонализирани стойности", past: "Минал", following: "Следващ", previous: "Предишен", "prev-week": "Седмица", "prev-month": "Месец", "prev-year": "Година", next: "Следващ", "next-week": "Седмица", "next-month": "Месец", "next-year": "Година", "less-than": "Периодът от време не трябва да е повече от %d дни", "more-than": "Периодът от време не трябва да е по-малко от %d дни", "default-more": "Моля изберете период по-дълъг от %d дни", "default-single": "Моля изберете дата", "default-less": "Моля изберете период по-къс от %d дни", "default-range": "Моля изберете период между %d и %d дни", "default-default": "Моля изберете период", time: "Време", hour: "Час", minute: "Минута" }, cn: { selected: "已选择:", day: "天", days: "天", apply: "确定", "week-1": "一", "week-2": "二", "week-3": "三", "week-4": "四", "week-5": "五", "week-6": "六", "week-7": "日", "week-number": "周", "month-name": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], shortcuts: "快捷选择", past: "过去", following: "将来", previous: "&nbsp;&nbsp;&nbsp;", "prev-week": "上周", "prev-month": "上个月", "prev-year": "去年", next: "&nbsp;&nbsp;&nbsp;", "next-week": "下周", "next-month": "下个月", "next-year": "明年", "less-than": "所选日期范围不能大于%d天", "more-than": "所选日期范围不能小于%d天", "default-more": "请选择大于%d天的日期范围", "default-less": "请选择小于%d天的日期范围", "default-range": "请选择%d天到%d天的日期范围", "default-single": "请选择一个日期", "default-default": "请选择一个日期范围", time: "时间", hour: "小时", minute: "分钟" }, cz: { selected: "Vybráno:", day: "Den", days: "Dny", apply: "Zavřít", "week-1": "po", "week-2": "út", "week-3": "st", "week-4": "čt", "week-5": "pá", "week-6": "so", "week-7": "ne", "month-name": ["leden", "únor", "březen", "duben", "květen", "červen", "červenec", "srpen", "září", "říjen", "listopad", "prosinec"], shortcuts: "Zkratky", past: "po", following: "následující", previous: "předchozí", "prev-week": "týden", "prev-month": "měsíc", "prev-year": "rok", next: "další", "next-week": "týden", "next-month": "měsíc", "next-year": "rok", "less-than": "Rozsah data by neměl být větší než %d dnů", "more-than": "Rozsah data by neměl být menší než %d dnů", "default-more": "Prosím zvolte rozsah data větší než %d dnů", "default-single": "Prosím zvolte datum", "default-less": "Prosím zvolte rozsah data menší než %d dnů", "default-range": "Prosím zvolte rozsah data mezi %d a %d dny", "default-default": "Prosím zvolte rozsah data" }, de: { selected: "Auswahl:", day: "Tag", days: "Tage", apply: "Schließen", "week-1": "mo", "week-2": "di", "week-3": "mi", "week-4": "do", "week-5": "fr", "week-6": "sa", "week-7": "so", "month-name": ["januar", "februar", "märz", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "dezember"], shortcuts: "Schnellwahl", past: "Vorherige", following: "Folgende", previous: "Vorherige", "prev-week": "Woche", "prev-month": "Monat", "prev-year": "Jahr", next: "Nächste", "next-week": "Woche", "next-month": "Monat", "next-year": "Jahr", "less-than": "Datumsbereich darf nicht größer sein als %d Tage", "more-than": "Datumsbereich darf nicht kleiner sein als %d Tage", "default-more": "Bitte mindestens %d Tage auswählen", "default-single": "Bitte ein Datum auswählen", "default-less": "Bitte weniger als %d Tage auswählen", "default-range": "Bitte einen Datumsbereich zwischen %d und %d Tagen auswählen", "default-default": "Bitte ein Start- und Enddatum auswählen", Time: "Zeit", hour: "Stunde", minute: "Minute" }, es: { selected: "Seleccionado:", day: "Día", days: "Días", apply: "Cerrar", "week-1": "lu", "week-2": "ma", "week-3": "mi", "week-4": "ju", "week-5": "vi", "week-6": "sa", "week-7": "do", "month-name": ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"], shortcuts: "Accesos directos", past: "Pasado", following: "Siguiente", previous: "Anterior", "prev-week": "Semana", "prev-month": "Mes", "prev-year": "Año", next: "Siguiente", "next-week": "Semana", "next-month": "Mes", "next-year": "Año", "less-than": "El rango no debería ser mayor de %d días", "more-than": "El rango no debería ser menor de %d días", "default-more": "Por favor selecciona un rango mayor a %d días", "default-single": "Por favor selecciona un día", "default-less": "Por favor selecciona un rango menor a %d días", "default-range": "Por favor selecciona un rango entre %d y %d días", "default-default": "Por favor selecciona un rango de fechas." }, fr: { selected: "Sélection:", day: "Jour", days: "Jours", apply: "Fermer", "week-1": "lu", "week-2": "ma", "week-3": "me", "week-4": "je", "week-5": "ve", "week-6": "sa", "week-7": "di", "month-name": ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"], shortcuts: "Raccourcis", past: "Passé", following: "Suivant", previous: "Précédent", "prev-week": "Semaine", "prev-month": "Mois", "prev-year": "Année", next: "Suivant", "next-week": "Semaine", "next-month": "Mois", "next-year": "Année", "less-than": "L'intervalle ne doit pas être supérieure à %d jours", "more-than": "L'intervalle ne doit pas être inférieure à %d jours", "default-more": "Merci de choisir une intervalle supérieure à %d jours", "default-single": "Merci de choisir une date", "default-less": "Merci de choisir une intervalle inférieure %d jours", "default-range": "Merci de choisir une intervalle comprise entre %d et %d jours", "default-default": "Merci de choisir une date" }, hu: { selected: "Kiválasztva:", day: "Nap", days: "Nap", apply: "Ok", "week-1": "h", "week-2": "k", "week-3": "sz", "week-4": "cs", "week-5": "p", "week-6": "sz", "week-7": "v", "month-name": ["január", "február", "március", "április", "május", "június", "július", "augusztus", "szeptember", "október", "november", "december"], shortcuts: "Gyorsválasztó", past: "Múlt", following: "Következő", previous: "Előző", "prev-week": "Hét", "prev-month": "Hónap", "prev-year": "Év", next: "Következő", "next-week": "Hét", "next-month": "Hónap", "next-year": "Év", "less-than": "A kiválasztás nem lehet több %d napnál", "more-than": "A kiválasztás nem lehet több %d napnál", "default-more": "Válassz ki egy időszakot ami hosszabb mint %d nap", "default-single": "Válassz egy napot", "default-less": "Válassz ki egy időszakot ami rövidebb mint %d nap", "default-range": "Válassz ki egy %d - %d nap hosszú időszakot", "default-default": "Válassz ki egy időszakot" }, it: { selected: "Selezionati:", day: "Giorno", days: "Giorni", apply: "Chiudi", "week-1": "lu", "week-2": "ma", "week-3": "me", "week-4": "gi", "week-5": "ve", "week-6": "sa", "week-7": "do", "month-name": ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"], shortcuts: "Scorciatoie", past: "Scorso", following: "Successivo", previous: "Precedente", "prev-week": "Settimana", "prev-month": "Mese", "prev-year": "Anno", next: "Prossimo", "next-week": "Settimana", "next-month": "Mese", "next-year": "Anno", "less-than": "L'intervallo non dev'essere maggiore di %d giorni", "more-than": "L'intervallo non dev'essere minore di %d giorni", "default-more": "Seleziona un intervallo maggiore di %d giorni", "default-single": "Seleziona una data", "default-less": "Seleziona un intervallo minore di %d giorni", "default-range": "Seleziona un intervallo compreso tra i %d e i %d giorni", "default-default": "Seleziona un intervallo di date" }, ko: { selected: "기간:", day: "일", days: "일간", apply: "닫기", "week-1": "월", "week-2": "화", "week-3": "수", "week-4": "목", "week-5": "금", "week-6": "토", "week-7": "일", "week-number": "주", "month-name": ["1월", "2월", "3월", "4월", "5월", "6월", "7월", "8월", "9월", "10월", "11월", "12월"], shortcuts: "단축키들", past: "지난(오늘기준)", following: "이후(오늘기준)", previous: "이전", "prev-week": "1주", "prev-month": "1달", "prev-year": "1년", next: "다음", "next-week": "1주", "next-month": "1달", "next-year": "1년", "less-than": "날짜 범위는 %d 일보다 많을 수 없습니다", "more-than": "날짜 범위는 %d 일보다 작을 수 없습니다", "default-more": "날짜 범위를 %d 일보다 길게 선택해 주세요", "default-single": "날짜를 선택해 주세요", "default-less": "%d 일보다 작은 날짜를 선택해 주세요", "default-range": "%d와 %d 일 사이의 날짜 범위를 선택해 주세요", "default-default": "날짜 범위를 선택해 주세요", time: "시각", hour: "시", minute: "분" }, no: { selected: "Valgt:", day: "Dag", days: "Dager", apply: "Lukk", "week-1": "ma", "week-2": "ti", "week-3": "on", "week-4": "to", "week-5": "fr", "week-6": "lø", "week-7": "sø", "month-name": ["januar", "februar", "mars", "april", "mai", "juni", "juli", "august", "september", "oktober", "november", "desember"], shortcuts: "Snarveier", "custom-values": "Egendefinerte Verdier", past: "Over", following: "Følger", previous: "Forrige", "prev-week": "Uke", "prev-month": "Måned", "prev-year": "År", next: "Neste", "next-week": "Uke", "next-month": "Måned", "next-year": "År", "less-than": "Datoperioden skal ikkje være lengre enn %d dager", "more-than": "Datoperioden skal ikkje være kortere enn %d dager", "default-more": "Vennligst velg ein datoperiode lengre enn %d dager", "default-single": "Vennligst velg ein dato", "default-less": "Vennligst velg ein datoperiode mindre enn %d dager", "default-range": "Vennligst velg ein datoperiode mellom %d og %d dager", "default-default": "Vennligst velg ein datoperiode", time: "Tid", hour: "Time", minute: "Minutter" }, nl: { selected: "Geselecteerd:", day: "Dag", days: "Dagen", apply: "Ok", "week-1": "ma", "week-2": "di", "week-3": "wo", "week-4": "do", "week-5": "vr", "week-6": "za", "week-7": "zo", "month-name": ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"], shortcuts: "Snelkoppelingen", "custom-values": "Aangepaste waarden", past: "Verleden", following: "Komend", previous: "Vorige", "prev-week": "Week", "prev-month": "Maand", "prev-year": "Jaar", next: "Volgende", "next-week": "Week", "next-month": "Maand", "next-year": "Jaar", "less-than": "Interval moet langer dan %d dagen zijn", "more-than": "Interval mag niet minder dan %d dagen zijn", "default-more": "Selecteer een interval langer dan %dagen", "default-single": "Selecteer een datum", "default-less": "Selecteer een interval minder dan %d dagen", "default-range": "Selecteer een interval tussen %d en %d dagen", "default-default": "Selecteer een interval", time: "Tijd", hour: "Uur", minute: "Minuut" }, ru: { selected: "Выбрано:", day: "День", days: "Дней", apply: "Применить", "week-1": "пн", "week-2": "вт", "week-3": "ср", "week-4": "чт", "week-5": "пт", "week-6": "сб", "week-7": "вс", "month-name": ["январь", "февраль", "март", "апрель", "май", "июнь", "июль", "август", "сентябрь", "октябрь", "ноябрь", "декабрь"], shortcuts: "Быстрый выбор", "custom-values": "Пользовательские значения", past: "Прошедшие", following: "Следующие", previous: "&nbsp;&nbsp;&nbsp;", "prev-week": "Неделя", "prev-month": "Месяц", "prev-year": "Год", next: "&nbsp;&nbsp;&nbsp;", "next-week": "Неделя", "next-month": "Месяц", "next-year": "Год", "less-than": "Диапазон не может быть больше %d дней", "more-than": "Диапазон не может быть меньше %d дней", "default-more": "Пожалуйста выберите диапазон больше %d дней", "default-single": "Пожалуйста выберите дату", "default-less": "Пожалуйста выберите диапазон меньше %d дней", "default-range": "Пожалуйста выберите диапазон между %d и %d днями", "default-default": "Пожалуйста выберите диапазон", time: "Время", hour: "Часы", minute: "Минуты" }, pl: { selected: "Wybrany:", day: "Dzień", days: "Dni", apply: "Zamknij", "week-1": "pon", "week-2": "wt", "week-3": "śr", "week-4": "czw", "week-5": "pt", "week-6": "so", "week-7": "nd", "month-name": ["styczeń", "luty", "marzec", "kwiecień", "maj", "czerwiec", "lipiec", "sierpień", "wrzesień", "październik", "listopad", "grudzień"], shortcuts: "Skróty", "custom-values": "Niestandardowe wartości", past: "Przeszłe", following: "Następne", previous: "Poprzednie", "prev-week": "tydzień", "prev-month": "miesiąc", "prev-year": "rok", next: "Następny", "next-week": "tydzień", "next-month": "miesiąc", "next-year": "rok", "less-than": "Okres nie powinien być dłuższy niż %d dni", "more-than": "Okres nie powinien być krótszy niż  %d ni", "default-more": "Wybierz okres dłuższy niż %d dni", "default-single": "Wybierz datę", "default-less": "Wybierz okres krótszy niż %d dni", "default-range": "Wybierz okres trwający od %d do %d dni", "default-default": "Wybierz okres", time: "Czas", hour: "Godzina", minute: "Minuta" }, se: { selected: "Vald:", day: "dag", days: "dagar", apply: "godkänn", "week-1": "ma", "week-2": "ti", "week-3": "on", "week-4": "to", "week-5": "fr", "week-6": "lö", "week-7": "sö", "month-name": ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"], shortcuts: "genvägar", "custom-values": "Anpassade värden", past: "över", following: "följande", previous: "förra", "prev-week": "vecka", "prev-month": "månad", "prev-year": "år", next: "nästa", "next-week": "vecka", "next-month": "måned", "next-year": "år", "less-than": "Datumintervall bör inte vara mindre än %d dagar", "more-than": "Datumintervall bör inte vara mer än %d dagar", "default-more": "Välj ett datumintervall längre än %d dagar", "default-single": "Välj ett datum", "default-less": "Välj ett datumintervall mindre än %d dagar", "default-range": "Välj ett datumintervall mellan %d och %d dagar", "default-default": "Välj ett datumintervall", time: "tid", hour: "timme", minute: "minut" }, pt: { selected: "Selecionado:", day: "Dia", days: "Dias", apply: "Fechar", "week-1": "seg", "week-2": "ter", "week-3": "qua", "week-4": "qui", "week-5": "sex", "week-6": "sab", "week-7": "dom", "week-number": "N", "month-name": ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"], shortcuts: "Atalhos", "custom-values": "Valores Personalizados", past: "Passado", following: "Seguinte", previous: "Anterior", "prev-week": "Semana", "prev-month": "Mês", "prev-year": "Ano", next: "Próximo", "next-week": "Próxima Semana", "next-month": "Próximo Mês", "next-year": "Próximo Ano", "less-than": "O período selecionado não deve ser maior que %d dias", "more-than": "O período selecionado não deve ser menor que %d dias", "default-more": "Selecione um período superior a %d dias", "default-single": "Selecione uma data", "default-less": "Selecione um período inferior a %d dias", "default-range": "Selecione um período de %d a %d dias", "default-default": "Selecione um período", time: "Tempo", hour: "Hora", minute: "Minuto" }, tc: { selected: "已選擇:", day: "天", days: "天", apply: "確定", "week-1": "一", "week-2": "二", "week-3": "三", "week-4": "四", "week-5": "五", "week-6": "六", "week-7": "日", "week-number": "周", "month-name": ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], shortcuts: "快速選擇", past: "過去", following: "將來", previous: "&nbsp;&nbsp;&nbsp;", "prev-week": "上週", "prev-month": "上個月", "prev-year": "去年", next: "&nbsp;&nbsp;&nbsp;", "next-week": "下周", "next-month": "下個月", "next-year": "明年", "less-than": "所選日期範圍不能大於%d天", "more-than": "所選日期範圍不能小於%d天", "default-more": "請選擇大於%d天的日期範圍", "default-less": "請選擇小於%d天的日期範圍", "default-range": "請選擇%d天到%d天的日期範圍", "default-single": "請選擇一個日期", "default-default": "請選擇一個日期範圍", time: "日期", hour: "小時", minute: "分鐘" }, ja: { selected: "選択しました:", day: "日", days: "日々", apply: "閉じる", "week-1": "月", "week-2": "火", "week-3": "水", "week-4": "木", "week-5": "金", "week-6": "土", "week-7": "日", "month-name": ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"], shortcuts: "クイック選択", past: "過去", following: "将来", previous: "&nbsp;&nbsp;&nbsp;", "prev-week": "先週、", "prev-month": "先月", "prev-year": "昨年", next: "&nbsp;&nbsp;&nbsp;", "next-week": "来週", "next-month": "来月", "next-year": "来年", "less-than": "日付の範囲は ％d 日以上にすべきではありません", "more-than": "日付の範囲は ％d 日を下回ってはいけません", "default-more": "％d 日よりも長い期間を選択してください", "default-less": "％d 日未満の期間を選択してください", "default-range": "％d と％ d日の間の日付範囲を選択してください", "default-single": "日付を選択してください", "default-default": "日付範囲を選択してください", time: "時間", hour: "時間", minute: "分" }, da: { selected: "Valgt:", day: "Dag", days: "Dage", apply: "Luk", "week-1": "ma", "week-2": "ti", "week-3": "on", "week-4": "to", "week-5": "fr", "week-6": "lö", "week-7": "sö", "month-name": ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"], shortcuts: "genveje", "custom-values": "Brugerdefinerede værdier", past: "Forbi", following: "Følgende", previous: "Forrige", "prev-week": "uge", "prev-month": "månad", "prev-year": "år", next: "Næste", "next-week": "Næste uge", "next-month": "Næste måned", "next-year": "Næste år", "less-than": "Dato interval bør ikke være med end %d dage", "more-than": "Dato interval bør ikke være mindre end %d dage", "default-more": "Vælg datointerval længere end %d dage", "default-single": "Vælg dato", "default-less": "Vælg datointerval mindre end %d dage", "default-range": "Vælg datointerval mellem %d og %d dage", "default-default": "Vælg datointerval", time: "tid", hour: "time", minute: "minut" }, fi: { selected: "Valittu:", day: "Päivä", days: "Päivää", apply: "Sulje", "week-1": "ma", "week-2": "ti", "week-3": "ke", "week-4": "to", "week-5": "pe", "week-6": "la", "week-7": "su", "week-number": "V", "month-name": ["tammikuu", "helmikuu", "maaliskuu", "huhtikuu", "toukokuu", "kesäkuu", "heinäkuu", "elokuu", "syyskuu", "lokakuu", "marraskuu", "joulukuu"], shortcuts: "Pikavalinnat", "custom-values": "Mukautetut Arvot", past: "Menneet", following: "Tulevat", previous: "Edellinen", "prev-week": "Viikko", "prev-month": "Kuukausi", "prev-year": "Vuosi", next: "Seuraava", "next-week": "Viikko", "next-month": "Kuukausi", "next-year": "Vuosi", "less-than": "Aikajakson tulisi olla vähemmän kuin %d päivää", "more-than": "Aikajakson ei tulisi olla vähempää kuin %d päivää", "default-more": "Valitse pidempi aikajakso kuin %d päivää", "default-single": "Valitse päivä", "default-less": "Valitse lyhyempi aikajakso kuin %d päivää", "default-range": "Valitse aikajakso %d ja %d päivän väliltä", "default-default": "Valitse aikajakso", time: "Aika", hour: "Tunti", minute: "Minuutti" }, cat: { selected: "Seleccionats:", day: "Dia", days: "Dies", apply: "Tanca", "week-1": "Dl", "week-2": "Dm", "week-3": "Dc", "week-4": "Dj", "week-5": "Dv", "week-6": "Ds", "week-7": "Dg", "week-number": "S", "month-name": ["gener", "febrer", "març", "abril", "maig", "juny", "juliol", "agost", "setembre", "octubre", "novembre", "desembre"], shortcuts: "Dreçeres", "custom-values": "Valors personalitzats", past: "Passat", following: "Futur", previous: "Anterior", "prev-week": "Setmana", "prev-month": "Mes", "prev-year": "Any", next: "Següent", "next-week": "Setmana", "next-month": "Mes", "next-year": "Any", "less-than": "El període no hauria de ser de més de %d dies", "more-than": "El període no hauria de ser de menys de %d dies", "default-more": "Perfavor selecciona un període més gran de %d dies", "default-single": "Perfavor selecciona una data", "default-less": "Perfavor selecciona un període de menys de %d dies", "default-range": "Perfavor selecciona un període d'entre %d i %d dies", "default-default": "Perfavor selecciona un període", time: "Temps", hour: "Hora", minute: "Minut" } }, e.fn.dateRangePicker = function (a) {
	    function n(t, a) {
	      return a.contains(t.target) || t.target == a || void 0 != a.childNodes && e.inArray(t.target, a.childNodes) >= 0;
	    }function r() {
	      if (!a.inline) {
	        var t = e(ue).offset();if ("relative" == e(a.container).css("position")) {
	          var n = e(a.container).offset(),
	              r = Math.max(0, t.left + ie.outerWidth() - e("body").width() + 16);ie.css({ top: t.top - n.top + e(ue).outerHeight() + 4, left: t.left - n.left - r });
	        } else t.left < 460 ? ie.css({ top: t.top + e(ue).outerHeight() + parseInt(e("body").css("border-top") || 0, 10), left: t.left }) : ie.css({ top: t.top + e(ue).outerHeight() + parseInt(e("body").css("border-top") || 0, 10), left: t.left + e(ue).width() - ie.width() - 16 });
	      }
	    }function s(t) {
	      F(), i(), a.customOpenAnimation ? a.customOpenAnimation.call(ie.get(0), function () {
	        e(ue).trigger("datepicker-opened", { relatedTarget: ie });
	      }) : ie.slideDown(t, function () {
	        e(ue).trigger("datepicker-opened", { relatedTarget: ie });
	      }), e(ue).trigger("datepicker-open", { relatedTarget: ie }), B(), d(), r();
	    }function i() {
	      var e = a.getValue.call(me),
	          n = e ? e.split(a.separator) : "";if (n && (1 == n.length && a.singleDate || n.length >= 2)) {
	        var r = a.format;r.match(/Do/) && (r = r.replace(/Do/, "D"), n[0] = n[0].replace(/(\d+)(th|nd|st)/, "$1"), n.length >= 2 && (n[1] = n[1].replace(/(\d+)(th|nd|st)/, "$1"))), le = !1, n.length >= 2 ? T(o(n[0], r, t.locale(a.language)), o(n[1], r, t.locale(a.language))) : 1 == n.length && a.singleDate && C(o(n[0], r, t.locale(a.language))), le = !0;
	      }
	    }function o(e, a, n) {
	      return t(e, a, n).isValid() ? t(e, a, n).toDate() : t().toDate();
	    }function d() {
	      var e = ie.find(".gap").css("margin-left");e && (e = parseInt(e));var t = ie.find(".month1").width(),
	          a = ie.find(".gap").width() + (e ? 2 * e : 0),
	          n = ie.find(".month2").width();ie.find(".month-wrapper").width(t + a + n);
	    }function l(e, a) {
	      ie.find("." + e + " input[type=range].hour-range").val(t(a).hours()), ie.find("." + e + " input[type=range].minute-range").val(t(a).minutes()), h(e, t(a).format("HH"), t(a).format("mm"));
	    }function u(e, n) {
	      a[e] = parseInt(t(parseInt(n)).startOf("day").add(t(a[e + "Time"]).format("HH"), "h").add(t(a[e + "Time"]).format("mm"), "m").valueOf());
	    }function m() {
	      l("time1", a.start), l("time2", a.end);
	    }function h(e, n, r) {
	      function s(e, t) {
	        var s = t.format("HH"),
	            i = t.format("mm");a[e] = t.startOf("day").add(n || s, "h").add(r || i, "m").valueOf();
	      }switch (n && ie.find("." + e + " .hour-val").text(n), r && ie.find("." + e + " .minute-val").text(r), e) {case "time1":
	          a.start && s("start", t(a.start)), s("startTime", t(a.startTime || t().valueOf()));break;case "time2":
	          a.end && s("end", t(a.end)), s("endTime", t(a.endTime || t().valueOf()));}x(), M(), O();
	    }function c(e) {
	      var n = e;return "week-range" === a.batchMode ? n = "monday" === a.startOfWeek ? t(parseInt(e)).startOf("isoweek").valueOf() : t(parseInt(e)).startOf("week").valueOf() : "month-range" === a.batchMode && (n = t(parseInt(e)).startOf("month").valueOf()), n;
	    }function p(e) {
	      var n = e;return "week-range" === a.batchMode ? n = "monday" === a.startOfWeek ? t(parseInt(e)).endOf("isoweek").valueOf() : t(parseInt(e)).endOf("week").valueOf() : "month-range" === a.batchMode && (n = t(parseInt(e)).endOf("month").valueOf()), n;
	    }function f(n) {
	      if (!n.hasClass("invalid")) {
	        var r = n.attr("time");if (n.addClass("checked"), a.singleDate ? (a.start = r, a.end = !1) : "week" === a.batchMode ? "monday" === a.startOfWeek ? (a.start = t(parseInt(r)).startOf("isoweek").valueOf(), a.end = t(parseInt(r)).endOf("isoweek").valueOf()) : (a.end = t(parseInt(r)).endOf("week").valueOf(), a.start = t(parseInt(r)).startOf("week").valueOf()) : "workweek" === a.batchMode ? (a.start = t(parseInt(r)).day(1).valueOf(), a.end = t(parseInt(r)).day(5).valueOf()) : "weekend" === a.batchMode ? (a.start = t(parseInt(r)).day(6).valueOf(), a.end = t(parseInt(r)).day(7).valueOf()) : "month" === a.batchMode ? (a.start = t(parseInt(r)).startOf("month").valueOf(), a.end = t(parseInt(r)).endOf("month").valueOf()) : a.start && a.end || !a.start && !a.end ? (a.start = c(r), a.end = !1) : a.start && (a.end = p(r), a.time.enabled && u("end", a.end)), a.time.enabled && (a.start && u("start", a.start), a.end && u("end", a.end)), !a.singleDate && a.start && a.end && a.start > a.end) {
	          var s = a.end;a.end = p(a.start), a.start = c(s), a.time.enabled && a.swapTime && m();
	        }a.start = parseInt(a.start), a.end = parseInt(a.end), y(), a.start && !a.end && (e(ue).trigger("datepicker-first-date-selected", { date1: new Date(a.start) }), w(n)), k(r), x(), M(), O(), D();
	      }
	    }function v(e) {
	      var n,
	          r,
	          s = parseInt(e.attr("data-start-time"), 10);a.startWeek ? (ie.find(".week-number-selected").removeClass("week-number-selected"), n = new Date(s < a.startWeek ? s : a.startWeek), r = new Date(s < a.startWeek ? a.startWeek : s), a.startWeek = !1, a.start = t(n).day("monday" == a.startOfWeek ? 1 : 0).valueOf(), a.end = t(r).day("monday" == a.startOfWeek ? 7 : 6).valueOf()) : (a.startWeek = s, e.addClass("week-number-selected"), n = new Date(s), a.start = t(n).day("monday" == a.startOfWeek ? 1 : 0).valueOf(), a.end = t(n).day("monday" == a.startOfWeek ? 7 : 6).valueOf()), k(), x(), M(), O(), D();
	    }function g(e) {
	      if (e = parseInt(e, 10), a.startDate && R(e, a.startDate) < 0) return !1;if (a.endDate && R(e, a.endDate) > 0) return !1;if (a.start && !a.end && !a.singleDate) {
	        if (a.maxDays > 0 && S(e, a.start) > a.maxDays) return !1;if (a.minDays > 0 && S(e, a.start) < a.minDays) return !1;if (a.selectForward && e < a.start) return !1;if (a.selectBackward && e > a.start) return !1;if (a.beforeShowDay && "function" == typeof a.beforeShowDay) {
	          for (var t = !0, n = e; S(n, a.start) > 1;) {
	            if (!a.beforeShowDay(new Date(n))[0]) {
	              t = !1;break;
	            }if (Math.abs(n - a.start) < 864e5) break;n > a.start && (n -= 864e5), n < a.start && (n += 864e5);
	          }if (!t) return !1;
	        }
	      }return !0;
	    }function k() {
	      return ie.find(".day.invalid.tmp").removeClass("tmp invalid").addClass("valid"), a.start && !a.end && ie.find(".day.toMonth.valid").each(function () {
	        g(parseInt(e(this).attr("time"), 10)) ? e(this).addClass("valid tmp").removeClass("invalid") : e(this).addClass("invalid tmp").removeClass("valid");
	      }), !0;
	    }function w(t) {
	      var n = parseInt(t.attr("time")),
	          r = "";if (t.hasClass("has-tooltip") && t.attr("data-tooltip")) r = '<span style="white-space:nowrap">' + t.attr("data-tooltip") + "</span>";else if (!t.hasClass("invalid")) if (a.singleDate) ie.find(".day.hovering").removeClass("hovering"), t.addClass("hovering");else if (ie.find(".day").each(function () {
	        var t = parseInt(e(this).attr("time"));a.start, a.end;t == n ? e(this).addClass("hovering") : e(this).removeClass("hovering"), a.start && !a.end && (a.start < t && n >= t || a.start > t && n <= t) ? e(this).addClass("hovering") : e(this).removeClass("hovering");
	      }), a.start && !a.end) {
	        var s = S(n, a.start);a.hoveringTooltip && ("function" == typeof a.hoveringTooltip ? r = a.hoveringTooltip(s, a.start, n) : !0 === a.hoveringTooltip && s > 1 && (r = s + " " + ne("days")));
	      }if (r) {
	        var i = t.offset(),
	            o = ie.offset(),
	            d = i.left - o.left,
	            l = i.top - o.top;d += t.width() / 2;var u = ie.find(".date-range-length-tip"),
	            m = u.css({ visibility: "hidden", display: "none" }).html(r).width(),
	            h = u.height();d -= m / 2, l -= h, setTimeout(function () {
	          u.css({ left: d, top: l, display: "block", visibility: "visible" });
	        }, 10);
	      } else ie.find(".date-range-length-tip").hide();
	    }function y() {
	      ie.find(".day.hovering").removeClass("hovering"), ie.find(".date-range-length-tip").hide();
	    }function b(e) {
	      var n = e.val(),
	          r = e.attr("name"),
	          s = e.parents("table").hasClass("month1") ? "month1" : "month2",
	          i = "month1" === s ? "month2" : "month1",
	          o = !!a.startDate && t(a.startDate),
	          d = !!a.endDate && t(a.endDate),
	          l = t(a[s])[r](n);o && l.isSameOrBefore(o) && (l = o.add("month2" === s ? 1 : 0, "month")), d && l.isSameOrAfter(d) && (l = d.add(a.singleMonth || "month1" !== s ? 0 : -1, "month")), z(l, s), "month1" === s ? (a.stickyMonths || t(l).isSameOrAfter(a[i], "month")) && z(t(l).add(1, "month"), i) : (a.stickyMonths || t(l).isSameOrBefore(a[i], "month")) && z(t(l).add(-1, "month"), i), B();
	    }function D() {
	      !0 === a.singleDate ? le && a.start && a.autoClose && L() : le && a.start && a.end && a.autoClose && L();
	    }function x() {
	      var e = Math.ceil((a.end - a.start) / 864e5) + 1;a.singleDate ? a.start && !a.end ? ie.find(".drp_top-bar").removeClass("error").addClass("normal") : ie.find(".drp_top-bar").removeClass("error").removeClass("normal") : a.maxDays && e > a.maxDays ? (a.start = !1, a.end = !1, ie.find(".day").removeClass("checked"), ie.find(".drp_top-bar").removeClass("normal").addClass("error").find(".error-top").html(ne("less-than").replace("%d", a.maxDays))) : a.minDays && e < a.minDays ? (a.start = !1, a.end = !1, ie.find(".day").removeClass("checked"), ie.find(".drp_top-bar").removeClass("normal").addClass("error").find(".error-top").html(ne("more-than").replace("%d", a.minDays))) : a.start || a.end ? ie.find(".drp_top-bar").removeClass("error").addClass("normal") : ie.find(".drp_top-bar").removeClass("error").removeClass("normal"), a.singleDate && a.start && !a.end || !a.singleDate && a.start && a.end ? ie.find(".apply-btn").removeClass("disabled") : ie.find(".apply-btn").addClass("disabled"), a.batchMode && (a.start && a.startDate && R(a.start, a.startDate) < 0 || a.end && a.endDate && R(a.end, a.endDate) > 0) && (a.start = !1, a.end = !1, ie.find(".day").removeClass("checked"));
	    }function M(t, n) {
	      ie.find(".start-day").html("..."), ie.find(".end-day").html("..."), ie.find(".selected-days").hide(), a.start && ie.find(".start-day").html(N(new Date(parseInt(a.start)))), a.end && ie.find(".end-day").html(N(new Date(parseInt(a.end))));var r;a.start && a.singleDate ? (ie.find(".apply-btn").removeClass("disabled"), r = N(new Date(a.start)), a.setValue.call(me, r, N(new Date(a.start)), N(new Date(a.end))), le && !n && e(ue).trigger("datepicker-change", { value: r, date1: new Date(a.start) })) : a.start && a.end ? (ie.find(".selected-days").show().find(".selected-days-num").html(S(a.end, a.start)), ie.find(".apply-btn").removeClass("disabled"), r = N(new Date(a.start)) + a.separator + N(new Date(a.end)), a.setValue.call(me, r, N(new Date(a.start)), N(new Date(a.end))), le && !n && e(ue).trigger("datepicker-change", { value: r, date1: new Date(a.start), date2: new Date(a.end) })) : t ? ie.find(".apply-btn").removeClass("disabled") : ie.find(".apply-btn").addClass("disabled");
	    }function S(e, t) {
	      return Math.abs(X(e) - X(t)) + 1;
	    }function T(e, t, n) {
	      if (e.getTime() > t.getTime()) {
	        var r = t;t = e, e = r, r = null;
	      }var s = !0;if (a.startDate && R(e, a.startDate) < 0 && (s = !1), a.endDate && R(t, a.endDate) > 0 && (s = !1), !s) return z(a.startDate, "month1"), z(E(a.startDate), "month2"), void B();a.start = e.getTime(), a.end = t.getTime(), a.time.enabled && (l("time1", e), l("time2", t)), (a.stickyMonths || R(e, t) > 0 && 0 === H(e, t)) && (a.lookBehind ? e = q(t) : t = E(e)), a.stickyMonths && !1 !== a.endDate && H(t, a.endDate) > 0 && (e = q(e), t = q(t)), a.stickyMonths || 0 === H(e, t) && (a.lookBehind ? e = q(t) : t = E(e)), z(e, "month1"), z(t, "month2"), B(), x(), M(!1, n), D();
	    }function C(e) {
	      var t = !0;a.startDate && R(e, a.startDate) < 0 && (t = !1), a.endDate && R(e, a.endDate) > 0 && (t = !1), t ? (a.start = e.getTime(), a.time.enabled && l("time1", e), z(e, "month1"), !0 !== a.singleMonth && z(E(e), "month2"), B(), M(), D()) : z(a.startDate, "month1");
	    }function O() {
	      (a.start || a.end) && (ie.find(".day").each(function () {
	        var n = parseInt(e(this).attr("time")),
	            r = a.start,
	            s = a.end;a.time.enabled && (n = t(n).startOf("day").valueOf(), r = t(r || t().valueOf()).startOf("day").valueOf(), s = t(s || t().valueOf()).startOf("day").valueOf()), a.start && a.end && s >= n && r <= n || a.start && !a.end && t(r).format("YYYY-MM-DD") == t(n).format("YYYY-MM-DD") ? e(this).addClass("checked") : e(this).removeClass("checked"), a.start && t(r).format("YYYY-MM-DD") == t(n).format("YYYY-MM-DD") ? e(this).addClass("first-date-selected") : e(this).removeClass("first-date-selected"), a.end && t(s).format("YYYY-MM-DD") == t(n).format("YYYY-MM-DD") ? e(this).addClass("last-date-selected") : e(this).removeClass("last-date-selected");
	      }), ie.find(".week-number").each(function () {
	        e(this).attr("data-start-time") == a.startWeek && e(this).addClass("week-number-selected");
	      }));
	    }function z(e, n) {
	      var r = j(e = t(e).toDate(), n),
	          s = P(e, n);ie.find("." + n + " .month-name").html(r + " " + s), ie.find("." + n + " tbody").html(te(e)), a[n] = e, k(), A();
	    }function j(e, n) {
	      var r,
	          s = !!a.startDate && t(a.startDate).add(a.singleMonth || "month2" !== n ? 0 : 1, "month"),
	          i = !!a.endDate && t(a.endDate).add(a.singleMonth || "month1" !== n ? 0 : -1, "month");return e = t(e), !a.monthSelect || s && i && s.isSame(i, "month") ? '<div class="month-element">' + I(e.get("month")) + "</div>" : (r = [s && e.isSame(s, "year") ? s.get("month") : 0, i && e.isSame(i, "year") ? i.get("month") : 11])[0] === r[1] ? '<div class="month-element">' + I(e.get("month")) + "</div>" : Y("month", V(r, e.get("month"), function (e) {
	        return I(e);
	      }));
	    }function P(e, n) {
	      e = t(e);var r,
	          s = !!a.startDate && t(a.startDate).add(a.singleMonth || "month2" !== n ? 0 : 1, "month"),
	          i = !!a.endDate && t(a.endDate).add(a.singleMonth || "month1" !== n ? 0 : -1, "month"),
	          o = e.get("year"),
	          d = a.yearSelect && "function" == typeof a.yearSelect;return !a.yearSelect || s && i && s.isSame(t(i), "year") ? '<div class="month-element">' + o + "</div>" : (r = d ? a.yearSelect(o) : a.yearSelect.slice(), r = [s ? Math.max(r[0], s.get("year")) : Math.min(r[0], o), i ? Math.min(r[1], i.get("year")) : Math.max(r[1], o)], Y("year", V(r, o)));
	    }function V(e, t, a) {
	      var n = [];a = a || function (e) {
	        return e;
	      };for (var r = e[0]; r <= e[1]; r++) {
	        n.push({ value: r, text: a(r), isCurrent: r === t });
	      }return n;
	    }function Y(e, t) {
	      for (var a, n = '<div class="select-wrapper"><select class="' + e + '" name="' + e + '">', r = 0, s = t.length; r < s; r++) {
	        n += '<option value="' + t[r].value + '"' + (t[r].isCurrent ? " selected" : "") + ">", n += t[r].text, n += "</option>", t[r].isCurrent && (a = t[r].text);
	      }return n += "</select>" + a + "</div>";
	    }function A() {
	      ie.find(".day").unbind("click").click(function (t) {
	        f(e(this));
	      }), ie.find(".day").unbind("mouseenter").mouseenter(function (t) {
	        w(e(this));
	      }), ie.find(".day").unbind("mouseleave").mouseleave(function (e) {
	        ie.find(".date-range-length-tip").hide(), a.singleDate && y();
	      }), ie.find(".week-number").unbind("click").click(function (t) {
	        v(e(this));
	      }), ie.find(".month").unbind("change").change(function (t) {
	        b(e(this));
	      }), ie.find(".year").unbind("change").change(function (t) {
	        b(e(this));
	      });
	    }function W(e, t) {
	      ie.find("." + t).append($()), l(t, e);
	    }function I(e) {
	      return ne("month-name")[e];
	    }function N(e) {
	      return t(e).format(a.format);
	    }function B() {
	      O();var e = parseInt(t(a.month1).format("YYYYMM")),
	          n = parseInt(t(a.month2).format("YYYYMM")),
	          r = Math.abs(e - n);r > 1 && 89 != r ? ie.addClass("has-gap").removeClass("no-gap").find(".gap").css("visibility", "visible") : ie.removeClass("has-gap").addClass("no-gap").find(".gap").css("visibility", "hidden");var s = ie.find("table.month1").height(),
	          i = ie.find("table.month2").height();ie.find(".gap").height(Math.max(s, i) + 10);
	    }function L() {
	      if (!a.alwaysOpen) {
	        var t = function t() {
	          e(ue).data("date-picker-opened", !1), e(ue).trigger("datepicker-closed", { relatedTarget: ie });
	        };a.customCloseAnimation ? a.customCloseAnimation.call(ie.get(0), t) : e(ie).slideUp(a.duration, t), e(ue).trigger("datepicker-close", { relatedTarget: ie });
	      }
	    }function F() {
	      z(a.month1, "month1"), z(a.month2, "month2");
	    }function H(e, a) {
	      var n = parseInt(t(e).format("YYYYMM")) - parseInt(t(a).format("YYYYMM"));return n > 0 ? 1 : 0 === n ? 0 : -1;
	    }function R(e, a) {
	      var n = parseInt(t(e).format("YYYYMMDD")) - parseInt(t(a).format("YYYYMMDD"));return n > 0 ? 1 : 0 === n ? 0 : -1;
	    }function E(e) {
	      return t(e).add(1, "months").toDate();
	    }function q(e) {
	      return t(e).add(-1, "months").toDate();
	    }function $() {
	      return "<div><span>" + ne("Time") + ': <span class="hour-val">00</span>:<span class="minute-val">00</span></span></div><div class="hour"><label>' + ne("Hour") + ': <input type="range" class="hour-range" name="hour" min="0" max="23"></label></div><div class="minute"><label>' + ne("Minute") + ': <input type="range" class="minute-range" name="minute" min="0" max="59"></label></div>';
	    }function J() {
	      var t = '<div class="date-picker-wrapper';a.extraClass && (t += " " + a.extraClass + " "), a.singleDate && (t += " single-date "), a.showShortcuts || (t += " no-shortcuts "), a.showTopbar || (t += " no-topbar "), a.customTopBar && (t += " custom-topbar "), t += '">', a.showTopbar && (t += '<div class="drp_top-bar">', a.customTopBar ? ("function" == typeof a.customTopBar && (a.customTopBar = a.customTopBar()), t += '<div class="custom-top">' + a.customTopBar + "</div>") : (t += '<div class="normal-top"><span style="color:#333">' + ne("selected") + ' </span> <b class="start-day">...</b>', a.singleDate || (t += ' <span class="separator-day">' + a.separator + '</span> <b class="end-day">...</b> <i class="selected-days">(<span class="selected-days-num">3</span> ' + ne("days") + ")</i>"), t += "</div>", t += '<div class="error-top">error</div><div class="default-top">default</div>'), t += '<input type="button" class="apply-btn disabled' + K() + '" value="' + ne("apply") + '" />', t += "</div>");var n = a.showWeekNumbers ? 6 : 5,
	          r = "&lt;";a.customArrowPrevSymbol && (r = a.customArrowPrevSymbol);var s = "&gt;";if (a.customArrowNextSymbol && (s = a.customArrowNextSymbol), t += '<div class="month-wrapper">   <table class="month1" cellspacing="0" border="0" cellpadding="0">       <thead>           <tr class="caption">               <th style="width:27px;">                   <span class="prev">' + r + '                   </span>               </th>               <th colspan="' + n + '" class="month-name">               </th>               <th style="width:27px;">' + (a.singleDate || !a.stickyMonths ? '<span class="next">' + s + "</span>" : "") + '               </th>           </tr>           <tr class="week-name">' + _() + "       </thead>       <tbody></tbody>   </table>", Z() && (t += '<div class="gap">' + U() + '</div><table class="month2" cellspacing="0" border="0" cellpadding="0">   <thead>   <tr class="caption">       <th style="width:27px;">' + (a.stickyMonths ? "" : '<span class="prev">' + r + "</span>") + '       </th>       <th colspan="' + n + '" class="month-name">       </th>       <th style="width:27px;">           <span class="next">' + s + '</span>       </th>   </tr>   <tr class="week-name">' + _() + "   </thead>   <tbody></tbody></table>"), t += '<div style="clear:both;height:0;font-size:0;"></div><div class="time"><div class="time1"></div>', a.singleDate || (t += '<div class="time2"></div>'), t += '</div><div style="clear:both;height:0;font-size:0;"></div></div>', t += '<div class="footer">', a.showShortcuts) {
	        t += '<div class="shortcuts"><b>' + ne("shortcuts") + "</b>";var i = a.shortcuts;if (i) {
	          var o;if (i["prev-days"] && i["prev-days"].length > 0) {
	            t += '&nbsp;<span class="prev-days">' + ne("past");for (d = 0; d < i["prev-days"].length; d++) {
	              o = i["prev-days"][d], o += ne(i["prev-days"][d] > 1 ? "days" : "day"), t += ' <a href="javascript:;" shortcut="day,-' + i["prev-days"][d] + '">' + o + "</a>";
	            }t += "</span>";
	          }if (i["next-days"] && i["next-days"].length > 0) {
	            t += '&nbsp;<span class="next-days">' + ne("following");for (d = 0; d < i["next-days"].length; d++) {
	              o = i["next-days"][d], o += ne(i["next-days"][d] > 1 ? "days" : "day"), t += ' <a href="javascript:;" shortcut="day,' + i["next-days"][d] + '">' + o + "</a>";
	            }t += "</span>";
	          }if (i.prev && i.prev.length > 0) {
	            t += '&nbsp;<span class="prev-buttons">' + ne("previous");for (d = 0; d < i.prev.length; d++) {
	              o = ne("prev-" + i.prev[d]), t += ' <a href="javascript:;" shortcut="prev,' + i.prev[d] + '">' + o + "</a>";
	            }t += "</span>";
	          }if (i.next && i.next.length > 0) {
	            t += '&nbsp;<span class="next-buttons">' + ne("next");for (d = 0; d < i.next.length; d++) {
	              o = ne("next-" + i.next[d]), t += ' <a href="javascript:;" shortcut="next,' + i.next[d] + '">' + o + "</a>";
	            }t += "</span>";
	          }
	        }if (a.customShortcuts) for (d = 0; d < a.customShortcuts.length; d++) {
	          t += '&nbsp;<span class="custom-shortcut"><a href="javascript:;" shortcut="custom">' + a.customShortcuts[d].name + "</a></span>";
	        }t += "</div>";
	      }if (a.showCustomValues && (t += '<div class="customValues"><b>' + (a.customValueLabel || ne("custom-values")) + "</b>", a.customValues)) for (var d = 0; d < a.customValues.length; d++) {
	        var l = a.customValues[d];t += '&nbsp;<span class="custom-value"><a href="javascript:;" custom="' + l.value + '">' + l.name + "</a></span>";
	      }return t += "</div></div>", e(t);
	    }function K() {
	      var e = "";return !0 === a.autoClose && (e += " hide"), "" !== a.applyBtnClass && (e += " " + a.applyBtnClass), e;
	    }function _() {
	      var e = a.showWeekNumbers ? "<th>" + ne("week-number") + "</th>" : "";return "monday" == a.startOfWeek ? e + "<th>" + ne("week-1") + "</th><th>" + ne("week-2") + "</th><th>" + ne("week-3") + "</th><th>" + ne("week-4") + "</th><th>" + ne("week-5") + "</th><th>" + ne("week-6") + "</th><th>" + ne("week-7") + "</th>" : e + "<th>" + ne("week-7") + "</th><th>" + ne("week-1") + "</th><th>" + ne("week-2") + "</th><th>" + ne("week-3") + "</th><th>" + ne("week-4") + "</th><th>" + ne("week-5") + "</th><th>" + ne("week-6") + "</th>";
	    }function G(e) {
	      return e = t(e), !(!a.startDate || !e.endOf("month").isBefore(a.startDate)) || !(!a.endDate || !e.startOf("month").isAfter(a.endDate));
	    }function U() {
	      for (var e = ['<div class="gap-top-mask"></div><div class="gap-bottom-mask"></div><div class="gap-lines">'], t = 0; t < 20; t++) {
	        e.push('<div class="gap-line"><div class="gap-1"></div><div class="gap-2"></div><div class="gap-3"></div></div>');
	      }return e.push("</div>"), e.join("");
	    }function Z() {
	      return !a.singleMonth;
	    }function Q(t, a, n) {
	      var r = e.extend(!0, {}, t);e.each(a, function (e, t) {
	        var a = t(n);for (var s in a) {
	          r.hasOwnProperty(s) ? r[s] += a[s] : r[s] = a[s];
	        }
	      });var s = "";for (var i in r) {
	        r.hasOwnProperty(i) && (s += i + '="' + r[i] + '" ');
	      }return s;
	    }function X(e) {
	      return Math.floor(ee(e) / 864e5);
	    }function ee(e) {
	      return t.isMoment(e) && (e = e.toDate().getTime()), "object" == (typeof e === "undefined" ? "undefined" : (0, _typeof3.default)(e)) && e.getTime && (e = e.getTime()), "string" != typeof e || e.match(/\d{13}/) || (e = t(e, a.format).toDate().getTime()), e = parseInt(e, 10) - 60 * new Date().getTimezoneOffset() * 1e3;
	    }function te(e) {
	      var n = [];e.setDate(1);new Date(e.getTime() - 864e5);var r = new Date(),
	          s = e.getDay();0 === s && "monday" === a.startOfWeek && (s = 7);var i, o;if (s > 0) for (l = s; l > 0; l--) {
	        o = g((h = new Date(e.getTime() - 864e5 * l)).getTime()), a.startDate && R(h, a.startDate) < 0 && (o = !1), a.endDate && R(h, a.endDate) > 0 && (o = !1), n.push({ date: h, type: "lastMonth", day: h.getDate(), time: h.getTime(), valid: o });
	      }for (var d = e.getMonth(), l = 0; l < 40; l++) {
	        o = g((i = t(e).add(l, "days").toDate()).getTime()), a.startDate && R(i, a.startDate) < 0 && (o = !1), a.endDate && R(i, a.endDate) > 0 && (o = !1), n.push({ date: i, type: i.getMonth() == d ? "toMonth" : "nextMonth", day: i.getDate(), time: i.getTime(), valid: o });
	      }for (var u = [], m = 0; m < 6 && "nextMonth" != n[7 * m].type; m++) {
	        u.push("<tr>");for (var h = 0; h < 7; h++) {
	          i = n[7 * m + ("monday" == a.startOfWeek ? h + 1 : h)];var c = t(i.time).format("L") == t(r).format("L");if (i.extraClass = "", i.tooltip = "", i.valid && a.beforeShowDay && "function" == typeof a.beforeShowDay) {
	            var p = a.beforeShowDay(t(i.time).toDate());i.valid = p[0], i.extraClass = p[1] || "", i.tooltip = p[2] || "", "" !== i.tooltip && (i.extraClass += " has-tooltip ");
	          }var f = { time: i.time, "data-tooltip": i.tooltip, class: "day " + i.type + " " + i.extraClass + " " + (i.valid ? "valid" : "invalid") + " " + (c ? "real-today" : "") };0 === h && a.showWeekNumbers && u.push('<td><div class="week-number" data-start-time="' + i.time + '">' + a.getWeekNumber(i.date) + "</div></td>"), u.push("<td " + Q({}, a.dayTdAttrs, i) + "><div " + Q(f, a.dayDivAttrs, i) + ">" + ae(i.time, i.day) + "</div></td>");
	        }u.push("</tr>");
	      }return u.join("");
	    }function ae(e, t) {
	      return a.showDateFilter && "function" == typeof a.showDateFilter ? a.showDateFilter(e, t) : t;
	    }function ne(t) {
	      var a = t.toLowerCase(),
	          n = t in de ? de[t] : a in de ? de[a] : null,
	          r = e.dateRangePickerLanguages.default;return null == n && (n = t in r ? r[t] : a in r ? r[a] : ""), n;
	    }function re() {
	      var e = a.defaultTime ? a.defaultTime : new Date();return a.lookBehind ? (a.startDate && H(e, a.startDate) < 0 && (e = E(t(a.startDate).toDate())), a.endDate && H(e, a.endDate) > 0 && (e = t(a.endDate).toDate())) : (a.startDate && H(e, a.startDate) < 0 && (e = t(a.startDate).toDate()), a.endDate && H(E(e), a.endDate) > 0 && (e = q(t(a.endDate).toDate()))), a.singleDate && (a.startDate && H(e, a.startDate) < 0 && (e = t(a.startDate).toDate()), a.endDate && H(e, a.endDate) > 0 && (e = t(a.endDate).toDate())), e;
	    }function se(e) {
	      e || (e = re()), a.lookBehind ? (z(q(e), "month1"), z(e, "month2")) : (z(e, "month1"), z(E(e), "month2")), a.singleDate && z(e, "month1"), O(), B();
	    }a || (a = {}), (a = e.extend(!0, { autoClose: !1, format: "YYYY-MM-DD", separator: " to ", language: "auto", startOfWeek: "sunday", getValue: function getValue() {
	        return e(this).val();
	      }, setValue: function setValue(t) {
	        e(this).attr("readonly") || e(this).is(":disabled") || t == e(this).val() || e(this).val(t);
	      }, startDate: !1, endDate: !1, time: { enabled: !1 }, minDays: 0, maxDays: 0, showShortcuts: !1, shortcuts: {}, customShortcuts: [], inline: !1, container: "body", alwaysOpen: !1, singleDate: !1, lookBehind: !1, batchMode: !1, duration: 200, stickyMonths: !1, dayDivAttrs: [], dayTdAttrs: [], selectForward: !1, selectBackward: !1, applyBtnClass: "", singleMonth: "auto", hoveringTooltip: function hoveringTooltip(e, t, a) {
	        return e > 1 ? e + " " + ne("days") : "";
	      }, showTopbar: !0, swapTime: !1, showWeekNumbers: !1, getWeekNumber: function getWeekNumber(e) {
	        return t(e).format("w");
	      }, customOpenAnimation: null, customCloseAnimation: null, customArrowPrevSymbol: null, customArrowNextSymbol: null, monthSelect: !1, yearSelect: !1 }, a)).start = !1, a.end = !1, a.startWeek = !1, a.isTouchDevice = "ontouchstart" in window || navigator.msMaxTouchPoints, a.isTouchDevice && (a.hoveringTooltip = !1), "auto" == a.singleMonth && (a.singleMonth = e(window).width() < 480), a.singleMonth && (a.stickyMonths = !1), a.showTopbar || (a.autoClose = !0), a.startDate && "string" == typeof a.startDate && (a.startDate = t(a.startDate, a.format).toDate()), a.endDate && "string" == typeof a.endDate && (a.endDate = t(a.endDate, a.format).toDate()), a.yearSelect && "boolean" == typeof a.yearSelect && (a.yearSelect = function (e) {
	      return [e - 5, e + 5];
	    });var ie,
	        oe,
	        de = function () {
	      if ("auto" == a.language) {
	        var t = navigator.language ? navigator.language : navigator.browserLanguage;return t && (t = t.toLowerCase()) in e.dateRangePickerLanguages ? e.dateRangePickerLanguages[t] : e.dateRangePickerLanguages.default;
	      }return a.language && a.language in e.dateRangePickerLanguages ? e.dateRangePickerLanguages[a.language] : e.dateRangePickerLanguages.default;
	    }(),
	        le = !1,
	        ue = this,
	        me = e(ue).get(0);return e(this).unbind(".datepicker").bind("click.datepicker", function (e) {
	      ie.is(":visible") || s(a.duration);
	    }).bind("change.datepicker", function (e) {
	      i();
	    }).bind("keyup.datepicker", function () {
	      try {
	        clearTimeout(oe);
	      } catch (e) {}oe = setTimeout(function () {
	        i();
	      }, 2e3);
	    }), function () {
	      function s(t) {
	        var n = e(t).parents("table").hasClass("month2"),
	            r = n ? a.month2 : a.month1;r = E(r), !a.singleMonth && !a.singleDate && !n && H(r, a.month2) >= 0 || G(r) || (z(r, n ? "month2" : "month1"), B());
	      }function i(e) {
	        var t = E(a.month1),
	            n = E(a.month2);G(n) || !a.singleDate && H(t, n) >= 0 || (z(t, "month1"), z(n, "month2"), O());
	      }function o(t) {
	        var n = e(t).parents("table").hasClass("month2"),
	            r = n ? a.month2 : a.month1;r = q(r), n && H(r, a.month1) <= 0 || G(r) || (z(r, n ? "month2" : "month1"), B());
	      }function l(e) {
	        var t = q(a.month1),
	            n = q(a.month2);G(t) || !a.singleDate && H(n, t) <= 0 || (z(n, "month2"), z(t, "month1"), O());
	      }var u = this;if (e(this).data("date-picker-opened")) L();else {
	        e(this).data("date-picker-opened", !0), (ie = J().hide()).append('<div class="date-range-length-tip"></div>'), e(a.container).append(ie), a.inline ? ie.addClass("inline-wrapper") : r(), a.alwaysOpen && ie.find(".apply-btn").hide();var m = re();if (se(m), a.time.enabled) if (a.startDate && a.endDate || a.start && a.end) W(t(a.start || a.startDate).toDate(), "time1"), W(t(a.end || a.endDate).toDate(), "time2");else {
	          var c = a.defaultEndTime ? a.defaultEndTime : m;W(m, "time1"), W(c, "time2");
	        }var p = "";p = ne(a.singleDate ? "default-single" : a.minDays && a.maxDays ? "default-range" : a.minDays ? "default-more" : a.maxDays ? "default-less" : "default-default"), ie.find(".default-top").html(p.replace(/\%d/, a.minDays).replace(/\%d/, a.maxDays)), a.singleMonth ? ie.addClass("single-month") : ie.addClass("two-months"), setTimeout(function () {
	          d(), le = !0;
	        }, 0), ie.click(function (e) {
	          e.stopPropagation();
	        }), e(document).bind("click.datepicker", function (e) {
	          n(e, u[0]) || ie.is(":visible") && L();
	        }), ie.find(".next").click(function () {
	          a.stickyMonths ? i() : s(this);
	        }), ie.find(".prev").click(function () {
	          a.stickyMonths ? l() : o(this);
	        }), ie.attr("unselectable", "on").css("user-select", "none").bind("selectstart", function (e) {
	          return e.preventDefault(), !1;
	        }), ie.find(".apply-btn").click(function () {
	          L();var t = N(new Date(a.start)) + a.separator + N(new Date(a.end));e(u).trigger("datepicker-apply", { value: t, date1: new Date(a.start), date2: new Date(a.end) });
	        }), ie.find("[custom]").click(function () {
	          var t = e(this).attr("custom");a.start = !1, a.end = !1, ie.find(".day.checked").removeClass("checked"), a.setValue.call(me, t), x(), M(!0), O(), a.autoClose && L();
	        }), ie.find("[shortcut]").click(function () {
	          var t,
	              n = e(this).attr("shortcut"),
	              r = new Date(),
	              s = !1;if (-1 != n.indexOf("day")) {
	            var i = parseInt(n.split(",", 2)[1], 10);s = new Date(new Date().getTime() + 864e5 * i), r = new Date(r.getTime() + 864e5 * (i > 0 ? 1 : -1));
	          } else if (-1 != n.indexOf("week")) {
	            var o;for (o = 1 == (t = -1 != n.indexOf("prev,") ? -1 : 1) ? "monday" == a.startOfWeek ? 1 : 0 : "monday" == a.startOfWeek ? 0 : 6, r = new Date(r.getTime() - 864e5); r.getDay() != o;) {
	              r = new Date(r.getTime() + 864e5 * t);
	            }s = new Date(r.getTime() + 864e5 * t * 6);
	          } else if (-1 != n.indexOf("month")) (s = 1 == (t = -1 != n.indexOf("prev,") ? -1 : 1) ? E(r) : q(r)).setDate(1), (r = E(s)).setDate(1), r = new Date(r.getTime() - 864e5);else if (-1 != n.indexOf("year")) t = -1 != n.indexOf("prev,") ? -1 : 1, (s = new Date()).setFullYear(r.getFullYear() + t), s.setMonth(0), s.setDate(1), r.setFullYear(r.getFullYear() + t), r.setMonth(11), r.setDate(31);else if ("custom" == n) {
	            var d = e(this).html();if (a.customShortcuts && a.customShortcuts.length > 0) for (var l = 0; l < a.customShortcuts.length; l++) {
	              var u = a.customShortcuts[l];if (u.name == d) {
	                var m = [];if ((m = u.dates.call()) && 2 == m.length && (s = m[0], r = m[1]), m && 1 == m.length) {
	                  var h = m[0];z(h, "month1"), z(E(h), "month2"), B();
	                }break;
	              }
	            }
	          }s && r && (T(s, r), x());
	        }), ie.find(".time1 input[type=range]").bind("change touchmove", function (t) {
	          var a = t.target;h("time1", "hour" == a.name ? e(a).val().replace(/^(\d{1})$/, "0$1") : void 0, "minute" == a.name ? e(a).val().replace(/^(\d{1})$/, "0$1") : void 0);
	        }), ie.find(".time2 input[type=range]").bind("change touchmove", function (t) {
	          var a = t.target;h("time2", "hour" == a.name ? e(a).val().replace(/^(\d{1})$/, "0$1") : void 0, "minute" == a.name ? e(a).val().replace(/^(\d{1})$/, "0$1") : void 0);
	        });
	      }
	    }.call(this), a.alwaysOpen && s(0), e(this).data("dateRangePicker", { setStart: function setStart(e) {
	        return "string" == typeof e && (e = t(e, a.format).toDate()), a.end = !1, C(e), this;
	      }, setEnd: function setEnd(e, n) {
	        var r = new Date();return r.setTime(a.start), "string" == typeof e && (e = t(e, a.format).toDate()), T(r, e, n), this;
	      }, setDateRange: function setDateRange(e, n, r) {
	        "string" == typeof e && "string" == typeof n && (e = t(e, a.format).toDate(), n = t(n, a.format).toDate()), T(e, n, r);
	      }, clear: function clear() {
	        a.start = !1, a.end = !1, ie.find(".day.checked").removeClass("checked"), ie.find(".day.last-date-selected").removeClass("last-date-selected"), ie.find(".day.first-date-selected").removeClass("first-date-selected"), a.setValue.call(me, ""), x(), M(), O();
	      }, close: L, open: s, redraw: F, getDatePicker: function getDatePicker() {
	        return ie;
	      }, resetMonthsView: se, destroy: function destroy() {
	        e(ue).unbind(".datepicker"), e(ue).data("dateRangePicker", ""), e(ue).data("date-picker-opened", null), ie.remove(), e(window).unbind("resize.datepicker", r), e(document).unbind("click.datepicker", L);
	      } }), e(window).bind("resize.datepicker", r), this;
	  };
	});

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var attributes;
	
	attributes = __webpack_require__(79).attributes;
	
	module.exports = {
	  computed: {
	    submittable: function() {
	      return !(this.pristine || this.errors.any());
	    }
	  },
	  methods: {
	    select: function(objId, objClass) {
	      var range, wrapNode;
	      this.deSelect();
	      wrapNode = document.getElementById(objId);
	      if (document.selection) {
	        range = document.body.createTextRange();
	        range.moveToElementText(wrapNode.getElementsByClassName(objClass)[0]);
	        return range.select();
	      } else if (window.getSelection) {
	        range = document.createRange();
	        range.selectNode(wrapNode.getElementsByClassName(objClass)[0]);
	        return window.getSelection().addRange(range);
	      }
	    },
	    deSelect: function() {
	      if (document.selection) {
	        return document.selection.empty();
	      } else if (window.getSelection) {
	        return window.getSelection().removeAllRanges();
	      }
	    },
	    validateEmail: function(email) {
	      var regex;
	      regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	      return regex.test(String(email).toLowerCase());
	    },
	    setDirty: function() {
	      return this.pristine = false;
	    },
	    handleApiErrors: function(response, options) {
	      var error, i, key, keyErrors, len, normalized_key, ref, response_body, results;
	      if (options == null) {
	        options = {};
	      }
	      Loader.off();
	      response_body = response.body;
	      if (!response_body) {
	        return;
	      }
	      this.addApiErrorMessages(response_body);
	      if (options.extra_attributes) {
	        this.addExtraAttributesErrors(response_body, options.extra_attributes);
	      }
	      ref = Object.keys(this.$validator.fieldBag.fields);
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        key = ref[i];
	        normalized_key = key.replace(".", "_");
	        keyErrors = response_body[key];
	        if (keyErrors) {
	          results.push((function() {
	            var j, len1, results1;
	            results1 = [];
	            for (j = 0, len1 = keyErrors.length; j < len1; j++) {
	              error = keyErrors[j];
	              results1.push(this.errors.add(normalized_key, this.errorMessage(key, error)));
	            }
	            return results1;
	          }).call(this));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    addApiErrorMessages: function(response_body) {
	      var baseErrors, errors;
	      errors = response_body.errors;
	      baseErrors = response_body.base;
	      this.apiErrorMessages = errors || [];
	      if (baseErrors) {
	        return this.apiErrorMessages = this.apiErrorMessages.concat(baseErrors);
	      }
	    },
	    addExtraAttributesErrors: function(response_body, extra_attributes) {
	      var error, i, key, keyErrors, len, results;
	      results = [];
	      for (i = 0, len = extra_attributes.length; i < len; i++) {
	        key = extra_attributes[i];
	        keyErrors = response_body[key];
	        if (keyErrors) {
	          results.push((function() {
	            var j, len1, results1;
	            results1 = [];
	            for (j = 0, len1 = keyErrors.length; j < len1; j++) {
	              error = keyErrors[j];
	              results1.push(this.apiErrorMessages = this.apiErrorMessages.concat(this.errorMessage(key, error)));
	            }
	            return results1;
	          }).call(this));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    errorMessage: function(key, error) {
	      if (attributes[key] !== void 0) {
	        return 'O campo ' + attributes[key] + ' ' + error;
	      } else {
	        return 'O campo ' + error;
	      }
	    },
	    unknownError: function() {
	      Loader.off();
	      return alertify.error("Ops, algo deu errado!");
	    }
	  }
	};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

	var s4;
	
	s4 = function() {
	  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	};
	
	exports.generateGuid = function() {
	  return s4() + s4() + '-' + s4() + '-' + s4();
	};


/***/ }),
/* 234 */
/***/ (function(module, exports) {

	(function($) {
	  $.extend($.summernote.lang, {
	    'pt-BR': {
	      font: {
	        bold: 'Negrito',
	        italic: 'Itálico',
	        underline: 'Sublinhado',
	        clear: 'Remover estilo da fonte',
	        height: 'Altura da linha',
	        name: 'Fonte',
	        strikethrough: 'Riscado',
	        size: 'Tamanho da fonte'
	      },
	      image: {
	        image: 'Imagem',
	        insert: 'Inserir imagem',
	        resizeFull: 'Resize Full',
	        resizeHalf: 'Resize Half',
	        resizeQuarter: 'Resize Quarter',
	        floatLeft: 'Float Left',
	        floatRight: 'Float Right',
	        floatNone: 'Float None',
	        dragImageHere: 'Arraste uma imagem para cá',
	        selectFromFiles: 'Selecione a partir dos arquivos',
	        url: 'URL da imagem'
	      },
	      video: {
	        video: 'Vídeo',
	        videoLink: 'Link para vídeo',
	        insert: 'Inserir vídeo',
	        url: 'URL do vídeo?',
	        providers: '(YouTube, Vimeo, Vine, Instagram, DailyMotion, ou Youku)'
	      },
	      link: {
	        link: 'Link',
	        insert: 'Inserir link',
	        unlink: 'Remover link',
	        edit: 'Editar',
	        textToDisplay: 'Texto para exibir',
	        url: 'Para qual URL esse link leva?',
	        openInNewWindow: 'Abrir em uma nova janela'
	      },
	      table: {
	        table: 'Tabela'
	      },
	      hr: {
	        insert: 'Inserir linha horizontal'
	      },
	      style: {
	        style: 'Estilo',
	        normal: 'Normal',
	        blockquote: 'Citação',
	        pre: 'Código',
	        h1: 'Título 1',
	        h2: 'Título 2',
	        h3: 'Título 3',
	        h4: 'Título 4',
	        h5: 'Título 5',
	        h6: 'Título 6'
	      },
	      lists: {
	        unordered: 'Lista com marcadores',
	        ordered: 'Lista numerada'
	      },
	      options: {
	        help: 'Ajuda',
	        fullscreen: 'Tela cheia',
	        codeview: 'Ver código-fonte'
	      },
	      paragraph: {
	        paragraph: 'Parágrafo',
	        outdent: 'Menor tabulação',
	        indent: 'Maior tabulação',
	        left: 'Alinhar à esquerda',
	        center: 'Alinhar ao centro',
	        right: 'Alinha à direita',
	        justify: 'Justificado'
	      },
	      color: {
	        recent: 'Cor recente',
	        more: 'Mais cores',
	        background: 'Fundo',
	        foreground: 'Fonte',
	        transparent: 'Transparente',
	        setTransparent: 'Fundo transparente',
	        reset: 'Restaurar',
	        resetToDefault: 'Restaurar padrão'
	      },
	      shortcut: {
	        shortcuts: 'Atalhos do teclado',
	        close: 'Fechar',
	        textFormatting: 'Formatação de texto',
	        action: 'Ação',
	        paragraphFormatting: 'Formatação de parágrafo',
	        documentStyle: 'Estilo de documento'
	      },
	      history: {
	        undo: 'Desfazer',
	        redo: 'Refazer'
	      }
	    }
	  });
	})(jQuery);


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Template = (function(superClass) {
	  extend(Template, superClass);
	
	  function Template() {
	    return Template.__super__.constructor.apply(this, arguments);
	  }
	
	  Template.ATTRIBUTES = {
	    id: {},
	    name: {},
	    subject: {
	      "default": ''
	    },
	    body: {},
	    signature: {},
	    category_name: {},
	    template_category_id: {
	      "default": null,
	      type: Number
	    },
	    parent_id: {},
	    recipients_statistics: {},
	    kind: {},
	    actions_count: {},
	    cc: {},
	    value: {}
	  };
	
	  Template.ASSOCIATIONS = {
	    email_statistic: function() {
	      return EmailStatistic;
	    },
	    user: function() {
	      return User;
	    }
	  };
	
	  Template.prototype.connectedCount = function() {
	    var ref, ref1, ref2;
	    return (ref = this.recipients_statistics) != null ? (ref1 = ref.by_qualification) != null ? (ref2 = ref1.connected) != null ? ref2.count : void 0 : void 0 : void 0;
	  };
	
	  Template.prototype.contentLabel = function() {
	    switch (this.kind) {
	      case "email":
	        return "Conteúdo do email";
	      case "phonecall":
	        return "Conteúdo do roteiro de ligação";
	      case "linkedin":
	        return "Conteúdo do Inmail";
	      case "social":
	        return "Conteúdo da mensagem em rede social";
	      default:
	        return "Conteúdo";
	    }
	  };
	
	  return Template;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	var App, Shared, companyGuard, componentize, emailGuard, sessionGuard, view;
	
	App = __webpack_require__(93);
	
	Shared = {
	  header: __webpack_require__(184)
	};
	
	view = function(view_name) {
	  return __webpack_require__(318)("./" + view_name);
	};
	
	componentize = function(view_name, options) {
	  var component;
	  if (options == null) {
	    options = {};
	  }
	  if (options.include_header == null) {
	    options.include_header = true;
	  }
	  component = options.component || {};
	  if (component.app == null) {
	    component.app = view(view_name);
	  }
	  if (options.include_header) {
	    component.header = Shared.header;
	  }
	  return component;
	};
	
	companyGuard = function(to, from, next) {
	  return (function(_this) {
	    return function(response) {
	      if (!to.meta.no_auth_allowed && (response && response.status === 401)) {
	        Session.logout();
	        next({
	          name: 'landing'
	        });
	      } else {
	        next();
	      }
	      return Loader.off();
	    };
	  })(this);
	};
	
	emailGuard = function(to, from, next) {
	  if (window.parent) {
	    window.parent.postMessage({
	      type: "message-ui-v1",
	      route: to.path
	    }, "*");
	  }
	  MixpanelCtrl.trackEvent(to.matched[to.matched.length - 1].path, {
	    path: to.fullPath
	  });
	  if (!to.meta.no_auth_allowed) {
	    if (Session.authorized) {
	      if (Session.current_user.requireEmailAuthorization()) {
	        if (to.meta.email_service_allowed) {
	          return next();
	        } else {
	          return next({
	            name: 'email-config'
	          });
	        }
	      } else {
	        return next();
	      }
	    } else {
	      return next({
	        name: 'landing'
	      });
	    }
	  } else {
	    if (Session.authorized) {
	      if (to.meta.signed_user_allowed) {
	        return next();
	      } else {
	        return next({
	          name: 'contatos/leads'
	        });
	      }
	    } else {
	      return next();
	    }
	  }
	};
	
	sessionGuard = function(to, from, next) {
	  Loader.on();
	  if (Session.current_user) {
	    return new UsersResource().reloadSession(companyGuard(to, from, next), {
	      id: Session.current_user.id
	    });
	  } else {
	    Loader.off();
	    return next();
	  }
	};
	
	exports.guards = {
	  company: companyGuard,
	  email: emailGuard,
	  session: sessionGuard
	};
	
	exports.routes = [
	  {
	    path: '/auth',
	    component: App,
	    meta: {
	      no_auth_allowed: true
	    },
	    children: [
	      {
	        name: 'landing',
	        path: 'login',
	        components: componentize('sessions/login', {
	          include_header: false
	        }),
	        meta: {
	          no_auth_allowed: true
	        }
	      }, {
	        path: 'recuperar-senha',
	        components: componentize('sessions/recover_password', {
	          include_header: false
	        }),
	        meta: {
	          no_auth_allowed: true
	        }
	      }, {
	        path: 'redefinir-senha',
	        components: componentize('sessions/reset_password', {
	          include_header: false
	        }),
	        meta: {
	          no_auth_allowed: true
	        }
	      }, {
	        name: 'invite',
	        path: 'convite',
	        components: componentize('users/activation', {
	          include_header: false
	        }),
	        meta: {
	          no_auth_allowed: true,
	          signed_user_allowed: true
	        }
	      }
	    ]
	  }, {
	    name: 'root',
	    path: '/',
	    component: App,
	    children: [
	      {
	        name: 'tasks',
	        path: '/tarefas',
	        components: componentize('manual_tasks/index')
	      }, {
	        path: '/notificacoes',
	        components: componentize('shared/notifications/index')
	      }, {
	        path: '/fluxos-de-cadencia/criar',
	        components: componentize('flows/new')
	      }, {
	        path: '/fluxos-de-cadencia/criar/:id',
	        components: componentize('flows/new')
	      }, {
	        path: '/fluxos-de-cadencia/opcoes-de-criacao',
	        components: componentize('flows/creation_options')
	      }, {
	        path: '/fluxos-de-cadencia/biblioteca',
	        components: componentize('flows/library')
	      }, {
	        path: '/fluxos-de-cadencia/:id/editar',
	        components: componentize('flows/edit')
	      }, {
	        path: '/fluxos-de-cadencia/:id',
	        components: componentize('flows/show')
	      }, {
	        name: 'flows',
	        path: '/fluxos-de-cadencia',
	        components: componentize('flows/index')
	      }, {
	        path: '/templates',
	        components: componentize('templates/index')
	      }, {
	        path: '/templates/criar',
	        components: componentize('templates/new')
	      }, {
	        path: '/templates/criar/:template_id',
	        components: componentize('templates/new')
	      }, {
	        path: '/templates/:id/editar',
	        components: componentize('templates/edit')
	      }, {
	        path: 'contatos/importar/manualmente',
	        components: componentize('contacts/import/manually')
	      }, {
	        path: 'contatos/importar/csv',
	        components: componentize('contacts/import/csv')
	      }, {
	        path: '/contatos',
	        components: componentize('contacts/index'),
	        children: [
	          {
	            name: 'contatos/leads',
	            path: 'leads',
	            components: {
	              content: view('contacts/leads')
	            }
	          }, {
	            path: 'grupos',
	            components: {
	              content: view('contacts/groups')
	            }
	          }, {
	            path: 'empresas',
	            components: {
	              content: view('contacts/businesses')
	            }
	          }, {
	            path: 'empresas/:id',
	            components: {
	              content: view('businesses/show')
	            }
	          }
	        ]
	      }, {
	        path: 'grupos',
	        components: componentize('contacts/groups')
	      }, {
	        path: 'empresas',
	        components: componentize('contacts/businesses')
	      }, {
	        path: 'contatos/:id',
	        components: componentize('contacts/show')
	      }, {
	        path: 'grupos-de-contatos/importar/manualmente',
	        components: componentize('contacts/import/manually'),
	        props: {
	          app: function(route) {
	            return {
	              has_groups: true
	            };
	          }
	        }
	      }, {
	        path: 'grupos-de-contatos/importar/csv',
	        components: componentize('contacts/import/csv'),
	        props: {
	          app: function(route) {
	            return {
	              has_groups: true
	            };
	          }
	        }
	      }, {
	        path: 'grupos-de-contatos/:id/editar',
	        components: componentize('contact_groups/edit')
	      }, {
	        name: 'email-config',
	        path: '/configurar-email',
	        components: componentize('configuration/index_nylas'),
	        meta: {
	          email_service_allowed: true
	        }
	      }, {
	        name: 'integrations',
	        path: '/configuracoes/integracoes',
	        components: componentize('configuration/integrations'),
	        meta: {
	          email_service_allowed: true
	        }
	      }, {
	        name: 'integration',
	        path: '/configuracoes/integracao',
	        meta: {
	          email_service_allowed: true
	        },
	        components: componentize('configuration/integrations/index')
	      }, {
	        path: '/configuracoes/empresas',
	        meta: {
	          email_service_allowed: true
	        },
	        components: componentize('companies/index')
	      }, {
	        path: '/configuracoes/empresas/criar',
	        meta: {
	          email_service_allowed: true
	        },
	        components: componentize('companies/new')
	      }, {
	        path: '/configuracoes/empresas/:id/editar',
	        components: componentize('companies/edit')
	      }, {
	        path: '/configuracoes',
	        components: componentize('configuration/index'),
	        meta: {
	          email_service_allowed: true
	        },
	        children: [
	          {
	            path: 'perfil',
	            meta: {
	              email_service_allowed: true
	            },
	            components: {
	              content: view('configuration/profile'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'permissoes',
	            meta: {
	              nylas_allowed: true
	            },
	            components: {
	              content: view('configuration/permissions'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'alterar-senha',
	            meta: {
	              email_service_allowed: true
	            },
	            components: {
	              content: view('configuration/change_password'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'usuarios',
	            meta: {
	              email_service_allowed: true
	            },
	            components: {
	              content: view('users/index'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'usuarios/convidar',
	            meta: {
	              email_service_allowed: true
	            },
	            components: {
	              content: view('users/invitation_form'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'templates',
	            components: {
	              content: view('template_categories/index'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            name: 'lost_reason',
	            path: 'motivo-de-perda',
	            components: {
	              content: view('lost_reason/index'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            name: 'meetings',
	            path: 'atividades',
	            components: {
	              content: view('meetings/index'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            name: 'voip',
	            path: 'voip',
	            components: {
	              content: view('configuration/voip'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'empresas',
	            meta: {
	              email_service_allowed: true
	            },
	            components: {
	              content: view('companies/index'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'empresas/criar',
	            meta: {
	              email_service_allowed: true
	            },
	            components: {
	              content: view('companies/new'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'empresas/:id/editar',
	            components: {
	              content: view('companies/edit'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'tags',
	            components: {
	              content: view('tags/index'),
	              sidebar: view('configuration/sidebar')
	            }
	          }, {
	            path: 'contatos/campos-personalizados',
	            components: {
	              content: view('custom_fields/index'),
	              sidebar: view('configuration/sidebar')
	            }
	          }
	        ]
	      }, {
	        name: 'migracao',
	        path: '/migracao',
	        components: componentize('old_reev', {
	          include_header: false
	        }),
	        meta: {
	          email_service_allowed: true
	        }
	      }, {
	        path: '*',
	        redirect: {
	          name: 'contatos/leads'
	        }
	      }
	    ]
	  }
	];


/***/ }),
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSItMC41OSAyLjI2MSAxMi4xODMgOC44NTQiIHdpZHRoPSIxMC40OTMwMDAwMzA1MTc1NzgiIGhlaWdodD0iNS45NDAwMDAwNTcyMjA0NTkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGcgaWQ9IkFydGJvYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09Im1hdHJpeCgwLCAxLjAwMDAwMDk1MzY3NDMxNjQsIC0xLjAwMDAwMDk1MzY3NDMxNjQsIDAsIDEwNjYuNzgwMTUxMzY3MTg3NSwgLTg0Mi43MjI5MDAzOTA2MjUpIj4KICAgIDxwb2x5bGluZSBpZD0iUGF0aC0yIiBzdHJva2Utd2lkdGg9IjIiIHBvaW50cz0iODQ2LjAxOTkxOCAxMDU2IDg1MS45NCAxMDYxLjMwMTcyIDg0NiAxMDY2LjQ5MzI2IiBzdHlsZT0ic3Ryb2tlOiByZ2IoNDYsIDY4LCA4NSk7Ii8+CiAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIxNTguNjQwOTQ1NDM0NTcwMyAxMjEuMzg2OTYyODkwNjI1IDgyLjI4Mzk4MTMyMzI0MjE5IDk1LjAxMjk4NTIyOTQ5MjE5IiB3aWR0aD0iODIuMjgzOTgxMzIzMjQyMTkiIGhlaWdodD0iOTUuMDEyOTg1MjI5NDkyMTkiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6Yng9Imh0dHBzOi8vYm94eS1zdmcuY29tIj4KICA8cGF0aCBkPSJNIDI0MS40MTMgMTY3LjQ3MiBMIDI4OC45MTkgMjQ5Ljc1NiBMIDE5My45MDYgMjQ5Ljc1NiBMIDI0MS40MTMgMTY3LjQ3MiBaIiB0cmFuc2Zvcm09Im1hdHJpeCgwLCAxLCAtMSwgMCwgNDA4LjM5Njk0MjEzODY3MTksIC03Mi41MTkwNTA1OTgxNDQ1MykiIHN0eWxlPSJmaWxsOiByZ2IoNzAsIDIxMSwgMTY2KTsiIGJ4OnNoYXBlPSJ0cmlhbmdsZSAxOTMuOTA2IDE2Ny40NzIgOTUuMDEzIDgyLjI4NCAwLjUgMCAxQGFlODhkYTI5Ii8+Cjwvc3ZnPg=="

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSIxOXB4IiB2aWV3Qm94PSIwIDAgMTQgMTkiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU0LjEgKDc2NDkwKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5leHBvcnRhciBpY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IkJhc2UtZGUtQ29udGF0b3MtTGl2ZSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkFydGJvYXJkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtOTcxLjAwMDAwMCwgLTEzOC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9ImV4cG9ydGFyLWljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDk3Mi4wMDAwMDAsIDEzOS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwb2x5Z29uIGlkPSJQYXRoLTQiIGZpbGw9IiMwN0QzQTciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuNzU3NTA3LCAxMC4yNDQ0OTApIHNjYWxlKDEsIC0xKSB0cmFuc2xhdGUoLTUuNzU3NTA3LCAtMTAuMjQ0NDkwKSAiIHBvaW50cz0iNS45NjE2MDA1IDMgNC4xNjkwNDQxOSAxMi43NTAwOTY4IDEgMTIuNzUwMDk2OCA1Ljk2MTYwMDUgMTcuNDg4OTgwMSAxMC41MTUwMTUgMTIuNzUwMDk2OCA3LjYyODAzOCAxMi43NTAwOTY4Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNOS43Njk5NjI2MmUtMTUsMC41IEwxMiwwLjUiIGlkPSJMaW5lLTIiIHN0cm9rZT0iIzA3RDNBNyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMTUiIHdpZHRoPSIxNSIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCjxwYXRoIGZpbGw9ImdyZXkiIGQ9Ik0xMS44Myw5TDE1LDEyLjE2QzE1LDEyLjExIDE1LDEyLjA1IDE1LDEyQTMsMyAwIDAsMCAxMiw5QzExLjk0LDkgMTEuODksOSAxMS44Myw5TTcuNTMsOS44TDkuMDgsMTEuMzVDOS4wMywxMS41NiA5LDExLjc3IDksMTJBMywzIDAgMCwwIDEyLDE1QzEyLjIyLDE1IDEyLjQ0LDE0Ljk3IDEyLjY1LDE0LjkyTDE0LjIsMTYuNDdDMTMuNTMsMTYuOCAxMi43OSwxNyAxMiwxN0E1LDUgMCAwLDEgNywxMkM3LDExLjIxIDcuMiwxMC40NyA3LjUzLDkuOE0yLDQuMjdMNC4yOCw2LjU1TDQuNzMsN0MzLjA4LDguMyAxLjc4LDEwIDEsMTJDMi43MywxNi4zOSA3LDE5LjUgMTIsMTkuNUMxMy41NSwxOS41IDE1LjAzLDE5LjIgMTYuMzgsMTguNjZMMTYuODEsMTkuMDhMMTkuNzMsMjJMMjEsMjAuNzNMMy4yNywzTTEyLDdBNSw1IDAgMCwxIDE3LDEyQzE3LDEyLjY0IDE2Ljg3LDEzLjI2IDE2LjY0LDEzLjgyTDE5LjU3LDE2Ljc1QzIxLjA3LDE1LjUgMjIuMjcsMTMuODYgMjMsMTJDMjEuMjcsNy42MSAxNyw0LjUgMTIsNC41QzEwLjYsNC41IDkuMjYsNC43NSA4LDUuMkwxMC4xNyw3LjM1QzEwLjc0LDcuMTMgMTEuMzUsNyAxMiw3WiIvPg0KPC9zdmc+"

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxMHB4IiB2aWV3Qm94PSIwIDAgMTAgMTAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5DbG9zZSBpY29uIENvcHkgMzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJBcnRib2FyZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcyMS4wMDAwMDAsIC00NDMuMDAwMDAwKSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+CiAgICAgICAgPGcgaWQ9IkNvbXBvc2UtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzM4LjAwMDAwMCwgNDMzLjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9IkNsb3NlLWljb24tQ29weS0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzODQuMDAwMDAwLCAxMS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik03LjYzNjM2MzY0LDAuMzYzNjM2MzY0IEwwLjcxNzcwOTk2Nyw3LjI4MjI5MDAzIiBpZD0iTGluZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTcuNjM2MzYzNjQsMC4zNjM2MzYzNjQgTDAuNzE3NzA5OTY3LDcuMjgyMjkwMDMiIGlkPSJMaW5lLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQuMDAwMDAwLCA0LjAwMDAwMCkgc2NhbGUoLTEsIDEpIHRyYW5zbGF0ZSgtNC4wMDAwMDAsIC00LjAwMDAwMCkgIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMTUiIHdpZHRoPSIxNSIgdmlld0JveD0iMCAwIDI0IDI0Ij4NCjxwYXRoIGZpbGw9ImdyZXkiIGQ9Ik0xMiw5QzEwLjM0LDkgOSwxMC4zNCA5LDEyQzksMTMuNjYgMTAuMzQsMTUgMTIsMTVDMTMuNjYsMTUgMTUsMTMuNjYgMTUsMTJDMTUsMTAuMzQgMTMuNjYsOSAxMiw5TTEyLDE3QzkuMjQsMTcgNywxNC43NiA3LDEyQzcsOS4yNCA5LjI0LDcgMTIsN0MxNC43Niw3IDE3LDkuMjQgMTcsMTJDMTcsMTQuNzYgMTQuNzYsMTcgMTIsMTdNMTIsNC41QzcsNC41IDIuNzMsNy42MSAxLDEyQzIuNzMsMTYuMzkgNywxOS41IDEyLDE5LjVDMTcsMTkuNSAyMS4yNywxNi4zOSAyMywxMkMyMS4yNyw3LjYxIDE3LDQuNSAxMiw0LjVaIi8+DQo8L3N2Zz4="

/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 255 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHoAAACECAYAAABfwT+NAAAKuWlDQ1BJQ0MgUHJvZmlsZQAASImVlwdUk8kWx+f70kNCS+gt9CZIJ4CU0EMRpIONkAQSSogJQUUUC6KCFRERUFd0QUTBCshasSDKomCvG2RRUNfFgg007wMeYfe9894773/OzfzOzcy9d+bMnHM/AEhfWEJhJqwMQJYgRxQV5EtLSEyi4Z4DItAEigAP1FlssZARGRkGEE2Nf9enewAaH2/bjMf69///q1Q4XDEbACgS4RSOmJ2F8EnEpGyhKAcAVBniN16cIxznVoSpIqRAhLvGOW2SpeOcMskfJ+bERPkBgMYDgCexWKI0AEhUxE/LZachcUhOCNsJOHwBwhyEvdg8FjKSDiA8Iysre5xvIWyR8pc4aX+LmSKPyWKlyXlyLxPC+/PFwkzW0v/zOP63sjIlUznMECPxRMFR4/mQM3uQkR0qZ0HK7Igp5nMmaxpnniQ4dorZYr+kKeaw/EPlazNnh01xKj+QKY+Tw4yZYq44IHqKRdlR8lypIj/GFLNE03klGbFyP4/LlMfP48XET3EuP272FIszokOn5/jJ/SJJlLx+riDIdzpvoHzvWeK/7JfPlK/N4cUEy/fOmq6fK2BMxxQnyGvjcP0DpufEyucLc3zluYSZkfL53MwguV+cGy1fm4NcyOm1kfIzTGeFRE4x4INwwALsHO6SnPHi/bKFS0X8NF4OjYG8Ki6NKWDbzqA52NnTARh/o5NXYPjmxNuDtFSmfUUrkSs9JpPJmqd9wZsAOFYAAPHitM+8EwCltQBca2ZLRLmTPvT4DwZ5/UqACrSAPjAGFsAGOAAX4AF8QAAIAREgBiSCBYANeCALiMBikA9WgSJQAraCHaAS7AX7wUFwBBwHLeAMuAiughvgFrgLHgMpGACvwTD4BEYhCMJBZIgCaUEGkClkDTlAdMgLCoDCoCgoEUqG0iABJIHyoTVQCVQKVUL7oHroGHQaugh1Qj3QQ6gPGoLeQ99gFEyCqbAebAbPhOkwAw6FY+D5cBq8CM6DC+HNcAVcAx+Gm+GL8A34LiyFX8MjKIBSQKmjDFE2KDrKDxWBSkKlokSoFahiVDmqBtWIakN1oG6jpKg3qK9oLJqCpqFt0B7oYHQsmo1ehF6B3oiuRB9EN6Mvo2+j+9DD6B8YMkYXY41xxzAxCZg0zGJMEaYcU4s5hbmCuYsZwHzCYrHqWHOsKzYYm4hNxy7DbsTuxjZhL2B7sP3YERwOp4WzxnniInAsXA6uCLcLdxh3HteLG8B9wSvgDfAO+EB8El6AX40vxx/Cn8P34l/iRwnKBFOCOyGCwCEsJWwhHCC0EW4SBgijRBWiOdGTGENMJ64iVhAbiVeIT4gfFBQUjBTcFOYo8BVWKlQoHFW4ptCn8JWkSrIi+ZHmkSSkzaQ60gXSQ9IHMplsRvYhJ5FzyJvJ9eRL5GfkL4oURVtFpiJHsUCxSrFZsVfxrRJByVSJobRAKU+pXOmE0k2lN8oEZTNlP2WW8grlKuXTyveVR1QoKvYqESpZKhtVDql0qgyq4lTNVANUOaqFqvtVL6n2U1AUY4ofhU1ZQzlAuUIZoGKp5lQmNZ1aQj1C7aYOq6mqOanFqS1Rq1I7qyZVR6mbqTPVM9W3qB9Xv6f+TUNPg6HB1dig0ajRq/FZU0fTR5OrWazZpHlX85sWTStAK0Nrm1aL1lNttLaV9hztxdp7tK9ov9Gh6njosHWKdY7rPNKFda10o3SX6e7X7dId0dPXC9IT6u3Su6T3Rl9d30c/Xb9M/5z+kAHFwMuAb1BmcN7gFU2NxqBl0ipol2nDhrqGwYYSw32G3YajRuZGsUarjZqMnhoTjenGqcZlxu3GwyYGJuEm+SYNJo9MCaZ0U57pTtMO089m5mbxZuvMWswGzTXNmeZ55g3mTyzIFt4WiyxqLO5YYi3plhmWuy1vWcFWzlY8qyqrm9awtYs133q3dc8MzAy3GYIZNTPu25BsGDa5Ng02fbbqtmG2q21bbN/ONJmZNHPbzI6ZP+yc7TLtDtg9tle1D7Ffbd9m/97ByoHtUOVwx5HsGOhY4Njq+M7J2onrtMfpgTPFOdx5nXO783cXVxeRS6PLkKuJa7Jrtet9OpUeSd9Iv+aGcfN1K3A74/bV3cU9x/24+58eNh4ZHoc8BmeZz+LOOjCr39PIk+W5z1PqRfNK9vrJS+pt6M3yrvF+7mPsw/Gp9XnJsGSkMw4z3vra+Yp8T/l+9nP3W+53wR/lH+Rf7N8doBoQG1AZ8CzQKDAtsCFwOMg5aFnQhWBMcGjwtuD7TD0mm1nPHA5xDVkecjmUFBodWhn6PMwqTBTWFg6Hh4RvD38y23S2YHZLBIhgRmyPeBppHrko8pc52DmRc6rmvIiyj8qP6oimRC+MPhT9KcY3ZkvM41iLWElse5xS3Ly4+rjP8f7xpfHShJkJyxNuJGon8hNbk3BJcUm1SSNzA+bumDswz3le0bx7883nL5nfuUB7QeaCswuVFrIWnkjGJMcnH0oeY0WwalgjKcyU6pRhth97J/s1x4dTxhnienJLuS9TPVNLUwfTPNO2pw3xvHnlvDd8P34l/116cPre9M8ZERl1GbLM+MymLHxWctZpgaogQ3A5Wz97SXaP0FpYJJQucl+0Y9GwKFRUK4bE88WtOVSkGeqSWEjWSvpyvXKrcr8sjlt8YonKEsGSrqVWSzcsfZkXmPfzMvQy9rL2fMP8Vfl9yxnL962AVqSsaC8wLigsGFgZtPLgKuKqjFW/rrZbXbr645r4NW2FeoUrC/vXBq1tKFIsEhXdX+exbu969Hr++u4Njht2bfhRzCm+XmJXUl4ytpG98fom+00Vm2SbUzd3b3HZsmcrdqtg671t3tsOlqqU5pX2bw/f3lxGKysu+7hj4Y7OcqfyvTuJOyU7pRVhFa27THZt3TVWyau8W+Vb1VStW72h+vNuzu7ePT57Gvfq7S3Z++0n/k8P9gXta64xqynfj92fu//FgbgDHT/Tf66v1a4tqf1eJ6iTHow6eLnetb7+kO6hLQ1wg6Rh6PC8w7eO+B9pbbRp3Nek3lRyFByVHH11LPnYveOhx9tP0E80njQ9WX2Kcqq4GWpe2jzcwmuRtia29pwOOd3e5tF26hfbX+rOGJ6pOqt2dss54rnCc7LzeedHLggvvLmYdrG/fWH740sJl+5cnnO5+0rolWtXA69e6mB0nL/mee1Mp3vn6ev06y03XG40dzl3nfrV+ddT3S7dzTddb7becrvV1jOr51yvd+/F2/63r95h3rlxd/bdnnux9x7cn3df+oDzYPBh5sN3j3IfjT5e+QTzpPip8tPyZ7rPan6z/K1J6iI92+ff1/U8+vnjfnb/69/Fv48NFL4gvyh/afCyftBh8MxQ4NCtV3NfDbwWvh59U/SHyh/Vby3envzT58+u4YThgXeid7L3Gz9ofaj76PSxfSRy5NmnrE+jn4u/aH05+JX+teNb/LeXo4vHcGMV3y2/t/0I/fFEliWTCVki1kQrgEIMTk0F4H0dAOREAChIT0ycO9lDTwia7PsnCPwnnuyzJ+QCQCMyjLdC463gCR+khUVMEbEIxGJ8AOzoKLd/Spzq6DAZS7EBAJyhTPY+GwACYmNBMtlopEz2vRop9g4A5wYne/dxYZEvmkadgj8KHW/3XsgH/6J/ALPhEdyGX/hoAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAB3RJTUUH4wECEhAvNdx6oQAACjlJREFUeNrtnT+M29Ydx7/8J4oiJer/nc6yHQNtGrRIhyzNUANFky3oEKBj4TlTl27tnLFT260Fgnbs2rF/hqLeUqQJUMRG0cZXy7qTTieKovhHJN/rcPElV0sxqTvqSN3vs8RwLPHpffj+/957AuecIyMeuxZ++Nlf8ZgtQKznG5KO39+9j1cr9cyeIWb1xYxzPHjykCQn4FG8wIMnD8GyK3PZif710SN8FNtkMSEfxTZ+c/SoeKIfumOyl5K/ZZhnmYl+HDpkLkd5lpnoe3KFzOUozzIT/R2tTeZylGeZiX6v9xpeFXWyl5BXRR3v9V4rnuiSKOGD/pvoiSpZfAk9UcUH/TdREqXMniFkOWECANMwwE//+yH+4o/xhPvI+HGFQRAE3BM0fE/r4P3+G2go2RaIzEV/mXm0xDyOyDKAqiSjKpe292JxKmI3ApGygEQTJJooGvJlPvzYtfB3ZwInDiknM8SQFLxhtC61jLlRZ+wPk0P8+OhDPOMBWdgiB4KKX+y/gXdad7MX/fOnH+Nn1j8p16+R9+vfxE/6385O9CfOKb775I8IOKPcvkZUQcTDu2/jW0Yzm87Yr0afkuQcEHCGX44+za7X/fFyRrmcE/6R0kUq0Raj3nVeSOsilejXSzXK4ZyQ1kUq0e9Ub1EO54Qf1PrZiX6w93W8pVDkyHXzdqmNH3W/lp1oAPjdvft4V92n3L4m3lX38dtX7qf+3MbLlH+aDvBne4hPghkWnNaYs0QXZLyumvh+rYe3Gps1n7QefUOg1SsSTZBogkQT+eRC4MHC9eB6PoJlSGG5BUUQBKglBRWtDL2iXex1R1GMo/EEC9ejnNqlYVlFw36nBVmWIDDG+OHgCH6wpJzZQcqqiju39iBaszlJ3mH8IIA1m0N0qLreeRzXg0il+SaU6iVExig0aNdhjNE4+qZAokk0QaKJwpFq71W33YAo0ruRlw7W6GSajeiqrkOWJcrlHBBFcSrRVDypjSZINEGiCRJNkGiCRBMkmiDRBIkm0QSJJkg0QaIJEk1sGXmXfxxjDK7nw1l4WIYhojhGFMVnP1yWIEsSSooCQ9dQ0co7HVSxk6KXyxAnUwvOwlu7WTAMI4RhBM8PMJs7EAQBhq6h3aijVFJIdJ6JohgnUwszO/2NcJxzzB0Xc8eFWTPQbtYhSxKJzht+EGAwHCOK40t/18x2sFh4uNXroKzuxnVOO9Eo2c4Ch4PjK5F8XjvEMQ4Hx7CdBZXoPOAsPAyPT1J9RpIkaGUVsiSBcXbeVq+qzofHJxAFEYaukejrIliGGB4nv4pXK6toN+vQyioEQbjw/+KYwbLnOLVmYOxiB244GuPOrR7UAnfSClt1c84xOBolvkW93TBx59Y+Klr5BclnpVxEq2Hilf7BC0IZ43h2NCr0cR+FFW3Zc4RhshML2806Ws1kF48oiozbB3tQ5IuV3TKMYNlzEr3tiZDJabKDyStaGa2GmboNP9jvvPD3k9MZirrNuJCiZ7aDOGGGd1qbXSFUVkuoGhcv7o4Zw2zukOhtMV+4if5dSZEvNQ6uGS/efz13XBK9DeI4XjkUWtnL1sqXelZlxec9P0B8heN1Er0G109+qdplpzBFUVzZQ0+TBhK9IVGU/GzwKxkOrfiONGkg0RuLTl5thlF86WfxS6aBRG/cRicf3ried6lSve7IzDRpINEbt5tCqpfCWWzeS143QZImDSR6Q2Q53fT8eGJtNMkxmztrj85MmwYSvYnolD3pMIowPD5JVYX7foDj8WlmvXkSnYByuZT6M47r4elwlKgTNXcWOHx2/JUvxiZpuPYCUrQElxQFJUXBMkx3N6Pr+fj34QANs4qaoUNVv5DFGMPC82HN5nA9P9HzSfQWMHQNp1b6C1E55zi1bJxaNgRBgCxL4IynikwpagBCIee6zZpxBfMgHGEYpQ4/uopnk+gU1Xe9Vt36c+u1aiGr7cKKBoBW01w5D50VgiCg1TSLml3FFS1LEnrd1tae1+u2Ch3nXehw36qhp44e2aj2aJiorlibJtHbrMIbJsxqdh0ks2ps5WWi4VWCtnO/20KppGA8mV7pd3daDTTrNewCO7Mlp1mvQS0pOD45TRwdug5FkbHXbl64CY5E5wi9ouHe7QPMbAcnUyv1cqIkiWg36jBrxlZ79CR6w6q8blZh1ozzvdGO666d55ZlCUalcr5HetcE76zoLwvXKxr0ioY9NME5RxTF5zNhsiSd3dm4o2JvjOhV4hVFhqLcmJ+8W8MrgkQTN6Hq5pwjjCLEMUMcx2f/Zew8+F6SJEiiCEkSz/4siVBkmTpjeYcxBj9YwvV8eH4Azw9SR4AKggCtrEIrq6hoZZTV0s6cVFRo0YxzzJ0FZraTeJvOy2oB1/Phej4m07PdmlpZhVkzUDV0iAUu7YUUvQxDzGwn1a7KTXleO4xPpjBrBsyaQaFEWRMsQ4wn07WB9VkSM3YehqRXNHRbjUKdR1YI0YwxTKYznFp2LtKzcD38x/XQrNfQapiFaMdzL9pZeBidnCLM4ca2U8vG3HHRbTdzHzSYW9GccxyNJ7DnV3POlyxJUNUS5M+HUpIoQpREcH625zpmDCxmCKMIfhAgaYc9jCIMjkaoVXXsd1q5HZ7lUnQcMzw7Hr80xvqrkCQJVb0CTTsbLikpttFwzuEHS3h+ANfzsHBfng57vkAUxTjY60CSRBL90hISRng6HKUO0H+OXtFQrxnQK9rGpevL4+lmvYYwimDPz4ZxX9WEuJ6Pw8ER+r1u7ubUc5UaP1ji6fB4o22pVaOCTrORSQYrsoxWw0SzXoOzcDGaTNcuey7DEE8GQ/R7eyirJRL9/0RRjMFwlFpyWS2h225CK2d/OKsgCKgaOvRKBdOZjcl0tnL2LY4ZBsMR7vZ7ublvOxeNyfNTANPummg367hza38rki9kmiig1TBx7/bBhT1cF17cOMYgR6cN5kL00Xiydi/y6owW0e910WqY19rLVRQZdw72Vx5T9bwpOhpPSDQATGd2qiGUIsu429/PTeCeKAro7bXRaTXW9sanM/tmi46iGOOJlWrI1D/o5nKuuVmvob0m/ns8sa79gJtrFX0ytRK3YaIooN/r5npBodWsr9z8xznHydS6maKD5TLV3RcHe51cDVfW0W03VjYrM9tBsFzePNFpqmzz8wmQIiAIAvY6zZVr12l+806I9oMg8VKjLElrOzp5RZHllWleuB78ILg5omd28l52t92AVMBwHrNmrGxq0vz2QovmnCe+eUaRZRh6BUVEEISVG/RsZ3EtkyhbF+35QeID3upmtdBRmYZeeWHzPGPsSuLbci96kXDpURAEmNVibz5/vg9s0zy40rR8+q/POIidh3ZqkGiCRBMkmiDRxHWKVnfw9nPiImpJgbjtMBxi+2hlFWJRtpQQG1bZ4tktuqIsy+h1W4XeEkqskSwIZ2eYyjIE/vkMexhFGE8seL5fyHudiC+QZQlauYxOq36+Q+V/biQzvI0Vj0gAAAAASUVORK5CYII="

/***/ }),
/* 257 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 258 */,
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(826)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(377),
	  /* template */
	  __webpack_require__(1136),
	  /* scopeId */
	  "data-v-5cca3822",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(781)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(379),
	  /* template */
	  __webpack_require__(1085),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(842)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(381),
	  /* template */
	  __webpack_require__(1153),
	  /* scopeId */
	  "data-v-665d43c2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(772)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(383),
	  /* template */
	  __webpack_require__(1074),
	  /* scopeId */
	  "data-v-38432390",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(384),
	  /* template */
	  __webpack_require__(1193),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(385),
	  /* template */
	  __webpack_require__(1100),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(900)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(386),
	  /* template */
	  __webpack_require__(1225),
	  /* scopeId */
	  "data-v-e157cf5e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(829)
	__webpack_require__(828)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(387),
	  /* template */
	  __webpack_require__(1139),
	  /* scopeId */
	  "data-v-5e3f0824",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(813)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(401),
	  /* template */
	  __webpack_require__(1123),
	  /* scopeId */
	  "data-v-568a48e2",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(796)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(402),
	  /* template */
	  __webpack_require__(1103),
	  /* scopeId */
	  "data-v-4beef098",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(403),
	  /* template */
	  __webpack_require__(1187),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(713)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(404),
	  /* template */
	  __webpack_require__(1010),
	  /* scopeId */
	  "data-v-0b3dadb6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(819)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(408),
	  /* template */
	  __webpack_require__(1129),
	  /* scopeId */
	  "data-v-59f845ea",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(753)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(413),
	  /* template */
	  __webpack_require__(1053),
	  /* scopeId */
	  "data-v-2a473864",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(795)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(420),
	  /* template */
	  __webpack_require__(1102),
	  /* scopeId */
	  "data-v-4b826234",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(866)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(421),
	  /* template */
	  __webpack_require__(1180),
	  /* scopeId */
	  "data-v-85c28e08",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(855)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(422),
	  /* template */
	  __webpack_require__(1166),
	  /* scopeId */
	  "data-v-7205a04d",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(1186),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(754)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(423),
	  /* template */
	  __webpack_require__(1054),
	  /* scopeId */
	  "data-v-2c2be2e7",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(801)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(425),
	  /* template */
	  __webpack_require__(1108),
	  /* scopeId */
	  "data-v-4e8e69e4",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(714)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(429),
	  /* template */
	  __webpack_require__(1011),
	  /* scopeId */
	  "data-v-0c9f0e04",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(899)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(431),
	  /* template */
	  __webpack_require__(1224),
	  /* scopeId */
	  "data-v-dfce0e46",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(435),
	  /* template */
	  __webpack_require__(1077),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(457),
	  /* template */
	  __webpack_require__(1178),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(458),
	  /* template */
	  __webpack_require__(1230),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(461),
	  /* template */
	  __webpack_require__(1068),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(462),
	  /* template */
	  __webpack_require__(1218),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(789)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(464),
	  /* template */
	  __webpack_require__(1095),
	  /* scopeId */
	  "data-v-47a20bae",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(465),
	  /* template */
	  __webpack_require__(1185),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(725)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(466),
	  /* template */
	  __webpack_require__(1021),
	  /* scopeId */
	  "data-v-15c5e0d3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(715)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(326),
	  /* template */
	  __webpack_require__(1012),
	  /* scopeId */
	  "data-v-0eb999a6",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(868)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(477),
	  /* template */
	  __webpack_require__(1182),
	  /* scopeId */
	  "data-v-8a8ce2b8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(774)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(329),
	  /* template */
	  __webpack_require__(1078),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(718)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(491),
	  /* template */
	  __webpack_require__(1015),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(492),
	  /* template */
	  __webpack_require__(1177),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(493),
	  /* template */
	  __webpack_require__(1137),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(903)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(494),
	  /* template */
	  __webpack_require__(1228),
	  /* scopeId */
	  "data-v-ea29283e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(719)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(500),
	  /* template */
	  __webpack_require__(1016),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(894)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(503),
	  /* template */
	  __webpack_require__(1219),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(508),
	  /* template */
	  __webpack_require__(1204),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(790)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(511),
	  /* template */
	  __webpack_require__(1096),
	  /* scopeId */
	  "data-v-47eb1fa3",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(512),
	  /* template */
	  __webpack_require__(1035),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(783)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(518),
	  /* template */
	  __webpack_require__(1089),
	  /* scopeId */
	  "data-v-447d502a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(906)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(524),
	  /* template */
	  __webpack_require__(1232),
	  /* scopeId */
	  "data-v-f42faa44",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(851)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(525),
	  /* template */
	  __webpack_require__(1162),
	  /* scopeId */
	  "data-v-6c811d1e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(807)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(531),
	  /* template */
	  __webpack_require__(1116),
	  /* scopeId */
	  "data-v-522b3b66",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(548),
	  /* template */
	  __webpack_require__(1194),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(844)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(554),
	  /* template */
	  __webpack_require__(1155),
	  /* scopeId */
	  "data-v-672397e8",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(798)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(560),
	  /* template */
	  __webpack_require__(1105),
	  /* scopeId */
	  "data-v-4d878a68",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(872)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(564),
	  /* template */
	  __webpack_require__(1191),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(779)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  null,
	  /* template */
	  __webpack_require__(1083),
	  /* scopeId */
	  "data-v-3f75a2ca",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(567),
	  /* template */
	  __webpack_require__(1003),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(570),
	  /* template */
	  __webpack_require__(1004),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(736)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(575),
	  /* template */
	  __webpack_require__(1036),
	  /* scopeId */
	  "data-v-1ee11c89",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(780)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(577),
	  /* template */
	  __webpack_require__(1084),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(786)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(578),
	  /* template */
	  __webpack_require__(1092),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./App": 93,
		"./App.vue": 93,
		"./automatic_tasks/reactivate_recipient_modal": 23,
		"./automatic_tasks/reactivate_recipient_modal.vue": 23,
		"./businesses/filters": 94,
		"./businesses/filters.vue": 94,
		"./businesses/list": 95,
		"./businesses/list.vue": 95,
		"./businesses/list_item": 96,
		"./businesses/list_item.vue": 96,
		"./businesses/new_modal": 97,
		"./businesses/new_modal.vue": 97,
		"./businesses/show": 259,
		"./businesses/show.vue": 259,
		"./companies/additional_minute": 98,
		"./companies/additional_minute.vue": 98,
		"./companies/edit": 260,
		"./companies/edit.vue": 260,
		"./companies/email_service_dropdown": 49,
		"./companies/email_service_dropdown.vue": 49,
		"./companies/index": 261,
		"./companies/index.vue": 261,
		"./companies/list_item": 99,
		"./companies/list_item.vue": 99,
		"./companies/new": 262,
		"./companies/new.vue": 262,
		"./configuration/change_password": 263,
		"./configuration/change_password.vue": 263,
		"./configuration/index": 264,
		"./configuration/index.vue": 264,
		"./configuration/index_nylas": 265,
		"./configuration/index_nylas.vue": 265,
		"./configuration/integrations": 266,
		"./configuration/integrations.vue": 266,
		"./configuration/integrations/cv_crm": 100,
		"./configuration/integrations/cv_crm.vue": 100,
		"./configuration/integrations/deal_lost": 32,
		"./configuration/integrations/deal_lost.vue": 32,
		"./configuration/integrations/hubspot": 50,
		"./configuration/integrations/hubspot.vue": 50,
		"./configuration/integrations/index": 101,
		"./configuration/integrations/index.vue": 101,
		"./configuration/integrations/pipedrive": 102,
		"./configuration/integrations/pipedrive.vue": 102,
		"./configuration/integrations/properties_matching": 13,
		"./configuration/integrations/properties_matching.vue": 13,
		"./configuration/integrations/properties_select": 103,
		"./configuration/integrations/properties_select.vue": 103,
		"./configuration/integrations/properties_table": 104,
		"./configuration/integrations/properties_table.vue": 104,
		"./configuration/integrations/property_item": 105,
		"./configuration/integrations/property_item.vue": 105,
		"./configuration/integrations/rd_station": 51,
		"./configuration/integrations/rd_station.vue": 51,
		"./configuration/integrations/rd_station_crm": 106,
		"./configuration/integrations/rd_station_crm.vue": 106,
		"./configuration/integrations/salesforce": 107,
		"./configuration/integrations/salesforce.vue": 107,
		"./configuration/integrations/stages_matching": 24,
		"./configuration/integrations/stages_matching.vue": 24,
		"./configuration/integrations/trigger_stages": 7,
		"./configuration/integrations/trigger_stages.vue": 7,
		"./configuration/integrations/vtiger": 108,
		"./configuration/integrations/vtiger.vue": 108,
		"./configuration/modal_carousel": 33,
		"./configuration/modal_carousel.vue": 33,
		"./configuration/modal_carousel_custom": 109,
		"./configuration/modal_carousel_custom.vue": 109,
		"./configuration/permissions": 267,
		"./configuration/permissions.vue": 267,
		"./configuration/profile": 268,
		"./configuration/profile.vue": 268,
		"./configuration/sidebar": 269,
		"./configuration/sidebar.vue": 269,
		"./configuration/voip": 270,
		"./configuration/voip.vue": 270,
		"./configuration/voip_report/card": 110,
		"./configuration/voip_report/card.vue": 110,
		"./configuration/voip_report/list": 111,
		"./configuration/voip_report/list.vue": 111,
		"./configuration/voip_report/list_item": 112,
		"./configuration/voip_report/list_item.vue": 112,
		"./contact_groups/edit": 271,
		"./contact_groups/edit.vue": 271,
		"./contact_groups/filters": 113,
		"./contact_groups/filters.vue": 113,
		"./contact_groups/list": 52,
		"./contact_groups/list.vue": 52,
		"./contact_groups/list_item": 114,
		"./contact_groups/list_item.vue": 114,
		"./contact_groups/new": 115,
		"./contact_groups/new.vue": 115,
		"./contacts/businesses": 272,
		"./contacts/businesses.vue": 272,
		"./contacts/change_responsability_modal": 116,
		"./contacts/change_responsability_modal.vue": 116,
		"./contacts/create_tag_modal": 117,
		"./contacts/create_tag_modal.vue": 117,
		"./contacts/dialer": 118,
		"./contacts/dialer.vue": 118,
		"./contacts/events": 119,
		"./contacts/events.vue": 119,
		"./contacts/filters": 120,
		"./contacts/filters.vue": 120,
		"./contacts/form": 121,
		"./contacts/form.vue": 121,
		"./contacts/groups": 273,
		"./contacts/groups.vue": 273,
		"./contacts/import/csv": 274,
		"./contacts/import/csv.vue": 274,
		"./contacts/import/manually": 275,
		"./contacts/import/manually.vue": 275,
		"./contacts/index": 276,
		"./contacts/index.vue": 276,
		"./contacts/leads": 277,
		"./contacts/leads.vue": 277,
		"./contacts/list": 34,
		"./contacts/list.vue": 34,
		"./contacts/list_item": 278,
		"./contacts/list_item.vue": 278,
		"./contacts/manual_picker": 53,
		"./contacts/manual_picker.vue": 53,
		"./contacts/mass_actions": 122,
		"./contacts/mass_actions.vue": 122,
		"./contacts/picker": 54,
		"./contacts/picker.vue": 54,
		"./contacts/picker/manually": 279,
		"./contacts/picker/manually.vue": 279,
		"./contacts/picker/text_csv": 35,
		"./contacts/picker/text_csv.vue": 35,
		"./contacts/show": 280,
		"./contacts/show.vue": 280,
		"./contacts/task_bar": 123,
		"./contacts/task_bar.vue": 123,
		"./contacts/tasks": 124,
		"./contacts/tasks.vue": 124,
		"./contacts/user_dropdown": 55,
		"./contacts/user_dropdown.vue": 55,
		"./custom_fields/index": 281,
		"./custom_fields/index.vue": 281,
		"./custom_fields/list": 125,
		"./custom_fields/list.vue": 125,
		"./custom_fields/list_item": 126,
		"./custom_fields/list_item.vue": 126,
		"./custom_fields/new_modal": 56,
		"./custom_fields/new_modal.vue": 56,
		"./events/comment_event": 127,
		"./events/comment_event.vue": 127,
		"./events/event": 128,
		"./events/event.vue": 128,
		"./events/filters": 129,
		"./events/filters.vue": 129,
		"./events/hs_event": 130,
		"./events/hs_event.vue": 130,
		"./events/lead_lovers_event": 131,
		"./events/lead_lovers_event.vue": 131,
		"./events/manual_task_event": 132,
		"./events/manual_task_event.vue": 132,
		"./events/pipedrive_created_event": 133,
		"./events/pipedrive_created_event.vue": 133,
		"./events/pipedrive_event": 134,
		"./events/pipedrive_event.vue": 134,
		"./events/rd_station_event": 135,
		"./events/rd_station_event.vue": 135,
		"./events/sharp_spring_event": 136,
		"./events/sharp_spring_event.vue": 136,
		"./events/task_destroyed_event": 137,
		"./events/task_destroyed_event.vue": 137,
		"./flow_actions/list": 138,
		"./flow_actions/list.vue": 138,
		"./flow_actions/list_item": 139,
		"./flow_actions/list_item.vue": 139,
		"./flow_actions/picker": 140,
		"./flow_actions/picker.vue": 140,
		"./flow_actions/picker/send_at": 141,
		"./flow_actions/picker/send_at.vue": 141,
		"./flow_actions/picker/type": 142,
		"./flow_actions/picker/type.vue": 142,
		"./flows/contacts": 143,
		"./flows/contacts.vue": 143,
		"./flows/contacts_form": 144,
		"./flows/contacts_form.vue": 144,
		"./flows/creation_options": 282,
		"./flows/creation_options.vue": 282,
		"./flows/edit": 283,
		"./flows/edit.vue": 283,
		"./flows/filters": 145,
		"./flows/filters.vue": 145,
		"./flows/form": 57,
		"./flows/form.vue": 57,
		"./flows/index": 284,
		"./flows/index.vue": 284,
		"./flows/library": 285,
		"./flows/library.vue": 285,
		"./flows/list": 58,
		"./flows/list.vue": 58,
		"./flows/list_item": 286,
		"./flows/list_item.vue": 286,
		"./flows/new": 287,
		"./flows/new.vue": 287,
		"./flows/show": 288,
		"./flows/show.vue": 288,
		"./flows/triggers": 146,
		"./flows/triggers.vue": 146,
		"./lost_reason/index": 289,
		"./lost_reason/index.vue": 289,
		"./lost_reason/list_item": 147,
		"./lost_reason/list_item.vue": 147,
		"./lost_reason/new": 148,
		"./lost_reason/new.vue": 148,
		"./manual_tasks/calendar": 149,
		"./manual_tasks/calendar.vue": 149,
		"./manual_tasks/confirm_destroy": 36,
		"./manual_tasks/confirm_destroy.vue": 36,
		"./manual_tasks/contact_picker": 37,
		"./manual_tasks/contact_picker.vue": 37,
		"./manual_tasks/daily_events": 59,
		"./manual_tasks/daily_events.vue": 59,
		"./manual_tasks/done_tasks": 150,
		"./manual_tasks/done_tasks.vue": 150,
		"./manual_tasks/done_tasks/done_tasks_feed": 151,
		"./manual_tasks/done_tasks/done_tasks_feed.vue": 151,
		"./manual_tasks/done_tasks/list": 152,
		"./manual_tasks/done_tasks/list.vue": 152,
		"./manual_tasks/done_tasks/list_item": 153,
		"./manual_tasks/done_tasks/list_item.vue": 153,
		"./manual_tasks/filters": 154,
		"./manual_tasks/filters.vue": 154,
		"./manual_tasks/form": 60,
		"./manual_tasks/form.vue": 60,
		"./manual_tasks/index": 290,
		"./manual_tasks/index.vue": 290,
		"./manual_tasks/list": 61,
		"./manual_tasks/list.vue": 61,
		"./manual_tasks/list_item": 62,
		"./manual_tasks/list_item.vue": 62,
		"./manual_tasks/live_feed": 155,
		"./manual_tasks/live_feed.vue": 155,
		"./manual_tasks/live_feed_event_list_item": 156,
		"./manual_tasks/live_feed_event_list_item.vue": 156,
		"./manual_tasks/modal_flow": 157,
		"./manual_tasks/modal_flow.vue": 157,
		"./manual_tasks/modal_form": 17,
		"./manual_tasks/modal_form.vue": 17,
		"./manual_tasks/ozzy_tasks/list": 158,
		"./manual_tasks/ozzy_tasks/list.vue": 158,
		"./manual_tasks/ozzy_tasks/list_item": 159,
		"./manual_tasks/ozzy_tasks/list_item.vue": 159,
		"./manual_tasks/ozzy_tasks/ozzy_tasks_wrapper": 160,
		"./manual_tasks/ozzy_tasks/ozzy_tasks_wrapper.vue": 160,
		"./manual_tasks/panel": 161,
		"./manual_tasks/panel.vue": 161,
		"./manual_tasks/paused_contacts": 162,
		"./manual_tasks/paused_contacts.vue": 162,
		"./manual_tasks/statistic_cards": 163,
		"./manual_tasks/statistic_cards.vue": 163,
		"./manual_tasks/vertical_bar": 164,
		"./manual_tasks/vertical_bar.vue": 164,
		"./meetings/index": 291,
		"./meetings/index.vue": 291,
		"./meetings/list_item": 165,
		"./meetings/list_item.vue": 165,
		"./meetings/new": 166,
		"./meetings/new.vue": 166,
		"./meetings/no_show_flow": 167,
		"./meetings/no_show_flow.vue": 167,
		"./old_reev": 292,
		"./old_reev.vue": 292,
		"./sessions/login": 293,
		"./sessions/login.vue": 293,
		"./sessions/recover_password": 294,
		"./sessions/recover_password.vue": 294,
		"./sessions/reset_password": 295,
		"./sessions/reset_password.vue": 295,
		"./shared/account_status_info": 168,
		"./shared/account_status_info.vue": 168,
		"./shared/autocomplete/companies": 63,
		"./shared/autocomplete/companies.vue": 63,
		"./shared/autocomplete/company_item": 169,
		"./shared/autocomplete/company_item.vue": 169,
		"./shared/autocomplete/contact_item": 170,
		"./shared/autocomplete/contact_item.vue": 170,
		"./shared/autocomplete/contacts": 64,
		"./shared/autocomplete/contacts.vue": 64,
		"./shared/autocomplete/filter_stages": 296,
		"./shared/autocomplete/filter_stages.vue": 296,
		"./shared/autocomplete/filter_tag_item": 65,
		"./shared/autocomplete/filter_tag_item.vue": 65,
		"./shared/autocomplete/filter_tags": 171,
		"./shared/autocomplete/filter_tags.vue": 171,
		"./shared/autocomplete/flow_item": 172,
		"./shared/autocomplete/flow_item.vue": 172,
		"./shared/autocomplete/flows": 8,
		"./shared/autocomplete/flows.vue": 8,
		"./shared/autocomplete/group": 173,
		"./shared/autocomplete/group.vue": 173,
		"./shared/autocomplete/group_item": 66,
		"./shared/autocomplete/group_item.vue": 66,
		"./shared/autocomplete/groups": 67,
		"./shared/autocomplete/groups.vue": 67,
		"./shared/autocomplete/item": 297,
		"./shared/autocomplete/item.vue": 297,
		"./shared/autocomplete/tag_item": 174,
		"./shared/autocomplete/tag_item.vue": 174,
		"./shared/autocomplete/tags": 175,
		"./shared/autocomplete/tags.vue": 175,
		"./shared/autocomplete/template_item": 176,
		"./shared/autocomplete/template_item.vue": 176,
		"./shared/autocomplete/templates": 68,
		"./shared/autocomplete/templates.vue": 68,
		"./shared/back_link": 298,
		"./shared/back_link.vue": 298,
		"./shared/compose/list": 177,
		"./shared/compose/list.vue": 177,
		"./shared/compose/list_item": 178,
		"./shared/compose/list_item.vue": 178,
		"./shared/compose/quota_exceeded": 179,
		"./shared/compose/quota_exceeded.vue": 179,
		"./shared/compose/scheduler": 180,
		"./shared/compose/scheduler.vue": 180,
		"./shared/date_range_picker": 299,
		"./shared/date_range_picker.vue": 299,
		"./shared/dropdown-multiple-select": 300,
		"./shared/dropdown-multiple-select.vue": 300,
		"./shared/dropdown-select": 181,
		"./shared/dropdown-select.vue": 181,
		"./shared/dropdown_multiple_kind/stage_filter": 25,
		"./shared/dropdown_multiple_kind/stage_filter.vue": 25,
		"./shared/dropdown_multiple_kind/tag_filter": 69,
		"./shared/dropdown_multiple_kind/tag_filter.vue": 69,
		"./shared/global_boxes": 182,
		"./shared/global_boxes.vue": 182,
		"./shared/global_loader": 183,
		"./shared/global_loader.vue": 183,
		"./shared/go_to_top": 301,
		"./shared/go_to_top.vue": 301,
		"./shared/header": 184,
		"./shared/header.vue": 184,
		"./shared/header_actions/alert_tick": 185,
		"./shared/header_actions/alert_tick.vue": 185,
		"./shared/header_actions/change_account": 186,
		"./shared/header_actions/change_account.vue": 186,
		"./shared/header_actions/email": 187,
		"./shared/header_actions/email.vue": 187,
		"./shared/header_actions/voip": 188,
		"./shared/header_actions/voip.vue": 188,
		"./shared/internal_scroller": 302,
		"./shared/internal_scroller.vue": 302,
		"./shared/lead_organization": 189,
		"./shared/lead_organization.vue": 189,
		"./shared/loading": 303,
		"./shared/loading.vue": 303,
		"./shared/modals/comment": 190,
		"./shared/modals/comment.vue": 190,
		"./shared/modals/confirm": 70,
		"./shared/modals/confirm.vue": 70,
		"./shared/modals/lost_reason_modal": 38,
		"./shared/modals/lost_reason_modal.vue": 38,
		"./shared/modals/meeting_modal": 71,
		"./shared/modals/meeting_modal.vue": 71,
		"./shared/modals/reset_contact_modal": 191,
		"./shared/modals/reset_contact_modal.vue": 191,
		"./shared/notifications/bell": 192,
		"./shared/notifications/bell.vue": 192,
		"./shared/notifications/dropdown": 193,
		"./shared/notifications/dropdown.vue": 193,
		"./shared/notifications/index": 304,
		"./shared/notifications/index.vue": 304,
		"./shared/notifications/kind/change_responsability": 194,
		"./shared/notifications/kind/change_responsability.vue": 194,
		"./shared/notifications/kind/contact_interrupted": 195,
		"./shared/notifications/kind/contact_interrupted.vue": 195,
		"./shared/notifications/kind/contact_public_api": 196,
		"./shared/notifications/kind/contact_public_api.vue": 196,
		"./shared/notifications/kind/created_lead_lovers": 197,
		"./shared/notifications/kind/created_lead_lovers.vue": 197,
		"./shared/notifications/kind/created_pipedrive": 198,
		"./shared/notifications/kind/created_pipedrive.vue": 198,
		"./shared/notifications/kind/created_rd_station": 199,
		"./shared/notifications/kind/created_rd_station.vue": 199,
		"./shared/notifications/kind/created_sharp_spring": 200,
		"./shared/notifications/kind/created_sharp_spring.vue": 200,
		"./shared/notifications/kind/ozzy_task": 201,
		"./shared/notifications/kind/ozzy_task.vue": 201,
		"./shared/notifications/kind/remind": 202,
		"./shared/notifications/kind/remind.vue": 202,
		"./shared/notifications/kind/task": 203,
		"./shared/notifications/kind/task.vue": 203,
		"./shared/notifications/kind/updated_lead_lovers": 204,
		"./shared/notifications/kind/updated_lead_lovers.vue": 204,
		"./shared/notifications/kind/updated_rd_station": 205,
		"./shared/notifications/kind/updated_rd_station.vue": 205,
		"./shared/notifications/kind/updated_sharp_spring": 206,
		"./shared/notifications/kind/updated_sharp_spring.vue": 206,
		"./shared/notifications/list": 207,
		"./shared/notifications/list.vue": 207,
		"./shared/notifications/list_item": 39,
		"./shared/notifications/list_item.vue": 39,
		"./shared/notifications/popup": 208,
		"./shared/notifications/popup.vue": 208,
		"./shared/statistic_table_col": 305,
		"./shared/statistic_table_col.vue": 305,
		"./shared/step_bar": 209,
		"./shared/step_bar.vue": 209,
		"./shared/text_image": 210,
		"./shared/text_image.vue": 210,
		"./specific_templates/list": 211,
		"./specific_templates/list.vue": 211,
		"./specific_templates/list_item": 212,
		"./specific_templates/list_item.vue": 212,
		"./specific_templates/modal": 213,
		"./specific_templates/modal.vue": 213,
		"./tags/color_input": 72,
		"./tags/color_input.vue": 72,
		"./tags/index": 306,
		"./tags/index.vue": 306,
		"./tags/list": 73,
		"./tags/list.vue": 73,
		"./tags/list_item": 214,
		"./tags/list_item.vue": 214,
		"./tags/new": 215,
		"./tags/new.vue": 215,
		"./tags/picker_modal": 74,
		"./tags/picker_modal.vue": 74,
		"./tags/tag": 9,
		"./tags/tag.vue": 9,
		"./template_categories/index": 307,
		"./template_categories/index.vue": 307,
		"./template_categories/list_item": 216,
		"./template_categories/list_item.vue": 216,
		"./template_categories/new": 217,
		"./template_categories/new.vue": 217,
		"./templates/create_modal": 218,
		"./templates/create_modal.vue": 218,
		"./templates/edit": 308,
		"./templates/edit.vue": 308,
		"./templates/empty": 309,
		"./templates/empty.vue": 309,
		"./templates/filters": 219,
		"./templates/filters.vue": 219,
		"./templates/form": 26,
		"./templates/form.vue": 26,
		"./templates/index": 310,
		"./templates/index.vue": 310,
		"./templates/list": 75,
		"./templates/list.vue": 75,
		"./templates/list_item": 220,
		"./templates/list_item.vue": 220,
		"./templates/new": 311,
		"./templates/new.vue": 311,
		"./templates/picker": 221,
		"./templates/picker.vue": 221,
		"./templates/preview": 222,
		"./templates/preview.vue": 222,
		"./templates/show_modal": 223,
		"./templates/show_modal.vue": 223,
		"./templates/variables_dropdown": 76,
		"./templates/variables_dropdown.vue": 76,
		"./users/activation": 312,
		"./users/activation.vue": 312,
		"./users/destroy_modal": 224,
		"./users/destroy_modal.vue": 224,
		"./users/index": 313,
		"./users/index.vue": 313,
		"./users/invitation_form": 314,
		"./users/invitation_form.vue": 314,
		"./users/list_copy": 225,
		"./users/list_copy.vue": 225,
		"./users/list_item": 40,
		"./users/list_item.vue": 40,
		"./users/miniature": 226,
		"./users/miniature.vue": 226
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 318;


/***/ }),
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(2);
	
	var view_model = {
	  props: ['settings', 'on_responsibility'],
	
	  data: function data() {
	    return {
	      mark_as: null,
	      not_update_deal_lost: false,
	      update_deal_lost: false
	    };
	  },
	
	
	  methods: {
	    sending_checked: function sending_checked(option) {
	      if (option === 'update_deal_lost') {
	        this.update_deal_lost = !this.update_deal_lost;
	        this.not_update_deal_lost = !this.update_deal_lost;
	
	        this.mark_as = 'update_deal_lost';
	        this.$emit('selected', this.mark_as);
	      } else if (option === 'not_update_deal_lost') {
	        this.not_update_deal_lost = !this.not_update_deal_lost;
	        this.update_deal_lost = !this.not_update_deal_lost;
	
	        this.mark_as = 'not_update_deal_lost';
	        this.$emit('selected', this.mark_as);
	      }
	    }
	  },
	
	  created: function created() {
	    if (this.settings === 'update_deal_lost') this.update_deal_lost = true;else this.not_update_deal_lost = true;
	  }
	};
	
	exports.default = helpers.vue_include(view_model, helpers.form);

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _getIterator2 = __webpack_require__(230);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = __webpack_require__(2);
	var users_resource = new UsersResource();
	
	var view_model = {
	  components: {
	    carouselModal: __webpack_require__(33),
	    triggerStages: __webpack_require__(7),
	    dealLost: __webpack_require__(32),
	    propertiesMatching: __webpack_require__(13),
	    stagesMatching: __webpack_require__(24),
	    stagesSelect: __webpack_require__(25)
	  },
	
	  data: function data() {
	    return {
	      current_user: Session.current_user,
	      show: false,
	      setting: new HubspotSetting(),
	      hs_carousel: null,
	      copied_hs: false,
	      copied_hs_deal: false,
	      stage_lost: false,
	      properties_matching: Session.current_user.hubspot_setting.properties_matching,
	      api_fields: [],
	      matching: [],
	      metadata_lifecycles: [],
	      integration_stages: [],
	      matching_stages: [],
	      update_stages_all_users: false,
	      integration_pipelines: [],
	      selected_pipeline: { stage_query: null }
	    };
	  },
	
	
	  computed: {
	    authorized: function authorized() {
	      return this.setting.id;
	    },
	    hs_url: function hs_url() {
	      if (this.has_configured_hs_carousel || !this.setting.use_carousel) {
	        return ("https://api.reev.co") + "/webhooks/hubspot/import_contacts?token=" + this.current_user.authentication_token;
	      } else {
	        return ("https://api.reev.co") + "/webhooks/hubspot/import_contacts?token=" + this.current_user.authentication_token;
	      }
	    },
	    has_configured_hs_carousel: function has_configured_hs_carousel() {
	      return this.hs_carousel != null && this.hs_carousel.carousel_users.length > 0;
	    },
	    checkedCreateWebhook: function checkedCreateWebhook() {
	      return this.setting.create_webhook;
	    },
	    show_configuration_by_pipeline_name: function show_configuration_by_pipeline_name() {
	      if (!this.setting) return false;
	      if (this.setting.pipeline) return true;
	      return false;
	    },
	    lost_checked: function lost_checked() {
	      if (this.current_user.hubspot_setting.length == 0) return false;
	      if (this.current_user.hubspot_setting.triggers.stages.filter(function (item) {
	        return item == 'lost';
	      }).length != 0) return true;
	      return false;
	    }
	  },
	
	  methods: {
	    itemSelectedItems: function itemSelectedItems(stage) {
	      this.metadata_lifecycles = stage;
	    },
	    use_carousel: function use_carousel() {
	      if (this.setting.use_carousel) return this.$t('integrations.label.contactsViaCarousel');
	      return this.$t('integrations.label.contactsViaResponsibleCRM');
	    },
	    toggleCreateWebhook: function toggleCreateWebhook() {
	      if (this.has_configured_hs_carousel || !this.setting.use_carousel) {
	        this.setting.create_webhook = !this.setting.create_webhook;
	      }
	    },
	    checkLifecycle: function checkLifecycle(stage) {
	      if (!this.metadata_lifecycles) return false;
	      return this.metadata_lifecycles.indexOf(stage) > -1;
	    },
	    open: function open() {
	      this.$router.push({ path: "/configuracoes/integracao?setting=hubspot" });
	    },
	    close: function close() {
	      this.$router.push({ path: "/configuracoes/integracoes" });
	    },
	    save: function save() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (success) {
	        if (success) {
	          _this.updateUser();
	        }
	      });
	    },
	    updateUser: function updateUser() {
	      var _this2 = this;
	
	      if (this.setting.create_webhook && this.metadata_lifecycles.length == 0) {
	        return alertify.error(this.$t('integrations.feedback.requiredLifeCicleStage'));
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.matching_stages), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var stage = _step.value;
	
	          if (!stage.reev || !stage.integration) return alertify.error(this.$t('integrations.feedback.requiredFunnelStageMap'));
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        var _loop = function _loop() {
	          var property = _step2.value;
	
	          property.type = _this2.api_fields.find(function (field) {
	            return field.key == property.integration;
	          }).type;
	        };
	
	        for (var _iterator2 = (0, _getIterator3.default)(this.matching), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          _loop();
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.setting.metadata.lifecycles = this.metadata_lifecycles;
	      Loader.on();
	      var params = {
	        id: Session.current_user.id,
	        update_stages_all_users: this.update_stages_all_users,
	        user_to_update_stages: this.user_to_update_stages,
	        hubspot_setting_attributes: {
	          id: this.setting.id,
	          pipeline: this.setting.pipeline,
	          metadata: this.setting.metadata,
	          stage: this.setting.stage,
	          create_webhook: this.setting.create_webhook,
	          triggers: this.setting.triggers,
	          use_carousel: this.setting.use_carousel,
	          properties_matching: this.matching,
	          stages_matching: this.matching_stages,
	          mark_as: this.setting.mark_as
	        }
	      };
	      new UsersResource().update(this.updateUserSuccess, this.handleApiErrors, params);
	    },
	    updateUserSuccess: function updateUserSuccess() {
	      Loader.off();
	      alertify.success(this.$t('general.feedback.settingUpdated'));
	    },
	    oauthUrl: function oauthUrl() {
	      var params = jQuery.param({
	        client_id: ("712fd2bc-79a6-4058-bc76-280793238cad"),
	        response_type: "code",
	        redirect_uri: window.location.protocol + "//" + window.location.host + "/configuracoes/integracoes",
	        scope: "timeline oauth crm.objects.contacts.read crm.objects.contacts.write crm.objects.companies.write crm.schemas.contacts.read crm.objects.companies.read crm.objects.deals.read crm.objects.deals.write crm.schemas.companies.read crm.schemas.deals.read crm.objects.owners.read",
	        state: "hubspot"
	      });
	
	      return "https://app.hubspot.com/oauth/authorize?" + params;
	    },
	    matchingStagesUpdated: function matchingStagesUpdated(data) {
	      this.matching_stages = data;
	    },
	    updateUsers: function updateUsers(data) {
	      this.update_stages_all_users = data.update_all_users;
	      this.user_to_update_stages = data.user_id;
	    },
	    connect: function connect() {
	      Loader.on();
	      if (window.parent && Session.current_user.new_ui) return window.parent.postMessage({ type: "redirect-integration", route: this.oauthUrl() }, "*");
	      window.location = this.oauthUrl();
	    },
	    disconnect: function disconnect() {
	      Loader.on();
	      var params = {
	        id: Session.current_user.id,
	        hubspot_setting_attributes: {
	          id: this.setting.id,
	          _destroy: 1,
	          triggers: this.setting.triggers
	        }
	      };
	
	      users_resource.update(this.disconnectSuccess, this.handleApiErrors, params);
	    },
	    disconnectSuccess: function disconnectSuccess() {
	      Loader.off();
	      this.close();
	      this.setting = new HubspotSetting();
	      alertify.success(this.$t('integrations.feedback.hubspotDisconnectSuccess'));
	    },
	    authorize: function authorize() {
	      Loader.on();
	      var code = this.$route.query.code;
	      this.$router.replace({ name: "integrations" });
	      var params = { code: code };
	      if (Session.current_user.new_ui) params.hubspot_redirect_uri = ("https://se.reev.co") + this.$route.path;
	      IntegrationsResource.authorize_hubspot(this.authorizeSuccess, this.unknownError, params);
	    },
	    authorizeSuccess: function authorizeSuccess(response) {
	      Session.updateCurrentUser(response.body.user);
	      this.setting = Session.current_user.hubspot_setting;
	      Loader.off();
	      alertify.success(this.$t('integrations.feedback.hubspotConnectSuccess'));
	    },
	    copyURLhs: function copyURLhs() {
	      jQuery("#hs_url").select();
	      document.execCommand("copy");
	      return this.copied_hs = true;
	    },
	    loadHsCarouselData: function loadHsCarouselData() {
	      return this.$refs.hs_carousel_modal.loadData();
	    },
	    modalTitle: function modalTitle() {
	      if (this.current_user.isSeller()) {
	        return this.$t('integrations.attributes.Carousel');
	      } else {
	        return this.$t('integrations.label.setCarousel');
	      }
	    },
	    fillHsCarousel: function fillHsCarousel(carousel) {
	      return this.hs_carousel = carousel;
	    },
	    setStages: function setStages(data) {
	      this.setting.triggers = data;
	      this.update_stage_lost(data.stages);
	    },
	    setMarkAs: function setMarkAs(data) {
	      this.setting.mark_as = data;
	    },
	    toggleUseCarousel: function toggleUseCarousel() {
	      this.setting.use_carousel = !this.setting.use_carousel;
	    },
	    update_stage_lost: function update_stage_lost(stages) {
	      if (stages.filter(function (item) {
	        return item == 'lost';
	      }).length != 0) return this.stage_lost = true;
	      return this.stage_lost = false;
	    },
	    matchingUpdated: function matchingUpdated(data) {
	      this.matching = data.filter(function (field) {
	        return !(field.reev == undefined || field.reev == "");
	      });
	    },
	    loadHubspotFields: function loadHubspotFields() {
	      var _this3 = this;
	
	      if (!this.setting.access_token) return;
	
	      var opts = {
	        params: { hapikey: this.setting.access_token },
	        headers: {
	          "Access-Control-Allow-Origin": "*",
	          Accept: "application/json",
	          "Content-Type": "application/json"
	        }
	      };
	
	      Vue.http.get(("https://api.reev.co") + "/hubspots/contact_properties", opts).then(function (response) {
	        var regex = /^(?!hs_|hubspot|lifecyclestage|engagements|associated).*/;
	        var body = response.body;
	        body = body.map(function (field) {
	          if (field.type == "string") {
	            field.type = "text";
	          }
	
	          if (field.type == "datetime") {
	            field.type = "date";
	          }
	
	          field.key = field.name;
	          field.name = field.label;
	          return field;
	        });
	
	        _this3.api_fields = body.filter(function (field) {
	          return regex.test(field.name) && field.readOnlyValue != true && field.hidden != true && !field.referencedObjectType;
	        });
	
	        _this3.properties_matching = Session.current_user.hubspot_setting.properties_matching;
	        if (!_this3.properties_matching || _this3.properties_matching.length === 0) {
	          _this3.properties_matching = [{
	            reev: "first_name",
	            reev_name: _this3.$t('integrations.attributes.name'),
	            integration: "firstname",
	            integration_name: "firstname"
	          }, {
	            reev: "last_name",
	            reev_name: _this3.$t('integrations.attributes.lastname'),
	            integration: "lastname",
	            integration_name: "lastname"
	          }, {
	            reev: "email",
	            reev_name: _this3.$t('integrations.attributes.email'),
	            integration: "email",
	            integration_name: "email"
	          }, {
	            reev: "telephone",
	            reev_name: _this3.$t('integrations.attributes.telephone'),
	            integration: "phone",
	            integration_name: "Phone Number"
	          }, {
	            reev: "cellphone",
	            reev_name: _this3.$t('integrations.attributes.cellphone'),
	            integration: "mobilephone",
	            integration_name: "Mobile Phone Number"
	          }, {
	            reev: "url",
	            reev_name: _this3.$t('integrations.attributes.url'),
	            integration: "website",
	            integration_name: "website"
	          }];
	        }
	      });
	    },
	    loadHubspotStages: function loadHubspotStages() {
	      var _this4 = this;
	
	      if (!this.setting.access_token) return;
	
	      var opts = {
	        params: { hapikey: this.setting.access_token }
	      };
	
	      Vue.http.get(("https://api.reev.co") + "/hubspots/pipeline_stages?pipeline_id=" + this.selected_pipeline, opts).then(function (response) {
	        var body = response.body;
	        _this4.integration_stages = body.map(function (stage) {
	          return { name: stage.label, id: stage.stageId };
	        });
	      });
	    },
	    loadHubspotPipelines: function loadHubspotPipelines() {
	      var _this5 = this;
	
	      if (!this.setting.access_token) return;
	
	      var opts = {
	        params: { hapikey: this.setting.access_token }
	      };
	
	      Vue.http.get(("https://api.reev.co") + "/hubspots/pipelines", opts).then(function (response) {
	        var body = response.body;
	        _this5.integration_pipelines = body.map(function (pipeline) {
	          return {
	            value: { stage_query: pipeline.pipeline_id },
	            text: pipeline.label,
	            stages: pipeline.stages.map(function (stage) {
	              return { name: stage.label, id: stage.stageId };
	            })
	          };
	        });
	        _this5.integration_pipelines.unshift({
	          value: { stage_query: null },
	          text: _this5.$t('integrations.placeholder.funnel')
	        });
	        var pipeline = _this5.integration_pipelines[0].value.stage_query;
	        if (_this5.selected_pipeline) {
	          if (_this5.selected_pipeline.stage_query) {
	            pipeline = _this5.selected_pipeline.stage_query;
	          }
	        }
	        _this5.loadByNewPipeline({
	          pipeline: {
	            stage_query: pipeline
	          }
	        });
	      });
	    },
	    loadByNewPipeline: function loadByNewPipeline(data) {
	      var _this6 = this;
	
	      this.setting.metadata.pipeline_id = data.pipeline.stage_query;
	      this.selected_pipeline = data.pipeline;
	      if (this.setting.metadata) this.setting.metadata.pipeline_id = this.selected_pipeline.stage_query;
	      var pipeline = this.integration_pipelines.find(function (pipe) {
	        return pipe.value.stage_query == _this6.selected_pipeline.stage_query;
	      });
	      if (pipeline.stages) {
	        this.integration_stages = pipeline.stages;
	      } else {
	        this.loadHubspotStages();
	      }
	    },
	    changePipeline: function changePipeline(data) {
	      this.setting.metadata.pipeline_id = data.pipeline.stage_query;
	      this.setting.stages_matching = [];
	      this.loadByNewPipeline(data);
	    }
	  },
	
	  created: function created() {
	    if (this.$route.query.state == "hubspot" && this.$route.query.code) {
	      setTimeout(this.authorize, 1000);
	    }
	
	    if (Session.current_user.hubspot_setting) {
	      this.setting = Session.current_user.hubspot_setting;
	      if (this.setting.metadata !== undefined && this.setting.metadata.lifecycles) this.metadata_lifecycles = this.setting.metadata.lifecycles;
	
	      if (this.setting.metadata) {
	        this.selected_pipeline = {
	          stage_query: this.setting.metadata.pipeline_id
	        };
	      }
	    }
	
	    this.loadHubspotFields();
	    this.loadHubspotPipelines();
	    this.show = /integracao\?/.test(this.$router.currentRoute.fullPath);
	  }
	};
	
	exports.default = helpers.vue_include(view_model, helpers.form);

/***/ }),
/* 323 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.default = {
	  props: {
	    item: { required: true },
	    searchText: { required: true }
	  },
	
	  methods: {
	    replacer: function replacer(match) {
	      return "<strong>" + match + "</strong>";
	    }
	  },
	
	  computed: {
	    text: function text() {
	      var _this = this;
	
	      function __guard__(value, transform) {
	        return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
	      }
	      return __guard__(this.item != null ? this.item.name : undefined, function (x) {
	        return x.replace(new RegExp(_this.searchText, "i"), _this.replacer);
	      });
	    }
	  }
	};

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(2);
	
	var view_model = {
	  props: ['settings', 'integration', 'on_responsibility'],
	
	  components: {
	    stagesSelect: __webpack_require__(25)
	  },
	
	  data: function data() {
	    return {
	      kind_multiple_filter: 'stage_filter',
	      uncheck_all_items: false,
	      filter_item_selected_ids: [],
	      trigger: false,
	      stage_created: null,
	      triggers: { status: [], stages: [] },
	      status_connected_trigger: true,
	      stages: [],
	      on_created: false,
	      on_change: false
	    };
	  },
	
	
	  methods: {
	    showIntegrationOnCreated: function showIntegrationOnCreated() {
	      return ['hubspot', 'pipedrive', 'nectar', 'webhook', 'vtiger'].indexOf(this.integration) > -1;
	    },
	    toggleTrigger: function toggleTrigger(trigger) {
	      this.trigger = !this.trigger;
	      if (!this.trigger) {
	        this.itemSelectedItems([]);
	      }
	    },
	    toggleStatusTrigger: function toggleStatusTrigger() {
	      this.status_connected_trigger = !this.status_connected_trigger;
	      this.emitData();
	    },
	    itemSelectedItems: function itemSelectedItems(data) {
	      this.stages = data;
	      this.emitData();
	    },
	    emitData: function emitData() {
	      this.triggers = {
	        status: [],
	        stages: this.stages,
	        on_change: this.on_change,
	        on_created: this.on_created
	
	      };
	      if (this.status_connected_trigger) {
	        this.triggers.status.push('connected');
	      }
	      this.$emit('selected-stages', this.triggers);
	    },
	    toggleResponsibilityTrigger: function toggleResponsibilityTrigger() {
	      this.on_change = !this.on_change;
	      this.emitData();
	    },
	    toggleMark: function toggleMark() {
	      this.on_created = !this.on_created;
	      this.emitData();
	    }
	  },
	
	  watch: {
	    settings: function settings() {
	      this.on_created = this.settings.on_created;
	      this.triggers = { stages: [this.settings.stages], status: [this.settings.status] };
	      if (this.settings.status) this.status_connected_trigger = this.settings.status.indexOf('connected') > -1;
	      if (this.settings.stages) this.filter_item_selected_ids = this.settings.stages;
	      if (this.filter_item_selected_ids.length > 0) {
	        this.trigger = true;
	      }
	    }
	  },
	
	  created: function created() {
	    if (!this.settings || this.settings == {}) {
	      this.itemSelectedItems([]);
	      return;
	    }
	    if (this.settings.status) this.status_connected_trigger = this.settings.status.indexOf('connected') > -1;
	    if (this.settings.stages) this.filter_item_selected_ids = this.settings.stages;
	    if (this.filter_item_selected_ids.length > 0) {
	      this.trigger = true;
	    }
	
	    this.stages = this.settings.stages;
	    this.on_created = this.settings.on_created;
	    this.on_change = this.on_responsibility;
	  }
	};
	
	exports.default = helpers.vue_include(view_model, helpers.form);

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(2);
	
	var view_model = {
	  mixins: [__webpack_require__(6), __webpack_require__(80)],
	
	  components: {
	    flows: __webpack_require__(8),
	    groups: __webpack_require__(67),
	    users: __webpack_require__(55)
	  },
	
	  props: {
	    triggers: {
	      default: null
	    },
	    current_user_id: {
	      type: Number,
	      default: null
	    }
	  },
	
	  data: function data() {
	    return {
	      current_company: Session.current_company,
	      matching: [],
	      default_flow: null,
	      triggers_options: [{ value: "connected", text: this.$t('flows.options.triggers.connected') }, { value: "bounced", text: this.$t('flows.options.triggers.bounced') }, { value: "lost", text: this.$t('flows.options.triggers.lost') }, { value: "stage", text: this.$t('flows.options.triggers.stage') }],
	      actions_options: [{ value: "send_to_new_flow", text: this.$t('flows.options.actions.sendToNewFlow') }, { value: "change_stage", text: this.$t('flows.options.actions.changeStage') }, { value: "fill_property", text: this.$t('flows.options.actions.fillProperty') }, { value: "insert_tag", text: this.$t('flows.options.actions.insertTag') }, { value: "insert_into_a_group", text: this.$t('flows.options.actions.insertIntoGroup') }, { value: "change_responsible", text: this.$t('flows.options.actions.changeResponsible') }],
	      timming_options: [{ value: "immediately", text: this.$t('flows.options.timming.immediately') }, { value: "next_day", text: this.$t('flows.options.timming.nextDay') }, { value: "after", text: this.$t('flows.options.timming.after') }],
	      timming_complements: [{ value: "hours", text: this.$t('flows.options.timmingComplements.hours') }, { value: "days", text: this.$t('flows.options.timmingComplements.days') }, { value: "weeks", text: this.$t('flows.options.timmingComplements.weeks') }, { value: "months", text: this.$t('flows.options.timmingComplements.months') }],
	      actions_trigger_without_stages: [{ value: "send_to_new_flow", text: this.$t('flows.options.actionsTriggerWithoutStages.sendToNewFlow') }, { value: "fill_property", text: this.$t('flows.options.actionsTriggerWithoutStages.fillProperty') }, { value: "insert_tag", text: this.$t('flows.options.actionsTriggerWithoutStages.insertTag') }, { value: "insert_into_a_group", text: this.$t('flows.options.actionsTriggerWithoutStages.insertIntoGroup') }, { value: "change_responsible", text: this.$t('flows.options.actionsTriggerWithoutStages.changeResponsible') }],
	      stages_options: [{ value: null, text: this.$t('flows.options.stages') }],
	      lost_reason_id: null,
	      properties_options: [{ value: null, text: this.$t('flows.options.properties') }],
	      tag_filter: [],
	      kind_multiple_filter: 'tag_filter',
	      selected_user: Session.current_user.id
	    };
	  },
	
	
	  methods: {
	    newTrigger: function newTrigger() {
	      this.matching.push({
	        trigger_type: "connected",
	        trigger_value: null,
	        action_type: "send_to_new_flow",
	        action_value: null,
	        timming_type: "immediately",
	        timming_value: null,
	        timming_complement: null,
	        action_metadata: []
	      });
	    },
	    setDirty: function setDirty() {
	      var action_value = void 0;
	      var obj = this.matching.map(function (trigger) {
	        action_value = trigger.action_value;
	        if (trigger.action_type == 'change_responsible' && trigger.action_value) action_value = trigger.action_value.user_id_eq;
	
	        trigger.timming_complement = trigger.timming_complement ? trigger.timming_complement : 'hours';
	        return {
	          id: trigger.id || null,
	          trigger_type: trigger.trigger_type,
	          trigger_value: trigger.trigger_value,
	          action_type: trigger.action_type,
	          action_value: action_value,
	          action_target: trigger.action_target,
	          action_metadata: trigger.action_metadata.map(function (id) {
	            return id.toString();
	          }),
	          timming_type: trigger.timming_type == "after" ? trigger.timming_complement : trigger.timming_type,
	          timming_value: trigger.timming_value,
	          _destroy: trigger._destroy
	        };
	      });
	      this.$emit("update-triggers", obj);
	    },
	    itemSelectedItems: function itemSelectedItems(data) {
	      this.matching[data.position].action_metadata = data.selected_items.map(function (t) {
	        return t.id;
	      });
	    },
	    selectFlow: function selectFlow(flow) {
	      this.matching[flow.position].action_value = flow.id;
	    },
	    selectGroup: function selectGroup(group) {
	      this.matching[group.position].action_value = group.id;
	    },
	    lostReasonOptions: function lostReasonOptions() {
	      var result = [];
	      result.push({ value: null, text: this.$t('flows.options.lostReason') });
	      if (this.$store.getters.lostReasonsCount == 0) {
	        this.$store.dispatch("fetchLostReasons");
	      }
	      var list = this.$store.getters.lostReasonsList;
	      var index;
	      for (index = 0; index < this.$store.getters.lostReasonsCount; index++) {
	        result.push({ value: list[index].id, text: list[index].title });
	      }
	      return result;
	    },
	    removeTrigger: function removeTrigger(item, index) {
	      if (item.id) {
	        this.matching[index]._destroy = true;
	      } else {
	        this.matching.splice(index, 1);
	      }
	      this.$forceUpdate();
	      this.setDirty();
	    },
	    loadCustomFields: function loadCustomFields() {
	      Loader.on();
	      new CustomFieldsResource().index(this.loadCustomFieldsSuccess, this.loadCustomFieldsFail);
	    },
	    loadCustomFieldsSuccess: function loadCustomFieldsSuccess(data) {
	      this.properties_options = this.properties_options.concat(data.custom_fields.map(function (field) {
	        return { value: field.id, text: field.field };
	      }));
	      Loader.off();
	    },
	    loadCustomFieldsFail: function loadCustomFieldsFail() {
	      Loader.off();
	      alertify.error(this.$t('contacts.label.customFieldsFailLoading'));
	    }
	  },
	
	  computed: {
	    show_timming_actions: function show_timming_actions() {
	      return ['send_to_new_flow', 'change_stage'];
	    }
	  },
	
	  watch: {
	    triggers: function triggers() {
	      var _this = this;
	
	      if (this.triggers.length > 0 && this.matching.length == 0) {
	        this.matching = this.triggers.map(function (trigger) {
	          if (trigger.action_type == 'send_to_new_flow') trigger.action_value = trigger.flow;
	          if (trigger.action_type == 'insert_into_a_group') trigger.action_value = trigger.contact_group;
	          if (trigger.action_type == 'change_responsible') trigger.action_value = { user_id_eq: trigger.action_value };
	          if (trigger.action_type == 'fill_property' && typeof trigger.action_target == 'string') trigger.action_target = _this.properties_options.find(function (propertie) {
	            return propertie.value == parseInt(trigger.action_target);
	          }).value;
	          if (!isNaN(trigger.trigger_value) && trigger.trigger_value != null) trigger.trigger_value = parseInt(trigger.trigger_value);
	          if (trigger.timming_type == 'days' || trigger.timming_type == 'hours' || trigger.timming_type == 'weeks' || trigger.timming_type == 'months') {
	            trigger.timming_complement = trigger.timming_type;
	            trigger.timming_type = 'after';
	          }
	          return trigger;
	        });
	      }
	    },
	
	
	    matching: {
	      handler: function handler(val) {
	        this.setDirty();
	      },
	
	      deep: true
	    }
	  },
	
	  created: function created() {
	    this.stages_options = this.stages_options.concat(new Contact().stages());
	    this.flow_resources = new FlowsResource(this.current_company.id);
	    this.current_user_id |= Session.current_user.id;
	    this.loadCustomFields();
	  }
	};
	
	exports.default = helpers.vue_include(view_model, helpers.form);

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _helpers = __webpack_require__(2);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var view_model = {
	  components: {
	    listItem: __webpack_require__(147),
	    newLostReason: __webpack_require__(148)
	  },
	  data: function data() {
	    return {
	      title: '',
	      editing: null,
	      selected_lost_reason: {}
	    };
	  },
	
	
	  methods: {
	    loadLostReasons: function loadLostReasons() {
	      if (this.$store.getters.lostReasonsCount == 0) {
	        this.$store.dispatch('fetchLostReasons');
	      }
	    },
	    toggleEditClass: function toggleEditClass(id) {
	      if (this.editing && this.editing.id === id) {
	        return '';
	      } else {
	        return 'hidden';
	      }
	    },
	    updatedLostReason: function updatedLostReason(lost_reason) {
	      var index = this.lost_reasons.findIndex(lost_reason.id);
	      this.lost_reasons.replaceById(lost_reason);
	    },
	    createdLostReason: function createdLostReason(lost_reason) {
	      this.lost_reasons.unshift(lost_reason);
	    },
	    openDestroyConfirmationModal: function openDestroyConfirmationModal(lost_reason) {
	      this.selected_lost_reason = lost_reason;
	      EventsBus.$emit('confirm-modal-show', { id: 'confirm-destroy-lost-reason' });
	    },
	    destroyLostReason: function destroyLostReason() {
	      this.$store.dispatch('removeLostReason', { id: this.selected_lost_reason.id });
	    }
	  },
	
	  beforeCreate: function beforeCreate() {
	    if (Session.current_user.isSeller() || Session.current_user.isMonitoringManager()) {
	      return this.$router.push('/configuracoes/perfil');
	    }
	  },
	  created: function created() {
	    return this.loadLostReasons();
	  }
	};
	
	exports.default = _helpers2.default.vue_include(view_model, _helpers2.default.form);

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _helpers = __webpack_require__(2);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var view_model = {
	  props: ['lost_reason'],
	  data: function data() {
	    return {
	      title: this.lost_reason.title,
	      editing: false
	    };
	  },
	
	
	  computed: {
	    can_edit_lost_reason: function can_edit_lost_reason() {
	      return this.title != 'Blocklist' && this.title != 'Sem Conexão';
	    }
	  },
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.$validator.validateAll({ title: this.title }).then(function (success) {
	        if (success) {
	          _this.updateLostCategory();
	        }
	      });
	    },
	    updateLostCategory: function updateLostCategory() {
	      var params = { id: this.lost_reason.id, title: this.title };
	      this.$store.dispatch('updateLostReason', params);
	      this.editing = false;
	    },
	    destroyLostReason: function destroyLostReason() {
	      this.$emit('destroy', this.lost_reason);
	    },
	    trackIntercomLostCategoryUpdate: function trackIntercomLostCategoryUpdate(lost_reason) {
	      var metadata = [{ attribute: 'title', key: 'Título', function: 'changedFromTo' }];
	      IntercomCtrl.trackEventMetadata('Atualizou uma categoria de perda', metadata, this.lost_reason, lost_reason);
	    }
	  }
	};
	
	exports.default = _helpers2.default.vue_include(view_model, _helpers2.default.form);

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var helpers = __webpack_require__(2);
	
	var view_model = {
	  data: function data() {
	    return {
	      title: '',
	      existing_title: false
	    };
	  },
	
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.$validator.validateAll({ title: this.title }).then(function (success) {
	        if (success) {
	          if (_this.search(_this.title, _this.$store.getters.lostReasonsList)) {
	            _this.existing_title = true;
	          } else {
	            _this.createLostReason();
	          }
	        }
	      });
	    },
	    search: function search(titleKey, myArray) {
	      for (var i = 0; i < myArray.length; i++) {
	        if (myArray[i].title === titleKey) {
	          console.log(myArray[i].title);
	          return true;
	        }
	      }
	    },
	    createLostReason: function createLostReason() {
	      this.$store.dispatch('createLostReason', { title: this.title });
	    }
	  },
	  watch: {
	    title: function title(newTitle, oldTitle) {
	      if (newTitle === "") {
	        this.existing_title = false;
	      }
	    }
	  }
	};
	
	exports.default = helpers.vue_include(view_model, helpers.form);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _helpers = __webpack_require__(2);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var view_model = {
	  components: {
	    listItem: __webpack_require__(165),
	    newMeetingType: __webpack_require__(166),
	    noShowFlow: __webpack_require__(167)
	  },
	  data: function data() {
	    return {
	      title: '',
	      editing: null,
	      selected_meeting_type: {}
	    };
	  },
	
	
	  methods: {
	    loadMeetingTypes: function loadMeetingTypes() {
	      if (this.$store.getters.meetingTypesCount == 0) {
	        this.$store.dispatch('fetchMeetingTypes');
	      }
	    },
	    toggleEditClass: function toggleEditClass(id) {
	      if (this.editing && this.editing.id === id) {
	        return '';
	      } else {
	        return 'hidden';
	      }
	    },
	    updatedMeetingType: function updatedMeetingType(meeting_type) {
	      var index = this.meeting_types.findIndex(meeting_type.id);
	      this.meeting_types.replaceById(meeting_type);
	    },
	    createdMeetingType: function createdMeetingType(meeting_type) {
	      this.meeting_types.unshift(meeting_type);
	    },
	    openDestroyConfirmationModal: function openDestroyConfirmationModal(meeting_type) {
	      this.selected_meeting_type = meeting_type;
	      EventsBus.$emit('confirm-modal-show', { id: 'confirm-destroy-meeting-type' });
	    },
	    destroyMeetingType: function destroyMeetingType() {
	      this.$store.dispatch('removeMeetingType', { id: this.selected_meeting_type.id });
	    }
	  },
	
	  beforeCreate: function beforeCreate() {
	    if (Session.current_user.isSeller() || Session.current_user.isMonitoringManager()) {
	      return this.$router.push('/configuracoes/perfil');
	    }
	  },
	  created: function created() {
	    return this.loadMeetingTypes();
	  }
	};
	
	exports.default = _helpers2.default.vue_include(view_model, _helpers2.default.form);

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _helpers = __webpack_require__(2);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var view_model = {
	  props: ['meeting_type'],
	  data: function data() {
	    return {
	      title: this.meeting_type.title,
	      editing: false
	    };
	  },
	
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.$validator.validateAll({ title: this.title }).then(function (success) {
	        if (success) {
	          _this.updateMeetingType();
	        }
	      });
	    },
	    updateMeetingType: function updateMeetingType() {
	      var params = { id: this.meeting_type.id, title: this.title };
	      this.$store.dispatch('updateMeetingType', params);
	      this.editing = false;
	    },
	    destroymeetingType: function destroymeetingType() {
	      this.$emit('destroy', this.meeting_type);
	    },
	    trackIntercomLostCategoryUpdate: function trackIntercomLostCategoryUpdate(meeting_type) {
	      var metadata = [{ attribute: 'title', key: 'Título', function: 'changedFromTo' }];
	      IntercomCtrl.trackEventMetadata('Atualizou um tipo de reunião', metadata, this.meeting_type, meeting_type);
	    }
	  }
	};
	
	exports.default = _helpers2.default.vue_include(view_model, _helpers2.default.form);

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var helpers = __webpack_require__(2);
	
	var view_model = {
	  data: function data() {
	    return {
	      title: "",
	      existing_title: false
	    };
	  },
	
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.$validator.validateAll({ title: this.title }).then(function (success) {
	        if (success) {
	          if (_this.search(_this.title, _this.$store.getters.meetingTypesList)) {
	            _this.existing_title = true;
	          } else {
	            _this.createMeetingType();
	          }
	        }
	      });
	    },
	    search: function search(titleKey, myArray) {
	      for (var i = 0; i < myArray.length; i++) {
	        if (myArray[i].title === titleKey) {
	          return true;
	        }
	      }
	    },
	    createMeetingType: function createMeetingType() {
	      this.$store.dispatch("createMeetingType", { title: this.title });
	      this.title = "";
	    }
	  },
	  watch: {
	    title: function title(newTitle, oldTitle) {
	      if (newTitle === "") {
	        this.existing_title = false;
	      }
	    }
	  }
	};
	
	exports.default = helpers.vue_include(view_model, helpers.form);

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _helpers = __webpack_require__(2);
	
	var _helpers2 = _interopRequireDefault(_helpers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var view_model = {
	  components: {
	    flows: __webpack_require__(8)
	  },
	  data: function data() {
	    return {
	      selected_user: Session.current_user.id,
	      flow: null,
	      default_flow: Session.current_user.flow.id ? Session.current_user.flow : null
	    };
	  },
	
	  methods: {
	    selectFlow: function selectFlow(flow) {
	      this.flow = flow.id;
	    },
	    submit: function submit() {
	      new UsersResource().update(this.updateSuccess, this.unknownError, {
	        id: this.selected_user,
	        flow_id: this.flow
	      });
	    },
	    updateSuccess: function updateSuccess(data, response) {
	      Session.signIn(response.body.user);
	      alertify.success("Dados salvos com sucesso!");
	    }
	  }
	};
	
	exports.default = _helpers2.default.vue_include(view_model, _helpers2.default.form);

/***/ }),
/* 333 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.default = {
	  props: {
	    item: { required: true },
	    searchText: { required: true }
	  },
	
	  methods: {
	    replacer: function replacer(match) {
	      return "<strong>" + match + "</strong>";
	    }
	  },
	
	  computed: {
	    text: function text() {
	      var _this = this;
	
	      function __guard__(value, transform) {
	        return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
	      }
	      return __guard__(this.item != null ? this.item.name : undefined, function (x) {
	        return x.replace(new RegExp(_this.searchText, "i"), _this.replacer);
	      });
	    }
	  }
	};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var listItem = __webpack_require__(172);
	var helpers = __webpack_require__(2);
	var on_clickaway = __webpack_require__(5);
	
	var view_model = {
	  mixins: [on_clickaway.mixin],
	  props: ['contact', 'user_id', 'default_flow', 'position', 'focus'],
	  data: function data() {
	    return {
	      show: false,
	      current_company: Session.current_company,
	      flow: this.default_flow || null,
	      flows: [],
	      template: listItem,
	      attrs: {
	        placeholder: "Digite o nome do fluxo"
	      }
	    };
	  },
	
	
	  methods: {
	    setFocus: function setFocus() {
	      if (this.focus) {
	        jQuery('#' + this.id + '.v-autocomplete .v-autocomplete-input').focus();
	      }
	    },
	    onClickaway: function onClickaway() {
	      this.$emit('hide');
	    },
	    getLabel: function getLabel(flow) {
	      return flow != null ? flow.name : undefined;
	    },
	    getContacts: function getContacts() {
	      if (!contact) {
	        return;
	      } else if (this.flow) {
	        this.contact_resource.lastActiveOnFlow(this.getContactsSuccess, this.unknownError, { flow_id: this.flow.id });
	      }
	    },
	    getContactsSuccess: function getContactsSuccess(data) {
	      this.flow.contacts = data.contacts;
	      this.flow.contacts.push(this.contact);
	    },
	    updateFlows: function updateFlows(text) {
	      var user_id = this.contact ? this.contact.user.id : this.user_id;
	      this.flow_resources.index(this.searchSuccess, this.unknownError, { params: { q: { name_cont: text, user_id_eq: user_id } } });
	    },
	    searchSuccess: function searchSuccess(resources) {
	      this.flows = resources.flows;
	    },
	    saveFlow: function saveFlow(flow) {
	      if (this.contact) {
	        if (this.contact.recipient && flow.id === this.contact.recipient.flow_id) {
	          EventsBus.$emit('Contact::SameFlowConfirmationModal', { contact: this.contact, flow: flow });
	        } else {
	          this.flow_resources.update(this.saveFlowSuccess, this.saveFlowFailure, { id: flow.id, recipients_attributes: [{ contact_id: this.contact.id }] });
	        }
	      } else {
	        flow.position = this.position;
	        this.$emit('flow-selected', flow);
	      }
	    },
	    saveFlowSuccess: function saveFlowSuccess(data) {
	      alertify.success('Contato enviado para o fluxo com sucesso');
	      this.$emit('hide');
	      this.flow.position = this.position;
	      this.$emit('flow-selected', this.flow);
	    },
	    saveFlowFailure: function saveFlowFailure() {
	      alertify.error('Para inserir o contato em outro fluxo é necessário finaliza-lo no fluxo atual');
	      this.$emit('hide');
	    }
	  },
	
	  computed: {
	    id: function id() {
	      if (this.contact) {
	        return 'autocomplete_' + this.contact.id;
	      } else {
	        return "autocomplete_flow";
	      }
	    }
	  },
	  mounted: function mounted() {
	    this.setFocus();
	  },
	  created: function created() {
	    this.flow_resources = new FlowsResource(this.current_company.id);
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	  }
	};
	exports.default = helpers.vue_include(view_model, helpers.form);

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var listItem = __webpack_require__(66);
	var helpers = __webpack_require__(2);
	var on_clickaway = __webpack_require__(5);
	
	var view_model = {
	  mixins: [on_clickaway.mixin],
	  props: ['user_id'],
	  data: function data() {
	    return {
	      group_options: [],
	      template: listItem,
	      group_filter: null,
	      attrs: {
	        placeholder: "Grupo"
	      }
	    };
	  },
	
	
	  watch: {
	    user_id: function user_id() {
	      this.loadGroups();
	    }
	  },
	
	  methods: {
	    onClickaway: function onClickaway() {
	      this.$emit('hide');
	    },
	    getLabel: function getLabel(group) {
	      return group != null ? group.name : undefined;
	    },
	    updateGroups: function updateGroups(text) {
	      var params = { page: 1, per: 10, q: { search_query: text, s: 'name asc' } };
	      this.contact_groups_resource.index(this.loadGroupsSuccess, this.unknownError, { params: params });
	    },
	    selected: function selected(item) {
	      this.$emit('group-selected', item);
	    },
	    loadGroups: function loadGroups() {
	      var params = { page: 1, per: 10, q: { s: 'name asc' } };
	      if (this.user_id) params.q.user_id_eq = this.user_id;
	      this.contact_groups_resource.index(this.loadGroupsSuccess, null, { params: params });
	    },
	    loadGroupsSuccess: function loadGroupsSuccess(data) {
	      this.group_options = data.contact_groups;
	      this.group_options.unshift({ id: null, name: 'Grupos' });
	    }
	  },
	
	  mounted: function mounted() {
	    this.contact_groups_resource = new ContactGroupsResource(Session.current_company.id);
	    this.loadGroups();
	  }
	};
	exports.default = helpers.vue_include(view_model, helpers.filters);

/***/ }),
/* 336 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.default = {
	  props: {
	    item: { required: true },
	    searchText: { required: true }
	  },
	
	  methods: {
	    replacer: function replacer(match) {
	      return "<strong>" + match + "</strong>";
	    }
	  },
	
	  computed: {
	    text: function text() {
	      var _this = this;
	
	      function __guard__(value, transform) {
	        return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
	      }
	      return __guard__(this.item != null ? this.item.name : undefined, function (x) {
	        return x.replace(new RegExp(_this.searchText, "i"), _this.replacer);
	      });
	    }
	  }
	};

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var listItem = __webpack_require__(66);
	var helpers = __webpack_require__(2);
	var on_clickaway = __webpack_require__(5);
	
	var view_model = {
	  mixins: [on_clickaway.mixin],
	  props: ['user_id', 'position', 'default_group'],
	  data: function data() {
	    return {
	      show: false,
	      current_company: Session.current_company,
	      group: this.default_group || null,
	      groups: [],
	      template: listItem,
	      attrs: {
	        placeholder: "Digite o nome do grupo"
	      }
	    };
	  },
	
	
	  methods: {
	    setFocus: function setFocus() {
	      jQuery('#' + this.id + '.v-autocomplete .v-autocomplete-input').focus();
	    },
	    onClickaway: function onClickaway() {
	      this.$emit('hide');
	    },
	    getLabel: function getLabel(group) {
	      return group != null ? group.name : undefined;
	    },
	    selectGroup: function selectGroup(text) {
	      this.group_resources.index(this.searchSuccess, this.unknownError, { params: { page: 1, per: 10, q: { name_cont: text, user_id_eq: this.user_id } } });
	    },
	    searchSuccess: function searchSuccess(resources) {
	      this.groups = resources.contact_groups;
	    },
	    saveGroup: function saveGroup(group) {
	      group.position = this.position;
	      this.$emit('group-selected', group);
	    },
	    updateGroups: function updateGroups(text) {
	      this.group_resources.index(this.searchSuccess, this.unknownError, { params: { page: 1, per: 10, q: { name_cont: text, user_id_eq: this.user_id } } });
	    }
	  },
	
	  mounted: function mounted() {
	    this.setFocus();
	  },
	  created: function created() {
	    this.group_resources = new ContactGroupsResource(this.current_company.id);
	  }
	};
	exports.default = helpers.vue_include(view_model, helpers.form);

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(353);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _getIterator2 = __webpack_require__(230);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = __webpack_require__(2);
	var summernote = __webpack_require__(77);
	
	var view_model = {
	  props: {
	    id: {
	      default: "new-compose"
	    },
	
	    task: {
	      default: {}
	    },
	
	    template: {
	      default: {}
	    },
	
	    number_composes: {
	      default: 1
	    },
	
	    event: {
	      default: {}
	    }
	  },
	
	  components: {
	    contactAutocomplete: __webpack_require__(64),
	    variablesDropdown: __webpack_require__(76),
	    templateAutocomplete: __webpack_require__(68),
	    scheduler: __webpack_require__(180)
	  },
	
	  data: function data() {
	    return {
	      cc_text: '',
	      cc_emails: [],
	      loading: false,
	      show_template_autocomplete: false,
	      current_user: Session.current_user,
	      lastSubjectCursorPosition: 0,
	      minimized: false,
	      selected_template: null,
	      variables: [],
	      show_cc: false,
	      copied: false,
	      subject: '',
	      file_ids: [],
	      show_scheduler: false,
	      due_on_scheduler: null,
	      error_file: false,
	      files: [],
	      uploading: false,
	      progress: 0,
	      progress_bar: [],
	      removed_contact: null,
	      remove_quota_exceeded: false,
	      schedule: false,
	      send_email: false
	    };
	  },
	
	
	  methods: {
	    updateMetadata: function updateMetadata(task) {
	      this.task.metadata = task.metadata;
	      this.task.due_on = task.due_on;
	    },
	    titleClass: function titleClass() {
	      if (this.task.isScheduled()) {
	        if (this.template) {
	          return this.template.kind + " scheduled";
	        } else {
	          return this.task.templateKind() + " scheduled";
	        }
	      } else {
	        if (this.template) {
	          return this.template.kind;
	        } else {
	          return this.task.templateKind();
	        }
	      }
	    },
	    openScheduler: function openScheduler() {
	      this.show_scheduler = true;
	    },
	    closeScheduler: function closeScheduler() {
	      this.show_scheduler = false;
	    },
	    doneTask: function doneTask() {
	      this.task.markAsDone();
	      return this.tasks_resources.save(this.taskUpdated, this.unknownError, this.task.serialize(['id', 'done_at']));
	    },
	    taskUpdated: function taskUpdated(resources) {
	      alertify.success('Tarefa atualizada com sucesso');
	      resources.task.assigned_to = this.task.assigned_to;
	      EventsBus.$emit('Task::Done', resources.task);
	      return this.close();
	    },
	    copy: function copy() {
	      this.select(this.compose_id, 'note-editing-area');
	      document.execCommand("copy");
	      alertify.success('Texto copiado para a área de transferência');
	      return this.copied = true;
	    },
	    contentLabel: function contentLabel(kind) {
	      switch (kind) {
	        case "email":
	          return "Conteúdo do email";
	        case "phonecall":
	          return "Conteúdo do roteiro de ligação";
	        case "linkedin":
	          return "Conteúdo do Inmail";
	        case "social":
	          return "Conteúdo da mensagem em rede social";
	        default:
	          return "Conteúdo do email";
	      }
	    },
	    removeEmail: function removeEmail(index) {
	      return this.cc_emails.splice(index, 1);
	    },
	    updateContact: function updateContact(contact) {
	      this.task.contact = contact;
	      this.updateSummernoteCode();
	    },
	    removeContact: function removeContact() {
	      this.removed_contact = this.task.contact;
	      this.task.contact = null;
	      this.updateSummernoteCode(this.removed_contact);
	    },
	    toggleTemplateAutocomplete: function toggleTemplateAutocomplete() {
	      this.show_template_autocomplete = !this.show_template_autocomplete;
	      if (this.show_template_autocomplete) {
	        jQuery('#' + this.compose_id + ' .panel-heading.note-toolbar').hide();
	      }
	      return this.initTooltip();
	    },
	    hideTemplateAutocomplete: function hideTemplateAutocomplete() {
	      return this.show_template_autocomplete = false;
	    },
	    updateTemplate: function updateTemplate(template) {
	      this.selected_template = template;
	      if (this.task_has_contact) {
	        this.subject = this.variablesValues(template.subject, false);
	      } else {
	        this.subject = template.subject;
	      }
	      this.setSummernoteCode();
	    },
	    toggleCc: function toggleCc() {
	      this.show_cc = !this.show_cc;
	      this.cc_emails = [];
	      return this.cc_text = '';
	    },
	    saveSummernoteRange: function saveSummernoteRange() {
	      return this.$body.summernote('editor.saveRange');
	    },
	    addVariableToSubject: function addVariableToSubject(data) {
	      var value = data.variable.placeholder;
	      if (this.task_has_contact) {
	        value = this.task.contact[data.variable.target_method];
	      }
	      return this.subject = [this.subject.slice(0, this.lastSubjectCursorPosition), value, this.subject.slice(this.lastSubjectCursorPosition)].join('');
	    },
	    updateLastSubjectCursorPosition: function updateLastSubjectCursorPosition(evt) {
	      return this.lastSubjectCursorPosition = evt.target.selectionStart;
	    },
	    addVariableToBody: function addVariableToBody(data) {
	      this.$body.summernote('editor.restoreRange');
	      this.$body.summernote('editor.focus');
	      if (this.task_has_contact && this.task.contact[data.variable.target_method]) {
	        this.$body.summernote('pasteHTML', '<span class="' + data.variable.placeholder_name + '">' + this.task.contact[data.variable.target_method] + '</span>');
	      } else {
	        this.$body.summernote('insertText', data.variable.placeholder);
	      }
	    },
	    loadVariables: function loadVariables() {
	      params = { company_id: Session.current_company.id };
	      return new VariableResource().index(this.loadVariablesSuccess, null, { params: params });
	    },
	    loadVariablesSuccess: function loadVariablesSuccess(resource) {
	      this.variables = resource.variables;
	      this.setSummernoteCode();
	    },
	    handleSchedueEmailEvent: function handleSchedueEmailEvent(due_on) {
	      this.due_on_scheduler = due_on;
	      this.submit(false, true);
	    },
	    setMeetingReminderDate: function setMeetingReminderDate(reminder_date) {
	      this.due_on_scheduler = reminder_date;
	    },
	    submit: function submit(send_email, schedule) {
	      var _this = this;
	
	      if (send_email == null) {
	        send_email = false;
	      }
	      if (schedule == null) {
	        schedule = false;
	      }
	      this.send_email = send_email;
	      this.schedule = schedule;
	      if (this.loading) {
	        return;
	      }
	      this.blurCc();
	      if (this.task.contact != null && this.task.contact.id) {
	        this.setTemplate();
	        return this.$validator.validateAll(this.selected_template).then(function (success) {
	
	          if (Session.current_user.isNylas()) {
	            if (Session.current_user.nylas_setting.quota_exceeded != null && !_this.remove_quota_exceeded && _this.send_email) {
	              return _this.quotaExceeded();
	            }
	          }
	
	          return _this.validateVariables(send_email, schedule);
	        });
	      } else {
	        return alertify.error("Por favor, selecione o contato.");
	      }
	    },
	    chooseFiles: function chooseFiles() {
	      this.$refs.fileUpload.click();
	    },
	    selectAttachment: function selectAttachment() {
	      var file = event.target.files[0];
	      this.files.push(file);
	      this.error_file = false;
	      if (file.size > 20971520) {
	        this.error_file = true;
	        return alertify.error("ERRO. O anexo deve possuir no máximo 20 MB.");
	      }
	
	      this.uploading = true;
	      file.uploading = true;
	      file.progress = 0;
	      var formData = new FormData();
	      formData.append('file', file);
	      jQuery.ajax({
	        url: ("https://api.nylas.com") + '/files',
	        data: formData,
	        type: 'POST',
	        contentType: false,
	        processData: false,
	        headers: {
	          'authorization': 'Basic ' + btoa(Session.current_user.nylas_setting.access_token + ':')
	        },
	        success: this.uploadDone,
	        error: this.uploadError
	      });
	    },
	    uploadDone: function uploadDone(data) {
	      this.file_ids = this.file_ids.concat(data.map(function (element) {
	        return element.id;
	      }));
	      var file = this.files.find(function (file) {
	        return file.name == data[0].filename;
	      });
	      file.uploading = false;
	      file.progress = 100;
	      this.error_file = false;
	      this.$refs.fileUpload.value = '';
	      this.$forceUpdate();
	    },
	    uploadError: function uploadError(error) {
	      this.file_ids = [];
	      this.files = [];
	      this.error_file = true;
	    },
	    removeFile: function removeFile(index) {
	      this.file_ids.splice(index, 1);
	      this.files.splice(index, 1);
	      this.$refs.fileUpload.value = '';
	    },
	    validateVariables: function validateVariables(send_email, schedule) {
	      this.loading = true;
	      var templates_resource = new TemplatesResource(Session.current_company.id);
	      return templates_resource.validate(this.emitValidationSuccess(send_email, schedule), this.handleApiErrors, this.selected_template);
	    },
	    emitValidationSuccess: function emitValidationSuccess(send_email, schedule) {
	      var event = { originalEventName: 'validation-success' };
	      return this.saveTemplateAndSendEmail(send_email, schedule);
	    },
	    close: function close() {
	      return this.$emit('compose-close');
	    },
	    minimize: function minimize() {
	      return this.minimized = !this.minimized;
	    },
	    toggleToolbar: function toggleToolbar() {
	      return jQuery('#' + this.compose_id + ' .panel-heading.note-toolbar').toggle();
	    },
	    inializeSummernote: function inializeSummernote() {
	      var self = this;
	      this.$body = jQuery('#' + this.compose_id + ' .form .body');
	      summernote(this.$body, { scroll: false });
	      jQuery('.compose').on('summernote.change', function (we, contents, $editable) {
	
	        if (self.task_has_contact) {
	
	          var body = self.$body.summernote('code');
	          body = self.variablesPlaceholder(body, self.task.contact);
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(self.variables), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var variable = _step.value;
	
	              if (body.indexOf('<span class="' + variable.placeholder_name) > -1) {
	                var remove_var = body.indexOf('<span class="' + variable.placeholder_name + '">' + self.task.contact[variable.target_method]) == -1;
	                if (remove_var) {
	                  var parts = body.split('<span class="' + variable.placeholder_name);
	
	                  while (parts[1].indexOf('</span>') != 0) {
	                    parts[1] = parts[1].substr(1);
	                  }
	
	                  parts[1] = parts[1].substr(7);
	
	                  body = self.variablesValues(parts[0] + parts[1]);
	                  self.$body.summernote('code', body);
	                  return;
	                } else {
	                  var _parts = body.split('<span class="' + variable.placeholder_name + '">' + self.task.contact[variable.target_method]);
	                  var extra_content = '';
	
	                  while (_parts[1].indexOf('</span>') != 0) {
	                    extra_content = extra_content + "" + _parts[1];
	                    _parts[1] = _parts[1].substr(1);
	                  }
	
	                  _parts[1] = _parts[1].substr(7);
	
	                  var tmp = '';
	                  extra_content = extra_content.split('</span>')[0];
	                  tmp = '<span class="' + variable.placeholder_name + '">' + self.task.contact[variable.target_method] + '</span>' + extra_content;
	
	                  _parts[1] = tmp + _parts[1];
	
	                  body = self.variablesValues(_parts[0] + _parts[1]);
	                  self.$body.summernote('code', body);
	                  return;
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	      });
	    },
	    setTemplate: function setTemplate() {
	      if (!this.task.service === 'ManualTasksServices::Email') {
	        this.subject = '-';
	      }
	      if (!this.selected_template.name) {
	        this.selected_template.name = "-";
	      }
	      var body = this.$body.summernote('code');
	      if (this.task_has_contact) {
	        this.selected_template.subject = this.variablesPlaceholder(this.subject, this.task.contact, false);
	        body = this.variablesPlaceholder(body, this.task.contact);
	      } else {
	        this.selected_template.subject = this.subject;
	      }
	      this.selected_template.body = body !== '<p><br></p>' ? body : '';
	      return this.task.template = this.selected_template;
	    },
	    updateSummernoteCode: function updateSummernoteCode(contact) {
	      var body = this.$body.summernote('code');
	      if (this.task_has_contact) {
	        body = this.variablesValues(body);
	        this.subject = this.variablesValues(this.subject, false);
	      } else {
	        body = this.variablesPlaceholder(body, contact);
	        this.subject = this.variablesPlaceholder(this.subject, contact, false);
	      }
	      this.$body.summernote('code', body);
	    },
	    setSummernoteCode: function setSummernoteCode() {
	      var body = this.selected_template && this.selected_template.body ? this.selected_template.body : '';
	      if (this.task_has_contact) {
	        body = this.variablesValues(body);
	        this.subject = this.variablesValues(this.subject, false);
	      }
	      this.$body.summernote('code', body);
	    },
	    variablesValues: function variablesValues(text) {
	      var _this2 = this;
	
	      var html = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      this.variables.forEach(function (variable) {
	        if (_this2.task.contact[variable.target_method] && text) {
	          if (html) {
	            text = text.split(variable.placeholder).join('<span class="' + variable.placeholder_name + '">' + _this2.removeSpecialCharacter(_this2.task.contact[variable.target_method]) + '</span>');
	          } else {
	            text = text.split(variable.placeholder).join(_this2.task.contact[variable.target_method]);
	          }
	        }
	      });
	      return text;
	    },
	    variablesPlaceholder: function variablesPlaceholder(text, contact) {
	      var _this3 = this;
	
	      var html = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	      this.variables.forEach(function (variable) {
	        if (text && contact[variable.target_method]) {
	          if (html) {
	            text = text.split('<span class="' + variable.placeholder_name + '">' + _this3.removeSpecialCharacter(contact[variable.target_method]) + '</span>').join(variable.placeholder);
	          } else {
	            text = text.split(contact[variable.target_method]).join(variable.placeholder);
	          }
	        }
	      });
	      return text;
	    },
	    removeSpecialCharacter: function removeSpecialCharacter(text) {
	      var result = text.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
	      return result;
	    },
	    initTooltip: function initTooltip() {
	      if (this.selected_template.name) {
	        jQuery('[data-toggle="tooltip"]').tooltip('destroy');
	      }
	      return jQuery('[data-toggle="tooltip"]').tooltip();
	    },
	    blurCc: function blurCc() {
	      var last_index = this.cc_text.length - 1;
	      if (this.cc_text[last_index] === ',' || this.cc_text[last_index] === '' || this.cc_text[last_index] === ' ') {
	        return;
	      }
	      return this.cc_text += " ";
	    },
	    setParams: function setParams(send_email, schedule) {
	      if (send_email == null) {
	        send_email = false;
	      }
	      var shared_params = {
	        subject: this.selected_template.subject,
	        body: this.selected_template.body,
	        kind: this.selected_template.kind,
	        file_ids: this.file_ids,
	        send_email: send_email,
	        remove_quota_exceeded: this.remove_quota_exceeded
	      };
	
	      if (this.cc_emails.length > 0) {
	        shared_params.cc = this.cc_emails;
	      }
	
	      var params = {
	        id: this.task.id,
	        task_id: this.task.id,
	        signature: this.selected_template.signature
	      };
	
	      if (this.task != null && (this.task.isCreatedByUser() || this.task.isOzzyTask())) {
	        params = {
	          task_id: this.task.id,
	          template_id: this.selected_template.id
	        };
	      }
	
	      if (this.task.id === null) {
	        this.task.slug = 'email-task';
	        params = {
	          contact_id: this.task.contact.id,
	          template_id: this.selected_template.id
	        };
	      }
	
	      if (schedule) {
	        params['due_on'] = this.due_on_scheduler;
	      }
	
	      return (0, _assign2.default)({}, params, shared_params);
	    },
	    scheduleEmailSend: function scheduleEmailSend(params) {
	      this.loading = true;
	      this.tasks_resources.schedule(this.scheduleEmailSendSuccess, this.scheduleEmailSendFailure, params);
	    },
	    scheduleEmailSendSuccess: function scheduleEmailSendSuccess(data) {
	      this.loading = false;
	      alertify.success("Tarefa de envio de email agendada com sucesso.");
	      if (data.task.isDueToday()) {
	        EventsBus.$emit('Task::UpdatedMetadata', data.task);
	      } else {
	        EventsBus.$emit('Task::remove', data.task);
	      }
	      this.updateMetadata(data.task);
	      this.closeScheduler();
	      this.close();
	    },
	    scheduleEmailSendFailure: function scheduleEmailSendFailure() {
	      this.loading = false;
	      alertify.error("Ops, ocorreu algum erro ao agendar o envio do email.");
	    },
	    saveTemplateAndSendEmail: function saveTemplateAndSendEmail(send_email, schedule) {
	      var params = this.setParams(send_email, schedule);
	      var success_callback = send_email ? this.sendEmailSuccess : this.saveTemplateSuccess;
	      if (schedule) {
	        return this.scheduleEmailSend(params);
	      }
	      if (this.task == null || this.task.id === null || this.task.isCreatedByUser() || this.task.isOzzyTask()) {
	        return this.tasks_resources.only_send_email(success_callback, this.sendEmailFailure, params);
	      } else {
	        return this.tasks_resources.save_template_and_send_email(success_callback, this.sendEmailFailure, params);
	      }
	    },
	    sendEmailFailure: function sendEmailFailure(data) {
	      this.loading = false;
	      this.unknownError();
	    },
	    sendEmailSuccess: function sendEmailSuccess(data) {
	      this.loading = false;
	      alertify.success('E-mail disparado com sucesso');
	      this.task.markAsDone();
	      if (this.task.id) {
	        EventsBus.$emit('Task::Done', this.task);
	      }
	      return this.close();
	    },
	    saveTemplateSuccess: function saveTemplateSuccess(response) {
	      this.loading = false;
	      alertify.success('Template salvo com sucesso');
	      EventsBus.$emit('Task::Undone', response.task);
	      return this.close();
	    },
	    hideCompose: function hideCompose() {
	      this.setTemplate();
	      return this.$emit('compose-hide', this.task);
	    },
	    isUploading: function isUploading() {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.files), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var file = _step2.value;
	
	          if (file.uploading) return true;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      return false;
	    },
	    quotaExceeded: function quotaExceeded() {
	      EventsBus.$emit('quota-exceeded-modal');
	    },
	    removeQuotaExceeded: function removeQuotaExceeded() {
	      this.remove_quota_exceeded = true;
	      this.submit(this.send_email, this.schedule);
	    },
	    toWhatsapp: function toWhatsapp() {
	      if (!this.task_has_contact || !this.task.contact.cellphone) return '';
	      var cellphone = this.task.contact.cellphone;
	      cellphone = '55' + cellphone.replace(/[^0-9+]+/ig, "");
	      var contents = this.$body.summernote('code');
	      var body = contents.replace(/<\/p>/gi, "\n").replace(/<br\/?>/gi, "\n").replace(/<\/?[^>]+(>|$)/g, "").replace(/&nbsp;/gi, ' ').replace(/%26nbsp%3B/gi, ' ');
	      body = encodeURIComponent(body).replace(/&nbsp;/gi, ' ').replace(/%26nbsp%3B/gi, ' ');
	      var url = 'https://web.whatsapp.com/send?phone=' + cellphone + '&text=' + body;
	      window.open(url, '_blank');
	    },
	    toLinkedin: function toLinkedin() {
	      this.copy();
	      var absolute_url = 'https://www.linkedin.com/';
	      if (this.task.contact.linkedin) {
	        var url = this.task.contact.linkedin;
	        var reg = /^((http|https|ftp):\/\/)/;
	        if (!reg.test(url)) {
	          absolute_url = "http://" + url;
	        } else {
	          absolute_url = url;
	        }
	      }
	      window.open(absolute_url, '_blank');
	    }
	  },
	
	  watch: {
	    cc_text: function cc_text(text) {
	      var last_index = text.length - 1;
	      if (text[last_index] === ',' || text[last_index] === '' || text[last_index] === ' ') {
	        var email = text.substring(0, last_index);
	        if (this.validateEmail(email)) {
	          this.cc_emails.push({ email: email });
	          return this.cc_text = '';
	        }
	      }
	    },
	    uploading: function uploading() {
	      var _this4 = this;
	
	      if (this.uploading) {
	        this.progress = 0;
	        var self = this;
	
	        var _loop = function _loop(i) {
	          _this4.progress_bar.push(setTimeout(function () {
	            self.progress = i;
	          }, i * 200));
	        };
	
	        for (var i = 0; i < 90; i++) {
	          _loop(i);
	        }
	      }
	    }
	  },
	
	  computed: {
	    contact_has_cellphone: function contact_has_cellphone() {
	      if (!this.task_has_contact || !this.task.contact.cellphone) return false;
	      return true;
	    },
	    task_has_contact: function task_has_contact() {
	      return this.task.contact != null ? this.task.contact.id : undefined;
	    },
	    scheduled_overdue: function scheduled_overdue() {
	      if (this.task.id) {
	        return this.task.isOverdue() && this.task.isScheduled();
	      } else {
	        return false;
	      }
	    },
	    allow_change_template: function allow_change_template() {
	      return this.show_template_autocomplete;
	    },
	    template_name: function template_name() {
	      return this.selected_template != null ? this.selected_template.name : undefined;
	    },
	    compose_id: function compose_id() {
	      return 'compose-' + this.id;
	    },
	    subject_group_class: function subject_group_class() {
	      if (this.errors.has('subject')) {
	        return 'has-error';
	      } else if (this.subject) {
	        if (this.subject.length > 60) {
	          return 'has-danger';
	        } else if (this.subject.length > 40) {
	          return 'has-warning';
	        }
	      }
	    },
	    subject_help_text: function subject_help_text() {
	      if (this.errors.has('subject')) {
	        return this.errors.first('subject');
	      } else if (this.subject) {
	        if (this.subject.length > 60) {
	          return 'Assuntos acima de 60 caracteres não aparecerão completos para os seus leads';
	        } else if (this.subject.length > 40) {
	          return 'Assuntos acima de 40 caracteres podem ser cortados';
	        }
	      }
	    },
	    compose_header: function compose_header() {
	      if (this.is_meeting_schedule) {
	        return 'Agendar e-mail de lembrete de reunião';
	      }
	
	      if (this.task.contact != null ? this.task.contact.id : undefined) {
	        return (this.task.contact != null ? this.task.contact.full_name : undefined) + ' - ' + __guard__(this.task.contact != null ? this.task.contact.business : undefined, function (x) {
	          return x.name;
	        });
	      } else {
	        return 'Novo E-mail';
	      }
	    },
	    is_meeting_schedule: function is_meeting_schedule() {
	      if (event) {
	        return event.originalEventName == 'Compose::Open::Schedule::Meeting';
	      }
	    }
	  },
	
	  mounted: function mounted() {
	    this.inializeSummernote();
	    this.setSummernoteCode();
	    if (this.selected_template.name) {
	      this.initTooltip();
	    }
	
	    if (this.is_meeting_schedule) {
	      this.openScheduler();
	      this.toggleCc();
	    }
	    return this.errors.clear();
	  },
	  created: function created() {
	    this.tasks_resources = new TasksResource();
	    this.selected_template = this.template;
	    this.subject = this.selected_template.subject;
	    if (this.selected_template.cc) if (this.selected_template.cc.length > 0) {
	      this.cc_emails = this.selected_template.cc.map(function (item) {
	        return { email: item };
	      });
	      this.show_cc = true;
	    }
	    EventsBus.$on('send-email-quota-exceeded', this.removeQuotaExceeded);
	    return this.loadVariables();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.$body.summernote('destroy');
	    EventsBus.$off('send-email-quota-exceeded', this.removeQuotaExceeded);
	    return this.hideCompose();
	  },
	  updated: function updated() {
	    return this.initTooltip();
	  }
	};
	
	exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters);
	function __guard__(value, transform) {
	  return typeof value !== 'undefined' && value !== null ? transform(value) : undefined;
	}

/***/ }),
/* 339 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    task: {
	      default: {}
	    },
	
	    number_composes: {
	      default: 1
	    },
	
	    loading: {
	      default: false
	    },
	
	    event: {
	      default: {}
	    }
	  },
	
	  data: function data() {
	    return {
	      due_on_date: new Date(),
	      due_on_time: this.task ? this.task.due_on.format('hh:mm') : null,
	      due_on_scheduler: this.task ? this.task.due_on : moment()
	    };
	  },
	
	
	  methods: {
	    selectDefaultTime: function selectDefaultTime(time) {
	      this.due_on_time = time;
	    },
	    isSelected: function isSelected(time) {
	      return this.due_on_time == time;
	    },
	    closeScheduler: function closeScheduler() {
	      this.$emit('close-scheduler');
	    },
	    setDueOn: function setDueOn() {
	      if (this.due_on_time) {
	        var parts = this.due_on_time.split(':');
	        this.due_on_scheduler = moment(this.due_on_date).hours(parts[0]).minutes(parts[1]);
	
	        if (this.is_meeting_schedule) {
	          this.$emit('schedule-meeting-date', this.due_on_scheduler);
	        }
	      }
	    },
	    submit: function submit() {
	      var _this = this;
	
	      if (this.loading) {
	        return false;
	      }
	      this.$validator.validateAll().then(function (success) {
	        if (success) {
	          return _this.scheduleEmailSend();
	        }
	      });
	    },
	    scheduleEmailSend: function scheduleEmailSend() {
	      this.$emit('schedule-email-send', this.due_on_scheduler);
	    }
	  },
	
	  computed: {
	    yesterday: function yesterday() {
	      var date = new Date();
	      date.setDate(date.getDate() - 1);
	      return date;
	    },
	    from_dates: function from_dates() {
	      var date = new Date();
	      if (this.is_meeting_schedule) {
	        date = this.task.due_on.clone().toDate();
	      } else {
	        date.setDate(date.getDate() + 730);
	      }
	
	      return date;
	    },
	    scheduler_header: function scheduler_header() {
	      if (this.is_meeting_schedule) {
	        return 'Agendar e-mail de lembrete de reunião';
	      }
	
	      return 'Agendar envio de E-mail';
	    },
	    is_meeting_schedule: function is_meeting_schedule() {
	      return event.originalEventName == 'Compose::Open::Schedule::Meeting';
	    }
	  },
	
	  watch: {
	    due_on_date: function due_on_date() {
	      this.setDueOn();
	    },
	    due_on_time: function due_on_time() {
	      this.setDueOn();
	    }
	  },
	
	  mounted: function mounted() {
	    var due_on = this.due_on_scheduler.clone();
	    if (this.is_meeting_schedule) {
	      due_on = due_on.subtract(1, 'd');
	    }
	
	    if (due_on.toDate() < new Date()) {
	      this.due_on_date = new Date();
	    } else {
	      this.due_on_date = due_on.toDate();
	    }
	
	    if (!this.task.undefined_time) {
	      this.due_on_time = due_on.format('HH:mm');
	    }
	  },
	  created: function created() {
	    this.tasks_resources = new TasksResource();
	    this.default_times = ['08:00', '09:30', '11:00', '13:30', '14:00', '17:30'];
	  }
	};

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    multiple_groups: { default: false },
	    groups: { default: null },
	    remaining: { default: null }
	  },
	  components: {
	    tagFilter: __webpack_require__(69),
	    tags: __webpack_require__(9),
	    flows: __webpack_require__(8),
	    groups: __webpack_require__(67)
	  },
	  mixins: [__webpack_require__(6)],
	  data: function data() {
	    return {
	      sent_to_flow: false,
	      add_to_group: false,
	      selected_user: Session.current_user.id,
	      selected_user_option: null,
	      selected_tags: [],
	      selected_flow: null,
	      selected_group: null,
	      current_user_role: Session.current_user.role,
	      current_user_id: Session.current_user.id,
	      account_setting: Session.current_company.account_setting,
	      check: false
	    };
	  },
	
	  computed: {
	    filtered_user_options: function filtered_user_options() {
	      var filtered_user_options = this.users_options;
	      filtered_user_options.shift();
	      return filtered_user_options;
	    },
	    show_user_options: function show_user_options() {
	      return this.current_user_role == 'manager' || this.current_user_role == 'admin';
	    }
	  },
	  methods: {
	    getGroupText: function getGroupText(group_params) {
	      var group = group_params.group;
	      var user_name = this.users_options.find(function (obj) {
	        if (obj.value !== null) {
	          return obj.value.user_id_eq == group.user_id;
	        }
	      }).text;
	
	      if (this.current_user_role == "manager" && group.id !== null) {
	        return '<label>\n                  <strong> Inserir ' + group_params.contacts_count + ' contatos </strong>\n                  <span> no grupo </span>\n                  <strong>' + group.name + '</strong>\n                  <span> do usu\xE1rio ' + user_name + '</strong>\n                </label>';
	      } else if (this.current_user_role !== "manager" && group.id !== null && group.user_id == this.current_user_id) {
	        return '<label>\n                  <strong> Inserir ' + group_params.contacts_count + ' contatos </strong>\n                  <span> no seu grupo </span>\n                  <strong>' + group.name + '</strong>\n                </label>';
	      } else if (this.current_user_role !== "manager" && group.id !== null && group.user_id != this.current_user_id) {
	        return '<span class="group_problem_error">\n                  <strong> Voc\xEA n\xE3o pode adicionar contatos </strong>\n                  <span> no grupo </span>\n                  <strong>' + group.name + '</strong>\n                  <span> do usu\xE1rio ' + user_name + '</strong>\n                </span>';
	      } else if (group.action == 'updated' && group.id == null) {
	        return '<label>\n                  <strong> Inserir ' + group_params.contacts_count + ' contatos </strong>\n                  <span> no gropo </span>\n                  <strong>' + group.name + '</strong>\n                </label>';
	      } else {
	        return '<label>\n                  <strong> Criar grupo ' + group.name + '</strong>\n                  <span> com </span>\n                  <strong>' + group_params.contacts_count + ' contatos </strong>\n                </label>';
	      }
	    },
	    getShowCheckboxGroupConditions: function getShowCheckboxGroupConditions(group_params) {
	      var group = group_params.group;
	      return group.id == null || this.current_user_role == 'manager' || group.user_id == this.current_user_id;
	    },
	    toogleCheck: function toogleCheck(index) {
	      if (this.getShowCheckboxGroupConditions(this.groups[index])) {
	        this.groups[index]["selected"] = !this.groups[index]["selected"];
	        if (!this.groups[index]["selected"]) {
	          this.$emit('remainingContacts', this.remaining + this.groups[index]["contacts_count"]);
	        } else {
	          this.$emit('remainingContacts', this.remaining - this.groups[index]["contacts_count"]);
	        }
	      }
	    },
	    updateTags: function updateTags(data) {
	      this.selected_tags = data.selected_items;
	      var payload = {
	        type: 'contact_tags',
	        value: this.selected_tags.map(function (tag) {
	          return tag.id;
	        })
	      };
	      this.$emit('tagsUpdated', this.selected_tags.map(function (tag) {
	        return { tag_id: tag.id };
	      }));
	    },
	    removeTag: function removeTag(data) {
	      this.selected_tags.remove(data);
	    },
	    updateUserId: function updateUserId(data) {
	      if (data) {
	        this.selected_user = data.user_id_eq;
	        var payload = {
	          type: 'user_id',
	          value: Number(data.user_id_eq)
	        };
	      }
	      this.$emit('userUpdated', this.selected_user_option.user_id_eq);
	    },
	    switchSendToFlow: function switchSendToFlow() {
	      this.sent_to_flow = !this.sent_to_flow;
	      if (!this.sent_to_flow) {
	        this.selected_flow = null;
	        var payload = {
	          type: 'flow_data',
	          value: null,
	          switch: false
	        };
	      }
	      this.$emit('flowSwitch', this.sent_to_flow);
	    },
	    switchAddToGroup: function switchAddToGroup() {
	      this.add_to_group = !this.add_to_group;
	      if (!this.add_to_group) {
	        this.selected_group = null;
	        var payload = {
	          type: 'group_data',
	          value: null,
	          switch: false
	        };
	      }
	      this.$emit('groupSwitch', this.add_to_group);
	    },
	    selectFlow: function selectFlow(flow) {
	      this.selected_flow = flow;
	      var payload = {
	        type: 'flow_data',
	        value: Number(this.selected_flow.id),
	        switch: this.sent_to_flow
	      };
	      this.$emit('fillFlow', Number(this.selected_flow.id));
	    },
	    selectGroup: function selectGroup(group) {
	      this.selected_group = group;
	      var payload = {
	        type: 'group_data',
	        value: Number(this.selected_group.id),
	        switch: this.add_to_group
	      };
	      this.$emit('fillGroup', Number(this.selected_group.id));
	    }
	  },
	  mounted: function mounted() {
	    this.updateUserId(this.selected_user_option);
	  },
	  created: function created() {
	    this.sent_to_flow = false;
	    this.add_to_group = false;
	    this.selected_user_option = this.users_options.find(function (option) {
	      return option.value && parseInt(option.value.user_id_eq) == Session.current_user.id;
	    }).value;
	  }
	};

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _keys = __webpack_require__(354);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var helpers = __webpack_require__(2);
	
	var view_model = {
	  props: ['contact', 'temp_attr'],
	  components: {
	    flows: __webpack_require__(8)
	  },
	  data: function data() {
	    return {
	      lost_reason_id: null,
	      lost_reason_comment: '',
	      checkBlocklist: false,
	      showCheckStatus: false,
	      listLostReason: [],
	      send_to_new_flow: false,
	      reactivation_period: 0,
	      due_on_date_custom: new Date(),
	      due_on_date: '',
	      reactivation_period_options: [{ label: 'Imediatamente', days: 0 }, { label: 'Amanhã', days: 1 }, { label: 'Em 3 dias', days: 3 }, { label: 'Em 1 semana', days: 7 }, { label: 'Em 2 semana', days: 14 }, { label: 'Em 1 mês', days: 30 }, { label: 'Em 3 meses', days: 90 }, { label: 'Em 6 meses', days: 180 }],
	      flow: null,
	      flow_resource: null,
	      immediately: true,
	      due_on_time: '00:01',
	      selected_user: Session.current_user.id,
	      new_stage: null,
	      comment: null,
	      tried_to_save: false
	    };
	  },
	
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.tried_to_save = true;
	      this.$validator.validateAll().then(function (success) {
	        if (!_this.flow && _this.send_to_new_flow) {
	          return;
	        }
	        if (success) {
	          var params = {};
	
	          if (_this.send_to_new_flow) {
	            params['send_to_new_flow'] = _this.send_to_new_flow;
	            params['reactivation_period'] = _this.reactivation_period;
	            params['flow'] = _this.flow;
	            params['due_on_date_custom'] = moment(_this.due_on_date_custom).format('YYYY-MM-DD') + 'T' + _this.due_on_time;
	            params['immediately'] = _this.immediately;
	          }
	
	          if (_this.lost_reason_id) {
	            params['id'] = _this.lost_reason_id;
	            params['comment'] = _this.lost_reason_comment;
	          }
	
	          if (_this.status == 'connected') {
	            if (_this.new_stage && _this.new_stage != _this.contact.stage) params.stage = _this.new_stage;
	            if (_this.comment) params['comment'] = _this.comment;
	          } else if (_this.new_stage) {
	            params.schedule_set_contact_stage = _this.new_stage;
	          }
	
	          if (_this.temp_attr.new_status) {
	            params['status'] = _this.temp_attr.new_status;
	          }
	
	          if (_this.status == 'blocklisted') {
	            params['stage'] = 'lost';
	            params['status'] = _this.status;
	          }
	
	          if (_this.checkBlocklist) params['status'] = 'blocklisted';
	
	          _this.$emit('update-contact-recipient', params);
	        }
	      });
	    },
	    lostReasonOptions: function lostReasonOptions() {
	      var _this2 = this;
	
	      var result = [];
	      result.push({ value: null, text: 'Selecione um motivo de perda' });
	      if (this.$store.getters.lostReasonsCount == 0) {
	        this.$store.dispatch('fetchLostReasons');
	      }
	      var list = this.$store.getters.lostReasonsList;
	      var index;
	      list.forEach(function (item) {
	        if (_this2.status == 'connected' || _this2.contact.recipient_status == 'connected') {
	          if (item.title != 'Sem Conexão') result.push({ value: item.id, text: item.title });
	        } else {
	          result.push({ value: item.id, text: item.title });
	        }
	      });
	      return result;
	    },
	    toggleType: function toggleType() {
	      if (this.checkBlocklist === false) {
	        this.send_to_new_flow = !this.send_to_new_flow;
	      }
	    },
	    setReactivationPeriod: function setReactivationPeriod(days) {
	      this.reactivation_period = days;
	      this.due_on_date_custom = moment().add(days, 'days').toDate();
	    },
	    selectFlow: function selectFlow(flow) {
	      this.flow = flow.id;
	    },
	    formatDueOnDate: function formatDueOnDate(date) {
	      this.due_on_date = moment(date).format('DD/MM/YYYY');
	      var today = moment({ hours: 0 });
	      this.reactivation_period = moment(date).diff(today, 'days');
	    },
	    checkImmediately: function checkImmediately() {
	      if (moment(this.due_on_date_custom).diff(moment().startOf('day'), 'days') == 0) {
	        this.immediately = true;
	      } else this.immediately = false;
	    }
	  },
	  created: function created() {
	    this.formatDueOnDate(new Date());
	    this.selected_user = this.contact.user.id;
	    if (['send_to_new_flow', 'lost'].indexOf(this.temp_attr.event) > -1) {
	      this.send_to_new_flow = true;
	    }
	    if (this.temp_attr.status == 'blocklisted') {
	      this.lost_reason_id = this.lostReasonOptions().find(function (lost_reason) {
	        return lost_reason.text == 'Blocklist';
	      }).value;
	    }
	    this.new_stage = this.contact.stage;
	  },
	
	  computed: {
	    yesterday: function yesterday() {
	      var date = new Date();
	      date.setDate(date.getDate() - 1);
	      return date;
	    },
	    status: function status() {
	      if (!this.temp_attr) return false;
	      if (!this.temp_attr.status) return false;
	      return this.temp_attr.status;
	    },
	    flow_immediately: function flow_immediately() {
	      return "Enviar para novo fluxo " + (this.immediately ? "imediatamente" : "agendado");
	    },
	    next_valid_stages: function next_valid_stages() {
	      var _this3 = this;
	
	      if (!this.contact) return [];
	      var options = (0, _keys2.default)(this.contact.getNextValidStages(['smart_lead'])).map(function (stage) {
	        return { value: stage, text: _this3.contact.next_valid_stages[stage].human_name };
	      });
	      options.push({ value: this.contact.stage, text: this.contact.human_stage });
	      return options;
	    },
	    disable_lost_reason_selection: function disable_lost_reason_selection() {
	      return this.status == 'blocklisted';
	    }
	  },
	  watch: {
	    due_on_date_custom: function due_on_date_custom() {
	      this.formatDueOnDate(this.due_on_date_custom);
	      this.checkImmediately();
	    },
	    due_on_date: function due_on_date() {
	      if (this.due_on_date.length == 10) {
	        var date = new Date();
	        date.setDate(date.getDate() - 1);
	        if (moment(this.due_on_date, 'DD/MM/YYYY').toDate() < date) return alertify.error('A data de ativação deve ser maior que a data atual!');
	        this.due_on_date_custom = moment(this.due_on_date, 'DD/MM/YYYY').toDate();
	      }
	    },
	    lost_reason_id: function lost_reason_id() {
	      var _this4 = this;
	
	      this.listLostReason = this.lostReasonOptions();
	      var reason = this.listLostReason.find(function (reason) {
	        return reason.value === _this4.lost_reason_id;
	      }).text;
	      if (reason === 'Blocklist') {
	        this.checkBlocklist = true;
	        this.showCheckStatus = false;
	        this.send_to_new_flow = false;
	      } else {
	        this.checkBlocklist = false;
	        this.showCheckStatus = true;
	      }
	    },
	    checkBlocklist: function checkBlocklist() {
	      if (this.checkBlocklist === true) {
	        this.send_to_new_flow = false;
	      }
	    }
	  }
	};
	
	exports.default = helpers.vue_include(view_model);

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var helpers = __webpack_require__(2);
	
	var view_model = {
	  props: ["task"],
	  components: {
	    flows: __webpack_require__(8)
	  },
	  data: function data() {
	    return {
	      lost_reason_id: null,
	      comment: "",
	      send_to_new_flow: false,
	      reactivation_period: 0,
	      due_on_date_custom: new Date(),
	      due_on_date: "",
	      reactivation_period_options: [{ label: "Imediatamente", days: 0 }, { label: "Amanhã", days: 1 }, { label: "Em 3 dias", days: 3 }, { label: "Em 1 semana", days: 7 }, { label: "Em 2 semana", days: 14 }, { label: "Em 1 mês", days: 30 }, { label: "Em 3 meses", days: 90 }, { label: "Em 6 meses", days: 180 }],
	      statuses: [{ value: "connect", label: "Conectado" }, { value: "lost", label: "Perdido" }, { value: "no-show", label: "No Show" }],
	      status: 'connect',
	      flow: null,
	      flow_resource: null,
	      immediately: true,
	      due_on_time: "00:01",
	      selected_user: Session.current_user.id,
	      new_meeting: false,
	      default_flow: Session.current_user.flow.id ? Session.current_user.flow : null
	    };
	  },
	
	
	  methods: {
	    submit: function submit() {
	      var _this = this;
	
	      this.$validator.validateAll().then(function (success) {
	        if (!_this.flow && _this.send_to_new_flow) {
	          return;
	        }
	        _this.task.markAsDone();
	        if (success) {
	          var params = {
	            id: _this.task.id,
	            lost_reason_id: _this.lost_reason_id,
	            lost_reason_comment: _this.comment,
	            send_to_new_flow: _this.send_to_new_flow,
	            flow: _this.flow,
	            due_on_date_custom: moment(_this.due_on_date_custom).format('YYYY-MM-DD') + 'T' + _this.due_on_time,
	            immediately: _this.immediately,
	            status: _this.status,
	            done_at: _this.task.done_at
	          };
	
	          new TasksResource().update(_this.updateSuccess, _this.updateError, params);
	
	          if (_this.new_meeting) {
	            EventsBus.$emit('TaskModalForm::Show', { task_id: null, contact: _this.task.contact, id: 'manual-task-form-modal' });
	          }
	
	          _this.$emit("close-meeting-modal");
	        }
	      });
	    },
	    updateSuccess: function updateSuccess(response) {
	      Loader.off();
	      alertify.success('Tarefa atualizada com sucesso');
	      response.task.assigned_to = this.task.assigned_to;
	      this.$emit('task-updated', response.task);
	    },
	    updateError: function updateError(response) {
	      Loader.off();
	      alertify.error("Ops, algo deu errado!");
	    },
	    lostReasonOptions: function lostReasonOptions() {
	      var result = [];
	      result.push({ value: null, text: "Selecione um motivo de perda" });
	      if (this.$store.getters.lostReasonsCount == 0) {
	        this.$store.dispatch("fetchLostReasons");
	      }
	      var list = this.$store.getters.lostReasonsList;
	      var index;
	      for (index = 0; index < this.$store.getters.lostReasonsCount; index++) {
	        result.push({ value: list[index].id, text: list[index].title });
	      }
	      return result;
	    },
	    toggleType: function toggleType() {
	      this.send_to_new_flow = !this.send_to_new_flow;
	    },
	    toggleNewMeeting: function toggleNewMeeting() {
	      this.new_meeting = !this.new_meeting;
	    },
	    setReactivationPeriod: function setReactivationPeriod(days) {
	      this.reactivation_period = days;
	      days == 0 ? this.immediately = true : this.immediately = false;
	      this.due_on_date_custom = moment().add(days, "days").toDate();
	    },
	    selectFlow: function selectFlow(flow) {
	      this.flow = flow.id;
	    },
	    formatDueOnDate: function formatDueOnDate(date) {
	      this.due_on_date = moment(date).format("DD/MM/YYYY");
	      var today = moment({ hours: 0 });
	      this.reactivation_period = moment(date).diff(today, "days");
	      this.reactivation_period == 0 ? this.immediately = true : this.immediately = false;
	    }
	  },
	  created: function created() {
	    this.formatDueOnDate(new Date());
	    this.selected_user = this.contact.user.id;
	  },
	
	  computed: {
	    yesterday: function yesterday() {
	      var date = new Date();
	      date.setDate(date.getDate() - 1);
	      return date;
	    },
	    flow_immediately: function flow_immediately() {
	      return "Enviar para novo fluxo " + (this.immediately ? "imediatamente" : "agendado");
	    },
	    is_status_connect: function is_status_connect() {
	      return this.status === 'connect' || this.status === 'no-show';
	    },
	    is_status_lost: function is_status_lost() {
	      return this.status === 'lost';
	    },
	    lost_reason_validate: function lost_reason_validate() {
	      if (this.status === 'lost') {
	        return "'required'";
	      } else {
	        return '';
	      }
	    }
	  },
	  watch: {
	    due_on_date_custom: function due_on_date_custom() {
	      this.formatDueOnDate(this.due_on_date_custom);
	      this.immediately = false;
	    },
	    due_on_date: function due_on_date() {
	      if (this.due_on_date.length == 10) {
	        var date = new Date();
	        date.setDate(date.getDate() - 1);
	        if (moment(this.due_on_date, "DD/MM/YYYY").toDate() < date) return alertify.error("A data de ativação deve ser maior que a data atual!");
	        this.due_on_date_custom = moment(this.due_on_date, "DD/MM/YYYY").toDate();
	        this.immediately = false;
	      }
	    }
	  }
	};
	
	exports.default = helpers.vue_include(view_model);

/***/ }),
/* 343 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.default = {
	  props: {
	    current_step: { default: 1 },
	    title: { default: "" },
	    upload_progress: { default: 0 },
	    validation_progress: { default: 0 },
	    creation_progress: { default: 0 },
	    steps_labels: { default: ["Busca", "Validação", "Organização", "Envio para a base"] }
	  },
	  data: function data() {
	    return {
	      status_initial: "current",
	      status_validation: "",
	      status_organization: "",
	      status_send_to_base: ""
	    };
	  },
	
	  methods: {
	    percentage: function percentage(value) {
	      if (value > 90) {
	        value = 90;
	      }
	      return value + "%";
	    }
	  },
	  watch: {
	    current_step: function current_step(val) {
	      switch (val) {
	        case 1:
	          this.status_initial = "current";
	          this.status_validation = "";
	          this.status_organization = "";
	          this.status_send_to_base = "";
	          return;
	        case 2:
	          this.status_initial = "done";
	          this.status_validation = "current";
	          this.status_organization = "";
	          this.status_send_to_base = "";
	          return;
	        case 3:
	          this.status_initial = "done";
	          this.status_validation = "done";
	          this.status_organization = "current";
	          this.status_send_to_base = "";
	          return;
	        case 4:
	          this.status_initial = "done";
	          this.status_validation = "done";
	          this.status_organization = "done";
	          this.status_send_to_base = "current";
	          return;
	        default:
	          this.status_initial = "done";
	          this.status_validation = "done";
	          this.status_organization = "done";
	          this.status_send_to_base = "done";
	      }
	    }
	  },
	  created: function created() {
	    this.steps = [1, 2, 3, 4];
	  }
	};

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _businesses = __webpack_require__(911);
	
	var _businesses2 = _interopRequireDefault(_businesses);
	
	var _companies = __webpack_require__(912);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _contacts = __webpack_require__(913);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _contacts_csv = __webpack_require__(914);
	
	var _contacts_csv2 = _interopRequireDefault(_contacts_csv);
	
	var _contacts_group = __webpack_require__(915);
	
	var _contacts_group2 = _interopRequireDefault(_contacts_group);
	
	var _error_messages = __webpack_require__(916);
	
	var _error_messages2 = _interopRequireDefault(_error_messages);
	
	var _flows = __webpack_require__(917);
	
	var _flows2 = _interopRequireDefault(_flows);
	
	var _general = __webpack_require__(918);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _groups = __webpack_require__(919);
	
	var _groups2 = _interopRequireDefault(_groups);
	
	var _integrations = __webpack_require__(920);
	
	var _integrations2 = _interopRequireDefault(_integrations);
	
	var _recipient = __webpack_require__(921);
	
	var _recipient2 = _interopRequireDefault(_recipient);
	
	var _template = __webpack_require__(922);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _users = __webpack_require__(923);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _voip = __webpack_require__(924);
	
	var _voip2 = _interopRequireDefault(_voip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    businesses: _businesses2.default,
	    companies: _companies2.default,
	    contacts: _contacts2.default,
	    contacts_csv: _contacts_csv2.default,
	    contacts_group: _contacts_group2.default,
	    error_messages: _error_messages2.default,
	    flows: _flows2.default,
	    general: _general2.default,
	    groups: _groups2.default,
	    integrations: _integrations2.default,
	    template: _template2.default,
	    recipient: _recipient2.default,
	    users: _users2.default,
	    voip: _voip2.default
	};

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _businesses = __webpack_require__(925);
	
	var _businesses2 = _interopRequireDefault(_businesses);
	
	var _companies = __webpack_require__(926);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _contacts = __webpack_require__(927);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _contacts_csv = __webpack_require__(928);
	
	var _contacts_csv2 = _interopRequireDefault(_contacts_csv);
	
	var _contacts_group = __webpack_require__(929);
	
	var _contacts_group2 = _interopRequireDefault(_contacts_group);
	
	var _error_messages = __webpack_require__(930);
	
	var _error_messages2 = _interopRequireDefault(_error_messages);
	
	var _flows = __webpack_require__(931);
	
	var _flows2 = _interopRequireDefault(_flows);
	
	var _general = __webpack_require__(932);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _groups = __webpack_require__(933);
	
	var _groups2 = _interopRequireDefault(_groups);
	
	var _integrations = __webpack_require__(934);
	
	var _integrations2 = _interopRequireDefault(_integrations);
	
	var _recipient = __webpack_require__(935);
	
	var _recipient2 = _interopRequireDefault(_recipient);
	
	var _template = __webpack_require__(936);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _users = __webpack_require__(937);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _voip = __webpack_require__(938);
	
	var _voip2 = _interopRequireDefault(_voip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    businesses: _businesses2.default,
	    companies: _companies2.default,
	    contacts: _contacts2.default,
	    contacts_csv: _contacts_csv2.default,
	    contacts_group: _contacts_group2.default,
	    error_messages: _error_messages2.default,
	    flows: _flows2.default,
	    general: _general2.default,
	    groups: _groups2.default,
	    integrations: _integrations2.default,
	    template: _template2.default,
	    recipient: _recipient2.default,
	    users: _users2.default,
	    voip: _voip2.default
	};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _businesses = __webpack_require__(939);
	
	var _businesses2 = _interopRequireDefault(_businesses);
	
	var _companies = __webpack_require__(940);
	
	var _companies2 = _interopRequireDefault(_companies);
	
	var _contacts = __webpack_require__(941);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _contacts_csv = __webpack_require__(942);
	
	var _contacts_csv2 = _interopRequireDefault(_contacts_csv);
	
	var _contacts_group = __webpack_require__(943);
	
	var _contacts_group2 = _interopRequireDefault(_contacts_group);
	
	var _error_messages = __webpack_require__(944);
	
	var _error_messages2 = _interopRequireDefault(_error_messages);
	
	var _flows = __webpack_require__(945);
	
	var _flows2 = _interopRequireDefault(_flows);
	
	var _general = __webpack_require__(946);
	
	var _general2 = _interopRequireDefault(_general);
	
	var _groups = __webpack_require__(947);
	
	var _groups2 = _interopRequireDefault(_groups);
	
	var _integrations = __webpack_require__(948);
	
	var _integrations2 = _interopRequireDefault(_integrations);
	
	var _recipient = __webpack_require__(949);
	
	var _recipient2 = _interopRequireDefault(_recipient);
	
	var _template = __webpack_require__(950);
	
	var _template2 = _interopRequireDefault(_template);
	
	var _users = __webpack_require__(951);
	
	var _users2 = _interopRequireDefault(_users);
	
	var _voip = __webpack_require__(952);
	
	var _voip2 = _interopRequireDefault(_voip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = {
	    businesses: _businesses2.default,
	    companies: _companies2.default,
	    contacts: _contacts2.default,
	    contacts_csv: _contacts_csv2.default,
	    contacts_group: _contacts_group2.default,
	    error_messages: _error_messages2.default,
	    flows: _flows2.default,
	    general: _general2.default,
	    groups: _groups2.default,
	    integrations: _integrations2.default,
	    template: _template2.default,
	    recipient: _recipient2.default,
	    users: _users2.default,
	    voip: _voip2.default
	};

/***/ }),
/* 347 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var resource = new LostReasonsResource();
	
	var state = {
	  lost_reason_list: [],
	  lost_reason_loading: false,
	  lost_reason_fetched: false
	};
	
	var getters = {
	  lostReasonsCount: function lostReasonsCount(state) {
	    return state.lost_reason_list.length;
	  },
	  lostReasonsList: function lostReasonsList(state) {
	    return state.lost_reason_list;
	  },
	  lostReasonLoading: function lostReasonLoading(state) {
	    return state.lost_reason_loading;
	  },
	  lostReasonFetched: function lostReasonFetched(state) {
	    return state.lost_reason_fetched;
	  }
	};
	
	var mutations = {
	  loadLostReasons: function loadLostReasons(state, lost_reasons) {
	    if (lost_reasons) {
	      state.lost_reason_list = lost_reasons;
	    } else {
	      state.lost_reason_list = [];
	    }
	  },
	  addLostReason: function addLostReason(state, lost_reason) {
	    state.lost_reason_list.unshift(lost_reason);
	  },
	  removeLostReason: function removeLostReason(state, lost_reason) {
	    state.lost_reason_list.remove(lost_reason.id);
	  },
	  replaceLostReason: function replaceLostReason(state, lost_reason) {
	    state.lost_reason_list.replaceById(lost_reason);
	  },
	  resetLostReasons: function resetLostReasons(state) {
	    state.lost_reason_list = [];
	  },
	  setLostReasonLoading: function setLostReasonLoading(state, loading) {
	    state.lost_reason_loading = loading;
	  },
	  setLostReasonFetched: function setLostReasonFetched(state, fetched) {
	    state.lost_reason_fetched = fetched;
	  },
	  lostReasonsCount: function lostReasonsCount(state, value) {
	    state.lost_reason_list.length = value;
	  },
	  lostReasonsList: function lostReasonsList(state, value) {
	    state.lost_reason_list = value;
	  },
	  lostReasonLoading: function lostReasonLoading(state, value) {
	    state.lost_reason_loading = value;
	  },
	  lostReasonFetched: function lostReasonFetched(state, value) {
	    state.lost_reason_fetched = value;
	  }
	};
	
	var actions = {
	  fetchLostReasons: function fetchLostReasons(context, payload) {
	    context.commit('setLostReasonLoading', true);
	
	    if (!context.getters.lostReasonFetched) {
	      resource.index(function (response) {
	        context.commit('setLostReasonLoading', false);
	        context.commit('setLostReasonFetched', true);
	        context.commit('loadLostReasons', response.lost_reasons);
	      }, function (error) {
	        context.commit('setLostReasonLoading', false);
	        if (payload && payload.errorCallback) {
	          payload.errorCallback(error);
	        }
	      });
	    }
	    context.commit('setLostReasonLoading', false);
	  },
	  resetLostReasons: function resetLostReasons(context) {
	    context.commit('lostReasonFetched', false);
	    context.commit('lostReasonLoading', false);
	    context.commit('lostReasonsList', []);
	  },
	  createLostReason: function createLostReason(context, payload) {
	    context.commit('setLostReasonLoading', true);
	
	    resource.create(function (response) {
	      context.commit('setLostReasonLoading', false);
	      context.commit('addLostReason', response.data.lost_reason);
	
	      alertify.success('Motivo de perda salvo com sucesso.');
	    }, function (error) {
	      context.commit('setLostReasonLoading', false);
	      alertify.error('Ocorreu um erro ao salvar o motivo de perda.');
	    }, payload);
	  },
	  removeLostReason: function removeLostReason(context, payload) {
	    context.commit('setLostReasonLoading', true);
	
	    resource.destroy(function (response) {
	      console.log(response);
	      context.commit('setLostReasonLoading', false);
	      context.commit('removeLostReason', payload);
	
	      alertify.success('Motivo de perda excluído com sucesso.');
	    }, function (error) {
	      context.commit('setLostReasonLoading', false);
	      if (!error.body || !error.body.base) {
	        alertify.error('Ocorreu um erro ao excluir o motivo de perda.');
	        return;
	      }
	
	      alertify.error(error.body.base[0]);
	    }, payload);
	  },
	  updateLostReason: function updateLostReason(context, payload) {
	    context.commit('setLostReasonLoading', true);
	
	    resource.update(function (response) {
	      context.commit('setLostReasonLoading', false);
	      context.commit('replaceLostReason', response.lost_reason);
	
	      alertify.success('Motivo de perda salvo com sucesso.');
	    }, function (error) {
	      context.commit('setLostReasonLoading', false);
	      alertify.error('Ocorreu um erro ao salvar o motivo de perda.');
	    }, payload);
	  }
	};
	
	exports.default = { state: state, getters: getters, mutations: mutations, actions: actions };

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var resource = new MeetingTypesResource();
	
	var state = {
	  meeting_type_list: [],
	  meeting_type_loading: false,
	  meeting_type_fetched: false
	};
	
	var getters = {
	  meetingTypesCount: function meetingTypesCount(state) {
	    return state.meeting_type_list.length;
	  },
	  meetingTypesList: function meetingTypesList(state) {
	    return state.meeting_type_list;
	  },
	  meetingTypeLoading: function meetingTypeLoading(state) {
	    return state.meeting_type_loading;
	  },
	  meetingTypeFetched: function meetingTypeFetched(state) {
	    return state.meeting_type_fetched;
	  }
	};
	
	var mutations = {
	  loadMeetingTypes: function loadMeetingTypes(state, meeting_types) {
	    if (meeting_types) {
	      state.meeting_type_list = meeting_types;
	    } else {
	      state.meeting_type_list = [];
	    }
	  },
	  addMeetingType: function addMeetingType(state, meeting_type) {
	    state.meeting_type_list.unshift(meeting_type);
	  },
	  removeMeetingType: function removeMeetingType(state, meeting_type) {
	    state.meeting_type_list.remove(meeting_type.id);
	  },
	  replaceMeetingType: function replaceMeetingType(state, meeting_type) {
	    state.meeting_type_list.replaceById(meeting_type);
	  },
	  resetMeetingTypes: function resetMeetingTypes(state) {
	    state.meeting_type_list = [];
	  },
	  setMettingTypeLoading: function setMettingTypeLoading(state, loading) {
	    state.meeting_type_loading = loading;
	  },
	  setMeetingTypeFetched: function setMeetingTypeFetched(state, fetched) {
	    state.meeting_type_fetched = fetched;
	  }
	};
	
	var actions = {
	  fetchMeetingTypes: function fetchMeetingTypes(context, payload) {
	    context.commit('setMettingTypeLoading', true);
	
	    if (!context.getters.meetingTypeFetched) {
	      resource.index(function (response) {
	        context.commit('setMettingTypeLoading', false);
	        context.commit('setMeetingTypeFetched', true);
	        context.commit('loadMeetingTypes', response.meeting_types);
	      }, function (error) {
	        context.commit('setMettingTypeLoading', false);
	        if (payload && payload.errorCallback) {
	          payload.errorCallback(error);
	        }
	      });
	    }
	    context.commit('setMettingTypeLoading', false);
	  },
	  createMeetingType: function createMeetingType(context, payload) {
	    context.commit('setMettingTypeLoading', true);
	
	    resource.create(function (response) {
	      context.commit('setMettingTypeLoading', false);
	      context.commit('addMeetingType', response.data.meeting_type);
	
	      alertify.success('Tipo de reunião salvo com sucesso.');
	    }, function (error) {
	      context.commit('setMettingTypeLoading', false);
	      alertify.error('Ocorreu um erro ao salvar o tipo de reunião.');
	    }, payload);
	  },
	  removeMeetingType: function removeMeetingType(context, payload) {
	    context.commit('setMettingTypeLoading', true);
	
	    resource.destroy(function (response) {
	      context.commit('setMettingTypeLoading', false);
	      context.commit('removeMeetingType', payload);
	
	      alertify.success('Tipo de reunião excluído com sucesso.');
	    }, function (error) {
	      context.commit('setMettingTypeLoading', false);
	      if (!error.body || !error.body.base) {
	        alertify.error('Ocorreu um erro ao excluir o tipo de reunião.');
	        return;
	      }
	
	      alertify.error(error.body.base[0]);
	    }, payload);
	  },
	  updateMeetingType: function updateMeetingType(context, payload) {
	    context.commit('setMettingTypeLoading', true);
	
	    resource.update(function (response) {
	      context.commit('setMettingTypeLoading', false);
	      context.commit('replaceMeetingType', response.meeting_type);
	
	      alertify.success('Tipo de reunião salvo com sucesso.');
	    }, function (error) {
	      context.commit('setMettingTypeLoading', false);
	      alertify.error('Ocorreu um erro ao salvar o tipo de reunião.');
	    }, payload);
	  },
	  resetMeetingTypes: function resetMeetingTypes(context) {
	    context.commit('resetMeetingTypes', []);
	  }
	};
	
	exports.default = { state: state, getters: getters, mutations: mutations, actions: actions };

/***/ }),
/* 349 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  notifications_list: []
	};
	
	var getters = {
	  notificationsCount: function notificationsCount(state) {
	    return state.notifications_list.length;
	  },
	  notificationsList: function notificationsList(state) {
	    return state.notifications_list;
	  },
	  unreadNotificationsCount: function unreadNotificationsCount(state) {
	    var count = 0;
	    for (var i = 0; i < state.notifications_list.length; i++) {
	      if (state.notifications_list[i].read_at == null) {
	        count++;
	      }
	    }
	    return count;
	  }
	};
	
	var mutations = {
	  loadNotifications: function loadNotifications(state, notifications) {
	    state.notifications_list = notifications;
	  },
	  addOrReplaceNotification: function addOrReplaceNotification(state, notification) {
	    if (state.notifications_list.find(notification.id)) {
	      state.notifications_list.replaceById(notification);
	    } else {
	      state.notifications_list.unshift(notification);
	    }
	  },
	  removeNotification: function removeNotification(state, notification) {
	    state.notifications_list.remove(notification);
	  },
	  readAllNotifications: function readAllNotifications(state) {
	    for (var i = 0; i < state.notifications_list.length; i++) {
	      Vue.set(state.notifications_list[i], 'read_at', new Date());
	    }
	  },
	  resetNotifications: function resetNotifications(state) {
	    state.notifications_list = [];
	  }
	};
	
	var actions = {
	  resetNotifications: function resetNotifications(context) {
	    context.commit('resetNotifications', []);
	  }
	};
	
	exports.default = { state: state, getters: getters, mutations: mutations, actions: actions };

/***/ }),
/* 350 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  tags_list: []
	};
	
	var getters = {
	  tagsCount: function tagsCount(state) {
	    return state.tags_list.length;
	  },
	  tagsList: function tagsList(state) {
	    return state.tags_list;
	  }
	};
	
	var mutations = {
	  loadTags: function loadTags(state, tags) {
	    state.tags_list = tags;
	  },
	  addTag: function addTag(state, tag) {
	    state.tags_list.push(tag);
	  },
	  removeTag: function removeTag(state, tag) {
	    state.tags_list.remove(tag);
	  },
	  resetTags: function resetTags(state) {
	    state.tags_list = [];
	  }
	};
	
	var actions = {
	  resetTags: function resetTags(context) {
	    context.commit('resetTags', []);
	  }
	};
	
	exports.default = { state: state, getters: getters, mutations: mutations, actions: actions };

/***/ }),
/* 351 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  template_categories_list: []
	};
	
	var getters = {
	  templateCategoriesCount: function templateCategoriesCount(state) {
	    return state.template_categories_list.length;
	  },
	  templateCategoriesList: function templateCategoriesList(state) {
	    return state.template_categories_list;
	  }
	};
	
	var mutations = {
	  loadTemplateCategories: function loadTemplateCategories(state, template_categories) {
	    state.template_categories_list = template_categories;
	  },
	  addTemplateCategory: function addTemplateCategory(state, template_category) {
	    state.template_categories_list.push(template_category);
	  },
	  removeTemplateCategory: function removeTemplateCategory(state, template_category) {
	    state.template_categories_list.remove(template_category);
	  },
	  resetTemplateCategories: function resetTemplateCategories(state) {
	    state.template_categories_list = [];
	  }
	};
	
	var actions = {
	  resetTemplateCategory: function resetTemplateCategory(context) {
	    context.commit('resetTemplateCategories', []);
	  }
	};
	
	exports.default = { state: state, getters: getters, mutations: mutations, actions: actions };

/***/ }),
/* 352 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var state = {
	  users_list: [],
	  picked: []
	};
	
	var getters = {
	  usersCount: function usersCount(state) {
	    return state.users_list.length;
	  },
	  usersList: function usersList(state) {
	    return state.users_list;
	  },
	  propertyTable: function propertyTable(state) {
	    return state.picked;
	  }
	
	};
	
	var mutations = {
	  table: function table(state, selected) {
	    state.picked = selected;
	  },
	  loadUsers: function loadUsers(state, users) {
	    state.users_list = users;
	  },
	  addUser: function addUser(state, user) {
	    state.users_list.push(user);
	  },
	  resetUsers: function resetUsers(state) {
	    state.users_list = [];
	  }
	};
	
	var actions = {
	  resetUsers: function resetUsers(context) {
	    context.commit('resetUsers', []);
	  }
	};
	
	exports.default = { state: state, getters: getters, mutations: mutations, actions: actions };

/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var routes;
	
	routes = __webpack_require__(236);
	
	module.exports = {
	  components: {
	    globalBoxes: __webpack_require__(182)
	  },
	  beforeRouteEnter: function(to, from, next) {
	    if (!ActionCable.cable) {
	      ActionCable.connect();
	    }
	    return routes.guards.session(to, from, next);
	  },
	  data: function() {
	    return {
	      is_authorized: Session.authorized,
	      show_notifications: true
	    };
	  },
	  methods: {
	    initializeIntercom: function() {
	      this.intercom = new IntercomCtrl;
	      Session.addCallback('session_finished', this.sessionFinishCallback);
	      Session.addCallback('session_started', this.resetStorage);
	      Session.addCallback('session_started', this.sessionStartCallback);
	      if (Session.authorized) {
	        return this.intercom.start({
	          current_user: Session.current_user,
	          current_company: Session.current_company
	        });
	      }
	    },
	    loadPlivoSdk: function() {
	      var plivo;
	      plivo = document.createElement('script');
	      plivo.setAttribute('src', 'https://cdn.plivo.com/sdk/browser/v2/plivo.min.js');
	      return document.head.appendChild(plivo);
	    },
	    sessionFinishCallback: function() {
	      this.is_authorized = false;
	      return this.intercom.finish();
	    },
	    sessionStartCallback: function() {
	      this.is_authorized = true;
	      return this.intercom.start;
	    },
	    resetStorage: function() {
	      this.$store.commit('resetUsers');
	      this.$store.commit('resetTemplateCategories');
	      this.$store.commit('resetTags');
	      return this.$store.commit('resetNotifications');
	    },
	    intercepted: function(e) {
	      var link, ref, ref1;
	      link = document.getElementById('header-wrapper');
	      if (((ref = e.data.current_user) != null ? ref.id : void 0) && e.data.type === 'login') {
	        e.data.current_user.new_ui = true;
	        Session.signIn(e.data.current_user);
	        this.updateLocale();
	        link.style.display = 'none';
	        this.show_notifications = false;
	        if (e.data.route) {
	          this.$router.push(e.data.route);
	        }
	      }
	      if (e.data.type === 'navigate-to-flow') {
	        Session.current_user.new_ui = true;
	        this.$router.push(e.data.route);
	      }
	      if (e.data.type === 'logout') {
	        Session.logout(this.logoutSuccess);
	      }
	      if (e.data.type === 'get-current-user') {
	        window.parent.postMessage({
	          type: 'current-user',
	          current_user: JSON.stringify(Session.current_user)
	        }, '*');
	      }
	      if (((ref1 = e.data.user) != null ? ref1.id : void 0) && e.data.type === 'change-company') {
	        e.data.user.new_ui = true;
	        return Session.signIn(e.data.user);
	      }
	    },
	    logoutSuccess: function() {
	      return Session.logout();
	    },
	    updateLocale: function() {
	      var locale;
	      locale = Session.current_user.selectedLanguage().replace('-', '_');
	      if (!locale) {
	        return;
	      }
	      this.$i18n.locale = locale;
	      if (locale === 'en_US') {
	        return moment.updateLocale('en-us', momentLocales.en_US);
	      } else if (locale === 'es') {
	        return moment.updateLocale('es', momentLocales.es);
	      } else {
	        return moment.updateLocale('pt-br', momentLocales.pt_BR);
	      }
	    }
	  },
	  created: function() {
	    this.mixpanel = new MixpanelCtrl;
	    if (window.addEventListener) {
	      window.addEventListener('message', this.intercepted, false);
	    } else if (window.attachEvent) {
	      window.attachEvent('on' + 'message', this.intercepted);
	    }
	    if (window.parent) {
	      return window.parent.postMessage({
	        type: "created"
	      }, "*");
	    }
	  },
	  mounted: function() {
	    Loader.off();
	    this.initializeIntercom();
	    this.loadPlivoSdk();
	    if (window.parent) {
	      return window.parent.postMessage({
	        type: "app-mounted"
	      }, "*");
	    }
	  }
	};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['contact'],
	  data: function() {
	    return {
	      task: new Task,
	      due_on_date: new Date(),
	      due_on_time: null,
	      past_dates: {
	        to: moment().subtract(1, 'day').toDate()
	      },
	      confirming_destroy_reactivation: false,
	      recipient: null,
	      new_stage: {
	        value: {
	          stage_eq: 'smart_lead'
	        },
	        text: 'Smart Lead'
	      }
	    };
	  },
	  methods: {
	    setDueOn: function() {
	      var parts;
	      parts = this.due_on_time.split(':');
	      return this.task.due_on = moment(this.due_on_date).hours(parts[0]).minutes(parts[1]);
	    },
	    scheduleReactivation: function() {
	      this.task.referenceable_id = this.recipient.id;
	      this.task.referenceable_type = 'FlowRecipient';
	      this.task.metadata = {
	        schedule_set_contact_stage: this.new_stage.stage_eq
	      };
	      return this.tasks_resources.save(this.scheduleReactivationSuccess, this.unknownError, this.task);
	    },
	    scheduleReactivationSuccess: function(data) {
	      this.emitRefreshContactEvent();
	      alertify.success('Agendamento realizado com sucesso!');
	      jQuery('#recipient-schedule-reactivation').modal('hide');
	      return IntercomCtrl.trackEvent('Reagendamento de contato no fluxo');
	    },
	    toggleConfirmDestroyScheduledReactivation: function() {
	      return this.confirming_destroy_reactivation = !this.confirming_destroy_reactivation;
	    },
	    destroyScheduledReactivation: function() {
	      return this.tasks_resources.destroy(this.destroyScheduledReactivationSuccess, this.unknownError, this.task);
	    },
	    destroyScheduledReactivationSuccess: function() {
	      this.confirming_destroy_reactivation = false;
	      this.emitRefreshContactEvent();
	      alertify.success('Agendamento cancelado com sucesso!');
	      return jQuery('#recipient-schedule-reactivation').modal('hide');
	    },
	    emitRefreshContactEvent: function() {
	      return EventsBus.$emit('Contact::Refresh', {
	        id: this.contact.id
	      });
	    },
	    setStage: function(data) {
	      return this.new_stage = data;
	    }
	  },
	  computed: {
	    due_on_text: function() {
	      if (!this.task.due_on) {
	        return 'Selecione data e hora';
	      }
	      return (this.task.formattedDueOn()) + " (" + (this.task.due_on.fromNow()) + ")";
	    },
	    save_task_text: function() {
	      if (this.task.isPersisted()) {
	        return 'Atualizar';
	      }
	      return 'Agendar';
	    },
	    title_text: function() {
	      if (this.task.isPersisted()) {
	        return 'Editar Reativação';
	      }
	      return 'Agendar Reativação';
	    },
	    valid_due_on: function() {
	      return this.task && this.task.validDueOn() && this.task.due_on && !this.overdue;
	    },
	    overdue: function() {
	      var parts, task_due_on_date_time;
	      if (!this.due_on_date || !this.due_on_time) {
	        return false;
	      }
	      parts = this.due_on_time.split(':');
	      task_due_on_date_time = moment(this.due_on_date).hours(parts[0]).minutes(parts[1]);
	      if (task_due_on_date_time.isBefore(moment())) {
	        return true;
	      }
	      return false;
	    },
	    next_valid_stages: function() {
	      return [
	        {
	          value: {
	            stage_eq: 'smart_lead'
	          },
	          text: 'Smart Lead'
	        }, {
	          value: {
	            stage_eq: 'prospect'
	          },
	          text: 'Prospect'
	        }, {
	          value: {
	            stage_eq: 'lead'
	          },
	          text: 'Lead'
	        }, {
	          value: {
	            stage_eq: 'mql'
	          },
	          text: 'MQL'
	        }, {
	          value: {
	            stage_eq: 'sql'
	          },
	          text: 'SQL'
	        }, {
	          value: {
	            stage_eq: 'opportunity'
	          },
	          text: 'Oportunidade'
	        }, {
	          value: {
	            stage_eq: 'client'
	          },
	          text: 'Cliente'
	        }
	      ];
	    }
	  },
	  watch: {
	    due_on_date: function() {
	      return this.setDueOn();
	    },
	    due_on_time: function() {
	      return this.setDueOn();
	    },
	    contact: function() {
	      var contact, due_on, previous_stage;
	      if (!this.contact) {
	        return;
	      }
	      this.recipient = this.contact.recipient;
	      if (this.recipient.reactivate_automatic_task.constructor === Task) {
	        this.task = this.recipient.reactivate_automatic_task;
	      } else {
	        this.task = new Task({
	          type: 'AutomaticTask',
	          service: 'AutomaticTasksServices::ReactivateRecipient'
	        });
	      }
	      due_on = this.task.due_on.clone();
	      this.due_on_date = due_on.toDate();
	      this.due_on_time = due_on.format('HH:mm');
	      contact = this.contact;
	      previous_stage = this.next_valid_stages.find(function(stage) {
	        return stage.value.stage_eq === contact.previous_stage;
	      });
	      return this.new_stage = {
	        stage_eq: previous_stage.value.stage_eq
	      };
	    }
	  },
	  created: function() {
	    return this.tasks_resources = new TasksResource;
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  mixins: [__webpack_require__(6), __webpack_require__(80)],
	  props: {
	    filters: {
	      "default": {}
	    }
	  },
	  data: function() {
	    return {
	      status_filter: this.statusFilter(),
	      status_options: [
	        {
	          value: null,
	          text: this.$t('businesses.label.statusOptions.all')
	        }, {
	          value: {
	            active_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.active')
	        }, {
	          value: {
	            bounced_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.bounced')
	        }, {
	          value: {
	            connected_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.connected')
	        }, {
	          value: {
	            uninitialized_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.uninitialized')
	        }, {
	          value: {
	            paused_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.')
	        }, {
	          value: {
	            converting_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.converting')
	        }, {
	          value: {
	            scheduled_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.scheduled')
	        }, {
	          value: {
	            interrupted_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.interrupted')
	        }, {
	          value: {
	            blocklisted_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.blocklisted')
	        }, {
	          value: {
	            not_connected_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.notConnected')
	        }, {
	          value: {
	            disqualified_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.disqualified')
	        }, {
	          value: {
	            inactive_status: true
	          },
	          text: this.$t('businesses.label.statusOptions.inactive')
	        }
	      ],
	      stage_filter: this.extractFilter('stage_eq'),
	      stage_options: [
	        {
	          value: null,
	          text: this.$t('businesses.label.stageOptions.all')
	        }, {
	          value: {
	            stage_query: 'smart_lead'
	          },
	          text: this.$t('businesses.label.stageOptions.smartLead')
	        }, {
	          value: {
	            stage_query: 'prospect'
	          },
	          text: this.$t('businesses.label.stageOptions.prospect')
	        }, {
	          value: {
	            stage_query: 'lead'
	          },
	          text: this.$t('businesses.label.stageOptions.lead')
	        }, {
	          value: {
	            stage_query: 'mql'
	          },
	          text: this.$t('businesses.label.stageOptions.mql')
	        }, {
	          value: {
	            stage_query: 'sql'
	          },
	          text: this.$t('businesses.label.stageOptions.sql')
	        }, {
	          value: {
	            stage_query: 'opportunity'
	          },
	          text: this.$t('businesses.label.stageOptions.opportunity')
	        }, {
	          value: {
	            stage_query: 'client'
	          },
	          text: this.$t('businesses.label.stageOptions.client')
	        }, {
	          value: {
	            stage_query: 'lost'
	          },
	          text: this.$t('businesses.label.stageOptions.lost')
	        }
	      ],
	      tag_filter: this.extractFilter('contacts_contact_tags_tag_id_eq'),
	      text_field_filter: this.filters.search_query
	    };
	  },
	  computed: {
	    filterParams: function() {
	      var filter, filter_params, i, len, ref, ref1;
	      filter_params = {};
	      ref = [this.status_filter, this.stage_filter];
	      for (i = 0, len = ref.length; i < len; i++) {
	        filter = ref[i];
	        if (filter) {
	          Object.assign(filter_params, filter);
	        }
	      }
	      if (this.text_field_filter) {
	        filter_params['search_query'] = this.text_field_filter;
	      }
	      if (((ref1 = this.tag_filter) != null ? ref1.contact_tags_tag_id_eq : void 0) != null) {
	        filter_params['contacts_contact_tags_tag_id_eq'] = this.tag_filter.contact_tags_tag_id_eq;
	      }
	      return filter_params;
	    }
	  },
	  methods: {
	    filter: function() {
	      return this.$emit('filter', this.filterParams);
	    },
	    statusFilter: function() {
	      var filter_keys, i, len, ref, status_filter, type;
	      filter_keys = Object.keys(this.filters).join();
	      if (!filter_keys.match(/_status/)) {
	        return;
	      }
	      status_filter = {};
	      ref = ['active_status', 'paused_status', 'scheduled_status', 'interrupted_status', 'uninitialized_status', 'blocklisted_status', 'not_connected_status', 'disqualified_status'];
	      for (i = 0, len = ref.length; i < len; i++) {
	        type = ref[i];
	        if (this.filters[type]) {
	          status_filter[type] = true;
	        }
	      }
	      return status_filter;
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.filters);


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    filters: __webpack_require__(94),
	    businessListItem: __webpack_require__(96)
	  },
	  props: {
	    businesses: {
	      "default": function() {
	        return [];
	      }
	    },
	    filters: {
	      "default": function() {
	        return {};
	      }
	    }
	  },
	  data: function() {
	    return {
	      selected_business: {
	        name: "-"
	      }
	    };
	  },
	  methods: {
	    filter: function(filters) {
	      return this.$emit('filter', filters);
	    },
	    callDestroyBusiness: function() {
	      return this.businesses_resource.destroy(this.destroyBusinessSuccess, this.unknownError, {
	        id: this.selected_business.id
	      });
	    },
	    destroyBusinessSuccess: function() {
	      this.excludeBusinessFromList(this.selected_business.id);
	      return alertify.success(this.$t('businesses.feedback.removeSuccess'));
	    },
	    excludeBusinessFromList: function(business_id) {
	      var index;
	      index = this.businesses.findIndex(business_id);
	      if (index > -1) {
	        this.businesses.splice(index, 1);
	      }
	      return this.selected_business = {
	        name: "-"
	      };
	    },
	    openDestroyBusinessModal: function(data) {
	      if (data.business.contacts_count > 0) {
	        return alertify.error(this.$t('businesses.label.companyRemoveAlert'));
	      } else {
	        this.selected_business = data.business;
	        return EventsBus.$emit('confirm-modal-show', {
	          id: 'confirm-remove-business'
	        });
	      }
	    }
	  },
	  created: function() {
	    return this.businesses_resource = new BusinessesResource();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    tag: __webpack_require__(9)
	  },
	  props: {
	    business: {
	      type: Business
	    }
	  },
	  data: function() {
	    return {};
	  },
	  computed: {
	    address: function() {
	      var ref, short_address;
	      if (this.business.address) {
	        short_address = (ref = this.business.address) != null ? ref.substring(0, 40) : void 0;
	        if (this.business.address.length > 40) {
	          short_address += "...";
	        }
	        return short_address;
	      }
	    },
	    statusIconClass: function() {
	      switch (this.business.status) {
	        case 'paused':
	          return 'contact-event-subicon paused-icon';
	        case 'active':
	          return 'contact-event-subicon active-icon';
	        case 'uninitialized':
	          return 'contact-event-subicon uninitialized-icon';
	        case 'scheduled_reactivation':
	          return 'contact-event-subicon scheduled_reactivation-icon';
	        default:
	          return 'contact-event-subicon finished-icon';
	      }
	    },
	    stageClasses: function() {
	      return "btn-contact-stage btn-contact-fake contact-stage-" + this.business.stage;
	    },
	    tag_first: function() {
	      if (this.business.tags.length > 0) {
	        return this.business.tags[0];
	      }
	    },
	    tags_count_left: function() {
	      return this.business.tags.length - 1;
	    },
	    show_more_tags: function() {
	      return this.business.tags.length > 1;
	    }
	  },
	  methods: {
	    destroyBusiness: function(event, attr) {
	      if (attr == null) {
	        attr = {};
	      }
	      event.originalEventName = 'business-destroy';
	      return this.$emit('business-destroy', {
	        event: event,
	        business: this.business
	      });
	    },
	    editBusiness: function() {
	      return this.$router.push({
	        path: "/contatos/empresas/" + this.business.id
	      });
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.contacts.styles, helpers.form);


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      business: new Business(),
	      apiErrorMessages: [],
	      pristine: true
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.create();
	          }
	        };
	      })(this));
	    },
	    create: function() {
	      Loader.on();
	      return this.businesses_resource.create(this.createSuccess, this.handleApiErrors, this.business);
	    },
	    createSuccess: function(data) {
	      Loader.off();
	      return this.$emit('business-create', data.business);
	    }
	  },
	  created: function() {
	    return this.businesses_resource = new BusinessesResource(Session.current_company.id);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    tag: __webpack_require__(9),
	    contactList: __webpack_require__(34)
	  },
	  data: function() {
	    return {
	      business: new Business,
	      contacts: [],
	      contact_filter: {},
	      contact_next_page: 1,
	      current_user: Session.current_user,
	      contacts_loading: false,
	      selected_contact: null
	    };
	  },
	  computed: {
	    statusIconClass: function() {
	      switch (this.business.status) {
	        case 'paused':
	          return 'contact-event-subicon paused-icon';
	        case 'active':
	          return 'contact-event-subicon active-icon';
	        case 'uninitialized':
	          return 'contact-event-subicon uninitialized-icon';
	        case 'scheduled_reactivation':
	          return 'contact-event-subicon scheduled_reactivation-icon';
	        default:
	          return 'contact-event-subicon finished-icon';
	      }
	    },
	    stageClasses: function() {
	      return "btn-contact-stage btn-contact-fake contact-stage-" + this.business.stage;
	    }
	  },
	  methods: {
	    toggleTaskBar: function(data) {
	      return EventsBus.$emit('toggle-task-bar', data.contact.id);
	    },
	    openDestroyContactConfirmationModal: function(data) {
	      this.selected_contact = data.contact;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-remove-contact'
	      });
	    },
	    callDestroyContact: function() {
	      return this.destroyContact({
	        contact: this.selected_contact
	      }, this.contact_resource);
	    },
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.save();
	          }
	        };
	      })(this));
	    },
	    save: function() {
	      return this.businesses_resource.update(this.saveSuccess, this.unknownError, this.business);
	    },
	    saveSuccess: function(data) {
	      return alertify.success(this.$t('businesses.feedback.saveSuccess'));
	    },
	    loadBusiness: function() {
	      var params;
	      Loader.on();
	      params = {
	        include_contact_custom_fields: true
	      };
	      return this.businesses_resource.get(this.loadSuccess, this.loadFailure, {
	        id: this.$route.params.id,
	        params: params
	      });
	    },
	    loadFailure: function(data) {
	      if (data.status === 403) {
	        return this.$router.push('/contatos/empresas');
	      } else {
	        return alertify.error(this.$t('businesses.feedback.unknownFail'));
	      }
	    },
	    loadSuccess: function(resources) {
	      Loader.off();
	      this.business = resources.business;
	      this.contact_filter = {
	        business_id_eq: this.business.id
	      };
	      return this.loadContacts();
	    },
	    loadContacts: function() {
	      var params;
	      if (this.contacts_loading || !this.contact_next_page || !this.business.id) {
	        return;
	      }
	      this.contacts_loading = true;
	      params = {};
	      params.q = this.contact_filter;
	      params.page = this.contact_next_page;
	      return this.contact_resource.index(this.loadContactsSuccess, this.unknownError, {
	        params: params
	      });
	    },
	    loadContactsSuccess: function(resources) {
	      this.contacts_loading = false;
	      this.contact_next_page = resources.meta.next_page;
	      return this.contacts = this.contacts.concat(resources.contacts);
	    },
	    unknownError: function() {
	      Loader.off();
	      return alertify.error(this.$t('businesses.feedback.errorTitle'));
	    }
	  },
	  created: function() {
	    this.businesses_resource = new BusinessesResource();
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    return this.loadBusiness();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes, helpers.contacts.list_wrapper, helpers.filters);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['additional'],
	  computed: {
	    additional_time_in_minutes: {
	      get: function() {
	        if (!this.additional) {
	          return 0;
	        }
	        return parseInt(this.additional.seconds / 60);
	      },
	      set: function(value) {
	        if (!this.additional) {
	          return;
	        }
	        return this.additional.seconds = parseInt(value || 0) * 60;
	      }
	    },
	    consumed_in_minutes: function() {
	      if (!this.additional) {
	        return '';
	      }
	      return this.$t('companies.feedback.consummedMinutes');
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    emailServiceDropdown: __webpack_require__(49),
	    additionalMinute: __webpack_require__(98)
	  },
	  data: function() {
	    return {
	      company: new Company,
	      account_setting_selected: null,
	      account_setting: new AccountSetting,
	      max_duration_in_mintues: 0,
	      plivo_setting: null,
	      minutes_to_add: 0,
	      voip_service: 'plivo',
	      voip_services: [
	        {
	          value: 'plivo',
	          text: 'Plivo'
	        }, {
	          value: 'twilio',
	          text: 'Twilio'
	        }
	      ]
	    };
	  },
	  computed: {
	    regular_users_upper_limit: function() {
	      switch (this.account_setting_selected.name) {
	        case 'basic':
	          return 3;
	        case 'developer':
	          return 8;
	        case 'premium':
	          return 12;
	        case 'enterprise':
	          return 100;
	        default:
	          return 0;
	      }
	    },
	    default_regular_users_bottom_limit: function() {
	      switch (this.account_setting_selected.name) {
	        case 'basic':
	          return 1;
	        case 'developer':
	          return 3;
	        case 'premium':
	          return 9;
	        case 'enterprise':
	          return 13;
	        default:
	          return 0;
	      }
	    },
	    regular_users_bottom_limit: function() {
	      return Math.max(this.company.number_of_regular_users, this.default_regular_users_bottom_limit);
	    },
	    voip_active: function() {
	      return this.company.isPlivo() || this.company.isTwilio();
	    },
	    max_duration_in_minutes: {
	      get: function() {
	        if (!(this.plivo_setting || this.twilio_setting)) {
	          return 0;
	        }
	        if (this.plivo_setting && this.company.isPlivo()) {
	          return this.plivo_setting.voip_monthly_plan.max_duration / 60;
	        } else if (this.twilio_setting && this.company.isTwilio()) {
	          return this.twilio_setting.voip_monthly_plan.max_duration / 60;
	        }
	      },
	      set: function(value) {
	        if (!(this.plivo_setting || this.twilio_setting)) {
	          return;
	        }
	        if (this.plivo_setting && this.company.isPlivo()) {
	          return this.plivo_setting.voip_monthly_plan.max_duration = parseInt(value || 0) * 60;
	        } else if (this.twilio_setting && this.company.isTwilio()) {
	          return this.twilio_setting.voip_monthly_plan.max_duration = parseInt(value || 0) * 60;
	        }
	      }
	    }
	  },
	  methods: {
	    toggleActiveCompany: function() {
	      return this.company.active = !this.company.active;
	    },
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function() {
	          return _this.save();
	        };
	      })(this));
	    },
	    loadCompany: function() {
	      Loader.on();
	      return new CompaniesResource().get(this.loadCompanySuccess, this.handleApiErrors, {
	        id: this.company_id
	      });
	    },
	    loadCompanySuccess: function(data) {
	      var selected;
	      this.company = data.company;
	      this.voip_service = this.company.voip_service;
	      this.plivo_setting = this.company.plivo_setting;
	      this.twilio_setting = this.company.twilio_setting;
	      this.account_setting_selected = {};
	      if (this.company.account_setting && !(this.company.account_setting instanceof Array)) {
	        selected = Object.assign({}, this.company.account_setting_options().account_settings.find((function(setting) {
	          return setting.value.name === data.company.account_setting.name;
	        })));
	        if (selected) {
	          this.account_setting_selected = selected.value;
	        }
	        this.account_setting.max_number_of_regular_users = this.company.account_setting.max_number_of_regular_users || 0;
	        this.account_setting.max_number_of_monitoring_managers = this.company.account_setting.max_number_of_monitoring_managers || 0;
	        this.account_setting = this.company.account_setting;
	      } else {
	        this.account_setting_selected = {
	          name: 'basic',
	          max_number_of_regular_users: 3
	        };
	      }
	      return Loader.off();
	    },
	    updateCompany: function() {
	      this.account_setting.name = this.account_setting_selected.name;
	      this.account_setting.max_number_of_regular_users = parseInt(this.account_setting.max_number_of_regular_users);
	      this.account_setting.max_number_of_monitoring_managers = parseInt(this.account_setting.max_number_of_monitoring_managers);
	      this.account_setting.company_id = this.company.id;
	      return this.company.account_setting = this.account_setting;
	    },
	    verifyUsers: function() {
	      if (this.company.max_number_of_regular_users > this.account_setting_selected.max_number_of_regular_users || this.company.max_number_of_monitoring_managers > parseInt(this.account_setting.max_number_of_monitoring_managers)) {
	        alertify.error(this.$t('companies.feedback.contactsExceeded'));
	        return false;
	      } else {
	        return true;
	      }
	    },
	    updatePlivoSettingAttributes: function() {
	      if (this.company.isPlivo()) {
	        return this.company.plivo_setting_attributes = {
	          id: this.plivo_setting.id,
	          max_duration: this.plivo_setting.max_duration,
	          additional_time: this.plivo_setting.additional_time
	        };
	      } else {
	        return this.company.plivo_setting_attributes = null;
	      }
	    },
	    updateTwilioSettingAttributes: function() {
	      if (this.company.isTwilio()) {
	        return this.company.twilio_setting_attributes = {
	          id: this.twilio_setting.id,
	          max_duration: this.twilio_setting.max_duration,
	          additional: this.twilio_setting.additional_time
	        };
	      } else {
	        return this.company.twilio_setting_attributes = null;
	      }
	    },
	    save: function() {
	      Loader.on();
	      if (!this.verifyUsers()) {
	        return;
	      }
	      this.updateCompany();
	      this.company.plivo_setting = this.plivo_setting;
	      this.company.twilio_setting = this.twilio_setting;
	      return new CompaniesResource().update(this.saveSuccess, this.handleApiErrors, this.company.serialize());
	    },
	    saveSuccess: function() {
	      Loader.off();
	      alertify.success(this.$t('companies.feedback.updated'));
	      return this.$router.push('/configuracoes/empresas');
	    },
	    setVoipService: function() {
	      Loader.on();
	      return new CompaniesResource().update(this.toggleServiceSuccess, this.handleApiErrors, {
	        id: this.company.id,
	        voip_service: this.voip_service
	      });
	    },
	    toggleVoipService: function() {
	      var voip_service;
	      voip_service = null;
	      if (!this.company.voip_service) {
	        voip_service = 'plivo';
	      }
	      Loader.on();
	      return new CompaniesResource().update(this.toggleServiceSuccess, this.handleApiErrors, {
	        id: this.company.id,
	        voip_service: voip_service
	      });
	    },
	    toggleServiceSuccess: function(data) {
	      alertify.success(this.$t('companies.feedback.saved'));
	      this.loadCompanySuccess(data);
	      Loader.on();
	      return new CompaniesResource().update(this.toggleServiceSuccess, this.handleApiErrors, this.company.serialize());
	    },
	    addMinutes: function() {
	      if (this.company.isPlivo()) {
	        return this.plivo_setting.voip_additional_times.push(new VoipAdditionalTime({
	          user_id: Session.current_user.id
	        }));
	      } else if (this.company.isTwilio()) {
	        return this.twilio_setting.voip_additional_times.push(new VoipAdditionalTime({
	          user_id: Session.current_user.id
	        }));
	      }
	    }
	  },
	  created: function() {
	    this.company_id = this.$route.params.id;
	    return this.loadCompany();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 380 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['value'],
	  data: function() {
	    return {
	      email_service_options: [
	        {
	          value: 'nylas',
	          text: 'Nylas',
	          icon_class: 'nylas-icon'
	        }, {
	          value: 'sparkpost',
	          text: 'Sparkpost',
	          icon_class: 'sparkpost-icon'
	        }
	      ]
	    };
	  },
	  methods: {
	    emitChange: function(value) {
	      return this.$emit('input', value);
	    }
	  }
	};


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    listItem: __webpack_require__(99)
	  },
	  data: function() {
	    return {
	      companies: [],
	      loading: false,
	      next_page: 1,
	      text_field_filter: ''
	    };
	  },
	  methods: {
	    loadCompanies: function() {
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      return new CompaniesResource().index(this.loadCompaniesSuccess, this.unknownError, {
	        params: {
	          q: {
	            search_query: this.text_field_filter
	          },
	          page: this.next_page
	        }
	      });
	    },
	    loadCompaniesSuccess: function(data) {
	      this.loading = false;
	      this.companies = this.companies.concat(data.companies);
	      return this.next_page = data.meta.next_page;
	    },
	    companyUpdated: function(company) {
	      this.companies.replaceById(company);
	      if (company.email_domain_verified) {
	        return alertify.success(this.$t('general.feedback.domainVerified'));
	      } else {
	        return alertify.log(this.$t('companies.feedback.domainWarning'), 'warning');
	      }
	    },
	    filter: function() {
	      this.next_page = 1;
	      this.companies = [];
	      return this.loadCompanies();
	    },
	    nameLetters: function(name) {
	      var firstName, lastName, ref;
	      ref = name.split(" "), firstName = ref[0], lastName = ref[1];
	      if (!!firstName && !lastName) {
	        return firstName.charAt(0).toUpperCase();
	      }
	      return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
	    }
	  },
	  created: function() {
	    this.loadCompanies();
	    if (!Session.current_user.isAdmin()) {
	      return this.$router.push('/');
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['company'],
	  data: function() {
	    return {
	      show_dkim: false
	    };
	  },
	  computed: {
	    plivo_activated: function() {
	      var ref;
	      return this.company.isPlivo() && (((ref = this.company.plivo_setting) != null ? ref.voip_monthly_plan : void 0) != null);
	    },
	    twilio_activated: function() {
	      var ref;
	      return this.company.isTwilio() && (((ref = this.company.twilio_setting) != null ? ref.voip_monthly_plan : void 0) != null);
	    }
	  },
	  methods: {
	    verify: function() {
	      Loader.on();
	      return new CompaniesResource().verify(this.verifySuccess, this.unkownError, {
	        id: this.company.id
	      });
	    },
	    verifySuccess: function(data) {
	      Loader.off();
	      return this.$emit('updated', data.company);
	    },
	    toggleShowDkim: function(event) {
	      if (jQuery(event.target).closest('.clickable-element').length) {
	        return;
	      }
	      return this.show_dkim = !this.show_dkim;
	    },
	    companyEditPath: function() {
	      return "/configuracoes/empresas/" + this.company.id + "/editar";
	    },
	    editCompany: function() {
	      return this.$router.push({
	        path: this.companyEditPath()
	      });
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    emailServiceDropdown: __webpack_require__(49)
	  },
	  data: function() {
	    return {
	      company: new Company({
	        email_service: 'nylas'
	      }),
	      account_setting_selected: {
	        name: 'basic',
	        max_number_of_regular_users: 3
	      },
	      account_setting: new AccountSetting
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function() {
	          return _this.save();
	        };
	      })(this));
	    },
	    updateCompany: function() {
	      this.account_setting.name = this.account_setting_selected.name;
	      if (this.account_setting.isCustom()) {
	        this.account_setting.max_number_of_regular_users = parseInt(this.account_setting.max_number_of_regular_users);
	      } else {
	        this.account_setting.max_number_of_regular_users = this.account_setting_selected.max_number_of_regular_users;
	      }
	      this.account_setting.max_number_of_monitoring_managers = parseInt(this.account_setting.max_number_of_monitoring_managers);
	      this.company.account_setting = this.account_setting;
	      return this.company.active = true;
	    },
	    save: function() {
	      Loader.on();
	      this.updateCompany();
	      return new CompaniesResource().create(this.saveSuccess, this.handleApiErrors, this.company.serialize());
	    },
	    saveSuccess: function(response) {
	      Loader.off();
	      alertify.success(this.$t('companies.actions.created'));
	      return this.$router.push('/configuracoes/empresas');
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	var api, helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	api = __webpack_require__(4);
	
	view_model = {
	  data: function() {
	    return {
	      credentials: {
	        current_password: '',
	        password: '',
	        password_confirmation: ''
	      },
	      apiErrorMessages: []
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll(this.credentials).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.changePassword();
	          }
	        };
	      })(this));
	    },
	    changePassword: function() {
	      Loader.on();
	      return new UsersResource().changePassword(this.changePasswordSuccess, this.handleApiErrors, this.credentials);
	    },
	    changePasswordSuccess: function() {
	      Loader.off();
	      IntercomCtrl.trackEvent('Alterou a senha');
	      this.$router.push({
	        path: '/configuracoes/perfil'
	      });
	      return alertify.success('Senha alterada com sucesso');
	    }
	  },
	  mounted: function() {
	    return this.errors.clear();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 385 */
/***/ (function(module, exports) {

	


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      current_user: Session.current_user
	    };
	  },
	  methods: {
	    redirect: function() {
	      if (!this.current_user.default_user) {
	        return alertify.error(this.$t('integrations.actions.email.setUp.error.defaultUserError'));
	      }
	      Loader.on();
	      return window.location = this.nylasOauthUrl();
	    },
	    nylasOauthUrl: function() {
	      var params;
	      params = jQuery.param({
	        client_id: ("8ipcwu19ld095jfh10kfh06ra"),
	        response_type: 'code',
	        scopes: ("email.send,email.read_only,calendar"),
	        login_hint: this.current_user.email,
	        redirect_uri: window.location.protocol + "//" + window.location.host + "/configuracoes/integracoes",
	        state: 'nylas'
	      });
	      return "https://api.nylas.com/oauth/authorize?" + params;
	    }
	  },
	  created: function() {
	    if (!this.current_user.email_service_requires_authorization) {
	      return this.$router.push({
	        name: 'contatos/leads'
	      });
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    carouselModal: __webpack_require__(33),
	    textImage: __webpack_require__(210),
	    vtiger: __webpack_require__(108),
	    hubspot: __webpack_require__(50),
	    rd_station: __webpack_require__(51),
	    triggerStages: __webpack_require__(7),
	    integration: __webpack_require__(101)
	  },
	  data: function() {
	    var ref, ref1, ref2;
	    return {
	      current_user: Session.current_user,
	      rd_station_setting: Session.current_user.rd_station_setting.id != null ? Session.current_user.rd_station_setting : new RdStationSetting(),
	      salesforce_setting: Session.current_user.salesforce_setting.id != null ? Session.current_user.salesforce_setting : new SalesforceSetting(),
	      pipedrive_setting: Session.current_user.pipedrive_setting.id != null ? Session.current_user.pipedrive_setting : new PipedriveSetting(),
	      crm_setting: Session.current_user.crm_setting.id != null ? Session.current_user.crm_setting : new CRMSetting(),
	      nectar_setting: Session.current_user.nectar_setting.id != null ? Session.current_user.nectar_setting : new NectarSetting(),
	      webhook_url: Session.current_user.webhook_setting.id != null ? Session.current_user.webhook_setting.url : 'https://',
	      salesforce_authorized: ((ref = Session.current_user.salesforce_setting) != null ? ref.access_token : void 0) != null,
	      rdstation_authorized: (ref1 = Session.current_user.rd_station_setting) != null ? ref1.authorized : void 0,
	      selectedRD: (ref2 = Session.current_user.rd_station_setting) != null ? ref2.mark_lead_as_sale : void 0,
	      create_on_add_to_nectar: Session.current_user.nectar_setting.create_on_add,
	      nectar_api_key: Session.current_user.nectar_api_key || '',
	      show_form: false,
	      show_form_bcc: false,
	      show_form_rd: false,
	      show_form_sp: false,
	      show_form_ll: false,
	      show_form_nectar: false,
	      show_form_salesforce: false,
	      copied_rd: false,
	      copied_sp: false,
	      copied_ll: false,
	      rd_carousel: null,
	      sp_carousel: null,
	      conectedToNylas: false,
	      show_api_token: false,
	      show_carousel: false,
	      carousel: null,
	      webhook_triggers: {},
	      sharpspring_setting: Session.current_user.sharpspring_setting.id != null ? Session.current_user.sharpspring_setting : new SharpspringSetting(),
	      leadlovers_setting: Session.current_user.leadlovers_setting.id != null ? Session.current_user.leadlovers_setting : new LeadloversSetting()
	    };
	  },
	  computed: {
	    sp_url: function() {
	      if (this.has_configured_sp_carousel || !this.sharpspring_setting.use_carousel) {
	        return ("https://api.reev.co") + '/webhooks/sharp_spring/import_contacts?token=' + this.current_user.authentication_token;
	      } else {
	        return this.$t('integrations.feedback.sharpspringNeedsCarousel');
	      }
	    },
	    leadloversSet: function() {
	      if (Session.current_user.leadlovers_setting.id != null) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    ll_url: function() {
	      return ("https://api.reev.co") + '/webhooks/lead_lovers/import_contacts?token=' + this.current_user.authentication_token;
	    },
	    salesforce_mark_as: function() {
	      if (this.salesforce_setting.mark_as === 'lead_and_opportunity') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    salesforce_send_to: function() {
	      if (this.salesforce_setting.send_to === 'queue') {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    has_configured_rd_carousel: function() {
	      return (this.rd_carousel != null) && this.rd_carousel.carousel_users.length > 0;
	    },
	    has_configured_sp_carousel: function() {
	      return (this.sp_carousel != null) && this.sp_carousel.carousel_users.length > 0;
	    },
	    webhook_error: function() {
	      var error;
	      error = this.errors.first('webhook_url');
	      if (!error) {
	        return;
	      }
	      return error + this.$t('integrations.feedback.rememberHttps');
	    },
	    nylasOauthUrl: function() {
	      var params;
	      params = jQuery.param({
	        client_id: ("8ipcwu19ld095jfh10kfh06ra"),
	        response_type: 'code',
	        scopes: ("email.send,email.read_only,calendar"),
	        login_hint: Session.current_user.email,
	        redirect_uri: window.location.protocol + "//" + window.location.host + "/configuracoes/integracoes",
	        state: 'nylas'
	      });
	      return "https://api.nylas.com/oauth/authorize?" + params;
	    },
	    salesforceOauthUrl: function() {
	      var client_id, params;
	      client_id = Session.current_user.new_ui ? ("3MVG9zlTNB8o8BA1krJtuDM9UTfPVP_SneWt0Un21Dv87jJebCfbGqyeJ_Ffmbxp38VsvfPuIHWp__SC9Es1L") : ("3MVG9zlTNB8o8BA1krJtuDM9UTTRwgZa.Znn9_tUkWOTIqOJpyvJgCjvlu0nQPwIuFOz1p0VbTvSqNsK8hO0F");
	      params = jQuery.param({
	        client_id: client_id,
	        response_type: 'code',
	        redirect_uri: window.location.protocol + "//" + window.location.host + "/configuracoes/integracoes",
	        state: 'salesforce,' + this.salesforce_setting.sandbox_test
	      });
	      if (this.salesforce_setting.sandbox_test) {
	        return "https://test.salesforce.com/services/oauth2/authorize?" + params;
	      } else {
	        return "https://login.salesforce.com/services/oauth2/authorize?" + params;
	      }
	    },
	    rdStationOauthUrl: function() {
	      var params;
	      params = jQuery.param({
	        client_id: ("ea885b8c-3199-45c1-a2c6-a6f298f6affa"),
	        redirect_url: window.location.protocol + "//" + window.location.host + "/configuracoes/integracoes",
	        state: 'rdstation'
	      });
	      return "https://api.rd.services/auth/dialog?" + params;
	    },
	    email_authorized: function() {
	      return this.current_user.email_authorized && !this.current_user.requireEmailReauthorization();
	    }
	  },
	  methods: {
	    toggleSendTasks: function() {
	      return this.nectar_setting.send_tasks = !this.nectar_setting.send_tasks;
	    },
	    use_carousel_rd: function() {
	      if (this.rd_station_setting.use_carousel) {
	        return this.$t('integrations.label.contactsViaCarousel');
	      }
	      return this.$t('integrations.label.contactsViaResponsible');
	    },
	    use_carousel_sp: function() {
	      if (this.sharpspring_setting.use_carousel) {
	        return this.$t('integrations.label.contactsViaCarousel');
	      }
	      return this.$t('integrations.label.contactsViaResponsible');
	    },
	    checkboxSelectRD: function() {
	      if (!this.rdstation_authorized && this.rd_station_setting.use_carousel) {
	        return;
	      }
	      this.selectedRD = !this.selectedRD;
	      if (this.selectedRD) {
	        if (this.rd_station_setting.triggers.stages.indexOf('client') === -1) {
	          this.rd_station_setting.triggers.stages.push('client');
	        }
	      } else {
	        this.rd_station_setting.triggers.stages.pop();
	      }
	      return this.updateRdStationSetting();
	    },
	    fillRdCarousel: function(carousel) {
	      return this.rd_carousel = carousel;
	    },
	    fillSpCarousel: function(carousel) {
	      return this.sp_carousel = carousel;
	    },
	    fillCarousel: function(carousel) {
	      return this.carousel = carousel;
	    },
	    modalTitle: function() {
	      if (this.current_user.isSeller()) {
	        return this.$t('integrations.attributes.Carousel');
	      } else {
	        return this.$t('integrations.label.setCarousel');
	      }
	    },
	    loadRdCarouselData: function() {
	      return this.$refs.rd_carousel_modal.loadData();
	    },
	    loadSpCarouselData: function() {
	      return this.$refs.sp_carousel_modal.loadData();
	    },
	    loadCarouselData: function() {
	      return this.$refs.carousel_modal.loadData();
	    },
	    copyURLsp: function() {
	      jQuery('#sp_url').select();
	      document.execCommand("copy");
	      return this.copied_sp = true;
	    },
	    copyURLll: function() {
	      jQuery('#ll_url').select();
	      document.execCommand("copy");
	      return this.copied_ll = true;
	    },
	    copyApiToken: function() {
	      jQuery('input#api-token').select();
	      return document.execCommand("copy");
	    },
	    toggleSalesforceMarkAs: function() {
	      if (this.salesforce_setting.mark_as === 'lead_and_opportunity') {
	        return this.salesforce_setting.mark_as = 'only_lead';
	      } else {
	        return this.salesforce_setting.mark_as = 'lead_and_opportunity';
	      }
	    },
	    toggleSalesforceSendTo: function() {
	      if (this.salesforce_setting.send_to === 'responsible') {
	        return this.salesforce_setting.send_to = 'queue';
	      } else {
	        return this.salesforce_setting.send_to = 'responsible';
	      }
	    },
	    toggleMarkAddContatsToNectar: function() {
	      return this.create_on_add_to_nectar = !this.create_on_add_to_nectar;
	    },
	    saveNectar: function() {
	      return this.$validator.validateAll({
	        nectar_api_key: this.nectar_api_key
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.updateNectarApiKey();
	          }
	        };
	      })(this));
	    },
	    updateNectarApiKey: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        nectar_api_key: this.nectar_api_key,
	        nectar_setting_attributes: {
	          id: this.nectar_setting.id,
	          pipeline_id: this.nectar_setting.pipeline_id,
	          stage_number: this.nectar_setting.stage_number,
	          send_tasks: this.nectar_setting.send_tasks,
	          triggers: this.nectar_setting.triggers,
	          responsible: this.nectar_setting.responsible
	        }
	      };
	      return new UsersResource().update(this.updateNectarApiKeySuccess, this.handleApiErrors, params);
	    },
	    updateSalesforceSetting: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        salesforce_setting_attributes: {
	          id: this.salesforce_setting.id,
	          mark_as: this.salesforce_setting.mark_as,
	          send_to: this.salesforce_setting.send_to,
	          triggers: this.salesforce_setting.triggers
	        }
	      };
	      return new UsersResource().update(this.updateSalesforceSettingSuccess, this.handleApiErrors, params);
	    },
	    removeNectarApiKey: function() {
	      this.nectar_api_key = null;
	      return this.updateNectarApiKey();
	    },
	    updateSalesforceSettingSuccess: function(data, response) {
	      Loader.off();
	      alertify.success(this.$t('general.feedback.settingUpdated'));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      return this.closeForm();
	    },
	    updateNectarApiKeySuccess: function(data, response) {
	      var intercom_event_name, message_action;
	      Loader.off();
	      message_action = data.user.nectar_api_key ? this.$t('general.actions.connectedTo') : this.$t('general.actions.disconnectedTo');
	      alertify.success(this.$t('integrations.feedback.nectarSuccess'));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      this.nectar_api_key = Session.current_user.nectar_api_key;
	      this.closeForm();
	      intercom_event_name = data.user.nectar_api_key ? this.$t('integrations.feedback.connectedToNectar') : this.$t('integrations.feedback.disconnectedToNectar');
	      return IntercomCtrl.trackEvent(intercom_event_name);
	    },
	    openConectPipedriveForm: function() {
	      this.show_form = !this.show_form;
	      this.show_form_bcc = false;
	      this.show_form_salesforce = false;
	      this.show_form_sp = false;
	      this.show_form_ll = false;
	      this.show_form_nectar = false;
	      return this.show_form_rd = false;
	    },
	    openConectNectarForm: function() {
	      if (!this.nectar_setting.responsible) {
	        this.nectar_setting.responsible = Session.current_user.email;
	      }
	      this.show_form_nectar = !this.show_form_nectar;
	      this.show_form_rd = false;
	      this.show_form = false;
	      this.show_form_bcc = false;
	      this.show_form_salesforce = false;
	      this.show_form_sp = false;
	      return this.show_form_ll = false;
	    },
	    openConectSalesForceForm: function() {
	      this.show_form_salesforce = !this.show_form_salesforce;
	      this.show_form_nectar = false;
	      this.show_form_rd = false;
	      this.show_form = false;
	      this.show_form_bcc = false;
	      this.show_form_sp = false;
	      return this.show_form_ll = false;
	    },
	    openConectRDForm: function() {
	      this.show_form_rd = !this.show_form_rd;
	      this.show_form_nectar = false;
	      this.show_form = false;
	      this.show_form_bcc = false;
	      this.show_form_salesforce = false;
	      this.show_form_sp = false;
	      return this.show_form_ll = false;
	    },
	    openConectSPForm: function() {
	      this.show_form_sp = !this.show_form_sp;
	      this.show_form_ll = false;
	      this.show_form_rd = false;
	      this.show_form_nectar = false;
	      this.show_form = false;
	      this.show_form_bcc = false;
	      return this.show_form_salesforce = false;
	    },
	    openConectLLForm: function() {
	      this.show_form_ll = !this.show_form_ll;
	      this.show_form_sp = false;
	      this.show_form_rd = false;
	      this.show_form_nectar = false;
	      this.show_form = false;
	      this.show_form_bcc = false;
	      return this.show_form_salesforce = false;
	    },
	    saveBcc: function() {
	      return this.updatePipedriveBcc();
	    },
	    saveWebhookUrl: function() {
	      return this.$validator.validateAll({
	        webhook_url: this.webhook_url
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.updateWebhookURL();
	          }
	        };
	      })(this));
	    },
	    updatePipedriveBcc: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        crm_setting_attributes: {
	          id: this.crm_setting.id,
	          bcc_send_email: this.crm_setting.bcc_send_email,
	          bcc_reply_email: this.crm_setting.bcc_reply_email
	        }
	      };
	      return new UsersResource().update(this.updatecrmBccSuccess, this.handleApiErrors, params);
	    },
	    updatecrmBccSuccess: function(data, response) {
	      Loader.off();
	      alertify.success(this.$t('general.feedback.settingSaved'));
	      this.trackIntercomBccUpdate(data.user.crm_setting);
	      Session.signIn(response.body.user);
	      this.crm_setting = Session.current_user.crm_setting;
	      return this.closeForm();
	    },
	    updateWebhookSuccess: function(data, response) {
	      Loader.off();
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      alertify.success(this.$t('general.feedback.settingSaved'));
	      return this.closeForm();
	    },
	    updateWebhookURL: function() {
	      var params;
	      Loader.on();
	      if (this.webhook_triggers.on_created === void 0) {
	        this.webhook_triggers = Session.current_user.webhook_setting.triggers;
	      }
	      params = {
	        id: Session.current_user.id,
	        webhooks_attributes: {
	          id: Session.current_user.webhook_setting.id || null,
	          event: 'ChangeContactStage',
	          url: this.webhook_url,
	          triggers: this.webhook_triggers,
	          user_change: this.webhook_triggers.on_change
	        }
	      };
	      return new UsersResource().update(this.updateWebhookSuccess, this.webHookErrors, params);
	    },
	    saveSharpSpring: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        sharpspring_setting_attributes: {
	          id: Session.current_user.sharpspring_setting.id || null,
	          triggers: this.sharpspring_setting.triggers,
	          use_carousel: this.sharpspring_setting.use_carousel
	        }
	      };
	      return new UsersResource().update(this.updateWebhookSuccess, this.SharpSpringErrors, params);
	    },
	    SharpSpringErrors: function(data, response) {
	      Loader.off();
	      return alertify.error(this.$t('general.feedback.updateError'));
	    },
	    saveLeadlovers: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        leadlovers_setting_attributes: {
	          id: Session.current_user.leadlovers_setting.id || null,
	          triggers: this.leadlovers_setting.triggers,
	          use_carousel: this.leadlovers_setting.use_carousel
	        }
	      };
	      return new UsersResource().update(this.updateLeadloversSuccess, this.LeadloversErrors, params);
	    },
	    removeLeadlovers: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        leadlovers_setting_attributes: {
	          id: this.leadlovers_setting.id,
	          _destroy: true
	        }
	      };
	      return new UsersResource().update(this.updateLeadloversSuccess, this.LeadloversErrors, params);
	    },
	    updateLeadloversSuccess: function(data, response) {
	      Loader.off();
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      alertify.success(this.$t('general.feedback.settingSaved'));
	      return window.location.reload();
	    },
	    LeadloversErrors: function(data, response) {
	      Loader.off();
	      return alertify.error(this.$t('general.feedback.updateError'));
	    },
	    webHookErrors: function(data, response) {
	      Loader.off();
	      return alertify.error(this.$t('general.feedback.invalidUrl'));
	    },
	    openBccForm: function() {
	      this.show_form_bcc = !this.show_form_bcc;
	      return this.show_form = false;
	    },
	    closeForm: function() {
	      this.nectar_api_key = '';
	      this.show_form = false;
	      this.show_form_bcc = false;
	      this.show_form_nectar = false;
	      this.show_form_salesforce = false;
	      return this.errors.clear();
	    },
	    trackIntercomBccUpdate: function(pipedrive_setting) {
	      var metadata;
	      metadata = {
	        'BCC para envio': pipedrive_setting.bcc_send__email || this.$t('general.actions.notConfigured'),
	        'BCC para resposta': pipedrive_setting.bcc_reply_email || this.$t('general.actions.notConfigured')
	      };
	      return IntercomCtrl.trackEvent(this.$t('integrations.feedback.configuredBCCPipedrive'), metadata);
	    },
	    redirectToNylasOauthUrl: function() {
	      if (!this.current_user.default_user) {
	        return alertify.error(this.$t('integrations.actions.email.setUp.error.defaultUserError'));
	      }
	      if (this.email_authorized) {
	        return this.undoNylasConnection();
	      } else {
	        Loader.on();
	        return window.location = this.nylasOauthUrl;
	      }
	    },
	    undoNylasConnection: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        undo_nylas_connection: true
	      };
	      return new UsersResource().update(this.updateNylasConnectionSuccess, this.webHookErrors, params);
	    },
	    updateNylasConnectionSuccess: function(data, response) {
	      Loader.off();
	      Session.current_user.email_authorized = false;
	      Session.current_user.email_account_status = null;
	      return alertify.success(this.$t('general.feedback.settingUpdated'));
	    },
	    authorizeNylas: function() {
	      var code;
	      Loader.on();
	      code = this.$route.query.code;
	      this.$router.replace({
	        name: 'integrations'
	      });
	      IntegrationsResource.authorize_nylas(this.authorizeNylasSuccess, this.authorizeNylasFailure, {
	        code: code
	      });
	      return EventsBus.$emit('email-account-connected');
	    },
	    authorizeNylasSuccess: function(response) {
	      Session.updateCurrentUser(response.body.user);
	      this.current_user = Session.current_user;
	      Loader.off();
	      alertify.success(this.$t('general.feedback.configEmailSuccess'));
	      return setTimeout(this.validateCalendar, 4000);
	    },
	    authorizeNylasFailure: function(response) {
	      Loader.off();
	      return alertify.error(response.body.error, 10);
	    },
	    validateCalendar: function() {
	      return jQuery.ajax({
	        url: ("https://api.nylas.com") + "/calendars",
	        type: 'GET',
	        headers: {
	          'Authorization': Session.current_user.nylas_setting.access_token
	        },
	        success: this.successLoadCalendar,
	        error: this.failureLoadCalendar
	      });
	    },
	    successLoadCalendar: function(response) {
	      var calendar, i, len, params;
	      for (i = 0, len = response.length; i < len; i++) {
	        calendar = response[i];
	        if (calendar.name === Session.current_user.email) {
	          params = {
	            id: Session.current_user.id,
	            nylas_setting_attributes: {
	              id: Session.current_user.nylas_setting.id,
	              calendar_id: calendar.id
	            }
	          };
	          new UsersResource().update(this.updateCalendarSuccess, this.handleApiErrors, params);
	          return;
	        }
	      }
	      return this.validateReadOnlyCalendar(response);
	    },
	    validateReadOnlyCalendar: function(response) {
	      var calendar, i, len, params;
	      for (i = 0, len = response.length; i < len; i++) {
	        calendar = response[i];
	        if (!calendar.read_only) {
	          params = {
	            id: Session.current_user.id,
	            nylas_setting_attributes: {
	              id: Session.current_user.nylas_setting.id,
	              calendar_id: calendar.id
	            }
	          };
	          new UsersResource().update(this.updateCalendarSuccess, this.handleApiErrors, params);
	          return;
	        }
	      }
	      return setTimeout(this.validateCalendar, 4000);
	    },
	    failureLoadCalendar: function(response) {
	      return alertify.error(this.$t('integrations.feedback.calendarFail'));
	    },
	    updateCalendarSuccess: function(data, response) {
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      alertify.success(this.$t('integrations.feedback.calendarSuccess'));
	      return window.location.reload();
	    },
	    redirectToSalesforceOauthUrl: function() {
	      var intercom_event_name, params;
	      if (this.salesforce_authorized) {
	        Loader.on();
	        params = {
	          id: Session.current_user.id,
	          salesforce_setting_attributes: {
	            id: this.salesforce_setting.id,
	            _destroy: 1
	          }
	        };
	        new UsersResource().update(this.updateSalesforceSettingSuccess, this.handleApiErrors, params);
	        this.salesforce_authorized = false;
	        alertify.success(this.$t('integrations.feedback.salesforceDisconnectSuccess'));
	        intercom_event_name = this.$t('integrations.feedback.salesforceDisconnectEvent');
	        return IntercomCtrl.trackEvent(intercom_event_name);
	      } else {
	        Loader.on();
	        if (window.parent && Session.current_user.new_ui) {
	          return window.parent.postMessage({
	            type: "redirect-integration",
	            route: this.salesforceOauthUrl
	          }, "*");
	        }
	        return window.location = this.salesforceOauthUrl;
	      }
	    },
	    authorizeSalesforce: function() {
	      var code, ref, sand;
	      Loader.on();
	      code = this.$route.query.code;
	      sand = (ref = this.$route.query.state.split(',')[1] === 'true') != null ? ref : {
	        "true": false
	      };
	      this.$router.replace({
	        name: 'integrations'
	      });
	      IntegrationsResource.authorize_salesforce(this.authorizeSalesforceSuccess, this.authorizeSalesforceFailure, {
	        code: code,
	        new_ui: Session.current_user.new_ui,
	        sandbox_test: sand
	      });
	      return EventsBus.$emit('salesforce-account-connected');
	    },
	    authorizeSalesforceSuccess: function(response) {
	      var intercom_event_name;
	      Session.updateCurrentUser(response.body.user);
	      this.current_user = Session.current_user;
	      Loader.off();
	      alertify.success(this.$t('integrations.feedback.salesforceConnectSuccess'));
	      this.salesforce_authorized = true;
	      intercom_event_name = this.$t('integrations.feedback.salesforceConnectEvent');
	      return IntercomCtrl.trackEvent(intercom_event_name);
	    },
	    authorizeSalesforceFailure: function(response) {
	      Loader.off();
	      return alertify.error(response.body.error, 10);
	    },
	    updateRdStationSetting: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        rd_station_setting_attributes: {
	          id: this.rd_station_setting.id,
	          mark_lead_as_sale: this.selectedRD,
	          use_carousel: this.rd_station_setting.use_carousel
	        }
	      };
	      return new UsersResource().update(this.updateRdstationSettingSuccess, this.handleApiErrors, params);
	    },
	    redirectToRdstationOauthUrl: function() {
	      var intercom_event_name, params;
	      if (this.rdstation_authorized) {
	        Loader.on();
	        params = {
	          id: Session.current_user.id,
	          rd_station_setting_attributes: {
	            id: this.rd_station_setting.id,
	            _destroy: 1
	          }
	        };
	        new UsersResource().update(this.updateRdstationSettingSuccess, this.handleApiErrors, params);
	        this.rdstation_authorized = false;
	        alertify.success(this.$t('integrations.feedback.rdStationDisconnectSuccess'));
	        this.$router.push({
	          path: "/configuracoes/integracao"
	        });
	        intercom_event_name = this.$t('integrations.feedback.rdStationDisconnectEvent');
	        return IntercomCtrl.trackEvent(intercom_event_name);
	      } else {
	        Loader.on();
	        return window.location = this.rdStationOauthUrl;
	      }
	    },
	    updateRdstationSettingSuccess: function(data, response) {
	      Loader.off();
	      alertify.success(this.$t('general.feedback.settingUpdated'));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      return this.closeForm();
	    },
	    authorizeRdstation: function() {
	      var code;
	      Loader.on();
	      code = this.$route.query.code;
	      this.$router.replace({
	        name: 'integrations'
	      });
	      IntegrationsResource.authorize_rdstation(this.authorizeRdstationSuccess, this.authorizeRdstationFailure, {
	        code: code,
	        new_ui: Session.current_user.new_ui
	      });
	      return EventsBus.$emit('rdstation-account-connected');
	    },
	    authorizeRdstationSuccess: function(response) {
	      var intercom_event_name;
	      Session.updateCurrentUser(response.body.user);
	      this.current_user = Session.current_user;
	      Loader.off();
	      alertify.success(this.$t('integrations.feedback.rdStationConnectSuccess'));
	      this.rdstation_authorized = true;
	      this.$router.push({
	        path: "/configuracoes/integracao?setting=rd_station"
	      });
	      intercom_event_name = this.$t('integrations.feedback.rdStationConnectEvent');
	      return IntercomCtrl.trackEvent(intercom_event_name);
	    },
	    authorizeRdstationFailure: function(response) {
	      Loader.off();
	      return alertify.error(response.body.error, 10);
	    },
	    setStagesWebhook: function(data) {
	      return this.webhook_triggers = data;
	    },
	    setStagesNectar: function(data) {
	      return this.nectar_setting.triggers = data;
	    },
	    setStagesSalesforce: function(data) {
	      return this.salesforce_setting.triggers = data;
	    },
	    toggleUseCarouselRd: function() {
	      return this.rd_station_setting.use_carousel = !this.rd_station_setting.use_carousel;
	    },
	    toggleUseCarouselSp: function() {
	      return this.sharpspring_setting.use_carousel = !this.sharpspring_setting.use_carousel;
	    },
	    toggleSandboxTestSf: function() {
	      return this.salesforce_setting.sandbox_test = !this.salesforce_setting.sandbox_test;
	    },
	    toIntegration: function(setting) {
	      var path;
	      path = '/configuracoes/integracao?setting=';
	      path += setting;
	      return this.$router.push({
	        path: path
	      });
	    }
	  },
	  created: function() {
	    return setTimeout((function(_this) {
	      return function() {
	        var ref, ref1;
	        if (_this.$route.query.state === 'nylas' && _this.$route.query.code) {
	          _this.authorizeNylas();
	        }
	        if (((ref = _this.$route.query) != null ? (ref1 = ref.state) != null ? ref1.split(',')[0] : void 0 : void 0) === 'salesforce' && _this.$route.query.code) {
	          _this.authorizeSalesforce();
	        }
	        if (_this.$route.query.state === 'rdstation' && _this.$route.query.code) {
	          return _this.authorizeRdstation();
	        }
	      };
	    })(this), 500);
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    triggerStages: __webpack_require__(7),
	    dealLost: __webpack_require__(32),
	    propertiesMatching: __webpack_require__(13),
	    stagesMatching: __webpack_require__(24)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      cv_crm_setting: Session.current_user.cv_crm_setting.id != null ? Session.current_user.cv_crm_setting : new CvCrmSetting(),
	      add_contacts_from_cv_crm: Session.current_user.cv_crm_setting.add_contacts_from_cv_crm,
	      domain: Session.current_user.cv_crm_setting.domain,
	      email: Session.current_user.cv_crm_setting.email,
	      cv_crm_api_token: Session.current_user.cv_crm_api_token || '',
	      url_cv_crm: 'cvcrm.com.br/api/v1/cv/',
	      api_fields: [],
	      stage_lost: false,
	      integration_stages: [],
	      matching: [],
	      matching_stages: [],
	      update_stages_all_users: false,
	      pipelines: [],
	      selected_pipeline: {
	        stage_query: null
	      },
	      loading_api_key: false
	    };
	  },
	  watch: {
	    email: function() {
	      return this.loadStages();
	    },
	    domain: function() {
	      return this.loadStages();
	    },
	    cv_crm_api_token: function() {
	      return this.loadStages();
	    }
	  },
	  methods: {
	    copy: function() {
	      navigator.clipboard.writeText(this.webhook_url);
	      return alertify.success(this.$t('general.actions.copied'));
	    },
	    toggleMarkAddContatsFromCV: function() {
	      return this.add_contacts_from_cv_crm = !this.add_contacts_from_cv_crm;
	    },
	    save: function() {
	      return this.$validator.validateAll({
	        cv_crm_api_token: this.cv_crm_api_token
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.updateCvCrmApiToken();
	          }
	        };
	      })(this));
	    },
	    updateCvCrmApiToken: function() {
	      var i, item, j, k, len, len1, len2, metadata, params, property, quant, ref, ref1, ref2, stage;
	      ref = this.matching_stages;
	      for (i = 0, len = ref.length; i < len; i++) {
	        stage = ref[i];
	        if (!stage.reev || !stage.integration) {
	          return alertify.error(this.$t('integrations.feedback.requiredFunnelStageMap'));
	        }
	      }
	      quant = {};
	      ref1 = this.matching_stages;
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        item = ref1[j];
	        if (item.integration !== this.$t('integrations.label.ignore')) {
	          if (quant[item.integration] === void 0 || quant[item.integration] === (0/0)) {
	            quant[item.integration] = 0;
	          }
	          quant[item.integration] += 1;
	        }
	        if (quant[item.integration] > 1) {
	          return alertify.error(this.$t('integrations.feedback.onlyIgnoreStage'));
	        }
	      }
	      ref2 = this.matching;
	      for (k = 0, len2 = ref2.length; k < len2; k++) {
	        property = ref2[k];
	        property.type = this.api_fields.find(function(field) {
	          return field.key === property.integration;
	        }).type;
	      }
	      metadata = this.cv_crm_setting.metadata;
	      if (this.integration_stages.length > 0) {
	        metadata['default_stage'] = this.integration_stages[0].id;
	      }
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        cv_crm_api_token: this.cv_crm_api_token,
	        update_stages_all_users: this.update_stages_all_users,
	        user_to_update_stages: this.user_to_update_stages,
	        cv_crm_setting_attributes: {
	          id: this.cv_crm_setting.id,
	          email: this.email,
	          domain: this.domain,
	          add_contacts_from_cv_crm: this.add_contacts_from_cv_crm,
	          triggers: this.cv_crm_setting.triggers,
	          metadata: metadata,
	          properties_matching: this.matching,
	          stages_matching: this.matching_stages
	        }
	      };
	      return new UsersResource().update(this.updateCvCrmApiTokenSuccess, this.cvCrmErrors, params);
	    },
	    removeCvCrmApiToken: function() {
	      var params;
	      this.cv_crm_api_token = null;
	      this.matching = [];
	      this.matching_stages = [];
	      this.integration_stages = [];
	      this.cv_crm_setting.stages_matching = [];
	      this.domain = '';
	      this.email = '';
	      this.pipelines = [];
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        cv_crm_api_token: this.cv_crm_api_token,
	        cv_crm_setting_attributes: {
	          id: this.cv_crm_setting.id,
	          _destroy: true
	        }
	      };
	      return new UsersResource().update(this.updateCvCrmApiTokenSuccess, this.cvCrmErrors, params);
	    },
	    updateCvCrmApiTokenSuccess: function(data, response) {
	      var intercom_event_name, message_action;
	      Loader.off();
	      message_action = data.user.cv_crm_api_token ? this.$t('general.actions.connectedTo') : this.$t('general.actions.disconnectedTo');
	      alertify.success(this.$t('integrations.feedback.cvCrmSuccess', {
	        message_action: message_action
	      }));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      this.cv_crm_api_token = data.user.cv_crm_api_token;
	      this.domain = data.user.cv_crm_setting.domain;
	      this.email = data.user.cv_crm_setting.email;
	      this.cv_crm_setting.email = this.email;
	      this.cv_crm_setting.domain = this.domain;
	      this.cv_crm_setting.stage_id = data.user.cv_crm_setting.stage_id;
	      intercom_event_name = data.user.cv_crm_api_token ? this.$t('integrations.feedback.connectedToCvCrm') : this.$t('integrations.feedback.disconnectedToCvCrm');
	      return IntercomCtrl.trackEvent(intercom_event_name);
	    },
	    cvCrmErrors: function(response, options) {
	      var error, i, len, ref, results;
	      if (options == null) {
	        options = {};
	      }
	      this.handleApiErrors(response, options);
	      if (response.body.cv_crm_setting) {
	        ref = response.body.cv_crm_setting;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          error = ref[i];
	          results.push(this.errors.add(error, this.$t('general.feedback.invalid')));
	        }
	        return results;
	      }
	    },
	    setStagesCvCrm: function(data) {
	      this.cv_crm_setting.triggers = data;
	      return this.update_stage_lost(data.stages);
	    },
	    setMarkAs: function(data) {
	      return this.cv_crm_setting.mark_as = data;
	    },
	    update_stage_lost: function(stages) {
	      var lost_stage;
	      if (stages == null) {
	        stages = {};
	      }
	      lost_stage = stages.filter(function(item) {
	        return item === 'lost';
	      });
	      if (lost_stage.length !== 0) {
	        return this.stage_lost = true;
	      }
	      return this.stage_lost = false;
	    },
	    matchingUpdated: function(data) {
	      return this.matching = data.filter(function(field) {
	        return !(field.reev === void 0 || field.reev === '');
	      });
	    },
	    matchingStagesUpdated: function(data) {
	      return this.matching_stages = data;
	    },
	    updateUsers: function(data) {
	      this.update_stages_all_users = data.update_all_users;
	      return this.user_to_update_stages = data.user_id;
	    },
	    loadStages: function() {
	      if (!this.cv_crm_api_token || !this.email || !this.domain) {
	        return;
	      }
	      if (this.cv_crm_api_token.length < 40) {
	        return;
	      }
	      return this.$http.get("https://" + this.domain + "." + this.url_cv_crm + "workflow/leads?funcionalidade=leads", {
	        headers: {
	          email: this.email,
	          token: this.cv_crm_api_token
	        }
	      }).then(((function(_this) {
	        return function(response) {
	          return _this.integration_stages = response.body.map(function(situation) {
	            return {
	              name: situation.nome,
	              id: situation.idsituacao
	            };
	          });
	        };
	      })(this)), ((function(_this) {
	        return function(response) {};
	      })(this)));
	    },
	    closeForm: function() {
	      return this.$router.push({
	        path: '/configuracoes/integracoes'
	      });
	    }
	  },
	  computed: {
	    lost_checked: function() {
	      var lost_stage;
	      lost_stage = this.cv_crm_setting.triggers.stages.filter(function(item) {
	        return item === 'lost';
	      });
	      if (lost_stage.length !== 0) {
	        return true;
	      }
	      return false;
	    },
	    webhook_url: function() {
	      return ("https://api.reev.co") + "/webhooks/cv_crm/import_contacts?token=" + this.current_user.authentication_token;
	    }
	  },
	  mounted: function() {
	    Tooltip.initialize();
	    return this.loadStages();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    pipedrive: __webpack_require__(102),
	    rdStation: __webpack_require__(51),
	    rdStationCrm: __webpack_require__(106),
	    salesforce: __webpack_require__(107),
	    hubspot: __webpack_require__(50),
	    cvCrm: __webpack_require__(100)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      setting: ''
	    };
	  },
	  computed: {
	    is_pipedrive: function() {
	      return this.setting === 'pipedrive';
	    },
	    is_rd_station: function() {
	      return this.setting === 'rd_station';
	    },
	    is_rd_station_crm: function() {
	      return this.setting === 'rd_station_crm';
	    },
	    is_salesforce: function() {
	      return this.setting === 'salesforce';
	    },
	    is_hubspot: function() {
	      return this.setting === 'hubspot';
	    },
	    is_cv_crm: function() {
	      return this.setting === 'cv_crm';
	    }
	  },
	  mounted: function() {
	    return this.setting = this.$router.currentRoute.query.setting;
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    triggerStages: __webpack_require__(7),
	    dealLost: __webpack_require__(32),
	    propertiesMatching: __webpack_require__(13),
	    stagesMatching: __webpack_require__(24)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      pipedrive_setting: Session.current_user.pipedrive_setting.id != null ? Session.current_user.pipedrive_setting : new PipedriveSetting(),
	      add_contacts_to_pipedrive: Session.current_user.pipedrive_setting.add_contacts_to_pipedrive,
	      pipedrive_api_key: Session.current_user.pipedrive_api_key || '',
	      url_pipedrive: 'https://api.pipedrive.com/v1/',
	      api_fields: [],
	      stage_lost: false,
	      integration_stages: [],
	      matching: [],
	      matching_stages: [],
	      update_stages_all_users: false,
	      pipelines: [],
	      selected_pipeline: {
	        stage_query: null
	      },
	      loading_api_key: false,
	      copy_settings: false,
	      user_pipe_setting: null,
	      users_options_pipedrive: [],
	      pipedrive_setting_copy: []
	    };
	  },
	  methods: {
	    toggleMarkAddContatsToPipedrive: function() {
	      return this.add_contacts_to_pipedrive = !this.add_contacts_to_pipedrive;
	    },
	    toggleCopySettings: function() {
	      return this.copy_settings = !this.copy_settings;
	    },
	    loadUsersPipedrive: function() {
	      var company_id, ref, roles;
	      roles = [User.ROLES['seller'], User.ROLES['sdr'], User.ROLES['manager']];
	      company_id = typeof Session !== "undefined" && Session !== null ? (ref = Session.current_company) != null ? ref.id : void 0 : void 0;
	      return new UsersResource().index(this.loadUsersPipedriveSuccess, null, {
	        params: {
	          q: {
	            s: 'name asc',
	            role_in: roles
	          },
	          company_id: company_id
	        }
	      });
	    },
	    loadUsersPipedriveSuccess: function(data) {
	      var i, len, ref, user;
	      ref = data.users;
	      for (i = 0, len = ref.length; i < len; i++) {
	        user = ref[i];
	        if (user.pipedrive_api_key !== null) {
	          this.pipedrive_setting_copy.push(user);
	          this.users_options_pipedrive.push({
	            value: {
	              user_id: user.id
	            },
	            text: user.firstAndLastName()
	          });
	        }
	      }
	      return this.users_options_pipedrive.unshift({
	        value: null,
	        text: this.$t('general.label.user')
	      });
	    },
	    copy: function() {
	      var data, data_pipe;
	      if (this.user_pipe_setting.user_id !== null) {
	        data = this.pipedrive_setting_copy.filter((function(_this) {
	          return function(item) {
	            return item.id === _this.user_pipe_setting.user_id;
	          };
	        })(this));
	        data_pipe = data[0].pipedrive_setting;
	        this.add_contacts_to_pipedrive = data_pipe.add_contacts_to_pipedrive;
	        this.pipedrive_setting.mark_as = data_pipe.mark_as;
	        this.pipedrive_setting.triggers = data_pipe.triggers;
	        this.pipedrive_setting.properties_matching = data_pipe.properties_matching;
	        this.pipedrive_setting.metadata.pipeline_id = data_pipe.metadata.pipeline_id;
	        this.selected_pipeline = data_pipe.metadata.pipeline_id;
	        return this.pipedrive_setting.stages_matching = data_pipe.stages_matching;
	      }
	    },
	    save: function() {
	      return this.$validator.validateAll({
	        pipedrive_api_key: this.pipedrive_api_key
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.updatePipedriveApiKey();
	          }
	        };
	      })(this));
	    },
	    updatePipedriveApiKey: function() {
	      var i, item, j, k, len, len1, len2, metadata, params, property, quant, ref, ref1, ref2, stage;
	      ref = this.matching_stages;
	      for (i = 0, len = ref.length; i < len; i++) {
	        stage = ref[i];
	        if (!stage.reev || !stage.integration) {
	          return alertify.error(this.$t('integrations.feedback.requiredFunnelStageMap'));
	        }
	      }
	      quant = {};
	      ref1 = this.matching_stages;
	      for (j = 0, len1 = ref1.length; j < len1; j++) {
	        item = ref1[j];
	        if (item.integration !== this.$t('integrations.label.ignore')) {
	          if (quant[item.integration] === void 0 || quant[item.integration] === (0/0)) {
	            quant[item.integration] = 0;
	          }
	          quant[item.integration] += 1;
	        }
	        if (quant[item.integration] > 1) {
	          return alertify.error(this.$t('integrations.feedback.onlyIgnoreStage'));
	        }
	      }
	      ref2 = this.matching;
	      for (k = 0, len2 = ref2.length; k < len2; k++) {
	        property = ref2[k];
	        property.type = this.api_fields.find(function(field) {
	          return field.key === property.integration;
	        }).type;
	      }
	      metadata = this.pipedrive_setting.metadata;
	      if (this.integration_stages.length > 0) {
	        metadata['default_stage'] = this.integration_stages[0].id;
	      }
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        pipedrive_api_key: this.pipedrive_api_key,
	        update_stages_all_users: this.update_stages_all_users,
	        user_to_update_stages: this.user_to_update_stages,
	        pipedrive_setting_attributes: {
	          id: this.pipedrive_setting.id,
	          stage_id: this.pipedrive_setting.stage_id,
	          add_contacts_to_pipedrive: this.add_contacts_to_pipedrive,
	          triggers: this.pipedrive_setting.triggers,
	          metadata: metadata,
	          properties_matching: this.matching,
	          stages_matching: this.matching_stages,
	          mark_as: this.pipedrive_setting.mark_as
	        }
	      };
	      return new UsersResource().update(this.updatePipedriveApiKeySuccess, this.pipedriveErrors, params);
	    },
	    removePipedriveApiKey: function() {
	      var params;
	      this.pipedrive_api_key = null;
	      this.matching = [];
	      this.matching_stages = [];
	      this.integration_stages = [];
	      this.pipedrive_setting.stages_matching = [];
	      this.pipelines = [];
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        pipedrive_api_key: this.pipedrive_api_key,
	        pipedrive_setting_attributes: {
	          id: this.pipedrive_setting.id,
	          _destroy: true
	        }
	      };
	      return new UsersResource().update(this.updatePipedriveApiKeySuccess, this.pipedriveErrors, params);
	    },
	    updatePipedriveApiKeySuccess: function(data, response) {
	      var intercom_event_name, message_action;
	      Loader.off();
	      message_action = data.user.pipedrive_api_key ? this.$t('general.actions.connectedTo') : this.$t('general.actions.disconnectedTo');
	      alertify.success(this.$t('integrations.feedback.pipedriveSuccess'));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      this.pipedrive_api_key = data.user.pipedrive_api_key;
	      this.pipedrive_setting.stage_id = data.user.pipedrive_setting.stage_id;
	      intercom_event_name = data.user.pipedrive_api_key ? this.$t('integrations.feedback.connectedToPipedrive') : this.$t('integrations.feedback.disconnectedToPipedrive');
	      return IntercomCtrl.trackEvent(intercom_event_name);
	    },
	    pipedriveErrors: function(response, options) {
	      var error, i, len, ref, results;
	      if (options == null) {
	        options = {};
	      }
	      this.handleApiErrors(response, options);
	      if (response.body.pipedrive_setting) {
	        ref = response.body.pipedrive_setting;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          error = ref[i];
	          results.push(this.errors.add(error, this.$t('general.feedback.invalid')));
	        }
	        return results;
	      }
	    },
	    updateWebhookSuccess: function(data, response) {
	      Loader.off();
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      alertify.success(this.$t('general.feedback.settingSaved'));
	      return this.closeForm();
	    },
	    setStagesPipedrive: function(data) {
	      this.pipedrive_setting.triggers = data;
	      return this.update_stage_lost(data.stages);
	    },
	    setMarkAs: function(data) {
	      return this.pipedrive_setting.mark_as = data;
	    },
	    update_stage_lost: function(stages) {
	      var lost_stage;
	      if (stages == null) {
	        stages = {};
	      }
	      lost_stage = stages.filter(function(item) {
	        return item === 'lost';
	      });
	      if (lost_stage.length !== 0) {
	        return this.stage_lost = true;
	      }
	      return this.stage_lost = false;
	    },
	    matchingUpdated: function(data) {
	      return this.matching = data.filter(function(field) {
	        return !(field.reev === void 0 || field.reev === '');
	      });
	    },
	    matchingStagesUpdated: function(data) {
	      return this.matching_stages = data;
	    },
	    updateUsers: function(data) {
	      this.update_stages_all_users = data.update_all_users;
	      return this.user_to_update_stages = data.user_id;
	    },
	    getTypeField: function(type) {
	      if (type === 'enum') {
	        return 'enum';
	      }
	      if (type === 'phone') {
	        return 'tel';
	      }
	      if (type === 'date') {
	        return 'date';
	      }
	      if (type === 'double') {
	        return 'number';
	      }
	      if (type === 'int') {
	        return 'number';
	      }
	      return 'text';
	    },
	    loadPipedriveFields: function() {
	      if (this.pipedrive_api_key === '') {
	        return;
	      }
	      this.loadFields();
	      return this.loadPipelines();
	    },
	    loadFields: function() {
	      if (!Array.isArray(this.pipedrive_setting.properties_matching)) {
	        this.pipedrive_setting.properties_matching = new PipedriveSetting().properties_matching;
	      }
	      if (this.pipedrive_setting.properties_matching === {}) {
	        this.pipedrive_setting.properties_matching = [];
	      }
	      this.loadPersonFields();
	      return this.loadDealFields();
	    },
	    loadPersonFields: function() {
	      var self;
	      self = this;
	      return this.$http.get(this.url_pipedrive + 'personFields?api_token=' + this.pipedrive_api_key).then(((function(_this) {
	        return function(personResponse) {
	          var fields;
	          fields = personResponse.body.data.filter(function(field) {
	            return field.bulk_edit_allowed && field.key !== 'name' && field.key !== 'email' && field.key !== 'visible_to' && field.key !== 'owner_id' && field.key !== 'org_id';
	          });
	          return _this.api_fields = _this.api_fields.concat(fields.map(function(field) {
	            return {
	              origin: 'person',
	              type: self.getTypeField(field.field_type),
	              key: field.key,
	              name: field.name
	            };
	          }));
	        };
	      })(this)), ((function(_this) {
	        return function(personResponse) {};
	      })(this)));
	    },
	    loadDealFields: function() {
	      var self;
	      self = this;
	      return this.$http.get(this.url_pipedrive + 'dealFields?api_token=' + this.pipedrive_api_key).then(((function(_this) {
	        return function(dealResponse) {
	          var fields;
	          fields = dealResponse.body.data.filter(function(field) {
	            return field.bulk_edit_allowed && field.key !== 'title' && field.key !== 'org_id' && field.key !== 'status' && field.key !== 'stage_id' && ['user', 'people', 'stage'].indexOf(field.field_type) === -1;
	          });
	          return _this.api_fields = _this.api_fields.concat(fields.map(function(field) {
	            return {
	              origin: 'deal',
	              type: self.getTypeField(field.field_type),
	              key: field.key,
	              name: field.name
	            };
	          }));
	        };
	      })(this)), ((function(_this) {
	        return function(dealResponse) {};
	      })(this)));
	    },
	    loadStages: function(pipeline_id) {
	      if (pipeline_id == null) {
	        pipeline_id = this.pipedrive_setting.metadata.pipeline_id;
	      }
	      if (!pipeline_id) {
	        return this.loadPipelines();
	      }
	      return this.$http.get(this.url_pipedrive + 'stages?pipeline_id=' + pipeline_id + '&api_token=' + this.pipedrive_api_key).then(((function(_this) {
	        return function(response) {
	          return _this.integration_stages = response.body.data.map(function(stage) {
	            return {
	              name: stage.name,
	              id: stage.id
	            };
	          });
	        };
	      })(this)), ((function(_this) {
	        return function(response) {};
	      })(this)));
	    },
	    loadPipelines: function() {
	      return this.$http.get(this.url_pipedrive + 'pipelines?api_token=' + this.pipedrive_api_key).then(((function(_this) {
	        return function(response) {
	          var i, len, pipeline, ref;
	          _this.pipelines = response.body.data.map(function(pipeline) {
	            return {
	              value: {
	                stage_query: pipeline.id
	              },
	              text: pipeline.name
	            };
	          });
	          _this.pipelines.unshift({
	            value: {
	              stage_query: null
	            },
	            text: 'Selecione um funil'
	          });
	          ref = response.body.data;
	          for (i = 0, len = ref.length; i < len; i++) {
	            pipeline = ref[i];
	            if (_this.pipedrive_setting.metadata.pipeline_id) {
	              if (pipeline.id === _this.pipedrive_setting.metadata.pipeline_id) {
	                _this.pipedrive_setting.metadata.pipeline_id = pipeline.id;
	                return _this.loadStages();
	              }
	            } else {
	              if (pipeline.url_title === 'default') {
	                _this.pipedrive_setting.metadata.pipeline_id = pipeline.id;
	                return _this.loadStages();
	              }
	            }
	          }
	          _this.pipedrive_setting.metadata.pipeline_id = response.body.data[0].id;
	          return _this.loadStages();
	        };
	      })(this)), ((function(_this) {
	        return function(response) {};
	      })(this)));
	    },
	    loadByNewPipeline: function(data) {
	      this.pipedrive_setting.metadata.pipeline_id = data.pipeline.stage_query;
	      this.pipedrive_setting.stages_matching = [];
	      return this.loadStages(data.pipeline.stage_query);
	    },
	    closeForm: function() {
	      return this.$router.push({
	        path: '/configuracoes/integracoes'
	      });
	    },
	    validate_api_key: function() {
	      this.loading_api_key = true;
	      return this.$http.get(this.url_pipedrive + 'pipelines?api_token=' + this.pipedrive_api_key).then(((function(_this) {
	        return function(response) {
	          _this.errors.clear();
	          _this.loading_api_key = false;
	          return _this.loadPipedriveFields();
	        };
	      })(this)), ((function(_this) {
	        return function(response) {
	          _this.loading_api_key = false;
	          return _this.errors.add('pipedrive_api_key', _this.$t('integrations.feedback.invalidApiKey'));
	        };
	      })(this)));
	    }
	  },
	  computed: {
	    show_configuration_by_pipeline_name: function() {
	      var ref, ref1, ref2;
	      return ((ref = this.pipedrive_setting) != null ? ref.id : void 0) && ((ref1 = this.pipedrive_setting) != null ? (ref2 = ref1.metadata) != null ? ref2.pipeline_name : void 0 : void 0);
	    },
	    lost_checked: function() {
	      var lost_stage;
	      lost_stage = this.pipedrive_setting.triggers.stages.filter(function(item) {
	        return item === 'lost';
	      });
	      if (lost_stage.length !== 0) {
	        return true;
	      }
	      return false;
	    }
	  },
	  watch: {
	    pipedrive_api_key: function() {
	      if (this.loading_api_key) {
	        return;
	      }
	      return this.validate_api_key();
	    }
	  },
	  mounted: function() {
	    var ref;
	    Tooltip.initialize();
	    this.loadPipedriveFields();
	    this.loadUsersPipedrive();
	    this.selected_pipeline = {
	      stage_query: (ref = this.pipedrive_setting) != null ? ref.metadata.pipeline_id : void 0
	    };
	    return {
	      pipedrive_setting: function() {
	        return this.copy();
	      }
	    };
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, listItem, on_clickaway, view_model;
	
	helpers = __webpack_require__(2);
	
	listItem = __webpack_require__(105);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  components: {
	    draggable: __webpack_require__(27),
	    newCustomFieldsModal: __webpack_require__(56)
	  },
	  props: ['properties_matching', 'integration_name', 'api_fields'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      reev_fields: [],
	      original_reev_fields: [],
	      matching: [],
	      custom_fields: [],
	      edit_custom_field: new CustomField(),
	      template: listItem,
	      attrs: {
	        placeholder: this.$t('integrations.placeholder.properties_matching')
	      },
	      filter: []
	    };
	  },
	  methods: {
	    updateProperty: function(field) {
	      var i, idx, index, item, len, new_element, reev_field, ref;
	      if (!field) {
	        return;
	      }
	      idx = void 0;
	      reev_field = this.reev_fields.find(function(r_field) {
	        return r_field.key === field.key;
	      });
	      reev_field.matching = true;
	      ref = this.api_fields;
	      for (index = i = 0, len = ref.length; i < len; index = ++i) {
	        item = ref[index];
	        if (this.filter[item.key]) {
	          idx = index;
	        }
	      }
	      if (idx !== void 0) {
	        new_element = {
	          reev: field.key,
	          reev_name: field.name,
	          integration: '',
	          integration_name: ''
	        };
	        this.matching[idx] = new_element;
	        this.doMath();
	        this.matchingUpdated(this.matching);
	      }
	      this.reev_fields = this.original_reev_fields.filter(function(field) {
	        return !field.matching;
	      });
	      return this.filter = [];
	    },
	    api_field_class: function(field) {
	      var str_required;
	      str_required = 'not-required';
	      if (field != null ? field.required : void 0) {
	        str_required = 'required';
	      }
	      return [str_required];
	    },
	    updateAutocomplete: function(text) {
	      if (!text) {
	        return this.reev_fields = this.original_reev_fields;
	      }
	      return this.reev_fields = this.original_reev_fields.filter(function(field) {
	        return field.name.indexOf(text) > -1;
	      });
	    },
	    getLabel: function(field) {
	      if (field !== null) {
	        return field.name;
	      }
	      return void 0;
	    },
	    onClickaway: function() {
	      return this.$emit('hide');
	    },
	    defaultFields: function(removed_key) {
	      if (removed_key == null) {
	        removed_key = null;
	      }
	      return [
	        {
	          name: this.$t('integrations.attributes.url'),
	          key: 'url',
	          type: 'input'
	        }, {
	          name: 'LinkedIn',
	          key: 'linkedin',
	          type: 'input'
	        }, {
	          name: this.$t('integrations.attributes.position'),
	          key: 'position',
	          type: 'input'
	        }, {
	          name: this.$t('integrations.attributes.telephone'),
	          key: 'telephone',
	          type: 'tel'
	        }, {
	          name: this.$t('integrations.attributes.cellphone'),
	          key: 'cellphone',
	          type: 'tel'
	        }, {
	          name: this.$t('integrations.attributes.address'),
	          key: 'address',
	          type: 'input'
	        }, {
	          name: this.$t('integrations.attributes.variable') + ' 1',
	          key: 'variable1',
	          type: 'input'
	        }, {
	          name: this.$t('integrations.attributes.variable') + ' 2',
	          key: 'variable2',
	          type: 'input'
	        }, {
	          name: this.$t('integrations.attributes.variable') + ' 3',
	          key: 'variable3',
	          type: 'input'
	        }
	      ].filter((function(_this) {
	        return function(field) {
	          if (_this.properties_matching == null) {
	            return true;
	          }
	          return !(_this.properties_matching.find(function(matching) {
	            return matching.reev === field.key && removed_key !== field.key;
	          }));
	        };
	      })(this));
	    },
	    loadCustomFieldsSuccess: function(data) {
	      var custom, custom_in, i, item, j, len, len1, ref, ref1;
	      this.reev_fields = this.reev_fields.filter(function(filter) {
	        return !filter.custom;
	      });
	      custom_in = false;
	      ref = data.custom_fields;
	      for (i = 0, len = ref.length; i < len; i++) {
	        custom = ref[i];
	        ref1 = this.properties_matching;
	        for (j = 0, len1 = ref1.length; j < len1; j++) {
	          item = ref1[j];
	          if (item.reev === custom.field) {
	            custom_in = true;
	            break;
	          } else {
	            custom_in = false;
	          }
	        }
	        if (custom_in === false) {
	          this.reev_fields.push({
	            custom: true,
	            name: custom.field,
	            key: custom.field,
	            type: custom.kind
	          });
	        }
	      }
	      return this.original_reev_fields = this.reev_fields;
	    },
	    autoMatchFields: function() {
	      var field, i, len, math, ref, results;
	      ref = this.matching;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        field = ref[i];
	        math = this.reev_fields.find(function(reev) {
	          return reev.key === field.integration;
	        });
	        if (math) {
	          field.reev = math.key;
	          field.reev_name = math.name;
	          results.push(math.matching = true);
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    mountDefaultFields: function() {
	      var field, i, len, math, ref, results;
	      ref = this.matching;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        field = ref[i];
	        math = this.properties_matching.find(function(reev) {
	          return reev.integration === field.integration && reev.origin === field.origin;
	        });
	        if (math) {
	          field.reev = math.reev;
	          field.reev_name = math.reev_name;
	          results.push(math.matching = true);
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    matchingChanged: function(event) {
	      var new_element, removed;
	      if (event.added) {
	        event.added.element.matching = true;
	        removed = this.matching.splice(event.added.newIndex + 1, 1);
	        this.read_option(removed);
	      } else if (event.removed) {
	        event.removed.element.matching = false;
	        new_element = {
	          reev: '',
	          reev_name: '',
	          integration: event.removed.element.integration,
	          integration_name: event.removed.element.integration_name
	        };
	        removed = this.matching.splice(event.removed.oldIndex, 0, new_element);
	        this.read_option(removed);
	      } else if (event.moved) {
	        new_element = {
	          reev: '',
	          reev_name: '',
	          integration: event.moved.element.integration,
	          integration_name: event.moved.element.integration_name
	        };
	        this.matching[event.moved.oldIndex] = new_element;
	      }
	      return this.doMath();
	    },
	    read_option: function(removed) {
	      var field, found, i, len, results;
	      results = [];
	      for (i = 0, len = removed.length; i < len; i++) {
	        field = removed[i];
	        found = this.reev_fields.find(function(item) {
	          return item.name === field.reev_name;
	        });
	        if (found === void 0 && field.reev_name !== '') {
	          results.push(this.reev_fields.push({
	            integration: "",
	            key: field.reev,
	            matching: false,
	            name: field.reev_name,
	            type: field.type
	          }));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    removeField: function(field, idx) {
	      var new_element, reev_field;
	      reev_field = this.reev_fields.find(function(r_field) {
	        return r_field.key === field.reev;
	      });
	      if (reev_field) {
	        reev_field.matching = false;
	      } else {
	        reev_field = this.defaultFields(field.reev).find(function(r_field) {
	          return r_field.key === field.reev;
	        });
	        if (reev_field) {
	          this.reev_fields.push(reev_field);
	        } else {
	          this.reev_fields.push({
	            name: field.reev_name,
	            key: field.reev,
	            type: field.type
	          });
	        }
	      }
	      new_element = {
	        reev: '',
	        reev_name: '',
	        integration: '',
	        integration_name: ''
	      };
	      this.matching[idx] = new_element;
	      this.doMath();
	      return this.matchingUpdated(this.matching);
	    },
	    doMath: function() {
	      var field, i, idx, len, ref, results;
	      ref = this.matching;
	      results = [];
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        field = ref[idx];
	        field.integration = this.api_fields[idx].key;
	        results.push(field.integration_name = this.api_fields[idx].name);
	      }
	      return results;
	    },
	    matchingUpdated: function(updated) {
	      var api_fields, array;
	      api_fields = this.api_fields;
	      array = updated.map(function(obj, idx) {
	        var ref, ref1, ref2, ref3;
	        return {
	          reev: obj.key || obj.reev,
	          reev_name: obj.name || obj.reev_name,
	          integration: (ref = api_fields[idx]) != null ? ref.key : void 0,
	          integration_name: (ref1 = api_fields[idx]) != null ? ref1.name : void 0,
	          type: (ref2 = api_fields[idx]) != null ? ref2.type : void 0,
	          origin: (ref3 = api_fields[idx]) != null ? ref3.origin : void 0,
	          matching: true
	        };
	      });
	      this.matching = array;
	      return this.$emit('matching-updated', array);
	    },
	    reevFieldsUpdated: function(updated) {
	      var array;
	      array = updated.map(function(obj) {
	        return {
	          key: obj.key || obj.reev,
	          name: obj.name || obj.reev_name,
	          type: obj.type,
	          matching: false,
	          integration: ''
	        };
	      });
	      return this.reev_fields = array;
	    },
	    onMove: function(context) {
	      var draggedElement, relatedElement;
	      relatedElement = context.relatedContext.element;
	      draggedElement = context.draggedContext.element;
	      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
	    },
	    openModal: function() {
	      return jQuery("#new-custom-fields-modal").modal('show');
	    },
	    closeCreateModal: function() {
	      this.edit_custom_field = new CustomField();
	      return jQuery("#new-custom-fields-modal").modal('hide');
	    },
	    custom_field_created: function(custom_field) {
	      this.closeCreateModal();
	      this.reev_fields.push({
	        custom: true,
	        name: custom_field.field,
	        key: custom_field.field,
	        type: custom_field.kind
	      });
	      return this.original_reev_fields = this.reev_fields;
	    },
	    loadCustomFields: function() {
	      return new CustomFieldsResource().index(this.loadCustomFieldsSuccess, null, {});
	    },
	    validateApiFields: function() {
	      var ref;
	      this.matching = this.api_fields.map(function(field) {
	        return {
	          reev: '',
	          reev_name: '',
	          integration: field.key,
	          integration_name: field.name,
	          type: field.type,
	          origin: field.origin
	        };
	      });
	      if (((ref = this.properties_matching) != null ? ref.length : void 0) !== this.api_fields.length) {
	        this.mountDefaultFields();
	      } else {
	        this.matching = this.properties_matching;
	      }
	      return this.matchingUpdated(this.matching);
	    },
	    loadFields: function() {
	      this.reev_fields = this.defaultFields();
	      return this.loadCustomFields();
	    }
	  },
	  computed: {
	    api_fields_person: function() {
	      return this.api_fields.filter(function(field) {
	        return !field.origin || field.origin !== 'deal';
	      });
	    },
	    matching_person: function() {
	      return this.matching.filter(function(field) {
	        return !field.origin || field.origin !== 'deal';
	      });
	    },
	    api_fields_deal: function() {
	      return this.api_fields.filter(function(field) {
	        return field.origin === 'deal';
	      });
	    },
	    matching_deal: function() {
	      return this.matching.filter(function(field) {
	        return field.origin === 'deal';
	      });
	    },
	    draggable_options: function() {
	      return {
	        animation: 0,
	        group: "description",
	        disabled: false
	      };
	    }
	  },
	  watch: {
	    api_fields: function() {
	      return this.validateApiFields();
	    },
	    properties_matching: function() {
	      this.validateApiFields();
	      return this.loadFields();
	    }
	  },
	  mounted: function() {
	    Tooltip.initialize();
	    this.loadFields();
	    return this.validateApiFields();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

	var on_clickaway;
	
	on_clickaway = __webpack_require__(5);
	
	exports["default"] = {
	  mixins: [on_clickaway.mixin],
	  props: {
	    id: {
	      type: Number,
	      "default": ''
	    }
	  },
	  data: function() {
	    return {
	      selected: null,
	      selected_items: [],
	      default_label: null,
	      list: [],
	      show_list: false
	    };
	  },
	  watch: {
	    selected: function() {
	      return this.$emit('selected', this.selected);
	    }
	  },
	  methods: {
	    successCallback: function(response) {
	      var i, len, ref, results, x;
	      len = response.custom_fields.length;
	      results = [];
	      for (x = i = 0, ref = len - 1; 0 <= ref ? i <= ref : i >= ref; x = 0 <= ref ? ++i : --i) {
	        if (response.custom_fields[x]['kind'] === 'dropdown') {
	          if (response.custom_fields[x]["id"] === this.id) {
	            this.selected = response.custom_fields[x]["field"];
	          }
	          results.push(this.list.push(response.custom_fields[x]["field"]));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    clickList: function() {
	      return this.show_list = !this.show_list;
	    },
	    clicked: function() {
	      return this.$store.commit('table', this.selected);
	    },
	    onClickaway: function() {
	      if (this.show_list) {
	        return this.show_list = false;
	      }
	    }
	  },
	  created: function() {
	    var params;
	    params = {
	      q: {
	        kind_eq: 'dropdown'
	      }
	    };
	    return new CustomFieldsResource().index(this.successCallback, null, params);
	  }
	};


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

	var on_clickaway;
	
	on_clickaway = __webpack_require__(5);
	
	exports["default"] = {
	  components: {
	    carouselModalCustom: __webpack_require__(109)
	  },
	  mixins: [on_clickaway.mixin],
	  props: {
	    selected: {
	      type: String,
	      "default": ''
	    }
	  },
	  data: function() {
	    return {
	      active: {},
	      dados: {},
	      property_id_group: {},
	      property_id: null,
	      datacopy: false,
	      dados_modal: {},
	      selected_copy: {},
	      config: false,
	      show_modal: false,
	      loading_users: true,
	      loading_table: false,
	      loading_carousel: true,
	      users: [],
	      id: null,
	      custom_select: {},
	      custom_select_value: null,
	      custom_select_id: null,
	      current_user: Session.current_user,
	      company_id: Session.current_company.id
	    };
	  },
	  computed: {
	    loading: function() {
	      return this.loading_users || this.loading_carousel;
	    }
	  },
	  watch: {
	    selected: function() {
	      var params;
	      params = {
	        q: {
	          kind_eq: 'dropdown'
	        }
	      };
	      new CustomFieldsResource().index(this.successId, null, params);
	      this.loadUsers();
	      return this.loadCarousel();
	    }
	  },
	  methods: {
	    dropOpen: function(item) {
	      var i, k, len1, new_active, ref;
	      new_active = this.active;
	      ref = Object.keys(new_active);
	      for (k = 0, len1 = ref.length; k < len1; k++) {
	        i = ref[k];
	        if (i !== item) {
	          new_active[i] = false;
	        }
	      }
	      new_active[item] = !new_active[item];
	      return this.active = Object.assign({}, new_active);
	    },
	    slicePictureBuble: function(item) {
	      var aux, len, resultado;
	      len = null;
	      if (this.dados[this.selected][item].Carousel !== void 0 && this.dados[this.selected][item].Carousel !== null) {
	        if (this.dados[this.selected][item].Carousel.carousel_users !== void 0 && this.dados[this.selected][item].Carousel.carousel_usesr !== null) {
	          aux = this.dados[this.selected][item].Carousel.carousel_users;
	          len = Object.keys(aux).length;
	          resultado = Object.fromEntries(Object.entries(aux).slice(3, len));
	        }
	        return resultado;
	      }
	    },
	    slicePicture: function(item) {
	      var aux, resultado;
	      if (this.dados[this.selected][item].Carousel) {
	        aux = this.dados[this.selected][item].Carousel.carousel_users;
	        resultado = Object.fromEntries(Object.entries(aux).slice(0, 3));
	      }
	      return resultado;
	    },
	    successId: function(response) {
	      var i, k, len1, ref, results;
	      ref = response.custom_fields;
	      results = [];
	      for (k = 0, len1 = ref.length; k < len1; k++) {
	        i = ref[k];
	        if (i.kind === 'dropdown' && i.field === this.selected) {
	          results.push(this.id = i.id);
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    successCallback: function(response) {
	      var j, k, l, len, objeto, ref, ref1, saizeOption, x;
	      len = response.custom_fields.length;
	      this.dados = {};
	      for (x = k = 0, ref = len - 1; 0 <= ref ? k <= ref : k >= ref; x = 0 <= ref ? ++k : --k) {
	        if (response.custom_fields[x]['kind'] === 'dropdown') {
	          this.dados[response.custom_fields[x]['field']] = {};
	          this.selected_copy[response.custom_fields[x]['field']] = {};
	          this.property_id_group[response.custom_fields[x]['field']];
	          if (response.custom_fields[x]['field'] === this.selected) {
	            this.id = response.custom_fields[x]['id'];
	          }
	          objeto = response.custom_fields[x]["options"];
	          saizeOption = response.custom_fields[x]["options"].length;
	          for (j = l = 0, ref1 = saizeOption - 1; 0 <= ref1 ? l <= ref1 : l >= ref1; j = 0 <= ref1 ? ++l : --l) {
	            this.dados[response.custom_fields[x]['field']][objeto[j]['name']] = {
	              "Carousel": void 0
	            };
	            this.selected_copy[response.custom_fields[x]['field']][objeto[j]['name']] = {
	              "custom_field_value": objeto[j]['name'],
	              "selected": false
	            };
	          }
	          this.selected_copy[response.custom_fields[x]['field']]["Outros"] = {
	            "custom_field_value": "Outros",
	            "selected": false
	          };
	          this.dados[response.custom_fields[x]['field']]["Outros"] = {
	            "Carousel": void 0
	          };
	        }
	      }
	      return this.$emit('property_id', this.id);
	    },
	    modalTitle: function() {
	      if (this.config === true) {
	        return this.$t('integrations.actions.update.carousel');
	      } else {
	        return this.$t('integrations.label.setCarousel');
	      }
	    },
	    fillRdCopy: function(response) {
	      var i, k, len1, results;
	      results = [];
	      for (k = 0, len1 = response.length; k < len1; k++) {
	        i = response[k];
	        results.push(this.dados[this.selected][i.custom_field_value].Carousel = i);
	      }
	      return results;
	    },
	    copyConfig: function(mensagem) {
	      this.dados_modal = this.dados[this.selected];
	      this.custom_select = {
	        'id': 0,
	        'value': ''
	      };
	      this.custom_select['value'] = mensagem;
	      this.custom_select['id'] = this.id;
	      this.datacopy = true;
	      return this.show_modal = true;
	    },
	    selectedCarousel: function(mensagem) {
	      var i, k, len1, ref;
	      this.loading_carousel = true;
	      this.custom_select = {
	        'id': 0,
	        'value': ''
	      };
	      this.dados_modal = {};
	      if (mensagem !== this.$t('general.label.others')) {
	        if (this.dados[this.selected][mensagem].Carousel) {
	          this.dados_modal = this.dados[this.selected][mensagem].Carousel;
	        }
	        if (this.dados[this.selected][mensagem].Carousel === null || this.dados[this.selected][mensagem].Carousel === void 0) {
	          this.custom_select['value'] = mensagem;
	          this.custom_select['id'] = this.id;
	        }
	      } else if (mensagem === this.$t('general.label.others')) {
	        ref = Object.keys(this.dados[this.selected]);
	        for (k = 0, len1 = ref.length; k < len1; k++) {
	          i = ref[k];
	          if (this.dados[this.selected][i].Carousel) {
	            if (this.dados[this.selected][i].Carousel.custom_field_value === null) {
	              this.dados_modal = this.dados[this.selected][i].Carousel;
	            }
	          }
	          this.custom_select['value'] = null;
	          this.custom_select['id'] = this.id;
	        }
	      }
	      this.datacopy = false;
	      this.loading_carousel = false;
	      return this.show_modal = true;
	    },
	    fillRdCarousel: function(carousel) {
	      if (this.custom_select['value'] === null) {
	        this.custom_select['value'] = this.$t('general.label.others');
	      }
	      this.dados[this.selected][this.custom_select['value']].Carousel = carousel;
	      this.dados_modal = {};
	      return this.show_modal = false;
	    },
	    copy_config: function(item) {
	      if (this.dados[this.selected][item] && this.dados[this.selected][item].Carousel) {
	        return false;
	      } else {
	        return true;
	      }
	    },
	    text_config: function(item) {
	      if (this.dados[this.selected] && this.dados[this.selected][item] && this.dados[this.selected][item].Carousel) {
	        return this.$t('integrations.actions.update.carousel');
	      } else {
	        return this.$t('integrations.label.setCarousel');
	      }
	    },
	    loadUsersSuccess: function(data) {
	      this.users = data.users.filter(function(user) {
	        return !user.isAdmin();
	      });
	      this.users = data.users;
	      return this.loading_users = false;
	    },
	    loadUsers: function() {
	      var params;
	      this.loading_users = true;
	      params = {
	        q: {
	          accepted: true,
	          s: 'name asc'
	        }
	      };
	      if (this.current_user.isAdmin()) {
	        params['company_id'] = this.company_id;
	      }
	      return new UsersResource().index(this.loadUsersSuccess, this.unknownError, {
	        params: params
	      });
	    },
	    loadCarousel: function(data) {
	      if (data) {
	        this.carousel = data.carousel_by_property;
	        this.selected_users = data.carousel_by_property.carousel_users;
	        return this.loading_table = true;
	      } else {
	        this.loading_carousel = true;
	        return new CarouselPropertyResource().show(this.loadCarouselSuccess, this.loadCarouselFailure, {
	          params: {
	            q: {
	              kind_eq: 2,
	              type_eq: 'CarouselByProperty'
	            }
	          }
	        });
	      }
	    },
	    loadCarouselSuccess: function(data) {
	      var config, k, len, len1, x;
	      len = null;
	      if (data !== void 0 && Object.keys(data).length > 0 && this.dados !== void 0) {
	        for (k = 0, len1 = data.length; k < len1; k++) {
	          x = data[k];
	          if (x.custom_field_value === null) {
	            this.dados[this.selected][this.$t('general.label.others')].Carousel = x;
	          } else if (x.custom_field_value !== null && x.custom_field_value !== void 0 && this.dados[this.selected][x.custom_field_value] !== void 0) {
	            this.dados[this.selected][x.custom_field_value].Carousel = x;
	          }
	        }
	      }
	      config = true;
	      this.loading_table = true;
	      return this.loading_carousel = false;
	    },
	    loadCarouselFailure: function(data) {
	      if (data.status === 404) {
	        return this.carousel = new Carousel;
	      } else {
	        return this.unknownError;
	      }
	    }
	  },
	  created: function() {
	    var params;
	    params = {
	      q: {
	        kind_eq: 'dropdown'
	      }
	    };
	    new CustomFieldsResource().index(this.successCallback, null, params);
	    this.loadUsers();
	    this.loadCarousel();
	    return this.loading_table = false;
	  },
	  mounted: function() {
	    return this.text_config();
	  }
	};


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    carouselModal: __webpack_require__(33),
	    triggerStages: __webpack_require__(7),
	    propertiesMatching: __webpack_require__(13),
	    propertiesSelect: __webpack_require__(103),
	    propertiesTable: __webpack_require__(104),
	    stagesSelect: __webpack_require__(25)
	  },
	  data: function() {
	    var ref, ref1, ref2, ref3;
	    return {
	      status: false,
	      property: null,
	      property_id: null,
	      current_user: Session.current_user,
	      rd_carousel: null,
	      show_carousel: false,
	      show_id: false,
	      custom_field_id: null,
	      use_carousel: false,
	      show_user_carousel: false,
	      rd_station_setting: Session.current_user.rd_station_setting.id != null ? Session.current_user.rd_station_setting : new RdStationSetting(),
	      selectedSaleRD: (ref = Session.current_user.rd_station_setting) != null ? ref.mark_lead_as_sale : void 0,
	      selectedLostRD: (ref1 = Session.current_user.rd_station_setting) != null ? ref1.mark_lead_as_lost : void 0,
	      selectedOpportunityRD: (ref2 = Session.current_user.rd_station_setting) != null ? ref2.mark_lead_as_opportunity : void 0,
	      copied_rd: false,
	      rdstation_authorized: (ref3 = Session.current_user.rd_station_setting) != null ? ref3.authorized : void 0,
	      show_form_rd: false,
	      url_fields: 'https://api.rd.services/platform/contacts/fields',
	      api_fields: [],
	      matching: [],
	      filter_item_selected_ids: []
	    };
	  },
	  mounted: function() {
	    if (this.$route.query.setting === "rd_station") {
	      this.show_form_rd = true;
	      if (!this.rdstation_authorized) {
	        this.redirectToRdstationOauthUrl();
	      }
	    }
	    if (Session.current_user.rd_station_setting.id != null) {
	      this.rd_station_setting = Session.current_user.rd_station_setting;
	    } else {
	      this.rd_station_setting = new RdStationSetting();
	    }
	    this.custom_field_id = this.rd_station_setting.custom_field_id;
	    if (this.rd_station_setting.use_carousel === true) {
	      this.use_carousel = true;
	      this.show_carousel = false;
	      this.show_user_carousel = false;
	    } else if (this.rd_station_setting.use_carousel_by_property === true) {
	      this.show_id = true;
	      this.show_carousel = true;
	      this.use_carousel = false;
	      this.show_user_carousel = false;
	    } else if (this.rd_station_setting.use_carousel_by_property === false && this.rd_station_setting.use_carousel === false) {
	      this.show_user_carousel = true;
	      this.show_carousel = false;
	      this.use_carousel = false;
	    }
	    Tooltip.initialize();
	    return this.loadFields();
	  },
	  computed: {
	    use_carousel: function() {
	      if (this.use_carousel === true && this.show_carousel === false && this.show_user_carousel === false) {
	        return this.updateRdStationSetting();
	      }
	    },
	    show_carousel: function() {
	      if (this.show_carousel === true && this.use_carousel === false && this.show_user_carousel === false) {
	        return this.updateRdStationSetting();
	      }
	    },
	    show_user_carousel: function() {
	      if (this.show_carousel === false && this.use_carousel === false && this.show_user_carousel === true) {
	        return this.updateRdStationSetting();
	      }
	    }
	  },
	  methods: {
	    itemSelectedItems: function(data) {
	      return this.rd_station_setting.triggers.stages = data;
	    },
	    setStages: function(data) {
	      return this.setting.triggers = data;
	    },
	    property_id_updated: function(id) {
	      return this.property_id = id;
	    },
	    property_updated: function(property) {
	      this.property = property;
	      return this.$store.commit('table', this.property);
	    },
	    use_carousel_rd: function() {
	      if (this.rd_station_setting.use_carousel) {
	        return this.$t('integrations.label.contactsViaCarousel');
	      }
	      return this.$t('integrations.label.contactsViaResponsible');
	    },
	    checkboxSelectSaleRD: function() {
	      if (!this.rdstation_authorized && this.rd_station_setting.use_carousel) {
	        return;
	      }
	      this.selectedSaleRD = !this.selectedSaleRD;
	      return this.updateStages();
	    },
	    checkboxSelectLostRD: function() {
	      if (!this.rdstation_authorized && this.rd_station_setting.use_carousel) {
	        return;
	      }
	      this.selectedLostRD = !this.selectedLostRD;
	      return this.updateStages();
	    },
	    checkboxSelectOpportunityRD: function() {
	      if (!this.rdstation_authorized && this.rd_station_setting.use_carousel) {
	        return;
	      }
	      this.selectedOpportunityRD = !this.selectedOpportunityRD;
	      return this.updateStages();
	    },
	    updateStages: function() {
	      if (this.selectedSaleRD && (this.rd_station_setting.triggers.stages.indexOf('client') < 0)) {
	        this.rd_station_setting.triggers.stages.push('client');
	      }
	      if (this.selectedLostRD && (this.rd_station_setting.triggers.stages.indexOf('lost') < 0)) {
	        this.rd_station_setting.triggers.stages.push('lost');
	      }
	      if (this.selectedOpportunityRD && (this.rd_station_setting.triggers.stages.indexOf('opportunity') < 0)) {
	        return this.rd_station_setting.triggers.stages.push('opportunity');
	      }
	    },
	    fillRdCarousel: function(carousel) {
	      return this.rd_carousel = carousel;
	    },
	    loadRdCarouselData: function() {
	      return this.$refs.rd_carousel_modal.loadData();
	    },
	    open: function() {
	      this.show_form_rd = true;
	      return this.$router.push({
	        path: "/configuracoes/integracao?setting=rd_station"
	      });
	    },
	    connect: function() {
	      Loader.on();
	      return this.redirectToRdstationOauthUrl();
	    },
	    copyURLrd: function() {
	      jQuery('#rd_url').select();
	      document.execCommand("copy");
	      return this.copied_rd = true;
	    },
	    updateRdStationSetting: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        rd_station_setting_attributes: {
	          id: this.rd_station_setting.id,
	          mark_lead_as_sale: this.selectedSaleRD,
	          mark_lead_as_lost: this.selectedLostRD,
	          mark_lead_as_opportunity: this.selectedOpportunityRD,
	          use_carousel: this.rd_station_setting.use_carousel,
	          custom_field_id: this.rd_station_setting.custom_field_id,
	          use_carousel_by_property: this.rd_station_setting.use_carousel_by_property,
	          triggers: this.rd_station_setting.triggers,
	          use_new_ui: Session.current_user.new_ui
	        }
	      };
	      return new UsersResource().update(this.updateRdstationSettingSuccess, this.handleApiErrors, params);
	    },
	    redirectToRdstationOauthUrl: function() {
	      var intercom_event_name, params;
	      if (this.rdstation_authorized) {
	        Loader.on();
	        params = {
	          id: Session.current_user.id,
	          rd_station_setting_attributes: {
	            id: this.rd_station_setting.id,
	            _destroy: 1
	          }
	        };
	        new UsersResource().update(this.updateRdstationSettingSuccess, this.handleApiErrors, params);
	        this.rdstation_authorized = false;
	        alertify.success(this.$t('integrations.feedback.rdStationDisconnectSuccess'));
	        intercom_event_name = this.$t('integrations.feedback.rdStationDisconnectEvent');
	        IntercomCtrl.trackEvent(intercom_event_name);
	        return this.$router.push({
	          path: "/configuracoes/integracao"
	        });
	      } else {
	        Loader.on();
	        if (window.parent && Session.current_user.new_ui) {
	          return window.parent.postMessage({
	            type: "redirect-integration",
	            route: this.rdStationOauthUrl
	          }, "*");
	        }
	        return window.location = this.rdStationOauthUrl;
	      }
	    },
	    updateRdstationSettingSuccess: function(data, response) {
	      Loader.off();
	      alertify.success(this.$t('general.feedback.settingUpdated'));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      return this.rd_station_setting = Session.current_user.rd_station_setting;
	    },
	    toggleUserCarouselRd: function() {
	      var show_carousel;
	      if (this.rd_station_setting.use_carousel_by_property === true) {
	        show_carousel = true;
	        this.show_id = true;
	      }
	      this.property = null;
	      this.show_id = true;
	      this.show_carousel = !this.show_carousel;
	      this.rd_station_setting.use_carousel_by_property = true;
	      this.rd_station_setting.use_carousel = false;
	      this.use_carousel = false;
	      return this.show_user_carousel = false;
	    },
	    toggleUseCarouselRd: function() {
	      if (this.rd_station_setting.use_carousel === true) {
	        this.use_carousel = true;
	      } else {
	        this.use_carousel = !this.use_carousel;
	      }
	      this.rd_station_setting.use_carousel = true;
	      this.rd_station_setting.use_carousel_by_property = false;
	      this.show_carousel = false;
	      return this.show_user_carousel = false;
	    },
	    toggleUseResponsibleRd: function() {
	      if (this.rd_station_setting.use_carousel_by_property === false && this.rd_station_setting.use_carousel === false) {
	        this.show_user_carousel = true;
	      }
	      this.rd_station_setting.use_carousel = false;
	      this.rd_station_setting.use_carousel_by_property = false;
	      this.use_carousel = false;
	      this.show_carousel = false;
	      return this.show_user_carousel = !this.show_user_carousel;
	    },
	    modalTitle: function() {
	      if (this.current_user.isSeller()) {
	        return this.$t('integrations.attributes.Carousel');
	      } else {
	        return this.$t('integrations.label.setCarousel');
	      }
	    },
	    loadCarousel: function(data) {
	      return new CarouselPropertyResource().show(this.loadCarouselSuccess, this.loadCarouselFailure, {
	        params: {
	          q: {
	            kind_eq: 2
	          }
	        }
	      });
	    },
	    loadCarouselSuccess: function(data) {
	      if (data !== void 0 && Object.keys(data).length > 0 && data !== null && this.rd_station_setting.use_carousel === false) {
	        return this.custom_field_id = data[0].custom_field_id;
	      }
	    },
	    loadCarouselFailure: function(data) {
	      if (data.status === 404) {
	        this.carousel = new Carousel;
	      } else {
	
	      }
	      return this.unknownError;
	    },
	    loadFields: function() {
	      var self;
	      if (!this.rdstation_authorized && (this.rd_station_setting.use_carousel || this.rd_station_setting.use_carousel_by_property)) {
	        return;
	      }
	      self = this;
	      return Vue.http.get(("https://api.reev.co") + "/rd_station/contact_properties").then(function(response) {
	        var fields;
	        fields = response.data.fields.filter(function(field) {
	          return field.api_identifier !== 'name' && field.api_identifier !== 'email';
	        });
	        if (!Array.isArray(self.rd_station_setting.properties_matching)) {
	          self.rd_station_setting.properties_matching = new RdStationSetting().properties_matching;
	        }
	        return self.api_fields = fields.map(function(field) {
	          return {
	            type: self.getTypeField(field.data_type),
	            key: field.api_identifier,
	            name: field.custom_field ? field.name["default"] : field.label["default"]
	          };
	        }).sortByKey('name');
	      })["catch"](function(error) {
	        return alertify.error(this.$t('integrations.feedback.expiredAuth'));
	      });
	    },
	    closeForm: function() {
	      return this.$router.push({
	        path: '/configuracoes/integracoes'
	      });
	    },
	    getTypeField: function(data) {
	      return 'text';
	    },
	    matchingUpdated: function(data) {
	      return this.matching = data;
	    },
	    save: function() {
	      var params;
	      this.rd_station_setting.use_carousel_by_property = this.show_carousel;
	      this.rd_station_setting.use_carousel = this.use_carousel;
	      this.rd_station_setting.properties_matching = this.matching;
	      this.rd_station_setting.mark_lead_as_sale = this.selectedSaleRD;
	      this.rd_station_setting.mark_lead_as_lost = this.selectedLostRD;
	      this.rd_station_setting.mark_lead_as_opportunity = this.selectedOpportunityRD;
	      this.rd_station_setting.custom_field_id = this.property_id;
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        rd_station_setting_attributes: this.rd_station_setting
	      };
	      new UsersResource().update(this.updateSuccess, this.handleApiErrors, params);
	      return this.closeForm();
	    },
	    updateSuccess: function(data, response) {
	      Loader.off();
	      alertify.success(this.$t('integrations.feedback.databaseSuccess'));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      return this.rd_station_setting.stage_id = data.user.rd_station_setting.stage_id;
	    }
	  },
	  computed: {
	    rd_url: function() {
	      var ref;
	      if (this.has_configured_rd_carousel || !this.rd_station_setting.use_carousel || ((ref = this.current_user.company.rd_carousel) != null ? ref.id : void 0)) {
	        return ("https://api.reev.co") + '/webhooks/rd_station/import_contacts?token=' + this.current_user.authentication_token;
	      } else {
	        return this.$t('integrations.feedback.sharpspringNeedsCarousel');
	      }
	    },
	    rdStationOauthUrl: function() {
	      var client_id, params;
	      client_id = Session.current_user.new_ui ? ("1849d8fa-c124-4043-b7e0-e589c6530a85") : ("ea885b8c-3199-45c1-a2c6-a6f298f6affa");
	      params = jQuery.param({
	        client_id: client_id,
	        redirect_url: window.location.protocol + "//" + window.location.host + "/configuracoes/integracoes",
	        state: 'rdstation'
	      });
	      return "https://api.rd.services/auth/dialog?" + params;
	    },
	    has_configured_rd_carousel: function() {
	      return (this.rd_carousel != null) && this.rd_carousel.carousel_users.length > 0;
	    }
	  },
	  created: function() {
	    return this.loadCarousel();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    triggerStages: __webpack_require__(7),
	    propertiesMatching: __webpack_require__(13),
	    stagesMatching: __webpack_require__(24)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      rd_station_crm_setting: Session.current_user.rd_station_crm_setting.id != null ? Session.current_user.rd_station_crm_setting : new RDStationCRMSetting(),
	      add_contacts_to_rd_station_crm: Session.current_user.rd_station_crm_setting.add_contacts_to_rd_station_crm,
	      rd_station_crm_api_key: Session.current_user.rd_station_crm_api_key || '',
	      api_fields: [],
	      integration_stages: [],
	      matching: [],
	      matching_stages: [],
	      update_stages_all_users: false,
	      has_stages_api: true,
	      loading_api_key: false,
	      pipelines: [],
	      selected_pipeline: {
	        stage_query: null
	      },
	      copy_settings: false,
	      user_rd_setting: null,
	      users_options_rd: [],
	      rd_setting_copy: []
	    };
	  },
	  methods: {
	    toggleMarkAddContatsToRDStationCRM: function() {
	      return this.add_contacts_to_rd_station_crm = !this.add_contacts_to_rd_station_crm;
	    },
	    toggleCopySettings: function() {
	      return this.copy_settings = !this.copy_settings;
	    },
	    loadUsersRDStation: function() {
	      var company_id, ref, roles;
	      roles = [User.ROLES['seller'], User.ROLES['sdr'], User.ROLES['manager']];
	      company_id = typeof Session !== "undefined" && Session !== null ? (ref = Session.current_company) != null ? ref.id : void 0 : void 0;
	      return new UsersResource().index(this.loadUsersRDStationSuccess, null, {
	        params: {
	          q: {
	            s: 'name asc',
	            role_in: roles
	          },
	          company_id: company_id
	        }
	      });
	    },
	    loadUsersRDStationSuccess: function(data) {
	      var j, len, ref, user;
	      ref = data.users;
	      for (j = 0, len = ref.length; j < len; j++) {
	        user = ref[j];
	        if (user.rd_station_crm_api_key !== null) {
	          this.rd_setting_copy.push(user);
	          this.users_options_rd.push({
	            value: {
	              user_id: user.id
	            },
	            text: user.firstAndLastName()
	          });
	        }
	      }
	      return this.users_options_rd.unshift({
	        value: null,
	        text: this.$t('general.label.user')
	      });
	    },
	    copy: function() {
	      var data, data_rd;
	      if (this.user_rd_setting.user_id !== null) {
	        data = this.rd_setting_copy.filter((function(_this) {
	          return function(item) {
	            return item.id === _this.user_rd_setting.user_id;
	          };
	        })(this));
	        data_rd = data[0].rd_station_crm_setting;
	        this.add_contacts_to_rd_station_crm = data_rd.add_contacts_to_rd_station_crm;
	        this.rd_station_crm_setting.triggers = data_rd.triggers;
	        this.rd_station_crm_setting.properties_matching = data_rd.properties_matching;
	        this.rd_station_crm_setting.metadata.pipeline_id = data_rd.metadata.pipeline_id;
	        this.selected_pipeline = data_rd.metadata.pipeline_id;
	        return this.rd_station_crm_setting.stages_matching = data_rd.stages_matching;
	      }
	    },
	    save: function() {
	      return this.$validator.validateAll({
	        rd_station_crm_api_key: this.rd_station_crm_api_key
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.updateRDStationCRMApiKey();
	          }
	        };
	      })(this));
	    },
	    updateRDStationCRMApiKey: function() {
	      var j, len, params, ref, stage;
	      ref = this.matching_stages;
	      for (j = 0, len = ref.length; j < len; j++) {
	        stage = ref[j];
	        if (!stage.reev || !stage.integration) {
	          return alertify.error(this.$t('integrations.feedback.requiredFunnelStageMap'));
	        }
	      }
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        rd_station_crm_api_key: this.rd_station_crm_api_key,
	        update_stages_all_users: this.update_stages_all_users,
	        user_to_update_stages: this.user_to_update_stages,
	        rd_station_crm_setting_attributes: {
	          id: this.rd_station_crm_setting.id,
	          metadata: this.rd_station_crm_setting.metadata,
	          stage_id: this.rd_station_crm_setting.stage_id,
	          add_contacts_to_rd_station_crm: this.add_contacts_to_rd_station_crm,
	          triggers: this.rd_station_crm_setting.triggers,
	          properties_matching: this.matching,
	          stages_matching: this.matching_stages
	        }
	      };
	      return new UsersResource().update(this.updateRDStationCRMApiKeySuccess, this.rdStationCRMErrors, params);
	    },
	    removeRDStationCRMApiKey: function() {
	      var params;
	      this.rd_station_crm_api_key = null;
	      this.matching = [];
	      this.matching_stages = [];
	      this.rd_station_crm_setting.stages_matching = [];
	      Loader.on();
	      params = {
	        id: Session.current_user.id,
	        rd_station_crm_api_key: this.rd_station_crm_api_key,
	        rd_station_crm_setting_attributes: {
	          id: this.rd_station_crm_setting.id,
	          _destroy: true
	        }
	      };
	      return new UsersResource().update(this.updateRDStationCRMApiKeySuccess, this.rdStationCRMErrors, params);
	    },
	    updateRDStationCRMApiKeySuccess: function(data, response) {
	      var intercom_event_name, message_action;
	      Loader.off();
	      message_action = data.user.rd_station_crm_api_key ? this.$t('general.actions.connectedTo') : this.$t('general.actions.disconnectedTo');
	      alertify.success(this.$t('integrations.feedback.rdStationCRMSuccess'));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      this.rd_station_crm_api_key = data.user.rd_station_crm_api_key;
	      this.has_stages_api = true;
	      this.rd_station_crm_setting.stage_id = data.user.rd_station_crm_setting.stage_id;
	      this.closeForm();
	      intercom_event_name = data.user.rd_station_crm_api_key ? this.$t('integrations.rdStationCRMConnectEvent') : this.$t('integrations.rdStationCRMDisconnectEvent');
	      return IntercomCtrl.trackEvent(intercom_event_name);
	    },
	    rdStationCRMErrors: function(response, options) {
	      var error, j, len, ref, results;
	      if (options == null) {
	        options = {};
	      }
	      this.handleApiErrors(response, options);
	      if (response.body.rd_station_crm_setting) {
	        ref = response.body.rd_station_crm_setting;
	        results = [];
	        for (j = 0, len = ref.length; j < len; j++) {
	          error = ref[j];
	          results.push(this.errors.add(error, this.$t('general.feedback.invalid')));
	        }
	        return results;
	      }
	    },
	    setStagesRDStationCRM: function(data) {
	      return this.rd_station_crm_setting.triggers = data;
	    },
	    matchingUpdated: function(data) {
	      return this.matching = data;
	    },
	    matchingStagesUpdated: function(data) {
	      return this.matching_stages = data;
	    },
	    updateUsers: function(data) {
	      this.update_stages_all_users = data.update_all_users;
	      return this.user_to_update_stages = data.user_id;
	    },
	    getTypeField: function(type) {
	      if (type === 'enum') {
	        return 'number';
	      }
	      if (type === 'phone') {
	        return 'tel';
	      }
	      if (type === 'date') {
	        return 'date';
	      }
	      if (type === 'double') {
	        return 'number';
	      }
	      if (type === 'int') {
	        return 'number';
	      }
	      return 'text';
	    },
	    loadRDStationCRMFields: function() {
	      if (this.rd_station_crm_api_key === '') {
	        return;
	      }
	      this.has_stages_api = true;
	      this.loadFields();
	      return this.loadPipelines();
	    },
	    loadFields: function() {
	      var opts, self;
	      if (!this.rd_station_crm_api_key) {
	        return;
	      }
	      opts = {
	        params: {
	          rd_station_crm_apikey: this.rd_station_crm_api_key
	        },
	        headers: {
	          "Access-Control-Allow-Origin": "*",
	          "Accept": "application/json",
	          "Content-Type": "application/json"
	        }
	      };
	      self = this;
	      return Vue.http.get(("https://api.reev.co") + "/rd_station_crm/contact_properties", opts).then(function(response) {
	        var body;
	        body = response.body || [];
	        if (!Object.values(body)[0]) {
	          return;
	        }
	        if (Object.values(body)[0].length > 0 || Object.values(body)[0].length === void 0) {
	          return self.api_fields = response.body.filter(function(field) {
	            return field["for"] === 'contact' || field["for"] === 'deal';
	          }).map(function(field) {
	            return {
	              name: field.label,
	              key: field._id,
	              type: field.type,
	              required: !field.required,
	              origin: field["for"]
	            };
	          });
	        }
	      });
	    },
	    loadPipelines: function() {
	      var opts;
	      if (!this.rd_station_crm_api_key) {
	        return;
	      }
	      opts = {
	        params: {
	          rd_station_crm_apikey: this.rd_station_crm_api_key
	        },
	        headers: {
	          "Access-Control-Allow-Origin": "*",
	          "Accept": "application/json",
	          "Content-Type": "application/json"
	        }
	      };
	      return this.$http.get(("https://api.reev.co") + "/rd_station_crm/deal_pipelines", opts).then((function(_this) {
	        return function(response) {
	          var firstQuery, founded;
	          _this.pipelines = response.body.map(function(pipeline) {
	            return {
	              value: {
	                stage_query: pipeline.id
	              },
	              text: pipeline.name,
	              stages: pipeline.deal_stages.map(function(stage) {
	                return {
	                  id: stage.id,
	                  name: stage.name
	                };
	              })
	            };
	          });
	          _this.pipelines.unshift({
	            value: {
	              stage_query: null
	            },
	            text: 'Selecione um funil'
	          });
	          firstQuery = _this.pipelines[0].value.stage_query;
	          if (_this.rd_station_crm_setting.metadata) {
	            if (_this.rd_station_crm_setting.metadata.pipeline_id) {
	              founded = _this.pipelines.filter(function(i) {
	                return i.value.stage_query === _this.rd_station_crm_setting.metadata.pipeline_id;
	              });
	              if (founded[0] !== null && founded !== null) {
	                _this.selected_pipeline = founded[0].value;
	              }
	            }
	          }
	          if (_this.selected_pipeline) {
	            firstQuery = _this.selected_pipeline.stage_query;
	          }
	          return _this.loadByNewPipeline({
	            pipeline: {
	              stage_query: firstQuery
	            }
	          });
	        };
	      })(this));
	    },
	    loadByNewPipeline: function(data) {
	      var pipeline;
	      if (!this.rd_station_crm_setting.metadata) {
	        this.rd_station_crm_setting.metadata = {
	          pipeline_id: data.pipeline.stage_query
	        };
	      } else {
	        this.rd_station_crm_setting.metadata.pipeline_id = data.pipeline.stage_query;
	      }
	      pipeline = this.pipelines.filter((function(_this) {
	        return function(i) {
	          return i.value.stage_query === data.pipeline.stage_query;
	        };
	      })(this))[0];
	      this.selected_pipeline = pipeline.value;
	      if (pipeline.stages) {
	        this.has_stages_api = true;
	        return this.integration_stages = pipeline.stages;
	      } else {
	        return this.integration_stages = [];
	      }
	    },
	    changePipeline: function(data) {
	      this.rd_station_crm_setting.metadata.pipeline_id = data.pipeline.stage_query;
	      this.rd_station_crm_setting.metadata.stages_matching = [];
	      return this.loadByNewPipeline(data);
	    },
	    closeForm: function() {
	      return this.$router.push({
	        path: '/configuracoes/integracoes'
	      });
	    },
	    validate_api_key: function() {
	      var opts;
	      this.loading_api_key = true;
	      opts = {
	        params: {
	          rd_station_crm_apikey: this.rd_station_crm_api_key
	        }
	      };
	      return this.$http.get(("https://api.reev.co") + "/rd_station_crm/contact_properties", opts).then(((function(_this) {
	        return function(response) {
	          _this.errors.clear();
	          _this.loadRDStationCRMFields();
	          return _this.loading_api_key = false;
	        };
	      })(this)), ((function(_this) {
	        return function(response) {
	          _this.loading_api_key = false;
	          return _this.errors.add('rd_station_crm_api_key', _this.$t('integrations.feedback.invalidApiKey'));
	        };
	      })(this)));
	    }
	  },
	  watch: {
	    rd_station_crm_api_key: function() {
	      if (this.loading_api_key) {
	        return;
	      }
	      return this.validate_api_key();
	    }
	  },
	  mounted: function() {
	    Tooltip.initialize();
	    this.loadRDStationCRMFields();
	    this.loadUsersRDStation();
	    return {
	      rd_station_crm_setting: function() {
	        return this.copy();
	      }
	    };
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    triggerStages: __webpack_require__(7),
	    propertiesMatching: __webpack_require__(13)
	  },
	  data: function() {
	    var ref;
	    return {
	      current_user: Session.current_user,
	      salesforce_authorized: ((ref = Session.current_user.salesforce_setting) != null ? ref.access_token : void 0) != null,
	      salesforce_setting: Session.current_user.salesforce_setting.id != null ? Session.current_user.salesforce_setting : new SalesforceSetting(),
	      matching: [],
	      api_fields: [],
	      permission_groups: true,
	      api_permissions: true,
	      only_lead: false,
	      leads_and_accounts: false,
	      leads_accounts_and_opportunities: false
	    };
	  },
	  computed: {
	    to_article: function() {
	      return 'https://intercom.help/reevoutbound-marketing/pt-BR/articles/2619495-como-fazer-a-integracao-do-reev-com-o-salesforce';
	    },
	    salesforce_mark_as: function() {
	      return this.salesforce_setting.mark_as === 'lead_and_opportunity';
	    },
	    salesforce_send_to: function() {
	      return this.salesforce_setting.send_to === 'queue';
	    },
	    salesforceSandboxTeste: function() {
	      if (this.salesforce_setting.sandbox_test) {
	        return this.$t('integrations.checkbox.sandboxEnv');
	      } else {
	        return this.$t('integrations.checkbox.productionEnv');
	      }
	    },
	    salesforceOauthUrl: function() {
	      var client_id, params;
	      client_id = Session.current_user.new_ui ? ("3MVG9zlTNB8o8BA1krJtuDM9UTfPVP_SneWt0Un21Dv87jJebCfbGqyeJ_Ffmbxp38VsvfPuIHWp__SC9Es1L") : ("3MVG9zlTNB8o8BA1krJtuDM9UTTRwgZa.Znn9_tUkWOTIqOJpyvJgCjvlu0nQPwIuFOz1p0VbTvSqNsK8hO0F");
	      params = jQuery.param({
	        client_id: client_id,
	        response_type: 'code',
	        redirect_uri: window.location.protocol + "//" + window.location.host + "/configuracoes/integracoes",
	        state: 'salesforce,' + this.salesforce_setting.sandbox_test
	      });
	      if (this.salesforce_setting.sandbox_test) {
	        return "https://test.salesforce.com/services/oauth2/authorize?" + params;
	      } else {
	        return "https://login.salesforce.com/services/oauth2/authorize?" + params;
	      }
	    }
	  },
	  methods: {
	    sending_checked: function(option) {
	      this.only_lead = this.leads_and_accounts = this.leads_accounts_and_opportunities = false;
	      if (option === 'lead') {
	        this.only_lead = true;
	      }
	      if (option === 'lead_account') {
	        this.leads_and_accounts = true;
	      }
	      if (option === 'lead_account_opportunity') {
	        return this.leads_accounts_and_opportunities = true;
	      }
	    },
	    toggleSalesforceMarkAs: function() {
	      if (this.salesforce_setting.mark_as === 'lead_and_opportunity') {
	        return this.salesforce_setting.mark_as = 'only_lead';
	      } else {
	        return this.salesforce_setting.mark_as = 'lead_and_opportunity';
	      }
	    },
	    toggleSalesforceSendTo: function() {
	      if (!this.permission_groups) {
	        return;
	      }
	      if (this.salesforce_setting.send_to === 'responsible') {
	        return this.salesforce_setting.send_to = 'queue';
	      } else {
	        return this.salesforce_setting.send_to = 'responsible';
	      }
	    },
	    updateSalesforceSetting: function() {
	      var mark_as, params;
	      Loader.on();
	      if (this.only_lead) {
	        mark_as = 'only_lead';
	      }
	      if (this.leads_and_accounts) {
	        mark_as = 'lead_and_account';
	      }
	      if (this.leads_accounts_and_opportunities) {
	        mark_as = 'lead_account_and_opportunity';
	      }
	      params = {
	        id: Session.current_user.id,
	        salesforce_setting_attributes: {
	          id: this.salesforce_setting.id,
	          mark_as: mark_as,
	          send_to: this.salesforce_setting.send_to,
	          triggers: this.salesforce_setting.triggers,
	          properties_matching: this.matching
	        }
	      };
	      return new UsersResource().update(this.updateSalesforceSettingSuccess, this.handleApiErrors, params);
	    },
	    updateSalesforceSettingSuccess: function(data, response) {
	      Loader.off();
	      alertify.success(this.$t('general.feedback.settingUpdated'));
	      Session.signIn(response.body.user);
	      return this.current_user = Session.current_user;
	    },
	    saveSalesforceSetting: function() {
	      return this.updateSalesforceSetting();
	    },
	    redirectToSalesforceOauthUrl: function() {
	      var intercom_event_name, params;
	      if (this.salesforce_authorized) {
	        Loader.on();
	        params = {
	          id: Session.current_user.id,
	          salesforce_setting_attributes: {
	            id: this.salesforce_setting.id,
	            _destroy: 1
	          }
	        };
	        new UsersResource().update(this.updateSalesforceSettingSuccess, this.handleApiErrors, params);
	        this.salesforce_authorized = false;
	        alertify.success(this.$t('integrations.feedback.salesforceDisconnectSuccess'));
	        intercom_event_name = this.$t('integrations.feedback.salesforceDisconnectEvent');
	        return IntercomCtrl.trackEvent(intercom_event_name);
	      } else {
	        Loader.on();
	        if (window.parent && Session.current_user.new_ui) {
	          return window.parent.postMessage({
	            type: "redirect-integration",
	            route: this.salesforceOauthUrl
	          }, "*");
	        }
	        return window.location = this.salesforceOauthUrl;
	      }
	    },
	    authorizeSalesforce: function() {
	      var code;
	      Loader.on();
	      code = this.$route.query.code;
	      this.$router.replace({
	        name: 'integrations'
	      });
	      IntegrationsResource.authorize_salesforce(this.authorizeSalesforceSuccess, this.authorizeSalesforceFailure, {
	        code: code,
	        sandbox_test: Session.current_user.sandbox_test
	      });
	      return EventsBus.$emit('salesforce-account-connected');
	    },
	    authorizeSalesforceSuccess: function(response) {
	      var intercom_event_name;
	      Session.updateCurrentUser(response.body.user);
	      this.current_user = Session.current_user;
	      Loader.off();
	      alertify.success(this.$t('integrations.feedback.salesforceConnectSuccess'));
	      this.salesforce_authorized = true;
	      intercom_event_name = this.$t('integrations.feedback.salesforceConnectEvent');
	      return IntercomCtrl.trackEvent(intercom_event_name);
	    },
	    authorizeSalesforceFailure: function(response) {
	      Loader.off();
	      return alertify.error(response.body.error, 10);
	    },
	    setStages: function(data) {
	      return this.salesforce_setting.triggers = data;
	    },
	    matchingUpdated: function(data) {
	      return this.matching = data;
	    },
	    loadSalesforceFields: function() {
	      var opts, self;
	      if (!this.salesforce_setting.access_token) {
	        return;
	      }
	      if (this.salesforce_setting.mark_as === 'only_lead') {
	        this.only_lead = true;
	      }
	      if (this.salesforce_setting.mark_as === 'lead_and_account') {
	        this.leads_and_accounts = true;
	      }
	      if (this.salesforce_setting.mark_as === 'lead_account_and_opportunity') {
	        this.leads_accounts_and_opportunities = true;
	      }
	      opts = {
	        headers: {
	          'Access-Control-Allow-Origin': '*',
	          'Accept': 'application/json',
	          'Content-Type': 'application/json'
	        }
	      };
	      self = this;
	      return Vue.http.get(("https://api.reev.co") + "/salesforces/contact_properties", opts).then(function(response) {
	        var fields;
	        fields = response.body.map(function(field) {
	          return {
	            name: field.label,
	            key: field.name,
	            type: 'input',
	            updateable: field.updateable,
	            required: !field.nillable
	          };
	        });
	        self.api_fields = fields.filter(function(field) {
	          return field.updateable && ['LastName', 'FirstName', 'Company', 'Email', 'OwnerId'].indexOf(field.key) === -1;
	        });
	        return self.api_permissions = true;
	      })["catch"](function(error) {
	        return self.api_permissions = false;
	      });
	    },
	    validateApiGroups: function() {
	      var opts, self;
	      if (!this.salesforce_setting.access_token) {
	        return;
	      }
	      opts = {
	        headers: {
	          'Access-Control-Allow-Origin': '*',
	          'Accept': 'application/json',
	          'Content-Type': 'application/json'
	        }
	      };
	      self = this;
	      return Vue.http.get(("https://api.reev.co") + "/salesforces/validate_api_permissions", opts).then(function(response) {
	        self.permission_groups = response.body;
	        if (response.body === false) {
	          return self.salesforce_setting.send_to = 'responsible';
	        }
	      })["catch"](function(error) {
	        self.permission_groups = false;
	        return self.salesforce_setting.send_to = 'responsible';
	      });
	    }
	  },
	  mounted: function() {
	    Tooltip.initialize();
	    this.loadSalesforceFields();
	    return this.validateApiGroups();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  mixins: [__webpack_require__(6)],
	  components: {
	    draggable: __webpack_require__(27)
	  },
	  props: {
	    stages_matching: Array,
	    integration_name: String,
	    integration_stages: {
	      "default": [],
	      type: Array
	    },
	    pipelines: {
	      "default": function() {
	        return [];
	      },
	      type: Array
	    },
	    pipeline_id: {
	      type: [String, Number, Object],
	      "default": null
	    },
	    integration_no_stages_api: {
	      type: Boolean,
	      "default": false
	    },
	    show_ignore_stages: {
	      type: Boolean,
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      reev_stages: [],
	      matching: [],
	      update_all_users: false,
	      user_stage_setting: null,
	      stage_options: [
	        {
	          value: {
	            stage_query: null
	          },
	          text: this.$t('integrations.label.stages_matching.stage'),
	          ignore: true
	        }, {
	          value: {
	            stage_query: 'smart_lead'
	          },
	          text: this.$t('integrations.label.stages_matching.smartLead')
	        }, {
	          value: {
	            stage_query: 'prospect'
	          },
	          text: this.$t('integrations.label.stages_matching.prospect')
	        }, {
	          value: {
	            stage_query: 'lead'
	          },
	          text: this.$t('integrations.label.stages_matching.lead')
	        }, {
	          value: {
	            stage_query: 'mql'
	          },
	          text: this.$t('integrations.label.stages_matching.mql')
	        }, {
	          value: {
	            stage_query: 'sql'
	          },
	          text: this.$t('integrations.label.stages_matching.sql')
	        }, {
	          value: {
	            stage_query: 'opportunity'
	          },
	          text: this.$t('integrations.label.stages_matching.opportunity')
	        }, {
	          value: {
	            stage_query: 'client'
	          },
	          text: this.$t('integrations.label.stages_matching.customer')
	        }
	      ],
	      selected_pipeline: null
	    };
	  },
	  methods: {
	    defaultFields: function() {
	      return [
	        {
	          key: 'smart_lead',
	          name: this.$t('integrations.label.stages_matching.smartLead')
	        }, {
	          key: 'prospect',
	          name: this.$t('integrations.label.stages_matching.prospect')
	        }, {
	          key: 'lead',
	          name: this.$t('integrations.label.stages_matching.lead')
	        }, {
	          key: 'mql',
	          name: this.$t('integrations.label.stages_matching.mql')
	        }, {
	          key: 'sql',
	          name: this.$t('integrations.label.stages_matching.sql')
	        }, {
	          key: 'opportunity',
	          name: this.$t('integrations.label.stages_matching.opportunity')
	        }, {
	          key: 'client',
	          name: this.$t('integrations.label.stages_matching.customer')
	        }, {
	          key: 'lost',
	          name: this.$t('integrations.label.stages_matching.lost')
	        }
	      ];
	    },
	    validateApiFields: function() {
	      var default_integration_id, ref, ref1, self;
	      default_integration_id = '';
	      if (this.integration_stages.length > 0) {
	        if (this.integration_name === 'pipedrive' || this.integration_name === 'cv crm') {
	          default_integration_id = this.$t('integrations.label.ignore');
	        } else {
	          default_integration_id = this.integration_stages[0].id;
	        }
	      }
	      this.matching = this.stage_options.filter(function(field) {
	        return !field.ignore;
	      }).map(function(field) {
	        return {
	          option: {
	            stage_query: null
	          },
	          reev: field.value.stage_query,
	          reev_name: field.text,
	          integration: default_integration_id,
	          integration_name: ''
	        };
	      });
	      if (this.integration_no_stages_api) {
	        if (((ref = this.stages_matching) != null ? ref.length : void 0) > 0) {
	          return this.matching = this.stages_matching.map(function(field) {
	            return {
	              option: {
	                stage_query: field.reev
	              },
	              integration: field.integration,
	              integration_name: field.integration_name,
	              reev_name: field.reev_name
	            };
	          });
	        }
	      } else {
	        if (((ref1 = this.stages_matching) != null ? ref1.length : void 0) > 0) {
	          self = this;
	          this.matching = this.stage_options.filter(function(field) {
	            return !field.ignore;
	          }).map(function(field) {
	            var integration_value;
	            integration_value = self.stages_matching.find(function(stage) {
	              return stage.reev === field.value.stage_query;
	            });
	            return {
	              option: {
	                stage_query: null
	              },
	              reev: field.value.stage_query,
	              reev_name: field.text,
	              integration: {
	                stage_query: (integration_value != null ? integration_value.integration.toString() : void 0) || default_integration_id
	              },
	              integration_name: ''
	            };
	          });
	        }
	        return this.updateProps();
	      }
	    },
	    toggleUpdateAllUsers: function() {
	      var ref;
	      this.update_all_users = !this.update_all_users;
	      return this.$emit('users-update', {
	        update_all_users: this.update_all_users,
	        user_id: (ref = this.user_stage_setting) != null ? ref.user_id_eq : void 0
	      });
	    },
	    updateProps: function() {
	      var array;
	      array = this.matching.map(function(field) {
	        var integration, ref;
	        integration = field.integration;
	        if (typeof field.integration === 'object') {
	          integration = field.integration.stage_query;
	        }
	        return {
	          integration: integration,
	          integration_name: field.integration_name,
	          reev_name: field.reev_name,
	          reev: ((ref = field.option) != null ? ref.stage_query : void 0) || field.reev
	        };
	      });
	      return this.$emit('matching-updated', array);
	    },
	    updateStages: function() {
	      return this.$emit('update-stages', {
	        pipeline: this.selected_pipeline
	      });
	    }
	  },
	  computed: {
	    draggable_options: function() {
	      return {
	        animation: 0,
	        group: "description",
	        disabled: false
	      };
	    },
	    integration_stages_options: function() {
	      var stages;
	      stages = this.integration_stages.map(function(stage) {
	        return {
	          value: {
	            stage_query: stage.id.toString()
	          },
	          text: stage.name
	        };
	      });
	      if (this.show_ignore_stages) {
	        stages.unshift({
	          value: {
	            stage_query: this.$t('integrations.label.ignore')
	          },
	          text: this.$t('general.actions.ignore')
	        });
	      }
	      return stages;
	    }
	  },
	  watch: {
	    integration_stages: function() {
	      return this.validateApiFields();
	    },
	    user_stage_setting: function() {
	      var ref;
	      return this.$emit('users-update', {
	        update_all_users: this.update_all_users,
	        user_id: (ref = this.user_stage_setting) != null ? ref.user_id_eq : void 0
	      });
	    },
	    integration_no_stages_api: function() {
	      if (this.integration_no_stages_api) {
	        return this.validateApiFields();
	      }
	    },
	    pipeline_id: function() {
	      return this.selected_pipeline = this.pipeline_id;
	    },
	    stages_matching: function() {
	      return this.validateApiFields();
	    }
	  },
	  mounted: function() {
	    Tooltip.initialize();
	    this.reev_stages = this.defaultFields();
	    this.validateApiFields();
	    this.selected_pipeline = this.pipeline_id;
	    if (Session.current_user.isManager()) {
	      this.user_stage_setting = {
	        user_id_eq: Session.current_user.id.toString()
	      };
	    }
	    if (['hubspot', 'pipedrive', 'rd station crm', 'cv crm'].indexOf(this.integration_name.toLowerCase()) > -1) {
	      return this.stage_options.push({
	        value: {
	          stage_query: 'lost'
	        },
	        text: this.$t('integrations.label.stages_matching.lost')
	      });
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    triggerStages: __webpack_require__(7)
	  },
	  data: function() {
	    return {
	      show: false,
	      setting: Session.current_user.vtiger_setting.id != null ? Session.current_user.vtiger_setting : new VtigerSetting(),
	      lead: false,
	      contact: false
	    };
	  },
	  methods: {
	    sending_checked: function(option) {
	      this.lead = this.contact = false;
	      if (option === 'lead') {
	        this.lead = true;
	      }
	      if (option === 'contact') {
	        return this.contact = true;
	      }
	    },
	    open: function() {
	      return this.show = !this.show;
	    },
	    close: function() {
	      return this.show = false;
	    },
	    save: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.updateUser();
	          }
	        };
	      })(this));
	    },
	    updateUser: function() {
	      var mark_as, params;
	      Loader.on();
	      if (this.lead) {
	        mark_as = 'lead';
	      }
	      if (this.contact) {
	        mark_as = 'contact';
	      }
	      params = {
	        id: Session.current_user.id,
	        vtiger_setting_attributes: {
	          id: this.setting.id,
	          mark_as: mark_as,
	          access_key: this.setting.access_key,
	          username: this.setting.username,
	          url: this.setting.url,
	          triggers: this.setting.triggers
	        }
	      };
	      return new UsersResource().update(this.updateUserSuccess, this.handleApiErrors, params);
	    },
	    updateUserSuccess: function(data, response) {
	      var message_action;
	      Loader.off();
	      message_action = data.user.vtiger_setting.id ? this.$t('general.actions.connectedTo') : this.$t('general.actions.disconnectedTo');
	      alertify.success(this.$t('integrations.label.vtiger.success'));
	      Session.signIn(response.body.user);
	      this.current_user = Session.current_user;
	      return this.close();
	    },
	    setStages: function(data) {
	      return this.setting.triggers = data;
	    },
	    loadVtigerFields: function() {
	      if (this.setting.mark_as === 'lead' || this.setting.mark_as === null) {
	        this.lead = true;
	      }
	      if (this.setting.mark_as === 'contact') {
	        return this.contact = true;
	      }
	    }
	  },
	  mounted: function() {
	    return this.loadVtigerFields();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    listItem: __webpack_require__(40),
	    draggable: __webpack_require__(27)
	  },
	  props: {
	    modalTitle: {
	      required: true
	    },
	    kind: {
	      required: true
	    }
	  },
	  data: function() {
	    return {
	      users: [],
	      selected_all: false,
	      selected_users: [],
	      current_user: Session.current_user,
	      company_id: Session.current_company.id,
	      removed: [],
	      draggable_options: {
	        disabled: Session.current_user.isSeller()
	      },
	      carousel: {
	        type: Carousel
	      },
	      loading_users: true,
	      loading_carousel: true
	    };
	  },
	  computed: {
	    loading: function() {
	      return this.loading_users || this.loading_carousel;
	    },
	    has_last_user: function() {
	      return !(this.carousel.last_user instanceof Array) && !jQuery.isEmptyObject(this.carousel.last_user);
	    }
	  },
	  methods: {
	    changeOrder: function(data) {
	      this.selected_users = data;
	      return this.reorderCarousel();
	    },
	    reorderCarousel: function() {
	      var j, len;
	      len = this.selected_users.length;
	      if (len > 0) {
	        j = 0;
	        while (j < len - 1) {
	          this.selected_users[j].next_user_id = this.selected_users[j + 1].user_id;
	          j++;
	        }
	        this.selected_users[len - 1].next_user_id = this.selected_users[0].user_id;
	        return this.carousel.next_user_id = this.selected_users[0].user_id;
	      }
	    },
	    userIsSelected: function(user) {
	      var i, len1, ref, selected;
	      ref = this.selected_users;
	      for (i = 0, len1 = ref.length; i < len1; i++) {
	        selected = ref[i];
	        if (selected.user_id === user.id) {
	          return true;
	        }
	      }
	      return false;
	    },
	    indexOfUser: function(user) {
	      var i, index, len1, ref, selected;
	      ref = this.selected_users;
	      for (index = i = 0, len1 = ref.length; i < len1; index = ++i) {
	        selected = ref[index];
	        if (selected.user_id === user.id) {
	          return index;
	        }
	      }
	    },
	    selectAll: function() {
	      var i, len1, ref, results, user;
	      this.selected_all = !this.selected_all;
	      ref = this.users;
	      results = [];
	      for (i = 0, len1 = ref.length; i < len1; i++) {
	        user = ref[i];
	        if (this.selected_all) {
	          if (!this.userIsSelected(user)) {
	            results.push(this.selectUser(user));
	          } else {
	            results.push(void 0);
	          }
	        } else {
	          results.push(this.selectUser(user));
	        }
	      }
	      return results;
	    },
	    selectUser: function(user) {
	      var carousel_user, index, users;
	      if (this.userIsSelected(user)) {
	        users = this.selected_users.map(function(selected) {
	          return selected.user;
	        });
	        index = this.indexOfUser(user);
	        if (this.selected_users[index].id != null) {
	          this.removed[this.selected_users[index].user_id] = this.selected_users[index];
	        }
	        this.selected_users.splice(index, 1);
	        this.reorderCarousel();
	        return this.selected_all = false;
	      } else {
	        if (this.removed[user.id] != null) {
	          carousel_user = this.removed[user.id];
	          delete this.removed[user.id];
	        } else {
	          carousel_user = new CarouselUser;
	        }
	        carousel_user.user_id = user.id;
	        carousel_user.next_user_id = this.selected_users.length > 0 ? this.selected_users[0].user_id : user.id;
	        carousel_user.user = user;
	        this.selected_users.push(carousel_user);
	        this.reorderCarousel();
	        return this.selected_all = this.selected_users.length === this.users.length;
	      }
	    },
	    loadData: function() {
	      this.loadUsers();
	      return this.loadCarousel();
	    },
	    loadUsersSuccess: function(data) {
	      this.users = data.users.filter(function(user) {
	        return !user.isAdmin();
	      });
	      this.users = data.users;
	      return this.loading_users = false;
	    },
	    loadUsers: function() {
	      var params;
	      this.loading_users = true;
	      params = {
	        q: {
	          accepted: true,
	          s: 'name asc'
	        }
	      };
	      if (this.current_user.isAdmin()) {
	        params['company_id'] = this.company_id;
	      }
	      return new UsersResource().index(this.loadUsersSuccess, this.unknownError, {
	        params: params
	      });
	    },
	    loadCarousel: function(data) {
	      if (data) {
	        this.carousel = data.carousel;
	        return this.selected_users = data.carousel.carousel_users;
	      } else {
	        this.loading_carousel = true;
	        return new CarouselResource().show(this.loadCarouselSuccess, this.loadCarouselFailure, {
	          params: {
	            kind: this.kind
	          }
	        });
	      }
	    },
	    loadCarouselSuccess: function(data) {
	      this.selected_users = data.carousel.carousel_users;
	      this.carousel = data.carousel;
	      this.loading_carousel = false;
	      return this.selected_all = this.selected_users.length === this.users.length;
	    },
	    loadCarouselFailure: function(data) {
	      if (data.status === 404) {
	        this.carousel = new Carousel;
	        return this.loading_carousel = false;
	      } else {
	        return this.unknownError;
	      }
	    },
	    buildCarousel: function() {
	      var carousel, i, k, len1, len2, ref, ref1, selected, user_removed;
	      carousel = new Carousel({
	        kind: this.kind
	      });
	      if (this.kind === 'rd') {
	        carousel.type = 'Carousel';
	      }
	      carousel.next_user_id = this.selected_users.length > 0 ? this.selected_users[0].user_id : null;
	      ref = this.selected_users;
	      for (i = 0, len1 = ref.length; i < len1; i++) {
	        selected = ref[i];
	        carousel.carousel_users.push(new CarouselUser({
	          id: selected.id,
	          user_id: selected.user_id,
	          next_user_id: selected.next_user_id
	        }));
	      }
	      if (Object.keys(this.removed).length > 0) {
	        ref1 = Object.values(this.removed);
	        for (k = 0, len2 = ref1.length; k < len2; k++) {
	          user_removed = ref1[k];
	          carousel.carousel_users.push(new CarouselUser({
	            id: user_removed.id,
	            user_id: user_removed.user_id,
	            next_user_id: user_removed.next_user_id,
	            _destroy: true
	          }));
	        }
	      }
	      return carousel;
	    },
	    save: function() {
	      var carousel;
	      carousel = this.buildCarousel().serialize();
	      return new CarouselResource().create_or_update(this.saveSuccess, this.saveFailure, carousel);
	    },
	    saveSuccess: function(data) {
	      this.loadCarousel(data);
	      this.removed = [];
	      jQuery('#carousel-config').modal('hide');
	      this.$emit('savedCarousel', data.carousel);
	      return alertify.success(this.$t('integrations.label.modal_carousel.successFeedback'));
	    },
	    saveFailure: function(data) {
	      return alertify.error(this.$t('integrations.label.modal_carousel.failFeedback'));
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    listCopy: __webpack_require__(225),
	    listItem: __webpack_require__(40),
	    draggable: __webpack_require__(27)
	  },
	  props: {
	    modalTitle: {
	      required: true
	    },
	    kind: {
	      required: true
	    },
	    custom: {},
	    custom_fields_select: {},
	    dados: {},
	    copy: null
	  },
	  data: function() {
	    return {
	      users: [],
	      complete: null,
	      selected_all: false,
	      value_copy: null,
	      fields_select: {},
	      selected_users: [],
	      custom_copy: null,
	      current_user: Session.current_user,
	      company_id: Session.current_company.id,
	      removed: [],
	      draggable_options: {
	        disabled: Session.current_user.isSeller()
	      },
	      carousel: {
	        type: Carousel
	      },
	      loading_users: true,
	      loading_carousel: true
	    };
	  },
	  computed: {
	    loading: function() {
	      return this.loading_users || this.loading_carousel;
	    },
	    has_last_user: function() {
	      return !(this.carousel.last_user instanceof Array) && !jQuery.isEmptyObject(this.carousel.last_user);
	    }
	  },
	  mounted: function() {
	    if (!this.copy) {
	      this.selected_users = [];
	      return this.loadData();
	    } else {
	      this.selected_users = [];
	      return this.loadCopy();
	    }
	  },
	  methods: {
	    changeOrder: function(data) {
	      this.selected_users = data;
	      return this.reorderCarousel();
	    },
	    close_modal: function() {
	      jQuery('#carousel-config').modal('toggle');
	      jQuery('body').removeClass('modal-open');
	      jQuery('body').css('padding-right', '0px');
	      jQuery('.modal-backdrop').remove();
	      return this.$emit('closeModal');
	    },
	    finishText: function() {
	      if (this.copy) {
	        return this.$t('general.actions.copy');
	      } else {
	        return this.$t('general.actions.cancel');
	      }
	    },
	    reorderCarousel: function() {
	      var j, len;
	      len = this.selected_users.length;
	      if (len > 0) {
	        j = 0;
	        while (j < len - 1) {
	          this.selected_users[j].next_user_id = this.selected_users[j + 1].user_id;
	          j++;
	        }
	        this.selected_users[len - 1].next_user_id = this.selected_users[0].user_id;
	        return this.carousel.next_user_id = this.selected_users[0].user_id;
	      }
	    },
	    userIsSelected: function(user) {
	      var i, len1, ref, selected;
	      ref = this.selected_users;
	      for (i = 0, len1 = ref.length; i < len1; i++) {
	        selected = ref[i];
	        if (selected.user_id === user.id) {
	          return true;
	        }
	      }
	      return false;
	    },
	    indexOfUser: function(user) {
	      var i, index, len1, ref, selected;
	      ref = this.selected_users;
	      for (index = i = 0, len1 = ref.length; i < len1; index = ++i) {
	        selected = ref[index];
	        if (selected.user_id === user.id) {
	          return index;
	        }
	      }
	    },
	    selectAll: function() {
	      var i, len1, ref, results, user;
	      this.selected_all = !this.selected_all;
	      ref = this.users;
	      results = [];
	      for (i = 0, len1 = ref.length; i < len1; i++) {
	        user = ref[i];
	        if (this.selected_all) {
	          if (!this.userIsSelected(user)) {
	            results.push(this.selectUser(user));
	          } else {
	            results.push(void 0);
	          }
	        } else {
	          results.push(this.selectUser(user));
	        }
	      }
	      return results;
	    },
	    selectUser: function(user) {
	      var carousel_user, index, users;
	      if (this.userIsSelected(user)) {
	        users = this.selected_users.map(function(selected) {
	          return selected.user;
	        });
	        index = this.indexOfUser(user);
	        if (this.selected_users[index].id != null) {
	          this.removed[this.selected_users[index].user_id] = this.selected_users[index];
	        }
	        this.selected_users.splice(index, 1);
	        this.reorderCarousel();
	        return this.selected_all = false;
	      } else {
	        if (this.removed[user.id] != null) {
	          carousel_user = this.removed[user.id];
	          delete this.removed[user.id];
	        } else {
	          carousel_user = new CarouselUser;
	        }
	        carousel_user.user_id = user.id;
	        carousel_user.next_user_id = this.selected_users.length > 0 ? this.selected_users[0].user_id : user.id;
	        carousel_user.user = user;
	        this.selected_users.push(carousel_user);
	        this.reorderCarousel();
	        return this.selected_all = this.selected_users.length === this.users.length;
	      }
	    },
	    loadCopy: function() {
	      this.selected_users = [];
	      this.users = [];
	      this.fields_select = Object.assign({}, this.custom_fields_select);
	      delete this.fields_select[this.custom['value']];
	      this.selected_users = this.dados[this.custom['value']].Carousel.carousel_users;
	      this.loadUsers();
	      return this.loading_carousel = false;
	    },
	    loadData: function() {
	      if (this.dados === void 0 || this.dados === null || Object.keys(this.dados).length === 0) {
	        this.selected_users = [];
	        this.users = [];
	        this.loadUsers();
	        return this.loadCarousel();
	      } else {
	        this.selected_users = [];
	        this.users = [];
	        if (this.dados !== void 0 && this.dados !== null) {
	          if (Object.keys(this.dados).length > 1) {
	            this.loadUsers();
	            return this.loadDadoShow();
	          }
	        }
	      }
	    },
	    loadUsersSuccess: function(data) {
	      this.users = data.users.filter(function(user) {
	        return !user.isAdmin();
	      });
	      this.users = data.users;
	      return this.loading_users = false;
	    },
	    loadUsers: function() {
	      var params;
	      this.loading_users = true;
	      params = {
	        q: {
	          accepted: true,
	          s: 'name asc'
	        }
	      };
	      if (this.current_user.isAdmin()) {
	        params['company_id'] = this.company_id;
	      }
	      return new UsersResource().index(this.loadUsersSuccess, this.unknownError, {
	        params: params
	      });
	    },
	    loadCarousel: function(data) {
	      return this.loading_carousel = false;
	    },
	    loadDadoShow: function() {
	      this.selected_users = this.dados.carousel_users;
	      this.carousel = this.dados;
	      return this.loading_carousel = false;
	    },
	    buildCarousel: function() {
	      var carousel, i, k, l, len1, len2, len3, ref, ref1, ref2, selected, user_removed;
	      carousel = new Carousel({
	        kind: this.kind
	      });
	      carousel.type = "CarouselByProperty";
	      if (this.carousel.id !== null) {
	        carousel.id = this.carousel.id;
	        carousel.custom_field_value = this.carousel.custom_field_value;
	        if (this.carousel.custom_field_value !== void 0) {
	          this.custom['value'] = this.carousel.custom_field_value;
	          this.custom['id'] = this.carousel.custom_field_id;
	        }
	        carousel.custom_field_id = this.carousel.custom_field_id;
	      }
	      if (this.copy) {
	        if (this.value_copy === "Outros") {
	          carousel.custom_field_value = null;
	        } else {
	          carousel.custom_field_value = this.value_copy;
	        }
	        ref = this.selected_users;
	        for (i = 0, len1 = ref.length; i < len1; i++) {
	          selected = ref[i];
	          carousel.carousel_users.push(new CarouselUser({
	            user_id: selected.user_id,
	            next_user_id: selected.next_user_id
	          }));
	        }
	      } else {
	        carousel.custom_field_value = this.custom['value'];
	        ref1 = this.selected_users;
	        for (k = 0, len2 = ref1.length; k < len2; k++) {
	          selected = ref1[k];
	          carousel.carousel_users.push(new CarouselUser({
	            id: selected.id,
	            user_id: selected.user_id,
	            next_user_id: selected.next_user_id
	          }));
	        }
	      }
	      carousel.custom_field_id = this.custom['id'];
	      carousel.next_user_id = this.selected_users.length > 0 ? this.selected_users[0].user_id : null;
	      if (Object.keys(this.removed).length > 0) {
	        ref2 = Object.values(this.removed);
	        for (l = 0, len3 = ref2.length; l < len3; l++) {
	          user_removed = ref2[l];
	          carousel.carousel_users.push(new CarouselUser({
	            id: user_removed.id,
	            user_id: user_removed.user_id,
	            next_user_id: user_removed.next_user_id,
	            _destroy: true
	          }));
	        }
	      }
	      return carousel;
	    },
	    cancel: function() {
	      jQuery('#carousel-config').modal('toggle');
	      jQuery('body').removeClass('modal-open');
	      jQuery('body').css('padding-right', '0px');
	      jQuery('.modal-backdrop').remove();
	      return this.$emit('closeModal');
	    },
	    save: function() {
	      var carousel, i, item, len1, params, ref;
	      if (this.copy) {
	        params = {
	          carousel_id_src: this.dados[this.custom['value']].Carousel.id,
	          carousel_id_dst: []
	        };
	        ref = Object.values(this.fields_select);
	        for (i = 0, len1 = ref.length; i < len1; i++) {
	          item = ref[i];
	          if (item.selected && item.custom_field_value !== this.$t('general.label.others')) {
	            params.carousel_id_dst.push(item.custom_field_value);
	          } else if (item.selected && item.custom_field_value === this.$t('general.label.others')) {
	            params.carousel_id_dst.push(null);
	          }
	        }
	        return new CarouselPropertyResource().copy(this.saveSuccessCopy, this.saveFailure, params);
	      } else {
	        carousel = this.buildCarousel().serialize();
	        return new CarouselPropertyResource().create_or_update(this.saveSuccess, this.saveFailure, carousel);
	      }
	    },
	    saveSuccessCopy: function(response) {
	      this.removed = [];
	      this.$emit('carousel_copy', response);
	      jQuery('#carousel-config').modal('hide');
	      return alertify.success(this.$t('integrations.feedback.carouselCopySuccess'));
	    },
	    saveFailureCopy: function(data) {
	      return alertify.error(this.$t('integrations.feedback.carouselCopyFail'));
	    },
	    saveSuccess: function(response) {
	      this.removed = [];
	      this.$emit('carousel_updated', response.carousel_by_property);
	      jQuery('#carousel-config').modal('hide');
	      return alertify.success(this.$t('integrations.label.modal_carousel.successFeedback'));
	    },
	    saveFailure: function(data) {
	      return alertify.error(this.$t('integrations.label.modal_carousel.failFeedback'));
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      seller_can_see_all_contacts: false,
	      seller_can_edit_templates: false,
	      seller_can_change_responsability: false,
	      company_id: Session.current_company.id,
	      company: null,
	      user: Session.current_user
	    };
	  },
	  methods: {
	    toggleSellerCanChangeResponsability: function() {
	      return this.seller_can_change_responsability = !this.seller_can_change_responsability;
	    },
	    toggleSellerCanSeeAllContacts: function() {
	      return this.seller_can_see_all_contacts = !this.seller_can_see_all_contacts;
	    },
	    toggleSellerCanEditTemplates: function() {
	      return this.seller_can_edit_templates = !this.seller_can_edit_templates;
	    },
	    loadCompany: function() {
	      Loader.on();
	      return new CompaniesResource().get(this.loadCompanySuccess, this.handleApiErrors, {
	        id: this.company_id
	      });
	    },
	    loadCompanySuccess: function(data) {
	      this.company = data.company;
	      this.seller_can_see_all_contacts = this.company.account_setting.seller_can_see_all_contacts;
	      this.seller_can_edit_templates = this.company.account_setting.seller_can_edit_templates;
	      this.seller_can_change_responsability = this.company.account_setting.seller_can_change_responsability;
	      return Loader.off();
	    },
	    updateCompany: function() {
	      if (this.company) {
	        this.company.account_setting.seller_can_see_all_contacts = this.seller_can_see_all_contacts;
	        this.company.account_setting.seller_can_edit_templates = this.seller_can_edit_templates;
	        return this.company.account_setting.seller_can_change_responsability = this.seller_can_change_responsability;
	      }
	    },
	    save: function() {
	      this.updateCompany();
	      if (this.company.account_setting.id) {
	        Loader.on();
	        return new CompaniesResource().update(this.saveSuccess, this.handleApiErrors, this.company.serialize());
	      } else {
	        Loader.off();
	        if (this.user.isManager()) {
	          return alertify.error('Sua empresa ainda não foi vinculada a nenhum plano, por favor solicite a adesão.');
	        } else {
	          return alertify.error('A empresa em questão precisa estar vinculada a um plano para alterar permissões.');
	        }
	      }
	    },
	    saveSuccess: function() {
	      Loader.off();
	      Session.current_company.account_setting.seller_can_see_all_contacts = this.seller_can_see_all_contacts;
	      Session.current_company.account_setting.seller_can_edit_templates = this.seller_can_edit_templates;
	      Session.current_company.account_setting.seller_can_change_responsability = this.seller_can_change_responsability;
	      return alertify.success('Permissões atualizadas com sucesso');
	    }
	  },
	  created: function() {
	    return this.loadCompany();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, summernote, view_model;
	
	helpers = __webpack_require__(2);
	
	summernote = __webpack_require__(77);
	
	view_model = {
	  data: function() {
	    return {
	      file: null,
	      user: {},
	      timezones: [
	        {
	          value: null,
	          text: 'Carregando...'
	        }
	      ],
	      loading: false
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll(this.user).then((function(_this) {
	        return function(success) {
	          if (_this.$signature.summernote('code') !== _this.user.signature) {
	            return _this.openModalSignature();
	          } else {
	            return _this.update(false);
	          }
	        };
	      })(this));
	    },
	    updateUser: function() {
	      Loader.on();
	      return this.usersResource.update(this.updateUserSuccess, this.handleApiErrors, this.buildFormData());
	    },
	    updateUserSuccess: function(data, response) {
	      Loader.off();
	      this.trackIntercomEvent(data.user);
	      Session.updateCurrentUser(response.body.user);
	      this.user = Session.currentUserCopy();
	      return alertify.success('Perfil salvo com sucesso');
	    },
	    buildFormData: function() {
	      var form_data;
	      form_data = new FormData();
	      if (this.file) {
	        form_data.append('picture', this.file);
	      }
	      form_data.append('id', this.user.id);
	      form_data.append('name', this.user.name);
	      form_data.append('timezone', this.user.timezone);
	      form_data.append('signature', this.user.signature);
	      if (this.user.update_all_signatures) {
	        form_data.append('update_all_signatures', this.user.update_all_signatures);
	      }
	      return form_data;
	    },
	    fileInput: function(event) {
	      var files;
	      files = event.target.files || event.dataTransfer.files;
	      if (files && files[0]) {
	        this.file = files[0];
	        return this.previewPicture();
	      }
	    },
	    loadTimezones: function() {
	      return this.usersResource.timezones(this.loadTimezonesSuccess);
	    },
	    loadTimezonesSuccess: function(response) {
	      var i, len, ref, results, timezone;
	      this.timezones = [
	        {
	          value: null,
	          text: 'Selecione um fuso horário'
	        }
	      ];
	      ref = response.body;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        timezone = ref[i];
	        results.push(this.timezones.push({
	          value: timezone,
	          text: timezone
	        }));
	      }
	      return results;
	    },
	    loadSignatureSummernote: function() {
	      this.$signature = jQuery('#signature');
	      summernote(this.$signature);
	      return this.$signature.summernote('code', this.user.signature);
	    },
	    ensureSignature: function() {
	      var signature;
	      signature = this.$signature.summernote('code');
	      return this.user.signature = signature !== '<p><br></p>' ? signature : '';
	    },
	    previewPicture: function() {
	      var reader;
	      reader = new FileReader();
	      reader.onload = function(e) {
	        return jQuery('.user-picture').css('background-image', "url(" + e.target.result + ")");
	      };
	      return reader.readAsDataURL(this.file);
	    },
	    trackIntercomEvent: function(user) {
	      var metadata;
	      metadata = [
	        {
	          attribute: 'name',
	          key: 'Nome',
	          "function": 'changedFromTo'
	        }, {
	          attribute: 'timezone',
	          key: 'Fuso horário',
	          "function": 'changedFromTo'
	        }, {
	          attribute: 'signature',
	          key: 'Assinatura atualizada',
	          "function": 'isChanged'
	        }, {
	          attribute: 'signature',
	          key: 'Quantidade de imagens na assinatura',
	          "function": 'htmlImgTagQuantityDiff'
	        }, {
	          attribute: 'signature',
	          key: 'Quantidade de hiperlinks assinatura',
	          "function": 'htmlATagQuantityDiff'
	        }, {
	          attribute: 'picture_url',
	          key: 'Foto de perfil alterada',
	          "function": 'isChanged'
	        }
	      ];
	      return IntercomCtrl.trackEventMetadata('Perfil atualizado', metadata, Session.current_user, user);
	    },
	    openModalSignature: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'atualizar-assinatura-confirmation-modal'
	      });
	    },
	    update: function(args) {
	      if (args) {
	        this.user.update_all_signatures = true;
	      }
	      this.ensureSignature();
	      return this.updateUser();
	    }
	  },
	  mounted: function() {
	    this.usersResource = new UsersResource();
	    this.user = Session.currentUserCopy();
	    this.loadSignatureSummernote();
	    return this.loadTimezones();
	  },
	  beforeDestroy: function() {
	    return this.$signature.summernote('destroy');
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 403 */
/***/ (function(module, exports) {

	exports["default"] = {
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      current_company: Session.current_company
	    };
	  },
	  computed: {
	    show_company_management_menus: function() {
	      return this.current_user.isAdmin() || (!this.current_user.requireEmailAuthorization() && !this.current_user.isSeller() && !this.current_user.isMonitoringManager());
	    }
	  }
	};


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    voipCard: __webpack_require__(110),
	    reportList: __webpack_require__(111),
	    confirm: __webpack_require__(70)
	  },
	  data: function() {
	    return {
	      iniDate: '',
	      endDate: '',
	      voipCards: [],
	      voipCalls: [],
	      next_page: 1,
	      additional_time: null,
	      loadingCards: false,
	      loadingList: false,
	      caller_id: '',
	      current_user: Session.current_user,
	      current_company: Session.current_company,
	      dynamicMask: '(##) #####-####'
	    };
	  },
	  computed: {
	    numeric_status: function() {
	      this.minutes_expended = this.seconds_left > 0 && this.seconds_left < 60 ? this.max_duration - (this.minutes_left + 1) : this.max_duration - this.minutes_left;
	      return this.minutes_expended + "/" + this.max_duration;
	    },
	    calc_bar_percentage: function() {
	      return (this.minutes_left / this.max_duration) * 100;
	    },
	    loading: function() {
	      return this.loadingCards || this.loadingList;
	    }
	  },
	  watch: {
	    caller_id: function() {
	      if (this.caller_id.length >= 15) {
	        return this.dynamicMask = '(##) #####-####';
	      } else {
	        return this.dynamicMask = '(##) ####-####';
	      }
	    }
	  },
	  methods: {
	    dateChanged: function(value) {
	      this.iniDate = value.from;
	      this.endDate = value.to;
	      return this.loadData();
	    },
	    cardTitle: function(type) {
	      switch (type) {
	        case 'minutes_total':
	          return 'Minutos Totais';
	        case 'fixed_bill_duration':
	          return 'Fixo';
	        case 'mobile_bill_duration':
	          return 'Celular';
	        case 'not_connected':
	          return 'Não conectadas';
	        case 'max_duration':
	          return 'Franquia Mensal';
	        case 'additional_consumed':
	          return 'Excedentes';
	        case 'fixed_added_time_consumed':
	          return 'Adicionais Fixo';
	        case 'mobile_added_time_consumed':
	          return 'Adicionais Celular';
	      }
	    },
	    cardClass: function(type) {
	      switch (type) {
	        case 'minutes_total':
	          return 'total-minutes';
	        case 'fixed_bill_duration':
	          return 'fix';
	        case 'mobile_bill_duration':
	          return 'cell';
	        case 'not_connected':
	          return 'not-conected';
	        case 'max_duration':
	          return 'monthly';
	        case 'additional_consumed':
	          return 'exceeded';
	        case 'fixed_added_time_consumed':
	          return 'additional-fix';
	        case 'mobile_added_time_consumed':
	          return 'additional-cell';
	      }
	    },
	    loadData: function() {
	      this.next_page = 1;
	      this.voipCards = [];
	      this.voipCalls = [];
	      this.loadCards();
	      return this.loadVoipCalls();
	    },
	    loadCards: function(params) {
	      if (this.loadingCards) {
	        return;
	      }
	      this.loadingCards = true;
	      params = {
	        q: {
	          period: {
	            from: this.iniDate,
	            to: this.endDate
	          }
	        }
	      };
	      return this.voip_call_resources.summary(this.loadSuccessCard, this.loadingFailure, {
	        params: params
	      });
	    },
	    loadSuccessCard: function(resources) {
	      var data, i, len, results, type, types;
	      this.loadingCards = false;
	      types = ['minutes_total', 'fixed_bill_duration', 'mobile_bill_duration', 'not_connected', 'max_duration', 'additional_consumed', 'fixed_added_time_consumed', 'mobile_added_time_consumed'];
	      data = resources.data;
	      results = [];
	      for (i = 0, len = types.length; i < len; i++) {
	        type = types[i];
	        results.push(this.voipCards.push({
	          type: type,
	          number: data[type],
	          title: this.cardTitle(type),
	          cssClass: this.cardClass(type)
	        }));
	      }
	      return results;
	    },
	    loadVoipCalls: function() {
	      var params;
	      if (this.loadingList || !this.next_page) {
	        return;
	      }
	      this.loadingList = true;
	      params = {
	        q: {
	          period: {
	            from: this.iniDate,
	            to: this.endDate
	          }
	        },
	        page: this.next_page
	      };
	      return this.voip_call_resources.index(this.loadSuccessVoipCalls, this.loadingFailure, {
	        params: params
	      });
	    },
	    loadSuccessVoipCalls: function(resources) {
	      this.loadingList = false;
	      this.next_page = resources.body.meta.next_page;
	      this.total_count = resources.body.meta.total_count;
	      return this.voipCalls = this.voipCalls.concat(resources.body.voip_calls);
	    },
	    loadingFailure: function() {
	      this.loadingCards = false;
	      this.loadingList = false;
	      return this.unknownError();
	    },
	    openModalConfirmation: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: "confirm-voip-caller_id"
	      });
	    },
	    save: function() {
	      var caller_id, id, ref;
	      caller_id = this.caller_id;
	      caller_id = '+55' + caller_id.replace(/[^0-9+]+/ig, "");
	      id = (ref = Session.current_company.plivo_setting) != null ? ref.id : void 0;
	      return new CompaniesResource().update(this.saveSuccessCallerId, this.loadingFailure, {
	        id: this.current_company.id,
	        plivo_setting_attributes: {
	          id: id,
	          caller_id: caller_id
	        }
	      });
	    },
	    saveSuccessCallerId: function() {
	      return alertify.success('Número alterado com sucesso');
	    }
	  },
	  created: function() {
	    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
	    this.caller_id = (ref = Session.current_company.plivo_setting) != null ? (ref1 = ref.caller_id) != null ? ref1.substring(3) : void 0 : void 0;
	    this.max_duration = (ref2 = Session.current_company.plivo_setting) != null ? (ref3 = ref2.voip_monthly_plan) != null ? ref3.max_duration_in_minutes() : void 0 : void 0;
	    this.minutes_left = parseInt(((ref4 = Session.current_company.plivo_setting) != null ? ref4.seconds_left : void 0) / 60);
	    this.seconds_left = (ref5 = Session.current_company.plivo_setting) != null ? ref5.seconds_left : void 0;
	    return this.additional_time = (ref6 = Session.current_company.plivo_setting) != null ? ref6.sum_additional_minutes() : void 0;
	  },
	  mounted: function() {
	    this.voip_call_resources = new VoipCallsResource(Session.current_company.id);
	    return this.dateChanged(this.$refs.date_range_picker.selected_option);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 405 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: ['cssClass', 'number', 'title', 'type'],
	  computed: {
	    convert_number: function() {
	      if (this.type === 'not_connected') {
	        return this.number;
	      }
	      return parseInt((this.number || 0) / 60);
	    },
	    suffix: function() {
	      if (this.type === 'not_connected') {
	        return 'lig';
	      }
	      return 'min';
	    }
	  }
	};


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  props: ['voipCalls'],
	  components: {
	    listItem: __webpack_require__(112)
	  },
	  methods: {
	    nextPage: function() {
	      return this.$emit('next-page');
	    }
	  }
	};


/***/ }),
/* 407 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: ['voipCall'],
	  methods: {
	    viewContact: function() {
	      if (!this.voipCall.contact.id) {
	        return;
	      }
	      return this.$router.push({
	        path: this.contactPath()
	      });
	    },
	    contactPath: function() {
	      return "/contatos/" + this.voipCall.contact.id;
	    }
	  },
	  computed: {
	    type: function() {
	      var ref;
	      if (((ref = this.voipCall) != null ? ref.phone_number_kind : void 0) === "mobile") {
	        return "celular";
	      } else {
	        return "fixo";
	      }
	    },
	    created_at: function() {
	      var m;
	      m = moment(this.voipCall.created_at);
	      return (m.format('D')) + " " + (m.format('MMM').toUpperCase()) + "/" + (m.format('YY'));
	    },
	    bill_duration: function() {
	      var hours, m, minutes;
	      m = moment.utc(this.voipCall.bill_duration * 1000);
	      hours = m.format('HH');
	      minutes = m.format('mm');
	      if (parseInt(hours) > 0) {
	        return hours + "h e " + minutes + " min";
	      } else {
	        return minutes + " min";
	      }
	    }
	  }
	};


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    contactPicker: __webpack_require__(54),
	    contactManualPicker: __webpack_require__(53)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      contact_group: new ContactGroup({
	        id: this.$route.params.id
	      }),
	      loaded_contacts: [],
	      selected_contacts: [],
	      new_contacts: [],
	      contact_ids_to_be_removed: [],
	      original_group_name: '',
	      next_page: 1,
	      fetching: false,
	      user_filters: {}
	    };
	  },
	  computed: {
	    filters: function() {
	      var merged_filters;
	      merged_filters = this.user_filters;
	      merged_filters.contact_group_id_eq = this.contact_group.id;
	      return merged_filters;
	    },
	    filtered_selected_contacts: function() {
	      return this.selected_contacts.filter((function(_this) {
	        return function(contact) {
	          return _this.filterContact(contact, _this.filters);
	        };
	      })(this));
	    },
	    filtered_new_contacts: function() {
	      return this.new_contacts.filter((function(_this) {
	        return function(contact) {
	          return _this.filterContact(contact, _this.filters);
	        };
	      })(this));
	    },
	    contacts: function() {
	      return this.loaded_contacts.concat(this.filtered_selected_contacts, this.filtered_new_contacts);
	    },
	    contacts_count: function() {
	      return this.contact_group.contacts_count + this.selected_contacts.length + this.new_contacts.length - this.contact_ids_to_be_removed.length;
	    }
	  },
	  methods: {
	    setContactGroup: function(contact_group) {
	      this.contact_group = contact_group;
	      return this.original_group_name = this.contact_group.name;
	    },
	    loadContactGroup: function() {
	      Loader.on();
	      return this.contact_group_resource.get(this.loadContactGroupSuccess, this.unknownError, {
	        id: this.$route.params.id
	      });
	    },
	    loadContactGroupSuccess: function(resources) {
	      this.setContactGroup(resources.contact_group);
	      return Loader.off();
	    },
	    loadContacts: function() {
	      if (this.fetching || !this.next_page) {
	        return;
	      }
	      this.fetching = true;
	      return this.contact_resource.index(this.loadContactsSuccess, this.unknownError, {
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadContactsSuccess: function(resources) {
	      this.next_page = resources.meta ? resources.meta.next_page : null;
	      this.loaded_contacts = this.loaded_contacts.concat(resources.contacts);
	      return this.fetching = false;
	    },
	    filter: function(filters) {
	      this.user_filters = filters;
	      this.loaded_contacts = [];
	      this.next_page = 1;
	      return this.loadContacts();
	    },
	    removeContactFromList: function(contact, list) {
	      var index;
	      index = list.findIndex(contact);
	      if (index > -1) {
	        return list.splice(index, 1);
	      }
	    },
	    removeFromGroup: function(data) {
	      if (data.contact.id) {
	        if (data.contact.contact_group) {
	          return this.removePersistedContact(data.contact);
	        } else {
	          return this.removeSelectedContact(data.contact);
	        }
	      } else {
	        return this.removeNewContact(data.contact);
	      }
	    },
	    removeNewContact: function(contact) {
	      return this.removeContactFromList(contact, this.new_contacts);
	    },
	    removeSelectedContact: function(contact) {
	      this.removeContactFromList(contact, this.selected_contacts);
	      return EventsBus.$emit('ContactsPicker:AddContact', {
	        contact: contact,
	        selected: false
	      });
	    },
	    removePersistedContact: function(contact) {
	      this.contact_ids_to_be_removed.push(contact.id);
	      this.removeContactFromList(contact, this.loaded_contacts);
	      return EventsBus.$emit('ContactsPicker:AddContact', {
	        contact: contact,
	        selected: false
	      });
	    },
	    saveGroup: function() {
	      Loader.on();
	      this.contact_group.contacts = this.contacts;
	      this.contact_group.contact_ids_to_be_removed = this.contact_ids_to_be_removed;
	      return this.contact_group_resource.update(this.saveSuccess, this.unknownError, this.contact_group.serialize());
	    },
	    saveSuccess: function(data) {
	      this.original_group_name = data.contact_group.name;
	      Loader.off();
	      this.$router.push({
	        path: '/contatos/grupos'
	      });
	      alertify.success('Grupo salvo com sucesso! Os contatos serão inseridos no grupo.');
	      return this.trackIntercomGroupUpdate(data.contact_group);
	    },
	    addContactsToGroup: function(data) {
	      var self;
	      self = this;
	      return data.contacts.forEach((function(_this) {
	        return function(contact) {
	          contact.user = _this.contact_group.user;
	          contact.stage = 'smart_lead';
	          contact.human_stage = 'Smart Lead';
	          contact.recipient_status = 'not_connected';
	          contact.human_recipient_status = 'Sem Conexão';
	          return _this.new_contacts.push(contact);
	        };
	      })(this));
	    },
	    selectContacts: function(data) {
	      return data.contacts.forEach((function(_this) {
	        return function(contact) {
	          var index;
	          index = _this.contact_ids_to_be_removed.indexOf(contact.id);
	          if (index > -1) {
	            if (index > -1) {
	              _this.contact_ids_to_be_removed.splice(index, 1);
	            }
	            _this.loaded_contacts.push(contact);
	          } else {
	            index = _this.selected_contacts.findIndex(contact);
	            if (index < 0) {
	              _this.selected_contacts.push(contact);
	            }
	          }
	          return EventsBus.$emit('ContactsPicker:RemoveContact', contact);
	        };
	      })(this));
	    },
	    filterContact: function(contact, filters) {
	      return (!filters.search_query || contact.full_name.toLowerCase().indexOf(filters.search_query.toLowerCase()) > -1) && (!filters.stage_eq || contact.stage === filters.stage_eq) && (!filters.current_recipient_status_eq || contact.recipient_status === filters.current_recipient_status_eq) && (!filters.contact_tags_tag_id_eq || contact.tags.some((function(_this) {
	        return function(tag) {
	          return tag.id === filters.contact_tags_tag_id_eq;
	        };
	      })(this)));
	    },
	    trackIntercomGroupUpdate: function(contact_group) {
	      var metadata;
	      metadata = {
	        id: contact_group.id,
	        'Nome': contact_group.name,
	        'Quantidade de contatos': contact_group.contacts_count
	      };
	      return IntercomCtrl.trackEvent('Editou um grupo', metadata);
	    }
	  },
	  created: function() {
	    this.contact_group_resource = new ContactGroupsResource(Session.current_company.id);
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    this.loadContactGroup();
	    this.loadContacts();
	    return EventsBus.$on('contact-picker-contacts-added', this.addContactsToGroup);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('contact-picker-contacts-added', this.addContactsToGroup);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_wrapper, helpers.contacts.list_view_modes);


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['filters'],
	  data: function() {
	    return {
	      sort_filter: this.extractFilter('s'),
	      sort_options: [
	        {
	          value: null,
	          text: this.$t('contacts_group.filters.sortBy')
	        }, {
	          value: {
	            s: 'name asc'
	          },
	          text: 'A-Z'
	        }, {
	          value: {
	            s: 'name desc'
	          },
	          text: 'Z-A'
	        }
	      ],
	      text_field_filter: null
	    };
	  },
	  computed: {
	    filterParams: function() {
	      var filter, filter_params, i, len, ref;
	      filter_params = {};
	      if ((this.sort_filter != null) && this.sort_filter.s === 'name asc') {
	        IntercomCtrl.trackEvent('Base de contatos - Grupos - Ordenação A-Z');
	      } else if ((this.sort_filter != null) && this.sort_filter.s === 'name desc') {
	        IntercomCtrl.trackEvent('Base de contatos - Grupos - Ordenação Z-A');
	      }
	      ref = [this.sort_filter];
	      for (i = 0, len = ref.length; i < len; i++) {
	        filter = ref[i];
	        if (filter) {
	          Object.assign(filter_params, filter);
	        }
	      }
	      if (this.text_field_filter) {
	        filter_params['search_query'] = this.text_field_filter;
	      }
	      return filter_params;
	    }
	  },
	  methods: {
	    filter: function() {
	      this.$emit('filter', this.filterParams);
	      if (this.text_field_filter) {
	        return IntercomCtrl.trackEvent('Filtrou a listagem de grupos');
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.filters);


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    filters: __webpack_require__(113),
	    contactGroupListItem: __webpack_require__(114)
	  },
	  props: {
	    contact_groups: {
	      "default": function() {
	        return [];
	      }
	    },
	    view_mode: {
	      type: Object,
	      required: true
	    },
	    filters: {
	      "default": function() {
	        return {};
	      }
	    },
	    selected_contact_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    all_initially_selected: {
	      "default": function() {
	        return false;
	      }
	    }
	  },
	  data: function() {
	    return {
	      selected_all: false
	    };
	  },
	  methods: {
	    filter: function(filters) {
	      return this.$emit('filter', filters);
	    },
	    toggleSelectAll: function() {
	      this.selected_all = !this.selected_all;
	      return EventsBus.$emit('ContactGroupList:SelectedAll', {
	        selected_all: this.selected_all
	      });
	    },
	    bubbleUp: function(data) {
	      if (data.event && data.event.originalEventName) {
	        return this.$emit(data.event.originalEventName, data);
	      } else {
	        return console.warn('bubbleUp method requires data.event.originalEventName to work properly');
	      }
	    }
	  },
	  created: function() {
	    return this.selected_all = this.all_initially_selected;
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    contact_group: {
	      type: ContactGroup
	    },
	    view_mode: {
	      type: Object,
	      required: true
	    },
	    selected_contact_ids: {
	      "default": []
	    },
	    initially_selected: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      selected: false
	    };
	  },
	  computed: {
	    all_group_contacts_selected: function() {
	      return this.checkAllContactsSelected();
	    },
	    opportunities: function() {
	      var value;
	      value = this.contact_group.opportunities_percentage;
	      if (value === null) {
	        return '--';
	      } else {
	        return value + '%';
	      }
	    },
	    group_contact_ids: function() {
	      return this.contact_group.contacts.map(function(contact) {
	        return contact.id;
	      });
	    },
	    remove_label: function() {
	      if (this.view_mode.remove_action === "remove-from-flow") {
	        return this.$t('contacts.actions.removeFromFlow');
	      } else {
	        return this.$t('general.actions.delete');
	      }
	    },
	    import_action_label: function() {
	      if (this.contact_group.import_action === "updated") {
	        return this.$t('contacts.actions.add');
	      } else {
	        return this.$t('groups.actions.create.createGroup');
	      }
	    },
	    is_processing: function() {
	      return this.contact_group.isProcessing();
	    },
	    is_with_error: function() {
	      return this.contact_group.isWithError();
	    },
	    contact_group_status_message: function() {
	      if (this.contact_group.isProcessing()) {
	        return this.$t('contacts_groups.feedback.updatingGroup');
	      } else if (this.contact_group.isWithError()) {
	        return this.$t('contacts_groups.feedback.creationFail');
	      }
	    },
	    contact_group_status_message_class: function() {
	      if (this.contact_group.isProcessing()) {
	        return 'flow-message-status flow-processing-status';
	      } else if (this.contact_group.isWithError()) {
	        return 'flow-message-status flow-error-status';
	      }
	    }
	  },
	  methods: {
	    toggleSelected: function() {
	      this.selected = !this.selected;
	      return this.emitSelectionToggleEvent();
	    },
	    emitSelectionToggleEvent: function() {
	      var attr;
	      event.originalEventName = 'group-selected';
	      attr = {
	        contact_group: this.contact_group,
	        selected: this.selected
	      };
	      return this.$emit('group-selected', {
	        event: event,
	        attr: attr
	      });
	    },
	    destroyGroup: function(event, attr) {
	      if (attr == null) {
	        attr = {};
	      }
	      event.originalEventName = 'group-destroy';
	      return this.$emit('group-destroy', {
	        event: event,
	        contact_group: this.contact_group
	      });
	    },
	    selectedAll: function(data) {
	      this.selected = data.selected_all;
	      return this.emitSelectionToggleEvent();
	    },
	    checkAllContactsSelected: function() {
	      var self;
	      self = this;
	      if (this.group_contact_ids === null || this.group_contact_ids.length === 0) {
	        return false;
	      }
	      return this.group_contact_ids.every(function(id) {
	        return self.selected_contact_ids.indexOf(id) >= 0;
	      });
	    },
	    editGroup: function() {
	      var editGroupPath;
	      editGroupPath = "/grupos-de-contatos/" + this.contact_group.id + "/editar";
	      return this.$router.push({
	        path: editGroupPath
	      });
	    },
	    checkboxToggle: function() {
	      if (this.view_mode.anywhere_select) {
	        return;
	      }
	      return toggleSelected();
	    },
	    rowClicked: function(event) {
	      if (!jQuery(event.target).closest('.clickable-element').length) {
	        if (this.view_mode.anywhere_select) {
	          return this.toggleSelected();
	        } else {
	          return this.editGroup();
	        }
	      }
	    }
	  },
	  created: function() {
	    this.selected = this.initially_selected || this.checkAllContactsSelected();
	    return EventsBus.$on('ContactGroupList:SelectedAll', this.selectedAll);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('ContactGroupList:SelectedAll', this.selectedAll);
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.contacts.styles, helpers.form);


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      group_name: null,
	      selected_contacts: {},
	      loaded_contacts: [],
	      persisted_selected_contacts: [],
	      persisted_selected_contact_ids: [],
	      loading: false,
	      next_page: 1
	    };
	  },
	  computed: {
	    contacts_count: function() {
	      return Object.keys(this.selected_contacts).length;
	    }
	  },
	  methods: {
	    loadContacts: function() {
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      this.filters = this.mergeCurrentUserFilter(this.filters);
	      return this.contact_resource.withoutGroup(this.loadSuccess, Loader.off, {
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadSuccess: function(resources) {
	      this.loading = false;
	      this.next_page = resources.meta.next_page;
	      return this.loaded_contacts = this.loaded_contacts.concat(resources.contacts);
	    },
	    filter: function(filters) {
	      this.loaded_contacts = [];
	      this.next_page = 1;
	      this.filters = filters;
	      return this.loadContacts();
	    },
	    createGroup: function() {
	      var contacts_ids;
	      if (!this.group_name) {
	        return;
	      }
	      Loader.on();
	      contacts_ids = Object.values(this.selected_contacts).map(function(x) {
	        return x.id;
	      });
	      this.contact_group_resource.post(this.saveSuccess, this.saveFailure, {
	        name: this.group_name,
	        contacts: contacts_ids
	      });
	      return jQuery("#new-group-modal").modal('hide');
	    },
	    saveSuccess: function(resource) {
	      var self;
	      self = this;
	      Loader.off();
	      this.group_name = null;
	      alertify.success(this.$t('contacts_group.feedback.creationSuccess'));
	      this.selected_contacts = {};
	      this.$emit('contact-group-saved', resource);
	      return this.trackIntercomGroupCreation(resource.contact_group);
	    },
	    saveFailure: function(response) {
	      Loader.off();
	      if (response.body.name) {
	        return alertify.error(response.body.name[0]);
	      } else {
	        return alertify.error(this.$t('contacts_group.feedback.creationProblem'));
	      }
	    },
	    updateSelectedContacts: function(data) {
	      if (data.attr.selected) {
	        return Vue.set(this.selected_contacts, data.attr.contact.id, data.attr.contact);
	      } else {
	        return Vue["delete"](this.selected_contacts, data.attr.contact.id);
	      }
	    },
	    resetModal: function() {
	      this.selected_contacts = {};
	      this.loaded_contacts = [];
	      this.persisted_selected_contacts = [];
	      this.persisted_selected_contact_ids = [];
	      this.next_page = 1;
	      return this.loadContacts();
	    },
	    show: function() {
	      this.resetModal();
	      return jQuery("#new-group-modal").modal('show');
	    },
	    trackIntercomGroupCreation: function(contact_group) {
	      var metadata;
	      metadata = {
	        id: contact_group.id,
	        'Nome': contact_group.name,
	        'Quantidade de contatos': contact_group.contacts_count
	      };
	      return IntercomCtrl.trackEvent(this.$t('contacts_group.events.created'), metadata);
	    }
	  },
	  created: function() {
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    this.contact_group_resource = new ContactGroupsResource(Session.current_company.id);
	    this.loadContacts();
	    return EventsBus.$on('new-group-modal-show', this.show);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('new-group-modal-show', this.show);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes, helpers.filters);


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    businessesList: __webpack_require__(95),
	    newBusinessModal: __webpack_require__(97)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      filters: {},
	      fetching: false,
	      next_page: true,
	      total_count: 0,
	      businesses: []
	    };
	  },
	  methods: {
	    showCreateModal: function() {
	      return jQuery("#new-business-modal").modal('show');
	    },
	    closeCreateModal: function() {
	      return jQuery("#new-business-modal").modal('hide');
	    },
	    created: function(business) {
	      this.closeCreateModal();
	      return this.updateBusinessList(business);
	    },
	    updateBusinessList: function(business) {
	      return this.businesses.unshift(business);
	    },
	    leadsRedirect: function() {
	      return this.$router.push('/contatos/leads');
	    },
	    businessRedirect: function() {
	      return this.$router.push('/contatos/empresas');
	    },
	    groupsRedirect: function() {
	      return this.$router.push('/contatos/grupos');
	    },
	    filter: function(filters) {
	      this.filters = filters;
	      this.businesses = [];
	      this.next_page = 1;
	      return this.loadData();
	    },
	    loadData: function() {
	      if (this.fetching || !this.next_page) {
	        return;
	      }
	      this.fetching = true;
	      return this.businesses_resource.index(this.loadSuccess, this.unknownError, {
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadSuccess: function(resources) {
	      this.fetching = false;
	      this.next_page = resources.meta.next_page;
	      this.total_count = resources.meta.total_count;
	      this.businesses = this.businesses.concat(resources.businesses);
	      return Loader.off();
	    },
	    showNabBars: function() {
	      return !Session.current_user.new_ui;
	    }
	  },
	  mounted: function() {
	    return this.errors.clear();
	  },
	  created: function() {
	    this.businesses_resource = new BusinessesResource(Session.current_company.id);
	    return this.loadData();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 414 */
/***/ (function(module, exports) {

	exports["default"] = {
	  data: function() {
	    return {
	      info: null,
	      user: null
	    };
	  },
	  props: {
	    hide_on_confirm: {
	      "default": true
	    }
	  },
	  methods: {
	    confirm: function(flag_finish) {
	      if (this.hide_on_confirm) {
	        jQuery("#change-responsability").modal('hide');
	      }
	      return this.$emit('confirm-modal-confirm', {
	        user: this.user,
	        flag_finish: flag_finish
	      });
	    },
	    reject: function() {
	      return this.$emit('confirm-modal-reject');
	    },
	    show: function(data) {
	      this.info = data.data;
	      this.user = data.user;
	      return jQuery("#" + data.id).modal('show');
	    },
	    loadInfo: function() {
	      return this.contact_resource.transferInfo(this.loadInfoSuccess, this.unknownError);
	    }
	  },
	  created: function() {
	    EventsBus.$on('confirm-modal-show', this.show);
	    return this.contact_resource = new ContactsResource(Session.current_company.id);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('confirm-modal-show', this.show);
	  }
	};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    hide_on_confirm: {
	      "default": true
	    }
	  },
	  data: function() {
	    return {
	      name: '',
	      tagColors: this.colors()
	    };
	  },
	  methods: {
	    close: function() {
	      this.errors.clear();
	      return jQuery("#create-tag").modal('hide');
	    },
	    create: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          var params;
	          params = {
	            name: _this.name,
	            color: _this.color()
	          };
	          Loader.on();
	          return new TagsResource().create(_this.createSuccess, _this.handleApiErrors, params);
	        };
	      })(this))["catch"]((function(_this) {
	        return function() {
	          return _this.errors;
	        };
	      })(this));
	    },
	    createSuccess: function(data) {
	      Loader.off();
	      this.close();
	      alertify.success('Salvo com sucesso');
	      this.name = '';
	      this.tagColors.forEach(function(color) {
	        return color["class"] = '';
	      });
	      return EventsBus.$emit('MassActions:Autocomplete:TagCreated', data.tag);
	    },
	    setColor: function(color) {
	      this.tagColors.forEach(function(color) {
	        return color["class"] = '';
	      });
	      return color["class"] = 'selected';
	    },
	    colors: function() {
	      return Tag.colors.map(function(color) {
	        return {
	          hex: color,
	          "class": ''
	        };
	      });
	    },
	    color: function() {
	      var ref;
	      return (ref = this.tagColors.find(function(color) {
	        return color["class"] === 'selected';
	      })) != null ? ref.hex : void 0;
	    },
	    show: function(data) {
	      this.name = data.name;
	      if (data.id === "create-tag") {
	        return jQuery("#create-tag").modal('show');
	      }
	    },
	    loadInfo: function() {
	      return this.contact_resource.transferInfo(this.loadInfoSuccess, this.unknownError);
	    }
	  },
	  created: function() {
	    EventsBus.$on('confirm-modal-show', this.show);
	    return this.contact_resource = new ContactsResource(Session.current_company.id);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('confirm-modal-show', this.show);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, voip_locale;
	
	helpers = __webpack_require__(2);
	
	voip_locale = __webpack_require__(79).voip;
	
	exports["default"] = {
	  components: {
	    contactAutocomplete: __webpack_require__(64),
	    tag: __webpack_require__(9),
	    lostReasonModal: __webpack_require__(38)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      current_company: Session.current_company,
	      input_number: '',
	      phone_number: '',
	      status: 'idle',
	      show_numbers: false,
	      muted: false,
	      show_dialer: false,
	      fail_reason: '',
	      task: new Task(),
	      phone_number_type: '',
	      contact: null,
	      set_interval: null,
	      timer: '00:00',
	      counter: 0,
	      sip_authenticated: false,
	      call_status: 'no_connection',
	      started_call: false,
	      web_rtc_support: true,
	      show_lost_reason_modal: false,
	      temp_attr: null
	    };
	  },
	  methods: {
	    closeLostReasonModal: function() {
	      return this.show_lost_reason_modal = false;
	    },
	    updateLostContact: function(lost_reason) {
	      var attr;
	      attr = {
	        stage: 'lost',
	        lost_reason_id: lost_reason.id,
	        lost_reason_comment: lost_reason.comment,
	        send_to_new_flow: lost_reason.send_to_new_flow,
	        due_on_date_custom: lost_reason.due_on_date_custom,
	        flow: lost_reason.flow,
	        immediately: lost_reason.immediately
	      };
	      if (lost_reason.status) {
	        attr.status = lost_reason.status;
	      }
	      if (lost_reason.schedule_set_contact_stage) {
	        attr.schedule_set_contact_stage = lost_reason.schedule_set_contact_stage;
	      }
	      this.updateContact(attr);
	      return this.show_lost_reason_modal = false;
	    },
	    updateContact: function(data) {
	      data.id = this.contact.id;
	      return this.contact_resources.update(this.updateContactSuccess, this.unknownError, data);
	    },
	    updateContactSuccess: function() {
	      return alertify.success('Contato atualizado com sucesso!');
	    },
	    openTaskModalForm: function() {
	      return EventsBus.$emit('TaskModalForm::Show', {
	        task_id: null,
	        contact: this.contact,
	        id: 'dialer-manual-task-form-modal'
	      });
	    },
	    selectContact: function(contact) {
	      this.contact = contact;
	      if (contact.telephone) {
	        this.updateInputNumber(contact.telephone);
	        this.phone_number_type = 'telephone';
	      } else if (contact.cellphone) {
	        this.updateInputNumber(contact.cellphone);
	        this.phone_number_type = 'cellphone';
	      }
	      return EventsBus.$emit('toggle-task-bar', contact.id);
	    },
	    newComment: function(open_anyway) {
	      if (open_anyway == null) {
	        open_anyway = false;
	      }
	      this.open_anyway = open_anyway;
	      if (this.task && this.task.id) {
	        return this.task_resources.get(this.loadTaskSuccess, this.unknownError, {
	          id: this.task.id
	        });
	      } else {
	        return EventsBus.$emit('Comment::New', {
	          contact: this.contact,
	          template: null
	        });
	      }
	    },
	    loadTaskSuccess: function(data) {
	      this.task = data.task;
	      if (this.task.template.id) {
	        return EventsBus.$emit('Comment::New', {
	          contact: this.contact,
	          template: this.task.template
	        });
	      } else if (this.open_anyway) {
	        return EventsBus.$emit('Comment::New', {
	          contact: this.contact,
	          template: null
	        });
	      }
	    },
	    updateInputNumber: function(number) {
	      if (this.input_number) {
	        return this.input_number += number;
	      } else {
	        return this.input_number = this.default_country_preffix + number;
	      }
	    },
	    saveCallContact: function(reset) {
	      var voip_call;
	      voip_call = new VoipCall;
	      if (this.plivo) {
	        voip_call.id = this.plivo.client.getLastCallUUID();
	      }
	      voip_call.status = this.call_status;
	      this.voip_call_resources.update(this.updateStatusSuccess, this.unknownError, voip_call);
	      if (!reset) {
	        return this.close();
	      }
	    },
	    updateStatusSuccess: function() {
	      this.task.voip_call_status = this.call_status;
	      return alertify.success("Status atualizado com sucesso");
	    },
	    removeTag: function(data) {
	      var params;
	      params = {
	        id: this.contact.id,
	        contact_tags_attributes: [
	          {
	            id: data.taggable_tag_id,
	            _destroy: true
	          }
	        ]
	      };
	      return this.contact_resources.update(this.removeTagSuccess(data), this.unknownError, params);
	    },
	    removeTagSuccess: function(data) {
	      return (function(_this) {
	        return function(response) {
	          alertify.success('Tag removida com sucesso!');
	          return EventsBus.$emit('update-tags', data);
	        };
	      })(this);
	    },
	    updateTags: function(data) {
	      return this.contact.tags = this.contact.tags.filter(function(tag) {
	        return tag.taggable_tag_id !== data.taggable_tag_id;
	      });
	    },
	    openTagsModal: function() {
	      return EventsBus.$emit('open-tag-picker-modal', this.contact);
	    },
	    openContact: function(contact_id) {
	      return this.$router.push('/contatos/' + contact_id);
	    },
	    toggleTaskBar: function() {
	      return EventsBus.$emit('toggle-task-bar', this.contact.id);
	    },
	    open: function(data) {
	      if (!this.checkVoipPermissions()) {
	        return;
	      }
	      this.contact = data.contact;
	      if (data.task) {
	        this.task = data.task;
	      }
	      this.input_number = this.default_country_preffix + data.number;
	      this.phone_number_type = data.number_type;
	      this.show_dialer = true;
	      if (this.contact) {
	        this.$nextTick((function(_this) {
	          return function() {
	            return _this.$refs.phone_input.focus();
	          };
	        })(this));
	      } else {
	        this.$nextTick((function(_this) {
	          return function() {
	            return jQuery('#dialer .v-autocomplete .v-autocomplete-input').focus();
	          };
	        })(this));
	      }
	      if (this.contact) {
	        EventsBus.$emit('reload-task-bar', this.contact.id);
	      }
	      if (data.open_comment) {
	        return this.newComment(false);
	      }
	    },
	    reset: function(number, phone_type) {
	      this.status = 'idle';
	      this.started_call = false;
	      this.fail_reason = '';
	      this.timer = '00:00';
	      this.input_number = this.default_country_preffix;
	      if (number) {
	        this.input_number = number;
	        this.phone_number_type = phone_type;
	      } else {
	        this.phone_number_type = '';
	      }
	      this.task = new Task;
	      return this.saveCallContact(true);
	    },
	    close: function() {
	      this.hangupCall();
	      this.muted = false;
	      this.call_status = 'no_connection';
	      this.show_dialer = false;
	      this.status = 'idle';
	      this.fail_reason = '';
	      this.timer = '00:00';
	      this.contact = null;
	      this.task = new Task;
	      return this.input_number = this.default_country_preffix;
	    },
	    checkVoipPermissions: function() {
	      var url;
	      if (this.status !== 'idle') {
	        alertify.error(voip_locale.error_messages.ongoing_call);
	        return false;
	      }
	      if (!(Session.current_user.plivo_endpoint && !Session.current_company.isVoipExceeded() && Session.current_company.isPlivo())) {
	        url = 'https://materiaisotb.outboundmarketing.com.br/contratacao-voip';
	        window.open(url, '_blank');
	        return false;
	      }
	      if (!this.web_rtc_support) {
	        alertify.error(voip_locale.error_messages.web_rtc_support);
	        return false;
	      }
	      if (!this.sip_authenticated) {
	        alertify.error(voip_locale.error_messages.authentication);
	        return false;
	      }
	      if (typeof Plivo === "undefined" || Plivo === null) {
	        alertify.error(voip_locale.error_messages.generic);
	        return false;
	      }
	      return true;
	    },
	    reloadContact: function(contact) {
	      return this.contact = contact;
	    },
	    goBack: function() {
	      return this.show_numbers = false;
	    },
	    setCallStatus: function(status) {
	      if (status === 'lost') {
	        this.call_status = status;
	        this.temp_attr = {
	          stage: 'lost'
	        };
	        return this.show_lost_reason_modal = true;
	      } else {
	        return this.call_status = status;
	      }
	    },
	    toggleMute: function() {
	      if (!this.is_calling_on) {
	        return;
	      }
	      this.muted = !this.muted;
	      if (this.muted) {
	        return this.plivo.client.mute();
	      } else {
	        return this.plivo.client.unmute();
	      }
	    },
	    startCall: function() {
	      if (this.started_call) {
	        return;
	      }
	      if (!this.contact) {
	        alertify.error("Por favor selecione um contato.");
	        return;
	      }
	      this.phone_number = this.input_number;
	      this.started_call = true;
	      if (this.task.id) {
	        this.plivo.client.call(helpers.masks.normalizePhone(this.phone_number), {
	          'X-PH-TaskId': this.task.id
	        });
	      } else {
	        this.plivo.client.call(helpers.masks.normalizePhone(this.phone_number), {
	          'X-PH-ContactId': this.contact.id
	        });
	      }
	      return this.show_numbers = false;
	    },
	    hangupCall: function() {
	      this.started_call = false;
	      this.status = 'ended';
	      this.fail_reason = '';
	      this.show_numbers = false;
	      return this.plivo.client.hangup();
	    },
	    insertPhoneNumber: function(number) {
	      this.input_number = this.input_number + number;
	      if (this.status === 'connected') {
	        return this.plivo.client.sendDtmf(number);
	      }
	    },
	    removeLastPhoneNumber: function() {
	      if (this.input_number && this.input_number.length > 0) {
	        return this.input_number = this.input_number.substring(0, this.input_number.length - 1);
	      } else {
	        this.contact = null;
	        return EventsBus.$emit('close-task-bar');
	      }
	    },
	    increaseTime: function() {
	      return this.timer = moment().hour(0).minute(0).second(this.counter++).format('mm:ss');
	    },
	    startTimer: function() {
	      return this.set_interval = setInterval(this.increaseTime, 1000);
	    },
	    stopTimer: function() {
	      this.counter = 0;
	      return clearInterval(this.set_interval);
	    },
	    onPlivoWebrtcNotSupported: function() {
	      return this.web_rtc_support = false;
	    },
	    onPlivoLogin: function() {
	      return this.sip_authenticated = true;
	    },
	    onPlivoLoginFailed: function() {
	      return this.sip_authenticated = false;
	    },
	    onPlivoCallFailed: function(error) {
	      console.log('[DEBUG] Dialer: Method: onPlivoCallFailed -> error: ' + error);
	      this.started_call = false;
	      this.status = 'failed';
	      this.fail_reason = error;
	      this.stopTimer();
	      this.checkMicPermission(error);
	      if (this.fail_reason === 'User Denied Media Access' || this.fail_reason === 'Canceled') {
	        return setTimeout(((function(_this) {
	          return function() {
	            return _this.close();
	          };
	        })(this)), 5000);
	      } else {
	        this.registerTaskVoipCall();
	        return this.createNewTask();
	      }
	    },
	    onPlivoCallAnswered: function(data) {
	      console.log('[DEBUG] Dialer: Method: onPlivoCallAnswered -> data: ' + data);
	      this.status = 'connected';
	      return this.startTimer();
	    },
	    onPlivoCallTerminated: function(data) {
	      console.log('[DEBUG] Dialer: Method: onPlivoCallTerminated -> data: ' + data);
	      this.started_call = false;
	      this.status = 'ended';
	      this.stopTimer();
	      this.registerTaskVoipCall();
	      return this.createNewTask();
	    },
	    onPlivoCalling: function(data) {
	      return this.status = 'calling';
	    },
	    onMediaPermission: function(data) {
	      console.log('Media Permission:');
	      return console.log(data);
	    },
	    registerTaskVoipCall: function() {
	      return EventsBus.$emit('voip-call-complete', this.task);
	    },
	    checkMicPermission: function(error) {
	      if (error !== 'User Denied Media Access') {
	        return;
	      }
	      return alertify.error(voip_locale.error_messages.mic_permission);
	    },
	    initializePlivo: function(counter) {
	      var plivo_credentials;
	      if (counter == null) {
	        counter = 0;
	      }
	      if (!Session.current_user.plivo_endpoint) {
	        return;
	      }
	      if (typeof Plivo === "undefined" || Plivo === null) {
	        if (counter < 200) {
	          setTimeout(((function(_this) {
	            return function() {
	              return _this.initializePlivo(counter + 1);
	            };
	          })(this)), 50);
	        }
	        return;
	      }
	      this.buildPlivoInstance();
	      plivo_credentials = Session.current_user.plivo_endpoint;
	      return this.plivo.client.login(plivo_credentials.username, plivo_credentials.password);
	    },
	    createNewTask: function() {
	      if (this.task.id != null) {
	        return;
	      }
	      this.task.service = 'ManualTasksServices::Phonecall';
	      this.task.type = 'ManualTask';
	      this.task.company = this.current_company;
	      this.task.contact = this.contact;
	      this.task.assigned_to = this.current_user;
	      this.task.assigned_to_id = this.current_user.id;
	      this.task.referenceable_id = this.contact.id;
	      this.task.referenceable_type = 'Contact';
	      this.task.created_by = this.current_user;
	      this.task.due_on = moment();
	      this.task.done_at = moment();
	      this.task.voip_calls_count = 1;
	      this.task.undefined_time = true;
	      return EventsBus.$emit('Task::Done', this.task);
	    },
	    buildPlivoInstance: function() {
	      this.plivo = new Plivo({
	        permOnClick: true
	      });
	      this.plivo.client.on('onWebrtcNotSupported', this.onPlivoWebrtcNotSupported);
	      this.plivo.client.on('onLogin', this.onPlivoLogin);
	      this.plivo.client.on('onLoginFailed', this.onPlivoLoginFailed);
	      this.plivo.client.on('onCallFailed', this.onPlivoCallFailed);
	      this.plivo.client.on('onCallAnswered', this.onPlivoCallAnswered);
	      this.plivo.client.on('onCallTerminated', this.onPlivoCallTerminated);
	      this.plivo.client.on('onCalling', this.onPlivoCalling);
	      return this.plivo.client.on('onMediaPermission', this.onMediaPermission);
	    }
	  },
	  computed: {
	    dial_css_class: function() {
	      if (this.contact) {
	        return "";
	      } else {
	        return "disabled";
	      }
	    },
	    show_contact_button: function() {
	      var ref;
	      return ((ref = this.contact) != null ? ref.id : void 0) != null;
	    },
	    show_call_status_options: function() {
	      console.log('[DEBUG] Dialer: show_call_status_options: ' + (this.status === "ended" || this.status === "failed") && (this.fail_reason !== "User Denied Media Access" && this.fail_reason !== "Canceled"));
	      console.log('[DEBUG] Dialer: Dialer status: ' + this.status);
	      console.log('[DEBUG] Dialer: Fail reason: ' + this.fail_reason);
	      return (this.status === "ended" || this.status === "failed") && (this.fail_reason !== "User Denied Media Access" && this.fail_reason !== "Canceled");
	    },
	    is_calling_on: function() {
	      var index;
	      index = this.connected_status.indexOf(this.status);
	      return index >= 0;
	    },
	    human_status: function() {
	      return voip_locale.call_status[this.status];
	    },
	    human_fail_reason: function() {
	      return voip_locale.error_messages.failed_status[this.fail_reason] || this.default_fail_status;
	    },
	    human_number_type: function() {
	      var phone_type;
	      phone_type = 'Outro número';
	      if (this.phone_number_type === 'cellphone') {
	        phone_type = 'Celular';
	      }
	      if (this.phone_number_type === 'telephone') {
	        phone_type = 'Fixo';
	      }
	      return phone_type;
	    }
	  },
	  watch: {
	    input_number: function(new_value, old_value) {
	      if (this.status !== 'idle') {
	        return new_value;
	      }
	      return this.input_number = helpers.masks.maskPhone(new_value);
	    }
	  },
	  mounted: function() {
	    setTimeout(((function(_this) {
	      return function() {
	        return _this.initializePlivo();
	      };
	    })(this)), 1000);
	    return jQuery(window).on('unload', this.hangupCall);
	  },
	  created: function() {
	    EventsBus.$on('open-dialer', this.open);
	    EventsBus.$on('update-contact', this.reloadContact);
	    EventsBus.$on('update-tags', this.updateTags);
	    this.contact_resources = new ContactsResource(Session.current_company.id);
	    this.voip_call_resources = new VoipCallsResource(Session.current_company.id);
	    this.task_resources = new TasksResource;
	    this.default_country_preffix = '55';
	    this.possible_status = ['idle', 'calling', 'connected', 'ended', 'failed'];
	    this.connected_status = ['calling', 'connected'];
	    this.default_fail_status = voip_locale.error_messages.failed_status['Unavailable'];
	    if (this.$store.getters.meetingTypesCount === 0) {
	      return this.$store.dispatch('fetchMeetingTypes');
	    }
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('open-dialer', this.open);
	    EventsBus.$off('update-tags', this.updateTags);
	    return EventsBus.$off('update-contact', this.reloadContact);
	  }
	};


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    filters: __webpack_require__(129),
	    rdStationEvent: __webpack_require__(135),
	    pipedriveEvent: __webpack_require__(134),
	    hsEvent: __webpack_require__(130),
	    pipedriveCreatedEvent: __webpack_require__(133),
	    sharpSpringEvent: __webpack_require__(136),
	    leadLoversEvent: __webpack_require__(131),
	    commentEvent: __webpack_require__(127),
	    manualTaskEvent: __webpack_require__(132),
	    event: __webpack_require__(128),
	    taskDestroyedEvent: __webpack_require__(137)
	  },
	  data: function() {
	    return {
	      contact: {},
	      events: [],
	      filters: {},
	      next_page: 1,
	      loading: false
	    };
	  },
	  methods: {
	    contactLoaded: function(data) {
	      this.contact = data.contact;
	      this.contact_events_resource = new ContactEventsResource(this.contact.id);
	      return this.loadEvents();
	    },
	    addEvent: function(event) {
	      return this.events.unshift(event);
	    },
	    removeEvent: function(event) {
	      return this.events.remove(event.id);
	    },
	    eventUpdated: function(event) {
	      return this.events.replaceById(event);
	    },
	    loadEvents: function() {
	      if (!this.contact_events_resource || this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      if (Session.current_user.extradata.new_contacts_events) {
	        return this.loadNewEvents();
	      }
	      return this.contact_events_resource.index(this.loadEventsSuccess, this.unknownError, {
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadNewEvents: function() {
	      var headers, path;
	      path = "https://" + (("69jkp3mxgb") + (".execute-api.us-east-1.amazonaws.com/production")) + "/contacts";
	      headers = {
	        'authorization': ("slC2Di7IJgMDNlsirsEd33cKOwQ7PL"),
	        'x-user-token': Session.current_user.authentication_token
	      };
	      return jQuery.ajax({
	        url: path,
	        headers: headers,
	        data: {
	          q: this.filters,
	          page: this.next_page,
	          contact_id: this.contact.id
	        },
	        success: this.loadEventsSuccessNewEvents,
	        error: this.unknownError
	      });
	    },
	    loadEventsSuccess: function(resources) {
	      this.events = this.events.concat(resources.events);
	      this.next_page = resources.meta.next_page;
	      return this.loading = false;
	    },
	    loadEventsSuccessNewEvents: function(resources) {
	      var events;
	      events = resources.events.map(function(event) {
	        return new ContactEvent(event);
	      });
	      return this.loadEventsSuccess({
	        events: events,
	        meta: resources.meta
	      });
	    },
	    filter: function(filters) {
	      this.events = [];
	      this.next_page = 1;
	      this.filters = filters;
	      return this.loadEvents();
	    },
	    eventComponent: function(event) {
	      switch (event.type()) {
	        case 'CommentEvent':
	          return 'comment-event';
	        case 'ManualTaskEvent':
	          return 'manual-task-event';
	        case 'ContactCreatedByPipedriveEvent':
	          return 'pipedrive-created-event';
	        case 'ContactUpdatedByPipedriveEvent':
	          return 'pipedrive-event';
	        case 'ContactCreatedByRdStationEvent':
	          return 'rd-station-event';
	        case 'ContactUpdatedByRdStationEvent':
	          return 'rd-station-event';
	        case 'ContactCreatedByHubspotEvent':
	          return 'hs-event';
	        case 'ContactUpdatedByHubspotEvent':
	          return 'hs-event';
	        case 'ContactCreatedBySharpSpringEvent':
	          return 'sharp-spring-event';
	        case 'ContactUpdatedBySharpSpringEvent':
	          return 'sharp-spring-event';
	        case 'ContactCreatedByLeadLoversEvent':
	          return 'lead-lovers-event';
	        case 'ContactUpdatedByLeadLoversEvent':
	          return 'lead-lovers-event';
	        case 'TaskDestroyedEvent':
	          return 'task-destroyed-event';
	        default:
	          return 'event';
	      }
	    },
	    handleToggleDone: function(task) {
	      var manual_task_event;
	      manual_task_event = new ContactEvent({
	        description: null,
	        detailed_type: 'ManualTaskEvent',
	        title: task.text,
	        created_at: task.done_at
	      });
	      manual_task_event.task = new Task(task);
	      return this.addEvent(manual_task_event);
	    }
	  },
	  created: function() {
	    EventsBus.$on('contact-loaded', this.contactLoaded);
	    return EventsBus.$on('Task::Done', this.handleToggleDone);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('contact-loaded', this.contactLoaded);
	    return EventsBus.$off('Task::Done', this.handleToggleDone);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.guid);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    autocompleteGroup: __webpack_require__(173)
	  },
	  mixins: [__webpack_require__(6), __webpack_require__(80)],
	  props: {
	    filters: {
	      "default": {}
	    },
	    show_user_filter: {
	      "default": true
	    },
	    show_status_filter: {
	      "default": true
	    },
	    show_stage_filter: {
	      "default": true
	    },
	    show_tag_filter: {
	      "default": true
	    },
	    show_group_filter: {
	      "default": false
	    },
	    show_lost_reason_filter: {
	      "default": true
	    },
	    label_clear_filter: {
	      "default": true
	    },
	    user_id: {
	      "default": null
	    }
	  },
	  data: function() {
	    return {
	      filter_item_selected_ids: this.filters['with_tags'],
	      uncheck_all_items: false,
	      kind_multiple_filter: 'tag_filter',
	      status_filter: this.statusFilter(),
	      pristine_filter: true,
	      base_filter_str: '{}',
	      status_options: [
	        {
	          value: null,
	          text: this.$t('contacts.attributes.status.title')
	        }, {
	          value: {
	            active_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.active')
	        }, {
	          value: {
	            bounced_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.bounced')
	        }, {
	          value: {
	            connected_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.connected')
	        }, {
	          value: {
	            uninitialized_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.uninitialized')
	        }, {
	          value: {
	            paused_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.paused')
	        }, {
	          value: {
	            converting_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.converting')
	        }, {
	          value: {
	            scheduled_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.scheduled')
	        }, {
	          value: {
	            interrupted_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.interrupted')
	        }, {
	          value: {
	            blocklisted_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.blocklisted')
	        }, {
	          value: {
	            not_connected_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.notConnected')
	        }, {
	          value: {
	            disqualified_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.disqualified')
	        }, {
	          value: {
	            inactive_status: true
	          },
	          text: this.$t('contacts.attributes.status.options.inactive')
	        }
	      ],
	      stage_filter: this.extractFilter('stage_eq'),
	      stage_options: [
	        {
	          value: null,
	          text: this.$t('contacts.attributes.stage.title')
	        }, {
	          value: {
	            stage_eq: 'smart_lead'
	          },
	          text: this.$t('contacts.attributes.stage.options.smartLead')
	        }, {
	          value: {
	            stage_eq: 'prospect'
	          },
	          text: this.$t('contacts.attributes.stage.options.prospect')
	        }, {
	          value: {
	            stage_eq: 'lead'
	          },
	          text: this.$t('contacts.attributes.stage.options.lead')
	        }, {
	          value: {
	            stage_eq: 'mql'
	          },
	          text: this.$t('contacts.attributes.stage.options.mql')
	        }, {
	          value: {
	            stage_eq: 'sql'
	          },
	          text: this.$t('contacts.attributes.stage.options.sql')
	        }, {
	          value: {
	            stage_eq: 'opportunity'
	          },
	          text: this.$t('contacts.attributes.stage.options.opportunity')
	        }, {
	          value: {
	            stage_eq: 'client'
	          },
	          text: this.$t('contacts.attributes.stage.options.client')
	        }, {
	          value: {
	            stage_eq: 'lost'
	          },
	          text: this.$t('contacts.attributes.stage.options.lost')
	        }
	      ],
	      tag_filter: this.extractFilter('with_tags'),
	      user_filter: this.extractFilter('user_id_eq'),
	      lost_reason_filter: this.extractFilter('lost_reason_id_eq'),
	      lost_reason_options: [],
	      group_filter: this.extractFilter('contact_group_id_eq'),
	      group_options: [
	        {
	          value: null,
	          text: 'Carregando...'
	        }
	      ],
	      text_field_filter: this.filters.search_query
	    };
	  },
	  computed: {
	    filterParams: function() {
	      var filter, filter_params, i, len, ref;
	      filter_params = {};
	      ref = [this.status_filter, this.stage_filter, this.tag_filter, this.user_filter, this.group_filter, this.lost_reason_filter];
	      for (i = 0, len = ref.length; i < len; i++) {
	        filter = ref[i];
	        if (filter) {
	          Object.assign(filter_params, filter);
	        }
	      }
	      if (this.text_field_filter) {
	        filter_params['search_query'] = this.text_field_filter;
	      }
	      return filter_params;
	    }
	  },
	  methods: {
	    lostReasonOptions: function() {
	      var i, len, lost_reason, ref, result;
	      result = [];
	      result.push({
	        value: null,
	        text: this.$t('general.label.lostReasons')
	      });
	      if (this.$store.getters.lostReasonsCount === 0) {
	        this.$store.dispatch('fetchLostReasons');
	      }
	      ref = this.$store.getters.lostReasonsList;
	      for (i = 0, len = ref.length; i < len; i++) {
	        lost_reason = ref[i];
	        result.push({
	          value: {
	            lost_reason_id_eq: lost_reason.id
	          },
	          text: lost_reason.title
	        });
	      }
	      return this.lost_reason_options = result;
	    },
	    itemSelectedItems: function(data) {
	      this.tag_filter = {
	        with_tags: data.selected_items.map(function(t) {
	          return t.id;
	        })
	      };
	      return this.filter();
	    },
	    filter: function() {
	      var params;
	      params = this.filterParams;
	      this.pristine_filter = this.base_filter_str === JSON.stringify(params);
	      return this.$emit('filter', params);
	    },
	    clearFilter: function() {
	      if (this.pristine_filter) {
	        return;
	      }
	      this.pristine_filter = true;
	      this.tag_filter = null;
	      this.user_filter = null;
	      this.group_filter = null;
	      this.status_filter = null;
	      this.text_field_filter = null;
	      this.stage_filter = null;
	      this.$emit('filter', {});
	      return this.uncheck_all_items = !this.uncheck_all_items;
	    },
	    statusFilter: function() {
	      var filter_keys, i, len, ref, status_filter, type;
	      filter_keys = Object.keys(this.filters).join();
	      if (!filter_keys.match(/_status/)) {
	        return;
	      }
	      status_filter = {};
	      ref = ['active_status', 'paused_status', 'scheduled_status', 'bounced_status', 'inactive_status', 'connected_status', 'converting_status', 'interrupted_status', 'uninitialized_status', 'blocklisted_status', 'not_connected_status', 'disqualified_status'];
	      for (i = 0, len = ref.length; i < len; i++) {
	        type = ref[i];
	        if (this.filters[type]) {
	          status_filter[type] = true;
	        }
	      }
	      return status_filter;
	    },
	    loadGroups: function() {
	      var params;
	      if (!this.show_group_filter) {
	        return;
	      }
	      params = {
	        q: {
	          s: 'name asc'
	        },
	        limit: 100
	      };
	      if (this.user_id) {
	        params.q.user_id_eq = this.user_id;
	      }
	      return new ContactGroupsResource(Session.current_company.id).index(this.loadGroupsSuccess, null, {
	        params: params
	      });
	    },
	    loadGroupsSuccess: function(data) {
	      this.group_options = data.contact_groups.map(function(contact_group) {
	        return {
	          value: {
	            contact_group_id_eq: contact_group.id.toString()
	          },
	          text: contact_group.name
	        };
	      });
	      return this.group_options.unshift({
	        value: null,
	        text: 'Grupos'
	      });
	    },
	    updateClearFilter: function() {
	      return this.pristine_filter = this.base_filter_str === JSON.stringify(this.filterParams) && !this.$router.currentRoute.query.id_in;
	    },
	    updateGroup: function(item) {
	      this.group_filter = {
	        contact_group_id_eq: item.id
	      };
	      return this.filter();
	    }
	  },
	  watch: {
	    '$route': 'updateClearFilter'
	  },
	  created: function() {
	    this.lostReasonOptions();
	    return this.updateClearFilter();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.filters);


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['contact'],
	  data: function() {
	    return {
	      business_class: '',
	      business_help_text: '',
	      pristine: true,
	      apiErrorMessages: [],
	      current_user: Session.current_user,
	      user_is_monitoring_manager: Session.current_user.isMonitoringManager(),
	      contact_custom_fields: [],
	      custom_fields: []
	    };
	  },
	  computed: {
	    change_business_name: function() {
	      return slugify(this.contact.business.name) === slugify(this.contact.base_business_name);
	    }
	  },
	  watch: {
	    'contact.contact_custom_fields': {
	      handler: function(new_value, old_value) {
	        var custom_field, i, len, results;
	        results = [];
	        for (i = 0, len = new_value.length; i < len; i++) {
	          custom_field = new_value[i];
	          if (custom_field.kind === 'telephone') {
	            results.push(custom_field.value = helpers.masks.maskPhoneInput(custom_field.value));
	          } else {
	            results.push(void 0);
	          }
	        }
	        return results;
	      },
	      deep: true
	    },
	    'contact.telephone': {
	      handler: function(new_value, old_value) {
	        if (old_value == null) {
	          return;
	        }
	        if (new_value != null) {
	          return this.contact.telephone = helpers.masks.maskPhoneInput(this.contact.telephone);
	        } else {
	          return this.contact.telephone = '';
	        }
	      }
	    },
	    'contact.cellphone': {
	      handler: function(new_value, old_value) {
	        if (old_value == null) {
	          return;
	        }
	        if (new_value != null) {
	          return this.contact.cellphone = helpers.masks.maskPhoneInput(this.contact.cellphone);
	        } else {
	          return this.contact.cellphone = '';
	        }
	      }
	    }
	  },
	  methods: {
	    custom_field_mask: function(custom_field) {
	      switch (custom_field.kind) {
	        case 'date':
	          return '##/##/####';
	        default:
	          return '';
	      }
	    },
	    update_business_class: function() {
	      if (this.errors.has('business')) {
	        return this.business_class = 'has-error';
	      }
	      if (!this.change_business_name) {
	        return this.business_class = 'has-warning';
	      }
	      return this.business_class = '';
	    },
	    update_business_help_text: function() {
	      if (this.errors.has('business')) {
	        return this.business_help_text = this.errors.first('business');
	      }
	      if (this.change_business_name) {
	        return this.business_help_text = '';
	      }
	      return this.business_help_text = "O contato será transferido da empresa " + this.contact.base_business_name + " para " + this.contact.business.name;
	    },
	    updated_base_business: function(evt) {
	      this.update_business_class();
	      return this.update_business_help_text();
	    },
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.save();
	          }
	        };
	      })(this));
	    },
	    save: function() {
	      Loader.on();
	      this.contact.contact_custom_fields_attributes = this.contact.contact_custom_fields;
	      this.contact.business_name = this.contact.business.name;
	      return this.contacts_resource.update(this.saveSuccess, this.saveError, this.contact);
	    },
	    saveError: function(response) {
	      var field, key, msg, ref, results;
	      Loader.off();
	      this.handleApiErrors(response);
	      alertify.error("Ops, algo deu errado!");
	      if (!response.body) {
	        return;
	      }
	      ref = response.body;
	      results = [];
	      for (key in ref) {
	        field = ref[key];
	        if (key.search(/^contact_custom_fields.*/) > -1) {
	          msg = "O campo " + field[0].custom_field_name + " é inválido";
	          this.errors.add("custom_field_" + field[0].custom_field_id, msg);
	        }
	        if (key === 'telephone') {
	          this.errors.add('telephone', 'O campo Telefone é inválido');
	        }
	        if (key === 'cellphone') {
	          results.push(this.errors.add('cellphone', 'O campo Celular é inválido'));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    saveSuccess: function(resources) {
	      Loader.off();
	      EventsBus.$emit('contact-updated', resources.contact);
	      alertify.success('Contato atualizado com sucesso');
	      this.business_class = '';
	      this.business_help_text = '';
	      return IntercomCtrl.trackEvent("Base de contatos - Contato atualizado.");
	    },
	    isValid: function() {
	      return !this.errors.any() && !this.anyActionErrors();
	    },
	    customFieldColumnClass: function(index) {
	      if ((index + 1) === this.contact.contact_custom_fields.length && (this.contact.contact_custom_fields.length % 2 === 1)) {
	        return 'col-md-12';
	      } else if (this.contact.contact_custom_fields[index].kind === 'textarea') {
	        return 'col-md-12';
	      } else {
	        return 'col-md-6';
	      }
	    }
	  },
	  mounted: function() {
	    this.errors.clear();
	    return this.contacts_resource = new ContactsResource(Session.current_company.id);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    contactGroupsList: __webpack_require__(52),
	    newGroupModal: __webpack_require__(115)
	  },
	  data: function() {
	    return {
	      group_destroy_contacts: false,
	      selected_group: {},
	      current_user: Session.current_user,
	      filters: {},
	      fetching: false,
	      next_page: true,
	      total_count: 0,
	      contact_groups: []
	    };
	  },
	  methods: {
	    leadsRedirect: function() {
	      return this.$router.push('/contatos/leads');
	    },
	    businessRedirect: function() {
	      return this.$router.push('/contatos/empresas');
	    },
	    groupsRedirect: function() {
	      return this.$router.push('/contatos/grupos');
	    },
	    openNewGroupModal: function() {
	      return EventsBus.$emit('new-group-modal-show');
	    },
	    updateContactGroupList: function(data) {
	      return this.contact_groups.push(data.contact_group);
	    },
	    openDestroyGroupConfirmationModal: function(data) {
	      this.selected_group = data.contact_group;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-remove-group'
	      });
	    },
	    destroyGroup: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: this.selected_group.id,
	        params: {
	          destroy_contacts: this.group_destroy_contacts
	        }
	      };
	      return this.contact_group_resource.destroy(this.destroyGroupSuccess, this.unknownError, params);
	    },
	    destroyGroupSuccess: function() {
	      Loader.off();
	      this.excludeGroupFromList(this.selected_group);
	      this.selected_group = {};
	      return alertify.success(this.$t('groups.actions.delete.success'));
	    },
	    excludeGroupFromList: function(contact_group) {
	      var index;
	      index = this.contact_groups.findIndex(contact_group);
	      if (index > -1) {
	        this.contact_groups.splice(index, 1);
	      }
	      if (this.group_destroy_contacts) {
	        return this.excludeGroupContactsFromList(this.selected_group);
	      }
	    },
	    excludeGroupContactsFromList: function(contact_group) {
	      var contact, contact_ids, index, results;
	      contact_ids = contact_group.contacts.map(function(contact) {
	        return contact.id;
	      });
	      index = this.contacts.length - 1;
	      results = [];
	      while (index >= 0) {
	        contact = this.contacts[index];
	        if (contact_ids.indexOf(contact.id) > -1) {
	          this.contacts.splice(index, 1);
	        }
	        results.push(index -= 1);
	      }
	      return results;
	    },
	    filter: function(filters) {
	      this.filters = filters;
	      this.contact_groups = [];
	      this.next_page = 1;
	      return this.loadData();
	    },
	    loadData: function() {
	      if (this.fetching || !this.next_page) {
	        return;
	      }
	      this.fetching = true;
	      return this.contact_group_resource.index(this.loadSuccess, this.unknownError, {
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadSuccess: function(resources) {
	      this.fetching = false;
	      this.next_page = resources.meta.next_page;
	      this.total_count = resources.meta.total_count;
	      this.contact_groups = this.contact_groups.concat(resources.contact_groups);
	      return Loader.off();
	    },
	    refreshList: function(data, self) {
	      var contact_group, i, idx, index, len, ref;
	      index = -1;
	      ref = self.contact_groups;
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        contact_group = ref[idx];
	        if (contact_group.id === data.id) {
	          index = idx;
	          contact_group = new ContactGroup(data);
	        }
	      }
	      if (!(index >= 0)) {
	        return setTimeout(self.refreshList(data, sefl), 1000);
	      }
	      self.contact_groups[index] = new ContactGroup(data);
	      Vue.set(self.contact_groups, index, new ContactGroup(data));
	      return self.$forceUpdate();
	    },
	    subscribeToContactGroupUpdateChannel: function() {
	      var self;
	      self = this;
	      this.removeSubscription();
	      return this.subscription = ActionCable.cable.subscriptions.create({
	        channel: 'ContactGroupUpdateChannel',
	        user_id: this.user_id
	      }, {
	        received: (function(_this) {
	          return function(data) {
	            return _this.refreshList(data, self);
	          };
	        })(this)
	      });
	    },
	    removeSubscription: function() {
	      if (this.subscription) {
	        return ActionCable.cable.subscriptions.remove(this.subscription);
	      }
	    },
	    showNabBars: function() {
	      return !Session.current_user.new_ui;
	    }
	  },
	  created: function() {
	    this.contact_group_resource = new ContactGroupsResource(Session.current_company.id);
	    this.subscribeToContactGroupUpdateChannel();
	    return this.loadData();
	  },
	  beforeDestroy: function() {
	    return this.removeSubscription();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes, helpers.contacts.list_wrapper, helpers.filters);


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    stepBar: __webpack_require__(209),
	    organizationStep: __webpack_require__(189)
	  },
	  data: function() {
	    return {
	      current_step: 1,
	      file: null,
	      apiErrorMessages: [],
	      raw_contacts: [],
	      line_errors: {},
	      has_valid: null,
	      has_duplicates: null,
	      file_errors: null,
	      encoding: null,
	      has_header: null,
	      encoding_options: [
	        {
	          value: 'UTF-8',
	          text: 'UTF-8'
	        }, {
	          value: 'ISO-8859-1',
	          text: 'ISO-8859-1'
	        }, {
	          value: 'CP850',
	          text: 'CP850'
	        }, {
	          value: 'macCroatian',
	          text: 'MAC'
	        }
	      ],
	      import_valid_only: false,
	      message: null,
	      menu_open: true,
	      custom_fields: [],
	      presigned_url: null,
	      filename: null,
	      websocket_id: null,
	      upload_progress: 0,
	      validation_state: 'none',
	      creation_progress: 0,
	      file_total_count: 0,
	      creation_in_progress: false,
	      valid: false,
	      selected_group_id: null,
	      selected_flow_id: null,
	      selected_user_id: Session.current_user.id,
	      selected_tags_ids: null,
	      import_finished: false,
	      work_on_duplicates: false,
	      multiple_groups: false,
	      groups: null,
	      remaining: null
	    };
	  },
	  watch: {
	    file: function(val) {
	      if (val !== null) {
	        return this.current_step = 2;
	      }
	    }
	  },
	  methods: {
	    newImport: function() {
	      this.current_step = 1;
	      this.import_finished = false;
	      this.selected_group_id = null;
	      this.selected_flow_id = null;
	      this.selected_user_id = Session.current_user.id;
	      this.selected_tags_ids = null;
	      this.upload_progress = 0;
	      this.validation_state = 'none';
	      this.creation_progress = 0;
	      this.file_total_count = 0;
	      return this.file = null;
	    },
	    selectUser: function(user_id) {
	      return this.selected_user_id = parseInt(user_id);
	    },
	    selectTags: function(tags) {
	      if (tags.lentgh !== 0) {
	        return this.selected_tags_ids = tags;
	      }
	    },
	    nextStep: function() {
	      if (this.current_step < 5) {
	        return this.current_step++;
	      }
	    },
	    switchGroup: function(send_to_group) {
	      if (!send_to_group) {
	        return this.selected_group_id = null;
	      }
	    },
	    switchFlow: function(send_to_flow) {
	      if (!send_to_flow) {
	        return this.selected_flow_id = null;
	      }
	    },
	    switchRemaining: function(new_remaining) {
	      return this.remaining = new_remaining;
	    },
	    selectGroup: function(groupId) {
	      return this.selected_group_id = groupId;
	    },
	    selectFlow: function(flowId) {
	      return this.selected_flow_id = flowId;
	    },
	    fileInput: function(event) {
	      var files;
	      this.resetValidation();
	      files = event.target.files || event.dataTransfer.files;
	      if (files.length) {
	        this.file = files[0];
	        return IntegrationsResource.s3PresignedUrl(this.s3PresignedUrlSuccess, this.s3PresignedUrlFailure, {
	          params: {
	            filename: this.file.name
	          }
	        });
	      }
	    },
	    s3PresignedUrlSuccess: function(data) {
	      this.presigned_url = data.body.url;
	      this.filename = data.body.filename;
	      return this.uploadFileToS3();
	    },
	    s3PresignedUrlFailure: function() {
	      return alertify.error(this.$t('contacts_csv.feedback.s3PresignedUrlFailure'));
	    },
	    uploadFileToS3: function() {
	      if (!this.presigned_url || !this.filename) {
	        return;
	      }
	      return jQuery.ajax({
	        type: 'PUT',
	        url: this.presigned_url,
	        contentType: this.file.type,
	        processData: false,
	        data: this.file,
	        xhr: (function(_this) {
	          return function() {
	            var xhr;
	            xhr = jQuery.ajaxSettings.xhr();
	            if (xhr.upload) {
	              xhr.upload.addEventListener('progress', _this.uploadProgress, false);
	            }
	            return xhr;
	          };
	        })(this),
	        success: this.uploadFileToS3Success,
	        error: this.uploadFileToS3Failure
	      });
	    },
	    uploadProgress: function(data) {
	      var loaded, total;
	      total = data.total;
	      loaded = data.loaded;
	      return this.upload_progress = loaded * 100.0 / total;
	    },
	    uploadFileToS3Success: function(data, a, b) {
	      jQuery('input#file[type="file"]').val(null);
	      this.file_url = this.presigned_url.split('?')[0];
	      return this.validateFile();
	    },
	    uploadFileToS3Failure: function() {
	      return alertify.error(this.$t('contacts_csv.feedback.uploadFileToS3Failure'));
	    },
	    validateFile: function() {
	      this.resetValidation(false);
	      this.groups = null;
	      this.subscribeToWebsocketChannel(this.validationWebsocketCallback);
	      return this.resource.importCsv(null, this.failImportValidation, this.params(false));
	    },
	    failImportValidation: function() {
	      return this.subscription.unsubscribe();
	    },
	    subscribeToWebsocketChannel: function(received_callback) {
	      this.websocket_id = this.generateToken();
	      return this.subscription = ActionCable.connect().subscriptions.create({
	        channel: 'ContactsImportChannel',
	        websocket_id: this.websocket_id
	      }, {
	        received: received_callback
	      });
	    },
	    exportDefaultCSV: function() {
	      return jQuery.ajax({
	        url: this.example_file_path,
	        success: this.defaultLoaded
	      });
	    },
	    defaultLoaded: function(data) {
	      var csvContent, custom, i, len, link, ref, row, rows;
	      rows = data.split('\n');
	      for (row in rows) {
	        if (row < rows.length - 1) {
	          ref = this.custom_fields;
	          for (i = 0, len = ref.length; i < len; i++) {
	            custom = ref[i];
	            rows[row] += ";" + custom.field;
	          }
	        }
	      }
	      csvContent = rows.join("\n");
	      link = document.createElement("a");
	      link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent('\uFEFF' + csvContent));
	      link.setAttribute("download", "reev-contatos-exemplo.csv");
	      document.body.appendChild(link);
	      return link.click();
	    },
	    validationWebsocketCallback: function(data) {
	      if (data.error) {
	        this.subscription.unsubscribe();
	        this.newImport();
	        return alertify.error(data.error);
	      }
	      if (data.info) {
	        if (data.has_valid) {
	          this.has_valid = data.has_valid;
	        }
	        if (data.has_duplicates) {
	          this.has_duplicates = data.has_duplicates;
	        }
	        this.encoding = data.info.encoding;
	        this.has_header = data.info.has_header;
	        this.file_total_count = data.info.total_count;
	      }
	      this.loadSetErrors(data.line_errors);
	      this.concatRawContacts(data.raw_contacts);
	      this.setGroups(data.groups);
	      this.remaining = data.remaining;
	      this.file_errors = data.file_errors;
	      if (data.finished) {
	        this.validation_state = this.has_errors ? 'error' : 'ok';
	        this.subscription.unsubscribe();
	        return this.valid = data.valid;
	      }
	    },
	    concatRawContacts: function(raw_contacts) {
	      var i, len, raw_contact;
	      this.raw_contact_index = this.raw_contacts.length;
	      for (i = 0, len = raw_contacts.length; i < len; i++) {
	        raw_contact = raw_contacts[i];
	        raw_contact.index = this.raw_contact_index;
	        this.raw_contact_index += 1;
	      }
	      return this.raw_contacts = this.raw_contacts.concat(raw_contacts);
	    },
	    setGroups: function(groups) {
	      if (groups !== null) {
	        if (Array.isArray(groups) && groups.length > 0) {
	          this.groups = groups;
	          return this.multiple_groups = true;
	        }
	      }
	    },
	    importSuccess: function() {
	      return this.import_finished = true;
	    },
	    importFile: function(only_valids) {
	      if (only_valids == null) {
	        only_valids = false;
	      }
	      console.log(this.valid);
	      console.log(only_valids);
	      console.log(this.work_on_duplicates);
	      console.log(this.params(!only_valids, only_valids));
	      if (!(this.valid || only_valids || this.work_on_duplicates)) {
	        return;
	      }
	      this.creation_in_progress = true;
	      this.subscribeToWebsocketChannel(this.importWebsocketCallback);
	      return this.resource.importCsv(this.importSuccess, this.importFileFailure, this.params(!only_valids, only_valids));
	    },
	    importWebsocketCallback: function(data) {
	      if (data.warning) {
	        alertify.error(data.warning);
	      }
	      if (data.error) {
	        this.subscription.unsubscribe();
	        this.file = null;
	        alertify.error(data.error);
	      }
	      if (data.finished) {
	        this.nextStep();
	        this.creation_progress = 100.0;
	        this.subscription.unsubscribe();
	        alertify.success(this.$t('contacts_csv.feedback.importSuccess'));
	        return this.notifyIntercom();
	      } else {
	        return this.creation_progress = data.count / parseFloat(this.file_total_count) * 100.0;
	      }
	    },
	    importFileFailure: function() {
	      this.subscription.unsubscribe();
	      return alertify.error('Falha ao importar arquivo');
	    },
	    menu_open_change: function() {
	      return this.menu_open = !this.menu_open;
	    },
	    workOnDuplicates: function() {
	      var current_user_role, message;
	      current_user_role = Session.current_user.role;
	      message = '';
	      if (current_user_role === "admin" || current_user_role === "manager" || ((current_user_role === "seller" || current_user_role === "sdr") && this.company.account_setting.seller_can_change_responsability)) {
	        message = this.$t('contacts_csv.feedback.responsabilityChangeCheck');
	      } else {
	        message = this.$t('contacts_csv.feedback.contactOwnerSelectCheck');
	      }
	      this.message = message;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-select-duplicate-confirmation-modal'
	      });
	    },
	    update: function(confirm) {
	      if (!confirm) {
	        return this.work_on_duplicates = false;
	      } else {
	        this.work_on_duplicates = true;
	        return this.nextStep();
	      }
	    },
	    updateActiveInFlow: function(confirm) {
	      if (confirm) {
	        this.nextStep();
	        return this.importFile(this.import_valid_only);
	      }
	    },
	    confirmImport: function() {
	      if (this.work_on_duplicates) {
	        return this.showConfirmFlowModal();
	      } else {
	        this.nextStep();
	        return this.importFile(this.import_valid_only);
	      }
	    },
	    confirmImportValidOnly: function() {
	      this.nextStep();
	      return this.import_valid_only = true;
	    },
	    showConfirmFlowModal: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-flow-select-confirmation-modal'
	      });
	    },
	    notifyIntercom: function() {
	      return IntercomCtrl.trackEvent(this.$t('contacts_csv.label.finishImportTitle'), this.$t('contacts_csv.label.finishImportMessage', {
	        num: this.raw_contacts.length
	      }));
	    },
	    importWithEncoding: function(encoding) {
	      this.encoding = encoding;
	      return this.validateFile();
	    },
	    humanAttribute: function(attribute) {
	      var attribute_name, human_attribute;
	      if (this.$te('contacts.attributes.' + attribute)) {
	        human_attribute = this.$t('contacts.attributes.' + attribute);
	      }
	      attribute_name = human_attribute || attribute;
	      return attribute_name.charAt(0).toUpperCase() + attribute_name.slice(1);
	    },
	    cellHasError: function(row_index, col_index) {
	      row_index += (this.has_header ? 2 : 1);
	      return !!this.cells_with_errors.findByProps({
	        row: row_index.toString(),
	        col: col_index.toString()
	      });
	    },
	    loadSetErrors: function(line_errors) {
	      var attribute, attributes_errors, col, error, errors, list, results, row;
	      if (!line_errors || jQuery.isEmptyObject(line_errors)) {
	        return;
	      }
	      results = [];
	      for (row in line_errors) {
	        attributes_errors = line_errors[row];
	        results.push((function() {
	          var results1;
	          results1 = [];
	          for (attribute in attributes_errors) {
	            errors = attributes_errors[attribute];
	            error = errors[0];
	            if (attribute === 'business.name') {
	              attribute = 'business';
	            }
	            col = this.isCustomFieldError(attribute, error);
	            if (col) {
	              error = error.error;
	            } else {
	              this.attributes_reference.forEach((function(_this) {
	                return function(attribute_reference, index) {
	                  if (attribute_reference[0] === attribute) {
	                    return col = index;
	                  }
	                };
	              })(this));
	            }
	            list = this.line_errors[error] || [];
	            list.push({
	              row: row,
	              attribute: attribute,
	              col: col != null ? col.toString() : void 0
	            });
	            results1.push(Vue.set(this.line_errors, error, list));
	          }
	          return results1;
	        }).call(this));
	      }
	      return results;
	    },
	    isCustomFieldError: function(error_field, error) {
	      var custom_field, i, index, len, ref;
	      if (!/contact_custom_fields\[\d{1,4}\]\.value/.exec(error_field)) {
	        return;
	      }
	      ref = this.custom_fields;
	      for (index = i = 0, len = ref.length; i < len; index = ++i) {
	        custom_field = ref[index];
	        if (custom_field.id === parseInt(error.custom_field_id)) {
	          return index + this.fixed_columns_size;
	        }
	      }
	      return null;
	    },
	    humanCells: function(cells) {
	      var human_cells;
	      human_cells = [];
	      cells.forEach((function(_this) {
	        return function(cell) {
	          var col;
	          col = _this.all_attributes_letters[parseInt(cell.col)];
	          return human_cells.push(cell.row + col);
	        };
	      })(this));
	      return human_cells.join(', ');
	    },
	    loadCustomFields: function() {
	      Loader.on();
	      return new CustomFieldsResource().index(this.loadCustomFieldsSuccess, this.unknownError);
	    },
	    loadCustomFieldsSuccess: function(data) {
	      this.custom_fields = data.custom_fields;
	      return Loader.off();
	    },
	    resetValidation: function(reset_upload) {
	      if (reset_upload == null) {
	        reset_upload = true;
	      }
	      if (reset_upload) {
	        this.upload_progress = 0;
	      }
	      this.raw_contacts = this.defaultRawContactsHeader();
	      this.line_errors = {};
	      this.valid = false;
	      this.validation_state = 'none';
	      this.creation_progress = 0;
	      this.file_total_count = 1;
	      this.creation_progress = 0;
	      return this.creation_in_progress = false;
	    },
	    params: function(save, valid_only) {
	      if (save == null) {
	        save = false;
	      }
	      if (valid_only == null) {
	        valid_only = false;
	      }
	      return {
	        file_url: this.file_url,
	        force_encoding: this.encoding,
	        user_id: this.selected_user_id,
	        flow_id: this.selected_flow_id,
	        group_id: this.selected_group_id,
	        contact_tags: this.selected_tags_ids,
	        websocket_id: this.websocket_id,
	        save: save,
	        valid_only: valid_only,
	        work_on_duplicates: this.work_on_duplicates,
	        ignored_groups: this.ignored_groups
	      };
	    },
	    defaultRawContactsHeader: function() {
	      var header, sub_header;
	      header = [];
	      header.index = 0;
	      sub_header = [];
	      sub_header.index = 1;
	      return [header, sub_header];
	    },
	    generateToken: function() {
	      return Math.random().toString(36).substr(2) + Math.random().toString(36).substr(2);
	    }
	  },
	  computed: {
	    ignored_groups: function() {
	      var group, i, ignored, len, ref;
	      ignored = [];
	      if (this.groups !== null) {
	        ref = this.groups;
	        for (i = 0, len = ref.length; i < len; i++) {
	          group = ref[i];
	          if (!group.selected) {
	            ignored.push(group.group.name);
	          }
	        }
	      }
	      return ignored;
	    },
	    attributes_reference: function() {
	      var attribute_name, attributes_list, attributes_names, email_index, i, index, len, linkedin_index;
	      attributes_names = ['first_name', 'last_name', 'email', 'business', 'position', 'telephone', 'cellphone', 'address', 'url', 'linkedin', 'Variável 1', 'Variável 2', 'Variável 3', 'Grupo'];
	      email_index = attributes_names.findIndex('email');
	      if (Session.current_company.cpf_active) {
	        attributes_names.splice(email_index + 1, 0, 'cpf');
	      }
	      linkedin_index = attributes_names.findIndex('linkedin');
	      if (Session.current_company.cnpj_active) {
	        attributes_names.splice(linkedin_index + 1, 0, 'cnpj');
	      }
	      attributes_list = [];
	      index = 0;
	      for (i = 0, len = attributes_names.length; i < len; i++) {
	        attribute_name = attributes_names[i];
	        attributes_list.push([attribute_name, String.fromCharCode('A'.charCodeAt(0) + index)]);
	        index++;
	      }
	      return attributes_list;
	    },
	    all_attributes_letters: function() {
	      return ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'AA', 'AB', 'AC', 'AD', 'AE', 'AF', 'AG', 'AH', 'AI', 'AJ', 'AL', 'AK', 'AM', 'AN', 'AO'];
	    },
	    example_file_path: function() {
	      return "/static/reev-contatos-exemplo.csv";
	    },
	    cells_with_errors: function() {
	      var cells, error, error_cells, ref;
	      cells = [];
	      ref = this.line_errors;
	      for (error in ref) {
	        error_cells = ref[error];
	        cells = cells.concat(error_cells);
	      }
	      return cells;
	    },
	    has_line_errors: function() {
	      return this.line_errors && Object.keys(this.line_errors).length;
	    },
	    has_file_errors: function() {
	      return this.file_errors && Object.keys(this.file_errors).length;
	    },
	    has_errors: function() {
	      return this.has_line_errors || this.has_file_errors;
	    },
	    start_line: function() {
	      if (this.has_header) {
	        return 2;
	      } else {
	        return 1;
	      }
	    },
	    validation_progress: function() {
	      if (this.current_step > 2) {
	        return this.raw_contacts.length / parseFloat(this.file_total_count) * 100.0;
	      }
	    },
	    validation_finished: function() {
	      return this.validation_state !== 'none';
	    },
	    loading: function() {
	      return !this.validation_finished || this.creation_in_progress;
	    },
	    visible_raw_contacts: function() {
	      return this.raw_contacts.slice(0, 1500);
	    },
	    fixed_columns_size: function() {
	      return this.attributes_reference.length;
	    }
	  },
	  created: function() {
	    this.company = Session.current_company;
	    this.resource = new ContactsResource(this.company.id);
	    return this.loadCustomFields();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes);


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    contactsPickerTextCsv: __webpack_require__(35),
	    contactGroupsList: __webpack_require__(52)
	  },
	  props: {
	    has_groups: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      raw_contacts: null,
	      contact_groups: null,
	      ignored_groups: []
	    };
	  },
	  methods: {
	    submit: function() {
	      return EventsBus.$emit('contacts-picker-text-csv-validate');
	    },
	    confirmImport: function(data) {
	      var save;
	      Loader.on();
	      this.raw_contacts = data;
	      save = this.has_groups ? false : true;
	      return this.confirmSave(this.raw_contacts, save);
	    },
	    confirmSave: function(data, save, ignored_groups) {
	      var successCallback;
	      if (save == null) {
	        save = true;
	      }
	      if (ignored_groups == null) {
	        ignored_groups = null;
	      }
	      successCallback = save ? this.successHandler : this.confirmationHandler;
	      return this.resource["import"](successCallback, this.failureHandler, {
	        data: data.contact_list,
	        save: save,
	        ignored_groups: ignored_groups
	      });
	    },
	    confirmationHandler: function(response) {
	      Loader.off();
	      if (this.has_groups) {
	        this.contact_groups = this.parseContactGroups(response);
	      }
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-create-groups'
	      });
	    },
	    successHandler: function(response) {
	      var metadata, successResponseLabel;
	      Loader.off();
	      successResponseLabel = this.$t('contacts.label.manuallyInsertSuccessMessage');
	      if (!this.has_groups) {
	        alertify.success(this.$t('contacts.feedback.confirmCreate', {
	          length: response.body.contacts.length
	        }));
	        return IntercomCtrl.trackEvent(this.$t('contacts.label.manuallyInsertSuccessTitle'), {
	          successResponseLabel: response.data.contacts.length
	        });
	      } else {
	        alertify.success("Grupos atualizados com sucesso");
	        metadata = this.createIntercomMetadata(this.contact_groups);
	        metadata[successResponseLabel] = response.data.contacts.length;
	        return IntercomCtrl.trackEvent(this.$t('contacts_group.label.manuallyInsertSuccessTitle'), metadata);
	      }
	    },
	    failureHandler: function(response) {
	      Loader.off();
	      alertify.error(this.$t('contacts_group.feedback.failOnCreate', {
	        type: this.has_groups ? this.$t('contacts_group.label.groups') : this.$t('contacts.label.contacts')
	      }));
	      return EventsBus.$emit('contacts-picker-text-csv-errors', response.body);
	    },
	    handleGroupSelect: function(data) {
	      var index;
	      if (data.attr.selected) {
	        index = this.ignored_groups.indexOf(data.attr.contact_group.name);
	        return this.ignored_groups.splice(index, 1);
	      } else {
	        return this.ignored_groups.push(data.attr.contact_group.name);
	      }
	    },
	    confirmGroups: function() {
	      return this.confirmSave(this.raw_contacts, true, this.ignored_groups);
	    },
	    parseContactGroups: function(response) {
	      if (!response.body.groups) {
	        return [];
	      } else {
	        return response.body.groups.map(function(group) {
	          return new ContactGroup({
	            name: group.name,
	            import_action: group.import_action,
	            contacts_count: group.contacts_count
	          });
	        });
	      }
	    },
	    createIntercomMetadata: function(groups) {
	      var metadata, onExistingGroupsLabel, onNewestGroupsLabel;
	      onExistingGroupsLabel = this.$t('contacts_group.feedback.contactsOnExistingGroups');
	      onNewestGroupsLabel = this.$t('contacts_group.feedback.contactsOnNewestGroups');
	      metadata = {
	        onExistingGroupsLabel: 0,
	        onNewestGroupsLabel: 0
	      };
	      groups.forEach((function(_this) {
	        return function(group) {
	          if (group.import_action === "updated") {
	            return metadata[onExistingGroupsLabel] += group.contacts_count;
	          } else {
	            return metadata[onNewestGroupsLabel] += group.contacts_count;
	          }
	        };
	      })(this));
	      return metadata;
	    }
	  },
	  created: function() {
	    var company;
	    company = Session.current_company.id;
	    this.resource = this.has_groups ? new ContactGroupsResource(company) : new ContactsResource(company);
	    return EventsBus.$on('contacts-picker-text-csv-publish', this.confirmImport);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('contacts-picker-text-csv-publish', this.confirmImport);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.contacts.list_view_modes);


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    contactList: __webpack_require__(34),
	    createTagModal: __webpack_require__(117),
	    reactivateRecipientModal: __webpack_require__(23),
	    changeResponsabilityModal: __webpack_require__(116),
	    taskModalForm: __webpack_require__(17)
	  },
	  data: function() {
	    return {
	      schedule_reactivation_contact: null,
	      selected_all: false,
	      selected_contact: {},
	      selected_contacts: [],
	      unselected_contacts: [],
	      current_user: Session.current_user,
	      filters: {},
	      fetching: false,
	      next_page: true,
	      total_count: 0,
	      contacts: []
	    };
	  },
	  computed: {
	    count_selected_contacts: function() {
	      if (this.selected_all) {
	        return this.count_all_contacts - this.unselected_contact_ids.length;
	      } else {
	        return this.selected_contact_ids.length;
	      }
	    },
	    count_all_contacts: function() {
	      return this.total_count;
	    },
	    count_page_contacts: function() {
	      return this.contacts.length;
	    },
	    selected_contact_ids: function() {
	      return this.selected_contacts.map(function(contact) {
	        return contact.id;
	      });
	    },
	    unselected_contact_ids: function() {
	      return this.unselected_contacts.map(function(contact) {
	        return contact.id;
	      });
	    }
	  },
	  methods: {
	    leadsRedirect: function() {
	      return this.$router.push('/contatos/leads');
	    },
	    businessRedirect: function() {
	      return this.$router.push('/contatos/empresas');
	    },
	    groupsRedirect: function() {
	      return this.$router.push('/contatos/grupos');
	    },
	    openDestroyContactConfirmationModal: function(data) {
	      this.selected_contact = data.contact;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-remove-contact'
	      });
	    },
	    callDestroyContact: function() {
	      return this.destroyContact({
	        contact: this.selected_contact
	      }, this.contact_resource);
	    },
	    callDestroyContacts: function() {
	      var params;
	      params = {
	        type: 'destroy',
	        filters: this.filters,
	        selected_ids: this.selected_contact_ids,
	        unselected_ids: this.unselected_contact_ids
	      };
	      return this.contact_resource.massActionExecute(this.destroyContactsSuccess, this.unknownError, params);
	    },
	    destroyContactsSuccess: function(response) {
	      alertify.success('Contatos removidos com sucesso!');
	      this.excludeContactsFromList(response.body.contact_ids);
	      return this.selected_contacts = [];
	    },
	    selectedAll: function(data) {
	      this.selected_all = data.selected_all;
	      if (this.selected_all) {
	        return this.selected_contacts = [];
	      } else {
	        return this.unselected_contacts = [];
	      }
	    },
	    massActionUpdateContactTag: function(data) {
	      this.updateContactTag(this.contacts, data.contact_ids, data.change_tags);
	      this.clearSelections();
	      return Loader.off();
	    },
	    excludeContactsFromList: function(contact_ids) {
	      var i, idx, ref, results, size;
	      size = this.contacts.length - 1;
	      results = [];
	      for (idx = i = ref = size; ref <= 0 ? i <= 0 : i >= 0; idx = ref <= 0 ? ++i : --i) {
	        if (contact_ids.indexOf(this.contacts[idx].id) > -1) {
	          results.push(this.contacts.splice(idx, 1));
	        }
	      }
	      return results;
	    },
	    changeResponsabilityParams: function(data) {
	      var params;
	      params = {
	        type: 'change_responsability',
	        filters: this.filters,
	        selected_ids: this.selected_contact_ids,
	        unselected_ids: this.unselected_contact_ids,
	        to_user_id: data.user.id,
	        finish_transfer: data.flag_finish
	      };
	      return params;
	    },
	    callPrepareChangeResponsability: function(data) {
	      var params;
	      Loader.on();
	      params = this.changeResponsabilityParams(data);
	      this.user_selected = data.user;
	      return this.contact_resource.massActionPrepare(this.prepareSuccess, this.prepareFail, params);
	    },
	    prepareSuccess: function(response) {
	      if (!this.disabled_buttons) {
	        EventsBus.$emit('confirm-modal-show', {
	          id: 'change-responsability',
	          user: this.user_selected,
	          data: response.data
	        });
	      }
	      return Loader.off();
	    },
	    confirmChangeResponsability: function(data) {
	      var params;
	      Loader.on();
	      params = this.changeResponsabilityParams(data);
	      return this.contact_resource.massActionExecute(this.confirmChangeResponsabilitySuccess, this.unknownError, params);
	    },
	    confirmChangeResponsabilitySuccess: function(response) {
	      alertify.success('Transferência realizada. A atualização dessa mudança na base pode demorar alguns minutos.');
	      this.updateContactResponsible(this.selected_contacts, this.user_selected, response.data.contact_ids);
	      this.clearSelections();
	      return Loader.off();
	    },
	    addContactList: function(list, contact) {
	      var idx;
	      idx = list.indexOf(contact);
	      if (idx === -1) {
	        return list.push(contact);
	      }
	    },
	    delContactList: function(list, contact) {
	      var idx;
	      idx = list.indexOf(contact);
	      return list.splice(idx, 1);
	    },
	    loadSelectedContactsList: function(data) {
	      if (this.selected_all) {
	        if (data.attr.selected) {
	          this.delContactList(this.unselected_contacts, data.attr.contact);
	        } else {
	          this.addContactList(this.unselected_contacts, data.attr.contact);
	        }
	      }
	      if (!this.selected_all) {
	        if (data.attr.selected) {
	          return this.addContactList(this.selected_contacts, data.attr.contact);
	        } else {
	          return this.delContactList(this.selected_contacts, data.attr.contact);
	        }
	      }
	    },
	    clearSelections: function() {
	      this.selected_all = false;
	      this.selected_contacts = [];
	      this.unselected_contacts = [];
	      return EventsBus.$emit('ContactList:ClearSelections', {
	        selected_all: this.selected_all
	      });
	    },
	    filter: function(filters) {
	      this.filters = filters;
	      this.contacts = [];
	      this.next_page = 1;
	      this.clearSelections();
	      return this.loadData();
	    },
	    loadData: function() {
	      if (this.fetching || !this.next_page) {
	        return;
	      }
	      this.fetching = true;
	      return this.contact_resource.index(this.loadSuccess, this.unknownError, {
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadSuccess: function(resources) {
	      this.fetching = false;
	      this.next_page = resources.meta.next_page;
	      this.total_count = resources.meta.total_count;
	      this.contacts = this.contacts.concat(resources.contacts);
	      return Loader.off();
	    },
	    setFiltersFromQueryParamsLocal: function() {
	      var query;
	      query = Object.assign({}, this.$router.currentRoute.query);
	      this.filters = query;
	      if (this.filters['with_tags[]']) {
	        this.filters['with_tags'] = this.filters['with_tags[]'];
	      }
	      if (this.filters['id_in']) {
	        return this.filters['id_in'] = this.filters['id_in'].split(',');
	      }
	    },
	    exportContacts: function(type) {
	      Loader.on();
	      return this.contact_resource["export"](this.loadSuccessExport, this.unknownError, {
	        q: this.filters,
	        type_export: type
	      });
	    },
	    loadSuccessExport: function(resources) {
	      var csvContent, link, rows;
	      Loader.off();
	      if (resources.data.message) {
	        return alertify.success(resources.data.message);
	      }
	      rows = resources.data.csv.split('\n');
	      csvContent = rows.join("\n");
	      link = document.createElement("a");
	      link.setAttribute('href', 'data:text/csv; charset=utf-8,' + encodeURIComponent('\uFEFF' + csvContent));
	      link.setAttribute("download", "contatos.csv");
	      document.body.appendChild(link);
	      return link.click();
	    }
	  },
	  watch: {
	    '$route': function() {
	      this.setFiltersFromQueryParamsLocal();
	      this.$emit('updateClearFilter');
	      return this.filter(this.filters);
	    }
	  },
	  created: function() {
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    this.setFiltersFromQueryParamsLocal();
	    this.loadData();
	    EventsBus.$on('Contact::ScheduleRecipientReactivation', this.openRecipientScheduleReactivationModal);
	    EventsBus.$on('Contact::Refresh', this.refreshContact);
	    EventsBus.$on('ContactList:SelectedAll', this.selectedAll);
	    EventsBus.$on('MassActions:Tags:UpdateContacts', this.massActionUpdateContactTag);
	    return EventsBus.$on('Show::UpdateListContactsInfo', this.updateContactList);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('Contact::ScheduleRecipientReactivation', this.openRecipientScheduleReactivationModal);
	    EventsBus.$off('Contact::Refresh', this.refreshContact);
	    EventsBus.$off('ContactList:SelectedAll', this.selectedAll);
	    EventsBus.$off('MassActions:Tags:UpdateContacts', this.massActionUpdateContactTag);
	    return EventsBus.$off('Show::UpdateListContactsInfo', this.updateContactList);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes, helpers.contacts.list_wrapper, helpers.filters);


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    draggable: __webpack_require__(27),
	    filters: __webpack_require__(120),
	    massActions: __webpack_require__(122)
	  },
	  props: {
	    origem: {
	      "default": null
	    },
	    contacts: {
	      "default": function() {
	        return [];
	      }
	    },
	    selected_contact_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    unselected_contact_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    count_all_contacts: {
	      "default": function() {
	        return 0;
	      }
	    },
	    count_page_contacts: {
	      "default": function() {
	        return 0;
	      }
	    },
	    initially_selected_contact_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    view_mode: {
	      type: Object,
	      required: true
	    },
	    flow: {
	      type: Flow,
	      "default": null
	    },
	    filters: {
	      "default": function() {
	        return {};
	      }
	    },
	    internal_scroller: {
	      "default": false
	    },
	    draggable_options: {
	      "default": function() {
	        return {
	          disabled: true,
	          filter: '.undraggable'
	        };
	      }
	    },
	    user_id: {
	      "default": null
	    }
	  },
	  data: function() {
	    return {
	      selected_all: false,
	      selected_page: false
	    };
	  },
	  computed: {
	    add_action_column: function() {
	      return this.view_mode.actions_dropdown || this.view_mode.anywhere_select_action === 'emit-selected';
	    }
	  },
	  methods: {
	    removeContactFromList: function(contact_id) {
	      return this.contacts.remove(contact_id);
	    },
	    filter: function(filters) {
	      if (this.view_mode.change_url_on_filter) {
	        this.applyFiltersOnUrlQueryParams(filters);
	      }
	      this.$emit('filter', filters);
	      return this.trackIntercomContactsFilter();
	    },
	    toggleSelectAll: function() {
	      this.selected_all = !this.selected_all;
	      return EventsBus.$emit('ContactList:SelectedAll', {
	        selected_all: this.selected_all
	      });
	    },
	    selectedAll: function(data) {
	      if (this.view_mode.show_selections) {
	        return this.selected_all = data.selected_all;
	      }
	    },
	    unSelectedAll: function() {
	      return this.selected_all = false;
	    },
	    selectedPage: function(data) {
	      return this.selected_page = data.selected_page;
	    },
	    contactsEmpty: function() {
	      return jQuery.isEmptyObject(this.contacts);
	    },
	    isInitiallySelected: function(contact) {
	      if (this.selected_all) {
	        return true;
	      }
	      return this.initially_selected_contact_ids.indexOf(contact.id) !== -1;
	    },
	    hitBottom: function() {
	      if (!this.internal_scroller) {
	        return;
	      }
	      return this.$emit('hit-bottom');
	    },
	    priorityUpdated: function(contacts) {
	      return this.$emit('priority-updated', contacts);
	    },
	    trackIntercomContactsFilter: function() {
	      var origem;
	      origem = this.flow ? "Fluxo " : location.href.match(/\/contatos/) ? "Base de contatos" : location.href.match(/\/grupos-de-contatos\/\d+\/editar/) ? 'Edição de grupo - Contatos' : void 0;
	      return IntercomCtrl.trackEvent(origem + ' - Utilização da busca manual');
	    },
	    infinitScrollTable: function() {
	      var element;
	      if (!this.internal_scroller) {
	        return;
	      }
	      element = document.querySelector('.table-body.internal-scroller');
	      if (!element) {
	        return;
	      }
	      return element.addEventListener('scroll', (function(_this) {
	        return function() {
	          if (element.scrollTop + element.clientHeight >= (element.scrollHeight - 100)) {
	            return _this.emitScrollEnded();
	          }
	        };
	      })(this));
	    },
	    emitScrollEnded: function() {
	      if (this.internal_scroller) {
	        return this.$emit('scroll-ended');
	      }
	    }
	  },
	  created: function() {
	    EventsBus.$on('ContactList:SelectedAll', this.selectedAll);
	    EventsBus.$on('ContactList:SelectedPage', this.selectedPage);
	    return EventsBus.$on('ContactList:unSelectedAll', this.unSelectedAll);
	  },
	  mounted: function() {
	    return this.infinitScrollTable();
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('ContactList:SelectedAll', this.selectedAll);
	    EventsBus.$off('ContactList:SelectedPage', this.selectedPage);
	    return EventsBus.$off('ContactList:unSelectedAll', this.unSelectedAll);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    tag: __webpack_require__(9),
	    autocomplete: __webpack_require__(8),
	    lostReasonModal: __webpack_require__(38)
	  },
	  props: {
	    origem: {
	      "default": null
	    },
	    contact: {
	      type: Contact
	    },
	    initially_selected: {
	      "default": false
	    },
	    view_mode: {
	      type: Object,
	      required: true
	    },
	    flow: {
	      type: Flow
	    }
	  },
	  data: function() {
	    return {
	      show_flow_search: false,
	      show_lost_reason_modal: false,
	      current_user: Session.current_user,
	      selected: false,
	      tags_margin_left: this.view_mode.show_checkbox ? '77px' : '19px',
	      temp_attr: null,
	      temp_event: null
	    };
	  },
	  computed: {
	    show_send_to_flow: function() {
	      var base;
	      return typeof (base = ['connected', 'finished', 'inactive', 'not_connected', 'disqualified']).includes === "function" ? base.includes(this.contact.recipient_status) : void 0;
	    },
	    show_reset_contact: function() {
	      return this.view_mode.remove_action === 'remove-from-flow' && this.contact.recipient_status !== 'uninitialized';
	    },
	    remove_label: function() {
	      if (this.view_mode.remove_action === 'remove-from-flow') {
	        return 'Remover do fluxo';
	      } else {
	        return 'Excluir';
	      }
	    },
	    can_change_priority: function() {
	      var ref, ref1;
	      if (!['inactive', 'finished', 'connected', 'uninitialized', 'blocklisted', 'not_connected', 'disqualified'].includes(this.contact.recipient_status)) {
	        return ((ref = this.contact.recipient) != null ? ref.last_flow_action_taken : void 0) === null;
	      } else if (this.contact.recipient) {
	        if (this.contact.recipient.flow_id === ((ref1 = this.flow) != null ? ref1.id : void 0)) {
	          return !['finished', 'connected', 'blocklisted', 'not_connected', 'disqualified'].includes(this.contact.recipient_status);
	        } else {
	          return true;
	        }
	      } else {
	        return true;
	      }
	    },
	    overflow_tags: function() {
	      return this.contact.tags.length > this.view_mode.number_of_tags;
	    },
	    overflow_tags_count: function() {
	      return this.contact.tags.length - this.view_mode.number_of_tags;
	    },
	    skipped_actions_tooltip_text: function() {
	      var actions, actions_text;
	      actions = this.contact.recipient.metadata.destroyed_tasks.map(function(step) {
	        return step + 1;
	      });
	      if (actions.length > 1) {
	        actions_text = actions.slice(0, -1).join(', ') + (" e " + (actions.last()));
	        return "Etapas " + actions_text + " excluídas";
	      } else {
	        return "Etapa " + actions[0] + " excluída";
	      }
	    }
	  },
	  watch: {
	    initially_selected: function(new_value, old_value) {
	      return this.selected = new_value;
	    }
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll({
	        lost_reason_unit: this.lost_reason_id
	      }).then((function(_this) {
	        return function(success) {
	          var attr;
	          if (success) {
	            attr = _this.temp_attr;
	            attr['lost_reason'] = {
	              id: _this.lost_reason_id,
	              comment: _this.lost_reason_comment
	            };
	            return _this.updateContact(_this.temp_event, attr);
	          }
	        };
	      })(this));
	    },
	    updateContactInfo: function(flow) {
	      this.updateStages();
	      if (this.view_mode.show_flow && flow.id !== this.contact.flow.id) {
	        this.removeContactFromList();
	      }
	      return this.contact.flow = flow;
	    },
	    updateStages: function() {
	      this.contact.recipient_status = 'uninitialized';
	      this.contact.human_recipient_status = 'Não iniciado';
	      if (this.contact.stage !== 'lost') {
	        return;
	      }
	      this.contact.stage = this.contact.previous_stage;
	      return this.contact.human_stage = this.contact.human_previous_stage;
	    },
	    removeContactFromList: function() {
	      return this.$emit('contact-removed-from-flow', this.contact.id);
	    },
	    showFlowSearch: function(contact_id) {
	      if (this.contact.id === contact_id) {
	        return this.show_flow_search = true;
	      }
	    },
	    showLostReasonModal: function() {
	      return this.show_lost_reason_modal = true;
	    },
	    closeLostReasonModal: function() {
	      return this.show_lost_reason_modal = false;
	    },
	    hideFlowSearch: function() {
	      return this.show_flow_search = false;
	    },
	    toggleSelected: function(event) {
	      this.selected = !this.selected;
	      return this.emitSelectionToggleEvent(event);
	    },
	    emitSelectionToggleEvent: function(event, attr) {
	      if (event == null) {
	        event = {};
	      }
	      if (attr == null) {
	        attr = {};
	      }
	      event.originalEventName = 'contact-selected';
	      attr.contact = this.contact;
	      attr.selected = this.selected;
	      return this.$emit('contact-selected', {
	        event: event,
	        attr: attr
	      });
	    },
	    openContact: function() {
	      if (!(this.view_mode.name_go_to_show && this.contact.id)) {
	        return;
	      }
	      if (this.view_mode.link_open_bar) {
	        event.originalEventName = 'toggle-task-bar';
	        return this.$emit('toggle-task-bar', {
	          event: event,
	          contact: this.contact
	        });
	      } else {
	        return this.viewContact();
	      }
	    },
	    viewContact: function() {
	      if (!(this.view_mode.name_go_to_show && this.contact.id)) {
	        return;
	      }
	      return this.$router.push({
	        path: this.contactPath()
	      });
	    },
	    contactPath: function() {
	      return "/contatos/" + this.contact.id;
	    },
	    updateLostContact: function(lost_reason) {
	      var attr;
	      attr = this.temp_attr;
	      attr['lost_reason_id'] = lost_reason.id;
	      attr['lost_reason_comment'] = lost_reason.comment;
	      attr['send_to_new_flow'] = lost_reason.send_to_new_flow;
	      attr['due_on_date_custom'] = lost_reason.due_on_date_custom;
	      attr['flow'] = lost_reason.flow;
	      attr['immediately'] = lost_reason.immediately;
	      if (lost_reason.stage) {
	        attr['stage'] = lost_reason.stage;
	      }
	      if (lost_reason.status) {
	        attr['status'] = lost_reason.status;
	      }
	      if (lost_reason.schedule_set_contact_stage) {
	        attr['schedule_set_contact_stage'] = lost_reason.schedule_set_contact_stage;
	      }
	      this.updateContact(this.temp_event, attr);
	      return this.show_lost_reason_modal = false;
	    },
	    updateContact: function(event, attr) {
	      var origin;
	      origin = this.getOrigin();
	      IntercomCtrl.trackEvent(origin + " - Mudança de estágio para " + attr['stage']);
	      event.originalEventName = 'contact-update';
	      attr.id = this.contact.id;
	      return this.$emit('contact-update', {
	        event: event,
	        attr: attr
	      });
	    },
	    setLostInfo: function(event, attr) {
	      if (attr.stage === 'lost') {
	        this.temp_attr = attr;
	        this.temp_event = event;
	        return this.show_lost_reason_modal = true;
	      } else {
	        return this.updateContact(event, attr);
	      }
	    },
	    getOrigin: function() {
	      if (this.flow) {
	        return "Fluxo de cadência";
	      } else if (location.href.indexOf('tarefas') > -1) {
	        return "Contatos pausados";
	      } else {
	        return "Base de contatos";
	      }
	    },
	    updateContactRecipient: function(event, attr) {
	      event.originalEventName = 'contact-recipient-update';
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.temp_event = event;
	      if (attr.status === 'blocklisted') {
	        return this.show_lost_reason_modal = true;
	      }
	      return this.$emit('contact-recipient-update', {
	        event: event,
	        attr: attr
	      });
	    },
	    connectedAndSendToNewFlow: function(event) {
	      var attr;
	      if (this.show_lost_reason_modal === true) {
	        return;
	      }
	      event.stopPropagation();
	      attr = {
	        status: 'connected',
	        event: 'send_to_new_flow'
	      };
	      event.originalEventName = 'contact-recipient-update';
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.temp_event = event;
	      this.$emit('contact-recipient-update', {
	        event: event,
	        attr: attr
	      });
	      return this.show_lost_reason_modal = true;
	    },
	    connectedAndLost: function(event) {
	      var attr;
	      event.stopPropagation();
	      attr = {
	        status: 'connected',
	        event: 'lost'
	      };
	      event.originalEventName = 'contact-recipient-update';
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.temp_event = event;
	      this.temp_attr = {
	        stage: 'lost',
	        status: 'lost',
	        new_status: 'connected'
	      };
	      return this.show_lost_reason_modal = true;
	    },
	    connectedAndCreateTask: function(event) {
	      var attr;
	      event.stopPropagation();
	      attr = {
	        status: 'connected'
	      };
	      event.originalEventName = 'contact-recipient-update';
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.temp_event = event;
	      this.$emit('contact-recipient-update', {
	        event: event,
	        attr: attr
	      });
	      return EventsBus.$emit('TaskModalForm::Show', {
	        task_id: null,
	        contact: this.contact,
	        id: 'manual-task-form-modal',
	        show_stage_selection: true
	      });
	    },
	    connectedAndChangeStage: function(event) {
	      var attr;
	      event.stopPropagation();
	      attr = {
	        status: 'connected',
	        event: 'change_stage'
	      };
	      event.originalEventName = 'contact-recipient-update';
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.temp_event = event;
	      this.$emit('contact-recipient-update', {
	        event: event,
	        attr: attr
	      });
	      return this.show_lost_reason_modal = true;
	    },
	    checkboxSelectContact: function(event) {
	      if (this.view_mode.anywhere_select) {
	        return;
	      }
	      return this.toggleSelected(event);
	    },
	    anywhereSelectContact: function(event) {
	      var data;
	      if (!this.view_mode.anywhere_select) {
	        return;
	      }
	      if (this.view_mode.anywhere_select_action === 'check') {
	        return this.toggleSelected(event);
	      } else if (this.view_mode.anywhere_select_action === 'emit-selected') {
	        data = {
	          contact: this.contact,
	          event: {
	            originalEventName: 'contact-selected'
	          }
	        };
	        return this.$emit('contact-selected', data);
	      }
	    },
	    selectedItem: function(data) {
	      this.selected = data.selected_page || data.selected_all;
	      return this.emitSelectionToggleEvent();
	    },
	    editContact: function(event, attr) {
	      if (attr == null) {
	        attr = {};
	      }
	      event.originalEventName = 'contact-edit';
	      return this.$emit('contact-edit', {
	        event: event,
	        contact: this.contact
	      });
	    },
	    destroyContact: function(event, attr) {
	      if (attr == null) {
	        attr = {};
	      }
	      event.originalEventName = 'contact-destroy';
	      return this.$emit('contact-destroy', {
	        event: event,
	        contact: this.contact
	      });
	    },
	    resetContactRecipient: function(event, attr) {
	      if (attr == null) {
	        attr = {};
	      }
	      event.originalEventName = 'contact-recipient-reset';
	      return this.$emit('contact-recipient-reset', {
	        event: event,
	        contact: this.contact
	      });
	    },
	    lastEmailOpenEventAt: function() {
	      var time;
	      time = moment(this.contact.recipient.emailOpenStatistics().last_at).format('LLL');
	      return "Ultima abertura: " + time;
	    },
	    showEmailOpenStatisticBadge: function() {
	      return this.contact.recipient.emailOpenStatistics() && this.contact.recipient.emailOpenStatistics().count > 1 && this.contact.recipient_last_flow_action_taken_state === 'open';
	    },
	    canUpdateContact: function() {
	      return this.current_user.isAdmin() || this.current_user.isManager() || this.contact.user.id === this.current_user.id;
	    },
	    canScheduleReactivation: function() {
	      if (this.current_user.isMonitoringManager()) {
	        return false;
	      }
	      return this.contact.recipient && (this.contact.recipient_status === 'paused' || this.contact.recipient_status === 'scheduled_reactivation');
	    },
	    openRecipientScheduleReactivationModal: function(event) {
	      var attr;
	      attr = {
	        contact: this.contact
	      };
	      return EventsBus.$emit('Contact::ScheduleRecipientReactivation', {
	        event: event,
	        attr: attr
	      });
	    },
	    scheduleReactivationText: function() {
	      if (this.contact.recipient && this.contact.recipient.reactivate_automatic_task.constructor === Task) {
	        return 'Editar Reativação';
	      } else {
	        return 'Agendar Reativação';
	      }
	    }
	  },
	  created: function() {
	    EventsBus.$on('ContactList:SelectedAll', this.selectedItem);
	    EventsBus.$on('ContactList:SelectedPage', this.selectedItem);
	    EventsBus.$on('open-flow-search', this.showFlowSearch);
	    return this.selected = this.initially_selected;
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('ContactList:SelectedAll', this.selectedItem);
	    EventsBus.$off('ContactList:SelectedPage', this.selectedItem);
	    return EventsBus.$off('open-flow-search', this.showFlowSearch);
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.contacts.styles, helpers.form);


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    contactsPickerTextCsv: __webpack_require__(35)
	  },
	  data: function() {
	    return {
	      new_contacts: {}
	    };
	  },
	  methods: {
	    contactsEmpty: function() {
	      return jQuery.isEmptyObject(this.contacts);
	    },
	    selectContacts: function() {
	      return EventsBus.$emit('contacts-picker-text-csv-validate');
	    },
	    contactsAdded: function(data) {
	      this.new_contacts = data.contacts;
	      EventsBus.$emit('contact-picker-contacts-added', {
	        contacts: this.new_contacts
	      });
	      return jQuery('#contacts-manual-picker').modal('hide');
	    }
	  },
	  created: function() {
	    return EventsBus.$on('contacts-picker-text-csv-publish', this.contactsAdded);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('contacts-picker-text-csv-publish', this.contactsAdded);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes);


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, on_clickaway, view_model;
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin, __webpack_require__(6)],
	  components: {
	    tagsAutocomplete: __webpack_require__(175)
	  },
	  props: {
	    filters: {
	      "default": function() {
	        return {};
	      }
	    },
	    unselected_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    selected_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    count_all_contacts: {
	      "default": function() {
	        return 0;
	      }
	    },
	    count_page_contacts: {
	      "default": function() {
	        return 0;
	      }
	    }
	  },
	  data: function() {
	    return {
	      tag_created: null,
	      selected_page: false,
	      selected_all: false,
	      show_change_tags: false,
	      users_options: [],
	      current_user: Session.current_user,
	      current_company: Session.current_company
	    };
	  },
	  computed: {
	    disabled_buttons: function() {
	      return this.count_selected_contacts === 0;
	    },
	    some_selected: function() {
	      return this.selected_ids.length > 0 || this.unselected_ids.length > 0;
	    },
	    all_selected: function() {
	      return this.count_selected_contacts === this.count_all_contacts && this.unselected_ids.length === 0;
	    },
	    select_button_class: function() {
	      var clazz;
	      clazz = '';
	      if (this.all_selected && this.count_all_contacts > 0) {
	        clazz = "all_selected";
	      } else if (this.some_selected) {
	        clazz = "some_selected";
	      }
	      return clazz;
	    },
	    count_selected_contacts: function() {
	      var count;
	      if (this.selected_all) {
	        count = this.count_all_contacts - this.unselected_ids.length;
	      } else {
	        count = this.selected_ids.length;
	      }
	      if (count === 0 && (this.selected_all || this.selected_page)) {
	        this.clearSelected();
	      }
	      return count;
	    },
	    toogle_tag_display_menu: function() {
	      if (this.show_change_tags) {
	        return {
	          display: 'block'
	        };
	      } else {
	        return {
	          display: 'none'
	        };
	      }
	    }
	  },
	  methods: {
	    showUserOption: function(user) {
	      return this.current_company.account_setting.seller_can_change_responsability || !(user.id === this.current_user.id && user.isSeller());
	    },
	    selection: function() {
	      if (this.all_selected || this.some_selected) {
	        return this.clearSelected();
	      } else {
	        return this.setSelectPage();
	      }
	    },
	    toogleShowChangeTags: function(tag) {
	      this.tag_created = tag.id ? tag : null;
	      return this.show_change_tags = !this.show_change_tags;
	    },
	    closeShowChangeTags: function() {
	      return this.show_change_tags = false;
	    },
	    clearSelected: function(data) {
	      if (data == null) {
	        data = {};
	      }
	      this.selected_all = false;
	      this.selected_page = false;
	      this.show_change_tags = false;
	      return EventsBus.$emit('ContactList:SelectedAll', {
	        selected_all: this.selected_all
	      });
	    },
	    setSelectPage: function() {
	      this.selected_page = true;
	      return EventsBus.$emit('ContactList:SelectedPage', {
	        selected_page: this.selected_page
	      });
	    },
	    remSelectPage: function() {
	      this.selected_page = false;
	      return EventsBus.$emit('ContactList:SelectedPage', {
	        selected_page: this.selected_page
	      });
	    },
	    toggleSelectAll: function() {
	      this.selected_all = !this.selected_all;
	      return EventsBus.$emit('ContactList:SelectedAll', {
	        selected_all: this.selected_all
	      });
	    },
	    openDestroyContactsConfirmationModal: function() {
	      if (!this.disabled_buttons) {
	        return EventsBus.$emit('confirm-modal-show', {
	          id: 'confirm-remove-contacts'
	        });
	      }
	    },
	    userSelected: function(user) {
	      event.originalEventName = 'user-selected';
	      return this.$emit('user-selected', {
	        event: event,
	        user: user
	      });
	    },
	    loadUsersOptionsSuccess: function(data) {
	      return this.users_options = data.users;
	    }
	  },
	  created: function() {
	    EventsBus.$on('ContactList:ClearSelections', this.clearSelected);
	    return EventsBus.$on('MassActions:Autocomplete:TagCreated', this.toogleShowChangeTags);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('ContactList:ClearSelections', this.clearSelected);
	    return EventsBus.$off('MassActions:Autocomplete:TagCreated', this.toogleShowChangeTags);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    fetch_mode: {
	      "default": "eligibleForANewFlow",
	      validator: function(value) {
	        var fetch_modes;
	        fetch_modes = ["eligibleForANewFlow", "withoutGroup", "all"];
	        return fetch_modes.indexOf(value) > -1;
	      }
	    },
	    view_mode: {
	      "default": null
	    },
	    user_id: {
	      "default": null
	    }
	  },
	  data: function() {
	    return {
	      contacts: [],
	      selected_contacts: {},
	      persisted_contacts: {},
	      fetching: false,
	      next_page: 1,
	      filters: {}
	    };
	  },
	  computed: {
	    selected_contact_ids: function() {
	      return Object.keys(this.selected_contacts).map(function(id, index) {
	        return parseInt(id);
	      });
	    }
	  },
	  watch: {
	    user_id: function(new_user_id) {
	      this.clearData();
	      return this.loadData();
	    }
	  },
	  methods: {
	    clearData: function() {
	      this.next_page = 1;
	      this.fetching = false;
	      this.filters = {};
	      return this.contacts = [];
	    },
	    loadData: function() {
	      if (this.fetching || !this.next_page || this.user_id === null) {
	        return;
	      }
	      this.filters = this.mergeCurrentUserFilter(this.filters, this.user_id);
	      this.fetching = true;
	      return this.fetchContacts();
	    },
	    fetchContacts: function() {
	      var filters, params;
	      filters = this.filters;
	      filters.not_blocklisted_status = true;
	      params = {
	        q: filters,
	        page: this.next_page
	      };
	      return this.selectFetchMode(params);
	    },
	    selectFetchMode: function(params) {
	      if (this.fetch_mode === "eligibleForANewFlow") {
	        return this.contact_resource.eligibleForANewFlow(this.loadSuccess, this.unknownError, {
	          params: params
	        });
	      } else if (this.fetch_mode === "withoutGroup") {
	        return this.contact_resource.withoutGroup(this.loadSuccess, this.unknownError, {
	          params: params
	        });
	      } else {
	        return this.contact_resource.index(this.loadSuccess, this.unknownError, {
	          params: params
	        });
	      }
	    },
	    loadSuccess: function(resources) {
	      if (resources.contacts[0] && resources.contacts[0].user.id !== this.user_id) {
	        return;
	      }
	      this.fetching = false;
	      this.next_page = resources.meta.next_page;
	      return this.contacts = this.contacts.concat(resources.contacts);
	    },
	    filter: function(filters) {
	      this.contacts = [];
	      this.filters = filters;
	      this.next_page = 1;
	      return this.loadData();
	    },
	    selectContacts: function() {
	      this.$emit('contacts-selected', {
	        contacts: Object.values(this.selected_contacts)
	      });
	      if (this.contacts.length === 0 && this.next_page) {
	        EventsBus.$emit('ContactList:unSelectedAll');
	        return this.loadData();
	      }
	    },
	    updateContactSelection: function(data) {
	      if (data.attr.selected) {
	        Vue.set(this.selected_contacts, data.attr.contact.id, data.attr.contact);
	      } else {
	        Vue["delete"](this.selected_contacts, data.attr.contact.id);
	      }
	      if (data.attr.force === true) {
	        return this.selectContacts();
	      }
	    },
	    updatePersistedContacts: function(data) {
	      this.persisted_contacts = data.contacts;
	      this.persisted_contacts.forEach((function(_this) {
	        return function(contact) {
	          return _this.updateContactSelection({
	            attr: {
	              contact: contact,
	              selected: true
	            }
	          });
	        };
	      })(this));
	      return this.selectContacts();
	    },
	    getViewMode: function() {
	      if (this.view_mode) {
	        return this.view_mode;
	      } else {
	        return this.contactListViewModes().picker;
	      }
	    },
	    addContact: function(data) {
	      this.contacts.unshift(data.contact);
	      this.updateContactSelection({
	        attr: {
	          contact: data.contact,
	          selected: data.selected
	        }
	      });
	      return this.selectContacts();
	    },
	    removeContact: function(data) {
	      return this.contacts = this.contacts.filter(function(contact) {
	        return contact.id !== data.id;
	      });
	    }
	  },
	  created: function() {
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    this.loadData();
	    EventsBus.$on('ContactsPicker:SetPersistedSelectedContacts', this.updatePersistedContacts);
	    EventsBus.$on('ContactsPicker:RemoveContact', this.removeContact);
	    return EventsBus.$on('ContactsPicker:AddContact', this.addContact);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('ContactsPicker:SetPersistedSelectedContacts', this.updatePersistedContacts);
	    EventsBus.$off('ContactsPicker:AddContact', this.addContact);
	    return EventsBus.$off('ContactsPicker:RemoveContact', this.removeContact);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes, helpers.filters);


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    contactsPickerTextCsv: __webpack_require__(35)
	  },
	  methods: {
	    submit: function() {
	      return EventsBus.$emit('contacts-picker-text-csv-validate');
	    },
	    saveSuccess: function(response) {
	      return Loader.off();
	    },
	    saveFailure: function(response) {
	      Loader.off();
	      alertify.error(this.$t('contacts_group.feedback.failOnCreate', {
	        type: this.$t('contacts.label.contacts')
	      }));
	      return EventsBus.$emit('contacts-picker-text-csv-errors', response.body);
	    }
	  },
	  created: function() {
	    return EventsBus.$on('contacts-picker-text-csv-publish', this.save);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('contacts-picker-text-csv-publish', this.save);
	  }
	};
	
	exports["default"] = view_model;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	var VeeValidate, helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	VeeValidate = __webpack_require__(258);
	
	view_model = {
	  props: {
	    has_groups: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      contact_list: '',
	      line_errors: [],
	      line_has_errors: {},
	      has_line_errors: false,
	      pristine: true,
	      emails: {},
	      custom_fields: []
	    };
	  },
	  computed: {
	    attributes: function() {
	      var attributes;
	      attributes = [this.$t('contacts.attributes.first_name').concat('*'), this.$t('contacts.attributes.last_name').concat('*'), this.$t('contacts.attributes.email').concat('*'), this.$t('contacts.attributes.company_id').concat('*')];
	      if (this.has_groups) {
	        attributes = attributes.concat([this.$t('contacts.attributes.contact_group').concat('*')]);
	      }
	      attributes = attributes.concat([this.$t('contacts.attributes.position'), this.$t('contacts.attributes.telephone'), this.$t('contacts.attributes.cellphone'), this.$t('contacts.attributes.address'), this.$t('contacts.attributes.url'), this.$t('contacts.attributes.linkedIn')]);
	      attributes = attributes.concat([this.$t('contacts.attributes.var1'), this.$t('contacts.attributes.var2'), this.$t('contacts.attributes.var3')]);
	      attributes = attributes.concat(this.custom_fields.map(function(custom_field) {
	        return custom_field.field;
	      }));
	      return attributes.join(', ');
	    }
	  },
	  methods: {
	    cleanUpTextarea: function() {
	      var line;
	      return this.contact_list = ((function() {
	        var i, len, ref, results;
	        ref = this.contactListLines();
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          line = ref[i];
	          if (line.trim() !== '') {
	            results.push(line);
	          }
	        }
	        return results;
	      }).call(this)).join("\n");
	    },
	    validateUnlessPristine: function() {
	      if (!this.pristine) {
	        return this.validate();
	      }
	    },
	    validate: function() {
	      var contact, errors, line_number, ref;
	      this.pristine = false;
	      this.line_errors = [];
	      this.line_has_errors = {};
	      this.has_line_errors = false;
	      this.contacts = this.parseContacts();
	      this.emails = {};
	      ref = this.contacts;
	      for (line_number in ref) {
	        contact = ref[line_number];
	        line_number = parseInt(line_number) + 1;
	        if (isNaN(line_number)) {
	          continue;
	        }
	        errors = this.validateContact(contact);
	        if (errors) {
	          this.addLineErrors(line_number, errors);
	        }
	      }
	      return !this.has_line_errors;
	    },
	    validateContact: function(contact) {
	      var errors, ref;
	      errors = [];
	      if (!(contact.first_name && contact.last_name && contact.email && ((ref = contact.business) != null ? ref.name : void 0) && (!this.has_groups || (contact.contact_group && contact.contact_group.name)))) {
	        errors.push(this.$t('contacts.label.' + (this.has_groups ? 'requiredFieldsWithGroups' : 'requiredFields')));
	      }
	      if (this.emails.hasOwnProperty(contact.email)) {
	        errors.push(this.$t('general.label.duplicatedField', {
	          field: contact.email
	        }));
	      } else {
	        this.emails[contact.email] = 0;
	      }
	      if (!this.validator.validate('email', contact.email)) {
	        errors.push(this.$t('general.label.invalidField', {
	          field: this.$t('contacts.attributes.email'),
	          field_value: contact.email
	        }));
	      }
	      return errors.length > 0 && errors || false;
	    },
	    contactListLines: function() {
	      return this.contact_list.split('\n');
	    },
	    parseContacts: function() {
	      var i, len, line, ref, results;
	      ref = this.contactListLines();
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        line = ref[i];
	        results.push(this.csvLineToContact(line));
	      }
	      return results;
	    },
	    csvLineToContact: function(line) {
	      var contact, parts;
	      parts = line.split(',');
	      contact = new Contact({
	        first_name: this.cleanContactAttribute(parts[0]),
	        last_name: this.cleanContactAttribute(parts[1]),
	        email: this.cleanContactAttribute(parts[2]),
	        business: {
	          name: this.cleanContactAttribute(parts[3])
	        },
	        business_name: this.cleanContactAttribute(parts[3]),
	        contact_group: {
	          name: (this.has_groups ? this.cleanContactAttribute(parts[4]) : null)
	        },
	        position: this.cleanContactAttribute(parts[4 + this.has_groups]),
	        telephone: this.cleanContactAttribute(parts[5 + this.has_groups]),
	        cellphone: this.cleanContactAttribute(parts[6 + this.has_groups]),
	        address: this.cleanContactAttribute(parts[7 + this.has_groups]),
	        url: this.cleanContactAttribute(parts[8 + this.has_groups]),
	        linkedin: this.cleanContactAttribute(parts[9 + this.has_groups]),
	        variable1: this.cleanContactAttribute(parts[10 + this.has_groups]),
	        variable2: this.cleanContactAttribute(parts[11 + this.has_groups]),
	        variable3: this.cleanContactAttribute(parts[12 + this.has_groups]),
	        contact_custom_fields: this.returnCustomFields(parts)
	      });
	      contact.full_name = contact.first_name + " " + contact.last_name;
	      return contact;
	    },
	    contactsToCsvLines: function(contacts) {
	      var lines;
	      lines = "";
	      contacts.forEach((function(_this) {
	        return function(contact, index) {
	          if (index !== 0) {
	            lines += '\n';
	          }
	          return lines += _this.contactToCsvLine(contact);
	        };
	      })(this));
	      return lines;
	    },
	    contactToCsvLine: function(contact) {
	      var attributes, line;
	      attributes = [contact.first_name, contact.last_name, contact.email, contact.business.name, contact.contact_group, contact.position, contact.telephone, contact.cellphone, contact.address];
	      line = attributes.join(", ");
	      return line;
	    },
	    cleanContactAttribute: function(attribute) {
	      return (attribute || '').trim();
	    },
	    treatBusinessName: function(api_errors) {
	      api_errors['empresa'] = api_errors['business.name'];
	      delete api_errors['business.name'];
	      return api_errors;
	    },
	    treatCustomField: function(api_errors, key) {
	      var errors, propriety;
	      propriety = "Propriedade " + api_errors[key][0]['custom_field_name'] + ": ";
	      errors = [api_errors[key][0]['custom_field_value'], api_errors[key][0]['error']];
	      api_errors[propriety] = errors;
	      delete api_errors[key];
	      return api_errors;
	    },
	    addErrorsWithLinesFromApi: function(response_body) {
	      var _, api_errors, errors, field, key, line_number, ref, results;
	      ref = response_body.line_errors;
	      results = [];
	      for (line_number in ref) {
	        api_errors = ref[line_number];
	        if (api_errors['business.name']) {
	          api_errors = this.treatBusinessName(api_errors);
	        }
	        for (key in api_errors) {
	          _ = api_errors[key];
	          if (key.search(/^contact_custom_fields.*/) > -1) {
	            api_errors = this.treatCustomField(api_errors, key);
	          }
	        }
	        this.has_line_errors = true;
	        errors = (function() {
	          var results1;
	          results1 = [];
	          for (field in api_errors) {
	            errors = api_errors[field];
	            results1.push(field + " " + (errors.join(', ')));
	          }
	          return results1;
	        })();
	        results.push(this.addLineErrors(line_number, errors));
	      }
	      return results;
	    },
	    addLineErrors: function(line_number, errors) {
	      this.has_line_errors = true;
	      this.line_errors.push({
	        line_number: line_number,
	        errors: errors
	      });
	      return this.line_has_errors[line_number] = true;
	    },
	    lineWithEmail: function(email) {
	      var line, line_number, ref;
	      ref = this.contactListLines();
	      for (line_number in ref) {
	        line = ref[line_number];
	        if (line.includes(email)) {
	          return parseInt(line_number) + 1;
	        }
	      }
	    },
	    addErrorsWithoutLinesFromApi: function(data) {
	      var i, len, line_number, ref, results, taken_email;
	      ref = data.errors.taken_emails;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        taken_email = ref[i];
	        line_number = this.lineWithEmail(taken_email);
	        if (line_number) {
	          results.push(this.addLineErrors(line_number, [
	            this.$t('general.label.duplicatedField', {
	              field: taken_email
	            })
	          ]));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    addErrorsFromApi: function(response_body) {
	      this.pristine = false;
	      this.clearErrors();
	      if (response_body.line_errors) {
	        return this.addErrorsWithLinesFromApi(response_body);
	      } else {
	        return this.addErrorsWithoutLinesFromApi(response_body);
	      }
	    },
	    clearErrors: function() {
	      var line_has_errors;
	      this.line_errors = [];
	      line_has_errors = {};
	      return {
	        has_line_errors: false
	      };
	    },
	    restoreContacts: function(contacts) {
	      this.contact_list = this.contactsToCsvLines(contacts);
	      return this.publish();
	    },
	    publish: function() {
	      this.cleanUpTextarea();
	      if (this.validate()) {
	        return EventsBus.$emit('contacts-picker-text-csv-publish', {
	          contact_list: this.contact_list,
	          contacts: this.contacts
	        });
	      }
	    },
	    returnCustomFields: function(parts) {
	      var custom_field, final_custom_fields, i, index, len, ref;
	      if (this.custom_fields.length === 0) {
	        return;
	      }
	      final_custom_fields = [];
	      ref = this.custom_fields;
	      for (index = i = 0, len = ref.length; i < len; index = ++i) {
	        custom_field = ref[index];
	        final_custom_fields.push({
	          value: this.cleanContactAttribute(parts[13 + this.has_groups + index]),
	          custom_field_id: custom_field.id
	        });
	      }
	      return final_custom_fields;
	    },
	    loadCustomFields: function() {
	      Loader.on();
	      return new CustomFieldsResource().index(this.loadCustomFieldsSuccess, this.loadCustomFieldsFail);
	    },
	    loadCustomFieldsSuccess: function(data) {
	      this.custom_fields = data.custom_fields;
	      return Loader.off();
	    },
	    loadCustomFieldsFail: function() {
	      Loader.off();
	      return alertify.error(this.$t('contacts.label.customFieldsFailLoading'));
	    }
	  },
	  mounted: function() {
	    return LinedTextarea.initialize('textarea.lined');
	  },
	  created: function() {
	    this.loadCustomFields();
	    this.validator = new VeeValidate.Validator({
	      email: 'email'
	    });
	    EventsBus.$on('contacts-picker-text-csv-validate', this.publish);
	    EventsBus.$on('contacts-picker-text-csv-errors', this.addErrorsFromApi);
	    return EventsBus.$on('contacts-picker-text-csv-restore', this.restoreContacts);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('contacts-picker-text-csv-validate', this.publish);
	    EventsBus.$off('contacts-picker-text-csv-errors', this.addErrorsFromApi);
	    return EventsBus.$off('contacts-picker-text-csv-restore', this.restoreContacts);
	  }
	};
	
	exports["default"] = view_model;


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, summernote, view_model;
	
	helpers = __webpack_require__(2);
	
	summernote = __webpack_require__(78);
	
	view_model = {
	  data: function() {
	    return {
	      contact: new Contact,
	      flow: null,
	      show_flow_autocomplete: false,
	      show_summernote: false,
	      selected_task: new Task,
	      current_user: Session.current_user,
	      show_lost_reason_modal: false,
	      temp_attr: null,
	      lost_reason: null,
	      prop_tooltip_placement: 'left',
	      schedule_reactivation_contact: null
	    };
	  },
	  components: {
	    flowAutocomplete: __webpack_require__(8),
	    contactEvents: __webpack_require__(119),
	    contactTasks: __webpack_require__(124),
	    contactForm: __webpack_require__(121),
	    userDropdown: __webpack_require__(55),
	    tag: __webpack_require__(9),
	    tagPickerModal: __webpack_require__(74),
	    lostReasonModal: __webpack_require__(38),
	    reactivateRecipientModal: __webpack_require__(23)
	  },
	  computed: {
	    show_flow_dropdown: function() {
	      return (!Session.current_user.isSeller() || Session.current_user.id === this.contact.user_id) && this.contact.recipient_status !== 'blocklisted';
	    },
	    show_new_task_button: function() {
	      return Session.current_user.id === this.contact.user_id;
	    },
	    user_can_edit_comment: function() {
	      return Session.current_user.id === this.contact.user_id || (Session.current_user.isAdmin() || Session.current_user.isManager());
	    },
	    has_business: function() {
	      var ref;
	      return ((ref = this.contact.business) != null ? ref.id : void 0) !== null;
	    }
	  },
	  methods: {
	    updateLostContact: function(lost_reason) {
	      var attr;
	      attr = this.temp_attr;
	      attr['lost_reason_id'] = lost_reason.id;
	      attr['lost_reason_comment'] = lost_reason.comment;
	      attr['send_to_new_flow'] = lost_reason.send_to_new_flow;
	      attr['due_on_date_custom'] = lost_reason.due_on_date_custom;
	      attr['flow'] = lost_reason.flow;
	      attr['immediately'] = lost_reason.immediately;
	      if (lost_reason.stage) {
	        attr['stage'] = lost_reason.stage;
	      }
	      if (lost_reason.status) {
	        attr['status'] = lost_reason.status;
	      }
	      if (lost_reason.schedule_set_contact_stage) {
	        attr['schedule_set_contact_stage'] = lost_reason.schedule_set_contact_stage;
	      }
	      this.updateContact(attr);
	      return this.show_lost_reason_modal = false;
	    },
	    setLostInfo: function(attr) {
	      if (attr.stage === 'lost') {
	        this.temp_attr = attr;
	        return this.show_lost_reason_modal = true;
	      } else {
	        return this.updateContact(attr);
	      }
	    },
	    closeLostReasonModal: function() {
	      return this.show_lost_reason_modal = false;
	    },
	    toggleTaskBar: function(data) {
	      return EventsBus.$emit('toggle-task-bar', {
	        contact_id: data.contact.id,
	        task: data.task
	      });
	    },
	    updateContactInfo: function(flow) {
	      this.updateStages();
	      this.contact.flow = flow;
	      this.flow = flow;
	      if (this.contact.recipient) {
	        return this.contact.recipient.flow_id = flow.id;
	      }
	    },
	    updateStages: function() {
	      this.contact.recipient_status = 'uninitialized';
	      this.contact.human_recipient_status = 'Não iniciado';
	      if (this.contact.stage !== 'lost') {
	        return;
	      }
	      this.contact.stage = this.contact.previous_stage;
	      return this.contact.human_stage = this.contact.human_previous_stage;
	    },
	    showFlowAutocomplete: function() {
	      var show_flow_autocomplete;
	      return show_flow_autocomplete = true;
	    },
	    hideFlowAutocomplete: function() {
	      var show_flow_autocomplete;
	      return show_flow_autocomplete = false;
	    },
	    toogleSummernote: function() {
	      if (this.user_can_edit_comment) {
	        return this.show_summernote = !this.show_summernote;
	      } else {
	        return alertify.error('Você não tem permissão para criar novos comentários neste contato');
	      }
	    },
	    inializeSummernote: function() {
	      this.$comment = jQuery('#comment');
	      summernote(this.$comment, {
	        focus: false
	      });
	      return this.$comment.summernote('code', '');
	    },
	    setContact: function(contact) {
	      this.contact = contact;
	      return this.flow = contact.flow;
	    },
	    saveComment: function() {
	      var comment_text, params;
	      comment_text = this.$comment.summernote('code');
	      if (comment_text.length === 0 || comment_text === '&nbsp;') {
	        alertify.error('Não é possível inserir um comentário sem conteúdo');
	        return;
	      }
	      Loader.on();
	      this.comment_events_resource = new CommentEventsResource(this.contact.id);
	      params = {
	        contact_id: this.contact.id,
	        author: Session.current_user.name,
	        comment: comment_text
	      };
	      return this.comment_events_resource.create(this.saveCommentSuccess, this.unknownError, params);
	    },
	    saveCommentSuccess: function(data) {
	      Loader.off();
	      alertify.success('Comentário salvo com sucesso!');
	      this.$refs.contact_events.addEvent(data.event);
	      return this.cancelComment();
	    },
	    cancelComment: function() {
	      this.show_summernote = !this.show_summernote;
	      return this.$comment.summernote('code', '');
	    },
	    loadSuccess: function(resources) {
	      this.setContact(resources.contact);
	      EventsBus.$emit('contact-loaded', {
	        contact: this.contact
	      });
	      return Loader.off();
	    },
	    loadContact: function() {
	      var params;
	      Loader.on();
	      params = {
	        include_contact_custom_fields: true
	      };
	      return this.contact_resource.get(this.loadSuccess, this.loadFailure, {
	        id: this.$route.params.id,
	        params: params
	      });
	    },
	    loadFailure: function(data) {
	      if (data.status === 403) {
	        return this.$router.push('/contatos/leads');
	      } else {
	        return alertify.error('Erro desconhecido ao carregar contato');
	      }
	    },
	    openScheduleReactivationModal: function(event) {
	      this.schedule_reactivation_contact = this.contact;
	      return jQuery('#recipient-schedule-reactivation').modal('show');
	    },
	    scheduleReactivationText: function() {
	      if (this.contact.recipient && this.contact.recipient.reactivate_automatic_task.constructor === Task) {
	        return 'Editar Reativação';
	      } else {
	        return 'Agendar Reativação';
	      }
	    },
	    updateContact: function(data) {
	      data.id = this.contact.id;
	      this.contact_resource.update(this.updateContactSuccess, this.unknownError, data);
	      if (data.stage != null) {
	        return IntercomCtrl.trackEvent("Base de contatos - estágio de contato modificada para " + data.stage, {
	          'Identificador do contato': this.contact.id
	        });
	      } else {
	        return IntercomCtrl.trackEvent("Base de contatos - responsável de contato modificado", {
	          'Identificador do contato': this.contact.id,
	          'Identificador do novo responsável': data.user_id
	        });
	      }
	    },
	    updateContactRecipient: function(event, data) {
	      return this.updateContactstatus(data);
	    },
	    updateContactstatus: function(data) {
	      var params, ref;
	      if ((ref = this.contact.recipient) != null ? ref.id : void 0) {
	        params = {
	          contact_id: this.contact.id,
	          id: this.contact.recipient.id,
	          status: data.status
	        };
	        return this.contact_resource.updateRecipient(this.updateContactSuccess, this.unknownError, params);
	      } else {
	        params = {
	          id: this.contact.id,
	          status: data.status
	        };
	        return this.contact_resource.update(this.updateContactSuccess, this.unknownError, params);
	      }
	    },
	    connectedAndSendToNewFlow: function(event) {
	      var attr;
	      if (this.show_lost_reason_modal === true) {
	        return;
	      }
	      event.stopPropagation();
	      attr = {
	        status: 'connected',
	        event: 'send_to_new_flow'
	      };
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.updateContactstatus({
	        status: 'connected'
	      });
	      return this.show_lost_reason_modal = true;
	    },
	    connectedAndLost: function(event) {
	      var attr;
	      event.stopPropagation();
	      attr = {
	        status: 'connected',
	        event: 'lost'
	      };
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.temp_attr = {
	        stage: 'lost',
	        status: 'lost',
	        new_status: 'connected'
	      };
	      return this.show_lost_reason_modal = true;
	    },
	    connectedAndCreateTask: function(event) {
	      var attr;
	      event.stopPropagation();
	      attr = {
	        status: 'connected'
	      };
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.updateContactstatus({
	        status: 'connected'
	      });
	      return EventsBus.$emit('TaskModalForm::Show', {
	        task_id: null,
	        contact: this.contact,
	        id: 'manual-task-form-modal',
	        show_stage_selection: true
	      });
	    },
	    connectedAndChangeStage: function(event) {
	      var attr;
	      event.stopPropagation();
	      attr = {
	        status: 'connected',
	        event: 'change_stage'
	      };
	      attr.contact_id = this.contact.id;
	      attr.id = this.contact.recipient.id;
	      this.temp_attr = attr;
	      this.updateContactstatus({
	        status: 'connected'
	      });
	      return this.show_lost_reason_modal = true;
	    },
	    openRemoveContactFromFlowModal: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-remove-contact-from-flow'
	      });
	    },
	    confirmRemoveContactFromFlow: function() {
	      return this.contact_resource.removeFromFlow(this.updateContactSuccess, this.unknownError, {
	        id: this.contact.id,
	        flow_id: this.contact.flow.id
	      });
	    },
	    updateContactSuccess: function(resources) {
	      this.setContact(resources.contact);
	      this.$refs.contact_tasks.reloadTasks();
	      return alertify.success('Contato atualizado com sucesso!');
	    },
	    viewFlow: function() {
	      return this.$router.push({
	        path: this.flowPath()
	      });
	    },
	    flowPath: function() {
	      return "/fluxos-de-cadencia/" + this.flow.id;
	    },
	    newTask: function(event) {
	      return EventsBus.$emit('TaskModalForm::Show', {
	        contact: this.contact,
	        id: 'dialer-manual-task-form-modal'
	      });
	    },
	    removeContact: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-remove-contact'
	      });
	    },
	    confirmRemoveContact: function() {
	      return this.contact_resource.destroy(this.removeContactSuccess, this.unknownError, {
	        id: this.contact.id
	      });
	    },
	    removeContactSuccess: function() {
	      this.$router.push({
	        path: '/contatos/leads'
	      });
	      return alertify.success('Contato excluído com sucesso');
	    },
	    removeTag: function(data) {
	      var params;
	      params = {
	        id: this.contact.id,
	        contact_tags_attributes: [
	          {
	            id: data.taggable_tag_id,
	            _destroy: true
	          }
	        ]
	      };
	      return this.contact_resource.update(this.removeTagSuccess(data), this.unknownError, params);
	    },
	    removeTagSuccess: function(data) {
	      return (function(_this) {
	        return function(response) {
	          alertify.success('Tag removida com sucesso!');
	          return _this.contact.tags = _this.contact.tags.filter(function(tag) {
	            return tag.taggable_tag_id !== data.taggable_tag_id;
	          });
	        };
	      })(this);
	    },
	    openTagsModal: function() {
	      this.$refs.tag_picker_modal.reloadTags();
	      return jQuery('#' + this.tag_picker_id).modal('show');
	    },
	    addTagsToContact: function(tags) {
	      var contact_tags_attributes, tag;
	      if (!tags.length) {
	        return;
	      }
	      contact_tags_attributes = (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = tags.length; i < len; i++) {
	          tag = tags[i];
	          results.push({
	            tag_id: tag.id
	          });
	        }
	        return results;
	      })();
	      return this.contact_resource.update(this.addTagsSuccess, this.unknownError, {
	        id: this.contact.id,
	        contact_tags_attributes: contact_tags_attributes
	      });
	    },
	    addTagsSuccess: function(data) {
	      this.setContact(data.contact);
	      return alertify.success('Tags adicionada ao contato com sucesso');
	    },
	    loadTaskInfo: function(data) {
	      Loader.on();
	      return this.tasks_resources.get(this.loadTaskInfoSuccess, this.unknownError, {
	        id: data.task.id
	      });
	    },
	    loadTaskInfoSuccess: function(data) {
	      this.selected_task = data.task;
	      EventsBus.$emit('confirm-modal-show', {
	        id: 'contact-create-template-modal'
	      });
	      return Loader.off();
	    },
	    taskDestroyed: function(data) {
	      return this.$refs.contact_events.addEvent(new ContactEvent(data.event));
	    },
	    updateLoading: function(loading) {
	      if (loading) {
	        return Loader.on();
	      } else {
	        return Loader.off();
	      }
	    }
	  },
	  created: function() {
	    this.tag_picker_id = 'tag-picker-interno';
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    this.tasks_resources = new TasksResource;
	    EventsBus.$on('contact-updated', this.setContact);
	    EventsBus.$emit('close-task-bar', parseInt(this.$route.params.id));
	    EventsBus.$on('Show::UpdateContactsInfo', this.updateContactInfo);
	    return this.loadContact();
	  },
	  mounted: function() {
	    return this.inializeSummernote();
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('contact-updated', this.setContact);
	    return EventsBus.$off('Show::UpdateContactsInfo', this.updateContactInfo);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.manual_tasks.list_wrapper, helpers.contacts.styles);


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    tag: __webpack_require__(9)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      is_bar_minimized: false,
	      description_num_of_char: 70,
	      show_full_comments: {},
	      all_comments: false,
	      contact: new Contact,
	      loading: true,
	      task: null,
	      show_sidebar: false,
	      action_human_signature: {
	        "task-flow-action-social-task": "Social",
	        "task-flow-action-phonecall-task": "Ligação",
	        "task-flow-action-linkedin-task": "LinkedIn",
	        "task-flow-action-email-task": "E-mail",
	        "email-flow-action": "E-mail"
	      }
	    };
	  },
	  methods: {
	    newComment: function(open_anyway) {
	      if (open_anyway == null) {
	        open_anyway = false;
	      }
	      this.open_anyway = open_anyway;
	      if (this.task && this.task.id) {
	        return this.task_resources.get(this.loadTaskSuccess, this.unknownError, {
	          id: this.task.id
	        });
	      } else {
	        return EventsBus.$emit('Comment::New', {
	          contact: this.contact,
	          template: null
	        });
	      }
	    },
	    loadTaskSuccess: function(data) {
	      this.task = data.task;
	      if (this.task.template.id) {
	        return EventsBus.$emit('Comment::New', {
	          contact: this.contact,
	          template: this.task.template
	        });
	      } else if (this.open_anyway) {
	        return EventsBus.$emit('Comment::New', {
	          contact: this.contact,
	          template: null
	        });
	      }
	    },
	    editComment: function(comment) {
	      return EventsBus.$emit('Comment::Edit', {
	        comment: comment,
	        contact: this.contact
	      });
	    },
	    openTagsModal: function() {
	      return EventsBus.$emit('open-tag-picker-modal', this.contact);
	    },
	    removeTag: function(data) {
	      var params;
	      params = {
	        id: this.contact.id,
	        contact_tags_attributes: [
	          {
	            id: data.taggable_tag_id,
	            _destroy: true
	          }
	        ]
	      };
	      return this.contact_resources.update(this.removeTagSuccess(data), this.unknownError, params);
	    },
	    removeTagSuccess: function(data) {
	      return (function(_this) {
	        return function(response) {
	          alertify.success('Tag removida com sucesso!');
	          return EventsBus.$emit('update-tags', data);
	        };
	      })(this);
	    },
	    updateTags: function(data) {
	      return this.contact.tags = this.contact.tags.filter(function(tag) {
	        return tag.taggable_tag_id !== data.taggable_tag_id;
	      });
	    },
	    updateContact: function(contact) {
	      return this.contact = contact;
	    },
	    openDialer: function(number, number_type, task) {
	      var data;
	      event.originalEventName = 'open-dialer';
	      data = {
	        contact: this.contact,
	        task: null,
	        number: number,
	        number_type: number_type
	      };
	      return EventsBus.$emit('open-dialer', data);
	    },
	    seeMoreComment: function(comment) {
	      if (this.show_full_comments[comment.id]) {
	        return Vue.set(this.show_full_comments, comment.id.toString(), !this.show_full_comments[comment.id.toString()]);
	      } else {
	        return Vue.set(this.show_full_comments, comment.id.toString(), true);
	      }
	    },
	    toggle: function(data) {
	      var contact_id;
	      if (data.contact_id) {
	        contact_id = data.contact_id;
	        this.task = data.task;
	      } else {
	        contact_id = data;
	      }
	      if (contact_id === this.contact.id) {
	        return this.close(contact_id);
	      } else {
	        this.open(contact_id);
	        if (data.open_comment) {
	          return this.newComment();
	        }
	      }
	    },
	    open: function(contact_id) {
	      this.loading = true;
	      this.loadContact(contact_id);
	      this.is_bar_minimized = false;
	      this.all_comments = false;
	      this.show_full_comments = {};
	      return this.show_sidebar = true;
	    },
	    close: function(contact_id) {
	      if (!((contact_id && contact_id === this.contact.id) || !contact_id)) {
	        return;
	      }
	      this.contact = new Contact;
	      return this.show_sidebar = false;
	    },
	    reload: function(contact_id) {
	      if (this.show_sidebar) {
	        return this.open(contact_id);
	      }
	    },
	    minimize: function() {
	      return this.is_bar_minimized = true;
	    },
	    showAllComments: function() {
	      return this.all_comments = !this.all_comments;
	    },
	    restore: function() {
	      return this.is_bar_minimized = false;
	    },
	    shortDescription: function(content) {
	      var result;
	      result = this.strippedContent(content);
	      if (result !== null && result.length > this.description_num_of_char) {
	        return result.substring(0, this.description_num_of_char) + '...';
	      } else {
	        if (result.length > 0) {
	          return result;
	        } else {
	          return '[imagem]';
	        }
	      }
	    },
	    strippedContent: function(content) {
	      var regex, result;
	      regex = /(<([^>]+)>)/ig;
	      result = content.replace(/<\/p><p>/gm, "&nbsp;");
	      result = result.replace(regex, "");
	      return result.replace(/&nbsp;/gi, ' ');
	    },
	    loadContact: function(contact_id) {
	      this.loading = true;
	      return this.contact_resources.summary(this.loadContactSuccess, this.unknownError, {
	        id: contact_id
	      });
	    },
	    loadContactSuccess: function(data) {
	      this.contact = data.contact;
	      this.loading = false;
	      return EventsBus.$emit('reload-contact', this.contact);
	    },
	    flowActionDescription: function(interaction) {
	      var description;
	      description = (interaction.step + 1) + "/" + this.contact.flow.actions_count + " " + interaction.template_name;
	      if (description.length > 33) {
	        return description.substring(0, 30) + '...';
	      } else {
	        return description;
	      }
	    },
	    templateDescription: function(name) {
	      if (name.length > 33) {
	        return name.substring(0, 30) + '...';
	      } else {
	        return name;
	      }
	    },
	    removeComment: function(comment) {
	      return this.contact.comments.remove(comment.id);
	    },
	    updateComments: function(comment) {
	      this.contact.comments.remove(comment.id);
	      return this.contact.comments.unshift(comment);
	    },
	    absoluteUrl: function(url) {
	      var fixed_url, reg;
	      fixed_url = url;
	      reg = /^((http|https|ftp):\/\/)/;
	      if (!reg.test(url)) {
	        fixed_url = "http://" + url;
	      }
	      return fixed_url;
	    },
	    updateLoading: function(loading) {
	      if (loading) {
	        return Loader.on();
	      } else {
	        return Loader.off();
	      }
	    }
	  },
	  computed: {
	    linkedin_user_name: function() {
	      var regex, result;
	      regex = /(?:https?:\/\/)?(?:www.)?linkedin.com\/in\/([0-9A-z-]+)[\/?\s$]?/;
	      result = regex.exec(this.contact.linkedin);
	      if (result) {
	        return result[1];
	      } else {
	        if (this.contact.linkedin) {
	          return this.contact.linkedin.substring(0, 30) + '...';
	        }
	      }
	    },
	    comments: function() {
	      var comment, i, len, ref, result;
	      result = [];
	      if (this.contact.comments) {
	        ref = this.contact.comments;
	        for (i = 0, len = ref.length; i < len; i++) {
	          comment = ref[i];
	          result.push(comment);
	          if (!this.all_comments) {
	            return result;
	          }
	        }
	      }
	      return result;
	    },
	    interactions_count: function() {
	      var interactions;
	      interactions = this.contact.interactions_with_current_flow;
	      if (!(interactions && !(interactions instanceof Array))) {
	        return {
	          open: "-",
	          delivery: "-"
	        };
	      }
	      return {
	        open: interactions.total_open || "-",
	        delivery: interactions.total_delivery || "-"
	      };
	    },
	    step_description: function() {
	      var signature;
	      if (!(this.contact.recipient.human_last_flow_action_taken && this.contact.flow.actions.length > 0)) {
	        return "Não iniciado";
	      }
	      signature = this.contact.flow.actions[this.contact.recipient.last_flow_action_taken].signature;
	      return this.action_human_signature[signature];
	    },
	    flow_current_step_text: function() {
	      var current_step;
	      if (!this.contact.flow) {
	        return "-";
	      }
	      current_step = this.contact.recipient.human_last_flow_action_taken || 0;
	      return current_step + "/" + this.contact.flow.actions_count + " - " + (this.step_description.toUpperCase());
	    },
	    subheader: function() {
	      var ref, ref1;
	      if (!(this.contact.position || ((ref = this.contact.business) != null ? ref.name : void 0))) {
	        return "-";
	      }
	      if (!((ref1 = this.contact.business) != null ? ref1.name : void 0)) {
	        return this.contact.position;
	      }
	      if (!this.contact.position) {
	        return this.contact.business.name;
	      }
	      return this.contact.business.name + " - " + this.contact.position;
	    },
	    has_open_interactions: function() {
	      var interactions;
	      interactions = this.contact.interactions_with_current_flow;
	      return interactions && !(interactions instanceof Array) && this.contact.interactions_with_current_flow.total_open > 0;
	    },
	    has_business: function() {
	      var ref;
	      return ((ref = this.contact.business) != null ? ref.id : void 0) !== null;
	    },
	    business_subheader: function() {
	      if (!this.has_business) {
	        return '';
	      }
	      return this.contact.business.name;
	    },
	    position_subheader: function() {
	      if (this.has_business) {
	        if (this.contact.position !== null) {
	          return ' - ' + this.contact.position;
	        } else {
	          return '';
	        }
	      } else {
	        if (this.contact.position !== null) {
	          return this.contact.position;
	        } else {
	          return '-';
	        }
	      }
	    }
	  },
	  created: function() {
	    this.contact_resources = new ContactsResource(Session.current_company.id);
	    this.task_resources = new TasksResource;
	    EventsBus.$on('toggle-task-bar', this.toggle);
	    EventsBus.$on('reload-task-bar', this.reload);
	    EventsBus.$on('close-task-bar', this.close);
	    EventsBus.$on('update-contact', this.updateContact);
	    EventsBus.$on('update-tags', this.updateTags);
	    EventsBus.$on('Comment::Destroyed', this.removeComment);
	    return EventsBus.$on('Comment::CreatedUpdated', this.updateComments);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('toggle-task-bar', this.toggle);
	    EventsBus.$off('reload-task-bar', this.reload);
	    EventsBus.$off('close-task-bar', this.close);
	    EventsBus.$off('update-contact', this.updateContact);
	    EventsBus.$off('update-tags', this.updateTags);
	    EventsBus.$off('Comment::Destroyed', this.removeComment);
	    return EventsBus.$off('Comment::CreatedUpdated', this.updateComments);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes, helpers.filters);


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  props: ['prop_tooltip_placement'],
	  components: {
	    taskList: __webpack_require__(61),
	    taskModalForm: __webpack_require__(17),
	    meetingModal: __webpack_require__(71)
	  },
	  data: function() {
	    return {
	      contact: null,
	      tasks: [],
	      filters: {
	        filter_by_contact_id: this.$route.params.id,
	        done_at_null: true
	      },
	      task_item_options: {
	        show_date: true,
	        icon_position: 'item',
	        show_contact: false,
	        padding: 'sm',
	        width: 'full-width'
	      },
	      show_meeting_modal: false
	    };
	  },
	  methods: {
	    reloadTasks: function() {
	      return this.$refs.task_list.reloadTasks();
	    },
	    updateMetadata: function(task) {
	      var old_task;
	      if (task.isDone()) {
	        return;
	      }
	      old_task = this.tasks.find(task.id);
	      if (old_task) {
	        old_task.metadata = task.metadata;
	        old_task.due_on = task.due_on;
	        return this.tasks.replaceById(old_task);
	      }
	    },
	    contactLoaded: function(data) {
	      return this.contact = data.contact;
	    },
	    taskCreated: function(data) {
	      this.$refs.task_list.addTask(data.task);
	      return alertify.success('Tarefa adicionada com sucesso!');
	    },
	    removeTask: function(data) {
	      this.$refs.task_list.removeTask(data.task);
	      this.$emit('task-destroyed', data);
	      return alertify.success('Tarefa excluída com sucesso!');
	    },
	    eventTaskUndone: function(task) {
	      return this.$refs.task_list.addTask(task);
	    },
	    editTask: function(data) {
	      return this.openModalForm(data.task.id);
	    },
	    newTask: function() {
	      return this.openModalForm();
	    },
	    openModalForm: function(task_id) {
	      return EventsBus.$emit('TaskModalForm::Show', {
	        task_id: task_id,
	        contact: null,
	        id: 'manual-task-form-modal'
	      });
	    },
	    taskSort: function(task_1, task_2) {
	      var task_1_done, task_2_done;
	      task_1_done = task_1.isDone();
	      task_2_done = task_2.isDone();
	      if ((task_1_done && task_2_done) || (!task_1_done && !task_2_done)) {
	        return task_1.due_on.isAfter(task_2.due_on) && 1 || -1;
	      } else if (task_1_done) {
	        return 1;
	      } else if (task_2_done) {
	        return -1;
	      }
	    },
	    openMeetingModal: function(data) {
	      this.selected_task = data.task;
	      return this.show_meeting_modal = true;
	    },
	    closeMeetingModal: function() {
	      this.selected_task = new Task;
	      return this.show_meeting_modal = false;
	    }
	  },
	  mounted: function() {
	    EventsBus.$on('contact-loaded', this.contactLoaded);
	    EventsBus.$on('Task::Created', this.taskCreated);
	    EventsBus.$on('Task::New', this.newTask);
	    EventsBus.$on('Task::EventUndone', this.eventTaskUndone);
	    EventsBus.$on('Task::UpdatedMetadata', this.updateMetadata);
	    return EventsBus.$on('meeting-modal-show', this.openMeetingModal);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('contact-loaded', this.contactLoaded);
	    EventsBus.$off('Task::Created', this.taskCreated);
	    EventsBus.$off('Task::New', this.newTask);
	    EventsBus.$off('Task::EventUndone', this.eventTaskUndone);
	    EventsBus.$off('Task::UpdatedMetadata', this.updateMetadata);
	    return EventsBus.$off('meeting-modal-show', this.openMeetingModal);
	  }
	};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['contact'],
	  data: function() {
	    return {
	      users: [],
	      user_options: [],
	      selected_user: {},
	      current_user: Session.current_user,
	      current_company: Session.current_company
	    };
	  },
	  methods: {
	    showUserOption: function(user) {
	      if (this.current_user.isManager() || this.current_user.isAdmin() || (this.current_company.account_setting.seller_can_change_responsability && user.id === this.current_user.id)) {
	        return true;
	      } else if (this.contact.user_id === this.current_user.id) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    loadUsers: function() {
	      return new UsersResource().index(this.loadUsersSuccess, this.unknownError);
	    },
	    loadUsersSuccess: function(data) {
	      var users;
	      users = data.users;
	      if (this.contact.user_id) {
	        users.remove(this.contact.user_id);
	      }
	      return this.users = users;
	    },
	    openUpdateContactUserConfirmationModal: function(user) {
	      this.selected_user = user;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-update-contact-user'
	      });
	    },
	    canUpdateContactUser: function() {
	      return !this.contact.active_on_flow && this.isAllowedToUpdateContactUser();
	    },
	    isAllowedToUpdateContactUser: function() {
	      return Session.current_user.isAdmin() || Session.current_user.isManager() || Session.current_user.id === this.contact.user_id || (Session.current_user.isSeller() && Session.current_company.account_setting.seller_can_change_responsability);
	    },
	    validateUpdateContactUser: function() {
	      var errors;
	      errors = [];
	      if (!this.isAllowedToUpdateContactUser()) {
	        errors.push('- Você não tem permissão para alterar o responsável desse contato');
	      }
	      if (this.contact.active_on_flow) {
	        errors.push('- O contato deve estar inativo, finalizado ou conectado para alterar seu responsável');
	      }
	      if (errors.length) {
	        return alertify.alert(errors.join('<br>'));
	      } else {
	        return this.updateUsersOptions();
	      }
	    },
	    updateUsersOptions: function() {
	      var i, len, ref, results, user;
	      this.user_options = [];
	      ref = this.users;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        user = ref[i];
	        if (user.id !== this.contact.user_id) {
	          results.push(this.user_options.push(user));
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    updateContactUser: function() {
	      return this.$emit('update-contact', {
	        user_id: this.selected_user.id
	      });
	    }
	  },
	  created: function() {
	    return this.loadUsers();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  components: {
	    list: __webpack_require__(125),
	    newCustomFieldsModal: __webpack_require__(56)
	  },
	  data: function() {
	    return {
	      edit_custom_field: new CustomField()
	    };
	  },
	  methods: {
	    customFieldCreated: function(custom_field) {
	      return this.$refs.list.addCustomField(custom_field);
	    },
	    showCreateModal: function() {
	      this.edit_custom_field = new CustomField();
	      return this.openModal();
	    },
	    openModal: function() {
	      return jQuery("#new-custom-fields-modal").modal('show');
	    },
	    closeCreateModal: function() {
	      this.edit_custom_field = new CustomField();
	      return jQuery("#new-custom-fields-modal").modal('hide');
	    },
	    edit: function(custom_field) {
	      return new CustomFieldsResource().get(this.loadCustomFieldSuccess, null, {
	        id: custom_field.id
	      });
	    },
	    loadCustomFieldSuccess: function(data) {
	      this.edit_custom_field = data.custom_field;
	      return this.openModal();
	    },
	    created: function(custom_field) {
	      this.closeCreateModal();
	      return this.$refs.list.addCustomField(custom_field);
	    },
	    updated: function(custom_field) {
	      this.closeCreateModal();
	      return this.$refs.list.customFieldUpdated(custom_field);
	    }
	  }
	};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  components: {
	    listItem: __webpack_require__(126)
	  },
	  props: ['options', 'list_item_options'],
	  data: function() {
	    return {
	      custom_fields: [],
	      selected_custom_field: {},
	      loading: false
	    };
	  },
	  methods: {
	    loadCustomFields: function() {
	      var filters, ref;
	      filters = ((ref = this.options) != null ? ref.filters : void 0) || {};
	      this.custom_fields = this.defaultFields();
	      this.loading = true;
	      return new CustomFieldsResource().index(this.loadCustomFieldsSuccess, null, {
	        params: {
	          q: filters
	        }
	      });
	    },
	    loadCustomFieldsSuccess: function(data) {
	      this.loading = false;
	      return this.custom_fields = this.custom_fields.concat(data.custom_fields);
	    },
	    openDestroyConfirmationModal: function(custom_field) {
	      this.selected_custom_field = custom_field;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-destroy-custom-field'
	      });
	    },
	    destroyCustomField: function() {
	      Loader.on();
	      return new CustomFieldsResource().destroy(this.successDestroyCustomField, this.unknownError, {
	        id: this.selected_custom_field.id
	      });
	    },
	    successDestroyCustomField: function() {
	      Loader.off();
	      this.custom_fields.remove(this.selected_custom_field.id);
	      return alertify.success('Campo personalizado excluído com sucesso');
	    },
	    customFieldUpdated: function(custom_field) {
	      return this.custom_fields.replaceById(custom_field);
	    },
	    addCustomField: function(custom_field) {
	      return this.custom_fields.push(custom_field);
	    },
	    edit: function(custom_field) {
	      return this.$emit('edit', custom_field);
	    },
	    defaultFields: function() {
	      return [
	        {
	          field: 'Nome',
	          kind: 'input',
	          editabled: false
	        }, {
	          field: 'Sobrenome',
	          kind: 'input',
	          editabled: false
	        }, {
	          field: 'E-mail',
	          kind: 'email',
	          editabled: false
	        }, {
	          field: 'Empresa',
	          kind: 'input',
	          editabled: false
	        }, {
	          field: 'Telefone',
	          kind: 'telephone',
	          editabled: false
	        }, {
	          field: 'Celular',
	          kind: 'telephone',
	          editabled: false
	        }
	      ];
	    }
	  },
	  created: function() {
	    return this.loadCustomFields();
	  }
	};


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  props: ['custom_field'],
	  mixins: [__webpack_require__(232)],
	  data: function() {
	    return {
	      field: this.custom_field.field
	    };
	  },
	  computed: {
	    editabled: function() {
	      return this.custom_field.editabled == null;
	    }
	  },
	  methods: {
	    edit: function() {
	      return this.$emit('edit', Object.assign({}, this.custom_field));
	    },
	    destroyCustomField: function() {
	      return this.$emit('destroy', this.custom_field);
	    }
	  }
	};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    draggable: __webpack_require__(27)
	  },
	  props: ['edit_custom_field'],
	  data: function() {
	    return {
	      custom_field: this.edit_custom_field || new CustomField(),
	      pristine: true,
	      kinds: [
	        {
	          value: 'input',
	          label: 'Texto'
	        }, {
	          value: 'textarea',
	          label: 'Múltiplas Linhas'
	        }, {
	          value: 'telephone',
	          label: 'Telefone'
	        }, {
	          value: 'date',
	          label: 'Data'
	        }, {
	          value: 'email',
	          label: 'E-mail'
	        }, {
	          value: 'dropdown',
	          label: 'Múltipla Escolha'
	        }
	      ],
	      option_deleted: false,
	      dont_replace: true,
	      replace_option: false,
	      new_value: ''
	    };
	  },
	  watch: {
	    edit_custom_field: {
	      handler: function(custom_field) {
	        return this.custom_field = custom_field;
	      },
	      deep: true
	    }
	  },
	  computed: {
	    to_updated: function() {
	      return this.custom_field.id != null;
	    },
	    label_button: function() {
	      if (this.to_updated) {
	        return 'Atualizar';
	      } else {
	        return 'Criar';
	      }
	    },
	    draggable_options: function() {
	      return {
	        disabled: false,
	        filter: '.undraggable'
	      };
	    },
	    title_modal: function() {
	      if (this.custom_field.id) {
	        return 'Editar propriedade';
	      }
	      return 'Criar nova propriedade';
	    },
	    valid_options: function() {
	      return this.custom_field.options.filter(function(option) {
	        return !option.deleted;
	      });
	    }
	  },
	  methods: {
	    close: function() {
	      this.resetOptions();
	      return this.$emit('close-create-modal');
	    },
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          return _this.create();
	        };
	      })(this));
	    },
	    create: function() {
	      var params;
	      Loader.on();
	      if (this.to_updated) {
	        params = this.custom_field;
	        params.option_deleted = this.option_deleted;
	        params.replace_option = this.replace_option;
	        params.new_value = this.new_value;
	        return new CustomFieldsResource().update(this.createCustomFieldSuccess, this.handleApiErrors, params);
	      } else {
	        return new CustomFieldsResource().create(this.createCustomFieldSuccess, this.handleApiErrors, this.custom_field);
	      }
	    },
	    createCustomFieldSuccess: function(data) {
	      this.resetOptions();
	      if (this.to_updated) {
	        this.$emit('custom-field-updated', data.custom_field);
	      } else {
	        this.$emit('custom-field-created', data.custom_field);
	      }
	      Loader.off();
	      alertify.success('Salvo com sucesso');
	      return this.custom_field = new CustomField();
	    },
	    resetOptions: function() {
	      this.option_deleted = false;
	      this.dont_replace = true;
	      this.replace_option = false;
	      return this.new_value = '';
	    },
	    addOption: function() {
	      return this.custom_field.options.push({
	        order: this.custom_field.options.length,
	        name: ''
	      });
	    },
	    priorityUpdated: function(options) {
	      return this.custom_field.options = options;
	    },
	    remove: function(option) {
	      var new_options;
	      if (this.custom_field.id) {
	        option.deleted = true;
	        option.name += ' - Campo Excluído';
	        return this.option_deleted = true;
	      } else {
	        new_options = this.custom_field.options.filter(function(opt) {
	          return opt.order !== option.order;
	        });
	        return this.custom_field.options = new_options.map(function(opt, index) {
	          return {
	            order: index,
	            name: opt.name
	          };
	        });
	      }
	    },
	    checkboxDontReplace: function() {
	      this.replace_option = this.dont_replace;
	      return this.dont_replace = !this.dont_replace;
	    },
	    checkboxReplaceOption: function() {
	      this.dont_replace = this.replace_option;
	      return this.replace_option = !this.replace_option;
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, summernote;
	
	helpers = __webpack_require__(2);
	
	summernote = __webpack_require__(78);
	
	module.exports = {
	  data: function() {
	    return {
	      showSummernote: false,
	      description_num_of_char: 210
	    };
	  },
	  props: ['event', 'contact'],
	  methods: {
	    toogleSummernote: function() {
	      return this.showSummernote = !this.showSummernote;
	    },
	    inializeSummernote: function() {
	      this.$comment = jQuery('#' + this.element_id);
	      return summernote(this.$comment);
	    },
	    removeComment: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-remove-comment' + this.event.id
	      });
	    },
	    confirmRemoveComment: function() {
	      var params;
	      params = {
	        id: this.event.id
	      };
	      return this.comment_events_resource.destroy(this.destroySuccess, this.unknownError, params);
	    },
	    destroySuccess: function() {
	      alertify.success('Comentário excluído com sucesso!');
	      return this.$emit('event-destroyed', this.event);
	    },
	    updateComment: function() {
	      var comment_text, params;
	      comment_text = this.$comment.summernote('code');
	      if (comment_text.length === 0 || comment_text === '&nbsp;') {
	        alertify.error('Não é possível inserir um comentário sem conteúdo');
	        return;
	      }
	      Loader.on();
	      params = {
	        id: this.event.id,
	        author: this.event.author,
	        edition_author: Session.current_user.name,
	        comment: comment_text
	      };
	      this.comment_events_resource.update(this.updateSuccess, this.unknownError, params);
	      return this.showSummernote = !this.showSummernote;
	    },
	    updateSuccess: function(data) {
	      Loader.off();
	      alertify.success('O comentário foi atualizado com sucesso!');
	      return this.$emit('event-updated', data.event);
	    },
	    setSummernoteCode: function() {
	      if (this.event.comment) {
	        return this.$comment.summernote('code', this.event.comment);
	      }
	    },
	    treatSummernote: function() {
	      this.inializeSummernote();
	      return this.setSummernoteCode();
	    },
	    initializeEditor: function() {
	      this.treatSummernote();
	      jQuery('[data-toggle="tooltip"]').tooltip('destroy');
	      return jQuery('[data-toggle="tooltip"]').tooltip();
	    }
	  },
	  computed: {
	    modal_id: function() {
	      return 'confirm-remove-comment' + this.event.id;
	    },
	    description: function() {
	      return this.event.comment;
	    },
	    element_id: function() {
	      return 'comment' + this.event.id;
	    },
	    has_edition: function() {
	      return this.event.created_at < this.event.updated_at;
	    },
	    short_description: function() {
	      if (this.stripped_content !== null && this.stripped_content.length > this.description_num_of_char) {
	        return this.stripped_content.substring(0, this.description_num_of_char) + '...';
	      } else {
	        if (this.stripped_content.length > 0) {
	          return this.stripped_content;
	        } else {
	          return '[imagem]';
	        }
	      }
	    },
	    stripped_content: function() {
	      var content, regex;
	      regex = /(<([^>]+)>)/ig;
	      content = this.description.replace(regex, "");
	      return content.replace(/&nbsp;/gi, '');
	    },
	    comment_events_resource: function() {
	      return new CommentEventsResource(this.contact.id);
	    },
	    user_can_edit: function() {
	      return Session.current_user.id === this.contact.user_id || (Session.current_user.isAdmin() || Session.current_user.isManager());
	    }
	  },
	  updated: function() {
	    return this.initializeEditor();
	  },
	  mounted: function() {
	    return this.initializeEditor();
	  }
	};


/***/ }),
/* 440 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event', 'contact'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      email_value: Session.current_user.email
	    };
	  },
	  methods: {
	    remove_opening_register_pixel: function(text) {
	      var result;
	      result = text.replace(/<img[^>]*src="https:\/\/api.nylas.com[^>]*>/g, '');
	      result = result.replace(/(<base \D*">)/g, '');
	      result = result.replace(/<img[^>]*https\:\/\/nyl.as[^>]*>/g, '');
	      result = result.replace(/<img[^>]*src="http:\/\/post.spmailtechn.com\/q[^>]*>/g, '');
	      result = result.replace(/<img[^>]*src="https:\/\/t.nylas.com\/open[^>]*>/g, '');
	      return result;
	    },
	    resendEmail: function() {
	      return new ContactEventsResource().resendEmail(this.resendEmailSuccess, this.unknownError, {
	        event: this.event,
	        email: this.email_value
	      });
	    },
	    resendEmailSuccess: function() {
	      alertify.success("Email reenviado com sucesso!");
	      return this.event.showEmail = false;
	    },
	    iconClass: function() {
	      var icon;
	      switch (this.event.type()) {
	        case 'ContactCreatedEvent':
	          return 'plus-icon';
	        case 'CreateContactEvent':
	          switch (this.event.description) {
	            case 'reev':
	              return 'plus-icon';
	            case 'pipedrive':
	              return 'pipedrive-icon';
	            case 'rdstation':
	              return 'rdstation-icon';
	            case 'sharpspring':
	              return 'sharpspring-icon';
	            case 'leadlovers':
	              return 'leadlovers-icon';
	            case 'hubspot':
	              return 'hs-icon';
	            default:
	              return 'plus-icon';
	          }
	          break;
	        case 'UpdateContactEvent':
	          switch (this.event.description) {
	            case 'reev':
	              return 'plus-icon';
	            case 'pipedrive':
	              return 'pipedrive-icon';
	            case 'rdstation':
	              return 'rdstation-icon';
	            case 'sharpspring':
	              return 'sharpspring-icon';
	            case 'leadlovers':
	              return 'leadlovers-icon';
	            case 'hubspot':
	              return 'hs-icon';
	            default:
	              return 'plus-icon';
	          }
	          break;
	        case 'ContactAddedToFlowEvent':
	          return 'added-to-flow-icon';
	        case 'CallEvent':
	          return 'task-icon phonecall-task-icon';
	        case 'EmailEvent':
	          return this.event.emailIconClasses();
	        case 'RecipientStatusChangedEvent':
	          return "status-icon contact-event-subicon " + (this.statusSubiconClass(this.event.detail()));
	        case 'ContactStageChangedEvent':
	          icon = this.event.detail() === 'lost' ? 'stage-lost-icon' : 'stage-default-icon';
	          return "stage-icon " + icon;
	        case 'ContactRemovedFromFlowEvent':
	          return "removed-from-flow-icon";
	      }
	    },
	    statusSubiconClass: function(detail) {
	      return detail + "-icon";
	    },
	    canResendEmail: function() {
	      if (this.current_user.email_service_requires_authorization) {
	        return false;
	      }
	      return this.current_user.isAdmin() || (this.current_user.id === this.contact.user_id);
	    },
	    canViewEmail: function() {
	      return this.current_user.isAdmin() || this.current_user.isManager() || (this.current_user.id === this.contact.user_id);
	    }
	  }
	};


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    filters: {
	      "default": function() {
	        return {};
	      }
	    }
	  },
	  data: function() {
	    return {
	      period_filter: {},
	      manual_task_service_filter: this.extractFilter('manual_task_service_eq'),
	      manual_task_service_options: [
	        {
	          value: null,
	          text: 'Todos os eventos'
	        }, {
	          value: {
	            manual_task_service_eq: 'ManualTasksServices::Email'
	          },
	          text: 'Email'
	        }, {
	          value: {
	            manual_task_service_eq: 'ManualTasksServices::Phonecall'
	          },
	          text: 'Ligação'
	        }, {
	          value: {
	            manual_task_service_eq: 'ManualTasksServices::Linkedin'
	          },
	          text: 'Linkedin/Social'
	        }
	      ]
	    };
	  },
	  computed: {
	    filterParams: function() {
	      var filter, filter_params, i, len, ref;
	      filter_params = {};
	      ref = [this.manual_task_service_filter, this.period_filter];
	      for (i = 0, len = ref.length; i < len; i++) {
	        filter = ref[i];
	        if (filter) {
	          Object.assign(filter_params, filter);
	        }
	      }
	      return filter_params;
	    }
	  },
	  methods: {
	    filter: function() {
	      return this.$emit('filter', this.filterParams);
	    },
	    dateChanged: function(data) {
	      this.updateDateFilter('created_at_gteq', data.from);
	      this.updateDateFilter('created_at_lteq', data.to);
	      return this.filter();
	    },
	    updateDateFilter: function(key, value) {
	      if (value) {
	        return Vue.set(this.period_filter, key, JSON.stringify(value));
	      } else {
	        return Vue["delete"](this.period_filter, key);
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.filters);


/***/ }),
/* 442 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event']
	};


/***/ }),
/* 443 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event']
	};


/***/ }),
/* 444 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      element_id: this.event.task.id,
	      undone_at: null,
	      tooltip_text: this.event.task.comment
	    };
	  },
	  computed: {
	    icon_class: function() {
	      switch (this.event.task.service.split('::')[1]) {
	        case 'Phonecall':
	          return 'task-icon phonecall-task-icon';
	        case 'Email':
	          return 'task-icon email-task-icon';
	        case 'Linkedin':
	          return 'task-icon linkedin-task-icon';
	        case 'Meeting':
	          return 'calendar-task-icon';
	      }
	    },
	    enable_undo: function() {
	      return !this.undone_at && this.event.task.canBeUndone() && this.user_can_manage;
	    },
	    user_can_manage: function() {
	      if (this.current_user.isSeller() && this.current_user.id !== this.event.task.assigned_to_id) {
	        return false;
	      }
	      return !this.current_user.isMonitoringManager();
	    }
	  },
	  methods: {
	    undo: function() {
	      return this.tasks_resources.save(this.undoSuccess, this.unknownError, {
	        id: this.event.task.id,
	        done_at: null
	      });
	    },
	    undoSuccess: function(data) {
	      var task;
	      alertify.success('Tarefa atualizada com sucesso');
	      this.event.task.done_at = null;
	      this.undone_at = moment();
	      task = new Task(data.task);
	      task.contact = data.task.contact;
	      return EventsBus.$emit('Task::EventUndone', task);
	    }
	  },
	  watch: {
	    task: function(new_value, old_value) {
	      return this.$refs.element_id.setAttribute('data-original-title', new_value.comment);
	    }
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  },
	  created: function() {
	    this.tasks_resources = new TasksResource();
	    if (this.event.description) {
	      return this.undone_at = moment(this.event.description);
	    }
	  }
	};


/***/ }),
/* 445 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event']
	};


/***/ }),
/* 446 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event']
	};


/***/ }),
/* 447 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event']
	};


/***/ }),
/* 448 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event']
	};


/***/ }),
/* 449 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event', 'contact'],
	  data: function() {
	    return {
	      current_user: Session.current_user
	    };
	  }
	};


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    actionListItem: __webpack_require__(139)
	  },
	  props: ['actions']
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['action'],
	  data: function() {
	    var ref;
	    return {
	      qualification_statistics: (ref = this.action.recipients_statistics) != null ? ref.by_qualification : void 0,
	      row_hovered: false
	    };
	  },
	  computed: {
	    preview_id: function() {
	      return "preview_" + this.action.id;
	    },
	    data_target_id: function() {
	      return "#" + this.preview_id;
	    },
	    cursor: function() {
	      if (this.has_template) {
	        return 'pointer';
	      } else {
	        return '';
	      }
	    },
	    has_template: function() {
	      return this.action.template_id != null;
	    },
	    label_by_template_kind: function() {
	      var ref;
	      switch ((ref = this.action.template) != null ? ref.kind : void 0) {
	        case 'linkedin':
	        case 'phonecall':
	        case 'social':
	          return this.$t('flows.attributes.name');
	        case 'email':
	          return this.$t('flows.attributes.subject');
	        default:
	          return '';
	      }
	    },
	    value_by_template_kind: function() {
	      var ref;
	      switch ((ref = this.action.template) != null ? ref.kind : void 0) {
	        case 'linkedin':
	        case 'phonecall':
	        case 'social':
	          return this.action.template.name;
	        case 'email':
	          return this.action.template.subject;
	        default:
	          return '';
	      }
	    },
	    recipients_statistics_conversion: function() {
	      var percentage;
	      if (!this.action.recipients_statistics.by_qualification) {
	        return '--';
	      }
	      percentage = (this.action.recipients_statistics.by_qualification.conversion.value * 100.0).toFixed(1);
	      return percentage.replace('.', ',') + '%';
	    },
	    action_legend: function() {
	      var atLabel, stepAfterFlow, stepAfterStep, stepDefinedTime, stepImmediately, stepUndefinedTime, text;
	      text = this.$t('flows.label.stepLabel', {
	        step: this.action.human_step
	      });
	      text += ' - ';
	      if (this.action.immediately) {
	        stepImmediately = this.$t('flows.label.stepImmediately');
	        text += stepImmediately;
	      } else if (!this.action.delay_after_previous_step_unit) {
	        if (this.action.undefined_time) {
	          stepUndefinedTime = this.$t('flows.label.stepUndefinedTime');
	          text += stepUndefinedTime;
	        } else {
	          stepDefinedTime = this.$t('flows.label.stepDefinedTime', {
	            time: this.action.humanSendAt()
	          });
	          text += stepDefinedTime;
	        }
	      } else {
	        if (this.action.is_first) {
	          stepAfterFlow = this.$t('flows.label.stepAfterFlow', {
	            time: this.action.humanDelay()
	          });
	          text += stepAfterFlow;
	        } else {
	          stepAfterStep = this.$t('flows.label.stepAfterStep', {
	            time: this.action.humanDelay(),
	            step: this.action.human_step - 1
	          });
	          text += stepAfterStep;
	        }
	        if (!this.action.undefined_time) {
	          atLabel = this.$t('general.label.at', {
	            time: this.action.humanSendAt()
	          });
	          text += " " + atLabel;
	        }
	      }
	      return text;
	    },
	    conversion: function() {
	      return this.qualification_statistics.connected.count + this.qualification_statistics.client.count;
	    },
	    show_conversion_statistic: function() {
	      if (!this.qualification_statistics) {
	        return false;
	      }
	      if (this.action.isEmailFlowAction() && this.action.email_statistic) {
	        return true;
	      }
	      return true;
	    },
	    total_for_conversion: function() {
	      if (this.action.isEmailFlowAction()) {
	        return this.action.email_statistic.sent;
	      } else {
	        return this.action.recipients_statistics.total.count;
	      }
	    }
	  },
	  mounted: function() {
	    return document.querySelectorAll(".list-item .preview a").forEach(function(item) {
	      return item.setAttribute("target", "_blank");
	    });
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    sendAtPicker: __webpack_require__(141),
	    typePicker: __webpack_require__(142)
	  },
	  data: function() {
	    return {
	      actions: [],
	      current_step: 0,
	      flow: new Flow,
	      templates: [],
	      template_categories: [],
	      template_variables: []
	    };
	  },
	  computed: {
	    options: function() {
	      return {
	        allow_create: true,
	        allow_blank: this.flow.semi_automatic,
	        from_flow: true,
	        disabled: this.flow.isWithError(),
	        preload: {
	          variables: this.template_variables,
	          categories: this.template_categories
	        }
	      };
	    }
	  },
	  methods: {
	    addAction: function(attributes) {
	      if (attributes == null) {
	        attributes = {};
	      }
	      attributes.type = this.flow.semi_automatic ? 'TaskFlowAction' : 'EmailFlowAction';
	      if (this.flow.semi_automatic) {
	        attributes.manual_task_parameters = {
	          service: Task.emailTaskService.service
	        };
	      }
	      attributes.step = this.current_step;
	      if (attributes.delay_after_previous_step_amount == null) {
	        attributes.delay_after_previous_step_amount = 2;
	      }
	      attributes.send_immediately = attributes.immediately;
	      this.actions.push(new FlowAction(attributes));
	      return this.current_step += 1;
	    },
	    removeAction: function(action_index) {
	      var action;
	      action = this.actions[action_index];
	      if (action.isPersisted()) {
	        if (action._destroy) {
	          return action._destroy = false;
	        } else {
	          return action._destroy = true;
	        }
	      } else {
	        return this.actions.splice(action_index, 1);
	      }
	    },
	    setActionType: function(data) {
	      var action, template;
	      action = this.actions[data.reference];
	      action.type = data.type;
	      action.send_as_reply = data.send_as_reply;
	      if ((data.template != null) && data.template.id > 0) {
	        action.template_id = data.template.id;
	        template = this.getTemplate(data.template.id);
	        if (!!template) {
	          action.template = template;
	        }
	      } else {
	        action.template_id = null;
	        action.template = data.template || {};
	      }
	      if (data.manual_task_parameters) {
	        action.manual_task_parameters = data.manual_task_parameters;
	      } else {
	        action.manual_task_parameters = null;
	      }
	      return this.flow.toggleActionTypes();
	    },
	    setActionSendAt: function(data) {
	      var action;
	      action = this.actions[data.reference];
	      action.send_at_kind = data.send_at_kind;
	      action.send_at = this.buildSendAt(data.send_at);
	      action.delay_after_previous_step_amount = data.delay_after_previous_step_amount;
	      action.delay_after_previous_step_unit = data.delay_after_previous_step_unit;
	      return action.send_immediately = data.send_at_kind === 'immediately';
	    },
	    buildSendAt: function(send_at) {
	      var parsed_send_at;
	      parsed_send_at = moment(send_at, 'HH:mm');
	      if (parsed_send_at.isValid()) {
	        return parsed_send_at.add(parsed_send_at.utcOffset(), 'minutes');
	      } else {
	        return null;
	      }
	    },
	    dismantleSendAt: function(moment_send_at) {
	      if (!(moment_send_at && moment_send_at.isValid && moment_send_at.isValid())) {
	        return null;
	      }
	      return moment_send_at.clone().subtract(moment_send_at.utcOffset(), 'minutes').format('HH:mm');
	    },
	    setFlow: function(data) {
	      this.flow = data.flow;
	      this.actions = this.flow.actions;
	      if (this.actions.length === 0) {
	        return this.addAction({
	          immediately: true
	        });
	      } else {
	        return this.updateCurrentStep();
	      }
	    },
	    updateSendAtPicker: function(data) {
	      var action;
	      if (!data.hasOwnProperty('reference')) {
	        return;
	      }
	      action = this.actions[data.reference];
	      return EventsBus.$emit('FlowSendAtPicker:Set', {
	        send_at: this.dismantleSendAt(this.actions[data.reference].send_at || null),
	        delay_after_previous_step_amount: action.delay_after_previous_step_amount,
	        delay_after_previous_step_unit: action.delay_after_previous_step_unit,
	        reference: data.reference,
	        persisted: action.isPersisted(),
	        immediately: action.immediately,
	        undefined_time: action.undefined_time
	      });
	    },
	    updateTypePicker: function(data) {
	      var action;
	      if (!data.hasOwnProperty('reference')) {
	        return;
	      }
	      action = this.actions[data.reference];
	      return EventsBus.$emit('FlowTypePicker:Set', {
	        type: action.type,
	        manual_task_parameters: action.manual_task_parameters,
	        template_id: action.template_id,
	        reference: data.reference
	      });
	    },
	    updateCurrentStep: function() {
	      return this.current_step = parseInt(Math.max.apply(null, this.actions.map(function(action) {
	        return action.step;
	      }))) + 1;
	    },
	    getTemplate: function(template_id) {
	      return this.templates.find(function(template) {
	        return template.id === template_id;
	      });
	    },
	    loadTemplates: function() {
	      var filters;
	      filters = this.mergeCurrentUserFilter({
	        s: 'name asc'
	      });
	      return new TemplatesResource(Session.current_company.id).index(this.loadTemplatesSuccess, Loader.off, {
	        params: {
	          page: 1,
	          per: '10',
	          q: filters
	        }
	      });
	    },
	    loadTemplatesSuccess: function(resources) {
	      return this.templates = resources.templates;
	    },
	    loadTemplateCategories: function() {
	      return new TemplateCategoriesResource(Session.current_company.id).index(this.templateCategoriesSuccess, null, {
	        params: {
	          q: {
	            s: 'name asc'
	          }
	        }
	      });
	    },
	    templateCategoriesSuccess: function(data) {
	      var template_category, template_category_options;
	      template_category_options = (function() {
	        var i, len, ref, results;
	        ref = data.template_categories;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          template_category = ref[i];
	          results.push({
	            value: template_category.id,
	            text: template_category.name
	          });
	        }
	        return results;
	      })();
	      template_category_options.unshift({
	        value: null,
	        text: this.$t('flows.label.categorySelect')
	      });
	      return this.template_categories = template_category_options;
	    },
	    loadVariables: function() {
	      var params;
	      params = {
	        company_id: Session.current_company.id
	      };
	      return new VariableResource().index(this.loadVariablesSuccess, null, {
	        params: params
	      });
	    },
	    loadVariablesSuccess: function(resource) {
	      return this.template_variables = resource.variables;
	    }
	  },
	  created: function() {
	    this.loadTemplates();
	    this.loadTemplateCategories();
	    this.loadVariables();
	    EventsBus.$on('flow-set', this.setFlow);
	    EventsBus.$on('FlowSendAtPicker:Created', this.updateSendAtPicker);
	    EventsBus.$on('FlowTypePicker:Created', this.updateTypePicker);
	    return EventsBus.$emit('ActionPicker:Created');
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('flow-set', this.setFlow);
	    EventsBus.$off('FlowSendAtPicker:Created', this.updateSendAtPicker);
	    return EventsBus.$off('FlowTypePicker:Created', this.updateTypePicker);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.filters);


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    reference: null,
	    allow_send_at_immediately: false,
	    action: null,
	    actions: null,
	    flow: null
	  },
	  data: function() {
	    return {
	      send_at_kind: 'after',
	      send_at: null,
	      delay_after_previous_step_amount: 1,
	      delay_after_previous_step_unit: 'days',
	      undefined_time: false,
	      persisted: false,
	      pristine: true
	    };
	  },
	  computed: {
	    show_send_at_field: function() {
	      return this.send_at_kind === "after" || this.send_at_kind === "today";
	    },
	    send_at_kind_options: function() {
	      return [
	        {
	          value: 'immediately',
	          text: this.capitalizeFirstLetter(this.$t('general.label.immediately'))
	        }, {
	          value: 'after',
	          text: this.capitalizeFirstLetter(this.$t('general.label.after'))
	        }, {
	          value: 'today',
	          text: this.capitalizeFirstLetter(this.$t('flows.options.timming.today'))
	        }
	      ];
	    },
	    delay_after_previous_step_unit_options: function() {
	      return [
	        {
	          value: 'days',
	          text: this.capitalizeFirstLetter(this.$t('general.label.days'))
	        }, {
	          value: 'weeks',
	          text: this.capitalizeFirstLetter(this.$t('general.label.weeks'))
	        }, {
	          value: 'months',
	          text: this.capitalizeFirstLetter(this.$t('general.label.months'))
	        }
	      ];
	    },
	    is_automatic_email_action: function() {
	      return this.action.type === 'EmailFlowAction' && !this.flow.semi_automatic;
	    },
	    send_at_validations: function() {
	      var previous_send_at, ref, send_at, validations;
	      validations = ['send_at'];
	      if (this.is_automatic_email_action) {
	        validations.push('required');
	      }
	      this.send_at;
	      this.actions[this.reference - 1];
	      this.delay_after_previous_step_amount;
	      if (this.send_at_kind === 'today') {
	        validations.push('today_send_at');
	      } else if ((this.send_at_kind === 'after' && parseInt(this.delay_after_previous_step_amount) === 0) && this.reference > 0) {
	        previous_send_at = this.actions[this.reference - 1].send_at_kind === 'immediately' ? (this.flow.created_at && moment(this.flow.created_at).format('HH:mm')) || moment().format('HH:mm') : (send_at = (ref = this.actions[this.reference - 1]) != null ? ref.send_at : void 0) ? (send_at = moment(send_at.format('HH:mm'), 'HH:mm'), send_at.add(-send_at.utcOffset(), 'minutes').format('HH:mm')) : void 0;
	        if (previous_send_at) {
	          previous_send_at = moment(previous_send_at, 'HH:mm');
	          if (!moment(this.send_at, 'HH:mm').isAfter(previous_send_at.add(29, 'minutes'))) {
	            validations.push('after_zero');
	          }
	        }
	      }
	      return validations.join('|');
	    }
	  },
	  methods: {
	    capitalizeFirstLetter: function(string) {
	      return helpers.masks.capitalizeFirstLetter(string);
	    },
	    validateAll: function() {
	      var key, ref, value;
	      this.errors.clear();
	      ref = this.fieldsToValidate();
	      for (key in ref) {
	        value = ref[key];
	        this.$validator.validate(key, value);
	      }
	      return EventsBus.$emit('flows-send-at-picker-errors', {
	        errors: this.errors,
	        reference: this.reference
	      });
	    },
	    publishChange: function() {
	      if (this.send_at_kind === 'immediately' || this.send_at_kind === 'today') {
	        this.delay_after_previous_step_amount = null;
	        this.delay_after_previous_step_unit = null;
	        if (this.send_at_kind === 'immediately' && !this.action.isPersisted()) {
	          this.send_at = null;
	        }
	      }
	      if (this.send_at_kind === 'after') {
	        if (this.delay_after_previous_step_unit == null) {
	          this.delay_after_previous_step_unit = 'days';
	        }
	        if (this.delay_after_previous_step_amount == null) {
	          this.delay_after_previous_step_amount = 2;
	        }
	      }
	      return this.$emit('change', {
	        send_at: this.send_at,
	        delay_after_previous_step_amount: this.delay_after_previous_step_amount,
	        delay_after_previous_step_unit: this.delay_after_previous_step_unit,
	        reference: this.reference,
	        send_at_kind: this.send_at_kind
	      });
	    },
	    revalidate: function() {
	      if (!this.pristine) {
	        return EventsBus.$emit('validate-all');
	      }
	    },
	    setSendAt: function(data) {
	      if (data.reference !== this.reference) {
	        return;
	      }
	      this.delay_after_previous_step_unit = data.delay_after_previous_step_unit;
	      this.delay_after_previous_step_amount = data.delay_after_previous_step_amount;
	      if (data.send_at && !data.undefined_time) {
	        this.send_at = data.send_at;
	      }
	      this.persisted = data.persisted;
	      this.undefined_time = data.undefined_time;
	      this.send_at_kind = data.immediately ? 'immediately' : !this.delay_after_previous_step_unit && (this.send_at || this.undefined_time) ? 'today' : 'after';
	      return this.publishChange();
	    },
	    fieldsToValidate: function() {
	      switch (this.send_at_kind) {
	        case 'after':
	          return {
	            delay_after_previous_step_amount: this.delay_after_previous_step_amount,
	            delay_after_previous_step_unit: this.delay_after_previous_step_unit,
	            send_at: this.send_at
	          };
	        case 'today':
	          return {
	            send_at: this.send_at
	          };
	        case 'immediately':
	          return {};
	      }
	    },
	    todaySendAtValidator: function() {
	      return {
	        validate: (function(_this) {
	          return function(value, args) {
	            var sent_at_time;
	            if ((value != null ? value.length : void 0) !== 5) {
	              return true;
	            }
	            sent_at_time = moment(value, 'HH:mm');
	            if (!_this.flow.human_weekdays_to_send.includes(sent_at_time.day()) && (sent_at_time.isAfter(moment().add(30, 'minutes')) || sent_at_time.isSameOrBefore(moment()))) {
	              return true;
	            }
	            return false;
	          };
	        })(this),
	        getMessage: (function(_this) {
	          return function(field, args) {
	            return _this.$t('flows.label.programaticTodaySendAction');
	          };
	        })(this)
	      };
	    },
	    afterZeroValidator: function() {
	      return {
	        validate: (function(_this) {
	          return function(value, args) {
	            return false;
	          };
	        })(this),
	        getMessage: (function(_this) {
	          return function(field, args) {
	            return _this.$t('flows.label.programaticAfterZeroAction');
	          };
	        })(this)
	      };
	    },
	    sendAtValidator: function() {
	      return {
	        validate: (function(_this) {
	          return function(value, args) {
	            var ref, sent_at_time;
	            if (((ref = _this.send_at) != null ? ref.length : void 0) !== 5) {
	              return true;
	            }
	            if (_this.send_at_kind === 'immediately') {
	              return true;
	            }
	            sent_at_time = moment(value, 'HH:mm');
	            return sent_at_time.isValid();
	          };
	        })(this),
	        getMessage: (function(_this) {
	          return function(field, args) {
	            return _this.$t('flows.label.programaticSendAtAction');
	          };
	        })(this)
	      };
	    },
	    addCustomValidators: function() {
	      this.$validator.remove('today_send_at');
	      this.$validator.extend('today_send_at', this.todaySendAtValidator());
	      this.$validator.remove('after_zero');
	      this.$validator.extend('after_zero', this.afterZeroValidator());
	      this.$validator.remove('send_at');
	      return this.$validator.extend('send_at', this.sendAtValidator());
	    }
	  },
	  watch: {
	    send_at_kind: function() {
	      return this.publishChange();
	    },
	    send_at: function() {
	      return this.publishChange();
	    },
	    delay_after_previous_step_amount: function() {
	      return this.publishChange();
	    },
	    delay_after_previous_step_unit: function() {
	      return this.publishChange();
	    }
	  },
	  created: function() {
	    this.errors.clear();
	    this.addCustomValidators();
	    EventsBus.$on('validate-all', this.validateAll);
	    EventsBus.$on('FlowSendAtPicker:Set', this.setSendAt);
	    return EventsBus.$emit('FlowSendAtPicker:Created', {
	      reference: this.reference
	    });
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('validate-all', this.validateAll);
	    return EventsBus.$off('FlowSendAtPicker:Set', this.setSendAt);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    templatePicker: __webpack_require__(221)
	  },
	  props: ['reference', 'action', 'templates', 'actions', 'flow', 'options'],
	  data: function() {
	    return {
	      action_parameters: null,
	      type: 'EmailFlowAction',
	      template: this.action.template,
	      previous_template: this.action.template,
	      previous_type: 'EmailFlowAction',
	      manual_task_parameters: null,
	      send_as_reply: this.action.send_as_reply
	    };
	  },
	  methods: {
	    templateChanged: function(data) {
	      this.template = data.template;
	      return this.emitChange();
	    },
	    emitChange: function() {
	      return this.$emit('change', {
	        type: this.type,
	        template: this.template,
	        manual_task_parameters: this.manual_task_parameters,
	        reference: this.reference,
	        send_as_reply: this.send_as_reply
	      });
	    },
	    typeChanged: function() {
	      this.type = this.action_parameters.type;
	      this.manual_task_parameters = {
	        service: this.action_parameters.service
	      };
	      if (this.is_email_flow_action) {
	        this.template = this.previous_template;
	        if (this.flow.semi_automatic) {
	          this.type = 'TaskFlowAction';
	        }
	      } else {
	        this.previous_template = this.template;
	      }
	      if (this.invalidActionTemplate()) {
	        this.action.template_id = null;
	        this.action.template = null;
	        this.template = null;
	        this.setTemplateKind();
	      }
	      return this.emitChange();
	    },
	    cancelTemplateEdit: function(data) {
	      this.action_parameters = this.previous_type;
	      this.action.template_id = data.action_template_id;
	      return this.action.template = this.previous_template;
	    },
	    invalidActionTemplate: function() {
	      var ref;
	      return this.action_parameters.service.split('::')[1].toLowerCase() !== ((ref = this.action.template) != null ? ref.kind : void 0);
	    },
	    setType: function(data) {
	      if (!(data.reference === this.reference && data.type)) {
	        return;
	      }
	      if (data.type === 'EmailFlowAction') {
	        this.action_parameters = this.action_parameters_list[0];
	      } else {
	        this.action_parameters = this.action_parameters_list.filter(function(action_parameters) {
	          return action_parameters.service === data.manual_task_parameters.service;
	        })[0];
	      }
	      return this.typeChanged();
	    },
	    toggleSendAsReply: function() {
	      if (this.disabled) {
	        return;
	      }
	      this.send_as_reply = !this.send_as_reply;
	      return this.emitChange();
	    },
	    setTemplateKind: function() {
	      if (!this.action_parameters) {
	        return this.template_kind = 'email';
	      } else {
	        return this.template_kind = this.action_parameters.service.split('::')[1].toLowerCase();
	      }
	    }
	  },
	  computed: {
	    action_parameters_list: function() {
	      return Task.availableManualTaskServices.filter(function(manual_task) {
	        return manual_task.service.toLowerCase().indexOf('meeting') === -1;
	      });
	    },
	    type_options: function() {
	      var action_parameters, human_name, i, icon_class, len, ref, results;
	      ref = this.action_parameters_list;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        action_parameters = ref[i];
	        if (action_parameters.type === 'EmailFlowAction' && this.flow.semi_automatic) {
	          human_name = action_parameters.human_name + ' manual';
	        } else {
	          human_name = action_parameters.human_name;
	        }
	        icon_class = Task.serviceIcons[action_parameters.service];
	        results.push({
	          value: action_parameters,
	          text: human_name,
	          icon_class: icon_class
	        });
	      }
	      return results;
	    },
	    hide_send_as_reply: function() {
	      var action, i, len, ref;
	      if (!this.action.isEmailFlowAction()) {
	        return true;
	      }
	      ref = this.actions;
	      for (i = 0, len = ref.length; i < len; i++) {
	        action = ref[i];
	        if (action.step < this.action.step && action.isEmailFlowAction()) {
	          return false;
	        }
	      }
	      return true;
	    },
	    is_email_flow_action: function() {
	      return this.type === 'EmailFlowAction' || this.manual_task_parameters.service === Task.emailTaskService.service;
	    },
	    template_kind: function() {
	      if (!this.action_parameters) {
	        return 'email';
	      } else {
	        return this.action_parameters.service.split('::')[1].toLowerCase();
	      }
	    }
	  },
	  created: function() {
	    EventsBus.$on('FlowTypePicker:Set', this.setType);
	    return EventsBus.$emit('FlowTypePicker:Created', {
	      reference: this.reference
	    });
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('FlowTypePicker:Set', this.setType);
	  },
	  mounted: function() {
	    if (this.action_parameters == null) {
	      this.action_parameters = this.action_parameters_list[0];
	    }
	    this.previous_type = this.action_parameters;
	    this.setTemplateKind();
	    return Tooltip.initialize();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['flow'],
	  components: {
	    reactivateRecipientModal: __webpack_require__(23)
	  },
	  data: function() {
	    return {
	      contacts: [],
	      filters: {},
	      loading: false,
	      next_page: 1,
	      schedule_reactivation_contact: null,
	      selected_contact: {}
	    };
	  },
	  methods: {
	    loadFlowContacts: function() {
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      return this.contact_resource.lastActiveOnFlow(this.loadFlowContactsSuccess, this.unknownError, {
	        flow_id: this.flow.id,
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadFlowContactsSuccess: function(resources) {
	      this.loading = false;
	      this.next_page = resources.meta.next_page;
	      this.contacts = this.contacts.concat(resources.contacts);
	      return this.contacts = this.contacts.sort(function(contact_1, contact_2) {
	        if (contact_1.recipient_priority === null) {
	          return 1;
	        }
	        if (contact_2.recipient_priority === null) {
	          return -1;
	        }
	        if (contact_1.recipient_priority > contact_2.recipient_priority) {
	          return 1;
	        } else {
	          return -1;
	        }
	      });
	    },
	    filter: function(filters) {
	      this.filters = filters;
	      this.next_page = 1;
	      this.contacts = [];
	      return this.loadFlowContacts();
	    },
	    openRemoveContactFromFlowModal: function(data) {
	      this.selected_contact = data.contact;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-remove-contact-from-flow'
	      });
	    },
	    confirmRemoveContactFromFlow: function() {
	      return this.removeContactFromFlow(this.selected_contact, this.flow);
	    },
	    openResetContactConfirmationModal: function(data) {
	      this.selected_contact = data.contact;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-reset-contact'
	      });
	    },
	    callResetContact: function() {
	      return this.resetContactRecipient(this.selected_contact);
	    },
	    reloadContacts: function() {
	      return this.filter({});
	    }
	  },
	  created: function() {
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    this.loadFlowContacts();
	    EventsBus.$on('Contact::ScheduleRecipientReactivation', this.openRecipientScheduleReactivationModal);
	    EventsBus.$on('Contact::Refresh', this.refreshContact);
	    EventsBus.$on('Show::UpdateListContactsInfo', this.updateContactList);
	    return EventsBus.$on('reload-contacts', this.reloadContacts);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('Contact::ScheduleRecipientReactivation', this.openRecipientScheduleReactivationModal);
	    EventsBus.$off('Contact::Refresh', this.refreshContact);
	    EventsBus.$off('Show::UpdateListContactsInfo', this.updateContactList);
	    return EventsBus.$off('reload-contacts', this.reloadContacts);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.contacts.list_view_modes, helpers.contacts.list_wrapper, helpers.form);


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    contactPicker: __webpack_require__(54),
	    contactManualPicker: __webpack_require__(53),
	    specificTemplatesModal: __webpack_require__(213),
	    triggers: __webpack_require__(146)
	  },
	  props: {
	    flow: {
	      "default": function() {
	        return new Flow;
	      }
	    }
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      filters: {},
	      fetching_contacts: false,
	      fetching_specific_templates: false,
	      current_contact: {},
	      selected_contacts: [],
	      new_contacts: [],
	      flow_contacts: [],
	      removed_contacts: [],
	      contacts: [],
	      contacts_with_specific_templates: [],
	      next_page: 1,
	      contacts_total_count: 0
	    };
	  },
	  computed: {
	    fetching: function() {
	      return this.fetching_contacts || this.fetching_specific_templates;
	    },
	    any_filter: function() {
	      return !!Object.keys(this.filters).length;
	    },
	    added_contacts: function() {
	      return this.selected_contacts.concat(this.new_contacts);
	    },
	    number_of_contacts: function() {
	      return this.added_contacts.length + this.contacts_total_count;
	    },
	    user_id_or_default: function() {
	      if (this.flow.user_id) {
	        return this.flow.user_id;
	      } else {
	        return Session.current_user.id;
	      }
	    }
	  },
	  watch: {
	    flow: function(new_flow) {
	      if (this.flow.isPersisted()) {
	        if (this.flow.isWithError()) {
	          return this.restoreContacts();
	        } else {
	          this.loadFlowContacts();
	          return this.loadSpecificTemplates();
	        }
	      } else {
	        return EventsBus.$emit('ContactsPicker:SetPersistedSelectedContacts', {
	          contacts: []
	        });
	      }
	    },
	    selected_contacts: function() {
	      return this.setContacts();
	    },
	    new_contacts: function() {
	      return this.setContacts();
	    },
	    flow_contacts: function() {
	      return this.setContacts();
	    },
	    contacts: function() {
	      var contact, i, index, len, ref, results;
	      if (!this.any_filter) {
	        ref = this.contacts;
	        results = [];
	        for (index = i = 0, len = ref.length; i < len; index = ++i) {
	          contact = ref[index];
	          results.push(contact.recipient_priority = index);
	        }
	        return results;
	      }
	    }
	  },
	  methods: {
	    loadFlowContacts: function() {
	      if (this.fetching_contacts || !this.next_page || !this.flow.id) {
	        return;
	      }
	      this.fetching_contacts = true;
	      return new ContactsResource(Session.current_company.id).lastActiveOnFlow(this.loadFlowContactsSuccess, this.unknownError, {
	        flow_id: this.flow.id,
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadFlowContactsSuccess: function(data) {
	      this.next_page = data.meta.next_page;
	      if (!this.any_filter) {
	        this.contacts_total_count = data.meta.total_count;
	      }
	      this.fetching_contacts = false;
	      this.flow_contacts = this.flow_contacts.concat(data.contacts);
	      return this.setContacts();
	    },
	    restoreContacts: function() {
	      var new_contacts;
	      new_contacts = [];
	      this.flow.job_status.contacts.forEach((function(_this) {
	        return function(contact_params) {
	          var contact;
	          contact = new Contact(contact_params);
	          if (contact.id !== null) {
	            return _this.selected_contacts.push(contact);
	          } else {
	            return new_contacts.push(contact);
	          }
	        };
	      })(this));
	      return EventsBus.$emit('contacts-picker-text-csv-restore', new_contacts);
	    },
	    loadSpecificTemplates: function() {
	      var resource;
	      this.fetching_specific_templates = true;
	      resource = new ContactSpecificTemplatesResource(Session.current_company.id, this.$route.params.id);
	      return resource.index(this.loadSpecificTemplatesSuccess, this.unknownError, {
	        params: {
	          limit: 'disabled'
	        }
	      });
	    },
	    loadSpecificTemplatesSuccess: function(resources) {
	      this.addPersistedSpecificTemplates(resources);
	      return this.fetching_specific_templates = false;
	    },
	    createSpecificTemplate: function(data) {
	      return new ContactSpecificTemplate({
	        id: data.id,
	        flow_action_id: data.flow_action_id,
	        contact_id: data.contact_id,
	        template_id: data.id,
	        subject: data.subject,
	        body: data.body,
	        signature: data.signature,
	        kind: data.kind
	      });
	    },
	    hasSpecificTemplate: function(contact) {
	      if (contact.id) {
	        return this.contacts_with_specific_templates.find(contact.id);
	      } else if (contact.email) {
	        return this.contacts_with_specific_templates.findByProps({
	          email: contact.email
	        });
	      }
	    },
	    updateContactsWithSpecificTemplate: function(data, has_template) {
	      var index;
	      index = data.specific_template.contact_id ? this.contacts_with_specific_templates.findIndexByProps({
	        id: data.specific_template.contact_id
	      }) : this.contacts_with_specific_templates.findIndexByProps({
	        email: data.specific_template.contact.email
	      });
	      if (has_template) {
	        if (index < 0) {
	          return this.contacts_with_specific_templates.push(data.specific_template.contact);
	        }
	      } else {
	        if (index > -1) {
	          return this.contacts_with_specific_templates.splice(index, 1);
	        }
	      }
	    },
	    groupSpecificTemplatesByAction: function(data) {
	      var self, specific_templates;
	      self = this;
	      specific_templates = {};
	      data.templates.forEach(function(template) {
	        var action_id;
	        action_id = template.flow_action_id;
	        if (!specific_templates[action_id]) {
	          specific_templates[action_id] = [];
	        }
	        specific_templates[action_id].push(self.createSpecificTemplate(template));
	        return self.contacts_with_specific_templates.push({
	          id: template.contact_id
	        });
	      });
	      return specific_templates;
	    },
	    addPersistedSpecificTemplates: function(data) {
	      var self, specific_templates;
	      self = this;
	      specific_templates = this.groupSpecificTemplatesByAction(data);
	      return this.flow.actions.forEach(function(action) {
	        if (!!specific_templates[action.id]) {
	          return action.contact_specific_templates = specific_templates[action.id];
	        }
	      });
	    },
	    openSpecificTemplatesModal: function(contact) {
	      this.current_contact = contact;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'edit-specific-templates'
	      });
	    },
	    removeContact: function(contact) {
	      var i, len, list, ref, results;
	      ref = ['new_contacts', 'selected_contacts', 'flow_contacts'];
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        list = ref[i];
	        if (this[list].remove(contact.id)) {
	          if (list === 'flow_contacts') {
	            this.removed_contacts.push(contact);
	          }
	          if (list !== 'new_contacts') {
	            results.push(EventsBus.$emit('ContactsPicker:AddContact', {
	              contact: contact,
	              selected: false
	            }));
	          } else {
	            results.push(void 0);
	          }
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    filter: function(filters) {
	      this.filters = filters;
	      this.next_page = 1;
	      this.flow_contacts = [];
	      return this.loadFlowContacts();
	    },
	    filterContacts: function(contacts) {
	      var filters;
	      filters = this.filters;
	      return contacts.filter(function(contact) {
	        return (!filters.search_query || contact.full_name.toLowerCase().indexOf(filters.search_query.toLowerCase()) > -1) && (!filters.stage_eq || contact.stage === filters.stage_eq) && (!filters.current_recipient_status_eq || contact.recipient_status === filters.current_recipient_status_eq);
	      });
	    },
	    selectContacts: function(data) {
	      this.selected_contacts = data.contacts.filter((function(_this) {
	        return function(contact) {
	          return !contact.flow.hasOwnProperty('id') || contact.flow.id === _this.flow.id;
	        };
	      })(this));
	      return this.selected_contacts.forEach(function(contact) {
	        return EventsBus.$emit('ContactsPicker:RemoveContact', contact);
	      });
	    },
	    setNewContacts: function(data) {
	      return this.new_contacts = data.contacts;
	    },
	    setContacts: function() {
	      var contacts;
	      contacts = [].concat(this.flow_contacts);
	      contacts = contacts.concat(this.filterContacts(this.added_contacts));
	      return this.contacts = contacts.sort(function(contact_1, contact_2) {
	        if (contact_1.recipient_priority === null) {
	          return 1;
	        }
	        if (contact_2.recipient_priority === null) {
	          return -1;
	        }
	        if (contact_1.recipient_priority > contact_2.recipient_priority) {
	          return 1;
	        } else {
	          return -1;
	        }
	      });
	    },
	    updateContactsPriority: function(contacts) {
	      return this.contacts = contacts;
	    },
	    contactsToSend: function() {
	      var contacts;
	      contacts = this.contacts.filter((function(_this) {
	        return function(contact) {
	          return contact.original_recipient_priority !== contact.recipient_priority;
	        };
	      })(this));
	      return contacts.concat(this.added_contacts.filter((function(_this) {
	        return function(contact) {
	          return !contacts.find(contact.id);
	        };
	      })(this)));
	    },
	    updateTriggers: function(data) {
	      return this.flow.triggers = data;
	    }
	  },
	  created: function() {
	    return EventsBus.$on('contact-picker-contacts-added', this.setNewContacts);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('contact-picker-contacts-added', this.setNewContacts);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.contacts.list_view_modes);


/***/ }),
/* 457 */
/***/ (function(module, exports) {

	


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    flowForm: __webpack_require__(57)
	  },
	  data: function() {
	    return {
	      flow: new Flow
	    };
	  },
	  methods: {
	    flowPath: function() {
	      return "/fluxos-de-cadencia/" + this.flow_id;
	    },
	    loadFlow: function() {
	      Loader.on();
	      return new FlowsResource().get(this.loadSuccess, this.unknownError, {
	        id: this.flow_id
	      });
	    },
	    loadSuccess: function(resources) {
	      Loader.off();
	      this.flow = resources.flow;
	      return this.redirectIfNotOwner(this.flow);
	    }
	  },
	  created: function() {
	    this.flow_id = this.$route.params.id;
	    return EventsBus.$on('ActionPicker:Created', this.loadFlow);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('ActionPicker:Created', this.loadFlow);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  mixins: [__webpack_require__(6)],
	  props: ['filters', 'options'],
	  data: function() {
	    var ref;
	    return {
	      sort_filter: this.extractFilter('s'),
	      sort_options: [
	        {
	          value: null,
	          text: this.$t('general.label.newest')
	        }, {
	          value: {
	            s: 'id asc'
	          },
	          text: this.$t('general.label.oldest')
	        }
	      ],
	      user_filter: this.extractFilter('user_id_eq'),
	      users_options: [
	        {
	          value: null,
	          text: this.$t('general.label.loading')
	        }
	      ],
	      text_field_filter: this.filters.name_cont,
	      show_user_filter: !Session.current_user.isSeller() || ((ref = this.options) != null ? ref.show_user_filter : void 0)
	    };
	  },
	  computed: {
	    filterParams: function() {
	      var filter, filter_params, i, len, ref;
	      filter_params = {};
	      ref = [this.sort_filter, this.user_filter];
	      for (i = 0, len = ref.length; i < len; i++) {
	        filter = ref[i];
	        if (filter) {
	          Object.assign(filter_params, filter);
	        }
	      }
	      if (this.text_field_filter) {
	        filter_params['name_cont'] = this.text_field_filter;
	      }
	      return filter_params;
	    }
	  },
	  methods: {
	    filter: function() {
	      this.applyFiltersOnUrlQueryParams(this.filterParams);
	      return this.$emit('filter', this.filterParams);
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.filters);


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	var api, helpers, view_model,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	api = __webpack_require__(4).api();
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    save_button_text: {
	      "default": function() {
	        return this.$t('flows.actions.new');
	      }
	    },
	    cancel_path: {
	      "default": '/fluxos-de-cadencia'
	    },
	    flow: {
	      "default": function() {
	        return new Flow;
	      }
	    },
	    type_of_action: {
	      "default": function() {
	        return this.$t('flows.actions.newFromLib');
	      }
	    }
	  },
	  components: {
	    actionPicker: __webpack_require__(140),
	    contactsForm: __webpack_require__(144),
	    flows: __webpack_require__(8)
	  },
	  data: function() {
	    return {
	      has_emails_per_day: false,
	      old_activation_limit: null,
	      flow_categories: [],
	      save_flow_after_validations: false,
	      delay_before_finishing_contact_amount: 1,
	      delay_before_finishing_contact_unit: 'days',
	      disabledStageLost: false,
	      lostReasonId: '',
	      lost_reason: 'reason 1',
	      sent_to_flow: false,
	      selected_user: Session.current_user.id,
	      weekdays: [this.capitalizeFirstLetter(this.$t('general.label.sun')), this.capitalizeFirstLetter(this.$t('general.label.mon')), this.capitalizeFirstLetter(this.$t('general.label.tue')), this.capitalizeFirstLetter(this.$t('general.label.wed')), this.capitalizeFirstLetter(this.$t('general.label.thu')), this.capitalizeFirstLetter(this.$t('general.label.fri')), this.capitalizeFirstLetter(this.$t('general.label.sat'))],
	      pristine: true,
	      apiErrorMessages: [],
	      action_errors: {}
	    };
	  },
	  computed: {
	    all_errors: function() {
	      var error, errors, i, len, ref;
	      errors = {};
	      ref = this.errors.errors;
	      for (i = 0, len = ref.length; i < len; i++) {
	        error = ref[i];
	        errors[error.field] = error.msg;
	      }
	      return Object.assign({}, errors, this.action_errors);
	    },
	    flow_type_label: function() {
	      if (this.flow.semi_automatic) {
	        return this.$t('flows.label.semiAutomatedFlow');
	      } else {
	        return this.$t('flows.label.automatedFlow');
	      }
	    },
	    modal_title: function() {
	      if (!this.has_emails_per_day) {
	        return this.$t('flows.title.noLimitWarning');
	      } else {
	        return this.$t('flows.title.limitChangeWarning');
	      }
	    },
	    modal_message: function() {
	      if (!this.has_emails_per_day) {
	        return this.$t('flows.text.noLimitWarning');
	      } else {
	        return this.$t('flows.text.limitChangeWarning');
	      }
	    },
	    modal_confirm_text: function() {
	      if (!this.has_emails_per_day) {
	        return this.$t('general.label.yes');
	      } else {
	        return this.$t('general.actions.ok');
	      }
	    },
	    has_changed_activation_limit: function() {
	      return this.is_editing && (this.old_activation_limit !== parseInt(this.flow.emails_per_day));
	    },
	    is_editing: function() {
	      var ref;
	      return (ref = this.flow) != null ? ref.id : void 0;
	    },
	    isReevAccount: function() {
	      return [1, 2, 1169, 1709, 1901, 2115, 2120, 2228, 2602].includes(Session.current_company.id);
	    }
	  },
	  methods: {
	    toggleTaskTimer: function() {
	      if (this.isReevAccount) {
	        return this.flow.toggleTaskTimer();
	      }
	    },
	    capitalizeFirstLetter: function(string) {
	      return helpers.masks.capitalizeFirstLetter(string);
	    },
	    checkStage: function() {
	      return this.flow.set_lost_on_finish = !this.flow.set_lost_on_finish;
	    },
	    lostReasonOptions: function(flowId) {
	      var i, indexLostReason, len, lost_reason, noConnection, ref, ref1, result, stageLost;
	      result = [];
	      noConnection = this.$t('flows.label.noConnection');
	      if (this.$store.getters.lostReasonsCount === 0) {
	        this.$store.dispatch('fetchLostReasons');
	      }
	      ref = this.$store.getters.lostReasonsList;
	      for (i = 0, len = ref.length; i < len; i++) {
	        lost_reason = ref[i];
	        if (lost_reason.title === noConnection) {
	          if (!(this.flow.id || this.flow.lost_reason_id)) {
	            this.flow.lost_reason_id = lost_reason.id;
	          }
	          result.unshift({
	            value: lost_reason.id,
	            text: lost_reason.title
	          });
	        } else {
	          result.push({
	            value: lost_reason.id,
	            text: lost_reason.title
	          });
	        }
	      }
	      if (!this.flow.lost_reason_id) {
	        this.flow.lost_reason_id = (ref1 = result[0]) != null ? ref1.value : void 0;
	      }
	      if (result.length !== 0 && this.lostReasonId !== this.flow.lost_reason_id) {
	        indexLostReason = this.flow.lost_reason_id;
	        stageLost = result.find(function(item) {
	          return item.value === indexLostReason;
	        });
	        if (!stageLost) {
	          this.disabledStageLost = false;
	        } else if (stageLost.text !== noConnection) {
	          this.disabledStageLost = true;
	          this.lostReasonId = stageLost.value;
	        } else {
	          this.disabledStageLost = false;
	          this.lostReasonId = stageLost.value;
	        }
	        this.flow.set_lost_on_finish = true;
	      }
	      return result;
	    },
	    loadFlowCategories: function() {
	      return api.get("/companies/" + Session.current_company.id + "/flow_categories", {}, {
	        success: this.flowCategoriesSuccess,
	        failure: this.flowCategoriesFailure
	      });
	    },
	    flowCategoriesSuccess: function(data) {
	      var ref;
	      this.flow_categories = data.body.flow_categories.map(function(flow_category) {
	        return {
	          text: flow_category.name,
	          value: flow_category.id
	        };
	      });
	      if (!this.flow.category_id) {
	        return this.flow.category_id = (ref = this.flow_categories[0]) != null ? ref.value : void 0;
	      }
	    },
	    flowCategoriesFailure: function(error) {
	      return console.error(error);
	    },
	    validTriggers: function() {
	      var has_flow_triggers, has_responsible_triggers, i, len, ref, trigger;
	      ref = this.flow.triggers;
	      for (i = 0, len = ref.length; i < len; i++) {
	        trigger = ref[i];
	        if (this.flow.triggers.filter(function(t) {
	          return t.trigger_type === trigger.trigger_type && t.trigger_value === trigger.trigger_value && t.action_type === trigger.action_type && !trigger._destroy;
	        }).length > 1) {
	          alertify.error(this.$t('flows.label.errors.markedTriggers'));
	          return false;
	        }
	        if (['stage'].indexOf(trigger.trigger_type) > -1 && !trigger.trigger_value && !t._destroy) {
	          alertify.error(this.$t('flows.label.errors.needAction'));
	          return false;
	        }
	        if (['insert_into_a_group', 'send_to_new_flow', 'fill_property', 'change_stage', 'change_responsible'].indexOf(trigger.action_type) > -1 && !trigger.action_value && !trigger._destroy) {
	          alertify.error(this.$t('flows.label.errors.needAction'));
	          return false;
	        }
	        if (['fill_property'].indexOf(trigger.action_type) > -1 && !trigger.action_target && !t._destroy) {
	          alertify.error(this.$t('flows.label.errors.needProperty'));
	          return false;
	        }
	        if (['hours', 'days', 'weeks', 'months'].indexOf(trigger.timming_type) > -1 && !trigger.timming_value && ['send_to_new_flow', 'change_stage'].indexOf(trigger.action_type) > -1 && !trigger._destroy) {
	          alertify.error(this.$t('flows.label.errors.needSetTime'));
	          return false;
	        }
	        if (trigger.trigger_type === 'lost' && !trigger.trigger_value) {
	          if (this.flow.triggers.filter(function(t) {
	            return t.trigger_type === trigger.trigger_type && !trigger._destroy;
	          }).length > 1) {
	            alertify.error(this.$t('flows.label.errors.triggerConflicts'));
	            return false;
	          }
	        }
	      }
	      has_flow_triggers = this.flow.triggers.filter(function(t) {
	        return t.action_type === 'send_to_new_flow' && !trigger._destroy;
	      }).length > 0;
	      has_responsible_triggers = this.flow.triggers.filter(function(t) {
	        return t.action_type === 'change_responsible' && !trigger._destroy;
	      }).length > 0;
	      if (has_flow_triggers && has_responsible_triggers) {
	        alertify.error(this.$t('flows.label.errors.responsibleAndFlowConflictError'));
	        return false;
	      }
	      return true;
	    },
	    switchSendToFlow: function() {
	      var payload;
	      this.sent_to_flow = !this.sent_to_flow;
	      if (!this.sent_to_flow) {
	        this.selected_flow = null;
	        payload = {
	          type: 'flow_data',
	          value: null,
	          "switch": false
	        };
	        this.$store.dispatch('setOrganizationOptions', payload);
	      }
	      return this.$emit('flowSwitch', this.sent_to_flow);
	    },
	    selectFlow: function(flow) {
	      var payload;
	      this.selected_flow = flow;
	      payload = {
	        type: 'flow_data',
	        value: Number(this.selected_flow.id),
	        "switch": this.sent_to_flow
	      };
	      this.$store.dispatch('setOrganizationOptions', payload);
	      this.$emit('fillFlow', Number(this.selected_flow.id));
	    },
	    toggleType: function() {
	      if (this.flow.canEditActions()) {
	        return this.flow.toggleType();
	      }
	    },
	    onCategoryChange: function(category_id) {
	      if (category_id !== 3) {
	        return this.flow.with_task_timer = false;
	      }
	    },
	    validateAll: function() {
	      Vue["delete"](this.action_errors, 'required');
	      Vue["delete"](this.action_errors, 'send_at');
	      Vue["delete"](this.action_errors, 'delay_after_previous_step_amount');
	      Vue["delete"](this.action_errors, 'template');
	      this.setDirty();
	      return this.$validator.validateAll();
	    },
	    submit: function() {
	      this.save_flow_after_validations = true;
	      return EventsBus.$emit('validate-all');
	    },
	    validateAndSaveFlow: function() {
	      this.save_flow_after_validations = false;
	      if (!this.isValid()) {
	        jQuery('html, body').animate({
	          scrollTop: 0
	        }, 500);
	        return;
	      }
	      if (!this.validTriggers()) {
	        return;
	      }
	      if (!this.has_emails_per_day || this.has_changed_activation_limit) {
	        EventsBus.$emit('confirm-modal-show', {
	          id: 'confirm-save'
	        });
	        return;
	      }
	      return this.saveFlow();
	    },
	    saveFlow: function() {
	      var flow_attributes;
	      this.ensureActionStepOrder();
	      this.ensureActionSendAt();
	      this.ensureEmailsPerDay();
	      this.ensureEmptyTaskParameters();
	      this.flow.contacts = this.$refs.contacts_form.contactsToSend();
	      this.flow.contact_ids_to_be_removed = this.$refs.contacts_form.removed_contacts.map(function(contact) {
	        return contact.id;
	      });
	      flow_attributes = this.flow.serialize();
	      Loader.on();
	      if (this.flow.isWithError()) {
	        return this.flow_resource.retry(this.saveSuccess, this.saveFailure, flow_attributes);
	      } else {
	        return this.flow_resource.save(this.saveSuccess, this.saveFailure, flow_attributes);
	      }
	    },
	    saveSuccess: function(resources) {
	      var flowActionsNumber, flowActiveAfterCreated, flowActiveBBC, flowContactsLength, flowCreatedURL, flowDailyEmailLength;
	      flowCreatedURL = this.$t('flows.label.flowCreatedURL');
	      flowContactsLength = this.$t('flows.label.flowContactsLength');
	      flowDailyEmailLength = this.$t('flows.label.flowDailyEmailLength');
	      flowActiveAfterCreated = this.$t('flows.label.flowActiveAfterCreated');
	      flowActiveBBC = this.$t('flows.label.flowActiveBBC');
	      flowActionsNumber = this.$t('flows.label.flowActionsNumber');
	      Loader.off();
	      this.$router.push({
	        path: "/fluxos-de-cadencia/"
	      });
	      return IntercomCtrl.trackEvent(this.$t('flows.label.flowStatus', {
	        status: this.type_of_action
	      }), {
	        flowCreatedURL: location.href,
	        flowContactsLength: this.flow.contacts.length,
	        flowDailyEmailLength: resources.flow.emails_per_day === null ? this.$t('general.label.none') : resources.flow.emails_per_day,
	        flowActiveAfterCreated: resources.flow.status === 'paused' ? this.$t('general.label.no') : this.$t('general.label.yes'),
	        flowActiveBBC: resources.flow.bcc ? this.$t('general.label.yes') : this.$t('general.label.no'),
	        flowActionsNumber: resources.flow.actions.length
	      });
	    },
	    saveFailure: function(response) {
	      Loader.off();
	      if (!this.handleContactPickerErrors(response.body.errors.details, response.body.errors.messages)) {
	        jQuery('html, body').animate({
	          scrollTop: 0
	        }, 500);
	        return alertify.error(this.$t('flows.feedback.unknownErrorOnCreate'));
	      }
	    },
	    isValid: function() {
	      return !this.errors.any() && !this.anyActionErrors();
	    },
	    toggleHasEmailsPerDay: function() {
	      this.has_emails_per_day = !this.has_emails_per_day;
	      return this.flow.emails_per_day = this.has_emails_per_day ? 0 : null;
	    },
	    toggleWeekday: function(weekday_number) {
	      var d;
	      if (this.weekdaySelected(weekday_number)) {
	        return this.flow.weekdays_to_send = (function() {
	          var i, len, ref, results;
	          ref = this.flow.weekdays_to_send;
	          results = [];
	          for (i = 0, len = ref.length; i < len; i++) {
	            d = ref[i];
	            if (d !== weekday_number) {
	              results.push(d);
	            }
	          }
	          return results;
	        }).call(this);
	      } else {
	        return this.flow.weekdays_to_send.push(weekday_number);
	      }
	    },
	    weekdaySelected: function(weekday_number) {
	      return indexOf.call(this.flow.weekdays_to_send, weekday_number) >= 0;
	    },
	    handleTriggerSandErrors: function(data) {
	      var error, i, len, ref;
	      ref = data['triggers.action_value'];
	      for (i = 0, len = ref.length; i < len; i++) {
	        error = ref[i];
	        this.errors.errors.push({
	          field: 'Ação',
	          msg: error.error
	        });
	      }
	      return jQuery('html, body').animate({
	        scrollTop: 0
	      }, 500);
	    },
	    handleContactPickerErrors: function(data, messages) {
	      var emails, errors, recipients_errors;
	      if (data['triggers.action_value']) {
	        this.handleTriggerSandErrors(data);
	        return true;
	      }
	      recipients_errors = data['recipients'] || data['recipients.contact.email'];
	      if (!recipients_errors) {
	        return this.handlerContactListErrors(data, messages);
	      }
	      emails = recipients_errors.map(function(error) {
	        return error.value;
	      });
	      errors = {
	        taken_emails: emails
	      };
	      EventsBus.$emit('contacts-picker-text-csv-errors', {
	        errors: errors
	      });
	      return jQuery('#contacts-manual-picker').modal('show');
	    },
	    handlerContactListErrors: function(data, messages) {
	      var contact_errors, error_messages, i, idx, len, message;
	      error_messages = messages['contacts'];
	      contact_errors = data['contacts'];
	      if (!contact_errors) {
	        return false;
	      }
	      for (idx = i = 0, len = error_messages.length; i < len; idx = ++i) {
	        message = error_messages[idx];
	        console.log(contact_errors[idx]);
	        this.errors.errors.push({
	          field: 'Listagem',
	          msg: message
	        });
	      }
	      return jQuery('html, body').animate({
	        scrollTop: 0
	      }, 500);
	    },
	    handleTemplatesPickerErrors: function(data) {
	      if (data.errors.any()) {
	        return Vue.set(this.action_errors, 'template', 'A escolha dos templates é obrigatória');
	      }
	    },
	    handleSendAtPickerErrors: function(data) {
	      var error, i, len, ref;
	      ref = data.errors.errors;
	      for (i = 0, len = ref.length; i < len; i++) {
	        error = ref[i];
	        if (error.field === 'send_at' && error.rule === 'regex') {
	          Vue.set(this.action_errors, 'send_at', this.$t('flows.label.error.invalidFormat'));
	        } else if (error.field === 'delay_after_previous_step_amount' && error.rule === 'between') {
	          Vue.set(this.action_errors, 'delay_after_previous_step_amount', this.$t('flows.label.error.fieldSendAfterError'));
	        } else {
	          Vue.set(this.action_errors, 'required', error.msg);
	        }
	      }
	      if (this.save_flow_after_validations) {
	        return this.validateAndSaveFlow();
	      }
	    },
	    anyActionErrors: function() {
	      return !jQuery.isEmptyObject(this.action_errors);
	    },
	    ensureActionStepOrder: function() {
	      var action, current_step, i, len, results, sorted_actions;
	      current_step = 0;
	      sorted_actions = Object.values(this.flow.actions).sort(this.actionSorter);
	      results = [];
	      for (i = 0, len = sorted_actions.length; i < len; i++) {
	        action = sorted_actions[i];
	        if (!action._destroy) {
	          action.step = current_step;
	          action.human_step = current_step;
	          results.push(current_step += 1);
	        } else {
	          results.push(void 0);
	        }
	      }
	      return results;
	    },
	    ensureActionSendAt: function() {
	      var now;
	      if (this.flow.actions[0].send_at || this.flow.actions[0].send_at_kind !== 'immediately') {
	        return;
	      }
	      now = moment();
	      return this.flow.actions[0].send_at = now.add(now.utcOffset(), 'minutes');
	    },
	    ensureEmailsPerDay: function() {
	      return this.flow.emails_per_day = this.has_emails_per_day ? this.flow.emails_per_day : null;
	    },
	    ensureEmptyTaskParameters: function() {
	      var action, i, len, ref, results;
	      ref = this.flow.actions;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        action = ref[i];
	        if (action.type !== 'EmailFlowAction') {
	          continue;
	        }
	        results.push(action.manual_task_parameters = {});
	      }
	      return results;
	    },
	    actionSorter: function(action_1, action_2) {
	      if (action_1.step < action_2.step) {
	        return -1;
	      }
	      if (action_1.step > action_2.step) {
	        return 1;
	      }
	      return 0;
	    },
	    setFlow: function(flow) {
	      this.flow = flow;
	      this.has_emails_per_day = this.flow.emails_per_day > 0;
	      if (this.flow.id) {
	        this.old_activation_limit = this.flow.emails_per_day;
	      }
	      return EventsBus.$emit('flow-set', {
	        flow: this.flow
	      });
	    }
	  },
	  watch: {
	    flow: function(new_flow) {
	      this.setFlow(new_flow);
	      return this.errors.clear();
	    }
	  },
	  created: function() {
	    this.sent_to_flow = false;
	    this.flow_resource = new FlowsResource(Session.current_company.id);
	    this.delay_before_finishing_contact_options = [
	      {
	        value: 'days',
	        text: helpers.masks.capitalizeFirstLetter(this.$t('general.label.days'))
	      }, {
	        value: 'weeks',
	        text: helpers.masks.capitalizeFirstLetter(this.$t('general.label.weeks'))
	      }, {
	        value: 'months',
	        text: helpers.masks.capitalizeFirstLetter(this.$t('general.label.months'))
	      }
	    ];
	    EventsBus.$on('validate-all', this.validateAll);
	    EventsBus.$on('templates-picker-errors', this.handleTemplatesPickerErrors);
	    return EventsBus.$on('flows-send-at-picker-errors', this.handleSendAtPickerErrors);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('validate-all', this.validateAll);
	    EventsBus.$off('templates-picker-errors', this.handleTemplatesPickerErrors);
	    return EventsBus.$off('flows-send-at-picker-errors', this.handleSendAtPickerErrors);
	  },
	  mounted: function() {
	    this.loadFlowCategories();
	    return this.$nextTick((function(_this) {
	      return function() {
	        return _this.errors.clear();
	      };
	    })(this));
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  components: {
	    list: __webpack_require__(58)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      list_item_options: {
	        show_user: !Session.current_user.isSeller()
	      }
	    };
	  }
	};


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  components: {
	    list: __webpack_require__(58)
	  },
	  data: function() {
	    return {
	      list_item_options: {
	        show_user: true,
	        row_click_action: 'select',
	        action: 'select',
	        show_contacts_count: false,
	        show_reply_statistic: false
	      },
	      filter_options: {
	        show_user_filter: true
	      },
	      options: {
	        show_everybodys_flows: true
	      }
	    };
	  }
	};


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    filters: __webpack_require__(145)
	  },
	  props: ['list_item_options', 'filter_options', 'options'],
	  data: function() {
	    return {
	      flows: [],
	      filters: {},
	      loading: false,
	      next_page: 1,
	      selected_flow: {},
	      default_options: {
	        show_everybodys_flows: false
	      }
	    };
	  },
	  methods: {
	    loadFlows: function() {
	      var filters;
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      filters = this.default_options.show_everybodys_flows ? this.filters : this.mergeCurrentUserFilterIfSeller(this.filters);
	      return this.flow_resource.index(this.loadSuccess, Loader.off, {
	        params: {
	          q: filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadSuccess: function(resources) {
	      this.loading = false;
	      this.next_page = resources.meta.next_page;
	      this.flows = this.flows.concat(resources.flows);
	      return this.subscribeToFlowCreationChannel();
	    },
	    flowsEmpty: function() {
	      return jQuery.isEmptyObject(this.flows);
	    },
	    updateFlow: function(data) {
	      Loader.on();
	      return this.flow_resource.update(this.updateFlowSuccess, Loader.off, data.attr);
	    },
	    updateFlowSuccess: function(resources) {
	      this.updateFlowList(resources.flow);
	      return Loader.off();
	    },
	    updateFlowList: function(flow) {
	      var index;
	      index = this.flows.findIndex(flow.id);
	      if (index > -1) {
	        return Vue.set(this.flows, index, flow);
	      } else {
	        return this.flows.push(flow);
	      }
	    },
	    filter: function(filters) {
	      this.filters = filters;
	      this.flows = [];
	      this.next_page = 1;
	      return this.loadFlows();
	    },
	    openDestroyFlowConfirmationModal: function(flow) {
	      this.selected_flow = flow;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'destroy-flow-confirmation-modal'
	      });
	    },
	    destroyFlow: function() {
	      return this.flow_resource.destroy(this.destroyFlowSuccess, this.unknownError, this.selected_flow);
	    },
	    destroyFlowSuccess: function() {
	      var intercomDescription, intercomTitle;
	      intercomTitle = this.$t('flows.label.removeDialogTitle');
	      intercomDescription = this.$t('flows.label.removeDialogDescription');
	      this.flows.remove(this.selected_flow.id);
	      alertify.success(this.$t('flows.feedback.removeSuccess'));
	      return IntercomCtrl.trackEvent(intercomTitle, {
	        intercomDescription: location.href + '/' + this.selected_flow.id
	      });
	    },
	    mergeDefaultOptions: function() {
	      return this.default_options = Object.assign({}, this.default_options, this.options);
	    },
	    refreshFlow: function(data) {
	      var flow, i, idx, index, len, ref;
	      index = 0;
	      ref = this.flows;
	      for (idx = i = 0, len = ref.length; i < len; idx = ++i) {
	        flow = ref[idx];
	        if (flow.id === data.id) {
	          index = idx;
	        }
	      }
	      if (!(index >= 0)) {
	        return;
	      }
	      return Vue.set(this.flows, index, new Flow(data));
	    },
	    subscribeToFlowCreationChannel: function() {
	      this.removeSubscription();
	      return this.subscription = ActionCable.cable.subscriptions.create({
	        channel: 'FlowCreationChannel',
	        user_id: this.user_id
	      }, {
	        received: (function(_this) {
	          return function(data) {
	            return _this.refreshFlow(data);
	          };
	        })(this)
	      });
	    },
	    removeSubscription: function() {
	      if (this.subscription) {
	        return ActionCable.cable.subscriptions.remove(this.subscription);
	      }
	    }
	  },
	  computed: {
	    destroy_confirm_modal_message: function() {
	      return this.$t('flows.label.removeConfirm', {
	        name: this.selected_flow.name
	      });
	    }
	  },
	  created: function() {
	    this.mergeDefaultOptions();
	    this.flow_resource = new FlowsResource(Session.current_company.id);
	    this.setFiltersFromQueryParams();
	    return this.loadFlows();
	  },
	  beforeDestroy: function() {
	    return this.removeSubscription();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['flow', 'options'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      default_options: {
	        show_user: false,
	        row_click_action: 'show',
	        action: 'dropdown',
	        show_contacts_count: true,
	        show_reply_statistic: true
	      }
	    };
	  },
	  methods: {
	    circleStatusClass: function() {
	      var classes;
	      classes = '';
	      if (this.flow.isProcessing()) {
	        classes = 'circle flow-status circle-grey';
	      } else if (this.flow.isWithError()) {
	        classes = 'circle flow-status circle-red';
	      } else if (this.flow.isPublished()) {
	        classes = 'circle flow-status circle-green';
	      } else if (this.flow.isPaused()) {
	        classes = 'circle flow-status circle-yellow';
	      }
	      if (this.flow.semi_automatic) {
	        classes += ' semi-automatic';
	      }
	      return classes;
	    },
	    rowClicked: function(event) {
	      if (this.flow.isProcessing() || jQuery(event.target).closest('.clickable-element').length) {
	        return;
	      }
	      switch (this.default_options.row_click_action) {
	        case 'show':
	          return this.viewFlow();
	        case 'select':
	          return this.$router.push("/fluxos-de-cadencia/criar/" + this.flow.id);
	      }
	    },
	    viewFlow: function() {
	      if (this.is_processing) {
	        return;
	      }
	      if (this.is_with_error) {
	        return this.$router.push("/fluxos-de-cadencia/criar/" + this.flow.id);
	      } else {
	        return this.$router.push("/fluxos-de-cadencia/" + this.flow.id);
	      }
	    },
	    updateFlow: function(attr) {
	      attr.id = this.flow.id;
	      return this.$emit('flow-update', {
	        attr: attr
	      });
	    },
	    flowEditPath: function() {
	      return "/fluxos-de-cadencia/" + this.flow.id + "/editar";
	    },
	    editFlow: function() {
	      return this.$router.push({
	        path: this.flowEditPath()
	      });
	    },
	    openDestroyFlowConfirmationModal: function() {
	      return this.$emit('flow-confirm-destroy', this.flow);
	    }
	  },
	  computed: {
	    is_processing: function() {
	      return this.flow.isProcessing();
	    },
	    is_with_error: function() {
	      return this.flow.isWithError();
	    },
	    flow_status_message: function() {
	      if (this.flow.isProcessing()) {
	        return this.$t('flows.label.flowProcessing');
	      } else if (this.flow.isWithError()) {
	        return this.$t('flows.label.flowProcessingError');
	      }
	    },
	    flow_status_message_class: function() {
	      if (this.flow.isProcessing()) {
	        return 'flow-message-status flow-processing-status';
	      } else if (this.flow.isWithError()) {
	        return 'flow-message-status flow-error-status';
	      }
	    }
	  },
	  created: function() {
	    return this.default_options = Object.assign({}, this.default_options, this.options || {});
	  }
	};
	
	exports["default"] = view_model;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  components: {
	    flowForm: __webpack_require__(57)
	  },
	  data: function() {
	    return {
	      flow: new Flow,
	      type_of_action: this.$t('general.actions.new')
	    };
	  },
	  methods: {
	    loadFlow: function() {
	      Loader.on();
	      return new FlowsResource().get(this.loadFlowSuccess, this.unknownError, {
	        id: this.$route.params.id
	      });
	    },
	    loadFlowSuccess: function(resource) {
	      Loader.off();
	      this.type_of_action = this.$t('flows.actions.newFromLib');
	      return this.flow = this.buildFlow(resource.flow, true);
	    },
	    buildFlow: function(flow, copying) {
	      var actions, loaded_action;
	      if (copying == null) {
	        copying = false;
	      }
	      if (flow.job_status !== null) {
	        this.type_of_action = this.$t('flows.actions.retryAfterError');
	      }
	      actions = (function() {
	        var i, len, ref, results;
	        ref = flow.actions;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          loaded_action = ref[i];
	          results.push(this.buildAction(loaded_action, copying));
	        }
	        return results;
	      }).call(this);
	      return new Flow({
	        id: flow.isWithError() ? flow.id : null,
	        name: flow.name,
	        emails_per_day: flow.emails_per_day,
	        weekdays_to_send: flow.weekdays_to_send,
	        actions: actions,
	        semi_automatic: flow.semi_automatic,
	        job_status: flow.job_status,
	        triggers: flow.triggers.map(function(trigger) {
	          var id;
	          id = flow.isWithError() ? trigger.id : null;
	          return Object.assign(trigger, {
	            id: id,
	            action_value: null,
	            action_metadata: []
	          });
	        }),
	        lost_reason_id: flow.lost_reason_id,
	        bcc: flow.bcc,
	        delay_before_finishing_contact_amount: flow.delay_before_finishing_contact_amount,
	        delay_before_finishing_contact_unit: flow.delay_before_finishing_contact_unit,
	        category_id: flow.category_id,
	        with_task_timer: flow.with_task_timer
	      });
	    },
	    buildAction: function(loaded_action, copying) {
	      var flow;
	      if (copying == null) {
	        copying = false;
	      }
	      flow = new FlowAction({
	        step: loaded_action.step,
	        name: loaded_action.name,
	        send_at: loaded_action.send_at,
	        template_id: loaded_action.template_id,
	        delay_after_previous_step_amount: loaded_action.delay_after_previous_step_amount,
	        delay_after_previous_step_unit: loaded_action.delay_after_previous_step_unit,
	        send_as_reply: loaded_action.send_as_reply,
	        immediately: loaded_action.immediately,
	        type: loaded_action.type,
	        manual_task_parameters: loaded_action.manual_task_parameters,
	        undefined_time: loaded_action.undefined_time
	      });
	      flow.template = Object.assign({}, loaded_action.template);
	      if (copying) {
	        flow.template_copied_from_id = loaded_action.original_template_id;
	      }
	      return flow;
	    },
	    setFlow: function() {
	      if (this.$route.params.id) {
	        return this.loadFlow();
	      } else {
	        return this.flow = new Flow({
	          weekdays_to_send: [1, 2, 3, 4, 5]
	        });
	      }
	    }
	  },
	  created: function() {
	    return EventsBus.$on('ActionPicker:Created', this.setFlow);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('ActionPicker:Created', this.setFlow);
	  }
	};


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    actionList: __webpack_require__(138),
	    contacts: __webpack_require__(143),
	    taskModalForm: __webpack_require__(17),
	    ModalFlowForm: __webpack_require__(157)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      flow: new Flow({
	        weekdays_to_send: [],
	        email_statistic: {},
	        actions: []
	      }),
	      actions: [],
	      confirming_destroy_flow: false
	    };
	  },
	  methods: {
	    openTaskModalForm: function() {
	      return EventsBus.$emit('ModalFlowForm::Show', {
	        task_id: null,
	        contact: this.contact,
	        id: 'dialer-manual-flow-form-modal'
	      });
	    },
	    toggleTaskBar: function(data) {
	      return EventsBus.$emit('toggle-task-bar', data.contact.id);
	    },
	    trackEventViewContact: function(flow) {
	      var viewContactFlow, viewContactFlowDescription;
	      viewContactFlow = this.$t('flows.label.viewContactFlow');
	      viewContactFlowDescription = this.$t('flows.label.viewContactFlowDescription');
	      return IntercomCtrl.trackEvent(viewContactFlow, {
	        viewContactFlowDescription: this.flow.id
	      });
	    },
	    setFlow: function(flow) {
	      this.flow = flow;
	      this.actions = flow.actions;
	      return Tooltip.initialize();
	    },
	    toggleFlowStatus: function() {
	      var statusChangeDescriptionLabel, statusChangeLabel;
	      if (!!this.current_user.isMonitoringManager()) {
	        return;
	      }
	      statusChangeLabel = this.$t('flows.label.statusChangeLabel', {
	        name: this.flow.name,
	        human_status: this.flow.human_status
	      });
	      statusChangeDescriptionLabel = this.$t('flows.label.statusChangeDescription');
	      this.flow.toggleStatus();
	      IntercomCtrl.trackEvent(statusChangeLabel, {
	        statusChangeDescriptionLabel: this.flow.id
	      });
	      return this.flow_resource.update(this.updateFlowSuccess, null, {
	        id: this.flow.id,
	        status: this.flow.status
	      });
	    },
	    updateFlowSuccess: function(resources) {
	      this.setFlow(resources.flow);
	      return alertify.success(this.$t('flows.label.updateFlowSuccess', {
	        status: this.flow.human_status
	      }));
	    },
	    loadFlow: function() {
	      Loader.on();
	      return this.flow_resource.get(this.loadFlowSuccess, this.unknownError, {
	        id: this.$route.params.id
	      });
	    },
	    loadFlowSuccess: function(resources) {
	      this.setFlow(resources.flow);
	      Loader.off();
	      return this.redirectIfNotOwner(this.flow);
	    },
	    confirmDestroy: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-destroy-flow-modal'
	      });
	    },
	    reengageContacts: function() {
	      return this.flow_resource.reengage(this.flowReengageSuccess, null, {
	        id: this.flow.id
	      });
	    },
	    flowReengageSuccess: function() {
	      alertify.success(this.$t('flows.label.contactResume'));
	      return EventsBus.$emit('reload-contacts');
	    },
	    destroyConfirmed: function() {
	      var intercomDescription, intercomTitle, viewContactFlowDescription;
	      intercomTitle = this.$t('flows.label.removeDialogTitle');
	      intercomDescription = this.$t('flows.label.removeDialogDescription');
	      viewContactFlowDescription = this.$t('flows.label.viewContactFlowDescription');
	      IntercomCtrl.trackEvent(intercomTitle, {
	        intercomDescription: location.href,
	        viewContactFlowDescription: this.flow.id
	      });
	      return this.flow_resource.destroy(this.flowDestroySuccess, this.flowDestroyFailure, {
	        id: this.flow.id
	      });
	    },
	    flowDestroySuccess: function() {
	      alertify.success(this.$t('flows.feedback.removeSuccess'));
	      return this.$router.replace({
	        name: 'flows'
	      });
	    },
	    flowDestroyFailure: function() {
	      return alertify.error(this.$t('general.feedback.actionNotAllowed'));
	    },
	    editFlow: function() {
	      return this.$router.push({
	        path: this.flowEditPath()
	      });
	    },
	    flowEditPath: function() {
	      return "/fluxos-de-cadencia/" + this.flow.id + "/editar";
	    },
	    countLabelTooltipHtml: function(data) {
	      var i, inner_html, item, len, lines;
	      lines = [];
	      for (i = 0, len = data.length; i < len; i++) {
	        item = data[i];
	        lines.push("<p> <span class='tooltip-count'>" + item[0] + "</span> <span class='tooltip-label'> " + item[1] + " </span> </p>");
	      }
	      return inner_html = lines.join('');
	    }
	  },
	  computed: {
	    recipientsByStatusHtml: function() {
	      var _, data, status;
	      data = (function() {
	        var ref, results;
	        ref = this.flow.recipients_statistics.by_status;
	        results = [];
	        for (_ in ref) {
	          status = ref[_];
	          results.push([status.count, status.human_label]);
	        }
	        return results;
	      }).call(this);
	      return this.countLabelTooltipHtml(data);
	    },
	    detailedConversionStatisticHtml: function() {
	      var data, ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, statistics;
	      statistics = this.flow.recipients_statistics;
	      if (!((statistics != null ? (ref = statistics.by_stage) != null ? ref.lost : void 0 : void 0) && (statistics != null ? (ref1 = statistics.by_status) != null ? ref1.connected : void 0 : void 0) && (statistics != null ? (ref2 = statistics.by_stage) != null ? ref2.client : void 0 : void 0))) {
	        return;
	      }
	      data = [[((ref3 = statistics.by_status.not_connected) != null ? ref3.count : void 0) || 0, ((ref4 = statistics.by_status.not_connected) != null ? ref4.human_label : void 0) || '-'], [((ref5 = statistics.by_status.disqualified) != null ? ref5.count : void 0) || 0, ((ref6 = statistics.by_status.disqualified) != null ? ref6.human_label : void 0) || '-'], [((ref7 = statistics.by_status.blocklisted) != null ? ref7.count : void 0) || 0, ((ref8 = statistics.by_status.blocklisted) != null ? ref8.human_label : void 0) || '-'], [statistics.by_status.connected.count, statistics.by_status.connected.human_label], [statistics.by_stage.client.count, statistics.by_stage.client.human_label + 's']];
	      return this.countLabelTooltipHtml(data);
	    },
	    detailedReplyStatisticHtml: function() {
	      var data;
	      if (!this.flow.email_statistic) {
	        return;
	      }
	      data = [[this.flow.email_statistic.sent, this.flow.email_statistic.humanLabel('sent')], [this.flow.email_statistic.reply, this.flow.email_statistic.humanLabel('reply')]];
	      return this.countLabelTooltipHtml(data);
	    },
	    contactsCount: function() {
	      if (!this.flow.recipients_statistics.total) {
	        return 0;
	      }
	      return this.flow.recipients_statistics.total.count;
	    },
	    recipientsStatisticsConversion: function() {
	      var percentage;
	      if (!this.flow.recipients_statistics.by_stage) {
	        return '--';
	      }
	      percentage = (this.flow.recipients_statistics.by_stage.conversion.value * 100.0).toFixed(1);
	      return percentage.replace('.', ',') + '%';
	    }
	  },
	  created: function() {
	    this.setFiltersFromQueryParams();
	    this.flow_resource = new FlowsResource(Session.current_company.id);
	    return this.loadFlow();
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	__webpack_require__(229);
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  mixins: [__webpack_require__(6)],
	  data: function() {
	    return {
	      users_options: [
	        {
	          value: null,
	          text: 'Carregando...'
	        }
	      ],
	      user_filter: {},
	      loading: false,
	      start_date: moment().startOf('day').format('YYYY-MM-DD'),
	      end_date: moment().endOf('day').format('YYYY-MM-DD'),
	      current_user: Session.current_user,
	      done_tasks_grouped: {}
	    };
	  },
	  methods: {
	    valid_label_task_card: function(key) {
	      return this.label_of_tasks[key] && this.label_of_tasks[key].length > 0;
	    },
	    countingNumber: function(number) {
	      var result;
	      result = number;
	      if (number < 10 && number > 0) {
	        result = '0' + number;
	      }
	      return result;
	    },
	    initializeDatePicker: function() {
	      return jQuery('#calendar-input').dateRangePicker({
	        language: 'pt',
	        hoveringTooltip: false,
	        inline: true,
	        container: '#calendar',
	        alwaysOpen: true,
	        format: 'dddd DD/MM',
	        singleMonth: true,
	        separator: ' - ',
	        showTopbar: false
	      }).bind('datepicker-change', (function(_this) {
	        return function(event, obj) {
	          return _this.calendarChanged(obj);
	        };
	      })(this));
	    },
	    calendarChanged: function(obj) {
	      this.start_date = moment(obj.date1).startOf('day').format('YYYY-MM-DD');
	      this.end_date = moment(obj.date2).endOf('day').format('YYYY-MM-DD');
	      return this.loadGroupedDoneTasksData(this.card_filters);
	    },
	    loadGroupedDoneTasksData: function(filters) {
	      this.loading = true;
	      return this.reports_resource.groupedDoneTasks(this.loadGroupedDoneTasksDataSuccess, this.unkonwnError, {
	        params: {
	          q: filters
	        }
	      });
	    },
	    loadGroupedDoneTasksDataSuccess: function(data) {
	      this.done_tasks_grouped = this.mergingDoneTasks(data.body);
	      return this.loading = false;
	    },
	    mergingDoneTasks: function(done_tasks) {
	      var i, len, result, task;
	      result = {
	        'ManualTasksServices::Email': 0,
	        'ManualTasksServices::Linkedin': 0,
	        'ManualTasksServices::Phonecall': 0,
	        'ManualTasksServices::Social': 0
	      };
	      for (i = 0, len = done_tasks.length; i < len; i++) {
	        task = done_tasks[i];
	        result[task.service] += task.count;
	      }
	      return result;
	    },
	    declaringVariables: function() {
	      var img_prefix;
	      this.label_of_tasks = {
	        'ManualTasksServices::Email': 'Emails manuais',
	        'ManualTasksServices::Linkedin': 'Linkedin',
	        'ManualTasksServices::Phonecall': 'Ligações',
	        'ManualTasksServices::Social': 'Sociais'
	      };
	      img_prefix = '../../assets/images/icons/';
	      return this.class_of_tasks = {
	        'ManualTasksServices::Email': 'email',
	        'ManualTasksServices::Linkedin': 'linkedin',
	        'ManualTasksServices::Phonecall': 'call',
	        'ManualTasksServices::Social': 'social'
	      };
	    }
	  },
	  computed: {
	    date_string: function() {
	      return moment(this.start_date).format('dddd DD/MM') + ' - ' + moment(this.end_date).format('dddd DD/MM');
	    },
	    card_filters: function() {
	      var filters;
	      filters = {
	        period: {
	          from: this.start_date,
	          to: this.end_date
	        }
	      };
	      if (this.current_user.isManager() || this.current_user.isMonitoringManager()) {
	        if (this.user_filter) {
	          filters.user_id_eq = this.user_filter.user_id_eq;
	        }
	      } else {
	        filters.user_id_eq = this.current_user.id;
	      }
	      return filters;
	    }
	  },
	  created: function() {
	    this.reports_resource = new ReportsResource(Session.current_company.id);
	    this.loadGroupedDoneTasksData(this.card_filters);
	    return this.declaringVariables();
	  },
	  mounted: function() {
	    return this.initializeDatePicker();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 468 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: ['task'],
	  methods: {
	    destroyTask: function() {
	      Loader.on();
	      return new TasksResource().destroy(this.destroyTaskSuccess, this.unknownError, {
	        id: this.task.id
	      });
	    },
	    destroyTaskSuccess: function(resource) {
	      this.$emit('destroyed', {
	        task: this.task,
	        event: resource.body.task.event
	      });
	      return Loader.off();
	    }
	  }
	};


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      contacts: [],
	      loading: false,
	      next_page: 1
	    };
	  },
	  methods: {
	    loadContacts: function(filters) {
	      if (filters == null) {
	        filters = {};
	      }
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      filters = Object.assign({}, filters);
	      if (!filters.user_id_eq && Session.current_user.isSeller()) {
	        filters.user_id_eq = Session.current_user.id;
	      }
	      return this.contact_resource.index(this.loadSuccess, Loader.off, {
	        params: {
	          q: filters,
	          page: this.next_page
	        }
	      });
	    },
	    loadSuccess: function(resources) {
	      this.loading = false;
	      this.next_page = resources.meta.next_page;
	      return this.contacts = this.contacts.concat(resources.contacts);
	    },
	    filter: function(filters) {
	      this.contacts = [];
	      this.next_page = 1;
	      return this.loadContacts(filters);
	    },
	    contactsEmpty: function() {
	      return jQuery.isEmptyObject(this.contacts);
	    }
	  },
	  created: function() {
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    return this.loadContacts();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes, helpers.filters);


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      default_user: Session.current_user,
	      current_day: true,
	      current_date: new Date,
	      height: 0,
	      loading: true,
	      hours: [
	        {
	          hour: 0,
	          events: []
	        }, {
	          hour: 1,
	          events: []
	        }, {
	          hour: 2,
	          events: []
	        }, {
	          hour: 3,
	          events: []
	        }, {
	          hour: 4,
	          events: []
	        }, {
	          hour: 5,
	          events: []
	        }, {
	          hour: 6,
	          events: []
	        }, {
	          hour: 7,
	          events: []
	        }, {
	          hour: 8,
	          events: []
	        }, {
	          hour: 9,
	          events: []
	        }, {
	          hour: 10,
	          events: []
	        }, {
	          hour: 11,
	          events: []
	        }, {
	          hour: 12,
	          events: []
	        }, {
	          hour: 13,
	          events: []
	        }, {
	          hour: 14,
	          events: []
	        }, {
	          hour: 15,
	          events: []
	        }, {
	          hour: 16,
	          events: []
	        }, {
	          hour: 17,
	          events: []
	        }, {
	          hour: 18,
	          events: []
	        }, {
	          hour: 19,
	          events: []
	        }, {
	          hour: 20,
	          events: []
	        }, {
	          hour: 21,
	          events: []
	        }, {
	          hour: 22,
	          events: []
	        }, {
	          hour: 23,
	          events: []
	        }
	      ],
	      search_date: new Date
	    };
	  },
	  watch: {
	    height: function() {
	      return this.newHeight();
	    }
	  },
	  methods: {
	    loadEvents: function() {
	      var hour, i, len, params, ref;
	      if (!this.valid_calendar_id) {
	        return this.loading = false;
	      }
	      ref = this.hours;
	      for (i = 0, len = ref.length; i < len; i++) {
	        hour = ref[i];
	        hour.events = [];
	      }
	      params = {
	        starts_after: Math.floor(this.search_date.setHours(0, 0, 0, 0) / 1000),
	        ends_before: Math.floor(this.search_date.setHours(23, 59, 59, 999) / 1000)
	      };
	      this.loading = true;
	      return jQuery.ajax({
	        url: ("https://api.nylas.com") + ("/events?expand_recurring=true&starts_after=" + params.starts_after + "&ends_before=" + params.ends_before + "&calendar_id=" + this.current_user.nylas_setting.calendar_id),
	        type: 'GET',
	        headers: {
	          'Authorization': this.current_user.nylas_setting.access_token
	        },
	        success: this.successLoadEvents,
	        error: this.failureLoadEvents
	      });
	    },
	    newHeight: function() {
	      if (this.valid_calendar_id) {
	        return this.height = window.innerHeight - 215;
	      } else {
	        return this.height = window.innerHeight - 118;
	      }
	    },
	    successLoadEvents: function(response) {
	      var end_time, event, i, len, start_time;
	      for (i = 0, len = response.length; i < len; i++) {
	        event = response[i];
	        if (!event.when.start_time) {
	          event.when.start_time = event.when.time;
	        }
	        start_time = new Date(event.when.start_time * 1000);
	        this.hours[start_time.getHours()].events = [];
	        this.hours[start_time.getHours()].events.push(event);
	        if (!event.when.end_time) {
	          event.when.end_time = event.when.time + 1800;
	        }
	        end_time = new Date(event.when.end_time * 1000);
	        event.start_time = this.pad(start_time.getHours()) + ":" + this.pad(start_time.getMinutes());
	        event.end_time = this.pad(end_time.getHours()) + ":" + this.pad(end_time.getMinutes());
	        event.height = 50;
	        event.length = end_time.getHours() - start_time.getHours();
	        if (end_time.getMinutes() > 0) {
	          event.length += 1;
	        }
	        event.size = event.length;
	      }
	      return this.loading = false;
	    },
	    failureLoadEvents: function() {
	      Loader.off();
	      return this.loading = false;
	    },
	    changeDay: function(day) {
	      this.search_date.setDate(this.search_date.getDate() + day);
	      this.current_day = this.search_date.getDate() === this.current_date.getDate();
	      this.loadEvents();
	      return EventsBus.$emit('manualtask-form::date', this.search_date);
	    },
	    pad: function(number) {
	      if (number < 10) {
	        number = '0' + number;
	      }
	      return number;
	    },
	    redirect: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: this.current_user.id,
	        undo_nylas_connection: true
	      };
	      return new UsersResource().update(this.updateNylasConnectionSuccess, this.webHookErrors, params);
	    },
	    updateNylasConnectionSuccess: function() {
	      return window.location = this.nylasOauthUrl();
	    },
	    nylasOauthUrl: function() {
	      var params;
	      params = jQuery.param({
	        client_id: ("8ipcwu19ld095jfh10kfh06ra"),
	        response_type: 'code',
	        scopes: ("email.send,email.read_only,calendar"),
	        login_hint: this.current_user.email,
	        redirect_uri: window.location.protocol + "//" + window.location.host + "/configuracoes/integracoes",
	        state: 'nylas'
	      });
	      return "https://api.nylas.com/oauth/authorize?" + params;
	    },
	    changeUser: function(data) {
	      this.current_user = data.user;
	      return this.loadEvents();
	    },
	    changeDate: function(date) {
	      this.search_date = date;
	      return this.loadEvents();
	    }
	  },
	  computed: {
	    valid_calendar_id: function() {
	      var ref;
	      return (ref = this.current_user.nylas_setting) != null ? ref.calendar_id : void 0;
	    },
	    weekday: function() {
	      return this.search_date.toLocaleDateString('bt-br', {
	        weekday: 'long'
	      });
	    }
	  },
	  created: function() {
	    EventsBus.$on('daily-events::user', this.changeUser);
	    return EventsBus.$on('daily-events::date', this.changeDate);
	  },
	  mounted: function() {
	    window.addEventListener('resize', this.newHeight);
	    this.height = window.innerHeight;
	    return this.loadEvents();
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('daily-events::user', this.changeUser);
	    return EventsBus.$off('daily-events::date', this.changeDate);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['filters'],
	  components: {
	    verticalBar: __webpack_require__(164)
	  },
	  data: function() {
	    return {
	      done_tasks_data: {}
	    };
	  },
	  methods: {
	    loadDoneTasksData: function(filters) {
	      if (filters == null) {
	        filters = {};
	      }
	      return this.reports_resource.doneTasks(this.loadDoneTasksDataSuccess, this.unkonwnError, {
	        params: {
	          q: filters
	        }
	      });
	    },
	    loadDoneTasksDataSuccess: function(data) {
	      return this.done_tasks_data = data.body;
	    },
	    increase: function(service) {
	      return Vue.set(this.done_tasks_data, service, (this.done_tasks_data[service] ? this.done_tasks_data[service] + 1 : 1));
	    },
	    decrease: function(service) {
	      return Vue.set(this.done_tasks_data, service, (this.done_tasks_data[service] ? this.done_tasks_data[service] - 1 : 0));
	    }
	  },
	  computed: {
	    total_quantity: function() {
	      return this.done_tasks_list.reduce((function(sum, task_data) {
	        return sum + task_data[1];
	      }), 0);
	    },
	    done_tasks_list: function() {
	      var i, len, ref, results, task_service;
	      ref = Task.availableManualTaskServices;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        task_service = ref[i];
	        results.push([task_service.service, this.done_tasks_data[task_service.service] || 0, Task.serviceIcons[task_service.service]]);
	      }
	      return results;
	    }
	  },
	  created: function() {
	    this.reports_resource = new ReportsResource(Session.current_company.id);
	    return this.loadDoneTasksData();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    list: __webpack_require__(152)
	  },
	  props: ['users_options'],
	  data: function() {
	    return {
	      user_filter: null
	    };
	  },
	  methods: {
	    reloadTasks: function() {
	      return this.$nextTick((function(_this) {
	        return function() {
	          return _this.$refs.done_tasks_list.reloadTasks();
	        };
	      })(this));
	    }
	  },
	  computed: {
	    show_user_filter: function() {
	      return !Session.current_user.isSeller();
	    },
	    done_today_filters: function() {
	      var filters;
	      filters = {};
	      filters.done = true;
	      if (Session.current_user.isSeller()) {
	        filters.assigned_to_id_eq = Session.current_user.id;
	      } else {
	        filters = Object.assign({}, filters, this.user_filter || {});
	        if (this.user_filter) {
	          filters.assigned_to_id_eq = this.user_filter.user_id_eq;
	        }
	      }
	      filters.done_at_gteq = this.start_of_day;
	      filters.done_at_lteq = this.end_of_day;
	      filters.s = ['done_at desc'];
	      return filters;
	    }
	  },
	  created: function() {
	    this.current_user = Session.current_user;
	    this.tasks_resources = new TasksResource;
	    this.end_of_day = moment().endOf('day').toJSON().replace('Z', '') + '999Z';
	    return this.start_of_day = moment().startOf('day').toJSON();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  props: ['filters'],
	  components: {
	    doneTaskItem: __webpack_require__(153)
	  },
	  data: function() {
	    return {
	      tasks: [],
	      loading: false,
	      next_page: 1
	    };
	  },
	  methods: {
	    handleToggleDoneEvent: function(task) {
	      if (task.isDone()) {
	        return this.tasks.remove(task.id);
	      } else {
	        return this.tasks.push(task);
	      }
	    },
	    taskUpdated: function(task) {
	      if (task.isDone()) {
	        return;
	      }
	      this.tasks.remove(task.id);
	      return EventsBus.$emit('Task::Undone', task);
	    },
	    loadTasks: function() {
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      return this.tasks_resource.index(this.loadTasksSuccess, this.unknownError, {
	        params: {
	          q: this.filters,
	          page: this.next_page
	        }
	      });
	    },
	    addTask: function(task) {
	      return this.tasks.unshift(task);
	    },
	    reloadTasks: function() {
	      this.loading = false;
	      this.next_page = 1;
	      this.tasks = [];
	      return this.loadTasks();
	    },
	    loadTasksSuccess: function(data) {
	      this.tasks = this.tasks.concat(data.tasks);
	      this.next_page = data.meta.next_page;
	      return this.loading = false;
	    },
	    sort: function(task_1, task_2) {
	      return task_1.done_at.isAfter(task_2.done_at) && 1 || -1;
	    }
	  },
	  watch: {
	    filters: function() {
	      return this.loadTasks();
	    }
	  },
	  created: function() {
	    this.tasks_resource = new TasksResource;
	    this.loadTasks();
	    return EventsBus.$on('Task::Done', this.addTask);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('Task::Done', this.addTask);
	  }
	};


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['task', 'options', 'origem'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      tooltip_text: this.task.comment,
	      element_options: {
	        show_date: false,
	        show_contact: true,
	        show_comment: true,
	        icon_position: 'text',
	        padding: 'sm'
	      }
	    };
	  },
	  watch: {
	    task: function(new_value, old_value) {
	      return this.$refs.element_id.setAttribute('data-original-title', new_value.comment);
	    }
	  },
	  created: function() {
	    this.tasks_resources = new TasksResource;
	    return this.mergeDefaultOptions();
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.manual_tasks.list_item_wrapper, helpers.form, helpers.filters);


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  mixins: [__webpack_require__(6)],
	  props: ['filters'],
	  data: function() {
	    return {
	      users_options: [
	        {
	          value: null,
	          text: 'Carregando...'
	        }
	      ],
	      user_filter: this.extractFilter('user_id_eq'),
	      task_type_options: this.taskTypeOptions(),
	      task_type_filter: this.extractFilter('service_eq'),
	      search_contact_filter: this.filters.search_contacts
	    };
	  },
	  computed: {
	    show_user_filter: function() {
	      return !Session.current_user.isSeller();
	    }
	  },
	  methods: {
	    defaultFilters: function() {
	      var filters;
	      filters = Object.assign({}, this.user_filter || {});
	      if (this.user_filter) {
	        filters.assigned_to_id_eq = this.user_filter.user_id_eq;
	      }
	      if (this.search_contact_filter) {
	        filters.search_contacts = this.search_contact_filter;
	      }
	      if (this.task_type_filter) {
	        filters.service_eq = this.task_type_filter.service_eq;
	      }
	      filters.done_at_null = true;
	      filters.s = ['due_on asc', 'id desc'];
	      return filters;
	    },
	    filterUrlParams: function() {
	      var key, permited_keys, ref, url_params, value;
	      url_params = {};
	      permited_keys = ['service_eq', 'search_contacts'];
	      if (!Session.current_user.isSeller()) {
	        permited_keys.push('user_id_eq');
	      }
	      ref = this.defaultFilters();
	      for (key in ref) {
	        value = ref[key];
	        if (value == null) {
	          continue;
	        }
	        if (key === 'service_eq') {
	          value = value.split('::').last();
	        }
	        if (permited_keys.includes(key)) {
	          url_params[key] = value;
	        }
	      }
	      return url_params;
	    },
	    reloadTasks: function() {
	      this.applyFiltersOnUrlQueryParams(this.filterUrlParams());
	      return this.$emit('filter', this.defaultFilters());
	    },
	    taskTypeOptions: function() {
	      var options;
	      options = Task.availableManualTaskServices.map(function(option) {
	        return {
	          value: {
	            service_eq: option.service
	          },
	          text: option.human_name
	        };
	      });
	      options.unshift({
	        value: null,
	        text: 'Todas as tarefas'
	      });
	      return options;
	    }
	  },
	  watch: {
	    user_filter: function() {
	      return IntercomCtrl.trackEvent('Uso do filtro de usuários para as atividades pendentes');
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.manual_tasks.list_wrapper, helpers.form, helpers.filters);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['task', 'contact', 'can_change_contact', 'origem', 'show_stage_selection'],
	  mixins: [__webpack_require__(6)],
	  components: {
	    contactPicker: __webpack_require__(37)
	  },
	  data: function() {
	    return {
	      due_on_date: new Date,
	      due_on_time: null,
	      end_on_time: null,
	      social_link: '',
	      height: 0,
	      email_invites: [],
	      meeting_types: [],
	      cc_text: '',
	      send_reminder: false,
	      user_filter: {
	        user_id_eq: Session.current_user.id.toString()
	      },
	      users_options: [
	        {
	          value: null,
	          text: 'Carregando...'
	        }
	      ],
	      users: [],
	      new_stage: null
	    };
	  },
	  methods: {
	    emitOpenTemplateModalEvent: function() {
	      event.originalEventName = 'open-template-modal';
	      return this.$emit('open-template-modal', {
	        event: event,
	        task: this.task
	      });
	    },
	    setDueOn: function(update_end_on) {
	      var end_on, parts;
	      if (update_end_on == null) {
	        update_end_on = false;
	      }
	      if (!this.due_on_date) {
	        return;
	      }
	      if (!this.due_on_time) {
	        this.task.undefined_time = true;
	        this.task.due_on = moment(this.due_on_date).hours("23").minutes("59");
	        this.task.end_on = '';
	      } else {
	        parts = this.due_on_time.split(':');
	        this.task.due_on = moment(this.due_on_date).hours(parts[0]).minutes(parts[1]);
	        parts = this.end_on_time.split(':');
	        this.task.end_on = moment(this.due_on_date).hours(parts[0]).minutes(parts[1]);
	        if (update_end_on) {
	          end_on = this.task.due_on.clone();
	          this.due_on_date = end_on.toDate();
	          this.end_on_time = end_on.add(1, 'hour').format('HH:mm');
	          parts = this.end_on_time.split(':');
	          this.task.end_on = moment(this.due_on_date).hours(parts[0]).minutes(parts[1]);
	        }
	        this.task.undefined_time = false;
	      }
	      return EventsBus.$emit('daily-events::date', this.due_on_date);
	    },
	    save: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function() {
	          _this.blurCc();
	          if (_this.task.metadata == null) {
	            _this.task.metadata = {};
	          }
	          _this.task.metadata.email_invites = _this.email_invites;
	          Loader.on();
	          _this.task_was_persisted = _this.task.isPersisted();
	          if (!_this.task.isPersisted()) {
	            _this.task.assigned_to_id = Session.current_user.id;
	          }
	          if (_this.user_filter.user_id_eq && _this.task.isMeetingTask()) {
	            _this.task.assigned_to_id = _this.user_filter.user_id_eq;
	          }
	          if (_this.show_stage_selection && _this.new_stage !== _this.contact.stage) {
	            _this.task.new_contact_stage = _this.new_stage;
	          }
	          _this.setContact();
	          return _this.tasks_resources.save(_this.saveSuccess, _this.unknownError, _this.task);
	        };
	      })(this));
	    },
	    saveSuccess: function(resources) {
	      var action_description;
	      Loader.off();
	      action_description = this.task.isPersisted() ? 'Edição de tarefa' : 'Criação de tarefa';
	      if (this.origem == null) {
	        this.origem = 'Base de contatos ';
	      }
	      IntercomCtrl.trackEvent(this.origem + "Contato - " + action_description, {
	        'Identificador do contato': this.contact.id
	      });
	      EventsBus.$emit('TaskModalForm::Hide');
	      if (this.task_was_persisted) {
	        return EventsBus.$emit('Task::Updated', {
	          task: resources.task
	        });
	      } else {
	        EventsBus.$emit('Task::Created', {
	          task: resources.task
	        });
	        if (this.send_reminder) {
	          window.task = resources.task;
	          window.event = {};
	          window.event.originalEventName = 'Compose::Open::Schedule::Meeting';
	          return EventsBus.$emit('Compose::Open', {
	            event: window.event,
	            task: window.task
	          });
	        }
	      }
	    },
	    setContact: function() {
	      if (!this.contact) {
	        return;
	      }
	      this.task.referenceable_type = 'Contact';
	      return this.task.referenceable_id = this.contact.id;
	    },
	    toActivities: function() {
	      return this.$router.push({
	        path: "/configuracoes/atividades"
	      });
	    },
	    blurCc: function() {
	      var last_index;
	      last_index = this.cc_text.length - 1;
	      if (this.cc_text[last_index] === ',' || this.cc_text[last_index] === '' || this.cc_text[last_index] === ' ') {
	        return;
	      }
	      return this.cc_text += " ";
	    },
	    removeEmail: function(index) {
	      return this.email_invites.splice(index, 1);
	    },
	    checkboxSendReminder: function() {
	      return this.send_reminder = !this.send_reminder;
	    },
	    newHeight: function() {
	      return this.height = window.innerHeight - 300;
	    },
	    changeDate: function(date) {
	      this.due_on_date = date;
	      return this.setDueOn();
	    }
	  },
	  computed: {
	    availableManualTaskServices: function() {
	      var self;
	      self = this;
	      return Task.availableManualTaskServices.filter(function(manual_task) {
	        if (!manual_task.service) {
	          return false;
	        }
	        if (self.task && !self.task.isCreatedByUser() && manual_task.service === 'ManualTasksServices::Meeting') {
	          return false;
	        }
	        return true;
	      });
	    },
	    valid_due_on: function() {
	      return this.task && this.task.due_on && this.task.due_on.isValid && this.task.due_on.isValid();
	    },
	    modal_title: function() {
	      if (this.task.isPersisted()) {
	        return 'EDITAR TAREFA';
	      }
	      return 'CRIAR NOVA TAREFA';
	    },
	    yesterday: function() {
	      var date;
	      date = new Date();
	      date.setDate(date.getDate() - 1);
	      return date;
	    },
	    show_meeting_task: function() {
	      if (this.task.isMeetingTask()) {
	        return true;
	      }
	      this.social_link = '';
	      this.email_invites = [];
	      this.end_on_time = "" + this.end_on_time;
	      return false;
	    },
	    next_valid_stages: function() {
	      var options, self;
	      if (!this.contact) {
	        return [];
	      }
	      self = this;
	      options = Object.keys(this.contact.next_valid_stages).map(function(stage) {
	        return {
	          value: stage,
	          text: self.contact.next_valid_stages[stage].human_name
	        };
	      });
	      options.push({
	        value: this.contact.stage,
	        text: this.contact.human_stage
	      });
	      return options;
	    }
	  },
	  watch: {
	    height: function() {
	      return this.newHeight();
	    },
	    due_on_date: function() {
	      return this.setDueOn();
	    },
	    due_on_time: function() {
	      return this.setDueOn(true);
	    },
	    end_on_time: function() {
	      return this.setDueOn();
	    },
	    task: function() {
	      if (this.task.due_on) {
	        this.due_on_date = this.task.due_on.toDate();
	        if (!this.task.undefined_time) {
	          return this.due_on_time = this.task.due_on.format('HH:mm');
	        }
	      }
	    },
	    social_link: function(value) {
	      if (this.task.metadata == null) {
	        this.task.metadata = {};
	      }
	      return this.task.metadata.social_link = value;
	    },
	    cc_text: function(text) {
	      var email, last_index;
	      last_index = text.length - 1;
	      if (text[last_index] === ',' || text[last_index] === '' || text[last_index] === ' ') {
	        email = text.substring(0, last_index);
	        if (this.validateEmail(email)) {
	          this.email_invites.push({
	            email: email
	          });
	          return this.cc_text = '';
	        }
	      }
	    },
	    user_filter: function() {
	      var user, user_id;
	      user_id = this.user_filter.user_id_eq;
	      user = this.users.find(function(user) {
	        return user.id.toString() === user_id;
	      });
	      return EventsBus.$emit('daily-events::user', {
	        user: user
	      });
	    },
	    contact: function() {
	      if (this.show_stage_selection) {
	        return this.new_stage = this.contact.stage;
	      }
	    }
	  },
	  created: function() {
	    this.tasks_resources = new TasksResource;
	    this.meeting_types = this.$store.getters.meetingTypesList;
	    this.users = this.$store.getters.usersList;
	    EventsBus.$on('manualtask-form::date', this.changeDate);
	    if (this.show_stage_selection) {
	      return this.new_stage = this.contact.stage;
	    }
	  },
	  mounted: function() {
	    var due_on, end_on;
	    window.addEventListener('resize', this.newHeight);
	    this.height = window.innerHeight;
	    due_on = this.task.due_on.clone();
	    end_on = this.task.end_on.clone();
	    this.due_on_date = due_on.toDate();
	    this.end_on_date = end_on.toDate();
	    if (!this.task.undefined_time) {
	      this.due_on_time = due_on.format('HH:mm');
	    }
	    if (!this.task.undefined_time) {
	      this.end_on_time = end_on.format('HH:mm');
	    }
	    if (this.task.isMeetingTask()) {
	      this.social_link = this.task.metadata.social_link;
	      this.email_invites = this.task.metadata.email_invites || [];
	      end_on = this.task.end_on.clone();
	      this.end_on_date = end_on.toDate();
	      this.end_on_time = end_on.format('HH:mm');
	      this.user_filter = {
	        user_id_eq: this.task.assigned_to_id.toString()
	      };
	    }
	    jQuery('[data-toggle="tooltip"]').tooltip('destroy');
	    return jQuery('[data-toggle="tooltip"]').tooltip();
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('manualtask-form::date', this.changeDate);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  mixins: [__webpack_require__(6)],
	  components: {
	    filters: __webpack_require__(154),
	    calendar: __webpack_require__(149),
	    liveFeed: __webpack_require__(155),
	    taskModalForm: __webpack_require__(17),
	    doneTasks: __webpack_require__(150),
	    taskList: __webpack_require__(61),
	    taskItem: __webpack_require__(62),
	    pausedContacts: __webpack_require__(162),
	    statisticCards: __webpack_require__(163),
	    doneTasksFeed: __webpack_require__(151),
	    ozzyTasks: __webpack_require__(160),
	    meetingModal: __webpack_require__(71)
	  },
	  data: function() {
	    return {
	      users_options: [
	        {
	          value: null,
	          text: 'Carregando...'
	        }
	      ],
	      filters: {},
	      today_filter: {},
	      overdue_filter: {},
	      future_filter: {},
	      number_of_overdue_tasks: '0',
	      number_of_future_tasks: '0',
	      number_of_today_tasks: '0',
	      selected_task: new Task,
	      current_user: Session.current_user,
	      contact: {},
	      show_meeting_modal: false
	    };
	  },
	  methods: {
	    emitOpenCompose: function() {
	      event.originalEventName = 'Compose::Open';
	      return EventsBus.$emit('Compose::Open', {
	        event: event
	      });
	    },
	    toggleTaskBar: function(data) {
	      return EventsBus.$emit('toggle-task-bar', {
	        contact_id: data.contact.id,
	        task: data.task,
	        open_comment: data.open_comment
	      });
	    },
	    numberOfFutureTasks: function(value) {
	      return this.number_of_future_tasks = value;
	    },
	    numberOfOverdueTasks: function(value) {
	      return this.number_of_overdue_tasks = value;
	    },
	    numberOfTodayTasks: function(value) {
	      return this.number_of_today_tasks = value;
	    },
	    openTaskModalForm: function() {
	      return EventsBus.$emit('TaskModalForm::Show', {
	        task_id: null,
	        contact: null,
	        id: 'manual-task-form-modal'
	      });
	    },
	    openModalForm: function(data) {
	      return EventsBus.$emit('TaskModalForm::Show', {
	        task_id: data.task.id,
	        contact: null,
	        id: 'manual-task-form-modal'
	      });
	    },
	    openMeetingModal: function(data) {
	      this.selected_task = data.task;
	      return this.show_meeting_modal = true;
	    },
	    closeMeetingModal: function() {
	      this.selected_task = new Task;
	      return this.show_meeting_modal = false;
	    },
	    removeTask: function(data) {
	      var task;
	      task = data.task;
	      this.$refs.today_tasks.removeTask(task);
	      this.$refs.overdue_tasks.removeTask(task);
	      if (task.due_on.isBefore(moment().endOf('day')) && task.due_on.isAfter(moment().startOf('day'))) {
	        return this.$refs.statistic_cards.decreaseTodayTasks(task);
	      }
	    },
	    taskCreated: function(data) {
	      var metadata;
	      metadata = {
	        'Tipo de tarefa': data.task.text
	      };
	      IntercomCtrl.trackEvent('Tarefa criada a partir da área de tarefas', metadata);
	      if (data.task.due_on.isBefore(moment().endOf('day')) || data.task.undefined_time) {
	        if (data.task.due_on.isAfter(moment().startOf('day'))) {
	          this.$refs.today_tasks.addTask(data.task);
	          return this.$refs.statistic_cards.increaseTodayTasks(data.task);
	        } else {
	          return this.$refs.overdue_tasks.addTask(data.task);
	        }
	      }
	    },
	    reloadTasks: function() {
	      return this.$nextTick((function(_this) {
	        return function() {
	          _this.$refs.today_tasks.reloadTasks();
	          _this.$refs.overdue_tasks.reloadTasks();
	          return _this.$refs.future_tasks.reloadTasks();
	        };
	      })(this));
	    },
	    moment: function() {
	      return moment();
	    },
	    filter: function(filters) {
	      this.filters = filters;
	      this.setTodayFilter();
	      this.setOverdueFilter();
	      this.setFutureFilter();
	      return this.reloadTasks();
	    },
	    primaryFilter: function() {
	      var primary;
	      primary = {
	        s: ['due_on asc', 'id desc'],
	        done_at_null: true,
	        assigned_to_id_eq: this.filters.user_id_eq
	      };
	      if (!Session.current_user.isSeller()) {
	        return primary;
	      }
	      return Object.assign(primary, {
	        assigned_to_id_eq: Session.current_user.id
	      });
	    },
	    setTodayFilter: function() {
	      var interval;
	      interval = {
	        due_on_gteq: this.start_of_day,
	        due_on_lteq: this.end_of_day
	      };
	      return this.today_filter = Object.assign(this.primaryFilter(), this.filters, interval);
	    },
	    setOverdueFilter: function() {
	      var interval;
	      interval = {
	        due_on_lt: this.start_of_day
	      };
	      return this.overdue_filter = Object.assign(this.primaryFilter(), this.filters, interval);
	    },
	    setFutureFilter: function() {
	      var interval;
	      interval = {
	        due_on_gt: this.end_of_day
	      };
	      return this.future_filter = Object.assign(this.primaryFilter(), this.filters, interval);
	    },
	    setFiltersFromQueryParamsLocal: function() {
	      this.filters = this.$router.currentRoute.query;
	      if (this.filters.service_eq) {
	        this.filters.service_eq = "ManualTasksServices::" + this.filters.service_eq;
	      }
	      if (Session.current_user.isSeller()) {
	        this.filters.user_id_eq = null;
	      }
	      return this.filters;
	    }
	  },
	  created: function() {
	    this.tasks_resources = new TasksResource;
	    this.end_of_day = moment().endOf('day').toJSON().replace('Z', '') + '999Z';
	    this.start_of_day = moment().startOf('day').toJSON();
	    this.setFiltersFromQueryParamsLocal();
	    this.setTodayFilter();
	    this.setOverdueFilter();
	    this.setFutureFilter();
	    EventsBus.$on('Task::Edit', this.openModalForm);
	    EventsBus.$on('Task::Created', this.taskCreated);
	    EventsBus.$on('meeting-modal-show', this.openMeetingModal);
	    if (this.$store.getters.meetingTypesCount === 0) {
	      this.$store.dispatch('fetchMeetingTypes');
	    }
	    if (this.$store.getters.lostReasonsCount === 0) {
	      return this.$store.dispatch('fetchLostReasons');
	    }
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('Task::Edit', this.openModalForm);
	    EventsBus.$off('Task::Created', this.taskCreated);
	    return EventsBus.$off('meeting-modal-show', this.openMeetingModal);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.manual_tasks.list_wrapper, helpers.form, helpers.filters);


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  props: {
	    filters: {},
	    item_options: {},
	    item_class: {},
	    options: {},
	    prop_tooltip_placement: {
	      "default": null
	    },
	    origem: {
	      "default": 'Tarefas'
	    },
	    sort: {
	      "default": function() {
	        return function(task_1, task_2) {
	          var duration, endTime, startTime;
	          startTime = moment(task_1.due_on);
	          endTime = moment(task_2.due_on);
	          duration = moment.duration(startTime.diff(endTime));
	          if (duration.asMilliseconds() > 0) {
	            return task_1.due_on.isAfter(task_2.due_on) && 1 || -1;
	          } else {
	            return task_1.id > task_2.id && 1 || -1;
	          }
	        };
	      }
	    }
	  },
	  components: {
	    taskItem: __webpack_require__(62)
	  },
	  data: function() {
	    return {
	      tasks: [],
	      loading: false,
	      next_page: 1,
	      total_count: 0,
	      disable_infinite_scroll: false,
	      current_company: Session.current_company,
	      element_options: {
	        tasks_status: 'all'
	      }
	    };
	  },
	  methods: {
	    handleToggleDoneEvent: function(task) {
	      if (task.isDone()) {
	        return this.tasks.remove(task.id);
	      } else {
	        return this.tasks.push(task);
	      }
	    },
	    tasksList: function() {
	      return this.tasks;
	    },
	    loadTasks: function() {
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      return this.tasks_resource.index(this.loadTasksSuccess, this.unknownError, {
	        params: {
	          q: this.filters,
	          company_id: this.current_company.id,
	          page: this.next_page
	        }
	      });
	    },
	    reloadTasks: function() {
	      this.loading = false;
	      this.next_page = 1;
	      this.tasks = [];
	      return this.loadTasks();
	    },
	    loadTasksSuccess: function(data) {
	      this.tasks = this.tasks.concat(data.tasks);
	      this.loading = false;
	      if (data.meta) {
	        this.next_page = data.meta.next_page;
	        this.total_count = data.meta.total_count;
	        return this.$emit('number-of-tasks', this.total_count);
	      }
	    },
	    taskUpdated: function(task) {
	      if (!task.isDone()) {
	        return;
	      }
	      return EventsBus.$emit('Task::Done', task);
	    },
	    updateTasksList: function(data) {
	      if (!data.task.isDone()) {
	        return this.tasks.replaceById(data.task);
	      }
	    },
	    updateMetadata: function(task) {
	      var old_task;
	      if (task.isDone()) {
	        return;
	      }
	      old_task = this.tasks.find(task.id);
	      if (old_task) {
	        old_task.metadata = task.metadata;
	        old_task.due_on = task.due_on;
	        return this.tasks.replaceById(old_task);
	      }
	    },
	    canAddTaskToList: function(task) {
	      if (this.tasks.findIndex(task.id) > -1) {
	        return;
	      }
	      switch (this.element_options.tasks_status) {
	        case 'today':
	          return task.isDueToday();
	        case 'overdue':
	          return task.isOverdue() && !task.isDueToday();
	        default:
	          return true;
	      }
	    },
	    addTask: function(task) {
	      if (!this.canAddTaskToList(task)) {
	        return;
	      }
	      this.tasks.push(task);
	      this.total_count++;
	      return this.$emit('number-of-tasks', this.total_count);
	    },
	    removeTask: function(task) {
	      var ref;
	      if ((!((ref = task.metadata) != null ? ref.ozzy : void 0) && this.tasks.remove(task.id)) && task.id) {
	        this.total_count--;
	        return this.$emit('number-of-tasks', this.total_count);
	      }
	    },
	    mergeDefaultOptions: function() {
	      return this.element_options = Object.assign({}, this.element_options, this.options || {});
	    },
	    initializeTasksResource: function() {
	      var contact_id;
	      contact_id = this.filters.filter_by_contact_id;
	      if (!contact_id) {
	        return new TasksResource;
	      }
	      this.disable_infinite_scroll = true;
	      return new ContactTasksResource(contact_id);
	    }
	  },
	  computed: {
	    sorted_tasks: function() {
	      return this.tasks.sort(this.sort);
	    }
	  },
	  created: function() {
	    this.mergeDefaultOptions();
	    this.tasks_resource = this.initializeTasksResource();
	    this.loadTasks();
	    EventsBus.$on('Task::Undone', this.addTask);
	    EventsBus.$on('Task::Done', this.removeTask);
	    EventsBus.$on('Task::Remove', this.removeTask);
	    EventsBus.$on('Task::Updated', this.updateTasksList);
	    return EventsBus.$on('Task::UpdatedMetadata', this.updateMetadata);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('Task::Undone', this.addTask);
	    EventsBus.$off('Task::Done', this.removeTask);
	    EventsBus.$off('Task::Remove', this.removeTask);
	    EventsBus.$off('Task::Updated', this.updateTasksList);
	    return EventsBus.$off('Task::UpdatedMetadata', this.updateMetadata);
	  }
	};


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['task', 'options', 'origem', 'type', 'prop_tooltip_placement'],
	  components: {
	    confirm: __webpack_require__(70)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      tooltip_text: this.task.comment,
	      tooltip_placement: 'right',
	      element_options: {
	        show_date: false,
	        show_contact: true,
	        show_comment: true,
	        icon_position: 'text',
	        padding: 'sm'
	      }
	    };
	  },
	  computed: {
	    total_open: function() {
	      var ref, ref1;
	      return ((ref = this.task.contact) != null ? (ref1 = ref.interactions_with_current_flow) != null ? ref1.total_open : void 0 : void 0) || "-";
	    },
	    total_delivery: function() {
	      var ref, ref1;
	      return ((ref = this.task.contact) != null ? (ref1 = ref.interactions_with_current_flow) != null ? ref1.total_delivery : void 0 : void 0) || "-";
	    },
	    confirmTaskId: function() {
	      return "confirm-task-done-" + this.task.id;
	    },
	    showConfirmationModal: function() {
	      return this.task.service === 'ManualTasksServices::Email';
	    },
	    showComposeMeeting: function() {
	      return this.task.service === 'ManualTasksServices::Meeting';
	    }
	  },
	  methods: {
	    iconClass: function() {
	      switch (this.task.service) {
	        case 'ManualTasksServices::Email':
	          return 'email-send-icon';
	        case 'ManualTasksServices::Phonecall':
	          return 'hidden';
	        case 'ManualTasksServices::Linkedin':
	          return 'linkedin-icon';
	        case 'ManualTasksServices::Social':
	          return 'social-icon';
	        case 'ManualTasksServices::Meeting':
	          return 'meeting-icon';
	        default:
	          return 'email-send-icon';
	      }
	    }
	  },
	  watch: {
	    task: function(new_value, old_value) {
	      return this.$refs.element_id.setAttribute('data-original-title', new_value.comment);
	    }
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  },
	  created: function() {
	    var ref, ref1;
	    if (this.prop_tooltip_placement != null) {
	      this.tooltip_placement = this.prop_tooltip_placement;
	    }
	    if (((ref = this.type) != null ? ref.tasks_status : void 0) === "overdue" || ((ref1 = this.type) != null ? ref1.tasks_status : void 0) === "future") {
	      this.tooltip_placement = "left";
	    }
	    EventsBus.$on('voip-call-complete', this.registerVoipCall);
	    this.tasks_resources = new TasksResource;
	    return this.mergeDefaultOptions();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.manual_tasks.list_item_wrapper, helpers.form, helpers.filters);


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  props: ['users_options'],
	  components: {
	    liveFeedEventListItem: __webpack_require__(156)
	  },
	  data: function() {
	    return {
	      events: [],
	      subscription: null,
	      user_filter: null,
	      current_user: Session.current_user,
	      max_events: 30,
	      loading: true
	    };
	  },
	  methods: {
	    subscribeToLiveFeedChannel: function() {
	      var ref, user_id;
	      user_id = (ref = this.user_filter) != null ? ref.user_id_eq : void 0;
	      this.removeSubscription();
	      return this.subscription = ActionCable.cable.subscriptions.create({
	        channel: 'LiveFeedChannel',
	        user_id: user_id
	      }, {
	        received: (function(_this) {
	          return function(event_data) {
	            var contact_event, ref1;
	            if ((((ref1 = _this.user_filter) != null ? ref1.user_id_eq : void 0) && event_data.user.id === _this.user_filter.user_id_eq) || _this.user_filter === null) {
	              contact_event = new ContactEvent(event_data);
	              _this.events.unshift(contact_event);
	              if (_this.events.length > _this.max_events) {
	                return _this.events.splice(-1);
	              }
	            }
	          };
	        })(this)
	      });
	    },
	    removeSubscription: function() {
	      if (this.subscription) {
	        ActionCable.cable.subscriptions.remove(this.subscription);
	      }
	      return this.subscription = null;
	    },
	    loadLiveFeedEvents: function() {
	      var filters;
	      this.events = [];
	      this.loading = true;
	      filters = this.user_filter ? {
	        user_id: this.user_filter.user_id_eq
	      } : {};
	      if (Session.current_user.extradata.new_live_feed) {
	        return this.loadNewLiveFeed();
	      }
	      return new ReportsResource(Session.current_company.id).liveFeedEvents(this.loadLiveFeedEventsSuccess, this.loadLiveFeedEventsFailure, {
	        params: {
	          q: filters
	        }
	      });
	    },
	    loadLiveFeedEventsSuccess: function(data) {
	      this.loading = false;
	      this.subscribeToLiveFeedChannel();
	      return this.events = data.events;
	    },
	    loadLiveFeedEventsFailure: function() {
	      this.loading = false;
	      return alertify.error('Ops, houve um erro ao carregar o live feed');
	    },
	    loadNewLiveFeed: function() {
	      var filters, headers, path;
	      path = "https://" + (("q5i61f583f") + (".execute-api.us-east-1.amazonaws.com/production")) + "/liveFeed";
	      headers = {
	        'authorization': ("slC2Di7IJgMDNlsirsEd33cKOwQ7PL"),
	        'x-user-token': Session.current_user.authentication_token
	      };
	      filters = {
	        company_id: Session.current_company.id
	      };
	      if (this.user_filter) {
	        filters = {
	          user_id: this.user_filter.user_id_eq
	        };
	      }
	      return jQuery.ajax({
	        url: path,
	        headers: headers,
	        data: filters,
	        success: this.loadLiveFeedSuccessNewEvents,
	        error: this.unknownError
	      });
	    },
	    loadLiveFeedSuccessNewEvents: function(resources) {
	      var count, events;
	      count = 0;
	      events = resources.events.map(function(event) {
	        event.id = ++count;
	        return new ContactEvent(event);
	      });
	      return this.loadLiveFeedEventsSuccess({
	        events: events
	      });
	    }
	  },
	  created: function() {
	    return this.loadLiveFeedEvents();
	  }
	};


/***/ }),
/* 481 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['event'],
	  data: function() {
	    return {
	      moment: moment
	    };
	  },
	  methods: {
	    liveFeedEventDescription: function() {
	      switch (this.event.detailed_type) {
	        case 'EmailEvent-open':
	          return 'leu um email';
	        case 'EmailEvent-reply':
	          return 'respondeu um email';
	        case 'EmailEvent-bounce':
	          return 'não recebeu um email';
	      }
	    },
	    toggleTaskBar: function(contact) {
	      event.originalEventName = 'toggle-task-bar';
	      return this.$emit('toggle-task-bar', {
	        event: event,
	        contact: contact
	      });
	    }
	  }
	};


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    contact: {
	      "default": null
	    },
	    id: {
	      "default": 'manual-task-form-modal'
	    }
	  },
	  components: {
	    contactPicker: __webpack_require__(37),
	    taskForm: __webpack_require__(60),
	    confirmDestroy: __webpack_require__(36),
	    dailyEvents: __webpack_require__(59)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      removing: false,
	      filter: null,
	      task: new Task,
	      selected_contact: null,
	      show_stage_selection: false,
	      add_contact: false,
	      active_contact: false,
	      activated_contacts: false,
	      connected_contact: false,
	      lost_contact: false,
	      tasksRealized: false,
	      selected: null,
	      optionsList: [],
	      valid_list: [],
	      status_options: [
	        {
	          value: 'today',
	          text: this.$t('flows.reports.time.today')
	        }, {
	          value: 'week',
	          text: this.$t('flows.reports.time.week')
	        }, {
	          value: 'month',
	          text: this.$t('flows.reports.time.month')
	        }, {
	          value: 'year',
	          text: this.$t('flows.reports.time.year')
	        }
	      ]
	    };
	  },
	  computed: {
	    show_calendar: function() {
	      return true;
	    }
	  },
	  methods: {
	    sending: function() {
	      var data, params, todos_sao_falsos;
	      data = this.getStartOfMonth(this.selected);
	      params = {
	        id: this.$route.params.id,
	        users_id: Session.current_user.id,
	        flow_id: this.$route.params.id,
	        company_id: Session.current_company.id,
	        date_start: data[0],
	        date_end: data[1],
	        options: {
	          add_contact: this.add_contact,
	          activated_contacts: this.activated_contacts,
	          active_contact: this.active_contact,
	          connected_contact: this.connected_contact,
	          lost_contact: this.lost_contact,
	          tasks_realized: this.tasksRealized
	        }
	      };
	      moment.locale('pt-br');
	      todos_sao_falsos = function(value) {
	        return value === false;
	      };
	      if (Object.values(params.options).every(todos_sao_falsos)) {
	        alertify.error("Voce precisa selecionar algum relatorio");
	        return;
	      }
	      return new FlowsResource().flow_reports(this.loadReportsSuccess, this.handleApiErrors, {
	        params: params
	      });
	    },
	
	    /*
	    getStartOfMonth:(month) ->
	      currentSelect ='01/'+month
	      startDate = new Date(new Date(currentSelect).toLocaleString("en-US", { timeZone: @current_user.timezone }));
	      startDate.setDate(1)
	      startDate.setHours(0, 0, 0);
	      d = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0)
	      endDate = new Date(new Date(new Date(d).toLocaleString("en-US", { timeZone: @current_user.timezone }) ).setHours(23, 59, 59)).toISOString()
	      return [startDate.toISOString(), endDate]
	     */
	    getStartOfMonth: function(month) {
	      var currentSelect, endDate, startDate;
	      currentSelect = '01/' + month;
	      startDate = new Date(new Date(currentSelect).toLocaleString("en-US", {
	        timeZone: this.current_user.timezone
	      }));
	      startDate.setDate(1);
	      startDate.setHours(0, 0, 0);
	      endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
	      endDate.setHours(23, 59, 59);
	      return [startDate.toISOString(), endDate.toISOString()];
	    },
	    resetSelect: function() {
	      this.add_contact = false;
	      this.active_contact = false;
	      this.activated_contacts = false;
	      this.connected_contact = false;
	      this.lost_contact = false;
	      this.tasksRealized = false;
	      jQuery('#defaultCheck1').prop("checked", false);
	      jQuery('#defaultCheck2').prop("checked", false);
	      jQuery('#defaultCheck3').prop("checked", false);
	      jQuery('#defaultCheck4').prop("checked", false);
	      jQuery('#defaultCheck5').prop("checked", false);
	      jQuery('#defaultCheck6').prop("checked", false);
	      return jQuery('#defaultCheck7').prop("checked", false);
	    },
	    monthList: function() {
	      var currentMonth, engLinst, j, k, len, len1, listMonths, month, year, yearsList;
	      moment.locale(this.current_user.extradata['language']);
	      listMonths = moment.months();
	      engLinst = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	      currentMonth = listMonths[new Date().getMonth()] + '/' + new Date().getFullYear();
	      yearsList = ['2022', '2023'];
	      for (j = 0, len = yearsList.length; j < len; j++) {
	        year = yearsList[j];
	        for (k = 0, len1 = listMonths.length; k < len1; k++) {
	          month = listMonths[k];
	          this.optionsList.push({
	            value: engLinst[listMonths.indexOf(month)] + '/' + year,
	            text: month + ' ' + year,
	            currentMonth: false,
	            valid: this.validMonths(engLinst[listMonths.indexOf(month)] + '/' + year)
	          });
	        }
	      }
	      return this.optionsList = this.optionsList.reverse();
	    },
	    validMonths: function(month) {
	      var aux, year;
	      year = month.split('/')[1];
	      if (parseInt(year) === new Date().getFullYear()) {
	        aux = new Date(month).getMonth();
	        if (new Date().getMonth() < aux) {
	          return false;
	        }
	        return true;
	      } else {
	        return true;
	      }
	    },
	    gerarListaDeAnos: function(anoInicial) {
	      var i, j, listaAnos;
	      listaAnos = [];
	      for (i = j = 0; j < 5; i = ++j) {
	        listaAnos.push(anoInicial + i);
	      }
	      return listaAnos;
	    },
	    toggleMark: function() {
	      return this.add_contact = !this.add_contact;
	    },
	    toggleactivated_contactsMark: function() {
	      return this.activated_contacts = !this.activated_contacts;
	    },
	    toggleactive_contactMark: function() {
	      return this.active_contact = !this.active_contact;
	    },
	    toggleconnected_contact: function() {
	      return this.connected_contact = !this.connected_contact;
	    },
	    togglelostContactMark: function() {
	      return this.lost_contact = !this.lost_contact;
	    },
	    toggletasksRealizedMark: function() {
	      return this.tasksRealized = !this.tasksRealized;
	    },
	    loadReportsSuccess: function(data) {
	      this.hideFlowModal();
	      return alertify.success(this.$t('flows.feedback.reportSand'));
	    },
	    showFlowModal: function(data) {
	      this.resetSelect();
	      return jQuery('#dialer-manual-flow-form-modal').modal('show');
	    },
	    hideFlowModal: function() {
	      this.resetSelect();
	      return jQuery('#dialer-manual-flow-form-modal').modal('hide');
	    }
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('ModalFlowForm::Show', this.showFlowModal);
	    return EventsBus.$off('ModalFlowForm::Hide', this.hideFlowModal);
	  },
	  mounted: function() {
	    EventsBus.$on('ModalFlowForm::Show', this.showFlowModal);
	    EventsBus.$on('ModalFlowForm::Hide', this.hideFlowModal);
	    moment.locale("en-US");
	    this.selected = moment().format('MMMM/YYYY');
	    this.monthList();
	    return this.resetSelect();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    contact: {
	      "default": null
	    },
	    id: {
	      "default": 'manual-task-form-modal'
	    }
	  },
	  components: {
	    contactPicker: __webpack_require__(37),
	    taskForm: __webpack_require__(60),
	    confirmDestroy: __webpack_require__(36),
	    dailyEvents: __webpack_require__(59)
	  },
	  data: function() {
	    return {
	      removing: false,
	      task: new Task,
	      selected_contact: null,
	      show_stage_selection: false
	    };
	  },
	  watch: {
	    task: {
	      handler: function(value) {
	        if (!this.task.isMeetingTask()) {
	          return this.resetMeetingTask();
	        }
	      },
	      deep: true
	    }
	  },
	  computed: {
	    show_calendar: function() {
	      return this.selected_contact && Session.current_user.isNylas();
	    }
	  },
	  methods: {
	    resetMeetingTask: function() {
	      this.task.meeting_type_id = null;
	      if (this.task.metadata != null) {
	        delete this.task.metadata['social_link'];
	        return delete this.task.metadata['email_invites'];
	      }
	    },
	    showTaskModal: function(data) {
	      this.buildTask(data.task_id);
	      this.selected_contact = this.contact || data.contact;
	      this.removing = false;
	      if (data.show_stage_selection) {
	        this.show_stage_selection = true;
	      }
	      if (data.id === this.id) {
	        return jQuery('#' + this.id).modal('show');
	      }
	    },
	    hideTaskModal: function() {
	      return jQuery('#' + this.id).modal('hide');
	    },
	    setSelectedContact: function(data) {
	      return this.selected_contact = data.contact;
	    },
	    taskDestroyed: function(data) {
	      this.hideTaskModal();
	      return this.$emit('destroyed', {
	        task: this.task,
	        event: data.event
	      });
	    },
	    buildTask: function(task_id) {
	      if (task_id) {
	        return this.loadTask(task_id);
	      } else {
	        return this.task = new Task({
	          created_by_type: 'User',
	          type: 'ManualTask',
	          due_on: new Date()
	        });
	      }
	    },
	    loadTask: function(task_id) {
	      Loader.on();
	      return new TasksResource().get(this.loadTaskSuccess, this.unkonwnError, {
	        id: task_id
	      });
	    },
	    loadTaskSuccess: function(data) {
	      Loader.off();
	      this.task = data.task;
	      return this.selected_contact = this.task.contact;
	    }
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('TaskModalForm::Show', this.showTaskModal);
	    return EventsBus.$off('TaskModalForm::Hide', this.hideTaskModal);
	  },
	  mounted: function() {
	    EventsBus.$on('TaskModalForm::Show', this.showTaskModal);
	    return EventsBus.$on('TaskModalForm::Hide', this.hideTaskModal);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  props: ['filters'],
	  components: {
	    ozzyTaskItem: __webpack_require__(159)
	  },
	  data: function() {
	    return {
	      tasks: [],
	      loading: false,
	      next_page: 2,
	      current_page: 1
	    };
	  },
	  methods: {
	    nextPage: function() {
	      this.loadTasks(this.next_page);
	      return this.current_page++;
	    },
	    prevPage: function() {
	      this.loadTasks(this.current_page - 1);
	      return this.current_page--;
	    },
	    taskUpdated: function(task) {
	      this.reloadTasks();
	      return EventsBus.$emit('Task::Done', task);
	    },
	    loadTasks: function(page) {
	      if (this.loading) {
	        return;
	      }
	      this.loading = true;
	      return this.tasks_resource.index(this.loadTasksSuccess, this.unknownError, {
	        params: {
	          q: this.filters,
	          page: page,
	          per: 6
	        }
	      });
	    },
	    removeTask: function() {
	      return this.reloadTasks();
	    },
	    loadTasksSuccess: function(data) {
	      this.tasks = data.tasks;
	      this.next_page = data.meta.next_page;
	      return this.loading = false;
	    },
	    reloadTasks: function() {
	      if (this.tasks.length < 2) {
	        return this.prevPage();
	      } else {
	        return this.loadTasks(this.current_page);
	      }
	    }
	  },
	  created: function() {
	    this.tasks_resource = new TasksResource;
	    this.loadTasks(this.current_page);
	    return EventsBus.$on('Task::Destroyed', this.removeTask);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('Task::Destroyed', this.removeTask);
	  }
	};


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['task', 'options', 'origem'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      element_options: {
	        show_date: false,
	        show_contact: true,
	        show_comment: true,
	        icon_position: 'text',
	        padding: 'sm'
	      }
	    };
	  },
	  computed: {
	    interaction_total_delivery: function() {
	      if (this.task.contact.interactions_with_current_flow.total_delivery === null) {
	        return '-';
	      } else {
	        return this.task.contact.interactions_with_current_flow.total_delivery;
	      }
	    },
	    interaction_total_open: function() {
	      if (this.task.contact.interactions_with_current_flow.total_open === null) {
	        return '-';
	      } else {
	        return this.task.contact.interactions_with_current_flow.total_open;
	      }
	    }
	  },
	  methods: {
	    removeTask: function() {
	      event.originalEventName = 'removing';
	      return this.$emit('removing', {
	        event: event,
	        task: this.task
	      });
	    }
	  },
	  created: function() {
	    EventsBus.$on('voip-call-complete', this.registerVoipCall);
	    this.tasks_resources = new TasksResource;
	    return this.mergeDefaultOptions();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.manual_tasks.list_item_wrapper, helpers.form, helpers.filters);


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    list: __webpack_require__(158),
	    confirmDestroy: __webpack_require__(36)
	  },
	  props: ['users_options'],
	  data: function() {
	    return {
	      task: new Task
	    };
	  },
	  methods: {
	    showConfirmDestroyModal: function(data) {
	      jQuery('#confirm-destroy-ozzy-task').modal('show');
	      return this.task = data.task;
	    },
	    cancelRemoving: function() {
	      return jQuery('#confirm-destroy-ozzy-task').modal('hide');
	    },
	    taskDestroyed: function(data) {
	      EventsBus.$emit('Task::Destroyed', data.task);
	      jQuery('#confirm-destroy-ozzy-task').modal('hide');
	      return alertify.success('Ozzy task excluída com sucesso!');
	    }
	  },
	  computed: {
	    ozzy_tasks_filters: function() {
	      var filters;
	      filters = {};
	      filters.only_ozzy = true;
	      filters.undone = true;
	      filters.assigned_to_id_eq = Session.current_user.id;
	      return filters;
	    }
	  },
	  created: function() {
	    this.current_user = Session.current_user;
	    return this.tasks_resources = new TasksResource;
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 487 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['title']
	};


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    contactList: __webpack_require__(34),
	    reactivateRecipientModal: __webpack_require__(23),
	    dashboardPanel: __webpack_require__(161)
	  },
	  props: ['users_options', 'header'],
	  data: function() {
	    return {
	      contacts: [],
	      schedule_reactivation_contact: null,
	      user_filter: null,
	      next_page: 1,
	      loading: false
	    };
	  },
	  computed: {
	    filters: function() {
	      var filters;
	      filters = this.user_filter || {};
	      filters.current_recipient_status_eq = 'converting';
	      filters.s = 'last_recipient_status_updated_at DESC';
	      return filters;
	    }
	  },
	  methods: {
	    getClass: function() {
	      if (this.header) {
	        return 'dashboard-body';
	      }
	    },
	    loadContacts: function() {
	      var params;
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      params = {
	        page: this.next_page
	      };
	      params.q = this.filters;
	      return this.contact_resource.index(this.loadContactsSuccess, this.unknownError, {
	        params: params
	      });
	    },
	    loadContactsSuccess: function(data) {
	      this.next_page = data.meta.next_page;
	      this.contacts = this.contacts.concat(data.contacts);
	      return this.loading = false;
	    },
	    reloadContacts: function() {
	      this.next_page = 1;
	      this.loading = false;
	      this.contacts = [];
	      return this.loadContacts();
	    }
	  },
	  watch: {
	    user_filter: function() {
	      return IntercomCtrl.trackEvent('Uso do filtro de usuários para os contatos pausados');
	    }
	  },
	  created: function() {
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    EventsBus.$on('Contact::ScheduleRecipientReactivation', this.openRecipientScheduleReactivationModal);
	    return EventsBus.$on('Contact::Refresh', this.refreshContact);
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('Contact::ScheduleRecipientReactivation', this.openRecipientScheduleReactivationModal);
	    return EventsBus.$off('Contact::Refresh', this.refreshContact);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters, helpers.contacts.list_view_modes, helpers.contacts.list_wrapper);


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      count_tasks_data: {},
	      loading: true
	    };
	  },
	  methods: {
	    moment: function() {
	      return moment();
	    },
	    increaseTodayTasks: function(task) {
	      return Vue.set(this.count_tasks_data, task.service, (this.count_tasks_data[task.service] || 0) + 1);
	    },
	    decreaseTodayTasks: function(task) {
	      return Vue.set(this.count_tasks_data, task.service, (this.count_tasks_data[task.service] || 0) - 1);
	    },
	    loadCountTasksData: function(filters) {
	      if (filters == null) {
	        filters = {};
	      }
	      return this.reports_resource.countTasks(this.loadCountTasksDataSuccess, this.unkonwnError, {
	        params: {
	          q: filters
	        }
	      });
	    },
	    loadCountTasksDataSuccess: function(data) {
	      this.count_tasks_data = data.body;
	      return this.loading = false;
	    }
	  },
	  computed: {
	    card_filters: function() {
	      var filters;
	      filters = {
	        period: this.period,
	        mode: 'due_on'
	      };
	      if (this.current_user.isSeller()) {
	        filters.user_id_eq = this.current_user.id;
	      }
	      return filters;
	    },
	    calls_task: function() {
	      return this.count_tasks_data.find(function(task) {
	        return task.type === 'ManualTasksServices::Phonecall';
	      }).total;
	    },
	    email_task: function() {
	      return this.count_tasks_data.find(function(task) {
	        return task.type === 'ManualTasksServices::Email';
	      }).total;
	    },
	    linkedin_task: function() {
	      return this.count_tasks_data.find(function(task) {
	        return task.type === 'ManualTasksServices::Linkedin';
	      }).total;
	    },
	    social_task: function() {
	      return this.count_tasks_data.find(function(task) {
	        return task.type === 'ManualTasksServices::Social';
	      }).total;
	    }
	  },
	  created: function() {
	    this.period = {
	      from: this.now,
	      to: this.now
	    };
	    this.reports_resource = new ReportsResource(Session.current_company.id);
	    return this.loadCountTasksData(this.card_filters);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.manual_tasks.list_wrapper, helpers.form, helpers.filters);


/***/ }),
/* 490 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: ['total', 'value', 'icon_class'],
	  computed: {
	    percentage: function() {
	      var total;
	      total = this.total || 1;
	      return parseFloat(this.value) * 100.0 / parseFloat(total) + '%';
	    }
	  }
	};


/***/ }),
/* 491 */
/***/ (function(module, exports) {

	module.exports = {
	  data: function() {
	    return {
	      is_authorized: Session.authorized
	    };
	  }
	};


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      credentials: {
	        email: '',
	        password: ''
	      },
	      pristine: true,
	      apiErrorMessages: []
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.login();
	          }
	        };
	      })(this));
	    },
	    login: function() {
	      Loader.on();
	      this.clearApiErrors();
	      return new UsersResource().login(this.loginSuccess, this.loginFailed, this.credentials);
	    },
	    loginFailed: function(response) {
	      Loader.off();
	      return this.addApiError(response.body.message);
	    },
	    loginSuccess: function() {
	      if (Session.current_user.extradata.use_new_ui) {
	        return window.location = ("https://se.reev.co") + "/auth/novo-reev";
	      } else {
	        Loader.off();
	        this.$router.push({
	          name: 'contatos/leads'
	        });
	        return MixpanelCtrl.start_session();
	      }
	    },
	    addApiError: function(message) {
	      return this.apiErrorMessages.push(message);
	    },
	    clearApiErrors: function() {
	      return this.apiErrorMessages = [];
	    }
	  },
	  created: function() {
	    var intercom;
	    intercom = new IntercomCtrl;
	    Session.addCallback('session_started', intercom.start);
	    return this.errors.clear();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      credentials: {
	        email: ''
	      },
	      pristine: true,
	      apiErrorMessages: [],
	      emailRecovered: false
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.recoverPassword();
	          }
	        };
	      })(this));
	    },
	    recoverPassword: function() {
	      Loader.on();
	      this.clearApiErrors();
	      return new UsersResource().recoverPassword(this.recoverSuccess, this.recoverFailed, this.credentials);
	    },
	    recoverSuccess: function() {
	      Loader.off();
	      return this.emailRecovered = true;
	    },
	    recoverFailed: function(response) {
	      Loader.off();
	      return this.handleApiErrors(response);
	    },
	    addApiError: function(message) {
	      return this.apiErrorMessages.push(message);
	    },
	    clearApiErrors: function() {
	      return this.apiErrorMessages = [];
	    },
	    goToLogin: function() {
	      this.emailRecovered = false;
	      return this.$router.push({
	        name: 'landing'
	      });
	    }
	  },
	  mounted: function() {
	    return this.errors.clear();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, usersResource, view_model;
	
	helpers = __webpack_require__(2);
	
	usersResource = new UsersResource;
	
	view_model = {
	  data: function() {
	    return {
	      apiErrorMessages: [],
	      token: '',
	      user: {
	        password: '',
	        password_confirmation: ''
	      }
	    };
	  },
	  methods: {
	    extractTokenIfExists: function() {
	      return this.token = this.$route.query && this.$route.query.hasOwnProperty('token') && this.$route.query.token;
	    },
	    redirectIfNoToken: function() {
	      if (!this.token) {
	        return this.$router.push({
	          name: 'landing'
	        });
	      }
	    },
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.resetPassword();
	          }
	        };
	      })(this));
	    },
	    resetPassword: function() {
	      var params;
	      Loader.on();
	      params = Object.assign({
	        reset_password_token: this.token
	      }, this.user);
	      return usersResource.resetPassword(this.resetPasswordSuccess, this.resetPasswordFailure, params);
	    },
	    resetPasswordSuccess: function(response) {
	      Loader.off();
	      Session.signIn(response.body.user);
	      return this.$router.push({
	        name: 'flows'
	      });
	    },
	    resetPasswordFailure: function(response) {
	      Loader.off();
	      return this.handleApiErrors(response, {
	        extra_attributes: ['reset_password_token']
	      });
	    }
	  },
	  created: function() {
	    this.extractTokenIfExists();
	    return this.redirectIfNoToken();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 495 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['show_alert', 'account_status', 'nylas_setting'],
	  data: function() {
	    return {
	      current_user: Session.current_user
	    };
	  },
	  computed: {
	    show_call_to_action: function() {
	      return this.account_status === 'invalid' && this.$route.name !== 'integrations';
	    },
	    show_support_info: function() {
	      return this.account_status !== 'running' && this.account_status !== 'invalid';
	    },
	    show_resync_info: function() {
	      return this.account_status === 'invalid' && this.$route.name === 'integrations';
	    },
	    quota_exceeded: function() {
	      var ref;
	      return ((ref = this.nylas_setting) != null ? ref.quota_exceeded : void 0) !== null;
	    },
	    to_article: function() {
	      return 'https://intercom.help/reevoutbound-marketing/pt-BR/articles/3216507-recebi-um-alerta-de-limite-de-envio-de-e-mails-excedido-e-agora';
	    }
	  },
	  methods: {
	    redirect: function() {
	      return this.$router.push({
	        name: 'integrations'
	      });
	    }
	  }
	};


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, item, on_clickaway, view_model;
	
	item = __webpack_require__(169);
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  props: ['external_id'],
	  data: function() {
	    return {
	      show: false,
	      current_company: Session.current_company,
	      current_user: Session.current_user,
	      company: null,
	      companies: [],
	      show_no_result_found_message: false,
	      item_company: item,
	      attrs: {
	        placeholder: "Buscar empresa"
	      }
	    };
	  },
	  methods: {
	    selectCategory: function(category) {
	      this.category_selected = category;
	      this.show_categories = false;
	      if (this.category_selected) {
	        return this.searchTemplates("");
	      }
	    },
	    hideCategories: function() {
	      return this.show_categories = false;
	    },
	    toggleCategories: function() {
	      return this.show_categories = !this.show_categories;
	    },
	    setFocus: function() {
	      return jQuery('#' + this.id + '.v-autocomplete .v-autocomplete-input').focus();
	    },
	    onClickaway: function() {
	      return this.$emit('hide');
	    },
	    getLabel: function(company) {
	      return company != null ? company.name : void 0;
	    },
	    searchCompanies: function(text) {
	      var params;
	      params = {
	        q: {
	          name_cont: text
	        },
	        per: 10
	      };
	      if (this.current_user.hasMoreAccounts()) {
	        params = {
	          q: {
	            name_cont: text,
	            users_with_same_account: this.current_user.email
	          },
	          per: 10
	        };
	      }
	      return this.company_resources.index(this.searchSuccess, this.unknownError, {
	        params: params
	      });
	    },
	    getInitialCompanies: function() {
	      var params;
	      params = {
	        per: 10
	      };
	      if (this.current_user.hasMoreAccounts()) {
	        params = {
	          q: {
	            users_with_same_account: this.current_user.email
	          },
	          per: 10
	        };
	      }
	      return this.company_resources.index(this.searchSuccess, this.unknownError, {
	        params: params
	      });
	    },
	    searchSuccess: function(resources) {
	      this.companies = resources.companies;
	      return this.show_no_result_found_message = resources.companies.length === 0;
	    },
	    selectedCompany: function(company) {
	      this.$emit("selected-company", company);
	      this.getInitialCompanies();
	      return setTimeout(((function(_this) {
	        return function() {
	          return _this.company = "";
	        };
	      })(this)), 500);
	    }
	  },
	  computed: {
	    id: function() {
	      return "company_autocomplete_" + this.external_id;
	    }
	  },
	  mounted: function() {
	    this.getInitialCompanies();
	    return this.setFocus();
	  },
	  created: function() {
	    return this.company_resources = new CompaniesResource(this.current_company.id);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 497 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    item: {
	      required: true
	    },
	    searchText: {
	      required: true
	    }
	  },
	  methods: {
	    replacer: function(match) {
	      return '<strong>' + match + '</strong>';
	    }
	  },
	  computed: {
	    name: function() {
	      return this.item.name.replace(new RegExp(this.searchText, "i"), this.replacer);
	    }
	  }
	};


/***/ }),
/* 498 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    item: {
	      required: true
	    },
	    searchText: {
	      required: true
	    }
	  },
	  methods: {
	    replacer: function(match) {
	      return '<strong>' + match + '</strong>';
	    }
	  },
	  computed: {
	    name: function() {
	      return this.item.full_name.replace(new RegExp(this.searchText, "i"), this.replacer);
	    },
	    business: function() {
	      var ref;
	      return (ref = this.item.business.name) != null ? ref.replace(new RegExp(this.searchText, "i"), this.replacer) : void 0;
	    },
	    email: function() {
	      var ref;
	      return (ref = this.item.email) != null ? ref.replace(new RegExp(this.searchText, "i"), this.replacer) : void 0;
	    },
	    telephone: function() {
	      var ref;
	      return (ref = this.item.telephone) != null ? ref.replace(new RegExp(this.searchText, "i"), this.replacer) : void 0;
	    },
	    cellphone: function() {
	      var ref;
	      return (ref = this.item.cellphone) != null ? ref.replace(new RegExp(this.searchText, "i"), this.replacer) : void 0;
	    }
	  }
	};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, item, on_clickaway, view_model;
	
	item = __webpack_require__(170);
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  props: {
	    external_id: {
	      "default": ''
	    },
	    from_dialer: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      show: false,
	      current_company: Session.current_company,
	      current_user: Session.current_user,
	      contact: null,
	      contacts: [],
	      show_no_result_found_message: false,
	      item_contact: item,
	      loading: false,
	      attrs: {
	        placeholder: this.$t('contacts.label.searchContact')
	      }
	    };
	  },
	  methods: {
	    selectCategory: function(category) {
	      this.category_selected = category;
	      this.show_categories = false;
	      if (this.category_selected) {
	        return this.searchTemplates("");
	      }
	    },
	    hideCategories: function() {
	      return this.show_categories = false;
	    },
	    toggleCategories: function() {
	      return this.show_categories = !this.show_categories;
	    },
	    setFocus: function() {
	      return jQuery('#' + this.id + '.v-autocomplete .v-autocomplete-input').focus();
	    },
	    onClickaway: function() {
	      return this.$emit('hide');
	    },
	    splitPhones: function(contacts) {
	      var contact, i, len, new_contact, new_contacts;
	      new_contacts = [];
	      for (i = 0, len = contacts.length; i < len; i++) {
	        contact = contacts[i];
	        if (contact.telephone && contact.cellphone) {
	          new_contact = new Contact(contact);
	          new_contact.telephone = null;
	          contact.cellphone = null;
	          new_contacts.push(new_contact);
	        }
	      }
	      return contacts.concat(new_contacts);
	    },
	    removePhones: function(contacts) {
	      var contact, i, len;
	      for (i = 0, len = contacts.length; i < len; i++) {
	        contact = contacts[i];
	        if (contact.telephone || contact.cellphone) {
	          contact.telephone = null;
	          contact.cellphone = null;
	        }
	      }
	      return contacts;
	    },
	    getLabel: function(contact) {
	      return contact != null ? contact.full_name : void 0;
	    },
	    searchContacts: function(text) {
	      this.loading = true;
	      if (this.from_dialer) {
	        return this.contact_resources.index(this.searchSuccess, this.unknownError, {
	          params: {
	            q: {
	              search_phone_query: text,
	              user_id_eq: this.current_user.id,
	              not_blocklisted_status: true
	            },
	            per: 10
	          }
	        });
	      } else {
	        return this.contact_resources.index(this.searchSuccess, this.unknownError, {
	          params: {
	            q: {
	              search_query: text,
	              user_id_eq: this.current_user.id,
	              not_blocklisted_status: true
	            },
	            per: 10
	          }
	        });
	      }
	    },
	    searchSuccess: function(resources) {
	      this.loading = false;
	      if (this.from_dialer) {
	        this.contacts = this.splitPhones(resources.contacts);
	      } else {
	        this.contacts = this.removePhones(resources.contacts);
	      }
	      if (resources.contacts.length === 0) {
	        this.show_no_result_found_message = true;
	        return setTimeout(((function(_this) {
	          return function() {
	            return _this.show_no_result_found_message = false;
	          };
	        })(this)), 3000);
	      } else {
	        return this.show_no_result_found_message = false;
	      }
	    },
	    addContact: function(contact) {
	      return this.$emit('contact-selected', contact);
	    }
	  },
	  computed: {
	    id: function() {
	      return "contact_autocomplete_" + this.external_id;
	    }
	  },
	  mounted: function() {
	    return this.setFocus();
	  },
	  created: function() {
	    return this.contact_resources = new ContactsResource(this.current_company.id);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, listItem, on_clickaway, view_model;
	
	listItem = __webpack_require__(65);
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  props: {
	    filter_item_selected_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    uncheck_all_items: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      current_company: Session.current_company,
	      current_user: Session.current_user,
	      stage: null,
	      stages: [],
	      stages_all: [],
	      template: listItem,
	      show_stages: true,
	      selected_stage_ids: [],
	      attrs: {
	        placeholder: "Buscar estagios"
	      }
	    };
	  },
	  watch: {
	    stages: {
	      handler: function(stages) {
	        var current_selected_ids, data, i, len, selected_items, stage, stage_all;
	        for (i = 0, len = stages.length; i < len; i++) {
	          stage = stages[i];
	          stage_all = this.stages_all.find(function(t) {
	            return stage.id === t.id;
	          });
	          stage_all.behavior = stage.behavior;
	        }
	        selected_items = this.stages_all.filter(function(t) {
	          return t.behavior === 'check';
	        });
	        current_selected_ids = selected_items.map(function(t) {
	          return t.id;
	        });
	        data = {
	          selected_items: selected_items
	        };
	        this.stage = '';
	        if (this.selected_stage_ids.length !== current_selected_ids.length) {
	          this.selected_stage_ids = current_selected_ids;
	          return this.$emit('item-selected-items', data);
	        }
	      },
	      deep: true
	    },
	    uncheck_all_items: {
	      handler: function() {
	        var i, len, ref, results, stage;
	        ref = this.stages;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          stage = ref[i];
	          results.push(stage.behavior = 'uncheck');
	        }
	        return results;
	      }
	    }
	  },
	  methods: {
	    setFocus: function() {
	      return jQuery('#' + this.id + '.v-autocomplete .v-autocomplete-input').focus();
	    },
	    stageIndex: function() {
	      var checked, data, i, len, results, stage;
	      data = new Contact().stages();
	      results = [];
	      for (i = 0, len = data.length; i < len; i++) {
	        stage = data[i];
	        checked = (this.filter_item_selected_ids || []).indexOf("" + stage.value) >= 0;
	        stage.behavior = checked ? 'check' : 'uncheck';
	        this.stages.push({
	          id: stage.value,
	          name: stage.text,
	          behavior: stage.behavior
	        });
	        results.push(this.stages_all.push({
	          id: stage.value,
	          name: stage.text,
	          behavior: stage.behavior
	        }));
	      }
	      return results;
	    },
	    filterStages: function(text) {
	      var i, len, ref, regex, results, stage;
	      if (text === '' || typeof text !== 'string') {
	        return (this.stages = this.stages_all);
	      }
	      this.stages = [];
	      regex = new RegExp(text, 'i');
	      ref = this.stages_all;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        stage = ref[i];
	        if (regex.exec(stage.name)) {
	          results.push(this.stages.push(stage));
	        }
	      }
	      return results;
	    }
	  },
	  created: function() {
	    this.stageIndex();
	    this.id = 'dropdown-filter-stages';
	    return this.setFocus();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 501 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    item: {
	      required: true
	    },
	    searchText: {
	      required: true
	    }
	  },
	  methods: {
	    replacer: function(match) {
	      return '<strong>' + match + '</strong>';
	    }
	  },
	  computed: {
	    text: function() {
	      var ref, ref1;
	      return (ref = this.item) != null ? (ref1 = ref.name) != null ? ref1.replace(new RegExp(this.searchText, "i"), this.replacer) : void 0 : void 0;
	    },
	    select_button_class: function() {
	      var clazz;
	      clazz = '';
	      if (this.item.behavior === 'check') {
	        clazz = "all_selected";
	      }
	      return clazz;
	    }
	  }
	};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, listItem, on_clickaway, view_model;
	
	listItem = __webpack_require__(65);
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  props: {
	    filter_item_selected_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    uncheck_all_items: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      current_company: Session.current_company,
	      current_user: Session.current_user,
	      tag: null,
	      tags: [],
	      tags_all: [],
	      template: listItem,
	      show_tags: true,
	      selected_tag_ids: [],
	      attrs: {
	        placeholder: this.$t('contacts.label.searchTags')
	      }
	    };
	  },
	  watch: {
	    tags: {
	      handler: function(tags) {
	        var current_selected_ids, data, i, len, selected_items, tag, tag_all;
	        for (i = 0, len = tags.length; i < len; i++) {
	          tag = tags[i];
	          tag_all = this.tags_all.find(function(t) {
	            return tag.id === t.id;
	          });
	          tag_all.behavior = tag.behavior;
	        }
	        selected_items = this.tags_all.filter(function(t) {
	          return t.behavior === 'check';
	        });
	        current_selected_ids = selected_items.map(function(t) {
	          return t.id;
	        });
	        data = {
	          selected_items: selected_items
	        };
	        if (this.selected_tag_ids.length !== current_selected_ids.length) {
	          this.selected_tag_ids = current_selected_ids;
	          return this.$emit('item-selected-items', data);
	        }
	      },
	      deep: true
	    },
	    uncheck_all_items: {
	      handler: function() {
	        var i, len, ref, results, tag;
	        ref = this.tags;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          tag = ref[i];
	          results.push(tag.behavior = 'uncheck');
	        }
	        return results;
	      }
	    }
	  },
	  methods: {
	    getLabel: function(item) {
	      return item.name;
	    },
	    setFocus: function() {
	      return jQuery('#' + this.id + '.v-autocomplete .v-autocomplete-input').focus();
	    },
	    tagIndex: function() {
	      return new TagsResource().index(this.loadTagsSuccess, null, {
	        params: {
	          q: {
	            company_id_eq: this.current_company.id
	          }
	        }
	      });
	    },
	    loadTagsSuccess: function(data) {
	      var checked, i, len, ref, results, tag;
	      this.tags_all = [];
	      this.tags = [];
	      ref = data.tags;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        tag = ref[i];
	        checked = (this.filter_item_selected_ids || []).indexOf("" + tag.id) >= 0;
	        tag.behavior = checked ? 'check' : 'uncheck';
	        this.tags_all.push(tag);
	        results.push(this.tags.push(tag));
	      }
	      return results;
	    },
	    itemClicked: function(item) {
	      item.behavior = item.behavior === 'check' ? 'uncheck' : 'check';
	      return this.tag = null;
	    },
	    clearInput: function() {
	      this.$refs.tag_autocomplete.searchText = '';
	      return this.$refs.tag_autocomplete.inputChange();
	    },
	    filterTags: function(text) {
	      var i, len, ref, regex, results, tag;
	      if (text === '') {
	        return (this.tags = this.tags_all);
	      }
	      this.tags = [];
	      regex = new RegExp(text, 'i');
	      ref = this.tags_all;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        tag = ref[i];
	        if (regex.exec(tag.name)) {
	          results.push(this.tags.push(tag));
	        }
	      }
	      return results;
	    }
	  },
	  created: function() {
	    this.tagIndex();
	    this.id = 'dropdown-filter-tags';
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    return this.setFocus();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 503 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    item: {
	      required: true
	    },
	    searchText: {
	      required: true
	    }
	  },
	  methods: {
	    replacer: function(match) {
	      return '<strong>' + match + '</strong>';
	    }
	  },
	  computed: {
	    text: function() {
	      var ref, ref1;
	      return (ref = this.item) != null ? (ref1 = ref.name) != null ? ref1.replace(new RegExp(this.searchText, "i"), this.replacer) : void 0 : void 0;
	    }
	  }
	};


/***/ }),
/* 504 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    item: {
	      required: true
	    },
	    searchText: {
	      required: true
	    }
	  },
	  methods: {
	    replacer: function(match) {
	      return '<strong>' + match + '</strong>';
	    },
	    clicked: function() {
	      return EventsBus.$emit('MassActions:Autocomplete:ItemClicked', this.item);
	    }
	  },
	  computed: {
	    text: function() {
	      var ref, ref1;
	      return (ref = this.item) != null ? (ref1 = ref.name) != null ? ref1.replace(new RegExp(this.searchText, "i"), this.replacer) : void 0 : void 0;
	    },
	    select_button_class: function() {
	      var clazz;
	      clazz = '';
	      if (this.item.behavior === 'check') {
	        clazz = "all_selected";
	      } else if (this.item.behavior === 'line') {
	        clazz = "some_selected";
	      }
	      return clazz;
	    }
	  }
	};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, listItem, on_clickaway, view_model;
	
	listItem = __webpack_require__(174);
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  props: {
	    tag_created: {
	      "default": function() {
	        return null;
	      }
	    },
	    show_change_tags: {
	      "default": function() {
	        return false;
	      }
	    },
	    filters: {
	      "default": function() {
	        return {};
	      }
	    },
	    unselected_ids: {
	      "default": function() {
	        return [];
	      }
	    },
	    selected_ids: {
	      "default": function() {
	        return [];
	      }
	    }
	  },
	  data: function() {
	    return {
	      loading: false,
	      show: true,
	      current_company: Session.current_company,
	      current_user: Session.current_user,
	      tag: null,
	      tags: [],
	      tags_all: [],
	      tags_base: [],
	      show_tags: true,
	      template: listItem,
	      change_tags: [],
	      show_button_apply: false,
	      autocomplete_text: '',
	      attrs: {
	        placeholder: this.$t('contacts.label.searchTags')
	      }
	    };
	  },
	  computed: {
	    button_title_create_tag: function() {
	      return 'Criar tag ' + '"' + this.autocomplete_text + '"';
	    }
	  },
	  methods: {
	    setFocus: function() {
	      return jQuery('#' + this.id + '.v-autocomplete .v-autocomplete-input').focus();
	    },
	    tagIndex: function() {
	      return new TagsResource().index(this.loadTagsSuccess, null, {
	        params: {
	          q: {
	            company_id_eq: this.current_company.id
	          }
	        }
	      });
	    },
	    openModal: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'create-tag',
	        name: this.autocomplete_text
	      });
	    },
	    filterTags: function(text) {
	      var i, len, ref, regex, results, tag;
	      this.autocomplete_text = text;
	      if (text === '') {
	        return (this.tags = this.tags_all);
	      }
	      this.tags = [];
	      regex = new RegExp(text, 'i');
	      ref = this.tags_all;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        tag = ref[i];
	        if (regex.exec(tag.name)) {
	          results.push(this.tags.push(tag));
	        }
	      }
	      return results;
	    },
	    loadTagsSuccess: function(data) {
	      var i, len, ref, tag;
	      ref = data.tags;
	      for (i = 0, len = ref.length; i < len; i++) {
	        tag = ref[i];
	        tag.behavior = 'uncheck';
	        this.tags.push(tag);
	      }
	      return this.tags_all = this.tags;
	    },
	    itemClicked: function(tag) {
	      this.circleBehavior(tag);
	      this.updateChangeTags(tag);
	      return this.show_button_apply = this.toogleShowButtonApply(tag);
	    },
	    circleBehavior: function(tag) {
	      var has_tag;
	      if (tag.behavior === 'check') {
	        return tag.behavior = 'uncheck';
	      } else if (tag.behavior === 'uncheck') {
	        has_tag = this.tags_base.find(function(t) {
	          return tag.id === t.id && t.behavior === 'line';
	        });
	        return tag.behavior = has_tag != null ? 'line' : 'check';
	      } else {
	        return tag.behavior = 'check';
	      }
	    },
	    updateChangeTags: function(tag) {
	      var change_tags;
	      change_tags = this.change_tags.find(function(t) {
	        return tag.id === t.id;
	      });
	      if (change_tags) {
	        return change_tags.behavior = tag.behavior;
	      }
	    },
	    toogleShowButtonApply: function(tag) {
	      var tag_base;
	      tag_base = this.tags_base.find(function(t) {
	        return tag.id === t.id;
	      });
	      return tag_base && tag.behavior !== tag_base.behavior;
	    },
	    changeTagsParams: function() {
	      return {
	        type: 'change_tags',
	        filters: this.filters,
	        change_tags: this.change_tags,
	        selected_ids: this.selected_ids,
	        unselected_ids: this.unselected_ids
	      };
	    },
	    callExecuteChangeTags: function() {
	      var params;
	      Loader.on();
	      params = this.changeTagsParams();
	      return this.contact_resource.massActionExecute(this.executeSuccess, this.executeError, params);
	    },
	    executeSuccess: function(response) {
	      var data;
	      Loader.off();
	      data = {
	        contact_ids: response.body.contact_ids,
	        change_tags: this.change_tags
	      };
	      EventsBus.$emit('MassActions:Tags:UpdateContacts', data);
	      return alertify.success("Tags modificadas com sucesso.");
	    },
	    executeError: function() {
	      Loader.off();
	      if (this.current_user.isSeller()) {
	        return alertify.error("Por favor, selecione somente contatos de sua responsabilidade.");
	      } else {
	        return alertify.error("Ops, algo deu errado.");
	      }
	    },
	    callPrepareChangeTags: function() {
	      var params;
	      this.loading = true;
	      params = this.changeTagsParams();
	      return this.contact_resource.massActionPrepare(this.prepareSuccess, this.unknownError, params);
	    },
	    prepareSuccess: function(response) {
	      var i, len, ref, ref1, response_tag, response_tags, tag;
	      response_tags = ((ref = response.body) != null ? ref.tags : void 0) || [];
	      ref1 = this.tags;
	      for (i = 0, len = ref1.length; i < len; i++) {
	        tag = ref1[i];
	        response_tag = response_tags.find(function(t) {
	          return tag.id === t.id;
	        });
	        tag.behavior = (response_tag != null ? response_tag.behavior : void 0) || 'uncheck';
	        this.tags_base.push({
	          id: tag.id,
	          behavior: tag.behavior
	        });
	        this.change_tags.push({
	          id: tag.id,
	          name: tag.name,
	          color: tag.color,
	          behavior: tag.behavior
	        });
	        if (this.tag_created && this.tag_created.id === tag.id) {
	          this.itemClicked(tag);
	        }
	      }
	      return this.loading = false;
	    },
	    resetTags: function() {
	      this.autocomplete_text = '';
	      this.tags = [];
	      return this.tag = '';
	    },
	    tagCreated: function(data) {
	      this.resetTags();
	      return this.tagIndex();
	    },
	    showChangeTags: function() {
	      this.show_button_apply = false;
	      if (this.show_change_tags) {
	        this.callPrepareChangeTags();
	        return this.setFocus();
	      } else {
	        this.change_tags = [];
	        return this.tags_base = [];
	      }
	    }
	  },
	  created: function() {
	    this.tagIndex();
	    this.id = 'mass-action-tags';
	    this.contact_resource = new ContactsResource(Session.current_company.id);
	    this.showChangeTags();
	    return EventsBus.$on('MassActions:Autocomplete:ItemClicked', this.itemClicked);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('MassActions:Autocomplete:ItemClicked', this.itemClicked);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  data: function() {
	    return {
	      show_preview: false
	    };
	  },
	  props: {
	    item: {
	      required: true
	    },
	    searchText: {
	      required: true
	    }
	  },
	  components: {
	    templatePreview: __webpack_require__(222)
	  },
	  methods: {
	    replacer: function(match) {
	      return '<strong>' + match + '</strong>';
	    },
	    showPreview: function() {
	      this.show_preview = !this.show_preview;
	      return EventsBus.$emit('TemplateAutoComplete::SetShowList', true, this.$parent.$parent._uid);
	    }
	  },
	  computed: {
	    text: function() {
	      var ref, ref1;
	      return (ref = this.item) != null ? (ref1 = ref.name) != null ? ref1.replace(new RegExp(this.searchText, "i"), this.replacer) : void 0 : void 0;
	    }
	  }
	};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, item, on_clickaway, view_model;
	
	item = __webpack_require__(176);
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  props: {
	    'external_id': {
	      "default": function() {
	        return 0;
	      }
	    },
	    'kind': {
	      "default": function() {
	        return '0';
	      }
	    },
	    'open_template_modal': {
	      "default": function() {
	        return false;
	      }
	    },
	    'user_id': {
	      "default": function() {
	        return Session.current_user.id;
	      }
	    }
	  },
	  data: function() {
	    return {
	      input_text: '',
	      keep_items_open: false,
	      show_categories: false,
	      categories: [],
	      category_selected: null,
	      show: false,
	      current_company: Session.current_company,
	      current_user: Session.current_user,
	      template: null,
	      templates: [],
	      item_template: item,
	      show_no_result_found_message: false,
	      attrs: {
	        placeholder: this.$t('general.placeholder.search')
	      }
	    };
	  },
	  methods: {
	    openCreateTemplateModal: function() {
	      var ref, templateAttrs;
	      if (!this.open_template_modal) {
	        return;
	      }
	      this.$emit('template-selected', {
	        id: 'create'
	      });
	      this.setShowList(false);
	      this.show_no_result_found_message = false;
	      templateAttrs = {
	        template_kind: this.kind,
	        template_name: this.input_text,
	        template_category_id: (ref = this.category_selected) != null ? ref.id : void 0
	      };
	      return this.$emit('open-template-modal', templateAttrs);
	    },
	    selectCategory: function(category) {
	      this.category_selected = category;
	      this.show_categories = false;
	      this.searchTemplates('');
	      return this.setShowList(false);
	    },
	    hideCategories: function() {
	      this.show_categories = false;
	      return this.keep_items_open = false;
	    },
	    toggleCategories: function() {
	      return this.show_categories = !this.show_categories;
	    },
	    onClickaway: function() {
	      return this.$emit('hide');
	    },
	    loadCategories: function() {
	      return this.template_category_resources.index(this.loadCategoriesSuccess, this.unknownError);
	    },
	    loadCategoriesSuccess: function(data) {
	      return this.categories = data.template_categories;
	    },
	    getLabel: function(template) {
	      return template != null ? template.name : void 0;
	    },
	    searchTemplates: function(text) {
	      var filters, kind, limit;
	      this.input_text = text;
	      kind = this.kind_idx > -1 ? this.kind_idx : null;
	      filters = {
	        kind_eq: kind,
	        name_cont: text,
	        user_id_eq: this.user_id || this.current_user.id
	      };
	      if (text === '') {
	        this.clearTemplate();
	      }
	      limit = text === "" ? 5 : 'disabled';
	      if (this.category_selected) {
	        filters.template_category_id_eq = this.category_selected.id;
	        this.setShowList(true);
	      }
	      return this.template_resources.index(this.searchSuccess, this.unknownError, {
	        params: {
	          q: filters,
	          per: limit
	        }
	      });
	    },
	    searchSuccess: function(resources) {
	      this.templates = resources.templates;
	      this.clearTemplate();
	      return this.show_no_result_found_message = resources.templates.length === 0;
	    },
	    setShowList: function(value, uid) {
	      if (uid == null) {
	        uid = null;
	      }
	      if (uid == null) {
	        return this.keep_items_open = value;
	      }
	      if (this._uid === uid) {
	        return this.keep_items_open = value;
	      }
	    },
	    clearTemplate: function(clear_input) {
	      var autocomplete;
	      if (clear_input == null) {
	        clear_input = false;
	      }
	      if (clear_input) {
	        autocomplete = this.$children.find(function(c) {
	          return c.$el.className === 'v-autocomplete';
	        });
	        autocomplete.searchText = '';
	        this.input_text = '';
	        this.show_no_result_found_message = false;
	        this.keep_items_open = false;
	        this.template = null;
	        this.$emit('destroy-created-template');
	      }
	      return this.$emit('template-selected', {
	        id: null
	      });
	    },
	    addTemplate: function(template) {
	      this.setShowList(false);
	      this.$emit('hide');
	      return this.$emit('template-selected', template);
	    }
	  },
	  computed: {
	    show_not_result_without_modal: function() {
	      return this.show_no_result_found_message && this.input_text.length > 0 && !this.open_template_modal;
	    },
	    show_not_result_with_modal: function() {
	      return this.show_no_result_found_message && this.input_text.length > 0 && this.open_template_modal;
	    },
	    show_clear_button: function() {},
	    kind_idx: function() {
	      return ['email', 'phonecall', 'social', 'linkedin'].indexOf(this.kind);
	    },
	    id: function() {
	      return "autocomplete_" + this.external_id;
	    },
	    label_category: function() {
	      var ref;
	      return ((ref = this.category_selected) != null ? ref.name : void 0) || this.$t('template.label.allCategories');
	    }
	  },
	  watch: {
	    kind: function() {
	      this.templates = [];
	      this.setShowList(false);
	      this.show_no_result_found_message = false;
	      this.searchTemplates('');
	      return this.clearTemplate(true);
	    }
	  },
	  created: function() {
	    this.template_resources = new TemplatesResource(this.current_company.id);
	    this.template_category_resources = new TemplateCategoriesResource(this.current_company.id);
	    this.loadCategories();
	    this.searchTemplates('', false);
	    return EventsBus.$on('TemplateAutoComplete::SetShowList', this.setShowList);
	  },
	  mounted: function() {
	    return this.attrs.placeholder = this.$t('general.placeholder.search');
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 508 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: ['to', 'name'],
	  methods: {
	    back: function() {
	      if (this.to) {
	        return this.$router.go(this.to);
	      } else {
	        return window.history.back();
	      }
	    }
	  }
	};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, on_clickaway, view_model;
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  components: {
	    compose: __webpack_require__(178),
	    quotaExceeded: __webpack_require__(179)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      list: [],
	      show_menu: false,
	      event: {}
	    };
	  },
	  methods: {
	    onClickaway: function() {
	      return this.show_menu = false;
	    },
	    compose_header: function(task, index) {
	      var ref, ref1, ref2;
	      if (task.contact.id) {
	        return ((ref = task.contact) != null ? ref.full_name : void 0) + ' - ' + ((ref1 = task.contact) != null ? (ref2 = ref1.business) != null ? ref2.name : void 0 : void 0);
	      } else {
	        return "Email " + (index + 1);
	      }
	    },
	    loadTaskInfo: function(data) {
	      var task;
	      if (data.event) {
	        this.event = data.event;
	      }
	      if (!data.task) {
	        task = new Task;
	        task.service = 'ManualTasksServices::Email';
	        task.created_by_type = 'User';
	        return this.incrementList(task);
	      } else {
	        if (!this.list.find(data.task.id)) {
	          return this.tasks_resources.get(this.loadTaskInfoSuccess, this.unknownError, {
	            id: data.task.id
	          });
	        }
	      }
	    },
	    loadTaskInfoSuccess: function(data) {
	      return this.incrementList(data.task);
	    },
	    hideCompose: function(task) {
	      if (this.list.remove(task)) {
	        return this.list.push(task);
	      }
	    },
	    incrementList: function(task) {
	      this.show_menu = false;
	      if (this.list.find(task)) {
	        this.list.remove(task);
	      }
	      return this.list.unshift(task);
	    },
	    removeFromList: function(task) {
	      return this.list.remove(task);
	    }
	  },
	  computed: {
	    limited_list: function() {
	      return this.list.slice(0, 2);
	    },
	    hidden_list: function() {
	      return this.list.slice(2);
	    },
	    hidden_list_has_elements: function() {
	      return this.hidden_list.length > 0;
	    }
	  },
	  created: function() {
	    this.tasks_resources = new TasksResource;
	    return EventsBus.$on('Compose::Open', this.loadTaskInfo);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('Compose::Open', this.loadTaskInfo);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  methods: {
	    hide: function() {
	      return jQuery('#quota_exceeded').modal('hide');
	    },
	    show: function() {
	      return jQuery('#quota_exceeded').modal('show');
	    },
	    removeQuotaExceeded: function() {
	      EventsBus.$emit('send-email-quota-exceeded');
	      return this.hide();
	    }
	  },
	  created: function() {
	    return EventsBus.$on('quota-exceeded-modal', this.show);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('quota-exceeded-modal', this.show);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.contacts.list_view_modes);


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, on_clickaway;
	
	__webpack_require__(229);
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	module.exports = {
	  mixins: [on_clickaway.mixin],
	  props: {
	    id: {
	      "default": ''
	    },
	    full_period_option: {
	      "default": false
	    },
	    this_month: {
	      "default": false
	    },
	    this_today: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      show_picker: false,
	      container: this.id + "-container",
	      options: this.buildOptions(),
	      selected_option: null
	    };
	  },
	  methods: {
	    buildOptions: function() {
	      var options;
	      options = [
	        {
	          value: {
	            text: 'Data customizada',
	            from: null,
	            to: null
	          },
	          text: 'Data customizada'
	        }, {
	          value: {
	            text: 'Hoje',
	            from: new Date(),
	            to: new Date()
	          },
	          text: 'Hoje'
	        }, {
	          value: {
	            text: 'Ontem',
	            from: this.getYesterday(),
	            to: this.getYesterday()
	          },
	          text: 'Ontem'
	        }, {
	          value: {
	            text: 'Essa semana',
	            from: this.getMonday(),
	            to: new Date()
	          },
	          text: 'Essa semana'
	        }, {
	          value: {
	            text: 'Esse mês',
	            from: this.getFirstDayMonth(new Date()),
	            to: new Date()
	          },
	          text: 'Esse mês'
	        }, {
	          value: {
	            text: 'Esse ano',
	            from: this.getFirstDayYear(new Date()),
	            to: new Date()
	          },
	          text: 'Esse ano'
	        }
	      ];
	      if (this.full_period_option) {
	        options.unshift({
	          value: {
	            text: 'Todo o período',
	            from: null,
	            to: null
	          },
	          text: 'Todo o período'
	        });
	      }
	      return options;
	    },
	    initialSelectedOption: function() {
	      if (this.full_period_option) {
	        return {
	          value: {
	            text: 'Todo o período',
	            from: null,
	            to: null
	          },
	          text: 'Todo o período'
	        };
	      }
	      if (this.this_month) {
	        return {
	          value: {
	            text: 'Esse mês',
	            from: this.getFirstDayMonth(new Date()),
	            to: new Date()
	          },
	          text: 'Esse mês'
	        };
	      }
	      if (this.this_today) {
	        return {
	          value: {
	            text: 'Hoje',
	            from: new Date(),
	            to: new Date()
	          },
	          text: 'Hoje'
	        };
	      }
	      return {
	        value: {
	          text: 'Essa semana',
	          from: this.getMonday(),
	          to: new Date()
	        },
	        text: 'Essa semana'
	      };
	    },
	    dropdownChanged: function(value) {
	      this.setSelectedOption(value);
	      if (this.validDate(this.date_from) && this.validDate(this.date_to)) {
	        jQuery('#' + this.id).data('dateRangePicker').setDateRange(this.date_from._d, this.date_to._d, true);
	        return this.emitDate();
	      } else {
	        jQuery('#' + this.id).data('dateRangePicker').clear();
	        if (this.selected_option.text === 'Todo o período') {
	          return this.emitDate();
	        }
	      }
	    },
	    calendarChanged: function(obj) {
	      this.setSelectedOption({
	        text: 'Data customizada',
	        from: obj.date1,
	        to: obj.date2
	      });
	      return this.emitDate();
	    },
	    setSelectedOption: function(value) {
	      value.from = this.validDate(value.from) ? moment(value.from)._d : '-';
	      value.to = this.validDate(value.to) ? moment(value.to)._d : '-';
	      return this.selected_option = value;
	    },
	    validDate: function(value) {
	      return value && value !== '-';
	    },
	    formatDate: function(value) {
	      if (this.validDate(value)) {
	        return value.format('LL');
	      } else {
	        return '-';
	      }
	    },
	    toggleShowPicker: function() {
	      return this.show_picker = !this.show_picker;
	    },
	    hidePicker: function() {
	      return this.show_picker = false;
	    },
	    getMonday: function() {
	      return moment().weekday(1)._d;
	    },
	    getFirstDayMonth: function(date) {
	      var firstDayMonth, m, y;
	      y = date.getFullYear();
	      m = date.getMonth();
	      firstDayMonth = new Date(y, m, 1);
	      return moment(firstDayMonth)._d;
	    },
	    getFirstDayYear: function(date) {
	      var firstDayYear, m, y;
	      y = date.getFullYear();
	      m = date.getMonth();
	      firstDayYear = new Date(y, 0, 1);
	      return moment(firstDayYear)._d;
	    },
	    getYesterday: function() {
	      return moment().subtract(1, 'd')._d;
	    },
	    initializeDatePicker: function() {
	      return jQuery('#' + this.id).dateRangePicker({
	        language: 'pt',
	        startOfWeek: 'monday',
	        hoveringTooltip: false,
	        inline: true,
	        container: '#' + this.id + '-container',
	        alwaysOpen: true,
	        format: 'DD/MM/YYYY',
	        separator: ' à ',
	        showTopbar: false,
	        autoClose: true,
	        endDate: moment().toDate()
	      }).bind('datepicker-change', (function(_this) {
	        return function(event, obj) {
	          return _this.calendarChanged(obj);
	        };
	      })(this));
	    },
	    emitDate: function() {
	      var from, to;
	      from = this.validDate(this.selected_option.from) ? this.selected_option.from : null;
	      to = this.validDate(this.selected_option.to) ? this.selected_option.to : null;
	      return this.$emit('date-changed', {
	        from: from,
	        to: to
	      });
	    }
	  },
	  computed: {
	    date_from: function() {
	      if (this.validDate(this.selected_option.from)) {
	        return moment(this.selected_option.from);
	      } else {
	        return '-';
	      }
	    },
	    date_to: function() {
	      if (this.validDate(this.selected_option.to)) {
	        return moment(this.selected_option.to);
	      } else {
	        return '-';
	      }
	    },
	    selected_text: function() {
	      if (this.selected_option.text === 'Todo o período') {
	        return this.selected_option.text;
	      }
	      if (!this.validDate(this.date_from) && !this.validDate(this.date_to)) {
	        return ' - ';
	      }
	      if (this.selected_option.text !== 'Data customizada') {
	        return this.selected_option.text;
	      }
	      return this.date_from.format('D MMMM, YYYY') + ' - ' + this.date_to.format('D MMMM, YYYY');
	    },
	    isCalendarDisabled: function() {
	      return this.selected_option.text !== 'Data customizada';
	    }
	  },
	  created: function() {
	    return this.setSelectedOption(this.initialSelectedOption().value);
	  },
	  mounted: function() {
	    return this.initializeDatePicker();
	  }
	};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  props: ['kind', 'filter_item_selected_ids', 'uncheck_all_items', 'position', 'index'],
	  components: {
	    tagFilter: __webpack_require__(69),
	    stageFilter: __webpack_require__(25)
	  },
	  data: function() {
	    return {
	      selected_items: []
	    };
	  },
	  methods: {
	    dropdownComponent: function(kind) {
	      switch (kind) {
	        case 'tag_filter':
	          return 'tag-filter';
	        case 'stage_filter':
	          return 'stage-filter';
	        default:
	          return '';
	      }
	    },
	    itemSelectedItems: function(data) {
	      this.selected_items = data.selected_items;
	      data.position = this.position;
	      return this.$emit('item-selected-items', data);
	    }
	  }
	};


/***/ }),
/* 513 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    capital: {
	      "default": false
	    },
	    options: {
	      type: Array,
	      "default": function() {
	        return [];
	      }
	    },
	    verify: {
	      "default": false
	    },
	    selected: {
	      "default": void 0
	    },
	    value: {
	      "default": void 0
	    },
	    disabled: {
	      "default": false
	    },
	    fullWidth: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      selected_option: this.options[0]
	    };
	  },
	  methods: {
	    selectOption: function(option) {
	      this.selected_option = option;
	      return this.$emit('input', this.selected_option.value);
	    },
	    setSelectedOptionOrDefault: function() {
	      var option;
	      if (this.selected_value !== void 0) {
	        option = this.options.findByProps({
	          value: this.selected_value
	        });
	      }
	      if (option == null) {
	        option = this.options[0];
	      }
	      return this.selected_option = option;
	    }
	  },
	  watch: {
	    options: function(new_options) {
	      return this.setSelectedOptionOrDefault();
	    },
	    selected: function(new_value) {
	      if (this.selected_option.value !== new_value) {
	        return this.setSelectedOptionOrDefault();
	      }
	    },
	    value: function(new_value) {
	      if (this.selected_option.value !== new_value) {
	        return this.setSelectedOptionOrDefault();
	      }
	    }
	  },
	  computed: {
	    selected_value: function() {
	      if (this.selected !== void 0) {
	        return this.selected;
	      } else {
	        return this.value;
	      }
	    }
	  },
	  mounted: function() {
	    return this.setSelectedOptionOrDefault();
	  }
	};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	var on_clickaway;
	
	on_clickaway = __webpack_require__(5);
	
	exports["default"] = {
	  mixins: [on_clickaway.mixin],
	  props: {
	    filter_item_selected_ids: {
	      type: Array,
	      "default": function() {
	        return [];
	      }
	    },
	    uncheck_all_items: {
	      type: Boolean,
	      "default": false
	    },
	    default_label: {
	      type: String,
	      "default": ''
	    },
	    integration: {
	      type: String,
	      "default": ''
	    }
	  },
	  data: function() {
	    return {
	      selected_items: [],
	      list: [],
	      show_list: false
	    };
	  },
	  computed: {
	    dropdown_title: function() {
	      switch (false) {
	        case this.list.filter(function(s) {
	            return s.selected === true;
	          }).length !== 0:
	          return this.default_label || this.$t('integrations.label.stages_matching.selectPhases');
	        case this.list.filter(function(s) {
	            return s.selected === true;
	          }).length !== 1:
	          return this.list.filter(function(s) {
	            return s.selected === true;
	          })[0].text;
	        default:
	          return this.$t('integrations.label.stages_matching.multipleStages');
	      }
	    }
	  },
	  methods: {
	    updateStages: function() {
	      return this.$emit('item-selected-items', this.list.filter(function(s) {
	        return s.selected;
	      }).map(function(s) {
	        return s.value;
	      }));
	    },
	    clickList: function() {
	      return this.show_list = !this.show_list;
	    },
	    clicked: function(data) {
	      var i, len, ref, stage;
	      ref = this.list;
	      for (i = 0, len = ref.length; i < len; i++) {
	        stage = ref[i];
	        if (stage.value === data.value) {
	          if (stage.selected) {
	            stage.selected = !stage.selected;
	          } else {
	            stage.selected = true;
	          }
	        }
	      }
	      return this.updateStages();
	    },
	    onClickaway: function() {
	      if (this.show_list) {
	        return this.show_list = false;
	      }
	    }
	  },
	  created: function() {
	    var i, len, ref, results, stage;
	    if (this.integration.indexOf('hubspot_integration') > -1) {
	      this.list = new Contact().hubspot_stages();
	    } else if (this.integration.indexOf('rd_station') > -1) {
	      this.list = new Contact().rd_station_stages();
	    } else {
	      this.list = new Contact().stages();
	    }
	    if (['webhook', 'nectar', 'hubspot', 'pipedrive'].indexOf(this.integration.toLowerCase()) > -1) {
	      this.list.push({
	        value: 'lost',
	        selected: false,
	        text: this.$t('integrations.label.stages_matching.lost')
	      });
	    }
	    ref = this.list;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      stage = ref[i];
	      if (this.filter_item_selected_ids.indexOf(stage.value) > -1) {
	        results.push(stage.selected = true);
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  }
	};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  props: {
	    filter_item_selected_ids: {
	      type: Array,
	      "default": function() {
	        return [];
	      }
	    },
	    uncheck_all_items: {
	      type: Boolean,
	      "default": false
	    },
	    default_label: {
	      type: String,
	      "default": 'Tags'
	    },
	    index: {
	      type: String,
	      "default": ''
	    }
	  },
	  components: {
	    filterTagsAutocomplete: __webpack_require__(171)
	  },
	  data: function() {
	    return {
	      selected_items: []
	    };
	  },
	  computed: {
	    dropdown_title: function() {
	      switch (false) {
	        case this.selected_items.length !== 0:
	          return this.default_label;
	        case this.selected_items.length !== 1:
	          return this.selected_items[0].name;
	        default:
	          return 'Múltiplas Tags';
	      }
	    }
	  },
	  methods: {
	    itemSelectedItems: function(data) {
	      this.selected_items = data.selected_items;
	      return this.$emit('item-selected-items', data);
	    }
	  }
	};


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    resetContactModal: __webpack_require__(191),
	    taskModalForm: __webpack_require__(17),
	    listComposers: __webpack_require__(177),
	    taskBar: __webpack_require__(123),
	    dialer: __webpack_require__(118),
	    tagPickerModal: __webpack_require__(74),
	    commentGlobalModal: __webpack_require__(190)
	  },
	  data: function() {
	    return {
	      contact: null
	    };
	  },
	  methods: {
	    confirmRemoveComment: function() {
	      return EventsBus.$emit('Comment::Destroy');
	    },
	    openTagsModal: function(data) {
	      this.contact = data;
	      jQuery('#' + this.tag_picker_id).modal('show');
	      return setTimeout(this.$refs.tag_picker_modal.reloadTags, 10);
	    },
	    addTagsToContact: function(tags) {
	      var contact_tags_attributes, tag;
	      if (!tags.length) {
	        return;
	      }
	      contact_tags_attributes = (function() {
	        var i, len, results;
	        results = [];
	        for (i = 0, len = tags.length; i < len; i++) {
	          tag = tags[i];
	          results.push({
	            tag_id: tag.id
	          });
	        }
	        return results;
	      })();
	      return this.contact_resource.update(this.addTagsSuccess, this.unknownError, {
	        id: this.contact.id,
	        contact_tags_attributes: contact_tags_attributes
	      });
	    },
	    addTagsSuccess: function(data) {
	      this.contact = data.contact;
	      EventsBus.$emit('update-contact', this.contact);
	      return alertify.success('Tags adicionada ao contato com sucesso');
	    }
	  },
	  created: function() {
	    this.tag_picker_id = 'tag-picker';
	    EventsBus.$on('open-tag-picker-modal', this.openTagsModal);
	    return this.contact_resource = new ContactsResource(Session.current_company.id);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('open-tag-picker-modal', this.openTagsModal);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.contacts.list_wrapper);


/***/ }),
/* 517 */
/***/ (function(module, exports) {

	exports["default"] = {
	  data: function() {
	    return {
	      loading: true
	    };
	  },
	  methods: {
	    name: function() {
	      return 'Shared/Loader';
	    },
	    "switch": function(loading) {
	      return this.loading = loading;
	    }
	  },
	  created: function() {
	    return EventsBus.$on('switch-loader', this["switch"]);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('switch-loader', this["switch"]);
	  }
	};


/***/ }),
/* 518 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    offset: {
	      "default": 300
	    }
	  },
	  data: function() {
	    return {
	      visible: false
	    };
	  },
	  methods: {
	    onScroll: function() {
	      if (this.window.scrollTop() > this.offset) {
	        return this.visible = true;
	      } else {
	        return this.visible = false;
	      }
	    },
	    goToTop: function() {
	      return jQuery('html, body').animate({
	        scrollTop: 0
	      }, 500);
	    }
	  },
	  mounted: function() {
	    this.window = jQuery(window);
	    this.window.scroll(this.onScroll);
	    return this.onScroll();
	  }
	};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    notificationBell: __webpack_require__(192),
	    notificationsPopup: __webpack_require__(208),
	    voip: __webpack_require__(188),
	    email: __webpack_require__(187),
	    changeAccount: __webpack_require__(186)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      groups: [],
	      tags: [],
	      users: []
	    };
	  },
	  computed: {
	    show_change_account: function() {
	      return this.current_user.virtual_user_count > 1 || this.current_user.isAdmin();
	    },
	    load_user: function() {
	      return this.$store.getters.usersCount === 0;
	    },
	    load_tag: function() {
	      return this.$store.getters.tagsCount === 0;
	    },
	    change_to_new_ui: function() {
	      return this.current_user.extradata.change_to_new_ui;
	    },
	    to_help: function() {
	      return 'https://intercom.help/reevoutbound-marketing/pt-BR';
	    }
	  },
	  methods: {
	    goToNewUi: function() {
	      Session.current_user.extradata['use_new_ui'] = true;
	      return this.usersResource.update(this.updateUserSuccess, this.handleApiErrors, Session.current_user);
	    },
	    updateUserSuccess: function(data, response) {
	      return window.location = ("https://se.reev.co") + "/auth/novo-reev?redirect=" + (window.location.pathname.slice(1));
	    },
	    updateCurrentUser: function() {
	      return this.current_user = Session.current_user;
	    },
	    logout: function() {
	      return Session.logout(this.logoutSuccess);
	    },
	    logoutSuccess: function() {
	      return this.$router.replace({
	        name: 'landing'
	      });
	    }
	  },
	  mounted: function() {
	    this.usersResource = new UsersResource();
	    return Tooltip.initialize();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['service_status', 'message'],
	  computed: {
	    show: function() {
	      return this.service_status === 'exceeded' || this.service_status === 'exceeding';
	    },
	    css_class: function() {
	      switch (this.service_status) {
	        case 'exceeded':
	          return 'alert-red';
	        case 'exceeding':
	          return 'alert-orange';
	        default:
	          return '';
	      }
	    }
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      user: Session.current_user,
	      company: null
	    };
	  },
	  components: {
	    companiesAutocomplete: __webpack_require__(63)
	  },
	  methods: {
	    selectedCompany: function(company) {
	      if (this.user.isAdmin()) {
	        return this.setAdminCompany(company);
	      } else {
	        return this.getProperUser(company);
	      }
	    },
	    getProperUser: function(company) {
	      this.company = company;
	      return this.users_resource.searchAccount(this.loadUserSuccess, this.unknownError, {
	        params: {
	          company_id: company.id
	        }
	      });
	    },
	    loadUserSuccess: function(resource) {
	      if (resource) {
	        return this.setUserCompany(resource.user);
	      }
	    },
	    setUserCompany: function(user) {
	      Session.current_company = this.company;
	      Session.current_user = user;
	      this.$emit('update-user');
	      Session.setHttpHeaders();
	      Session.saveSessionInfo(user);
	      this.resetStorage();
	      if (this.$router.currentRoute.path === '/contatos/leads') {
	        return this.goTo('/tarefas');
	      } else {
	        return this.goTo('/contatos/leads');
	      }
	    },
	    setAdminCompany: function(company) {
	      Session.current_company.id = company.id;
	      Session.current_company.name = company.name;
	      this.resetStorage();
	      return this.goTo('/tarefas');
	    },
	    resetStorage: function() {
	      this.$store.commit('resetUsers');
	      this.$store.commit('resetTemplateCategories');
	      return this.$store.commit('resetTags');
	    }
	  },
	  created: function() {
	    return this.users_resource = new UsersResource();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    accountStatusInfo: __webpack_require__(168)
	  },
	  data: function() {
	    return {
	      account_status: Session.current_user.email_account_status,
	      show_alert: false,
	      nylas_setting: Session.current_user.nylas_setting
	    };
	  },
	  methods: {
	    emitOpenCompose: function() {
	      event.originalEventName = 'Compose::Open';
	      return EventsBus.$emit('Compose::Open', {
	        event: event
	      });
	    },
	    setRunningStatus: function() {
	      this.updateAccountStatus('running');
	      return this.show_alert = this.updateShowAlert();
	    },
	    updateAccountStatus: function(account_status) {
	      Session.current_user.email_account_status = account_status;
	      this.account_status = account_status;
	      return this.current_user = Session.current_user;
	    },
	    updateShowAlert: function() {
	      var ref;
	      if (!((ref = this.current_user) != null ? ref.email_account_status : void 0)) {
	        return false;
	      }
	      return this.show_account_status || this.show_nylas_setting;
	    },
	    subscribeToChannel: function() {
	      this.removeSubscription();
	      if (!this.current_user) {
	        return;
	      }
	      return this.subscription = ActionCable.cable.subscriptions.create({
	        channel: 'NylasAccountStatusUpdatedChannel',
	        user_id: this.current_user.id
	      }, {
	        received: (function(_this) {
	          return function(nylas_setting) {
	            _this.updateAccountStatus(nylas_setting.account_status);
	            _this.nylas_setting = nylas_setting;
	            return _this.show_alert = _this.updateShowAlert();
	          };
	        })(this)
	      });
	    },
	    removeSubscription: function() {
	      if (this.subscription) {
	        ActionCable.cable.subscriptions.remove(this.subscription);
	      }
	      return this.subscription = null;
	    }
	  },
	  computed: {
	    show_account_status: function() {
	      var ref, ref1;
	      return ((ref = this.current_user) != null ? ref.email_service_requires_authorization : void 0) && ((ref1 = this.current_user) != null ? ref1.email_account_status : void 0) !== 'running';
	    },
	    show_nylas_setting: function() {
	      var ref;
	      return ((ref = this.nylas_setting) != null ? ref.quota_exceeded : void 0) !== null;
	    }
	  },
	  created: function() {
	    this.current_user = Session.current_user;
	    this.show_alert = this.updateShowAlert();
	    return EventsBus.$on('email-account-connected', this.setRunningStatus);
	  },
	  mounted: function() {
	    var ref;
	    if ((ref = this.current_user) != null ? ref.email_service_requires_authorization : void 0) {
	      return this.subscribeToChannel();
	    }
	  },
	  beforeDestroy: function() {
	    return this.removeSubscription();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      current_company: Session.current_company
	    };
	  },
	  components: {
	    alertTick: __webpack_require__(185)
	  },
	  computed: {
	    css_class: function() {
	      if (!Session.current_user.plivo_endpoint || Session.current_company.isVoipExceeded() || !Session.current_company.isPlivo()) {
	        return "inactive";
	      } else {
	        return "";
	      }
	    },
	    voip_status: function() {
	      return this.current_company.voip_plan_status;
	    },
	    voip_message: function() {
	      switch (this.voip_status) {
	        case 'exceeded':
	          return 'Sua franquia mensal do VoIP se esgotou';
	        case 'exceeding':
	          return 'Sua franquia mensal do VoIP está próxima do fim';
	        case 'additional_time':
	          return 'Sua franquia mensal do VoIP se esgotou e estará consumindo seus minutos adicionais';
	        default:
	          return '';
	      }
	    }
	  },
	  methods: {
	    subscribeToVoipUsageChannel: function() {
	      this.removeVoipSubscription();
	      return this.voip_subscription = ActionCable.cable.subscriptions.create({
	        channel: 'PlivoPlanUsageChannel',
	        company_id: this.current_company.id
	      }, {
	        received: (function(_this) {
	          return function(event_data) {
	            Session.current_company.voip_plan_status = event_data;
	            _this.$emit('update-company');
	            return setTimeout(Tooltip.initialize, 1000);
	          };
	        })(this)
	      });
	    },
	    removeVoipSubscription: function() {
	      if (this.voip_subscription) {
	        ActionCable.cable.subscriptions.remove(this.voip_subscription);
	      }
	      return this.voip_subscription = null;
	    },
	    openDialer: function(number, number_type, task, open_comment) {
	      var data;
	      if (open_comment == null) {
	        open_comment = false;
	      }
	      event.originalEventName = 'open-dialer';
	      data = {
	        contact: task != null ? task.contact : void 0,
	        task: task,
	        number: number,
	        number_type: number_type,
	        open_comment: open_comment
	      };
	      return EventsBus.$emit('open-dialer', data);
	    }
	  },
	  created: function() {
	    this.voip_subscription = null;
	    return this.subscribeToVoipUsageChannel();
	  },
	  beforeDestroy: function() {
	    return this.removeVoipSubscription();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers;
	
	helpers = __webpack_require__(2);
	
	exports["default"] = {
	  props: {
	    max_height: {
	      "default": 200
	    }
	  },
	  computed: {
	    max_height_style: function() {
	      return this.max_height + "px";
	    }
	  }
	};


/***/ }),
/* 525 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    loading: {},
	    size: {
	      "default": '30px'
	    }
	  },
	  computed: {
	    style: function() {
	      return {
	        width: this.size,
	        height: this.size
	      };
	    }
	  }
	};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, summernote, view_model;
	
	helpers = __webpack_require__(2);
	
	summernote = __webpack_require__(78);
	
	view_model = {
	  data: function() {
	    return {
	      contact: new Contact,
	      show_comment_modal: false,
	      edit_comment: false,
	      comment_event: new ContactEvent,
	      task: null,
	      template: null,
	      variables: null
	    };
	  },
	  methods: {
	    "new": function(data) {
	      var contact, template;
	      contact = data.contact;
	      template = data.template;
	      this.show_comment_modal = !this.show_comment_modal;
	      if (this.show_comment_modal) {
	        this.edit_comment = false;
	        this.contact = contact;
	        if (template) {
	          this.template = template;
	          this.setSummernoteCode();
	        } else {
	          this.$comment.summernote('code', '');
	        }
	        return this.comment_event = new ContactEvent;
	      }
	    },
	    edit: function(data) {
	      this.show_comment_modal = true;
	      this.edit_comment = true;
	      this.contact = data.contact;
	      this.comment_event = data.comment;
	      return this.$comment.summernote('code', this.comment_event.comment);
	    },
	    reloadContact: function(contact) {
	      this.contact = contact;
	      if (this.template) {
	        return this.setSummernoteCode();
	      } else {
	        return this.$comment.summernote('code', '');
	      }
	    },
	    close: function() {
	      this.show_comment_modal = false;
	      this.$comment.summernote('code', '');
	      return this.template = null;
	    },
	    confirmRemoveComment: function() {
	      var params;
	      params = {
	        id: this.comment_event.id
	      };
	      this.comment_events_resource.destroy(this.destroySuccess, this.unknownError, params);
	      return this.close();
	    },
	    destroySuccess: function() {
	      alertify.success('Comentário excluído com sucesso!');
	      return EventsBus.$emit('Comment::Destroyed', this.comment_event);
	    },
	    inializeSummernote: function() {
	      this.$comment = jQuery('#comment-modal');
	      summernote(this.$comment, {
	        focus: false
	      });
	      return this.$comment.summernote('code', '');
	    },
	    saveComment: function() {
	      var comment_text;
	      comment_text = this.$comment.summernote('code');
	      if (comment_text.length === 0 || comment_text === '&nbsp;') {
	        alertify.error('Não é possível inserir um comentário sem conteúdo');
	        return;
	      }
	      Loader.on();
	      this.comment_event.description = '-';
	      this.comment_event.author = Session.current_user.name;
	      this.comment_event.edition_author = Session.current_user.name;
	      this.comment_event.comment = comment_text;
	      this.comment_events_resource.save(this.updateSuccess, this.unknownError, this.comment_event);
	      return this.show_comment_modal = false;
	    },
	    updateSuccess: function(data) {
	      Loader.off();
	      alertify.success('O comentário foi atualizado com sucesso!');
	      return EventsBus.$emit('Comment::CreatedUpdated', data.event);
	    },
	    removeComment: function() {
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'global_confirm_modal'
	      });
	    },
	    loadVariables: function() {
	      var params;
	      params = {
	        company_id: Session.current_company.id
	      };
	      return new VariableResource().index(this.loadVariablesSuccess, null, {
	        params: params
	      });
	    },
	    loadVariablesSuccess: function(resource) {
	      this.variables = resource.variables;
	      return this.setSummernoteCode();
	    },
	    setSummernoteCode: function() {
	      var comment;
	      comment = (this.template && this.template.body) ? this.template.body : '';
	      comment = this.variablesValues(comment);
	      return this.$comment.summernote('code', comment);
	    },
	    variablesValues: function(text) {
	      var i, len, ref, variable;
	      if (text !== '') {
	        ref = this.variables;
	        for (i = 0, len = ref.length; i < len; i++) {
	          variable = ref[i];
	          if (this.contact[variable.target_method]) {
	            text = text.replace(variable.placeholder, '<span class="' + variable.placeholder_name + '">' + this.contact[variable.target_method] + '</span>');
	          }
	        }
	      }
	      return text;
	    }
	  },
	  computed: {
	    contacts_name: function() {
	      if (this.contact) {
	        return this.contact.full_name;
	      }
	    },
	    modal_id: function() {
	      return 'confirm-remove-comment-global' + this.comment_event.id;
	    },
	    comment_events_resource: function() {
	      return new CommentEventsResource(this.contact.id);
	    }
	  },
	  created: function() {
	    EventsBus.$on('reload-contact', this.reloadContact);
	    EventsBus.$on('Comment::Destroy', this.confirmRemoveComment);
	    EventsBus.$on('Comment::Edit', this.edit);
	    return EventsBus.$on('Comment::New', this["new"]);
	  },
	  mounted: function() {
	    this.inializeSummernote();
	    return this.loadVariables();
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('reload-contact', this.reloadContact);
	    EventsBus.$off('Comment::Destroy', this.confirmRemoveComment);
	    EventsBus.$off('Comment::Edit', this.edit);
	    return EventsBus.$off('Comment::New', this["new"]);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.manual_tasks.list_wrapper, helpers.contacts.styles);


/***/ }),
/* 527 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: {
	    id: {
	      "default": 'confirm-modal'
	    },
	    title: {
	      "default": 'Título'
	    },
	    message: {
	      "default": null
	    },
	    confirm_text: {
	      "default": 'Confirmar'
	    },
	    confirm_class: {
	      "default": 'btn-primary'
	    },
	    reject_text: {
	      "default": 'Cancelar'
	    },
	    hide_on_confirm: {
	      "default": true
	    }
	  },
	  methods: {
	    confirm: function() {
	      if (this.hide_on_confirm) {
	        jQuery("#" + this.id).modal('hide');
	      }
	      return this.$emit('confirm-modal-confirm');
	    },
	    reject: function() {
	      return this.$emit('confirm-modal-reject');
	    },
	    show: function(data) {
	      if (data.id === this.id) {
	        return jQuery("#" + this.id).modal('show');
	      }
	    }
	  },
	  created: function() {
	    return EventsBus.$on('confirm-modal-show', this.show);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('confirm-modal-show', this.show);
	  }
	};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      contact: null,
	      flow: null
	    };
	  },
	  methods: {
	    openResetContactSameFlowConfirmationModal: function(data) {
	      this.contact = data.contact;
	      this.flow = data.flow;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-reset-same-flow'
	      });
	    },
	    callResetContact: function() {
	      return this.resetContactRecipient(this.contact);
	    }
	  },
	  created: function() {
	    EventsBus.$on('Contact::SameFlowConfirmationModal', this.openResetContactSameFlowConfirmationModal);
	    return this.contact_resource = new ContactsResource(Session.current_company.id);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('Contact::SameFlowConfirmationModal', this.openResetContactSameFlowConfirmationModal);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.contacts.list_wrapper);


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, on_clickaway, view_model;
	
	helpers = __webpack_require__(2);
	
	on_clickaway = __webpack_require__(5);
	
	view_model = {
	  mixins: [on_clickaway.mixin],
	  components: {
	    notificationDropdown: __webpack_require__(193)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      show_notifications_dropdown: false
	    };
	  },
	  computed: {
	    notifications_count: function() {
	      return this.$store.getters.unreadNotificationsCount;
	    }
	  },
	  methods: {
	    readAllNotificationsOnStore: function() {
	      return this.$store.commit('readAllNotifications');
	    },
	    readAllNotifications: function() {
	      return this.notifications_resource.readAll(null, this.unknownError);
	    },
	    toggleNotificationDropdown: function() {
	      this.show_notifications_dropdown = !this.show_notifications_dropdown;
	      if (this.show_notifications_dropdown) {
	        if (this.notifications_count > 0) {
	          return this.readAllNotifications();
	        }
	      } else {
	        if (this.notifications_count > 0) {
	          return this.readAllNotificationsOnStore();
	        }
	      }
	    },
	    closeNotificationDropdown: function() {
	      if (this.show_notifications_dropdown) {
	        this.show_notifications_dropdown = false;
	        if (this.notifications_count > 0) {
	          return this.readAllNotificationsOnStore();
	        }
	      }
	    }
	  },
	  created: function() {
	    return this.notifications_resource = new NotificationsResource();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  mixins: [__webpack_require__(604)],
	  components: {
	    list: __webpack_require__(207)
	  },
	  data: function() {
	    var ref;
	    this.current_user = Session.current_user;
	    return {
	      filters: {
	        q: {
	          user_id_eq: (ref = this.current_user) != null ? ref.id : void 0
	        }
	      }
	    };
	  },
	  methods: {
	    close: function() {
	      return this.$emit('close');
	    },
	    seeAllNotifications: function() {
	      this.close();
	      return this.$router.push('/notificacoes');
	    }
	  },
	  computed: {
	    show_all_notifications_button: function() {
	      return (this.current_user.isManager() || this.current_user.isMonitoringManager()) || this.notifications_count > 0;
	    },
	    unread_notifications_count: function() {
	      return this.$store.getters.unreadNotificationsCount;
	    },
	    notifications_count: function() {
	      return this.$store.getters.notificationsCount;
	    }
	  },
	  created: function() {
	    return EventsBus.$on('NotificationDropdown::Close', this.close);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('NotificationDropdown::Close', this.close);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    listItem: __webpack_require__(39)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      notifications: [],
	      next_page: 1,
	      loading: false
	    };
	  },
	  methods: {
	    updateNotification: function(notif) {
	      return this.notifications.replaceById(notif);
	    },
	    loadNotifications: function(filters) {
	      var params;
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      params = filters ? {
	        q: filters,
	        page: this.next_page
	      } : {
	        page: this.next_page
	      };
	      return this.notifications_resource.index(this.loadNotificationsSuccess, this.unknownError, {
	        params: params
	      });
	    },
	    loadNotificationsSuccess: function(data) {
	      this.loading = false;
	      this.notifications = this.notifications.concat(data.notifications);
	      return this.next_page = data.meta.next_page;
	    },
	    filter: function(filters) {
	      this.next_page = 1;
	      this.notifications = [];
	      return this.loadNotifications(filters);
	    }
	  },
	  computed: {
	    show_user_filter: function() {
	      return this.current_user.isManager();
	    }
	  },
	  created: function() {
	    this.notifications_resource = new NotificationsResource();
	    this.loadNotifications();
	    return EventsBus.$on('NotificationTask::Done', this.updateNotification);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('NotificationTask::Done', this.updateNotification);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    contacts_text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos';
	      } else {
	        return this.notification.count + ' contato';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/fluxos-de-cadencia/" + this.notification.metadata.flow_id
	    };
	  },
	  computed: {
	    flow_name: function() {
	      return this.notification.flow_name;
	    },
	    flow_id: function() {
	      return this.notification.flow_id;
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    contacts_text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos';
	      } else {
	        return this.notification.count + ' contato';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    contacts_text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos';
	      } else {
	        return this.notification.count + ' contato';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    contacts_text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos criados';
	      } else {
	        return this.notification.count + ' contato criado';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    contacts_text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos';
	      } else {
	        return this.notification.count + ' contato';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    contacts_text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos';
	      } else {
	        return this.notification.count + ' contato';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: '/tarefas'
	    };
	  },
	  computed: {
	    pre_text: function() {
	      if (this.notification.count > 1) {
	        return "Foram criadas ";
	      } else {
	        return "Foi criada ";
	      }
	    },
	    name: function() {
	      var ref;
	      if (this.manager_and_not_owner) {
	        return (ref = this.notification.user) != null ? ref.name : void 0;
	      } else {
	        return 'Você';
	      }
	    },
	    text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' Ozzy Tasks';
	      } else {
	        return ' 1 Ozzy Task';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: '/contatos/leads'
	    };
	  },
	  computed: {
	    contacts_text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos';
	      } else {
	        return this.notification.count + ' contato';
	      }
	    },
	    minutes: function() {
	      if (this.notification.kind === 'remind_ten_minutes') {
	        return 10;
	      } else {
	        return 30;
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: '/tarefas'
	    };
	  },
	  methods: {
	    loadTask: function(action) {
	      var fn;
	      fn = (function() {
	        switch (action) {
	          case 'task_email':
	            return this.openCompose;
	          case 'task_phonecall':
	            return this.openDialer;
	          case 'mask_as_done':
	            return this.doTask;
	          default:
	            return this.doTask;
	        }
	      }).call(this);
	      this.tasks_resources.get(fn, this.unknownError, {
	        id: this.notification.metadata.task_ids[0]
	      });
	      return this.closeDropdown();
	    },
	    openCompose: function(data) {
	      var task;
	      task = data.task;
	      event.originalEventName = 'Compose::Open';
	      return EventsBus.$emit('Compose::Open', {
	        event: event,
	        task: task
	      });
	    },
	    openDialer: function(data) {
	      var contact, number, number_type, task;
	      task = data.task;
	      contact = task.contact;
	      number_type = contact.cellphone ? 'cellphone' : 'telefone';
	      number = contact.cellphone || contact.telephone;
	      event.originalEventName = 'open-dialer';
	      data = {
	        contact: contact,
	        task: task,
	        number: number,
	        number_type: number_type
	      };
	      return EventsBus.$emit('open-dialer', data);
	    },
	    doTask: function(data) {
	      data.task.markAsDone();
	      return this.tasks_resources.save(this.taskUpdated, this.unknownError, data.task.serialize(['id', 'done_at']));
	    },
	    taskUpdated: function(data) {
	      var task;
	      task = data.task;
	      alertify.success('Tarefa atualizada com sucesso');
	      Vue.set(this.notification, 'task_done_at', task.done_at);
	      EventsBus.$emit('Task::Done', task);
	      return EventsBus.$emit('NotificationTask::Done', this.notification);
	    }
	  },
	  computed: {
	    done_task: function() {
	      return this.notification.task_done_at;
	    },
	    multiple_tasks: function() {
	      var ref, ref1;
	      return ((ref = this.notification.metadata) != null ? (ref1 = ref.task_ids) != null ? ref1.length : void 0 : void 0) > 1;
	    },
	    show_do_task: function() {
	      return this.notification.kind === 'task_email' || this.notification.kind === 'task_phonecall';
	    },
	    due_on: function() {
	      return moment(this.notification.task_due_on).format('LT');
	    },
	    text: function() {
	      if (this.notification.count > 1) {
	        return (" " + this.notification.count + " tarefas") + this.kind_text;
	      } else {
	        return " uma tarefa" + this.kind_text;
	      }
	    },
	    contact_name: function() {
	      if (this.notification.contact_name) {
	        return " para " + this.notification.contact_name;
	      } else {
	        return "";
	      }
	    },
	    flow_name: function() {
	      if (this.notification.flow_name) {
	        return " do fluxo " + this.notification.flow_name;
	      } else {
	        return "";
	      }
	    },
	    kind_text: function() {
	      switch (this.notification.kind) {
	        case 'task_email':
	          return ' de email ';
	        case 'task_social':
	          return ' de social ';
	        case 'task_linkedin':
	          return ' de InMail ';
	        case 'task_phonecall':
	          return ' de ligação ';
	        default:
	          return '';
	      }
	    }
	  },
	  created: function() {
	    return this.tasks_resources = new TasksResource;
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos já existentes';
	      } else {
	        return '1 contato já existente';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos já existentes';
	      } else {
	        return '1 contato já existente';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      go_to: "/contatos/leads?" + (this.ransack_contact_ids('id_in'))
	    };
	  },
	  computed: {
	    text: function() {
	      if (this.notification.count > 1) {
	        return this.notification.count + ' contatos já existentes';
	      } else {
	        return '1 contato já existente';
	      }
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.notifications.kind_wrapper);


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notifications'],
	  components: {
	    listItem: __webpack_require__(39)
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['notification', 'table'],
	  components: {
	    changeResponsability: __webpack_require__(194),
	    task: __webpack_require__(203),
	    ozzytask: __webpack_require__(201),
	    remind: __webpack_require__(202),
	    contactPublicApi: __webpack_require__(196),
	    createdRdStation: __webpack_require__(199),
	    updatedRdStation: __webpack_require__(205),
	    createdSharpSpring: __webpack_require__(200),
	    updatedSharpSpring: __webpack_require__(206),
	    createdLeadLovers: __webpack_require__(197),
	    updatedLeadLovers: __webpack_require__(204),
	    createdPipedrive: __webpack_require__(198),
	    contactInterrupted: __webpack_require__(195)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user
	    };
	  },
	  methods: {
	    remove: function(markAsRead) {
	      if (markAsRead == null) {
	        markAsRead = true;
	      }
	      return this.$emit('remove-notification', this.notification.id, markAsRead);
	    },
	    notificationComponent: function(notification) {
	      switch (notification.kind) {
	        case 'change_responsability':
	          return 'change-responsability';
	        case 'task_email':
	          return 'task';
	        case 'task_social':
	          return 'task';
	        case 'task_linkedin':
	          return 'task';
	        case 'task_phonecall':
	          return 'task';
	        case 'ozzytask':
	          return 'ozzytask';
	        case 'contact_public_api':
	          return 'contact-public-api';
	        case 'created_rd_station':
	          return 'created-rd-station';
	        case 'updated_rd_station':
	          return 'updated-rd-station';
	        case 'created_sharp_spring':
	          return 'created-sharp-spring';
	        case 'updated_sharp_spring':
	          return 'updated-sharp-spring';
	        case 'created_lead_lovers':
	          return 'created-lead-lovers';
	        case 'updated_lead_lovers':
	          return 'updated-lead-lovers';
	        case 'created_pipedrive':
	          return 'created-pipedrive';
	        case 'remind_ten_minutes':
	          return 'remind';
	        case 'remind_thirty_minutes':
	          return 'remind';
	        case 'contact_interrupted':
	          return 'contact-interrupted';
	        default:
	          return '';
	      }
	    }
	  },
	  created: function() {
	    return setTimeout((function(_this) {
	      return function() {
	        return _this.remove(false);
	      };
	    })(this), 5000);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    notificationListItem: __webpack_require__(39)
	  },
	  data: function() {
	    return {
	      notifications: []
	    };
	  },
	  methods: {
	    addNotification: function(notif) {
	      var notification;
	      notification = new Notification();
	      notification.id = notif.id;
	      notification.user_id = notif.user_id;
	      notification.count = notif.count;
	      notification.kind = notif.kind;
	      notification.created_at = moment(notif.created_at).toDate();
	      notification.updated_at = moment(notif.updated_at).toDate();
	      if (notif.contact_name) {
	        notification.contact_name = notif.contact_name;
	      }
	      if (notif.flow_name) {
	        notification.flow_name = notif.flow_name;
	      }
	      if (notif.task_due_on) {
	        notification.task_due_on = notif.task_due_on;
	      }
	      if (notif.metadata) {
	        notification.metadata = notif.metadata;
	      }
	      this.addOrReplaceNotification(notification);
	      return this.$store.commit('addOrReplaceNotification', notification);
	    },
	    addOrReplaceNotification: function(notification) {
	      if (this.notifications.find(notification.id)) {
	        return this.notifications.replaceById(notification);
	      } else {
	        return this.notifications.unshift(notification);
	      }
	    },
	    removeNotification: function(id, markAsRead) {
	      if (markAsRead == null) {
	        markAsRead = true;
	      }
	      if (markAsRead) {
	        this.notifications_resource.read(null, this.unknownError, {
	          id: id
	        });
	      }
	      return this.notifications.remove(id);
	    },
	    subscribeToNotificationChannel: function() {
	      this.removeNotificationSubscription();
	      return this.notification_subscription = ActionCable.cable.subscriptions.create({
	        channel: 'NotificationChannel',
	        user_id: Session.current_user.id
	      }, {
	        received: (function(_this) {
	          return function(event_data) {
	            return _this.addNotification(event_data);
	          };
	        })(this)
	      });
	    },
	    removeNotificationSubscription: function() {
	      if (this.notification_subscription) {
	        ActionCable.cable.subscriptions.remove(this.notification_subscription);
	      }
	      return this.notification_subscription = null;
	    }
	  },
	  created: function() {
	    this.notifications_resource = new NotificationsResource();
	    this.notification_subscription = null;
	    return this.subscribeToNotificationChannel();
	  },
	  beforeDestroy: function() {
	    return this.removeNotificationSubscription();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model);


/***/ }),
/* 548 */
/***/ (function(module, exports) {

	exports["default"] = {
	  props: ['total', 'value', 'label', 'show_details', 'show_raw_value'],
	  computed: {
	    value_text: function() {
	      if (this.total && this.total !== 0) {
	        if (this.show_details) {
	          return this.value + "/" + this.total;
	        } else {
	          return ((parseFloat(this.value) / this.total) * 100.0).toFixed(1).replace('.', ',') + '%';
	        }
	      } else {
	        if (this.show_raw_value && this.value) {
	          return this.value;
	        } else {
	          return '--';
	        }
	      }
	    }
	  }
	};


/***/ }),
/* 549 */
/***/ (function(module, exports) {

	module.exports = {
	  props: {
	    text: {
	      required: true
	    },
	    color: {
	      "default": '#000'
	    }
	  }
	};


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    specificTemplateListItem: __webpack_require__(212)
	  },
	  props: {
	    flow: {
	      required: true
	    },
	    contact: {
	      required: true
	    }
	  }
	};
	
	exports["default"] = view_model;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      current_user: Session.current_user
	    };
	  },
	  props: {
	    flow: {
	      required: true
	    },
	    action: {
	      required: true
	    },
	    contact: {
	      required: true
	    }
	  },
	  computed: {
	    specific_template: function() {
	      return this.action.contact_specific_templates.find((function(_this) {
	        return function(template) {
	          return template.belongsToContact(_this.contact) && !template._destroy;
	        };
	      })(this));
	    },
	    edited: function() {
	      return this.specific_template && Object.keys(this.specific_template).length > 0;
	    },
	    template: function() {
	      var template;
	      template = Object.assign({}, this.action.template);
	      if (this.specific_template) {
	        template.subject = this.specific_template.subject;
	        template.body = this.specific_template.body;
	        template.signature = this.specific_template.signature;
	      }
	      return template;
	    }
	  },
	  methods: {
	    editSpecificTemplate: function(event, attr) {
	      if (attr == null) {
	        attr = {};
	      }
	      event.originalEventName = 'specific-template-edit';
	      return this.$emit('specific-template-edit', {
	        event: event,
	        action: this.action
	      });
	    },
	    destroySpecificTemplate: function(event, attr) {
	      if (attr == null) {
	        attr = {};
	      }
	      event.originalEventName = 'specific-template-destroy';
	      return this.$emit('specific-template-destroy', {
	        event: event,
	        action: this.action
	      });
	    }
	  }
	};
	
	exports["default"] = view_model;


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model,
	  slice = [].slice;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    specificTemplatesList: __webpack_require__(211),
	    templateForm: __webpack_require__(26)
	  },
	  props: {
	    flow: {
	      required: true
	    },
	    contact: {
	      required: true
	    }
	  },
	  data: function() {
	    return {
	      id: 'edit-specific-templates',
	      fetching: true,
	      current_action: {},
	      current_template: {},
	      form_options: {
	        name: 'hide',
	        category: 'hide',
	        show_footer: false,
	        modal: true,
	        focus: false
	      }
	    };
	  },
	  computed: {
	    show_form: function() {
	      return Object.keys(this.current_action).length !== 0 && Object.keys(this.current_template).length !== 0;
	    },
	    title: function() {
	      if (!this.show_form) {
	        return this.$t('template.modal.edit.title');
	      } else {
	        return this.$t('template.modal.edit.titleSpecific', {
	          name: this.current_template.name
	        });
	      }
	    },
	    business_name: function() {
	      var ref, ref1;
	      return (ref = this.contact) != null ? (ref1 = ref.business) != null ? ref1.name : void 0 : void 0;
	    },
	    has_valid_email_actions: function() {
	      return this.flow.actions.some(function(action) {
	        return action.template_id;
	      });
	    },
	    template_kind: function() {
	      var _, i, kind, ref;
	      if (this.current_action == null) {
	        return 'email';
	      }
	      ref = this.current_action.manual_task_parameters.service.split('::'), _ = 2 <= ref.length ? slice.call(ref, 0, i = ref.length - 1) : (i = 0, []), kind = ref[i++];
	      return kind.toLowerCase();
	    }
	  },
	  methods: {
	    openSpecificTemplateForm: function(data) {
	      this.current_action = data.action;
	      return this.current_template = this.buildTemplate();
	    },
	    buildTemplate: function() {
	      var specific_template, template;
	      template = Object.assign({}, this.current_action.template);
	      specific_template = this.findSpecificTemplate();
	      if (specific_template) {
	        template.id = specific_template.id;
	        template.kind = this.template_kind;
	        template.subject = specific_template.subject;
	        template.body = specific_template.body;
	        template.signature = specific_template.signature;
	      }
	      return template;
	    },
	    findSpecificTemplate: function() {
	      return this.current_action.contact_specific_templates.find((function(_this) {
	        return function(template) {
	          return template.belongsToContact(_this.contact) && !template._destroy;
	        };
	      })(this));
	    },
	    updateSpecificTemplate: function(data) {
	      var old_specific_template, specific_template;
	      data.attr.template.contact_id = this.contact.id;
	      old_specific_template = this.removeSpecificTemplate(this.current_action);
	      specific_template = this.createSpecificTemplate(data.attr.template);
	      specific_template.id = old_specific_template ? old_specific_template.id : null;
	      specific_template.flow_action_id = this.current_action.id;
	      this.addSpecificTemplate(this.current_action, specific_template);
	      Loader.off();
	      return this.back();
	    },
	    removeSpecificTemplate: function(action) {
	      var contact_ids, index, removed, step;
	      step = action.step;
	      contact_ids = this.flow.actions[step].contact_specific_templates.map(function(template) {
	        return template.contact_id || template.contact.email;
	      });
	      index = contact_ids.indexOf(this.contact.id || this.contact.email);
	      if (index > -1) {
	        removed = this.flow.actions[step].contact_specific_templates.splice(index, 1);
	        return removed[0];
	      }
	      return null;
	    },
	    createSpecificTemplate: function(data) {
	      var contact_specific_template;
	      IntercomCtrl.trackEvent('Fluxo - Criação de template específico');
	      contact_specific_template = new ContactSpecificTemplate({
	        id: data.id,
	        flow_action_id: data.flow_action_id,
	        template_id: data.id,
	        subject: data.subject,
	        kind: data.kind,
	        body: data.body,
	        signature: data.signature,
	        contact: this.contact
	      });
	      if (data.contact_id) {
	        contact_specific_template.contact_id = data.contact_id;
	      } else {
	        contact_specific_template.contact_email = this.contact.email;
	      }
	      return contact_specific_template;
	    },
	    destroySpecificTemplate: function(data) {
	      var action, specific_template;
	      action = data.action;
	      specific_template = this.removeSpecificTemplate(action);
	      if (specific_template.id) {
	        specific_template._destroy = true;
	        this.addSpecificTemplate(action, specific_template);
	      }
	      return this.$emit('specific-template-destroy', {
	        action: action,
	        specific_template: specific_template
	      });
	    },
	    addSpecificTemplate: function(action, specific_template) {
	      this.flow.actions[action.step].contact_specific_templates.push(specific_template);
	      return this.$emit('specific-template-add', {
	        action: action,
	        specific_template: specific_template
	      });
	    },
	    show: function(data) {
	      this.current_action = {};
	      this.current_template = {};
	      if (data.id === this.id) {
	        return jQuery("#" + this.id).modal('show');
	      }
	    },
	    back: function() {
	      this.current_action = {};
	      return this.current_template = {};
	    },
	    submit: function() {
	      return EventsBus.$emit('TemplateForm:Submit');
	    }
	  },
	  created: function() {
	    return EventsBus.$on('confirm-modal-show', this.show);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('confirm-modal-show', this.show);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var on_clickaway;
	
	on_clickaway = __webpack_require__(5);
	
	module.exports = {
	  props: ['value'],
	  mixins: [on_clickaway.mixin],
	  data: function() {
	    return {
	      colors: Tag.colors,
	      show_picker: false
	    };
	  },
	  methods: {
	    setColor: function(color) {
	      this.$emit('input', color);
	      return this.show_picker = false;
	    },
	    onClickaway: function() {
	      return this.show_picker = false;
	    }
	  }
	};


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    newTag: __webpack_require__(215),
	    list: __webpack_require__(73)
	  },
	  data: function() {
	    return {
	      list_item_options: {
	        checkbox: false,
	        can_edit: true
	      }
	    };
	  },
	  methods: {
	    tagCreated: function(tag) {
	      return this.$refs.list.tags.unshift(tag);
	    }
	  },
	  beforeCreate: function() {
	    if (Session.current_user.isSeller() || Session.current_user.isMonitoringManager()) {
	      return this.$router.push('/configuracoes/perfil');
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  components: {
	    listItem: __webpack_require__(214)
	  },
	  props: ['options', 'list_item_options'],
	  data: function() {
	    return {
	      tags: [],
	      selected_tag: {},
	      selected_tags: [],
	      loading: false
	    };
	  },
	  methods: {
	    loadTags: function() {
	      var filters, ref;
	      filters = ((ref = this.options) != null ? ref.filters : void 0) || {};
	      this.tags = [];
	      this.loading = true;
	      return new TagsResource().index(this.loadTagsSuccess, null, {
	        params: {
	          q: filters
	        }
	      });
	    },
	    loadTagsSuccess: function(data) {
	      this.loading = false;
	      this.tags = data.tags;
	      return this.selected_tags = [];
	    },
	    openDestroyConfirmationModal: function(tag) {
	      this.selected_tag = tag;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-destroy-tag'
	      });
	    },
	    destroyTag: function() {
	      Loader.on();
	      return new TagsResource().destroy(this.successDestroyTag, this.unknownError, {
	        id: this.selected_tag.id
	      });
	    },
	    successDestroyTag: function() {
	      Loader.off();
	      this.tags.remove(this.selected_tag.id);
	      this.$store.commit('removeTag', this.selected_tag);
	      return alertify.success('Categoria excluída com sucesso');
	    },
	    tagUpdated: function(tag) {
	      return this.tags.replaceById(tag);
	    },
	    tagSelectionToggle: function(data) {
	      if (data.selected) {
	        if (!this.selected_tags.find(data.tag.id)) {
	          this.selected_tags.push(data.tag);
	        }
	      } else {
	        this.selected_tags.remove(data.tag.id);
	      }
	      return this.$emit('selection-changed', this.selected_tags);
	    }
	  },
	  created: function() {
	    return this.loadTags();
	  }
	};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    tag: __webpack_require__(9),
	    colorInput: __webpack_require__(72)
	  },
	  props: ['tag', 'options'],
	  data: function() {
	    return {
	      name: this.tag.name,
	      color: this.tag.color,
	      selected: false,
	      editing: false,
	      default_options: {
	        can_edit: true,
	        checkbox: true
	      }
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll({
	        name: this.name
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.updateTag();
	          }
	        };
	      })(this));
	    },
	    updateTag: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: this.tag.id,
	        name: this.name,
	        color: this.color
	      };
	      return new TagsResource().update(this.updateTagSuccess, this.handleApiErrors, params);
	    },
	    updateTagSuccess: function(data) {
	      Loader.off();
	      alertify.success('Salvo com sucesso');
	      this.editing = false;
	      return this.$emit('updated', data.tag);
	    },
	    destroyTag: function() {
	      return this.$emit('destroy', this.tag);
	    },
	    toggleSelected: function() {
	      this.selected = !this.selected;
	      return this.$emit('selection-toggle', {
	        tag: this.tag,
	        selected: this.selected
	      });
	    },
	    mergeDefaultOptions: function() {
	      return this.default_options = Object.assign({}, this.default_options, this.options || {});
	    }
	  },
	  watch: {
	    tag: function() {
	      return this.selected = false;
	    }
	  },
	  created: function() {
	    return this.mergeDefaultOptions();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    colorInput: __webpack_require__(72)
	  },
	  data: function() {
	    return {
	      name: '',
	      color: Tag.colors[0]
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll({
	        name: this.name
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.createTag();
	          }
	        };
	      })(this));
	    },
	    createTag: function() {
	      Loader.on();
	      return new TagsResource().create(this.createTagSuccess, this.handleApiErrors, {
	        name: this.name,
	        color: this.color
	      });
	    },
	    createTagSuccess: function(data) {
	      Loader.off();
	      alertify.success('Salvo com sucesso');
	      this.$emit('created', data.tag);
	      this.$store.commit('addTag', data.tag);
	      this.name = '';
	      this.color = Tag.colors[0];
	      return this.$nextTick((function(_this) {
	        return function() {
	          return _this.errors.clear();
	        };
	      })(this));
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers;
	
	helpers = __webpack_require__(2);
	
	module.exports = {
	  components: {
	    list: __webpack_require__(73)
	  },
	  props: ['taggable', 'prop_id'],
	  data: function() {
	    return {
	      selected_tags: [],
	      list_item_options: {
	        checkbox: true,
	        can_edit: false
	      }
	    };
	  },
	  computed: {
	    list_options: function() {
	      var tag, tag_ids;
	      if (!this.taggable) {
	        return;
	      }
	      tag_ids = (function() {
	        var i, len, ref, results;
	        ref = this.taggable.tags;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          tag = ref[i];
	          results.push(tag.id);
	        }
	        return results;
	      }).call(this);
	      return {
	        filters: {
	          id_not_in: tag_ids
	        }
	      };
	    }
	  },
	  methods: {
	    pick: function() {
	      return this.$emit('picked', this.selected_tags);
	    },
	    selection_changed: function(tags) {
	      return this.selected_tags = tags;
	    },
	    reloadTags: function(tags) {
	      return this.$refs.tag_list.loadTags();
	    }
	  }
	};


/***/ }),
/* 559 */
/***/ (function(module, exports) {

	module.exports = {
	  props: {
	    tag: {
	      type: Tag
	    },
	    deletable: {
	      type: Boolean,
	      "default": false
	    }
	  },
	  computed: {
	    style: function() {
	      var color;
	      color = "#" + this.tag.color;
	      return {
	        color: color,
	        'border-right-color': color
	      };
	    }
	  },
	  methods: {
	    removeTag: function() {
	      return this.$emit('remove-tag', this.tag);
	    }
	  }
	};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    listItem: __webpack_require__(216),
	    newTemplateCategory: __webpack_require__(217)
	  },
	  data: function() {
	    return {
	      template_categories: [],
	      name: '',
	      editing: null,
	      loading: true,
	      selected_template_category: {}
	    };
	  },
	  methods: {
	    loadTemplateCategories: function() {
	      return new TemplateCategoriesResource(Session.current_company.id).index(this.loadTemplateCategoriesSuccess);
	    },
	    loadTemplateCategoriesSuccess: function(data) {
	      this.loading = false;
	      return this.template_categories = data.template_categories;
	    },
	    toggleEditClass: function(id) {
	      if (this.editing && this.editing.id === id) {
	        return '';
	      } else {
	        return 'hidden';
	      }
	    },
	    updatedTemplateCategory: function(template_category) {
	      var index;
	      index = this.template_categories.findIndex(template_category.id);
	      return this.template_categories.replaceById(template_category);
	    },
	    createdTemplateCategory: function(template_category) {
	      return this.template_categories.unshift(template_category);
	    },
	    openDestroyConfirmationModal: function(template_category) {
	      this.selected_template_category = template_category;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'confirm-destroy-template-category'
	      });
	    },
	    destroyTemplateCategory: function() {
	      Loader.on();
	      return new TemplateCategoriesResource().destroy(this.successDestroyTemplateCategory, this.unknownError, {
	        id: this.selected_template_category.id
	      });
	    },
	    successDestroyTemplateCategory: function() {
	      Loader.off();
	      this.template_categories.remove(this.selected_template_category.id);
	      this.$store.commit('removeTemplateCategory', this.selected_template_category);
	      alertify.success('Categoria excluída com sucesso');
	      return IntercomCtrl.trackEvent('Excluiu uma categoria de template', {
	        id: this.selected_template_category.id,
	        'Nome': this.selected_template_category.name
	      });
	    }
	  },
	  beforeCreate: function() {
	    if (Session.current_user.isSeller() || Session.current_user.isMonitoringManager()) {
	      return this.$router.push('/configuracoes/perfil');
	    }
	  },
	  created: function() {
	    return this.loadTemplateCategories();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['template_category'],
	  data: function() {
	    return {
	      name: this.template_category.name,
	      editing: false
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll({
	        name: this.name
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.updateTemplateCategory();
	          }
	        };
	      })(this));
	    },
	    updateTemplateCategory: function() {
	      var params;
	      Loader.on();
	      params = {
	        id: this.template_category.id,
	        name: this.name
	      };
	      return new TemplateCategoriesResource().update(this.updateTemplateCategorySuccess, this.handleApiErrors, params);
	    },
	    updateTemplateCategorySuccess: function(data) {
	      Loader.off();
	      alertify.success('Salvo com sucesso');
	      this.editing = false;
	      this.trackIntercomTemplateCategoryUpdate(data.template_category);
	      return this.$emit('updated', data.template_category);
	    },
	    destroyTemplateCategory: function() {
	      return this.$emit('destroy', this.template_category);
	    },
	    trackIntercomTemplateCategoryUpdate: function(template_category) {
	      var metadata;
	      metadata = [
	        {
	          attribute: 'name',
	          key: 'Nome',
	          "function": 'changedFromTo'
	        }
	      ];
	      return IntercomCtrl.trackEventMetadata('Atualizou uma categoria de template', metadata, this.template_category, template_category);
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      name: ''
	    };
	  },
	  methods: {
	    submit: function() {
	      return this.$validator.validateAll({
	        name: this.name
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.createTemplateCategory();
	          }
	        };
	      })(this));
	    },
	    createTemplateCategory: function() {
	      Loader.on();
	      return new TemplateCategoriesResource(Session.current_company.id).create(this.createTemplateCategorySuccess, this.handleApiErrors, {
	        name: this.name
	      });
	    },
	    createTemplateCategorySuccess: function(data) {
	      Loader.off();
	      alertify.success('Salvo com sucesso');
	      this.$emit('created', data.template_category);
	      this.$store.commit('addTemplateCategory', data.template_category);
	      this.name = '';
	      this.$nextTick((function(_this) {
	        return function() {
	          return _this.errors.clear();
	        };
	      })(this));
	      return IntercomCtrl.trackEvent('Criou uma categoria de template', {
	        'Nome': data.template_category.name
	      });
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    templateForm: __webpack_require__(26)
	  },
	  props: {
	    element_id: {
	      "default": 'create-template-modal'
	    },
	    action: {
	      type: FlowAction,
	      required: false
	    },
	    template: {
	      "default": function() {
	        return {};
	      }
	    },
	    options: {
	      type: Object
	    }
	  },
	  data: function() {
	    return {
	      template_kind: 'email',
	      current_user: Session.current_user,
	      default_options: {
	        title: this.$t('template.actions.new'),
	        subtitle: ' ',
	        name: 'show',
	        category: 'show',
	        delete_button: false,
	        disable_buttons: false
	      }
	    };
	  },
	  computed: {
	    element_options: function() {
	      return Object.assign({}, this.default_options, this.options || {});
	    },
	    form_id: function() {
	      return this.element_id + '-form';
	    },
	    form_options: function() {
	      return {
	        name: this.element_options.name,
	        category: this.element_options.category,
	        show_footer: false,
	        focus: true,
	        modal: true,
	        preload: this.element_options.preload,
	        from_flow: this.element_options.from_flow
	      };
	    },
	    has_template: function() {
	      return this.template !== null && !jQuery.isEmptyObject(this.template) && !Array.isArray(this.template);
	    },
	    template_or_default: function() {
	      if (!this.has_template) {
	        return new Template({
	          signature: Session.current_user.signature,
	          kind: this.template_kind
	        });
	      } else {
	        return this.template;
	      }
	    }
	  },
	  methods: {
	    show: function(data) {
	      if (data.id !== this.element_id) {
	        return;
	      }
	      this.template_or_default.name = data.template_name;
	      this.template_or_default.template_category_id = data.template_category_id;
	      this.template_kind = data.template_kind;
	      if (!this.has_template) {
	        this.$refs.template_form.clear();
	      }
	      return jQuery("#" + this.element_id).modal('show');
	    },
	    hide: function() {
	      return jQuery("#" + this.element_id).modal('hide');
	    },
	    cancel: function() {
	      this.$emit('cancel');
	      return this.hide();
	    },
	    submit: function() {
	      return EventsBus.$emit('TemplateForm:Submit');
	    },
	    saveTemplate: function(data) {
	      this.bubbleUp(data);
	      return this.hide();
	    },
	    destroy: function() {
	      this.$emit('destroy');
	      return this.hide();
	    }
	  },
	  created: function() {
	    return EventsBus.$on('confirm-modal-show', this.show);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('confirm-modal-show', this.show);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    templateForm: __webpack_require__(26)
	  },
	  data: function() {
	    return {
	      template: {},
	      update_flow_templates: true,
	      options: {
	        responsible: 'disabled'
	      }
	    };
	  },
	  computed: {
	    actions_count_text: function() {
	      var text;
	      text = this.template.actions_count <= 1 ? 'fluxo' : 'fluxos';
	      return this.template.actions_count + " " + text;
	    },
	    optionsLabel: function() {
	      return this.$t('template.label.optionsLabel', {
	        actionsCountText: this.actions_count_text
	      });
	    }
	  },
	  methods: {
	    loadTemplate: function() {
	      Loader.on();
	      return this.templates_resource.get(this.loadTemplateSuccess, this.unknownError, {
	        id: this.$route.params.id
	      });
	    },
	    loadTemplateSuccess: function(data) {
	      Loader.off();
	      this.template = data.template;
	      this.template.user_id = data.template.user.id;
	      return IntercomCtrl.trackEvent(this.$t('template.label.templateViewer'));
	    },
	    save: function() {
	      Loader.on();
	      if (this.update_flow_templates) {
	        return this.templates_resource.update(this.saveSuccess, this.unknownError, this.template);
	      } else {
	        return this.templates_resource.create(this.saveSuccess, this.unknownError, this.template);
	      }
	    },
	    saveSuccess: function(response) {
	      Loader.off();
	      this.$router.push('/templates');
	      alertify.success(this.$t('template.label.saveSuccess'));
	      if (response) {
	        return this.trackIntercomEvent(response);
	      }
	    },
	    saveConfirmation: function(data) {
	      Loader.off();
	      if (!data.attr.metadata.submittable) {
	        return this.saveSuccess();
	      } else if (this.template.actions_count > 0) {
	        return EventsBus.$emit('confirm-modal-show', {
	          id: 'confirm-edit-template'
	        });
	      } else {
	        return this.save();
	      }
	    },
	    trackIntercomEvent: function(response) {
	      var metadata, template;
	      template = response.data ? response.data.template : response.template;
	      metadata = [
	        {
	          value: location.href + "/" + template.id + "/editar",
	          key: this.$t('template.label.templateURL')
	        }, {
	          attribute: 'body',
	          key: this.$t('template.label.imagesContentLength'),
	          "function": 'htmlImgTagQuantity'
	        }, {
	          attribute: 'body',
	          key: this.$t('template.label.hiperlinksContentLength'),
	          "function": 'htmlATagQuantity'
	        }, {
	          attribute: 'signature',
	          key: this.$t('template.label.imagesSignatureLength'),
	          "function": 'htmlImgTagQuantity'
	        }, {
	          attribute: 'signature',
	          key: this.$t('template.label.hiperlinksSignatureLength'),
	          "function": 'htmlATagQuantity'
	        }
	      ];
	      return IntercomCtrl.trackEventMetadata(this.$t('template.label.templateEditing'), metadata, null, template);
	    }
	  },
	  created: function() {
	    this.templates_resource = new TemplatesResource(Session.current_company.id);
	    return this.loadTemplate();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  mixins: [__webpack_require__(6), __webpack_require__(605)],
	  props: ['filters', 'options'],
	  data: function() {
	    return {
	      default_options: {
	        show_user_filter: !Session.current_user.isSeller()
	      },
	      sort_filter: this.extractFilter('s'),
	      sort_options: [
	        {
	          value: null,
	          text: this.$t('general.label.newest')
	        }, {
	          value: {
	            s: 'id asc'
	          },
	          text: this.$t('general.label.oldest')
	        }
	      ],
	      template_category_filter: this.extractFilter('template_category_id_eq'),
	      template_category_options: [
	        {
	          value: null,
	          text: this.$t('general.label.loading')
	        }
	      ],
	      user_filter: this.extractFilter('user_id_eq'),
	      users_options: [
	        {
	          value: null,
	          text: this.$t('general.label.loading')
	        }
	      ],
	      kind_filter: this.extractFilter('kind_eq'),
	      kind_options: [
	        {
	          value: null,
	          text: this.$t('template.options.all')
	        }, {
	          value: {
	            kind_eq: 0
	          },
	          text: this.$t('template.options.email')
	        }, {
	          value: {
	            kind_eq: 1
	          },
	          text: this.$t('template.options.call')
	        }, {
	          value: {
	            kind_eq: 3
	          },
	          text: this.$t('template.options.linkedin')
	        }, {
	          value: {
	            kind_eq: 2
	          },
	          text: this.$t('template.options.social')
	        }
	      ],
	      text_field_filter: this.filters.name_or_subject_cont
	    };
	  },
	  computed: {
	    filterParams: function() {
	      var filter, filter_params, i, len, ref;
	      filter_params = {};
	      ref = [this.sort_filter, this.template_category_filter, this.user_filter, this.kind_filter];
	      for (i = 0, len = ref.length; i < len; i++) {
	        filter = ref[i];
	        if (filter) {
	          Object.assign(filter_params, filter);
	        }
	      }
	      if (this.text_field_filter) {
	        filter_params['name_or_subject_cont'] = this.text_field_filter;
	      }
	      return filter_params;
	    }
	  },
	  methods: {
	    filter: function() {
	      IntercomCtrl.trackEvent(this.$t('template.label.templateManualSearch'));
	      this.applyFiltersOnUrlQueryParams(this.filterParams);
	      return this.$emit('filter', this.filterParams);
	    }
	  },
	  created: function() {
	    return this.default_options = Object.assign(this.default_options, this.options);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.filters);


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, summernote, view_model;
	
	helpers = __webpack_require__(2);
	
	summernote = __webpack_require__(77);
	
	view_model = {
	  props: {
	    id: {
	      "default": "template-form"
	    },
	    template: {
	      "default": {}
	    },
	    default_template_kind: {
	      "default": null
	    },
	    options: {
	      type: Object
	    }
	  },
	  components: {
	    dropdownSelect: __webpack_require__(181),
	    variablesDropdown: __webpack_require__(76),
	    list: __webpack_require__(75)
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      company: Session.current_company,
	      template_kind: this.default_template_kind ? this.default_template_kind : 'email',
	      template_category_options: [
	        {
	          value: null,
	          text: this.$t('general.label.loading')
	        }
	      ],
	      template_user_options: [
	        {
	          value: null,
	          text: this.$t('general.label.loading')
	        }
	      ],
	      variables: [],
	      sellers: [],
	      disabledBnt: false,
	      apiErrorMessages: [],
	      lastSubjectCursorPosition: 0,
	      pristine: true,
	      list_item_options: {
	        show_open_statistic: true,
	        show_reply_statistic: true,
	        show_user: true,
	        row_click_action: 'new',
	        action: 'select-action'
	      },
	      list_options: {
	        only_current_user_templates: false
	      },
	      filter_options: {
	        show_user_filter: true
	      },
	      default_options: {
	        name: 'show',
	        category: 'show',
	        show_footer: true,
	        preload: null,
	        focus: false,
	        modal: false,
	        template_type: 'OriginalTemplate'
	      }
	    };
	  },
	  methods: {
	    fillForm: function(data) {
	      this.$body.summernote('code', data.template.body);
	      if (Session.current_user.signature) {
	        this.$signature.summernote('code', Session.current_user.signature);
	      }
	      this.template.subject = data.template.subject || "-";
	      this.template.template_category_id = data.template.template_category_id;
	      this.template.name = data.template.name;
	      this.template.kind = data.template.kind;
	      this.template.signature = Session.current_user.signature;
	      return this.template_kind = data.template.kind;
	    },
	    changeTemplateType: function(new_kind) {
	      if (this.inactive(new_kind)) {
	        return;
	      }
	      this.template_kind = new_kind;
	      this.template.kind = new_kind;
	      if (new_kind !== "email") {
	        return this.template.subject = "-";
	      }
	    },
	    submit: function(metadata) {
	      this.ensureSummernoteCode();
	      return this.$validator.validateAll(this.template).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.validateTemplate(metadata);
	          }
	        };
	      })(this));
	    },
	    validateTemplate: function(metadata) {
	      var templates_resource;
	      Loader.on();
	      this.disabledBnt = true;
	      templates_resource = new TemplatesResource(Session.current_company.id);
	      return templates_resource.validate(this.emitValidationSuccess(metadata), this.failcallback, this.template);
	    },
	    failcallback: function(response) {
	      this.disabledBnt = false;
	      return this.handleApiErrors(response);
	    },
	    emitValidationSuccess: function(metadata) {
	      return (function(_this) {
	        return function(response) {
	          var attr, event;
	          if (!metadata) {
	            metadata = {};
	          }
	          metadata.submittable = _this.submittable;
	          event = {
	            originalEventName: 'validation-success'
	          };
	          attr = {
	            template: _this.template,
	            metadata: metadata
	          };
	          _this.disabledBnt = false;
	          return _this.$emit('validation-success', {
	            event: event,
	            attr: attr
	          });
	        };
	      })(this);
	    },
	    addVariablePlaceholder: function(data) {
	      return this.template[data.attribute] += data.variable.placeholder;
	    },
	    loadTemplateCategories: function() {
	      if (this.element_options.preload && this.element_options.preload.categories) {
	        return this.template_category_options = this.element_options.preload.categories;
	      } else {
	        return new TemplateCategoriesResource(Session.current_company.id).index(this.templateCategoriesSuccess, this.unknownError, {
	          params: {
	            q: {
	              s: 'name asc'
	            }
	          }
	        });
	      }
	    },
	    loadTemplateUsers: function() {
	      if (!this.show_responsible_dropdown) {
	        return;
	      }
	      Loader.on();
	      if (this.element_options.preload && this.element_options.preload.users) {
	        return this.template_user_options = this.element_options.preload.users;
	      } else {
	        return new UsersResource().index(this.loadTemplateUsersSuccess, this.unknownError, {
	          params: {
	            q: {
	              s: 'name asc'
	            }
	          }
	        });
	      }
	    },
	    loadTemplateUsersSuccess: function(data) {
	      var i, len, ref, user;
	      this.template_user_options = [];
	      ref = data.users;
	      for (i = 0, len = ref.length; i < len; i++) {
	        user = ref[i];
	        if (user.isSeller()) {
	          this.sellers.push(user);
	          this.template_user_options.push({
	            value: user.id,
	            text: user.name
	          });
	        }
	      }
	      this.template_user_options.unshift({
	        value: null,
	        text: this.$t('template.options.userSelect')
	      });
	      return Loader.off();
	    },
	    templateCategoriesSuccess: function(data) {
	      var template_category, template_category_options;
	      template_category_options = (function() {
	        var i, len, ref, results;
	        ref = data.template_categories;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          template_category = ref[i];
	          results.push({
	            value: template_category.id,
	            text: template_category.name
	          });
	        }
	        return results;
	      })();
	      template_category_options.unshift({
	        value: null,
	        text: this.$t('template.options.categorySelect')
	      });
	      return this.template_category_options = template_category_options;
	    },
	    loadVariables: function() {
	      var params;
	      if (this.element_options.preload && this.element_options.preload.variables) {
	        return this.variables = this.element_options.preload.variables;
	      } else {
	        params = {
	          company_id: Session.current_company.id
	        };
	        return new VariableResource().index(this.loadVariablesSuccess, null, {
	          params: params
	        });
	      }
	    },
	    loadVariablesSuccess: function(resource) {
	      return this.variables = resource.variables;
	    },
	    inializeSummernote: function() {
	      this.$signature = jQuery('#' + this.id + ' .signature');
	      if (this.element_options.focus) {
	        summernote(this.$signature, {
	          focus: true
	        });
	      } else {
	        summernote(this.$signature);
	      }
	      this.$body = jQuery('#' + this.id + ' .body');
	      if (this.element_options.focus) {
	        return summernote(this.$body, {
	          focus: true
	        });
	      } else {
	        return summernote(this.$body);
	      }
	    },
	    ensureSummernoteCode: function() {
	      var body, signature;
	      body = this.$body.summernote('code');
	      if (body !== this.template.body) {
	        this.setDirty();
	      }
	      this.template.body = body !== '<p><br></p>' ? body : '';
	      signature = this.$signature.summernote('code');
	      if (signature !== this.template.signature) {
	        this.setDirty();
	      }
	      return this.template.signature = signature !== '<p><br></p>' ? signature : '';
	    },
	    updateLastSubjectCursorPosition: function(evt) {
	      return this.lastSubjectCursorPosition = evt.target.selectionStart;
	    },
	    addVariableToSubject: function(data) {
	      return this.template.subject = [this.template.subject.slice(0, this.lastSubjectCursorPosition), data.variable.placeholder, this.template.subject.slice(this.lastSubjectCursorPosition)].join('');
	    },
	    addVariableToBody: function(data) {
	      this.$body.summernote('editor.restoreRange');
	      this.$body.summernote('editor.focus');
	      return this.$body.summernote('editor.insertText', data.variable.placeholder);
	    },
	    saveSummernoteRange: function() {
	      return this.$body.summernote('editor.saveRange');
	    },
	    setSummernoteCode: function() {
	      if (this.template.body) {
	        this.$body.summernote('code', this.template.body);
	      }
	      if (this.template.signature) {
	        return this.$signature.summernote('code', this.template.signature);
	      }
	    },
	    clear: function() {
	      this.$body.summernote('code', '');
	      return this.errors.clear();
	    },
	    nameLabel: function() {
	      switch (this.template_kind) {
	        case "email":
	          return this.$t('template.attributes.nameTemplate');
	        case "phonecall":
	          return this.$t('template.attributes.nameRoadMap');
	        case "linkedin":
	          return this.$t('template.attributes.nameLinkedin');
	        case "social":
	          return this.$t('template.attributes.nameSocial');
	        default:
	          return this.$t('template.attributes.name');
	      }
	    },
	    contentLabel: function() {
	      switch (this.template_kind) {
	        case "email":
	          return this.$t('template.attributes.contentEmail');
	        case "phonecall":
	          return this.$t('template.attributes.contentCall');
	        case "linkedin":
	          return this.$t('template.attributes.contentLinkedin');
	        case "social":
	          return this.$t('template.attributes.contentSocial');
	        default:
	          return this.$t('template.attributes.content');
	      }
	    },
	    buttonLabel: function() {
	      switch (this.template_kind) {
	        case "email":
	          return this.$t('template.attributes.template');
	        case "phonecall":
	          return this.$t('template.attributes.roadMap');
	        case "linkedin":
	          return this.$t('template.attributes.linkedin');
	        case "social":
	          return this.$t('template.attributes.social');
	        default:
	          return this.$t('general.actions.create');
	      }
	    },
	    inactive: function(kind) {
	      return (this.default_template_kind !== null && this.default_template_kind !== kind) || (this.template.id && this.template.kind !== kind);
	    }
	  },
	  computed: {
	    show_responsible_dropdown: function() {
	      return !this.company.account_setting.seller_can_edit_templates && this.show_company_management_options && !this.element_options.from_flow;
	    },
	    show_company_management_options: function() {
	      return this.current_user.isAdmin() || (!this.current_user.requireEmailAuthorization() && !this.current_user.isSeller() && !this.current_user.isMonitoringManager());
	    },
	    templateCategoryClassObject: function() {
	      return {
	        'has-error': this.errors.has('template_category_id') || this.errors.has('template_category')
	      };
	    },
	    subject_group_class: function() {
	      if (this.errors.has('subject')) {
	        return 'has-error';
	      } else if (this.template.subject) {
	        if (this.template.subject.length > 60) {
	          return 'has-danger';
	        } else if (this.template.subject.length > 40) {
	          return 'has-warning';
	        }
	      }
	    },
	    subject_help_text: function() {
	      if (this.errors.has('subject')) {
	        return this.errors.first('subject');
	      } else if (this.template.subject) {
	        if (this.template.subject.length > 60) {
	          return this.$t('template.label.characterLimit60');
	        } else if (this.template.subject.length > 40) {
	          return this.$t('template.label.characterLimit40');
	        }
	      }
	    },
	    element_options: function() {
	      return Object.assign({}, this.default_options, this.options || {});
	    }
	  },
	  watch: {
	    default_template_kind: function() {
	      this.template_kind = this.default_template_kind;
	      this.template.kind = this.default_template_kind;
	      if (this.default_template_kind !== 'email') {
	        return this.template.subject = "-";
	      }
	    },
	    template: function(new_template) {
	      this.setSummernoteCode();
	      if (this.template.kind === null) {
	        return this.template.kind = 'email';
	      }
	    },
	    element_options: function(new_options) {
	      if (new_options.preload) {
	        this.loadTemplateCategories();
	        return this.loadVariables();
	      }
	    }
	  },
	  created: function() {
	    EventsBus.$on('TemplateForm:Submit', this.submit);
	    this.possible_template_types = ['email', 'phonecall', 'social', 'linkedin'];
	    this.template.kind = 'email';
	    this.loadTemplateCategories();
	    this.loadVariables();
	    return this.loadTemplateUsers();
	  },
	  mounted: function() {
	    this.errors.clear();
	    this.inializeSummernote();
	    return this.setSummernoteCode();
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('TemplateForm:Submit', this.submit);
	    this.$body.summernote('destroy');
	    return this.$signature.summernote('destroy');
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  data: function() {
	    return {
	      current_user: Session.current_user
	    };
	  },
	  components: {
	    list: __webpack_require__(75)
	  }
	};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    filters: __webpack_require__(219),
	    listItem: __webpack_require__(220),
	    showModal: __webpack_require__(223)
	  },
	  props: ['options', 'list_item_options', 'filter_options'],
	  data: function() {
	    return {
	      templates: [],
	      modal_template: null,
	      selected_template_to_destroy: {},
	      filters: {},
	      loading: false,
	      next_page: 1,
	      default_options: {
	        only_current_user_templates: true
	      }
	    };
	  },
	  methods: {
	    loadTemplates: function() {
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      this.loading = true;
	      return this.templates_resource.index(this.loadTemplatesSuccess, Loader.off, {
	        params: {
	          q: this.buildFilters(),
	          page: this.next_page
	        }
	      });
	    },
	    loadTemplatesSuccess: function(resources) {
	      this.next_page = resources.meta.next_page;
	      this.loading = false;
	      return this.templates = this.templates.concat(resources.templates);
	    },
	    showTemplate: function(template) {
	      this.modal_template = template;
	      return jQuery('#template-show').modal('show');
	    },
	    showDestroyConfirmationModal: function(template) {
	      this.selected_template_to_destroy = template;
	      return EventsBus.$emit('confirm-modal-show', {
	        id: 'destroy-template-confirmation-modal'
	      });
	    },
	    destroy: function() {
	      var id;
	      Loader.on();
	      id = this.selected_template_to_destroy.id;
	      return new TemplatesResource().destroy(this.destroySuccess(id), this.destroyFailure, {
	        id: id
	      });
	    },
	    destroySuccess: function(id) {
	      return (function(_this) {
	        return function() {
	          Loader.off();
	          _this.templates.remove(id);
	          return alertify.success(_this.$t('template.feedback.removeSuccess'));
	        };
	      })(this);
	    },
	    destroyFailure: function() {
	      Loader.off();
	      return alertify.error(this.$t('template.feedback.removeFail'));
	    },
	    filter: function(filters) {
	      this.filters = filters;
	      this.templates = [];
	      this.next_page = 1;
	      return this.loadTemplates();
	    },
	    buildFilters: function() {
	      if (this.default_options.only_current_user_templates) {
	        return this.mergeCurrentUserFilterIfSeller(this.filters);
	      } else {
	        return this.filters;
	      }
	    }
	  },
	  computed: {
	    destroy_confirm_modal_message: function() {
	      return this.$t('template.label.removeTemplateByNameConfirm', {
	        name: this.selected_template_to_destroy.name
	      });
	    }
	  },
	  created: function() {
	    this.setFiltersFromQueryParams();
	    this.templates_resource = new TemplatesResource(Session.current_company.id);
	    this.default_options = Object.assign(this.default_options, this.options);
	    return this.loadTemplates();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	exports["default"] = {
	  components: {
	    userMiniature: __webpack_require__(226)
	  },
	  props: {
	    template: {},
	    options: {
	      "default": function() {
	        return {};
	      }
	    }
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      default_options: {
	        show_open_statistic: true,
	        show_reply_statistic: true,
	        show_conversion_statistic: true,
	        show_user: false,
	        row_click_action: 'edit',
	        action: 'dropdown-action'
	      }
	    };
	  },
	  methods: {
	    editPath: function(template) {
	      return "/templates/" + template.id + "/editar";
	    },
	    rowClick: function(template, event) {
	      if (!this.current_user.can_manage_templates) {
	        return;
	      }
	      if (!jQuery(event.target).closest('.clickable-element').length) {
	        if (!this.current_user.isMonitoringManager()) {
	          if (this.default_options.row_click_action === 'edit') {
	            return this.$router.push(this.editPath(template));
	          } else {
	            return this.selectTemplate(event, template);
	          }
	        } else {
	          return this.showModal();
	        }
	      }
	    },
	    selectTemplate: function(event, template) {
	      event.originalEventName = 'template-selected';
	      return this.$emit('template-selected', {
	        event: event,
	        template: template
	      });
	    },
	    showModal: function() {
	      this.$emit('showModal', this.template);
	      return IntercomCtrl.trackEvent("Template - Pré-visualizado");
	    },
	    confirmDestroy: function() {
	      return this.$emit('confirm-destroy', this.template);
	    }
	  },
	  created: function() {
	    return this.default_options = Object.assign(this.default_options, this.options);
	  }
	};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    templateForm: __webpack_require__(26)
	  },
	  data: function() {
	    return {
	      template: new Template({
	        signature: Session.current_user.signature
	      }),
	      from_library: false
	    };
	  },
	  methods: {
	    loadTemplate: function() {
	      var id;
	      Loader.on();
	      id = this.$route.params.template_id;
	      return this.templates_resource.get(this.loadTemplateSuccess, this.unknownError, {
	        id: id
	      });
	    },
	    loadTemplateSuccess: function(resource) {
	      var template;
	      this.from_library = true;
	      Loader.off();
	      template = resource.template;
	      return this.template = new Template({
	        name: template.name,
	        template_category_id: template.template_category_id,
	        subject: template.subject,
	        body: template.body,
	        parent_id: template.id,
	        signature: Session.current_user.signature
	      });
	    },
	    save: function() {
	      return this.templates_resource.create(this.saveSuccess, this.unknownError, this.template);
	    },
	    saveSuccess: function(response) {
	      var template;
	      Loader.off();
	      this.$router.push('/templates');
	      template = response.data ? response.data.template : response.template;
	      alertify.success(this.$t('template.feedback.createSuccess'));
	      if (response) {
	        return this.trackIntercomEvent(response);
	      }
	    },
	    trackIntercomEvent: function(response) {
	      var action, metadata, template;
	      template = response.data ? response.data.template : response.template;
	      action = this.from_library ? 'Novo a partir da biblioteca' : this.$t('general.actions.new');
	      metadata = [
	        {
	          value: location.href + "/" + template.id + "/editar",
	          key: this.$t('template.label.templateURL')
	        }, {
	          attribute: 'body',
	          key: this.$t('template.label.imagesContentLength'),
	          "function": 'htmlImgTagQuantity'
	        }, {
	          attribute: 'body',
	          key: this.$t('template.label.hiperlinksContentLength'),
	          "function": 'htmlATagQuantity'
	        }, {
	          attribute: 'signature',
	          key: this.$t('template.label.imagesSignatureLength'),
	          "function": 'htmlImgTagQuantity'
	        }, {
	          attribute: 'signature',
	          key: this.$t('template.label.hiperlinksSignatureLength'),
	          "function": 'htmlATagQuantity'
	        }
	      ];
	      return IntercomCtrl.trackEventMetadata('Template - ' + action, metadata, null, template);
	    }
	  },
	  created: function() {
	    this.templates_resource = new TemplatesResource(Session.current_company.id);
	    if (this.$route.params.template_id) {
	      return this.loadTemplate();
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  components: {
	    createTemplateModal: __webpack_require__(218),
	    templateAutocomplete: __webpack_require__(68)
	  },
	  props: ['reference', 'action', 'flow', 'templates', 'validate', 'options', 'template_kind'],
	  data: function() {
	    return {
	      selected_template_id: this.action.template_id || '',
	      action_template_id: this.action.template_id,
	      show_select: !this.action.template_id,
	      current_user: Session.current_user,
	      created_template: null,
	      pristine: true,
	      default_options: {
	        allow_create: false,
	        allow_blank: false,
	        preload: null
	      }
	    };
	  },
	  computed: {
	    show_cancel_editing: function() {
	      return this.action_template_id && this.show_select;
	    },
	    show_edit_button: function() {
	      return this.selected_template_id === -1 && this.created_template;
	    },
	    template_modal_options: function() {
	      return {
	        delete_button: this.created_template !== null
	      };
	    },
	    select_validation: function() {
	      if (this.validate && !this.flow.semi_automatic) {
	        return 'required';
	      }
	    },
	    create_modal_element_id: function() {
	      return 'create-template-modal-' + this.action.step;
	    },
	    input_group_class: function() {
	      return {
	        'group-without-buttons': !this.show_cancel_editing && !this.show_edit_button,
	        'group-with-edit-and-cancel-button': this.show_cancel_editing && this.show_edit_button,
	        'group-with-cancel-button': this.show_cancel_editing && !this.show_edit_button,
	        'group-with-edit-button': !this.show_cancel_editing && this.show_edit_button
	      };
	    }
	  },
	  methods: {
	    templateSelected: function(template) {
	      return this.selected_template_id = template.id;
	    },
	    validateAll: function() {
	      this.setDirty();
	      this.$validator.validateAll({
	        selected_template_id: this.selected_template_id
	      });
	      return EventsBus.$emit('templates-picker-errors', {
	        errors: this.errors,
	        reference: this.reference
	      });
	    },
	    revalidate: function() {
	      if (!this.pristine) {
	        return EventsBus.$emit('validate-all');
	      }
	    },
	    cancelEditing: function() {
	      this.selected_template_id = this.action_template_id;
	      this.show_select = false;
	      return this.$emit('cancel-editing', {
	        action_template_id: this.action_template_id,
	        reference: this.reference
	      });
	    },
	    editTemplate: function() {
	      this.show_select = true;
	      return this.selected_template_id = '';
	    },
	    createTemplate: function(data) {
	      data.attr.template.id = this.selected_template_id;
	      this.created_template = data.attr.template;
	      this.$emit('change', {
	        template: this.created_template,
	        reference: this.reference
	      });
	      return Loader.off();
	    },
	    cancelTemplateChange: function() {
	      if (!this.created_template) {
	        return this.selected_template_id = '';
	      }
	    },
	    openCreateTemplateModal: function(templateAttrs) {
	      templateAttrs.id = this.create_modal_element_id;
	      return EventsBus.$emit('confirm-modal-show', templateAttrs);
	    },
	    destroyCreatedTemplate: function() {
	      this.created_template = null;
	      return this.selected_template_id = '';
	    }
	  },
	  watch: {
	    selected_template_id: function(template_id) {
	      var template;
	      if (template_id === 'create') {
	        return this.selected_template_id = -1;
	      } else {
	        if (template_id === -1) {
	          template = this.created_template;
	        } else {
	          template = new Template({
	            id: template_id
	          });
	        }
	        return this.$emit('change', {
	          template: template,
	          reference: this.reference
	        });
	      }
	    },
	    template_kind: function(kind) {
	      this.selected_template_id = -1;
	      return this.show_select = true;
	    }
	  },
	  mounted: function() {
	    return Tooltip.initialize();
	  },
	  created: function() {
	    this.errors.clear();
	    return EventsBus.$on('validate-all', this.validateAll);
	  },
	  beforeDestroy: function() {
	    return EventsBus.$off('validate-all', this.validateAll);
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    template: {
	      "default": {}
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form, helpers.filters);


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['template'],
	  data: function() {
	    return {
	      current_user: Session.current_user
	    };
	  },
	  computed: {
	    editPath: function() {
	      return "/templates/" + this.template.id + "/editar";
	    }
	  }
	};
	
	exports["default"] = view_model;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers;
	
	helpers = __webpack_require__(2);
	
	exports["default"] = {
	  props: ['variables'],
	  methods: {
	    addVariable: function(variable) {
	      this.$emit('add-variable', {
	        variable: variable,
	        attribute: this.attribute
	      });
	      return IntercomCtrl.trackEvent(this.$t('template.label.templateVariableUsing', {
	        name: variable.name
	      }));
	    }
	  }
	};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var api, helpers, view_model;
	
	api = __webpack_require__(4).api;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      apiErrorMessages: [],
	      email: '',
	      showPassword: false,
	      showPasswordConfirmation: false,
	      user: {
	        invitation_token: '',
	        name: '',
	        password: '',
	        password_confirmation: '',
	        default_user: '',
	        email: ''
	      }
	    };
	  },
	  methods: {
	    hasInvitationToken: function() {
	      return this.$route.query && this.$route.query.hasOwnProperty('invitation_token');
	    },
	    redirectIfNoToken: function() {
	      if (this.hasInvitationToken()) {
	        this.user.invitation_token = this.$route.query.invitation_token;
	        return this.user.default_user = this.$route.query.default_user === 'true';
	      } else {
	        return this.$router.push({
	          path: '/login'
	        });
	      }
	    },
	    extractEmailIfExists: function() {
	      return this.email = (this.$route.query && this.$route.query.email) || '';
	    },
	    submit: function() {
	      return this.$validator.validateAll().then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.activateUser();
	          }
	        };
	      })(this));
	    },
	    activateUser: function() {
	      Loader.on();
	      if (!this.user.default_user) {
	        delete this.user.password;
	        delete this.user.password_confirmation;
	      }
	      this.user.email = this.email;
	      return new UsersResource().activateInvitedUser(this.activationSuccess, this.activationFailure, this.user);
	    },
	    activationSuccess: function(response) {
	      Loader.off();
	      Session.signIn(response.body.user);
	      return this.$router.push({
	        name: 'flows'
	      });
	    },
	    activationFailure: function(response) {
	      Loader.off();
	      return this.handleApiErrors(response, {
	        extra_attributes: ['email']
	      });
	    }
	  },
	  created: function() {
	    this.redirectIfNoToken();
	    return this.extractEmailIfExists();
	  },
	  mounted: function() {}
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: ['user'],
	  data: function() {
	    return {
	      replace_user_id: null,
	      users: null
	    };
	  },
	  computed: {
	    user_options: function() {
	      var i, len, options, ref, user;
	      if (this.users) {
	        options = [
	          {
	            value: null,
	            text: 'Selecione um usuário'
	          }
	        ];
	        ref = this.users;
	        for (i = 0, len = ref.length; i < len; i++) {
	          user = ref[i];
	          if (user.id !== this.user.id) {
	            options.push({
	              value: user.id,
	              text: user.name
	            });
	          }
	        }
	        return options;
	      } else {
	        return [
	          {
	            value: null,
	            text: 'Carregando...'
	          }
	        ];
	      }
	    }
	  },
	  methods: {
	    destroyUser: function() {
	      return this.$validator.validateAll({
	        replace_user_id: this.replace_user_id
	      }).then((function(_this) {
	        return function() {
	          Loader.on();
	          return new UsersResource().destroy(_this.destroyUserSuccess, _this.handleApiErrors, {
	            id: _this.user.id,
	            params: {
	              replace_user_id: _this.replace_user_id
	            }
	          });
	        };
	      })(this));
	    },
	    destroyUserSuccess: function() {
	      Loader.off();
	      IntercomCtrl.trackEvent('Excluiu um usuário', {
	        id: this.user.id,
	        name: this.user.name,
	        email: this.user.email
	      });
	      alertify.success('Usuário excluído com sucesso');
	      jQuery('#destroy-user-modal').modal('hide');
	      return this.$emit('destroyed', this.user);
	    },
	    successLoadUsers: function(resource) {
	      return this.users = resource.users;
	    }
	  },
	  watch: {
	    user: function() {
	      this.errors.clear();
	      this.users = null;
	      this.replace_user_id = null;
	      return new UsersResource().index(this.successLoadUsers, this.unknownError, {
	        params: {
	          company_id: this.user.company_id
	        }
	      });
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	var view_model;
	
	view_model = {
	  components: {
	    listItem: __webpack_require__(40),
	    destroyModal: __webpack_require__(224),
	    companiesAutocomplete: __webpack_require__(63)
	  },
	  data: function() {
	    return {
	      users: [],
	      loading: false,
	      company_name: Session.current_company.name,
	      destroy_user: {},
	      current_user: Session.current_user,
	      company_id: Session.current_company.id,
	      company: Session.current_company,
	      company_options: [],
	      companies: [],
	      next_page: 1,
	      text_field_filter: '',
	      attrs: {
	        placeholder: "Digite o nome da empresa"
	      }
	    };
	  },
	  computed: {
	    max_number_of_regular_users: function() {
	      if (this.company && this.company.account_setting && !(this.company.account_setting instanceof Array)) {
	        return this.company.account_setting.max_number_of_regular_users;
	      } else {
	        return '-';
	      }
	    },
	    max_number_of_monitoring_managers: function() {
	      if (this.company && this.company.account_setting && !(this.company.account_setting instanceof Array)) {
	        return this.company.account_setting.max_number_of_monitoring_managers;
	      } else {
	        return '-';
	      }
	    }
	  },
	  methods: {
	    invitation: function() {
	      if (this.isInvitationDisabled()) {
	        return;
	      }
	      return this.$router.push({
	        path: "/configuracoes/usuarios/convidar"
	      });
	    },
	    isInvitationDisabled: function() {
	      if (this.company && this.company.account_setting) {
	        return this.company.number_of_regular_users >= this.max_number_of_regular_users && this.company.number_of_monitoring_managers >= this.max_number_of_monitoring_managers;
	      } else {
	        return false;
	      }
	    },
	    loadUsersSuccess: function(data) {
	      this.loading = false;
	      this.users = this.users.concat(data.users);
	      return this.next_page = data.meta.next_page;
	    },
	    currentUser: function() {
	      return Session.current_user;
	    },
	    userUpdated: function(user) {
	      return this.users.replaceById(user);
	    },
	    showDestroyModal: function(user) {
	      this.destroy_user = user;
	      return jQuery('#destroy-user-modal').modal('show');
	    },
	    loadCompany: function() {
	      return new CompaniesResource().get(this.loadCompanySuccess, this.loadCompaniesError, {
	        id: this.company_id
	      });
	    },
	    loadCompanySuccess: function(data) {
	      this.company = data.company;
	      return Loader.off();
	    },
	    loadCompanies: function() {
	      return new CompaniesResource().index(this.loadCompaniesSuccess, this.loadCompaniesError, {
	        params: {
	          limit: '5'
	        }
	      });
	    },
	    loadCompaniesSuccess: function(data) {
	      var company, i, len, ref;
	      this.loading = false;
	      this.companies = data.companies;
	      this.company_options = [];
	      ref = data.companies;
	      for (i = 0, len = ref.length; i < len; i++) {
	        company = ref[i];
	        this.company_options.push(company.name);
	      }
	      return Loader.off();
	    },
	    loadUsers: function() {
	      var params;
	      if (this.loading || !this.next_page) {
	        return;
	      }
	      params = {
	        q: {
	          accepted: false,
	          search_query: this.text_field_filter
	        },
	        page: this.next_page,
	        limit: '15'
	      };
	      if (this.current_user.isAdmin()) {
	        params['company_id'] = this.company_id;
	      }
	      this.loading = true;
	      return new UsersResource().index(this.loadUsersSuccess, null, {
	        params: params
	      });
	    },
	    userDestroyed: function(user) {
	      this.users.remove(user.id);
	      if (user.role === 'monitoring_manager') {
	        return this.company.number_of_monitoring_managers = this.company.number_of_monitoring_managers - 1;
	      } else {
	        return this.company.number_of_regular_users = this.company.number_of_regular_users - 1;
	      }
	    },
	    selectedCompany: function(company) {
	      if (this.companies.length > 0) {
	        this.company = this.companies.find(function(c) {
	          return c.name === company;
	        });
	        if (this.company) {
	          return this.company_id = this.company.id;
	        }
	      }
	    },
	    searchCompanies: function(search) {
	      var params;
	      if (this.loading || search.length < 3) {
	        return;
	      }
	      this.loading = true;
	      params = {
	        q: {
	          search_query: search
	        },
	        limit: '5'
	      };
	      return new CompaniesResource().index(this.loadCompaniesSuccess, this.loadCompaniesError, {
	        params: params
	      });
	    },
	    loadCompaniesError: function() {
	      return this.loading = false;
	    }
	  },
	  watch: {
	    company_id: function() {
	      this.users = [];
	      this.next_page = 1;
	      return this.loadUsers();
	    }
	  },
	  created: function() {
	    Loader.on();
	    this.loadUsers();
	    this.loadCompany();
	    if (this.current_user.isAdmin()) {
	      return this.loadCompanies();
	    }
	  }
	};
	
	exports["default"] = view_model;


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      email: '',
	      role: void 0,
	      company_id: Session.current_company.id,
	      companies: [],
	      company: Session.current_company,
	      company_options: [],
	      company_name: Session.current_company.name,
	      next_page: 1,
	      text_field_filter: '',
	      attrs: {
	        placeholder: "Digite o nome da empresa"
	      }
	    };
	  },
	  methods: {
	    roleHaveSeats: function(role) {
	      if (this.company != null) {
	        return indexOf.call(this.company.available_roles(), role) >= 0;
	      } else {
	        return true;
	      }
	    },
	    submit: function() {
	      if (!this.role) {
	        return this.errors.add('role', 'O campo função precisa ser definido');
	      }
	      return this.$validator.validateAll({
	        email: this.email,
	        role: this.role
	      }).then((function(_this) {
	        return function(success) {
	          if (success) {
	            return _this.inviteUser();
	          }
	        };
	      })(this));
	    },
	    inviteUser: function() {
	      Loader.on();
	      return new UsersResource().inviteUser(this.inviteSuccess, this.handleApiErrors, {
	        email: this.email,
	        role: this.role,
	        company_id: this.company_id
	      });
	    },
	    inviteSuccess: function() {
	      Loader.off();
	      IntercomCtrl.trackEvent('Convidou usuário', {
	        'Email': this.email,
	        'Função': this.role,
	        company_id: this.company_id
	      });
	      this.$router.push('/configuracoes/usuarios');
	      return alertify.success("Usuário convidado com sucesso!");
	    },
	    loadCompanies: function() {
	      return new CompaniesResource().index(this.loadCompaniesSuccess, this.loadCompaniesError, {
	        params: {
	          limit: '5'
	        }
	      });
	    },
	    loadCompaniesSuccess: function(data) {
	      var company, i, len, ref, results;
	      this.loading = false;
	      this.company_options = [];
	      ref = data.companies;
	      results = [];
	      for (i = 0, len = ref.length; i < len; i++) {
	        company = ref[i];
	        this.company_options.push(company.name);
	        results.push(this.companies.push(company));
	      }
	      return results;
	    },
	    selectedCompany: function(company) {
	      if (this.companies.length > 0) {
	        this.company = this.companies.find(function(c) {
	          return c.name === company;
	        });
	        if (this.company) {
	          return this.company_id = this.company.id;
	        }
	      }
	    },
	    searchCompanies: function(search) {
	      var params;
	      if (this.loading || search.length < 3) {
	        return;
	      }
	      this.loading = true;
	      params = {
	        q: {
	          search_query: search
	        },
	        limit: '5'
	      };
	      return new CompaniesResource().index(this.loadCompaniesSuccess, this.loadCompaniesError, {
	        params: params
	      });
	    },
	    loadCompaniesError: function() {
	      return this.loading = false;
	    }
	  },
	  beforeCreate: function() {
	    if (Session.current_user.isSeller()) {
	      return this.$router.push('/configuracoes/usuarios');
	    }
	  },
	  created: function() {
	    if (Session.current_user.isAdmin()) {
	      return this.loadCompanies();
	    }
	  },
	  mounted: function() {
	    return this.errors.clear();
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    user: {},
	    user_index: {
	      "default": -1,
	      type: Number
	    },
	    showCheckbox: {
	      "default": false
	    },
	    listCarousel: {
	      "default": false
	    },
	    userIsSelected: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user
	    };
	  },
	  methods: {
	    checkboxSelectUser: function(user) {
	      return this.$emit('user-selected', user);
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers, view_model;
	
	helpers = __webpack_require__(2);
	
	view_model = {
	  props: {
	    user: {
	      type: User
	    },
	    showCheckbox: {
	      "default": false
	    },
	    listCarousel: {
	      "default": false
	    },
	    userIsSelected: {
	      "default": false
	    }
	  },
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      show_form: false,
	      role_options: [
	        {
	          value: 'sdr',
	          text: this.$t('users.role.sdr')
	        }, {
	          value: 'seller',
	          text: this.$t('users.role.seller')
	        }, {
	          value: 'monitoring_manager',
	          text: this.$t('users.role.monitoring_manager')
	        }, {
	          value: 'manager',
	          text: this.$t('users.role.manager')
	        }
	      ],
	      new_email: null,
	      new_role: null
	    };
	  },
	  computed: {
	    cant_update_user: function() {
	      return (this.user.role === this.new_role && this.user.email === this.new_email) || (this.new_role === null && this.new_email === null);
	    },
	    confirmed: function() {
	      if (this.user.name) {
	        return true;
	      }
	      return false;
	    },
	    user_name: function() {
	      if (this.user.name) {
	        if (this.user.id === this.current_user.id) {
	          return '#{@user.name} ' + this.$t('users.label.me');
	        } else {
	          return this.user.name;
	        }
	      } else {
	        return this.$t('users.label.guestPending');
	      }
	    },
	    can_show_form: function() {
	      return this.current_user.isAdmin() || this.current_user.isManager();
	    },
	    selected: function() {
	      return this.userIsSelected;
	    }
	  },
	  methods: {
	    submit: function() {
	      if (!this.errors.has('email')) {
	        return this.updateUser();
	      }
	    },
	    setRole: function(role) {
	      return this.new_role = role;
	    },
	    showForm: function() {
	      this.show_form = !this.show_form;
	      if (this.show_form) {
	        return setTimeout(Tooltip.initialize, 500);
	      }
	    },
	    checkboxSelectUser: function(user) {
	      return this.$emit('user-selected', user);
	    },
	    resendUserInvite: function(user_id) {
	      Loader.on();
	      return new UsersResource().resendInviteUser(this.updateUserResendInviteSuccess, this.unknownError, {
	        user_id: this.user.id
	      });
	    },
	    updateUserResendInviteSuccess: function(resource) {
	      Loader.off();
	      return alertify.success(this.$t('users.actions.invite.resendSuccess'));
	    },
	    setParameters: function() {
	      var params;
	      params = {
	        id: this.user.id
	      };
	      if (this.new_role && this.new_role !== this.user.role) {
	        params["role"] = this.new_role;
	      }
	      if (this.new_email && this.new_email !== this.user.email) {
	        params["email"] = this.new_email;
	      }
	      return params;
	    },
	    updateUser: function() {
	      var params;
	      params = this.setParameters();
	      if (this.cant_update_user || (!params.hasOwnProperty("role") && !params.hasOwnProperty("email"))) {
	        alertify.error(this.$t('users.actions.error.changeEmail'));
	        return;
	      }
	      Loader.on();
	      return new UsersResource().update(this.updateUserSuccess, this.unknownError, params);
	    },
	    updateUserSuccess: function(resource) {
	      Loader.off();
	      this.trackIntercomEvent(resource);
	      alertify.success(this.$t('users.actions.update.success'));
	      this.$emit('updated', resource.user);
	      this.show_form = false;
	      this.new_email = null;
	      return this.new_role = null;
	    },
	    destroyUser: function() {
	      return this.$emit('destroy', this.user);
	    },
	    trackIntercomEvent: function(resource) {
	      var metadata;
	      metadata = [
	        {
	          attribute: 'role',
	          key: this.$t('users.attributes.role'),
	          "function": 'changedFromTo'
	        }, {
	          key: 'id',
	          value: resource.user.id
	        }, {
	          key: this.$t('users.attributes.name'),
	          value: resource.user.name
	        }, {
	          key: this.$t('users.attributes.email'),
	          value: resource.user.email
	        }
	      ];
	      return IntercomCtrl.trackEventMetadata(this.$t('users.actions.update.role'), metadata, {
	        role: this.user.role
	      }, resource.user);
	    }
	  }
	};
	
	exports["default"] = helpers.vue_include(view_model, helpers.form);


/***/ }),
/* 581 */
/***/ (function(module, exports) {

	module.exports = {
	  props: ['user', 'options'],
	  computed: {
	    user_name: function() {
	      if (!(this.user instanceof User)) {
	        return;
	      }
	      if (this.options && this.options.first_name) {
	        return this.user.firstName();
	      } else {
	        return this.user.firstAndLastName();
	      }
	    },
	    user_full_name: function() {
	      if (!(this.user instanceof User)) {
	        return '';
	      }
	      return this.user.firstAndLastName();
	    }
	  }
	};


/***/ }),
/* 582 */
/***/ (function(module, exports) {

	module.exports = {
	  methods: {
	    bubbleUp: function(data) {
	      if (data.event && data.event.originalEventName) {
	        return this.$emit(data.event.originalEventName, data);
	      } else {
	        return console.warn('bubbleUp method requires data.event.originalEventName to work properly');
	      }
	    },
	    redirectIfNotOwner: function(object) {
	      var user_id;
	      user_id = object.user_id || object.user.id;
	      if (Session.current_user.isSeller() && user_id !== Session.current_user.id) {
	        return this.$router.push('/');
	      }
	    },
	    goTo: function(path, options) {
	      if (options == null) {
	        options = {};
	      }
	      this.$router.push(path);
	      if (options.success) {
	        return alertify.success(options.success);
	      } else if (options.error) {
	        return alertify.success(options.error);
	      }
	    }
	  }
	};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {global.Vue = __webpack_require__(18);
	
	global.Vuex = __webpack_require__(316);
	
	global.jQuery = __webpack_require__(92);
	
	global.alertify = __webpack_require__(320)();
	
	alertify.delay(8000);
	
	global.moment = __webpack_require__(16);
	
	__webpack_require__(953);
	
	global.moment.tz.setDefault('America/Recife');
	
	global.momentLocales = {
	  pt_BR: __webpack_require__(603),
	  en_US: __webpack_require__(955),
	  es: __webpack_require__(956)
	};
	
	global.Locales = __webpack_require__(79);
	
	global.Cache = __webpack_require__(593);
	
	global.EventsBus = __webpack_require__(595);
	
	global.Tooltip = __webpack_require__(601);
	
	global.LinedTextarea = __webpack_require__(597);
	
	global.Loader = __webpack_require__(598);
	
	global.IntercomCtrl = __webpack_require__(596);
	
	global.MixpanelCtrl = __webpack_require__(599);
	
	global.Raphael = __webpack_require__(958);
	
	global.slugify = __webpack_require__(960);
	
	global.Avatar = __webpack_require__(999);
	
	__webpack_require__(611);
	
	__webpack_require__(614);
	
	__webpack_require__(613);
	
	__webpack_require__(610);
	
	__webpack_require__(606);
	
	__webpack_require__(620);
	
	__webpack_require__(621);
	
	__webpack_require__(622);
	
	__webpack_require__(235);
	
	__webpack_require__(640);
	
	__webpack_require__(636);
	
	__webpack_require__(637);
	
	__webpack_require__(235);
	
	__webpack_require__(615);
	
	__webpack_require__(638);
	
	__webpack_require__(619);
	
	__webpack_require__(641);
	
	__webpack_require__(630);
	
	__webpack_require__(618);
	
	__webpack_require__(627);
	
	__webpack_require__(646);
	
	__webpack_require__(634);
	
	__webpack_require__(633);
	
	__webpack_require__(632);
	
	__webpack_require__(616);
	
	__webpack_require__(631);
	
	__webpack_require__(639);
	
	__webpack_require__(644);
	
	__webpack_require__(642);
	
	__webpack_require__(629);
	
	__webpack_require__(608);
	
	__webpack_require__(609);
	
	__webpack_require__(617);
	
	__webpack_require__(612);
	
	__webpack_require__(643);
	
	__webpack_require__(628);
	
	__webpack_require__(607);
	
	__webpack_require__(645);
	
	__webpack_require__(623);
	
	__webpack_require__(625);
	
	__webpack_require__(635);
	
	__webpack_require__(624);
	
	__webpack_require__(626);
	
	__webpack_require__(649);
	
	__webpack_require__(659);
	
	__webpack_require__(656);
	
	__webpack_require__(655);
	
	__webpack_require__(658);
	
	__webpack_require__(661);
	
	__webpack_require__(662);
	
	__webpack_require__(671);
	
	__webpack_require__(667);
	
	__webpack_require__(668);
	
	__webpack_require__(670);
	
	__webpack_require__(657);
	
	__webpack_require__(669);
	
	__webpack_require__(654);
	
	__webpack_require__(672);
	
	__webpack_require__(666);
	
	__webpack_require__(651);
	
	__webpack_require__(652);
	
	__webpack_require__(653);
	
	__webpack_require__(660);
	
	__webpack_require__(673);
	
	__webpack_require__(665);
	
	__webpack_require__(650);
	
	__webpack_require__(663);
	
	__webpack_require__(664);
	
	__webpack_require__(600);
	
	__webpack_require__(592);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 584 */
/***/ (function(module, exports) {

	var ContactGroupListViewMode, ContactGroupListViewModes, ContactListViewMode, ContactListViewModes;
	
	ContactListViewMode = (function() {
	  function ContactListViewMode(properties) {
	    var name, ref, value;
	    ref = this.defaultProperties;
	    for (name in ref) {
	      value = ref[name];
	      if (properties.hasOwnProperty(name)) {
	        this[name] = properties[name];
	      } else {
	        this[name] = value;
	      }
	    }
	  }
	
	  ContactListViewMode.prototype.defaultProperties = {
	    action_step: false,
	    actions_dropdown: true,
	    anywhere_select: false,
	    anywhere_select_action: 'none',
	    business: 'column',
	    flow: true,
	    status: true,
	    stage: true,
	    name_go_to_show: true,
	    group: false,
	    user: true,
	    change_url_on_filter: true,
	    allow_update_stage: true,
	    remove_action: 'destroy-contact',
	    show_checkbox: true,
	    edit_button: false,
	    delete_button: false,
	    initialized_contact_icon: false,
	    show_filters: true,
	    show_status_updated_at_column: false,
	    number_of_tags: 10,
	    user_filter: true,
	    tags_filter: true,
	    lost_reason: true,
	    group_filter: false,
	    label_clear_filter: true,
	    show_stage_updated_at_column: false,
	    link_open_bar: false,
	    only_picture_miniature: false,
	    show_flow: false,
	    show_selections: true,
	    show_created_at_column: false
	  };
	
	  return ContactListViewMode;
	
	})();
	
	ContactListViewModes = {};
	
	ContactListViewModes.index = new ContactListViewMode({});
	
	ContactListViewModes.picker = new ContactListViewMode({
	  actions_dropdown: false,
	  anywhere_select: true,
	  anywhere_select_action: 'check',
	  flow: false,
	  name_go_to_show: false,
	  change_url_on_filter: false,
	  allow_update_stage: false,
	  number_of_tags: 8,
	  user_filter: false,
	  group_filter: true,
	  show_selections: false,
	  label_clear_filter: false
	});
	
	ContactListViewModes.flow = new ContactListViewMode({
	  action_step: true,
	  flow: false,
	  name_go_to_show: true,
	  user: false,
	  remove_action: 'remove-from-flow',
	  link_open_bar: true,
	  show_flow: true,
	  show_checkbox: false,
	  show_selections: false
	});
	
	ContactListViewModes.flow_edit = new ContactListViewMode({
	  flow: false,
	  name_go_to_show: false,
	  user: false,
	  actions_dropdown: false,
	  status: false,
	  stage: false,
	  group: true,
	  show_checkbox: false,
	  edit_button: true,
	  delete_button: true,
	  initialized_contact_icon: true,
	  show_selections: false,
	  user_filter: false,
	  status: true,
	  stage: true,
	  lost_reason: false,
	  tags_filter: true,
	  show_show_filters: true
	});
	
	ContactListViewModes.single_picker = new ContactListViewMode({
	  actions_dropdown: false,
	  anywhere_select: true,
	  anywhere_select_action: 'emit-selected',
	  flow: false,
	  name_go_to_show: false,
	  change_url_on_filter: false,
	  allow_update_stage: false,
	  show_checkbox: false,
	  number_of_tags: 8,
	  user_filter: true,
	  show_selections: false,
	  label_clear_filter: false
	});
	
	ContactListViewModes.group = new ContactListViewMode({
	  user: false,
	  name_go_to_show: true,
	  user_filter: false,
	  show_selections: false,
	  show_checkbox: false
	});
	
	ContactListViewModes.group_picker = new ContactListViewMode({
	  user: false,
	  name_go_to_show: false,
	  actions_dropdown: false,
	  show_selections: false,
	  label_clear_filter: false,
	  user_filter: false
	});
	
	ContactListViewModes.paused_contacts = new ContactListViewMode({
	  business: 'below-name',
	  actions_dropdown: true,
	  anywhere_select_action: 'none',
	  flow: false,
	  name_go_to_show: true,
	  change_url_on_filter: false,
	  allow_update_stage: true,
	  show_checkbox: false,
	  show_filters: false,
	  show_status_updated_at_column: true,
	  link_open_bar: true,
	  show_selections: false
	});
	
	ContactListViewModes.last_opportunities = new ContactListViewMode({
	  actions_dropdown: false,
	  anywhere_select_action: 'none',
	  flow: false,
	  name_go_to_show: true,
	  change_url_on_filter: false,
	  allow_update_stage: true,
	  show_checkbox: false,
	  show_filters: false,
	  show_status_updated_at_column: true,
	  link_open_bar: true,
	  show_selections: false
	});
	
	ContactListViewModes.business_contacts = new ContactListViewMode({
	  business: 'none',
	  user: true,
	  show_created_at_column: true,
	  actions_dropdown: true,
	  anywhere_select: 'none',
	  flow: false,
	  name_go_to_show: true,
	  change_url_on_filter: false,
	  allow_update_stage: true,
	  show_checkbox: false,
	  show_filters: false,
	  show_status_updated_at_column: false,
	  link_open_bar: true,
	  show_selections: false,
	  number_of_tags: 3,
	  only_picture_miniature: true
	});
	
	ContactGroupListViewMode = (function() {
	  function ContactGroupListViewMode(properties) {
	    var name, ref, value;
	    ref = this.defaultProperties;
	    for (name in ref) {
	      value = ref[name];
	      if (properties.hasOwnProperty(name)) {
	        this[name] = properties[name];
	      } else {
	        this[name] = value;
	      }
	    }
	  }
	
	  ContactGroupListViewMode.prototype.defaultProperties = {
	    actions_dropdown: true,
	    statistics: true,
	    user: true,
	    contacts_count: true,
	    allow_update_stage: false,
	    filters: true,
	    import_action: false,
	    remove_action: 'destroy-contact-group',
	    anywhere_select: false
	  };
	
	  return ContactGroupListViewMode;
	
	})();
	
	ContactGroupListViewModes = {};
	
	ContactGroupListViewModes.index = new ContactGroupListViewMode({});
	
	ContactGroupListViewModes["import"] = new ContactGroupListViewMode({
	  actions_dropdown: false,
	  user: false,
	  statistics: false,
	  filters: false,
	  import_action: true,
	  anywhere_select: true
	});
	
	module.exports = {
	  methods: {
	    contactListViewModes: function() {
	      return ContactListViewModes;
	    },
	    contactGroupListViewModes: function() {
	      return ContactGroupListViewModes;
	    }
	  }
	};


/***/ }),
/* 585 */
/***/ (function(module, exports) {

	var indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	module.exports = {
	  methods: {
	    contactsEmpty: function() {
	      return jQuery.isEmptyObject(this.contacts);
	    },
	    updateContactRecipient: function(data) {
	      if (data.attr.id) {
	        return this.contact_resource.updateRecipient(this.updateContactSuccess, this.unknownError, data.attr);
	      } else {
	        return this.contact_resource.update(this.updateContactSuccess, this.unknownError, {
	          id: data.attr.contact_id,
	          status: data.attr.status
	        });
	      }
	    },
	    updateContact: function(data) {
	      return this.contact_resource.update(this.updateContactSuccess, this.unknownError, data.attr);
	    },
	    reengage: function(data) {
	      return this.contact_resource.reengage(this.updateContactSuccess, this.unknownError, data.attr);
	    },
	    resetContactRecipient: function(data) {
	      var attr;
	      attr = {};
	      attr.contact_id = data.id;
	      attr.id = data.recipient.id;
	      return this.contact_resource.resetRecipient(this.updateContactSuccess, this.unknownError, attr);
	    },
	    updateContactSuccess: function(resources) {
	      this.updateContactList(resources.contact);
	      return alertify.success('Contato atualizado com sucesso!');
	    },
	    updateContactList: function(contact) {
	      var index;
	      if (this.flow) {
	        EventsBus.$emit('Show::UpdateContactsInfo', this.flow);
	      }
	      if (this.contacts) {
	        index = this.contacts.findIndex(contact.id);
	        if (index > -1) {
	          return Vue.set(this.contacts, index, contact);
	        } else {
	          return this.contacts.push(contact);
	        }
	      } else {
	        if (contact) {
	          return EventsBus.$emit('Show::UpdateListContactsInfo', contact);
	        }
	      }
	    },
	    updateContactResponsible: function(contacts, user, contacts_ids) {
	      var contact, i, len, results, screenContacts;
	      screenContacts = this._screenContacts(contacts, contacts_ids);
	      results = [];
	      for (i = 0, len = screenContacts.length; i < len; i++) {
	        contact = screenContacts[i];
	        contact.user = user;
	        contact.recipient_status = 'disqualified';
	        results.push(contact.human_recipient_status = 'Desqualificado');
	      }
	      return results;
	    },
	    updateContactTag: function(contacts, contact_ids, change_tags) {
	      var add_tag_ids, contact, del_tag_ids, i, len, results, screenContacts;
	      screenContacts = this._screenContacts(contacts, contact_ids);
	      add_tag_ids = this._add_tag_ids(change_tags);
	      del_tag_ids = this._del_tag_ids(change_tags);
	      results = [];
	      for (i = 0, len = screenContacts.length; i < len; i++) {
	        contact = screenContacts[i];
	        add_tag_ids.forEach((function(_this) {
	          return function(tag_id) {
	            return _this._add_tag(contact, tag_id, change_tags);
	          };
	        })(this));
	        results.push(del_tag_ids.forEach((function(_this) {
	          return function(tag_id) {
	            return _this._del_tag(contact, tag_id);
	          };
	        })(this)));
	      }
	      return results;
	    },
	    refreshContact: function(params) {
	      return this.contact_resource.get(this.refreshContactSuccess, this.unknownError, params);
	    },
	    refreshContactSuccess: function(resources) {
	      return this.updateContactList(resources.contact);
	    },
	    excludeContactFromList: function(contact_id) {
	      var index;
	      index = this.contacts.findIndex(contact_id);
	      if (index > -1) {
	        return this.contacts.splice(index, 1);
	      }
	    },
	    destroyContact: function(data) {
	      return this.contact_resource.destroy(this.destroyContactSuccessClosure(data.contact), this.unknownError, {
	        id: data.contact.id
	      });
	    },
	    destroyContactSuccessClosure: function(contact) {
	      return (function(_this) {
	        return function(response) {
	          return _this.destroyContactSuccess(contact, response);
	        };
	      })(this);
	    },
	    openRecipientScheduleReactivationModal: function(data) {
	      this.schedule_reactivation_contact = data.attr.contact;
	      return jQuery('#recipient-schedule-reactivation').modal('show');
	    },
	    destroyContactSuccess: function(contact, response) {
	      this.excludeContactFromList(contact.id);
	      return alertify.success('Contato removido com sucesso!');
	    },
	    removeContactFromFlow: function(contact, flow) {
	      return this.contact_resource.removeFromFlow(this.removeContactFromFlowSuccessClosure(contact), this.unknownError, {
	        id: contact.id,
	        flow_id: flow.id
	      });
	    },
	    removeContactFromFlowSuccessClosure: function(contact) {
	      return (function(_this) {
	        return function(response) {
	          if (_this.contacts) {
	            _this.excludeContactFromList(contact.id);
	            return alertify.success('Contato removido com sucesso!');
	          }
	        };
	      })(this);
	    },
	    _add_tag: function(contact, tag_id, change_tags) {
	      var idx, tag;
	      idx = contact.tags.findIndexByProps({
	        id: tag_id
	      });
	      if (idx === -1) {
	        tag = change_tags.find(function(tag) {
	          return tag.id === tag_id;
	        });
	        return contact.tags.push(new Tag(tag));
	      }
	    },
	    _del_tag: function(contact, tag_id) {
	      var idx;
	      idx = contact.tags.findIndexByProps({
	        id: tag_id
	      });
	      if (idx > -1) {
	        return contact.tags.splice(idx, 1);
	      }
	    },
	    _screenContacts: function(contacts, contact_ids) {
	      var contact, i, len, ref, results;
	      results = [];
	      for (i = 0, len = contacts.length; i < len; i++) {
	        contact = contacts[i];
	        if (ref = contact.id, indexOf.call(contact_ids, ref) >= 0) {
	          results.push(contact);
	        }
	      }
	      return results;
	    },
	    _add_tag_ids: function(change_tags) {
	      var i, len, results, tag;
	      results = [];
	      for (i = 0, len = change_tags.length; i < len; i++) {
	        tag = change_tags[i];
	        if (tag.behavior === 'check') {
	          results.push(tag.id);
	        }
	      }
	      return results;
	    },
	    _del_tag_ids: function(change_tags) {
	      var i, len, results, tag;
	      results = [];
	      for (i = 0, len = change_tags.length; i < len; i++) {
	        tag = change_tags[i];
	        if (tag.behavior === 'uncheck') {
	          results.push(tag.id);
	        }
	      }
	      return results;
	    }
	  }
	};


/***/ }),
/* 586 */
/***/ (function(module, exports) {

	module.exports = {
	  methods: {
	    contactStatusClass: function() {
	      return "contact-status-" + this.contact.recipient_status;
	    },
	    contactItemStatusClasses: function() {
	      var classes;
	      classes = ['btn-contact-status'];
	      if (this.anyNextRecipientStatuses()) {
	        classes.push('dropdown-toggle');
	      } else {
	        classes.push('btn-contact-fake');
	      }
	      classes.push(this.contactStatusClass());
	      return classes.join(' ');
	    },
	    contactStatusDropdownAvailable: function() {
	      if (this.anyNextRecipientStatuses()) {
	        return 'dropdown';
	      } else {
	        return false;
	      }
	    },
	    contactStageDropdownAvailable: function() {
	      if (this.anyNextStage()) {
	        return 'dropdown';
	      } else {
	        return false;
	      }
	    },
	    contactStatusIconClass: function() {
	      return "contact-event-subicon " + this.contact.recipient_status + "-icon";
	    },
	    contactStageClass: function() {
	      return "contact-stage-" + this.contact.stage;
	    },
	    contactItemStageClasses: function() {
	      var classes;
	      classes = ['btn-contact-stage'];
	      if (this.anyNextStage()) {
	        classes.push('dropdown-toggle');
	      } else {
	        classes.push('btn-contact-fake');
	      }
	      classes.push(this.contactStageClass());
	      return classes.join(' ');
	    },
	    contactItemLastActionTakenStateIcon: function() {
	      if (!this.contact.recipient_last_flow_action_taken_state) {
	        return false;
	      }
	      if (this.contact.recipient_last_flow_action_taken_state === 'none') {
	        return "glyphicon glyphicon-time";
	      } else {
	        return "contact-event-subicon " + this.contact.recipient_last_flow_action_taken_state + "-icon";
	      }
	    },
	    anyNextRecipientStatuses: function() {
	      return !jQuery.isEmptyObject(this.contact.next_valid_recipient_statuses);
	    },
	    anyNextStage: function() {
	      return this.contact.next_valid_stages !== {};
	    }
	  }
	};


/***/ }),
/* 587 */
/***/ (function(module, exports) {

	module.exports = {
	  methods: {
	    mergeCurrentUserFilterIfSeller: function(filters) {
	      if (filters == null) {
	        filters = {};
	      }
	      if (Session.current_user.isSeller()) {
	        return this.mergeCurrentUserFilter(filters);
	      } else {
	        return filters;
	      }
	    },
	    mergeCurrentUserFilter: function(filters, user_id) {
	      var id;
	      if (filters == null) {
	        filters = {};
	      }
	      if (user_id == null) {
	        user_id = null;
	      }
	      id = user_id ? user_id : Session.current_user.id;
	      return jQuery.extend({}, filters, {
	        user_id_eq: id
	      });
	    },
	    setFiltersFromQueryParams: function() {
	      return this.filters = this.$router.currentRoute.query;
	    },
	    applyFiltersOnUrlQueryParams: function(filters) {
	      var path, serializedQueryParams;
	      if (filters == null) {
	        filters = {};
	      }
	      serializedQueryParams = jQuery.param(filters);
	      path = this.$router.currentRoute.path;
	      if (serializedQueryParams) {
	        path += "?" + serializedQueryParams;
	      }
	      return window.history.pushState({
	        path: path
	      }, '', path);
	    },
	    extractFilter: function(key) {
	      var obj;
	      if (this.filters[key]) {
	        obj = {};
	        obj[key] = this.filters[key];
	        return obj;
	      } else {
	        return null;
	      }
	    }
	  }
	};


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers;
	
	helpers = __webpack_require__(2);
	
	module.exports = {
	  methods: {
	    emitOpenCompose: function() {
	      if (this.task.isMeetingTask()) {
	        return EventsBus.$emit('meeting-modal-show', {
	          event: event,
	          task: this.task
	        });
	      } else {
	        event.originalEventName = 'Compose::Open';
	        return EventsBus.$emit('Compose::Open', {
	          event: event,
	          task: this.task
	        });
	      }
	    },
	    toggleDone: function() {
	      if (this.showConfirmationModal) {
	        return EventsBus.$emit('confirm-modal-show', {
	          id: "confirm-task-done-" + this.task.id
	        });
	      } else if (this.showComposeMeeting) {
	        return EventsBus.$emit('meeting-modal-show', {
	          event: event,
	          task: this.task
	        });
	      } else {
	        return this.doneTask();
	      }
	    },
	    doneTask: function() {
	      this.task.markAsDone();
	      this.tasks_resources.save(this.taskUpdated, this.unknownError, this.task.serialize(['id', 'done_at']));
	      return this.trackIntercomDoneEvent();
	    },
	    sendEmailDoneTask: function() {
	      return this.tasks_resources.get(this.loadTaskInfoSuccess, this.unknownError, {
	        id: this.task.id
	      });
	    },
	    loadTaskInfoSuccess: function(data) {
	      var params, ref, template;
	      template = data.task.template;
	      if (!template.body || !template.subject) {
	        return alertify.error('A tarefa não possui um template válido');
	      } else {
	        params = this.buildParams(template);
	        if ((ref = this.task) != null ? ref.isCreatedByUser() : void 0) {
	          return this.tasks_resources.only_send_email(this.sendEmailSuccess, this.unknownError, params);
	        } else {
	          return this.tasks_resources.save_template_and_send_email(this.sendEmailSuccess, this.unknownError, params);
	        }
	      }
	    },
	    buildParams: function(template) {
	      var params, ref, shared_params;
	      shared_params = {
	        subject: template.subject,
	        body: template.body,
	        kind: template.kind,
	        send_email: true
	      };
	      if ((ref = this.task) != null ? ref.isCreatedByUser() : void 0) {
	        params = {
	          task_id: this.task.id,
	          template_id: template.id
	        };
	      } else {
	        params = {
	          id: this.task.id,
	          signature: template.signature
	        };
	      }
	      return Object.assign({}, params, shared_params);
	    },
	    sendEmailSuccess: function(data) {
	      alertify.success('E-mail disparado com sucesso');
	      this.task.markAsDone();
	      return EventsBus.$emit('Task::Done', this.task);
	    },
	    taskUpdated: function(resources) {
	      alertify.success('Tarefa atualizada com sucesso');
	      resources.task.assigned_to = this.task.assigned_to;
	      return this.$emit('task-updated', resources.task);
	    },
	    iconClass: function(task) {
	      return task.slug + "-icon";
	    },
	    toggleTaskBar: function(open_comment) {
	      var contact, task;
	      if (open_comment == null) {
	        open_comment = false;
	      }
	      event.originalEventName = 'toggle-task-bar';
	      contact = this.task.contact;
	      task = this.task;
	      return this.$emit('toggle-task-bar', {
	        event: event,
	        contact: contact,
	        task: task,
	        open_comment: open_comment
	      });
	    },
	    editTask: function() {
	      return EventsBus.$emit('TaskModalForm::Show', {
	        task_id: this.task.id,
	        contact: null,
	        id: 'manual-task-form-modal'
	      });
	    },
	    openDialer: function(number, number_type, task, open_comment) {
	      var data;
	      if (open_comment == null) {
	        open_comment = false;
	      }
	      event.originalEventName = 'open-dialer';
	      data = {
	        contact: task.contact,
	        task: task,
	        number: number,
	        number_type: number_type,
	        open_comment: open_comment
	      };
	      return EventsBus.$emit('open-dialer', data);
	    },
	    normalizePhone: function(number) {
	      return helpers.masks.maskPhone("+55" + number);
	    },
	    trackIntercomDoneEvent: function() {
	      var final_text;
	      final_text = this.task.isDone() ? 'realizada' : 'não realizada';
	      return IntercomCtrl.trackEvent(this.origem + " - tarefa marcada como " + final_text, {
	        'Identificador da tarefa': this.task.id,
	        'Identificador do contato': this.task.contact.id
	      });
	    },
	    registerVoipCall: function(task) {
	      if (task.id === this.task.id) {
	        this.task.voip_calls_count += 1;
	        this.task.markAsDone();
	        return this.$emit('task-updated', task);
	      }
	    },
	    taskItemClass: function() {
	      var item_class;
	      item_class = "padding-" + this.element_options.padding;
	      if (this.task.isOverdue() && !this.task.isDueToday()) {
	        item_class += ' overdue-task-item';
	      }
	      if (!this.task.isOverdue() && !this.task.isDueToday()) {
	        item_class += ' future-task-item';
	      }
	      if (this.task.isScheduled()) {
	        item_class += ' scheduled';
	      }
	      if (this.element_options.description !== "contact-info") {
	        item_class += ' contact-show';
	      }
	      if (this.task.isOzzyTask()) {
	        item_class += ' ozzy-task';
	      }
	      return item_class;
	    },
	    mergeDefaultOptions: function() {
	      return this.element_options = Object.assign({}, this.element_options, this.options || {});
	    }
	  },
	  computed: {
	    task_description: function() {
	      var description;
	      description = '';
	      if (this.task.slug === 'phonecall-task' && (this.task.contact.telephone || this.task.contact.cellphone)) {
	        if (this.task.voip_call_status) {
	          description = this.task.voip_call_status;
	        } else {
	          description = 'Ligar para contato';
	        }
	      } else if (this.task.slug === 'email-task' && this.task.contact.email) {
	        description = "Enviar email";
	      } else if (this.task.slug === 'meeting-task' && this.task.meeting_type) {
	        description = this.task.text + ' - ' + this.task.meeting_type.title;
	      } else {
	        description = this.task.text;
	      }
	      return description;
	    },
	    task_info: function() {
	      if (this.task.slug === 'phonecall-task' && (this.task.contact.telephone || this.task.contact.cellphone)) {
	        return this.task.contact.telephone || this.task.contact.cellphone;
	      } else if (this.task.slug === 'email-task' && this.task.contact.email) {
	        return this.task.contact.email;
	      }
	    },
	    element_id: function() {
	      return "task-" + this.task.id;
	    },
	    show_call_button: function() {
	      return this.task.slug === "phonecall-task" && this.task.assigned_to_id === this.current_user.id && !this.task.isDone();
	    },
	    show_second_call_button: function() {
	      return (!Session.current_user.plivo_endpoint || Session.current_company.isVoipExceeded() || !Session.current_company.isPlivo()) && this.task.slug === "phonecall-task";
	    },
	    disable_toggle_done: function() {
	      return (!this.task.canBeUndone() && this.task.isDone()) || !this.user_can_manage;
	    },
	    user_can_manage: function() {
	      if (this.current_user.isSeller() && this.current_user.id !== this.task.assigned_to_id) {
	        return false;
	      }
	      return !this.current_user.isMonitoringManager();
	    }
	  },
	  beforeDestroy: function() {
	    EventsBus.$off('voip-call-complete', this.registerVoipCall);
	    if (this.tooltip_content) {
	      return this.tooltip_content.$destroy();
	    }
	  }
	};


/***/ }),
/* 589 */
/***/ (function(module, exports) {

	module.exports = {
	  methods: {
	    loadTaskInfo: function(data) {
	      Loader.on();
	      return this.tasks_resources.get(this.loadTaskInfoSuccess, this.unknownError, {
	        id: data.task.id
	      });
	    },
	    loadTaskInfoSuccess: function(data) {
	      this.selected_task = data.task;
	      EventsBus.$emit('confirm-modal-show', {
	        id: 'create-template-modal'
	      });
	      return Loader.off();
	    },
	    sendEmail: function(data) {
	      var params, template;
	      Loader.on();
	      template = data.attr.template;
	      params = {
	        id: this.selected_task.id,
	        subject: template.subject,
	        body: template.body,
	        signature: template.signature,
	        send_email: true
	      };
	      return this.tasks_resources.save_template_and_send_email(this.sendEmailSuccess, this.unknownError, params);
	    },
	    sendEmailSuccess: function(data) {
	      Loader.off();
	      alertify.success('E-mail disparado com sucesso');
	      this.selected_task.markAsDone();
	      return EventsBus.$emit('Task::Done', this.selected_task);
	    },
	    saveTemplate: function(data) {
	      var params, template;
	      Loader.on();
	      template = data.attr.template;
	      params = {
	        id: this.selected_task.id,
	        subject: template.subject,
	        body: template.body,
	        signature: template.signature,
	        send_email: false
	      };
	      return this.tasks_resources.save_template_and_send_email(this.saveTemplateSuccess, this.unknownError, params);
	    },
	    saveTemplateSuccess: function(data) {
	      Loader.off();
	      return alertify.success('Tarefa atualizada com sucesso');
	    }
	  }
	};


/***/ }),
/* 590 */
/***/ (function(module, exports) {

	module.exports = {
	  capitalizeFirstLetter: function(string) {
	    if (!string) {
	      return;
	    }
	    return string.charAt(0).toUpperCase() + string.slice(1);
	  },
	  normalizePhone: function(number) {
	    if (!number) {
	      return;
	    }
	    return number.replace(/[^\d#*]/g, '');
	  },
	  maskPhone: function(number) {
	    var result, size;
	    if (!number) {
	      return;
	    }
	    result = this.normalizePhone(number);
	    size = result.length;
	    if (size > 12) {
	      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{5})([\d#*]{4})([\d*#]{0,5}).*/, "$1 $2 $3-$4$5");
	    } else if (size > 8) {
	      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{4})([\d#*]{0,4}).*/, "$1 $2 $3-$4");
	    } else if (size > 4) {
	      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{0,5})/, "$1 $2 $3");
	    } else if (size > 2) {
	      result = result.replace(/^([\d#*][\d#*])([\d#*]*)/, "$1 $2");
	    }
	    return result;
	  },
	  maskPhoneInput: function(number) {
	    var result, size;
	    if (!number) {
	      return '';
	    }
	    result = this.normalizePhone(number);
	    size = result.length;
	    if (result.search(/^0/) > -1) {
	      if (size > 8) {
	        result = result.replace(/^([\d#*]{4})([\d#*]{4})([\d#*]*)/, "$1-$2-$3");
	      } else if (size > 4) {
	        result = result.replace(/^([\d#*]{4})([\d#*]*)/, "$1-$2");
	      }
	      return result;
	    }
	    if (result.search(/^4/) > -1 && size <= 8) {
	      if (size > 4) {
	        result = result.replace(/^([\d#*]{4})([\d#*]*)/, "$1-$2");
	      }
	      return result;
	    }
	    if (size > 10) {
	      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{3})([\d#*]{0,8}).*/, "$1 $2$3-$4");
	    } else if (size > 6) {
	      result = result.replace(/^([\d#*][\d#*])([\d#*][\d#*])([\d#*]{2})([\d#*]{0,5}).*/, "$1 $2$3-$4");
	    } else if (size > 2) {
	      result = result.replace(/^([\d#*][\d#*])([\d#*]*)/, "$1 $2");
	    }
	    return result;
	  },
	  padLeft: function(number, pad) {
	    if (pad == null) {
	      pad = '00';
	    }
	    return pad.substring(0, pad.length - number.toString().length) + number.toString();
	  }
	};


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	var helpers;
	
	helpers = __webpack_require__(2);
	
	module.exports = {
	  methods: {
	    closeDropdown: function() {
	      return EventsBus.$emit('NotificationDropdown::Close');
	    },
	    remove: function() {
	      return this.$emit('remove-notification', this.notification.id);
	    },
	    navigate: function() {
	      this.remove();
	      event.originalEventName = 'navigate';
	      this.$emit(event.originalEventName, {
	        event: event
	      });
	      if (!this.go_to) {
	        return;
	      }
	      (new NotificationsResource()).read(null, this.unknownError, {
	        id: this.notification.id
	      });
	      this.$router.push(this.go_to);
	      return this.closeDropdown();
	    },
	    ransack_contact_ids: function(key) {
	      var contact_ids;
	      contact_ids = this.notification.metadata.contact_ids;
	      contact_ids = Array.from(new Set(contact_ids));
	      return key + "=" + contact_ids;
	    }
	  },
	  computed: {
	    name: function() {
	      var ref, ref1;
	      if (this.manager_and_not_owner && this.notification) {
	        return ((ref = this.notification) != null ? (ref1 = ref.user) != null ? ref1.name : void 0 : void 0) || 'Você';
	      } else {
	        return 'Você';
	      }
	    },
	    manager_and_not_owner: function() {
	      var ref;
	      return this.notification && this.current_user.isManager() && this.current_user.id !== ((ref = this.notification.user) != null ? ref.id : void 0);
	    }
	  },
	  created: function() {
	    return this.current_user = Session.current_user;
	  }
	};


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var actioncable;
	
	actioncable = __webpack_require__(319);
	
	global.ActionCable = (function() {
	  function ActionCable() {}
	
	  ActionCable.connect = function() {
	    var ref;
	    if (this.cable) {
	      return this.cable;
	    }
	    if (!((ref = Session.current_user) != null ? ref.authentication_token : void 0) || !Session.current_user.email) {
	      return;
	    }
	    return this.cable = actioncable.createConsumer(this.url());
	  };
	
	  ActionCable.url = function() {
	    var path, protocol, url;
	    protocol =  true ? 'wss://' : 'ws://';
	    path = "/cable?token=" + Session.current_user.authentication_token + "&email=" + Session.current_user.email;
	    return url = protocol + ("api.reev.co") + path;
	  };
	
	  return ActionCable;

	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 593 */
/***/ (function(module, exports) {

	var Cache;
	
	Cache = (function() {
	  function Cache() {
	    this.data = {};
	  }
	
	  Cache.prototype.get = function(key) {
	    return this.data[key];
	  };
	
	  Cache.prototype.set = function(key, value) {
	    return this.data[key] = value;
	  };
	
	  Cache.prototype.remove = function(key) {
	    return delete this.data[key];
	  };
	
	  return Cache;
	
	})();
	
	module.exports = new Cache;


/***/ }),
/* 594 */
/***/ (function(module, exports) {

	var LocalStorage;
	
	LocalStorage = (function() {
	  function LocalStorage() {}
	
	  LocalStorage.prototype.get = function(key) {
	    return JSON.parse(localStorage.getItem(key));
	  };
	
	  LocalStorage.prototype.set = function(key, value) {
	    return localStorage.setItem(key, JSON.stringify(value));
	  };
	
	  LocalStorage.prototype.remove = function(key) {
	    return localStorage.removeItem(key);
	  };
	
	  return LocalStorage;
	
	})();
	
	exports.db = new LocalStorage;


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	var Vue;
	
	Vue = __webpack_require__(18);
	
	module.exports = new Vue;


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	var IntercomCtrl,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };
	
	IntercomCtrl = (function() {
	  function IntercomCtrl() {
	    this.start = bind(this.start, this);
	    this.finish = bind(this.finish, this);
	    this.init();
	  }
	
	  IntercomCtrl.prototype.finish = function() {
	    return window.Intercom('shutdown');
	  };
	
	  IntercomCtrl.prototype.start = function(params) {
	    window.Intercom('boot', {
	      app_id: ("s2621u0d"),
	      name: params.current_user.name,
	      email: params.current_user.email,
	      created_at: new Date().getTime() / 1000,
	      job_title: params.current_user.roleDescription(),
	      new_reev: false,
	      company: {
	        id: params.current_company.id,
	        name: params.current_company.name
	      }
	    });
	    return setTimeout((function() {
	      if (window !== window.parent) {
	        jQuery('.intercom-launcher').addClass('hide-intercom');
	      }
	    }), 2000);
	  };
	
	  IntercomCtrl.prototype.init = function() {
	    var d, i, ic, s, w;
	    d = document;
	    w = window;
	    ic = w.Intercom;
	    s = d.createElement('script');
	    s.setAttribute('src', 'https://widget.intercom.io/widget/s2621u0d');
	    s.setAttribute('async', true);
	    d.head.appendChild(s);
	    i = function() {
	      i.c(arguments);
	    };
	    i.q = [];
	    i.c = function(args) {
	      i.q.push(args);
	    };
	    return w.Intercom = i;
	  };
	
	  IntercomCtrl.trackEvent = function(event_name, event_meta_data) {
	    return window.Intercom('trackEvent', event_name, event_meta_data);
	  };
	
	  IntercomCtrl.trackEventMetadata = function(event_name, metadata_list, old_object, new_object) {
	    var event_meta_data, j, len, metadata, value;
	    event_meta_data = {};
	    for (j = 0, len = metadata_list.length; j < len; j++) {
	      metadata = metadata_list[j];
	      value = metadata.value ? metadata.value : metadata["function"] ? this[metadata["function"]](old_object, new_object, metadata.attribute) : void 0;
	      event_meta_data[metadata.key] = value;
	    }
	    return this.trackEvent(event_name, event_meta_data);
	  };
	
	  IntercomCtrl.htmlImgTagQuantityDiff = function(old_object, new_object, attribute) {
	    return (jQuery('<div/>').html(old_object[attribute]).find('img').length) + " -> " + (jQuery('<div/>').html(new_object[attribute]).find('img').length);
	  };
	
	  IntercomCtrl.htmlImgTagQuantity = function(old_object, new_object, attribute) {
	    return "" + (jQuery('<div/>').html(new_object[attribute]).find('img').length);
	  };
	
	  IntercomCtrl.htmlATagQuantityDiff = function(old_object, new_object, attribute) {
	    return (jQuery('<div/>').html(old_object[attribute]).find('a').length) + " -> " + (jQuery('<div/>').html(new_object[attribute]).find('a').length);
	  };
	
	  IntercomCtrl.htmlATagQuantity = function(old_object, new_object, attribute) {
	    return "" + (jQuery('<div/>').html(new_object[attribute]).find('a').length);
	  };
	
	  IntercomCtrl.changedFromTo = function(old_object, new_object, attribute) {
	    return old_object[attribute] + " -> " + new_object[attribute];
	  };
	
	  IntercomCtrl.isChanged = function(old_object, new_object, attribute) {
	    if (old_object[attribute] !== new_object[attribute]) {
	      return 'Sim';
	    } else {
	      return 'Não';
	    }
	  };
	
	  return IntercomCtrl;
	
	})();
	
	module.exports = IntercomCtrl;


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(674);
	
	exports.initialize = function(selector) {
	  return jQuery(selector).linedtextarea();
	};


/***/ }),
/* 598 */
/***/ (function(module, exports) {

	module.exports = {
	  on: function() {
	    return EventsBus.$emit('switch-loader', true);
	  },
	  off: function() {
	    return EventsBus.$emit('switch-loader', false);
	  }
	};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	var MixpanelCtrl;
	
	MixpanelCtrl = (function() {
	  function MixpanelCtrl() {
	    this.init();
	  }
	
	  MixpanelCtrl.start_session = function() {
	    var ref, ref1, ref10, ref11, ref12, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
	    if (("production") !== 'production' || !Session.authorized) {
	      return;
	    }
	    if (!((ref = window.mixpanel) != null ? ref.track : void 0)) {
	      return;
	    }
	    mixpanel.identify(Session.current_user.id);
	    mixpanel.people.set({
	      "$email": Session.current_user.email,
	      "$created": Session.current_user.created_at,
	      "$last_login": new Date(),
	      name: Session.current_user.name,
	      company_name: Session.current_company.name,
	      job_title: Session.current_user.roleDescription(),
	      email_service: Session.current_user.email_service,
	      email_provider: Session.current_user.isNylas() ? (ref1 = Session.current_user.nylas_setting) != null ? (ref2 = ref1.original_response) != null ? ref2.provider : void 0 : void 0 : '',
	      pipedrive: ((ref3 = Session.current_user.pipedrive_setting) != null ? ref3.stage_id : void 0) !== void 0,
	      nectar: ((ref4 = Session.current_user.nectar_setting) != null ? ref4.id : void 0) !== void 0,
	      salesforce: ((ref5 = Session.current_user.salesforce_setting) != null ? ref5.id : void 0) !== void 0,
	      hubspot: ((ref6 = Session.current_user.hubspot_setting) != null ? ref6.id : void 0) !== void 0,
	      rd_station: ((ref7 = Session.current_user.rd_station_setting) != null ? ref7.id : void 0) !== void 0,
	      sharpspring: ((ref8 = Session.current_user.sharpspring_setting) != null ? ref8.id : void 0) !== void 0,
	      leadlovers: ((ref9 = Session.current_user.leadlovers_setting) != null ? ref9.id : void 0) !== void 0,
	      vtiger: ((ref10 = Session.current_user.vtiger_setting) != null ? ref10.id : void 0) !== void 0,
	      webhooks: ((ref11 = Session.current_user.webhooks) != null ? ref11.id : void 0) !== void 0,
	      email_send_response: ((ref12 = Session.current_user.crm_setting) != null ? ref12.bcc_send_email : void 0) !== void 0,
	      company_has_voip: Session.current_company.voip_service,
	      company_active: Session.current_company.active
	    });
	    mixpanel.set_group("company", Session.current_company.name);
	    mixpanel.get_group("company", Session.current_company.name).set({
	      company_name: Session.current_company.name,
	      company_has_voip: Session.current_company.voip_service,
	      company_active: Session.current_company.active,
	      email_service: Session.current_company.email_service
	    });
	    return mixpanel.track('session_start', MixpanelCtrl.profileData());
	  };
	
	  MixpanelCtrl.trackEvent = function(event_name, event_meta_data) {
	    var ref, ref1, ref2, ref3, ref4;
	    if (("production") !== 'production' || !Session.authorized) {
	      return;
	    }
	    if (!((ref = window.mixpanel) != null ? ref.track : void 0)) {
	      return;
	    }
	    if (!Number.isInteger((ref1 = window.mixpanel) != null ? (ref2 = ref1.persistence) != null ? (ref3 = ref2.props) != null ? ref3.distinct_id : void 0 : void 0 : void 0)) {
	      MixpanelCtrl.start_session();
	    }
	    if ((ref4 = window.mixpanel) != null ? ref4.track : void 0) {
	      return mixpanel.track(event_name, Object.assign(event_meta_data, MixpanelCtrl.profileData()));
	    }
	  };
	
	  MixpanelCtrl.profileData = function() {
	    if (!Session.authorized) {
	      return {};
	    }
	    return {
	      user_id: Session.current_user.id,
	      job_title: Session.current_user.roleDescription(),
	      email: Session.current_user.email,
	      name: Session.current_user.name,
	      created_at: Session.current_user.created_at,
	      company_name: Session.current_company.name,
	      company_has_voip: Session.current_company.voip_service,
	      company_active: Session.current_company.active
	    };
	  };
	
	  MixpanelCtrl.logout = function() {
	    var ref;
	    if (("production") !== 'production' || !Session.authorized) {
	      return;
	    }
	    if ((ref = window.mixpanel) != null ? ref.track : void 0) {
	      return mixpanel.reset();
	    }
	  };
	
	  MixpanelCtrl.prototype.init = function() {
	    var self;
	    self = this;
	    (function(c, a) {
	      var b, d, f, h, j, k, l, m, n;
	      if (!a.__SV) {
	        b = window;
	        try {
	          d = void 0;
	          m = void 0;
	          j = void 0;
	          k = b.location;
	          f = k.hash;
	          d = function(a, b) {
	            if ((m = a.match(RegExp(b + '=([^&]*)')))) {
	              return m[1];
	            } else {
	              return null;
	            }
	          };
	          f && d(f, 'state') && (j = JSON.parse(decodeURIComponent(d(f, 'state'))));
	          'mpeditor' === j.action && b.sessionStorage.setItem('_mpcehash', f);
	          history.replaceState(j.desiredHash || '', c.title, k.pathname + k.search);
	        } catch (error) {
	          n = error;
	        }
	        l = void 0;
	        h = void 0;
	        window.mixpanel = a;
	        a._i = [];
	        a.init = function(b, d, g) {
	          var c;
	          var f;
	          var e;
	          e = a;
	          c = function(b, i) {
	            var a;
	            a = i.split('.');
	            2 === a.length && (b = b[a[0]]);
	            i = a[1];
	            b[i] = function() {
	              b.push([i].concat(Array.prototype.slice.call(arguments, 0)));
	            };
	          };
	          if ('undefined' !== typeof g) {
	            e = a[g] = [];
	          } else {
	            g = 'mixpanel';
	          }
	          e.people = e.people || [];
	          e.toString = function(b) {
	            var a;
	            a = 'mixpanel';
	            'mixpanel' !== g && (a += '.' + g);
	            b || (a += ' (stub)');
	            return a;
	          };
	          e.people.toString = function() {
	            return e.toString(1) + '.people (stub)';
	          };
	          l = 'disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove'.split(' ');
	          h = 0;
	          while (h < l.length) {
	            c(e, l[h]);
	            h++;
	          }
	          f = 'set set_once union unset remove delete'.split(' ');
	          e.get_group = function() {
	            var a;
	            var b;
	            var d;
	            var c;
	            a = function(c) {
	              b[c] = function() {
	                var call2, call2_args;
	                call2_args = arguments;
	                call2 = [c].concat(Array.prototype.slice.call(call2_args, 0));
	                e.push([d, call2]);
	              };
	            };
	            b = {};
	            d = ['get_group'].concat(Array.prototype.slice.call(arguments, 0));
	            c = 0;
	            while (c < f.length) {
	              a(f[c]);
	              c++;
	            }
	            return b;
	          };
	          a._i.push([b, d, g]);
	        };
	        a.__SV = 1.2;
	        b = c.createElement('script');
	        b.type = 'text/javascript';
	        b.async = !0;
	        b.src = 'https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js';
	        d = c.getElementsByTagName('script')[0];
	        d.parentNode.insertBefore(b, d);
	      }
	    })(document, window.mixpanel || []);
	    return mixpanel.init(("a32f7eff8486ab27d15c55552c19c7cb"), {
	      loaded: function() {
	        return MixpanelCtrl.start_session();
	      }
	    });
	  };
	
	  return MixpanelCtrl;
	
	})();
	
	module.exports = MixpanelCtrl;


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var Session, api, db, store,
	  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	api = __webpack_require__(4).api;
	
	db = __webpack_require__(594).db;
	
	store = __webpack_require__(228).store;
	
	Session = (function() {
	  function Session() {
	    this.authorized = false;
	    this.callbacks = {
	      session_started: [],
	      session_finished: [],
	      current_user_updated: []
	    };
	    this.startSession(db.get('session-info'));
	  }
	
	  Session.prototype.startSession = function(session_info) {
	    if (!session_info) {
	      return;
	    }
	    moment.tz.setDefault(session_info.timezone);
	    this.setCurrentUser(session_info);
	    if (this.current_user.extradata.use_new_ui && window === window.parent) {
	      window.location = ("https://se.reev.co") + "/auth/novo-reev?redirect=" + (window.location.pathname.slice(1));
	      return;
	    }
	    this.setHttpHeaders();
	    this.authorized = true;
	    return this.runCallbacks('session_started', this);
	  };
	
	  Session.prototype.clearAll = function() {
	    store.dispatch("resetUsers");
	    store.dispatch("resetTags");
	    store.dispatch("resetTemplateCategory");
	    store.dispatch("resetNotifications");
	    store.dispatch("resetLostReasons");
	    return store.dispatch("resetMeetingTypes");
	  };
	
	  Session.prototype.finishSession = function() {
	    this.clearAll();
	    this.removeHttpHeaders();
	    this.deleteSessionInfo();
	    this.authorized = false;
	    this.current_user = null;
	    this.current_company = null;
	    return this.runCallbacks('session_finished', this);
	  };
	
	  Session.prototype.signIn = function(session_info) {
	    this.saveSessionInfo(session_info);
	    return this.startSession(session_info);
	  };
	
	  Session.prototype.logout = function(success, failure) {
	    this.finishSession();
	    MixpanelCtrl.logout();
	    if (success) {
	      return success();
	    }
	  };
	
	  Session.prototype.addCallback = function(hook, callback) {
	    var available_hooks;
	    available_hooks = Object.keys(this.callbacks);
	    if (indexOf.call(available_hooks, hook) < 0) {
	      console.error("Unknown hook " + hook + ", Available hooks: " + (available_hooks.join(', ')));
	    }
	    return this.callbacks[hook].push(callback);
	  };
	
	  Session.prototype.runCallbacks = function(hook, args) {
	    var callback, i, len, ref, results;
	    if (args == null) {
	      args = {};
	    }
	    ref = this.callbacks[hook];
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      callback = ref[i];
	      results.push(callback(args));
	    }
	    return results;
	  };
	
	  Session.prototype.setCurrentUser = function(session_info) {
	    this.current_user = new User(session_info);
	    return this.current_company = this.current_user.company;
	  };
	
	  Session.prototype.updateCurrentUser = function(session_info) {
	    this.signIn(session_info);
	    return this.runCallbacks('current_user_updated', this);
	  };
	
	  Session.prototype.currentUserCopy = function() {
	    if (!this.current_user) {
	      return null;
	    }
	    return new User(this.current_user);
	  };
	
	  Session.prototype.setHttpHeaders = function() {
	    Vue.http.headers.common['X-User-Email'] = this.current_user.email;
	    return Vue.http.headers.common['X-User-Token'] = this.current_user.authentication_token;
	  };
	
	  Session.prototype.removeHttpHeaders = function() {
	    delete Vue.http.headers.common['X-User-Email'];
	    return delete Vue.http.headers.common['X-User-Token'];
	  };
	
	  Session.prototype.saveSessionInfo = function(session_info) {
	    return db.set('session-info', session_info);
	  };
	
	  Session.prototype.deleteSessionInfo = function() {
	    return db.remove('session-info');
	  };
	
	  return Session;
	
	})();
	
	global.Session = new Session;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 601 */
/***/ (function(module, exports) {

	exports.initialize = function() {
	  return jQuery('[data-toggle="tooltip"]').tooltip({
	    html: true
	  });
	};


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	var Vue, component_name, component_options, ui_components, view;
	
	Vue = __webpack_require__(18);
	
	__webpack_require__(358);
	
	view = function(view_name) {
	  return __webpack_require__(318)("./" + view_name);
	};
	
	ui_components = {
	  contactList: view('contacts/list'),
	  contactListItem: view('contacts/list_item'),
	  flowListItem: view('flows/list_item'),
	  userMiniature: view('users/miniature'),
	  confirmModal: view('shared/modals/confirm'),
	  loading: view('shared/loading'),
	  goToTop: view('shared/go_to_top'),
	  backLink: view('shared/back_link'),
	  statisticTableCol: view('shared/statistic_table_col'),
	  dropdownSelect: view('shared/dropdown-select'),
	  dropdownMultipleSelect: view('shared/dropdown-multiple-select'),
	  dateRangePicker: view('shared/date_range_picker')
	};
	
	for (component_name in ui_components) {
	  component_options = ui_components[component_name];
	  Vue.component(component_name, component_options);
	}
	
	Vue.component('datepicker', __webpack_require__(1241));
	
	module.exports = ui_components;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(factory) {
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(16)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    module.exports = factory(require('../moment'));
	  } else {
	    factory(window.moment);
	  }
	})(function(moment) {
	  return moment.defineLocale('pt-br', {
	    months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split('_'),
	    monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	    weekdays: 'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split('_'),
	    weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	    weekdaysMin: 'dom_2ª_3ª_4ª_5ª_6ª_sáb'.split('_'),
	    longDateFormat: {
	      LT: 'HH:mm',
	      L: 'DD/MM/YYYY',
	      LDB: 'YYYY-MM-DD',
	      LTS: 'L LT',
	      LL: 'D [de] MMMM [de] YYYY',
	      LLL: 'D [de] MMMM [de] YYYY [às] LT',
	      LLLL: 'dddd, D [de] MMMM [de] YYYY [às] LT'
	    },
	    calendar: {
	      sameDay: '[Hoje às] LT',
	      nextDay: '[Amanhã às] LT',
	      nextWeek: 'dddd [às] LT',
	      lastDay: '[Ontem às] LT',
	      lastWeek: function() {
	        if (this.day() === 0 || this.day() === 6) {
	          return '[Último] dddd [às] LT';
	        } else {
	          return '[Última] dddd [às] LT';
	        }
	      },
	      sameElse: 'L'
	    },
	    relativeTime: {
	      future: 'em %s',
	      past: '%s atrás',
	      s: 'segundos',
	      m: 'um minuto',
	      mm: '%d minutos',
	      h: 'uma hora',
	      hh: '%d horas',
	      d: 'um dia',
	      dd: '%d dias',
	      M: 'um mês',
	      MM: '%d meses',
	      y: 'um ano',
	      yy: '%d anos'
	    },
	    ordinal: '%dº'
	  });
	});


/***/ }),
/* 604 */
/***/ (function(module, exports) {

	module.exports = {
	  data: function() {
	    return {
	      current_user: Session.current_user,
	      filters: {}
	    };
	  },
	  methods: {
	    loadNotificationsOptionsSuccess: function(data) {
	      if (this.load_notifications) {
	        return this.$store.commit('loadNotifications', data.notifications);
	      }
	    },
	    loadNotificationsOptions: function() {
	      return this.notifications_resource.index(this.loadNotificationsOptionsSuccess, this.unknownError, {
	        params: this.filters
	      });
	    }
	  },
	  computed: {
	    notifications: function() {
	      return this.$store.getters.notificationsList;
	    },
	    load_notifications: function() {
	      return this.$store.getters.notificationsCount === 0;
	    }
	  },
	  created: function() {
	    this.notifications_resource = new NotificationsResource();
	    if (this.load_notifications) {
	      return this.loadNotificationsOptions();
	    }
	  }
	};


/***/ }),
/* 605 */
/***/ (function(module, exports) {

	module.exports = {
	  data: function() {
	    return {
	      template_category_options: [
	        {
	          value: null,
	          text: this.$t('general.feedback.loading')
	        }
	      ]
	    };
	  },
	  methods: {
	    loadTemplateCategories: function() {
	      return new TemplateCategoriesResource(Session.current_company.id).index(this.loadTemplateCategoriesSuccess, null, {
	        params: {
	          q: {
	            s: 'name asc'
	          }
	        }
	      });
	    },
	    getTemplateCategoriesFromStore: function() {
	      var data;
	      data = {
	        template_categories: this.$store.getters.templateCategoriesList
	      };
	      return this.loadTemplateCategoriesSuccess(data);
	    },
	    loadTemplateCategoriesSuccess: function(data) {
	      var template_category, template_category_options;
	      template_category_options = (function() {
	        var i, len, ref, results;
	        ref = data.template_categories;
	        results = [];
	        for (i = 0, len = ref.length; i < len; i++) {
	          template_category = ref[i];
	          results.push({
	            value: {
	              template_category_id_eq: template_category.id.toString()
	            },
	            text: template_category.name
	          });
	        }
	        return results;
	      })();
	      template_category_options.unshift({
	        value: null,
	        text: this.$t('template.label.allCategories')
	      });
	      this.template_category_options = template_category_options;
	      if (this.load_template_categories) {
	        return this.$store.commit('loadTemplateCategories', data.template_categories);
	      }
	    }
	  },
	  computed: {
	    load_template_categories: function() {
	      return this.$store.getters.templateCategoriesCount === 0;
	    }
	  },
	  created: function() {
	    if (this.load_template_categories) {
	      return this.loadTemplateCategories();
	    } else {
	      return this.getTemplateCategoriesFromStore();
	    }
	  }
	};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.AccountSetting = (function(superClass) {
	  extend(AccountSetting, superClass);
	
	  function AccountSetting() {
	    return AccountSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  AccountSetting.ATTRIBUTES = {
	    id: {},
	    name: {},
	    max_number_of_regular_users: {
	      "default": 0
	    },
	    max_number_of_monitoring_managers: {
	      "default": 0
	    },
	    seller_can_edit_templates: {
	      "default": true
	    },
	    seller_can_see_all_contacts: {
	      "default": true
	    },
	    seller_can_change_responsability: {
	      "default": false
	    }
	  };
	
	  AccountSetting.prototype.isCustom = function() {
	    return this.name === 'custom';
	  };
	
	  return AccountSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Business = (function(superClass) {
	  extend(Business, superClass);
	
	  function Business() {
	    return Business.__super__.constructor.apply(this, arguments);
	  }
	
	  Business.ATTRIBUTES = {
	    id: {},
	    name: {},
	    domain: {},
	    status: {},
	    address: {},
	    list_contacts: {},
	    contacts_count: {},
	    human_status: {},
	    stage: {},
	    human_stage: {}
	  };
	
	  Business.ASSOCIATIONS = {
	    tags: function() {
	      return Tag;
	    }
	  };
	
	  Business.SERIALIZABLE_ATTRIBUTES = ['id', 'name', 'domain', 'address'];
	
	  return Business;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Carousel = (function(superClass) {
	  extend(Carousel, superClass);
	
	  function Carousel() {
	    return Carousel.__super__.constructor.apply(this, arguments);
	  }
	
	  Carousel.ATTRIBUTES = {
	    id: {},
	    next_user_id: {},
	    kind: {},
	    custom_field_id: {},
	    custom_field_value: {},
	    type: {}
	  };
	
	  Carousel.ASSOCIATIONS = {
	    last_user: function() {
	      return User;
	    },
	    next_user: function() {
	      return User;
	    },
	    company: function() {
	      return Company;
	    },
	    carousel_users: function() {
	      return CarouselUser;
	    }
	  };
	
	  Carousel.SERIALIZABLE_ATTRIBUTES = ['id', 'next_user_id', 'kind', 'custom_field_id', 'custom_field_value', 'type'];
	
	  Carousel.SERIALIZABLE_ASSOCIATIONS = ['carousel_users'];
	
	  return Carousel;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.CarouselUser = (function(superClass) {
	  extend(CarouselUser, superClass);
	
	  function CarouselUser() {
	    return CarouselUser.__super__.constructor.apply(this, arguments);
	  }
	
	  CarouselUser.ATTRIBUTES = {
	    id: {},
	    user_id: {},
	    next_user_id: {},
	    _destroy: {}
	  };
	
	  CarouselUser.ASSOCIATIONS = {
	    user: function() {
	      return User;
	    }
	  };
	
	  CarouselUser.SERIALIZABLE_ATTRIBUTES = ['id', 'user_id', 'next_user_id', '_destroy'];
	
	  CarouselUser.SERIALIZABLE_ASSOCIATIONS = [];
	
	  return CarouselUser;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Company = (function(superClass) {
	  extend(Company, superClass);
	
	  function Company() {
	    return Company.__super__.constructor.apply(this, arguments);
	  }
	
	  Company.ATTRIBUTES = {
	    id: {},
	    name: {},
	    email_domain: {},
	    email_domain_verified: {},
	    dkim_value: {},
	    dkim_selector: {},
	    active: true,
	    number_of_regular_users: {},
	    number_of_monitoring_managers: {},
	    voip_service: {},
	    voip_plan_status: {},
	    email_service: {},
	    voip_plan_seconds_left: {},
	    voip_plan_max_duration: {},
	    cpf_active: false,
	    cnpj_active: false
	  };
	
	  Company.ASSOCIATIONS = {
	    account_setting: function() {
	      return AccountSetting;
	    },
	    custom_fields: function() {
	      return CustomField;
	    },
	    plivo_setting: function() {
	      return PlivoSetting;
	    },
	    twilio_setting: function() {
	      return TwilioSetting;
	    },
	    rd_carousel: function() {
	      return Carousel;
	    },
	    sp_carousel: function() {
	      return Carousel;
	    },
	    hs_carousel: function() {
	      return Carousel;
	    }
	  };
	
	  Company.SERIALIZABLE_ATTRIBUTES = ['id', 'name', 'email_domain', 'active', 'plivo_setting_attributes', 'twilio_setting_attributes', 'email_service'];
	
	  Company.SERIALIZABLE_ASSOCIATIONS = ['account_setting', 'plivo_setting', 'twilio_setting'];
	
	  Company.prototype.isActive = function() {
	    return this.active;
	  };
	
	  Company.prototype.account_setting_options = function() {
	    return {
	      account_settings: [
	        {
	          value: {
	            name: 'basic',
	            max_number_of_regular_users: 3
	          },
	          text: 'Básico (até 3 usuários)'
	        }, {
	          value: {
	            name: 'developer',
	            max_number_of_regular_users: 8
	          },
	          text: 'Profissional (3-8 usuários)'
	        }, {
	          value: {
	            name: 'premium',
	            max_number_of_regular_users: 12
	          },
	          text: 'Premium (9-12 usuários)'
	        }, {
	          value: {
	            name: 'enterprise',
	            max_number_of_regular_users: null
	          },
	          text: 'Customizado (mais de 12 usuários)'
	        }
	      ]
	    };
	  };
	
	  Company.prototype.available_roles = function() {
	    var roles;
	    roles = [];
	    if (this.number_of_regular_users < this.account_setting.max_number_of_regular_users || !this.account_setting || this.account_setting instanceof Array) {
	      roles.push('manager');
	      roles.push('seller');
	      roles.push('sdr');
	    }
	    if (this.number_of_monitoring_managers < this.account_setting.max_number_of_monitoring_managers || !this.account_setting || this.account_setting instanceof Array) {
	      roles.push('monitoring_manager');
	    }
	    return roles;
	  };
	
	  Company.prototype.isPlivo = function() {
	    return this.voip_service === 'plivo';
	  };
	
	  Company.prototype.isTwilio = function() {
	    return this.voip_service === 'twilio';
	  };
	
	  Company.prototype.isVoipExceeded = function() {
	    return this.voip_plan_status === 'exceeded';
	  };
	
	  Company.prototype.serialize = function() {
	    var serialized;
	    serialized = Company.__super__.serialize.apply(this, arguments);
	    if (!this.isPlivo()) {
	      delete serialized['plivo_setting_attributes'];
	    }
	    if (!this.isTwilio()) {
	      delete serialized['twilio_setting_attributes'];
	    }
	    return serialized;
	  };
	
	  Company.prototype.isSparkpost = function() {
	    return this.email_service === 'sparkpost';
	  };
	
	  Company.prototype.isNylas = function() {
	    return this.email_service === 'nylas';
	  };
	
	  return Company;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel, i18n,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	i18n = __webpack_require__(227);
	
	global.Contact = (function(superClass) {
	  extend(Contact, superClass);
	
	  Contact.ATTRIBUTES = {
	    id: {},
	    address: {},
	    business_name: {},
	    base_business_name: {},
	    cellphone: {},
	    city: {},
	    country: {},
	    email: {},
	    first_name: {},
	    full_name: {},
	    contact_group: {},
	    contact_group_id: {},
	    human_stage: {},
	    human_previous_stage: {},
	    human_recipient_status: {},
	    recipient_last_flow_action_taken_state: {},
	    last_name: {},
	    next_valid_stages: {
	      type: Object
	    },
	    next_valid_recipient_statuses: {
	      type: Object
	    },
	    position: {},
	    stage: {},
	    previous_stage: {},
	    recipient_priority: {},
	    recipient_status: {},
	    state: {},
	    telephone: {},
	    user_id: {},
	    lost_reason_id: {},
	    lost_reason_title: {},
	    active_on_flow: {},
	    stage_updated_at: {},
	    updated_at: {
	      type: Date
	    },
	    created_at: {
	      type: Date
	    },
	    url: {},
	    linkedin: {},
	    interactions_with_current_flow: {},
	    variable1: {},
	    variable2: {},
	    variable3: {},
	    deleted_by_user_at: {},
	    business_model_name: {},
	    status_updated_at: {
	      type: Date
	    }
	  };
	
	  Contact.ASSOCIATIONS = {
	    business: function() {
	      return Business;
	    },
	    user: function() {
	      return User;
	    },
	    flow: function() {
	      return Flow;
	    },
	    recipient: function() {
	      return FlowRecipient;
	    },
	    tags: function() {
	      return Tag;
	    },
	    events: function() {
	      return ContactEvent;
	    },
	    comments: function() {
	      return ContactEvent;
	    },
	    contact_custom_fields: function() {
	      return ContactCustomField;
	    }
	  };
	
	  Contact.SERIALIZABLE_ATTRIBUTES = ['first_name', 'last_name', 'email', 'business_name', 'business_model_name', 'position', 'telephone', 'cellphone', 'address', 'stage', 'city', 'state', 'country', 'contact_group_id', 'url', 'variable1', 'variable2', 'variable3'];
	
	  Contact.SERIALIZABLE_ASSOCIATIONS = ['business', 'contact_custom_fields'];
	
	  function Contact(attributes) {
	    Contact.__super__.constructor.call(this, attributes);
	    if (this.business.name) {
	      this.base_business_name = this.business.name;
	    } else {
	      this.base_business_name = '';
	      this.business = new Business();
	    }
	  }
	
	  Contact.prototype.afterInitialize = function() {
	    return this.original_recipient_priority = this.recipient_priority;
	  };
	
	  Contact.prototype.humanStageUpdatedAt = function() {
	    if (!this.stage_updated_at) {
	      return '';
	    }
	    return this.stage_updated_at.format('LTS');
	  };
	
	  Contact.prototype.humalUpdatedAt = function() {
	    if (!this.updated_at) {
	      return '';
	    }
	    return this.updated_at.format('LTS');
	  };
	
	  Contact.prototype.humalCreatedAt = function() {
	    if (!this.created_at) {
	      return '';
	    }
	    return this.created_at.format('LTS');
	  };
	
	  Contact.prototype.stages = function() {
	    return [
	      {
	        value: 'smart_lead',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.smartLead')
	      }, {
	        value: 'prospect',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.prospect')
	      }, {
	        value: 'lead',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.lead')
	      }, {
	        value: 'mql',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.mql')
	      }, {
	        value: 'sql',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.sql')
	      }, {
	        value: 'opportunity',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.opportunity')
	      }, {
	        value: 'client',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.client')
	      }, {
	        value: 'lost',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.lost')
	      }
	    ];
	  };
	
	  Contact.prototype.hubspot_stages = function() {
	    return [
	      {
	        value: 'subscriber',
	        selected: false,
	        text: 'Subscriber'
	      }, {
	        value: 'lead',
	        selected: false,
	        text: 'Lead'
	      }, {
	        value: 'marketingqualifiedlead',
	        selected: false,
	        text: 'MQL'
	      }, {
	        value: 'salesqualifiedlead',
	        selected: false,
	        text: 'SQL'
	      }, {
	        value: 'opportunity',
	        selected: false,
	        text: 'Opportunity'
	      }, {
	        value: 'customer',
	        selected: false,
	        text: 'Customer'
	      }
	    ];
	  };
	
	  Contact.prototype.rd_station_stages = function() {
	    return [
	      {
	        value: 'smart_lead',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.smartLead')
	      }, {
	        value: 'prospect',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.prospect')
	      }, {
	        value: 'lead',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.lead')
	      }, {
	        value: 'mql',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.mql')
	      }, {
	        value: 'sql',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.sql')
	      }, {
	        value: 'opportunity',
	        selected: false,
	        text: i18n["default"].t('integrations.label.stages_matching.opportunity')
	      }
	    ];
	  };
	
	  Contact.prototype.humanStatusUpdatedAt = function() {
	    if (!Array.isArray(this.recipient)) {
	      return this.recipient.humanStatusUpdatedAt();
	    }
	    if (!this.status_updated_at) {
	      return '';
	    }
	    return this.status_updated_at.format('LTS');
	  };
	
	  Contact.prototype.getNextValidStages = function(hideStages) {
	    var key, ref, stages, value;
	    if (hideStages == null) {
	      hideStages = [];
	    }
	    if (hideStages.length === 0) {
	      return this.next_valid_stages;
	    }
	    stages = {};
	    ref = this.next_valid_stages;
	    for (key in ref) {
	      value = ref[key];
	      if (hideStages.includes(key)) {
	        continue;
	      }
	      stages[key] = value;
	    }
	    return stages;
	  };
	
	  return Contact;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.ContactCustomField = (function(superClass) {
	  extend(ContactCustomField, superClass);
	
	  function ContactCustomField() {
	    return ContactCustomField.__super__.constructor.apply(this, arguments);
	  }
	
	  ContactCustomField.ATTRIBUTES = {
	    id: {},
	    custom_field_id: {},
	    value: {},
	    field: {},
	    kind: {},
	    options: {}
	  };
	
	  return ContactCustomField;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.ContactEvent = (function(superClass) {
	  extend(ContactEvent, superClass);
	
	  function ContactEvent() {
	    return ContactEvent.__super__.constructor.apply(this, arguments);
	  }
	
	  ContactEvent.ATTRIBUTES = {
	    id: {},
	    detailed_type: {},
	    title: {},
	    description: {},
	    created_at: {
	      type: Date
	    },
	    updated_at: {
	      type: Date
	    },
	    email: {},
	    author: {},
	    edition_author: {},
	    comment: {},
	    flow_action_id: {},
	    call_status: {},
	    call_recording_url: {},
	    showEmail: false,
	    metadata: {}
	  };
	
	  ContactEvent.ASSOCIATIONS = {
	    user: function() {
	      return User;
	    },
	    contact: function() {
	      return Contact;
	    },
	    task: function() {
	      return Task;
	    },
	    flow: function() {
	      return Flow;
	    }
	  };
	
	  ContactEvent.prototype.quotedDescription = function() {
	    if (this.description && !this.isCallEvent()) {
	      return "\"" + this.description + "\"";
	    } else {
	      return '';
	    }
	  };
	
	  ContactEvent.prototype.type = function() {
	    return this.detailed_type.split('-')[0];
	  };
	
	  ContactEvent.prototype.detail = function() {
	    return this.detailed_type.split('-')[1];
	  };
	
	  ContactEvent.prototype.emailIconClasses = function() {
	    if (this.detail() !== 'soft_bounce') {
	      if (this.detail() === 'sent') {
	        return "task-icon " + (this.emailSubiconClass());
	      } else {
	        return "email-icon contact-event-subicon " + (this.emailSubiconClass());
	      }
	    } else {
	      return "soft_bounce-event-icon";
	    }
	  };
	
	  ContactEvent.prototype.emailSubiconClass = function() {
	    switch (this.detail()) {
	      case 'sent':
	        return 'email-task-icon';
	      case 'delivery':
	        return 'delivery-icon';
	      case 'open':
	        return 'open-icon';
	      case 'reply':
	        return 'reply-icon';
	      case 'bounce':
	        return 'bounce-icon';
	    }
	  };
	
	  ContactEvent.prototype.humanStatus = function() {
	    switch (this.call_status) {
	      case "no_connection":
	        return "Sem conexão";
	      case "gatekeeper":
	        return "Gatekeeper";
	      case "opportunity":
	        return "Conectado";
	      case "client":
	        return "Cliente";
	      case "lost":
	        return "Perdido";
	    }
	  };
	
	  ContactEvent.prototype.isDoneTaskEvent = function() {
	    return this.task && this.task.done_at && !this.description;
	  };
	
	  ContactEvent.prototype.isCallEvent = function() {
	    return this.type() === 'CallEvent';
	  };
	
	  return ContactEvent;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.ContactGroup = (function(superClass) {
	  extend(ContactGroup, superClass);
	
	  function ContactGroup() {
	    return ContactGroup.__super__.constructor.apply(this, arguments);
	  }
	
	  ContactGroup.ATTRIBUTES = {
	    id: {},
	    name: {},
	    import_action: {},
	    contacts_count: {},
	    user_id: {},
	    opportunities_percentage: {},
	    job_status: {}
	  };
	
	  ContactGroup.ASSOCIATIONS = {
	    contacts: function() {
	      return Contact;
	    },
	    user: function() {
	      return User;
	    }
	  };
	
	  ContactGroup.SERIALIZABLE_ATTRIBUTES = ['id', 'name', 'contact_ids_to_be_removed'];
	
	  ContactGroup.SERIALIZABLE_ASSOCIATIONS = ['contacts'];
	
	  ContactGroup.prototype.isProcessing = function() {
	    return this.job_status !== null && (this.job_status.status === 'processing' || this.job_status.status === 'unitialized');
	  };
	
	  ContactGroup.prototype.isWithError = function() {
	    return this.job_status !== null && this.job_status.status === 'error';
	  };
	
	  ContactGroup.prototype.hasStatusMessage = function() {
	    return this.isProcessing() || this.isWithError();
	  };
	
	  ContactGroup.prototype.serialize = function() {
	    var contact, contacts_attributes, i, len, ref, serialized;
	    serialized = ContactGroup.__super__.serialize.apply(this, arguments);
	    contacts_attributes = [];
	    ref = this.contacts;
	    for (i = 0, len = ref.length; i < len; i++) {
	      contact = ref[i];
	      if (contact.isPersisted()) {
	        if (contact.contact_group_id !== this.id) {
	          contacts_attributes.push({
	            id: contact.id
	          });
	        }
	      } else {
	        contacts_attributes.push(contact.serialize());
	      }
	    }
	    serialized.contacts_attributes = contacts_attributes;
	    return serialized;
	  };
	
	  return ContactGroup;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.ContactSpecificTemplate = (function(superClass) {
	  extend(ContactSpecificTemplate, superClass);
	
	  function ContactSpecificTemplate() {
	    return ContactSpecificTemplate.__super__.constructor.apply(this, arguments);
	  }
	
	  ContactSpecificTemplate.ATTRIBUTES = {
	    id: {},
	    flow_action_id: {},
	    contact_id: {},
	    template_id: {},
	    subject: {},
	    body: {},
	    kind: {},
	    signature: {},
	    _destroy: false,
	    contact_email: {},
	    contact: {}
	  };
	
	  ContactSpecificTemplate.SERIALIZABLE_ATTRIBUTES = ['id', 'contact_id', 'template_id', 'contact_email', 'subject', 'body', 'signature', 'kind', '_destroy'];
	
	  ContactSpecificTemplate.prototype.belongsToContact = function(contact) {
	    var ref;
	    if (contact.id) {
	      return (this.contact_id || this.contact.id) === contact.id;
	    } else if ((contact != null ? contact.email : void 0) && (this.contact_email || ((ref = this.contact) != null ? ref.email : void 0))) {
	      return (this.contact_email || this.contact.email) === contact.email;
	    }
	  };
	
	  return ContactSpecificTemplate;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.CRMSetting = (function(superClass) {
	  extend(CRMSetting, superClass);
	
	  function CRMSetting() {
	    return CRMSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  CRMSetting.ATTRIBUTES = {
	    id: {},
	    bcc_send_email: {},
	    bcc_reply_email: {},
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    properties_matching: {
	      "default": [],
	      type: Object
	    },
	    stages_matching: {
	      "default": [],
	      type: Object
	    }
	  };
	
	  return CRMSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.CustomField = (function(superClass) {
	  extend(CustomField, superClass);
	
	  function CustomField() {
	    return CustomField.__super__.constructor.apply(this, arguments);
	  }
	
	  CustomField.ATTRIBUTES = {
	    id: {},
	    field: {},
	    kind: {},
	    options: {
	      "default": []
	    }
	  };
	
	  return CustomField;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.CvCrmSetting = (function(superClass) {
	  extend(CvCrmSetting, superClass);
	
	  function CvCrmSetting() {
	    return CvCrmSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  CvCrmSetting.ATTRIBUTES = {
	    id: {},
	    domain: {},
	    email: {},
	    add_contacts_from_cv_crm: {},
	    metadata: {
	      "default": {
	        pipeline_name: '',
	        stage_id: '',
	        pipeline_id: ''
	      },
	      type: Object
	    },
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    properties_matching: {
	      "default": [
	        {
	          reev: 'telephone',
	          reev_name: 'Telefone',
	          integration: 'phone',
	          integration_name: 'Telefone',
	          type: 'tel'
	        }
	      ],
	      type: Object
	    },
	    stages_matching: {
	      "default": [],
	      type: Object
	    }
	  };
	
	  return CvCrmSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.EmailStatistic = (function(superClass) {
	  extend(EmailStatistic, superClass);
	
	  function EmailStatistic() {
	    return EmailStatistic.__super__.constructor.apply(this, arguments);
	  }
	
	  EmailStatistic.ATTRIBUTES = {
	    id: {},
	    sent: {
	      type: Number
	    },
	    accepted: {
	      type: Number
	    },
	    rejected: {
	      type: Number
	    },
	    delivery: {
	      type: Number
	    },
	    bounce: {
	      type: Number
	    },
	    open: {
	      type: Number
	    },
	    reply: {
	      type: Number
	    }
	  };
	
	  EmailStatistic.prototype.openPercentage = function() {
	    return this.formattedPercentage(this.open);
	  };
	
	  EmailStatistic.prototype.replyPercentage = function(recipients_count) {
	    return this.formattedPercentage(this.reply, recipients_count);
	  };
	
	  EmailStatistic.prototype.formattedPercentage = function(value, total) {
	    var percentage;
	    if (total == null) {
	      total = null;
	    }
	    if (total == null) {
	      total = this.sent;
	    }
	    if (total > 0) {
	      percentage = ((parseFloat(value) / total) * 100.0).toFixed(1);
	      return percentage.replace('.', ',') + '%';
	    } else {
	      return '--';
	    }
	  };
	
	  EmailStatistic.prototype.humanLabel = function(field) {
	    var attributes;
	    attributes = {
	      sent: 'Enviados',
	      accepted: 'Recebidos',
	      rejected: 'Rejeitados',
	      delivery: 'Entregues',
	      bounce: 'Rejeitados',
	      open: 'Abertos',
	      reply: 'Respondidos'
	    };
	    return attributes[field];
	  };
	
	  return EmailStatistic;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Flow = (function(superClass) {
	  extend(Flow, superClass);
	
	  function Flow() {
	    return Flow.__super__.constructor.apply(this, arguments);
	  }
	
	  Flow.ATTRIBUTES = {
	    id: {},
	    name: {},
	    emails_per_day: {
	      type: Number
	    },
	    status: {
	      "default": 'paused'
	    },
	    delay_before_finishing_contact_amount: {
	      "default": 1
	    },
	    delay_before_finishing_contact_unit: {
	      "default": 'days'
	    },
	    weekdays_to_send: {
	      type: Array
	    },
	    duration_in_days: {
	      type: Number
	    },
	    created_at: {
	      type: Date
	    },
	    next_valid_statuses: {
	      type: Object
	    },
	    recipients_statistics: {
	      type: Object
	    },
	    human_weekdays_to_send: {
	      type: Array
	    },
	    human_status: {},
	    job_status: {
	      type: Object
	    },
	    actions_count: {
	      "default": 0
	    },
	    bcc: {
	      "default": false
	    },
	    semi_automatic: {
	      "default": true
	    },
	    with_task_timer: {
	      "default": false
	    },
	    interrupted_contacts: {
	      "default": false
	    },
	    user_id: {},
	    lost_reason_id: {},
	    set_lost_on_finish: {
	      "default": true
	    },
	    value: {},
	    triggers: {
	      type: Array
	    },
	    can_edit_flow_actions: {
	      "default": false
	    },
	    category_id: {
	      "default": null
	    }
	  };
	
	  Flow.SERIALIZABLE_ATTRIBUTES = ['id', 'name', 'emails_per_day', 'status', 'weekdays_to_send', 'delay_before_finishing_contact_amount', 'delay_before_finishing_contact_unit', 'bcc', 'contact_ids_to_be_removed', 'semi_automatic', 'lost_reason_id', 'set_lost_on_finish', 'category_id', 'with_task_timer'];
	
	  Flow.ASSOCIATIONS = {
	    contacts: function() {
	      return Contact;
	    },
	    actions: function() {
	      return FlowAction;
	    },
	    email_statistic: function() {
	      return EmailStatistic;
	    },
	    user: function() {
	      return User;
	    }
	  };
	
	  Flow.SERIALIZABLE_ASSOCIATIONS = ['actions'];
	
	  Flow.prototype.recipients_statistics_conversion = function() {
	    var percentage, ref;
	    if (!((ref = this.recipients_statistics) != null ? ref.by_stage : void 0)) {
	      return '--';
	    }
	    percentage = (this.recipients_statistics.by_stage.conversion.value * 100.0).toFixed(1);
	    return percentage.replace('.', ',') + '%';
	  };
	
	  Flow.prototype.contacts_count = function() {
	    var ref;
	    if (!((ref = this.recipients_statistics) != null ? ref.total : void 0)) {
	      return 0;
	    }
	    return this.recipients_statistics.total.count;
	  };
	
	  Flow.prototype.isPublished = function() {
	    return this.status === 'published';
	  };
	
	  Flow.prototype.isPaused = function() {
	    return this.status === 'paused';
	  };
	
	  Flow.prototype.isProcessing = function() {
	    return this.job_status !== null && (this.job_status.status === 'processing' || this.job_status.status === 'unitialized');
	  };
	
	  Flow.prototype.errors = function() {
	    return this.job_status.errors;
	  };
	
	  Flow.prototype.isWithError = function() {
	    return this.job_status !== null && this.job_status.status === 'error';
	  };
	
	  Flow.prototype.hasStatusMessage = function() {
	    return this.isProcessing() || this.isWithError();
	  };
	
	  Flow.prototype.toggleStatus = function() {
	    if (this.isPublished()) {
	      return this.status = 'paused';
	    } else {
	      return this.status = 'published';
	    }
	  };
	
	  Flow.prototype.toggleTaskTimer = function() {
	    return this.with_task_timer = !this.with_task_timer;
	  };
	
	  Flow.prototype.toggleType = function() {
	    this.semi_automatic = !this.semi_automatic;
	    return this.toggleActionTypes();
	  };
	
	  Flow.prototype.toggleActionTypes = function() {
	    var action, i, len, ref, results;
	    ref = this.actions;
	    results = [];
	    for (i = 0, len = ref.length; i < len; i++) {
	      action = ref[i];
	      if (!(action.type === 'EmailFlowAction' || action.manual_task_parameters.service === Task.emailTaskService.service)) {
	        continue;
	      }
	      if (this.semi_automatic) {
	        action.type = 'TaskFlowAction';
	        results.push(action.manual_task_parameters = {
	          service: Task.emailTaskService.service
	        });
	      } else {
	        results.push(action.type = 'EmailFlowAction');
	      }
	    }
	    return results;
	  };
	
	  Flow.prototype.serialize = function() {
	    var contact, i, len, recipients_attributes, ref, serialized;
	    serialized = Flow.__super__.serialize.apply(this, arguments);
	    recipients_attributes = [];
	    ref = this.contacts;
	    for (i = 0, len = ref.length; i < len; i++) {
	      contact = ref[i];
	      if (contact.isPersisted()) {
	        recipients_attributes.push({
	          contact_id: contact.id,
	          priority: contact.recipient_priority
	        });
	      } else {
	        recipients_attributes.push({
	          contact_attributes: contact.serialize(),
	          priority: contact.recipient_priority
	        });
	      }
	    }
	    serialized.recipients_attributes = recipients_attributes;
	    serialized.triggers_attributes = this.triggers;
	    return serialized;
	  };
	
	  Flow.prototype.canEditActions = function() {
	    return this.contacts_count() === 0 || !this.id || this.can_edit_flow_actions;
	  };
	
	  return Flow;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.FlowAction = (function(superClass) {
	  extend(FlowAction, superClass);
	
	  function FlowAction() {
	    return FlowAction.__super__.constructor.apply(this, arguments);
	  }
	
	  FlowAction.ATTRIBUTES = {
	    id: {},
	    is_first: {
	      "default": false
	    },
	    name: {},
	    template_id: {},
	    delay_after_previous_step_amount: {
	      type: Number
	    },
	    delay_after_previous_step_unit: {},
	    recipients_statistics: {
	      type: Object
	    },
	    send_immediately: false,
	    send_at: {
	      type: Date
	    },
	    send_at_in_user_time_zone: {
	      type: Date
	    },
	    immediately: {},
	    step: {
	      type: Number
	    },
	    type: {},
	    manual_task_parameters: {},
	    signature: {},
	    send_as_reply: {},
	    undefined_time: {},
	    _destroy: {},
	    template_copied_from_id: {},
	    original_template_id: {}
	  };
	
	  FlowAction.SERIALIZABLE_ATTRIBUTES = ['id', 'step', 'template_id', 'delay_after_previous_step_amount', 'delay_after_previous_step_unit', 'send_at', 'type', 'manual_task_parameters', 'send_as_reply', 'undefined_time', 'send_immediately', '_destroy', 'template_copied_from_id'];
	
	  FlowAction.ASSOCIATIONS = {
	    email_statistic: function() {
	      return EmailStatistic;
	    },
	    template: function() {
	      return Template;
	    },
	    flow: function() {
	      return Flow;
	    },
	    contact_specific_templates: function() {
	      return ContactSpecificTemplate;
	    }
	  };
	
	  FlowAction.SERIALIZABLE_ASSOCIATIONS = ['contact_specific_templates'];
	
	  FlowAction.prototype.serialize = function(selected_attributes) {
	    var serialized;
	    if (selected_attributes == null) {
	      selected_attributes = false;
	    }
	    serialized = FlowAction.__super__.serialize.call(this, selected_attributes);
	    if (this.template.id === -1) {
	      serialized.original_template_attributes = Object.assign({}, this.template);
	      serialized.original_template_attributes.id = null;
	    }
	    return serialized;
	  };
	
	  FlowAction.prototype.isEmailFlowAction = function() {
	    return this.type === 'EmailFlowAction' || this.manual_task_parameters.service === 'ManualTasksServices::Email';
	  };
	
	  FlowAction.prototype.afterInitialize = function() {
	    this.human_step = this.step + 1;
	    return this.is_first = this.step === 0;
	  };
	
	  FlowAction.prototype.humanSendAt = function() {
	    if (!(this.send_at && this.send_at.isValid && this.send_at.isValid())) {
	      return null;
	    }
	    return this.send_at.clone().subtract(this.send_at.utcOffset(), 'minutes').format('HH:mm');
	  };
	
	  FlowAction.prototype.humanDelay = function() {
	    if (!this.delay_after_previous_step_unit) {
	      return;
	    }
	    return this.delay_after_previous_step_amount + " " + (this.humanUnit());
	  };
	
	  FlowAction.prototype.humanUnit = function() {
	    if (this.delay_after_previous_step_unit === 'months') {
	      if (this.delay_after_previous_step_amount === 1) {
	        return 'mês';
	      } else {
	        return 'meses';
	      }
	    } else if (this.delay_after_previous_step_unit === 'weeks') {
	      if (this.delay_after_previous_step_amount === 1) {
	        return 'semana';
	      } else {
	        return 'semanas';
	      }
	    } else if (this.delay_after_previous_step_unit === 'days') {
	      if (this.delay_after_previous_step_amount === 1) {
	        return 'dia';
	      } else {
	        return 'dias';
	      }
	    }
	  };
	
	  return FlowAction;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.FlowRecipient = (function(superClass) {
	  extend(FlowRecipient, superClass);
	
	  function FlowRecipient() {
	    return FlowRecipient.__super__.constructor.apply(this, arguments);
	  }
	
	  FlowRecipient.ATTRIBUTES = {
	    id: {},
	    last_flow_action_taken: {},
	    last_flow_action_taken_state: {},
	    human_last_flow_action_taken: {},
	    statistics: {
	      "default": {}
	    },
	    flow_id: {},
	    status_updated_at: {
	      type: Date
	    },
	    metadata: {},
	    soft_bounce_failures_count: {}
	  };
	
	  FlowRecipient.ASSOCIATIONS = {
	    reactivate_automatic_task: function() {
	      return Task;
	    }
	  };
	
	  FlowRecipient.SOFT_BOUNCE_MAX_ATTEMPTS = 3;
	
	  FlowRecipient.prototype.emailOpenStatistics = function() {
	    if (!this.statistics.email_open || this.last_flow_action_taken === void 0) {
	      return;
	    }
	    return this.statistics.email_open[this.last_flow_action_taken.toString()];
	  };
	
	  FlowRecipient.prototype.humanStatusUpdatedAt = function() {
	    if (!this.status_updated_at) {
	      return '';
	    }
	    return this.status_updated_at.format('LTS');
	  };
	
	  FlowRecipient.prototype.lastActionTakenStateTooltipText = function() {
	    if (this.last_flow_action_taken_state !== 'soft_bounce') {
	      return;
	    }
	    if (this.soft_bounce_failures_count === 0 || !this.softBounceReason()) {
	      return Locales.recipient.soft_bounce['generic'];
	    } else {
	      return Locales.recipient.soft_bounce[this.softBounceReason()](this.soft_bounce_failures_count, FlowRecipient.SOFT_BOUNCE_MAX_ATTEMPTS);
	    }
	  };
	
	  FlowRecipient.prototype.softBounceReason = function() {
	    var ref, ref1;
	    return (ref = this.metadata) != null ? (ref1 = ref.soft_bounce) != null ? ref1.reason : void 0 : void 0;
	  };
	
	  return FlowRecipient;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.HubspotSetting = (function(superClass) {
	  extend(HubspotSetting, superClass);
	
	  function HubspotSetting() {
	    return HubspotSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  HubspotSetting.ATTRIBUTES = {
	    id: {},
	    create_webhook: {},
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    use_carousel: {
	      "default": true
	    },
	    access_token: {},
	    properties_matching: {
	      "default": [],
	      type: Array
	    },
	    stages_matching: {
	      "default": [],
	      type: Object
	    },
	    metadata: {
	      "default": {
	        pipeline_id: null,
	        lifecycles: []
	      }
	    },
	    pipeline: {},
	    stage: {},
	    mark_as: {
	      "default": 'update_deal_lost'
	    }
	  };
	
	  return HubspotSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.LeadloversSetting = (function(superClass) {
	  extend(LeadloversSetting, superClass);
	
	  function LeadloversSetting() {
	    return LeadloversSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  LeadloversSetting.ATTRIBUTES = {
	    id: {},
	    metadata: {
	      "default": {},
	      type: Object
	    },
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    use_carousel: {
	      "default": false
	    }
	  };
	
	  return LeadloversSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.LostReason = (function(superClass) {
	  extend(LostReason, superClass);
	
	  function LostReason() {
	    return LostReason.__super__.constructor.apply(this, arguments);
	  }
	
	  LostReason.ATTRIBUTES = {
	    id: {},
	    title: {}
	  };
	
	  return LostReason;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.MeetingType = (function(superClass) {
	  extend(MeetingType, superClass);
	
	  function MeetingType() {
	    return MeetingType.__super__.constructor.apply(this, arguments);
	  }
	
	  MeetingType.ATTRIBUTES = {
	    id: {},
	    title: {}
	  };
	
	  return MeetingType;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.NectarSetting = (function(superClass) {
	  extend(NectarSetting, superClass);
	
	  function NectarSetting() {
	    return NectarSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  NectarSetting.ATTRIBUTES = {
	    id: {},
	    pipeline: {},
	    stage_id: {},
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: ['lost']
	      },
	      type: Object
	    },
	    pipeline_id: {},
	    stage_number: {},
	    create_on_add: {},
	    send_tasks: {
	      "default": true
	    },
	    responsible: {}
	  };
	
	  return NectarSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Notification = (function(superClass) {
	  extend(Notification, superClass);
	
	  function Notification() {
	    return Notification.__super__.constructor.apply(this, arguments);
	  }
	
	  Notification.ATTRIBUTES = {
	    id: {},
	    kind: {},
	    created_at: {
	      type: Date,
	      "default": null
	    },
	    updated_at: {
	      type: Date,
	      "default": null
	    },
	    read_at: {
	      type: Date,
	      "default": null
	    },
	    count: {},
	    contact_name: {},
	    flow_name: {},
	    task_due_on: {
	      type: Date,
	      "default": null
	    },
	    task_done_at: {
	      type: Date,
	      "default": null
	    },
	    task_ids: {},
	    metadata: {}
	  };
	
	  Notification.ASSOCIATIONS = {
	    user: function() {
	      return User;
	    }
	  };
	
	  Notification.SERIALIZABLE_ASSOCIATIONS = [];
	
	  Notification.prototype.timeText = function() {
	    var time;
	    time = moment(this.created_at);
	    time.locale('pt-BR');
	    return time.fromNow();
	  };
	
	  Notification.prototype.cssClasses = function() {
	    var c;
	    c = this.kind;
	    if (this.read_at) {
	      c += ' read';
	    }
	    return c;
	  };
	
	  return Notification;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.NylasSetting = (function(superClass) {
	  extend(NylasSetting, superClass);
	
	  function NylasSetting() {
	    return NylasSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  NylasSetting.ATTRIBUTES = {
	    id: {},
	    authorized: {
	      "default": false
	    }
	  };
	
	  return NylasSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.PipedriveSetting = (function(superClass) {
	  extend(PipedriveSetting, superClass);
	
	  function PipedriveSetting() {
	    return PipedriveSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  PipedriveSetting.ATTRIBUTES = {
	    id: {},
	    stage_id: {},
	    add_contacts_to_pipedrive: {},
	    metadata: {
	      "default": {
	        pipeline_name: '',
	        stage_id: '',
	        pipeline_id: ''
	      },
	      type: Object
	    },
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    properties_matching: {
	      "default": [
	        {
	          reev: 'telephone',
	          reev_name: 'Telefone',
	          integration: 'phone',
	          integration_name: 'Telefone',
	          type: 'tel'
	        }
	      ],
	      type: Object
	    },
	    stages_matching: {
	      "default": [],
	      type: Object
	    },
	    mark_as: {
	      "default": 'update_deal_lost'
	    }
	  };
	
	  return PipedriveSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.PlivoSetting = (function(superClass) {
	  extend(PlivoSetting, superClass);
	
	  function PlivoSetting() {
	    return PlivoSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  PlivoSetting.ATTRIBUTES = {
	    id: {},
	    seconds_left: {},
	    caller_id: ''
	  };
	
	  PlivoSetting.SERIALIZABLE_ATTRIBUTES = ['id'];
	
	  PlivoSetting.ASSOCIATIONS = {
	    voip_monthly_plan: function() {
	      return VoipMonthlyPlan;
	    },
	    voip_additional_times: function() {
	      return VoipAdditionalTime;
	    }
	  };
	
	  PlivoSetting.SERIALIZABLE_ASSOCIATIONS = ['voip_monthly_plan', 'voip_additional_times'];
	
	  PlivoSetting.prototype.sum_additional_minutes = function() {
	    if (this.voip_additional_times.length === 0) {
	      return 0;
	    }
	    return (this.voip_additional_times.map(function(m) {
	      return m.seconds_in_minutes();
	    })).reduce(function(a, b) {
	      return a + b;
	    });
	  };
	
	  return PlivoSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.RDStationCRMSetting = (function(superClass) {
	  extend(RDStationCRMSetting, superClass);
	
	  function RDStationCRMSetting() {
	    return RDStationCRMSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  RDStationCRMSetting.ATTRIBUTES = {
	    id: {},
	    metadata: {},
	    stage_id: {},
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    properties_matching: {
	      "default": [],
	      type: Object
	    },
	    stages_matching: {
	      "default": [],
	      type: Object
	    }
	  };
	
	  return RDStationCRMSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.RdStationSetting = (function(superClass) {
	  extend(RdStationSetting, superClass);
	
	  function RdStationSetting() {
	    return RdStationSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  RdStationSetting.ATTRIBUTES = {
	    id: {},
	    authorized: {},
	    mark_lead_as_sale: {},
	    mark_lead_as_lost: {},
	    mark_lead_as_opportunity: {},
	    triggers: {
	      "default": {
	        on_created: false,
	        status: [],
	        stages: []
	      },
	      type: Object
	    },
	    use_carousel: {
	      "default": false
	    },
	    use_carousel_by_property: {
	      "default": true
	    },
	    custom_field_id: {},
	    original_response: {},
	    properties_matching: {
	      "default": [],
	      type: Array
	    }
	  };
	
	  return RdStationSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.SalesforceSetting = (function(superClass) {
	  extend(SalesforceSetting, superClass);
	
	  function SalesforceSetting() {
	    return SalesforceSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  SalesforceSetting.ATTRIBUTES = {
	    id: {},
	    authorized: {},
	    status: {},
	    access_token: {},
	    mark_as: {
	      "default": 'only_lead'
	    },
	    send_to: {
	      "default": 'responsible'
	    },
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: ['lost']
	      },
	      type: Object
	    },
	    properties_matching: {
	      "default": [],
	      type: Array
	    },
	    sandbox_test: {
	      "default": false
	    }
	  };
	
	  return SalesforceSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.SharpspringSetting = (function(superClass) {
	  extend(SharpspringSetting, superClass);
	
	  function SharpspringSetting() {
	    return SharpspringSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  SharpspringSetting.ATTRIBUTES = {
	    id: {},
	    metadata: {
	      "default": {},
	      type: Object
	    },
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    use_carousel: {
	      "default": true
	    }
	  };
	
	  return SharpspringSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Tag = (function(superClass) {
	  extend(Tag, superClass);
	
	  function Tag() {
	    return Tag.__super__.constructor.apply(this, arguments);
	  }
	
	  Tag.ATTRIBUTES = {
	    id: {},
	    name: {},
	    color: {},
	    taggable_tag_id: {}
	  };
	
	  Tag.colors = ['27C3E2', '3FA8E4', '2D7DAA', '5DCE49', '54BB42', '6DB03C', 'F7DB1F', 'EFC017', 'F6AF16', 'F68F16', 'FA6252', 'E4524D', 'C43C37', 'EC6296', 'D83E78', '5A0C91'];
	
	  return Tag;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Task = (function(superClass) {
	  extend(Task, superClass);
	
	  function Task() {
	    return Task.__super__.constructor.apply(this, arguments);
	  }
	
	  Task.ATTRIBUTES = {
	    id: {},
	    type: {},
	    due_on: {
	      type: Date,
	      "default": moment().add(1, 'day')
	    },
	    end_on: {
	      type: Date,
	      "default": moment().add(1, 'day').add(1, 'hour')
	    },
	    done_at: {
	      type: Date,
	      "default": null
	    },
	    service: {},
	    comment: {},
	    metadata: {},
	    text: {},
	    slug: {},
	    referenceable_id: {},
	    referenceable_type: {},
	    created_by_type: {},
	    undefined_time: {},
	    assigned_to_id: {},
	    voip_calls_count: {},
	    voip_call_status: {},
	    meeting_type_id: {},
	    new_contact_stage: {}
	  };
	
	  Task.ASSOCIATIONS = {
	    contact: function() {
	      return Contact;
	    },
	    template: function() {
	      return Template;
	    },
	    assigned_to: function() {
	      return User;
	    },
	    meeting_type: function() {
	      return MeetingType;
	    },
	    flow: function() {
	      return Flow;
	    }
	  };
	
	  Task.SERIALIZABLE_ATTRIBUTES = ['id', 'type', 'due_on', 'metadata', 'service', 'done_at', 'comment', 'referenceable_type', 'referenceable_id', 'template', 'undefined_time'];
	
	  Task.SERIALIZABLE_ASSOCIATIONS = [];
	
	  Task.emailTaskService = {
	    service: 'ManualTasksServices::Email',
	    human_name: 'E-mail',
	    type: 'EmailFlowAction'
	  };
	
	  Task.availableManualTaskServices = [
	    Task.emailTaskService, {
	      service: 'ManualTasksServices::Linkedin',
	      human_name: 'LinkedIn',
	      type: 'TaskFlowAction'
	    }, {
	      service: 'ManualTasksServices::Phonecall',
	      human_name: 'Ligação',
	      type: 'TaskFlowAction'
	    }, {
	      service: 'ManualTasksServices::Social',
	      human_name: 'Social',
	      type: 'TaskFlowAction'
	    }, {
	      service: 'ManualTasksServices::Meeting',
	      human_name: 'Reunião',
	      type: 'TaskMeeting'
	    }
	  ];
	
	  Task.serviceIcons = {
	    'ManualTasksServices::Email': 'task-icon email-task-icon',
	    'ManualTasksServices::Phonecall': 'task-icon phonecall-task-icon',
	    'ManualTasksServices::Linkedin': 'task-icon linkedin-task-icon',
	    'ManualTasksServices::Social': 'task-icon social-task-icon'
	  };
	
	  Task.prototype.humanStatus = function() {
	    switch (this.voip_call_status) {
	      case "no_connection":
	        return "Sem conexão";
	      case "gatekeeper":
	        return "Gatekeeper";
	      case "opportunity":
	        return "Conectado";
	      case "client":
	        return "Cliente";
	      case "lost":
	        return "Perdido";
	      default:
	        return "Ligar para contato";
	    }
	  };
	
	  Task.manualTaskService = function(service) {
	    var i, len, ref, service_options;
	    ref = this.availableManualTaskServices;
	    for (i = 0, len = ref.length; i < len; i++) {
	      service_options = ref[i];
	      if (service_options.service === service) {
	        return service_options;
	      }
	    }
	    return {
	      service: service,
	      human_name: ''
	    };
	  };
	
	  Task.prototype.formattedDueOn = function() {
	    if (!this.validDueOn()) {
	      return 'Data inválida';
	    }
	    return this.due_on.format('LLL');
	  };
	
	  Task.prototype.validDueOn = function() {
	    return this.due_on && this.due_on.isValid && this.due_on.isValid();
	  };
	
	  Task.prototype.isEmailTask = function() {
	    return this.service === 'ManualTasksServices::Email' && (this.created_by_type === 'FlowAction' || this.created_by_type === 'User');
	  };
	
	  Task.prototype.isMeetingTask = function() {
	    return this.service === 'ManualTasksServices::Meeting';
	  };
	
	  Task.prototype.isSocialTask = function() {
	    return this.service === 'ManualTasksServices::Social';
	  };
	
	  Task.prototype.isLikedinTask = function() {
	    return this.service === 'ManualTasksServices::Linkedin';
	  };
	
	  Task.prototype.isCreatedByUser = function() {
	    return this.created_by_type === 'User';
	  };
	
	  Task.prototype.isDone = function() {
	    return this.done_at && this.done_at.isValid();
	  };
	
	  Task.prototype.isOzzyTask = function() {
	    return this.type === 'OzzyTask';
	  };
	
	  Task.prototype.isOverdue = function() {
	    return !this.isDone() && moment().isAfter(this.due_on);
	  };
	
	  Task.prototype.isDueToday = function() {
	    return this.due_on.isSame(moment(), 'day');
	  };
	
	  Task.prototype.wasOzzyTask = function() {
	    return this.metadata.ozzy;
	  };
	
	  Task.prototype.isScheduled = function() {
	    if (this.metadata && this.metadata.automatic_task_id) {
	      return true;
	    } else {
	      return false;
	    }
	  };
	
	  Task.prototype.markAsDone = function() {
	    if (this.isDone()) {
	      return;
	    }
	    return this.done_at = moment();
	  };
	
	  Task.prototype.toggleDone = function() {
	    if (this.isDone()) {
	      return this.done_at = null;
	    } else {
	      return this.done_at = moment();
	    }
	  };
	
	  Task.prototype.summaryText = function() {
	    if (!this.service) {
	      return '';
	    }
	    return Task.manualTaskService(this.service).human_name;
	  };
	
	  Task.prototype.dueOnText = function() {
	    if (!this.due_on) {
	      return 'Selecione data e hora';
	    }
	    if (!(this.due_on && this.due_on.isValid && this.due_on.isValid())) {
	      return 'Data Inválida';
	    }
	    return (this.due_on.format('LLL')) + " (" + (this.due_on.fromNow()) + ")";
	  };
	
	  Task.prototype.dueOnHour = function() {
	    return moment(this.due_on).format('LT');
	  };
	
	  Task.prototype.doneAtHour = function() {
	    return moment(this.done_at).format('LT');
	  };
	
	  Task.prototype.doneAtDate = function() {
	    return moment(this.done_at).format('L');
	  };
	
	  Task.prototype.dueOnDate = function() {
	    return moment(this.due_on).format('L');
	  };
	
	  Task.prototype.template_or_null = function() {
	    if (Array.isArray(this.template)) {
	      return null;
	    } else {
	      return this.template;
	    }
	  };
	
	  Task.prototype.template_or_new = function() {
	    if (Array.isArray(this.template)) {
	      return new Template({
	        kind: this.templateKind()
	      });
	    } else {
	      return this.template;
	    }
	  };
	
	  Task.prototype.hasVoipCalls = function() {
	    return this.voip_calls_count > 0;
	  };
	
	  Task.prototype.canBeUndone = function() {
	    return (this.isCreatedByUser() || this.wasOzzyTask()) && !this.hasVoipCalls();
	  };
	
	  Task.prototype.templateKind = function() {
	    switch (this.service) {
	      case 'ManualTasksServices::Phonecall':
	        return 'phonecall';
	      case 'ManualTasksServices::Linkedin':
	        return 'linkedin';
	      case 'ManualTasksServices::Social':
	        return 'social';
	      default:
	        return 'email';
	    }
	  };
	
	  return Task;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.TemplateCategory = (function(superClass) {
	  extend(TemplateCategory, superClass);
	
	  function TemplateCategory() {
	    return TemplateCategory.__super__.constructor.apply(this, arguments);
	  }
	
	  TemplateCategory.ATTRIBUTES = {
	    id: {},
	    name: {
	      type: String
	    }
	  };
	
	  return TemplateCategory;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.TwilioSetting = (function(superClass) {
	  extend(TwilioSetting, superClass);
	
	  function TwilioSetting() {
	    return TwilioSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  TwilioSetting.ATTRIBUTES = {
	    id: {},
	    seconds_left: {},
	    caller_id: ''
	  };
	
	  TwilioSetting.SERIALIZABLE_ATTRIBUTES = ['id'];
	
	  TwilioSetting.ASSOCIATIONS = {
	    voip_monthly_plan: function() {
	      return VoipMonthlyPlan;
	    },
	    voip_additional_times: function() {
	      return VoipAdditionalTime;
	    }
	  };
	
	  TwilioSetting.SERIALIZABLE_ASSOCIATIONS = ['voip_monthly_plan', 'voip_additional_times'];
	
	  TwilioSetting.prototype.sum_additional_minutes = function() {
	    if (this.voip_additional_times.length === 0) {
	      return 0;
	    }
	    return (this.voip_additional_times.map(function(m) {
	      return m.seconds_in_minutes();
	    })).reduce(function(a, b) {
	      return a + b;
	    });
	  };
	
	  return TwilioSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.User = (function(superClass) {
	  extend(User, superClass);
	
	  function User() {
	    return User.__super__.constructor.apply(this, arguments);
	  }
	
	  User.ATTRIBUTES = {
	    id: {},
	    name: {},
	    email: {},
	    role: {},
	    human_role: {},
	    authentication_token: {},
	    picture_url: {},
	    signature: {},
	    timezone: {},
	    pipedrive_api_key: {},
	    rd_station_crm_api_key: {},
	    cv_crm_api_token: {},
	    nectar_api_key: {},
	    email_authorized: {},
	    email_service_requires_authorization: {},
	    email_account_status: {},
	    can_manage_templates: {},
	    can_see_all_contacts: {},
	    plivo_endpoint: {},
	    api_token: {},
	    virtual_user_count: {},
	    nylas_setting: {},
	    email_service: {},
	    created_at: {},
	    company_id: {},
	    new_ui: {
	      "default": false
	    },
	    extradata: {
	      "default": {}
	    },
	    default_user: {}
	  };
	
	  User.ASSOCIATIONS = {
	    company: function() {
	      return Company;
	    },
	    salesforce_setting: function() {
	      return SalesforceSetting;
	    },
	    rd_station_setting: function() {
	      return RdStationSetting;
	    },
	    pipedrive_setting: function() {
	      return PipedriveSetting;
	    },
	    rd_station_crm_setting: function() {
	      return RDStationCRMSetting;
	    },
	    crm_setting: function() {
	      return CRMSetting;
	    },
	    nectar_setting: function() {
	      return NectarSetting;
	    },
	    webhook_setting: function() {
	      return WebhookSetting;
	    },
	    vtiger_setting: function() {
	      return VtigerSetting;
	    },
	    hubspot_setting: function() {
	      return HubspotSetting;
	    },
	    sharpspring_setting: function() {
	      return SharpspringSetting;
	    },
	    leadlovers_setting: function() {
	      return LeadloversSetting;
	    },
	    cv_crm_setting: function() {
	      return CvCrmSetting;
	    },
	    flow: function() {
	      return Flow;
	    }
	  };
	
	  User.ROLES = {
	    admin: 0,
	    manager: 1,
	    seller: 2,
	    monitoring_manager: 3,
	    sdr: 4
	  };
	
	  User.SERIALIZABLE_ASSOCIATIONS = ['salesforce_setting', 'rd_station_setting', 'rd_station_crm_setting', 'crm_setting', 'pipedrive_setting', 'nectar_setting', 'vtiger_setting', 'hubspot_setting', 'webhook_setting', 'sharpspring_setting', 'leadlovers_setting', 'cv_crm_setting'];
	
	  User.prototype.firstAndLastName = function() {
	    var first, last, ref;
	    ref = this.name.split(' '), first = ref[0], last = ref[ref.length - 1];
	    if (first !== last) {
	      return first + ' ' + last;
	    } else {
	      return first;
	    }
	  };
	
	  User.prototype.firstName = function() {
	    return this.name.split(' ')[0];
	  };
	
	  User.prototype.isAdmin = function() {
	    return this.role === 'admin';
	  };
	
	  User.prototype.isSeller = function() {
	    return this.role === 'seller' || this.role === 'sdr';
	  };
	
	  User.prototype.isManager = function() {
	    return this.role === 'manager';
	  };
	
	  User.prototype.isMonitoringManager = function() {
	    return this.role === 'monitoring_manager';
	  };
	
	  User.prototype.requireEmailAuthorization = function() {
	    return this.email_service_requires_authorization && !this.email_authorized;
	  };
	
	  User.prototype.requireEmailReauthorization = function() {
	    return this.email_account_status && this.email_account_status !== 'running';
	  };
	
	  User.prototype.manager_and_not_owner = function(object) {
	    return this.isManager() && this.id !== object.user.id;
	  };
	
	  User.prototype.hasMoreAccounts = function() {
	    return this.virtual_user_count > 1;
	  };
	
	  User.prototype.isSparkpost = function() {
	    return this.email_service === 'sparkpost';
	  };
	
	  User.prototype.isNylas = function() {
	    return this.email_service === 'nylas';
	  };
	
	  User.prototype.roleDescription = function() {
	    if (this.role === 'sdr') {
	      return 'SDR';
	    }
	    if (this.role === 'seller') {
	      return 'Executivo de vendas';
	    }
	    if (this.role === 'monitoring_manager') {
	      return 'Gerente de acompanhamento';
	    }
	    if (this.role === 'manager') {
	      return 'Gerente de contas';
	    }
	    return '';
	  };
	
	  User.prototype.selectedLanguage = function() {
	    return this.extradata['language'] || 'pt-BR';
	  };
	
	  return User;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.Variable = (function(superClass) {
	  extend(Variable, superClass);
	
	  function Variable() {
	    return Variable.__super__.constructor.apply(this, arguments);
	  }
	
	  Variable.ATTRIBUTES = {
	    id: {},
	    name: {
	      type: String
	    },
	    placeholder: {
	      type: String
	    },
	    placeholder_name: {
	      type: String
	    },
	    target_method: {
	      type: String
	    }
	  };
	
	  return Variable;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.VoipAdditionalTime = (function(superClass) {
	  extend(VoipAdditionalTime, superClass);
	
	  function VoipAdditionalTime() {
	    return VoipAdditionalTime.__super__.constructor.apply(this, arguments);
	  }
	
	  VoipAdditionalTime.ATTRIBUTES = {
	    id: {},
	    user_id: {},
	    seconds: {},
	    consumed: {}
	  };
	
	  VoipAdditionalTime.SERIALIZABLE_ATTRIBUTES = ['id', 'user_id', 'seconds', 'consumed'];
	
	  VoipAdditionalTime.prototype.consumed_in_minutes = function() {
	    return parseInt((this.consumed || 0) / 60);
	  };
	
	  VoipAdditionalTime.prototype.seconds_in_minutes = function() {
	    return parseInt((this.seconds || 0) / 60);
	  };
	
	  return VoipAdditionalTime;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.VoipCall = (function(superClass) {
	  extend(VoipCall, superClass);
	
	  function VoipCall() {
	    return VoipCall.__super__.constructor.apply(this, arguments);
	  }
	
	  VoipCall.ATTRIBUTES = {
	    id: {},
	    status: {}
	  };
	
	  return VoipCall;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.VoipMonthlyPlan = (function(superClass) {
	  extend(VoipMonthlyPlan, superClass);
	
	  function VoipMonthlyPlan() {
	    return VoipMonthlyPlan.__super__.constructor.apply(this, arguments);
	  }
	
	  VoipMonthlyPlan.ATTRIBUTES = {
	    id: {},
	    consumed: {},
	    additional_consumed: {},
	    max_duration: {}
	  };
	
	  VoipMonthlyPlan.SERIALIZABLE_ATTRIBUTES = ['id', 'consumed', 'additional_consumed', 'max_duration'];
	
	  VoipMonthlyPlan.prototype.max_duration_in_minutes = function() {
	    return parseInt((this.max_duration || 0) / 60);
	  };
	
	  VoipMonthlyPlan.prototype.consumed_in_minutes = function() {
	    return parseInt((this.consumed || 0) / 60);
	  };
	
	  return VoipMonthlyPlan;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.VtigerSetting = (function(superClass) {
	  extend(VtigerSetting, superClass);
	
	  function VtigerSetting() {
	    return VtigerSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  VtigerSetting.ATTRIBUTES = {
	    id: {},
	    url: {},
	    username: {},
	    access_key: {},
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    mark_as: {
	      "default": 0
	    }
	  };
	
	  return VtigerSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var BaseModel,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	BaseModel = __webpack_require__(3);
	
	global.WebhookSetting = (function(superClass) {
	  extend(WebhookSetting, superClass);
	
	  function WebhookSetting() {
	    return WebhookSetting.__super__.constructor.apply(this, arguments);
	  }
	
	  WebhookSetting.ATTRIBUTES = {
	    id: {},
	    url: {},
	    triggers: {
	      "default": {
	        on_created: false,
	        status: ['connected'],
	        stages: []
	      },
	      type: Object
	    },
	    user_change: false
	  };
	
	  return WebhookSetting;
	
	})(BaseModel);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(648);


/***/ }),
/* 648 */
/***/ (function(module, exports) {

	(function() {
	  var findItemAndIndexById, findItemAndIndexByProps, isEqual, isObjectsEqual, matchAllProps;
	  matchAllProps = function(item, props) {
	    var key, prop, value;
	    for (key in props) {
	      value = props[key];
	      prop = item[key];
	      if (prop === void 0 || !isEqual(prop, value)) {
	        return false;
	      }
	    }
	    return true;
	  };
	  findItemAndIndexByProps = function(array, props) {
	    var index, item, j, len;
	    for (index = j = 0, len = array.length; j < len; index = ++j) {
	      item = array[index];
	      if (matchAllProps(item, props)) {
	        return {
	          item: item,
	          index: index
	        };
	      }
	    }
	    return null;
	  };
	  findItemAndIndexById = function(array, id) {
	    return findItemAndIndexByProps(array, {
	      id: id
	    });
	  };
	  Array.prototype._find = Array.prototype.find;
	  isEqual = function(prop, value) {
	    if (prop === value) {
	      return true;
	    }
	    if (prop instanceof Object && value instanceof Object) {
	      return isObjectsEqual(prop, value);
	    }
	    return false;
	  };
	  isObjectsEqual = function(prop, value) {
	    return JSON.stringify(prop) === JSON.stringify(value);
	  };
	  Array.prototype.find = function(query) {
	    switch (typeof query) {
	      case 'number':
	        return this._find(function(i) {
	          return i.id === query;
	        });
	      case 'object':
	        return findItemAndIndexByProps(this, query);
	      default:
	        return this._find(query);
	    }
	  };
	  Array.prototype.findIndex = function(query) {
	    var result;
	    result = (function() {
	      switch (typeof query) {
	        case 'number':
	          return findItemAndIndexById(this, query);
	        default:
	          return findItemAndIndexByProps(this, query);
	      }
	    }).call(this);
	    if (result) {
	      return result.index;
	    }
	    return -1;
	  };
	  Array.prototype.remove = function(query) {
	    var result;
	    result = (function() {
	      switch (typeof query) {
	        case 'number':
	          return findItemAndIndexById(this, query);
	        default:
	          return findItemAndIndexByProps(this, query);
	      }
	    }).call(this);
	    if (result) {
	      this.splice(result.index, 1);
	      return true;
	    }
	  };
	  Array.prototype.replaceById = function(object) {
	    var index;
	    index = this.findIndex(object.id);
	    if (index >= 0) {
	      return this.splice(index, 1, object);
	    }
	  };
	  Array.prototype.findWithIndexByProps = function(props) {
	    if (props == null) {
	      props = {};
	    }
	    return findItemAndIndexByProps(this, props);
	  };
	  Array.prototype.removeByProps = function(props) {
	    var result;
	    if (props == null) {
	      props = {};
	    }
	    result = this.findWithIndexByProps(props);
	    if (result) {
	      return this.splice(result.index, 1);
	    }
	  };
	  Array.prototype.findByProps = function(props) {
	    var result;
	    if (props == null) {
	      props = {};
	    }
	    result = this.findWithIndexByProps(props);
	    if (result) {
	      return result.item;
	    }
	  };
	  Array.prototype.findIndexByProps = function(props) {
	    var result;
	    if (props == null) {
	      props = {};
	    }
	    result = this.findWithIndexByProps(props);
	    if (result) {
	      return result.index;
	    }
	    return -1;
	  };
	  Array.prototype.last = function() {
	    return this[this.length - 1];
	  };
	  return Array.prototype.sortByKey = function(key) {
	    return this.sort(function(a, b) {
	      if (a[key] < b[key]) {
	        return -1;
	      } else if (a[key] > b[key]) {
	        return 1;
	      } else {
	        return 0;
	      }
	    });
	  };
	})();


/***/ }),
/* 649 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {global.ResourceBase = (function() {
	  function ResourceBase() {}
	
	  ResourceBase.prototype.collectionSuccess = function(callback) {
	    return (function(_this) {
	      return function(response) {
	        var collection, resource_attributes, result;
	        collection = (function() {
	          var j, len, ref, results;
	          ref = response.body[this.constructor.PLURAL_RESOURCE_NAME];
	          results = [];
	          for (j = 0, len = ref.length; j < len; j++) {
	            resource_attributes = ref[j];
	            results.push(new this.constructor.MODEL(resource_attributes));
	          }
	          return results;
	        }).call(_this);
	        result = {};
	        result[_this.constructor.PLURAL_RESOURCE_NAME] = collection;
	        if (response.body.meta) {
	          result['meta'] = response.body.meta;
	        }
	        return callback(result, response);
	      };
	    })(this);
	  };
	
	  ResourceBase.prototype.collectionFailure = function(callback) {
	    return function(response) {
	      if (callback) {
	        return callback(response);
	      }
	    };
	  };
	
	  ResourceBase.prototype.memberCopy = function(callback) {
	    return (function(_this) {
	      return function(response) {
	        var attributes, group, i, j, len, model, result;
	        if (!callback) {
	          return;
	        }
	        group = [];
	        result = {};
	        attributes = response.body[_this.constructor.PLURAL_RESOURCE_NAME];
	        if (attributes.length > 1) {
	          for (j = 0, len = attributes.length; j < len; j++) {
	            i = attributes[j];
	            model = new _this.constructor.MODEL(i);
	            group.push(model);
	          }
	        } else {
	          model = new _this.constructor.MODEL(attributes[0]);
	          group.push(model);
	        }
	        return callback(group, response);
	      };
	    })(this);
	  };
	
	  ResourceBase.prototype.memberSuccess = function(callback) {
	    return (function(_this) {
	      return function(response) {
	        var attributes, model, result;
	        if (!callback) {
	          return;
	        }
	        attributes = response.body[_this.constructor.SINGULAR_RESOURCE_NAME];
	        model = new _this.constructor.MODEL(attributes);
	        result = {};
	        result[_this.constructor.SINGULAR_RESOURCE_NAME] = model;
	        return callback(result, response);
	      };
	    })(this);
	  };
	
	  ResourceBase.prototype.memberProperty = function(callback) {
	    return (function(_this) {
	      return function(response) {
	        var group, i, j, len, model, result;
	        if (!callback) {
	          return;
	        }
	        group = [];
	        result = response.body[_this.constructor.PLURAL_RESOURCE_NAME];
	        if (result !== void 0) {
	          for (j = 0, len = result.length; j < len; j++) {
	            i = result[j];
	            model = new _this.constructor.MODEL(i);
	            group.push(model);
	          }
	        } else {
	          group = [];
	        }
	        return callback(group, response);
	      };
	    })(this);
	  };
	
	  ResourceBase.prototype.getParamsId = function(params) {
	    if (params instanceof FormData) {
	      return params.get('id');
	    } else {
	      return params.id;
	    }
	  };
	
	  ResourceBase.prototype.save = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    if (this.getParamsId(params)) {
	      return this.update(success, failure, params);
	    } else {
	      return this.create(success, failure, params);
	    }
	  };
	
	  return ResourceBase;

	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.BusinessesResource = (function(superClass) {
	  extend(BusinessesResource, superClass);
	
	  BusinessesResource.MODEL = Business;
	
	  BusinessesResource.SINGULAR_RESOURCE_NAME = 'business';
	
	  BusinessesResource.PLURAL_RESOURCE_NAME = 'businesses';
	
	  function BusinessesResource(company_id) {
	    this.company_id = company_id;
	  }
	
	  BusinessesResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + this.company_id + "/businesses", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  BusinessesResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/businesses/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  BusinessesResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/businesses/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  BusinessesResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/businesses", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  BusinessesResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/businesses/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return BusinessesResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.CarouselResource = (function(superClass) {
	  extend(CarouselResource, superClass);
	
	  function CarouselResource() {
	    return CarouselResource.__super__.constructor.apply(this, arguments);
	  }
	
	  CarouselResource.MODEL = Carousel;
	
	  CarouselResource.SINGULAR_RESOURCE_NAME = 'carousel';
	
	  CarouselResource.PLURAL_RESOURCE_NAME = 'carousels';
	
	  CarouselResource.prototype.create_or_update = function(success, failure, params) {
	    return api.post('/carousels/create_or_update', params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CarouselResource.prototype.show = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get('/carousels', params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  return CarouselResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.CarouselPropertyResource = (function(superClass) {
	  extend(CarouselPropertyResource, superClass);
	
	  function CarouselPropertyResource() {
	    return CarouselPropertyResource.__super__.constructor.apply(this, arguments);
	  }
	
	  CarouselPropertyResource.MODEL = Carousel;
	
	  CarouselPropertyResource.SINGULAR_RESOURCE_NAME = 'carousel_by_property';
	
	  CarouselPropertyResource.PLURAL_RESOURCE_NAME = 'carousel_by_properties';
	
	  CarouselPropertyResource.prototype.create_or_update = function(success, failure, params) {
	    return api.post('/carousels/create_or_update', params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CarouselPropertyResource.prototype.copy = function(success, failure, params) {
	    return api.post('/carousels/copy', params, {
	      success: this.memberCopy(success),
	      failure: failure
	    });
	  };
	
	  CarouselPropertyResource.prototype.show = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get('/carousels', params, {
	      success: this.memberProperty(success),
	      failure: failure
	    });
	  };
	
	  return CarouselPropertyResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.CommentEventsResource = (function(superClass) {
	  extend(CommentEventsResource, superClass);
	
	  CommentEventsResource.MODEL = ContactEvent;
	
	  CommentEventsResource.SINGULAR_RESOURCE_NAME = 'event';
	
	  CommentEventsResource.PLURAL_RESOURCE_NAME = 'events';
	
	  function CommentEventsResource(contact_id) {
	    this.contact_id = contact_id;
	  }
	
	  CommentEventsResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/contacts/" + this.contact_id + "/comment_events", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CommentEventsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/contacts/" + this.contact_id + "/comment_events/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CommentEventsResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/contacts/" + this.contact_id + "/comment_events/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return CommentEventsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.CompaniesResource = (function(superClass) {
	  extend(CompaniesResource, superClass);
	
	  function CompaniesResource() {
	    return CompaniesResource.__super__.constructor.apply(this, arguments);
	  }
	
	  CompaniesResource.MODEL = Company;
	
	  CompaniesResource.SINGULAR_RESOURCE_NAME = 'company';
	
	  CompaniesResource.PLURAL_RESOURCE_NAME = 'companies';
	
	  CompaniesResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  CompaniesResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CompaniesResource.prototype.verify = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + (this.getParamsId(params)) + "/verify", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CompaniesResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CompaniesResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/companies/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  return CompaniesResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.ContactEventsResource = (function(superClass) {
	  extend(ContactEventsResource, superClass);
	
	  ContactEventsResource.MODEL = ContactEvent;
	
	  ContactEventsResource.SINGULAR_RESOURCE_NAME = 'event';
	
	  ContactEventsResource.PLURAL_RESOURCE_NAME = 'events';
	
	  function ContactEventsResource(contact_id) {
	    this.contact_id = contact_id;
	  }
	
	  ContactEventsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/contacts/" + this.contact_id + "/events", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactEventsResource.prototype.resendEmail = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/events/" + params.event.id + "/resend_reply_email", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactEventsResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/contacts/" + this.contact_id + "/comment_events", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactEventsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/contacts/" + this.contact_id + "/comment_events/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactEventsResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/contacts/" + this.contact_id + "/comment_events/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return ContactEventsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.ContactGroupsResource = (function(superClass) {
	  extend(ContactGroupsResource, superClass);
	
	  ContactGroupsResource.MODEL = ContactGroup;
	
	  ContactGroupsResource.SINGULAR_RESOURCE_NAME = 'contact_group';
	
	  ContactGroupsResource.PLURAL_RESOURCE_NAME = 'contact_groups';
	
	  function ContactGroupsResource(company_id) {
	    this.company_id = company_id;
	  }
	
	  ContactGroupsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + this.company_id + "/contact_groups", params, {
	      success: this.collectionSuccess(success),
	      failure: this.collectionFailure(failure)
	    });
	  };
	
	  ContactGroupsResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/contact_groups/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactGroupsResource.prototype.post = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/contact_groups", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactGroupsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/contact_groups/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactGroupsResource.prototype["import"] = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/contact_groups/import", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactGroupsResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/contact_groups/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return ContactGroupsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.ContactSpecificTemplatesResource = (function(superClass) {
	  extend(ContactSpecificTemplatesResource, superClass);
	
	  ContactSpecificTemplatesResource.MODEL = ContactSpecificTemplate;
	
	  ContactSpecificTemplatesResource.SINGULAR_RESOURCE_NAME = 'template';
	
	  ContactSpecificTemplatesResource.PLURAL_RESOURCE_NAME = 'templates';
	
	  function ContactSpecificTemplatesResource(company_id, flow_id) {
	    this.company_id = company_id;
	    this.flow_id = flow_id;
	  }
	
	  ContactSpecificTemplatesResource.prototype.basePath = function() {
	    return "/flows/" + this.flow_id + "/contact_specific_templates";
	  };
	
	  ContactSpecificTemplatesResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get(this.basePath(), params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  return ContactSpecificTemplatesResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.ContactTasksResource = (function(superClass) {
	  extend(ContactTasksResource, superClass);
	
	  ContactTasksResource.MODEL = Task;
	
	  ContactTasksResource.SINGULAR_RESOURCE_NAME = 'task';
	
	  ContactTasksResource.PLURAL_RESOURCE_NAME = 'tasks';
	
	  function ContactTasksResource(contact_id) {
	    this.contact_id = contact_id;
	  }
	
	  ContactTasksResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/contacts/" + this.contact_id + "/tasks", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  return ContactTasksResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.ContactsResource = (function(superClass) {
	  extend(ContactsResource, superClass);
	
	  ContactsResource.MODEL = Contact;
	
	  ContactsResource.SINGULAR_RESOURCE_NAME = 'contact';
	
	  ContactsResource.PLURAL_RESOURCE_NAME = 'contacts';
	
	  function ContactsResource(company_id) {
	    this.company_id = company_id;
	  }
	
	  ContactsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + this.company_id + "/contacts", params, {
	      success: this.collectionSuccess(success),
	      failure: this.collectionFailure(failure)
	    });
	  };
	
	  ContactsResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/contacts/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.summary = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/contacts/" + (this.getParamsId(params)) + "/summary", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/contacts/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.updateRecipient = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/contacts/" + params.contact_id + "/recipients/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.resetRecipient = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/contacts/" + params.contact_id + "/recipients/" + (this.getParamsId(params)) + "/reset", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.eligibleForANewFlow = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + this.company_id + "/contacts?q[eligible_for_a_new_flow]=1", params, {
	      success: this.collectionSuccess(success),
	      failure: this.collectionFailure(failure)
	    });
	  };
	
	  ContactsResource.prototype.lastActiveOnFlow = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + this.company_id + "/contacts?q[last_active_on_flow]=" + params.flow_id, params, {
	      success: this.collectionSuccess(success),
	      failure: this.collectionFailure(failure)
	    });
	  };
	
	  ContactsResource.prototype.withoutGroup = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + this.company_id + "/contacts?q[without_group]=1", params, {
	      success: this.collectionSuccess(success),
	      failure: this.collectionFailure(failure)
	    });
	  };
	
	  ContactsResource.prototype["import"] = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/contacts/import", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.importCsv = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/contacts/import_csv", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.validateImport = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/contacts/validate_import", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/contacts/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.massActionPrepare = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/contacts/mass_actions/prepare", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.massActionExecute = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/contacts/mass_actions/execute", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.removeFromFlow = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/contacts/" + (this.getParamsId(params)) + "/remove_from_flow", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.groupContacts = function(success, failure, params) {
	    var contact_group_id;
	    if (params == null) {
	      params = {};
	    }
	    contact_group_id = params.params.contact_group_id;
	    delete params['contact_group_id'];
	    return api.get("/contact_groups/" + contact_group_id + "/contacts", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype["export"] = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/contacts/export", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ContactsResource.prototype.reengage = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/contacts/" + (this.getParamsId(params)) + "/reengage", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  return ContactsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.CustomFieldsResource = (function(superClass) {
	  extend(CustomFieldsResource, superClass);
	
	  function CustomFieldsResource() {
	    return CustomFieldsResource.__super__.constructor.apply(this, arguments);
	  }
	
	  CustomFieldsResource.MODEL = CustomField;
	
	  CustomFieldsResource.SINGULAR_RESOURCE_NAME = 'custom_field';
	
	  CustomFieldsResource.PLURAL_RESOURCE_NAME = 'custom_fields';
	
	  CustomFieldsResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/custom_fields", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CustomFieldsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/custom_fields", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  CustomFieldsResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/custom_fields/" + (this.getParamsId(params)), {}, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CustomFieldsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/custom_fields/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  CustomFieldsResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/custom_fields/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return CustomFieldsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.FlowsResource = (function(superClass) {
	  extend(FlowsResource, superClass);
	
	  FlowsResource.MODEL = Flow;
	
	  FlowsResource.SINGULAR_RESOURCE_NAME = 'flow';
	
	  FlowsResource.PLURAL_RESOURCE_NAME = 'flows';
	
	  function FlowsResource(company_id) {
	    this.company_id = company_id;
	  }
	
	  FlowsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + this.company_id + "/flows", params, {
	      success: this.collectionSuccess(success),
	      failure: this.collectionFailure(failure)
	    });
	  };
	
	  FlowsResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/flows", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  FlowsResource.prototype.retry = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/flows/" + (this.getParamsId(params)) + "/retry", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  FlowsResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/flows/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  FlowsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/flows/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  FlowsResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/flows/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  FlowsResource.prototype.flow_reports = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    console.log(params);
	    return api.get("/flows/" + (this.getParamsId(params.params)) + "/flow_reports", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  FlowsResource.prototype.memberSuccess = function(callback) {
	    return (function(_this) {
	      return function(response) {
	        var flow_attributes;
	        if (!callback) {
	          return;
	        }
	        flow_attributes = _this.cleanUpMemberResponseBody(response.body.flow);
	        return callback({
	          flow: new Flow(flow_attributes)
	        });
	      };
	    })(this);
	  };
	
	  FlowsResource.prototype.collectionSuccess = function(callback) {
	    return (function(_this) {
	      return function(response) {
	        var flow_attributes, flows;
	        if (!callback) {
	          return;
	        }
	        flows = (function() {
	          var i, len, ref, results;
	          ref = this.cleanUpCollectionResponseBody(response.body.flows);
	          results = [];
	          for (i = 0, len = ref.length; i < len; i++) {
	            flow_attributes = ref[i];
	            results.push(new Flow(flow_attributes));
	          }
	          return results;
	        }).call(_this);
	        return callback({
	          flows: flows,
	          meta: response.body.meta
	        });
	      };
	    })(this);
	  };
	
	  FlowsResource.prototype.collectionFailure = function(failure_callback) {
	    return function(response) {
	      if (failure_callback) {
	        return failure_callback(response);
	      }
	    };
	  };
	
	  FlowsResource.prototype.cleanUpMemberResponseBody = function(flow_attributes) {
	    var contact_attributes, recipient, recipients;
	    recipients = flow_attributes.recipients || [];
	    delete flow_attributes.recipients;
	    flow_attributes.contacts = (function() {
	      var i, len, results;
	      results = [];
	      for (i = 0, len = recipients.length; i < len; i++) {
	        recipient = recipients[i];
	        delete recipient.contact.flow;
	        contact_attributes = recipient.contact;
	        delete recipient.contact;
	        contact_attributes.recipient = recipient;
	        results.push(contact_attributes);
	      }
	      return results;
	    })();
	    return flow_attributes;
	  };
	
	  FlowsResource.prototype.cleanUpCollectionResponseBody = function(flows_attributes) {
	    var flow_attributes, i, len, results;
	    results = [];
	    for (i = 0, len = flows_attributes.length; i < len; i++) {
	      flow_attributes = flows_attributes[i];
	      results.push(this.cleanUpMemberResponseBody(flow_attributes));
	    }
	    return results;
	  };
	
	  FlowsResource.prototype.reengage = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/flows/" + (this.getParamsId(params)) + "/reengage", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  return FlowsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.IntegrationsResource = (function(superClass) {
	  extend(IntegrationsResource, superClass);
	
	  function IntegrationsResource() {
	    return IntegrationsResource.__super__.constructor.apply(this, arguments);
	  }
	
	  IntegrationsResource.authorize_salesforce = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post('/integrations/authorize_salesforce', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  IntegrationsResource.authorize_hubspot = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post('/integrations/authorize_hubspot', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  IntegrationsResource.authorize_rdstation = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post('/integrations/authorize_rdstation', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  IntegrationsResource.authorize_nylas = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post('/integrations/authorize_nylas', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  IntegrationsResource.s3PresignedUrl = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get('/integrations/s3_presigned_url', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return IntegrationsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.LostReasonsResource = (function(superClass) {
	  extend(LostReasonsResource, superClass);
	
	  function LostReasonsResource() {
	    return LostReasonsResource.__super__.constructor.apply(this, arguments);
	  }
	
	  LostReasonsResource.MODEL = LostReason;
	
	  LostReasonsResource.SINGULAR_RESOURCE_NAME = 'lost_reason';
	
	  LostReasonsResource.PLURAL_RESOURCE_NAME = 'lost_reasons';
	
	  LostReasonsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/lost_reasons", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  LostReasonsResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/lost_reasons", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  LostReasonsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/lost_reasons/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  LostReasonsResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/lost_reasons/" + (this.getParamsId(params)), {}, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return LostReasonsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.MeetingTypesResource = (function(superClass) {
	  extend(MeetingTypesResource, superClass);
	
	  function MeetingTypesResource() {
	    return MeetingTypesResource.__super__.constructor.apply(this, arguments);
	  }
	
	  MeetingTypesResource.MODEL = MeetingType;
	
	  MeetingTypesResource.SINGULAR_RESOURCE_NAME = 'meeting_type';
	
	  MeetingTypesResource.PLURAL_RESOURCE_NAME = 'meeting_types';
	
	  MeetingTypesResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/meeting_types", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  MeetingTypesResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/meeting_types", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  MeetingTypesResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/meeting_types/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  MeetingTypesResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/meeting_types/" + (this.getParamsId(params)), {}, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return MeetingTypesResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.NotificationsResource = (function(superClass) {
	  extend(NotificationsResource, superClass);
	
	  function NotificationsResource() {
	    return NotificationsResource.__super__.constructor.apply(this, arguments);
	  }
	
	  NotificationsResource.MODEL = Notification;
	
	  NotificationsResource.SINGULAR_RESOURCE_NAME = 'notification';
	
	  NotificationsResource.PLURAL_RESOURCE_NAME = 'notifications';
	
	  NotificationsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/notifications", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  NotificationsResource.prototype.read = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/notifications/" + (this.getParamsId(params)) + "/read", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  NotificationsResource.prototype.readAll = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/notifications/read", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return NotificationsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.ReportsResource = (function(superClass) {
	  extend(ReportsResource, superClass);
	
	  function ReportsResource(company_id) {
	    this.company_id = company_id;
	  }
	
	  ReportsResource.prototype.basePath = function() {
	    return "/companies/" + this.company_id + "/reports";
	  };
	
	  ReportsResource.prototype.opportunityLost = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get((this.basePath()) + "/opportunity_lost", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ReportsResource.prototype.countTasks = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get((this.basePath()) + "/count_tasks", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ReportsResource.prototype.liveFeedEvents = function(success, failure, params) {
	    var success_callback;
	    if (params == null) {
	      params = {};
	    }
	    success_callback = new ContactEventsResource().collectionSuccess(success);
	    return api.get((this.basePath()) + "/live_feed_events", params, {
	      success: success_callback,
	      failure: failure
	    });
	  };
	
	  ReportsResource.prototype.funnel = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get((this.basePath()) + "/funnel", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  ReportsResource.prototype.topStatisticable = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get((this.basePath()) + "/top_statisticable", params, {
	      success: this.topStatisticableSuccessCallback(success),
	      failure: failure
	    });
	  };
	
	  ReportsResource.prototype.topStatisticableSuccessCallback = function(success) {
	    return (function(_this) {
	      return function(data) {
	        if (data.body.flows) {
	          return new FlowsResource().collectionSuccess(success)(data);
	        } else if (data.body.templates) {
	          return new TemplatesResource().collectionSuccess(success)(data);
	        } else {
	          return success(data);
	        }
	      };
	    })(this);
	  };
	
	  ReportsResource.prototype.groupedDoneTasks = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get((this.basePath()) + "/grouped_done_tasks", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return ReportsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.TagsResource = (function(superClass) {
	  extend(TagsResource, superClass);
	
	  function TagsResource() {
	    return TagsResource.__super__.constructor.apply(this, arguments);
	  }
	
	  TagsResource.MODEL = Tag;
	
	  TagsResource.SINGULAR_RESOURCE_NAME = 'tag';
	
	  TagsResource.PLURAL_RESOURCE_NAME = 'tags';
	
	  TagsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/tags", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  TagsResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/tags", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TagsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/tags/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TagsResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/tags/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return TagsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.TasksResource = (function(superClass) {
	  extend(TasksResource, superClass);
	
	  function TasksResource() {
	    return TasksResource.__super__.constructor.apply(this, arguments);
	  }
	
	  TasksResource.MODEL = Task;
	
	  TasksResource.SINGULAR_RESOURCE_NAME = 'task';
	
	  TasksResource.PLURAL_RESOURCE_NAME = 'tasks';
	
	  TasksResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/tasks", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  TasksResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/tasks", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TasksResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/tasks/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TasksResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/tasks/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  TasksResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/tasks/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TasksResource.prototype.save_template_and_send_email = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/tasks/" + (this.getParamsId(params)) + "/save_template_and_send_email", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  TasksResource.prototype.only_send_email = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/tasks/only_send_email", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TasksResource.prototype.schedule = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/tasks/schedule", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  return TasksResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.TemplateCategoriesResource = (function(superClass) {
	  extend(TemplateCategoriesResource, superClass);
	
	  TemplateCategoriesResource.MODEL = TemplateCategory;
	
	  TemplateCategoriesResource.SINGULAR_RESOURCE_NAME = 'template_category';
	
	  TemplateCategoriesResource.PLURAL_RESOURCE_NAME = 'template_categories';
	
	  function TemplateCategoriesResource(company_id) {
	    this.company_id = company_id;
	  }
	
	  TemplateCategoriesResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/companies/" + this.company_id + "/template_categories", params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  TemplateCategoriesResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/template_categories/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TemplateCategoriesResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post("/companies/" + this.company_id + "/template_categories", params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TemplateCategoriesResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/template_categories/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return TemplateCategoriesResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.TemplatesResource = (function(superClass) {
	  extend(TemplatesResource, superClass);
	
	  TemplatesResource.MODEL = Template;
	
	  TemplatesResource.SINGULAR_RESOURCE_NAME = 'template';
	
	  TemplatesResource.PLURAL_RESOURCE_NAME = 'templates';
	
	  function TemplatesResource(company_id) {
	    this.company_id = company_id;
	  }
	
	  TemplatesResource.prototype.basePath = function() {
	    return "/companies/" + this.company_id + "/templates";
	  };
	
	  TemplatesResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get(this.basePath(), params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  TemplatesResource.prototype.create = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post(this.basePath(), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  TemplatesResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/templates/" + (this.getParamsId(params)), {}, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TemplatesResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/templates/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  TemplatesResource.prototype.destroy = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api["delete"]("/templates/" + (this.getParamsId(params)), {}, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  TemplatesResource.prototype.validate = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post(this.basePath() + "/validate", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return TemplatesResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.UsersResource = (function(superClass) {
	  extend(UsersResource, superClass);
	
	  function UsersResource() {
	    this.loginSuccess = bind(this.loginSuccess, this);
	    return UsersResource.__super__.constructor.apply(this, arguments);
	  }
	
	  UsersResource.MODEL = User;
	
	  UsersResource.SINGULAR_RESOURCE_NAME = 'user';
	
	  UsersResource.PLURAL_RESOURCE_NAME = 'users';
	
	  UsersResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get('/users', params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.searchAccount = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get('/users/search_account', params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.inviteUser = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.post('/users/invitation', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.resendInviteUser = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put('/users/invitation/resend', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.timezones = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get('/users/timezones', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.get = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get("/users/" + (this.getParamsId(params)), {}, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.update = function(success, failure, params) {
	    return api.put("/users/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.resetPassword = function(success, failure, params) {
	    return api.put('/users/password', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.changePassword = function(success, failure, params) {
	    return api.put('/users/password/change', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.recoverPassword = function(success, failure, params) {
	    return api.post('/users/password', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.login = function(success, failure, params) {
	    return api.post('/users/sign_in', params, {
	      success: this.loginSuccess(success),
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.reloadSession = function(callback, params) {
	    return api.get("/users/" + (this.getParamsId(params)), {}, {
	      success: this.loginSuccess(callback),
	      failure: callback
	    });
	  };
	
	  UsersResource.prototype.loginSuccess = function(success_callback) {
	    return (function(_this) {
	      return function(response) {
	        Session.signIn(response.body.user);
	        if (window.parent) {
	          window.parent.postMessage({
	            type: "created"
	          }, "*");
	        }
	        if (success_callback) {
	          return success_callback(response);
	        }
	      };
	    })(this);
	  };
	
	  UsersResource.prototype.activateInvitedUser = function(success, failure, params) {
	    return api.put('/users/invitation', params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  UsersResource.prototype.destroy = function(success, failure, params) {
	    return api["delete"]("/users/" + (this.getParamsId(params)), params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  return UsersResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.VariableResource = (function(superClass) {
	  extend(VariableResource, superClass);
	
	  function VariableResource() {
	    return VariableResource.__super__.constructor.apply(this, arguments);
	  }
	
	  VariableResource.MODEL = Variable;
	
	  VariableResource.SINGULAR_RESOURCE_NAME = 'variable';
	
	  VariableResource.PLURAL_RESOURCE_NAME = 'variables';
	
	  VariableResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.get('/variables', params, {
	      success: this.collectionSuccess(success),
	      failure: failure
	    });
	  };
	
	  return VariableResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var api,
	  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
	  hasProp = {}.hasOwnProperty;
	
	api = __webpack_require__(4).api();
	
	global.VoipCallsResource = (function(superClass) {
	  extend(VoipCallsResource, superClass);
	
	  VoipCallsResource.MODEL = VoipCall;
	
	  VoipCallsResource.SINGULAR_RESOURCE_NAME = 'voiCall';
	
	  VoipCallsResource.PLURAL_RESOURCE_NAME = 'voipCalls';
	
	  function VoipCallsResource(company_id) {
	    this.company_id = company_id;
	  }
	
	  VoipCallsResource.prototype.index = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    params = JSON.parse(JSON.stringify(params));
	    return api.get("/companies/" + this.company_id + "/voip_calls", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  VoipCallsResource.prototype.summary = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    params = JSON.parse(JSON.stringify(params));
	    return api.get("/companies/" + this.company_id + "/voip_calls/summary", params, {
	      success: success,
	      failure: failure
	    });
	  };
	
	  VoipCallsResource.prototype.update = function(success, failure, params) {
	    if (params == null) {
	      params = {};
	    }
	    return api.put("/voip_calls/" + (this.getParamsId(params)), params, {
	      success: this.memberSuccess(success),
	      failure: failure
	    });
	  };
	
	  return VoipCallsResource;
	
	})(ResourceBase);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 674 */
/***/ (function(module, exports) {

	(function($) {
	  $.fn.linedtextarea = function(options) {
	    var fillOutLines, opts;
	    opts = $.extend({}, $.fn.linedtextarea.defaults, options);
	
	    /*
	     * Helper function to make sure the line numbers are always
	     * kept up to the current system
	     */
	    fillOutLines = function(codeLines, h, lineNo) {
	      var totalLines;
	      totalLines = 0;
	      while (totalLines <= h) {
	        if (lineNo === opts.selectedLine) {
	          codeLines.append('<div class=\'lineno lineselect\'>' + lineNo + '</div>');
	        } else {
	          codeLines.append('<div class=\'lineno\'>' + lineNo + '</div>');
	        }
	        lineNo++;
	        totalLines += 15;
	      }
	      return lineNo;
	    };
	
	    /*
	     * Iterate through each of the elements are to be applied to
	     */
	    return this.each(function() {
	      var codeLinesDiv, fontSize, lineNo, linedTextAreaDiv, linedWrapDiv, linesDiv, originalTextAreaWidth, paddingHorizontal, position, sidebarWidth, textarea, textareaDiffWidth;
	      lineNo = 1;
	      textarea = $(this);
	
	      /* Turn off the wrapping of as we don't want to screw up the line numbers */
	      textarea.attr('wrap', 'off');
	      textarea.css({
	        resize: 'none'
	      });
	      originalTextAreaWidth = textarea.outerWidth();
	
	      /* Wrap the text area in the elements we need */
	      textarea.wrap('<div class=\'linedtextarea\'></div>');
	      linedTextAreaDiv = textarea.parent().wrap('<div class=\'linedwrap\' style=\'width: 100%\'></div>');
	      linedWrapDiv = linedTextAreaDiv.parent();
	      linedWrapDiv.prepend('<div class=\'lines\' style=\'width:50px\'></div>');
	      linesDiv = linedWrapDiv.find('.lines');
	      linesDiv.height(textarea.height() + 6);
	
	      /* Draw the number bar; filling it out where necessary */
	      linesDiv.append('<div class=\'codelines\'></div>');
	      codeLinesDiv = linesDiv.find('.codelines');
	      lineNo = fillOutLines(codeLinesDiv, linesDiv.height(), 1);
	
	      /* Move the textarea to the selected line */
	      if (opts.selectedLine !== -1 && !isNaN(opts.selectedLine)) {
	        fontSize = parseInt(textarea.height() / (lineNo - 2));
	        position = parseInt(fontSize * opts.selectedLine) - (textarea.height() / 2);
	        textarea[0].scrollTop = position;
	      }
	
	      /* Set the width */
	      sidebarWidth = linesDiv.outerWidth();
	      paddingHorizontal = parseInt(linedWrapDiv.css('border-left-width')) + parseInt(linedWrapDiv.css('border-right-width')) + parseInt(linedWrapDiv.css('padding-left')) + parseInt(linedWrapDiv.css('padding-right'));
	      textareaDiffWidth = sidebarWidth + paddingHorizontal + 20;
	      textarea.width("calc(100% - " + textareaDiffWidth + "px)");
	      linedWrapDiv.width("calc(100% - " + paddingHorizontal + "px)");
	
	      /* React to the scroll event */
	      textarea.scroll(function(tn) {
	        var clientHeight, domTextArea, scrollTop;
	        domTextArea = $(this)[0];
	        scrollTop = domTextArea.scrollTop;
	        clientHeight = domTextArea.clientHeight;
	        codeLinesDiv.css({
	          'margin-top': -1 * scrollTop + 'px'
	        });
	        lineNo = fillOutLines(codeLinesDiv, scrollTop + clientHeight, lineNo);
	      });
	
	      /* Should the textarea get resized outside of our control */
	      textarea.resize(function(tn) {
	        var domTextArea;
	        domTextArea = $(this)[0];
	        linesDiv.height(domTextArea.clientHeight + 6);
	      });
	    });
	  };
	  $.fn.linedtextarea.defaults = {
	    selectedLine: -1,
	    selectedClass: 'lineselect'
	  };
	})(jQuery);


/***/ }),
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 721 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 723 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 724 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 728 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 732 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 735 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 738 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 744 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 752 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 753 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 755 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 756 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 758 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 763 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 764 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 766 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 769 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 772 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 776 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 778 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 779 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 780 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 781 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 785 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 786 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 788 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 790 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 793 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 795 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 797 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 798 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 799 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 800 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 801 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 802 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 804 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 806 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 808 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 809 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 811 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 813 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 888 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 899 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 906 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	module.exports = {"version":"2021e","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Pacific/Port_Moresby|+10|-a0|0||25e4","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1zc0 Oo0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 LA0 1C00 Oo0 1C00 LA0 1C00|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1nA0 1200 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 Xc0 1qo0 1200 1qo0 Xc0 1qo0|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|0121212121212121212121212121212121212121212123212321232123212121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|01212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 4q00 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|LMT -1030 -0930 -10|aD.4 au 9u a0|0123232323232323232323232323|-FSdk.U 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Accra","Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Chicago|US/Central","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Atikokan","America/Panama|America/Cayman","America/Panama|America/Coral_Harbour","America/Phoenix|America/Creston","America/Phoenix|US/Arizona","America/Puerto_Rico|America/Anguilla","America/Puerto_Rico|America/Antigua","America/Puerto_Rico|America/Aruba","America/Puerto_Rico|America/Blanc-Sablon","America/Puerto_Rico|America/Curacao","America/Puerto_Rico|America/Dominica","America/Puerto_Rico|America/Grenada","America/Puerto_Rico|America/Guadeloupe","America/Puerto_Rico|America/Kralendijk","America/Puerto_Rico|America/Lower_Princes","America/Puerto_Rico|America/Marigot","America/Puerto_Rico|America/Montserrat","America/Puerto_Rico|America/Port_of_Spain","America/Puerto_Rico|America/St_Barthelemy","America/Puerto_Rico|America/St_Kitts","America/Puerto_Rico|America/St_Lucia","America/Puerto_Rico|America/St_Thomas","America/Puerto_Rico|America/St_Vincent","America/Puerto_Rico|America/Tortola","America/Puerto_Rico|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|America/Nassau","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Antarctica/Syowa","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Enderbury|Pacific/Kanton","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Antarctica/DumontDUrville","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Company Base","linkedContacts":"Linked Contacts"},"subtitle":{},"attributes":{"name":"Name/Domain","address":"Address","status":"Status","stage":"Stage","tag":"Tag","tags":"Tags","contacts":"Contacts","domain":"Domain"},"tooltip":{},"label":{"statusOptions":{"all":"All statuses","active":"Active","bounced":"Bounce","connected":"Connected","uninitialized":"Uninitialized","paused":"Paused","converting":"Pending","scheduled":"Scheduled","interrupted":"Interrupted","blocklisted":"Blocklist","notConnected":"No Connection","disqualified":"Disqualified","inactive":"Inactive"},"stageOptions":{"all":"All stages","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Opportunity","client":"Customer","lost":"Lost"},"details":"Company Details","removeCompany":"Delete company","removeCompanyConfirm":"Do you really want to delete company {name}?","companyRemoveAlert":"Companies with associated contacts cannot be deleted"},"actions":{"new":"New company","contacts":"Contacts","groups":"Groups","companies":"Companies"},"feedback":{"removeSuccess":"Company successfully removed","saveSuccess":"Changes saved successfully","unknownFail":"Unknown error loading company","noDataText":"No more results","errorTitle":"Oops! Something went wrong!"},"filters":{"placeholder":"Search for businesses, contacts, addresses, etc..."}}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

	module.exports = {"attributes":{"name":"Name","domain":"Domain","email":"Email","plan":"Plan","service":"Service","emailDomain":"Email Domain","emailService":"Email Service","companyStatus":"Company status","status":"Status","usersCount":"Number of Users","maxUsersCount":"Maximum number of users","managersCount":"Number of Monitoring Managers.","maxManagersCount":"Maximum number of monitoring managers.","voip":"VoIP","usedMinutes":"Used Minutes","paidMinutes":"Paid Minutes","paidMinutesUsedOnMonth":"Paid minutes used in the month","usedContacts":"Used Contacts","paidContacts":"Paid Contacts","paidContactsUsedOnMonth":"Paid contacts used on month","additionalMinutes":"Additional Minutes","additionalContacts":"Additional Contacts"},"label":{"activeCompany":"Active","pausedCompany":"Paused"},"actions":{"create":"Register Company","search":"Search Company","update":"Update Company"},"feedback":{"serviceSaved":"Successfully saved","created":"Company successfully registered","updated":"Company successfully updated","domainWarning":"Queried but not yet verified","consummedMinutes":" - #{@additional.consumed_in_minutes()} minutes consumed","contactsExceeded":"The number of existing users exceeds the maximum number of the chosen plan! Modifications are required to change the plan!"}}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Contacts","singular":"Contact"},"subtitle":{},"attributes":{"name":"Name","email":"email","password":"password","password_confirmation":"repeat password","current_password":"current password","reset_password_token":"token","subject":"subject","body":"content","template_category_id":"category","company_id":"company","first_name":"name","last_name":"surname","business":"company","business_name":"business name","position":"position","telephone":"telephone","cellphone":"cellular","address":"address","domain":"domain","city":"city","state":"state","country":"country","contact_group":"group","role":"role","timezone":"timezone","pipedrive_api_key":"Pipedrive API KEY","nectar_api_key":"NectarCRM API KEY","crm_setting":{"bcc_reply_email":"Reply email","bcc_send_email":"Sending email"},"webhook_setting":{"url":"URL"},"access_key":"access key","replace_user_id":"user","task_service":"task type","due_on_time":"time","email_domain":"email domain","send_at":"action time","emails_per_day":"daily activation","weekdays_to_send":"valid days to send","delay_before_finishing_contact_amount":"interval for finishing contact in the flow","field":"Name","webhook_url":"webhook URL","url":"URL","caller_id":"Number","meeting_type_id":"Meeting Type","kind":"Property type","linkedIn":"LinkedIn","var1":"Variable 1","var2":"Variable 2","var3":"Variable 3","status":{"title":"Status","options":{"all":"All statuses","active":"Active","bounced":"Bounce","connected":"Connected","uninitialized":"Uninitialized","paused":"Paused","converting":"Pending","scheduled":"Scheduled","interrupted":"Interrupted","blocklisted":"Blocklist","notConnected":"No Connection","disqualified":"Disqualified","inactive":"Inactive"}},"stage":{"title":"Stage","options":{"all":"All stages","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Opportunity","client":"Customer","lost":"Lost"}}},"tooltip":{"text":{"startedInFlow":"Lead already started in flow"}},"label":{"contacts":"contacts","manuallyInsertSuccessTitle":"Contacts base - manually entered contacts","manuallyInsertSuccessMessage":"Number of contacts inserted","requiredFields":"First and last name, email and company are required.","requiredFieldsWithGroups":"First and last name, email, group and company are required.","customFieldsFailLoading":"Failed to load custom fields","removeContactConfirm":"Confirm deletion of the contact below?","searchTags":"Search tags","searchContact":"Search contact"},"actions":{"add":"Add contacts","delete":"Delete contact","removeFromFlow":"Remove from flow"},"feedback":{"confirmCreate":"Created {length} contacts","noDataTitle":"There is no data in your Funnel chart","noDataText":"Performing tasks and interacting with your leads will give you access to your data here","errorTitle":"Oops! Something went wrong!","errorText":"There was a failure to load your Dashboard data.","noSearchResults":"No contacts found for this search.","noMoreResults":"No more results"}}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Import Contact List"},"subtitle":{"errorsResume":"Errors Summary","nextStepsCheck":"Attention, before proceeding to the next step, check the import:"},"label":{"uploadStep":"Upload","validationStep":"Validation","organizationStep":"Organization","sendToBaseStep":"Send to base","uploadFromFile":"Upload from file","howToCSVUpload":"How to upload the file?","nextStepsCheck1":"If the contact information is in the correct columns.","nextStepsCheck2":"If the accent is correct. If not, try changing the file encoding:","importConfirmTitle":"Confirm sending data","importConfirmMessage":"Contacts that are active in a flow will not be sent to a new flow nor will they have their responsibility transferred. Do you want to continue?","finishImportTitle":"Contacts database - import contacts via CSV","finishImportMessage":"Number of contacts entered {num}"},"actions":{"upload":"Select CSV file","exampleExport":"Download an example here","importAfterCheck":"Import corrected CSV","contactsImportOnlyFine":"Import only contacts without error","contactsImportDuplicated":"Continue and select duplicates","nextStepsCheckedContinue":"Yes, I checked! Next step","backToContactsPage":"Go to Contact Base","newImport":"Perform a new import","contactImport":"Import contacts"},"feedback":{"validateUpload":"Validating the uploaded file. Please wait a few moments...","sendingContacts":"Sending contacts to the base and organizing. Please wait a few moments...","contactsSent":"Contacts added and arranged successfully!","s3PresignedUrlFailure":"There was an error communicating with the server, please reload the page and try again","uploadFileToS3Failure":"Failed to upload file, please reload the page and try again","importSuccess":"Contacts imported successfully","responsabilityChangeCheck":"Existing contacts may have their responsibility changed. Do you want to continue?","contactOwnerSelectCheck":"Only contacts under your responsibility will be selected. Do you want to continue?"}}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Enter contacts manually","manuallyPicker":"Add contacts: Manually"},"subtitle":{},"tooltip":{},"label":{"groups":"groups","importConfirmMessage":"The following groups will be created or changed:","manuallyInsertSuccessTitle":"Groups - manually inserted contacts","insertInfo":"Enter contact information separated by comma:"},"actions":{},"feedback":{"contactsOnExistingGroups":"Number of contacts added to existing groups","contactsOnNewestGroups":"Number of contacts entered in new groups","failOnCreate":"Oops! We had a problem creating the {type}","updatingGroup":"Your group is being updated. Please wait...","creationFail":"There was an error creating the group.","creationProblem":"Oops! There was a problem creating the group","creationSuccess":"The group was successfully created! The contacts will be inserted into the group."},"filters":{"sortBy":"Sort by"},"events":{"created":"Created a group from the contact base"}}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	module.exports = {"after":"The {field} field must be after the {target} field","alpha_dash":"The {field} field must contain letters, numbers and dashes","alpha_num":"The {field} field must contain only letters and numbers","alpha_spaces":"The {field} can only contain alphabetic characters and spaces","alpha":"The {field} field must contain only letters","before":"The field {field} must be before the field {target}","between":"The {field} field must be between {min} and {max}","confirmed":"The field {field} and {confirmedField} must be the same","credit_card":"The field {field} is invalid","date_between":"The field {field} must be between {min} and {max}","date_format":"The field {field} must be in the format {format}","decimal":"The {field} field must be numeric and must contain {decimals == '*' ? '' : decimals} decimal places","digits":"The {field} field must be numeric and have {length} digits","dimensions":"The field {field} must be {width} pixels wide by {height} pixels high","email":"The {field} field must be a valid email","ext":"The {field} field must be a valid file","image":"The field {field} must be an image","in":"The {field} field must have a valid value","ip":"The {field} field must be a valid IP address","max":"The {field} field must not be longer than {length} characters","max_value":"The field {field} must be {max} or less","mimes":"The {field} field must be a valid file type","min":"The {field} field must contain at least {length} characters","min_value":"The field {field} must be {min} or greater","not_in":"The {field} field must be a valid value","numeric":"The {field} field must contain only numbers","regex":"The {field} field has an invalid format","required":"The {field} field is required","size":"The {field} field must be less than {size} KB","url":"The {field} field is not a valid URL"}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	module.exports = {"title":{"contacts":"Contacts","cadenceFlows":"Cadence Flows","cadenceFlowNew":"New cadence flow","cadenceFlowEdit":"Editing cadence flow","libFlows":"Flows Library","actions":"Actions","endContacts":"End Contacts","BCC":"BCC","flowRemove":"You are about to delete a flow","markAsLost":"Mark as lost?","noLimitWarning":"You are about to save a flow without a limit for daily activation","limitChangeWarning":"You are about to change the limit for daily activation of your flow"},"subtitle":{"contacts":"Define the contacts to insert in the flow","cadenceFlowNew":"Select an option below:","libFlows":"Select a flow below to use it as a template","actions":"Define the sequence of activities for the flow","endContacts":"Select the time at which contacts will be finished/lost after the last action of the flow.","BCC":"Define if the flow will use the BCC address of your CRM","flowRemove":"This action cannot be reversed. Do you want to confirm?"},"attributes":{"name":"Flow name","category":"Flow category","subject":"Subject","hasEmailsPerDay":"Daily activation","contacts":"Contacts","conversion":"Conversion","performed":"Performed","opening":"Opening","reply":"Reply"},"options":{"triggers":{"connected":"Marked as connected","bounced":"Marked as bounce","lost":"Marked as lost","stage":"Change to stage"},"actions":{"sendToNewFlow":"Send to a flow","changeStage":"Change stage","fillProperty":"Fill property","insertTag":"Insert tags","insertIntoGroup":"Insert into a group","changeResponsible":"Change responsible"},"timming":{"immediately":"Immediately","nextDay":"Next day","after":"After","today":"Always at"},"timmingComplements":{"hours":"Hours","days":"Days","weeks":"Weeks","months":"Months"},"actionsTriggerWithoutStages":{"sendToNewFlow":"Send to a flow","fillProperty":"Fill property","insertTag":"Insert tags","insertIntoGroup":"Insert into a group","changeResponsible":"Change responsible"},"stages":"Select a stage","properties":"Select a property","lostReason":"Any reason for loss"},"tooltip":{},"label":{"contactS":"contacts)","addS":"added(s)","dragDropProperties":"Click and drag the contact to change its sending priority in the flow","resetContactOnFlow":"Reset contact in flow","confirmResetContactOnFlow":"The contact will restart from the beginning of the flow. Do you want to proceed?","confirmRemoveContactOnFlow":"Do you want to remove contact <strong>{contact_name}</strong> from flow <strong>{flow_name}</strong>?","messageRemoveContactOnFlow":"<strong class=\"dark-red-color\">Warning</strong>: removing this contact will directly affect the flow statistics.","emptyCadenceFlow":"Blank","createCadenceFlow":"Create a cadence flow from scratch","fromLibCadenceFlow":"Library","useCadenceFlow":"Use a flow from the library as a template","contactsPerDay":"contacts per day","markAsLostIfNoReply":"Mark as lost contacts who do not respond to any actions in the flow.","checkReasonForLoss":"Select the reason for loss.","checkIfSendToFlow":"Should automatically finished/lost contacts at the end of actions be sent to a flow? If yes, select another flow after moving the switch.","labelAboutFlow":"Text about flow <Change>","emailBCCIntegration":"Email integration with your CRM (smart BCC address)","useBCC":"Use BCC","flowProcessing":"Your flow is being updated. Please wait...","flowProcessingError":"There was an error creating the flow.","removeDialogTitle":"Flow - Deleting flow","removeDialogDescription":"Flow URL:","removeConfirm":"Do you really want to delete cadence flow {name}? This action cannot be reversed","removeCadenceFlowConfirm":"You are about to delete a cadence flow. Do you want to proceed?","flowStatus":"Flow {status}","newContactsByDay":"New contacts per day","dailyActivationLimit":"No daily activation limit","viewContactFlow":"Flow - Contacts View","viewContactFlowDescription":"Flow Identifier","statusChangeLabel":"Flow - Status change to {status}","statusChangeDescription":"Flow Identifier","updateFLowSuccess":"{name} is now {human_status}","contactResume":"Contacts will be resumed in the flow","programaticTodaySendAction":"The time of the action scheduled for today must be at least 30 minutes ahead of the current time (eg if it is 10:00 am, the action \"Today\" must be scheduled for after 10:30 am)","programaticAfterZeroAction":"The time of the action scheduled for after 0 days must be at least 30 minutes ahead of the time of the previous action","programaticSendAtAction":"The action time is invalid","semiAutomated":"semi-automated","semiAutomatedFlow":"Semi-automated flow","withTaskTimerTitle":"Track the time from creating a task to execution","withTaskTimerLabel":"It is possible to track the time elapsed between task creation and execution/completion. By enabling the checkbox, it will be possible to view the time count on tasks for contacts that are in inbound flow.","automated":"automated","automatedFlow":"Automated flow","noConnection":"No connection","flowCreatedURL":"URL of the created flow","flowContactsLength":"Number of contacts in the flow","flowDailyEmailLength":"Number of emails per day (target)","flowActiveAfterCreated":"Active after creation?","flowActiveBBC":"Active BCC","flowActionsNumber":"Number of actions","categorySelect":"Select a category","stepLabel":"Step: {step}","stepImmediately":"Immediate upload after flow activation","stepUndefinedTime":"Sending after flow activation","stepDefinedTime":"Sending at {time}","stepAfterFlow":"{time} after flow creation","stepAfterStep":"{time} after step {step}","executeTasks":"Perform Activities","clearFilters":"Clear Filters","errors":{"markedTriggers":"Oops, there are conflicts between the marked triggers.","needAction":"Oops, there are triggers configured that need an action.","needProperty":"Oops, there are triggers configured that need a property.","needSetTime":"Oops, there are triggers configured that need a set time.","triggerConflicts":"Oops, there are conflicts between the marked triggers.","invalidFormat":"Invalid format for sending time. Examples: 09:00, 14:30","fieldSendAfterError":"The \"send after\" field must be positive","responsibleAndFlowConflictError":"You cannot have Send to Flow and Change Responsible actions in the same flow."}},"actions":{"insertContacts":"Insert Contacts","contactsBase":"Contacts Base","manually":"Manually","new":"Create flow","save":"Save flow","editType":"Edit","find":"Find flow","activateAfterCreate":"Activate flow after creation","newFromLib":"New from library","retryAfterError":"Retry After Error","contactsRollback":"Resume interrupted contacts","addTrigger":"Add Trigger","sendAsReply":"Send as Reply","addAction":"Add action"},"feedback":{"removeSuccess":"Flow removed successfully","unknownError":"Errors occurred while creating the cadence flow","unknownErrorOnCreate":"The flow could not be created due to an unknown error","noDataText":"No more results","noResults":"There are no results","reportSand":"Report(s) being generated"},"reports":{"label":{"generate":"Export","canceled":"Cancel","title":"Export Reports","periodLabel":"Select the period you want to export: ","addContact":"Added contacts","activatedContacts":"Activated contacts","activeContact":"Active contacts","connectedContact":"Connected contacts","lostContact":"Lost contacts","tasksRealized":"Tasks performed"},"time":{"today":"Today","week":"This week","month":"This month","year":"This year"}},"text":{"fromPreviousAction":"from the previous action","noLimitWarning":"When this flow is activated, all of its contacts will be activated too. Do you wish to go on?","limitChangeWarning":"The new limit will be used from the next day onwards. Contacts already activated will not be affected"}}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

	module.exports = {"title":{},"tooltip":{},"label":{"duplicatedField":"'{field}' is already in use","invalidField":"'{field_value}' is not a valid {field}","newest":"Newest","oldest":"Oldest","loading":"Loading...","numberIntervalLimit":"Must be between {min} and {max}","requiredDateField":"Choose at least one day","yes":"Yes","no":"No","none":"none","actions":"actions","days":"days","hours":"hours","minutes":"min","after":"after","today":"today","weeks":"weeks","months":"months","at":"at {time}","generalAt":"at","immediately":"immediately","sun":"sun","mon":"mon","tue":"tue","wed":"wed","thu":"thu","fri":"fri","sat":"sat","user":"User","Manually":"Manually","others":"Other","here":"here","active":"Active","inactive":"Inactive","lostReasons":"Reasons for loss"},"actions":{"back":"Back","cancel":"Cancel","confirm":"Confirm","conclude":"Finish","remove":"Remove","delete":"Delete","confirm_actions":"Confirm Actions","select":"Select","retry":"Try again","toView":"View","edit":"Edit","new":"New","create":"Create","options":"Options","close":"Close","save":"Save","saveWithLabel":"Save {label}","createWithLabel":"Create {label}","disconnect":"Disconnect","connect":"Connect","copy":"Copy","copied":"Copied","configure":"Configure","chooseEnv":"Choose environment","ok":"Ok","connectedTo":"Connected to","disconnectedTo":"Disconnected from","notConfigured":"Not configured","ignore":"Ignore","verified":"Verified","verify":"Verify"},"feedback":{"actionNotAllowed":"You are not allowed to perform this action","unknownError":"An unknown error has occurred","loading":"Loading...","settingSaved":"Setting saved successfully","settingUpdated":"Setting updated successfully","updateError":"Error when updating.","invalidUrl":"Invalid URL","configEmailSuccess":"E-mail configured successfully!","invalid":"Invalid","noResults":"No more results","domainVerified":"Verified successfully"},"placeholder":{"search":"Search..."}}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Group Base"},"subtitle":{},"attributes":{"Name":"Name","name":"name","Responsible":"Responsible","groupName":"Group name"},"tooltip":{},"label":{"group":"Group","groups":"groups","manuallyInsertSuccessTitle":"Contact base - manually entered contacts","contacts":"contact(s)","added":"added","navBar":{"contacts":"Contacts","groups":"Groups","businesses":"Businesses","connections":"Connections"}},"actions":{"create":{"title":"Create new group","newGroup":"New group","createGroup":"Create group","manuallyAdd":"Add manually","contactBaseAdd":"Contact Base"},"update":{"title":"Edit Group","success":"Group edited successfully!"},"delete":{"title":"Delete Group","deleteGroups":"Delete groups","message":"Are you sure you want to delete the group below?<br><strong style=\"color: rgb(223, 98, 114);\">{groupName}</strong>","confirm":"Yes, delete","confirmBelow":"Confirm deletion of the group below?","checkboxConfirm":"Delete the group","andAllContacts":"and all its contacts","success":"Group removed successfully!","fail":{"massFail":"Could not delete groups!","cantDeleteAnyOfSelected":"You are not allowed to delete any of the selected groups"}},"view":{"title":"View Group","search":"Search group"}},"feedback":{"noGroups":"There are no groups","noMoreResults":"No more results"}}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Integration","integrations":"Integrations","mailProvider":"Email Provider","api":"Integration via API","crm":"CRM","pipedrive":"Pipedrive","nectar":"NectarCRM","salesforce":"Salesforce","carousel":"Carousel for receiving Leads","rdStation":"RD Station","sharpspring":"SharpSpring","leadlovers":"LeadLovers","cv":"CV CRM","vtiger":"Vtiger","hubspot":"HubSpot","webhooksCapslock":"WEBHOOKS","trigger_stages":"Configure under which conditions the contact will be sent to the CRM","deal_lost":"Update lost deals in CRM","properties_matching":"Properties matching","stages_matching":"Stage matching","properties_table":"Responsible"},"subtitle":{"mailProvider":"Email Server Provider","api":"API integration","crm":"Customer Relationship Management","pipedrive":"CRM","nectar":"CRM","salesforce":"CRM","carousel":"Leads receipt carousel configuration","rdStation":"CRM","rdStationMarketing":"Marketing Automation","sharpspring":"Marketing Automation","leadlovers":"Marketing Automation","cv":"CRM","vtiger":"CRM","hubspot":"CRM and Marketing Automation","properties_matching":{"dragOrCreate":"Drag a property or create a new one by clicking next to it.","fieldsFilled":"The name and email fields will now be filled in automatically."}},"attributes":{"Responsible":"Responsible","Carousel":"Carousel","accessKey":"Access key","email":"Email","apiUrl":"API URL","lead":"Lead","contact":"Contact","funnelName":"Funnel name","funnelStage":"Funnel stage order number","funnelStageNumber":"Funnel Stage ID","stageNumber":"Stage number","name":"Name","lastname":"Lastname","phone":"Phone","cellphone":"Cellphone","url":"url","contactProperties":"Contact properties","businessProperties":"Business properties","notMatchedProperties":"Matched Reev Properties","position":"Position","address":"Address","variable":"Variable"},"tooltip":{"mailProvider":"Email out of sync. Use the button on the side to resynchronize.","api":"This is the token that must be used to use our API. Please contact our support team for more information.","crm":"Webhooks provide the ability to send data updates about your leads' activities. When changing a contact to Connected, Missing, or Customer, their information will be sent to the URL below.","saveWebhookUrl":"To register sent and received emails in your CRM, enter the email addresses provided by it in the fields below. If you want to register only sent or received only, fill in only the field of your choice.","nectarFunnelConfig":"Configure which funnel and funnel stage your lead will be sent to when qualified as Connected. If the funnel ID and/or stage is not informed, the lead will be sent to the first stage of the default funnel. ","chooseEnv":"*Verify in your Salesforce account that you have permission to integrate in Sandbox environment","carousel":"This carousel allows you to distribute leads that arrive at Reev via API among your sales team and define which and in what order they will receive these leads.","sharpspringLead":"Leads sent by your marketing automation tool can be assigned to a carousel of sellers or directly to the user responsible for it. Please select the option that makes the most sense for your process."},"placeholder":{"funnelName":"Insert funnel name here","funnelStage":"Insert funnel stage order number here","funnelStageNumber":"Enter stage ID here","stageNumber":"Enter stage ID here","funnel":"Select a funnel","properties_matching":"Fill or drag property","stages_matching":"stage id no","apiKey":"Enter your private API token here","cvCrmEmail":"Enter your CV CRM email here","cvCrmDomain":"Enter your CV CRM client domain"},"label":{"ignore":"ignore","showToken":"View token","apiKey":"API KEY","apiToken":"API Authentication Token","email":"Email","webhookUrlForm":"Enter the URL where the contact should be sent here","nectarFunnelID":"Funnel ID","nectarFunnelIDPlaceholder":"Enter Funnel ID","nectarFunnelStage":"Funnel Stage","nectarFunnelStagePlaceholder":"Insert stage number","nectarSettingResponsible":"Responsible Email","nectarSettingResponsiblePlaceholder":"Enter the responsible person's email","chooseEnv":"Configure which environment you want to integrate with.","chooseEnvOptions":"It is possible to integrate with Sandbox Environment* or Production Environment.","carouselModal":"View carousel","sharpspringLead":"What to do with the lead?","setCarousel":"Set Carousel","contactsViaCarousel":"Distribution of contacts via Carousel","contactsViaResponsible":"Distribution of contacts to the person responsible in Marketing Automation.","contactsViaResponsibleCRM":"Distribution of contacts to the person responsible in the CRM","copySettings":"Copy another user's settings","modal_carousel":{"leadSelect":"Select the sellers who will receive the leads:","lastResponsible":"Last person responsible to receive a lead","lastResponsibleFeedback":"No assignees received leads","nextResponsibles":"Next Responsible","successFeedback":"Carousel saved successfully!","failFeedback":"Carousel data could not be saved."},"leadlovers":{"receiveContactsTitle":"Configure the LeadLovers Integration > Reev","receiveText":"Leads sent by your marketing automation tool will be directly assigned to the user responsible for them. Enter the URL below into your tool to send leads."},"pipedrive":{"bcc_for_sent":"BCC for sending","bcc_for_reply":"BCC for reply","receiveContactsTitle":"Add contacts created in Pipedrive to Reev."},"vtiger":{"accessKey":"Access key provided by Vtiger","email":"vTiger user email","apiUrl":"Enter API URL here","lead":"Select which entity will receive the information in Vtiger","success":"{message_action} Vtiger successfully"},"cvCrm":{"clientDomain":"Client domain","receiveContactsTitle":"Add contacts created in CV CRM to Reev.","webhooksUrl":"Webhook's URL","pasteUrl":"Paste this URL in the webhooks's address field on CV CRM"},"hubspot":{"receiveContactsTitle":"Send Hubspot Contacts to Reev","receiveContacts":"Set up sending contacts from Hubspot to Reev","addContacts":"Add contacts in lifecycle stages from Hubspot to Reev","smartLeads":"All contacts sent by Hubspot to Reev will be added as Smart Leads.","contactsDistributionTitle":"Configure the contacts distribution model","eachUser":"The integration between Hubspot and Reev is done on a per-user basis.","eachUserDescription":"By connecting your Reev account to a Hubspot account and selecting this distribution option, every Hubspot contact under your responsibility, and meeting the lifecycle stage criteria, will be received by you here at Reev.","carousel":"In the distribution by Carousel, it is necessary to configure the order in which the contacts will be received. Click on the \"Configure Carousel\" button next to it, select the users who will enter the distribution and, before exiting, save the settings.","carouselDescription":"This way, Reev will provide you with a code to use in HubSpot.","configByPipeline":"Configure which funnel and funnel stage your lead will be sent to when qualified as Connected. If the funnel ID and/or stage is not informed, the lead will be sent to the first stage of the default funnel. ","configByPipelineStage":"Configure which funnel stage your lead will be sent to when qualified as Connected. If the stage ID is not informed, the lead will be sent to the first stage of the default funnel.","sendContactsTitle":"Sending Reev Contacts to Husbpot","syncContacts":"Sync information between Reev and Hubspot, keeping your stack tightly integrated and data about your contacts always up to date."},"stages_matching":{"funnel":"Select mailing funnel","stage":"Select the corresponding stage","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Opportunity","client":"Client","customer":"Customer","lost":"Lost","multipleStages":"Multiple Stages","selectPhases":"Select stages"},"rdStationMarketing":{"contactsDistributionTitle":"Configure the contact distribution model","choosenModel":"Every contact received in the integration with RD Station will have its responsibility defined by the chosen model.","choosenModelInfo":"To use a property for distribution, it is only possible to select multiple choice properties in Reev and a carousel must be determined for each possible option.","chooseModelAction":"Choose the desired model","propertyDistribution":"Property Distribution","simpleCarouselDistribution":"Simple Carousel Distribution","responsibleDistribution":"Distribution for Responsible in RD Marketing","receiveLeadsInfo":"Before activating the receipt of leads via RD Station, you must configure the order of receipt of sellers by clicking on the \"Configure Carousel\" button. This way, Reev will provide a code for you to use in RD Station.","sendContactsTitle":"Sending Reev Contacts to RD Station","chooseContactTag":"The Reev - RD Station integration allows leads tagged as \"Customer\" in Reev to be updated to \"Sale\" in RD Station. To enable this functionality you need to click the connect button and modify the permissions within from RD Station.","customerTag":"When marking a contact as \"Customer\" in Reev, mark it as \"Sale\" in RD.","lostTag":"When tagging a contact as \"Lost\" in Reev, mark it as \"Lost\" in RD.","stagesTag":"Either mark a non-stage contact(s) selected to the side, or Reev will mark it as \"Opportunities\" not RD."},"salesforce":{"sendTo":"Select whether the contact will be saved in a queue or or will go straight to the responsible user (verifying via the user's email).","chooseData":"Select which data to send to Salesforce","onlyLead":"Only Leads","leadAndAccounts":"Leads and Accounts","leadAccountsAndOpportunities":"Leads, Accounts and Opportunities","featurePermission":"Warning: Your salesforce account does not allow the use of this feature. Learn more","queuePermission":"Warning: Your Salesforce user does not have permission to use Queues. Learn more"},"modal_carousel_custom":{"copiedCarouselItems":"Select which items should receive the copied carousel","rightColumn":"The right column corresponds to the details of the Carousel to be copied","chooseUsersAndOrder":"To configure the carousel, select users and choose the order of receipt","chooseUsers":"Select Users","lastResponsible":"Last person responsible to receive a lead","carouselDetails":"Carousel Details","userOrders":"User Order","nextResponsibles":"Next Responsible"}},"checkbox":{"productionEnv":"Production Environment","sandboxEnv":"Sandbox/Test Environment","nectar":{"sendTasks":"Send completed tasks to Nectar"},"trigger_stages":{"onCreated":"On being created in Reev","onStatusConnected":"On being marked as connected","onAdvanceStage":"On advancing to the stage(s)","onChangeResponsibility":"On changing responsibility"},"updateAllUsers":"Save this setting for all users"},"actions":{"create":{"title":""},"update":{"title":"","success":"","carousel":"Edit Carousel","deal_lost":{"update":"Update lost deals","notUpdate":"Don't update lost deals"}},"delete":{"title":"","message":"","confirm":"","success":"","fail":{}},"view":{"title":"","properties_matching":"VIEW PROPERTIES","stages_matching":"VIEW STAGES"},"email":{"setUp":{"error":{"defaultUserError":"Only the default user is able to set up this integration."}}}},"feedback":{"nectarSettingResponsibleInvalid":"Responsible email field must be a valid email","sharpspringNeedsCarousel":"Receipts carousel setup needed","rememberHttps":" (remember to start with \"https\").","nectarSuccess":"{message_action} Nectar was successful","connectedToNectar":"Connected to Nectar","disconnectedToNectar":"Disconnected from Nectar","configuredBCCPipedrive":"Configured Pipedrive BCC","calendarSuccess":"Calendar successfully synced!","calendarFail":"Error synchronizing calendar!","salesforceDisconnectSuccess":"Successfully disconnected from Salesforce","salesforceDisconnectEvent":"Disconnected from Salesforce","salesforceConnectSuccess":"Successfully connected to Salesforce","salesforceConnectEvent":"Connected to Salesforce","rdStationCRMSuccess":"RD Station CRM successfully saved","rdStationDisconnectSuccess":"Disconnected from RD Station successfully","rdStationDisconnectEvent":"Disconnected from RD Station","rdStationConnectSuccess":"Connected to RD Station successfully","rdStationCRMConnectEvent":"Connected to RD Station CRM","rdStationCRRMDisconnectEvent":"Disconnected from RD Station CRM","rdStationConnectEvent":"Connected to RD Station","requiredFunnelStageMap":"Stage mapping must be filled!","requiredLifeCicleStage":"Necessary to complete the lifecycle stages from Hubspot to Reev.","hubspotDisconnectSuccess":"Successfully disconnected from HubSpot","hubspotConnectSuccess":"Connected to HubSpot successfully","requiredFunnel":"Funnel name is required","requiredFunnelStage":"Stage name is required","onlyIgnoreStage":"Only the \"Ignore\" stage can be repeated!","pipedriveSuccess":"{message_action} Pipedrive successful","cvCrmSuccess":"{message_action} CV CRM successfully","connectedToPipedrive":"Connected to Pipedrive","disconnectedToPipedrive":"Disconnected from Pipedrive","connectedToCvCrm":"Connected to CV CRM","disconnectedToCvCrm":"Disconnected from CV CRM","invalidApiKey":"Invalid API Key","expiredAuth":"Authentication expired. Please authenticate again.","databaseSuccess":"Successfully saved to database","carouselCopySuccess":"Carousel copy successful!","carouselCopyFail":"'Carousel data could not be copied.'"}}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	module.exports = {"soft_bounce":{"generic":"The contact's email server has rejected your email at this time. The sending has been rescheduled for the next day.","message_rejected":"The contact's email server has rejected your email at this time. The sending has been rescheduled for the next day. {attempts}/{max_attempts} attempts","account_failure":"The email was not sent because your account was not synchronized at the time of sending. The email was rescheduled for the next day. {attempts}/{max_attempts} attempts","limit_exceeded":"The email was not sent because you exceeded the sending limit for the day. The email was rescheduled for the next day. {attempts}/{max_attempts} attempts","service_failure":"The email was not sent because there was a problem with the sending server. The sending of the email was rescheduled for the next day. {attempts}/{max_attempts} attempts","unknown":"The email was not sent because there was a problem sending the email. The email was rescheduled for the next day. {attempts}/{max_attempts} attempts"}}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Templates","edit":"Edit template"},"modal":{"edit":{"title":"Edit Templates","titleSpecific":"Edit Template {name}"}},"subtitle":{},"attributes":{"stage":"Stage","category":"Category","user":"Responsible","subject":"Subject","emailSignature":"Email Signature","name":"Name","content":"Content","nameTemplate":"Template name","nameLinkedin":"LinkedIn Template Name","nameSocial":"Message name on social network","nameRoadMap":"Roadmap name","contentLinkedin":"InMail Content","contentSocial":"Message content on social network","contentEmail":"Content of the email","contentCall":"Content of call script","template":"Template","roadMap":"Road","linkedin":"InMail","social":"Message","variable":"variable"},"options":{"all":"All types","call":"Call","email":"Email","linkedin":"LinkedIn","social":"Social","userSelect":"Select a user","categorySelect":"Select a category"},"tooltip":{},"label":{"optionsLabel":"This template is being used in <strong>{actionsCountText}</strong>. Select the desired option:","selectTemplate":"Select the type of template you want to create:","templateViewer":"Template - View","templateEditing":"Template - Editing","templateManualSearch":"Templates - Manual search performed","saveSuccess":"Template saved successfully","templateURL":"URL of the created template","imagesContentLength":"Number of images in content","hiperlinksContentLength":"Number of hyperlinks in the content","imagesSignatureLength":"Number of images in signature","hiperlinksSignatureLength":"Number of signature hyperlinks","characterLimit60":"Subjects over 60 characters will not appear complete for your leads","characterLimit40":"Subjects over 40 characters can be trimmed","emailOpen":"Open","emailReply":"Reply","conversion":"Conversion","preShow":"Preview","removeTemplateConfirm":"You are about to delete a template. Do you want to proceed?","removeTemplateByNameConfirm":"Do you really want to delete template <b>{name}</b>? This action cannot be reversed","editTemplateAction":"When editing the template for this action, all templates already edited for contacts in this step will be deleted.","templateVariableUsing":"Template - Variable usage {name}","allCategories":"All categories"},"actions":{"new":"New Template","update":"Update template","edit":"Change template","updateAtFlows":"Update template in flows","createOnEdit":"Create a new template from editing","search":"Search template","save":"Save Template"},"feedback":{"removeSuccess":"Template removed successfully","createSuccess":"Template created successfully","removeFail":"Failed to delete template","noDataText":"You don't have any Templates yet","noDataResults":"No more results","noActions":"No actions use templates."}}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

	module.exports = {"title":{},"subtitle":{},"attributes":{"name":"Name","email":"Email","timezone":"Timezone","signature":"Signature","role":"Role","status":"Status","company":"Company"},"status":{"active":"Active","pending":"pending"},"role":{"admin":"Administrator","manager":"Account Manager","seller":"Sales executive","monitoringManager":"Monitoring Manager","sdr":"sdr"},"tooltip":{},"label":{"me":"I","guestPending":"Guest (pending confirmation)"},"actions":{"update":{"success":"User updated successfully","role":"Changed a user's role"},"invite":{"resend":"Resend Invitation","resendSuccess":"Email successfully resent"},"delete":{"delete":"Delete User"},"error":{"changeEmail":"Must change user email or role before saving"}},"feedback":{}}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	module.exports = {"call_status":{"idle":"Idle","calling":"Calling","connected":"Connected","ended":"Call ended","failed":"Connection ended"},"error_messages":{"generic":"There was an error with your VoIP service. Please try again later or contact support","unauthorized_manager":"Access to VoIP not authorized. For more information contact Reev's CS team","unauthorized":"Access to VoIP not authorized. For more information, contact your account manager","web_rtc_support":"This browser does not support making VoIP calls","authentication":"An authentication error occurred in the VoIP service. Please try again later or contact support","mic_permission":"Microphone is blocked for browser use. Enable to make calls","ongoing_call":"There is already a call in progress.","failed_status":{"User Denied Media Access":"Microphone not enabled","Canceled":"Canceled","Not Found":"Number does not exist","Busy":"Busy or nonexistent","Unavailable":"Not answered"}}}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Base de negocios","linkedContacts":"Contactos vinculados"},"subtitle":{},"attributes":{"name":"Nombre/Dominio","address":"Dirección","status":"Estado","stage":"Etapa","tag":"Etiqueta","tags":"Etiquetas","contacts":"Contactos","domain":"Dominio"},"tooltip":{},"label":{"statusOptions":{"all":"Todos los estados","active":"Activo","bounced":"Bounce","connected":"Conectado","uninitialized":"No iniciado","paused":"Pausado","converting":"Pendiente","scheduled":"Agendado","interrupted":"Interrumpido","blocklisted":"Blocklist","notConnected":"Sin conexión","disqualified":"Descalificado","inactive":"Inactivo"},"stageOptions":{"all":"Todas las etapas","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Oportunidad","client":"Cliente","lost":"Perdido"},"details":"Detalles de la Empresa","removeCompany":"Eliminar empresa","removeCompanyConfirm":"¿Realmente desea eliminar la empresa {name}?","companyRemoveAlert":"Las empresas con contactos asociados no se pueden eliminar"},"actions":{"new":"Nueva empresa","contacts":"Contactos","groups":"Grupos","companies":"Empresas"},"feedback":{"removeSuccess":"Empresa eliminada con éxito","saveSuccess":"Modificaciones guardadas con éxito","unknownFail":"Error desconocido al cargar la empresa","noDataText":"No hay más resultados","errorTitle":"¡Ups! ¡Algo salió mal!"},"filters":{"placeholder":"Busca empresa, contactos, direcciones, etc..."}}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	module.exports = {"attributes":{"name":"Nombre","domain":"Dominio","email":"E-mail","plan":"Plan","service":"Servicio","emailDomain":"Dominio del email","emailService":"Servicio de e-mail","companyStatus":"Estado de la empresa","status":"Estado","usersCount":"N° de Usuarios","maxUsersCount":"Número máximo de usuarios","managersCount":"N° de Gerentes de segui.","maxManagersCount":"Número máx. de gerentes de segui.","voip":"VoIP","usedMinutes":"Minutos usados","paidMinutes":"Minutos Contratados","paidMinutesUsedOnMonth":"Minutos contratados utilizados en el mes","usedContacts":"Contactos usados","paidContacts":"Contactos contratados","paidContactsUsedOnMonth":"Contactos contratados utilizados en el mes","additionalMinutes":"Minutos adicionales","additionalContacts":"Contactos Adicionales"},"label":{"activeCompany":"Activo","pausedCompany":"En pausa"},"actions":{"create":"Registrar Empresa","search":"Buscar Empresa","update":"Actualizar Empresa"},"feedback":{"serviceSaved":"Guardado exitosamente","created":"Empresa registrada exitosamente","updated":"Empresa actualizada con éxito","domainWarning":"Consultado pero aún no verificado","consummedMinutes":" - #{@additional.consumed_in_minutes()} minutos consumidos","contactsExceeded":"¡El número de usuarios existentes supera el número máximo del plan elegido! ¡Se requieren modificaciones para cambiar el plan!"}}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Contactos","singular":"Contacto"},"subtitle":{},"attributes":{"name":"nombre","email":"email","password":"Clave","password_confirmation":"Repita la contraseña","current_password":"Contraseña actual","reset_password_token":"token","subject":"Asunto","body":"contenido","template_category_id":"categoría","company_id":"empresa","first_name":"nombre","last_name":"apellido","business":"empresa","business_name":"nombre de la empresa","position":"Puesto","telephone":"telefono","cellphone":"celular","address":"Dirección","domain":"dominio","city":"Ciudad","state":"estado","country":"país","contact_group":"grupo","role":"Puesto","timezone":"Huso horario","pipedrive_api_key":"API KEY de Pipedrive","nectar_api_key":"API KEY de NectarCRM","crm_setting":{"bcc_reply_email":"Email de respuesta","bcc_send_email":"Email de envío"},"webhook_setting":{"url":"URL"},"access_key":"Llave de acceso","replace_user_id":"usuario","task_service":"tipo de tarea","due_on_time":"horario","email_domain":"dominio del email","send_at":"horario de la acción","emails_per_day":"Activación diaria","weekdays_to_send":"días válidos para el envío","delay_before_finishing_contact_amount":"intervalo para finalizar el contacto en el flujo","field":"Nombre","webhook_url":"URL de webhook","url":"URL","caller_id":"Numero","meeting_type_id":"Tipo de reunión","kind":"Tipo de propiedad","linkedIn":"LinkedIn","var1":"Variable 1","var2":"Variable 2","var3":"Variable 3","status":{"title":"Estado","options":{"all":"Todos los estados","active":"Activo","bounced":"Bounce","connected":"Conectado","uninitialized":"No iniciado","paused":"Pausado","converting":"Pendiente","scheduled":"Agendado","interrupted":"Interrumpido","blocklisted":"Blocklist","notConnected":"Sin conexión","disqualified":"Descalificado","inactive":"Inactivo"}},"stage":{"title":"Etapa","options":{"all":"Todas las etapas","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Oportunidad","client":"Cliente","lost":"Perdido"}}},"tooltip":{"text":{"startedInFlow":"El lead ya comenzó en el flujo"}},"label":{"contacts":"contactos","manuallyInsertSuccessTitle":"Base de contactos - contactos introducidos manualmente","manuallyInsertSuccessMessage":"Número de contactos ingresados","requiredFields":"Se requiere primero y ultimo nombre, e-mail y empresa.","requiredFieldsWithGroups":"Se requiere primero y ultimo nombre, e-mail, grupo y empresa.","customFieldsFailLoading":"No se pudieron cargar los campos personalizados","removeContactConfirm":"¿Confirmar la eliminación del contacto a continuación?","searchTags":"Buscar etiquetas","searchContact":"Buscar contacto"},"actions":{"add":"Añadir contactos","delete":"Eliminar contacto","removeFromFlow":"Eliminar del fluxo"},"feedback":{"confirmCreate":"Creados {length} contactos","noDataTitle":"No hay datos en su gráfico de embudo","noDataText":"Realizando tareas e interactuando con tus leads tendrás acceso a sus datos aquí","errorTitle":"¡Ups! ¡Algo salió mal!","errorText":"Hubo un error al cargar los dados de su Dashboard.","noSearchResults":"No hay resultados de contactos para esta búsqueda.","noMoreResults":"No hay más resultados"}}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Importar lista de contactos"},"subtitle":{"errorsResume":"Resumen de errores","nextStepsCheck":"Atención, antes de continuar con el siguiente paso, verifique la importación:"},"label":{"uploadStep":"Upload","validationStep":"Validación","organizationStep":"Organización","sendToBaseStep":"Envío a la base","uploadFromFile":"Upload de archivo","howToCSVUpload":"¿Cómo enviar el archivo?","nextStepsCheck1":"Si la información de contacto está en las columnas correctas.","nextStepsCheck2":"Si el acento es correcto. Si no, intente cambiar la codificación del archivo.:","importConfirmTitle":"Confirmar envío de datos","importConfirmMessage":"Los contactos que están activos en un flujo no se enviarán a una nuevo flujo y su responsabilidad no se transferirá. ¿Desea continuar?","finishImportTitle":"Base de contactos: importar contactos a través de CSV","finishImportMessage":"Número de contactos ingresados {num}"},"actions":{"upload":"Seleccionar archivo CSV","exampleExport":"Descarga un ejemplo aquí","importAfterCheck":"Importar CSV corregido","contactsImportOnlyFine":"Importar solo contactos sin error","contactsImportDuplicated":"Continuar y seleccionar duplicados","nextStepsCheckedContinue":"¡Sí, lo comprobé! Próximo paso","backToContactsPage":"Ir a Base de Contactos","newImport":"Realizar una nueva importación","contactImport":"Importar contactos"},"feedback":{"validateUpload":"Validando el archivo descargado. Espere un momento...","sendingContacts":"Envío de contactos a la base y organización. Espere un momento...","contactsSent":"¡Contactos agregados y organizados con éxito!","s3PresignedUrlFailure":"Hubo un error de comunicación con el servidor, recarga la página e inténtalo de nuevo","uploadFileToS3Failure":"No se pudo cargar el archivo, vuelva a cargar la página y vuelva a intentarlo","importSuccess":"Contactos importados con éxito","responsabilityChangeCheck":"Los contactos existentes pueden tener su responsabilidad cambiada. ¿Desea continuar?","contactOwnerSelectCheck":"Solo se seleccionarán los contactos bajo su responsabilidad. ¿Desea continuar?"}}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Insertar contactos manualmente","manuallyPicker":"Agregar contactos: Manualmente"},"subtitle":{},"tooltip":{},"label":{"groups":"grupos","importConfirmMessage":"Los siguientes grupos serán creados o cambiados:","manuallyInsertSuccessTitle":"Grupos - contactos introducidos manualmente","insertInfo":"Ingrese las informaciones de los contactos separadas por coma:"},"actions":{},"feedback":{"contactsOnExistingGroups":"Número de contactos insertados en grupos existentes","contactsOnNewestGroups":"Número de contactos agregados en nuevos grupos","failOnCreate":"¡Ups! Tuvimos un problema al crear los {type}","updatingGroup":"Tu grupo se está actualizando. Aguarde...","creationFail":"Hubo un error al crear el grupo.","creationProblem":"¡Ups! Tuvimos un problema al crear el grupo.","creationSuccess":"¡El grupo fue creado con éxito! Los contactos se insertarán en el grupo."},"filters":{"sortBy":"Ordenar por"},"events":{"created":"Creó un grupo a partir de la base de contactos."}}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

	module.exports = {"after":"El campo {field} debe estar después del campo {target}","alpha_dash":"El campo {field} debe contener letras, números y guiones","alpha_num":"El campo {field} debe contener solo letras y números","alpha_spaces":"El {field} solo puede contener caracteres alfabéticos y espacios","alpha":"El campo {field} debe contener solo letras","before":"El campo {field} debe estar antes del campo {target}","between":"El campo {field} debe estar entre {min} y {max}","confirmed":"El campo {field} y {confirmedField} debe ser igual","credit_card":"El campo {field} no es válido","date_between":"El campo {field} debe estar entre {min} y {max}","date_format":"El campo {field} debe estar en el formato {format}","decimal":"El campo {field} debe ser numérico y debe contener {decimals == '*' ? '' : decimals} casas decimales","digits":"El campo {field} debe ser numérico y tener {length} dígitos","dimensions":"El campo {field} debe tener {width} píxeles de ancho por {height} píxeles de altura","email":"El campo {field} debe ser un correo electrónico válido","ext":"El campo {field} debe ser un archivo valido","image":"El campo {field} debe ser una imagen","in":"El campo {field} debe tener un valor válido","ip":"El campo {field} debe ser una dirección IP válida","max":"El campo {field} no debe tener más de {length} caracteres","max_value":"El campo {field} debe ser {max} o menos","mimes":"El campo {field} debe ser un tipo de archivo válido","min":"El campo {field} debe contener al menos {length} caracteres","min_value":"El campo {field} debe ser {min} o mayor","not_in":"El campo {field} debe ser un valor válido","numeric":"El campo {field} debe contener solo números","regex":"El campo {field} tiene un formato inválido","required":"El campo {field} es obligatorio","size":"El campo {field} debe ser menor que {size} KB","url":"El campo {field} no es una URL válida"}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

	module.exports = {"title":{"contacts":"Contactos","cadenceFlows":"Flujos de cadencia","cadenceFlowNew":"Nuevo flujo de cadencia","cadenceFlowEdit":"Edición del flujo de cadencia","libFlows":"Biblioteca de flujo","actions":"Acciones","endContacts":"Finalizar Contactos","BCC":"BCC","flowRemove":"Estás a punto de eliminar un flujo","markAsLost":"¿Marcar como perdido?","noLimitWarning":"Estás a punto de guardar un flujo sin limite de activación diaria","limitChangeWarning":"Estás a punto de cambiar el limite de activación diaria de tu flujo"},"subtitle":{"contacts":"Definir los contactos a insertar en el flujo","cadenceFlowNew":"Seleccione una opción a continuación:","libFlows":"Seleccione un flujo a continuación para usarlo como plantilla","actions":"Definir la secuencia de actividades de flujo","endContacts":"Seleccione la hora a la que se cancelarán/perderán los contactos después de la última acción del flujo.","BCC":"Defina si el flujo utilizará la dirección BCC de su CRM","flowRemove":"Esta acción no se puede revertir. ¿Quieres confirmar?"},"attributes":{"name":"Nombre de flujo","category":"Categoría de flujo","subject":"Asunto","hasEmailsPerDay":"Activación diaria","contacts":"Contactos","conversion":"Conversión","performed":"Realizadas","opening":"Apertura","reply":"Respuesta"},"options":{"triggers":{"connected":"Marcado como conectado","bounced":"Marcado como Bounce","lost":"Marcado como perdido","stage":"Cambiado a la etapa"},"actions":{"sendToNewFlow":"Enviar a un flujo","changeStage":"Cambiar de etapa","fillProperty":"Completa la propiedad","insertTag":"Insertar etiquetas","insertIntoGroup":"Insertar en un grupo","changeResponsible":"Cambiar responsable"},"timming":{"immediately":"Inmediatamente","nextDay":"Día siguiente","after":"Después","today":"Siempre a las"},"timmingComplements":{"hours":"Horas","days":"Días","weeks":"Semanas","months":"Meses"},"actionsTriggerWithoutStages":{"sendToNewFlow":"Enviar a una corriente","fillProperty":"Completa la propiedad","insertTag":"Insertar etiquetas","insertIntoGroup":"Insertar en un grupo","changeResponsible":"Cambiar responsable"},"stages":"Seleccione una Etapa","properties":"Seleccione una propiedad","lostReason":"Cualquier motivo de pérdida"},"tooltip":{},"label":{"contactS":"contacto(s)","addS":"adicional(s)","dragDropProperties":"Haga clic y arrastre el contacto para cambiar su prioridad de envío en el flujo","resetContactOnFlow":"Restablecer contacto en flujo","confirmResetContactOnFlow":"El contacto se reiniciará desde el comienzo del flujo. Quieres proceder?","confirmRemoveContactOnFlow":"¿Quieres eliminar el contacto <strong>{contact_name}</strong> del flujo <strong>{flow_name}</strong>?","messageRemoveContactOnFlow":"<strong class=\"dark-red-color\">Atenção</strong>: eliminar este contacto afectará directamente las estadísticas de flujo.","emptyCadenceFlow":"En blanco","createCadenceFlow":"Crea un flujo de cadencia desde cero","fromLibCadenceFlow":"Biblioteca","useCadenceFlow":"Usar un flujo de biblioteca como plantilla","contactsPerDay":"Contactos por dia","markAsLostIfNoReply":"Marcar como perdidos los contactos que no respondan a ninguna acción de flujo.","checkReasonForLoss":"Seleccione el motivo de la pérdida.","checkIfSendToFlow":"¿Deberían enviarse a un flujo los contactos cancelados/perdidos automáticamente al final de las acciones? En caso afirmativo, seleccione otra secuencia después de mover el switch.","labelAboutFlow":"Texto sobre el flujo <Alterar>","emailBCCIntegration":"Integración de correo electrónico con su CRM (dirección BCC inteligente)","useBCC":"Usar BCC","flowProcessing":"Tu transmisión se está actualizando. Aguarde...","flowProcessingError":"Hubo un error al crear el flujo..","removeDialogTitle":"Flujo - Eliminación de flujo","removeDialogDescription":"URL del Flujo:","removeConfirm":"¿De verdad quieres eliminar el flujo de cadencia {name}? Esta acción no se puede revertir.","removeCadenceFlowConfirm":"Está a punto de eliminar un flujo de cadencia. ¿Quieres proceder?","flowStatus":"Flujo {status}","newContactsByDay":"Nuevos contactos por día","dailyActivationLimit":"Sin límite de activación diaria","viewContactFlow":"Flujo - Visualización de contactos","viewContactFlowDescription":"Identificador de flujo","statusChangeLabel":"Flujo - Cambio de estado a {status}","statusChangeDescription":"Identificador de flujo","updateFLowSuccess":"{name} ahora está {human_status}","contactResume":"Los contactos se reanudarán en el flujo","programaticTodaySendAction":"La hora de la acción programada para hoy debe estar al menos 30 minutos por delante de la hora actual (por ejemplo, si son las 10:00 a. m., la acción \"Hoy\" debe programarse después de las 10:30 a. m.)","programaticAfterZeroAction":"El horario de acción programado para después de 0 días debe estar al menos 30 minutos por delante del tiempo de acción anterior","programaticSendAtAction":"El horario de acción no es válido","semiAutomated":"Semiautomatizado","semiAutomatedFlow":"Flujo semiautomatizado","withTaskTimerTitle":"Realice un seguimiento del tiempo desde la creación de una tarea hasta su ejecución","withTaskTimerLabel":"Es posible realizar un seguimiento del tiempo transcurrido entre la creación y la ejecución/finalización de la tarea. Al habilitar la casilla de verificación, será posible ver el recuento de tiempo de las tareas de los contactos que están en flujo entrante.","automated":"Automatizado","automatedFlow":"Flujo automatizado","noConnection":"Sin conexión","flowCreatedURL":"URL de flujo creado","flowContactsLength":"Número de contactos de flujo","flowDailyEmailLength":"Número de e-mails por día (objetivo)","flowActiveAfterCreated":"¿Activo después de la creación?","flowActiveBBC":"BCC activo","flowActionsNumber":"Número de acciones","categorySelect":"Seleccione una categoría","stepLabel":"Etapa: {step}","stepImmediately":"Envío inmediato después de la activación del flujo","stepUndefinedTime":"Envío después de la activación del flujo","stepDefinedTime":"Envío a {time}","stepAfterFlow":"{time} después de crear el flujo","stepAfterStep":"{time} después de la etapa {step}","executeTasks":"Realizar Actividades","clearFilters":"Borrar Filtros","errors":{"markedTriggers":"¡Ups! Hay conflictos entre los disparadores marcados.","needAction":"¡Ups! Hay disparadores configurados que requieren una acción.","needProperty":"¡Ups! Hay disparadores configurados que requieren una propiedad.","needSetTime":"¡Ups! Hay activadores configurados que necesitan un tiempo determinado.","triggerConflicts":"¡Ups! Hay conflictos entre los disparadores marcados.","invalidFormat":"Formato no válido para la hora de envío. Ejemplos: 09:00 a. m., 02:30 p. m.","fieldSendAfterError":"El campo \"enviar después\" debe ser positivo","responsibleAndFlowConflictError":"No puedes tener acciones Enviar al flujo y Cambiar responsable en el mismo flujo."}},"actions":{"insertContacts":"Insertar contactos","contactsBase":"Base de contacto","manually":"Manualmente","new":"Crear flujo","save":"Guardar flujo","editType":"Edición","find":"Buscar flujo","activateAfterCreate":"Activar flujo después de la creación","newFromLib":"Nuevo de la biblioteca","retryAfterError":"Reintentar después del error","contactsRollback":"Reanudar contactos interrumpidos","addTrigger":"Agregar disparador","sendAsReply":"Enviar como respuesta","addAction":"Añadir acción"},"feedback":{"removeSuccess":"Flujo eliminado con éxito","unknownError":"Ocurrieron errores de creación de flujo de cadencia","unknownErrorOnCreate":"No se pudo crear la transmisión debido a un error desconocido","noDataText":"No hay más resultados","noResults":"No hay resultados","reportSand":"Informe(s) que se está generando"},"reports":{"label":{"generate":"Exportar","canceled":"Cancelar","title":"Exportar informes","periodLabel":"Seleccione el período que desea exportar: ","addContact":"Contactos agregados","activatedContacts":"Contactos activados","activeContact":"Contactos activos","connectedContact":"Contactos conectados","lostContact":"Contactos perdidos","tasksRealized":"Tarefas realizadas"},"time":{"today":"Hoy","week":"Esa semana","month":"Ese mes","year":"Ese año"}},"text":{"fromPreviousAction":"de la acción anterior","noLimitWarning":"Cuando se activa este flujo, también se activarán todos los contactos que contiene. ¿Quieres proceder?","limitChangeWarning":"El nuevo limite entrará en vigor a partir del día siguiente. Los contactos ya activados no se verán afectados"}}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

	module.exports = {"title":{},"tooltip":{},"label":{"duplicatedField":"'{field}' Esta en uso","invalidField":"'{field_value}' no es un {field} válido","newest":"Más reciente","oldest":"Más antiguo","loading":"Carregando...","numberIntervalLimit":"Deve estar entre {min} y {max}","requiredDateField":"Elige al menos un día","yes":"Sí","no":"No","none":"ninguna","actions":"acciones","days":"días","hours":"horas","minutes":"min","after":"após","today":"hoy","weeks":"semanas","months":"meses","at":"a las {time}","generalAt":"a las","immediately":"inmediatamente","sun":"dom","mon":"lun","tue":"mar","wed":"mie","thu":"jue","fri":"vie","sat":"sáb","user":"Responsable","Manually":"Manualmente","others":"Otros","here":"aqui","active":"Activo","inactive":"Inactivo","lostReasons":"Motivos de Pérdida"},"actions":{"back":"Regresar","cancel":"Cancelar","confirm":"Confirmar","conclude":"Concluir","remove":"Remover","delete":"Eliminar","confirm_actions":"Confirmar acciones","select":"Seleccione","retry":"Intentar nuevamente","toView":"Visualizar","edit":"Editar","new":"Nuevo","create":"Crear","options":"Opciones","close":"Cerrar","save":"Guardar","saveWithLabel":"Guardar {label}","createWithLabel":"Crear {label}","disconnect":"Desconectar","connect":"Conectar","copy":"Copiar","copied":"Copiado","configure":"Configurar","chooseEnv":"Elegir ambiente","ok":"Ok","connectedTo":"Conectado a","disconnectedTo":"Desconectado de","notConfigured":"No configurado","ignore":"Ignorar","verified":"Controlado","verify":"Controlar"},"feedback":{"actionNotAllowed":"No cuenta con permiso para realizar esta acción.","unknownError":"Un error desconocido a ocurrido","loading":"Cargando...","settingSaved":"Configuración guardada con éxito","settingUpdated":"Configuración actualizada con éxito","updateError":"Error al actualizar.","invalidUrl":"URL inválida","configEmailSuccess":"Correo electrónico configurado con éxito!","invalid":"Inválido","noResults":"No hay más resultados","domainVerified":"Controlado con éxito"},"placeholder":{"search":"Buscar..."}}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Base del grupo"},"subtitle":{},"attributes":{"Name":"Nombre","name":"nombre","Responsible":"Responsable","groupName":"Nombre del grupo"},"tooltip":{},"label":{"group":"Grupo","groups":"grupos","manuallyInsertSuccessTitle":"Base de contactos - contactos ingresados ​​manualmente","contacts":"contacto(s)","added":"añadido(s)","navBar":{"contacts":"Contactos","groups":"Grupos","businesses":"Empresas","connections":"Conexiones"}},"actions":{"create":{"title":"Crear nuevo grupo","newGroup":"Nuevo grupo","createGroup":"Crea un grupo","manuallyAdd":"Insertar manualmente","contactBaseAdd":"Base de contactos"},"update":{"title":"Editar Grupo","success":"¡Grupo editado con éxito!"},"delete":{"title":"Eliminar grupo","deleteGroups":"Eliminar grupos","message":"¿Está seguro de que desea eliminar el grupo a continuación?<br><strong style=\"color: rgb(223, 98, 114);\">{groupName}</strong>","confirm":"Sí, borrar","confirmBelow":"¿Confirma la eliminación del grupo a continuación?","checkboxConfirm":"Eliminar el grupo","andAllContacts":"y todos sus contactos","success":"¡Grupo eliminado con éxito!","fail":{"massFail":"¡No se pueden eliminar los grupos!","cantDeleteAnyOfSelected":"No tienes permiso para eliminar ninguno de los grupos seleccionados."}},"view":{"title":"Ver grupo","search":"Buscar grupo"}},"feedback":{"noGroups":"No hay grupos","noMoreResults":"No hay más resultados"}}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Integración","integrations":"Integraciones","mailProvider":"Proveedor de e-mail","api":"Integración vía API","crm":"CRM","pipedrive":"Pipedrive","nectar":"NectarCRM","salesforce":"Salesforce","carousel":"Carrusel de recepción de Leads","rdStation":"RD Station","sharpspring":"SharpSpring","leadlovers":"LeadLovers","cv":"CV CRM","vtiger":"Vtiger","hubspot":"HubSpot","webhooksCapslock":"WEBHOOKS","trigger_stages":"Configurar en qué condiciones se enviará el contacto al CRM","deal_lost":"Actualizar ofertas perdidas en CRM","properties_matching":"Correspondencia de propiedades","stages_matching":"Correspondencia de etapas","properties_table":"responsables"},"subtitle":{"mailProvider":"Proveedor de servidor de correo electrónico","api":"API integration","crm":"Customer Relationship Management","pipedrive":"CRM","nectar":"CRM","salesforce":"CRM","carousel":"Configuración del carrusel de recepción de Leads","rdStation":"CRM","cv":"CRM","rdStationMarketing":"Automatización de marketing","sharpspring":"Automatización de marketing","leadlovers":"Automatización de marketin","vtiger":"CRM","hubspot":"CRM y automatización de marketing","properties_matching":{"dragOrCreate":"Arrastre una propiedad o cree una nueva haciendo clic en el lateral.","fieldsFilled":"Los campos de nombre y E-mail ahora se completarán automáticamente."}},"attributes":{"Responsible":"Responsable","Carousel":"Carrusel","accessKey":"Clave de acceso","email":"E-mail","apiUrl":"URL de la API","lead":"Lead","contact":"Contacto","funnelName":"Nombre del embudo","funnelStage":"Número de orden de la etapa del embudo","funnelStageNumber":"ID de la etapa del embudo","stageNumber":"Número de la etapa","name":"Nombre","lastname":"Apellido","telephone":"Teléfono","cellphone":"Celular","url":"Url","contactProperties":"Propiedades de contacto","businessProperties":"Propriedades de negocio","notMatchedProperties":"Propiedades de Reev sin","position":"Cargo","address":"Dirección","variable":"Variable"},"tooltip":{"mailProvider":"Correo electrónico no sincronizado. Use el botón en el lateral para resincronizar.","api":"Este es el token que debe usarse para usar nuestra API. Póngase en contacto con nuestro equipo de soporte para obtener más información.","crm":"Los webhooks le brindan la posibilidad de enviar actualizaciones de datos sobre las actividades de sus Leads. Al cambiar un contacto a Conectado, Perdido o Cliente, su información se enviará a la siguiente URL.","saveWebhookUrl":"Para registrar e-mails entrantes y salientes en su CRM, ingrese las direcciones de correo electrónico proporcionadas por su CRM en los campos a continuación. Si desea registrarse solo enviado o solo recibido, complete solo el campo de su elección.","nectarFunnelConfig":"Configure a qué embudo y etapa del embudo se enviará su Lead cuando califique como Conectado. Si no se informa el ID del embudo y/o la etapa, el Lead se enviará a la primera etapa del embudo predeterminado.","chooseEnv":"*Verifique en su cuenta de Salesforce si tiene permiso para integrarse en un entorno Sandbox","carousel":"Este carrusel te permite distribuir los leads que llegan a Reev vía API entre tu equipo de ventas y definir cuáles y en qué orden recibirán estos leads.","sharpspringLead":"Los Leads enviados por su herramienta de automatización de marketing se pueden asignar a un carrusel de vendedores o directamente al usuario responsable del mismo. Seleccione la opción que tenga más sentido para su proceso."},"placeholder":{"funnelName":"Ingrese el nombre del embudo aquí","funnelStage":"Ingrese el número de orden de la etapa del embudo aquí","funnelStageNumber":"Ingrese la ID de la etapa aquí","stageNumber":"Ingrese la ID de la etapa aquí","funnel":"Seleccione un embudo","properties_matching":"Complete o arrastre la propiedad","stages_matching":"ID de etapa en","apiKey":"Ingrese su token de API privado aquí","cvCrmEmail":"Ingrese tu correo electrónico de CV CRM aquí.","cvCrmDomain":"Ingrese su dominio de cliente CV CRM aquí"},"label":{"ignore":"ignorar","showToken":"Ver token","apiKey":"API KEY","apiToken":"Token de autenticación de API","email":"Correo electrónico","webhookUrlForm":"Ingrese la URL donde se debe enviar el contacto aquí","nectarFunnelID":"ID del embudo","nectarFunnelIDPlaceholder":"Introduce el ID del embudo","nectarFunnelStage":"Etapa de embudo","nectarFunnelStagePlaceholder":"Ingrese el número de etapa","nectarSettingResponsible":"Correo electrónico de la persona responsable","nectarSettingResponsiblePlaceholder":"Ingrese el correo electrónico de la persona responsable","chooseEnv":"Configure con qué entorno desea integrarse.","chooseEnvOptions":"Es posible la integración con el entorno Sandbox* o el entorno de producción.","carouselModal":"Ver carrusel","sharpspringLead":"¿Qué hacer con el Lead?","setCarousel":"Configurar carrusel","contactsViaCarousel":"Distribución de contactos vía Carrusel","contactsViaResponsible":"Distribución de contactos al responsable en Automatización de marketing.","contactsViaResponsibleCRM":"Distribución de contactos al responsable en el CRM","copySettings":"Copiar la configuración de otro usuario","modal_carousel":{"leadSelect":"Seleccione los vendedores que recibirán los Leads:","lastResponsible":"Último asignado en recibir un Lead","lastResponsibleFeedback":"Ningún responsable recibió leads","nextResponsibles":"Próximos responsables","successFeedback":"¡Carrusel guardado con éxito!","failFeedback":"No se pudieron guardar los datos del carrusel."},"leadlovers":{"receiveContactsTitle":"Configurar la integración de LeadLovers > Reev","receiveText":"Los Leads enviados por su herramienta de automatización de marketing se asignarán directamente al usuario responsable del mismo. Ingrese la URL a continuación en su herramienta para enviar los leads."},"pipedrive":{"bcc_for_sent":"BCC para envío","bcc_for_reply":"BCC para respuesta","receiveContactsTitle":"Agregar contactos creados en Pipedrive a Reev."},"vtiger":{"accessKey":"Clave de acceso proporcionada por Vtiger","email":"Correo electrónico de usuario de vTiger","apiUrl":"Ingrese la URL de la API aquí","lead":"Seleccione qué entidad recibirá la información en Vtiger","success":"{message_action} Vtiger con éxito"},"cvCrm":{"clientDomain":"Dominio del cliente","receiveContactsTitle":"Agregar contactos creados en CV CRM a Reev.","webhooksUrl":"URL de Webhook","pasteUrl":"Pegue esta URL en el campo de dirección de los webhooks en CV CRM"},"hubspot":{"receiveContactsTitle":"Envío de contactos de Hubspot a Reev","receiveContacts":"Configurar el envío de contactos de Hubspot a Reev","addContacts":"Agregar contactos en etapas del ciclo de vida de Hubspot a Reev","smartLeads":"Todos los contactos enviados por Hubspot a Reev se agregarán como Smart Leads.","contactsDistributionTitle":"Configurar el modelo de distribución de contactos","eachUser":"La integración entre Hubspot y Reev se hace para cada usuario.","eachUserDescription":"Al conectar su cuenta de Reev a una cuenta de Hubspot y seleccionar esta opción de distribución, todos los contactos en Hubspot bajo su responsabilidad y que cumplan con los criterios de la etapa del ciclo de vida serán recibidos por usted aquí en Reev.","carousel":"En la distribución por Carrusel, es necesario configurar el orden en que se reciben los contactos. Haga clic en el botón lateral \"Configurar carrusel\", seleccione los usuarios que ingresarán a la distribución y, antes de salir, guarde la configuración.","carouselDescription":"De esa manera, Reev te proporcionará un código para usar en HubSpot.","configByPipeline":"Configure a qué embudo y etapa del embudo se enviará su Lead cuando califique como Conectado. Si no se informa el ID del embudo y/o la etapa, el Lead se enviará a la primera etapa del embudo predeterminado.","configByPipelineStage":"Configure a qué etapa del embudo se enviará su Lead cuando califique como Conectado. Si no se informa el ID de la etapa, el Lead se enviará a la primera etapa del embudo predeterminado.","sendContactsTitle":"Envío de contactos de Reev a Husbpot","syncContacts":"Sincroniza la información entre Reev y Hubspot, manteniendo tu stack bien integrado y los datos de tus contactos siempre actualizados."},"stages_matching":{"funnel":"Seleccione el embudo para enviar por correo","stage":"Seleccione la etapa correspondiente","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Oportunidad","client":"Cliente","customer":"Cliente","lost":"Perdido","multipleStages":"Múltiples etapas","selectPhases":"Seleccionar etapas"},"rdStationMarketing":{"contactsDistributionTitle":"Configurar el modelo de distribución de contactos","choosenModel":"Todo contacto recibido en la integración con RD Station tendrá su responsabilidad definida por el modelo elegido.","choosenModelInfo":"Para utilizar una propiedad para la distribución, solo es posible seleccionar propiedades de opción múltiple en Reev y se debe determinar un carrusel para cada opción posible.","chooseModelAction":"Elige el modelo deseado","propertyDistribution":"Distribución por Propiedad","simpleCarouselDistribution":"Distribución por Carrusel Simple","responsibleDistribution":"Distribución para el Responsable en RD Marketing","receiveLeadsInfo":"Antes de activar la recepción de leads a través de RD Station, debe configurar el orden en que se reciben los vendedores haciendo clic en el botón \"Configurar Carrusel\". De esta forma, Reev te proporcionará un código para que lo uses en RD Station.","sendContactsTitle":"Envío de contactos de Reev a la estación RD","chooseContactTag":"La integración Reev - RD Station permite que los prospectos marcados como \"Cliente\" en Reev se actualicen a \"Venta\" en RD Station. Para activar esta funcionalidad es necesario hacer clic en el botón conectar y modificar los permisos dentro de RD Station.","customerTag":"Al etiquetar un contacto como \"Cliente\" en Reev, al etiquetarlo como \"Venta\" en RD.","lostTag":"Al marcar un contacto como \"Perdido\" en Reev, marcándolo como \"Perdido\" en RD.","stagesTag":"Al marcar un contacto en la(s) etapa(s) seleccionada(s) en el lateral, Reev lo marcará como \"Oportunidad\" en el RD."},"salesforce":{"sendTo":"Seleccione si el contacto se guardará en una cola o irá directamente al usuario responsable (verificando a través del correo electrónico del usuario).","chooseData":"Seleccione qué datos enviar a Salesforce","onlyLead":"Solo los Leads","leadAndAccounts":"Leads y cuentas","leadAccountsAndOpportunities":"Leads, cuentas y oportunidades","featurePermission":"Atención: su cuenta de Salesforce no permite el uso de esta funcionalidad. Aprende más","queuePermission":"Atención: Su usuario de Salesforce no tiene permiso para usar Colas. Aprende más"},"modal_carousel_custom":{"copiedCarouselItems":"Seleccione qué artículos deben recibir el carrusel copiado","rightColumn":"La columna de la derecha corresponde a los detalles del Carrusel a copiar","chooseUsersAndOrder":"Para configurar el carrusel seleccione los usuarios y elija el orden de recepción","chooseUsers":"Seleccionar usuarios","lastResponsible":"Último asignado en recibir un Lead","carouselDetails":"Detalles del carrusel","userOrders":"Orden de usuarios","nextResponsibles":"Próximos responsables"}},"checkbox":{"productionEnv":"Entorno de producción","sandboxEnv":"Entorno de Sandbox/prueba","nectar":{"sendTasks":"Enviar tareas completadas a Nectar"},"trigger_stages":{"onCreated":"Al ser creado en Reev","onStatusConnected":"Al ser marcado como conectado","onAdvanceStage":"Al avanzar a la(s) etapa(s)","onChangeResponsibility":"Al cambiar de responsabilidad"},"updateAllUsers":"Guardar esta configuración para todos los usuarios"},"actions":{"create":{"title":""},"update":{"title":"","success":"","carousel":"Editar carrusel","deal_lost":{"update":"Actualizar negocios perdidos","notUpdate":"No actualizar negocios perdidos"}},"delete":{"title":"","message":"","confirm":"","success":"","fail":{}},"view":{"title":"","properties_matching":"VER PROPIEDADES","stages_matching":"VER PRÁCTICAS"},"email":{"setUp":{"error":{"defaultUserError":"Solo el usuario estándar puede realizar esta integración."}}}},"feedback":{"nectarSettingResponsibleInvalid":"El campo de correo electrónico responsable debe ser un correo electrónico válido","sharpspringNeedsCarousel":"Necesidad de configurar el carrusel de recibos","rememberHttps":" (recuerde comenzar con \"https\").","nectarSuccess":"{message_action} Nectar con éxito","connectedToNectar":"Conectado al néctar","disconnectedToNectar":"Desconectado de néctar","configuredBCCPipedrive":"Pipedrive BCC configurado","calendarSuccess":"¡Calendario sincronizado con éxito!","calendarFail":"¡Error al sincronizar el calendario!","salesforceDisconnectSuccess":"Desconectado de Salesforce con éxito","salesforceDisconnectEvent":"Desconectado de Salesforce","salesforceConnectSuccess":"Conectado a Salesforce con éxito","salesforceConnectEvent":"Conectado a Salesforce","rdStationCRMSuccess":"RD Station CRM guardado con éxito","rdStationDisconnectSuccess":"Desconectado de RD Station con éxito","rdStationDisconnectEvent":"Desconectado de la estación RD","rdStationConnectSuccess":"Conectado a RD Station con éxito","rdStationCRMConnectEvent":"Conectado a RD Station CRM","rdStationCRMDisconnectEvent":"Desconectado de RD Station CRM","rdStationConnectEvent":"Conectado a la estación RD","requiredFunnelStageMap":"¡Se debe completar el mapeo de etapas!","hubspotDisconnectSuccess":"HubSpot se desconectó correctamente","hubspotConnectSuccess":"Conectado a HubSpot con éxito","requiredFunnel":"El nombre del embudo es obligatorio","requiredFunnelStage":"El nombre de la etapa es obligatorio","requiredLifeCicleStage":"Requerido para completar las etapas del ciclo de vida de Hubspot a Reev.","onlyIgnoreStage":"¡Solo se puede repetir la etapa \"Ignorar\"!","pipedriveSuccess":"{message_action} Pipedrive con éxito","cvCrmSuccess":"{message_action} CV CRM con éxito","connectedToPipedrive":"Conectado a Pipedrive","disconnectedToPipedrive":"Desconectado de Pipedrive","connectedToCvCrm":"Conectado a CV CRM","disconnectedToCvCrm":"Desconectado de CV CRM","invalidApiKey":"API Key o válida","expiredAuth":"Autenticación caducada. Vuelva a autenticarse.","databaseSuccess":"Guardado en la base de datos con éxito","carouselCopySuccess":"¡Copia de carrusel realizada con éxito!","carouselCopyFail":"'No se pudieron copiar los datos del carrusel.'"}}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

	module.exports = {"soft_bounce":{"generic":"El servidor de correo electrónico del contacto ha rechazado su e-mail en este momento. El envío ha sido reprogramado para el día siguiente.","message_rejected":"El servidor de correo electrónico del contacto ha rechazado su e-mail en este momento. El envío ha sido reprogramado para el día siguiente. {attempts}/{max_attempts} intentos","account_failure":"El e-mail no se envió porque su cuenta no estaba sincronizada en el momento del envío. El envío del e-mail se ha reprogramado para el día siguiente. {attempts}/{max_attempts} intentos","limit_exceeded":"El e-mail no se envió porque superó el límite de envío del día. El envío del e-mail se ha reprogramado para el día siguiente. {attempts}/{max_attempts} intentos","service_failure":"El e-mail no se envió porque hubo un problema con el servidor de envío. El envío del e-mail fue reprogramado para el día siguiente. {attempts}/{max_attempts} intentos","unknown":"El e-mail no se envió porque hubo un problema en el momento del envío. El envío del e-mail fue reprogramado para el día siguientee. {attempts}/{max_attempts} intentos"}}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Plantillas","edit":"Editar plantilla"},"modal":{"edit":{"title":"Editar Platillas","titleSpecific":"Editar Plantilla {name}"}},"subtitle":{},"attributes":{"stage":"Etapa","category":"Categoría","user":"Responsable","subject":"Asunto","emailSignature":"Firma de email","name":"Nombre","content":"Contenido","nameTemplate":"Nombre de la plantilla","nameLinkedin":"Nombre de la plantilla de LinkedIn","nameSocial":"Nombre del mensaje de la red social","nameRoadMap":"Nombre del guión","contentLinkedin":"Contenido de ce-mail","contentSocial":"Contenido del mensaje de las redes sociales","contentEmail":"Contenido del e-mail","contentCall":"Contenido del guión de llamada","template":"Plantilla","roadMap":"Guión","linkedin":"InMail","social":"Mensaje","variable":"variabel"},"options":{"all":"Todos los tipos","call":"Llamada","email":"E-mail","linkedin":"LinkedIn","social":"Social","userSelect":"Seleccione un usuario","categorySelect":"Seleccione una categoría"},"tooltip":{},"label":{"optionsLabel":"Esta plantilla se está utilizando en <strong>{actionsCountText}</strong>. Seleccione la opción deseada:","selectTemplate":"Seleccione el tipo de plantilla que desea crear:","templateViewer":"Plantilla - Visualización","templateEditing":"Plantilla - Edición","templateManualSearch":"Plantilla - Búsqueda manual realizada","saveSuccess":"Plantilla guardada con éxito","templateURL":"URL de la plantilla creada","imagesContentLength":"Número de imágenes en el contenido.","hiperlinksContentLength":"Número de hipervínculos en el contenido","imagesSignatureLength":"Número de imágenes en la firma","hiperlinksSignatureLength":"Número de hipervínculos de firma","characterLimit60":"Los asuntos de más de 60 caracteres no aparecerán completos para sus leads","characterLimit40":"Los asuntos de más de 40 caracteres podrán cortarse","emailOpen":"Apertura","emailReply":"Respuesta","conversion":"Conversión","preShow":"Vista previa","removeTemplateConfirm":"Está a punto de eliminar una plantilla. ¿Desea proceder?","removeTemplateByNameConfirm":"¿De verdad quieres eliminar la plantilla <b>{name}</b>? Esta acción no se puede revertir","editTemplateAction":"Al editar la plantilla para esta acción, se eliminarán todas las plantillas ya editadas para los contactos en esa etapa..","templateVariableUsing":"Plantilla - Uso de la variable {name}","allCategories":"Todas las categorias"},"actions":{"new":"Nueva plantilla","update":"Actualizar plantilla","edit":"Cambiar plantilla","updateAtFlows":"Actualizar la plantilla en los flujos","createOnEdit":"Crear una nueva plantilla a partir de la edición","search":"Buscar plantillas","save":"Guardar Plantilla"},"feedback":{"removeSuccess":"Plantilla eliminada con éxito","createSuccess":"Plantilla creada con éxito","removeFail":"No se pudo eliminar la plantilla","noDataText":"Aún no tienes ninguna Plantilla","noDataResults":"No hay más resultados","noActions":"Ninguna acción usa platillas."}}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

	module.exports = {"title":{},"subtitle":{},"attributes":{"name":"Nombre","email":"E-mail","timezone":"Huso horario","signature":"Firma","role":"Ocupación","status":"Estado","company":"Empresa"},"status":{"active":"Activo","pending":"Pendiente"},"role":{"admin":"Administrador","manager":"Gerente de Cuentas","seller":"Ejecutivo de ventas","monitoringManager":"Gerente de seguimiento","sdr":"SDR"},"tooltip":{},"label":{"me":"yo","guestPending":"Invitado (pendiente de confirmación)"},"actions":{"update":{"success":"Usuario actualizado con éxito","role":"Cambió la Ocupación de un usuario"},"invite":{"resend":"Reenviar invitacíon","resendSuccess":"E-mail reenviado con éxito"},"delete":{"delete":"Borrar usuario"},"error":{"changeEmail":"El usuario debe cambiar el correo electrónico o la Ocupación antes de guardar"}},"feedback":{}}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

	module.exports = {"call_status":{"idle":"Inactivo","calling":"Llamando","connected":"En llamada","ended":"Llamada terminada","failed":"Llamada terminada"},"error_messages":{"generic":"Hubo un error con su servicio de VoIP. Inténtalo más tarde o ponte en contacto con el servicio de asistencia.","unauthorized_manager":"Acceso al VoIP no autorizado. Para obtener más información, comuníquese con el equipo de CS de Reev.","unauthorized":"Acceso al VoIP no autorizado. Para obtener más información, comuníquese con su gerente de cuenta.","web_rtc_support":"Este navegador no es compatible con la realización de llamadas VoIP","authentication":"Ocurrió un error de autenticación en el servicio de VoIP. Inténtalo más tarde o ponte en contacto con el servicio de asistencia.","mic_permission":"El micrófono está bloqueado para el uso del navegador. Habilitar para hacer llamadas","ongoing_call":"Ya hay una llamada en curso.","failed_status":{"User Denied Media Access":"Micrófono no habilitado","Canceled":"Cancelada","Not Found":"Número inexistente","Busy":"Número ocupado o inexistente","Unavailable":"No contestado"}}}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Base de Empresas","linkedContacts":"Contatos vinculados"},"subtitle":{},"attributes":{"name":"Nome/Domínio","address":"Endereço","status":"Status","stage":"Estágio","tag":"Tag","tags":"Tags","contacts":"Contatos","domain":"Domínio"},"tooltip":{},"label":{"statusOptions":{"all":"Todos os status","active":"Ativo","bounced":"Bounce","connected":"Conectado","uninitialized":"Não iniciado","paused":"Pausado","converting":"Pendente","scheduled":"Agendado","interrupted":"Interrompido","blocklisted":"Blocklist","notConnected":"Sem Conexão","disqualified":"Desqualificado","inactive":"Inativo"},"stageOptions":{"all":"Todas os estágios","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Oportunidade","client":"Cliente","lost":"Perdido"},"details":"Detalhes da Empresa","removeCompany":"Excluir empresa","removeCompanyConfirm":"Deseja realmente excluir a empresa {name}?","companyRemoveAlert":"Empresas com contatos associados não podem ser excluídas"},"actions":{"new":"Nova empresa","contacts":"Contatos","groups":"Grupos","companies":"Empresas"},"feedback":{"removeSuccess":"Empresa removida com sucesso","saveSuccess":"Modificações salvas com sucesso","unknownFail":"Erro desconhecido ao carregar empresa","noDataText":"Sem mais resultados","errorTitle":"Ops! Algo deu errado!"},"filters":{"placeholder":"Buscar por empresas, contatos, endereços, etc..."}}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

	module.exports = {"attributes":{"name":"Nome","domain":"Domínio","email":"E-mail","plan":"Plano","service":"Serviço","emailDomain":"Dominio do email","emailService":"Serviço de e-mail","companyStatus":"Status da empresa","status":"Status","usersCount":"N° de Usuários","maxUsersCount":"Número máximo de usuários","managersCount":"N° de Gestores de Acomp.","maxManagersCount":"Número máx. de gestores de acomp.","voip":"VoIP","usedMinutes":"Minutos Utilizados","paidMinutes":"Minutos Contratados","paidMinutesUsedOnMonth":"Minutos contratados utilizados no mês","usedContacts":"Contatos Utilizados","paidContacts":"Contatos Contratados","paidContactsUsedOnMonth":"Contatos contratados utilizados no mês","additionalMinutes":"Minutos adicionais","additionalContacts":"Contatos adicionais"},"label":{"activeCompany":"Ativa","pausedCompany":"Pausada"},"actions":{"create":"Cadastrar Empresa","search":"Buscar Empresa","update":"Atualizar Empresa"},"feedback":{"serviceSaved":"Salvo com sucesso","created":"Empresa cadastrada com sucesso","updated":"Empresa atualizada com sucesso","domainWarning":"Consultado mas ainda não verificado","consummedMinutes":" - #{@additional.consumed_in_minutes()} minutos consumidos","contactsExceeded":"O número de usuários existentes excede o número máximo do plano escolhido! Modificações são necessárias para alterar o plano!"}}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Contatos","singular":"Contato"},"subtitle":{},"attributes":{"name":"nome","email":"email","password":"senha","password_confirmation":"repetir senha","current_password":"senha atual","reset_password_token":"token","subject":"assunto","body":"conteúdo","template_category_id":"categoria","company_id":"empresa","first_name":"nome","last_name":"sobrenome","business":"empresa","business_name":"nome da empresa","position":"cargo","telephone":"telefone","cellphone":"celular","address":"endereço","domain":"domínio","city":"cidade","state":"estado","country":"país","contact_group":"grupo","role":"função","timezone":"fuso horário","pipedrive_api_key":"API KEY do Pipedrive","nectar_api_key":"API KEY do NectarCRM","crm_setting":{"bcc_reply_email":"Email de resposta","bcc_send_email":"Email de envio"},"webhook_setting":{"url":"URL"},"access_key":"chave de acesso","replace_user_id":"usuário","task_service":"tipo de tarefa","due_on_time":"horário","email_domain":"domínio do email","send_at":"horário da ação","emails_per_day":"ativação diária","weekdays_to_send":"dias válidos para envio","delay_before_finishing_contact_amount":"intervalo para finalizar contato no fluxo","field":"Nome","webhook_url":"URL do webhook","url":"URL","caller_id":"Numero","meeting_type_id":"Tipo de Reunião","kind":"Tipo de propriedade","linkedIn":"LinkedIn","var1":"Variável 1","var2":"Variável 2","var3":"Variável 3","status":{"title":"Status","options":{"all":"Todos os status","active":"Ativo","bounced":"Bounce","connected":"Conectado","uninitialized":"Não iniciado","paused":"Pausado","converting":"Pendente","scheduled":"Agendado","interrupted":"Interrompido","blocklisted":"Blocklist","notConnected":"Sem Conexão","disqualified":"Desqualificado","inactive":"Inativo"}},"stage":{"title":"Estágio","options":{"all":"Todas os estágios","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Oportunidade","client":"Cliente","lost":"Perdido"}}},"tooltip":{"text":{"startedInFlow":"Lead já iniciado no fluxo"}},"label":{"contacts":"contatos","manuallyInsertSuccessTitle":"Base de contatos - contatos inseridos manualmente","manuallyInsertSuccessMessage":"Número de contatos inseridos","requiredFields":"Primeiro e último nome, email e empresa são obrigatórios.","requiredFieldsWithGroups":"Primeiro e último nome, email, grupo e empresa são obrigatórios.","customFieldsFailLoading":"Falha ao carregar os campos personalizados","removeContactConfirm":"Confirma exclusão do contato abaixo?","searchTags":"Buscar tags","searchContact":"Buscar contato"},"actions":{"add":"Adicionar contatos","delete":"Excluir contato","removeFromFlow":"Remover do fluxo"},"feedback":{"confirmCreate":"Criados {length} contatos","noDataTitle":"Não existem dados no seu gráfico de Funil","noDataText":"Realizando tarefas e interagindo com seus leads você terá acesso aos seus dados aqui","errorTitle":"Ops! Algo deu errado!","errorText":"Houve uma falha no carregamento dos dados do seu Dashboard.","noSearchResults":"Não há resultados de contatos para essa busca.","noMoreResults":"Sem mais resultados"}}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Importar lista de contatos"},"subtitle":{"errorsResume":"Resumo dos erros","nextStepsCheck":"Atenção, antes de passar para a pŕoxima etapa verifique a importação:"},"label":{"uploadStep":"Upload","validationStep":"Validação","organizationStep":"Organização","sendToBaseStep":"Envio para a base","uploadFromFile":"Upload do arquivo","howToCSVUpload":"Como enviar o arquivo?","nextStepsCheck1":"Se as informações do contato estão nas colunas corretas.","nextStepsCheck2":"Se a acentuação está correta. Caso não esteja, tente alterar a codificação do arquivo:","importConfirmTitle":"Confirmar o envio de dados","importConfirmMessage":"Contatos que estejam ativos em algum fluxo não serão enviados para um novo fluxo e nem terão sua responsabilidade transferida. Deseja continuar?","finishImportTitle":"Base de contatos - importação de contatos via CSV","finishImportMessage":"Número de contatos inseridos {num}"},"actions":{"upload":"Selecionar arquivo CSV","exampleExport":"Baixe aqui um exemplo","importAfterCheck":"Importar CSV corrigido","contactsImportOnlyFine":"Importar somente contatos sem erro","contactsImportDuplicated":"Continuar e selecionar duplicados","nextStepsCheckedContinue":"Sim, verifiquei! Próxima etapa","backToContactsPage":"Ir para a Base de Contatos","newImport":"Realizar uma nova importação","contactImport":"Importar contatos"},"feedback":{"validateUpload":"Validando o arquivo enviado. Aguarde alguns instantes...","sendingContacts":"Enviando contatos para a base e organizando. Aguarde alguns instantes...","contactsSent":"Os contatos estão sendo adicionados e organizados na sua base. Você pode continuar a utilizar o Reev enquanto isso.","s3PresignedUrlFailure":"Ocorreu um erro de comunicação com o servidor, por favor recarregue a página e tente novamente","uploadFileToS3Failure":"Falha ao realizar upload do arquivo, por favor recarregue a página e tente novamente","importSuccess":"Contatos importados com sucesso","responsabilityChangeCheck":"Os contatos já existentes poderão ter a responsabilidade alterada. Deseja continuar?","contactOwnerSelectCheck":"Apenas os contatos sob sua responsabilidade serão selecionados. Deseja continuar?"}}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Inserir contatos manualmente","manuallyPicker":"Adicionar contatos: Manualmente"},"subtitle":{},"tooltip":{},"label":{"groups":"grupos","importConfirmMessage":"Os seguintes grupos serão criados ou alterados:","manuallyInsertSuccessTitle":"Grupos - contatos inseridos manualmente","insertInfo":"Insira as informações dos contatos separadas por vírgula:"},"actions":{},"feedback":{"contactsOnExistingGroups":"Número de contatos inseridos em grupos já existentes","contactsOnNewestGroups":"Número de contatos inseridos em novos grupos","failOnCreate":"Ops! Tivemos algum problema na criação dos {type}","updatingGroup":"Seu grupo está sendo atualizado. Aguarde...","creationFail":"Ocorreu um erro na criação do grupo.","creationProblem":"Ops! Tivemos algum problema na criação do grupo","creationSuccess":"O grupo foi criado com sucesso! Os contatos serão inseridos no grupo."},"filters":{"sortBy":"Ordenar por"},"events":{"created":"Criou um grupo pela base de contatos"}}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

	module.exports = {"after":"O campo {field} deve estar depois do campo {target}","alpha_dash":"O campo {field} deve conter letras, números e traços","alpha_num":"O campo {field} deve conter somente letras e números","alpha_spaces":"The {field} só pode conter caracteres alfabéticos e espaços","alpha":"O campo {field} deve conter somente letras","before":"O campo {field} deve estar antes do campo {target}","between":"O campo {field} deve estar entre {min} e {max}","confirmed":"O campo {field} e {confirmedField} devem ser iguais","credit_card":"O campo {field} é inválido","date_between":"O campo {field} deve estar entre {min} e {max}","date_format":"O campo {field} deve estar no formato {format}","decimal":"O campo {field} deve ser numérico e deve conter {decimals == '*' ? '' : decimals} casas decimais","digits":"O campo {field} deve ser numérico e ter {length} dígitos","dimensions":"O campo {field} deve ter {width} pixels de largura por {height} pixels de altura","email":"O campo {field} deve ser um email válido","ext":"O campo {field} deve ser um arquivo válido","image":"O campo {field} deve ser uma imagem","in":"O campo {field} deve ter um valor válido","ip":"O campo {field} deve ser um endereço IP válido","max":"O campo {field} não deve ter mais que {length} caracteres","max_value":"O campo {field} precisa ser {max} ou menor","mimes":"O campo {field} deve ser um tipo de arquivo válido","min":"O campo {field} deve conter pelo menos {length} caracteres","min_value":"O campo {field} precisa ser {min} ou maior","not_in":"O campo {field} deve ser um valor válido","numeric":"O campo {field} deve conter apenas números","regex":"O campo {field} possui um formato inválido","required":"O campo {field} é obrigatório","size":"O campo {field} deve ser menor que {size} KB","url":"O campo {field} não é uma URL válida"}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

	module.exports = {"title":{"contacts":"Contatos","cadenceFlows":"Fluxos de cadência","cadenceFlowNew":"Novo fluxo de cadência","cadenceFlowEdit":"Editando fluxo de cadência","libFlows":"Biblioteca de fluxos","actions":"Ações","endContacts":"Finalizar Contatos","BCC":"BCC","flowRemove":"Você está prestes a excluir um fluxo","markAsLost":"Marcar como perdido?","noLimitWarning":"Você está prestes a salvar um fluxo sem limite de ativação diária","limitChangeWarning":"Você está prestes a alterar o limite de ativação diária do seu fluxo"},"subtitle":{"contacts":"Defina os contatos a inserir no fluxo","cadenceFlowNew":"Selecione uma opção abaixo:","libFlows":" Selecione um fluxo abaixo para utiliza-lo como modelo","actions":"Defina a sequência de atividades do fluxo","endContacts":"Selecione o tempo no qual os contatos serão finalizados/perdidos após a última ação do fluxo.","BCC":"Defina se o fluxo utilizará o endereço de BCC do seu CRM","flowRemove":"Esta ação não pode ser revertida. Deseja confirmar?"},"attributes":{"name":"Nome do fluxo","category":"Categoria do fluxo","subject":"Assunto","hasEmailsPerDay":"Ativação diária","contacts":"Contatos","conversion":"Conversão","performed":"Executadas","opening":"Abertura","reply":"Resposta"},"options":{"triggers":{"connected":"Marcado como conectado","bounced":"Marcado como bounce","lost":"Marcado como perdido","stage":"Alterado para o estágio"},"actions":{"sendToNewFlow":"Enviar para um fluxo","changeStage":"Alterar o estágio","fillProperty":"Preencher a propriedade","insertTag":"Inserir tags","insertIntoGroup":"Inserir em um grupo","changeResponsible":"Alterar o responsável"},"timming":{"immediately":"Imediatamente","nextDay":"Próximo dia","after":"Após","today":"Sempre às"},"timmingComplements":{"hours":"Horas","days":"Dias","weeks":"Semanas","months":"Meses"},"actionsTriggerWithoutStages":{"sendToNewFlow":"Enviar para um fluxo","fillProperty":"Preencher a propriedade","insertTag":"Inserir tags","insertIntoGroup":"Inserir em um grupo","changeResponsible":"Alterar o responsável"},"stages":"Selecione um estágio","properties":"Selecione uma propriedade","lostReason":"Qualquer motivo de perda"},"tooltip":{},"label":{"contactS":"contato(s)","addS":"adicionado(s)","dragDropProperties":"Clique e arraste o contato para mudar sua prioridade de envio no fluxo","resetContactOnFlow":"Resetar contato no fluxo","confirmResetContactOnFlow":"O contato reiniciará desde o início do fluxo. Deseja prosseguir?","confirmRemoveContactOnFlow":"Deseja remover o contato <strong>{contact_name}</strong> do fluxo <strong>{flow_name}</strong>?","messageRemoveContactOnFlow":"<strong class=\"dark-red-color\">Atenção</strong>: a remoção desse contato irá afetar diretamente as estatísticas do fluxo.","emptyCadenceFlow":"Em branco","createCadenceFlow":"Criar um fluxo de cadência a partir do zero","fromLibCadenceFlow":"Biblioteca","useCadenceFlow":"Usar um fluxo da biblioteca como modelo","contactsPerDay":"contatos por dia","markAsLostIfNoReply":"Marcar como perdido contatos que não responderem a nenhuma ação do fluxo.","checkReasonForLoss":"Selecione o motivo de perda.","checkIfSendToFlow":"Os contatos finalizados/perdidos automaticamente ao final das ações devem ser enviados para um fluxo? Se sim, selecione outro fluxo após mover o switch.","labelAboutFlow":"Texto sobre fluxo <Alterar>","emailBCCIntegration":"Integração de e-mail com o seu CRM (endereço de BCC inteligente)","useBCC":"Usar BCC","flowProcessing":"Seu fluxo está sendo atualizado. Aguarde...","flowProcessingError":"Ocorreu um erro na criação do fluxo.","removeDialogTitle":"Fluxo - Exclusão de fluxo","removeDialogDescription":"URL do Fluxo:","removeConfirm":"Deseja mesmo excluir o fluxo de cadência {name}? Essa ação não poderá ser revertida","removeCadenceFlowConfirm":"Você está prestes a excluir um fluxo de cadência. Deseja prosseguir?","flowStatus":"Fluxo {status}","newContactsByDay":"Novos contatos por dia","dailyActivationLimit":"Sem limite de ativação diária","viewContactFlow":"Fluxo - Visualização de contatos","viewContactFlowDescription":"Identificador do fluxo","updateFlowSuccess":"Fluxo - Mudança de status para {status}","statusChangeDescription":"Identificador do fluxo","statusChangeLabel":"{name} agora está {human_status}","contactResume":"Os contatos serão retomados no fluxo","programaticTodaySendAction":"O horário da ação programada para hoje deve ser ao menos 30 minutos à frente do horário atual (ex: se são 10h, a ação \"Hoje\" deve ser programada para após 10h30)","programaticAfterZeroAction":"O horário da ação programada para após 0 dias deve ser ao menos 30 minutos à frente do horário da ação anterior","programaticSendAtAction":"O Horário da ação é inválido","semiAutomated":"semi-automatizado","semiAutomatedFlow":"Fluxo semi-automatizado","withTaskTimerTitle":"Acompanhar o tempo de criação de uma tarefa até a execução","withTaskTimerLabel":"É possível acompanhar o tempo decorrido entre a criação da tarefa e a execução/finalização. Ao habilitar o checkbox, será possível visualizar a contagem de tempo nas tarefas de contatos que estão em fluxo inbound.","automated":"automatizado","automatedFlow":"Fluxo automatizado","noConnection":"Sem Conexão","flowCreatedURL":"URL do fluxo criado","flowContactsLength":"Número de contatos do fluxo","flowDailyEmailLength":"Número de emails por dia (objetivo)","flowActiveAfterCreated":"Ativo após criação?","flowActiveBBC":"BCC ativo","flowActionsNumber":"Número de ações","categorySelect":"Selecione uma categoria","stepLabel":"Etapa: {step}","stepImmediately":"Envio imediato após ativação do fluxo","stepUndefinedTime":"Envio após ativação do fluxo","stepDefinedTime":"Envio às {time}","stepAfterFlow":"{time} após criação do fluxo","stepAfterStep":"{time} após etapa {step}","executeTasks":"Realizar Atividades","clearFilters":"Limpar Filtros","errors":{"markedTriggers":"Ops, existem conflitos entre os gatilhos marcados.","needAction":"Ops, existem gatilhos configurados que necessitam de uma ação.","needProperty":"Ops, existem gatilhos configurados que necessitam de uma propriedade.","needSetTime":"Ops, existem gatilhos configurados que necessitam de horário definido.","triggerConflicts":"Ops, existem conflitos entre os gatilhos marcados.","invalidFormat":"Formato inválido para hora de envio. Exemplos: 09:00, 14:30","fieldSendAfterError":"O campo \"enviar após\" deve ser positivo","responsibleAndFlowConflictError":"Você não pode possuir ações de Enviar para Fluxo e Alterar Responsável em um mesmo fluxo."}},"actions":{"insertContacts":"Inserir Contatos","contactsBase":"Base de Contatos","manually":"Manualmente","new":"Criar fluxo","save":"Salvar fluxo","editType":"Edição","find":"Buscar fluxo","activateAfterCreate":"Ativar fluxo após a criação","newFromLib":"Novo a partir da biblioteca","retryAfterError":"Nova tentativa após erro","contactsRollback":"Retomar contatos interrompidos","addTrigger":"Adicionar Gatilho","sendAsReply":"Enviar como resposta","addAction":"Adicionar ação"},"feedback":{"removeSuccess":"Fluxo removido com sucesso","unknownError":"Ocorreram erros da criação do fluxo de cadência","unknownErrorOnCreate":"O fluxo não pôde ser criado devido a um erro desconhecido","noDataText":"Sem mais resultados","noResults":"Não há resultados","reportSand":"Relatório(s) sendo gerados"},"reports":{"label":{"generate":"Exportar","canceled":"Cancelar","title":"Exportar Relatórios","periodLabel":"Selecione o período que deseja exportar: ","addContact":"Contatos adicionados","activatedContacts":"Contatos ativados","activeContact":"Contatos ativos","connectedContact":"Contatos conectados","lostContact":"Contatos perdidos","tasksRealized":"Tarefas realizadas"},"time":{"today":"Hoje","week":"Essa Semana","month":"Esse mês","year":"Esse ano"}},"text":{"fromPreviousAction":"da ação anterior","noLimitWarning":"Quando este fluxo for ativado, todos os contatos que estão nele também serão ativados. Deseja prosseguir?","limitChangeWarning":"O novo limite entrará em vigor a partir do próximo dia. Os contatos já ativados não serão afetados"}}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

	module.exports = {"title":{},"tooltip":{},"label":{"duplicatedField":"'{field}' já está em uso","invalidField":"'{field_value}' não é um {field} válido","newest":"Mais recentes","oldest":"Mais antigos","loading":"Carregando...","numberIntervalLimit":"Deve estar entre {min} e {max}","requiredDateField":"Escolha pelo menos um dia","yes":"Sim","no":"Não","none":"nenhum","actions":"ações","days":"dias","hours":"horas","minutes":"min","after":"após","today":"hoje","weeks":"semanas","months":"meses","at":"às {time}","generalAt":"às","immediately":"imediatamente","sun":"dom","mon":"seg","tue":"ter","wed":"qua","thu":"qui","fri":"sex","sat":"sáb","user":"Responsável","Manually":"Manualmente","others":"Outros","here":"aqui","active":"Ativo","inactive":"Inativo","lostReasons":"Motivos de perda"},"actions":{"back":"Voltar","cancel":"Cancelar","confirm":"Confirmar","conclude":"Concluir","remove":"Remover","delete":"Excluir","confirm_actions":"Confirmar ações","select":"Selecionar","retry":"Tentar novamente","toView":"Visualizar","edit":"Editar","new":"Novo","create":"Criar","options":"Opções","close":"Fechar","save":"Salvar","saveWithLabel":"Salvar {label}","createWithLabel":"Criar {label}","disconnect":"Desconectar","connect":"Conectar","copy":"Copiar","copied":"Copiado","configure":"Configurar","chooseEnv":"Escolher ambiente","ok":"Ok","connectedTo":"Conectado ao","disconnectedTo":"Desconectado do","notConfigured":"Não configurado","ignore":"Ignorar","verified":"Verificado","verify":"Verificar"},"feedback":{"actionNotAllowed":"Você não tem permissão para executar essa ação","unknownError":"Ocorreu um erro desconhecido","loading":"Carregando...","settingSaved":"Configuração salva com sucesso","settingUpdated":"Configuração atualizada com sucesso","updateError":"Erro ao atualizar.","invalidUrl":"URL inválida","configEmailSuccess":"E-mail configurado com sucesso!","invalid":"Inválido","noResults":"Sem mais resultados","domainVerified":"Verificado com sucesso"},"placeholder":{"search":"Buscar..."}}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Base de Grupos"},"subtitle":{},"attributes":{"Name":"Nome","name":"nome","Responsible":"Responsável","groupName":"Nome do grupo"},"tooltip":{},"label":{"group":"Grupo","groups":"grupos","manuallyInsertSuccessTitle":"Base de contatos - contatos inseridos manualmente","contacts":"contato(s)","added":"adicionado(s)","navBar":{"contacts":"Contatos","groups":"Grupos","businesses":"Empresas","connections":"Conexões"}},"actions":{"create":{"title":"Criar novo grupo","newGroup":"Novo grupo","createGroup":"Criar grupo","manuallyAdd":"Inserir manualmente","contactBaseAdd":"Base de contatos"},"update":{"title":"Editar Grupo","success":"Grupo editado com sucesso!"},"delete":{"title":"Excluir Grupo","deleteGroups":"Deletar grupos","message":"Tem certeza que deseja excluir o grupo abaixo?<br><strong style=\"color: rgb(223, 98, 114);\">{groupName}</strong>","confirm":"Sim, excluir","confirmBelow":"Confirma exclusão do grupo abaixo?","checkboxConfirm":"Excluir o grupo","andAllContacts":"e todos seus contatos","success":"Grupo removido com sucesso!","fail":{"massFail":"Não foi possível deletar os grupos!","cantDeleteAnyOfSelected":"Você não tem permissão para deletar nenhum dos grupos selecionados"}},"view":{"title":"Visualizar Grupo","search":"Buscar grupo"}},"feedback":{"noGroups":"Não existem grupos","noMoreResults":"Sem mais resultados"}}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Integração","integrations":"Integrações","mailProvider":"Provedor de e-mail","api":"Integração via API","crm":"CRM","pipedrive":"Pipedrive","nectar":"NectarCRM","salesforce":"Salesforce","carousel":"Carrossel de recebimento de Leads","rdStation":"RD Station","sharpspring":"SharpSpring","leadlovers":"LeadLovers","cv":"CV CRM","vtiger":"Vtiger","hubspot":"HubSpot","webhooksCapslock":"WEBHOOKS","trigger_stages":"Configure em quais condições o contato será enviado para o CRM","deal_lost":"Atualizar negócios perdidos no CRM","properties_matching":"Correspondência de propriedades","stages_matching":"Correspondência de estágios","properties_table":"Responsáveis"},"subtitle":{"mailProvider":"E-mail Server Provider","api":"API integration","crm":"Customer Relationship Management","pipedrive":"CRM","nectar":"CRM","salesforce":"CRM","carousel":"Configuração do carrossel de recebimento de Leads","rdStation":"CRM","rdStationMarketing":"Automação de Marketing","sharpspring":"Automação de Marketing","leadlovers":"Automação de Marketing","cv":"CRM","vtiger":"CRM","hubspot":"CRM e Automação de Marketing","properties_matching":{"dragOrCreate":"Arraste uma propriedade ou crie uma nova clicando ao lado.","fieldsFilled":"Os campos de nome e e-mail ja serão preenchidos automaticamente."}},"attributes":{"Responsible":"Responsável","Carousel":"Carrossel","accessKey":"Chave de acesso","email":"E-mail","apiUrl":"URL da API","lead":"Lead","contact":"Contato","funnelName":"Nome do funil","funnelStage":"Número da ordem do estágio do funil","funnelStageNumber":"ID do estágio de funil","stageNumber":"Número do estágio","name":"Nome","lastname":"Sobrenome","telephone":"Telefone","cellphone":"Celular","url":"Url","contactProperties":"Propriedades de contato","businessProperties":"Propriedades de negócio","notMatchedProperties":"Propriedades Reev sem Correspondência","position":"Cargo","address":"Endereço","variable":"Variável"},"tooltip":{"mailProvider":"Email dessincronizado. Utilize o botão ao lado para ressincronizar.","api":"Este é o token que deve ser usado para utilizar nossa API. Entre em contato com nossa equipe de suporte para mais informações.","crm":"Webhooks oferecem a capacidade de enviar atualizações de dados sobre as atividades de seus leads. Ao alterar um contato para Conectado, Perdido ou Cliente, as informações dele serão enviadas para a URL abaixo.","saveWebhookUrl":"Para registrar e-mails enviados e recebidos em seu CRM, coloque os endereços de e-mail fornecidos por ele nos campos abaixo. Caso queira registrar somente enviados ou somente recebidos, preencha somente o campo de sua escolha.","nectarFunnelConfig":"Configure para qual funil e etapa do funil o seu lead será enviado ao ser qualificado como Conectado. Caso o ID do funil e/ou o estágio não sejam informados, o lead será enviado para o primeiro estágio do funil padrão.","chooseEnv":"*Verifique em sua conta Salesforce se você possui a permissão para integração em ambiente de Sandbox","carousel":"Este carrossel permite que você distribua os leads que chegam ao Reev via API entre sua equipe de vendedores e defina quais e em qual ordem eles irão receber esses leads.","sharpspringLead":"Os leads enviados pela sua ferramenta de automação de marketing podem ser atribuídos a um carrossel de vendedores ou diretamente para o usuário responsável por ele. Selecione a opção que faz mais sentido para o seu processo."},"placeholder":{"funnelName":"Insira aqui o Nome do funil","funnelStage":"Insira aqui o número da ordem do estágio do funil","funnelStageNumber":"Insira aqui o ID do estágio","stageNumber":"Insira aqui o ID do estágio","funnel":"Selecione um funil","properties_matching":"Preencha ou arraste a propriedade","stages_matching":"ID do estágio no","apiKey":"Insira aqui o seu token privado de API","cvCrmEmail":"Insira aqui o seu e-mail do CV CRM","cvCrmDomain":"Insira aqui o seu domínio de cliente do CV CRM"},"label":{"ignore":"ignorar","showToken":"Ver token","apiKey":"API KEY","apiToken":"Token de autenticação da API","email":"E-mail","webhookUrlForm":"Insira aqui a URL para onde o contato deve ser enviado","nectarFunnelID":"ID do funil","nectarFunnelIDPlaceholder":"Insira o ID do funil","nectarFunnelStage":"Estágio do funil","nectarFunnelStagePlaceholder":"Insira o número do estágio","nectarSettingResponsible":"E-mail do responsável","nectarSettingResponsiblePlaceholder":"Insira o e-mail do responsável","chooseEnv":"Configure com qual ambiente deseja realizar a integração.","chooseEnvOptions":"É possível integrar com o Ambiente Sandbox* ou o Ambiente de Produção.","carouselModal":"Ver carrossel","sharpspringLead":"O que fazer com o lead?","setCarousel":"Configurar Carrossel","contactsViaCarousel":"Distribuição de contatos via Carrossel","contactsViaResponsible":"Distribuição de contatos para o responsável na Automação de Marketing.","contactsViaResponsibleCRM":"Distribuição de contatos para o responsável no CRM","copySettings":"Copiar as configurações de outro usuário","modal_carousel":{"leadSelect":"Selecione os vendedores que irão receber os leads:","lastResponsible":"Último responsável a receber um lead","lastResponsibleFeedback":"Nenhum responsável recebeu leads","nextResponsibles":"Próximos responsáveis","successFeedback":"Carrossel salvo com sucesso!","failFeedback":"Os dados do carrossel não puderam ser salvos."},"leadlovers":{"receiveContactsTitle":"Configurar a integração LeadLovers > Reev","receiveText":"Os leads enviados pela sua ferramenta de automação de marketing serão atribuídos diretamente para o usuário responsável por ele. Insira a URL abaixo em sua ferramenta para que sejam enviados os leads."},"pipedrive":{"bcc_for_sent":"BCC para envio","bcc_for_reply":"BCC para resposta","receiveContactsTitle":"Adicionar contatos criados no Pipedrive ao Reev."},"vtiger":{"accessKey":"Chave de acesso fornecida pelo Vtiger","email":"E-mail do usuário vTiger","apiUrl":"Insira aqui a URL da API","lead":"Selecione qual entidade receberá as informações no Vtiger","success":"{message_action} Vtiger com sucesso"},"cvCrm":{"clientDomain":"Domínio de cliente","receiveContactsTitle":"Adicionar contatos criados no CV CRM ao Reev.","webhooksUrl":"URL do Webhook","pasteUrl":"Cole esta URL no Endereço do seu Webhook no CV CRM"},"hubspot":{"receiveContactsTitle":"Envio de Contatos Hubspot para Reev","receiveContacts":"Configure o envio de contatos da Hubspot para o Reev","addContacts":"Adicionar contatos nas fases do ciclo de vida da Hubspot ao Reev","smartLeads":"Todos os contatos enviados pela Hubspot ao Reev serão adicionados como Smart Leads.","contactsDistributionTitle":"Configure o modelo de distribuição dos contatos","eachUser":"A integração entre Hubspot e Reev é feita para cada usuário.","eachUserDescription":"Ao realizar a conexão entre a sua conta do Reev com uma conta Hubspot e selecionar essa opção de distribuição, todo contato na Hubspot sob sua responsabilidade, e atendendo aos critérios da fase do ciclo de vida, será recebido por você aqui no Reev.","carousel":"Na distribuição por Carrossel, é necessário configurar a ordem de recebimento dos contatos. Clique no botão \"Configurar Carrossel\" ao lado, selecione os usuários que entrarão na distribuição e, antes de sair, salve as configurações.","carouselDescription":"Dessa maneira, o Reev vai fornecer um código para você utilizar na HubSpot.","configByPipeline":"Configure para qual funil e etapa do funil o seu lead será enviado ao ser qualificado como Conectado. Caso o ID do funil e/ou o estágio não sejam informados, o lead será enviado para o primeiro estágio do funil padrão.","configByPipelineStage":"Configure para qual estágio de funil o seu lead será enviado ao ser qualificado como Conectado. Caso o ID do estágio não seja informado, o lead será enviado para o primeiro estágio do funil padrão.","sendContactsTitle":"Envio de Contatos Reev para Husbpot","syncContacts":"Sincronize as informações entre Reev e Hubspot, mantendo seu stack bem integrado e os dados sobre seus contatos sempre atualizados."},"stages_matching":{"funnel":"Selecione o funil para correspondência","stage":"Selecione o estágio correspondente","smartLead":"Smart Lead","prospect":"Prospect","lead":"Lead","mql":"MQL","sql":"SQL","opportunity":"Oportunidade","client":"Cliente","customer":"Cliente","lost":"Perdido","multipleStages":"Múltiplos estágios","selectPhases":"Selecione os estágios"},"rdStationMarketing":{"contactsDistributionTitle":"Configure o modelo de distribuição dos contatos","choosenModel":"Todo contato recebido na integração com a RD Station terá sua responsabilidade definida pelo modelo escolhido.","choosenModelInfo":"Para usar uma propriedade para distribuição, só é possível selecionar propriedades de múltipla escolha no Reev e um carrossel deve ser determinado para cada opção possível.","chooseModelAction":"Escolha o modelo desejado","propertyDistribution":"Distribuição por Propriedade","simpleCarouselDistribution":"Distribuição por Carrossel Simples","responsibleDistribution":"Distribuição para o Responsável no RD Marketing","receiveLeadsInfo":"Antes de ativar o recebimento de leads via RD Station, você deve configurar a ordem de recebimento dos vendedores clicando no botão \"Configurar Carrossel\". Dessa maneira, o Reev vai fornecer um código para você utilizar na RD Station.","sendContactsTitle":"Envio de Contatos Reev para RD Station","chooseContactTag":"A integração Reev - RD Station permite que leads marcados como \"Cliente\" no Reev sejam atualizados para \"Venda\" na RD Station. Para ativar essa funcionalidade é necessário clicar no botão conectar e modificar as permissões dentro da RD Station.","customerTag":"Ao marcar um contato como \"Cliente\" no Reev, marcá-lo como \"Venda\" no RD.","lostTag":"Ao marcar um contato como \"Perdido\" no Reev, marcá-lo como \"Perdido\" no RD.","stagesTag":"Ao marcar um contato no(s) estágio(s) selecionado(s) ao lado, o Reev irá marcá-lo como \"Oportunidade\" no RD."},"salesforce":{"sendTo":"Selecione se o contato será salvo em uma fila ou ou irá direto para o usuário responsável (verificando através do email do usuário).","chooseData":"Selecione quais dados serão enviados para o Salesforce","onlyLead":"Apenas os Leads","leadAndAccounts":"Leads e Contas","leadAccountsAndOpportunities":"Leads, Contas e oportunidades","featurePermission":"Atenção: sua conta salesforce não permite o uso dessa funcionalidade. Saiba mais","queuePermission":"Atenção: Seu usuário do Salesforce não possui permissão para utilizar Filas. Saiba mais"},"modal_carousel_custom":{"copiedCarouselItems":"Selecione quais itens devem receber o carrossel copiado","rightColumn":"A coluna da direta corresponde aos detalhes do Carrossel a ser copiado","chooseUsersAndOrder":"Para configurar o carrossel selecione os usuários e escolha a ordem de recebimento","chooseUsers":"Selecione os usuários","lastResponsible":"Último responsável a receber um lead","carouselDetails":"Detalhes do Carrossel","userOrders":"Ordem dos usuários","nextResponsibles":"Próximos responsáveis"}},"checkbox":{"productionEnv":"Ambiente de Produção","sandboxEnv":"Ambiente de Sandbox/Teste","nectar":{"sendTasks":"Enviar tarefas realizadas ao Nectar"},"trigger_stages":{"onCreated":"Ao ser criado no Reev","onStatusConnected":"Ao ser marcado como conectado","onAdvanceStage":"Ao avançar para o(s) estágio(s)","onChangeResponsibility":"Ao mudar de responsabilidade"},"updateAllUsers":"Salvar essa configuração para todos os usuários"},"actions":{"create":{"title":""},"update":{"title":"","success":"","carousel":"Editar Carrossel","deal_lost":{"update":"Atualizar negócios perdidos","notUpdate":"Não atualizar negócios perdidos"}},"delete":{"title":"","message":"","confirm":"","success":"","fail":{}},"view":{"title":"","properties_matching":"VER PROPRIEDADES","stages_matching":"VER ESTÁGIOS"},"email":{"setUp":{"error":{"defaultUserError":"Somente o usuário padrão pode realizar esta integração."}}}},"feedback":{"nectarSettingResponsibleInvalid":"O campo email do responsável deve ser um email válido","sharpspringNeedsCarousel":"Necessário configurar o carrossel de recebimentos","rememberHttps":" (lembre-se de começar com \"https\").","nectarSuccess":"{message_action} Nectar com sucesso","connectedToNectar":"Conectou ao Nectar","disconnectedToNectar":"Desconectou do Nectar","configuredBCCPipedrive":"Configurou Pipedrive BCC","calendarSuccess":"Calendário sincronizado com sucesso!","calendarFail":"Erro ao sincronizar calendário!","salesforceDisconnectSuccess":"Desconectado do Salesforce com sucesso","salesforceDisconnectEvent":"Desconectou do Salesforce","salesforceConnectSuccess":"Conectado ao Salesforce com sucesso","salesforceConnectEvent":"Conectou ao Salesforce","rdStationCRMSuccess":"RD Station CRM salvo com sucesso","rdStationDisconnectSuccess":"Desconectado do RD Station com sucesso","rdStationDisconnectEvent":"Desconectou do RD Station","rdStationConnectSuccess":"Conectado ao RD Station com sucesso","rdStationCRMConnectEvent":"Conectou ao RD Station CRM","rdStationCRMDisconnectEvent":"Desconectou do RD Station CRM","rdStationConnectEvent":"Conectou ao RD Station","requiredFunnelStageMap":"O mapeamento de estágios deve ser preenchido!","requiredLifeCicleStage":"Necessário definir os estágios do ciclo de vida de Hubspot para Reev.","hubspotDisconnectSuccess":"Desconectado do HubSpot com sucesso","hubspotConnectSuccess":"Conectado ao HubSpot com sucesso","requiredFunnel":"O nome do funil é obrigatório","requiredFunnelStage":"O nome do estágio é obrigatório","onlyIgnoreStage":"Somente o estágio \"Ignorar\" pode ser repetido!","pipedriveSuccess":"{message_action} Pipedrive com sucesso","cvCrmSuccess":"{message_action} CV CRM com sucesso","connectedToPipedrive":"Conectou ao Pipedrive","disconnectedToPipedrive":"Desconectou do Pipedrive","connectedToCvCrm":"Conectou ao CV CRM","disconnectedToCvCrm":"Desconectou do CV CRM","invalidApiKey":"API Key inválida","expiredAuth":"Autenticação expirada. Favor autenticar novamente.","databaseSuccess":"Salvo na base de dados com sucesso","carouselCopySuccess":"Copia de carrossel realizada com sucesso!","carouselCopyFail":"'Os dados do carrosel não puderam ser copiados.'"}}

/***/ }),
/* 949 */
/***/ (function(module, exports) {

	module.exports = {"soft_bounce":{"generic":"O servidor de e-mail do contato rejeitou seu e-mail neste momento. O envio foi reagendado para o dia seguinte.","message_rejected":"O servidor de e-mail do contato rejeitou seu e-mail neste momento. O envio foi reagendado para o dia seguinte. {attempts}/{max_attempts} tentativas","account_failure":"O e-mail não foi enviado pois sua conta não estava sincronizada no momento do envio. O envio do e-mail foi reagendado para o dia seguinte. {attempts}/{max_attempts} tentativas","limit_exceeded":"O e-mail não foi enviado pois você excedeu o limite de envio para o dia. O envio do e-mail foi reagendado para o dia seguinte. {attempts}/{max_attempts} tentativas","service_failure":"O e-mail não foi enviado pois ocorreu um problema com o servidor de envio. O envio do e-mail foi reagendado para o dia seguinte. {attempts}/{max_attempts} tentativas","unknown":"O e-mail não foi enviado pois ocorreu um problema no momento do envio. O envio do e-mail foi reagendado para o dia seguinte. {attempts}/{max_attempts} tentativas"}}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

	module.exports = {"title":{"index":"Templates","edit":"Editar template"},"modal":{"edit":{"title":"Editar Templates","titleSpecific":"Editar Template {name}"}},"subtitle":{},"attributes":{"stage":"Etapa","category":"Categoria","user":"Responsável","subject":"Assunto","emailSignature":"Assinatura do e-mail","name":"Nome","content":"Conteúdo","nameTemplate":"Nome do template","nameLinkedin":"Nome do template de LinkedIn","nameSocial":"Nome da mensagem em rede social","nameRoadMap":"Nome do roteiro","contentLinkedin":"Conteúdo do InMail","contentSocial":"Conteúdo da mensagem em rede social","contentEmail":"Conteúdo do email","contentCall":"Conteúdo do roteiro de ligação","template":"Template","roadMap":"Roteiro","linkedin":"InMail","social":"Mensagem","variable":"variável"},"options":{"all":"Todos os tipos","call":"Ligação","email":"E-mail","linkedin":"LinkedIn","social":"Social","userSelect":"Selecione um usuário","categorySelect":"Selecione uma categoria"},"tooltip":{},"label":{"optionsLabel":"Este template está sendo utilizado em <strong>{actionsCountText}</strong>.<br><br>Selecione a opção desejada:","selectTemplate":"Selecione o tipo de template que você deseja criar:","templateViewer":"Template - Visualização","templateEditing":"Template - Edição","templateManualSearch":"Templates - Busca manual realizada","saveSuccess":"Template salvo com sucesso","templateURL":"URL do template criado","imagesContentLength":"Quantidade de imagens no conteúdo","hiperlinksContentLength":"Quantidade de hiperlinks no conteúdo","imagesSignatureLength":"Quantidade de imagens na assinatura","hiperlinksSignatureLength":"Quantidade de hiperlinks assinatura","characterLimit60":"Assuntos acima de 60 caracteres não aparecerão completos para os seus leads","characterLimit40":"Assuntos acima de 40 caracteres podem ser cortados","emailOpen":"Abertura","emailReply":"Resposta","conversion":"Conversão","preShow":"Pré-visualizar","removeTemplateConfirm":"Você está prestes a excluir um template. Deseja prosseguir?","removeTemplateByNameConfirm":"Deseja realmente excluir o template <b>{name}</b>?<br><br>Esta ação não pode ser revertida.","editTemplateAction":"Ao editar o template dessa ação serão excluídos todos os templates já editados para contatos nessa etapa.","templateVariableUsing":"Template - Utilização da variável {name}","allCategories":"Todas as categorias"},"actions":{"new":"Novo template","update":"Atualizar template","edit":"Alterar template","updateAtFlows":"Atualizar o template nos fluxos","createOnEdit":"Criar um novo template a partir da edição","search":"Buscar template","save":"Salvar Template"},"feedback":{"removeSuccess":"Template removido com sucesso","createSuccess":"Template criado com sucesso","removeFail":"Falha ao excluir template","noDataText":"Você ainda não possui nenhum Template","noDataResults":"Sem mais resultados","noActions":"Não há nenhuma ação utilizando templates."}}

/***/ }),
/* 951 */
/***/ (function(module, exports) {

	module.exports = {"title":{},"subtitle":{},"attributes":{"name":"Nome","email":"E-mail","timezone":"Fuso Horário","signature":"Assinatura","role":"Função","status":"Status","company":"Empresa"},"status":{"active":"Ativo","pending":"Pendente"},"role":{"admin":"Administrador","manager":"Gerente de contas","seller":"Executivo de vendas","monitoringManager":"Gerente de acompanhamento","sdr":"SDR"},"tooltip":{},"label":{"me":"eu","guestPending":"Convidado (pendente confirmação)"},"actions":{"update":{"success":"Usuário atualizado com sucesso","role":"Alterou a função de um usuário"},"invite":{"resend":"Reenviar Convite","resendSuccess":"E-mail reenviado com sucesso"},"delete":{"delete":"Excluir usuário"},"error":{"changeEmail":"Deve-se alterar o email ou a função do usuário antes de salvar"}},"feedback":{}}

/***/ }),
/* 952 */
/***/ (function(module, exports) {

	module.exports = {"call_status":{"idle":"Ocioso","calling":"Chamando","connected":"Em ligação","ended":"Ligação encerrada","failed":"Ligação encerrada"},"error_messages":{"generic":"Ocorreu um erro com o seu serviço de VoiP. Tente mais tarde ou entre em contato com o suporte","unauthorized_manager":"Acesso ao VoiP não autorizado. Para mais informações entre em contato com o time de CS do Reev","unauthorized":"Acesso ao VoiP não autorizado. Para mais informações entre em contato com gerente da conta","web_rtc_support":"Esse navegador não tem suporte para a realização de chamadas VoiP","authentication":"Ocorreu um erro de autenticação no serviço de VoiP. Tente mais tarde ou entre em contato com o suporte","mic_permission":"O microfone está bloqueado para uso do navegador. Habilite para realizar chamadas","ongoing_call":"Já existe uma chamada em andamento.","failed_status":{"User Denied Media Access":"Microfone não habilitado","Canceled":"Cancelada","Not Found":"Número inexistente","Busy":"Número ocupado ou inexistente","Unavailable":"Não atendida"}}}

/***/ }),
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAAhFBMVEXY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODY3ODwufERAAAAK3RSTlMAAgYHCBAcJCUsPT5TVGtsdHd9goiJjpCRkpSasLHFxtjb3ebs7e7v8fn+dQRWOwAAAXJJREFUWMPt2NtSwjAQBuBtMYUqIgJqARGwNBz2/d/PCyGTpLtp2jCjaPaSlq8l+ydhAgAAAGkhsVPJIgW93rBzzQyo6g5VBoQBdRMQtKwI/U2oP35ma9xvAX26Arj9CWgwmbE1GcT2x0D+p0CmxV4uRAgkFnJfpN+bdRkClYiIryC5HcobOm/ceB0IacgOpBZCL2ja43K0JZjelIVw8+AP3W+Qh/C0FFQgtRCeSyxPSEFr9UH56DPMw1J9YW1AyeigrqyyJiZbqZsPT4kBmRdHiYuxH2pB5uvmvJN/WMNQg/QBPKok1Hp+tBpDQEZLL0lge65uoCDqgXTPtVcmIWII6J7ntVWpNl25JLBt5SCA7F2PiZt3QsSPyLXoD+kFl16JjGG9c7fACZmNdoeiAdKT4I5pE2QkwTVxmiGjVfxU9oD0JPCLixd0SUKt5+0hEPPdbi4gHPL9BxChCEXIAwqvXwhV13GqkGM6vV66Hxxah4hfMtxtXAPZxmoAAAAASUVORK5CYII="

/***/ }),
/* 964 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOHB4IiBoZWlnaHQ9IjE2cHgiIHZpZXdCb3g9IjAgMCA4IDE2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1NC4xICg3NjQ5MCkgLSBodHRwczovL3NrZXRjaGFwcC5jb20gLS0+CiAgICA8dGl0bGU+UGF0aDwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxnIGlkPSJDb250YXRvLS0tVGVtcGxhdGVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC05MzUuMDAwMDAwLCAtNjIyLjAwMDAwMCkiIHN0cm9rZT0iIzAwMDAwMCI+CiAgICAgICAgICAgIDxnIGlkPSJjb250ZXVkby1kby1lLW1haWwiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM3OC4wMDAwMDAsIDU4NC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJkaWFncmFtYcOnw6NvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMjMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImFuZXhvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1NDUuMDAwMDAwLCA3LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTguNDkxODgyNywxMi44ODgwNzIyIEwxOC40OTE4ODI3LDE5LjkyNjE1NTIgQzE4LjA5MTYxMzQsMjEuOTc1Mzg1MSAxNy4wNjk4MSwyMyAxNS40MjY0NzI0LDIzIEMxMi45NjE0NjYxLDIzIDEyLDIxLjAwNjg2NDkgMTIsMTkuNzcwNTIxIEMxMiwxOC45NDYyOTE4IDEyLDE1Ljk2Mzc0MDMgMTIsMTAuODIyODY2NSBDMTIuMjQxMjUzMiw5LjYwNzYyMjE1IDEyLjk1NzA2NzYsOSAxNC4xNDc0NDM0LDkgQzE1LjkzMzAwNyw5IDE2LjYyMjE0ODMsOS45Njc0NDU1MSAxNi42MjIxNDgzLDExLjAzMjM0NDMgQzE2LjYyMjE0ODMsMTEuNzQyMjc2OCAxNi42MjIxNDgzLDE0LjIzMzM2MDkgMTYuNjIyMTQ4MywxOC41MDU1OTY0IEMxNi40NzU2NDYxLDE5LjMyODY4OTUgMTYuMDY0MDk5NSwxOS43NDAyMzYxIDE1LjM4NzUwODUsMTkuNzQwMjM2MSBDMTQuMzcyNjIyLDE5Ljc0MDIzNjEgMTMuOTQ3NTU0OSwxOS4yMTczNDYgMTMuOTQ3NTU0OSwxOC4zMDAyODI2IEMxMy45NDc1NTQ5LDE3LjY4ODkwNyAxMy45NDc1NTQ5LDE1LjgzOTExODggMTMuOTQ3NTU0OSwxMi43NTA5MTgyIiBpZD0iUGF0aCI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 965 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB2aWV3Qm94PSIxNTguODY1NDc4NTE1NjI1IDEyMi4yNDA2MjM0NzQxMjExIDEwMC4yMDc2NjQ0ODk3NDYxIDg2LjM4MTQ2MjA5NzE2Nzk3IiB3aWR0aD0iODUuNDUyMzc3MzE5MzM1OTQiIGhlaWdodD0iNzEuNTc5OTg2NTcyMjY1NjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBvbHlsaW5lIHN0eWxlPSJmaWxsOiBub25lOyBzdHJva2Utd2lkdGg6IDEyOyBzdHJva2UtbGluZWNhcDogcm91bmQ7IHN0cm9rZTogcmdiKDI1NSwgMjU1LCAyNTUpOyIgcG9pbnRzPSIyMDMuMjQ0IDIwMi4yOSAxNjcuNDU5IDE2Ni41MDUgMjA1LjE2MiAxMzAuNzEiIHRyYW5zZm9ybT0ibWF0cml4KDEsIDAsIDAsIDEsIDAsIDApIi8+CiAgPGxpbmUgc3R5bGU9InN0cm9rZS13aWR0aDogMTI7IHN0cm9rZS1saW5lY2FwOiByb3VuZDsgc3Ryb2tlOiByZ2IoMjU1LCAyNTUsIDI1NSk7IiB4MT0iMTY4Ljg5MzEyNzQ0MTQwNjI1IiB5MT0iMTY2LjAzMDUzMjgzNjkxNDA2IiB4Mj0iMjUyLjkxMTM3Njk1MzEyNSIgeTI9IjE2Ni4wMzA1MzI4MzY5MTQwNiIgdHJhbnNmb3JtPSJtYXRyaXgoMSwgMCwgMCwgMSwgMCwgMCkiLz4KPC9zdmc+"

/***/ }),
/* 966 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 967 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTUgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ3LjEgKDQ1NDIyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5jb21lbnRhcmlvczwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJMaWdhw6fDo28tZmluYWwiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJMaWdhw6fDo28iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzIzLjAwMDAwMCwgLTEwMzEuMDAwMDAwKSIgc3Ryb2tlPSIjNTc2ODc2IiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExOS4wMDAwMDAsIDYxMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJjb21lbnRhcmlvcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjA0LjAwMzkyMywgNDE4Ljg5MDYwOCkiPgogICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMTMiIHg9IjEiIHk9IjEuMzg0NDU3MjQiIHdpZHRoPSIxMi42MDk5OTk3IiBoZWlnaHQ9IjE0LjE0NzIwMzkiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNC4yMjkwMjk2MSw1LjM4MjQwMTMyIEwxMC4zODAzNDU0LDUuMzgyNDAxMzIiIGlkPSJMaW5lLTIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiPjwvcGF0aD4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNNC4yMjkwMjk2MSw4LjQ1ODA1OTIxIEwxMC4zODAzNDU0LDguNDU4MDU5MjEiIGlkPSJMaW5lLTItQ29weSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+PC9wYXRoPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik00LjIyOTAyOTYxLDExLjUzMzcxNzEgTDguODQyNTE2NDUsMTEuNTMzNzE3MSIgaWQ9IkxpbmUtMi1Db3B5LTIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxN3B4IiB2aWV3Qm94PSIwIDAgMTUgMTciIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ3LjEgKDQ1NDIyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5jb250YXRvczwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJMaWdhw6fDo28tZmluYWwiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJMaWdhw6fDo28iIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTI1LjAwMDAwMCwgLTEwMzEuMDAwMDAwKSIgc3Ryb2tlPSIjNTc2ODc2IiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTExOS4wMDAwMDAsIDYxMi4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJjb250YXRvcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC4wMDM5MjMsIDQyMC44OTA2MDgpIj4KICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLTciIGN4PSI1LjUiIGN5PSIzLjUiIHI9IjMuNSI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZD0iTTAsMTQgQzAuOTAwNjA1Mjg4LDExLjMzMzMzMzMgMi41OTYxMDI3OSwxMCA1LjA4NjQ5MjUxLDEwIEM3LjU3Njg4MjIzLDEwIDkuNTQ4MDUxNCwxMS4zMzMzMzMzIDExLDE0IEwwLDE0IFoiIGlkPSJQYXRoLTUiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTNweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTMgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT7DrWNvbmUgZGlhZ3JhbWHDp8OjbyBjb3B5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkFydGJvYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzg5LjAwMDAwMCwgLTgyMi4wMDAwMDApIj4KICAgICAgICA8ZyBpZD0iQ29tcG9zZS0xIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3NTIuMDAwMDAwLCA0MzMuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSLDrWNvbmUtZGlhZ3JhbWHDp8Ojby1jb3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzNy4wMDAwMDAsIDM4NS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSJBIiBmb250LWZhbWlseT0iTW9udHNlcnJhdC1NZWRpdW1JdGFsaWMsIE1vbnRzZXJyYXQiIGZvbnQtc2l6ZT0iMTUiIGZvbnQtc3R5bGU9Iml0YWxpYyIgZm9udC13ZWlnaHQ9IjUwMCIgZmlsbD0iIzM5NEU1RSI+CiAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjIiIHk9IjE1Ij5BPC90c3Bhbj4KICAgICAgICAgICAgICAgIDwvdGV4dD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLjUsMTcuNSBMMTIuNSwxNy41IiBpZD0iTGluZS0xMCIgc3Ryb2tlPSIjMzk0RTVFIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 970 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTRweCIgaGVpZ2h0PSI5cHgiIHZpZXdCb3g9IjAgMCAxNCA5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1MSAoNTc0NjIpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPkdyb3VwIDc8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iTm90aWZpY2HDp8O1ZXMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTg1OS4wMDAwMDAsIC0zOC4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDgxNS4wMDAwMDAsIDI3LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQ0LjAwMDAwMCwgMTEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTciPgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTgtQ29weS01IiBmaWxsPSIjRkZGRkZGIiB4PSIwIiB5PSIwIiB3aWR0aD0iMTQiIGhlaWdodD0iOC45Mzc1Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aC0zLUNvcHktNSIgc3Ryb2tlPSIjNDM0MzQzIiBwb2ludHM9IjAuODg0NzA0NTkgMS42MzA5MTA0NCA3LjAzNjkxOTk5IDYuMTYwODI5MDUgMTMuMjg0NzA0MiAxLjU5NDQ1MTkiPjwvcG9seWxpbmU+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 971 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzBweCIgaGVpZ2h0PSIyM3B4IiB2aWV3Qm94PSIwIDAgMzAgMjMiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5Hcm91cCAxMTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJBcnRib2FyZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0Ny4wMDAwMDAsIC0xMDEwLjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJvenp5LXRhc2tzIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NS4wMDAwMDAsIDk5Ny4wMDAwMDApIj4KICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTExIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMTcuMDAwMDAwLCAyNC41MDAwMDApIHJvdGF0ZSgzNjAuMDAwMDAwKSB0cmFuc2xhdGUoLTExNy4wMDAwMDAsIC0yNC41MDAwMDApIHRyYW5zbGF0ZSgxMDMuMDAwMDAwLCAxNC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zLDggQzguNzUzMzM4NjEsMi42NjY2NjY2NyAxNi40MjAwMDUzLDIuNjY2NjY2NjcgMjYsOCIgaWQ9IlBhdGgtNyIgc3Ryb2tlPSIjRjdCMDAwIiBzdHJva2Utd2lkdGg9IjIiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0wLDQgQzguOTgyOTcyODUsLTEuMzMzMzMzMzMgMTguMzE2MzA2MiwtMS4zMzMzMzMzMyAyOCw0IiBpZD0iUGF0aC03LUNvcHktMiIgc3Ryb2tlPSIjRjdCMDAwIiBzdHJva2Utd2lkdGg9IjIiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zLDEyIEM4Ljc1MzMzODYxLDYuNjY2NjY2NjcgMTYuNDIwMDA1Myw2LjY2NjY2NjY3IDI2LDEyIiBpZD0iUGF0aC03LUNvcHkiIHN0cm9rZT0iI0Y3QjAwMCIgc3Ryb2tlLXdpZHRoPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNC41MDAwMDAsIDEwLjAwMDAwMCkgcm90YXRlKDE4MC4wMDAwMDApIHRyYW5zbGF0ZSgtMTQuNTAwMDAwLCAtMTAuMDAwMDAwKSAiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsLTUiIGZpbGw9IiM2NzQzRDEiIGN4PSIxNC41IiBjeT0iOCIgcng9IjMuNSIgcnk9IjMiPjwvZWxsaXBzZT4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik04LDExIEMxMi40MTUzNTQ3LDE2LjQ3NDIzNDggMTYuNzY2OTk0OCwxOS43NDIxOTY3IDIxLjA1NDkyMDMsMjAuODAzODg1OCBDMjcuNDg2ODA4NSwyMi4zOTY0MTk1IDI2Ljc0MTA4MDMsMTMuNzY2NzQwOCAyMy44OTgwMDAzLDEzLjc2Njc0MDggQzIyLjAwMjYxMzYsMTMuNzY2NzQwOCAyMS4zOTYzMjAzLDE0LjUxMjE1MTQgMjIuMDc5MTIwMywxNi4wMDI5NzI1IiBpZD0iUGF0aC04IiBzdHJva2U9IiNGN0IwMDAiIHN0cm9rZS13aWR0aD0iMiI+PC9wYXRoPgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTYsMTEuMDI2NjYzMyBDNy4xNDU4MzMzMywxMC42ODIzMDk4IDcuMTQ1ODMzMzMsMTMuNjczNDIyMSA2LDIwIiBpZD0iUGF0aC05IiBzdHJva2U9IiNGN0IwMDAiIHN0cm9rZS13aWR0aD0iMiI+PC9wYXRoPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 972 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxMXB4IiB2aWV3Qm94PSIwIDAgMTEgMTEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8dGl0bGU+Q2xvc2UgaWNvbjwvdGl0bGU+CiAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgPGcgaWQ9IkxpZ2HDp8Ojby1maW5hbCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSI+CiAgICA8ZyBpZD0iTGlnYcOnw6NvIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMzExLjAwMDAwMCwgLTkwLjAwMDAwMCkiIHN0cm9rZT0iI0QzRDNEMyIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgPGcgaWQ9Ikdyb3VwLTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDc4LjAwMDAwMCwgNzMuMDAwMDAwKSI+CiAgICAgICAgPGcgaWQ9ImluZm9zLWNvcHktMiI+CiAgICAgICAgICA8ZyBpZD0iR3JvdXAtNCI+CiAgICAgICAgICAgIDxnIGlkPSJDbG9zZS1pY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMzQuMDAwMDAwLCAxOC4wMDAwMDApIj4KICAgICAgICAgICAgICA8cGF0aCBkPSJNOC41OTA5MDkwOSwwLjQwOTA5MDkwOSBMMC44MDc0MjM3MTMsOC4xOTI1NzYyOSIgaWQ9IkxpbmUiIHN0eWxlPSJzdHJva2U6IHJnYigyNTUsIDI1NSwgMjU1KTsiLz4KICAgICAgICAgICAgICA8cGF0aCBkPSJNOC41OTA5MDkwOSwwLjQwOTA5MDkwOSBMMC44MDc0MjM3MTMsOC4xOTI1NzYyOSIgaWQ9IkxpbmUtQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNC41MDAwMDAsIDQuNTAwMDAwKSBzY2FsZSgtMSwgMSkgdHJhbnNsYXRlKC00LjUwMDAwMCwgLTQuNTAwMDAwKSAiIHN0eWxlPSJzdHJva2U6IHJnYigyNTUsIDI1NSwgMjU1KTsiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+"

/***/ }),
/* 973 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC4yNSA4LjVDOS4zNzEgOC41IDguNjQ4IDkuMTU0NSA4LjUyNTUgMTBIMy41VjlDMy41IDguNzIzNSAzLjI3NjUgOC41IDMgOC41SDJWNkgxMC4yNUMxMC4zODggNiAxMC41IDUuODg3NSAxMC41IDUuNzVWMS43NUMxMC41IDEuNjEyIDEwLjM4OCAxLjUgMTAuMjUgMS41SDMuNVYwLjVDMy41IDAuMjIzNSAzLjI3NjUgMCAzIDBIMC41QzAuMjIzNSAwIDAgMC4yMjM1IDAgMC41VjNDMCAzLjI3NjUgMC4yMjM1IDMuNSAwLjUgMy41SDNDMy4yNzY1IDMuNSAzLjUgMy4yNzY1IDMuNSAzVjJIMTBWNS41SDEuNzVDMS42MTIgNS41IDEuNSA1LjYxMTUgMS41IDUuNzVWOC41SDAuNUMwLjIyMzUgOC41IDAgOC43MjM1IDAgOVYxMS41QzAgMTEuNzc2NSAwLjIyMzUgMTIgMC41IDEySDNDMy4yNzY1IDEyIDMuNSAxMS43NzY1IDMuNSAxMS41VjEwLjVIOC41MjU1QzguNjQ4IDExLjM0NTUgOS4zNzEgMTIgMTAuMjUgMTJDMTEuMjE1IDEyIDEyIDExLjIxNSAxMiAxMC4yNUMxMiA5LjI4NSAxMS4yMTUgOC41IDEwLjI1IDguNVpNMi41IDIuNUgxVjFIMi41VjIuNVpNMSA5LjVWMTFIMi41VjkuNUgxWiIgZmlsbD0iIzczNzM3MyIvPgo8L3N2Zz4K"

/***/ }),
/* 974 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 975 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTVweCIgaGVpZ2h0PSIxNHB4IiB2aWV3Qm94PSIwIDAgMTUgMTQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkJhc2UtZGUtQ29udGF0b3MtMi4wIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zOTguMDAwMDAwLCAtMzY0LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iQcOnw7Vlcy1lbS1tYXNzYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUuMDAwMDAwLCAzNTEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0iYnRuLWV4Y2x1aXIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMC4wMDAwMDAsIDUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Imljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIzLjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS03IiBzdHJva2U9IiMyRTQ0NTUiIHN0cm9rZS13aWR0aD0iMiIgeD0iMi42OTU4MDA3OCIgeT0iMi42OTU4MDA3OCIgd2lkdGg9IjkuMDIyNzA1MDgiIGhlaWdodD0iOS44NzA2MDU0NyI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTgiIHN0cm9rZT0iIzJFNDQ1NSIgeD0iNS41ODc0MDIzNCIgeT0iNS41ODc0MDIzNCIgd2lkdGg9IjEiIGhlaWdodD0iNC4wODc0MDIzNCI+PC9yZWN0PgogICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTgtQ29weS0yIiBzdHJva2U9IiMyRTQ0NTUiIHg9IjguNTg3NDAyMzQiIHk9IjUuNTg3NDAyMzQiIHdpZHRoPSIxIiBoZWlnaHQ9IjQuMDg3NDAyMzQiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS05IiBmaWxsPSIjMkU0NDU1IiB4PSIwIiB5PSIxLjY5NTgwMDc4IiB3aWR0aD0iMTQuNDE0MzA2NiIgaGVpZ2h0PSIxLjY5NTgwMDc4Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtOS1Db3B5IiBmaWxsPSIjMkU0NDU1IiB4PSIzLjM5MTYwMTU2IiB5PSIwIiB3aWR0aD0iNy4xOTk5OTk4MSIgaGVpZ2h0PSIxLjY5NTgwMDc4Ij48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 976 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 977 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTZweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTYgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uIHRhZ3M8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQmFzZS1kZS1Db250YXRvcy0yLjAiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJBcnRib2FyZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTMyNi4wMDAwMDAsIC0zNjUuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJBw6fDtWVzLWVtLW1hc3NhIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0NS4wMDAwMDAsIDM1MS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJidG4tdGFncyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjY1LjAwMDAwMCwgNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iYnRuIj4KICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Imljb24tdGFncyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTYuMDAwMDAwLCA5LjAwMDAwMCkiPgogICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgc3Ryb2tlPSIjMkU0NDU1IiBzdHJva2Utd2lkdGg9IjIiIHg9IjEiIHk9IjEiIHdpZHRoPSIxNCIgaGVpZ2h0PSIxMCIgcng9IjIiPjwvcmVjdD4KICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMiwwIEwxNCwwIEMxNS4xMDQ1Njk1LC0yLjAyOTA2MTI1ZS0xNiAxNiwwLjg5NTQzMDUgMTYsMiBMMTYsMTAgQzE2LDExLjEwNDU2OTUgMTUuMTA0NTY5NSwxMiAxNCwxMiBMMTIsMTIgTDEyLDAgWiIgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjMkU0NDU1Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 978 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 979 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMTkgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjEgKDQ3MjUwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uZSBtdXRlIG9mZiBjb3B5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkxpZ2HDp8OjbyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyNzguMDAwMDAwLCAtNTMyLjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJkaWFsLXRlY2xhZG8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMTkuMDAwMDAwLCAyNjkuMDAwMDAwKSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjMiPgogICAgICAgICAgICA8ZyBpZD0iaWNvbmUtbXV0ZS1vZmYtY29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU2LjAwMDAwMCwgMjYzLjAwMDAwMCkiPgogICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgeD0iOS41IiB5PSIxLjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjE0IiByeD0iMyI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuMDI1NDMzMDMsNyBDNC43MTg3MjU5LDE2LjMzMzMzMzMgNy4xODYwNDY5MiwyMSAxMi40MjczOTYxLDIxIEMxNy42Njg3NDUyLDIxIDIwLjE4OTI1OTQsMTYuMzMzMzMzMyAxOS45ODg5Mzg2LDciIGlkPSJQYXRoLTIiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMi41LDIxIEwxMi41LDI2IiBpZD0iUGF0aC0zIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 980 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjUgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjEgKDQ3MjUwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uZSBtdXRlIG9mZiBjb3B5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkxpZ2HDp8OjbyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyNzUuMDAwMDAwLCAtNTMyLjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJkaWFsLXRlY2xhZG8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDExMTkuMDAwMDAwLCAyNjkuMDAwMDAwKSI+CiAgICAgICAgICAgIDxnIGlkPSJpY29uZS1tdXRlLW9mZi1jb3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNTYuMDAwMDAwLCAyNjMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBzdHJva2U9IiM2MjQxMDAiIHN0cm9rZS13aWR0aD0iMyIgeD0iOS41IiB5PSIxLjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjE0IiByeD0iMyI+PC9yZWN0PgogICAgICAgICAgICAgICAgPHBhdGggZD0iTTUuMDI1NDMzMDMsNyBDNC43MTg3MjU5LDE2LjMzMzMzMzMgNy4xODYwNDY5MiwyMSAxMi40MjczOTYxLDIxIEMxNy42Njg3NDUyLDIxIDIwLjE4OTI1OTQsMTYuMzMzMzMzMyAxOS45ODg5Mzg2LDciIGlkPSJQYXRoLTIiIHN0cm9rZT0iIzYyNDEwMCIgc3Ryb2tlLXdpZHRoPSIzIj48L3BhdGg+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMTIuNSwyMSBMMTIuNSwyNiIgaWQ9IlBhdGgtMyIgc3Ryb2tlPSIjNjI0MTAwIiBzdHJva2Utd2lkdGg9IjMiPjwvcGF0aD4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtOCIgZmlsbD0iIzYyNDEwMCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIuMjI2MDk5LCAxMi4xODcxMDEpIHJvdGF0ZSgxNDUuMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjIyNjA5OSwgLTEyLjE4NzEwMSkgIiB4PSItMS42NDg5MDA3MyIgeT0iMTAuNjg3MTAxMSIgd2lkdGg9IjI3Ljc1IiBoZWlnaHQ9IjMiPjwvcmVjdD4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 981 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iNTBweCIgaGVpZ2h0PSI1MHB4IiB2aWV3Qm94PSIwIDAgNTAgNTAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ3ICg0NTM5NikgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+bG9nbzwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJJbnRlZ3Jhw6fDtWVzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00NTAuMDAwMDAwLCAtMjE1LjAwMDAwMCkiPgogICAgICAgICAgICA8ZyBpZD0iY29udGV1ZG8iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzMC4wMDAwMDAsIDEzMS4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxnIGlkPSJpdGVtLTEtY29weS01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMDAuMDAwMDAwLCA2OS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8ZyBpZD0ibG9nbyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjAuMDAwMDAwLCAxNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS00IiBmaWxsPSIjRjJGMkYyIiB4PSIwIiB5PSIwIiB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIHJ4PSIyIj48L3JlY3Q+CiAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSJFU1AiIGZvbnQtZmFtaWx5PSJNb250c2VycmF0LU1lZGl1bSwgTW9udHNlcnJhdCIgZm9udC1zaXplPSIxMSIgZm9udC13ZWlnaHQ9IjQwMCIgZmlsbD0iIzU3Njg3NiI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iMTQiIHk9IjI5Ij5FU1A8L3RzcGFuPgogICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+CiAgICAgICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 982 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTFweCIgaGVpZ2h0PSIxMXB4IiB2aWV3Qm94PSIwIDAgMTEgMTEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjIgKDQ3MzI3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5tYXhpbWl6YXIgY29weTwvdGl0bGU+CiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4KICAgIDxkZWZzPjwvZGVmcz4KICAgIDxnIGlkPSJBcnRib2FyZCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTcwMy4wMDAwMDAsIC00NDMuMDAwMDAwKSI+CiAgICAgICAgPGcgaWQ9IkNvbXBvc2UtMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzM4LjAwMDAwMCwgNDMzLjAwMDAwMCkiIGZpbGw9IiNGRkZGRkYiPgogICAgICAgICAgICA8ZyBpZD0ibWF4aW1pemFyLWNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDM2My4wMDAwMDAsIDguMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iVHJpYW5nbGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjAwMDAwMCwgNS4wMDAwMDApIHJvdGF0ZSg0NS4wMDAwMDApIHRyYW5zbGF0ZSgtMTAuMDAwMDAwLCAtNS4wMDAwMDApICIgcG9pbnRzPSIxMCAyIDE0IDggNiA4Ij48L3BvbHlnb24+CiAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iVHJpYW5nbGUtQ29weS0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1LjAwMDAwMCwgMTAuMDAwMDAwKSByb3RhdGUoMjI1LjAwMDAwMCkgdHJhbnNsYXRlKC01LjAwMDAwMCwgLTEwLjAwMDAwMCkgIiBwb2ludHM9IjUgNyA5IDEzIDEgMTMiPjwvcG9seWdvbj4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 983 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOXB4IiBoZWlnaHQ9IjEwcHgiIHZpZXdCb3g9IjAgMCA5IDEwIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0Ny4xICg0NTQyMikgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+bWF4aW1pemFyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkxpZ2HDp8Ojby1maW5hbCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkxpZ2HDp8OjbyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTYwOC4wMDAwMDAsIC05MC4wMDAwMDApIiBmaWxsPSIjRDhEOEQ4Ij4KICAgICAgICAgICAgPGcgaWQ9InZlcnPDo28tbWluaW1pemFkYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzg3LjAwMDAwMCwgNzMuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0ibWF4aW1pemFyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMTguMDAwMDAwLCAxNS4wMDAwMDApIj4KICAgICAgICAgICAgICAgICAgICA8cG9seWdvbiBpZD0iVHJpYW5nbGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwLjAwMDAwMCwgNC44NTcxNDMpIHJvdGF0ZSg0NS4wMDAwMDApIHRyYW5zbGF0ZSgtMTAuMDAwMDAwLCAtNC44NTcxNDMpICIgcG9pbnRzPSIxMCAyIDE0IDcuNzE0Mjg1NzEgNiA3LjcxNDI4NTcxIj48L3BvbHlnb24+CiAgICAgICAgICAgICAgICAgICAgPHBvbHlnb24gaWQ9IlRyaWFuZ2xlLUNvcHktMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4wMDAwMDAsIDkuODU3MTQzKSByb3RhdGUoMjI1LjAwMDAwMCkgdHJhbnNsYXRlKC01LjAwMDAwMCwgLTkuODU3MTQzKSAiIHBvaW50cz0iNSA3IDkgMTIuNzE0Mjg1NyAxIDEyLjcxNDI4NTciPjwvcG9seWdvbj4KICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 984 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIycHgiIHZpZXdCb3g9IjAgMCAxMiAyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+UGF0aCA2PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkFydGJvYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjgyLjAwMDAwMCwgLTQ0Ny4wMDAwMDApIj4KICAgICAgICA8ZyBpZD0iQ29tcG9zZS0yIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzguMDAwMDAwLCA0MzMuMDAwMDAwKSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiPgogICAgICAgICAgICA8cGF0aCBkPSJNMzQ0LDE1IEwzNTUuODAwNzgxLDE1IiBpZD0iUGF0aC02Ij48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),
/* 985 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIycHgiIHZpZXdCb3g9IjAgMCAxMiAyIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0Ny4xICg0NTQyMikgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+bWluaW1pemFyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkxpZ2HDp8Ojby1maW5hbCIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IkxpZ2HDp8OjbyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTI4OS4wMDAwMDAsIC05NC4wMDAwMDApIiBzdHJva2U9IiNEM0QzRDMiIHN0cm9rZS13aWR0aD0iMiI+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0yODksOTUgTDMwMC44MDA3ODEsOTUiIGlkPSJtaW5pbWl6YXIiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 986 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTlweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMTkgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjEgKDQ3MjUwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uZSBtdXRlIG9mZiBjb3B5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkxpZ2HDp8OjbyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0MTguMDAwMDAwLCAtNTMyLjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJpY29uZS1tdXRlLW9mZi1jb3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDE1LjAwMDAwMCwgNTMyLjAwMDAwMCkiIHN0cm9rZT0iIzU3Njg3NiIgc3Ryb2tlLXdpZHRoPSIzIj4KICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgeD0iOS41IiB5PSIxLjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjE0IiByeD0iMyI+PC9yZWN0PgogICAgICAgICAgICA8cGF0aCBkPSJNNS4wMjU0MzMwMyw3IEM0LjcxODcyNTksMTYuMzMzMzMzMyA3LjE4NjA0NjkyLDIxIDEyLjQyNzM5NjEsMjEgQzE3LjY2ODc0NTIsMjEgMjAuMTg5MjU5NCwxNi4zMzMzMzMzIDE5Ljk4ODkzODYsNyIgaWQ9IlBhdGgtMiI+PC9wYXRoPgogICAgICAgICAgICA8cGF0aCBkPSJNMTIuNSwyMSBMMTIuNSwyNiIgaWQ9IlBhdGgtMyI+PC9wYXRoPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 987 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjVweCIgaGVpZ2h0PSIyNnB4IiB2aWV3Qm94PSIwIDAgMjUgMjYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ4LjEgKDQ3MjUwKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uZSBtdXRlIG9mZiBjb3B5PC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkxpZ2HDp8OjbyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE0MTUuMDAwMDAwLCAtNTMyLjAwMDAwMCkiPgogICAgICAgIDxnIGlkPSJpY29uZS1tdXRlLW9mZi1jb3B5IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNDE1LjAwMDAwMCwgNTMyLjAwMDAwMCkiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBzdHJva2U9IiNGOUEwMEQiIHN0cm9rZS13aWR0aD0iMyIgeD0iOS41IiB5PSIxLjUiIHdpZHRoPSI2IiBoZWlnaHQ9IjE0IiByeD0iMyI+PC9yZWN0PgogICAgICAgICAgICA8cGF0aCBkPSJNNS4wMjU0MzMwMyw3IEM0LjcxODcyNTksMTYuMzMzMzMzMyA3LjE4NjA0NjkyLDIxIDEyLjQyNzM5NjEsMjEgQzE3LjY2ODc0NTIsMjEgMjAuMTg5MjU5NCwxNi4zMzMzMzMzIDE5Ljk4ODkzODYsNyIgaWQ9IlBhdGgtMiIgc3Ryb2tlPSIjRjlBMDBEIiBzdHJva2Utd2lkdGg9IjMiPjwvcGF0aD4KICAgICAgICAgICAgPHBhdGggZD0iTTEyLjUsMjEgTDEyLjUsMjYiIGlkPSJQYXRoLTMiIHN0cm9rZT0iI0Y5QTAwRCIgc3Ryb2tlLXdpZHRoPSIzIj48L3BhdGg+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtOCIgZmlsbD0iI0Y5QTAwRCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTIuMjI2MDk5LCAxMi4xODcxMDEpIHJvdGF0ZSgxNDUuMDAwMDAwKSB0cmFuc2xhdGUoLTEyLjIyNjA5OSwgLTEyLjE4NzEwMSkgIiB4PSItMS42NDg5MDA3MyIgeT0iMTAuNjg3MTAxMSIgd2lkdGg9IjI3Ljc1IiBoZWlnaHQ9IjMiPjwvcmVjdD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 988 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 989 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 990 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTIgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDUwLjIgKDU1MDQ3KSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5pY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkJhc2UtZGUtQ29udGF0b3MtMi4wIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzYuMDAwMDAwLCAtMzY1LjAwMDAwMCkiIGZpbGw9IiMyRTQ0NTUiPgogICAgICAgICAgICA8ZyBpZD0iQcOnw7Vlcy1lbS1tYXNzYSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDUuMDAwMDAwLCAzNTEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8ZyBpZD0icmVzcG9uc8OhdmVsIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg3MC4wMDAwMDAsIDUuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9ImJ0biI+CiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJpY29uIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMS4wMDAwMDAsIDkuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsLTciIGN4PSI2IiBjeT0iMy4zMzMzMzMzMyIgcj0iMy4zMzMzMzMzMyI+PC9jaXJjbGU+CiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMi44NDIxNzA5NGUtMTQsMTIgQzEuMjgzMjExMjEsOS4zMDY4NTc2NCAzLjI4MzIxMTIxLDcuOTYwMjg2NDYgNiw3Ljk2MDI4NjQ2IEM4LjcxNjc4ODc5LDcuOTYwMjg2NDYgMTAuNzE2Nzg4OCw5LjMwNjg1NzY0IDEyLDEyIEwyLjg0MjE3MDk0ZS0xNCwxMiBaIiBpZD0iUGF0aC01Ij48L3BhdGg+CiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4KICAgICAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=="

/***/ }),
/* 991 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 992 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 993 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 994 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 995 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOXB4IiBoZWlnaHQ9IjEzcHgiIHZpZXdCb3g9IjAgMCA5IDEzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+UGF0aCAyPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IkFydGJvYXJkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtODQ1LjAwMDAwMCwgLTEwNTUuMDAwMDAwKSI+CiAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTIiIHN0cm9rZT0iIzU3Njg3NiIgc3Ryb2tlLXdpZHRoPSIyIiBwb2ludHM9Ijg0Ni4wMTk5MTggMTA1NiA4NTEuOTQgMTA2MS4zMDE3MiA4NDYgMTA2Ni40OTMyNiI+PC9wb2x5bGluZT4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 996 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iOXB4IiBoZWlnaHQ9IjEzcHgiIHZpZXdCb3g9IjAgMCA5IDEzIiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA0OC4yICg0NzMyNykgLSBodHRwOi8vd3d3LmJvaGVtaWFuY29kaW5nLmNvbS9za2V0Y2ggLS0+CiAgICA8dGl0bGU+UGF0aCAyIENvcHkgMjI8L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZGVmcz48L2RlZnM+CiAgICA8ZyBpZD0iQXJ0Ym9hcmQiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC01OS4wMDAwMDAsIC0xMDU1LjAwMDAwMCkiPgogICAgICAgIDxwb2x5bGluZSBpZD0iUGF0aC0yLUNvcHktMjIiIHN0cm9rZT0iIzU3Njg3NiIgc3Ryb2tlLXdpZHRoPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2My45NzAwMDAsIDEwNjEuMjQ2NjMyKSByb3RhdGUoMTgwLjAwMDAwMCkgdHJhbnNsYXRlKC02My45NzAwMDAsIC0xMDYxLjI0NjYzMikgIiBwb2ludHM9IjYxLjAxOTkxNzYgMTA1NiA2Ni45NDAwMDAxIDEwNjEuMzAxNzIgNjEgMTA2Ni40OTMyNiI+PC9wb2x5bGluZT4KICAgIDwvZz4KPC9zdmc+"

/***/ }),
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "templates-action-picker-wrapper"
	  }, [_c('div', {
	    staticClass: "linked-list"
	  }, _vm._l((_vm.actions), function(action, action_index) {
	    return (!action._destroy) ? _c('div', {
	      key: action_index,
	      staticClass: "linked-item"
	    }, [_c('div', {
	      staticClass: "row action-picker"
	    }, [_c('div', {
	      staticClass: "col-sm-7"
	    }, [_c('type-picker', {
	      attrs: {
	        "reference": action_index,
	        "action": action,
	        "templates": _vm.templates,
	        "actions": _vm.actions,
	        "flow": _vm.flow,
	        "options": _vm.options
	      },
	      on: {
	        "change": _vm.setActionType
	      }
	    })], 1), _c('div', {
	      staticClass: "col-sm-4 no-padding"
	    }, [_c('send-at-picker', {
	      attrs: {
	        "reference": action_index,
	        "allow_send_at_immediately": action.is_first,
	        "action": action,
	        "actions": _vm.actions,
	        "flow": _vm.flow
	      },
	      on: {
	        "change": _vm.setActionSendAt
	      }
	    })], 1), _c('div', {
	      staticClass: "col-sm-1"
	    }, [(!action.is_first && _vm.flow.canEditActions()) ? _c('div', {
	      staticClass: "btn-icon-remove",
	      on: {
	        "click": function($event) {
	          return _vm.removeAction(action_index)
	        }
	      }
	    }) : _vm._e()])])]) : _vm._e()
	  }), 0), (_vm.flow.canEditActions()) ? _c('div', {
	    staticClass: "btn btn-clean",
	    attrs: {
	      "id": "add-action"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.addAction()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.actions.addAction')))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "templates",
	    attrs: {
	      "id": "templates-index"
	    }
	  }, [_c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.$t('template.title.index')))]), (_vm.current_user.can_manage_templates) ? _c('router-link', {
	    staticClass: "btn btn-primary pull-right",
	    attrs: {
	      "to": "/templates/criar"
	    }
	  }, [_c('div', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('template.actions.new')))]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  })], 1), _c('list')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1004 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "templates",
	    attrs: {
	      "id": "templates-new"
	    }
	  }, [_c('router-link', {
	    staticClass: "back-link",
	    attrs: {
	      "to": "/templates"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('template.actions.new')))]), _c('br'), _c('template-form', {
	    attrs: {
	      "template": _vm.template
	    },
	    on: {
	      "validation-success": _vm.save
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1005 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "new-business-modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(0), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.actions.new')))])]), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    attrs: {
	      "id": "business-form"
	    }
	  }, [_c('div', {
	    staticClass: "form-wrapper"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.name')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.business.name),
	      expression: "business.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "business-name",
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.business.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.business, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1)]), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "domain"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.domain')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.business.domain),
	      expression: "business.domain"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "business-domain",
	      "name": "domain",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.business.domain)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.business, "domain", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "address"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.address')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.business.address),
	      expression: "business.address"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "business-address",
	      "name": "address",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.business.address)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.business, "address", $event.target.value)
	      }
	    }
	  })])])])])])]), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.create')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1006 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.task.isDone()) ? _c('div', {
	    staticClass: "done-task-item"
	  }, [(_vm.element_options.icon_position == "item") ? _c('div', {
	    staticClass: "done-task-icon",
	    class: _vm.iconClass(_vm.task)
	  }) : _vm._e(), (_vm.element_options.icon_position == "text") ? _c('div', {
	    staticClass: "done-task-icon text-icon",
	    class: _vm.iconClass(_vm.task)
	  }) : _vm._e(), _c('div', {
	    staticClass: "done-task-text"
	  }, [_c('div', {
	    staticClass: "done-task-status overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.task_description))])]), _c('div', {
	    staticClass: "done-task-date"
	  }, [_c('span', [_vm._v(_vm._s(_vm.task.doneAtDate()))]), (!_vm.task.undefined_time) ? _c('span', [_vm._v("- " + _vm._s(_vm.task.doneAtHour()))]) : _vm._e()]), (_vm.element_options.show_contact) ? _c('div', {
	    staticClass: "done-task-contact clickable",
	    on: {
	      "click": function($event) {
	        return _vm.toggleTaskBar()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "spacer-15"
	  }), _c('div', {
	    staticClass: "contact-name"
	  }, [_c('span', [_vm._v(_vm._s(_vm.task.contact.full_name))])]), _c('div', {
	    staticClass: "contact-business"
	  }, [_vm._v(_vm._s(_vm.task.contact.business.name))])]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "responsible"
	  }, [_c('span', {
	    staticClass: "responsible-lable"
	  }, [_vm._v("Responsável:  ")]), _c('span', {
	    staticClass: "responsible-name"
	  }, [_vm._v(_vm._s(_vm.task.assigned_to.name || _vm.current_user.name))])]), (_vm.element_options.show_comment && _vm.task.comment) ? _c('div', {
	    ref: "element_id",
	    staticClass: "comment-task-action task-comment-icon clickable",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "right",
	      "title": _vm.tooltip_text
	    }
	  }) : _vm._e(), (!_vm.disable_toggle_done) ? _c('div', {
	    staticClass: "done-toggle glyphicon glyphicon-repeat clickable",
	    on: {
	      "click": function($event) {
	        return _vm.toggleDone()
	      }
	    }
	  }) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1007 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-header table-row"
	  }, [_c('div', {
	    staticClass: "table-col specific-template-step"
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.stage')))]), _c('div', {
	    staticClass: "table-col table-col-200 specific-template-name"
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.nameTemplate')))]), _c('div', {
	    staticClass: "table-col specific-template-category"
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.category')))]), _c('div', {
	    staticClass: "table-col table-col-200 specific-template-body"
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.subject')))]), _c('div', {
	    staticClass: "table-col-collapsed specific-template-actions"
	  }), _c('div', {
	    staticClass: "table-col-collapsed specific-template-actions"
	  })]), _c('div', {
	    staticClass: "table-body"
	  }, _vm._l((_vm.flow.actions), function(action, action_id) {
	    return _c('specific-template-list-item', {
	      attrs: {
	        "flow": _vm.flow,
	        "action": action,
	        "contact": _vm.contact
	      },
	      on: {
	        "specific-template-edit": _vm.bubbleUp,
	        "specific-template-destroy": _vm.bubbleUp
	      }
	    })
	  }), 1)])
	},staticRenderFns: []}

/***/ }),
/* 1008 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "done-tasks-feed"
	    }
	  }, [_c('h2', {
	    staticClass: "title"
	  }, [_vm._v("ÚLTIMAS TAREFAS REALIZADAS")]), _c('br'), _c('div', {
	    staticClass: "filters"
	  }, [(_vm.show_user_filter) ? _c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "options": _vm.users_options
	    },
	    on: {
	      "input": _vm.reloadTasks
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  }) : _vm._e()], 1), _c('br'), _c('div', {
	    staticClass: "done-tasks-wrapper"
	  }, [_c('list', {
	    ref: "done_tasks_list",
	    attrs: {
	      "filters": _vm.done_today_filters
	    },
	    on: {
	      "toggle-task-bar": _vm.bubbleUp
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon glyphicon glyphicon-time"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.contacts_text))]), _vm._v(" convertido(s) via RD Station há mais de " + _vm._s(_vm.minutes) + " min e você não tomou nenhuma ação.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Voip")]), (_vm.current_user.isAdmin() || _vm.current_user.isManager()) ? _c('div', [_c('hr'), _vm._m(0), _c('br'), _vm._m(1), _c('br'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('caller_id')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: (_vm.dynamicMask),
	      expression: "dynamicMask"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.caller_id),
	      expression: "caller_id"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "caller_id",
	      "name": "caller_id",
	      "type": "text",
	      "placeholder": "(00) 00000-0000"
	    },
	    domProps: {
	      "value": (_vm.caller_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.caller_id = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('caller_id')),
	      expression: "errors.has('caller_id')"
	    }],
	    key: "caller_id",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('caller_id')))])])], 1)]), _c('div', {
	    staticClass: "col-md-8"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.openModalConfirmation
	    }
	  }, [_vm._v("Salvar")])])]), _c('br')]) : _vm._e(), _c('strong', [_vm._v("DASHBOARD")]), _c('hr'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('div', {
	    staticClass: "company-name"
	  }, [_vm._v(_vm._s(_vm.current_company.name))])]), _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('div', {
	    staticClass: "progression-bar"
	  }, [_c('div', {
	    staticClass: "bar-color"
	  }), _c('div', {
	    staticClass: "bar-background",
	    style: ({
	      width: _vm.calc_bar_percentage + '%'
	    })
	  })]), _c('div', {
	    staticClass: "plan-status text-center"
	  }, [_vm._v("Plano contratado: " + _vm._s(_vm.numeric_status))]), _c('div', {
	    staticClass: "plan-status text-center"
	  }, [_vm._v("Minutos adicionais restantes: "), _c('span', {
	    staticClass: "additional-time-info"
	  }, [_vm._v(_vm._s(_vm.additional_time))])])])]), _c('hr'), _c('date-range-picker', {
	    ref: "date_range_picker",
	    attrs: {
	      "id": "date-picker-voip",
	      "this_month": true
	    },
	    on: {
	      "date-changed": _vm.dateChanged
	    }
	  }), _c('div', {
	    attrs: {
	      "id": "voip-cards"
	    }
	  }, _vm._l((_vm.voipCards), function(voipCard) {
	    return (voipCard.title) ? _c('voip-card', {
	      attrs: {
	        "number": voipCard.number,
	        "cssClass": voipCard.cssClass,
	        "title": voipCard.title,
	        "type": voipCard.type
	      }
	    }) : _vm._e()
	  }), 1), _c('hr'), _c('div', {
	    attrs: {
	      "id": "report-list"
	    }
	  }, [_c('report-list', {
	    attrs: {
	      "voipCalls": _vm.voipCalls
	    },
	    on: {
	      "next-page": _vm.loadVoipCalls
	    }
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])])], 1), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  })], 1), _c('confirm', {
	    attrs: {
	      "id": "confirm-voip-caller_id",
	      "title": "O número de ligação sera redefinido",
	      "message": "Ao definir um número de VoiP para a empresa, os números definidos para todos os usuários da empresa serão alterados. Deseja prosseguir?",
	      "reject_text": "Cancelar",
	      "confirm_text": "Confirmar"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.save
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('strong', [_vm._v("CONFIGURAÇÕES")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', [_vm._v("Qual número de telefone deve aparecer para as pessoas que receberem ligações dos meus vendedores?")])])])
	}]}

/***/ }),
/* 1011 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "contacts-manual-picker"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('contacts_group.title.manuallyPicker')))]), _vm._m(0)]), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('contacts-picker-text-csv', {
	    attrs: {
	      "has_groups": _vm.has_groups
	    }
	  })], 1), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.selectContacts
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.conclude')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1012 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Motivo de Perda")]), _vm._m(0), _c('br'), _c('br'), _c('new-lost-reason', {
	    on: {
	      "created": _vm.createdLostReason
	    }
	  }), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _vm._l((_vm.$store.getters.lostReasonsList), function(lost_reason) {
	    return _c('list-item', {
	      key: lost_reason.id,
	      attrs: {
	        "lost_reason": lost_reason
	      },
	      on: {
	        "updated": _vm.updatedLostReason,
	        "destroy": _vm.openDestroyConfirmationModal
	      }
	    })
	  })], 2)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.$store.getters.lostReasonLoading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.$store.getters.lostReasonLoading),
	      expression: "!$store.getters.lostReasonLoading"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-destroy-lost-reason",
	      "title": "Excluir motivo de perda",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroyLostReason
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Confirma exclusão do motivo de perda abaixo?")]), _c('br'), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_lost_reason.title))]), _c('br'), _c('br')])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Cadastre motivos de perda que serão atribuídos aos contatos marcados com o estágio 'Perdido'. Ex.: Falta de budget"), _c('br'), _vm._v("Os motivos de perda cadastrados aqui estarão disponíveis para todo o time de vendas.")])
	}]}

/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item",
	    class: {
	      'done-task-event': _vm.event.isDoneTaskEvent(), 'ozzy-task': _vm.event.task.wasOzzyTask()
	    }
	  }, [_c('div', {
	    staticClass: "contact-event-icon small-icon",
	    class: _vm.icon_class
	  }), _c('div', {
	    staticClass: "contact-event-header overflow-ellipsis"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), (_vm.event.flow.name) ? _c('div', {
	    staticClass: "contact-event-description"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v("do ")]), _vm._v(" Fluxo " + _vm._s(_vm.event.flow.name))]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))]), _c('div', {
	    staticClass: "clear"
	  }), (_vm.undone_at) ? _c('div', {
	    staticClass: "event-undone-time"
	  }, [_vm._v("Marcada como desfeita em " + _vm._s(_vm.undone_at.format('LLL')))]) : _vm._e()]), _c('div', {
	    staticClass: "action-bar"
	  }, [(_vm.enable_undo) ? _c('div', {
	    staticClass: "undo-btn clickable glyphicon glyphicon-repeat",
	    on: {
	      "click": _vm.undo
	    }
	  }) : _vm._e(), (_vm.event.task.comment) ? _c('div', {
	    ref: "element_id",
	    staticClass: "comment-task-action task-comment-icon clickable",
	    attrs: {
	      "id": _vm.element_id,
	      "data-toggle": "tooltip",
	      "title": _vm.tooltip_text,
	      "data-placement": "left"
	    }
	  }) : _vm._e()]), _c('div', {
	    staticClass: "user"
	  }, [_c('user-miniature', {
	    attrs: {
	      "user": _vm.event.task.assigned_to,
	      "options": {
	        only_picture: true
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": _vm.id
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-specific-template",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(0), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
	    staticClass: "row specific-template-subheader"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_vm._v(_vm._s(_vm.contact.full_name) + " - " + _vm._s(_vm.business_name))])])]), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.show_form) ? _c('template-form', {
	    staticClass: "internal-scroller",
	    attrs: {
	      "id": 'specific-template-form',
	      "options": _vm.form_options,
	      "template": _vm.current_template,
	      "default_template_kind": _vm.template_kind
	    },
	    on: {
	      "validation-success": _vm.updateSpecificTemplate
	    }
	  }) : _c('specific-templates-list', {
	    attrs: {
	      "flow": _vm.flow,
	      "contact": _vm.contact
	    },
	    on: {
	      "specific-template-edit": _vm.openSpecificTemplateForm,
	      "specific-template-destroy": _vm.destroySpecificTemplate
	    }
	  }), _c('div', {
	    staticClass: "no-email-actions",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.has_valid_email_actions),
	      expression: "!has_valid_email_actions"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('template.feedback.noActions')))])])], 1), (_vm.show_form) ? _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('a', {
	    staticClass: "btn btn-gray",
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.actions.save')))])]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1015 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div')
	},staticRenderFns: []}

/***/ }),
/* 1016 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    on: {
	      "click": function($event) {
	        return $event.stopPropagation()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "lupa glyphicon glyphicon-search"
	  }), _c('v-autocomplete', {
	    attrs: {
	      "id": _vm.id,
	      "items": _vm.stages,
	      "component-item": _vm.template,
	      "input-attrs": _vm.attrs,
	      "keep-open": _vm.show_stages,
	      "auto-select-one-item": false
	    },
	    on: {
	      "change": _vm.filterStages
	    },
	    model: {
	      value: (_vm.stage),
	      callback: function($$v) {
	        _vm.stage = $$v
	      },
	      expression: "stage"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses()
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text",
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_vm._v(_vm._s(_vm.name) + " possui "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.contact_name))]), _vm._v(" "), _c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.flow_name))]), _vm._v(" agendada para " + _vm._s(_vm.due_on) + ".")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))]), (!_vm.multiple_tasks && !_vm.done_task) ? _c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [(_vm.show_do_task) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.loadTask(_vm.notification.kind)
	      }
	    }
	  }, [_vm._v("Executar tarefa")])]) : _vm._e(), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.loadTask("mark_as_done")
	      }
	    }
	  }, [_vm._v("Marcar como feita")])])])]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "actions dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }, [_c('div', {
	    staticClass: "bullet"
	  }), _c('div', {
	    staticClass: "bullet"
	  }), _c('div', {
	    staticClass: "bullet"
	  })])
	}]}

/***/ }),
/* 1018 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row clickable"
	  }, [(_vm.editing) ? [_c('div', {
	    staticClass: "table-col table-col-120"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('title')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "title",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })])])] : [_c('div', {
	    staticClass: "table-col table-col-120"
	  }, [_vm._v(_vm._s(_vm.meeting_type.title))])], _c('div', {
	    staticClass: "table-col table-col-80"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [(_vm.editing) ? _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")]) : _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        _vm.editing = !_vm.editing
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.editing ? 'Cancelar' : 'Editar'))]), _c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": _vm.destroymeetingType
	    }
	  }, [_vm._v("Excluir")])])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1019 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    on: {
	      "click": function($event) {
	        return $event.stopPropagation()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "lupa glyphicon glyphicon-search"
	  }), _c('span', {
	    staticClass: "remove glyphicon glyphicon-remove",
	    on: {
	      "click": _vm.clearInput
	    }
	  }), _c('v-autocomplete', {
	    ref: "tag_autocomplete",
	    attrs: {
	      "id": _vm.id,
	      "items": _vm.tags,
	      "component-item": _vm.template,
	      "input-attrs": _vm.attrs,
	      "keep-open": _vm.show_tags,
	      "auto-select-one-item": false,
	      "getLabel": _vm.getLabel
	    },
	    on: {
	      "change": _vm.filterTags,
	      "item-clicked": _vm.itemClicked
	    },
	    model: {
	      value: (_vm.tag),
	      callback: function($$v) {
	        _vm.tag = $$v
	      },
	      expression: "tag"
	    }
	  }), _c('hr', {
	    staticClass: "full"
	  }), (_vm.tags.length == 0) ? _c('div', {
	    staticClass: "tag-actions-buttons"
	  }, [_c('span', [_vm._v("Nenhuma tag foi encontrada")])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1020 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('selected_template_id')
	    },
	    on: {
	      "change": _vm.revalidate
	    }
	  }, [(_vm.show_select) ? _c('div', {
	    staticClass: "footer",
	    class: {
	      'has-error': _vm.errors.has('selected_template_id')
	    }
	  }, [_c('template-autocomplete', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.select_validation),
	      expression: "select_validation"
	    }],
	    attrs: {
	      "kind": _vm.template_kind,
	      "open_template_modal": true,
	      "external_id": _vm.action.step,
	      "user_id": _vm.flow.user_id,
	      "data-vv-name": "selected_template_id"
	    },
	    on: {
	      "template-selected": _vm.templateSelected,
	      "destroy-created-template": _vm.destroyCreatedTemplate,
	      "open-template-modal": _vm.openCreateTemplateModal
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "action-wrapper cancel-wrapper"
	  }, [(_vm.show_cancel_editing) ? _c('button', {
	    staticClass: "cancel-editing btn btn-sm",
	    on: {
	      "click": _vm.cancelEditing
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]) : _vm._e()]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.show_select),
	      expression: "!show_select"
	    }],
	    staticClass: "template-name"
	  }, [_vm._v(_vm._s(_vm.action.name)), _c('div', {
	    staticClass: "action-wrapper"
	  }, [(!_vm.options.disabled) ? _c('button', {
	    staticClass: "edit-template btn btn-sm button-tooltip pull-right",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": _vm.$t('template.label.editTemplateAction'),
	      "data-placement": "top"
	    },
	    on: {
	      "click": _vm.editTemplate
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.actions.edit')))]) : _vm._e()])]), _c('create-template-modal', {
	    attrs: {
	      "element_id": _vm.create_modal_element_id,
	      "template": _vm.created_template,
	      "options": _vm.template_modal_options
	    },
	    on: {
	      "validation-success": _vm.createTemplate,
	      "cancel": _vm.cancelTemplateChange,
	      "destroy": _vm.destroyCreatedTemplate
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    attrs: {
	      "id": "flows-show"
	    }
	  }, [_c('confirm-modal', {
	    attrs: {
	      "id": "confirm-destroy-flow-modal",
	      "title": _vm.$t('flows.title.flowRemove'),
	      "message": _vm.$t('flows.subtitle.flowRemove'),
	      "confirm_text": _vm.$t('general.actions.delete'),
	      "confirm_class": "btn-danger",
	      "visible": _vm.confirming_destroy_flow
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroyConfirmed
	    }
	  }), _c('back-link'), _c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.flow.name))]), _c('div', {
	    staticClass: "extra-config dropdown-export-menu pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-primary dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openTaskModalForm()
	      }
	    }
	  }, [_c('img', {
	    staticClass: "icon",
	    attrs: {
	      "src": __webpack_require__(250)
	    }
	  })])]), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
	    staticClass: "dropdown pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-primary flow-show-actions btn-options dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-cog"
	  }), _c('span', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.options')))]), _c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })]), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [(_vm.flow.interrupted_contacts) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.reengageContacts
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.actions.contactsRollback')) + " ")])]) : _vm._e(), _c('li', [_c('a', {
	    on: {
	      "click": _vm.confirmDestroy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.editFlow
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))])])])]) : _vm._e(), _c('div', {
	    staticClass: "flow-status-toggler-wrapper pull-right"
	  }, [_c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleFlowStatus()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.flow.isPublished()
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('flows.label.flowStatus', {
	    status: _vm.flow.human_status
	  })))])])])]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "flow-details"
	  }, [_c('div', {
	    staticClass: "flow-actions-count"
	  }, [_vm._v(_vm._s(_vm.flow.actions_count) + " " + _vm._s(_vm.$t('general.label.actions')))]), _c('div', {
	    staticClass: "flow-days-count"
	  }, [_vm._v(" " + _vm._s(_vm.flow.duration_in_days) + " " + _vm._s(_vm.$t('general.label.days')))]), _c('div', {
	    staticClass: "flow-weekdays-to-send"
	  }, [_vm._v(_vm._s(_vm.flow.human_weekdays_to_send.join(', ')))]), (_vm.flow.emails_per_day) ? _c('div', {
	    staticClass: "flow-new-contacts"
	  }, [_vm._v(_vm._s(_vm.flow.emails_per_day) + " " + _vm._s(_vm.$t('flows.label.newContactsByDay')) + " ")]) : _c('div', {
	    staticClass: "flow-new-contacts"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.dailyActivationLimit')))])]), _c('div', {
	    staticClass: "flow-statistics"
	  }, [_c('div', {
	    staticClass: "statistic-lg"
	  }, [_c('div', {
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-original-title": _vm.recipientsByStatusHtml,
	      "data-placement": "bottom"
	    }
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.contactsCount))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.contacts')))])])]), _c('div', {
	    staticClass: "statistic-lg"
	  }, [_c('div', {
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-original-title": _vm.detailedConversionStatisticHtml,
	      "data-placement": "bottom"
	    }
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.recipientsStatisticsConversion))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.conversion')))])])]), _c('div', {
	    staticClass: "statistic-lg"
	  }, [_c('div', {
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-original-title": _vm.detailedReplyStatisticHtml,
	      "data-placement": "bottom"
	    }
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.flow.email_statistic.replyPercentage(_vm.flow.recipients_count)))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.reply')))])])])]), _c('ul', {
	    staticClass: "tab-list",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    staticClass: "active",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#actions-tab",
	      "role": "tab",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.title.actions')))])]), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#contacts-tab",
	      "role": "tab",
	      "data-toggle": "tab"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.trackEventViewContact(_vm.flow)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.title.contacts')))])])]), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "actions-tab",
	      "role": "tabpanel"
	    }
	  }, [_c('action-list', {
	    attrs: {
	      "actions": _vm.actions
	    }
	  })], 1), _c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "contacts-tab",
	      "role": "tabpanel"
	    }
	  }, [(_vm.flow.id) ? _c('contacts', {
	    attrs: {
	      "flow": _vm.flow
	    },
	    on: {
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  }) : _vm._e()], 1)]), _c('task-modal-form'), _c('modal-flow-form')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickaway),
	      expression: "onClickaway"
	    }],
	    staticClass: "dropdown"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": _vm.clickList
	    }
	  }, [_c('div', {
	    staticClass: "text-search"
	  }, [_vm._v(_vm._s(_vm.dropdown_title))]), _c('span', {
	    staticClass: "gray-bold-caret"
	  }), (_vm.show_list) ? _c('div', {
	    staticClass: "list-stages"
	  }, _vm._l((_vm.list), function(item) {
	    return (_vm.show_list) ? _c('div', {
	      staticClass: "item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.clicked(item)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "select-button",
	      class: {
	        'all_selected': item.selected
	      }
	    }), _c('div', {
	      staticClass: "name-stage"
	    }, [_vm._v(_vm._s(item.text))])]) : _vm._e()
	  }), 0) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [(_vm.view_mode.show_filters) ? _c('div', {
	    staticClass: "table-actions"
	  }, [_c('filters', {
	    attrs: {
	      "filters": _vm.filters,
	      "show_user_filter": _vm.view_mode.user_filter,
	      "show_tag_filter": _vm.view_mode.tags_filter,
	      "show_lost_reason_filter": _vm.view_mode.lost_reason,
	      "show_group_filter": _vm.view_mode.group_filter,
	      "show_stage_filter": _vm.view_mode.stage,
	      "show_status_filter": _vm.view_mode.status,
	      "label_clear_filter": _vm.view_mode.label_clear_filter,
	      "user_id": _vm.user_id
	    },
	    on: {
	      "filter": _vm.filter
	    }
	  })], 1) : _vm._e(), (_vm.view_mode.show_selections) ? _c('div', {
	    staticStyle: {
	      "padding": "5px"
	    }
	  }, [_c('mass-actions', {
	    attrs: {
	      "unselected_ids": _vm.unselected_contact_ids,
	      "selected_ids": _vm.selected_contact_ids,
	      "count_all_contacts": _vm.count_all_contacts,
	      "count_page_contacts": _vm.count_page_contacts,
	      "filters": _vm.filters
	    },
	    on: {
	      "user-selected": _vm.bubbleUp
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "table-header table-row"
	  }, [(_vm.view_mode.show_checkbox && !_vm.view_mode.show_selections) ? _c('div', {
	    staticClass: "table-col contact-list-item-select table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    attrs: {
	      "id": "contact-select-all-checkbox"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleSelectAll()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selected_all
	    }
	  }), _c('label', [_vm._v(" ")])])]) : (_vm.view_mode.show_selections) ? _c('div', {
	    staticClass: "table-col contact-list-item-select table-col-collapsed gap"
	  }, [_c('label', [_vm._v("   ")])]) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-empashis table-col-120 contact-list-item-name"
	  }, [_vm._v(_vm._s(_vm.$t('contacts.title.singular')))]), (_vm.view_mode.show_created_at_column) ? _c('div', {
	    staticClass: "table-col table-col-50 contact-list-item-status-updated-at"
	  }, [_vm._v("Data")]) : _vm._e(), (_vm.view_mode.business == "column") ? _c('div', {
	    staticClass: "table-col contact-list-item-business"
	  }, [_vm._v(_vm._s(_vm.$t('users.attributes.company')))]) : _vm._e(), (_vm.view_mode.flow) ? _c('div', {
	    staticClass: "table-col contact-list-item-flow"
	  }, [_vm._v("Fluxo")]) : _vm._e(), (_vm.view_mode.action_step) ? _c('div', {
	    staticClass: "table-col contact-list-item-action-step"
	  }, [_vm._v("Etapa no Fluxo")]) : _vm._e(), (_vm.view_mode.show_status_updated_at_column) ? _c('div', {
	    staticClass: "table-col contact-list-item-status-updated-at"
	  }, [_vm._v("Data da pausa")]) : _vm._e(), (_vm.view_mode.show_stage_updated_at_column) ? _c('div', {
	    staticClass: "table-col contact-list-item-status-updated-at"
	  }, [_vm._v("Data e Hora")]) : _vm._e(), (_vm.view_mode.status) ? _c('div', {
	    staticClass: "table-col contact-list-item-status"
	  }, [_vm._v(_vm._s(_vm.$t('users.attributes.status')))]) : _vm._e(), (_vm.view_mode.stage) ? _c('div', {
	    staticClass: "table-col contact-list-item-stage"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.stage')))]) : _vm._e(), (_vm.view_mode.group) ? _c('div', {
	    staticClass: "table-col contact-list-item-group"
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.group')))]) : _vm._e(), (_vm.view_mode.user && !_vm.view_mode.only_picture_miniature) ? _c('div', {
	    staticClass: "table-col contact-list-item-user"
	  }, [_vm._v("Responsável")]) : _vm._e(), (_vm.view_mode.user && _vm.view_mode.only_picture_miniature) ? _c('div', {
	    staticClass: "table-col table-col-30"
	  }, [_vm._v("Resp.")]) : _vm._e(), (_vm.view_mode.initialized_contact_icon) ? _c('div', {
	    staticClass: "table-col contact-list-item-actions table-col-collapsed"
	  }) : _vm._e(), (_vm.view_mode.edit_button) ? _c('div', {
	    staticClass: "table-col contact-list-item-actions table-col-collapsed"
	  }) : _vm._e(), (_vm.view_mode.delete_button) ? _c('div', {
	    staticClass: "table-col contact-list-item-actions table-col-collapsed"
	  }) : _vm._e(), (_vm.add_action_column) ? _c('div', {
	    staticClass: "table-col contact-list-item-actions table-col-collapsed"
	  }) : _vm._e()]), _c('div', {
	    staticClass: "table-body",
	    class: {
	      'internal-scroller': _vm.internal_scroller
	    }
	  }, [_c('draggable', {
	    attrs: {
	      "value": _vm.contacts,
	      "options": _vm.draggable_options
	    },
	    on: {
	      "input": _vm.priorityUpdated
	    }
	  }, _vm._l((_vm.contacts), function(contact) {
	    return _c('contact-list-item', {
	      key: contact.guid,
	      attrs: {
	        "contact": contact,
	        "view_mode": _vm.view_mode,
	        "flow": _vm.flow,
	        "initially_selected": _vm.isInitiallySelected(contact),
	        "origem": _vm.origem
	      },
	      on: {
	        "contact-destroy": _vm.bubbleUp,
	        "reengage-contact": _vm.bubbleUp,
	        "contact-update": _vm.bubbleUp,
	        "contact-recipient-update": _vm.bubbleUp,
	        "contact-recipient-reset": _vm.bubbleUp,
	        "contact-selected": _vm.bubbleUp,
	        "contact-edit": _vm.bubbleUp,
	        "toggle-task-bar": _vm.bubbleUp,
	        "contact-removed-from-flow": _vm.removeContactFromList
	      }
	    }, [_vm._t("default", null, {
	      "contact": contact
	    })], 2)
	  }), 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-reset-same-flow",
	      "title": "Resetar contato no fluxo"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.callResetContact
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("O contato já está no fluxo e ações podem ter sido realizadas para ele. Você deseja reiniciar o contato no fluxo?")]), _c('br'), _c('div', [_c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v("Atenção")]), _vm._v(": Ao continuar, o lead voltará ao início do fluxo.")])])])
	},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._l((_vm.limited_list), function(task) {
	    return _c('compose', {
	      key: task.guid,
	      attrs: {
	        "task": task,
	        "template": task.template_or_new(),
	        "id": task.guid,
	        "number_composes": _vm.list.length,
	        "event": _vm.event
	      },
	      on: {
	        "compose-close": function($event) {
	          return _vm.removeFromList(task)
	        },
	        "compose-hide": _vm.hideCompose
	      }
	    })
	  }), (_vm.hidden_list_has_elements) ? _c('div', {
	    staticClass: "open-compose",
	    on: {
	      "click": function($event) {
	        _vm.show_menu = !_vm.show_menu
	      }
	    }
	  }, [_vm._v(_vm._s('+ ' + _vm.hidden_list.length))]) : _vm._e(), (_vm.show_menu && _vm.hidden_list_has_elements) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickaway),
	      expression: "onClickaway"
	    }],
	    staticClass: "compose-menu"
	  }, _vm._l((_vm.hidden_list), function(task, index) {
	    return _c('div', {
	      staticClass: "hidden-compose",
	      attrs: {
	        "title": _vm.compose_header(task, index)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.incrementList(task)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.compose_header(task, index)))])
	  }), 0) : _vm._e(), _c('quota-exceeded')], 2)
	},staticRenderFns: []}

/***/ }),
/* 1026 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "meeting-form",
	    class: {
	      'width-flow': _vm.send_to_new_flow
	    }
	  }, [_c('div', {
	    staticClass: "meeting-form_header"
	  }, [_c('strong', [_vm._v("Reunião")]), _c('br'), _vm._v(_vm._s(_vm.task.contact.full_name) + " - " + _vm._s(_vm.task.contact.business.name))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "flow-form__lost-selects"
	  }, [_c('form', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "div col-md",
	    class: {
	      'col-md-12': !_vm.send_to_new_flow, 'col-md-5': _vm.send_to_new_flow
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Status da reunião")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.status),
	      expression: "status"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "status"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.statuses), function(status) {
	    return _c('option', {
	      domProps: {
	        "value": status.value
	      }
	    }, [_vm._v(_vm._s(status.label))])
	  }), 0)]), (_vm.is_status_lost) ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('lost_reason_unit')
	    }
	  }, [_c('label', [_vm._v("Motivo de Perda")]), _c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "data-vv-name": "lost_reason_unit",
	      "v-validate": _vm.lost_reason_validate,
	      "options": _vm.lostReasonOptions()
	    },
	    model: {
	      value: (_vm.lost_reason_id),
	      callback: function($$v) {
	        _vm.lost_reason_id = $$v
	      },
	      expression: "lost_reason_id"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('lost_reason_unit')),
	      expression: "errors.has('lost_reason_unit')"
	    }],
	    key: "lost_reason_unit",
	    staticClass: "help-block"
	  }, [_vm._v("Favor selecionar o motivo de perda")])])], 1) : _vm._e(), (!_vm.is_status_connect) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Comentário:")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.comment),
	      expression: "comment"
	    }],
	    staticClass: "form-control",
	    domProps: {
	      "value": (_vm.comment)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.comment = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        return _vm.toggleType()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.send_to_new_flow
	    }
	  }), _c('label', [_vm._v("Enviar para novo fluxo?")])])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        return _vm.toggleNewMeeting()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.new_meeting
	    }
	  }), _c('label', [_vm._v("Cria nova reunião?")])])])]), (_vm.send_to_new_flow) ? _c('div', {
	    staticClass: "line-vertical"
	  }) : _vm._e(), (_vm.send_to_new_flow) ? _c('div', {
	    staticClass: "div col-md",
	    class: {
	      'col-md-7': _vm.send_to_new_flow
	    }
	  }, [_c('div', {
	    staticClass: "form-group contact-list-item-flow",
	    class: {
	      'has-error': !_vm.flow && _vm.send_to_new_flow
	    }
	  }, [_c('label', [_vm._v("Buscar por nome do fluxo")]), _c('flows', {
	    staticClass: "field",
	    attrs: {
	      "user_id": _vm.selected_user,
	      "default_flow": _vm.default_flow
	    },
	    on: {
	      "flow-selected": _vm.selectFlow
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.flow && _vm.send_to_new_flow),
	      expression: "!flow && send_to_new_flow"
	    }],
	    key: "flow_error",
	    staticClass: "help-block"
	  }, [_vm._v("Favor selecionar o novo fluxo")])])], 1), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Selecione um período para reativação"), _c('div', _vm._l((_vm.reactivation_period_options), function(period) {
	    return _c('span', [_c('button', {
	      staticClass: "button-reactivation-period",
	      class: {
	        'selected': period.days == _vm.reactivation_period
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setReactivationPeriod(period.days)
	        }
	      }
	    }, [_vm._v(_vm._s(period.label))])])
	  }), 0)])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Data Customizada:")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 no-padding"
	  }, [_c('input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ("##/##/####"),
	      expression: "\"##/##/####\""
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|regex:^([0-3][0-9]/[0-1][0-9]/[0-3][0-9][0-9][0-9])$'),
	      expression: "'required|regex:^([0-3][0-9]/[0-1][0-9]/[0-3][0-9][0-9][0-9])$'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.due_on_date),
	      expression: "due_on_date"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "due_on_date",
	      "placeholder": "DD/MM/AAAA"
	    },
	    domProps: {
	      "value": (_vm.due_on_date)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.due_on_date = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "col-md-9 calendar-right-align"
	  }, [_c('datepicker', {
	    attrs: {
	      "inline": true,
	      "disabled": {
	        to: _vm.yesterday
	      },
	      "language": "pt-br"
	    },
	    model: {
	      value: (_vm.due_on_date_custom),
	      callback: function($$v) {
	        _vm.due_on_date_custom = $$v
	      },
	      expression: "due_on_date_custom"
	    }
	  })], 1)])])]) : _vm._e()])]), _c('hr'), _c('div', {
	    staticClass: "meeting-form_footer"
	  }, [_c('div', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.$emit("close-meeting-modal")
	      }
	    }
	  }, [_vm._v("Cancelar")]), _c('div', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")])])])
	},staticRenderFns: []}

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "contact-tasks"
	    }
	  }, [_c('task-list', {
	    ref: "task_list",
	    attrs: {
	      "filters": _vm.filters,
	      "item_options": _vm.task_item_options,
	      "sort": _vm.taskSort,
	      "origem": "Base de contatos",
	      "prop_tooltip_placement": _vm.prop_tooltip_placement
	    },
	    on: {
	      "open-template-modal": _vm.bubbleUp,
	      "toggle-task-bar": _vm.bubbleUp
	    }
	  }), _c('task-modal-form', {
	    attrs: {
	      "contact": _vm.contact
	    },
	    on: {
	      "destroyed": _vm.removeTask
	    }
	  }), (_vm.show_meeting_modal) ? _c('meeting-modal', {
	    staticStyle: {
	      "top": "-10%",
	      "left": "-10%"
	    },
	    attrs: {
	      "task": _vm.selected_task
	    },
	    on: {
	      "close-meeting-modal": function($event) {
	        return _vm.closeMeetingModal()
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "inline form-control",
	    attrs: {
	      "name": "name",
	      "type": "text",
	      "placeholder": "Nova tag"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _c('color-input', {
	    model: {
	      value: (_vm.color),
	      callback: function($$v) {
	        _vm.color = $$v
	      },
	      expression: "color"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1)]), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Nova tag")])]), _c('div', {
	    staticClass: "clear"
	  }), _c('br')])
	},staticRenderFns: []}

/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "text-center"
	  }, [_c('br'), _c('div', {
	    staticClass: "text-gray-color"
	  }, [_vm._v("Deseja realmente excluir esta tarefa?")]), _c('br'), _c('div', {
	    staticClass: "rosy-red-color"
	  }, [_c('div', [_vm._v(_vm._s(_vm.task.summaryText()))]), _c('div', [_vm._v(_vm._s(_vm.task.dueOnText()))])]), _c('br')])]), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "btn btn-gray",
	    on: {
	      "click": function($event) {
	        return _vm.$emit("cancel-removing")
	      }
	    }
	  }, [_vm._v("Voltar")]), _c('div', {
	    staticClass: "btn btn-danger no-margin",
	    on: {
	      "click": _vm.destroyTask
	    }
	  }, [_vm._v("Sim, excluir")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_vm._v("EXCLUIR TAREFA"), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	}]}

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table-row clickable",
	    on: {
	      "click": function($event) {
	        _vm.editing = !_vm.editing
	      }
	    }
	  }, [(_vm.default_options.checkbox) ? _c('div', {
	    staticClass: "table-col table-col-collapsed no-padding"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": _vm.toggleSelected
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selected
	    }
	  }), _c('label', [_vm._v(" ")])])]) : _vm._e(), _c('div', {
	    staticClass: "table-col text-gray-color",
	    class: {
	      'no-padding': _vm.default_options.checkbox
	    }
	  }, [_vm._v(_vm._s(_vm.tag.name))]), _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('tag', {
	    attrs: {
	      "tag": _vm.tag
	    }
	  })], 1)])]), (_vm.default_options.can_edit && _vm.editing) ? _c('div', {
	    staticClass: "table-row template"
	  }, [_c('div', {
	    staticClass: "table-col table-col-200"
	  }, [_c('div', {
	    staticClass: "col-sm-4 col-sm-offset-2"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _c('color-input', {
	    model: {
	      value: (_vm.color),
	      callback: function($$v) {
	        _vm.color = $$v
	      },
	      expression: "color"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "col-sm-5"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")]), _c('span', {
	    staticClass: "spacer-15"
	  }), _c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": _vm.destroyTag
	    }
	  }, [_vm._v("Excluir")])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "autocomplete-group"
	    }
	  }, [_c('v-autocomplete', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickaway),
	      expression: "onClickaway"
	    }],
	    staticClass: "no-border",
	    attrs: {
	      "items": _vm.group_options,
	      "get-label": _vm.getLabel,
	      "component-item": _vm.template,
	      "input-attrs": _vm.attrs,
	      "auto-select-one-item": false
	    },
	    on: {
	      "update-items": _vm.updateGroups,
	      "item-selected": _vm.selected
	    },
	    model: {
	      value: (_vm.group_filter),
	      callback: function($$v) {
	        _vm.group_filter = $$v
	      },
	      expression: "group_filter"
	    }
	  }), _c('span', {
	    staticClass: "gray-bold-caret"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-autocomplete', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickaway),
	      expression: "onClickaway"
	    }],
	    staticClass: "no-border",
	    attrs: {
	      "id": _vm.id,
	      "items": _vm.flows,
	      "get-label": _vm.getLabel,
	      "component-item": _vm.template,
	      "input-attrs": _vm.attrs,
	      "auto-select-one-item": false
	    },
	    on: {
	      "update-items": _vm.updateFlows,
	      "item-selected": _vm.saveFlow
	    },
	    model: {
	      value: (_vm.flow),
	      callback: function($$v) {
	        _vm.flow = $$v
	      },
	      expression: "flow"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "done-tasks-dashboard"
	    }
	  }, [_c('h2', [_vm._v("Tarefas executadas")]), _c('br'), _c('div', {
	    staticClass: "row same-height-columns"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('div', {
	    staticClass: "total-quantity blue-block"
	  }, [_c('div', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.total_quantity))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v("Total")])]), _c('div', {
	    staticClass: "service-quantity-wrapper"
	  }, _vm._l((_vm.done_tasks_list), function(task_data) {
	    return _c('div', {
	      staticClass: "col-sm-6"
	    }, [_c('div', {
	      staticClass: "service-quantity blue-block"
	    }, [_c('div', {
	      staticClass: "number"
	    }, [_vm._v(_vm._s(task_data[1]))]), _c('div', {
	      staticClass: "icon icon-green",
	      class: task_data[2]
	    })])])
	  }), 0)]), _c('div', {
	    staticClass: "col-sm-1"
	  }), _c('div', {
	    staticClass: "col-sm-7"
	  }, [_c('div', {
	    staticClass: "row full-height"
	  }, _vm._l((_vm.done_tasks_list), function(task_data) {
	    return _c('div', {
	      staticClass: "col-sm-3 full-height vertical-bar-wrapper"
	    }, [_c('vertical-bar', {
	      attrs: {
	        "total": _vm.total_quantity,
	        "value": task_data[1],
	        "icon_class": task_data[2] + " icon-green"
	      }
	    })], 1)
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "carousel-config"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    class: {
	      'modal-lg': !_vm.current_user.isSeller()
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": _vm.close_modal
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), (_vm.copy) ? _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel_custom.copiedCarouselItems')))]) : _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "loading",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": "loading",
	      "size": "50px"
	    }
	  })], 1) : [(!_vm.current_user.isSeller()) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [(_vm.copy) ? _c('span', {
	    staticClass: "title light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel_custom.rightColumn')))]) : _c('span', {
	    staticClass: "title light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel_custom.chooseUsersAndOrder')))]), _c('div', {
	    staticClass: "cleafix"
	  }, [_vm._v(" ")]), _c('div', {
	    staticClass: "table table-modal"
	  }, [(!_vm.copy) ? _c('div', {
	    staticClass: "table-header table-row"
	  }, [_c('div', {
	    staticClass: "table-col contact-list-item-select table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    attrs: {
	      "id": "contact-select-all-checkbox"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.selectAll()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selected_all
	    }
	  }), _c('label', [_vm._v(" ")])])]), _c('div', {
	    staticClass: "table-col table-col-empashis table-col-120 contact-list-item-name"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel_custom.chooseUsers')) + ":")])]) : _vm._e(), (_vm.copy) ? _c('div', {
	    staticClass: "table-body internal-scroller"
	  }, [_c('hr'), _vm._l((_vm.fields_select), function(user, key, index) {
	    return _c('list-copy', {
	      key: index,
	      attrs: {
	        "user": user,
	        "user_index": index,
	        "show-checkbox": true,
	        "list-carousel": true
	      },
	      on: {
	        "user-selected": _vm.selectUser
	      }
	    })
	  })], 2) : _c('div', {
	    staticClass: "table-body internal-scroller"
	  }, [_c('hr'), _vm._l((_vm.users), function(user) {
	    return _c('list-item', {
	      key: user.id,
	      attrs: {
	        "user": user,
	        "show-checkbox": true,
	        "list-carousel": true,
	        "userIsSelected": _vm.userIsSelected(user)
	      },
	      on: {
	        "user-selected": _vm.selectUser
	      }
	    })
	  })], 2)])]) : _vm._e(), _c('div', {
	    class: {
	      'col-md-11': _vm.current_user.isSeller(), 'col-md-5': !_vm.current_user.isSeller()
	    }
	  }, [_c('div', {
	    staticClass: "list-reponsibles"
	  }, [(_vm.copy == false) ? _c('span', {
	    staticClass: "dark-slate-gray"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.lastResponsible')))]) : _vm._e(), (_vm.copy == false) ? _c('div', {
	    staticClass: "draggable-responsible",
	    class: {
	      'no-last-user': !_vm.has_last_user
	    }
	  }, [(_vm.has_last_user) ? [_c('div', {
	    staticClass: "user-miniature-wrapper"
	  }, [_c('div', {
	    staticClass: "user-miniature-picture-wrapper"
	  }, [_c('img', {
	    staticClass: "user-miniature-picture",
	    attrs: {
	      "src": _vm.carousel.last_user.picture_url
	    }
	  })])]), _c('div', {
	    staticClass: "name light-gray-text"
	  }, [_vm._v(_vm._s(_vm.carousel.last_user.name))])] : _c('div', {
	    staticClass: "name light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.lastResponsibleFeedback')))])], 2) : _vm._e(), (_vm.copy == false) ? _c('hr', {
	    staticClass: "separator"
	  }) : _vm._e(), (_vm.copy) ? _c('span', {
	    staticClass: "dark-slate-gray",
	    staticStyle: {
	      "font-size": "17px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel_custom.carouselDetails')))]) : _vm._e(), (_vm.copy) ? _c('span', {
	    staticClass: "dark-slate-gray"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel_custom.userOrders')) + ":")]) : _vm._e(), (_vm.copy == false) ? _c('span', {
	    staticClass: "dark-slate-gray"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel_custom.nextResponsibles')))]) : _vm._e(), _c('div', {
	    staticClass: "responsible-wrapper internal-scroller"
	  }, [_c('draggable', {
	    attrs: {
	      "value": _vm.selected_users
	    },
	    on: {
	      "input": _vm.changeOrder
	    }
	  }, _vm._l((_vm.selected_users), function(carousel_user) {
	    return _c('div', {
	      staticClass: "draggable-responsible clickable"
	    }, [(_vm.carousel && _vm.carousel.next_user_id == carousel_user.user_id) ? _c('img', {
	      staticClass: "green-arrow",
	      attrs: {
	        "src": __webpack_require__(249)
	      }
	    }) : _vm._e(), _c('div', {
	      staticClass: "user-miniature-wrapper"
	    }, [_c('div', {
	      staticClass: "user-miniature-picture-wrapper"
	    }, [_c('img', {
	      staticClass: "user-miniature-picture",
	      attrs: {
	        "src": carousel_user.user.picture_url
	      }
	    })])]), _c('div', {
	      staticClass: "name light-gray-text"
	    }, [_vm._v(_vm._s(carousel_user.user.name))])])
	  }), 0)], 1)])])]], 2), _c('div', {
	    staticClass: "clearfix"
	  }), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('a', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), (_vm.current_user.isSeller()) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.ok')))]) : _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.finishText()))])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c(_vm.dropdownComponent(_vm.kind), {
	    tag: "component",
	    attrs: {
	      "index": _vm.index,
	      "filter_item_selected_ids": _vm.filter_item_selected_ids,
	      "uncheck_all_items": _vm.uncheck_all_items
	    },
	    on: {
	      "item-selected-items": _vm.itemSelectedItems
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "container auth-view-wrapper"
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(31),
	      "alt": "Reev"
	    }
	  }), _c('fieldset', [_c('legend', {
	    staticClass: "login-legend"
	  }, [_vm._v("Ative sua conta")]), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, _vm._l((_vm.apiErrorMessages), function(errorMessage, idx) {
	    return _c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.apiErrorMessages.length > 0),
	        expression: "apiErrorMessages.length > 0"
	      }],
	      key: idx,
	      staticClass: "error-message"
	    }, [_vm._v(_vm._s(errorMessage))])
	  }), 0), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    staticClass: "form-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.email),
	      expression: "email",
	      modifiers: {
	        "lazy": true
	      }
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "activation-email",
	      "type": "email",
	      "name": "email",
	      "disabled": "",
	      "placeholder": "E-mail"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "change": function($event) {
	        _vm.email = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.name),
	      expression: "user.name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "activation-name",
	      "type": "name",
	      "name": "name",
	      "placeholder": "Nome"
	    },
	    domProps: {
	      "value": (_vm.user.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block text-left"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), (_vm.user.default_user) ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [((_vm.showPassword ? 'text-open-password' : 'password') === 'checkbox') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "activation-password",
	      "name": "password",
	      "placeholder": "Senha",
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.user.password) ? _vm._i(_vm.user.password, null) > -1 : (_vm.user.password)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.user.password,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.user, "password", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.user, "password", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.user, "password", $$c)
	        }
	      }
	    }
	  }) : ((_vm.showPassword ? 'text-open-password' : 'password') === 'radio') ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "activation-password",
	      "name": "password",
	      "placeholder": "Senha",
	      "type": "radio"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.user.password, null)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.user, "password", null)
	      }
	    }
	  }) : _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "activation-password",
	      "name": "password",
	      "placeholder": "Senha",
	      "type": _vm.showPassword ? 'text-open-password' : 'password'
	    },
	    domProps: {
	      "value": (_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "password", $event.target.value)
	      }
	    }
	  }), (_vm.showPassword) ? _c('div', {
	    staticClass: "input-group-addon open-password"
	  }, [_c('img', {
	    staticClass: "icon-size",
	    attrs: {
	      "src": __webpack_require__(253)
	    },
	    on: {
	      "click": function($event) {
	        _vm.showPassword = !_vm.showPassword
	      }
	    }
	  })]) : _c('div', {
	    staticClass: "input-group-addon open-password"
	  }, [_c('img', {
	    staticClass: "icon-size",
	    attrs: {
	      "src": __webpack_require__(251)
	    },
	    on: {
	      "click": function($event) {
	        _vm.showPassword = !_vm.showPassword
	      }
	    }
	  })])]), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    key: "password",
	    staticClass: "help-block text-left"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])], 1) : _vm._e(), (_vm.user.default_user) ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('password_confirmation')
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model.lazy",
	      value: (_vm.user.password_confirmation),
	      expression: "user.password_confirmation",
	      modifiers: {
	        "lazy": true
	      }
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('confirmed:password'),
	      expression: "'confirmed:password'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "activation-password_confirmation",
	      "type": _vm.showPasswordConfirmation ? 'text-open-password' : 'password',
	      "name": "password_confirmation",
	      "placeholder": "Repetir Senha"
	    },
	    domProps: {
	      "value": (_vm.user.password_confirmation)
	    },
	    on: {
	      "change": function($event) {
	        return _vm.$set(_vm.user, "password_confirmation", $event.target.value)
	      }
	    }
	  }), (_vm.showPasswordConfirmation) ? _c('div', {
	    staticClass: "input-group-addon open-password"
	  }, [_c('img', {
	    staticClass: "icon-size",
	    attrs: {
	      "src": __webpack_require__(253)
	    },
	    on: {
	      "click": function($event) {
	        _vm.showPasswordConfirmation = !_vm.showPasswordConfirmation
	      }
	    }
	  })]) : _c('div', {
	    staticClass: "input-group-addon open-password"
	  }, [_c('img', {
	    staticClass: "icon-size",
	    attrs: {
	      "src": __webpack_require__(251)
	    },
	    on: {
	      "click": function($event) {
	        _vm.showPasswordConfirmation = !_vm.showPasswordConfirmation
	      }
	    }
	  })])]), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password_confirmation')),
	      expression: "errors.has('password_confirmation')"
	    }],
	    key: "password_confirmation",
	    staticClass: "help-block text-left"
	  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])])], 1) : _vm._e(), _c('button', {
	    staticClass: "btn btn-block btn-primary submit-button",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.errors.any()
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v("Ativar conta")]), (_vm.apiErrorMessages.length > 0) ? _c('router-link', {
	    staticClass: "login-link",
	    attrs: {
	      "to": "login"
	    }
	  }, [_vm._v("Login")]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-image-wrapper",
	    style: ({
	      'background-color': _vm.color
	    })
	  }, [_c('div', {
	    staticClass: "text-image-text"
	  }, [_vm._v(_vm._s(_vm.text))])])
	},staticRenderFns: []}

/***/ }),
/* 1038 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row clickable"
	  }, [(_vm.editing) ? [_c('div', {
	    staticClass: "table-col table-col-120"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('title')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "title",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })])])] : [_c('div', {
	    staticClass: "table-col table-col-120"
	  }, [_vm._v(_vm._s(_vm.lost_reason.title))])], _c('div', {
	    staticClass: "table-col table-col-80"
	  }, [(_vm.can_edit_lost_reason) ? _c('div', {
	    staticClass: "pull-right"
	  }, [(_vm.editing) ? _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")]) : _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        _vm.editing = !_vm.editing
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.editing ? 'Cancelar' : 'Editar'))]), _c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": _vm.destroyLostReason
	    }
	  }, [_vm._v("Excluir")])]) : _vm._e()])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: {
	      'more-composes': _vm.number_composes > 1
	    },
	    attrs: {
	      "id": "email-scheduler"
	    }
	  }, [_c('div', {
	    staticClass: "scheduler__title"
	  }, [_vm._v(_vm._s(_vm.scheduler_header))]), _c('div', {
	    staticClass: "scheduler__datepicker-wrapper"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Selecione a data:")]), _c('datepicker', {
	    attrs: {
	      "inline": true,
	      "disabled": {
	        to: _vm.yesterday,
	        from: _vm.from_dates
	      },
	      "language": "pt-br"
	    },
	    model: {
	      value: (_vm.due_on_date),
	      callback: function($$v) {
	        _vm.due_on_date = $$v
	      },
	      expression: "due_on_date"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "form-group scheduler__default-times"
	  }, [_c('label', [_vm._v("Selecione o horário:")]), _vm._l((_vm.default_times), function(time) {
	    return _c('div', {
	      staticClass: "scheduler__default-time",
	      class: {
	        selected: _vm.isSelected(time)
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectDefaultTime(time)
	        }
	      }
	    }, [_vm._v(_vm._s(time))])
	  })], 2), _c('div', {
	    staticClass: "form-group time-to-send-picker-wrapper",
	    class: {
	      'has-error': _vm.errors.has('due_on_time')
	    }
	  }, [_c('label', [_vm._v("Horário customizado:")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|regex:^([0-2][0-9]:[0-5][0-9])$'),
	      expression: "'required|regex:^([0-2][0-9]:[0-5][0-9])$'"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##:##'),
	      expression: "'##:##'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.due_on_time),
	      expression: "due_on_time"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "due_on_time",
	      "placeholder": "HH:MM"
	    },
	    domProps: {
	      "value": (_vm.due_on_time)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.due_on_time = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('due_on_time')),
	      expression: "errors.has('due_on_time')"
	    }],
	    key: "due_on_time",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('due_on_time')))])])], 1), (_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "form-group time-to-send-picker-wrapper"
	  }, [_c('label', [_vm._v("Lembrar convidados:")]), _c('div', [_c('span', {
	    staticClass: "meeting-reminder-date"
	  }, [_vm._v(_vm._s(_vm.due_on_scheduler.format('DD/MM/YYYY')) + " ")]), _vm._v("às "), _c('span', {
	    staticClass: "meeting-reminder-date"
	  }, [_vm._v(_vm._s(_vm.due_on_time))])])]) : _vm._e(), (_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "form-group time-to-send-picker-wrapper"
	  }, [_c('label', [_vm._v("Reunião marcada para:")]), _c('div', [_c('span', {
	    staticClass: "meeting-date"
	  }, [_vm._v(_vm._s(_vm.task.due_on.format('DD/MM/YYYY')) + " ")]), _vm._v("às "), _c('span', {
	    staticClass: "meeting-date"
	  }, [_vm._v(_vm._s(_vm.task.due_on.format('HH:mm')))])])]) : _vm._e(), _c('div', {
	    staticClass: "scheduler__footer"
	  }, [(!_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "btn-primary btn-gray btn",
	    on: {
	      "click": function($event) {
	        return _vm.closeScheduler()
	      }
	    }
	  }, [_vm._v("Cancelar")]) : _vm._e(), (!_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "btn-primary btn-save btn",
	    attrs: {
	      "disabled": _vm.loading
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v("Agendar")]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row action-list-item list-item",
	    style: ({
	      cursor: _vm.cursor
	    }),
	    attrs: {
	      "data-toggle": "dropdown",
	      "aria-haspopup": "true",
	      "aria-expanded": "false",
	      "data-target": _vm.data_target_id
	    },
	    on: {
	      "mouseover": function($event) {
	        _vm.row_hovered = true
	      },
	      "mouseleave": function($event) {
	        _vm.row_hovered = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "table-col table-col-500"
	  }, [_c('div', {
	    staticClass: "action-info",
	    class: _vm.action.signature
	  }, [_c('div', {
	    staticClass: "action-human-step"
	  }, [_vm._v(_vm._s(_vm.action_legend))]), _c('div', {
	    staticClass: "action-name"
	  }, [_vm._v(_vm._s(_vm.action.name))])])]), (_vm.action.isEmailFlowAction() && _vm.action.email_statistic) ? [_c('statistic-table-col', {
	    attrs: {
	      "total": _vm.action.email_statistic.sent,
	      "value": _vm.action.email_statistic.open,
	      "label": _vm.$t('flows.attributes.opening'),
	      "show_details": _vm.row_hovered
	    }
	  }), _c('statistic-table-col', {
	    attrs: {
	      "total": _vm.action.email_statistic.sent,
	      "value": _vm.action.email_statistic.reply,
	      "label": _vm.$t('flows.attributes.reply'),
	      "show_details": _vm.row_hovered
	    }
	  })] : [_c('div', {
	    staticClass: "table-col"
	  }), (!_vm.action.isEmailFlowAction() && _vm.qualification_statistics) ? _c('statistic-table-col', {
	    attrs: {
	      "value": _vm.action.recipients_statistics.total.count,
	      "show_raw_value": true,
	      "label": _vm.$t('flows.attributes.performed')
	    }
	  }) : _vm._e()], (_vm.show_conversion_statistic) ? _c('statistic-table-col', {
	    attrs: {
	      "total": _vm.total_for_conversion,
	      "value": _vm.conversion,
	      "label": _vm.$t('flows.attributes.conversion'),
	      "show_details": _vm.row_hovered
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }), (_vm.has_template) ? _c('div', {
	    staticClass: "preview",
	    staticStyle: {
	      "flex": "0 1 100%"
	    },
	    attrs: {
	      "id": _vm.preview_id
	    }
	  }, [_c('div', {
	    staticStyle: {
	      "padding": "20px"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      }
	    }
	  }, [_c('h1', [_vm._v(_vm._s(_vm.label_by_template_kind)), _c('span', [_vm._v(_vm._s(_vm.value_by_template_kind))])]), _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.action.template.body)
	    }
	  })])]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1041 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    on: {
	      "click": function($event) {
	        return $event.stopPropagation()
	      }
	    }
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "loading-wrapper"
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "loading",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": "loading",
	      "size": "50px"
	    }
	  })], 1) : _vm._e()]) : _c('div', [_c('span', {
	    staticClass: "lupa glyphicon glyphicon-search"
	  }), _c('v-autocomplete', {
	    attrs: {
	      "id": _vm.id,
	      "items": _vm.tags,
	      "component-item": _vm.template,
	      "input-attrs": _vm.attrs,
	      "keep-open": _vm.show_tags,
	      "auto-select-one-item": false
	    },
	    on: {
	      "change": _vm.filterTags
	    },
	    model: {
	      value: (_vm.tag),
	      callback: function($$v) {
	        _vm.tag = $$v
	      },
	      expression: "tag"
	    }
	  }), _c('hr', {
	    staticClass: "full"
	  }), _c('div', {
	    staticClass: "tag-actions-buttons"
	  }, [(_vm.tags.length == 0) ? _c('span', [_vm._v("Nenhuma tag foi encontrada")]) : _vm._e(), (_vm.show_button_apply) ? _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.callExecuteChangeTags
	    }
	  }, [_vm._v("Aplicar")]) : _vm._e(), (_vm.autocomplete_text.length > 0) ? _c('a', {
	    on: {
	      "click": _vm.openModal
	    }
	  }, [_vm._v(_vm._s(_vm.button_title_create_tag))]) : _vm._e(), (!_vm.current_user.isSeller()) ? _c('div', [(_vm.autocomplete_text.length == 0 && !_vm.show_button_apply) ? _c('a', {
	    on: {
	      "click": _vm.openModal
	    }
	  }, [_vm._v("Criar Nova Tag")]) : _vm._e(), (_vm.autocomplete_text.length == 0 && !_vm.show_button_apply) ? _c('router-link', {
	    attrs: {
	      "to": '/configuracoes/tags'
	    }
	  }, [_vm._v("Editar tags")]) : _vm._e()], 1) : _vm._e()])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "vertical-bar"
	  }, [_c('div', {
	    staticClass: "wrapper"
	  }, [_c('div', {
	    staticClass: "bar",
	    style: ("height: " + _vm.percentage)
	  }), _c('div', {
	    staticClass: "icon",
	    class: _vm.icon_class,
	    style: ("bottom: calc(" + _vm.percentage + " + 4px)")
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "select-button",
	    class: _vm.select_button_class
	  }), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1044 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "new-custom-fields-modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._v(_vm._s(_vm.title_modal)), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])]), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    attrs: {
	      "id": "custom-field-form"
	    }
	  }, [_c('div', {
	    staticClass: "form-wrapper"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('field')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "field"
	    }
	  }, [_vm._v("Nome do campo")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.custom_field.field),
	      expression: "custom_field.field"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "custom-field-name",
	      "name": "field",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.custom_field.field)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.custom_field, "field", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('field')),
	      expression: "errors.has('field')"
	    }],
	    key: "field",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('field')))])])], 1), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('kind')
	    }
	  }, [_c('label', [_vm._v("Selecione o tipo de propriedade")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.custom_field.kind),
	      expression: "custom_field.kind"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control select-kind",
	    class: _vm.custom_field.kind,
	    attrs: {
	      "disabled": _vm.custom_field.id,
	      "name": "kind"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.custom_field, "kind", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.kinds), function(kind) {
	    return _c('option', {
	      domProps: {
	        "value": kind.value
	      }
	    }, [_vm._v(_vm._s(kind.label))])
	  }), 0), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('kind')),
	      expression: "errors.has('kind')"
	    }],
	    key: "kind",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('kind')))])])], 1), (_vm.custom_field.kind == 'dropdown') ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Opções da Múltipla Escolha")]), _c('draggable', {
	    attrs: {
	      "value": _vm.custom_field.options,
	      "options": _vm.draggable_options
	    },
	    on: {
	      "input": _vm.priorityUpdated
	    }
	  }, _vm._l((_vm.custom_field.options), function(option, index) {
	    return _c('div', {
	      staticClass: "option"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (option.name),
	        expression: "option.name"
	      }],
	      staticClass: "form-control",
	      class: {
	        'deleted': option.deleted
	      },
	      attrs: {
	        "disabled": option.deleted,
	        "placeholder": 'Opção ' + (index + 1)
	      },
	      domProps: {
	        "value": (option.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(option, "name", $event.target.value)
	        }
	      }
	    }), _c('button', {
	      staticClass: "close",
	      attrs: {
	        "type": "button",
	        "aria-label": "Close",
	        "disabled": option.deleted
	      },
	      on: {
	        "click": function($event) {
	          return _vm.remove(option)
	        }
	      }
	    }, [_c('span', {
	      attrs: {
	        "aria-hidden": "true"
	      }
	    }, [_vm._v("×")])])])
	  }), 0), _c('div', {
	    staticClass: "add-option",
	    on: {
	      "click": _vm.addOption
	    }
	  }, [_c('span', {
	    staticClass: "icon",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("+ ")]), _c('span', {
	    staticClass: "text"
	  }, [_vm._v("Adicionar Opção")])])], 1) : _vm._e(), (_vm.option_deleted) ? _c('div', {
	    staticClass: "form-group"
	  }, [_vm._v("A deletar o campo, você deve selecionar uma das opções abaixo:"), _c('div', [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": _vm.checkboxDontReplace
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.dont_replace
	    }
	  }), _c('label', [_vm._v("Não substituir essa informação no contato.")])])]), _c('div', [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": _vm.checkboxReplaceOption
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.replace_option
	    }
	  }), _c('label', [_vm._v("Substituir pela informação:")])])])]) : _vm._e(), (_vm.replace_option) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.new_value),
	      expression: "new_value"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "new_value"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.new_value = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.valid_options), function(option) {
	    return _c('option', {
	      domProps: {
	        "value": option.name
	      }
	    }, [_vm._v(_vm._s(option.name))])
	  }), 0)]) : _vm._e()])])]), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.label_button))])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_c('div', {
	    staticClass: "contact-event-icon leadlovers-icon"
	  }), _c('div', {
	    staticClass: "contact-event-header overflow-ellipsis"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
	    staticClass: "right-arrow glyphicon glyphicon-arrow-right"
	  }), _c('a', {
	    staticClass: "contact-event-description underlined",
	    attrs: {
	      "href": _vm.event.description,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.event.description))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.contacts_text))]), _vm._v(" via API do Reev.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1047 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table-row user-list-item clickable",
	    on: {
	      "click": _vm.showForm
	    }
	  }, [(_vm.showCheckbox) ? _c('div', {
	    staticClass: "table-col table-col-collapsed",
	    class: {
	      'table-modal-rd': _vm.listCarousel
	    }
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    on: {
	      "click": function($event) {
	        return _vm.checkboxSelectUser(_vm.user)
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selected
	    }
	  }), _c('label', [_vm._v(" ")])])]) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-collapsed user-miniature",
	    class: {
	      'table-modal-rd': _vm.listCarousel
	    }
	  }, [_c('div', {
	    staticClass: "user-miniature-wrapper"
	  }, [_c('div', {
	    staticClass: "user-miniature-picture-wrapper"
	  }, [_c('img', {
	    staticClass: "user-miniature-picture",
	    attrs: {
	      "src": _vm.user.picture_url
	    }
	  })])])]), _c('div', {
	    staticClass: "table-col table-col-150",
	    class: {
	      'table-modal-rd': _vm.listCarousel
	    }
	  }, [_c('div', {
	    staticClass: "identity"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.user_name))]), (!_vm.listCarousel) ? _c('div', {
	    staticClass: "email"
	  }, [_vm._v(_vm._s(_vm.user.email))]) : _vm._e()])]), (!_vm.listCarousel) ? _c('div', {
	    staticClass: "table-col table-col-100"
	  }, [_c('div', {
	    staticClass: "role"
	  }, [_vm._v(_vm._s(_vm.user.human_role))])]) : _vm._e()]), (_vm.show_form && _vm.user.id != _vm.current_user.id && _vm.can_show_form && !_vm.listCarousel) ? _c('div', {
	    staticClass: "table-row form user-form"
	  }, [(_vm.user.name) ? _c('div', {
	    staticClass: "table-col user-actions table-col-80"
	  }, [_c('span', {
	    staticClass: "role-label"
	  }, [_vm._v(_vm._s(_vm.$t('users.attributes.role')) + ":")]), _c('br'), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.role_options,
	      "selected": _vm.user.role
	    },
	    on: {
	      "input": _vm.setRole
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "table-col user-actions table-col-20"
	  }, [_c('span', {
	    staticClass: "role-label"
	  }, [_vm._v(_vm._s(_vm.$t('users.attributes.status')) + ":")]), _c('br'), (!_vm.confirmed) ? _c('span', {
	    staticClass: "status"
	  }, [_vm._v(_vm._s(_vm.$t('users.status.pending')))]) : _c('span', {
	    staticClass: "status"
	  }, [_vm._v(_vm._s(_vm.$t('users.status.active')))])]), _c('div', {
	    staticClass: "table-col user-actions"
	  }, [_c('span', {
	    staticClass: "role-label"
	  }, [_vm._v(_vm._s(_vm.$t('users.attributes.email')) + ":")]), _c('br'), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.new_email),
	      expression: "new_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('email'),
	      expression: "'email'"
	    }],
	    staticClass: "user-email",
	    class: {
	      pending: !_vm.confirmed
	    },
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "placeholder": _vm.user.email,
	      "disabled": !_vm.confirmed
	    },
	    domProps: {
	      "value": (_vm.new_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.new_email = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    key: "email",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])]), (!_vm.confirmed) ? _c('button', {
	    staticClass: "btn btn-info resend-invite",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": _vm.$t('users.actions.invite.resend'),
	      "data-placement": "top"
	    },
	    on: {
	      "click": _vm.resendUserInvite
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-repeat"
	  })]) : _vm._e()], 1)]), _c('div', {
	    staticClass: "buttons-wrapper"
	  }, [(_vm.confirmed) ? _c('button', {
	    staticClass: "btn btn-primary save-user",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))]) : _vm._e(), (!_vm.listCarousel) ? _c('button', {
	    staticClass: "btn btn-danger destroy-user",
	    on: {
	      "click": _vm.destroyUser
	    }
	  }, [_vm._v(_vm._s(_vm.$t('users.actions.delete.delete')))]) : _vm._e()])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1048 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" convertido(s) via SharpSpring.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "line-numbered-textarea-wrapper"
	  }, [_c('label', {
	    staticClass: "titleized",
	    attrs: {
	      "for": "contacts_textarea"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts_group.label.insertInfo')))]), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.has_line_errors),
	      expression: "has_line_errors"
	    }],
	    staticClass: "line-numbered-textarea-errors error-message"
	  }, _vm._l((_vm.line_errors), function(errors_with_line_number) {
	    return _c('div', {
	      staticClass: "line-numbered-textarea-line-error"
	    }, [(errors_with_line_number.line_number) ? _c('div', {
	      staticClass: "line-error-number"
	    }, [_vm._v(_vm._s(errors_with_line_number.line_number))]) : _vm._e(), _vm._l((errors_with_line_number.errors), function(error) {
	      return (errors_with_line_number.line_number) ? _c('div', {
	        staticClass: "line-error-error"
	      }, [_vm._v(_vm._s(error))]) : _vm._e()
	    })], 2)
	  }), 0)]), _c('div', {
	    staticClass: "contacts-text-area-label"
	  }, [_c('span', {
	    staticClass: "number textarea-label"
	  }, [_vm._v("N°")]), _c('span', {
	    staticClass: "fields textarea-label"
	  }, [_vm._v(_vm._s(_vm.attributes))])]), _c('div', [_c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact_list),
	      expression: "contact_list"
	    }],
	    staticClass: "lined",
	    attrs: {
	      "placeholder": _vm.attributes,
	      "name": "contacts_textarea"
	    },
	    domProps: {
	      "value": (_vm.contact_list)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.contact_list = $event.target.value
	      }, _vm.validateUnlessPristine]
	    }
	  })])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "tag",
	    class: {
	      deletable: _vm.deletable
	    },
	    style: (_vm.style)
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.tag.name))]), (_vm.deletable) ? _c('span', {
	    staticClass: "delete-button",
	    on: {
	      "click": _vm.removeTag
	    }
	  }, [_vm._v("×")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1051 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-link', {
	    staticClass: "back-link",
	    attrs: {
	      "to": "/configuracoes/integracoes"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('integrations.title.index')))]), (_vm.is_pipedrive) ? _c('pipedrive') : _vm._e(), (_vm.is_rd_station) ? _c('rd-station') : _vm._e(), (_vm.is_rd_station_crm) ? _c('rd-station-crm') : _vm._e(), (_vm.is_salesforce) ? _c('salesforce') : _vm._e(), (_vm.is_hubspot) ? _c('hubspot') : _vm._e(), (_vm.is_cv_crm) ? _c('cv-crm') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": "change-responsability"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.info && _vm.user) ? _c('div', {
	    staticClass: "text-center big-text"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.info.changeable.length))]), (_vm.info.changeable.length > 1) ? _c('span', [_vm._v(" contatos terão sua responsabilidade")]) : _c('span', [_vm._v(" contato terá sua responsabilidade")]), _c('br'), _c('span', [_vm._v("transferida para")]), _c('strong', [_vm._v(" " + _vm._s(_vm.user.firstAndLastName()))]), _c('div', {
	    staticClass: "small-text"
	  }, _vm._l((_vm.info.users), function(user) {
	    return _c('div', {
	      staticClass: "user_contacts"
	    }, [_c('strong', [_vm._v(_vm._s(user.count))]), (user.count > 1) ? _c('span', [_vm._v(" contatos de")]) : _c('span', [_vm._v(" contato de")]), _c('strong', [_vm._v(" " + _vm._s(user.name))])])
	  }), 0), (_vm.info.unfinished.length > 0) ? _c('div', {
	    staticClass: "warning"
	  }, [_c('span', {
	    staticClass: "red"
	  }, [_vm._v("Atenção:")]), (_vm.info.unfinished.length > 1) ? _c('span', [_vm._v(" existem " + _vm._s(_vm.info.unfinished.length) + " contatos não finalizados.")]) : _c('span', [_vm._v(" existe " + _vm._s(_vm.info.unfinished.length) + " contato não finalizado.")]), _c('br'), (_vm.info.unfinished.length > 1) ? _c('span', [_vm._v("Eles precisam ser finalizados antes de transferidos.")]) : _c('span', [_vm._v("Ele precisa ser finalizado antes de transferido.")])]) : _vm._e()]) : _vm._e()]), (_vm.info) ? _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.reject
	    }
	  }, [_vm._v("Cancelar")]), (_vm.info.unfinished.length > 0) ? _c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirm(true)
	      }
	    }
	  }, [_vm._v("Finalizar e transferir")]) : _vm._e(), (_vm.info.unfinished.length > 0) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirm(false)
	      }
	    }
	  }, [_vm._v("Transferir só finalizados")]) : _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.confirm(false)
	      }
	    }
	  }, [_vm._v("Transferir")])]) : _vm._e()])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Alterar responsável")])])
	}]}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadData),
	      expression: "loadData"
	    }],
	    staticStyle: {
	      "display": "inline"
	    },
	    attrs: {
	      "id": "contacts-index",
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.title.index')))]), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.showCreateModal()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('businesses.actions.new')))])]), _c('div', {
	    staticClass: "clear"
	  }), (_vm.showNabBars()) ? _c('div', {
	    staticClass: "row"
	  }, [_c('ul', {
	    staticClass: "tab-list",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.leadsRedirect()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.actions.contacts')))])]), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.groupsRedirect()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.actions.groups')))])]), _c('li', {
	    staticClass: "active",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.businessRedirect()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.actions.companies')))])])])]) : _vm._e(), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "groups-tab"
	    }
	  }, [_c('businesses-list', {
	    attrs: {
	      "businesses": _vm.businesses,
	      "filters": _vm.filters
	    },
	    on: {
	      "filter": _vm.filter
	    }
	  })], 1)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.fetching
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.feedback.noDataText')))])], 1), _c('new-business-modal', {
	    on: {
	      "business-create": _vm.created
	    }
	  }), _c('go-to-top')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadData),
	      expression: "loadData"
	    }],
	    staticStyle: {
	      "display": "inline"
	    },
	    attrs: {
	      "id": "contacts-index",
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v("Base de Contatos")]), _c('div', {
	    staticClass: "pull-right"
	  }, [_c('div', {
	    staticClass: "dropdown dropdown-export-menu"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu dropdown-export"
	  }, [_c('li', {
	    staticClass: "btn export",
	    on: {
	      "click": function($event) {
	        return _vm.exportContacts('all_base')
	      }
	    }
	  }, [_vm._v("Exportar Base de Contatos")]), _c('li', {
	    staticClass: "btn export",
	    on: {
	      "click": function($event) {
	        return _vm.exportContacts('filters')
	      }
	    }
	  }, [_vm._v("Exportar Resultados do Filtro")])])]), _c('div', {
	    staticClass: "dropdown pull-right"
	  }, [(!_vm.current_user.isMonitoringManager()) ? _c('button', {
	    staticClass: "btn btn-primary dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Inserir Contatos")]) : _vm._e(), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": '/contatos/importar/manualmente'
	    }
	  }, [_vm._v("Inserir manualmente")])], 1), _c('li', [_c('router-link', {
	    attrs: {
	      "to": '/contatos/importar/csv'
	    }
	  }, [_vm._v("Importar CSV")])], 1)])])])]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('ul', {
	    staticClass: "tab-list",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    staticClass: "active",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.leadsRedirect()
	      }
	    }
	  }, [_vm._v("Contatos")])]), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.groupsRedirect()
	      }
	    }
	  }, [_vm._v("Grupos")])]), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.businessRedirect()
	      }
	    }
	  }, [_vm._v("Empresas")])])])]), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "contacts-tab",
	      "role": "tabpanel"
	    }
	  }, [_c('contact-list', {
	    attrs: {
	      "contacts": _vm.contacts,
	      "selected_contact_ids": _vm.selected_contact_ids,
	      "unselected_contact_ids": _vm.unselected_contact_ids,
	      "count_all_contacts": _vm.count_all_contacts,
	      "count_page_contacts": _vm.count_page_contacts,
	      "view_mode": _vm.contactListViewModes().index,
	      "filters": _vm.filters
	    },
	    on: {
	      "contact-update": _vm.updateContact,
	      "reengage-contact": _vm.reengage,
	      "contact-recipient-update": _vm.updateContactRecipient,
	      "contact-destroy": _vm.openDestroyContactConfirmationModal,
	      "filter": _vm.filter,
	      "contact-selected": _vm.loadSelectedContactsList,
	      "user-selected": _vm.callPrepareChangeResponsability
	    }
	  })], 1)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.fetching
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1), _c('go-to-top'), _c('reactivate-recipient-modal', {
	    attrs: {
	      "contact": _vm.schedule_reactivation_contact
	    }
	  }), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-remove-contact",
	      "title": "Excluir contato",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.callDestroyContact
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Confirma exclusão do contato abaixo?")]), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_contact.full_name))])])]), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-remove-contacts",
	      "title": "Excluir contatos selecionados",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.callDestroyContacts
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [(_vm.count_selected_contacts > 1) ? _c('div', [_vm._v("Confirma exclusão de " + _vm._s(_vm.count_selected_contacts) + " contatos selecionados?")]) : _c('div', [_vm._v("Confirma exclusão de " + _vm._s(_vm.count_selected_contacts) + " contato selecionado?")])])]), _c('change-responsability-modal', {
	    on: {
	      "confirm-modal-confirm": _vm.confirmChangeResponsability
	    }
	  }), _c('create-tag-modal'), _c('task-modal-form')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-primary dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('img', {
	    staticClass: "icon",
	    attrs: {
	      "src": __webpack_require__(250)
	    }
	  })])
	}]}

/***/ }),
/* 1055 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    class: {
	      "modal-lg": !_vm.selected_contact, "auto-width": _vm.show_calendar
	    }
	  }, [_c('div', {
	    class: {
	      "container": _vm.show_calendar
	    }
	  }, [_c('div', {
	    class: {
	      'row': _vm.show_calendar
	    }
	  }, [_c('div', {
	    class: {
	      'col-md-8 col-sm-8': _vm.show_calendar
	    }
	  }, [_c('div', {
	    staticClass: "modal-content",
	    attrs: {
	      "id": "modal_form_dialog"
	    }
	  }, [(!_vm.selected_contact) ? _c('contact-picker', {
	    on: {
	      "contact-selected": _vm.setSelectedContact
	    }
	  }) : [_c('task-form', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.removing),
	      expression: "!removing"
	    }],
	    attrs: {
	      "task": _vm.task,
	      "contact": _vm.selected_contact,
	      "can_change_contact": !_vm.contact,
	      "show_stage_selection": _vm.show_stage_selection,
	      "origem": "Tarefas"
	    },
	    on: {
	      "removing": function($event) {
	        _vm.removing = true
	      },
	      "change-contact": _vm.setSelectedContact,
	      "open-template-modal": _vm.bubbleUp
	    }
	  }), _c('confirm-destroy', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.removing),
	      expression: "removing"
	    }],
	    attrs: {
	      "task": _vm.task
	    },
	    on: {
	      "destroyed": _vm.taskDestroyed,
	      "cancel-removing": function($event) {
	        _vm.removing = false
	      }
	    }
	  })]], 2)]), (_vm.show_calendar) ? _c('div', {
	    staticClass: "padding_left_zero col-md-4 col-sm-4"
	  }, [_c('daily-events')], 1) : _vm._e()])])])])
	},staticRenderFns: []}

/***/ }),
/* 1056 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "rd_station_crm"
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.rdStation')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.rdStation')))])])])])]), _c('div', {
	    staticClass: "form"
	  }, [_c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-5",
	    class: {
	      'has-error': _vm.errors.has('rd_station_crm_api_key')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "rd_station_crm_api_key"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.apiKey')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rd_station_crm_api_key),
	      expression: "rd_station_crm_api_key"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "rd_station_crm_api_key",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.placeholder.apiKey')
	    },
	    domProps: {
	      "value": (_vm.rd_station_crm_api_key)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.rd_station_crm_api_key = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('rd_station_crm_api_key')),
	      expression: "errors.has('rd_station_crm_api_key')"
	    }],
	    key: "rd_station_crm_api_key",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('rd_station_crm_api_key')))])])], 1)]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group col-md-6"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    on: {
	      "click": function($event) {
	        return _vm.toggleCopySettings()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")]), _c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.copy_settings
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.copySettings')))])])]), (_vm.copy_settings) ? _c('div', {
	    staticClass: "form-group col-md-6"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")]), _c('div', {
	    staticClass: "col-md-10 padding-none"
	  }, [_c('dropdown-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "options": _vm.users_options_rd
	    },
	    model: {
	      value: (_vm.user_rd_setting),
	      callback: function($$v) {
	        _vm.user_rd_setting = $$v
	      },
	      expression: "user_rd_setting"
	    }
	  })], 1), _c('div', {
	    staticClass: "com-md-2"
	  }, [_c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.copy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))])])]) : _vm._e()]), _c('trigger-stages', {
	    attrs: {
	      "integration": "rd station crm",
	      "settings": _vm.rd_station_crm_setting.triggers
	    },
	    on: {
	      "selected-stages": _vm.setStagesRDStationCRM
	    }
	  }), _c('properties-matching', {
	    attrs: {
	      "properties_matching": _vm.rd_station_crm_setting.properties_matching,
	      "integration_name": "rd station crm",
	      "api_fields": _vm.api_fields
	    },
	    on: {
	      "matching-updated": _vm.matchingUpdated
	    }
	  }), _c('stages-matching', {
	    attrs: {
	      "stages_matching": _vm.rd_station_crm_setting.stages_matching,
	      "integration_name": "rd station crm",
	      "integration_no_stages_api": !_vm.has_stages_api,
	      "integration_stages": _vm.integration_stages,
	      "pipelines": _vm.pipelines,
	      "pipeline_id": _vm.selected_pipeline
	    },
	    on: {
	      "matching-updated": _vm.matchingStagesUpdated,
	      "users-update": _vm.updateUsers,
	      "update-stages": _vm.changePipeline
	    }
	  }), _c('hr'), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), (_vm.current_user.rd_station_crm_api_key) ? _c('button', {
	    staticClass: "pull-right btn btn-danger",
	    staticStyle: {
	      "margin-left": "15px"
	    },
	    on: {
	      "click": _vm.removeRDStationCRMApiKey
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _vm._e(), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/rdstationcrm.png"
	    }
	  })])
	}]}

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.vtiger')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.vtiger')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-config",
	    on: {
	      "click": function($event) {
	        return _vm.open()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "info info-crm"
	  }), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.has('access_key')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "access_key"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.accessKey')))]), _c('br'), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.setting.access_key),
	      expression: "setting.access_key"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "access_key",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.label.vtiger.accessKey')
	    },
	    domProps: {
	      "value": (_vm.setting.access_key)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.setting, "access_key", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('access_key')),
	      expression: "errors.has('access_key')"
	    }],
	    key: "access_key",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('access_key')))])])], 1)]), _c('br'), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.email')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.setting.username),
	      expression: "setting.username"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "email",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.label.vtiger.email')
	    },
	    domProps: {
	      "value": (_vm.setting.username)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.setting, "username", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    key: "email",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1), _c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('url')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "url"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.apiUrl')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.setting.url),
	      expression: "setting.url"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|url'),
	      expression: "'required|url'"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "url",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.label.vtiger.apiUrl')
	    },
	    domProps: {
	      "value": (_vm.setting.url)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.setting, "url", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('url')),
	      expression: "errors.has('url')"
	    }],
	    key: "url",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('url')))])])], 1)]), _c('hr', {
	    staticClass: "lines-div"
	  }), _c('span', [_c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-7"
	  }, [_c('trigger-stages', {
	    attrs: {
	      "integration": "vtiger",
	      "settings": _vm.setting.triggers
	    },
	    on: {
	      "selected-stages": _vm.setStages
	    }
	  })], 1), _c('div', {
	    staticClass: "form-group col-md-5"
	  }, [_c('div', {
	    staticClass: "row description"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.vtiger.lead')) + ":")])])]), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "row input-padding"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        return _vm.sending_checked('lead')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.lead
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.attributes.lead')))])])]), _c('div', {
	    staticClass: "row input-padding"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        return _vm.sending_checked('contact')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.contact
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.attributes.contact')))])])])])])])])]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "logo-box"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/vtiger.png"
	    }
	  })])])
	}]}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_sidebar),
	      expression: "show_sidebar"
	    }],
	    attrs: {
	      "id": "task-bar"
	    }
	  }, [(_vm.contact != null && !_vm.loading) ? _c('div', {
	    staticClass: "task-bar-wrapper"
	  }, [_c('div', {
	    staticClass: "task-bar-header"
	  }, [_c('router-link', {
	    staticClass: "contacts-name link",
	    attrs: {
	      "to": "/contatos/" + _vm.contact.id
	    }
	  }, [_vm._v(_vm._s(_vm.contact.full_name))]), _c('div', {
	    staticClass: "task-bar__contact-panel"
	  }, [(!_vm.is_bar_minimized) ? _c('div', {
	    staticClass: "clickable",
	    on: {
	      "click": _vm.minimize
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(985)
	    }
	  })]) : _vm._e(), (_vm.is_bar_minimized) ? _c('div', {
	    staticClass: "clickable",
	    on: {
	      "click": _vm.restore
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(983)
	    }
	  })]) : _vm._e(), _c('div', {
	    staticClass: "clickable",
	    on: {
	      "click": function($event) {
	        return _vm.close(_vm.contact.id)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(48)
	    }
	  })])])], 1), (_vm.has_business) ? [_c('router-link', {
	    staticClass: "company-jobs-name link",
	    attrs: {
	      "to": '/contatos/empresas/' + _vm.contact.business.id
	    }
	  }, [_vm._v(_vm._s(_vm.business_subheader))]), _c('span', {
	    staticClass: "company-jobs-name"
	  }, [_vm._v(_vm._s(_vm.position_subheader))])] : _c('span', {
	    staticClass: "company-jobs-name"
	  }, [_vm._v(_vm._s(_vm.business_subheader + _vm.position_subheader))]), (!_vm.is_bar_minimized) ? _c('div', {
	    staticClass: "minimize internal-scroller"
	  }, [_c('hr'), (_vm.contact.url) ? _c('a', {
	    staticClass: "company-url link",
	    attrs: {
	      "href": _vm.absoluteUrl(_vm.contact.url),
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.contact.url))]) : _c('span', {
	    staticClass: "company-url"
	  }, [_vm._v("-")]), _c('hr'), _c('span', {
	    staticClass: "contact-email"
	  }, [_vm._v(_vm._s(_vm.contact.email))]), _c('div', {
	    staticClass: "telephone"
	  }, [_c('span', {
	    staticClass: "phone-label"
	  }, [_vm._v("TELEFONE FIXO  ")]), _c('span', {
	    staticClass: "phone"
	  }, [_vm._v(_vm._s(_vm.contact.telephone || "-"))])]), _c('div', {
	    staticClass: "celphone"
	  }, [_c('span', {
	    staticClass: "celphone-label"
	  }, [_vm._v("CELULAR  ")]), _c('span', {
	    staticClass: "phone"
	  }, [_vm._v(_vm._s(_vm.contact.cellphone || "-"))])]), (_vm.contact.linkedin) ? _c('div', {
	    staticClass: "social"
	  }, [_c('hr'), _c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v("Social")]), _c('div', {
	    staticClass: "fa fa-linkedin social-icon"
	  }), _c('span', [_c('a', {
	    staticClass: "link",
	    attrs: {
	      "href": _vm.absoluteUrl(_vm.contact.linkedin),
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.linkedin_user_name))])])]) : _vm._e(), _c('div', {
	    staticClass: "flow-info"
	  }, [_c('hr'), _c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v("Fluxo")]), _c('br'), (_vm.contact.flow.id) ? _c('router-link', {
	    staticClass: "flow-link link",
	    class: {
	      underline: _vm.contact.flow
	    },
	    attrs: {
	      "to": "/fluxos-de-cadencia/" + _vm.contact.flow.id
	    }
	  }, [_vm._v(_vm._s(_vm.contact.flow.name || "-"))]) : _vm._e(), (_vm.contact.flow.id) ? _c('div', {
	    staticClass: "current-step"
	  }, [_c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v("Etapa atual")]), _c('span', {
	    staticClass: "flow-step"
	  }, [_vm._v(_vm._s(_vm.flow_current_step_text))])]) : _c('div', {
	    staticClass: "current-step"
	  }, [_c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v("-")])]), _c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v("Interações com o fluxo")]), _c('span', {
	    staticClass: "sent"
	  }, [_vm._v(_vm._s(_vm.interactions_count.delivery))]), _c('span', {
	    staticClass: "opened"
	  }, [_vm._v(_vm._s(_vm.interactions_count.open))]), _c('div', {
	    staticClass: "clear"
	  }), (_vm.has_open_interactions) ? [_c('div', {
	    staticClass: "subtitle"
	  }, [_vm._v("Interações com os e-mails")]), _c('div', {
	    staticClass: "flow-interations"
	  }, _vm._l((_vm.contact.interactions_with_current_flow.by_flow_action), function(interaction) {
	    return _c('div', {
	      staticClass: "flow-iteration"
	    }, [_c('span', {
	      staticClass: "prospec"
	    }, [_vm._v(_vm._s(_vm.flowActionDescription(interaction)))]), _c('br'), _c('span', {
	      staticClass: "template-name"
	    }, [_vm._v(_vm._s(_vm.templateDescription(interaction.template_subject)))]), _c('div', {
	      staticClass: "times"
	    }, [_vm._v(_vm._s(interaction.open) + "x")])])
	  }), 0)] : _vm._e()], 2), _c('div', {
	    staticClass: "comments"
	  }, [_c('hr'), _c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v(_vm._s(_vm.all_comments ? "Comentários" : "Último comentário"))]), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "new-comment"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.newComment(true)
	      }
	    }
	  }, [_vm._v("Novo comentário")]), _c('div', {
	    staticClass: "clear"
	  }), (_vm.comments.length == 0) ? _c('p', [_vm._v("-")]) : _vm._e(), _vm._l((_vm.comments), function(comment) {
	    return _c('div', {
	      staticClass: "comment"
	    }, [(comment.created_at) ? _c('span', {
	      staticClass: "comment-date"
	    }, [_vm._v(_vm._s(comment.created_at.format('LTS')))]) : _vm._e(), _c('br'), (!_vm.show_full_comments[comment.id]) ? _c('span', {
	      staticClass: "comment-text-short"
	    }, [_vm._v(_vm._s(_vm.shortDescription(comment.comment)) + "  ")]) : _c('span', {
	      staticClass: "comment-text-full"
	    }, [_vm._v(_vm._s(_vm.strippedContent(comment.comment)) + "  ")]), _c('br'), (comment.comment.length > _vm.description_num_of_char) ? _c('a', {
	      staticClass: "see-more clickable",
	      on: {
	        "click": function($event) {
	          return _vm.seeMoreComment(comment)
	        }
	      }
	    }, [_vm._v(_vm._s(!_vm.show_full_comments[comment.id] ? "ver mais" : "ver menos"))]) : _vm._e(), _c('a', {
	      staticClass: "edit clickable",
	      on: {
	        "click": function($event) {
	          return _vm.editComment(comment)
	        }
	      }
	    }, [_vm._v("Editar")])])
	  }), (_vm.contact.comments.length > 1) ? _c('a', {
	    staticClass: "all-comments clickable",
	    class: {
	      'arrow-up': _vm.all_comments
	    },
	    on: {
	      "click": _vm.showAllComments
	    }
	  }, [_vm._v("todos comentários")]) : _vm._e()], 2), _c('hr'), _c('div', {
	    staticClass: "tags"
	  }, [_c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v("Tags")]), _vm._l((_vm.contact.tags), function(tag, index) {
	    return _c('tag', {
	      attrs: {
	        "tag": tag,
	        "deletable": true
	      },
	      on: {
	        "remove-tag": _vm.removeTag
	      }
	    })
	  }), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
	    staticClass: "clickable inline",
	    on: {
	      "click": function($event) {
	        return _vm.openTagsModal()
	      }
	    }
	  }, [(_vm.contact.tags.length == 0) ? _c('span', [_vm._v("Adicionar Tags")]) : _vm._e(), _c('div', {
	    staticClass: "add-tags-btn glyphicon glyphicon-plus text-gray-color"
	  })]) : _vm._e()], 2)]) : _vm._e()], 2) : _c('div', {
	    staticClass: "loading-wrapper",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" convertido(s) via LeadLovers.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "contacts-form"
	    }
	  }, [_c('triggers', {
	    attrs: {
	      "triggers": _vm.flow.triggers,
	      "current_user_id": _vm.user_id_or_default
	    },
	    on: {
	      "update-triggers": _vm.updateTriggers
	    }
	  }), _c('hr'), _c('div', {
	    staticClass: "col-sm-6 no-padding"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('flows.title.contacts')))]), _c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.contacts')))]), _c('div', {
	    staticClass: "number-with-label"
	  }, [_c('div', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.number_of_contacts))]), _c('div', {
	    staticClass: "labels"
	  }, [_c('div', {
	    staticClass: "upper-label"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.contactS')))]), _c('div', {
	    staticClass: "lower-label"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.addS')))])])])]), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_vm._t("default")], 2), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "dropdown"
	  }, [_c('div', {
	    staticClass: "btn btn-clean dropdown-toggle",
	    attrs: {
	      "id": "add-contacts-dropdown",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('flows.actions.insertContacts')))]), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    attrs: {
	      "id": "contact-picker",
	      "data-toggle": "modal",
	      "data-target": "#contacts-picker"
	    }
	  }, [_c('a', {
	    staticClass: "clickable",
	    attrs: {
	      "id": "open-contact-picker"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.actions.contactsBase')))])]), _c('li', {
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#contacts-manual-picker"
	    }
	  }, [_c('a', {
	    staticClass: "clickable"
	  }, [_vm._v(_vm._s(_vm.$t('flows.actions.manually')))])])])]), _c('contact-picker', {
	    attrs: {
	      "user_id": _vm.user_id_or_default
	    },
	    on: {
	      "contacts-selected": _vm.selectContacts
	    }
	  }), _c('contact-manual-picker'), _c('hr'), _c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.dragDropProperties')))]), _c('contact-list', {
	    attrs: {
	      "contacts": _vm.contacts,
	      "view_mode": _vm.contactListViewModes().flow_edit,
	      "internal_scroller": true,
	      "draggable_options": {
	        disabled: _vm.any_filter,
	        filter: ".undraggable"
	      },
	      "flow": _vm.flow
	    },
	    on: {
	      "priority-updated": _vm.updateContactsPriority,
	      "filter": _vm.filter,
	      "scroll-ended": _vm.loadFlowContacts
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var contact = ref.contact;
	
	        return [_c('div', {
	          staticClass: "table-col table-col-collapsed show"
	        }, [(_vm.current_user.can_manage_templates) ? _c('span', {
	          staticClass: "plain-btn-edit clickable-element",
	          class: {
	            orange: _vm.hasSpecificTemplate(contact)
	          },
	          on: {
	            "click": function($event) {
	              return _vm.openSpecificTemplatesModal(contact)
	            }
	          }
	        }) : _vm._e()]), _c('div', {
	          staticClass: "table-col table-col-collapsed show"
	        }, [_c('span', {
	          staticClass: "glyphicon glyphicon-trash clickable-element",
	          on: {
	            "click": function($event) {
	              return _vm.removeContact(contact)
	            }
	          }
	        })])]
	      }
	    }])
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.fetching
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('contacts.feedback.noMoreResults')))])], 1), _c('specific-templates-modal', {
	    attrs: {
	      "flow": _vm.flow,
	      "contact": _vm.current_contact
	    },
	    on: {
	      "specific-template-add": function($event) {
	        return _vm.updateContactsWithSpecificTemplate($event, true)
	      },
	      "specific-template-destroy": function($event) {
	        return _vm.updateContactsWithSpecificTemplate($event, false)
	      }
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "ozzy-tasks"
	    }
	  }, [_c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "confirm-destroy-ozzy-task",
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('confirm-destroy', {
	    attrs: {
	      "task": _vm.task
	    },
	    on: {
	      "destroyed": _vm.taskDestroyed,
	      "cancel-removing": _vm.cancelRemoving
	    }
	  })], 1)])]), _vm._m(0), _c('br'), _c('list', {
	    ref: "done_tasks_list",
	    attrs: {
	      "filters": _vm.ozzy_tasks_filters
	    },
	    on: {
	      "removing": _vm.showConfirmDestroyModal,
	      "toggle-task-bar": _vm.bubbleUp
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h2', {
	    staticClass: "title"
	  }, [_vm._v("Ozzy tasks  "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(971)
	    }
	  })])
	}]}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.show) ? _c('div', {
	    staticClass: "alert-tick",
	    class: _vm.css_class,
	    attrs: {
	      "title": _vm.message,
	      "data-toggle": "tooltip",
	      "data-placement": "bottom"
	    }
	  }, [_vm._v("!")]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "change-accounts"
	    }
	  }, [_c('span', [_vm._v("Selecionar conta:")]), _c('companies-autocomplete', {
	    attrs: {
	      "external_id": "change"
	    },
	    on: {
	      "selected-company": _vm.selectedCompany
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    class: {
	      'modal-lg': !_vm.current_user.isSeller()
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(0), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.modalTitle))])]), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.loading) ? _c('div', {
	    staticClass: "loading",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": "loading",
	      "size": "50px"
	    }
	  })], 1) : [(!_vm.current_user.isSeller()) ? _c('div', {
	    staticClass: "col-md-7"
	  }, [_c('span', {
	    staticClass: "title light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.leadSelect')))]), _c('div', {
	    staticClass: "cleafix"
	  }, [_vm._v(" ")]), _c('div', {
	    staticClass: "table table-modal"
	  }, [_c('div', {
	    staticClass: "table-header table-row"
	  }, [_c('div', {
	    staticClass: "table-col contact-list-item-select table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    attrs: {
	      "id": "contact-select-all-checkbox"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.selectAll()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selected_all
	    }
	  }), _c('label', [_vm._v(" ")])])]), _c('div', {
	    staticClass: "table-col table-col-empashis table-col-120 contact-list-item-name"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.Responsible')))])]), _c('div', {
	    staticClass: "table-body internal-scroller"
	  }, [_c('hr'), _vm._l((_vm.users), function(user) {
	    return _c('list-item', {
	      key: user.id,
	      attrs: {
	        "user": user,
	        "show-checkbox": true,
	        "list-carousel": true,
	        "userIsSelected": _vm.userIsSelected(user)
	      },
	      on: {
	        "user-selected": _vm.selectUser
	      }
	    })
	  })], 2)])]) : _vm._e(), _c('div', {
	    class: {
	      'col-md-11': _vm.current_user.isSeller(), 'col-md-5': !_vm.current_user.isSeller()
	    }
	  }, [_c('div', {
	    staticClass: "list-reponsibles"
	  }, [_c('span', {
	    staticClass: "dark-slate-gray"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.lastResponsible')))]), _c('div', {
	    staticClass: "draggable-responsible",
	    class: {
	      'no-last-user': !_vm.has_last_user
	    }
	  }, [(_vm.has_last_user) ? [_c('div', {
	    staticClass: "user-miniature-wrapper"
	  }, [_c('div', {
	    staticClass: "user-miniature-picture-wrapper"
	  }, [_c('img', {
	    staticClass: "user-miniature-picture",
	    attrs: {
	      "src": _vm.carousel.last_user.picture_url
	    }
	  })])]), _c('div', {
	    staticClass: "name light-gray-text"
	  }, [_vm._v(_vm._s(_vm.carousel.last_user.name))])] : _c('div', {
	    staticClass: "name light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.lastResponsibleFeedback')))])], 2), _c('hr', {
	    staticClass: "separator"
	  }), _c('span', {
	    staticClass: "dark-slate-gray"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.modal_carousel.nextResponsibles')))]), _c('div', {
	    staticClass: "responsible-wrapper internal-scroller"
	  }, [_c('draggable', {
	    attrs: {
	      "value": _vm.selected_users,
	      "options": _vm.draggable_options
	    },
	    on: {
	      "input": _vm.changeOrder
	    }
	  }, _vm._l((_vm.selected_users), function(carousel_user) {
	    return _c('div', {
	      staticClass: "draggable-responsible clickable"
	    }, [(_vm.carousel && _vm.carousel.next_user_id == carousel_user.user_id) ? _c('img', {
	      staticClass: "green-arrow",
	      attrs: {
	        "src": __webpack_require__(249)
	      }
	    }) : _vm._e(), _c('div', {
	      staticClass: "user-miniature-wrapper"
	    }, [_c('div', {
	      staticClass: "user-miniature-picture-wrapper"
	    }, [_c('img', {
	      staticClass: "user-miniature-picture",
	      attrs: {
	        "src": carousel_user.user.picture_url
	      }
	    })])]), _c('div', {
	      staticClass: "name light-gray-text"
	    }, [_vm._v(_vm._s(carousel_user.user.name))])])
	  }), 0)], 1)])])]], 2), _c('div', {
	    staticClass: "clearfix"
	  }), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('a', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Cancelar")]), (_vm.current_user.isSeller()) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.ok')))]) : _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "autocomplete-wrapper"
	  }, [_c('v-autocomplete', {
	    attrs: {
	      "id": _vm.id,
	      "items": _vm.contacts,
	      "get-label": _vm.getLabel,
	      "component-item": _vm.item_contact,
	      "input-attrs": _vm.attrs,
	      "auto-select-one-item": false
	    },
	    on: {
	      "update-items": _vm.searchContacts,
	      "item-selected": _vm.addContact
	    },
	    model: {
	      value: (_vm.contact),
	      callback: function($$v) {
	        _vm.contact = $$v
	      },
	      expression: "contact"
	    }
	  }), (_vm.loading) ? _c('div', {
	    staticClass: "loading",
	    attrs: {
	      "align": "right"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": "loading",
	      "size": "20px"
	    }
	  })], 1) : _vm._e(), (_vm.show_no_result_found_message) ? _c('div', {
	    staticClass: "no-result-found"
	  }, [_vm._v(_vm._s(_vm.$t('contacts.feedback.noSearchResults')))]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.task.isDone()) ? _c('div', {
	    staticClass: "task-item",
	    class: _vm.taskItemClass() + " " + _vm.options.width
	  }, [_c('div', {
	    staticClass: "task-date"
	  }, [_c('span', [_vm._v(_vm._s(_vm.task.dueOnDate()))]), (!_vm.task.undefined_time) ? _c('span', [_vm._v("- " + _vm._s(_vm.task.dueOnHour()))]) : _vm._e()]), (_vm.element_options.show_contact) ? _c('div', {
	    staticClass: "task-contact clickable",
	    on: {
	      "click": function($event) {
	        return _vm.toggleTaskBar(false)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "spacer-15"
	  }), _c('div', {
	    staticClass: "contact-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.task.contact.full_name))]), _c('div', {
	    staticClass: "contact-business"
	  }, [_vm._v(_vm._s(_vm.task.contact.business.name))])]) : _c('div', {
	    staticClass: "spacer-15"
	  }), _c('div', {
	    staticClass: "task-contact"
	  }, [(_vm.task.created_by_type === 'FlowAction' && _vm.task.flow !== undefined) ? _c('div', {
	    staticClass: "contact-flow"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(973),
	      "width": "9.5",
	      "height": "9.5"
	    }
	  }), _c('span', [_vm._v(_vm._s(_vm.task.flow.name))])]) : _vm._e()]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "interaction"
	  }, [(!_vm.task.isMeetingTask()) ? _c('span', {
	    staticClass: "sent"
	  }, [_vm._v(_vm._s(_vm.total_delivery))]) : _vm._e(), (!_vm.task.isMeetingTask()) ? _c('span', {
	    staticClass: "opened"
	  }, [_vm._v(_vm._s(_vm.total_open))]) : _vm._e()]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "task-text"
	  }, [_c('div', {
	    staticClass: "task-description overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.task_description))]), _c('div', {
	    staticClass: "task-info overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.task_info))])]), _c('div', {
	    staticClass: "task-action-bar"
	  }, [(!_vm.current_user.isMonitoringManager() && !_vm.task.isOzzyTask()) ? _c('div', {
	    staticClass: "edit-task-action glyphicon glyphicon-pencil",
	    on: {
	      "click": _vm.editTask
	    }
	  }) : _vm._e(), (_vm.element_options.show_comment && _vm.task.comment) ? _c('div', {
	    ref: "element_id",
	    staticClass: "comment-task-action task-comment-icon",
	    class: {
	      'comment-icon-down': _vm.task.isEmailTask()
	    },
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": _vm.tooltip_text,
	      "data-placement": _vm.tooltip_placement
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "edit-task-action",
	    class: _vm.iconClass(),
	    on: {
	      "click": _vm.emitOpenCompose
	    }
	  }), (_vm.show_second_call_button) ? _c('div', {
	    staticClass: "phone-task-action clickable",
	    on: {
	      "click": function($event) {
	        return _vm.toggleTaskBar(true)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "dropdown-toggle glyphicon glyphicon-earphone"
	  })]) : (_vm.show_call_button) ? _c('div', {
	    staticClass: "phone-task-action clickable"
	  }, [_c('span', {
	    staticClass: "dropdown-toggle glyphicon glyphicon-earphone",
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right"
	  }, [(_vm.task.contact.cellphone) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openDialer(_vm.task.contact.cellphone, "cellphone", _vm.task, true)
	      }
	    }
	  }, [_vm._v("Ligar para celular " + _vm._s(_vm.normalizePhone(_vm.task.contact.cellphone)))])]) : _vm._e(), (_vm.task.contact.telephone) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openDialer(_vm.task.contact.telephone, "telephone", _vm.task, true)
	      }
	    }
	  }, [_vm._v("Ligar para telefone fixo " + _vm._s(_vm.normalizePhone(_vm.task.contact.telephone)))])]) : _vm._e(), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openDialer(null, "", _vm.task, true)
	      }
	    }
	  }, [_vm._v("Ligar para outro número")])])])]) : _vm._e(), (!_vm.disable_toggle_done) ? _c('div', {
	    staticClass: "done-menu glyphicon glyphicon-ok-circle clickable",
	    on: {
	      "click": _vm.toggleDone
	    }
	  }) : _vm._e()]), (_vm.task.assigned_to && !_vm.current_user.isSeller()) ? _c('div', {
	    staticClass: "task-user"
	  }, [_c('user-miniature', {
	    attrs: {
	      "user": _vm.task.assigned_to,
	      "options": {
	        first_name: true
	      }
	    }
	  })], 1) : _vm._e(), _c('confirm', {
	    attrs: {
	      "id": _vm.confirmTaskId,
	      "title": "Sua tarefa será finalizada",
	      "message": "Deseja enviar o e-mail ou apenas concluir a tarefa?",
	      "reject_text": "Apenas concluir",
	      "confirm_text": "Concluir e enviar e-mail"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.sendEmailDoneTask,
	      "confirm-modal-reject": _vm.doneTask
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "compose",
	    class: {
	      minimized: _vm.minimized
	    },
	    attrs: {
	      "id": _vm.compose_id
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.minimized),
	      expression: "!minimized"
	    }],
	    staticClass: "full"
	  }, [_c('div', {
	    staticClass: "title",
	    class: _vm.titleClass()
	  }, [_c('span', [_vm._v(_vm._s(_vm.compose_header))]), _c('div', {
	    staticClass: "close-compose",
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(252)
	    }
	  })]), _c('div', {
	    staticClass: "minimize-compose",
	    on: {
	      "click": function($event) {
	        return _vm.minimize()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(984)
	    }
	  })])]), _c('div', {
	    staticClass: "form"
	  }, [(_vm.template.kind == 'email' || _vm.task.templateKind() == 'email') ? _c('div', {
	    staticClass: "label-to"
	  }, [_vm._v("Para")]) : _vm._e(), (_vm.template.kind == 'email' || _vm.task.templateKind() == 'email') ? _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.task_has_contact) ? _c('input', {
	    staticClass: "contacts",
	    attrs: {
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": _vm.task.contact.full_name
	    }
	  }) : _c('contact-autocomplete', {
	    attrs: {
	      "external_id": _vm.id
	    },
	    on: {
	      "contact-selected": _vm.updateContact
	    }
	  }), (_vm.task_has_contact) ? _c('div', {
	    staticClass: "contact-name"
	  }, [_vm._v(_vm._s(_vm.task.contact.full_name)), (_vm.task.id == null) ? _c('div', {
	    staticClass: "remove-contact glyphicon glyphicon-remove",
	    on: {
	      "click": _vm.removeContact
	    }
	  }) : _vm._e()]) : _vm._e()], 1) : _vm._e(), (_vm.template.kind == 'email' || _vm.task.templateKind() == 'email') ? _c('div', {
	    staticClass: "cc-open",
	    on: {
	      "click": _vm.toggleCc
	    }
	  }, [_vm._v("Cc")]) : _vm._e(), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_cc),
	      expression: "show_cc"
	    }],
	    staticClass: "cc-wrapper"
	  }, [_c('div', {
	    staticClass: "label-cc"
	  }, [_vm._v("Cc")]), _vm._l((_vm.cc_emails), function(item, index) {
	    return _c('div', {
	      staticClass: "email"
	    }, [_vm._v(_vm._s(item.email)), _c('div', {
	      staticClass: "remove-email glyphicon glyphicon-remove",
	      on: {
	        "click": function($event) {
	          return _vm.removeEmail(index)
	        }
	      }
	    })])
	  }), _c('input', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.cc_emails.length < 10),
	      expression: "cc_emails.length < 10"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cc_text),
	      expression: "cc_text"
	    }],
	    staticClass: "cc",
	    domProps: {
	      "value": (_vm.cc_text)
	    },
	    on: {
	      "blur": _vm.blurCc,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cc_text = $event.target.value
	      }
	    }
	  })], 2), _c('div', {
	    staticClass: "clear"
	  }), (_vm.template.kind == 'email' || _vm.task.templateKind() == 'email') ? _c('div', {
	    staticClass: "form-group",
	    class: _vm.subject_group_class
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.subject),
	      expression: "subject"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "subject",
	    attrs: {
	      "placeholder": "Assunto",
	      "name": "subject",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.subject)
	    },
	    on: {
	      "blur": _vm.updateLastSubjectCursorPosition,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.subject = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.subject_help_text),
	      expression: "subject_help_text"
	    }],
	    key: "subject",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.subject_help_text))])]), _c('variables-dropdown', {
	    class: {
	      cc: _vm.show_cc
	    },
	    attrs: {
	      "id": "subject-variables",
	      "variables": _vm.variables
	    },
	    on: {
	      "add-variable": _vm.addVariableToSubject
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "form-group white-border",
	    class: {
	      'has-error': _vm.errors.has('body')
	    }
	  }, [_c('div', {
	    staticClass: "label-body"
	  }, [_vm._v(_vm._s(_vm.template.id ? _vm.contentLabel(_vm.template.kind) : _vm.contentLabel(_vm.task.templateKind())))]), _c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "body",
	    attrs: {
	      "id": "body",
	      "name": "body"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('body')),
	      expression: "errors.has('body')"
	    }],
	    key: "body",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('body')))])]), _c('variables-dropdown', {
	    class: {
	      cc: _vm.show_cc
	    },
	    attrs: {
	      "id": "body-variables",
	      "variables": _vm.variables
	    },
	    on: {
	      "add-variable": _vm.addVariableToBody
	    },
	    nativeOn: {
	      "mousedown": function($event) {
	        $event.preventDefault();
	        return _vm.saveSummernoteRange.apply(null, arguments)
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "form-group white-border"
	  }, [(_vm.files.length != 0) ? _c('div', _vm._l((_vm.files), function(file, index) {
	    return _c('div', [_c('div', {
	      staticClass: "attachment",
	      class: {
	        'text-uploading': file.uploading
	      }
	    }, [(file.uploading) ? _c('div', {
	      staticClass: "progress-bar-upload",
	      style: ({
	        width: file.progress + '%'
	      })
	    }) : _vm._e(), _c('span', {
	      staticClass: "file-name"
	    }, [_vm._v(_vm._s(file.name))]), _c('span', [_vm._v("(" + _vm._s(file.size / 1000) + " KB)")]), (!file.uploading) ? _c('button', {
	      staticClass: "close",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.removeFile(index)
	        }
	      }
	    }, [_c('span', [_vm._v("×")])]) : _vm._e()])])
	  }), 0) : _vm._e()])]), _c('div', {
	    staticClass: "footer"
	  }, [(_vm.allow_change_template) ? _c('template-autocomplete', {
	    attrs: {
	      "external_id": _vm.id,
	      "kind": _vm.task.templateKind()
	    },
	    on: {
	      "template-selected": _vm.updateTemplate,
	      "hide": _vm.hideTemplateAutocomplete
	    }
	  }) : _vm._e(), _c('img', {
	    staticClass: "templates",
	    attrs: {
	      "src": __webpack_require__(993),
	      "data-toggle": "tooltip",
	      "title": _vm.template_name,
	      "data-placement": "top"
	    },
	    on: {
	      "click": _vm.toggleTemplateAutocomplete
	    }
	  }), _c('img', {
	    attrs: {
	      "src": __webpack_require__(969)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleToolbar()
	      }
	    }
	  }), (_vm.files.length < 5 && _vm.current_user.isNylas() && !_vm.is_meeting_schedule) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(964)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.chooseFiles()
	      }
	    }
	  }) : _vm._e(), (_vm.task.isSocialTask()) ? _c('div', {
	    staticClass: "btn-primary btn whatsapp-icon",
	    class: {
	      disabled: !_vm.contact_has_cellphone
	    },
	    on: {
	      "click": _vm.toWhatsapp
	    }
	  }, [_c('img', {
	    class: {
	      disabled: !_vm.contact_has_cellphone
	    },
	    attrs: {
	      "src": __webpack_require__(978)
	    }
	  })]) : _vm._e(), (_vm.task.isLikedinTask()) ? _c('div', {
	    staticClass: "btn-primary btn linkedin-icon",
	    on: {
	      "click": _vm.toLinkedin
	    }
	  }, [_vm._v("Copiar e Abrir Linkedin"), _c('img', {
	    attrs: {
	      "src": __webpack_require__(976)
	    }
	  })]) : _vm._e(), (_vm.task.templateKind() == 'email' && !_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "btn-primary btn btn-send",
	    attrs: {
	      "disabled": _vm.loading || _vm.isUploading()
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit(true)
	      }
	    }
	  }, [_vm._v("Enviar")]) : (!_vm.copied && !_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "btn-primary btn",
	    on: {
	      "click": function($event) {
	        return _vm.copy()
	      }
	    }
	  }, [_vm._v("Copiar")]) : (!_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "btn-primary btn",
	    on: {
	      "click": function($event) {
	        return _vm.doneTask()
	      }
	    }
	  }, [_vm._v("Finalizar")]) : _vm._e(), (!_vm.is_meeting_schedule && _vm.task.isEmailTask()) ? _c('div', {
	    staticClass: "btn-primary btn-calendar btn",
	    class: {
	      scheduled: _vm.task.isScheduled()
	    },
	    on: {
	      "click": function($event) {
	        return _vm.openScheduler()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(966)
	    }
	  })]) : _vm._e(), (_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "btn-primary btn",
	    on: {
	      "click": function($event) {
	        return _vm.submit(false, true)
	      }
	    }
	  }, [_vm._v("Agendar lembrete")]) : _vm._e(), (!_vm.is_meeting_schedule) ? _c('div', {
	    staticClass: "btn-primary btn-save btn",
	    attrs: {
	      "disabled": _vm.loading || _vm.isUploading()
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submit(false)
	      }
	    }
	  }, [_vm._v("Salvar")]) : _vm._e(), _c('input', {
	    ref: "fileUpload",
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "id": "fileUpload",
	      "type": "file"
	    },
	    on: {
	      "change": _vm.selectAttachment
	    }
	  }), _c('div', {
	    staticClass: "vertical-separator"
	  })], 1)]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.minimized),
	      expression: "minimized"
	    }],
	    staticClass: "minimized"
	  }, [_c('div', {
	    staticClass: "title",
	    class: _vm.template.kind
	  }, [_c('span', [_vm._v(_vm._s(_vm.compose_header))]), _c('div', {
	    staticClass: "close-compose",
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(252)
	    }
	  })]), _c('div', {
	    staticClass: "minimize-compose",
	    on: {
	      "click": function($event) {
	        return _vm.minimize()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(982)
	    }
	  })])])]), (_vm.show_scheduler) ? _c('scheduler', {
	    attrs: {
	      "task": _vm.task,
	      "loading": _vm.loading,
	      "number_composes": _vm.number_composes,
	      "event": _vm.event
	    },
	    on: {
	      "close-scheduler": function($event) {
	        return _vm.closeScheduler()
	      },
	      "schedule-meeting-date": _vm.setMeetingReminderDate,
	      "schedule-email-send": _vm.handleSchedueEmailEvent
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    attrs: {
	      "id": "flows-index"
	    }
	  }, [_c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.$t('flows.title.cadenceFlows')))]), (!_vm.current_user.isMonitoringManager()) ? _c('router-link', {
	    staticClass: "btn btn-primary pull-right",
	    attrs: {
	      "id": "new-flow",
	      "to": "/fluxos-de-cadencia/opcoes-de-criacao"
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('flows.title.cadenceFlowNew')))]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('list', {
	    attrs: {
	      "list_item_options": _vm.list_item_options
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  }), _c('span', {
	    staticClass: "conversion"
	  }, [_vm._v(_vm._s(_vm.item.recipients_statistics_conversion()))]), _c('span', {
	    staticClass: "contact_count"
	  }, [_vm._v(_vm._s(_vm.item.contacts_count()))])])
	},staticRenderFns: []}

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._v(_vm._s(_vm.modal_title)), _vm._m(0)]), _c('div', {
	    staticClass: "modal-body",
	    style: ({
	      maxHeight: _vm.height + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "task-form"
	  }, [_c('div', {
	    staticClass: "col-xl-8 col-md-7 col-sm-5 col-xs-12",
	    attrs: {
	      "id": "other_options"
	    }
	  }, [(_vm.can_change_contact) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Contato"), _c('span', {
	    staticClass: "spacer-5"
	  }), _c('span', {
	    staticClass: "glyphicon glyphicon-pencil clickable",
	    on: {
	      "click": function($event) {
	        return _vm.$emit("change-contact", {
	          contact: null
	        })
	      }
	    }
	  })]), _c('input', {
	    staticClass: "form-control text-gray-color",
	    attrs: {
	      "disabled": ""
	    },
	    domProps: {
	      "value": _vm.contact.full_name
	    }
	  })]) : _vm._e(), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('task_service')
	    }
	  }, [_c('label', [_vm._v("Tipo de Tarefa")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.task.service),
	      expression: "task.service"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    class: {
	      'is-email-task': _vm.task.isEmailTask()
	    },
	    attrs: {
	      "name": "task_service"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.task, "service", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.availableManualTaskServices), function(service_options) {
	    return _c('option', {
	      domProps: {
	        "value": service_options.service
	      }
	    }, [_vm._v(_vm._s(service_options.human_name))])
	  }), 0), (_vm.task.isEmailTask()) ? _c('div', {
	    staticClass: "button-email",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": "Ir para e-mail"
	    },
	    on: {
	      "click": _vm.emitOpenTemplateModalEvent
	    }
	  }) : _vm._e(), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('task_service')),
	      expression: "errors.has('task_service')"
	    }],
	    key: "task_service",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('task_service')))])])], 1), (!_vm.show_meeting_task) ? _c('div', {
	    staticClass: "form-group due-on-time-picker-wrapper",
	    class: {
	      'has-error': _vm.errors.has('due_on_time')
	    }
	  }, [_c('label', [_vm._v("Horário")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('regex:^([0-2][0-9]:[0-5][0-9])$'),
	      expression: "'regex:^([0-2][0-9]:[0-5][0-9])$'"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##:##'),
	      expression: "'##:##'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.due_on_time),
	      expression: "due_on_time"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "due_on_time",
	      "placeholder": "HH:MM"
	    },
	    domProps: {
	      "value": (_vm.due_on_time)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.due_on_time = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('due_on_time')),
	      expression: "errors.has('due_on_time')"
	    }],
	    key: "due_on_time",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('due_on_time')))])])], 1) : _vm._e(), (_vm.show_meeting_task) ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('meeting_type_id')
	    }
	  }, [_c('label', [_vm._v("Tipo de Reunião")]), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.task.meeting_type_id),
	      expression: "task.meeting_type_id"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    class: {
	      'is-email-task': _vm.task.isEmailTask()
	    },
	    attrs: {
	      "disabled": _vm.meeting_types.length == 0,
	      "name": "meeting_type_id"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.$set(_vm.task, "meeting_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	      }
	    }
	  }, _vm._l((_vm.meeting_types), function(meeting_type) {
	    return _c('option', {
	      domProps: {
	        "value": meeting_type.id
	      }
	    }, [_vm._v(_vm._s(meeting_type.title))])
	  }), 0), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('meeting_type_id')),
	      expression: "errors.has('meeting_type_id')"
	    }],
	    key: "meeting_type_id",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('meeting_type_id')))]), _c('a', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.meeting_types.length == 0),
	      expression: "meeting_types.length == 0"
	    }],
	    key: "meeting_type_empty",
	    staticClass: "link-no-meeting-types",
	    attrs: {
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.toActivities
	    }
	  }, [_vm._v("Você não possui nenhum tipo de reunião cadastrado")])])], 1) : _vm._e(), (_vm.show_meeting_task) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Responsável")]), _c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "options": _vm.users_options
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  })], 1) : _vm._e()]), _c('div', {
	    staticClass: "col-xl-4 col-md-5 col-sm-6 col-xs-12",
	    attrs: {
	      "id": "calendar_choice"
	    }
	  }, [_c('div', {
	    staticClass: "datepicker-wrapper"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Selecione a data")]), _c('datepicker', {
	    attrs: {
	      "inline": true,
	      "disabled": {
	        to: _vm.yesterday
	      },
	      "language": "pt-br"
	    },
	    model: {
	      value: (_vm.due_on_date),
	      callback: function($$v) {
	        _vm.due_on_date = $$v
	      },
	      expression: "due_on_date"
	    }
	  })], 1)]), (_vm.show_meeting_task) ? _c('div', {
	    staticClass: "form-group due-on-time-picker-wrapper",
	    class: {
	      'has-error': _vm.errors.has('due_on_time'), 'has-error': _vm.errors.has('end_on_time')
	    }
	  }, [_c('label', [_vm._v("Horário")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('regex:^([0-2][0-9]:[0-5][0-9])$'),
	      expression: "'regex:^([0-2][0-9]:[0-5][0-9])$'"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##:##'),
	      expression: "'##:##'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.due_on_time),
	      expression: "due_on_time"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "due_on_time",
	      "placeholder": "HH:MM"
	    },
	    domProps: {
	      "value": (_vm.due_on_time)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.due_on_time = $event.target.value
	      }
	    }
	  }), (_vm.show_meeting_task) ? _c('span', {
	    staticStyle: {
	      "padding": "10px"
	    }
	  }, [_vm._v("às")]) : _vm._e(), (_vm.show_meeting_task) ? _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('regex:^([0-2][0-9]:[0-5][0-9])$'),
	      expression: "'regex:^([0-2][0-9]:[0-5][0-9])$'"
	    }, {
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##:##'),
	      expression: "'##:##'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.end_on_time),
	      expression: "end_on_time"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "end_on_time",
	      "placeholder": "HH:MM"
	    },
	    domProps: {
	      "value": (_vm.end_on_time)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.end_on_time = $event.target.value
	      }
	    }
	  }) : _vm._e(), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('due_on_time') || _vm.errors.has('end_on_time')),
	      expression: "errors.has('due_on_time') || errors.has('end_on_time')"
	    }],
	    key: "due_on_time",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('due_on_time') || _vm.errors.first('end_on_time')))])])], 1) : _vm._e()])]), _c('div', {
	    staticClass: "task-form"
	  }, [(_vm.show_meeting_task) ? _c('div', {
	    staticClass: "form-group full-width",
	    class: {
	      'has-error': _vm.errors.has('email_invites')
	    }
	  }, [_c('label', [_vm._v("Enviar invites para")]), _c('div', {
	    staticClass: "cc-wrapper"
	  }, [_c('div', _vm._l((_vm.email_invites), function(item, index) {
	    return _c('div', {
	      staticClass: "email"
	    }, [_vm._v(_vm._s(item.email)), _c('div', {
	      staticClass: "remove-email glyphicon glyphicon-remove",
	      on: {
	        "click": function($event) {
	          return _vm.removeEmail(index)
	        }
	      }
	    })])
	  }), 0), _c('div', [_c('input', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.email_invites.length < 10),
	      expression: "email_invites.length < 10"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cc_text),
	      expression: "cc_text"
	    }],
	    staticClass: "form-control cc",
	    domProps: {
	      "value": (_vm.cc_text)
	    },
	    on: {
	      "blur": _vm.blurCc,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cc_text = $event.target.value
	      }
	    }
	  })])]), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email_invites')),
	      expression: "errors.has('email_invites')"
	    }],
	    key: "email_invites",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email_invites')))])])], 1) : _vm._e()]), _c('div', {
	    staticClass: "task-form"
	  }, [(_vm.show_meeting_task) ? _c('div', {
	    staticClass: "form-group full-width",
	    class: {
	      'has-error': _vm.errors.has('social_link')
	    }
	  }, [_c('label', [_vm._v("Link para reunião")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.social_link),
	      expression: "social_link"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "social_link"
	    },
	    domProps: {
	      "value": (_vm.social_link)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.social_link = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('social_link')),
	      expression: "errors.has('social_link')"
	    }],
	    key: "social_link",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('social_link')))])])], 1) : _vm._e()]), _c('div', {
	    staticClass: "task-form"
	  }, [(_vm.show_stage_selection) ? _c('div', {
	    staticClass: "form-group full-width",
	    class: {
	      'has-error': _vm.errors.has('new_stage')
	    }
	  }, [_c('label', [_vm._v("Selecione o novo estágio")]), _c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "data-vv-name": "new_stage",
	      "options": _vm.next_valid_stages
	    },
	    model: {
	      value: (_vm.new_stage),
	      callback: function($$v) {
	        _vm.new_stage = $$v
	      },
	      expression: "new_stage"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('new_stage')),
	      expression: "errors.has('new_stage')"
	    }],
	    key: "new_stage",
	    staticClass: "help-block"
	  }, [_vm._v("Favor selecionar o estágio")])])], 1) : _vm._e()]), _c('div', {
	    staticClass: "task-form"
	  }, [_c('div', {
	    staticClass: "form-group full-width",
	    class: {
	      'has-error': _vm.errors.has('comment')
	    }
	  }, [_c('label', [_vm._v("Comentário")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.task.comment),
	      expression: "task.comment"
	    }],
	    staticClass: "form-control comment",
	    attrs: {
	      "name": "comment",
	      "rows": "3"
	    },
	    domProps: {
	      "value": (_vm.task.comment)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.task, "comment", $event.target.value)
	      }
	    }
	  })])]), (_vm.show_meeting_task) ? _c('div', {
	    staticClass: "task-form"
	  }, [_c('div', {
	    staticClass: "form-group full-width"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": _vm.checkboxSendReminder
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.send_reminder
	    }
	  }), _c('label', [_vm._v("Enviar e-mail de lembrete da reunião")])])])]) : _vm._e()]), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "task-actions"
	  }, [_c('div', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), (_vm.task.isPersisted()) ? _c('div', {
	    staticClass: "btn btn-danger no-margin",
	    on: {
	      "click": function($event) {
	        return _vm.$emit("removing")
	      }
	    }
	  }, [_vm._v("Excluir")]) : _vm._e(), (_vm.valid_due_on) ? _c('div', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": _vm.meeting_types.length == 0 && _vm.show_meeting_task
	    },
	    on: {
	      "click": function($event) {
	        return _vm.save()
	      }
	    }
	  }, [_vm._v("Salvar")]) : _c('div', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v("Salvar")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "role": "dialog",
	      "id": "create-tag"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v("Criar Nova Tag")])]), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v("Nome da Tag")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "tagName",
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('color')
	    }
	  }, [_c('div', {
	    staticClass: "color-input"
	  }, [_c('div', {
	    staticClass: "color-picker"
	  }, _vm._l((_vm.tagColors), function(color) {
	    return _c('div', {
	      staticClass: "color-box",
	      class: color.class,
	      style: ({
	        "background": "#" + color.hex
	      }),
	      on: {
	        "click": function($event) {
	          return _vm.setColor(color)
	        }
	      }
	    })
	  }), 0), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "color",
	      "name": "color",
	      "type": "hidden"
	    },
	    domProps: {
	      "value": _vm.color()
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('color')),
	      expression: "errors.has('color')"
	    }],
	    key: "color",
	    staticClass: "help-block"
	  }, [_vm._v("Você precisa selecionar uma cor")])])], 1)])]), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_vm._v("Cancelar")]), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.create
	    }
	  }, [_vm._v("Criar")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table-row",
	    class: {
	      'clickable': _vm.editabled
	    }
	  }, [_c('div', {
	    staticClass: "table-col text-gray-color"
	  }, [_c('span', {
	    staticClass: "glyphicon",
	    class: _vm.custom_field.kind
	  }), _vm._v(_vm._s(_vm.custom_field.field))]), (_vm.editabled) ? _c('div', {
	    staticClass: "table-col text-right"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.edit
	    }
	  }, [_vm._v("Editar")]), _c('span', {
	    staticClass: "spacer-15"
	  }), _c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": _vm.destroyCustomField
	    }
	  }, [_vm._v("Excluir")])]) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dropdown pull-right"
	  }, [_c('div', {
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-plus uppercase"
	  }), _vm._v(_vm._s(_vm.$t('template.attributes.variable')))]), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, _vm._l((_vm.variables), function(variable) {
	    return _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.addVariable(variable)
	        }
	      }
	    }, [_vm._v(_vm._s(variable.name))])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "configuration-view-wrapper new-company"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('companies.actions.create')))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.name')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.company.name),
	      expression: "company.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "name",
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.company.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.company, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email_domain')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "email_domain"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.emailDomain')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.company.email_domain),
	      expression: "company.email_domain"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "email_domain",
	      "name": "email_domain",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.company.email_domain)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.company, "email_domain", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "email_domain": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email_domain')),
	      expression: "errors.has('email_domain')"
	    }],
	    key: "email_domain",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email_domain')))])])], 1), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "account_setting"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.plan')))]), _c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "id": "account_setting",
	      "options": _vm.company.account_setting_options().account_settings,
	      "selected": _vm.account_setting_selected
	    },
	    model: {
	      value: (_vm.account_setting_selected),
	      callback: function($$v) {
	        _vm.account_setting_selected = $$v
	      },
	      expression: "account_setting_selected"
	    }
	  })], 1), (_vm.account_setting_selected && _vm.account_setting_selected.name == "custom") ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('max_number_of_regular_users')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "max_number_of_regular_users"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.maxUsersCount')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account_setting.max_number_of_regular_users),
	      expression: "account_setting.max_number_of_regular_users"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "max_number_of_regular_users",
	      "name": "max_number_of_regular_users",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account_setting.max_number_of_regular_users)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account_setting, "max_number_of_regular_users", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "max_number_of_regular_users": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('max_number_of_regular_users')),
	      expression: "errors.has('max_number_of_regular_users')"
	    }],
	    key: "max_number_of_regular_users",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('max_number_of_regular_users')))])])], 1) : _vm._e(), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('max_number_of_monitoring_managers')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "max_number_of_monitoring_managers"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.maxManagersCount')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account_setting.max_number_of_monitoring_managers),
	      expression: "account_setting.max_number_of_monitoring_managers"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "max_number_of_monitoring_managers",
	      "name": "max_number_of_monitoring_managers",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account_setting.max_number_of_monitoring_managers)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account_setting, "max_number_of_monitoring_managers", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "max_number_of_monitoring_managers": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('max_number_of_monitoring_managers')),
	      expression: "errors.has('max_number_of_monitoring_managers')"
	    }],
	    key: "max_number_of_monitoring_managers",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('max_number_of_monitoring_managers')))])])], 1), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "account_setting"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.emailService')))]), _c('email-service-dropdown', {
	    model: {
	      value: (_vm.company.email_service),
	      callback: function($$v) {
	        _vm.$set(_vm.company, "email_service", $$v)
	      },
	      expression: "company.email_service"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email_service')),
	      expression: "errors.has('email_service')"
	    }],
	    key: "email_service",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email_service')))])])], 1)])]), _c('div', {
	    staticClass: "clear"
	  }), _c('br'), _c('router-link', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "to": "/configuracoes/empresas"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "filters"
	  }, [(!_vm.current_user.isSeller()) ? _c('dropdown-select', {
	    staticClass: "field user-filter",
	    attrs: {
	      "options": _vm.users_options
	    },
	    on: {
	      "input": function($event) {
	        return _vm.loadGroupedDoneTasksData(_vm.card_filters)
	      }
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  }) : _vm._e()], 1), _c('div', {
	    attrs: {
	      "id": "done-tasks-calendar"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "calendar"
	    }
	  }), _c('div', {
	    attrs: {
	      "id": "tasks-list-group"
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("Tarefas executadas")]), _c('span', {
	    attrs: {
	      "id": "calendar-input"
	    }
	  }, [_vm._v(_vm._s(_vm.date_string))]), _c('div', {
	    staticClass: "clear"
	  }), (_vm.loading) ? _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('br'), _c('br'), _c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  })], 1) : _c('div', {
	    staticClass: "list-group"
	  }, _vm._l((_vm.done_tasks_grouped), function(task, key) {
	    return (_vm.valid_label_task_card(key)) ? _c('div', {
	      staticClass: "list-item"
	    }, [_c('div', {
	      staticClass: "icon",
	      class: _vm.class_of_tasks[key]
	    }), _c('span', {
	      staticClass: "number"
	    }, [_vm._v(_vm._s(_vm.countingNumber(task)) + "  ")]), _c('span', [_vm._v(_vm._s(_vm.label_of_tasks[key]))])]) : _vm._e()
	  }), 0)])])])
	},staticRenderFns: []}

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('filters', {
	    on: {
	      "filter": _vm.filter
	    }
	  }), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadEvents),
	      expression: "loadEvents"
	    }],
	    staticClass: "linked-list",
	    attrs: {
	      "id": "contact-events",
	      "infinite-scroll-distance": "10"
	    }
	  }, _vm._l((_vm.events), function(event, index) {
	    return _c(_vm.eventComponent(event), {
	      key: event.guid,
	      tag: "component",
	      class: {
	        'done-task-event': event.isDoneTaskEvent()
	      },
	      attrs: {
	        "event": event,
	        "contact": _vm.contact
	      },
	      on: {
	        "event-destroyed": _vm.removeEvent,
	        "event-updated": _vm.eventUpdated
	      }
	    })
	  }), 1), _c('div', {
	    staticClass: "events-page-info",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Propriedades - Contatos")]), _c('div', {
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Crie campos personalizados para serem utilizados em seus contatos.")]), _c('br'), _c('br'), _c('new-custom-fields-modal', {
	    attrs: {
	      "edit_custom_field": _vm.edit_custom_field
	    },
	    on: {
	      "close-create-modal": _vm.closeCreateModal,
	      "custom-field-created": _vm.created,
	      "custom-field-updated": _vm.updated
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.showCreateModal
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Nova propriedade")]), _c('list', {
	    ref: "list",
	    on: {
	      "edit": _vm.edit
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "meeting-type"
	    }
	  }, [_c('h1', [_vm._v("Tipos de reunião")]), _c('no-show-flow'), _c('hr'), _vm._m(0), _c('br'), _c('br'), _c('new-meeting-type', {
	    on: {
	      "created": _vm.createdMeetingType
	    }
	  }), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _vm._l((_vm.$store.getters.meetingTypesList), function(meeting_type) {
	    return _c('list-item', {
	      key: meeting_type.id,
	      attrs: {
	        "meeting_type": meeting_type
	      },
	      on: {
	        "updated": _vm.updatedMeetingType,
	        "destroy": _vm.openDestroyConfirmationModal
	      }
	    })
	  })], 2)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.$store.getters.meetingTypeLoading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.$store.getters.meetingTypeLoading),
	      expression: "!$store.getters.meetingTypeLoading"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-destroy-meeting-type",
	      "title": "Excluir Tipo de reunião",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroyMeetingType
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Confirma exclusão do Tipo de reunião abaixo?")]), _c('br'), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_meeting_type.title))]), _c('br'), _c('br')])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Crie categorias de reuniões de acordo com o seu processo."), _c('br'), _vm._v("As categorias te ajudam a filtrar, selecionar e analisar a efetividade das suas reuniões.")])
	}]}

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_c('div', {
	    staticClass: "contact-event-icon hs-icon"
	  }), _c('div', {
	    staticClass: "contact-event-header overflow-ellipsis"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
	    staticClass: "right-arrow glyphicon glyphicon-arrow-right"
	  }), _c('a', {
	    staticClass: "contact-event-description underlined",
	    attrs: {
	      "href": _vm.event.description,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.event.description))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notifications-popup"
	  }, [_c('transition-group', {
	    attrs: {
	      "name": "list"
	    }
	  }, _vm._l((_vm.notifications), function(notif) {
	    return _c('notification-list-item', {
	      key: notif.guid,
	      attrs: {
	        "notification": notif
	      },
	      on: {
	        "remove-notification": _vm.removeNotification
	      }
	    })
	  }), 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1081 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "deal-lost-integrations"
	  }, [_c('div', {
	    staticClass: "form"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "row description"
	  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.title.deal_lost')) + ":")])])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "checkbox-inline checkbox-update",
	    on: {
	      "click": function($event) {
	        return _vm.sending_checked('update_deal_lost')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "name": "mark_as"
	    },
	    domProps: {
	      "checked": _vm.update_deal_lost
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.actions.update.deal_lost.update')))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "checkbox-inline checkbox-update",
	    on: {
	      "click": function($event) {
	        return _vm.sending_checked('not_update_deal_lost')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "name": "mark_as"
	    },
	    domProps: {
	      "checked": _vm.not_update_deal_lost
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.actions.update.deal_lost.notUpdate')))])])])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1082 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.contacts_text))]), _vm._v(" para a sua responsabilidade.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-empty"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(963)
	    }
	  }), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('template.feedback.noDataText')))]), _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "to": "/templates/criar"
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('template.actions.new')))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "users-index"
	    }
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v("Usuários")]), (!_vm.currentUser().isSeller() && !_vm.current_user.isMonitoringManager()) ? _c('div', {
	    staticClass: "btn btn-primary pull-right",
	    attrs: {
	      "id": "user-invitation",
	      "disabled": _vm.isInvitationDisabled()
	    },
	    on: {
	      "click": function($event) {
	        return _vm.invitation()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Convidar Usuário")]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), (_vm.current_user.isAdmin()) ? _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "company_id"
	    }
	  }, [_vm._v("Empresa")]), _c('v-autocomplete', {
	    attrs: {
	      "id": "id",
	      "auto-select-one-item": false,
	      "items": _vm.company_options,
	      "input-attrs": _vm.attrs
	    },
	    on: {
	      "change": _vm.searchCompanies,
	      "item-selected": _vm.selectedCompany
	    },
	    model: {
	      value: (_vm.company_name),
	      callback: function($$v) {
	        _vm.company_name = $$v
	      },
	      expression: "company_name"
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('br'), _c('span', {
	    staticClass: "user-count-label"
	  }, [_vm._v("Número de usuários comuns: "), _c('span', {
	    staticClass: "user-count"
	  }, [_vm._v(_vm._s(_vm.company.number_of_regular_users) + "/" + _vm._s(_vm.max_number_of_regular_users))])]), _c('br'), _c('span', {
	    staticClass: "user-count-label"
	  }, [_vm._v("Número de gestores de acompanhamento: "), _c('span', {
	    staticClass: "user-count"
	  }, [_vm._v(_vm._s(_vm.company.number_of_monitoring_managers) + "/" + _vm._s(_vm.max_number_of_monitoring_managers))])])]), _c('div', {
	    staticClass: "clear"
	  }), _c('br'), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadUsers),
	      expression: "loadUsers"
	    }],
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _vm._l((_vm.users), function(user) {
	    return _c('list-item', {
	      key: user.id,
	      attrs: {
	        "user": user
	      },
	      on: {
	        "updated": _vm.userUpdated,
	        "destroy": _vm.showDestroyModal
	      }
	    })
	  })], 2)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1), _c('destroy-modal', {
	    attrs: {
	      "user": _vm.destroy_user
	    },
	    on: {
	      "destroyed": _vm.userDestroyed
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1085 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "configuration-view-wrapper new-company"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('companies.actions.update')))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('p', {
	    staticClass: "text-gray-color"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('companies.attributes.name')) + ":")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.company.name),
	      expression: "company.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "company_name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.company.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.company, "name", $event.target.value)
	      }
	    }
	  })]), _c('p', {
	    staticClass: "text-gray-color"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('companies.attirbutes.emailDomain')) + ":")]), _c('span', [_vm._v("  " + _vm._s(_vm.company.email_domain))])])]), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "account_setting"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.emailService')))]), _c('email-service-dropdown', {
	    model: {
	      value: (_vm.company.email_service),
	      callback: function($$v) {
	        _vm.$set(_vm.company, "email_service", $$v)
	      },
	      expression: "company.email_service"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email_service')),
	      expression: "errors.has('email_service')"
	    }],
	    key: "email_service",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email_service')))])])], 1)])]), _c('hr'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12 plan"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', {
	    staticClass: "text-gray-color"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.companyStatus')) + ":")]), _c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleActiveCompany()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.company.active
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.company.active ? _vm.$t('companies.label.activeCompany') : _vm.$t('companies.label.pausedCompany')))])])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "account_setting"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.plan')))]), _c('dropdown-select', {
	    attrs: {
	      "id": "account_setting",
	      "options": _vm.company.account_setting_options().account_settings,
	      "selected": _vm.account_setting_selected
	    },
	    model: {
	      value: (_vm.account_setting_selected),
	      callback: function($$v) {
	        _vm.account_setting_selected = $$v
	      },
	      expression: "account_setting_selected"
	    }
	  })], 1), (_vm.account_setting_selected) ? _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('max_number_of_regular_users')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "max_number_of_regular_users"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.maxUsersCount')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        rules: {
	          required: true,
	          between: [_vm.regular_users_bottom_limit, _vm.regular_users_upper_limit]
	        }
	      }),
	      expression: "{ rules: { required: true, between: [regular_users_bottom_limit, regular_users_upper_limit] } }"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account_setting.max_number_of_regular_users),
	      expression: "account_setting.max_number_of_regular_users"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "max_number_of_regular_users",
	      "name": "max_number_of_regular_users",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account_setting.max_number_of_regular_users)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account_setting, "max_number_of_regular_users", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "max_number_of_regular_users": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('max_number_of_regular_users')),
	      expression: "errors.has('max_number_of_regular_users')"
	    }],
	    key: "max_number_of_regular_users",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('max_number_of_regular_users')))])])], 1) : _vm._e(), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('max_number_of_monitoring_managers')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "max_number_of_monitoring_managers"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.maxManagersCount')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.account_setting.max_number_of_monitoring_managers),
	      expression: "account_setting.max_number_of_monitoring_managers"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "max_number_of_monitoring_managers",
	      "name": "max_number_of_monitoring_managers",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.account_setting.max_number_of_monitoring_managers)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.account_setting, "max_number_of_monitoring_managers", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "max_number_of_monitoring_managers": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('max_number_of_monitoring_managers')),
	      expression: "errors.has('max_number_of_monitoring_managers')"
	    }],
	    key: "max_number_of_monitoring_managers",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('max_number_of_monitoring_managers')))])])], 1)])]), _c('hr'), _c('div', {
	    staticClass: "row voip-edit"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', {
	    staticClass: "text-gray-color"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.voip')) + ":")]), _c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleVoipService()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.voip_active
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.voip_active ? _vm.$t('general.label.active') : _vm.$t('general.label.inactive')))])])])]), (_vm.voip_active) ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "voip_service"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.service')))]), _c('dropdown-select', {
	    attrs: {
	      "id": "voip_service",
	      "options": _vm.voip_services,
	      "selected": _vm.voip_service
	    },
	    on: {
	      "input": _vm.setVoipService
	    },
	    model: {
	      value: (_vm.voip_service),
	      callback: function($$v) {
	        _vm.voip_service = $$v
	      },
	      expression: "voip_service"
	    }
	  })], 1), _c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "text-gray-color"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.paidMinutes')) + ":")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.max_duration_in_minutes),
	      expression: "max_duration_in_minutes"
	    }],
	    staticClass: "form-control minutes max-duration",
	    attrs: {
	      "name": "max_duration"
	    },
	    domProps: {
	      "value": (_vm.max_duration_in_minutes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.max_duration_in_minutes = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "text-gray-color"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.paidMinutesUsedOnMonth')))]), _c('span', {
	    staticClass: "minutes text-light-gray-color"
	  }, [_vm._v(_vm._s(_vm.plivo_setting && _vm.plivo_setting.voip_monthly_plan.consumed_in_minutes()) + " " + _vm._s(_vm.$t('general.label.minutes')))])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('span', {
	    staticClass: "text-gray-color"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.additionalMinutes')))]), _c('button', {
	    staticClass: "btn btn-default btn-primary btn-xs",
	    staticStyle: {
	      "margin-left": "10px",
	      "padding": "1px 5px",
	      "font-size": "12px"
	    },
	    on: {
	      "click": _vm.addMinutes
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-plus"
	  })]), _vm._l((_vm.plivo_setting.voip_additional_times), function(additional_minute) {
	    return _c('additional-minute', {
	      attrs: {
	        "additional": additional_minute
	      }
	    })
	  })], 2)]) : _vm._e()]), _c('br'), _c('router-link', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "to": "/configuracoes/empresas"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1086 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" convertido(s) via RD Station.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "custom-field-list"
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [(_vm.options && _vm.options.top_border) ? _c('hr') : _vm._e(), _vm._l((_vm.custom_fields), function(custom_field) {
	    return _c('list-item', {
	      key: custom_field.id,
	      attrs: {
	        "custom_field": custom_field
	      },
	      on: {
	        "updated": _vm.customFieldUpdated,
	        "destroy": _vm.openDestroyConfirmationModal,
	        "edit": _vm.edit
	      }
	    })
	  })], 2)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading && !_vm.custom_fields.length),
	      expression: "!loading && !custom_fields.length"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-destroy-custom-field",
	      "title": "Excluir campo personalizado",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroyCustomField
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Confirma exclusão do campo abaixo?")]), _c('br'), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_custom_field.field))]), _c('br'), _c('br'), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_vm._v("Se confirmada a exclusão desse campo, "), _c('strong', [_vm._v("todas as informações referentes a ele, ")]), _vm._v("em todos os contatos do Reev, "), _c('strong', [_vm._v("serão excluídas permanentemente.")])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters events-filter"
	  }, [_c('dropdown-select', {
	    staticClass: "field event-filter",
	    attrs: {
	      "options": _vm.manual_task_service_options
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.manual_task_service_filter),
	      callback: function($$v) {
	        _vm.manual_task_service_filter = $$v
	      },
	      expression: "manual_task_service_filter"
	    }
	  }), _c('date-range-picker', {
	    ref: "date_range_picker",
	    attrs: {
	      "id": "date-picker-events",
	      "full_period_option": true
	    },
	    on: {
	      "date-changed": _vm.dateChanged
	    }
	  }), _c('div', {
	    staticClass: "clear"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.visible),
	      expression: "visible"
	    }],
	    staticClass: "go-to-top",
	    on: {
	      "click": _vm.goToTop
	    }
	  }, [_c('div', {
	    staticClass: "glyphicon glyphicon-arrow-up"
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.current_user.isAdmin()) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeNotificationDropdown),
	      expression: "closeNotificationDropdown"
	    }],
	    staticClass: "notification-dropdown-button"
	  }, [_c('div', {
	    staticClass: "clickable",
	    on: {
	      "click": _vm.toggleNotificationDropdown
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(988),
	      "width": "106",
	      "alt": "Reev"
	    }
	  }), (_vm.notifications_count > 0) ? _c('span', {
	    staticClass: "notifications-count"
	  }, [_vm._v(_vm._s(_vm.notifications_count))]) : _vm._e()]), _c('notification-dropdown', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_notifications_dropdown),
	      expression: "show_notifications_dropdown"
	    }],
	    on: {
	      "close": _vm.closeNotificationDropdown
	    }
	  })], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flow-form form-wrapper",
	    on: {
	      "change": _vm.setDirty
	    }
	  }, [(_vm.flow.isWithError()) ? _c('div', {
	    staticClass: "actions-errors error-message"
	  }, [_c('div', {
	    staticClass: "action-errors"
	  }, [_vm._v(_vm._s(_vm.$t('general.feedback.unknownError')) + "  "), _c('a', {
	    staticClass: "retry-link",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.retry')))])])]) : _vm._e(), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(Object.keys(_vm.all_errors).length) ? _c('div', {
	    staticClass: "actions-errors error-message"
	  }, [_c('div', {
	    staticClass: "error-header"
	  }, [_vm._v(_vm._s(_vm.$t('flows.feedback.unknownError')))]), _vm._l((_vm.all_errors), function(error, key) {
	    return _c('div', {
	      staticClass: "action-errors"
	    }, [_vm._v("- " + _vm._s(error))])
	  })], 2) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-lg-7"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.name')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.flow.name),
	      expression: "flow.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "name",
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.flow.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.flow, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), _c('div', [_c('div', {
	    staticClass: "flow-type-toggler-wrapper"
	  }, [_c('div', {
	    staticClass: "toggler-inline flow-type-toggle",
	    on: {
	      "click": function($event) {
	        return _vm.toggleType()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.flow.semi_automatic
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.flow_type_label))])])])]), _c('hr'), _c('div', [_c('div', {
	    staticClass: "flow-category-dropdown"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('category')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "category"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.category')))]), _c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "field",
	    attrs: {
	      "name": "category",
	      "options": _vm.flow_categories
	    },
	    on: {
	      "input": function($event) {
	        return _vm.onCategoryChange($event)
	      }
	    },
	    model: {
	      value: (_vm.flow.category_id),
	      callback: function($$v) {
	        _vm.$set(_vm.flow, "category_id", $$v)
	      },
	      expression: "flow.category_id"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('category')),
	      expression: "errors.has('category')"
	    }],
	    key: "category",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('category')))])])], 1)])]), _c('hr'), (_vm.flow.category_id == 3) ? _c('div', [_c('div', [_c('div', {
	    staticClass: "flow-task-execution-timer"
	  }, [_c('div', {
	    staticClass: "flow-task-execution-timer-toggle",
	    on: {
	      "click": function($event) {
	        return _vm.toggleTaskTimer()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "disabled": !_vm.isReevAccount
	    },
	    domProps: {
	      "checked": _vm.flow.with_task_timer
	    }
	  }), _c('div', [_c('label', [_c('b', {
	    staticClass: "with-task-timer-title"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.withTaskTimerTitle')))]), _c('div', {
	    staticClass: "with-task-timer-label"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.withTaskTimerLabel')))])])])])])]), _c('hr')]) : _vm._e(), _c('div', [_c('div', {
	    staticClass: "checkbox-inline",
	    attrs: {
	      "id": "toggle-has-email-per-day"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleHasEmailsPerDay()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.has_emails_per_day
	    }
	  }), _c('label', {
	    staticClass: "control-label"
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.hasEmailsPerDay')))])]), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.has_emails_per_day) ? _c('div', {
	    staticClass: "form-group flow-emails-per-day pull-right no-margin-bottom",
	    class: {
	      'has-error': _vm.errors.has('emails_per_day')
	    }
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.flow.emails_per_day),
	      expression: "flow.emails_per_day"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ({
	        rules: {
	          required: _vm.has_emails_per_day,
	          between: [1, 1000]
	        }
	      }),
	      expression: "{ rules: { required: has_emails_per_day, between: [1,1000] } }"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "emails-per-day",
	      "type": "text",
	      "name": "emails_per_day"
	    },
	    domProps: {
	      "value": (_vm.flow.emails_per_day)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.flow, "emails_per_day", $event.target.value)
	      }
	    }
	  }), _c('div', {
	    staticClass: "input-group-addon light-text"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.contactsPerDay')))])]), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.errors.has('emails_per_day')) ? _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('general.label.numberIntervalLimit', {
	    min: 1,
	    max: 1000
	  })))]) : _vm._e()])], 1) : _vm._e()])], 1), _c('div', {
	    staticClass: "clear"
	  }), _c('hr'), _c('div', {
	    staticClass: "form-group no-margin-bottom"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('flows.label.executeTasks')))]), _c('div', {
	    staticClass: "flow-weekday-checkboxes-wrapper",
	    class: {
	      'has-error': _vm.errors.has('weekdays_to_send')
	    }
	  }, _vm._l((_vm.weekdays), function(weekday_name, weekday_number) {
	    return _c('div', {
	      staticClass: "checkbox-inline flow-weekday-checkbox-item",
	      on: {
	        "click": function($event) {
	          return _vm.toggleWeekday(weekday_number)
	        }
	      }
	    }, [_c('input', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "name": "weekdays_to_send"
	      },
	      domProps: {
	        "checked": _vm.weekdaySelected(weekday_number)
	      }
	    }), _c('label', [_vm._v(_vm._s(weekday_name))])])
	  }), 0), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.errors.has('weekdays_to_send')) ? _c('div', {
	    staticClass: "error-message"
	  }, [_vm._v(_vm._s(_vm.$t('general.label.requiredDateField')))]) : _vm._e()])], 1), (_vm.flow.isNew() || _vm.flow.isWithError()) ? _c('fieldset', {
	    staticClass: "borderless"
	  }, [_c('hr'), _c('div', {
	    staticClass: "form-group no-margin-bottom"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.flow.toggleStatus()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.flow.isPublished()
	    }
	  }), _c('label', {
	    staticClass: "no-margin-bottom"
	  }, [_vm._v(_vm._s(_vm.$t('flows.actions.activateAfterCreate')))])])])]) : _vm._e()])]), _c('hr', {
	    staticClass: "thick flow-actions"
	  }), _c('h2', [_vm._v(_vm._s(_vm.$t('flows.title.actions')))]), _c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.actions')))]), _c('action-picker'), _c('hr', {
	    staticClass: "thick"
	  }), _c('div', {
	    staticClass: "flow-form__lost"
	  }, [_c('div', {
	    staticClass: "flow-form__lost-selects"
	  }, [_c('div', {
	    staticClass: "flow-form__lost-select"
	  }, [_c('h2', {
	    staticClass: "uppercase"
	  }, [_vm._v(_vm._s(_vm.$t('flows.title.markAsLost')))]), _c('div', {
	    staticClass: "form-group no-margin-bottom"
	  }, [_c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.flow.set_lost_on_finish),
	      expression: "flow.set_lost_on_finish"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "checkStageLost",
	      "disabled": _vm.disabledStageLost
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.flow.set_lost_on_finish) ? _vm._i(_vm.flow.set_lost_on_finish, null) > -1 : (_vm.flow.set_lost_on_finish)
	    },
	    on: {
	      "click": function($event) {
	        return _vm.checkStage()
	      },
	      "change": function($event) {
	        var $$a = _vm.flow.set_lost_on_finish,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.flow, "set_lost_on_finish", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.flow, "set_lost_on_finish", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.flow, "set_lost_on_finish", $$c)
	        }
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "checkStageLost"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.markAsLostIfNoReply')))])])]), _c('div', {
	    staticClass: "lost_reason_selection"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.checkReasonForLoss')))]), _c('div', {
	    staticClass: "delay-inputs-wrapper"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('lost_reason_id')
	    }
	  }, [_c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "field",
	    attrs: {
	      "name": "lost_reason_id",
	      "disabled": !_vm.flow.set_lost_on_finish,
	      "options": _vm.lostReasonOptions(_vm.flow.lost_reason_id)
	    },
	    model: {
	      value: (_vm.flow.lost_reason_id),
	      callback: function($$v) {
	        _vm.$set(_vm.flow, "lost_reason_id", $$v)
	      },
	      expression: "flow.lost_reason_id"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('lost_reason_id')),
	      expression: "errors.has('lost_reason_id')"
	    }],
	    key: "lost_reason_id",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('lost_reason_id')))])])], 1)])]), _c('div', {
	    staticClass: "flow-form__lost-select"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('flows.title.endContacts')) + " ")]), _c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.endContacts')))]), _c('div', {
	    staticClass: "delay-inputs-wrapper form-inline"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('delay_before_finishing_contact_amount')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.flow.delay_before_finishing_contact_amount),
	      expression: "flow.delay_before_finishing_contact_amount"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|between:0,300'),
	      expression: "'required|between:0,300'"
	    }],
	    staticClass: "form-control delay-before-finishing-contact-amount text-center",
	    attrs: {
	      "type": "text",
	      "name": "delay_before_finishing_contact_amount"
	    },
	    domProps: {
	      "value": (_vm.flow.delay_before_finishing_contact_amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.flow, "delay_before_finishing_contact_amount", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('delay_before_finishing_contact_unit')
	    }
	  }, [_c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "field delay-before-finishing-contact-unit",
	    attrs: {
	      "name": "delay_before_finishing_contact_unit",
	      "options": _vm.delay_before_finishing_contact_options
	    },
	    model: {
	      value: (_vm.flow.delay_before_finishing_contact_unit),
	      callback: function($$v) {
	        _vm.$set(_vm.flow, "delay_before_finishing_contact_unit", $$v)
	      },
	      expression: "flow.delay_before_finishing_contact_unit"
	    }
	  })], 1)])])]), (false) ? _c('div', {
	    staticClass: "flow-form__lost-switch"
	  }, [_c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.checkIfSendToFlow')) + "  "), _c('span', {
	    staticClass: "glyphicon glyphicon-question-sign",
	    attrs: {
	      "id": "perda-tooltip",
	      "data-toggle": "tooltip",
	      "title": _vm.$t('flows.label.labelAboutFlow'),
	      "data-placement": "right"
	    }
	  })]), _c('div', {
	    staticClass: "toggler-inline"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.sent_to_flow
	    }
	  }), _c('label', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.switchSendToFlow()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.sent_to_flow ? _vm.$t('general.label.yes') : _vm.$t('general.label.no')))]), (_vm.sent_to_flow) ? _c('flows', {
	    attrs: {
	      "user_id": _vm.selected_user
	    },
	    on: {
	      "flow-selected": _vm.selectFlow
	    }
	  }) : _vm._e()], 1)]) : _vm._e()]), _c('hr', {
	    staticClass: "tick"
	  }), _c('contacts-form', {
	    ref: "contacts_form",
	    attrs: {
	      "flow": _vm.flow
	    }
	  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('flows.title.BCC')))]), _c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.BCC')))]), _c('div', {
	    staticClass: "checkbox-inline flow-bcc-checkbox-item",
	    on: {
	      "click": function($event) {
	        _vm.flow.bcc = !_vm.flow.bcc
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "name": "bcc_for_answer"
	    },
	    domProps: {
	      "checked": _vm.flow.bcc
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('flows.label.useBCC')) + "  "), _c('span', {
	    staticClass: "glyphicon glyphicon-question-sign",
	    attrs: {
	      "id": "bcc-tooltip",
	      "data-toggle": "tooltip",
	      "title": _vm.$t('flows.label.emailBCCIntegration'),
	      "data-placement": "right"
	    }
	  })])])]), _c('hr', {
	    staticClass: "thick"
	  }), _c('div', {
	    staticClass: "text-center"
	  }, [_c('router-link', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "to": _vm.cancel_path
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "save"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.save_button_text))])], 1), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-save",
	      "title": _vm.modal_title,
	      "message": _vm.modal_message,
	      "confirm_text": _vm.modal_confirm_text
	    },
	    on: {
	      "confirm-modal-confirm": _vm.saveFlow
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1092 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "users-invite"
	    }
	  }, [_c('h1', [_vm._v("Convidar Usuário")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-mail ")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "email",
	      "name": "email",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    key: "email",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1)])]), (_vm.current_user.isAdmin()) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('company_id')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "company_id"
	    }
	  }, [_vm._v("Empresa")]), _c('v-autocomplete', {
	    attrs: {
	      "id": "id",
	      "auto-select-one-item": false,
	      "items": _vm.company_options,
	      "input-attrs": _vm.attrs
	    },
	    on: {
	      "change": _vm.searchCompanies,
	      "item-selected": _vm.selectedCompany
	    },
	    model: {
	      value: (_vm.company_name),
	      callback: function($$v) {
	        _vm.company_name = $$v
	      },
	      expression: "company_name"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('company_id')),
	      expression: "errors.has('company_id')"
	    }],
	    key: "company_id",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('company_id')))])])], 1)])]) : _vm._e(), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('role')
	    }
	  }, [_c('label', {
	    staticClass: "control-label"
	  }, [_vm._v("Função")]), _c('br'), (_vm.roleHaveSeats("manager")) ? _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.role),
	      expression: "role"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    attrs: {
	      "id": "role_manager",
	      "type": "radio",
	      "value": "manager",
	      "name": "role"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.role, "manager")
	    },
	    on: {
	      "change": function($event) {
	        _vm.role = "manager"
	      }
	    }
	  }), _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "id": "manager-role",
	      "for": "role_manager"
	    }
	  }, [_vm._v("Gerente de contas")])]) : _vm._e(), (_vm.roleHaveSeats("sdr")) ? _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.role),
	      expression: "role"
	    }],
	    attrs: {
	      "id": "role_sdr",
	      "type": "radio",
	      "value": "sdr",
	      "name": "role"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.role, "sdr")
	    },
	    on: {
	      "change": function($event) {
	        _vm.role = "sdr"
	      }
	    }
	  }), _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "id": "seller-role",
	      "for": "role_sdr"
	    }
	  }, [_vm._v("SDR")])]) : _vm._e(), (_vm.roleHaveSeats("seller")) ? _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.role),
	      expression: "role"
	    }],
	    attrs: {
	      "id": "role_seller",
	      "type": "radio",
	      "value": "seller",
	      "name": "role"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.role, "seller")
	    },
	    on: {
	      "change": function($event) {
	        _vm.role = "seller"
	      }
	    }
	  }), _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "id": "seller-role",
	      "for": "role_seller"
	    }
	  }, [_vm._v("Executivo de vendas")])]) : _vm._e(), (_vm.roleHaveSeats("monitoring_manager")) ? _c('div', {
	    staticClass: "checkbox-inline"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.role),
	      expression: "role"
	    }],
	    attrs: {
	      "id": "role_monitoring_manager",
	      "type": "radio",
	      "value": "monitoring_manager",
	      "name": "role"
	    },
	    domProps: {
	      "checked": _vm._q(_vm.role, "monitoring_manager")
	    },
	    on: {
	      "change": function($event) {
	        _vm.role = "monitoring_manager"
	      }
	    }
	  }), _c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "id": "seller-role",
	      "for": "role_monitoring_manager"
	    }
	  }, [_vm._v("Gerente de acompanhamento")])]) : _vm._e(), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('role')),
	      expression: "errors.has('role')"
	    }],
	    key: "role",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('role')))])]), _c('div', {
	    staticClass: "wrapper-buttons"
	  }, [_c('router-link', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "to": "/configuracoes/usuarios"
	    }
	  }, [_vm._v("Cancelar")]), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "submit"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Convidar Usuário")])], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "dialer-manual-flow-form-modal",
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('h5', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.$t('flows.reports.label.title')))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('label', {
	    staticClass: "fix"
	  }, [_vm._v(_vm._s(_vm.$t('flows.reports.label.periodLabel')))]), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.optionsList,
	      "capital": true,
	      "verify": true
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.selected),
	      callback: function($$v) {
	        _vm.selected = $$v
	      },
	      expression: "selected"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "row config"
	  }, [_c('div', {
	    staticClass: "col-sm"
	  }, [_c('div', {
	    staticClass: "form-check"
	  }, [_c('label', {
	    staticClass: "form-check-label"
	  }, [_c('input', {
	    staticClass: "form-check-input",
	    attrs: {
	      "type": "checkbox",
	      "value": "1",
	      "id": "defaultCheck1"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleMark()
	      }
	    }
	  }), _vm._v("  " + _vm._s(_vm.$t('flows.reports.label.addContact')) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-check"
	  }, [_c('label', {
	    staticClass: "form-check-label"
	  }, [_c('input', {
	    staticClass: "form-check-input",
	    attrs: {
	      "type": "checkbox",
	      "value": "2",
	      "id": "defaultCheck2"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleactivated_contactsMark()
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('flows.reports.label.activatedContacts')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "form-check"
	  }, [_c('label', {
	    staticClass: "form-check-label"
	  }, [_c('input', {
	    staticClass: "form-check-input",
	    attrs: {
	      "type": "checkbox",
	      "value": "3",
	      "id": "defaultCheck3"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleactive_contactMark()
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('flows.reports.label.activeContact')))])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm extra_fix"
	  }, [_c('div', {
	    staticClass: "form-check"
	  }, [_c('label', {
	    staticClass: "form-check-label"
	  }, [_c('input', {
	    staticClass: "form-check-input",
	    attrs: {
	      "type": "checkbox",
	      "value": "6",
	      "id": "defaultCheck6"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.togglelostContactMark()
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('flows.reports.label.lostContact')) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-check"
	  }, [_c('label', {
	    staticClass: "form-check-label"
	  }, [_c('input', {
	    staticClass: "form-check-input",
	    attrs: {
	      "type": "checkbox",
	      "value": "4",
	      "id": "defaultCheck4"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleconnected_contact()
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('flows.reports.label.connectedContact')) + " ")])]), _vm._v(" "), _c('div', {
	    staticClass: "form-check"
	  }, [_c('label', {
	    staticClass: "form-check-label"
	  }, [_c('input', {
	    staticClass: "form-check-input",
	    attrs: {
	      "type": "checkbox",
	      "value": "7",
	      "id": "defaultCheck7"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggletasksRealizedMark()
	      }
	    }
	  }), _vm._v(" " + _vm._s(_vm.$t('flows.reports.label.tasksRealized')) + " ")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-secondary",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('flows.reports.label.canceled')))]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": false,
	      "type": "button"
	    },
	    on: {
	      "click": _vm.sending
	    }
	  }, [_vm._v(" " + _vm._s(_vm.$t('flows.reports.label.generate')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1094 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "daily-events"
	    }
	  }, [(_vm.valid_calendar_id && !_vm.loading) ? _c('div', [_c('div', {
	    staticClass: "daily_events_header"
	  }, [_vm._v("AGENDA - " + _vm._s(_vm.current_user.name))]), _c('div', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "change-date"
	  }, [_c('button', {
	    staticClass: "btn-default",
	    attrs: {
	      "disabled": _vm.current_day
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeDay(-1)
	      }
	    }
	  }, [_vm._v("<")])]), _c('div', {
	    staticClass: "current-day"
	  }, [_vm._v(_vm._s(_vm.pad(_vm.search_date.getDate())) + " / " + _vm._s(_vm.pad(_vm.search_date.getMonth() + 1)) + " / " + _vm._s(_vm.search_date.getFullYear()))]), _c('div', {
	    staticClass: "change-date"
	  }, [_c('button', {
	    staticClass: "btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.changeDay(+1)
	      }
	    }
	  }, [_vm._v(">")])]), _c('div', {
	    staticClass: "current-day weekday"
	  }, [_vm._v(_vm._s(_vm.weekday))])]), _c('div', {
	    staticClass: "zones internal-scroller",
	    style: ({
	      maxHeight: _vm.height + 'px'
	    })
	  }, [_c('table', [_c('tbody', _vm._l((_vm.hours), function(zone) {
	    return _c('tr', {
	      key: zone.hour,
	      staticClass: "zone"
	    }, [_c('td', {
	      staticClass: "hour"
	    }, [_vm._v(_vm._s(_vm.pad(zone.hour)) + ":00")]), _vm._l((zone.events), function(event) {
	      return (zone.events.length > 0) ? _c('td', {
	        key: event.id,
	        staticClass: "event",
	        attrs: {
	          "rowspan": event.size
	        }
	      }, [_c('div', {
	        staticClass: "event_name"
	      }, [_vm._v(_vm._s(event.title))]), _c('div', {
	        staticClass: "event_duration"
	      }, [_vm._v(_vm._s(event.start_time) + " - " + _vm._s(event.end_time))])]) : _vm._e()
	    })], 2)
	  }), 0)])])]) : (_vm.loading) ? _c('div', {
	    staticClass: "override",
	    style: ({
	      maxHeight: _vm.height + 86 + 'px',
	      minHeight: _vm.height + 86 + 'px'
	    })
	  }, [_c('div', {
	    staticClass: "center"
	  }, [_c('span', [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  })], 1)])]) : _c('div', {
	    staticClass: "override",
	    style: ({
	      maxHeight: _vm.height + 'px',
	      minHeight: _vm.height + 'px'
	    })
	  }, [(_vm.current_user.id == _vm.default_user.id) ? _c('div', {
	    staticClass: "center"
	  }, [_c('span', [_vm._v("Para utilizar a integração com o seu Calendar, é necessário se conectar com o seu cliente de e-mail.")]), _c('div', [_c('div', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.redirect
	    }
	  }, [_vm._v("Conectar")])])]) : _c('div', {
	    staticClass: "center"
	  }, [_c('span', [_vm._v("Para agendar a reunião para outro usuário é necessário que ele se conecte com o cliente de e-mail.")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row list-item flow-list-item",
	    class: {
	      clickable: !_vm.is_processing
	    },
	    on: {
	      "click": function($event) {
	        return _vm.rowClicked($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "table-col table-col-collapsed-half"
	  }, [_c('div', {
	    class: _vm.circleStatusClass()
	  })]), _c('div', {
	    staticClass: "table-col table-col-300 overflow-hidden"
	  }, [_c('div', {
	    staticClass: "flow-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.flow.name))]), _c('div', {
	    staticClass: "flow-details"
	  }, [_c('div', {
	    staticClass: "flow-actions-count"
	  }, [_vm._v(_vm._s(_vm.flow.actions_count) + " " + _vm._s(_vm.$t('general.label.actions')))]), _c('div', {
	    staticClass: "flow-days-count"
	  }, [_vm._v(" " + _vm._s(_vm.flow.duration_in_days) + " " + _vm._s(_vm.$t('general.label.days')))])])]), (_vm.flow.hasStatusMessage()) ? _c('div', {
	    staticClass: "table-col table-col-300 message-status-table-col"
	  }, [_c('div', {
	    class: _vm.flow_status_message_class
	  }, [_vm._v(_vm._s(_vm.flow_status_message))])]) : [(_vm.default_options.show_contacts_count) ? _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "percentage"
	  }, [_vm._v(_vm._s(_vm.flow.contacts_count()))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.contacts')))])])]) : _vm._e(), _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.flow.recipients_statistics_conversion()))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.conversion')))])])]), (_vm.default_options.show_reply_statistic) ? _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.flow.email_statistic.replyPercentage(_vm.flow.recipients_count)))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('flows.attributes.reply')))])])]) : _vm._e()], (_vm.default_options.show_user) ? _c('div', {
	    staticClass: "table-col table-col-150"
	  }, [_c('user-miniature', {
	    attrs: {
	      "user": _vm.flow.user
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [(_vm.default_options.action == 'dropdown' && (!_vm.is_processing || _vm.current_user.isAdmin())) ? _c('div', {
	    staticClass: "action clickable-element"
	  }, [_c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": _vm.viewFlow
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.toView')))])]), (!_vm.current_user.isMonitoringManager()) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.editFlow
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))])]) : _vm._e(), _vm._l((_vm.flow.next_valid_statuses), function(next_status_options, next_status) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          return _vm.updateFlow({
	            status: next_status
	          })
	        }
	      }
	    }, [_c('a', [_vm._v(_vm._s(next_status_options.human_action_name))])])
	  }), (!_vm.current_user.isMonitoringManager()) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.openDestroyFlowConfirmationModal
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])]) : _vm._e()], 2)])]) : (_vm.default_options.action == "select") ? _c('div', {
	    staticClass: "action"
	  }, [_vm._m(1)]) : _vm._e()])], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn select-action"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	}]}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.hidePicker),
	      expression: "hidePicker"
	    }],
	    staticClass: "dashboard-date-picker"
	  }, [_c('div', {
	    staticClass: "date-picker-select clickable",
	    attrs: {
	      "id": _vm.id
	    },
	    on: {
	      "click": _vm.toggleShowPicker
	    }
	  }, [_vm._v(_vm._s(_vm.selected_text)), _c('span', {
	    staticClass: "gray-bold-caret"
	  })]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_picker),
	      expression: "show_picker"
	    }],
	    staticClass: "date-range-container",
	    class: {
	      disabled: _vm.isCalendarDisabled
	    },
	    attrs: {
	      "id": _vm.container
	    }
	  }, [_c('div', {
	    staticClass: "date-header"
	  }, [_c('span', [_vm._v("Selecione o período:")]), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.options,
	      "selected": _vm.selected_option
	    },
	    on: {
	      "input": _vm.dropdownChanged
	    },
	    model: {
	      value: (_vm.selected_option),
	      callback: function($$v) {
	        _vm.selected_option = $$v
	      },
	      expression: "selected_option"
	    }
	  }), _c('input', {
	    attrs: {
	      "id": "date-from",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": _vm.formatDate(_vm.date_from)
	    }
	  }), _c('span', {
	    staticClass: "separador"
	  }, [_vm._v("-")]), _c('input', {
	    attrs: {
	      "id": "date-to",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": _vm.formatDate(_vm.date_to)
	    }
	  })], 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1097 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row list-item",
	    on: {
	      "click": function($event) {
	        return _vm.rowClick(_vm.template, $event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "table-col table-col-30 text-center icon-wrapper"
	  }, [_c('div', {
	    staticClass: "icon",
	    class: _vm.template.kind
	  })]), _c('div', {
	    staticClass: "table-col table-col-120 title"
	  }, [_c('div', {
	    staticClass: "name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.template.name))]), _c('div', {
	    staticClass: "subject overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.template.subject))])]), _c('div', {
	    staticClass: "table-col"
	  }, [_c('span', {
	    staticClass: "label label-default"
	  }, [_vm._v(_vm._s(_vm.template.category_name))])]), (_vm.default_options.show_open_statistic) ? _c('div', {
	    staticClass: "table-col"
	  }, [(_vm.template.kind == 'email') ? _c('div', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "percentage"
	  }, [_vm._v(_vm._s(_vm.template.email_statistic.openPercentage()))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('template.label.emailOpen')))])]) : _vm._e()]) : _vm._e(), (_vm.default_options.show_reply_statistic) ? _c('div', {
	    staticClass: "table-col"
	  }, [(_vm.template.kind == 'email') ? _c('div', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "percentage"
	  }, [_vm._v(_vm._s(_vm.template.email_statistic.replyPercentage()))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('template.label.emailReply')))])]) : _vm._e()]) : _vm._e(), (_vm.default_options.show_conversion_statistic) ? _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "percentage"
	  }, [_vm._v(_vm._s(_vm.template.email_statistic.formattedPercentage(_vm.template.connectedCount())))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('template.label.conversion')))])])]) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-collapsed show"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-eye-open clickable-element",
	    on: {
	      "click": _vm.showModal
	    }
	  })]), (!_vm.current_user.isSeller()) ? _c('div', {
	    staticClass: "table-col table-col-30"
	  }, [_c('user-miniature', {
	    attrs: {
	      "user": _vm.template.user,
	      "options": {
	        only_picture: true
	      }
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-50"
	  }, [(_vm.default_options.action == "dropdown-action") ? _c('div', {
	    staticClass: "action pull-right clickable-element"
	  }, [_c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.showModal.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.label.preShow')))])]), (_vm.current_user.can_manage_templates) ? _c('li', [(!_vm.current_user.isMonitoringManager()) ? _c('router-link', {
	    attrs: {
	      "to": _vm.editPath(_vm.template)
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))]) : _vm._e()], 1) : _vm._e(), (_vm.current_user.can_manage_templates) ? _c('li', [(!_vm.current_user.isMonitoringManager()) ? _c('a', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.confirmDestroy.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))]) : _vm._e()]) : _vm._e()])])]) : (_vm.default_options.action == "select-action") ? _c('div', {
	    staticClass: "action"
	  }, [_c('button', {
	    staticClass: "btn select-action",
	    attrs: {
	      "to": "/templates/criar/" + _vm.template.id
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])]) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	}]}

/***/ }),
/* 1098 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "contact-event-header"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
	    staticClass: "contact-event-description"
	  }, [_c('span', [_vm._v("- " + _vm._s(_vm.event.description))]), (_vm.event.metadata && _vm.event.metadata.step && _vm.event.metadata.flow_name && _vm.event.metadata.flow_id) ? _c('span', {
	    staticClass: "flow-description"
	  }, [_c('span', {
	    staticClass: "spaced"
	  }, [_vm._v("-")]), _c('strong', {
	    staticClass: "spaced"
	  }, [_vm._v(_vm._s(_vm.event.metadata.step))]), _c('strong', {
	    staticClass: "spaced"
	  }, [_vm._v("Fluxo:")]), _c('router-link', {
	    staticClass: "spaced underlined flow-link",
	    attrs: {
	      "to": '/fluxos-de-cadencia/' + _vm.event.metadata.flow_id
	    }
	  }, [_vm._v(_vm._s(_vm.event.metadata.flow_name))])], 1) : _vm._e()]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-icon"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/icons/trash-bin.svg"
	    }
	  })])
	}]}

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [(_vm.view_mode.filters) ? _c('div', {
	    staticClass: "table-actions"
	  }, [_c('filters', {
	    attrs: {
	      "filters": _vm.filters
	    },
	    on: {
	      "filter": _vm.filter
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "table-header table-row"
	  }, [_c('div', {
	    staticClass: "table-col contact-list-item-select table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    attrs: {
	      "id": "contact-select-all-checkbox"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleSelectAll()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selected_all
	    }
	  }), _c('label', [_vm._v(" ")])])]), _c('div', {
	    staticClass: "table-col table-col-empashis contact-list-item-name table-col-120"
	  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.Name')))]), (_vm.view_mode.statistics) ? _c('div', {
	    staticClass: "table-col"
	  }) : _vm._e(), _c('div', {
	    staticClass: "table-col"
	  }), (_vm.view_mode.user) ? _c('div', {
	    staticClass: "table-col contact-list-item-user"
	  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.Responsible')))]) : _vm._e(), (_vm.view_mode.actions_dropdown) ? _c('div', {
	    staticClass: "table-col contact-list-item-actions table-col-collapsed"
	  }) : _vm._e()]), _c('div', {
	    staticClass: "table-body"
	  }, _vm._l((_vm.contact_groups), function(contact_group, contact_group_id) {
	    return _c('contact-group-list-item', {
	      attrs: {
	        "contact_group": contact_group,
	        "view_mode": _vm.view_mode,
	        "initially_selected": _vm.selected_all,
	        "selected_contact_ids": _vm.selected_contact_ids
	      },
	      on: {
	        "group-destroy": _vm.bubbleUp,
	        "group-selected": _vm.bubbleUp
	      }
	    })
	  }), 1)])
	},staticRenderFns: []}

/***/ }),
/* 1100 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row",
	    attrs: {
	      "id": "configurations-wrapper"
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3 col-sm-12"
	  }, [_c('router-view', {
	    attrs: {
	      "name": "sidebar"
	    }
	  })], 1), _c('div', {
	    staticClass: "col-md-9 col-sm-12"
	  }, [_c('transition', {
	    attrs: {
	      "name": "enter"
	    }
	  }, [_c('router-view', {
	    attrs: {
	      "name": "content"
	    }
	  })], 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table-row company-list-item list-item",
	    on: {
	      "click": function($event) {
	        return _vm.toggleShowDkim($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "table-col two-lines-col table-col-80 overflow-hidden"
	  }, [_c('div', {
	    staticClass: "name dark-slate-gray-color overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.company.name))]), _c('small', {
	    staticClass: "email-domain text-gray-color overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.company.email_domain))])]), _c('div', {
	    staticClass: "table-col table-col-50 table-col-multiple-lines-middle"
	  }, [(_vm.company.isSparkpost()) ? _c('div', {
	    staticClass: "text-center"
	  }, [_c('img', {
	    staticClass: "email-service",
	    attrs: {
	      "src": "/static/icons/third-part/sparkpost.png"
	    }
	  }), _c('div', {
	    staticClass: "spacer-5"
	  }), (_vm.company.email_domain_verified) ? _c('h6', {
	    staticClass: "no-margin"
	  }, [_c('div', {
	    staticClass: "label label-success"
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.verified')))])]) : _c('h6', {
	    staticClass: "no-margin"
	  }, [_c('div', {
	    staticClass: "label label-warning"
	  }, [_vm._v("Pendente")])])]) : _vm._e(), (_vm.company.isNylas()) ? _c('div', {
	    staticClass: "text-center"
	  }, [_c('img', {
	    staticClass: "email-service",
	    attrs: {
	      "src": "/static/icons/third-part/nylas.svg",
	      "title": "Nylas"
	    }
	  })]) : _vm._e()]), _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('span', [_vm._v(" " + _vm._s(_vm.company.number_of_regular_users) + " / " + _vm._s(_vm.company.account_setting.id != null ? _vm.company.account_setting.max_number_of_regular_users : '-'))])]), _c('div', {
	    staticClass: "table-col table-col-50"
	  }, [_c('span', [_vm._v(_vm._s(_vm.company.number_of_monitoring_managers) + " / " + _vm._s(_vm.company.account_setting.id != null ? _vm.company.account_setting.max_number_of_monitoring_managers : '-'))])]), _c('div', {
	    staticClass: "table-col table-col-30"
	  }, [_c('span', {
	    staticClass: "voip label",
	    class: _vm.company.active ? "label-primary" : "label-default"
	  }, [_vm._v(_vm._s(_vm.company.active ? _vm.$t('companies.label.activeCompany') : _vm.$t('companies.label.pausedCompany')))])]), _c('div', {
	    staticClass: "table-col table-col-30"
	  }, [_c('span', {
	    staticClass: "voip label",
	    class: _vm.company.isPlivo() || _vm.company.isTwilio() ? "label-primary" : "label-default"
	  }, [_vm._v(_vm._s(_vm.company.isPlivo() || _vm.company.isTwilio() ? _vm.$t('general.label.active') : _vm.$t('general.label.inactive')))])]), _c('div', {
	    staticClass: "table-col table-col-50"
	  }, [(_vm.plivo_activated) ? _c('element', [_vm._v(_vm._s(_vm.company.plivo_setting.voip_monthly_plan.consumed_in_minutes()) + " / " + _vm._s(_vm.company.plivo_setting.voip_monthly_plan.max_duration_in_minutes()))]) : (_vm.twilio_activated) ? _c('element', [_vm._v(_vm._s(_vm.company.twilio_setting.voip_monthly_plan.consumed_in_minutes()) + " / " + _vm._s(_vm.company.twilio_setting.voip_monthly_plan.max_duration_in_minutes()))]) : _vm._e()]), _c('div', {
	    staticClass: "table-col table-col-80",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('div', {
	    staticClass: "spacer-15 pull-right"
	  }), _c('div', {
	    staticClass: "spacer-15 pull-right"
	  }), _c('div', {
	    staticClass: "action pull-right clickable-element"
	  }, [_c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.verify.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.verify')))])]), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.editCompany.apply(null, arguments)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))])])])])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_dkim && _vm.company.isSparkpost()),
	      expression: "show_dkim && company.isSparkpost()"
	    }],
	    staticClass: "table-row dkim-attributes"
	  }, [_c('div', {
	    staticClass: "table-col"
	  }, [_vm._v(_vm._s(_vm.company.dkim_selector))]), _c('div', {
	    staticClass: "table-col"
	  }, [_vm._v(_vm._s(_vm.company.dkim_value))])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	}]}

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadData),
	      expression: "loadData"
	    }],
	    staticStyle: {
	      "display": "inline"
	    },
	    attrs: {
	      "id": "contacts-index",
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v(_vm._s(_vm.$t('groups.title.index')))]), _c('div', {
	    staticClass: "dropdown pull-right"
	  }, [(!_vm.current_user.isMonitoringManager()) ? _c('button', {
	    staticClass: "btn btn-primary dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _c('span', [_vm._v(_vm._s(_vm.$t('groups.actions.create.newGroup')))])]) : _vm._e(), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": '/grupos-de-contatos/importar/manualmente'
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.actions.create.manuallyAdd')))])], 1), _c('li', {
	    attrs: {
	      "id": "new-group"
	    },
	    on: {
	      "click": _vm.openNewGroupModal
	    }
	  }, [_c('a', {
	    staticClass: "clickable",
	    attrs: {
	      "id": "open-new-group"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.actions.create.contactBaseAdd')))])])])])]), _c('div', {
	    staticClass: "clear"
	  }), (_vm.showNabBars()) ? _c('div', {
	    staticClass: "row"
	  }, [_c('ul', {
	    staticClass: "tab-list",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.leadsRedirect()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.contacts')))])]), _c('li', {
	    staticClass: "active",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.groupsRedirect()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.groups')))])]), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.businessRedirect()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.businesses')))])])])]) : _vm._e(), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "groups-tab"
	    }
	  }, [_c('contact-groups-list', {
	    attrs: {
	      "contact_groups": _vm.contact_groups,
	      "filters": _vm.filters,
	      "view_mode": _vm.contactGroupListViewModes().index
	    },
	    on: {
	      "group-destroy": _vm.openDestroyGroupConfirmationModal,
	      "filter": _vm.filter
	    }
	  })], 1)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.fetching
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('groups.feedback.noMoreResults')))])], 1), _c('go-to-top'), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-remove-group",
	      "title": _vm.$t('groups.actions.delete.title'),
	      "confirm_text": _vm.$t('groups.actions.delete.confirm'),
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroyGroup
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-left"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('groups.actions.delete.confirmBelow'))), _c('div', {
	    staticClass: "delete-group-option"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        _vm.group_destroy_contacts = false
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": !_vm.group_destroy_contacts
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('groups.actions.delete.checkboxConfirm')) + "  "), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_group.name))])])])]), _c('div', {
	    staticClass: "delete-group-option"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        _vm.group_destroy_contacts = true
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.group_destroy_contacts
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('groups.actions.delete.checkboxConfirm')) + "  "), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_group.name) + " " + _vm._s(_vm.$t('groups.actions.delete.andAllContacts')))])])])])])])]), _c('new-group-modal', {
	    on: {
	      "contact-group-saved": _vm.updateContactGroupList
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1103 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "configuration-view-wrapper profile"
	  }, [_c('h1', [_vm._v("Perfil")]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "loading",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": "loading",
	      "size": "50px"
	    }
	  })], 1), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading && _vm.user.id),
	      expression: "!loading && user.id"
	    }]
	  }, [_c('div', {
	    staticClass: "picture-wrapper"
	  }, [_c('div', {
	    staticClass: "user-picture",
	    style: ({
	      backgroundImage: 'url(' + _vm.user.picture_url + ')'
	    })
	  }), _c('input', {
	    staticClass: "hidden",
	    attrs: {
	      "id": "picture",
	      "type": "file"
	    },
	    on: {
	      "change": _vm.fileInput
	    }
	  }), _c('button', {
	    staticClass: "btn btn-clean",
	    attrs: {
	      "onclick": "jQuery('#picture').click()"
	    }
	  }, [_vm._v("Alterar foto")])]), _c('br'), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v("Nome")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.name),
	      expression: "user.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "name",
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.user.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v("E-mail")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.email),
	      expression: "user.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "email",
	      "name": "email",
	      "type": "text",
	      "disabled": "disabled"
	    },
	    domProps: {
	      "value": (_vm.user.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "email", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('timezone')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "timezone"
	    }
	  }, [_vm._v("Fuso horário")]), _c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "field",
	    attrs: {
	      "options": _vm.timezones,
	      "selected": _vm.user.timezone,
	      "data-vv-name": "timezone"
	    },
	    model: {
	      value: (_vm.user.timezone),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "timezone", $$v)
	      },
	      expression: "user.timezone"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('timezone')),
	      expression: "errors.has('timezone')"
	    }],
	    key: "timezone",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('timezone')))])])], 1), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('signature')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "signature"
	    }
	  }, [_vm._v("Assinatura do e-mail")]), _c('textarea', {
	    attrs: {
	      "id": "signature",
	      "name": "signature"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('signature')),
	      expression: "errors.has('signature')"
	    }],
	    key: "signature",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('signature')))])])], 1), _c('confirm-modal', {
	    attrs: {
	      "id": "atualizar-assinatura-confirmation-modal",
	      "title": "Assinatura alterada",
	      "message": "Deseja trocar a assinatura de todos os templates/fluxos?",
	      "confirm_text": "Sim",
	      "confirm_class": "btn-primary",
	      "reject_text": "Não"
	    },
	    on: {
	      "confirm-modal-confirm": function($event) {
	        return _vm.update(true)
	      },
	      "confirm-modal-reject": function($event) {
	        return _vm.update(false)
	      }
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "live-feed"
	    }
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("Livefeed teste")]), _c('div', {
	    staticClass: "spacer-10"
	  }), (!_vm.current_user.isSeller()) ? _c('div', {
	    staticClass: "filters"
	  }, [_c('dropdown-select', {
	    attrs: {
	      "options": _vm.users_options
	    },
	    on: {
	      "input": _vm.loadLiveFeedEvents
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "spacer-10"
	  }), (_vm.loading) ? _c('div', {
	    staticClass: "loading loading-spacer",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  })], 1) : _vm._e(), _c('div', {
	    staticClass: "events-list",
	    class: {
	      "less-space": _vm.current_user.isSeller()
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, _vm._l((_vm.events), function(event) {
	    return _c('live-feed-event-list-item', {
	      key: event.id,
	      attrs: {
	        "event": event
	      },
	      on: {
	        "toggle-task-bar": _vm.bubbleUp
	      }
	    })
	  }), 1)], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Templates")]), _vm._m(0), _c('br'), _c('br'), _c('new-template-category', {
	    on: {
	      "created": _vm.createdTemplateCategory
	    }
	  }), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _vm._l((_vm.template_categories), function(template_category) {
	    return _c('list-item', {
	      key: template_category.id,
	      attrs: {
	        "template_category": template_category
	      },
	      on: {
	        "updated": _vm.updatedTemplateCategory,
	        "destroy": _vm.openDestroyConfirmationModal
	      }
	    })
	  })], 2)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-destroy-template-category",
	      "title": "Excluir categoria",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroyTemplateCategory
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Confirma exclusão da categoria abaixo?")]), _c('br'), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_template_category.name))]), _c('br'), _c('br')])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Crie categorias personalizadas para templates de atividades de acordo com o seu processo. "), _c('br'), _vm._v("As categorias te ajudam a filtrar e selecionar ou analisar a efetividade dos seus templates.")])
	}]}

/***/ }),
/* 1106 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "destroy-user-modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "modal-body"
	  }, [_vm._m(1), _c('div', {
	    staticClass: "user-identification"
	  }, [_vm._v(" " + _vm._s(_vm.user.name) + "\n(" + _vm._s(_vm.user.email) + ")")]), _c('p'), _c('br'), _vm._m(2), _c('br'), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('replace_user_id')
	    }
	  }, [_c('label', [_vm._v("Usuário que receberá as responsabilidades do usuário excluído:")]), _c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ("required"),
	      expression: "\"required\""
	    }],
	    staticClass: "field",
	    attrs: {
	      "data-vv-name": "replace_user_id",
	      "options": _vm.user_options,
	      "selected": _vm.replace_user_id
	    },
	    model: {
	      value: (_vm.replace_user_id),
	      callback: function($$v) {
	        _vm.replace_user_id = $$v
	      },
	      expression: "replace_user_id"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('replace_user_id')),
	      expression: "errors.has('replace_user_id')"
	    }],
	    key: "replace_user_id",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('replace_user_id')))])])], 1)]), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), _c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": _vm.destroyUser
	    }
	  }, [_vm._v("Excluir usuário")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_vm._v("Excluir usuário"), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("Você está prestes a excluir o usuário:")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('strong', [_vm._v("Ao excluir um usuário, acontecerá o seguinte com suas responsabilidades no Reev:")]), _c('ul', [_c('li', [_vm._v("Seus fluxos serão pausados e excluídos.")]), _c('li', [_vm._v("As respostas dos fluxos serão redirecionadas para outro usuário.")]), _c('li', [_vm._v("Seus templates e contatos serão transferidos para outro usuário.")])])])
	}]}

/***/ }),
/* 1107 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.rdStation')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.rdStationMarketing')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [(_vm.rdstation_authorized && !_vm.show_form_rd) ? _c('button', {
	    staticClass: "btn btn-clean btn-nylas",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))]) : _vm._e(), (!_vm.rdstation_authorized && !_vm.show_form_rd) ? _c('button', {
	    staticClass: "btn btn-clean btn-nylas",
	    on: {
	      "click": _vm.connect
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.connect')))]) : _vm._e()])])]), (_vm.show_form_rd) ? _c('div', {
	    staticClass: "form",
	    staticStyle: {
	      "text-align": "left"
	    }
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show_form_rd = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "form-group margin-top"
	  }, [_c('span', {
	    staticClass: "triggers-integrations index"
	  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.contactsDistributionTitle')))])])]), _c('div', {
	    staticClass: "sub-index intermediate-index"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.choosenModel')))]), _c('div', {
	    staticClass: "sub-index"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.choosenModelInfo')))]), _c('span', {
	    staticClass: "index index-second"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.chooseModelAction')) + ":")]), _c('div', {
	    staticClass: "new_input"
	  }, [_c('div', {
	    staticClass: "checkbox-inline margin-top",
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleUserCarouselRd()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.show_carousel
	    }
	  }), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "max-width": "250px",
	      "margin-right": "200px",
	      "margin-top": "5px",
	      "margin-bottom": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "text_select"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.propertyDistribution')))])])]), (_vm.show_carousel && _vm.show_id) ? _c('properties-select', {
	    attrs: {
	      "id": _vm.custom_field_id
	    },
	    on: {
	      "selected": _vm.property_updated
	    }
	  }) : _vm._e()], 1), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "checkbox-inline margin-top",
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleUseCarouselRd()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.use_carousel
	    }
	  }), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "min-width": "465px",
	      "margin-right": "35px",
	      "margin-top": "5px",
	      "margin-bottom": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "text_select"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.simpleCarouselDistribution')))])])])])])]), _c('div', {
	    staticClass: "row",
	    staticStyle: {
	      "margin-left": "0px"
	    }
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "checkbox-inline margin-top",
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        return _vm.toggleUseResponsibleRd()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.show_user_carousel
	    }
	  }), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "min-width": "465px",
	      "margin-right": "35px",
	      "margin-top": "5px",
	      "margin-bottom": "10px"
	    }
	  }, [_c('div', {
	    staticClass: "text_select"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.responsibleDistribution')))])])])])])])]), (_vm.property && _vm.show_carousel) ? _c('properties-Table', {
	    attrs: {
	      "selected": _vm.property
	    },
	    on: {
	      "property_id": _vm.property_id_updated
	    }
	  }) : _vm._e()], 1), (_vm.use_carousel) ? _c('div', {
	    staticClass: "form-group margin-top"
	  }, [_c('div', {
	    staticClass: "info info-rd"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.receiveLeadsInfo')))])]) : _vm._e(), (_vm.use_carousel) ? _c('div', {
	    staticClass: "form-group margin-top"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "rd_url",
	      "name": "rd_url",
	      "type": "text",
	      "disabled": !_vm.has_configured_rd_carousel && _vm.use_carousel,
	      "readonly": _vm.rd_carousel != null
	    },
	    domProps: {
	      "value": _vm.rd_url
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary btn-copy",
	    attrs: {
	      "id": "btn-copy-rd-url",
	      "disabled": !_vm.has_configured_rd_carousel && _vm.use_carousel
	    },
	    on: {
	      "click": _vm.copyURLrd
	    }
	  }, [_vm._v(_vm._s(_vm.copied_rd ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))]), (_vm.use_carousel) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#rd-carousel-modal"
	    },
	    on: {
	      "click": _vm.loadRdCarouselData
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.setCarousel')))]) : _vm._e()]) : _vm._e(), (_vm.show_user_carousel) ? _c('div', {
	    staticClass: "form-group margin-top"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "rd_url",
	      "name": "rd_url",
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.rd_url
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary btn-copy",
	    attrs: {
	      "id": "btn-copy-rd-url"
	    },
	    on: {
	      "click": _vm.copyURLrd
	    }
	  }, [_vm._v(_vm._s(_vm.copied_rd ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))])]) : _vm._e(), _c('br'), _c('hr', {
	    staticClass: "lines-div",
	    staticStyle: {
	      "padding-bottom": "20px"
	    }
	  }), _c('span', {
	    staticClass: "triggers-integrations index"
	  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.sendContactsTitle')))])])]), (!_vm.rdstation_authorized) ? _c('div', {
	    staticClass: "info info-rd"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.chooseContactTag')))]) : _vm._e(), _c('div', {
	    staticClass: "triggers-integrations"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "checkbox-inline on-created",
	    on: {
	      "click": function($event) {
	        return _vm.checkboxSelectSaleRD()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selectedSaleRD
	    }
	  }), _c('label', {
	    staticClass: "text_label",
	    class: {
	      disabled: !_vm.rdstation_authorized && _vm.rd_station_setting.use_carousel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.customerTag')))])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col"
	  }, [_c('div', {
	    staticClass: "checkbox-inline on-created",
	    on: {
	      "click": function($event) {
	        return _vm.checkboxSelectLostRD()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selectedLostRD
	    }
	  }), _c('label', {
	    staticClass: "text_label",
	    class: {
	      disabled: !_vm.rdstation_authorized && _vm.rd_station_setting.use_carousel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.lostTag')))])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 left"
	  }, [_c('div', {
	    staticClass: "checkbox-inline on-created",
	    on: {
	      "click": function($event) {
	        return _vm.checkboxSelectOpportunityRD()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selectedOpportunityRD
	    }
	  }), _c('label', {
	    staticClass: "text_label",
	    class: {
	      disabled: !_vm.rdstation_authorized && _vm.rd_station_setting.use_carousel
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.rdStationMarketing.stagesTag')))])])]), (_vm.selectedOpportunityRD) ? _c('div', {
	    staticClass: "col-md-4 rd-stages"
	  }, [_c('stages-select', {
	    attrs: {
	      "integration": "rd_station",
	      "filter_item_selected_ids": _vm.rd_station_setting.triggers.stages
	    },
	    on: {
	      "item-selected-items": _vm.itemSelectedItems
	    }
	  })], 1) : _vm._e()])]), _c('properties-matching', {
	    attrs: {
	      "properties_matching": _vm.rd_station_setting.properties_matching,
	      "integration_name": "RD Station",
	      "api_fields": _vm.api_fields
	    },
	    on: {
	      "matching-updated": _vm.matchingUpdated
	    }
	  }), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))]), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    class: _vm.rdstation_authorized ? 'btn-danger' : 'btn-primary',
	    on: {
	      "click": _vm.redirectToRdstationOauthUrl
	    }
	  }, [_vm._v(_vm._s(_vm.rdstation_authorized ? _vm.$t('general.actions.disconnect') : _vm.$t('general.actions.connect')))])])])], 1) : _vm._e(), _c('carousel-modal', {
	    ref: "rd_carousel_modal",
	    attrs: {
	      "id": "rd-carousel-modal",
	      "modal-title": _vm.modalTitle(),
	      "kind": "rd"
	    },
	    on: {
	      "savedCarousel": _vm.fillRdCarousel
	    }
	  })], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/rdstation.jpg"
	    }
	  })])
	}]}

/***/ }),
/* 1108 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row contact-item list-item",
	    class: {
	      clickable: _vm.view_mode.anywhere_select, undraggable: !_vm.can_change_priority
	    },
	    on: {
	      "click": function($event) {
	        return _vm.anywhereSelectContact($event)
	      }
	    }
	  }, [(_vm.view_mode.show_checkbox) ? _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    on: {
	      "click": function($event) {
	        return _vm.checkboxSelectContact($event)
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selected
	    }
	  }), _c('label', [_vm._v(" ")])])]) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-120 contact-list-item-name overflow-hidden",
	    class: {
	      clickable: _vm.view_mode.name_go_to_show, "two-lines-col": _vm.view_mode.business == "below-name"
	    },
	    on: {
	      "click": _vm.openContact
	    }
	  }, [_c('div', {
	    staticClass: "contact-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.contact.full_name))]), (_vm.view_mode.business == "below-name") ? _c('div', {
	    staticClass: "contact-business-inline overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.contact.business.name))]) : _vm._e()]), (_vm.view_mode.show_created_at_column) ? _c('div', {
	    staticClass: "table-col table-col-50 contact-list-item-created-at text-gray-color"
	  }, [_c('div', {
	    staticClass: "contact-business"
	  }, [_vm._v(_vm._s(_vm.contact.humalCreatedAt()))])]) : _vm._e(), (_vm.view_mode.business == "column") ? _c('div', {
	    staticClass: "table-col overflow-hidden"
	  }, [_c('div', {
	    staticClass: "contact-business overflow-ellipsis"
	  }, [_vm._v(" " + _vm._s(_vm.contact.business.name))])]) : _vm._e(), (_vm.view_mode.flow) ? _c('div', {
	    staticClass: "table-col overflow-hidden"
	  }, [_c('div', {
	    staticClass: "contact-flow-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.contact.flow.name))])]) : _vm._e(), (_vm.view_mode.action_step) ? _c('div', {
	    staticClass: "table-col"
	  }, [(_vm.contact.recipient && _vm.flow && _vm.contact.recipient.human_last_flow_action_taken) ? _c('div', {
	    staticClass: "contact-recipient-action-step-info"
	  }, [_c('div', {
	    staticClass: "contact-recipient-last-action-step-taken"
	  }, [_vm._v(_vm._s(_vm.contact.recipient.human_last_flow_action_taken))]), _vm._v("/"), _c('div', {
	    staticClass: "contact-flow-number-of-actions"
	  }, [_vm._v(_vm._s(_vm.flow.actions.length))]), (_vm.contactItemLastActionTakenStateIcon()) ? _c('span', {
	    class: _vm.contactItemLastActionTakenStateIcon(),
	    attrs: {
	      "data-toggle": _vm.contact.recipient.lastActionTakenStateTooltipText() ? "tooltip" : null,
	      "data-original-title": _vm.contact.recipient.lastActionTakenStateTooltipText(),
	      "data-placement": "top"
	    }
	  }) : _vm._e(), (_vm.showEmailOpenStatisticBadge()) ? _c('span', {
	    staticClass: "badge",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-original-title": _vm.lastEmailOpenEventAt(),
	      "data-placement": "top"
	    }
	  }, [_vm._v(_vm._s(_vm.contact.recipient.emailOpenStatistics().count) + "x")]) : _vm._e(), (_vm.contact.recipient.metadata.destroyed_tasks && _vm.contact.recipient.metadata.destroyed_tasks.length) ? _c('img', {
	    staticClass: "skipped-actions",
	    attrs: {
	      "src": "/static/icons/skiped-actions.svg",
	      "data-toggle": "tooltip",
	      "data-original-title": _vm.skipped_actions_tooltip_text,
	      "data-placement": "top"
	    }
	  }) : _vm._e()]) : _vm._e()]) : _vm._e(), (_vm.view_mode.show_status_updated_at_column) ? _c('div', {
	    staticClass: "table-col contact-list-item-status-updated-at text-gray-color"
	  }, [_vm._v(_vm._s(_vm.contact.humanStatusUpdatedAt()))]) : _vm._e(), (_vm.view_mode.show_stage_updated_at_column) ? _c('div', {
	    staticClass: "table-col contact-list-item-stage-updated-at text-gray-color"
	  }, [_vm._v(_vm._s(_vm.contact.humanStageUpdatedAt()))]) : _vm._e(), (_vm.view_mode.status) ? _c('div', {
	    staticClass: "table-col contact-list-item-status"
	  }, [_c('div', {
	    staticClass: "dropdown hover-margin-status"
	  }, [_c('a', {
	    staticClass: "margin-status",
	    class: _vm.contactItemStatusClasses(),
	    attrs: {
	      "type": "button",
	      "data-toggle": _vm.contactStatusDropdownAvailable()
	    }
	  }, [_c('span', {
	    class: _vm.contactStatusIconClass()
	  }), _c('div', {
	    staticClass: "contact-status"
	  }, [_vm._v(_vm._s(_vm.contact.human_recipient_status))])]), (_vm.canUpdateContact()) ? _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_vm._l((_vm.contact.next_valid_recipient_statuses), function(next_status_options, next_status) {
	    return _c('li', [_c('a', {
	      class: {
	        "show-connected-options": next_status == "connected"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.updateContactRecipient($event, {
	            status: next_status
	          })
	        }
	      }
	    }, [_vm._v(_vm._s(next_status_options.human_action_name)), _c('ul', {
	      staticClass: "dropdown-menu connected-options",
	      staticStyle: {
	        "display": "none"
	      }
	    }, [_c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.connectedAndSendToNewFlow($event)
	        }
	      }
	    }, [_vm._v("Enviar para fluxo")])]), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.connectedAndCreateTask($event)
	        }
	      }
	    }, [_vm._v("Criar tarefa")])]), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.connectedAndChangeStage($event)
	        }
	      }
	    }, [_vm._v("Alterar estágio")])]), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.connectedAndLost($event)
	        }
	      }
	    }, [_vm._v("Perdido")])])])])])
	  }), (_vm.contact.recipient_status == 'converting') ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openRecipientScheduleReactivationModal($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.scheduleReactivationText()))])]) : _vm._e()], 2) : _vm._e()])]) : _vm._e(), (_vm.view_mode.stage) ? _c('div', {
	    staticClass: "table-col contact-list-item-stage"
	  }, [_c('div', {
	    staticClass: "dropdown"
	  }, [(_vm.show_flow_search) ? _c('autocomplete', {
	    attrs: {
	      "contact": _vm.contact
	    },
	    on: {
	      "hide": _vm.hideFlowSearch,
	      "flow-selected": _vm.updateContactInfo
	    }
	  }) : _vm._e(), _c('a', {
	    class: _vm.contactItemStageClasses(),
	    attrs: {
	      "type": "button",
	      "data-toggle": _vm.view_mode.allow_update_stage && _vm.contactStageDropdownAvailable()
	    }
	  }, [_c('div', {
	    staticClass: "contact-stage"
	  }, [_vm._v(_vm._s(_vm.contact.human_stage))])]), (_vm.canUpdateContact()) ? _c('ul', {
	    staticClass: "dropdown-menu"
	  }, _vm._l((_vm.contact.next_valid_stages), function(next_stage_options, next_stage) {
	    return _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.setLostInfo($event, {
	            stage: next_stage
	          })
	        }
	      }
	    }, [_vm._v(_vm._s(next_stage_options.human_name))])])
	  }), 0) : _vm._e()], 1)]) : _vm._e(), (_vm.view_mode.group) ? _c('div', {
	    staticClass: "table-col overflow-hidden"
	  }, [_c('div', {
	    staticClass: "contact-group-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.contact.contact_group ? _vm.contact.contact_group.name : ''))])]) : _vm._e(), (_vm.view_mode.user && !_vm.view_mode.only_picture_miniature) ? _c('div', {
	    staticClass: "table-col contact-list-item-user"
	  }, [_c('user-miniature', {
	    attrs: {
	      "user": _vm.contact.user,
	      "options": {
	        first_name: true
	      }
	    }
	  })], 1) : _vm._e(), (_vm.view_mode.user && _vm.view_mode.only_picture_miniature) ? _c('div', {
	    staticClass: "table-col table-col-30"
	  }, [_c('user-miniature', {
	    attrs: {
	      "user": _vm.contact.user,
	      "options": {
	        first_name: true,
	        only_picture: true
	      }
	    }
	  })], 1) : _vm._e(), (_vm.view_mode.initialized_contact_icon) ? _c('div', {
	    staticClass: "table-col table-col-collapsed show"
	  }, [(!_vm.can_change_priority) ? _c('span', {
	    staticClass: "glyphicon glyphicon-ok-circle reev-base-green-color single-line-tooltip",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-placement": "bottom",
	      "data-original-title": _vm.$t('contacts.tooltip.text.startedInFlow')
	    }
	  }) : _vm._e()]) : _vm._e(), _vm._t("default"), (_vm.view_mode.actions_dropdown) ? _c('div', {
	    staticClass: "table-col table-col-collapsed",
	    on: {
	      "!click": function($event) {}
	    }
	  }, [_c('div', {
	    staticClass: "action"
	  }, [_c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu multi-level"
	  }, [(_vm.show_send_to_flow && _vm.canUpdateContact()) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.show_flow_search = true
	      }
	    }
	  }, [_vm._v("Enviar para fluxo")])]) : _vm._e(), (_vm.contact.id) ? _c('li', [_c('a', {
	    on: {
	      "click": _vm.viewContact
	    }
	  }, [_vm._v("Visualizar")])]) : _vm._e(), (_vm.canUpdateContact()) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.destroyContact($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.remove_label))])]) : _vm._e(), (_vm.show_reset_contact && _vm.canUpdateContact()) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.resetContactRecipient($event)
	      }
	    }
	  }, [_vm._v("Resetar")])]) : _vm._e(), (_vm.canScheduleReactivation() && _vm.canUpdateContact()) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openRecipientScheduleReactivationModal($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.scheduleReactivationText()))])]) : _vm._e()])])])]) : (_vm.view_mode.anywhere_select_action == 'emit-selected') ? _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_vm._m(1)]) : _vm._e(), (_vm.view_mode.number_of_tags > 0) ? _c('div', {
	    staticClass: "tags-list",
	    style: ({
	      left: _vm.tags_margin_left
	    })
	  }, [_vm._l((_vm.contact.tags), function(tag, index) {
	    return (index < _vm.view_mode.number_of_tags) ? _c('tag', {
	      style: ({
	        color: '#' + tag.color
	      }),
	      attrs: {
	        "tag": tag
	      }
	    }, [_vm._v(_vm._s(tag.name))]) : _vm._e()
	  }), (_vm.overflow_tags) ? _c('div', {
	    staticClass: "tags_number",
	    on: {
	      "click": _vm.viewContact
	    }
	  }, [_vm._v(_vm._s(_vm.overflow_tags_count) + "+")]) : _vm._e()], 2) : _vm._e(), (_vm.show_lost_reason_modal) ? _c('lost-reason-modal', {
	    attrs: {
	      "contact": _vm.contact,
	      "temp_attr": _vm.temp_attr
	    },
	    on: {
	      "close-lost-reason-modal": function($event) {
	        return _vm.closeLostReasonModal()
	      },
	      "update-contact-recipient": _vm.updateLostContact
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "action"
	  }, [_c('button', {
	    staticClass: "btn select-action"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])])
	}]}

/***/ }),
/* 1109 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters"
	  }, [_c('dropdown-select', {
	    attrs: {
	      "options": _vm.sort_options,
	      "selected": _vm.sort_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.sort_filter),
	      callback: function($$v) {
	        _vm.sort_filter = $$v
	      },
	      expression: "sort_filter"
	    }
	  }), _c('div', {
	    staticClass: "search-field-wrapper"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-search glyphicon glyphicon-search",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.filter
	    }
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.text_field_filter),
	      expression: "text_field_filter"
	    }],
	    staticClass: "search-field form-control",
	    attrs: {
	      "placeholder": _vm.$t('groups.actions.view.search'),
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.text_field_filter)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filter.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.text_field_filter = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "clear"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "navbar"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "navbar-header"
	  }, [_c('router-link', {
	    staticClass: "navbar-brand",
	    attrs: {
	      "to": "/contatos/leads",
	      "title": "Ir para página inicial"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(31),
	      "width": "106",
	      "alt": "Reev"
	    }
	  })]), _vm._m(0)], 1), _c('div', {
	    staticClass: "navbar-collapse collapse",
	    attrs: {
	      "id": "navbar"
	    }
	  }, [(!_vm.current_user.requireEmailAuthorization()) ? [_c('ul', {
	    staticClass: "nav navbar-nav"
	  }, [_c('li', [_c('router-link', {
	    staticClass: "menu-item icon-tasks",
	    attrs: {
	      "to": "/tarefas"
	    }
	  }, [_vm._v("Tarefas")])], 1), _c('li', [_c('router-link', {
	    staticClass: "menu-item icon-flows",
	    attrs: {
	      "to": "/fluxos-de-cadencia"
	    }
	  }, [_vm._v("Fluxos")])], 1), _c('li', [_c('router-link', {
	    staticClass: "menu-item icon-templates",
	    attrs: {
	      "to": "/templates"
	    }
	  }, [_vm._v("Templates")])], 1), _c('li', [_c('router-link', {
	    staticClass: "menu-item icon-contacts",
	    attrs: {
	      "to": "/contatos/leads"
	    }
	  }, [_vm._v("Contatos")])], 1)])] : _vm._e(), _c('div', {
	    staticClass: "pull-right alert-buttons"
	  }, [(!_vm.current_user.isAdmin()) ? _c('email') : _vm._e(), (!_vm.current_user.isAdmin()) ? _c('voip') : _vm._e(), _c('notification-bell'), _c('div', {
	    staticClass: "dropdown user-area",
	    attrs: {
	      "text": "Action",
	      "type": "primary"
	    }
	  }, [_c('div', {
	    staticClass: "user-miniature-wrapper dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }, [_c('div', {
	    staticClass: "user-miniature-picture-wrapper"
	  }, [_c('img', {
	    staticClass: "user-miniature-picture",
	    attrs: {
	      "src": _vm.current_user.picture_url
	    }
	  })]), _c('div', {
	    staticClass: "pull-left"
	  }, [_c('div', {
	    staticClass: "user-miniature-name"
	  }, [_vm._v(_vm._s(_vm.current_user.firstName()))]), _c('br'), _c('div', {
	    staticClass: "user-miniature-role overflow-ellipsis"
	  }, [_vm._v(" " + _vm._s(_vm.current_user.company.name))])]), _c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })]), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": _vm.to_help,
	      "target": "_blank"
	    }
	  }, [_vm._v("Ajuda"), _c('i', {
	    staticClass: "icon-help glyphicon glyphicon-question-sign"
	  })])]), (_vm.show_change_account) ? _c('li', [_c('a', {
	    staticClass: "change-account-hover"
	  }, [_vm._v("Alterar Conta"), _c('change-account', {
	    on: {
	      "update-user": _vm.updateCurrentUser
	    }
	  })], 1)]) : _vm._e(), _c('li', [_c('router-link', {
	    staticClass: "configuration",
	    attrs: {
	      "to": "/configuracoes/perfil"
	    }
	  }, [_vm._v("Configurações")])], 1), _c('li', [_c('a', {
	    on: {
	      "click": _vm.goToNewUi
	    }
	  }, [_vm._v("Testar a nova versão")])]), _c('li', [_c('a', {
	    on: {
	      "click": _vm.logout
	    }
	  }, [_vm._v("Sair")])])])])], 1)], 2)]), _c('notifications-popup')], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "navbar-toggle collapsed",
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#navbar",
	      "aria-expanded": "false",
	      "aria-controls": "navbar"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _c('span', {
	    staticClass: "icon-bar"
	  }), _c('span', {
	    staticClass: "icon-bar"
	  }), _c('span', {
	    staticClass: "icon-bar"
	  })])
	}]}

/***/ }),
/* 1111 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row contact-item list-item",
	    class: {
	      clickable: !_vm.is_processing
	    },
	    on: {
	      "click": function($event) {
	        return _vm.rowClicked($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item clickable-element",
	    on: {
	      "click": _vm.toggleSelected
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.selected || _vm.all_group_contacts_selected
	    }
	  }), _c('label', [_vm._v(" ")])])]), _c('div', {
	    staticClass: "table-col contact-list-item-name overflow-hidden",
	    class: _vm.view_mode.import_action ? 'table-col-200' : 'table-col-120'
	  }, [_c('div', {
	    staticClass: "contact-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.contact_group.name))])]), (_vm.contact_group.hasStatusMessage()) ? _c('div', {
	    staticClass: "table-col table-col-300 message-status-table-col"
	  }, [_c('div', {
	    class: _vm.contact_group_status_message_class
	  }, [_vm._v(_vm._s(_vm.contact_group_status_message))])]) : [(_vm.view_mode.statistics) ? _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.opportunities))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.connections')))])])]) : _vm._e(), (_vm.view_mode.import_action) ? _c('div', {
	    staticClass: "table-col"
	  }, [_c('span', {
	    staticClass: "label label-default"
	  }, [_vm._v(_vm._s(_vm.import_action_label))])]) : _vm._e(), (_vm.view_mode.contacts_count) ? _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.contact_group.contacts_count))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.navBar.contacts')))])])]) : _vm._e()], (_vm.view_mode.user) ? _c('div', {
	    staticClass: "table-col contact-list-item-user"
	  }, [_c('user-miniature', {
	    attrs: {
	      "user": _vm.contact_group.user,
	      "options": {
	        first_name: true
	      }
	    }
	  })], 1) : _vm._e(), (_vm.view_mode.actions_dropdown) ? _c('div', {
	    staticClass: "table-col table-col-collapsed",
	    on: {
	      "!click": function($event) {}
	    }
	  }, [_c('div', {
	    staticClass: "action clickable-element"
	  }, [_c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu multi-level"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": _vm.editGroup
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))])]), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.destroyGroup($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])])])])])]) : _vm._e()], 2)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	}]}

/***/ }),
/* 1112 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dropdown",
	    class: {
	      'dropdown-full-width': _vm.fullWidth
	    }
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    class: {
	      'full-width': _vm.fullWidth
	    },
	    style: ({
	      'text-transform': _vm.capital ? 'capitalize' : 'none'
	    }),
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown",
	      "disabled": _vm.disabled
	    }
	  }, [_c('div', {
	    staticClass: "overflow-ellipsis"
	  }, [(_vm.selected_option && _vm.selected_option.icon_class) ? _c('span', {
	    staticClass: "icon",
	    class: _vm.selected_option.icon_class
	  }) : _vm._e(), _vm._v(_vm._s(_vm.selected_option ? _vm.selected_option.text : '')), _c('span', {
	    staticClass: "gray-bold-caret"
	  })])]), (_vm.verify) ? _c('ul', {
	    staticClass: "dropdown-menu",
	    style: ({
	      'text-transform': _vm.capital ? 'capitalize' : 'none'
	    })
	  }, [_vm._l((_vm.options), function(option) {
	    return (option.valid == true) ? [_c('li', [_c('a', {
	      attrs: {
	        "value": option.value
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectOption(option)
	        }
	      }
	    }, [(option.icon_class) ? _c('span', {
	      staticClass: "icon",
	      class: option.icon_class
	    }) : _vm._e(), _vm._v(_vm._s(option.text))])]), (option.divider) ? _c('li', {
	      staticClass: "divider"
	    }) : _vm._e()] : _vm._e()
	  })], 2) : _c('ul', {
	    staticClass: "dropdown-menu",
	    style: ({
	      'text-transform': _vm.capital ? 'capitalize' : 'none'
	    })
	  }, [_vm._l((_vm.options), function(option) {
	    return [_c('li', [_c('a', {
	      attrs: {
	        "value": option.value
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectOption(option)
	        }
	      }
	    }, [(option.icon_class) ? _c('span', {
	      staticClass: "icon",
	      class: option.icon_class
	    }) : _vm._e(), _vm._v(_vm._s(option.text))])]), (option.divider) ? _c('li', {
	      staticClass: "divider"
	    }) : _vm._e()]
	  })], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1113 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters"
	  }, [_c('dropdown-select', {
	    attrs: {
	      "options": _vm.status_options,
	      "selected": _vm.status_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.status_filter),
	      callback: function($$v) {
	        _vm.status_filter = $$v
	      },
	      expression: "status_filter"
	    }
	  }), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.stage_options,
	      "selected": _vm.stage_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.stage_filter),
	      callback: function($$v) {
	        _vm.stage_filter = $$v
	      },
	      expression: "stage_filter"
	    }
	  }), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.tag_options,
	      "selected": _vm.tag_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.tag_filter),
	      callback: function($$v) {
	        _vm.tag_filter = $$v
	      },
	      expression: "tag_filter"
	    }
	  }), _c('div', {
	    staticClass: "search-field-wrapper"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-search glyphicon glyphicon-search",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.filter
	    }
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.text_field_filter),
	      expression: "text_field_filter"
	    }],
	    staticClass: "search-field form-control",
	    attrs: {
	      "placeholder": _vm.$t('businesses.filters.placeholder'),
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.text_field_filter)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filter.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.text_field_filter = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "clear"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1114 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.name)
	    }
	  }), _c('span', [_vm._v(" -")]), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.business)
	    }
	  }), _c('br'), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.email)
	    }
	  }), (_vm.item.telephone) ? [_c('br'), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.telephone)
	    }
	  })] : _vm._e(), (_vm.item.cellphone) ? [_c('br'), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.cellphone)
	    }
	  })] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "id": "account_setting",
	      "options": _vm.email_service_options,
	      "value": _vm.value
	    },
	    on: {
	      "input": _vm.emitChange
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('back-link'), _c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v("Notificações")]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "table notifications"
	  }, [_c('div', {
	    staticClass: "table-header table-row"
	  }, [_c('div', {
	    staticClass: "table-col notification-header"
	  }, [_vm._v("Notificação")]), (!_vm.current_user.isSeller()) ? _c('div', {
	    staticClass: "table-col notification-responsible"
	  }, [_vm._v("Responsável")]) : _vm._e()]), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadNotifications),
	      expression: "loadNotifications"
	    }],
	    staticClass: "table-body"
	  }, _vm._l((_vm.notifications), function(notif, index) {
	    return _c('div', {
	      staticClass: "table-row"
	    }, [_c('div', {
	      staticClass: "table-col notification"
	    }, [_c('list-item', {
	      attrs: {
	        "notification": notif,
	        "table": true
	      }
	    })], 1), (!_vm.current_user.isSeller()) ? _c('div', {
	      staticClass: "table-col notification-responsible",
	      class: notif.cssClasses()
	    }, [_c('user-miniature', {
	      attrs: {
	        "user": notif.user,
	        "options": {
	          first_name: true
	        }
	      }
	    })], 1) : _vm._e()])
	  }), 0)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "notifications"
	    }
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_vm._v("Notificações"), (_vm.unread_notifications_count > 0) ? _c('span', {
	    staticClass: "notifications-count"
	  }, [_vm._v(_vm._s(_vm.unread_notifications_count))]) : _vm._e()]), (_vm.notifications_count > 0) ? _c('list', {
	    attrs: {
	      "notifications": _vm.notifications
	    },
	    on: {
	      "navigate": _vm.close
	    }
	  }) : _c('div', {
	    staticClass: "no-notifications"
	  }, [_vm._v("Você ainda não possui nenhuma notificação.")]), (_vm.show_all_notifications_button) ? _c('div', {
	    staticClass: "see-all button",
	    on: {
	      "click": function($event) {
	        return _vm.seeAllNotifications()
	      }
	    }
	  }, [_vm._v("ver todas")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "tabindex": "-1",
	      "role": "dialog",
	      "id": _vm.id
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(0), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.title))])]), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.message) ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.message)
	    }
	  }) : _vm._t("default")], 2), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.reject
	    }
	  }, [_vm._v(_vm._s(_vm.reject_text))]), _c('button', {
	    staticClass: "btn confirm",
	    class: _vm.confirm_class,
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.confirm
	    }
	  }, [_vm._v(_vm._s(_vm.confirm_text))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1119 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    attrs: {
	      "id": "sidebar"
	    }
	  }, [_c('task-bar'), _c('dialer'), _c('comment-global-modal')], 1), _c('task-modal-form', {
	    attrs: {
	      "id": "dialer-manual-task-form-modal"
	    }
	  }), _c('list-composers'), _c('tag-picker-modal', {
	    ref: "tag_picker_modal",
	    attrs: {
	      "taggable": _vm.contact,
	      "prop_id": _vm.tag_picker_id
	    },
	    on: {
	      "picked": _vm.addTagsToContact
	    }
	  }), _c('confirm-modal', {
	    attrs: {
	      "id": "global_confirm_modal",
	      "title": "Excluir comentário",
	      "message": "Deseja realmente excluir este comentário?",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.confirmRemoveComment
	    }
	  }), _c('reset-contact-modal')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1120 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.salesforce')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.salesforce'))), _c('span', {
	    staticClass: "ambient"
	  }, [_vm._v("( " + _vm._s(_vm.salesforceSandboxTeste) + " )")])])])])])]), _c('div', {
	    staticClass: "form"
	  }, [_c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.sendTo')))]), _c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        return _vm.toggleSalesforceSendTo()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.salesforce_send_to
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.salesforce_send_to ? "Fila" : "Usuário responsável"))])])]), _c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "info"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.chooseData')) + ":")]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        return _vm.sending_checked('lead')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.only_lead
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.onlyLead')))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        return _vm.sending_checked('lead_account')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.leads_and_accounts
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.leadAndAccounts')))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        return _vm.sending_checked('lead_account_opportunity')
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.leads_accounts_and_opportunities
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.salesforce.leadAccountsAndOpportunities')))])])])])])])]), _c('trigger-stages', {
	    attrs: {
	      "settings": _vm.salesforce_setting.triggers
	    },
	    on: {
	      "selected-stages": _vm.setStages
	    }
	  }), _c('properties-matching', {
	    attrs: {
	      "properties_matching": _vm.salesforce_setting.properties_matching,
	      "integration_name": "salesforce",
	      "api_fields": _vm.api_fields
	    },
	    on: {
	      "matching-updated": _vm.matchingUpdated
	    }
	  }), (!_vm.api_permissions) ? _c('div', {
	    staticClass: "warning"
	  }, [_c('span', {
	    staticClass: "red"
	  }, [_vm._v(_vm._s(_vm.$t(_vm.integrations.label.salesforce.featurePermission)) + " "), _c('a', {
	    staticClass: "call-to-action-link",
	    attrs: {
	      "href": _vm.to_article,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.label.here')))]), _vm._v(".")])]) : _vm._e(), (!_vm.permission_groups && _vm.salesforce_send_to) ? _c('div', {
	    staticClass: "warning"
	  }, [_c('span', {
	    staticClass: "red"
	  }, [_vm._v(_vm._s(_vm.$t(_vm.integrations.label.salesforce.queuePermission)) + " "), _c('a', {
	    staticClass: "call-to-action-link",
	    attrs: {
	      "href": _vm.to_article,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.label.here')))]), _vm._v(".")])]) : _vm._e(), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.saveSalesforceSetting
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))]), _c('button', {
	    staticClass: "pull-right btn btn-danger btn-nylas",
	    on: {
	      "click": _vm.redirectToSalesforceOauthUrl
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))])])])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/salesforce.png"
	    }
	  })])
	}]}

/***/ }),
/* 1121 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.pipedrive')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.pipedrive')))])])])])]), _c('div', {
	    staticClass: "form"
	  }, [_c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-5",
	    class: {
	      'has-error': _vm.errors.has('pipedrive_api_key')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "pipedrive_api_key"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.apiKey')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pipedrive_api_key),
	      expression: "pipedrive_api_key"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "pipedrive_api_key",
	      "type": "text",
	      "disabled": _vm.current_user.pipedrive_api_key,
	      "placeholder": _vm.$t('integrations.placeholder.apiKey')
	    },
	    domProps: {
	      "value": (_vm.pipedrive_api_key)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.pipedrive_api_key = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('pipedrive_api_key')),
	      expression: "errors.has('pipedrive_api_key')"
	    }],
	    key: "pipedrive_api_key",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('pipedrive_api_key')))])])], 1)]), (_vm.show_configuration_by_pipeline_name) ? [_c('div', {
	    staticClass: "info info-crm"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.configByPipelineStage')))]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-4",
	    class: {
	      'has-error': _vm.errors.has('pipedrive_setting_pipeline_name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "pipedrive_setting_pipeline_name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.funnelName')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pipedrive_setting.metadata.pipeline_name),
	      expression: "pipedrive_setting.metadata.pipeline_name"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "pipedrive_setting_pipeline_name",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.placeholder.funnelName')
	    },
	    domProps: {
	      "value": (_vm.pipedrive_setting.metadata.pipeline_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.pipedrive_setting.metadata, "pipeline_name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('pipedrive_setting_pipeline_name')),
	      expression: "errors.has('pipedrive_setting_pipeline_name')"
	    }],
	    key: "pipedrive_setting_pipeline_name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.feedback.funnel')))])])], 1), _c('div', {
	    staticClass: "form-group col-md-4",
	    class: {
	      'has-error': _vm.errors.has('pipedrive_setting_stage_id') || _vm.errors.has('pipedrive_setting_stage_id')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "pipedrive_setting_stage_id"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.stageNumber')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pipedrive_setting.metadata.stage_id),
	      expression: "pipedrive_setting.metadata.stage_id"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "pipedrive_setting_stage_id",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.placeholder.stageNumber')
	    },
	    domProps: {
	      "value": (_vm.pipedrive_setting.metadata.stage_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.pipedrive_setting.metadata, "stage_id", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('pipedrive_setting_stage_id')),
	      expression: "errors.has('pipedrive_setting_stage_id')"
	    }],
	    key: "pipedrive_setting_stage_id",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.feedback.requiredFunnelStage')))])])], 1), _c('div', {
	    staticClass: "form-group col-md-4"
	  }, [_c('label', {
	    attrs: {
	      "for": "pipedrive_stage_id"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.funnelStageNumber')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.pipedrive_setting.stage_id),
	      expression: "pipedrive_setting.stage_id"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "pipedrive_setting.stage_id",
	      "type": "text",
	      "disabled": "true",
	      "placeholder": _vm.$t('integrations.placeholder.funnelStageNumber')
	    },
	    domProps: {
	      "value": (_vm.pipedrive_setting.stage_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.pipedrive_setting, "stage_id", $event.target.value)
	      }
	    }
	  })])])] : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 without-padding"
	  }, [_c('div', {
	    staticClass: "form-group col-md-6"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    on: {
	      "click": function($event) {
	        return _vm.toggleCopySettings()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")]), _c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.copy_settings
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.copySettings')))])])]), (_vm.copy_settings) ? _c('div', {
	    staticClass: "form-group col-md-6"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")]), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('dropdown-select', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "options": _vm.users_options_pipedrive
	    },
	    model: {
	      value: (_vm.user_pipe_setting),
	      callback: function($$v) {
	        _vm.user_pipe_setting = $$v
	      },
	      expression: "user_pipe_setting"
	    }
	  })], 1), _c('div', {
	    staticClass: "com-md-2"
	  }, [_c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.copy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))])])]) : _vm._e()]), _c('div', {
	    staticClass: "col-md-4"
	  })]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    on: {
	      "click": function($event) {
	        return _vm.toggleMarkAddContatsToPipedrive()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")]), _c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.add_contacts_to_pipedrive
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.pipedrive.receiveContactsTitle')))]), _c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('trigger-stages', {
	    attrs: {
	      "integration": "pipedrive",
	      "settings": _vm.pipedrive_setting.triggers
	    },
	    on: {
	      "selected-stages": _vm.setStagesPipedrive
	    }
	  })], 1), _c('div', {
	    staticClass: "col-md-4"
	  }, [(_vm.lost_checked || _vm.stage_lost) ? _c('deal-lost', {
	    attrs: {
	      "settings": _vm.pipedrive_setting.mark_as
	    },
	    on: {
	      "selected": _vm.setMarkAs
	    }
	  }) : _vm._e()], 1)]), _c('properties-matching', {
	    attrs: {
	      "properties_matching": _vm.pipedrive_setting.properties_matching,
	      "integration_name": "pipedrive",
	      "api_fields": _vm.api_fields
	    },
	    on: {
	      "matching-updated": _vm.matchingUpdated
	    }
	  }), _c('stages-matching', {
	    attrs: {
	      "stages_matching": _vm.pipedrive_setting.stages_matching,
	      "integration_name": "pipedrive",
	      "integration_stages": _vm.integration_stages,
	      "pipelines": _vm.pipelines,
	      "pipeline_id": _vm.selected_pipeline,
	      "show_ignore_stages": true
	    },
	    on: {
	      "matching-updated": _vm.matchingStagesUpdated,
	      "users-update": _vm.updateUsers,
	      "update-stages": _vm.loadByNewPipeline
	    }
	  }), _c('hr'), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), (_vm.current_user.pipedrive_api_key) ? _c('button', {
	    staticClass: "pull-right btn btn-danger",
	    staticStyle: {
	      "margin-left": "15px"
	    },
	    on: {
	      "click": _vm.removePipedriveApiKey
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _vm._e(), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/pipedrive.png"
	    }
	  })])
	}]}

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "task-item ozzy-task",
	    class: _vm.taskItemClass()
	  }, [_c('div', {
	    staticClass: "remove-task",
	    on: {
	      "click": _vm.removeTask
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(48)
	    }
	  })]), (_vm.element_options.show_contact) ? _c('div', {
	    staticClass: "task-contact clickable",
	    on: {
	      "click": _vm.toggleTaskBar
	    }
	  }, [_c('div', {
	    staticClass: "spacer-15"
	  }), _c('div', {
	    staticClass: "contact-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.task.contact.full_name))]), _c('div', {
	    staticClass: "contact-business"
	  }, [_vm._v(_vm._s(_vm.task.contact.business.name))])]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "interaction"
	  }, [_c('span', {
	    staticClass: "sent"
	  }, [_vm._v(_vm._s(_vm.interaction_total_delivery))]), _c('span', {
	    staticClass: "opened"
	  }, [_vm._v(_vm._s(_vm.interaction_total_open))])]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "task-text"
	  }, [_c('div', {
	    staticClass: "task-description overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.task_description))]), _c('div', {
	    staticClass: "task-info overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.task_info))])]), _c('div', {
	    staticClass: "task-action-bar"
	  }, [(_vm.element_options.show_comment && _vm.task.comment) ? _c('div', {
	    staticClass: "comment-task-action task-comment-icon",
	    class: {
	      'comment-icon-down': _vm.task.isEmailTask()
	    },
	    attrs: {
	      "id": _vm.element_id
	    }
	  }) : _vm._e(), (_vm.task.isEmailTask()) ? _c('div', {
	    staticClass: "edit-task-action email-send-icon",
	    on: {
	      "click": _vm.emitOpenCompose
	    }
	  }) : _vm._e(), (_vm.show_call_button) ? _c('div', {
	    staticClass: "phone-task-action clickable"
	  }, [_c('span', {
	    staticClass: "dropdown-toggle glyphicon glyphicon-earphone",
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right"
	  }, [(_vm.task.contact.cellphone) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openDialer(_vm.task.contact.cellphone, "cellphone", _vm.task)
	      }
	    }
	  }, [_vm._v("Ligar para celular " + _vm._s(_vm.normalizePhone(_vm.task.contact.cellphone)))])]) : _vm._e(), (_vm.task.contact.telephone) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openDialer(_vm.task.contact.telephone, "telephone", _vm.task)
	      }
	    }
	  }, [_vm._v("Ligar para telefone fixo " + _vm._s(_vm.normalizePhone(_vm.task.contact.telephone)))])]) : _vm._e(), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openDialer(null, "", _vm.task)
	      }
	    }
	  }, [_vm._v("Ligar para outro número")])])])]) : _vm._e(), (!_vm.disable_toggle_done) ? _c('div', {
	    staticClass: "done-menu glyphicon glyphicon-ok-circle clickable",
	    on: {
	      "click": _vm.toggleDone
	    }
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Permissões")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', [_vm._v("Os Executivos de Vendas/SDR podem criar ou editar templates no Reev?")]), _c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSellerCanEditTemplates()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.seller_can_edit_templates
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.seller_can_edit_templates ? "Sim" : "Não"))])])]), _c('hr'), _c('div', {
	    staticClass: "form-group"
	  }, [_c('span', [_vm._v("Os Executivos de Vendas/SDR podem visualizar todos os contatos da base do Reev?")]), _c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSellerCanSeeAllContacts()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.seller_can_see_all_contacts
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.seller_can_see_all_contacts ? "Sim" : "Não"))])])]), _c('hr'), _c('div', {
	    staticClass: "form-group"
	  }, [_c('span', [_vm._v("Os Executivos de Vendas/SDRs podem alterar a responsabilidade de contatos para si mesmos?")]), _c('div', {
	    staticClass: "toggler-inline",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleSellerCanChangeResponsability()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.seller_can_change_responsability
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.seller_can_change_responsability ? "Sim" : "Não"))])])]), _c('div', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.save()
	      }
	    }
	  }, [_vm._v("Salvar")])])])])
	},staticRenderFns: []}

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "live-feed-event-list-item"
	  }, [_c('div', {
	    staticClass: "icon-wrapper"
	  }, [_c('div', {
	    staticClass: "contact-event-subicon",
	    class: _vm.event.emailSubiconClass()
	  })]), _c('div', {
	    staticClass: "title"
	  }, [(_vm.event.contact.deleted_by_user_at) ? _c('div', {
	    staticClass: "deleted-contact-name"
	  }, [_vm._v(_vm._s(_vm.event.contact.full_name))]) : _c('div', {
	    staticClass: "contact-name clickable",
	    on: {
	      "click": function($event) {
	        return _vm.toggleTaskBar(_vm.event.contact)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.event.contact.full_name))]), _c('div', {
	    staticClass: "description"
	  }, [_vm._v(_vm._s(_vm.liveFeedEventDescription()))])]), _c('div', {
	    staticClass: "created-at"
	  }, [_vm._v(_vm._s(_vm.moment(_vm.event.created_at).format('LTS')))]), _c('div', {
	    staticClass: "user"
	  }, [_c('span', [_vm._v("Responsável:")]), _c('span', {
	    staticClass: "user-name"
	  }, [_vm._v(_vm._s(_vm.event.user.name))])])])
	},staticRenderFns: []}

/***/ }),
/* 1125 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row type-and-template-wrapper"
	  }, [_c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('div', {
	    staticClass: "type-action-picker-wrapper form-group"
	  }, [_c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "name": "action_parameters",
	      "options": _vm.type_options,
	      "disabled": _vm.options.disabled || !_vm.flow.canEditActions()
	    },
	    on: {
	      "input": _vm.typeChanged
	    },
	    model: {
	      value: (_vm.action_parameters),
	      callback: function($$v) {
	        _vm.action_parameters = $$v
	      },
	      expression: "action_parameters"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "col-sm-8 no-padding"
	  }, [_c('div', {
	    staticClass: "template-picker-wrapper"
	  }, [_c('template-picker', {
	    attrs: {
	      "reference": _vm.reference,
	      "action": _vm.action,
	      "flow": _vm.flow,
	      "templates": _vm.templates,
	      "template_kind": _vm.template_kind,
	      "validate": _vm.is_email_flow_action,
	      "options": _vm.options
	    },
	    on: {
	      "change": _vm.templateChanged,
	      "cancel-editing": _vm.cancelTemplateEdit
	    }
	  })], 1)]), _c('div', {
	    staticClass: "col-sm-1 no-padding text-center"
	  }, [_c('div', {
	    staticClass: "send-as-reply-wrapper",
	    class: {
	      hidden: _vm.hide_send_as_reply
	    }
	  }, [_c('div', {
	    staticClass: "checkbox-inline reply-checkbox no-margin",
	    attrs: {
	      "id": "send-as-reply"
	    },
	    on: {
	      "click": _vm.toggleSendAsReply
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.send_as_reply
	    }
	  }), _c('label', {
	    staticClass: "control-label single-line-tooltip",
	    attrs: {
	      "data-toggle": "tooltip",
	      "data-title": _vm.$t('flows.actions.sendAsReply')
	    }
	  }, [_vm._v(" ")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "email-alert"
	  }, [_c('div', {
	    staticClass: "open-dialer",
	    on: {
	      "click": function($event) {
	        return _vm.emitOpenCompose()
	      }
	    }
	  }), _c('img', {
	    attrs: {
	      "src": __webpack_require__(970)
	    }
	  }), _c('account-status-info', {
	    attrs: {
	      "show_alert": _vm.show_alert,
	      "account_status": _vm.account_status,
	      "nylas_setting": _vm.nylas_setting
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "glyphicon glyphicon-earphone voip-alert",
	    class: _vm.css_class,
	    on: {
	      "click": function($event) {
	        return _vm.openDialer(null, "", null, false)
	      }
	    }
	  }, [_c('alert-tick', {
	    attrs: {
	      "service_status": _vm.voip_status,
	      "message": _vm.voip_message
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1128 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row specific-template-item"
	  }, [_c('div', {
	    staticClass: "table-col specific-template-item specific-template-step overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.action.human_step) + " / " + _vm._s(_vm.flow.actions.length))]), _c('div', {
	    staticClass: "table-col table-col-200 specific-template-item specific-template-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.template.name || '-'))]), _c('div', {
	    staticClass: "table-col specific-template-item specific-template-category"
	  }, [(_vm.template.category_name) ? _c('span', {
	    staticClass: "label label-default"
	  }, [_vm._v(_vm._s(_vm.template.category_name))]) : _c('span', [_vm._v("-")])]), _c('div', {
	    staticClass: "table-col table-col-200 specific-template-item specific-template-body overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.template.subject || '-'))]), _c('div', {
	    staticClass: "table-col table-col-collapsed specific-template-item specific-template-actions show action-button"
	  }, [_c('span', {
	    staticClass: "plain-btn-edit",
	    class: {
	      orange: _vm.edited
	    },
	    on: {
	      "click": function($event) {
	        return _vm.editSpecificTemplate($event)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "table-col table-col-collapsed specific-template-item specific-template-actions show"
	  }, [(_vm.edited && _vm.current_user.can_manage_templates) ? _c('span', {
	    staticClass: "glyphicon glyphicon-trash clickable-element",
	    on: {
	      "click": _vm.destroySpecificTemplate
	    }
	  }) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 1129 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "contact-item",
	    attrs: {
	      "id": "contacts-show"
	    }
	  }, [_c('router-link', {
	    staticClass: "back-link",
	    attrs: {
	      "to": "/contatos/grupos"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t('groups.actions.update.title')) + " " + _vm._s(_vm.original_group_name))])]), _c('div', {
	    staticClass: "dropdown pull-right"
	  }, [(!_vm.current_user.isMonitoringManager()) ? _c('button', {
	    staticClass: "btn btn-primary contact-show-actions btn-options dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-plus"
	  }), _c('span', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.$t('contacts.actions.add')))]), _c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })]) : _vm._e(), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#contacts-manual-picker"
	    }
	  }, [_c('a', {
	    staticClass: "clickable"
	  }, [_vm._v(_vm._s(_vm.$t('general.label.Manually')))])]), _c('li', {
	    attrs: {
	      "id": "contact-picker",
	      "data-toggle": "modal",
	      "data-target": "#contacts-picker"
	    }
	  }, [_c('a', {
	    staticClass: "clickable",
	    attrs: {
	      "id": "open-contact-picker"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.actions.create.contactBaseAdd')))])])])])]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.groupName')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact_group.name),
	      expression: "contact_group.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "name",
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.contact_group.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact_group, "name", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "col-md-2 col-md-offset-1"
	  }, [_c('label', {
	    attrs: {
	      "for": "responsible"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.Responsible')))]), _c('user-miniature', {
	    attrs: {
	      "id": "responsible",
	      "user": _vm.contact_group.user,
	      "options": {
	        first_name: true
	      }
	    }
	  })], 1), _c('div', {
	    staticClass: "col-md-2 col-md-offset-1"
	  }, [_c('div', {
	    staticClass: "number-with-label"
	  }, [_c('div', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.contacts_count))]), _c('div', {
	    staticClass: "labels"
	  }, [_c('div', {
	    staticClass: "upper-label"
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.contacts')))]), _c('div', {
	    staticClass: "lower-label"
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.added')))])]), _c('div', {
	    staticClass: "clear"
	  })])])]), _c('hr'), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadContacts),
	      expression: "loadContacts"
	    }],
	    staticClass: "group-contacts-list",
	    attrs: {
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('contact-list', {
	    attrs: {
	      "contacts": _vm.contacts,
	      "view_mode": _vm.contactListViewModes().group,
	      "origem": _vm.$t('groups.label.Group')
	    },
	    on: {
	      "contact-destroy": _vm.removeFromGroup,
	      "contact-update": _vm.updateContact,
	      "contact-recipient-update": _vm.updateContactRecipient,
	      "filter": _vm.filter
	    }
	  })], 1), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.fetching
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('groups.feedback.noMoreResults')))])], 1), _c('go-to-top'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "wrapper-buttons text-center"
	  }, [_c('router-link', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "to": "/contatos/grupos"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": _vm.current_user.isMonitoringManager()
	    },
	    on: {
	      "click": _vm.saveGroup
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])], 1)])]), _c('contact-picker', {
	    attrs: {
	      "fetch_mode": 'withoutGroup',
	      "view_mode": _vm.contactListViewModes().group_picker,
	      "user_id": _vm.contact_group.user.id
	    },
	    on: {
	      "contacts-selected": _vm.selectContacts
	    }
	  }), _c('contact-manual-picker', {
	    on: {
	      "contact-picker-contacts-added": _vm.addContactsToGroup
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1130 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "voip-card"
	  }, [_c('div', {
	    staticClass: "icon",
	    class: _vm.cssClass
	  }), _c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.convert_number) + " " + _vm._s(_vm.suffix))])])
	},staticRenderFns: []}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.current_page > 1 && _vm.tasks.length) ? _c('a', {
	    staticClass: "prev-page clickable",
	    on: {
	      "click": function($event) {
	        return _vm.prevPage()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(996)
	    }
	  })]) : _vm._e(), (_vm.next_page && _vm.tasks.length) ? _c('a', {
	    staticClass: "next-page clickable",
	    on: {
	      "click": function($event) {
	        return _vm.nextPage()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(995)
	    }
	  })]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('br'), (_vm.loading) ? _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  })], 1) : _vm._e(), (!_vm.loading && _vm.tasks.length) ? _c('div', {
	    staticClass: "task-list",
	    attrs: {
	      "id": "tasks"
	    }
	  }, [_vm._l((_vm.tasks), function(task, index) {
	    return [(task.contact) ? _c('ozzy-task-item', {
	      key: task.id,
	      attrs: {
	        "task": task
	      },
	      on: {
	        "toggle-task-bar": _vm.bubbleUp,
	        "removing": _vm.bubbleUp,
	        "task-updated": _vm.taskUpdated
	      }
	    }) : _vm._e()]
	  })], 2) : _vm._e(), (!_vm.loading && !_vm.tasks.length) ? _c('div', {
	    attrs: {
	      "id": "message"
	    }
	  }, [_vm._m(0)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "text-center"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(989)
	    }
	  }), _c('br'), _c('br'), _c('br'), _c('span', [_vm._v("Você não possui Ozzy Tasks no momento.")])])
	}]}

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1133 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_c('div', {
	    staticClass: "contact-event-icon sharpspring-icon"
	  }), _c('div', {
	    staticClass: "contact-event-header overflow-ellipsis"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
	    staticClass: "right-arrow glyphicon glyphicon-arrow-right"
	  }), _c('a', {
	    staticClass: "contact-event-description underlined",
	    attrs: {
	      "href": _vm.event.description,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.event.description))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1134 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c(_vm.notificationComponent(_vm.notification), {
	    tag: "component",
	    attrs: {
	      "notification": _vm.notification,
	      "table": _vm.table
	    },
	    on: {
	      "remove-notification": _vm.remove
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('v-autocomplete', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickaway),
	      expression: "onClickaway"
	    }],
	    attrs: {
	      "id": "autocomplete_group",
	      "items": _vm.groups,
	      "get-label": _vm.getLabel,
	      "component-item": _vm.template,
	      "input-attrs": _vm.attrs,
	      "auto-select-one-item": false
	    },
	    on: {
	      "update-items": _vm.updateGroups,
	      "item-selected": _vm.saveGroup
	    },
	    model: {
	      value: (_vm.group),
	      callback: function($$v) {
	        _vm.group = $$v
	      },
	      expression: "group"
	    }
	  })
	},staticRenderFns: []}

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "contact-item",
	    attrs: {
	      "id": "contacts-show"
	    }
	  }, [_c('back-link'), _c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.business.name))]), _c('div', {
	    staticClass: "sub-header"
	  }, [_vm._v(_vm._s(_vm.business.contacts))])])]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('aside', {
	    staticClass: "sidebar"
	  }), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.stage')))]), _c('div', {
	    class: _vm.stageClasses
	  }, [_c('div', {
	    staticClass: "contact-stage"
	  }, [_vm._v(_vm._s(_vm.business.human_stage))])])]), _c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.status')))]), _c('div', {
	    staticClass: "btn-contact-status btn-contact-fake",
	    class: 'contact-status-' + _vm.business.status
	  }, [_c('span', {
	    class: _vm.statusIconClass
	  }), _c('div', {
	    staticClass: "contact-status"
	  }, [_vm._v(_vm._s(_vm.business.human_status))])])]), _c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.tag')))]), _vm._l((_vm.business.tags), function(tag) {
	    return _c('tag', {
	      attrs: {
	        "tag": tag
	      }
	    })
	  }), (_vm.business.tags.length == 0) ? _c('div', [_c('strong', [_vm._v("-")])]) : _vm._e()], 2)])]), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('ul', {
	    staticClass: "tab-list"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.label.details')))])])]), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    attrs: {
	      "id": "details-tab"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "business-form"
	    }
	  }, [_c('div', {
	    staticClass: "form-wrapper"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('business_name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "business_name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.name')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.business.name),
	      expression: "business.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "business-name",
	      "name": "business_name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.business.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.business, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('business_name')),
	      expression: "errors.has('business_name')"
	    }],
	    key: "business_name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('business_name')))])])], 1)]), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "domain"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.domain')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.business.domain),
	      expression: "business.domain"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "business-domain",
	      "name": "domain",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.business.domain)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.business, "domain", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "address"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.address')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.business.address),
	      expression: "business.address"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "business-address",
	      "name": "address",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.business.address)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.business, "address", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row pull-right"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])])])])])]), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadContacts),
	      expression: "loadContacts"
	    }],
	    staticClass: "col-md-9 business-contacts",
	    staticStyle: {
	      "float": "right"
	    },
	    attrs: {
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('hr'), _c('h1', [_vm._v(_vm._s(_vm.$t('businesses.title.linkedContacts')))]), _c('contact-list', {
	    attrs: {
	      "contacts": _vm.contacts,
	      "view_mode": _vm.contactListViewModes().business_contacts
	    },
	    on: {
	      "contact-update": _vm.updateContact,
	      "contact-recipient-update": _vm.updateContactRecipient,
	      "contact-destroy": _vm.openDestroyContactConfirmationModal,
	      "toggle-task-bar": _vm.toggleTaskBar,
	      "filter": _vm.contact_filter
	    }
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.contacts_loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.contact_next_page),
	      expression: "!contact_next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.feedback.noDataText')))])], 1), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-remove-contact",
	      "title": _vm.$t('contact.actions.delete'),
	      "confirm_text": _vm.$t('general.label.delete'),
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.callDestroyContact
	    }
	  }, [_c('br'), (_vm.selected_contact) ? _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('contacts.label.removeContactConfirm')))]), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_contact.full_name))])]) : _vm._e()])], 1)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "container auth-view-wrapper"
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(31),
	      "alt": "Reev"
	    }
	  }), _c('fieldset', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.emailRecovered),
	      expression: "!emailRecovered"
	    }],
	    on: {
	      "change": _vm.setDirty,
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit.apply(null, arguments)
	      }
	    }
	  }, [_c('legend', {
	    staticClass: "auth-legend"
	  }, [_vm._v("Recupere sua senha")]), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, _vm._l((_vm.apiErrorMessages), function(message) {
	    return _c('div', {
	      staticClass: "error-message"
	    }, [_vm._v(_vm._s(message))])
	  }), 0), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-email",
	      "name": "email",
	      "type": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": (_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "email", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    key: "email",
	    staticClass: "help-block text-left"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1), _c('button', {
	    staticClass: "btn btn-block btn-primary submit-button",
	    attrs: {
	      "type": "submit",
	      "disabled": !_vm.submittable
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Enviar instruções por email")]), _c('router-link', {
	    staticClass: "login-link",
	    attrs: {
	      "to": "login"
	    }
	  }, [_vm._v("Voltar")])], 1), _c('fieldset', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.emailRecovered),
	      expression: "emailRecovered"
	    }]
	  }, [_vm._m(0), _c('button', {
	    staticClass: "btn btn-block btn-primary submit-button back-button",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.goToLogin()
	      }
	    }
	  }, [_vm._v("Ok, voltar para o login")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('legend', {
	    staticClass: "auth-legend password-feedback"
	  }, [_c('b', [_vm._v("E-mail enviado!")]), _vm._v(" Siga as instruções enviadas por e-mail para a redefinição da sua senha.")])
	}]}

/***/ }),
/* 1138 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lead-organization"
	  }, [_c('div', {
	    staticClass: "lead-organization__form"
	  }, [_c('p', {
	    staticClass: "lead-organization__text"
	  }, [_vm._v("Essa etapa permite que você organize seus contatos e tenha mais agilidade para encontrá-los dentro da base. Além disso, você pode escolher se vai enviar essa lista para outro usuário.")]), (_vm.show_user_options) ? _c('div', {
	    staticClass: "form-group lead-organization__responsable"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "lead_responsable"
	    }
	  }, [_vm._v("Quem será o responsável por esses leads?")]), _c('div', {
	    attrs: {
	      "id": "lead_responsable"
	    }
	  }, [_c('dropdown-select', {
	    attrs: {
	      "options": _vm.filtered_user_options,
	      "selected": _vm.selected_user_option
	    },
	    on: {
	      "input": _vm.updateUserId
	    },
	    model: {
	      value: (_vm.selected_user_option),
	      callback: function($$v) {
	        _vm.selected_user_option = $$v
	      },
	      expression: "selected_user_option"
	    }
	  })], 1)]) : _vm._e(), _c('div', {
	    staticClass: "form-group lead-organization__fluxo"
	  }, [_c('strong', {
	    staticClass: "text-gray-color"
	  }, [_vm._v("Enviar contatos para um fluxo?")]), _c('div', {
	    staticClass: "toggler-inline"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.sent_to_flow
	    }
	  }), _c('label', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.switchSendToFlow()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.sent_to_flow ? "Sim" : "Não"))]), (_vm.sent_to_flow) ? _c('flows', {
	    attrs: {
	      "user_id": _vm.selected_user
	    },
	    on: {
	      "flow-selected": _vm.selectFlow
	    }
	  }) : _vm._e()], 1)]), (_vm.remaining > 0) ? _c('div', {
	    staticClass: "form-group lead-organization__group"
	  }, [(_vm.multiple_groups) ? _c('strong', {
	    staticClass: "text-gray-color"
	  }, [_vm._v("Adicionar contatos restantes a um grupo?")]) : _c('strong', {
	    staticClass: "text-gray-color"
	  }, [_vm._v("Adicionar contatos a um grupo?")]), _c('div', {
	    staticClass: "toggler-inline half-width"
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.add_to_group
	    }
	  }), _c('label', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.switchAddToGroup()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.add_to_group ? "Sim" : "Não"))]), (_vm.add_to_group) ? _c('groups', {
	    attrs: {
	      "user_id": _vm.selected_user
	    },
	    on: {
	      "group-selected": _vm.selectGroup
	    }
	  }) : _vm._e()], 1)]) : _vm._e(), _c('div', {
	    staticClass: "lead-organization__filters"
	  }, [_c('div', [_c('label', [_vm._v("Inserir tags nos contatos?")]), _c('tag-filter', {
	    attrs: {
	      "id": "tags_filter",
	      "filter_item_selected_ids": _vm.selected_tags,
	      "default_label": 'Nenhuma tag'
	    },
	    on: {
	      "item-selected-items": _vm.updateTags
	    }
	  })], 1), _c('div', [_c('label', [_vm._v("Tags selecionadas:")]), _vm._l((_vm.selected_tags), function(selectedTag) {
	    return _c('tags', {
	      key: selectedTag.id,
	      attrs: {
	        "deletable": true,
	        "tag": selectedTag
	      },
	      on: {
	        "remove-tag": _vm.removeTag
	      }
	    })
	  })], 2)])]), (_vm.multiple_groups) ? _c('div', {
	    staticClass: "groups"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "text-gray-color"
	  }, [_vm._v("Confirme a criação de novos grupos e/ou a inserção de contatos em grupos existentes")]), _vm._l((_vm.groups), function(group, index) {
	    return _c('div', {
	      staticClass: "contact-list-item-checkbox-item",
	      on: {
	        "click": function($event) {
	          $event.stopPropagation();
	          return _vm.toogleCheck(index)
	        }
	      }
	    }, [(_vm.getShowCheckboxGroupConditions(group)) ? _c('input', {
	      staticClass: "checkbox-inline",
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": group.selected
	      }
	    }) : _vm._e(), _c('div', {
	      domProps: {
	        "innerHTML": _vm._s(_vm.getGroupText(group))
	      }
	    })])
	  }), (_vm.remaining > 0 && _vm.selected_group == null) ? _c('div', {
	    staticClass: "no-checkbox-inline contact-list-item-checkbox-item"
	  }, [_c('label', [(_vm.remaining > 1) ? _c('strong', [_vm._v("Os " + _vm._s(_vm.remaining) + " contatos restantes não serão adicionados a grupos.")]) : _c('strong', [_vm._v("O contato restante não será adicionado a um grupo.")])])]) : (_vm.selected_group && _vm.remaining > 0) ? _c('div', {
	    staticClass: "no-checkbox-inline contact-list-item-checkbox-item"
	  }, [_c('label', [_c('strong', [_vm._v("Inserir " + _vm._s(_vm.remaining) + " contatos ")]), _c('span', [_vm._v("no grupo ")]), _c('strong', [_vm._v(_vm._s(_vm.selected_group.name))])])]) : _c('div', {
	    staticClass: "no-checkbox-inline contact-list-item-checkbox-item"
	  }, [_vm._m(0)])], 2)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('label', [_c('span', [_vm._v("Não há contatos restantes na sua planilha.")])])
	}]}

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('integrations.title.integrations')))]), (_vm.current_user.email_service_requires_authorization) ? _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.mailProvider')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.mailProvider')))])]), (_vm.current_user.requireEmailReauthorization()) ? _c('div', {
	    staticClass: "table-col table-col-collapsed account-status-tooltip-col",
	    staticStyle: {
	      "text-align": "right"
	    }
	  }, [_c('span', {
	    staticClass: "account-status-alert glyphicon glyphicon-exclamation-sign",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": _vm.$t('integrations.tooltip.mailProvider'),
	      "data-placement": "top"
	    }
	  })]) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('a', {
	    staticClass: "btn btn-clean btn-nylas",
	    class: {
	      'btn-nylas-conected': _vm.email_authorized
	    },
	    on: {
	      "click": _vm.redirectToNylasOauthUrl
	    }
	  }, [_vm._v(_vm._s(_vm.email_authorized ? _vm.$t('general.actions.disconnect') : _vm.$t('general.actions.connect')))])])])])]) : _vm._e(), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('text-image', {
	    attrs: {
	      "text": "API",
	      "color": "#14948C"
	    }
	  })], 1), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.api')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.api')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-config",
	    on: {
	      "click": function($event) {
	        _vm.show_api_token = !_vm.show_api_token
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.showToken')))])])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_api_token),
	      expression: "show_api_token"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show_api_token = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.api')))]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-sm-12"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.apiToken')))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-10"
	  }, [_c('input', {
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "id": "api-token",
	      "readonly": "readonly"
	    },
	    domProps: {
	      "value": _vm.current_user.api_token
	    }
	  })]), _c('div', {
	    staticClass: "col-sm-2"
	  }, [_c('button', {
	    staticClass: "btn btn-primary btn-copy",
	    on: {
	      "click": _vm.copyApiToken
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))])])])])])]), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(1), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.crm')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.crm')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-config",
	    on: {
	      "click": function($event) {
	        return _vm.openBccForm()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_form_bcc),
	      expression: "show_form_bcc"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeForm()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.crm')))]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.has('webhook_url')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.webhook_url),
	      expression: "webhook_url"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|regex:^(https)://'),
	      expression: "'required|regex:^(https)://'"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "webhook_url",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.label.webhookUrlForm')
	    },
	    domProps: {
	      "value": (_vm.webhook_url)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.webhook_url = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('webhook_url')),
	      expression: "errors.has('webhook_url')"
	    }],
	    key: "webhook_url",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.webhook_error))])])], 1)]), _c('trigger-stages', {
	    attrs: {
	      "integration": "webhook",
	      "settings": _vm.current_user.webhook_setting.triggers,
	      "on_responsibility": _vm.current_user.webhook_setting.user_change
	    },
	    on: {
	      "selected-stages": _vm.setStagesWebhook
	    }
	  }), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.saveWebhookUrl()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])]), _c('hr'), _c('div', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.saveWebhookUrl')))]), _c('div', {
	    staticClass: "row vertical-aligned bcc-form"
	  }, [_c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('crm_setting_bcc_send_email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "crm_bcc_send"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts.attributes.crm_setting.bcc_send_email')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.crm_setting.bcc_send_email),
	      expression: "crm_setting.bcc_send_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "crm_setting.bcc_send_email",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.crm_setting.bcc_send_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.crm_setting, "bcc_send_email", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('crm_setting_bcc_send_email')),
	      expression: "errors.has('crm_setting_bcc_send_email')"
	    }],
	    key: "crm_setting_bcc_send_email",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('crm_setting_bcc_send_email')))])])], 1), _c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('crm_setting_bcc_reply_email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "crm_bcc_reply"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts.attributes.crm_setting.bcc_reply_email')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.crm_setting.bcc_reply_email),
	      expression: "crm_setting.bcc_reply_email"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "crm_setting.bcc_reply_email",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.crm_setting.bcc_reply_email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.crm_setting, "bcc_reply_email", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('crm_setting_bcc_reply_email')),
	      expression: "errors.has('crm_setting_bcc_reply_email')"
	    }],
	    key: "crm_setting_bcc_reply_email",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('crm_setting_bcc_reply_email')))])])], 1)]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.saveBcc()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 1), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(2), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.pipedrive')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.pipedrive')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-config",
	    on: {
	      "click": function($event) {
	        return _vm.toIntegration('pipedrive')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(3), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.nectar')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.nectar')))])]), _c('div', {
	    staticClass: "table-col detail"
	  }), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-config",
	    on: {
	      "click": function($event) {
	        return _vm.openConectNectarForm()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_form_nectar),
	      expression: "show_form_nectar"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeForm()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('nectar_api_key')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "nectar_api_key"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.apiKey')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nectar_api_key),
	      expression: "nectar_api_key"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "nectar_api_key",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.placeholder.apiKey')
	    },
	    domProps: {
	      "value": (_vm.nectar_api_key)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.nectar_api_key = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('nectar_api_key')),
	      expression: "errors.has('nectar_api_key')"
	    }],
	    key: "nectar_api_key",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('nectar_api_key')))])])], 1)]), _c('div', {
	    staticClass: "info info-crm"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.nectarFunnelConfig')))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 left"
	  }, [_c('div', {
	    staticClass: "checkbox-inline on-created",
	    on: {
	      "click": function($event) {
	        return _vm.toggleSendTasks()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "name": "send_tasks"
	    },
	    domProps: {
	      "checked": _vm.nectar_setting.send_tasks
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.nectar.sendTasks')))])])])]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('nectar_pipeline_id')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "nectar_pipeline"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.nectarFunnelID')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nectar_setting.pipeline_id),
	      expression: "nectar_setting.pipeline_id"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "nectar_setting.pipeline_id",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.label.nectarFunnelIDPlaceholder')
	    },
	    domProps: {
	      "value": (_vm.nectar_setting.pipeline_id)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nectar_setting, "pipeline_id", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('nectar_stage_number')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "nectar_stage_id"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.nectarFunnelStage')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nectar_setting.stage_number),
	      expression: "nectar_setting.stage_number"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "nectar_setting.stage_number",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.label.nectarFunnelStagePlaceholder')
	    },
	    domProps: {
	      "value": (_vm.nectar_setting.stage_number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nectar_setting, "stage_number", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('nectar_setting_responsible')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "nectar_setting_responsible"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.nectarSettingResponsible')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.nectar_setting.responsible),
	      expression: "nectar_setting.responsible"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "nectar_setting_responsible",
	      "type": "email",
	      "placeholder": _vm.$t('integrations.label.nectarSettingResponsiblePlaceholder')
	    },
	    domProps: {
	      "value": (_vm.nectar_setting.responsible)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.nectar_setting, "responsible", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('nectar_setting_responsible')),
	      expression: "errors.has('nectar_setting_responsible')"
	    }],
	    key: "nectar_setting_responsible",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.feedback.nectarSettingResponsibleInvalid')))])])], 1)]), _c('trigger-stages', {
	    attrs: {
	      "integration": "nectar",
	      "settings": _vm.nectar_setting.triggers
	    },
	    on: {
	      "selected-stages": _vm.setStagesNectar
	    }
	  }), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), (_vm.current_user.nectar_api_key) ? _c('button', {
	    staticClass: "pull-right btn btn-danger btn-config",
	    on: {
	      "click": _vm.removeNectarApiKey
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _vm._e(), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.saveNectar
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 1), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(4), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.salesforce')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.salesforce')))])]), _c('div', {
	    staticClass: "table-col detail"
	  }), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [(_vm.salesforce_authorized) ? _c('a', {
	    staticClass: "btn btn-clean btn-nylas",
	    on: {
	      "click": function($event) {
	        return _vm.toIntegration('salesforce')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))]) : _c('a', {
	    staticClass: "btn btn-clean btn-nylas",
	    on: {
	      "click": function($event) {
	        return _vm.openConectSalesForceForm()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.chooseEnv')))])])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_form_salesforce),
	      expression: "show_form_salesforce"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.closeForm()
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.chooseEnv'))), _c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.chooseEnvOptions')))])]), _c('div', {
	    staticClass: "info"
	  }, [_c('i', [_vm._v(_vm._s(_vm.$t('integrations.tooltip.chooseEnv')))])]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        return _vm.toggleSandboxTestSf()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": !_vm.salesforce_setting.sandbox_test
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.productionEnv')))])])])]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        return _vm.toggleSandboxTestSf()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.salesforce_setting.sandbox_test
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.sandboxEnv')))])])])]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), _c('a', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.redirectToSalesforceOauthUrl
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.connect')))])])])]), _c('vtiger'), _c('hubspot'), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('text-image', {
	    attrs: {
	      "text": "RL",
	      "color": "#BC00A4"
	    }
	  })], 1), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.carousel')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.carousel')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-config",
	    on: {
	      "click": function($event) {
	        _vm.show_carousel = !_vm.show_carousel
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_carousel),
	      expression: "show_carousel"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show_carousel = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-9"
	  }, [_c('div', {
	    staticClass: "info info-crm"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.carousel')))])]), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#carousel-modal"
	    },
	    on: {
	      "click": _vm.loadCarouselData
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.setCarousel')))])])])]), _c('carousel-modal', {
	    ref: "carousel_modal",
	    attrs: {
	      "id": "carousel-modal",
	      "modal-title": _vm.modalTitle(),
	      "kind": "app"
	    },
	    on: {
	      "savedCarousel": _vm.fillCarousel
	    }
	  }), _c('rd_station'), _c('div', {
	    staticClass: "table",
	    attrs: {
	      "id": "rd_station_crm"
	    }
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(5), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.rdStation')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.rdStation')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-config",
	    on: {
	      "click": function($event) {
	        return _vm.toIntegration('rd_station_crm')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])]), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(6), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.sharpspring')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.sharpspring')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [(_vm.current_user.isSeller()) ? _c('button', {
	    staticClass: "btn btn-clean btn-see-carousel",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#sp-carousel-modal"
	    },
	    on: {
	      "click": _vm.loadSpCarouselData
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.carouselModal')))]) : _c('button', {
	    staticClass: "btn btn-clean btn-conect-rd",
	    on: {
	      "click": function($event) {
	        return _vm.openConectSPForm()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_form_sp),
	      expression: "show_form_sp"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show_form_sp = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "form-group margin-top"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.sharpspringLead')))]), _c('div', {
	    staticClass: "info info-rd"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.tooltip.sharpspringLead')))]), _c('div', {
	    staticClass: "flow-type-toggler-wrapper"
	  }, [_c('div', {
	    staticClass: "toggler-inline flow-type-toggle",
	    on: {
	      "click": function($event) {
	        return _vm.toggleUseCarouselSp()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.sharpspring_setting.use_carousel
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.use_carousel_sp()))])])])]), _c('div', {
	    staticClass: "form-group full-width"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "sp_url",
	      "name": "sp_url",
	      "type": "text",
	      "disabled": !_vm.has_configured_sp_carousel && _vm.sharpspring_setting.use_carousel,
	      "readonly": _vm.sp_carousel != null
	    },
	    domProps: {
	      "value": _vm.sp_url
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary btn-copy",
	    attrs: {
	      "id": "btn-copy-rd-url",
	      "disabled": !_vm.has_configured_sp_carousel && _vm.sharpspring_setting.use_carousel
	    },
	    on: {
	      "click": _vm.copyURLsp
	    }
	  }, [_vm._v(_vm._s(_vm.copied_sp ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))]), (_vm.sharpspring_setting.use_carousel) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#sp-carousel-modal"
	    },
	    on: {
	      "click": _vm.loadSpCarouselData
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.setCarousel')))]) : _vm._e()]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.saveSharpSpring
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])]), _c('carousel-modal', {
	    ref: "sp_carousel_modal",
	    attrs: {
	      "id": "sp-carousel-modal",
	      "modal-title": _vm.modalTitle(),
	      "kind": "sp"
	    },
	    on: {
	      "savedCarousel": _vm.fillSpCarousel
	    }
	  })], 1), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(7), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.leadlovers')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.leadlovers')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-conect-rd",
	    on: {
	      "click": function($event) {
	        return _vm.openConectLLForm()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_form_ll),
	      expression: "show_form_ll"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "closeFormButton",
	      "type": "button",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        _vm.show_form_ll = false
	      }
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "form-group margin-top"
	  }, [_c('span', {
	    staticClass: "triggers-integrations index"
	  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.leadlovers.receiveContactsTitle')))])])]), _c('div', {
	    staticClass: "sub-index intermediate-index"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.leadlovers.receiveText')))]), _c('div', {
	    staticClass: "sub-index"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.contactsViaResponsible')))])]), _c('div', {
	    staticClass: "form-group full-width"
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "ll_url",
	      "name": "ll_url",
	      "type": "text"
	    },
	    domProps: {
	      "value": _vm.ll_url
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary btn-copy",
	    attrs: {
	      "id": "btn-copy-rd-url"
	    },
	    on: {
	      "click": _vm.copyURLll
	    }
	  }, [_vm._v(_vm._s(_vm.copied_ll ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))])]), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), (_vm.leadloversSet) ? _c('button', {
	    staticClass: "pull-right btn btn-danger",
	    on: {
	      "click": _vm.removeLeadlovers
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.saveLeadlovers
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])])]), _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(8), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.cv')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.cv')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [_c('button', {
	    staticClass: "btn btn-clean btn-config",
	    on: {
	      "click": function($event) {
	        return _vm.toIntegration('cv_crm')
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))])])])])])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(981)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    staticClass: "crm-icon",
	    attrs: {
	      "src": "/static/images/crm.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/pipedrive.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/nectarcrm.jpg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/salesforce.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/rdstationcrm.png"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "sharpspring-box"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/sharpspring.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "sharpspring-box"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/leadlovers.svg"
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "cv-box"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/cv_crm.webp"
	    }
	  })])])
	}]}

/***/ }),
/* 1140 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row list-item clickable",
	    on: {
	      "click": _vm.viewContact
	    }
	  }, [_c('div', {
	    staticClass: "table-col table-col-120 title"
	  }, [_c('div', {
	    staticClass: "name overflow-ellipsis"
	  }, [(_vm.voipCall.contact.deleted_by_user_at) ? _c('span', {
	    staticClass: "deleted-icon glyphicon glyphicon-remove"
	  }) : _vm._e(), _vm._v(_vm._s(_vm.voipCall.contact.full_name))])]), _c('div', {
	    staticClass: "table-col table-col-120"
	  }, [_c('div', {
	    staticClass: "name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.voipCall.business.name))])]), _c('div', {
	    staticClass: "table-col date"
	  }, [_vm._v(_vm._s(_vm.created_at))]), _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm.bill_duration))])]), _c('div', {
	    staticClass: "table-col type"
	  }, [_vm._v(_vm._s(_vm.type))]), _c('div', {
	    staticClass: "table-col table-col-30"
	  }, [_c('user-miniature', {
	    attrs: {
	      "user": _vm.voipCall.user,
	      "options": {
	        only_picture: true
	      }
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flows-send-at-picker-wrapper",
	    on: {
	      "change": _vm.revalidate
	    }
	  }, [(_vm.allow_send_at_immediately) ? _c('div', {
	    staticClass: "send-at-kind-wrapper"
	  }, [(!_vm.flow.canEditActions()) ? _c('div', {
	    staticClass: "form-group"
	  }, [(_vm.delay_after_previous_step_amount && _vm.delay_after_previous_step_unit) ? _c('span', [_vm._v(_vm._s(_vm.$t('flows.options.timming.after')))]) : (_vm.action.immediately) ? _c('span', [_vm._v(_vm._s(_vm.$t('flows.options.timming.immediately')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('flows.options.timming.today')))])]) : _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('dropdown-select', {
	    staticClass: "field send-at-kind",
	    attrs: {
	      "options": _vm.send_at_kind_options
	    },
	    model: {
	      value: (_vm.send_at_kind),
	      callback: function($$v) {
	        _vm.send_at_kind = $$v
	      },
	      expression: "send_at_kind"
	    }
	  })], 1)]) : _c('div', {
	    staticClass: "send-at-kind-wrapper"
	  }, [_c('div', {
	    staticClass: "spacer-5"
	  }), _vm._v(_vm._s(_vm.$t('flows.options.timming.after')))]), (_vm.send_at_kind == "after") ? _c('div', {
	    staticClass: "delay-inputs-wrapper form-inline"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('delay_after_previous_step_amount')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.delay_after_previous_step_amount),
	      expression: "delay_after_previous_step_amount"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|between:0,300'),
	      expression: "'required|between:0,300'"
	    }],
	    staticClass: "form-control delay-after-previous-step-amount text-center",
	    attrs: {
	      "type": "text",
	      "name": "delay_after_previous_step_amount",
	      "disabled": _vm.flow.isWithError()
	    },
	    domProps: {
	      "value": (_vm.delay_after_previous_step_amount)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.delay_after_previous_step_amount = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('delay_after_previous_step_unit')
	    }
	  }, [_c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "field delay-after-previous-step-unit",
	    attrs: {
	      "name": "delay_after_previous_step_unit",
	      "options": _vm.delay_after_previous_step_unit_options,
	      "disabled": _vm.flow.isWithError()
	    },
	    model: {
	      value: (_vm.delay_after_previous_step_unit),
	      callback: function($$v) {
	        _vm.delay_after_previous_step_unit = $$v
	      },
	      expression: "delay_after_previous_step_unit"
	    }
	  })], 1), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.allow_send_at_immediately),
	      expression: "!allow_send_at_immediately"
	    }],
	    staticClass: "delay-legend"
	  }, [_vm._v(_vm._s(_vm.$t('flows.text.fromPreviousAction')))])]) : _vm._e(), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.send_at_kind == "after"),
	      expression: "send_at_kind == \"after\""
	    }],
	    staticClass: "delay-send-at-divider"
	  }, [_vm._v(_vm._s(_vm.$t('general.label.generalAt')))]), (_vm.show_send_at_field) ? _c('div', {
	    staticClass: "send-at-wrapper"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('send_at')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ("##:##"),
	      expression: "\"##:##\""
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: (_vm.send_at_validations),
	      expression: "send_at_validations"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.send_at),
	      expression: "send_at"
	    }],
	    staticClass: "form-control send-at",
	    attrs: {
	      "type": "text",
	      "name": "send_at",
	      "placeholder": "HH:MM",
	      "disabled": _vm.flow.isWithError()
	    },
	    domProps: {
	      "value": (_vm.send_at)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.send_at = $event.target.value
	      }
	    }
	  })])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.clicked.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "select-button",
	    class: _vm.select_button_class
	  }), _c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "quota_exceeded"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _vm._m(1), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Cancelar")]), _c('div', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.removeQuotaExceeded
	    }
	  }, [_vm._v("Sim, desbloquear")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "titleized"
	  }, [_vm._v("Envio de e-mails bloqueado")]), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-body"
	  }, [_c('span', {
	    staticClass: "quota-exceeded"
	  }, [_vm._v("Deseja retirar o bloqueio de envio de e-mails da sua conta?")])])
	}]}

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal fade",
	    attrs: {
	      "id": _vm.element_id,
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-create-template",
	    attrs: {
	      "role": "document"
	    }
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._m(0), _c('h4', {
	    staticClass: "modal-title"
	  }, [_vm._v(_vm._s(_vm.element_options.title))]), _c('span', {
	    staticClass: "modal-subtitle"
	  }, [_vm._v(_vm._s(_vm.element_options.subtitle))])]), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('template-form', {
	    ref: "template_form",
	    staticClass: "internal-scroller",
	    attrs: {
	      "id": _vm.form_id,
	      "options": _vm.form_options,
	      "template": _vm.template_or_default,
	      "default_template_kind": _vm.template_kind
	    },
	    on: {
	      "validation-success": _vm.saveTemplate
	    }
	  })], 1), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('a', {
	    staticClass: "btn btn-gray",
	    on: {
	      "click": _vm.cancel
	    }
	  }, [_vm._v("Voltar")]), (_vm.element_options.delete_button) ? _c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": _vm.destroy
	    }
	  }, [_vm._v("Excluir")]) : _vm._e(), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": _vm.element_options.disable_buttons
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('contact-list', {
	    attrs: {
	      "contacts": _vm.contacts,
	      "view_mode": _vm.contactListViewModes().single_picker
	    },
	    on: {
	      "filter": _vm.filter,
	      "contact-selected": _vm.bubbleUp,
	      "scroll-ended": function($event) {
	        return _vm.loadContacts()
	      }
	    }
	  }), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_vm._v("SELECIONE O CONTATO"), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	}]}

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "loader-wrapper"
	  }, [_c('div', {
	    staticClass: "loader"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.loading) ? _c('div', {
	    staticClass: "loading loading-spacer",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  })], 1) : _c('div', {
	    staticClass: "statistic-cards"
	  }, [_c('div', {
	    staticClass: "date-flag"
	  }, [_vm._v("Hoje")]), _c('div', {
	    staticClass: "card calls"
	  }, [_c('span', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.calls_task || 0))]), _c('span', {
	    staticClass: "card-label"
	  }, [_vm._v("Ligações")]), _c('div', {
	    staticClass: "separation-line"
	  })]), _c('div', {
	    staticClass: "card emails"
	  }, [_c('span', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.email_task || 0))]), _c('span', {
	    staticClass: "card-label"
	  }, [_vm._v("e-mails")]), _c('div', {
	    staticClass: "separation-line"
	  })]), _c('div', {
	    staticClass: "card linkedin"
	  }, [_c('span', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.linkedin_task || 0))]), _vm._m(0), _c('div', {
	    staticClass: "separation-line"
	  })]), _c('div', {
	    staticClass: "card social"
	  }, [_c('span', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.social_task || 0))]), _vm._m(1), _c('div', {
	    staticClass: "separation-line"
	  })])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "card-label"
	  }, [_vm._v("Contatos "), _c('br'), _vm._v(" via LinkedIn")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "card-label"
	  }, [_vm._v("Contatos "), _c('br'), _vm._v(" via Social")])
	}]}

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "properties-matching"
	    }
	  }, [_c('div', {
	    staticClass: "row no-padding-bottom"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    staticClass: "component-name"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.title.properties_matching')))]), _c('a', {
	    staticClass: "collapse-button",
	    class: {
	      'bloqued': _vm.api_fields.length == 0
	    },
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#multiCollapse1",
	      "aria-expanded": "false",
	      "aria-controls": "multiCollapse1"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.actions.view.properties_matching'))), _c('span', {
	    staticClass: "gray-bold-caret"
	  })]), _c('hr')])]), _c('div', {
	    staticClass: "collapse multi-collapse",
	    attrs: {
	      "id": "multiCollapse1"
	    }
	  }, [_c('div', [_c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.properties_matching.dragOrCreate')))]), _c('br'), _c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.properties_matching.fieldsFilled')))])]), _c('div', {
	    staticClass: "row"
	  }), (_vm.matching_deal.length > 0) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.attributes.contactProperties')))])])])]) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._m(0), _c('draggable', {
	    attrs: {
	      "value": _vm.matching,
	      "options": _vm.draggable_options,
	      "move": _vm.onMove,
	      "tag": "ul"
	    },
	    on: {
	      "input": _vm.matchingUpdated,
	      "change": _vm.matchingChanged
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "matching"
	    }
	  }, _vm._l((_vm.matching_person), function(field, idx) {
	    return _c('div', {
	      key: field.integration,
	      staticClass: "form-group item"
	    }, [(field.reev) ? _c('div', {
	      staticClass: "box-matching"
	    }, [_c('input', {
	      staticClass: "form-control draggable removable",
	      class: field.type,
	      attrs: {
	        "type": "text",
	        "disabled": "disabled",
	        "placeholder": field.reev_name
	      }
	    }), _c('span', {
	      staticClass: "remove-icon",
	      on: {
	        "click": function($event) {
	          return _vm.removeField(field, idx)
	        }
	      }
	    }, [_vm._v("x")])]) : _c('div', {
	      staticClass: "box-no"
	    }, [_c('v-autocomplete', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.onClickaway),
	        expression: "onClickaway"
	      }],
	      staticClass: "box-no-matching no-border",
	      attrs: {
	        "items": _vm.reev_fields,
	        "get-label": _vm.getLabel,
	        "component-item": _vm.template,
	        "input-attrs": _vm.attrs,
	        "auto-select-one-item": false,
	        "min-len": 0
	      },
	      on: {
	        "update-items": _vm.updateAutocomplete,
	        "input": _vm.updateProperty
	      },
	      model: {
	        value: (_vm.filter[field.integration]),
	        callback: function($$v) {
	          _vm.$set(_vm.filter, field.integration, $$v)
	        },
	        expression: "filter[field.integration]"
	      }
	    }), (!_vm.current_user.isSeller()) ? _c('span', {
	      staticClass: "icon",
	      on: {
	        "click": _vm.openModal
	      }
	    }, [_vm._v("+")]) : _vm._e()], 1)])
	  }), 0)], 1)], 1), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.integration_name))])]), _vm._l((_vm.api_fields_person), function(field) {
	    return _c('div', {
	      staticClass: "form-group"
	    }, [_c('input', {
	      staticClass: "form-control",
	      class: _vm.api_field_class(field),
	      attrs: {
	        "type": "text",
	        "disabled": "disabled",
	        "placeholder": field.name
	      }
	    })])
	  })], 2)]), (_vm.matching_deal.length > 0) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.attributes.businessProperties')))])])])]) : _vm._e(), (_vm.matching_deal.length > 0) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._m(1), _c('draggable', {
	    attrs: {
	      "value": _vm.matching,
	      "options": _vm.draggable_options,
	      "move": _vm.onMove,
	      "tag": "ul"
	    },
	    on: {
	      "input": _vm.matchingUpdated,
	      "change": _vm.matchingChanged
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "matching"
	    }
	  }, _vm._l((_vm.matching_deal), function(field, idx) {
	    return _c('div', {
	      key: field.origin + "-" + field.integration,
	      staticClass: "form-group item"
	    }, [(field.reev) ? _c('div', {
	      staticClass: "box-matching"
	    }, [_c('input', {
	      staticClass: "form-control draggable removable",
	      class: field.type,
	      attrs: {
	        "type": "text",
	        "disabled": "disabled",
	        "placeholder": field.reev_name
	      }
	    }), _c('span', {
	      staticClass: "remove-icon",
	      on: {
	        "click": function($event) {
	          return _vm.removeField(field, idx)
	        }
	      }
	    }, [_vm._v("x")])]) : _c('div', {
	      staticClass: "box-no"
	    }, [_c('v-autocomplete', {
	      directives: [{
	        name: "on-clickaway",
	        rawName: "v-on-clickaway",
	        value: (_vm.onClickaway),
	        expression: "onClickaway"
	      }],
	      staticClass: "box-no-matching no-border",
	      attrs: {
	        "items": _vm.reev_fields,
	        "get-label": _vm.getLabel,
	        "component-item": _vm.template,
	        "input-attrs": _vm.attrs,
	        "auto-select-one-item": false,
	        "min-len": 0
	      },
	      on: {
	        "update-items": _vm.updateAutocomplete,
	        "input": _vm.updateProperty
	      },
	      model: {
	        value: (_vm.filter[field.integration]),
	        callback: function($$v) {
	          _vm.$set(_vm.filter, field.integration, $$v)
	        },
	        expression: "filter[field.integration]"
	      }
	    }), (!_vm.current_user.isSeller()) ? _c('span', {
	      staticClass: "icon",
	      on: {
	        "click": _vm.openModal
	      }
	    }, [_vm._v("+")]) : _vm._e()], 1)])
	  }), 0)], 1)], 1), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.integration_name))])]), _vm._l((_vm.api_fields_deal), function(field) {
	    return _c('div', {
	      staticClass: "form-group"
	    }, [_c('input', {
	      staticClass: "form-control",
	      class: _vm.api_field_class(field),
	      attrs: {
	        "type": "text",
	        "disabled": "disabled",
	        "placeholder": field.name
	      }
	    })])
	  })], 2)]) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('hr'), _c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.attributes.notMatchedProperties')))])]), _c('draggable', {
	    attrs: {
	      "value": _vm.reev_fields,
	      "options": _vm.draggable_options,
	      "move": _vm.onMove,
	      "tag": "ul"
	    },
	    on: {
	      "input": _vm.reevFieldsUpdated
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "type": "transition",
	      "name": "reev_fields"
	    }
	  }, _vm._l((_vm.reev_fields), function(field) {
	    return (!field.matching) ? _c('div', {
	      key: field.key,
	      staticClass: "form-group item"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (field.value),
	        expression: "field.value"
	      }],
	      staticClass: "form-control draggable",
	      class: field.type,
	      attrs: {
	        "type": "text",
	        "disabled": "disabled",
	        "placeholder": field.name
	      },
	      domProps: {
	        "value": (field.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(field, "value", $event.target.value)
	        }
	      }
	    })]) : _vm._e()
	  }), 0)], 1)], 1)])]), _c('new-custom-fields-modal', {
	    attrs: {
	      "edit_custom_field": _vm.edit_custom_field
	    },
	    on: {
	      "close-create-modal": _vm.closeCreateModal,
	      "custom-field-created": _vm.custom_field_created
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v("Reev")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v("Reev")])])
	}]}

/***/ }),
/* 1149 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "name",
	      "type": "text",
	      "placeholder": "Nova categoria"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1)]), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Adicionar categoria")])]), _c('div', {
	    staticClass: "clear"
	  }), _c('br')])
	},staticRenderFns: []}

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "btn btn-lg btn-default"
	  }, [_c('div', {
	    staticClass: "select-button",
	    class: _vm.select_button_class,
	    on: {
	      "click": _vm.selection
	    }
	  })]), _c('div', {
	    staticClass: "dropdown pull-left"
	  }, [_c('div', {
	    staticClass: "btn btn-lg btn-default dropdown-toggle",
	    attrs: {
	      "id": "change-responsible",
	      "data-toggle": "dropdown",
	      "disabled": _vm.disabled_buttons
	    }
	  }, [_c('img', {
	    staticClass: "change-responsible",
	    attrs: {
	      "src": __webpack_require__(990)
	    }
	  }), _c('img', {
	    staticClass: "arrow-down",
	    attrs: {
	      "src": __webpack_require__(248)
	    }
	  })]), (!_vm.disabled_buttons) ? _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', {
	    staticClass: "dropdown-header"
	  }, [_vm._v("Alterar responsável para:")]), _vm._l((_vm.users_options), function(user) {
	    return (_vm.showUserOption(user)) ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.userSelected(user)
	        }
	      }
	    }, [_vm._v(_vm._s(user.firstAndLastName()))])]) : _vm._e()
	  })], 2) : _vm._e()]), _c('div', {
	    staticClass: "dropdown pull-left",
	    attrs: {
	      "id": "changeTags"
	    }
	  }, [_c('button', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.closeShowChangeTags),
	      expression: "closeShowChangeTags"
	    }],
	    staticClass: "btn btn-lg btn-default dropdown-toggle",
	    attrs: {
	      "disabled": _vm.disabled_buttons
	    },
	    on: {
	      "click": _vm.toogleShowChangeTags
	    }
	  }, [_c('img', {
	    staticClass: "change-tags",
	    attrs: {
	      "src": __webpack_require__(977)
	    }
	  }), _c('img', {
	    staticClass: "arrow-down",
	    attrs: {
	      "src": __webpack_require__(248)
	    }
	  })]), _c('div', {
	    staticClass: "ul dropdown-menu",
	    style: (_vm.toogle_tag_display_menu),
	    attrs: {
	      "id": "tag-menu"
	    }
	  }, [_c('li', {
	    staticClass: "dropdown-header"
	  }, [_vm._v("Inserir tag:")]), _c('li', [(_vm.show_change_tags) ? _c('tags-autocomplete', {
	    attrs: {
	      "show_change_tags": _vm.show_change_tags,
	      "selected_ids": _vm.selected_ids,
	      "unselected_ids": _vm.unselected_ids,
	      "filters": _vm.filters,
	      "tag_created": _vm.tag_created
	    }
	  }) : _vm._e()], 1)])]), _c('div', {
	    staticClass: "btn btn-lg btn-default",
	    staticStyle: {
	      "margin-left": "5px"
	    },
	    attrs: {
	      "disabled": _vm.disabled_buttons
	    },
	    on: {
	      "click": _vm.openDestroyContactsConfirmationModal
	    }
	  }, [_c('img', {
	    staticClass: "trash",
	    attrs: {
	      "src": __webpack_require__(975)
	    }
	  })]), _c('div', {
	    staticClass: "pull-right message-selection"
	  }, [(!_vm.selected_all && _vm.count_selected_contacts > 0) ? _c('p', [(_vm.count_selected_contacts > 1) ? _c('span', [_vm._v("Os "), _c('b', [_vm._v(_vm._s(_vm.count_selected_contacts))]), _vm._v(" leads listados nessa página já estão selecionados.")]) : _c('span', [_vm._v("O lead listado nessa página já está selecionado.")]), (_vm.count_all_contacts != _vm.count_page_contacts) ? _c('a', {
	    staticClass: "link",
	    on: {
	      "click": _vm.toggleSelectAll
	    }
	  }, [_vm._v("Selecionar todos os "), _c('b', [_vm._v(_vm._s(_vm.count_all_contacts))]), _vm._v(" leads.")]) : _vm._e()]) : _vm._e(), (_vm.selected_all && _vm.count_selected_contacts > 0) ? _c('p', [_vm._v("Os "), _c('b', [_vm._v(_vm._s(_vm.count_selected_contacts))]), _vm._v(" leads da base estão selecionados."), _c('a', {
	    staticClass: "link",
	    on: {
	      "click": _vm.clearSelected
	    }
	  }, [_vm._v("Limpar seleção")])]) : _vm._e()])]), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1151 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hublespot table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.hubspot')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.hubspot')))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed actions"
	  }, [(_vm.authorized && !_vm.show) ? _c('button', {
	    staticClass: "btn btn-clean btn-nylas",
	    on: {
	      "click": _vm.open
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.configure')))]) : _vm._e(), (!_vm.authorized && !_vm.show) ? _c('button', {
	    staticClass: "btn btn-clean btn-nylas",
	    on: {
	      "click": _vm.connect
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.connect')))]) : _vm._e()])])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show),
	      expression: "show"
	    }],
	    staticClass: "form"
	  }, [_c('button', {
	    staticClass: "close",
	    attrs: {
	      "id": "close-form-button",
	      "type": "button",
	      "aria-label": "close"
	    },
	    on: {
	      "click": _vm.close
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])]), _c('div', {
	    staticClass: "hublespot__carousel"
	  }, [_c('span', {
	    staticClass: "indice"
	  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.title.webhooksCapslock')))])])]), _c('div', {
	    staticClass: "form-group margin-top"
	  }, [_c('div', {
	    staticClass: "form-group margin-top",
	    staticStyle: {
	      "padding-bottom": "20px"
	    }
	  }, [_c('input', {
	    staticClass: "form-control",
	    attrs: {
	      "id": "hs_url",
	      "name": "hs_url",
	      "type": "text",
	      "readonly": _vm.hs_carousel != null
	    },
	    domProps: {
	      "value": _vm.hs_url
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary btn-copy",
	    attrs: {
	      "id": "btn-copy-hs-url"
	    },
	    on: {
	      "click": _vm.copyURLhs
	    }
	  }, [_vm._v(_vm._s(_vm.copied_hs ? _vm.$t('general.actions.copied') : _vm.$t('general.actions.copy')))])]), _c('hr', {
	    staticClass: "lines-div",
	    staticStyle: {
	      "padding-bottom": "20px"
	    }
	  }), _c('span', {
	    staticClass: "indice"
	  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.receiveContactsTitle')))])])]), _c('span', {
	    staticClass: "ind"
	  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.receiveContacts')) + ":")])]), _c('div', {
	    staticClass: "checkbox-inline margin-top",
	    staticStyle: {
	      "display": "flex"
	    }
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.setting.create_webhook = !_vm.setting.create_webhook
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.setting.create_webhook
	    }
	  }), _c('label', {
	    staticClass: "control-label",
	    staticStyle: {
	      "min-width": "465px",
	      "margin-right": "35px",
	      "margin-top": "5px",
	      "margin-bottom": "10px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.addContacts')) + ":")])]), (_vm.checkedCreateWebhook) ? _c('stages-select', {
	    attrs: {
	      "integration": "hubspot_integration",
	      "filter_item_selected_ids": _vm.metadata_lifecycles
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	      },
	      "item-selected-items": _vm.itemSelectedItems
	    }
	  }) : _vm._e()], 1), _c('div', {
	    staticClass: "info info-rd",
	    staticStyle: {
	      "margin-top": "1em"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.smartLeads')))]), _c('span', {
	    staticClass: "indice indice-plus"
	  }, [_c('h6', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.contactsDistributionTitle')))])]), _c('div', {
	    staticClass: "flow-type-toggler-wrapper"
	  }, [_c('div', {
	    staticClass: "toggler-inline flow-type-toggle",
	    on: {
	      "click": function($event) {
	        return _vm.toggleUseCarousel()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.setting.use_carousel
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.use_carousel()))])])]), (_vm.setting.use_carousel == false) ? _c('div', {
	    staticClass: "hublespot__info info"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.eachUser')))]), _c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.eachUserDescription')))])]) : _vm._e()]), (_vm.setting.use_carousel) ? _c('div', {
	    staticClass: "form-group margin-top"
	  }, [_c('div', {
	    staticClass: "hublespot__info info"
	  }, [_c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.carousel')))]), _c('p', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.carouselDescription')))])])]) : _vm._e(), _c('div', {
	    staticClass: "form-group margin-top"
	  }, [(_vm.setting.use_carousel) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-toggle": "modal",
	      "data-target": "#hs-carousel-modal"
	    },
	    on: {
	      "click": _vm.loadHsCarouselData
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.setCarousel')))]) : _vm._e()])]), _c('carousel-modal', {
	    ref: "hs_carousel_modal",
	    attrs: {
	      "id": "hs-carousel-modal",
	      "modal-title": _vm.modalTitle(),
	      "kind": "hs"
	    },
	    on: {
	      "savedCarousel": _vm.fillHsCarousel
	    }
	  }), _c('hr', {
	    staticClass: "lines-div"
	  }), _c('div', {
	    staticClass: "hublespot__funil"
	  }, [(_vm.show_configuration_by_pipeline_name) ? _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "info info-crm"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.configByPipeline')))])])]) : _vm._e(), (_vm.show_configuration_by_pipeline_name) ? _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('pipeline')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "pipeline"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.funnelName')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.setting.pipeline),
	      expression: "setting.pipeline"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "setting.pipeline",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.placeholder.funnelName')
	    },
	    domProps: {
	      "value": (_vm.setting.pipeline)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.setting, "pipeline", $event.target.value)
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group col-md-6",
	    class: {
	      'has-error': _vm.errors.has('stage')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "stage"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.attributes.funnelStage')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.setting.stage),
	      expression: "setting.stage"
	    }, {
	      name: "validate",
	      rawName: "v-validate"
	    }],
	    staticClass: "form-control bcc-input",
	    attrs: {
	      "name": "setting.stage",
	      "type": "text",
	      "placeholder": _vm.$t('integrations.placeholder.funnelStage')
	    },
	    domProps: {
	      "value": (_vm.setting.stage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.setting, "stage", $event.target.value)
	      }
	    }
	  })])]) : _vm._e(), _c('span', {
	    staticClass: "indice"
	  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.sendContactsTitle')))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-7"
	  }, [_c('trigger-stages', {
	    attrs: {
	      "integration": "hubspot",
	      "settings": _vm.setting.triggers
	    },
	    on: {
	      "selected-stages": _vm.setStages
	    }
	  })], 1), _c('div', {
	    staticClass: "col-md-5"
	  }, [(_vm.lost_checked || _vm.stage_lost) ? _c('deal-lost', {
	    attrs: {
	      "settings": _vm.setting.mark_as
	    },
	    on: {
	      "selected": _vm.setMarkAs
	    }
	  }) : _vm._e()], 1)]), _c('hr', {
	    staticClass: "lines-div",
	    staticStyle: {
	      "padding-bottom": "20px"
	    }
	  }), _vm._m(1), _c('div', {
	    staticClass: "hublespot__info info"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.hubspot.syncContacts')))]), _c('properties-matching', {
	    attrs: {
	      "properties_matching": _vm.properties_matching,
	      "integration_name": "HubSpot",
	      "api_fields": _vm.api_fields
	    },
	    on: {
	      "matching-updated": _vm.matchingUpdated
	    }
	  }), _c('stages-matching', {
	    attrs: {
	      "stages_matching": _vm.setting.stages_matching,
	      "integration_name": "hubspot",
	      "integration_stages": _vm.integration_stages,
	      "pipelines": _vm.integration_pipelines,
	      "pipeline_id": _vm.selected_pipeline
	    },
	    on: {
	      "matching-updated": _vm.matchingStagesUpdated,
	      "users-update": _vm.updateUsers,
	      "update-stages": _vm.changePipeline
	    }
	  }), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))]), _c('button', {
	    staticClass: "pull-right btn btn-danger btn-nylas",
	    on: {
	      "click": _vm.disconnect
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))])])])], 1)], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/hubspot.svg"
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "indiceSyc indice"
	  }, [_c('h4', [_c('strong', [_vm._v("Hubspot Sync")])])])
	}]}

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "tag-list"
	    }
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [(_vm.options && _vm.options.top_border) ? _c('hr') : _vm._e(), _vm._l((_vm.tags), function(tag) {
	    return _c('list-item', {
	      key: tag.id,
	      attrs: {
	        "tag": tag,
	        "options": _vm.list_item_options
	      },
	      on: {
	        "updated": _vm.tagUpdated,
	        "destroy": _vm.openDestroyConfirmationModal,
	        "selection-toggle": _vm.tagSelectionToggle
	      }
	    })
	  })], 2)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading && !_vm.tags.length),
	      expression: "!loading && !tags.length"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1), (_vm.list_item_options.can_edit) ? _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-destroy-tag",
	      "title": "Excluir categoria",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroyTag
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Confirma exclusão da tag abaixo?")]), _c('br'), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.selected_tag.name))]), _c('br'), _c('br')])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "companies-index"
	    }
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_vm._v("Empresas")]), _c('router-link', {
	    staticClass: "btn btn-primary pull-right",
	    attrs: {
	      "to": "/configuracoes/empresas/criar"
	    }
	  }, [_c('div', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('companies.actions.create')))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadCompanies),
	      expression: "loadCompanies"
	    }],
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-header table-row"
	  }, [_c('div', {
	    staticClass: "table-col table-col-80"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.name')) + " / " + _vm._s(_vm.$t('companies.attributes.domain')))]), _c('div', {
	    staticClass: "table-col table-col-50"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.email')) + " / " + _vm._s(_vm.$t('companies.attributes.status')))]), _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.usersCount')))]), _c('div', {
	    staticClass: "table-col table-col-50"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.managersCount')))]), _c('div', {
	    staticClass: "table-col table-col-30"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.status')))]), _c('div', {
	    staticClass: "table-col table-col-30"
	  }, [_vm._v(_vm._s(_vm.$t('companies.attributes.voip')))]), _c('div', {
	    staticClass: "table-col table-col-50",
	    attrs: {
	      "title": ((_vm.$t('companies.attributes.usedMinutes')) + "/" + (_vm.$t('companies.attributes.paidMinutes')))
	    }
	  }, [_vm._v(_vm._s(_vm.nameLetters(_vm.$t('companies.attributes.usedMinutes'))) + "/ " + _vm._s(_vm.nameLetters(_vm.$t('companies.attributes.paidMinutes'))))]), _c('div', {
	    staticClass: "table-col table-col-80"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.text_field_filter),
	      expression: "text_field_filter"
	    }],
	    staticClass: "search-field form-control",
	    attrs: {
	      "placeholder": _vm.$t('companies.actions.search'),
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.text_field_filter)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filter.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.text_field_filter = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _vm._l((_vm.companies), function(company) {
	    return _c('list-item', {
	      key: company.id,
	      attrs: {
	        "company": company
	      },
	      on: {
	        "updated": _vm.companyUpdated
	      }
	    })
	  })], 2)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.loading),
	      expression: "!loading"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('general.feedback.noResults')))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.name)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('h1', [_vm._v("Tags")]), _vm._m(0), _c('br'), _c('br'), _c('new-tag', {
	    on: {
	      "created": _vm.tagCreated
	    }
	  }), _c('list', {
	    ref: "list",
	    attrs: {
	      "options": {
	        top_border: true
	      },
	      "list_item_options": _vm.list_item_options
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Crie tags personalizadas por nome e cor para classificar seus contatos. "), _c('br'), _vm._v("As tags estarão disponíveis para todo o time de vendas.")])
	}]}

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notifications-list"
	  }, _vm._l((_vm.notifications), function(notif, index) {
	    return _c('list-item', {
	      attrs: {
	        "notification": notif
	      },
	      on: {
	        "navigate": _vm.bubbleUp
	      }
	    })
	  }), 1)
	},staticRenderFns: []}

/***/ }),
/* 1157 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, [_c('hr'), _c('div', {
	    staticClass: "table-row table-padding"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "table-col title"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('integrations.title.cv')))]), _c('div', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.subtitle.cv')))])])])])]), _c('div', {
	    staticClass: "form"
	  }, [_c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-5",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "email"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.email')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "email",
	      "type": "email",
	      "disabled": _vm.cv_crm_setting.email,
	      "placeholder": _vm.$t('integrations.placeholder.cvCrmEmail')
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    key: "email",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1), _c('div', {
	    staticClass: "form-group col-md-5",
	    class: {
	      'has-error': _vm.errors.has('cv_crm_api_token')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "cv_crm_api_token"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.apiKey')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.cv_crm_api_token),
	      expression: "cv_crm_api_token"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "cv_crm_api_token",
	      "type": "text",
	      "disabled": _vm.current_user.cv_crm_api_token,
	      "placeholder": _vm.$t('integrations.placeholder.apiKey')
	    },
	    domProps: {
	      "value": (_vm.cv_crm_api_token)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.cv_crm_api_token = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('cv_crm_api_token')),
	      expression: "errors.has('cv_crm_api_token')"
	    }],
	    key: "cv_crm_api_token",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('cv_crm_api_token')))])])], 1)]), _c('br'), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "form-group col-md-5",
	    class: {
	      'has-error': _vm.errors.has('domain')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "domain"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.cvCrm.clientDomain')))]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.domain),
	      expression: "domain"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "domain",
	      "type": "text",
	      "disabled": _vm.cv_crm_setting.domain,
	      "placeholder": _vm.$t('integrations.placeholder.cvCrmDomain')
	    },
	    domProps: {
	      "value": (_vm.domain)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.domain = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('domain')),
	      expression: "errors.has('domain')"
	    }],
	    key: "domain",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('domain')))])])], 1), _c('div', {
	    staticClass: "form-group col-md-5"
	  }, [_c('label', {
	    attrs: {
	      "for": "webhook-url"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.label.cvCrm.webhooksUrl')))]), _c('input', {
	    staticClass: "form-control",
	    staticStyle: {
	      "width": "23em"
	    },
	    attrs: {
	      "id": "webhook-url",
	      "name": "webhook-url",
	      "type": "text",
	      "disabled": true
	    },
	    domProps: {
	      "value": _vm.webhook_url
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary pull-right",
	    on: {
	      "click": _vm.copy
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))]), _c('small', [_vm._v(_vm._s(_vm.$t('integrations.label.cvCrm.pasteUrl')))])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "form-group col-md-12"
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    on: {
	      "click": function($event) {
	        return _vm.toggleMarkAddContatsFromCV()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")]), _c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.add_contacts_from_cv_crm
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.label.cvCrm.receiveContactsTitle')))]), _c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8"
	  }, [_c('trigger-stages', {
	    attrs: {
	      "integration": "cv_crm",
	      "settings": _vm.cv_crm_setting.triggers
	    },
	    on: {
	      "selected-stages": _vm.setStagesCvCrm
	    }
	  })], 1)]), _c('stages-matching', {
	    attrs: {
	      "stages_matching": _vm.cv_crm_setting.stages_matching,
	      "integration_name": "cv crm",
	      "integration_stages": _vm.integration_stages,
	      "pipelines": _vm.pipelines,
	      "pipeline_id": _vm.selected_pipeline,
	      "show_ignore_stages": true
	    },
	    on: {
	      "matching-updated": _vm.matchingStagesUpdated,
	      "users-update": _vm.updateUsers
	    }
	  }), _c('hr'), _c('div', {
	    staticClass: "row vertical-aligned"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('br'), (_vm.current_user.cv_crm_api_token) ? _c('button', {
	    staticClass: "pull-right btn btn-danger",
	    staticStyle: {
	      "margin-left": "15px"
	    },
	    on: {
	      "click": _vm.removeCvCrmApiToken
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.disconnect')))]) : _vm._e(), _c('button', {
	    staticClass: "pull-right btn btn-primary",
	    on: {
	      "click": _vm.save
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.save')))])])])], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "cv-box"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/images/cv_crm.webp"
	    }
	  })])])
	}]}

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadTasks),
	      expression: "loadTasks"
	    }],
	    staticClass: "task-list",
	    attrs: {
	      "id": "tasks",
	      "infinite-scroll-distance": "10",
	      "infinite-scroll-disabled": "disable_infinite_scroll",
	      "infinite-scroll-immediate-check": "false"
	    }
	  }, [_vm._l((_vm.sorted_tasks), function(task, index) {
	    return [(task.contact) ? _c('task-item', {
	      key: task.guid,
	      class: _vm.item_class,
	      attrs: {
	        "task": task,
	        "options": _vm.item_options,
	        "type": _vm.options,
	        "origem": _vm.origem,
	        "prop_tooltip_placement": _vm.prop_tooltip_placement
	      },
	      on: {
	        "open-template-modal": _vm.bubbleUp,
	        "toggle-task-bar": _vm.bubbleUp,
	        "task-updated": _vm.taskUpdated
	      }
	    }) : _vm._e()]
	  }), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text",
	    attrs: {
	      "id": "no-more-results"
	    }
	  }, [_vm._v("Sem mais resultados")])], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1159 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.contacts_text))]), _vm._v(" convertido(s) via LeadLovers.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1160 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.contacts_text))]), _vm._v(" convertido(s) via RD Station.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1161 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    staticClass: "overflow-ellipsis",
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  }), _c('span', {
	    staticClass: "eye glyphicon glyphicon-eye-open",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        $event.preventDefault();
	        return _vm.showPreview.apply(null, arguments)
	      }
	    }
	  }), (_vm.show_preview) ? _c('template-preview', {
	    attrs: {
	      "template": _vm.item
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "loader",
	    style: (_vm.style)
	  })
	},staticRenderFns: []}

/***/ }),
/* 1163 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.contacts_text))]), _vm._v(" no Pipedrive.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.template.id == null) ? _c('div', {
	    staticClass: "lable text-center"
	  }, [_vm._v(_vm._s(_vm.$t('template.label.selectTemplate')))]) : _vm._e(), _c('div', {
	    staticClass: "row",
	    class: {
	      'template-modal': _vm.element_options.modal
	    },
	    attrs: {
	      "id": "template-types-menu"
	    }
	  }, [_c('div', {
	    staticClass: "template-type email",
	    class: {
	      active: _vm.template_kind == "email", inactive: _vm.inactive("email")
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeTemplateType("email")
	      }
	    }
	  }), _c('div', {
	    staticClass: "template-type phonecall",
	    class: {
	      active: _vm.template_kind == "phonecall", inactive: _vm.inactive("phonecall")
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeTemplateType("phonecall")
	      }
	    }
	  }), _c('div', {
	    staticClass: "template-type linkedin",
	    class: {
	      active: _vm.template_kind == "linkedin", inactive: _vm.inactive("linkedin")
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeTemplateType("linkedin")
	      }
	    }
	  }), _c('div', {
	    staticClass: "template-type social",
	    class: {
	      active: _vm.template_kind == "social", inactive: _vm.inactive("social")
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeTemplateType("social")
	      }
	    }
	  }), (!_vm.element_options.modal) ? _c('div', {
	    staticClass: "template-type library",
	    class: {
	      active: _vm.template_kind == "library", inactive: _vm.inactive("library")
	    },
	    on: {
	      "click": function($event) {
	        return _vm.changeTemplateType("library")
	      }
	    }
	  }) : _vm._e()]), _c('div', {
	    staticClass: "row form-wrapper",
	    class: [{
	      'template-modal': _vm.element_options.modal
	    }, _vm.template_kind]
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.template_kind == "library"),
	      expression: "template_kind == \"library\""
	    }],
	    staticClass: "col-sm-12"
	  }, [_c('list', {
	    attrs: {
	      "options": _vm.list_options,
	      "list_item_options": _vm.list_item_options,
	      "filter_options": _vm.filter_options
	    },
	    on: {
	      "template-selected": _vm.fillForm
	    }
	  })], 1), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.template_kind != "library"),
	      expression: "template_kind != \"library\""
	    }],
	    class: [{
	      'template-modal-form': _vm.element_options.modal,
	    }, _vm.template_kind],
	    attrs: {
	      "id": _vm.id
	    }
	  }, [_c('transition-group', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.apiErrorMessages.length),
	      expression: "apiErrorMessages.length"
	    }],
	    attrs: {
	      "name": "fade"
	    }
	  }, _vm._l((_vm.apiErrorMessages), function(errorMessage) {
	    return _c('div', {
	      staticClass: "error-message"
	    }, [_vm._v(_vm._s(errorMessage))])
	  }), 0), (_vm.show_responsible_dropdown) ? _c('div', {
	    staticClass: "wrap"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [(_vm.element_options.name != 'hide') ? _c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.nameLabel()))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.template.name),
	      expression: "template.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "name",
	      "type": "text",
	      "disabled": _vm.element_options.name == 'disabled'
	    },
	    domProps: {
	      "value": (_vm.template.name)
	    },
	    on: {
	      "change": _vm.setDirty,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.template, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1)]) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [(_vm.element_options.category != 'hide') ? _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('template_category_id')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "template_category_id"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.category')))]), _c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "field",
	    attrs: {
	      "options": _vm.template_category_options,
	      "selected": _vm.template.template_category_id,
	      "data-vv-name": "template_category_id",
	      "disabled": _vm.element_options.category == 'disabled'
	    },
	    on: {
	      "input": _vm.setDirty
	    },
	    model: {
	      value: (_vm.template.template_category_id),
	      callback: function($$v) {
	        _vm.$set(_vm.template, "template_category_id", $$v)
	      },
	      expression: "template.template_category_id"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('template_category_id')),
	      expression: "errors.has('template_category_id')"
	    }],
	    key: "template_category_id",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('template_category_id')))])])], 1)]) : _vm._e(), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "user_id"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.attribute.user')))]), _c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "field",
	    attrs: {
	      "options": _vm.template_user_options,
	      "selected": _vm.template.user_id,
	      "data-vv-name": "template_user_id",
	      "disabled": _vm.element_options.responsible == "disabled"
	    },
	    on: {
	      "change": _vm.setDirty
	    },
	    model: {
	      value: (_vm.template.user_id),
	      callback: function($$v) {
	        _vm.$set(_vm.template, "user_id", $$v)
	      },
	      expression: "template.user_id"
	    }
	  })], 1)])])]) : _c('div', {
	    staticClass: "row"
	  }, [(_vm.element_options.name != 'hide') ? _c('div', {
	    class: {
	      'col-md-12': _vm.template_kind == 'linkedin', 'col-md-6': _vm.template_kind != 'linkedin'
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.nameLabel()))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.template.name),
	      expression: "template.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "name",
	      "type": "text",
	      "disabled": _vm.element_options.name == 'disabled'
	    },
	    domProps: {
	      "value": (_vm.template.name)
	    },
	    on: {
	      "change": _vm.setDirty,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.template, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('name')),
	      expression: "errors.has('name')"
	    }],
	    key: "name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('name')))])])], 1)]) : _vm._e(), (_vm.element_options.category != 'hide') ? _c('div', {
	    class: {
	      'col-md-12': _vm.template_kind == 'linkedin', 'col-md-6': _vm.template_kind != 'linkedin'
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('template_category_id')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "template_category_id"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.category')))]), _c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "options": _vm.template_category_options,
	      "selected": _vm.template.template_category_id,
	      "data-vv-name": "template_category_id",
	      "disabled": _vm.element_options.category == 'disabled'
	    },
	    on: {
	      "input": _vm.setDirty
	    },
	    model: {
	      value: (_vm.template.template_category_id),
	      callback: function($$v) {
	        _vm.$set(_vm.template, "template_category_id", $$v)
	      },
	      expression: "template.template_category_id"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('template_category_id')),
	      expression: "errors.has('template_category_id')"
	    }],
	    key: "template_category_id",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('template_category_id')))])])], 1)]) : _vm._e()]), (_vm.template_kind == 'email') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: _vm.subject_group_class
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "subject"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.subject')))]), _c('variables-dropdown', {
	    attrs: {
	      "variables": _vm.variables
	    },
	    on: {
	      "add-variable": _vm.addVariableToSubject
	    }
	  }), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.template.subject),
	      expression: "template.subject"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "subject",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.template.subject)
	    },
	    on: {
	      "blur": _vm.updateLastSubjectCursorPosition,
	      "change": _vm.setDirty,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.template, "subject", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.subject_help_text),
	      expression: "subject_help_text"
	    }],
	    key: "subject",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.subject_help_text))])])], 1)])]) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('body')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "body"
	    }
	  }, [_vm._v(_vm._s(_vm.contentLabel()))]), _c('variables-dropdown', {
	    attrs: {
	      "variables": _vm.variables
	    },
	    on: {
	      "add-variable": _vm.addVariableToBody
	    },
	    nativeOn: {
	      "mousedown": function($event) {
	        $event.preventDefault();
	        return _vm.saveSummernoteRange.apply(null, arguments)
	      }
	    }
	  }), _c('textarea', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "body",
	    attrs: {
	      "name": "body"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('body')),
	      expression: "errors.has('body')"
	    }],
	    key: "body",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('body')))])])], 1)])]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.template_kind == 'email'),
	      expression: "template_kind == 'email'"
	    }],
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('signature')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "signature"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.emailSignature')))]), _c('textarea', {
	    staticClass: "signature",
	    attrs: {
	      "name": "signature"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('signature')),
	      expression: "errors.has('signature')"
	    }],
	    key: "signature",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('signature')))])])], 1)])])], 1), (_vm.element_options.show_footer) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-12"
	  }, [(_vm.template_kind != "library") ? _c('div', {
	    staticClass: "wrapper-buttons text-center"
	  }, [_c('router-link', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "to": "/templates"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": _vm.disabledBnt || _vm.current_user.isMonitoringManager()
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.template.id ? _vm.$t('general.actions.saveWithLabel', {
	    label: _vm.buttonLabel()
	  }) : _vm.$t('general.actions.createWithLabel', {
	    label: _vm.buttonLabel()
	  })))])], 1) : _vm._e()])]) : _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "clearfix"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row clickable"
	  }, [(_vm.editing) ? [_c('div', {
	    staticClass: "table-col table-col-200"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('name')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.name),
	      expression: "name"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.name = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "table-col table-col-100"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")])])] : [_c('div', {
	    staticClass: "table-col table-col-200"
	  }, [_vm._v(_vm._s(_vm.template_category.name))])], _c('div', {
	    staticClass: "table-col"
	  }, [_c('div', {
	    staticClass: "pull-right"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    on: {
	      "click": function($event) {
	        _vm.editing = !_vm.editing
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.editing ? 'Cancelar' : 'Editar'))])])]), _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": _vm.destroyTemplateCategory
	    }
	  }, [_vm._v("Excluir")])])], 2)
	},staticRenderFns: []}

/***/ }),
/* 1166 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "wrapper-content"
	  }, [_c('header', {
	    staticClass: "content-header"
	  }, [_c('router-link', {
	    staticClass: "back-link-spaced",
	    attrs: {
	      "to": "/contatos/leads"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('contacts_group.title.index')))])], 1), _c('contacts-picker-text-csv', {
	    attrs: {
	      "has_groups": _vm.has_groups
	    }
	  }), _c('router-link', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "type": "reset",
	      "to": "/contatos/leads"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('button', {
	    staticClass: "btn btn-primary save",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts.actions.add')))]), (_vm.has_groups) ? _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-create-groups",
	      "title": _vm.$t('general.actions.confirm_actions'),
	      "confirm_text": _vm.$t('general.actions.conclude'),
	      "confirm_class": "btn-primary"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.confirmGroups
	    }
	  }, [_c('div', {
	    staticClass: "confirm-message"
	  }, [_vm._v(_vm._s(_vm.$t('contacts_group.label.importConfirmMessage')) + " ")]), _c('contact-groups-list', {
	    attrs: {
	      "contact_groups": _vm.contact_groups,
	      "view_mode": _vm.contactGroupListViewModes().import,
	      "all_initially_selected": true
	    },
	    on: {
	      "group-selected": _vm.handleGroupSelect
	    }
	  })], 1) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1167 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickaway),
	      expression: "onClickaway"
	    }],
	    staticClass: "dropdown"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selected),
	      expression: "selected"
	    }],
	    staticClass: "item",
	    on: {
	      "click": function($event) {
	        return _vm.clicked()
	      },
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.list), function(item) {
	    return _c('option', {
	      staticClass: "item",
	      domProps: {
	        "value": item
	      }
	    }, [_c('div', {
	      staticClass: "name-stage"
	    }, [_vm._v(_vm._s(item))])])
	  }), 0)])
	},staticRenderFns: []}

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "template-show"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._v(_vm._s(_vm.$t('template.label.preShow')) + ":"), _c('span', {
	    staticClass: "name"
	  }, [_vm._v(" " + _vm._s(_vm.template.name))]), _vm._m(0)]), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.template.kind == 'email') ? [_c('div', {
	    staticClass: "subject-legend"
	  }, [_vm._v(_vm._s(_vm.$t('template.attributes.subject')) + ":")]), _c('div', {
	    staticClass: "subject"
	  }, [_vm._v(_vm._s(_vm.template.subject))])] : _vm._e(), _c('div', {
	    staticClass: "body-legend"
	  }, [_vm._v(_vm._s(_vm.template.contentLabel()) + ":")]), _c('div', {
	    staticClass: "body email-body"
	  }, [_c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.template.body)
	    }
	  }), (_vm.template.kind == 'email') ? _c('div', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.template.signature || _vm.current_user.signature)
	    }
	  }) : _vm._e()])], 2), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.close')))]), (_vm.current_user.can_manage_templates) ? _c('router-link', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-dismiss": "modal",
	      "to": _vm.editPath
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.actions.edit')))]) : _vm._e()], 1)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "steps flex-container"
	  }, [_c('div', {
	    staticClass: "step-text"
	  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
	    staticClass: "step-bar"
	  }, [_c('div', {
	    staticClass: "step",
	    class: _vm.status_initial
	  }, [_c('div', {
	    staticClass: "hidden-bar",
	    style: ({
	      width: _vm.percentage(_vm.upload_progress)
	    })
	  }), _c('label', {
	    style: ({
	      left: '-' + _vm.steps_labels[0].length + '%'
	    })
	  }, [_vm._v(_vm._s(_vm.steps_labels[0]))])]), _c('div', {
	    staticClass: "step",
	    class: _vm.status_validation
	  }, [_c('div', {
	    staticClass: "hidden-bar",
	    style: ({
	      width: _vm.percentage(_vm.validation_progress)
	    })
	  }), _c('label', {
	    style: ({
	      left: '-' + _vm.steps_labels[1].length + '%'
	    })
	  }, [_vm._v(_vm._s(_vm.steps_labels[1]))])]), _c('div', {
	    staticClass: "step",
	    class: _vm.status_organization
	  }, [_c('div', {
	    staticClass: "hidden-bar",
	    style: ({
	      width: _vm.percentage(_vm.creation_progress)
	    })
	  }), _c('label', {
	    style: ({
	      left: '-' + _vm.steps_labels[2].length + '%'
	    })
	  }, [_vm._v(_vm._s(_vm.steps_labels[2]))])]), _c('div', {
	    staticClass: "step",
	    class: _vm.status_send_to_base
	  }, [_c('label', {
	    style: ({
	      left: '-' + _vm.steps_labels[3].length + '%'
	    })
	  }, [_vm._v(_vm._s(_vm.steps_labels[3]))])])]), _c('div', {
	    staticClass: "step-status"
	  }, [_vm._v("Passo 0" + _vm._s(_vm.current_step) + " de 0" + _vm._s(_vm.steps.length))])])
	},staticRenderFns: []}

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickaway),
	      expression: "onClickaway"
	    }],
	    staticClass: "autocomplete-template-wrapper"
	  }, [_c('div', {
	    staticClass: "category-templates-dropdown clickable",
	    on: {
	      "click": _vm.toggleCategories
	    }
	  }, [_vm._v(_vm._s(_vm.label_category))]), (_vm.show_categories) ? _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.hideCategories),
	      expression: "hideCategories"
	    }],
	    staticClass: "category-template-items"
	  }, [_vm._l((_vm.categories), function(category) {
	    return _c('div', {
	      staticClass: "category-item",
	      on: {
	        "click": function($event) {
	          return _vm.selectCategory(category)
	        }
	      }
	    }, [_vm._v(_vm._s(category.name))])
	  }), (_vm.category_selected) ? _c('div', {
	    staticClass: "category-item",
	    on: {
	      "click": function($event) {
	        return _vm.selectCategory(null)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.$t('template.label.allCategories')))]) : _vm._e()], 2) : _vm._e(), _c('v-autocomplete', {
	    attrs: {
	      "id": _vm.id,
	      "min-len": 0,
	      "items": _vm.templates,
	      "get-label": _vm.getLabel,
	      "component-item": _vm.item_template,
	      "input-attrs": _vm.attrs,
	      "keep-open": _vm.keep_items_open,
	      "auto-select-one-item": false
	    },
	    on: {
	      "update-items": _vm.searchTemplates,
	      "item-selected": _vm.addTemplate
	    },
	    model: {
	      value: (_vm.template),
	      callback: function($$v) {
	        _vm.template = $$v
	      },
	      expression: "template"
	    }
	  }), (_vm.show_not_result_without_modal) ? _c('div', {
	    staticClass: "no-result-found"
	  }, [_vm._v(_vm._s(_vm.$t('flows.feedback.noResults')))]) : _vm._e(), (_vm.show_not_result_with_modal) ? _c('div', {
	    staticClass: "no-result-found",
	    on: {
	      "click": _vm.openCreateTemplateModal
	    }
	  }, [_c('span', [_vm._v(_vm._s(_vm.input_text))]), _c('span', {
	    staticClass: "create",
	    staticStyle: {
	      "margin-left": "30px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.create')))])]) : _vm._e(), (_vm.input_text || _vm.template) ? _c('span', {
	    staticClass: "clear-form glyphicon glyphicon-remove",
	    on: {
	      "click": function($event) {
	        return _vm.clearTemplate(true)
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1171 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.flowsEmpty()) ? _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadFlows),
	      expression: "loadFlows"
	    }],
	    staticClass: "table",
	    attrs: {
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('div', {
	    staticClass: "table-actions light-gray"
	  }, [_c('filters', {
	    attrs: {
	      "filters": _vm.filters,
	      "options": _vm.filter_options
	    },
	    on: {
	      "filter": _vm.filter
	    }
	  })], 1), _c('div', {
	    staticClass: "table-body",
	    attrs: {
	      "id": "flows-list"
	    }
	  }, _vm._l((_vm.flows), function(flow) {
	    return _c('flow-list-item', {
	      key: flow.id,
	      attrs: {
	        "flow": flow,
	        "options": _vm.list_item_options
	      },
	      on: {
	        "flow-update": _vm.updateFlow,
	        "flow-confirm-destroy": _vm.openDestroyFlowConfirmationModal
	      }
	    })
	  }), 1), _c('br'), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('flows.feedback.noDataText')))])], 1), _c('confirm-modal', {
	    attrs: {
	      "id": "destroy-flow-confirmation-modal",
	      "title": _vm.$t('flows.label.removeCadenceFlowConfirm'),
	      "message": _vm.destroy_confirm_modal_message,
	      "confirm_text": _vm.$t('general.label.yes'),
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroyFlow
	    }
	  }), _c('go-to-top')], 1) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 1172 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "table-row user-list-item clickable"
	  }, [(_vm.showCheckbox) ? _c('div', {
	    staticClass: "table-col table-col-collapsed",
	    class: {
	      'table-modal-rd': _vm.listCarousel
	    }
	  }, [_c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item",
	    on: {
	      "click": function($event) {
	        return _vm.checkboxSelectUser(_vm.user)
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.selected),
	      expression: "user.selected"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": _vm.user_index
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.user.selected) ? _vm._i(_vm.user.selected, null) > -1 : (_vm.user.selected)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.user.selected,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.$set(_vm.user, "selected", $$a.concat([$$v])))
	          } else {
	            $$i > -1 && (_vm.$set(_vm.user, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
	          }
	        } else {
	          _vm.$set(_vm.user, "selected", $$c)
	        }
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": _vm.user_index
	    }
	  }, [_vm._v(" ")])])]) : _vm._e(), _c('div', {
	    staticClass: "table-col table-col-150",
	    class: {
	      'table-modal-rd': _vm.listCarousel
	    }
	  }, [_c('div', {
	    staticClass: "identity"
	  }, [_c('div', {
	    staticClass: "name"
	  }, [_vm._v(_vm._s(_vm.user.custom_field_value))])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1173 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-actions"
	  }, [_c('filters', {
	    attrs: {
	      "filters": _vm.filters
	    },
	    on: {
	      "filter": _vm.filter
	    }
	  })], 1), _c('div', {
	    staticClass: "table-header table-row"
	  }, [_c('div', {
	    staticClass: "table-col table-col-80"
	  }, [_c('span', {
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.name')))])]), _c('div', {
	    staticClass: "table-col table-col-80"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.address')))]), _c('div', {
	    staticClass: "table-col table-col-60"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.status')))]), _c('div', {
	    staticClass: "table-col table-col-60"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.stage')))]), _c('div', {
	    staticClass: "table-col table-col-120"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.tags')))]), _c('div', {
	    staticClass: "table-col table-col-120"
	  }, [_vm._v(_vm._s(_vm.$t('businesses.attributes.contacts')))]), _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  })]), _c('div', {
	    staticClass: "table-body"
	  }, _vm._l((_vm.businesses), function(business, business_id) {
	    return _c('business-list-item', {
	      attrs: {
	        "business": business
	      },
	      on: {
	        "business-destroy": _vm.openDestroyBusinessModal
	      }
	    })
	  }), 1), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-remove-business",
	      "title": _vm.$t('businesses.label.removeCompany'),
	      "confirm_text": _vm.$t('general.actions.delete'),
	      "message": _vm.$t('businesses.label.removeCompany', {
	        name: _vm.selected_business.name
	      }),
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.callDestroyBusiness
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1174 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('title') || _vm.existing_title
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "title",
	      "type": "text",
	      "placeholder": "Novo motivo de perda"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('title')),
	      expression: "errors.has('title')"
	    }],
	    key: "title",
	    staticClass: "help-block"
	  }, [_vm._v("Favor preencher o campo acima")]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.existing_title),
	      expression: "existing_title"
	    }],
	    key: "existing_title",
	    staticClass: "help-block"
	  }, [_vm._v("O motivo de perda já existe")])])], 1)]), _c('div', {
	    staticClass: "col-sm-3"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Adicionar categoria")])]), _c('div', {
	    staticClass: "clear"
	  }), _c('br')])
	},staticRenderFns: []}

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "contact-form"
	    }
	  }, [_c('div', {
	    staticClass: "form-wrapper",
	    on: {
	      "change": _vm.setDirty,
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit.apply(null, arguments)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('first_name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "first_name"
	    }
	  }, [_vm._v("Nome")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.first_name),
	      expression: "contact.first_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-first-name",
	      "name": "first_name",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.first_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "first_name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('first_name')),
	      expression: "errors.has('first_name')"
	    }],
	    key: "first_name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('first_name')))])])], 1)]), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('last_name')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "last_name"
	    }
	  }, [_vm._v("Sobrenome")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.last_name),
	      expression: "contact.last_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-last-name",
	      "name": "last_name",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.last_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "last_name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('last_name')),
	      expression: "errors.has('last_name')"
	    }],
	    key: "last_name",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('last_name')))])])], 1)])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("URL")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.url),
	      expression: "contact.url"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-url",
	      "name": "url",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.url)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "url", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("LinkedIn")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.linkedin),
	      expression: "contact.linkedin"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "linkedin",
	      "name": "linkedin",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.linkedin)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "linkedin", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: _vm.business_class
	  }, [_c('label', {
	    attrs: {
	      "for": "business"
	    }
	  }, [_vm._v("Empresa")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.business.name),
	      expression: "contact.business.name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-business",
	      "name": "business",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.business.name)
	    },
	    on: {
	      "blur": _vm.updated_base_business,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact.business, "name", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.business_help_text),
	      expression: "business_help_text"
	    }],
	    key: "business",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.business_help_text))])])], 1)]), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "position"
	    }
	  }, [_vm._v("Cargo")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.position),
	      expression: "contact.position"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-position",
	      "name": "position",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.position)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "position", $event.target.value)
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('telephone')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "telephone"
	    }
	  }, [_vm._v("Telefone")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.telephone),
	      expression: "contact.telephone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-telephone",
	      "name": "telephone",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.telephone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "telephone", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('telephone')),
	      expression: "errors.has('telephone')"
	    }],
	    key: "telephone",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('telephone')))])])], 1)]), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('cellphone')
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "cellphone"
	    }
	  }, [_vm._v("Celular")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.cellphone),
	      expression: "contact.cellphone"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-cellphone",
	      "name": "cellphone",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.cellphone)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "cellphone", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('cellphone')),
	      expression: "errors.has('cellphone')"
	    }],
	    key: "cellphone",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('cellphone')))])])], 1)]), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "address"
	    }
	  }, [_vm._v("Endereço")]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.address),
	      expression: "contact.address"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-address",
	      "name": "address",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.address)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "address", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "address"
	    }
	  }, [_vm._v("Variável 1")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.variable1),
	      expression: "contact.variable1"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "variable-1",
	      "name": "variable1",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.variable1)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "variable1", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "address"
	    }
	  }, [_vm._v("Variável 2")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.variable2),
	      expression: "contact.variable2"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "variable-2",
	      "name": "variable2",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.variable2)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "variable2", $event.target.value)
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "address"
	    }
	  }, [_vm._v("Variável 3")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.contact.variable3),
	      expression: "contact.variable3"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "variable-2",
	      "name": "variable3",
	      "type": "text",
	      "disabled": _vm.user_is_monitoring_manager
	    },
	    domProps: {
	      "value": (_vm.contact.variable3)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.contact, "variable3", $event.target.value)
	      }
	    }
	  })])]), _vm._l((_vm.contact.contact_custom_fields), function(contact_custom_field, index) {
	    return _c('div', {
	      key: contact_custom_field.field,
	      class: _vm.customFieldColumnClass(index)
	    }, [_c('div', {
	      staticClass: "form-group",
	      class: {
	        'has-error': _vm.errors.has('custom_field_' + contact_custom_field.id)
	      }
	    }, [_c('label', {
	      attrs: {
	        "for": contact_custom_field.field
	      }
	    }, [_vm._v(_vm._s(contact_custom_field.field))]), (contact_custom_field.kind == 'dropdown') ? _c('select', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (contact_custom_field.value),
	        expression: "contact_custom_field.value"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "disabled": _vm.user_is_monitoring_manager
	      },
	      on: {
	        "change": function($event) {
	          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	            return o.selected
	          }).map(function(o) {
	            var val = "_value" in o ? o._value : o.value;
	            return val
	          });
	          _vm.$set(contact_custom_field, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
	        }
	      }
	    }, _vm._l((contact_custom_field.options), function(option) {
	      return _c('option', {
	        domProps: {
	          "value": option.name
	        }
	      }, [_vm._v(_vm._s(option.name))])
	    }), 0) : (contact_custom_field.kind != 'textarea') ? _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (contact_custom_field.value),
	        expression: "contact_custom_field.value"
	      }, {
	        name: "mask",
	        rawName: "v-mask",
	        value: (_vm.custom_field_mask(contact_custom_field)),
	        expression: "custom_field_mask(contact_custom_field)"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "type": "text",
	        "disabled": _vm.user_is_monitoring_manager
	      },
	      domProps: {
	        "value": (contact_custom_field.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(contact_custom_field, "value", $event.target.value)
	        }
	      }
	    }) : _c('textarea', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (contact_custom_field.value),
	        expression: "contact_custom_field.value"
	      }, {
	        name: "mask",
	        rawName: "v-mask",
	        value: (_vm.custom_field_mask(contact_custom_field)),
	        expression: "custom_field_mask(contact_custom_field)"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "disabled": _vm.user_is_monitoring_manager
	      },
	      domProps: {
	        "value": (contact_custom_field.value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(contact_custom_field, "value", $event.target.value)
	        }
	      }
	    }), _c('transition-group', {
	      attrs: {
	        "name": "fade"
	      }
	    }, [_c('div', {
	      directives: [{
	        name: "show",
	        rawName: "v-show",
	        value: (_vm.errors.has('custom_field_' + contact_custom_field.id)),
	        expression: "errors.has('custom_field_' + contact_custom_field.id)"
	      }],
	      key: "first_name",
	      staticClass: "help-block"
	    }, [_vm._v(_vm._s(_vm.errors.first('custom_field_' + contact_custom_field.id)))])])], 1)])
	  })], 2)]), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": !_vm.submittable
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1176 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "flow-triggers"
	    }
	  }, [_c('div', {
	    staticClass: "triggers-integrations"
	  }, [_vm._m(0), _vm._l((_vm.matching), function(item, index) {
	    return _c('div', {
	      staticClass: "row row-trigger"
	    }, [(!item._destroy) ? _c('div', {
	      staticClass: "col-md-12"
	    }, [_c('div', {
	      staticClass: "row first-item"
	    }, [_c('div', {
	      staticClass: "line-left"
	    }), _c('div', {
	      staticClass: "ball"
	    }), _vm._m(1, true), _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('dropdown-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "field",
	      attrs: {
	        "options": _vm.triggers_options,
	        "selected": item.trigger_type
	      },
	      on: {
	        "input": _vm.setDirty
	      },
	      model: {
	        value: (item.trigger_type),
	        callback: function($$v) {
	          _vm.$set(item, "trigger_type", $$v)
	        },
	        expression: "item.trigger_type"
	      }
	    })], 1), (item.trigger_type == 'stage') ? _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('dropdown-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "field",
	      attrs: {
	        "options": _vm.stages_options,
	        "selected": item.trigger_value
	      },
	      on: {
	        "input": _vm.setDirty
	      },
	      model: {
	        value: (item.trigger_value),
	        callback: function($$v) {
	          _vm.$set(item, "trigger_value", $$v)
	        },
	        expression: "item.trigger_value"
	      }
	    })], 1) : _vm._e(), (item.trigger_type == 'lost') ? _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('dropdown-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "field",
	      attrs: {
	        "data-vv-name": "lost_reason_unit",
	        "options": _vm.lostReasonOptions()
	      },
	      model: {
	        value: (item.trigger_value),
	        callback: function($$v) {
	          _vm.$set(item, "trigger_value", $$v)
	        },
	        expression: "item.trigger_value"
	      }
	    })], 1) : _vm._e()]), _c('div', {
	      staticClass: "row trigger-item",
	      class: [_vm.show_timming_actions.indexOf(item.action_type) > -1 ? '' : 'no-border']
	    }, [_c('div', {
	      staticClass: "line-faker"
	    }), _c('div', {
	      staticClass: "col-md-2 col-question fake-half-width"
	    }), _vm._m(2, true), _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('dropdown-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "field",
	      attrs: {
	        "options": item.trigger_type != 'stage' && item.trigger_type != 'lost' ? _vm.actions_options : _vm.actions_trigger_without_stages,
	        "selected": item.action_type
	      },
	      on: {
	        "input": _vm.setDirty
	      },
	      model: {
	        value: (item.action_type),
	        callback: function($$v) {
	          _vm.$set(item, "action_type", $$v)
	        },
	        expression: "item.action_type"
	      }
	    })], 1), (item.action_type == 'change_stage') ? _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('dropdown-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "field",
	      attrs: {
	        "options": _vm.stages_options,
	        "selected": item.action_value
	      },
	      on: {
	        "input": _vm.setDirty
	      },
	      model: {
	        value: (item.action_value),
	        callback: function($$v) {
	          _vm.$set(item, "action_value", $$v)
	        },
	        expression: "item.action_value"
	      }
	    })], 1) : _vm._e(), (item.action_type == 'send_to_new_flow') ? _c('div', {
	      staticClass: "col-md-4 contact-list-item-flow"
	    }, [_c('flows', {
	      attrs: {
	        "position": index,
	        "focus": false,
	        "default_flow": item.action_value,
	        "user_id": _vm.current_user_id
	      },
	      on: {
	        "flow-selected": _vm.selectFlow
	      }
	    })], 1) : _vm._e(), (item.action_type == 'fill_property') ? _c('div', {
	      staticClass: "col-md-5 no-padding"
	    }, [_c('dropdown-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "field fill-property-field",
	      attrs: {
	        "options": _vm.properties_options,
	        "selected": item.action_target
	      },
	      on: {
	        "input": _vm.setDirty
	      },
	      model: {
	        value: (item.action_target),
	        callback: function($$v) {
	          _vm.$set(item, "action_target", $$v)
	        },
	        expression: "item.action_target"
	      }
	    }), _c('div', {
	      staticClass: "trigger-question"
	    }, [_vm._v("com")]), _c('input', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }, {
	        name: "model",
	        rawName: "v-model",
	        value: (item.action_value),
	        expression: "item.action_value"
	      }],
	      staticClass: "form-control fill-property-field",
	      attrs: {
	        "name": "name",
	        "type": "text"
	      },
	      domProps: {
	        "value": (item.action_value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "action_value", $event.target.value)
	        }
	      }
	    })], 1) : _vm._e(), (item.action_type == 'insert_tag') ? _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('dropdown-multiple-select', {
	      attrs: {
	        "filter_item_selected_ids": item.action_metadata,
	        "position": index,
	        "index": index,
	        "kind": _vm.kind_multiple_filter
	      },
	      on: {
	        "item-selected-items": _vm.itemSelectedItems
	      }
	    })], 1) : _vm._e(), (item.action_type == 'insert_into_a_group') ? _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('groups', {
	      attrs: {
	        "position": index,
	        "default_group": item.action_value,
	        "user_id": _vm.selected_user
	      },
	      on: {
	        "group-selected": _vm.selectGroup
	      }
	    })], 1) : _vm._e(), (item.action_type == 'change_responsible') ? _c('div', {
	      staticClass: "col-md-4"
	    }, [_c('dropdown-select', {
	      attrs: {
	        "options": _vm.users_options,
	        "selected": item.action_value
	      },
	      model: {
	        value: (item.action_value),
	        callback: function($$v) {
	          _vm.$set(item, "action_value", $$v)
	        },
	        expression: "item.action_value"
	      }
	    })], 1) : _vm._e(), _c('div', {
	      staticClass: "col-md-1"
	    }, [_c('div', {
	      staticClass: "btn-icon-remove",
	      on: {
	        "click": function($event) {
	          return _vm.removeTrigger(item, index)
	        }
	      }
	    })])]), (_vm.show_timming_actions.indexOf(item.action_type) > -1) ? _c('div', {
	      staticClass: "row trigger-item"
	    }, [_c('div', {
	      staticClass: "mask"
	    }), _c('div', {
	      staticClass: "col-md-3 col-question fake-width"
	    }), _c('div', {
	      staticClass: "col-md-3"
	    }, [_c('dropdown-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "field",
	      attrs: {
	        "options": _vm.timming_options,
	        "selected": item.timming_type,
	        "disabled": (item.trigger_type == 'connected' || item.trigger_type == 'bounced') && item.action_type == 'change_stage'
	      },
	      on: {
	        "input": _vm.setDirty
	      },
	      model: {
	        value: (item.timming_type),
	        callback: function($$v) {
	          _vm.$set(item, "timming_type", $$v)
	        },
	        expression: "item.timming_type"
	      }
	    })], 1), (item.timming_type == 'after') ? _c('div', {
	      staticClass: "col-md-3 inline-options"
	    }, [_c('input', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }, {
	        name: "model",
	        rawName: "v-model",
	        value: (item.timming_value),
	        expression: "item.timming_value"
	      }],
	      staticClass: "form-control input-delay",
	      attrs: {
	        "name": "name",
	        "type": "text"
	      },
	      domProps: {
	        "value": (item.timming_value)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(item, "timming_value", $event.target.value)
	        }
	      }
	    }), _c('dropdown-select', {
	      directives: [{
	        name: "validate",
	        rawName: "v-validate",
	        value: ('required'),
	        expression: "'required'"
	      }],
	      staticClass: "field input-delay-options",
	      attrs: {
	        "options": _vm.timming_complements,
	        "selected": item.timming_complement
	      },
	      on: {
	        "input": _vm.setDirty
	      },
	      model: {
	        value: (item.timming_complement),
	        callback: function($$v) {
	          _vm.$set(item, "timming_complement", $$v)
	        },
	        expression: "item.timming_complement"
	      }
	    })], 1) : _vm._e()]) : _vm._e()]) : _vm._e()])
	  }), _c('div', {
	    staticClass: "row btn-new"
	  }, [_c('div', {
	    staticClass: "btn btn-clean",
	    on: {
	      "click": function($event) {
	        return _vm.newTrigger()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('flows.actions.addTrigger')))])])], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('h2', [_vm._v("Gatilhos")]), _c('div', {
	    staticClass: "titleized"
	  }, [_vm._v("Crie gatilhos personalizados para gerar ações automaticamente de acordo com o seu processo.")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-3 fake-width"
	  }, [_c('div', {
	    staticClass: "trigger-question"
	  }, [_vm._v("Quando um contato for")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "col-md-1 no-padding-right"
	  }, [_c('div', {
	    staticClass: "trigger-question"
	  }, [_vm._v("Quero")])])
	}]}

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "container auth-view-wrapper"
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(31),
	      "alt": "Reev"
	    }
	  }), _c('fieldset', {
	    on: {
	      "change": _vm.setDirty,
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit.apply(null, arguments)
	      }
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, _vm._l((_vm.apiErrorMessages), function(message, key) {
	    return _c('div', {
	      key: key,
	      staticClass: "error-message"
	    }, [_vm._v(_vm._s(message))])
	  }), 0), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('email')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|email'),
	      expression: "'required|email'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.email),
	      expression: "credentials.email"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-email",
	      "name": "email",
	      "type": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": (_vm.credentials.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "email", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('email')),
	      expression: "errors.has('email')"
	    }],
	    key: "email",
	    staticClass: "help-block text-left"
	  }, [_vm._v(_vm._s(_vm.errors.first('email')))])])], 1), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "user-password",
	      "name": "password",
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    key: "password",
	    staticClass: "help-block text-left"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])], 1), _c('button', {
	    staticClass: "btn btn-block btn-primary submit-button",
	    attrs: {
	      "id": "login-btn",
	      "type": "submit",
	      "disabled": !_vm.submittable
	    },
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Entrar")]), _c('router-link', {
	    staticClass: "forgot-password-link",
	    attrs: {
	      "to": "recuperar-senha"
	    }
	  }, [_vm._v("Esqueci minha senha")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    attrs: {
	      "id": "flows-creation-options"
	    }
	  }, [_c('router-link', {
	    staticClass: "back-link-spaced",
	    attrs: {
	      "to": "/fluxos-de-cadencia"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('flows.title.cadenceFlowNew')))]), _c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.cadenceFlowNew')))]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "big-option-box"
	  }, [_c('div', {
	    staticClass: "big-option-box-icon paper-icon"
	  }), _c('div', {
	    staticClass: "big-option-box-title"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.emptyCadenceFlow')))]), _c('div', {
	    staticClass: "big-option-box-text"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.createCadenceFlow')))]), _c('div', {
	    staticClass: "big-option-box-select-wrapper"
	  }, [_c('router-link', {
	    staticClass: "btn btn-clean",
	    attrs: {
	      "to": "/fluxos-de-cadencia/criar"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.select')))])], 1)])]), _c('div', {
	    staticClass: "col-md-3"
	  }, [_c('div', {
	    staticClass: "big-option-box"
	  }, [_c('div', {
	    staticClass: "big-option-box-icon folder-icon"
	  }), _c('div', {
	    staticClass: "big-option-box-title"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.fromLibCadenceFlow')))]), _c('div', {
	    staticClass: "big-option-box-text"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.useCadenceFlow')))]), _c('div', {
	    staticClass: "big-option-box-select-wrapper"
	  }, [_c('router-link', {
	    staticClass: "btn btn-clean",
	    attrs: {
	      "id": "flows-library",
	      "to": "/fluxos-de-cadencia/biblioteca"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.select')))])], 1)])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-row contact-item list-item"
	  }, [_c('div', {
	    staticClass: "table-col table-col-80 overflow-hidden clickable",
	    on: {
	      "click": function($event) {
	        return _vm.editBusiness()
	      }
	    }
	  }, [_c('div', {
	    staticClass: "business-name overflow-ellipsis",
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(_vm._s(_vm.business.name || " - "))]), _c('div', {
	    staticClass: "business-domain",
	    staticStyle: {
	      "padding-left": "10px"
	    }
	  }, [_vm._v(_vm._s(_vm.business.domain || " - "))])]), _c('div', {
	    staticClass: "table-col table-col-80 business-address-cell"
	  }, [_c('div', {
	    staticClass: "business-address overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.address || " - "))])]), _c('div', {
	    staticClass: "table-col table-col-60"
	  }, [_c('span', {
	    staticClass: "btn-contact-status btn-contact-fake",
	    class: 'contact-status-' + _vm.business.status
	  }, [(_vm.business.human_status) ? _c('span', {
	    class: _vm.statusIconClass
	  }) : _vm._e(), _c('div', {
	    staticClass: "contact-status"
	  }, [_vm._v(_vm._s(_vm.business.human_status || " - "))])])]), _c('div', {
	    staticClass: "table-col table-col-60"
	  }, [_c('span', {
	    class: _vm.stageClasses
	  }, [_c('div', {
	    staticClass: "contact-stage"
	  }, [_vm._v(_vm._s(_vm.business.human_stage || " - "))])])]), _c('div', {
	    staticClass: "table-col table-col-120"
	  }, [(_vm.business.tags.length > 0) ? _c('div', {
	    staticClass: "tags-list"
	  }, [_c('tag', {
	    style: ({
	      color: '#' + _vm.tag_first.color
	    }),
	    attrs: {
	      "tag": _vm.tag_first
	    }
	  }), (_vm.show_more_tags) ? _c('div', {
	    staticClass: "tag",
	    staticStyle: {
	      "color": "rgb(41,69,86)",
	      "border-right-color": "rgb(41,69,86)"
	    }
	  }, [_vm._v(_vm._s(_vm.tags_count_left) + "+")]) : _vm._e()], 1) : _c('span', [_vm._v("-")])]), _c('div', {
	    staticClass: "table-col table-col-120 business-contacts-cell"
	  }, [_c('div', {
	    staticClass: "business-contacts overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.business.list_contacts || " - "))])]), _c('div', {
	    staticClass: "table-col table-col-collapsed"
	  }, [_c('div', {
	    staticClass: "action"
	  }, [_c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu multi-level"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": _vm.editBusiness
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.edit')))]), _c('a', {
	    on: {
	      "click": _vm.destroyBusiness
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.delete')))])])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-default dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	}]}

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "import-contacts-csv"
	    }
	  }, [_c('router-link', {
	    staticClass: "back-link-spaced",
	    attrs: {
	      "to": "/contatos/leads"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('contacts_csv.title.index')))]), _c('step-bar', {
	    attrs: {
	      "current_step": _vm.current_step,
	      "upload_progress": _vm.upload_progress,
	      "validation_progress": _vm.validation_progress,
	      "creation_progress": _vm.creation_progress,
	      "steps_labels": ['Upload', 'Validação', 'Organização', 'Envio para a base'],
	      "title": _vm.$t('contacts_csv.label.uploadFromFile')
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.file),
	      expression: "!file"
	    }],
	    staticClass: "content-empty"
	  }, [_c('div', {
	    staticClass: "big-icon glyphicon glyphicon-cloud-upload"
	  }), _c('br'), _c('input', {
	    staticClass: "hidden",
	    attrs: {
	      "type": "file",
	      "id": "file",
	      "accept": ".csv"
	    },
	    on: {
	      "change": _vm.fileInput
	    }
	  }), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "onclick": "jQuery('#file').click()"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-arrow-up"
	  }), _vm._v(_vm._s(_vm.$t('contacts_csv.actions.upload')))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.label.howToCSVUpload')) + " "), _c('a', {
	    staticClass: "clickable",
	    on: {
	      "click": _vm.exportDefaultCSV
	    }
	  }, [_vm._v(" " + _vm._s(_vm.$t('contacts_csv.actions.exampleExport')) + " ")])]), _c('br')]), (_vm.loading && _vm.current_step == 2) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [_c('div', {
	    staticClass: "loading-message"
	  }, [_vm._m(0), _c('p', [_vm._v(_vm._s(_vm.$t('contacts_csv.feedback.validateUpload')))])])])]) : (_vm.file && _vm.current_step < 4) ? _c('div', [_c('div', {
	    class: {
	      'padding-top': _vm.loading
	    },
	    attrs: {
	      "align": "center"
	    }
	  }), _c('br'), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.validation_finished && !_vm.loading && _vm.current_step == 2),
	      expression: "validation_finished && !loading && current_step == 2"
	    }]
	  }, [_c('div', {
	    staticClass: "dark-slate-gray-color"
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-file dark-slate-gray-color"
	  }), _c('span', {
	    staticClass: "spacer-10"
	  }), _c('span', [_vm._v(_vm._s(_vm.file.name))])]), _c('br'), (_vm.has_line_errors) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, [_vm._v("Seu arquivo CSV possui erros")]) : _vm._e(), (_vm.has_file_errors) ? _c('div', {
	    staticClass: "alert alert-danger"
	  }, _vm._l((_vm.file_errors), function(error) {
	    return _c('div', [_vm._v("- " + _vm._s(error))])
	  }), 0) : _vm._e(), _c('virtual-scroller', {
	    staticClass: "table-responsive virtual-scroller",
	    attrs: {
	      "items": _vm.raw_contacts,
	      "item-height": 31,
	      "main-tag": "section",
	      "container-tag": "table"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(props) {
	        return [_c('tr', {
	          key: props.item.index
	        }, [(props.item.index < 2) ? [(props.item.index == 0) ? [_c('th'), _vm._l((_vm.attributes_reference), function(attribute_reference) {
	          return _c('th', [_c('div', [_vm._v(_vm._s(attribute_reference[1]))])])
	        }), _vm._l((_vm.custom_fields), function(custon_field, index) {
	          return _c('th', [_c('div', [_vm._v(_vm._s(_vm.all_attributes_letters[index + _vm.fixed_columns_size] || '--'))])])
	        })] : [_c('th', [_vm._v(_vm._s(_vm.has_header ? 1 : ''))]), _vm._l((_vm.attributes_reference), function(attribute_reference) {
	          return _c('td', [_c('div', [_vm._v(_vm._s(_vm.humanAttribute(attribute_reference[0])))])])
	        }), _vm._l((_vm.custom_fields), function(custom_field) {
	          return _c('td', [_c('div', [_vm._v(_vm._s(custom_field.field))])])
	        })]] : [_c('th', [_vm._v(_vm._s((props.item.index - 2) + (_vm.has_header ? 2 : 1)))]), _vm._l(((_vm.fixed_columns_size)), function(n, col_index) {
	          return _c('td', {
	            class: {
	              "has-error": _vm.cellHasError(props.item.index - 2, col_index)
	            }
	          }, [_vm._v(_vm._s(props.item[col_index]))])
	        }), _vm._l((_vm.custom_fields), function(custom_field, index) {
	          return _c('td', {
	            class: {
	              "has-error": _vm.cellHasError(props.item.index - 2, index + _vm.fixed_columns_size)
	            }
	          }, [_vm._v(_vm._s(props.item[index + (_vm.fixed_columns_size)]))])
	        })]], 2)]
	      }
	    }])
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.has_line_errors),
	      expression: "has_line_errors"
	    }]
	  }, [_c('hr', {
	    staticClass: "thick"
	  }), _c('div', {
	    staticClass: "subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.subtitle.errorsResume')))]), _c('div', {
	    staticClass: "spacer-15"
	  }), _vm._l((_vm.line_errors), function(cells, error) {
	    return _c('div', [_c('span', {
	      staticClass: "glyphicon glyphicon-alert light-red-color"
	    }), _c('span', {
	      staticClass: "spacer-10"
	    }), _c('span', {
	      staticClass: "dark-slate-gray-color bold"
	    }, [_vm._v(_vm._s(_vm.humanCells(cells)))]), _c('span', {
	      staticClass: "spacer-5"
	    }), _c('span', {
	      staticClass: "text-gray-color"
	    }, [_vm._v(_vm._s(error))]), _c('div', {
	      staticClass: "spacer-10"
	    })])
	  })], 2), _c('hr', {
	    staticClass: "thick"
	  }), _c('div', [_c('span', {
	    staticClass: "subtitle"
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.subtitle.nextStepsCheck')))]), _c('div', {
	    staticClass: "spacer-10"
	  }), _c('div', [_c('span', {
	    staticClass: "glyphicon glyphicon-alert yellow-color"
	  }), _c('span', {
	    staticClass: "spacer-10"
	  }), _c('span', {
	    staticClass: "text-gray-color"
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.label.nextStepsCheck1')) + " ")])]), _c('div', [_c('span', {
	    staticClass: "glyphicon glyphicon-alert yellow-color"
	  }), _c('span', {
	    staticClass: "spacer-10"
	  }), _c('span', {
	    staticClass: "text-gray-color"
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.label.nextStepsCheck2')) + " ")]), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.encoding_options
	    },
	    on: {
	      "input": _vm.importWithEncoding
	    },
	    model: {
	      value: (_vm.encoding),
	      callback: function($$v) {
	        _vm.encoding = $$v
	      },
	      expression: "encoding"
	    }
	  })], 1)]), _c('hr', {
	    staticClass: "thick"
	  }), _c('div', {
	    staticClass: "text-center"
	  }, [_c('router-link', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "to": "/contatos/leads"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')) + " ")]), (_vm.has_errors) ? _c('span', {
	    attrs: {
	      "id": "import_buttons"
	    }
	  }, [(_vm.has_errors) ? _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "import_fixed_csv",
	      "onclick": "jQuery('#file').click()"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.importAfterCheck')) + " ")]) : _vm._e(), ((_vm.has_valid && _vm.has_errors) || _vm.has_duplicates) ? _c('div', {
	    staticClass: "dropdown dropup",
	    attrs: {
	      "id": "dropdownElement",
	      "text": "Action",
	      "type": "primary",
	      "data-toggle": "dropdown"
	    }
	  }, [_c('div', {
	    staticClass: "user-miniature-wrapper dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.menu_open_change()
	      }
	    }
	  }, [(_vm.menu_open == true) ? _c('span', {
	    staticClass: "glyphicon glyphicon-menu-up"
	  }) : _c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })]), _c('ul', {
	    staticClass: "dropdown-menu dropdown-menu-right",
	    attrs: {
	      "id": "import_fixed_csv_dropdown_menu"
	    }
	  }, [_c('li', [(_vm.has_valid && _vm.has_errors) ? _c('a', {
	    on: {
	      "click": _vm.confirmImportValidOnly
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.contactsImportOnlyFine')) + " ")]) : _vm._e()]), _c('li', [(_vm.has_duplicates) ? _c('a', {
	    on: {
	      "click": _vm.workOnDuplicates
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.contactsImportDuplicated')) + " ")]) : _vm._e()])])]) : _vm._e()]) : _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.nextStep
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.nextStepsCheckedContinue')) + " ")]), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-select-duplicate-confirmation-modal",
	      "title": "Confirmar a seleção de contatos duplicados",
	      "message": _vm.message,
	      "confirm_text": "Confirmar",
	      "confirm_class": "btn-primary",
	      "reject_text": "Cancelar"
	    },
	    on: {
	      "confirm-modal-confirm": function($event) {
	        return _vm.update(true)
	      },
	      "confirm-modal-reject": function($event) {
	        return _vm.update(false)
	      }
	    }
	  })], 1)], 1)]) : _vm._e(), (_vm.current_step == 3) ? _c('organization-step', {
	    attrs: {
	      "multiple_groups": _vm.multiple_groups,
	      "groups": _vm.groups,
	      "remaining": _vm.remaining
	    },
	    on: {
	      "groupSwitch": _vm.switchGroup,
	      "flowSwitch": _vm.switchFlow,
	      "fillGroup": _vm.selectGroup,
	      "fillFlow": _vm.selectFlow,
	      "tagsUpdated": _vm.selectTags,
	      "userUpdated": _vm.selectUser,
	      "remainingContacts": _vm.switchRemaining
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [(_vm.current_step >= 4) ? _c('div', {
	    staticClass: "loading-message"
	  }, [(!_vm.import_finished) ? [_vm._m(1), _c('p', [_vm._v(_vm._s(_vm.$t('contacts_csv.feedback.sendingContacts')) + " ")])] : [_c('img', {
	    staticClass: "last",
	    attrs: {
	      "src": __webpack_require__(994)
	    }
	  }), _c('p', [_vm._v(_vm._s(_vm.$t('contacts_csv.feedback.contactsSent')) + " ")]), _c('br'), _c('router-link', {
	    staticClass: "btn btn-primary go-to-contacts",
	    attrs: {
	      "to": "/contatos/leads"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.backToContactsPage')) + " ")]), _c('br'), _c('a', {
	    on: {
	      "click": _vm.newImport
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.newImport')) + " ")])]], 2) : _vm._e()])]), _c('div', {
	    staticClass: "text-center"
	  }, [(_vm.current_step == 3) ? _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.confirmImport
	    }
	  }, [_vm._v(_vm._s(_vm.$t('contacts_csv.actions.contactImport')) + " ")]) : _vm._e()]), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-flow-select-confirmation-modal",
	      "title": _vm.$t('contacts_csv.label.importConfirmTitle'),
	      "message": _vm.$t('contacts_csv.label.importConfirmMessage'),
	      "confirm_text": _vm.$t('general.actions.confirm'),
	      "confirm_class": "btn-primary",
	      "reject_text": _vm.$t('general.actions.cancel')
	    },
	    on: {
	      "confirm-modal-confirm": function($event) {
	        return _vm.updateActiveInFlow(true)
	      },
	      "confirm-modal-reject": function($event) {
	        return _vm.updateActiveInFlow(false)
	      }
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "animation-loading"
	  }, [_c('img', {
	    staticClass: "first",
	    attrs: {
	      "src": __webpack_require__(254)
	    }
	  }), _c('img', {
	    staticClass: "second",
	    attrs: {
	      "src": __webpack_require__(255)
	    }
	  }), _c('img', {
	    staticClass: "third",
	    attrs: {
	      "src": __webpack_require__(256)
	    }
	  }), _c('img', {
	    staticClass: "fourth",
	    attrs: {
	      "src": __webpack_require__(257)
	    }
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "animation-loading"
	  }, [_c('img', {
	    staticClass: "first",
	    attrs: {
	      "src": __webpack_require__(254)
	    }
	  }), _c('img', {
	    staticClass: "second",
	    attrs: {
	      "src": __webpack_require__(255)
	    }
	  }), _c('img', {
	    staticClass: "third",
	    attrs: {
	      "src": __webpack_require__(256)
	    }
	  }), _c('img', {
	    staticClass: "fourth",
	    attrs: {
	      "src": __webpack_require__(257)
	    }
	  })])
	}]}

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_comment_modal),
	      expression: "show_comment_modal"
	    }],
	    staticClass: "resizable",
	    attrs: {
	      "id": "global-comment-modal",
	      "tabindex": "-1",
	      "role": "dialog"
	    }
	  }, [_c('div', {
	    staticClass: "comment-modal-header"
	  }, [_c('h5', {
	    staticClass: "comment-modal-title overflow-ellipsis"
	  }, [_vm._v("Comentários - " + _vm._s(_vm.contacts_name))]), _c('button', {
	    staticClass: "close-comment-modal",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(48)
	    }
	  })])]), _vm._m(0), _c('div', {
	    staticClass: "comment-modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "id": "cancel",
	      "type": "button",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.close()
	      }
	    }
	  }, [_vm._v("Cancelar")]), (_vm.edit_comment) ? _c('button', {
	    staticClass: "btn btn-danger",
	    attrs: {
	      "id": "destroy",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.removeComment()
	      }
	    }
	  }, [_vm._v("Excluir")]) : _vm._e(), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "save",
	      "type": "button"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.saveComment()
	      }
	    }
	  }, [_vm._v("Salvar")])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "comment-modal-body"
	  }, [_c('textarea', {
	    attrs: {
	      "id": "comment-modal",
	      "name": "comment"
	    }
	  })])
	}]}

/***/ }),
/* 1182 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "tasks-index"
	    }
	  }, [_c('h1', {
	    staticClass: "inline"
	  }, [_vm._v("Tarefas")]), (!_vm.current_user.isMonitoringManager()) ? _c('button', {
	    staticClass: "btn btn-clean pull-right",
	    attrs: {
	      "id": "new-task"
	    },
	    on: {
	      "click": _vm.openTaskModalForm
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Nova tarefa")]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('br'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('statistic-cards', {
	    ref: "statistic_cards"
	  })], 1)]), _c('br'), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('filters', {
	    attrs: {
	      "filters": _vm.filters
	    },
	    on: {
	      "filter": _vm.filter
	    }
	  })], 1)]), _c('div', {
	    staticClass: "row relative"
	  }, [_c('div', {
	    staticClass: "col-md-9"
	  }, [_c('div', {
	    staticClass: "tasks-header tasks"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('span', {
	    staticClass: "info"
	  }, [_vm._v("Tarefas de Hoje")]), _c('span', {
	    staticClass: "numbers today"
	  }, [_vm._v(_vm._s(_vm.number_of_today_tasks))])]), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('span', {
	    staticClass: "info"
	  }, [_vm._v("Tarefas em Atraso")]), _c('span', {
	    staticClass: "numbers overdue"
	  }, [_vm._v(_vm._s(_vm.number_of_overdue_tasks))])]), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('span', {
	    staticClass: "info"
	  }, [_vm._v("Tarefas Futuras")]), _c('span', {
	    staticClass: "numbers future"
	  }, [_vm._v(_vm._s(_vm.number_of_future_tasks))])])]), _c('div', {
	    staticClass: "tasks-wrapper tasks"
	  }, [_c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('task-list', {
	    ref: "today_tasks",
	    attrs: {
	      "filters": _vm.today_filter,
	      "options": {
	        tasks_status: 'today'
	      },
	      "item_options": {
	        description: 'contact-info',
	        width: 'full-width'
	      }
	    },
	    on: {
	      "number-of-tasks": _vm.numberOfTodayTasks,
	      "open-template-modal": _vm.loadTaskInfo,
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  })], 1), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('task-list', {
	    ref: "overdue_tasks",
	    attrs: {
	      "filters": _vm.overdue_filter,
	      "options": {
	        tasks_status: 'overdue'
	      },
	      "item_options": {
	        description: 'contact-info',
	        width: 'full-width'
	      }
	    },
	    on: {
	      "number-of-tasks": _vm.numberOfOverdueTasks,
	      "open-template-modal": _vm.loadTaskInfo,
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  })], 1), _c('div', {
	    staticClass: "col-sm-4"
	  }, [_c('task-list', {
	    ref: "future_tasks",
	    attrs: {
	      "filters": _vm.future_filter,
	      "options": {
	        tasks_status: 'future'
	      },
	      "item_options": {
	        description: 'contact-info',
	        width: 'full-width'
	      }
	    },
	    on: {
	      "number-of-tasks": _vm.numberOfFutureTasks,
	      "open-template-modal": _vm.loadTaskInfo,
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  })], 1)])]), _c('div', {
	    staticClass: "clear"
	  }), _c('br'), _c('div', {
	    staticClass: "col-md-9"
	  }, [_c('ozzy-tasks', {
	    attrs: {
	      "users_options": _vm.users_options
	    },
	    on: {
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  }), _c('div', {
	    staticClass: "clear"
	  }), _c('calendar')], 1), _c('live-feed', {
	    class: {
	      lower: _vm.current_user.isSeller()
	    },
	    attrs: {
	      "users_options": _vm.users_options
	    },
	    on: {
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  })], 1), _c('task-modal-form', {
	    on: {
	      "destroyed": _vm.removeTask,
	      "open-template-modal": _vm.loadTaskInfo
	    }
	  }), _c('div', {
	    staticClass: "clear"
	  }), _c('br'), _c('br'), _c('br'), _c('br'), _c('div', {
	    staticClass: "grid-footer"
	  }, [_c('div', {
	    staticClass: "done-tasks"
	  }, [_c('done-tasks-feed', {
	    attrs: {
	      "users_options": _vm.users_options
	    },
	    on: {
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  })], 1), _c('div', {
	    staticClass: "paused-contacts"
	  }, [_c('paused-contacts', {
	    attrs: {
	      "users_options": _vm.users_options
	    },
	    on: {
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  })], 1)]), (_vm.show_meeting_modal) ? _c('meeting-modal', {
	    staticStyle: {
	      "top": "30%",
	      "left": "10%"
	    },
	    attrs: {
	      "task": _vm.selected_task
	    },
	    on: {
	      "close-meeting-modal": function($event) {
	        return _vm.closeMeetingModal()
	      }
	    }
	  }) : _vm._e(), _c('go-to-top')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1183 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.additional_time_in_minutes),
	      expression: "additional_time_in_minutes"
	    }],
	    staticClass: "form-control minutes additional-time",
	    attrs: {
	      "name": "additional_time"
	    },
	    domProps: {
	      "value": (_vm.additional_time_in_minutes)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.additional_time_in_minutes = $event.target.value
	      }
	    }
	  }), _c('span', {
	    staticStyle: {
	      "margin-left": "5px"
	    }
	  }, [_vm._v(_vm._s(_vm.consumed_in_minutes))])])
	},staticRenderFns: []}

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": _vm.prop_id
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-md"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_vm._m(0), _c('div', {
	    staticClass: "modal-body internal-scroller"
	  }, [_c('list', {
	    ref: "tag_list",
	    staticClass: "tag-modal-list",
	    attrs: {
	      "options": _vm.list_options,
	      "list_item_options": _vm.list_item_options
	    },
	    on: {
	      "selection-changed": _vm.selection_changed
	    }
	  })], 1), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Cancelar")]), _c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.pick
	    }
	  }, [_vm._v("Concluir")])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal-header"
	  }, [_vm._v("Selecione uma ou mais tags"), _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])])
	}]}

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    attrs: {
	      "id": "flows-new"
	    }
	  }, [_c('router-link', {
	    staticClass: "back-link-spaced",
	    attrs: {
	      "to": "/fluxos-de-cadencia"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.back')))]), _c('h1', [_vm._v(_vm._s(_vm.$t('flows.title.cadenceFlowNew')))]), _c('flow-form', {
	    attrs: {
	      "type_of_action": _vm.type_of_action,
	      "save-text": _vm.$t('flows.actions.new'),
	      "flow": _vm.flow
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1186 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('router-view', {
	    attrs: {
	      "name": "content"
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1187 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    staticClass: "sidebar"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/perfil"
	    }
	  }, [_vm._v("Perfil")])], 1), (_vm.show_company_management_menus) ? _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/permissoes"
	    }
	  }, [_vm._v("Permissões")])], 1) : _vm._e(), _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/alterar-senha"
	    }
	  }, [_vm._v("Alterar Senha")])], 1), _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "id": "users",
	      "to": "/configuracoes/usuarios"
	    }
	  }, [_vm._v("Usuários")])], 1), (_vm.show_company_management_menus) ? _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/contatos/campos-personalizados"
	    }
	  }, [_vm._v("Propriedades")])], 1) : _vm._e(), (_vm.show_company_management_menus) ? _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/templates"
	    }
	  }, [_vm._v("Templates")])], 1) : _vm._e(), (_vm.show_company_management_menus) ? _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/tags"
	    }
	  }, [_vm._v("Tags")])], 1) : _vm._e(), (_vm.show_company_management_menus) ? _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/atividades"
	    }
	  }, [_vm._v("Atividades")])], 1) : _vm._e(), _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/integracoes"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.title.index')))])], 1), (_vm.show_company_management_menus) ? _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/motivo-de-perda"
	    }
	  }, [_vm._v("Motivo de Perda")])], 1) : _vm._e(), (_vm.current_user.isAdmin()) ? _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/empresas"
	    }
	  }, [_vm._v("Empresas")])], 1) : _vm._e(), (_vm.current_company.voip_service) ? _c('li', {
	    staticClass: "sidebar-menu-link"
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/configuracoes/voip"
	    }
	  }, [_vm._v("VoIP")])], 1) : _vm._e()])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "sidebar-header"
	  }, [_c('h3', {
	    staticClass: "sidebar-header-title"
	  }, [_vm._v(" Configurações")])])
	}]}

/***/ }),
/* 1188 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadFlowContacts),
	      expression: "loadFlowContacts"
	    }],
	    attrs: {
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('contact-list', {
	    attrs: {
	      "contacts": _vm.contacts,
	      "view_mode": _vm.contactListViewModes().flow,
	      "flow": _vm.flow,
	      "filters": _vm.filters
	    },
	    on: {
	      "contact-update": _vm.updateContact,
	      "contact-recipient-update": _vm.updateContactRecipient,
	      "reengage-contact": _vm.reengage,
	      "contact-recipient-reset": _vm.openResetContactConfirmationModal,
	      "contact-destroy": _vm.openRemoveContactFromFlowModal,
	      "toggle-task-bar": _vm.bubbleUp,
	      "filter": _vm.filter
	    }
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('flows.feedback.noDataText')))])], 1), _c('go-to-top', {
	    attrs: {
	      "offset": 600
	    }
	  }), _c('reactivate-recipient-modal', {
	    attrs: {
	      "contact": _vm.schedule_reactivation_contact
	    }
	  }), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-remove-contact-from-flow",
	      "title": _vm.$t('contacts.actions.removeFromFlow'),
	      "confirm_text": _vm.$t('general.actions.remove'),
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.confirmRemoveContactFromFlow
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v(_vm._s(_vm.$t('flows.label.confirmRemoveContactOnFlow', {
	    contact_name: _vm.selected_contact.full_name,
	    flow_name: _vm.flow.name
	  })))]), _c('br'), _c('div', [_vm._v(_vm._s(_vm.$t('flows.label.messageRemoveContactOnFlow')))])])]), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-reset-contact",
	      "title": _vm.$t('flows.label.resetContactOnFlow'),
	      "message": _vm.$t('flows.label.confirmResetContactOnFlow')
	    },
	    on: {
	      "confirm-modal-confirm": _vm.callResetContact
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1189 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.loading) ? _c('div', {
	    staticClass: "loading",
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": "loading",
	      "size": "50px"
	    }
	  })], 1) : _c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', {
	    staticClass: "scope col"
	  }), _c('th', {
	    staticClass: "scope col"
	  }), _c('th', {
	    staticClass: "scope col"
	  }), _c('th', {
	    staticClass: "scope col"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.title.properties_table')))])])]), _c('tbody', {
	    staticClass: "scroll"
	  }, _vm._l((Object.keys(_vm.dados[_vm.selected])), function(item, index) {
	    return _c('tr', {
	      attrs: {
	        "value": item
	      }
	    }, [_c('td', {
	      staticClass: "scope row",
	      attrs: {
	        "id": item
	      }
	    }, [_vm._v(_vm._s(item))]), _c('td', {
	      attrs: {
	        "id": item
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "type": "button",
	        "disabled": _vm.copy_config(item),
	        "data-toggle": "modal",
	        "data-target": "#rd-carousel-modal"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.copyConfig(item)
	        }
	      }
	    }, [_vm._v(_vm._s(_vm.$t('general.actions.copy')))])]), _c('td', {
	      attrs: {
	        "id": item
	      }
	    }, [_c('button', {
	      staticClass: "btn btn-primary",
	      attrs: {
	        "type": "button",
	        "data-toggle": "modal",
	        "data-target": "#rd-carousel-modal"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.selectedCarousel(item)
	        }
	      }
	    }, [_vm._v(" " + _vm._s(_vm.text_config(item)))])]), _c('td', {
	      staticClass: "image",
	      attrs: {
	        "id": item
	      }
	    }, [_vm._l((_vm.slicePicture(item)), function(user) {
	      return _c('div', {
	        staticStyle: {
	          "padding-right": "10px"
	        },
	        attrs: {
	          "value": user
	        }
	      }, [_c('img', {
	        staticClass: "user",
	        attrs: {
	          "src": user.user.picture_url,
	          "title": user.user.name
	        }
	      })])
	    }), (_vm.dados[_vm.selected][item].Carousel) ? _c('span', {
	      attrs: {
	        "id": item
	      }
	    }, [((_vm.dados[_vm.selected][item].Carousel.carousel_users.length - 3) > 0) ? _c('button', {
	      staticClass: "number_avatar",
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.dropOpen(item)
	        }
	      }
	    }, [((_vm.dados[_vm.selected][item].Carousel.carousel_users.length - 3) > 0) ? _c('div', {
	      staticClass: "number"
	    }, [_vm._v(_vm._s(_vm.dados[_vm.selected][item].Carousel.carousel_users.length - 3))]) : _vm._e()]) : _vm._e(), (_vm.active[item]) ? _c('div', {
	      staticClass: "dropdown"
	    }, [_c('ul', {
	      staticClass: "dropimage"
	    }, _vm._l((_vm.slicePictureBuble(item)), function(items) {
	      return _c('li', {
	        staticClass: "space",
	        attrs: {
	          "value": items
	        }
	      }, [_c('img', {
	        staticClass: "user",
	        attrs: {
	          "src": items.user.picture_url
	        }
	      }), _c('span', {
	        staticClass: "text_name"
	      }, [_vm._v(_vm._s(items.user.name))])])
	    }), 0)]) : _vm._e()]) : _vm._e()], 2)])
	  }), 0), (_vm.show_modal) ? _c('carousel-modal-custom', {
	    ref: "rd_carousel_modal",
	    attrs: {
	      "id": "rd-carousel-modal",
	      "copy": _vm.datacopy,
	      "modal-title": _vm.modalTitle(),
	      "kind": "rd",
	      "custom": _vm.custom_select,
	      "dados": _vm.dados_modal,
	      "custom_fields_select": _vm.selected_copy[_vm.selected]
	    },
	    on: {
	      "carousel_updated": _vm.fillRdCarousel,
	      "carousel_copy": _vm.fillRdCopy,
	      "closeModal": function($event) {
	        _vm.show_modal = !_vm.show_modal
	      }
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1190 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_c('div', {
	    staticClass: "contact-event-icon rdstation-icon"
	  }), _c('div', {
	    staticClass: "contact-event-header overflow-ellipsis"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
	    staticClass: "right-arrow glyphicon glyphicon-arrow-right"
	  }), _c('a', {
	    staticClass: "contact-event-description underlined",
	    attrs: {
	      "href": _vm.event.description,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.event.description))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1191 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "templates",
	    attrs: {
	      "id": "templates-new"
	    }
	  }, [_c('back-link'), _c('h1', [_vm._v(_vm._s(_vm.$t('template.title.edit')))]), _c('br'), _c('template-form', {
	    attrs: {
	      "options": _vm.options,
	      "template": _vm.template,
	      "default_template_kind": _vm.template.kind
	    },
	    on: {
	      "validation-success": _vm.saveConfirmation
	    }
	  }), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-edit-template",
	      "title": _vm.$t('template.actions.new'),
	      "confirm_text": _vm.$t('general.actions.confirm'),
	      "confirm_class": "btn-primary"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.save
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-left"
	  }, [_c('div', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.optionsLabel)
	    }
	  }), _c('div', {
	    staticClass: "modal-update-option"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        _vm.update_flow_templates = true
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.update_flow_templates
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('template.actions.updateAtFlows')))])])]), _c('div', {
	    staticClass: "modal-update-option"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    on: {
	      "click": function($event) {
	        _vm.update_flow_templates = false
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": !_vm.update_flow_templates
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('template.actions.createOnEdit')))])])])])])])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "triggers-integrations"
	  }, [_c('div', {
	    staticClass: "row description"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('label', [_c('strong', [_vm._v(_vm._s(_vm.$t('integrations.title.trigger_stages')) + ":")])])])]), _c('div', {
	    staticClass: "row"
	  }, [(_vm.showIntegrationOnCreated()) ? _c('div', {
	    staticClass: "col-md-8 left"
	  }, [_c('div', {
	    staticClass: "checkbox-inline on-created",
	    on: {
	      "click": function($event) {
	        return _vm.toggleMark()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "name": "created"
	    },
	    domProps: {
	      "checked": _vm.on_created
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.trigger_stages.onCreated')))])])]) : _vm._e()]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 left"
	  }, [_c('div', {
	    staticClass: "checkbox-inline on-created",
	    on: {
	      "click": function($event) {
	        return _vm.toggleStatusTrigger()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "name": "status_connected_trigger"
	    },
	    domProps: {
	      "checked": _vm.status_connected_trigger
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.trigger_stages.onStatusConnected')))])])])]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 left"
	  }, [_c('div', {
	    staticClass: "checkbox-inline on-created",
	    on: {
	      "click": function($event) {
	        return _vm.toggleTrigger()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "name": "trigger"
	    },
	    domProps: {
	      "checked": _vm.trigger
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.trigger_stages.onAdvanceStage')) + ":")])])]), (_vm.trigger) ? _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('stages-select', {
	    attrs: {
	      "integration": _vm.integration,
	      "filter_item_selected_ids": _vm.filter_item_selected_ids
	    },
	    on: {
	      "item-selected-items": _vm.itemSelectedItems
	    }
	  })], 1) : _vm._e()]), (_vm.integration == 'webhook') ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-8 left"
	  }, [_c('div', {
	    staticClass: "checkbox-inline on-created",
	    on: {
	      "click": function($event) {
	        return _vm.toggleResponsibilityTrigger()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox",
	      "name": "change_responsibility_trigger"
	    },
	    domProps: {
	      "checked": _vm.on_change
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.trigger_stages.onChangeResponsibility')))])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "configuration-view-wrapper"
	  }, [_c('h1', [_vm._v("Alterar Senha")]), _c('fieldset', {
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.submit.apply(null, arguments)
	      }
	    }
	  }, [_c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, _vm._l((_vm.apiErrorMessages), function(message) {
	    return _c('div', {
	      staticClass: "error-message"
	    }, [_vm._v(_vm._s(message))])
	  }), 0), _c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.has('current_password')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "current-password"
	    }
	  }, [_vm._v("Senha atual")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.current_password),
	      expression: "credentials.current_password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "current-password",
	      "name": "current_password",
	      "type": "password"
	    },
	    domProps: {
	      "value": (_vm.credentials.current_password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "current_password", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('current_password')),
	      expression: "errors.has('current_password')"
	    }],
	    key: "current_password",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('current_password')))])])], 1), _c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "password"
	    }
	  }, [_vm._v("Nova senha")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password),
	      expression: "credentials.password"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "new-password",
	      "name": "password",
	      "type": "password"
	    },
	    domProps: {
	      "value": (_vm.credentials.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    key: "password",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])])], 1), _c('div', {
	    staticClass: "form-group col-md-12",
	    class: {
	      'has-error': _vm.errors.has('password_confirmation')
	    }
	  }, [_c('label', {
	    staticClass: "control-label",
	    attrs: {
	      "for": "password-confirmation"
	    }
	  }, [_vm._v("Confirmar nova senha")]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('confirmed:password'),
	      expression: "'confirmed:password'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.credentials.password_confirmation),
	      expression: "credentials.password_confirmation"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "new-password-confirmation",
	      "name": "password_confirmation",
	      "type": "password"
	    },
	    domProps: {
	      "value": (_vm.credentials.password_confirmation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.credentials, "password_confirmation", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password_confirmation')),
	      expression: "errors.has('password_confirmation')"
	    }],
	    key: "password_confirmation",
	    staticClass: "help-block"
	  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])])], 1), _c('div', {
	    staticClass: "col-md-12"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.submit.apply(null, arguments)
	      }
	    }
	  }, [_vm._v("Salvar")])])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1194 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table-col statistic"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v(_vm._s(_vm.value_text))]), _c('div', {
	    staticClass: "legend"
	  }, [_vm._v(_vm._s(_vm.label))])])
	},staticRenderFns: []}

/***/ }),
/* 1195 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "filters"
	  }, [_c('div', {
	    staticClass: "search-field-wrapper contact-group"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-search glyphicon glyphicon-search",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.reloadTasks
	    }
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search_contact_filter),
	      expression: "search_contact_filter"
	    }],
	    staticClass: "search-field form-control input-contact",
	    attrs: {
	      "placeholder": "Buscar contato",
	      "type": "text",
	      "maxlength": "255"
	    },
	    domProps: {
	      "value": (_vm.search_contact_filter)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.reloadTasks.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search_contact_filter = $event.target.value
	      }
	    }
	  })])])]), _c('div', {
	    staticClass: "filters"
	  }, [_c('dropdown-select', {
	    staticClass: "field user-filter",
	    attrs: {
	      "options": _vm.task_type_options
	    },
	    on: {
	      "input": _vm.reloadTasks
	    },
	    model: {
	      value: (_vm.task_type_filter),
	      callback: function($$v) {
	        _vm.task_type_filter = $$v
	      },
	      expression: "task_type_filter"
	    }
	  })], 1), _c('div', {
	    staticClass: "filters"
	  }, [(_vm.show_user_filter) ? _c('dropdown-select', {
	    staticClass: "field user-filter input-user",
	    attrs: {
	      "options": _vm.users_options
	    },
	    on: {
	      "input": _vm.reloadTasks
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1196 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "stages-matching"
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12"
	  }, [_c('span', {
	    staticClass: "component-name"
	  }, [_vm._v(_vm._s(_vm.$t('integrations.title.stages_matching')))]), _c('a', {
	    staticClass: "collapse-button",
	    class: {
	      'bloqued': _vm.pipelines.length == 0 && _vm.integration_stages.length == 0 && !_vm.integration_no_stages_api
	    },
	    attrs: {
	      "type": "button",
	      "data-toggle": "collapse",
	      "data-target": "#multiCollapse2",
	      "aria-expanded": "false",
	      "aria-controls": "multiCollapse2"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('integrations.actions.view.stages_matching'))), _c('span', {
	    staticClass: "gray-bold-caret"
	  })]), _c('hr')])]), _c('div', {
	    staticClass: "collapse multi-collapse",
	    attrs: {
	      "id": "multiCollapse2"
	    }
	  }, [(_vm.current_user.isManager()) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('dropdown-select', {
	    attrs: {
	      "options": _vm.users_options,
	      "fullWidth": true
	    },
	    model: {
	      value: (_vm.user_stage_setting),
	      callback: function($$v) {
	        _vm.user_stage_setting = $$v
	      },
	      expression: "user_stage_setting"
	    }
	  })], 1)]), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "checkbox-inline",
	    staticStyle: {
	      "display": "flex"
	    },
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.toggleUpdateAllUsers()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.update_all_users
	    }
	  }), _c('label', [_vm._v(_vm._s(_vm.$t('integrations.checkbox.updateAllUsers')))])])])])]) : _vm._e(), (_vm.pipelines && _vm.pipelines.length > 0) ? _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('span', [_vm._v(_vm._s(_vm.$t('integrations.label.stages_matching.funnel')))]), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.pipelines,
	      "fullWidth": true
	    },
	    on: {
	      "input": _vm.updateStages
	    },
	    model: {
	      value: (_vm.selected_pipeline),
	      callback: function($$v) {
	        _vm.selected_pipeline = $$v
	      },
	      expression: "selected_pipeline"
	    }
	  })], 1)])]) : _vm._e(), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6"
	  }, [_vm._m(0), _vm._l((_vm.stage_options), function(stage) {
	    return (!stage.ignore) ? _c('div', {
	      key: stage.value.stage_query,
	      staticClass: "form-group item"
	    }, [_c('input', {
	      staticClass: "form-control draggable",
	      class: stage.type,
	      attrs: {
	        "type": "text",
	        "disabled": "disabled",
	        "placeholder": stage.text
	      }
	    })]) : _vm._e()
	  })], 2), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.integration_name))])]), (_vm.integration_no_stages_api) ? _c('div', _vm._l((_vm.matching), function(field) {
	    return _c('div', {
	      key: field.reev,
	      staticClass: "form-group item"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (field.integration),
	        expression: "field.integration"
	      }],
	      staticClass: "form-control",
	      attrs: {
	        "placeholder": ((_vm.$t('integrations.placeholder.stages_matching')) + " " + (_vm.integration_name.toUpperCase()))
	      },
	      domProps: {
	        "value": (field.integration)
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.$set(field, "integration", $event.target.value)
	        }, _vm.updateProps]
	      }
	    })])
	  }), 0) : (_vm.integration_stages_options.length > 0) ? _c('div', _vm._l((_vm.matching), function(field, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "form-group item"
	    }, [_c('dropdown-select', {
	      attrs: {
	        "options": _vm.integration_stages_options,
	        "selected": field.integration,
	        "fullWidth": true
	      },
	      on: {
	        "input": _vm.updateProps
	      },
	      model: {
	        value: (field.integration),
	        callback: function($$v) {
	          _vm.$set(field, "integration", $$v)
	        },
	        expression: "field.integration"
	      }
	    })], 1)
	  }), 0) : _vm._e()])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "form-group"
	  }, [_c('strong', [_vm._v("Reev")])])
	}]}

/***/ }),
/* 1197 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadTasks),
	      expression: "loadTasks"
	    }],
	    staticClass: "task-list",
	    attrs: {
	      "id": "tasks",
	      "infinite-scroll-distance": "10"
	    }
	  }, [_vm._l((_vm.tasks), function(task, index) {
	    return [(task.contact) ? _c('done-task-item', {
	      key: task.id,
	      attrs: {
	        "task": task
	      },
	      on: {
	        "toggle-task-bar": _vm.bubbleUp,
	        "task-updated": _vm.taskUpdated
	      }
	    }) : _vm._e()]
	  }), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text",
	    attrs: {
	      "id": "no-more-results"
	    }
	  }, [_vm._v("Sem mais resultados")])], 1)], 2)
	},staticRenderFns: []}

/***/ }),
/* 1198 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.nextPage),
	      expression: "nextPage"
	    }],
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, _vm._l((_vm.voipCalls), function(voipCall) {
	    return _c('list-item', {
	      key: voipCall.id,
	      attrs: {
	        "voipCall": voipCall
	      }
	    })
	  }), 1)])])
	},staticRenderFns: []}

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "contacts-picker"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('contacts.actions.add')) + ": " + _vm._s(_vm.$t('flows.actions.contactsBase')))]), _vm._m(0)]), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadData),
	      expression: "loadData"
	    }],
	    staticClass: "modal-body no-top-padding",
	    attrs: {
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('contact-list', {
	    attrs: {
	      "contacts": _vm.contacts,
	      "user_id": _vm.user_id,
	      "view_mode": _vm.getViewMode(),
	      "initially_selected_contact_ids": _vm.selected_contact_ids
	    },
	    on: {
	      "contact-selected": _vm.updateContactSelection,
	      "filter": _vm.filter
	    }
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.fetching
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('groups.feedback.noMoreResults')))])], 1)], 1), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "select-contacts",
	      "data-dismiss": "modal"
	    },
	    on: {
	      "click": _vm.selectContacts
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.confirm')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1200 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "meetings-no-show-flow"
	    }
	  }, [_c('div', {
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Em caso de \"No Show\" de um lead, deseja enviá-lo para um fluxo?"), _c('br'), _vm._v("Se sim, digite o nome do fluxo abaixo ou clique no campo para um selecionar um."), _c('div', {
	    staticClass: "interations row"
	  }, [_c('div', {
	    staticClass: "col-md-6 contact-list-item-flow"
	  }, [_c('flows', {
	    staticClass: "field",
	    attrs: {
	      "user_id": _vm.selected_user,
	      "default_flow": _vm.default_flow
	    },
	    on: {
	      "flow-selected": _vm.selectFlow
	    }
	  })], 1), _c('div', {
	    staticClass: "col-md-6"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")])])])])])
	},staticRenderFns: []}

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_c('div', {
	    staticClass: "contact-event-icon pipedrive-icon"
	  }), _c('div', {
	    staticClass: "contact-event-header overflow-ellipsis"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
	    staticClass: "right-arrow glyphicon glyphicon-arrow-right"
	  }), _c('a', {
	    staticClass: "contact-event-description underlined",
	    attrs: {
	      "href": _vm.event.description,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.event.description))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters"
	  }, [_c('dropdown-select', {
	    attrs: {
	      "options": _vm.sort_options,
	      "selected": _vm.sort_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.sort_filter),
	      callback: function($$v) {
	        _vm.sort_filter = $$v
	      },
	      expression: "sort_filter"
	    }
	  }), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.template_category_options,
	      "selected": _vm.template_category_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.template_category_filter),
	      callback: function($$v) {
	        _vm.template_category_filter = $$v
	      },
	      expression: "template_category_filter"
	    }
	  }), (_vm.default_options.show_user_filter) ? _c('dropdown-select', {
	    attrs: {
	      "options": _vm.users_options,
	      "selected": _vm.user_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  }) : _vm._e(), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.kind_options,
	      "selected": _vm.kind_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.kind_filter),
	      callback: function($$v) {
	        _vm.kind_filter = $$v
	      },
	      expression: "kind_filter"
	    }
	  }), _c('div', {
	    staticClass: "search-field-wrapper"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-search glyphicon glyphicon-search",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.filter
	    }
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.text_field_filter),
	      expression: "text_field_filter"
	    }],
	    staticClass: "search-field form-control",
	    attrs: {
	      "placeholder": _vm.$t('template.actions.search'),
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.text_field_filter)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filter.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.text_field_filter = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "clear"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1203 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_c('div', {
	    staticClass: "contact-event-icon",
	    class: _vm.iconClass()
	  }), _c('div', {
	    staticClass: "contact-event-header"
	  }, [(_vm.event.humanStatus()) ? _c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title + " - " + _vm.event.humanStatus()))]) : _c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), (_vm.event.quotedDescription()) ? _c('div', {
	    staticClass: "contact-event-description"
	  }, [_vm._v(_vm._s(_vm.event.quotedDescription()))]) : _vm._e(), (_vm.event.flow.name) ? _c('div', {
	    staticClass: "contact-event-description"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v("do ")]), _vm._v(" Fluxo " + _vm._s(_vm.event.flow.name))]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), (_vm.event.email) ? _c('span', {
	    staticClass: "glyphicon glyphicon-eye-open showEmail",
	    on: {
	      "click": function($event) {
	        _vm.event.showEmail = !_vm.event.showEmail
	      }
	    }
	  }) : _vm._e(), (_vm.event.showEmail) ? _c('div', {
	    staticClass: "contact-event-email"
	  }, [(_vm.canResendEmail()) ? _c('div', {
	    staticClass: "contact-event-email-field"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email_value),
	      expression: "email_value"
	    }],
	    staticClass: "form-control pull-left",
	    domProps: {
	      "value": (_vm.email_value)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email_value = $event.target.value
	      }
	    }
	  }), _c('a', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "resendEmail"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.resendEmail(_vm.event)
	      }
	    }
	  }, [_vm._v("Reenviar")])]) : _vm._e(), (_vm.event.email.html) ? _c('div', {
	    staticClass: "contact-event-email-body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.remove_opening_register_pixel(_vm.event.email.html))
	    }
	  }) : (_vm.event.email.text) ? _c('div', {
	    staticClass: "contact-event-email-body"
	  }, [_vm._v(_vm._s(_vm.remove_opening_register_pixel(_vm.event.email.text)))]) : _vm._e()]) : _vm._e(), (_vm.event.call_recording_url) ? _c('div', {
	    staticClass: "audio-wrapper pull-right"
	  }, [_c('audio', {
	    attrs: {
	      "controls": "controls"
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": _vm.event.call_recording_url,
	      "type": "audio/mpeg"
	    }
	  })])]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1204 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('a', {
	    staticClass: "back-link-spaced",
	    on: {
	      "click": _vm.back
	    }
	  }, [_vm._v(_vm._s(_vm.name || 'Voltar'))])
	},staticRenderFns: []}

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadTemplates),
	      expression: "loadTemplates"
	    }],
	    staticClass: "table",
	    attrs: {
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('div', {
	    staticClass: "table-actions light-gray"
	  }, [_c('filters', {
	    attrs: {
	      "filters": _vm.filters,
	      "options": _vm.filter_options
	    },
	    on: {
	      "filter": _vm.filter
	    }
	  })], 1), _c('div', {
	    staticClass: "table-body"
	  }, _vm._l((_vm.templates), function(template) {
	    return _c('list-item', {
	      key: template.id,
	      attrs: {
	        "template": template,
	        "options": _vm.list_item_options
	      },
	      on: {
	        "showModal": _vm.showTemplate,
	        "template-selected": _vm.bubbleUp,
	        "confirm-destroy": _vm.showDestroyConfirmationModal
	      }
	    })
	  }), 1)]), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('template.feedback.noDataResults')))])], 1), (_vm.modal_template) ? _c('show-modal', {
	    attrs: {
	      "template": _vm.modal_template
	    }
	  }) : _vm._e(), _c('confirm-modal', {
	    attrs: {
	      "id": "destroy-template-confirmation-modal",
	      "title": _vm.$t('template.label.removeTemplateConfirm'),
	      "message": _vm.destroy_confirm_modal_message,
	      "confirm_text": _vm.$t('general.actions.delete'),
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.destroy
	    }
	  }), _c('go-to-top')], 1)
	},staticRenderFns: []}

/***/ }),
/* 1206 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dropdown"
	  }, [_c('button', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown",
	      "data-target": '.dropdownFilterTags' + _vm.index
	    }
	  }, [_vm._v(_vm._s(_vm.dropdown_title)), _c('span', {
	    staticClass: "gray-bold-caret"
	  }), _c('filter-tags-autocomplete', {
	    staticClass: "dropdownFilterTags",
	    class: 'dropdownFilterTags' + _vm.index,
	    attrs: {
	      "id": "dropdownFilterTags",
	      "filter_item_selected_ids": _vm.filter_item_selected_ids,
	      "uncheck_all_items": _vm.uncheck_all_items
	    },
	    on: {
	      "item-selected-items": _vm.itemSelectedItems
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1207 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.show_alert) ? _c('div', {
	    staticClass: "wrapper-email-alert-tick"
	  }, [_c('div', {
	    staticClass: "alert-tick alert-red"
	  }, [_vm._v("!")]), _c('div', {
	    attrs: {
	      "id": "account-status-info",
	      "align": "center"
	    }
	  }, [(_vm.quota_exceeded) ? _c('div', [_vm._m(0), _c('div', {
	    staticClass: "body"
	  }, [_vm._v("O seu servidor de email emitiu um alerta e por isso bloqueamos os envios de email na sua conta temporariamente.")]), _c('br'), _c('div', {
	    staticClass: "body"
	  }, [_vm._v("Você pode remover esse bloqueio ao enviar um email manualmente, mas sua conta será bloqueada novamente caso o servidor emita um novo alerta.")]), _c('br'), _c('div', {
	    staticClass: "call-to-action"
	  }, [_vm._v("Para saber mais "), _c('a', {
	    staticClass: "call-to-action-link",
	    attrs: {
	      "href": _vm.to_article,
	      "target": "_blank"
	    }
	  }, [_vm._v("clique aqui")]), _vm._v(".")])]) : _vm._e(), (!_vm.quota_exceeded) ? _c('div', [_vm._m(1), _c('div', {
	    staticClass: "body"
	  }, [_vm._v("Isso pode afetar o funcionamento do seu Reev.")]), (_vm.show_support_info) ? _c('div', {
	    staticClass: "support-info"
	  }, [_vm._v("Favor entrar em contato com o suporte.")]) : _vm._e(), (_vm.show_resync_info) ? _c('div', {
	    staticClass: "resync-info"
	  }, [_vm._v("Por favor, reconecte sua conta de e-mail.")]) : _vm._e(), (_vm.show_call_to_action) ? _c('div', {
	    staticClass: "call-to-action"
	  }, [_vm._v("Para ressincronizar o seu email "), _c('a', {
	    staticClass: "call-to-action-link",
	    on: {
	      "click": _vm.redirect
	    }
	  }, [_vm._v("clique aqui")]), _vm._v(".")]) : _vm._e()]) : _vm._e()])]) : _vm._e()
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('strong', [_vm._v("Atenção")]), _vm._v(": Limite de envios excedido!")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "title"
	  }, [_c('strong', [_vm._v("Atenção")]), _vm._v(": Email dessincronizado!")])
	}]}

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lost-reason-form",
	    class: {
	      'width-flow': _vm.send_to_new_flow
	    }
	  }, [_c('div', {
	    staticClass: "lost-reason-form_header"
	  }, [_c('strong', [_vm._v(_vm._s(_vm.contact.full_name))]), _c('br'), _vm._v(_vm._s(_vm.contact.business.name))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "flow-form__lost-selects"
	  }, [_c('form', {
	    staticClass: "row"
	  }, [(_vm.status == 'connected') ? _c('div', {
	    staticClass: "div col-md",
	    class: {
	      'col-md-12': !_vm.send_to_new_flow, 'col-md-5': _vm.send_to_new_flow
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('new_stage')
	    }
	  }, [_c('label', [_vm._v("Selecione o novo estágio")]), _c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "data-vv-name": "new_stage",
	      "options": _vm.next_valid_stages
	    },
	    model: {
	      value: (_vm.new_stage),
	      callback: function($$v) {
	        _vm.new_stage = $$v
	      },
	      expression: "new_stage"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('new_stage')),
	      expression: "errors.has('new_stage')"
	    }],
	    key: "new_stage",
	    staticClass: "help-block"
	  }, [_vm._v("Favor selecionar o estágio")])])], 1), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Comentário:")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.comment),
	      expression: "comment"
	    }],
	    staticClass: "form-control",
	    domProps: {
	      "value": (_vm.comment)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.comment = $event.target.value
	      }
	    }
	  })])]) : _vm._e(), (_vm.status == false || _vm.status == 'lost' || _vm.status == 'blocklisted') ? _c('div', {
	    staticClass: "div col-md",
	    class: {
	      'col-md-12': !_vm.send_to_new_flow, 'col-md-5': _vm.send_to_new_flow
	    }
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('lost_reason_unit')
	    }
	  }, [_c('label', [_vm._v("Motivo de Perda")]), _c('dropdown-select', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "field",
	    class: {
	      'cursor-not-allowed': _vm.disable_lost_reason_selection
	    },
	    attrs: {
	      "disabled": _vm.disable_lost_reason_selection,
	      "data-vv-name": "lost_reason_unit",
	      "options": _vm.lostReasonOptions()
	    },
	    model: {
	      value: (_vm.lost_reason_id),
	      callback: function($$v) {
	        _vm.lost_reason_id = $$v
	      },
	      expression: "lost_reason_id"
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('lost_reason_unit')),
	      expression: "errors.has('lost_reason_unit')"
	    }],
	    key: "lost_reason_unit",
	    staticClass: "help-block"
	  }, [_vm._v("Favor selecionar o motivo de perda")])])], 1), (_vm.showCheckStatus) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Deseja atribuir status abaixo:")]), _c('div', {
	    staticClass: "checkbox-inline contact-list-item-checkbox-item clickable-element"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.checkBlocklist),
	      expression: "checkBlocklist"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "id": "checkBlocklist"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.checkBlocklist) ? _vm._i(_vm.checkBlocklist, null) > -1 : (_vm.checkBlocklist)
	    },
	    on: {
	      "change": function($event) {
	        var $$a = _vm.checkBlocklist,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.checkBlocklist = $$a.concat([$$v]))
	          } else {
	            $$i > -1 && (_vm.checkBlocklist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.checkBlocklist = $$c
	        }
	      }
	    }
	  }), _c('label', {
	    attrs: {
	      "for": "checkBlocklist"
	    }
	  }, [_vm._v("Blocklist")])])]) : _vm._e(), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Comentário:")]), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.lost_reason_comment),
	      expression: "lost_reason_comment"
	    }],
	    staticClass: "form-control",
	    domProps: {
	      "value": (_vm.lost_reason_comment)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.lost_reason_comment = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('div', {
	    staticClass: "toggler-inline",
	    class: {
	      'cursor-not-allowed': _vm.disable_lost_reason_selection
	    },
	    on: {
	      "click": function($event) {
	        return _vm.toggleType()
	      }
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": _vm.send_to_new_flow
	    }
	  }), _c('label', [_vm._v("Enviar para novo fluxo?")])])])]) : _vm._e(), (_vm.send_to_new_flow) ? _c('div', {
	    staticClass: "line-vertical"
	  }) : _vm._e(), (_vm.send_to_new_flow) ? _c('div', {
	    staticClass: "div col-md col-md-7"
	  }, [_c('div', {
	    staticClass: "form-group contact-list-item-flow autocomplete-flow",
	    class: {
	      'has-error': !_vm.flow && _vm.send_to_new_flow, 'has-warning': _vm.flow == _vm.contact.flow.id && _vm.contact.flow.id
	    }
	  }, [_c('label', [_vm._v("Buscar por nome do fluxo")]), _c('flows', {
	    staticClass: "field",
	    attrs: {
	      "user_id": _vm.selected_user
	    },
	    on: {
	      "flow-selected": _vm.selectFlow
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.flow && _vm.send_to_new_flow && _vm.tried_to_save),
	      expression: "!flow && send_to_new_flow && tried_to_save"
	    }],
	    key: "flow_error",
	    staticClass: "help-block"
	  }, [_vm._v("Favor selecionar o novo fluxo")]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.flow == _vm.contact.flow.id && _vm.contact.flow.id),
	      expression: "flow == contact.flow.id && contact.flow.id"
	    }],
	    key: "flow_warning",
	    staticClass: "help-block"
	  }, [_vm._v("O contato já passou por este fluxo e será reiniciado.")])])], 1), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Selecione um período para reativação"), _c('div', _vm._l((_vm.reactivation_period_options), function(period) {
	    return _c('span', [_c('button', {
	      staticClass: "button-reactivation-period",
	      class: {
	        'selected': period.days == _vm.reactivation_period
	      },
	      attrs: {
	        "type": "button"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.setReactivationPeriod(period.days)
	        }
	      }
	    }, [_vm._v(_vm._s(period.label))])])
	  }), 0)])]), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Data Customizada:")]), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-3 no-padding"
	  }, [_c('input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ("##/##/####"),
	      expression: "\"##/##/####\""
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|regex:^([0-3][0-9]/[0-1][0-9]/[0-3][0-9][0-9][0-9])$'),
	      expression: "'required|regex:^([0-3][0-9]/[0-1][0-9]/[0-3][0-9][0-9][0-9])$'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.due_on_date),
	      expression: "due_on_date"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "due_on_date",
	      "placeholder": "DD/MM/AAAA"
	    },
	    domProps: {
	      "value": (_vm.due_on_date)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.due_on_date = $event.target.value
	      }
	    }
	  })]), _c('div', {
	    staticClass: "col-md-9 calendar-right-align"
	  }, [_c('datepicker', {
	    attrs: {
	      "inline": true,
	      "disabled": {
	        to: _vm.yesterday
	      },
	      "language": "pt-br"
	    },
	    model: {
	      value: (_vm.due_on_date_custom),
	      callback: function($$v) {
	        _vm.due_on_date_custom = $$v
	      },
	      expression: "due_on_date_custom"
	    }
	  })], 1)])]), (_vm.status !== 'connected') ? _c('div', {
	    staticClass: "form-group new-stage"
	  }, [_c('label', [_vm._v("Em qual estágio esse contato deve ser reativado?")]), _c('dropdown-select', {
	    staticClass: "field",
	    attrs: {
	      "options": _vm.next_valid_stages,
	      "selected": _vm.new_stage
	    },
	    model: {
	      value: (_vm.new_stage),
	      callback: function($$v) {
	        _vm.new_stage = $$v
	      },
	      expression: "new_stage"
	    }
	  })], 1) : _vm._e()]) : _vm._e()])]), _c('hr'), _c('div', {
	    staticClass: "lost-reason-form_footer"
	  }, [_c('div', {
	    staticClass: "btn btn-default",
	    on: {
	      "click": function($event) {
	        return _vm.$emit("close-lost-reason-modal")
	      }
	    }
	  }, [_vm._v("Cancelar")]), _c('div', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_vm._v("Salvar")])])])
	},staticRenderFns: []}

/***/ }),
/* 1209 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('title') || _vm.existing_title
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "name": "title",
	      "type": "text",
	      "placeholder": "Digite o nome da reunião"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('title')),
	      expression: "errors.has('title')"
	    }],
	    key: "title",
	    staticClass: "help-block"
	  }, [_vm._v("Favor preencher o campo acima")]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.existing_title),
	      expression: "existing_title"
	    }],
	    key: "existing_title",
	    staticClass: "help-block"
	  }, [_vm._v("O tipo de reunião já existe")])])], 1)]), _c('div', {
	    staticClass: "col-sm-5"
	  }, [_c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.submit
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Adicionar tipo de reunião")])]), _c('div', {
	    staticClass: "clear"
	  }), _c('br')])
	},staticRenderFns: []}

/***/ }),
/* 1210 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "new-group-modal"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg modal-xlg"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('groups.actions.create.title')))]), _vm._m(0)]), _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadContacts),
	      expression: "loadContacts"
	    }],
	    staticClass: "modal-body",
	    attrs: {
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('div', {
	    staticClass: "row info"
	  }, [_c('div', {
	    staticClass: "col-md-8 col-lg-6"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('groups.attributes.groupName')))]), _c('input', {
	    directives: [{
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required'),
	      expression: "'required'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.group_name),
	      expression: "group_name"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "name",
	      "name": "name",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.group_name)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.group_name = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "col-md-6 col-lg-6"
	  }, [_c('div', {
	    staticClass: "number-with-label"
	  }, [_c('div', {
	    staticClass: "number"
	  }, [_vm._v(_vm._s(_vm.contacts_count))]), _c('div', {
	    staticClass: "labels"
	  }, [_c('div', {
	    staticClass: "upper-label"
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.contacts')))]), _c('div', {
	    staticClass: "lower-label"
	  }, [_vm._v(_vm._s(_vm.$t('groups.label.added')))])]), _c('div', {
	    staticClass: "clear"
	  })])])]), _c('contact-list', {
	    attrs: {
	      "contacts": _vm.loaded_contacts,
	      "view_mode": _vm.contactListViewModes().group_picker,
	      "initially_selected_contact_ids": _vm.persisted_selected_contact_ids
	    },
	    on: {
	      "filter": _vm.filter,
	      "contact-selected": _vm.updateSelectedContacts
	    }
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v(_vm._s(_vm.$t('groups.feedback.noMoreResults')))])], 1)], 1), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "id": "select-contacts",
	      "disabled": !_vm.group_name
	    },
	    on: {
	      "click": _vm.createGroup
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.conclude')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "contacts-manual-picker"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog modal-lg"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_c('div', {
	    staticClass: "titleized"
	  }, [_vm._v(_vm._s(_vm.$t('contacts.actions.add')) + ": " + _vm._s(_vm.$t('general.label.Manually')))]), _vm._m(0)]), _c('div', {
	    staticClass: "modal-body"
	  }, [_c('contacts-picker-text-csv')], 1), _c('div', {
	    staticClass: "modal-footer"
	  }, [_c('div', {
	    staticClass: "btn btn-default",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]), _c('div', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": _vm.selectContacts
	    }
	  }, [_vm._v(_vm._s(_vm.$t('general.actions.conclude')))])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1212 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "modal",
	    attrs: {
	      "id": "recipient-schedule-reactivation"
	    }
	  }, [_c('div', {
	    staticClass: "modal-dialog"
	  }, [_c('div', {
	    staticClass: "modal-content"
	  }, [_c('div', {
	    staticClass: "modal-header"
	  }, [_vm._v(_vm._s(_vm.title_text)), _vm._m(0)]), _c('div', {
	    staticClass: "modal-body"
	  }, [(_vm.confirming_destroy_reactivation) ? _c('div', {
	    staticClass: "task-confirm-destroy"
	  }, [_vm._v("Deseja mesmo cancelar este agendamento?")]) : _c('div', {
	    staticClass: "task-form"
	  }, [_c('div', {
	    staticClass: "datepicker-wrapper col-md-12 col-sm-12 col-xs-12"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-sm-6 col-xs-12"
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    staticClass: "form-group due-on-time-picker-wrapper",
	    class: {
	      'has-error': !_vm.valid_due_on
	    }
	  }, [_c('label', [_vm._v("Horário")]), _c('input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ("##:##"),
	      expression: "\"##:##\""
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|regex:^([0-2][0-9]:[0-5][0-9])$'),
	      expression: "'required|regex:^([0-2][0-9]:[0-5][0-9])$'"
	    }, {
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.due_on_time),
	      expression: "due_on_time"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "type": "text",
	      "name": "due_on_time",
	      "placeholder": "HH:MM"
	    },
	    domProps: {
	      "value": (_vm.due_on_time)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.due_on_time = $event.target.value
	      }
	    }
	  }), _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(!_vm.valid_due_on) ? _c('div', {
	    staticClass: "help-block"
	  }, [_vm._v("Data e hora inválidas")]) : _vm._e()])], 1)]), (_vm.contact && _vm.valid_due_on) ? _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.due_on_text))])]) : _vm._e(), _c('hr'), _c('div', {
	    staticClass: "form-group new-stage"
	  }, [_c('label', [_vm._v("Em qual estágio esse contato deve ser reativado?")]), _c('dropdown-select', {
	    attrs: {
	      "options": _vm.next_valid_stages,
	      "selected": _vm.new_stage
	    },
	    model: {
	      value: (_vm.new_stage),
	      callback: function($$v) {
	        _vm.new_stage = $$v
	      },
	      expression: "new_stage"
	    }
	  })], 1)], 1), _c('div', {
	    staticClass: "col-md-6 col-sm-6 col-xs-12"
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', [_vm._v("Selecione a data")]), _c('datepicker', {
	    attrs: {
	      "inline": true,
	      "disabled": _vm.past_dates,
	      "language": "pt-br"
	    },
	    model: {
	      value: (_vm.due_on_date),
	      callback: function($$v) {
	        _vm.due_on_date = $$v
	      },
	      expression: "due_on_date"
	    }
	  })], 1)])])])]), _c('div', {
	    staticClass: "modal-footer"
	  }, [(_vm.confirming_destroy_reactivation) ? _c('div', {
	    staticClass: "confirm-destroy-actions"
	  }, [_c('div', {
	    staticClass: "btn btn-gray",
	    on: {
	      "click": function($event) {
	        return _vm.toggleConfirmDestroyScheduledReactivation()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _c('div', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.destroyScheduledReactivation()
	      }
	    }
	  }, [_vm._v("Sim, cancelar")])]) : _c('div', {
	    staticClass: "task-actions"
	  }, [_c('div', {
	    staticClass: "btn btn-gray",
	    attrs: {
	      "data-dismiss": "modal"
	    }
	  }, [_vm._v("Fechar")]), (_vm.task.isPersisted()) ? _c('div', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.toggleConfirmDestroyScheduledReactivation()
	      }
	    }
	  }, [_vm._v("Remover")]) : _vm._e(), (_vm.valid_due_on) ? _c('div', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.scheduleReactivation()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.save_task_text))]) : _c('div', {
	    staticClass: "btn btn-primary",
	    attrs: {
	      "disabled": "disabled"
	    }
	  }, [_vm._v(_vm._s(_vm.save_task_text))])])])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "close",
	    attrs: {
	      "type": "button",
	      "data-dismiss": "modal",
	      "aria-label": "Close"
	    }
	  }, [_c('span', {
	    attrs: {
	      "aria-hidden": "true"
	    }
	  }, [_vm._v("×")])])
	}]}

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_dialer),
	      expression: "show_dialer"
	    }],
	    attrs: {
	      "id": "dialer"
	    }
	  }, [_c('div', {
	    class: {
	      orange: _vm.show_numbers && _vm.is_calling_on || (_vm.status == 'calling' || _vm.status == 'ended' || _vm.status == 'failed')
	    },
	    attrs: {
	      "id": "open-dialer"
	    }
	  }, [(_vm.status == 'idle') ? _c('div', {
	    staticClass: "close-dialer",
	    on: {
	      "click": _vm.close
	    }
	  }, [(_vm.status == "idle") ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(48)
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": __webpack_require__(972)
	    }
	  })]) : _vm._e(), ((_vm.show_numbers || _vm.status == 'idle') && !_vm.task.id && !_vm.contact) ? _c('contact-autocomplete', {
	    attrs: {
	      "from_dialer": true
	    },
	    on: {
	      "contact-selected": _vm.selectContact
	    }
	  }) : _vm._e(), ((_vm.show_numbers || _vm.status == 'idle') && _vm.contact) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.input_number),
	      expression: "input_number"
	    }],
	    ref: "phone_input",
	    staticClass: "phone-number",
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.input_number)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.input_number = $event.target.value
	      }
	    }
	  }) : _vm._e(), (_vm.show_numbers || _vm.status == 'idle') ? _c('div', {
	    staticClass: "btn-backspace",
	    on: {
	      "click": function($event) {
	        return _vm.removeLastPhoneNumber()
	      }
	    }
	  }) : _vm._e(), ((_vm.show_numbers || _vm.status == 'idle') && _vm.status != 'ended') ? _c('div', {
	    staticClass: "numbers noselect",
	    class: _vm.dial_css_class
	  }, [_c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("1")
	      }
	    }
	  }, [_vm._v("1")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("2")
	      }
	    }
	  }, [_vm._v("2")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("3")
	      }
	    }
	  }, [_vm._v("3")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("4")
	      }
	    }
	  }, [_vm._v("4")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("5")
	      }
	    }
	  }, [_vm._v("5")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("6")
	      }
	    }
	  }, [_vm._v("6")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("7")
	      }
	    }
	  }, [_vm._v("7")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("8")
	      }
	    }
	  }, [_vm._v("8")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("9")
	      }
	    }
	  }, [_vm._v("9")]), _c('div', {
	    staticClass: "number padding-top",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("*")
	      }
	    }
	  }, [_vm._v("*")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("0")
	      }
	    }
	  }, [_vm._v("0")]), _c('div', {
	    staticClass: "number",
	    on: {
	      "click": function($event) {
	        return _vm.insertPhoneNumber("#")
	      }
	    }
	  }, [_vm._v("#")])]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), (_vm.contact && _vm.status != 'idle' && !_vm.show_numbers) ? _c('div', {
	    staticClass: "contact-info",
	    class: _vm.status
	  }, [_c('div', {
	    staticClass: "contact-name",
	    on: {
	      "click": function($event) {
	        return _vm.openContact(_vm.contact.id)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.contact.full_name))]), _c('div', {
	    staticClass: "contact-company"
	  }, [_vm._v(_vm._s(_vm.contact.business.name))]), _c('div', {
	    staticClass: "contact-phone",
	    class: _vm.status
	  }, [_c('div', {
	    staticClass: "contact-number"
	  }, [_vm._v("+" + _vm._s(_vm.phone_number))]), _c('div', {
	    staticClass: "contact-number-type"
	  }, [_vm._v(_vm._s(_vm.human_number_type))])])]) : _vm._e(), (_vm.status == "calling" && !_vm.show_numbers) ? _c('div', {
	    staticClass: "ringing-balls"
	  }, [_c('div', {
	    staticClass: "ball first"
	  }), _c('div', {
	    staticClass: "ball second"
	  }), _c('div', {
	    staticClass: "ball last"
	  })]) : _vm._e(), (_vm.status != "idle" && !_vm.show_numbers) ? _c('div', {
	    staticClass: "timer",
	    class: _vm.status
	  }, [(_vm.status != "calling") ? _c('div', {
	    staticClass: "time"
	  }, [_vm._v(_vm._s(_vm.timer))]) : _vm._e(), (_vm.status != "idle" && !_vm.show_numbers) ? _c('div', {
	    staticClass: "status"
	  }, [_vm._v(_vm._s(_vm.human_status))]) : _vm._e(), _c('div', {
	    staticClass: "fail-reason",
	    class: _vm.status
	  }, [_vm._v(_vm._s(_vm.human_fail_reason))])]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), (_vm.show_call_status_options) ? _c('div', {
	    staticClass: "call-status-options",
	    class: _vm.status
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("Defina um status para a tarefa:")]), _c('a', {
	    staticClass: "call-status-option",
	    class: {
	      active: _vm.call_status == "no_connection"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setCallStatus("no_connection")
	      }
	    }
	  }, [_vm._v("Sem conexão")]), (_vm.status != "failed") ? _c('div', [_c('a', {
	    staticClass: "call-status-option",
	    class: {
	      active: _vm.call_status == "gatekeeper"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setCallStatus("gatekeeper")
	      }
	    }
	  }, [_vm._v("Gatekeeper")]), _c('a', {
	    staticClass: "call-status-option",
	    class: {
	      active: _vm.call_status == "opportunity"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setCallStatus("opportunity")
	      }
	    }
	  }, [_vm._v("Conectado")]), _c('a', {
	    staticClass: "call-status-option",
	    class: {
	      active: _vm.call_status == "client"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setCallStatus("client")
	      }
	    }
	  }, [_vm._v("Cliente")]), _c('a', {
	    staticClass: "call-status-option",
	    class: {
	      active: _vm.call_status == "lost"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.setCallStatus("lost")
	      }
	    }
	  }, [_vm._v("Perdido")])]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('hr'), (_vm.contact && _vm.contact.tags) ? _c('div', {
	    staticClass: "tags"
	  }, [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v("Tags")]), _vm._l((_vm.contact.tags), function(tag, index) {
	    return _c('tag', {
	      attrs: {
	        "tag": tag,
	        "deletable": true
	      },
	      on: {
	        "remove-tag": _vm.removeTag
	      }
	    })
	  }), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
	    staticClass: "clickable inline",
	    on: {
	      "click": function($event) {
	        return _vm.openTagsModal()
	      }
	    }
	  }, [(_vm.contact.tags.length == 0) ? _c('span', [_vm._v("Adicionar Tags")]) : _vm._e(), _c('div', {
	    staticClass: "add-tags-btn glyphicon glyphicon-plus text-gray-color"
	  })]) : _vm._e()], 2) : _vm._e(), _c('hr'), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "btn btn-clean btn-new-task",
	    on: {
	      "click": function($event) {
	        return _vm.openTaskModalForm()
	      }
	    }
	  }, [_vm._v("Nova Tarefa")]), (_vm.contact) ? _c('div', {
	    staticClass: "dropdown"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.reset(_vm.input_number, _vm.phone_number_type)
	      }
	    }
	  }, [_vm._v("Mesmo número")])]), (_vm.contact.telephone) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.reset(_vm.default_country_preffix + _vm.contact.telephone, "telephone")
	      }
	    }
	  }, [_vm._v("Telefone " + _vm._s(_vm.contact.telephone))])]) : _vm._e(), (_vm.contact.cellphone) ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.reset(_vm.default_country_preffix + _vm.contact.cellphone, "cellphone")
	      }
	    }
	  }, [_vm._v("Celular " + _vm._s(_vm.contact.cellphone))])]) : _vm._e(), _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.reset(null, "")
	      }
	    }
	  }, [_vm._v("Novo número")])])])]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('a', {
	    staticClass: "finish-link",
	    on: {
	      "click": function($event) {
	        return _vm.saveCallContact(false)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-ok"
	  }), _c('span', [_vm._v("Finalizar Tarefa")])])]) : _vm._e(), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "bottom-buttons"
	  }, [(_vm.show_numbers && _vm.is_calling_on) ? _c('div', {
	    staticClass: "btn-back",
	    on: {
	      "click": function($event) {
	        return _vm.goBack()
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(965)
	    }
	  })]) : _vm._e(), (_vm.is_calling_on && !_vm.show_numbers) ? _c('div', {
	    staticClass: "btn-show-numbers",
	    on: {
	      "click": function($event) {
	        _vm.show_numbers = true
	      }
	    }
	  }, [(_vm.status == "calling") ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(991)
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": __webpack_require__(992)
	    }
	  })]) : _vm._e(), (_vm.is_calling_on) ? _c('div', {
	    staticClass: "btn-hangup",
	    on: {
	      "click": function($event) {
	        return _vm.hangupCall()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-earphone"
	  })]) : _vm._e(), (_vm.status == "idle") ? _c('div', {
	    staticClass: "btn-call",
	    on: {
	      "click": function($event) {
	        return _vm.startCall()
	      }
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-earphone"
	  })]) : _vm._e(), (_vm.is_calling_on && !_vm.muted) ? _c('div', {
	    staticClass: "btn-mute unmuted",
	    on: {
	      "click": function($event) {
	        return _vm.toggleMute()
	      }
	    }
	  }, [(_vm.status == 'calling' || _vm.show_numbers) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(979)
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": __webpack_require__(986)
	    }
	  })]) : _vm._e(), (_vm.is_calling_on && _vm.muted) ? _c('div', {
	    staticClass: "btn-mute muted",
	    on: {
	      "click": function($event) {
	        return _vm.toggleMute()
	      }
	    }
	  }, [(_vm.status == 'calling' || _vm.show_numbers) ? _c('img', {
	    attrs: {
	      "src": __webpack_require__(980)
	    }
	  }) : _c('img', {
	    attrs: {
	      "src": __webpack_require__(987)
	    }
	  })]) : _vm._e()]), (_vm.show_contact_button) ? _c('div', {
	    staticClass: "btn-contact btn-bottom",
	    class: _vm.status,
	    on: {
	      "click": _vm.toggleTaskBar
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(968)
	    }
	  })]) : _vm._e(), _c('div', {
	    staticClass: "btn-comments btn-bottom",
	    class: _vm.status,
	    on: {
	      "click": function($event) {
	        return _vm.newComment(true)
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": __webpack_require__(967)
	    }
	  })])], 1), _c('div', {
	    attrs: {
	      "id": "minimized-dialer"
	    }
	  }), (_vm.show_lost_reason_modal) ? _c('lost-reason-modal', {
	    staticStyle: {
	      "top": "0",
	      "left": "102%"
	    },
	    attrs: {
	      "contact": _vm.contact,
	      "temp_attr": _vm.temp_attr
	    },
	    on: {
	      "close-lost-reason-modal": function($event) {
	        return _vm.closeLostReasonModal()
	      },
	      "update-contact-recipient": _vm.updateLostContact
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "btn-button btn-primary btn-new-try",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_vm._v("Nova Tentativa"), _c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	}]}

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_c('div', {
	    staticClass: "contact-event-icon comment-icon"
	  }), _c('div', {
	    staticClass: "contact-event-header"
	  }, [_c('span', {
	    staticClass: "contact-event-title"
	  }, [_vm._v("Comentado por " + _vm._s(_vm.event.author))]), _c('span', {
	    staticClass: "contact-event-time"
	  }, [_vm._v("em " + _vm._s(_vm.event.created_at.format('LLL')) + ".")]), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.has_edition),
	      expression: "has_edition"
	    }],
	    staticClass: "contact-event-title",
	    attrs: {
	      "data-toggle": "tooltip",
	      "title": _vm.event.updated_at.format('DD/MM/YYYY [às] HH:mm')
	    }
	  }, [_vm._v("Última edição: " + _vm._s(_vm.event.edition_author))]), _c('div', {
	    staticClass: "clearfix"
	  }), (!_vm.showSummernote) ? _c('div', {
	    staticClass: "contact-event-description clickable",
	    on: {
	      "click": function($event) {
	        return _vm.toogleSummernote()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.short_description))]) : _vm._e(), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.showSummernote),
	      expression: "showSummernote"
	    }],
	    staticClass: "contact-event-summernote"
	  }, [_c('textarea', {
	    attrs: {
	      "id": _vm.element_id
	    }
	  }), _c('div', {
	    staticClass: "add-comment-click comment-buttons"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    on: {
	      "click": function($event) {
	        _vm.showSummernote = !_vm.showSummernote
	      }
	    }
	  }, [_vm._v("Cancelar")]), (_vm.user_can_edit) ? _c('button', {
	    staticClass: "btn btn-danger",
	    on: {
	      "click": function($event) {
	        return _vm.removeComment()
	      }
	    }
	  }, [_vm._v("Excluir")]) : _vm._e(), (_vm.user_can_edit) ? _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.updateComment()
	      }
	    }
	  }, [_vm._v("Salvar")]) : _vm._e()])]), _c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.showSummernote),
	      expression: "!showSummernote"
	    }],
	    staticClass: "glyphicon glyphicon-trash delete-event-btn clickable",
	    on: {
	      "click": _vm.removeComment
	    }
	  })]), _c('div', {
	    staticClass: "clear"
	  }), _c('confirm-modal', {
	    attrs: {
	      "id": _vm.modal_id,
	      "title": "Excluir comentário",
	      "message": "Deseja realmente excluir este comentário?",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.confirmRemoveComment
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1215 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "user-miniature-wrapper overflow-hidden"
	  }, [_c('div', {
	    staticClass: "user-miniature-picture-wrapper"
	  }, [_c('img', {
	    staticClass: "user-miniature-picture",
	    attrs: {
	      "src": _vm.user.picture_url,
	      "title": _vm.user_full_name
	    }
	  })]), (!_vm.options || !_vm.options.only_picture) ? _c('div', {
	    staticClass: "user-miniature-name overflow-ellipsis"
	  }, [_vm._v(_vm._s(_vm.user_name))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 1216 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "dropdown"
	  }, [_c('a', {
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    },
	    on: {
	      "click": _vm.validateUpdateContactUser
	    }
	  }, [_c('user-miniature', {
	    staticStyle: {
	      "display": "inline-block"
	    },
	    attrs: {
	      "user": _vm.contact.user
	    }
	  })], 1), _c('ul', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.canUpdateContactUser() && _vm.users.length),
	      expression: "canUpdateContactUser() && users.length"
	    }],
	    staticClass: "dropdown-menu"
	  }, _vm._l((_vm.user_options), function(user) {
	    return (_vm.showUserOption(user)) ? _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.openUpdateContactUserConfirmationModal(user)
	        }
	      }
	    }, [_vm._v(_vm._s(user.name))])]) : _vm._e()
	  }), 0)]), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-update-contact-user",
	      "title": "Alterar responsável",
	      "confirm_text": "Alterar",
	      "confirm_class": "btn-primary"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.updateContactUser
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Confirma alteração do responsável abaixo?")]), _c('strong', {
	    staticClass: "bold reev-base-green-color"
	  }, [_c('br'), _c('span', [_vm._v(_vm._s(_vm.contact.user.name))]), _c('span', {
	    staticClass: "separator glyphicon glyphicon-arrow-right text-gray-color"
	  }), _c('span', [_vm._v(_vm._s(_vm.selected_user.name))])])]), _c('br')])], 1)
	},staticRenderFns: []}

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app-wrapper"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "header-wrapper"
	    }
	  }, [(_vm.show_notifications) ? _c('router-view', {
	    attrs: {
	      "name": "header"
	    }
	  }) : _vm._e()], 1), (_vm.is_authorized) ? _c('global-boxes') : _vm._e(), _c('div', {
	    staticClass: "container",
	    attrs: {
	      "id": "current-view-wrapper"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "enter"
	    }
	  }, [_c('router-view', {
	    attrs: {
	      "name": "app"
	    }
	  })], 1)], 1)], 1)
	},staticRenderFns: []}

/***/ }),
/* 1218 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    attrs: {
	      "id": "flows-index"
	    }
	  }, [_c('div', {
	    staticClass: "header-with-icon"
	  }, [_c('div', {
	    staticClass: "icon folder-icon"
	  }), _c('div', {
	    staticClass: "title-wrapper"
	  }, [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.$t('flows.title.libFlows')))]), _c('span', {
	    staticClass: "light-gray-text"
	  }, [_vm._v(_vm._s(_vm.$t('flows.subtitle.libFlows')))])]), _c('div', {
	    staticClass: "clear"
	  }), _c('br'), _c('list', {
	    attrs: {
	      "list_item_options": _vm.list_item_options,
	      "filter_options": _vm.filter_options,
	      "options": _vm.options
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1219 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "dashboard-panel"
	  }, [_c('div', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
	    staticClass: "filters inline pull-right"
	  }, [_vm._t("filters")], 2), _c('div', {
	    staticClass: "clear"
	  })]), _c('div', {
	    staticClass: "body"
	  }, [_vm._t("default")], 2)])
	},staticRenderFns: []}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    staticClass: "lupa glyphicon glyphicon-search"
	  }), _c('v-autocomplete', {
	    attrs: {
	      "id": _vm.id,
	      "items": _vm.companies,
	      "get-label": _vm.getLabel,
	      "component-item": _vm.item_company,
	      "min-len": 1,
	      "keep-open": true,
	      "input-attrs": _vm.attrs,
	      "auto-select-one-item": false
	    },
	    on: {
	      "update-items": _vm.searchCompanies,
	      "item-selected": _vm.selectedCompany
	    },
	    model: {
	      value: (_vm.company),
	      callback: function($$v) {
	        _vm.company = $$v
	      },
	      expression: "company"
	    }
	  }), (_vm.show_no_result_found_message) ? _c('div', {
	    staticClass: "no-result-found"
	  }, [_vm._v("Não há resultados de empresa para essa busca.")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters"
	  }, [(_vm.header) ? [_c('dashboard-panel', {
	    attrs: {
	      "title": "Contatos pendentes"
	    }
	  }, [_c('div', {
	    attrs: {
	      "slot": "filters"
	    },
	    slot: "filters"
	  }, [_c('dropdown-select', {
	    staticClass: "field dashboard-filter user-filter pull-right",
	    attrs: {
	      "options": _vm.users_options
	    },
	    on: {
	      "input": _vm.reloadContacts
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  })], 1)])] : [_c('h2', {
	    staticClass: "inline"
	  }, [_vm._v("Contatos pendentes")]), _c('dropdown-select', {
	    staticClass: "field pull-right",
	    attrs: {
	      "options": _vm.users_options
	    },
	    on: {
	      "input": _vm.reloadContacts
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  }), _c('br'), _c('br')], _c('div', {
	    directives: [{
	      name: "infinite-scroll",
	      rawName: "v-infinite-scroll",
	      value: (_vm.loadContacts),
	      expression: "loadContacts"
	    }],
	    class: _vm.getClass(),
	    attrs: {
	      "infinite-scroll-distance": "10"
	    }
	  }, [_c('contact-list', {
	    attrs: {
	      "contacts": _vm.contacts,
	      "view_mode": _vm.contactListViewModes().paused_contacts,
	      "filters": {}
	    },
	    on: {
	      "contact-update": _vm.updateContact,
	      "contact-recipient-update": _vm.updateContactRecipient,
	      "toggle-task-bar": _vm.bubbleUp
	    }
	  }), _c('div', {
	    attrs: {
	      "align": "center"
	    }
	  }, [_c('loading', {
	    attrs: {
	      "loading": _vm.loading
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.next_page),
	      expression: "!next_page"
	    }],
	    staticClass: "light-gray-text light-text"
	  }, [_vm._v("Sem mais resultados")])], 1)], 1), _c('reactivate-recipient-modal', {
	    attrs: {
	      "contact": _vm.schedule_reactivation_contact
	    }
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 1223 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters"
	  }, [(_vm.show_status_filter) ? _c('dropdown-select', {
	    attrs: {
	      "options": _vm.status_options,
	      "selected": _vm.status_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.status_filter),
	      callback: function($$v) {
	        _vm.status_filter = $$v
	      },
	      expression: "status_filter"
	    }
	  }) : _vm._e(), (_vm.show_stage_filter) ? _c('dropdown-select', {
	    attrs: {
	      "options": _vm.stage_options,
	      "selected": _vm.stage_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.stage_filter),
	      callback: function($$v) {
	        _vm.stage_filter = $$v
	      },
	      expression: "stage_filter"
	    }
	  }) : _vm._e(), (_vm.show_user_filter) ? _c('dropdown-select', {
	    attrs: {
	      "options": _vm.users_options,
	      "selected": _vm.user_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  }) : _vm._e(), (_vm.show_group_filter) ? _c('autocomplete-group', {
	    attrs: {
	      "user_id": _vm.user_id
	    },
	    on: {
	      "group-selected": _vm.updateGroup
	    }
	  }) : _vm._e(), (_vm.show_lost_reason_filter) ? _c('dropdown-select', {
	    attrs: {
	      "options": _vm.lost_reason_options,
	      "selected": _vm.lost_reason_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.lost_reason_filter),
	      callback: function($$v) {
	        _vm.lost_reason_filter = $$v
	      },
	      expression: "lost_reason_filter"
	    }
	  }) : _vm._e(), (_vm.show_tag_filter) ? _c('dropdown-multiple-select', {
	    attrs: {
	      "filter_item_selected_ids": _vm.filter_item_selected_ids,
	      "kind": _vm.kind_multiple_filter,
	      "uncheck_all_items": _vm.uncheck_all_items
	    },
	    on: {
	      "item-selected-items": _vm.itemSelectedItems
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "btn btn-primary clear-filter",
	    attrs: {
	      "disabled": _vm.pristine_filter,
	      "type": "button"
	    },
	    on: {
	      "click": _vm.clearFilter
	    }
	  }, [_c('span', {
	    staticClass: "clean-icon glyphicon glyphicon-remove-circle"
	  }), (_vm.label_clear_filter) ? _c('span', {
	    staticClass: "clean-text"
	  }, [_vm._v(_vm._s(_vm.$t('flows.label.clearFilters')))]) : _vm._e()]), _c('div', {
	    staticClass: "search-field-wrapper"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-search glyphicon glyphicon-search",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.filter
	    }
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.text_field_filter),
	      expression: "text_field_filter"
	    }],
	    staticClass: "search-field form-control",
	    attrs: {
	      "placeholder": _vm.$t('contacts.label.searchContact'),
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.text_field_filter)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filter.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.text_field_filter = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "clear"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1224 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "contact-item contacts-show",
	    attrs: {
	      "id": "contacts-show"
	    }
	  }, [_c('back-link'), _c('div', {
	    staticClass: "header-with-action"
	  }, [_c('h1', {
	    staticClass: "pull-left"
	  }, [_c('p', {
	    staticClass: "contacts-show__title-wrapper"
	  }, [_c('span', {
	    staticClass: "title",
	    class: _vm.contact.stage
	  }, [_vm._v(_vm._s(_vm.contact.full_name))])]), (_vm.has_business) ? _c('p', [_c('router-link', {
	    staticClass: "link sub-header",
	    attrs: {
	      "to": '/contatos/empresas/' + _vm.contact.business.id
	    }
	  }, [_vm._v(_vm._s(_vm.contact.business.name))])], 1) : _c('p', {
	    staticClass: "sub-header"
	  }, [_vm._v(_vm._s(_vm.contact.base_business_name || "-"))])]), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
	    staticClass: "dropdown pull-right"
	  }, [_vm._m(0), _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    staticClass: "remove-contact",
	    on: {
	      "click": _vm.removeContact
	    }
	  }, [_vm._v("Excluir")])])])]) : _vm._e(), _c('div', {
	    staticClass: "spacer-15 pull-right"
	  }), (!_vm.current_user.isMonitoringManager() && _vm.show_new_task_button) ? _c('button', {
	    staticClass: "btn btn-clean pull-right",
	    attrs: {
	      "id": "open-task-modal-form-btn"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.newTask($event)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "icon-more"
	  }, [_vm._v("+")]), _vm._v("Nova Tarefa")]) : _vm._e()]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "row",
	    on: {
	      "change": _vm.setDirty
	    }
	  }, [_c('div', {
	    staticClass: "col-md-3"
	  }, [_c('aside', {
	    staticClass: "sidebar"
	  }), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v("Estágio")]), _c('div', {
	    staticClass: "dropdown"
	  }, [_c('a', {
	    class: _vm.contactItemStageClasses(),
	    attrs: {
	      "type": "button",
	      "data-toggle": _vm.contactStageDropdownAvailable()
	    }
	  }, [_c('div', {
	    staticClass: "contact-stage"
	  }, [_vm._v(_vm._s(_vm.contact.human_stage))])]), (!_vm.current_user.isMonitoringManager()) ? _c('ul', {
	    staticClass: "dropdown-menu"
	  }, _vm._l((_vm.contact.next_valid_stages), function(next_stage_options, next_stage) {
	    return _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.setLostInfo({
	            stage: next_stage
	          })
	        }
	      }
	    }, [_vm._v(_vm._s(next_stage_options.human_name))])])
	  }), 0) : _vm._e()])]), _c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v("Status")]), _c('div', {
	    staticClass: "dropdown hover-margin-status"
	  }, [_c('a', {
	    staticClass: "margin-status",
	    class: _vm.contactItemStatusClasses(),
	    attrs: {
	      "type": "button",
	      "data-toggle": _vm.contactStatusDropdownAvailable()
	    }
	  }, [_c('span', {
	    class: _vm.contactStatusIconClass()
	  }), _c('div', {
	    staticClass: "contact-status"
	  }, [_vm._v(_vm._s(_vm.contact.human_recipient_status))])]), (!_vm.current_user.isMonitoringManager()) ? _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_vm._l((_vm.contact.next_valid_recipient_statuses), function(next_status_options, next_status) {
	    return _c('li', [_c('a', {
	      class: {
	        "show-connected-options": next_status == "connected"
	      },
	      on: {
	        "click": function($event) {
	          return _vm.updateContactRecipient($event, {
	            status: next_status
	          })
	        }
	      }
	    }, [_vm._v(_vm._s(next_status_options.human_action_name)), _c('ul', {
	      staticClass: "dropdown-menu connected-options",
	      staticStyle: {
	        "display": "none"
	      }
	    }, [_c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.connectedAndSendToNewFlow($event)
	        }
	      }
	    }, [_vm._v("Enviar para fluxo")])]), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.connectedAndCreateTask($event)
	        }
	      }
	    }, [_vm._v("Criar tarefa")])]), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.connectedAndChangeStage($event)
	        }
	      }
	    }, [_vm._v("Alterar estágio")])]), _c('li', [_c('a', {
	      on: {
	        "click": function($event) {
	          return _vm.connectedAndLost($event)
	        }
	      }
	    }, [_vm._v("Perdido")])])])])])
	  }), (_vm.contact.recipient_status == 'converting') ? _c('li', [_c('a', {
	    on: {
	      "click": function($event) {
	        return _vm.openScheduleReactivationModal($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.scheduleReactivationText()))])]) : _vm._e()], 2) : _vm._e()])]), _c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v("Fluxo Atual")]), (_vm.flow && _vm.flow.id) ? _c('div', {
	    staticClass: "dropdown"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    class: {
	      'semi-automatic-flow': _vm.flow.semi_automatic
	    },
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_vm._v(_vm._s(_vm.flow.name)), (!_vm.current_user.isMonitoringManager()) ? _c('span', {
	    staticClass: "gray-bold-caret"
	  }) : _vm._e()]), (_vm.show_flow_dropdown && !_vm.current_user.isMonitoringManager()) ? _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    staticClass: "show_flow_autocomplete"
	  }, [_vm._v("Alterar Fluxo"), _c('flow-autocomplete', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "contact": _vm.contact
	    },
	    on: {
	      "flow-selected": _vm.updateContactInfo
	    }
	  })], 1), _c('a', {
	    on: {
	      "click": _vm.viewFlow
	    }
	  }, [_vm._v("Visualizar Fluxo")]), _c('a', {
	    on: {
	      "click": _vm.openRemoveContactFromFlowModal
	    }
	  }, [_vm._v("Remover Contato")])])]) : _vm._e()]) : _c('div', {
	    staticClass: "dropdown none"
	  }, [_c('a', {
	    staticClass: "dropdown-toggle",
	    attrs: {
	      "type": "button",
	      "data-toggle": "dropdown"
	    }
	  }, [_vm._v("Nenhum"), (!_vm.current_user.isMonitoringManager()) ? _c('span', {
	    staticClass: "gray-bold-caret"
	  }) : _vm._e()]), (_vm.show_flow_dropdown && !_vm.current_user.isMonitoringManager()) ? _c('ul', {
	    staticClass: "dropdown-menu"
	  }, [_c('li', [_c('a', {
	    staticClass: "show_flow_autocomplete"
	  }, [_vm._v("Enviar para Fluxo"), _c('flow-autocomplete', {
	    staticStyle: {
	      "display": "none"
	    },
	    attrs: {
	      "contact": _vm.contact
	    },
	    on: {
	      "flow-selected": _vm.updateContactInfo
	    }
	  })], 1)])]) : _vm._e()])]), (_vm.contact.lost_reason_title) ? _c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v("Motivo de perda")]), _c('span', [_vm._v(_vm._s(_vm.contact.lost_reason_title))])]) : _vm._e(), _c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v("Tag")]), _vm._l((_vm.contact.tags), function(tag) {
	    return _c('tag', {
	      attrs: {
	        "tag": tag,
	        "deletable": true
	      },
	      on: {
	        "remove-tag": _vm.removeTag
	      }
	    })
	  }), (!_vm.current_user.isMonitoringManager()) ? _c('div', {
	    staticClass: "clickable inline",
	    on: {
	      "click": function($event) {
	        return _vm.openTagsModal()
	      }
	    }
	  }, [(_vm.contact.tags.length == 0) ? _c('span', [_vm._v("Adicionar Tags")]) : _vm._e(), _c('div', {
	    staticClass: "add-tags-btn glyphicon glyphicon-plus text-gray-color"
	  })]) : _vm._e()], 2), _c('li', [_c('div', {
	    staticClass: "sidebar-menu-title"
	  }, [_vm._v("Responsável")]), _c('user-dropdown', {
	    attrs: {
	      "contact": _vm.contact
	    },
	    on: {
	      "update-contact": _vm.updateContact
	    }
	  }), _c('div', {
	    staticClass: "clear"
	  })], 1)])]), _c('div', {
	    staticClass: "col-md-9"
	  }, [_vm._m(1), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('div', {
	    staticClass: "tab-pane",
	    attrs: {
	      "id": "details-tab",
	      "role": "tabpanel"
	    }
	  }, [_c('contact-form', {
	    attrs: {
	      "contact": _vm.contact
	    }
	  })], 1), _c('div', {
	    staticClass: "tab-pane active",
	    attrs: {
	      "id": "events-tab",
	      "role": "tabpanel"
	    }
	  }, [_c('label', [_vm._v("TAREFAS")]), _c('div', {
	    staticClass: "spacer-15"
	  }), _c('contact-tasks', {
	    ref: "contact_tasks",
	    attrs: {
	      "prop_tooltip_placement": _vm.prop_tooltip_placement
	    },
	    on: {
	      "open-template-modal": _vm.loadTaskInfo,
	      "task-destroyed": _vm.taskDestroyed,
	      "toggle-task-bar": _vm.toggleTaskBar
	    }
	  }), _c('div', {
	    staticClass: "divider"
	  }), _c('label', [_vm._v("HISTÓRICO DE ATIVIDADES")]), _c('div', {
	    staticClass: "spacer-15"
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.user_can_edit_comment),
	      expression: "user_can_edit_comment"
	    }],
	    staticClass: "add-comment"
	  }, [_vm._m(2), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!_vm.show_summernote),
	      expression: "!show_summernote"
	    }],
	    staticClass: "add-comment-click clickable",
	    on: {
	      "click": function($event) {
	        return _vm.toogleSummernote()
	      }
	    }
	  }, [_vm._v("Clique aqui e escreva seu comentário")]), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_summernote),
	      expression: "show_summernote"
	    }],
	    staticClass: "hide-summernote"
	  }, [_c('textarea', {
	    attrs: {
	      "id": "comment",
	      "name": "comment"
	    }
	  })]), (_vm.show_summernote) ? _c('div', {
	    staticClass: "add-comment-click comment-buttons"
	  }, [_c('button', {
	    staticClass: "btn btn-gray",
	    on: {
	      "click": function($event) {
	        return _vm.cancelComment()
	      }
	    }
	  }, [_vm._v("Cancelar")]), _c('button', {
	    staticClass: "btn btn-primary",
	    on: {
	      "click": function($event) {
	        return _vm.saveComment()
	      }
	    }
	  }, [_vm._v("Salvar")])]) : _vm._e()]), _c('div', {
	    staticClass: "clearfix"
	  }, [_vm._v(" ")]), _c('contact-events', {
	    ref: "contact_events"
	  })], 1)])])]), (_vm.flow && _vm.flow.id) ? _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-remove-contact-from-flow",
	      "title": "Remover do fluxo",
	      "confirm_text": "Remover",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.confirmRemoveContactFromFlow
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Deseja remover o contato "), _c('strong', [_vm._v(_vm._s(_vm.contact.full_name))]), _vm._v(" do fluxo "), _c('strong', [_vm._v(_vm._s(_vm.flow.name))]), _vm._v("?")]), _c('br'), _c('div', [_c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v("Atenção")]), _vm._v(": a remoção desse contato irá afetar diretamente as estatísticas do fluxo.")])])]) : _vm._e(), _c('confirm-modal', {
	    attrs: {
	      "id": "confirm-remove-contact",
	      "title": "Excluir contato",
	      "confirm_text": "Sim, excluir",
	      "confirm_class": "btn-danger"
	    },
	    on: {
	      "confirm-modal-confirm": _vm.confirmRemoveContact
	    }
	  }, [_c('br'), _c('div', {
	    staticClass: "text-center"
	  }, [_c('div', [_vm._v("Confirma exclusão do contato abaixo?")]), _c('strong', {
	    staticClass: "dark-red-color"
	  }, [_vm._v(_vm._s(_vm.contact.full_name))])])]), _c('tag-picker-modal', {
	    ref: "tag_picker_modal",
	    attrs: {
	      "taggable": _vm.contact,
	      "prop_id": _vm.tag_picker_id
	    },
	    on: {
	      "picked": _vm.addTagsToContact
	    }
	  }), (_vm.show_lost_reason_modal) ? _c('lost-reason-modal', {
	    staticStyle: {
	      "top": "41.3%",
	      "left": "32.2%"
	    },
	    attrs: {
	      "contact": _vm.contact,
	      "temp_attr": _vm.temp_attr
	    },
	    on: {
	      "close-lost-reason-modal": function($event) {
	        return _vm.closeLostReasonModal()
	      },
	      "update-contact-recipient": _vm.updateLostContact
	    }
	  }) : _vm._e(), _c('reactivate-recipient-modal', {
	    attrs: {
	      "contact": _vm.schedule_reactivation_contact
	    }
	  })], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn btn-primary contact-show-actions btn-options dropdown-toggle",
	    attrs: {
	      "data-toggle": "dropdown"
	    }
	  }, [_c('span', {
	    staticClass: "glyphicon glyphicon-cog"
	  }), _c('span', {
	    staticClass: "text"
	  }, [_vm._v("Opções")]), _c('span', {
	    staticClass: "glyphicon glyphicon-menu-down"
	  })])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "tab-list",
	    attrs: {
	      "role": "tablist"
	    }
	  }, [_c('li', {
	    staticClass: "active",
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#events-tab",
	      "role": "tab",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Tarefas e Histórico")])]), _c('li', {
	    attrs: {
	      "role": "presentation"
	    }
	  }, [_c('a', {
	    attrs: {
	      "href": "#details-tab",
	      "role": "tab",
	      "data-toggle": "tab"
	    }
	  }, [_vm._v("Detalhes do Contato")])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "add-comment-header"
	  }, [_c('span', {
	    staticClass: "contact-comment-icon"
	  }, [_vm._v("Adicionar comentário")])])
	}]}

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_vm._m(0), _c('div', {
	    staticClass: "clear"
	  }), _vm._m(1), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [_c('a', {
	    staticClass: "btn btn-primary configure",
	    on: {
	      "click": _vm.redirect
	    }
	  }, [_vm._v("Configurar e-mail")])])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [_c('img', {
	    staticClass: "computer",
	    attrs: {
	      "src": __webpack_require__(974)
	    }
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-12 text-center"
	  }, [_c('span', {
	    staticClass: "message"
	  }, [_vm._v("Antes de começar a usar o Reev, você deve conectar-se ao seu e-mail clicando no botão abaixo.")])])])
	}]}

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "compose preview",
	    attrs: {
	      "id": 'template-preview-' + _vm.template.id
	    }
	  }, [_c('div', {
	    staticClass: "full"
	  }, [_c('div', {
	    staticClass: "title",
	    class: _vm.template.kind
	  }, [_c('span', [_vm._v(_vm._s(_vm.template.name))]), _c('span', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "percentage"
	  }, [_vm._v(_vm._s(_vm.template.email_statistic.formattedPercentage(_vm.template.connectedCount())))]), _c('span', {
	    staticClass: "icon glyphicon glyphicon-transfer"
	  })]), (_vm.template.kind == 'email') ? _c('span', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "percentage"
	  }, [_vm._v(_vm._s(_vm.template.email_statistic.replyPercentage()))]), _c('span', {
	    staticClass: "icon glyphicon glyphicon-share-alt"
	  })]) : _vm._e(), (_vm.template.kind == 'email') ? _c('span', {
	    staticClass: "statistic"
	  }, [_c('div', {
	    staticClass: "percentage"
	  }, [_vm._v(_vm._s(_vm.template.email_statistic.openPercentage()))]), _c('span', {
	    staticClass: "icon glyphicon glyphicon-envelope"
	  })]) : _vm._e()]), _c('div', {
	    staticClass: "info"
	  }, [(_vm.template.subject && _vm.template.kind == "email") ? _c('div', {
	    staticClass: "info-group subject"
	  }, [_c('label', [_vm._v(_vm._s(_vm.$t('template.attributes.subject')))]), _c('span', [_vm._v(_vm._s(_vm.template.subject))])]) : _vm._e(), _c('div', {
	    staticClass: "info-group"
	  }, [_c('label', [_vm._v(_vm._s(_vm.template.contentLabel()))]), _c('div', {
	    staticClass: "body",
	    domProps: {
	      "innerHTML": _vm._s(_vm.template.body)
	    }
	  })]), _c('div', {
	    staticClass: "clear"
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 1227 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('span', {
	    domProps: {
	      "innerHTML": _vm._s(_vm.text)
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "container auth-view-wrapper"
	  }, [_c('img', {
	    staticClass: "logo",
	    attrs: {
	      "src": __webpack_require__(31),
	      "alt": "Reev"
	    }
	  }), _c('fieldset', [_c('legend', {
	    staticClass: "auth-legend"
	  }, [_vm._v("Redefinir senha")]), _c('transition-group', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.apiErrorMessages.length),
	      expression: "apiErrorMessages.length"
	    }],
	    attrs: {
	      "name": "fade"
	    }
	  }, _vm._l((_vm.apiErrorMessages), function(errorMessage) {
	    return _c('div', {
	      staticClass: "error-message"
	    }, [_vm._v(_vm._s(errorMessage))])
	  }), 0), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('password')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password),
	      expression: "user.password"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|min:6'),
	      expression: "'required|min:6'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "password_reset-password",
	      "type": "password",
	      "name": "password",
	      "placeholder": "Nova senha"
	    },
	    domProps: {
	      "value": (_vm.user.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "password", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password')),
	      expression: "errors.has('password')"
	    }],
	    key: "password",
	    staticClass: "help-block text-left"
	  }, [_vm._v(_vm._s(_vm.errors.first('password')))])], 1), _c('div', {
	    staticClass: "form-group",
	    class: {
	      'has-error': _vm.errors.has('password_confirmation')
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.user.password_confirmation),
	      expression: "user.password_confirmation"
	    }, {
	      name: "validate",
	      rawName: "v-validate",
	      value: ('required|confirmed:password'),
	      expression: "'required|confirmed:password'"
	    }],
	    staticClass: "form-control",
	    attrs: {
	      "id": "password_reset-password_confirmation",
	      "type": "password",
	      "name": "password_confirmation",
	      "placeholder": "Repetir nova senha"
	    },
	    domProps: {
	      "value": (_vm.user.password_confirmation)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.user, "password_confirmation", $event.target.value)
	      }
	    }
	  }), _c('transition-group', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.errors.has('password_confirmation')),
	      expression: "errors.has('password_confirmation')"
	    }],
	    key: "password_confirmation",
	    staticClass: "help-block text-left"
	  }, [_vm._v(_vm._s(_vm.errors.first('password_confirmation')))])])], 1), _c('button', {
	    staticClass: "btn btn-block btn-primary submit-button",
	    attrs: {
	      "type": "submit",
	      "disabled": _vm.errors.any()
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        return _vm.submit()
	      }
	    }
	  }, [_vm._v("Ativar conta")])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 1229 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v("Ocorreram erros de envio de email no fluxo "), _c('b', [_vm._v(_vm._s(_vm.flow_name))])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    attrs: {
	      "id": "flows-edit"
	    }
	  }, [_c('back-link'), _c('h1', [_vm._v(_vm._s(_vm.$t('flows.title.cadenceFlowEdit')))]), _c('flow-form', {
	    attrs: {
	      "type_of_action": _vm.$t('flows.actions.editType'),
	      "save_button_text": _vm.$t('flows.actions.save'),
	      "flow": _vm.flow,
	      "cancel_path": _vm.flowPath()
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.name) + " recebeu "), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.contacts_text))]), _vm._v(" convertido(s) via SharpSpring.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1232 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "internal-scroller",
	    style: ({
	      maxHeight: _vm.max_height_style
	    })
	  }, [_vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),
/* 1233 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "filters"
	  }, [_c('dropdown-select', {
	    attrs: {
	      "options": _vm.sort_options,
	      "selected": _vm.sort_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.sort_filter),
	      callback: function($$v) {
	        _vm.sort_filter = $$v
	      },
	      expression: "sort_filter"
	    }
	  }), (_vm.show_user_filter) ? _c('dropdown-select', {
	    attrs: {
	      "options": _vm.users_options,
	      "selected": _vm.user_filter
	    },
	    on: {
	      "input": _vm.filter
	    },
	    model: {
	      value: (_vm.user_filter),
	      callback: function($$v) {
	        _vm.user_filter = $$v
	      },
	      expression: "user_filter"
	    }
	  }) : _vm._e(), _c('div', {
	    staticClass: "search-field-wrapper"
	  }, [_c('div', {
	    staticClass: "input-group"
	  }, [_c('span', {
	    staticClass: "input-group-btn"
	  }, [_c('button', {
	    staticClass: "btn btn-search glyphicon glyphicon-search",
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.filter
	    }
	  })]), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.text_field_filter),
	      expression: "text_field_filter"
	    }],
	    staticClass: "search-field form-control",
	    attrs: {
	      "placeholder": _vm.$t('flows.actions.find'),
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.text_field_filter)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.filter.apply(null, arguments)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.text_field_filter = $event.target.value
	      }
	    }
	  })])]), _c('div', {
	    staticClass: "clear"
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notification",
	    class: _vm.notification.cssClasses(),
	    on: {
	      "click": _vm.navigate
	    }
	  }, [_c('div', {
	    staticClass: "close",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        return _vm.remove.apply(null, arguments)
	      }
	    }
	  }), _c('div', {
	    staticClass: "icon"
	  }), _c('div', {
	    staticClass: "text"
	  }, [_vm._v(_vm._s(_vm.pre_text)), _c('span', [_c('span', {
	    staticClass: "entity-type"
	  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" de sua responsabilidade.")])]), _c('div', {
	    staticClass: "time",
	    class: {
	      left: _vm.table
	    }
	  }, [_vm._v(_vm._s(_vm.notification.timeText()))])])
	},staticRenderFns: []}

/***/ }),
/* 1235 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "table"
	  }, [_c('div', {
	    staticClass: "table-body"
	  }, _vm._l((_vm.actions), function(action) {
	    return _c('action-list-item', {
	      attrs: {
	        "action": action
	      }
	    })
	  }), 1)])
	},staticRenderFns: []}

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "contact-event-item linked-item"
	  }, [_c('div', {
	    staticClass: "contact-event-icon pipedrive-icon"
	  }), _c('div', {
	    staticClass: "contact-event-header overflow-ellipsis"
	  }, [_c('div', {
	    staticClass: "contact-event-title"
	  }, [_vm._v(_vm._s(_vm.event.title))]), _c('div', {
	    staticClass: "right-arrow glyphicon glyphicon-arrow-right"
	  }), _c('a', {
	    staticClass: "contact-event-description underlined",
	    attrs: {
	      "href": _vm.event.description,
	      "target": "_blank"
	    }
	  }, [_vm._v(_vm._s(_vm.event.description))]), _c('div', {
	    staticClass: "clear"
	  }), _c('div', {
	    staticClass: "contact-event-time"
	  }, [_vm._v(_vm._s(_vm.event.created_at.format('LLL')))])]), _c('div', {
	    staticClass: "clear"
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1237 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    directives: [{
	      name: "on-clickaway",
	      rawName: "v-on-clickaway",
	      value: (_vm.onClickaway),
	      expression: "onClickaway"
	    }],
	    staticClass: "color-input"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.show_picker),
	      expression: "show_picker"
	    }],
	    staticClass: "color-picker"
	  }, _vm._l((_vm.colors), function(color) {
	    return _c('div', {
	      staticClass: "color-box",
	      style: ({
	        "background": "#" + color
	      }),
	      on: {
	        "click": function($event) {
	          return _vm.setColor(color)
	        }
	      }
	    })
	  }), 0), _c('div', {
	    staticClass: "color-box",
	    style: ({
	      "background": "#" + _vm.value
	    }),
	    on: {
	      "click": function($event) {
	        _vm.show_picker = !_vm.show_picker
	      }
	    }
	  })])
	},staticRenderFns: []}

/***/ }),
/* 1238 */,
/* 1239 */,
/* 1240 */,
/* 1241 */,
/* 1242 */,
/* 1243 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// static/js/app.b1e21317ab2021faf5a2.js